"use strict";
(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __esm = (fn, res, err) => function __init() {
    if (err) throw err[0];
    try {
      return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
    } catch (e) {
      throw err = [e], e;
    }
  };
  var __commonJS = (cb, mod) => function __require() {
    try {
      return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
    } catch (e) {
      throw mod = 0, e;
    }
  };
  var __export = (target, all3) => {
    for (var name in all3)
      __defProp(target, name, { get: all3[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // node_modules/@vue/shared/dist/shared.esm-bundler.js
  // @__NO_SIDE_EFFECTS__
  function makeMap(str) {
    const map3 = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(",")) map3[key] = 1;
    return (val) => val in map3;
  }
  function genCacheKey(source, options) {
    return source + JSON.stringify(
      options,
      (_2, val) => typeof val === "function" ? val.toString() : val
    );
  }
  function generateCodeFrame(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_2, idx) => idx % 2 === 1);
    lines = lines.filter((_2, idx) => idx % 2 === 0);
    let count = 0;
    const res = [];
    for (let i2 = 0; i2 < lines.length; i2++) {
      count += lines[i2].length + (newlineSequences[i2] && newlineSequences[i2].length || 0);
      if (count >= start) {
        for (let j = i2 - range; j <= i2 + range || end > count; j++) {
          if (j < 0 || j >= lines.length) continue;
          const line = j + 1;
          res.push(
            `${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`
          );
          const lineLength = lines[j].length;
          const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
          if (j === i2) {
            const pad = start - (count - (lineLength + newLineSeqLength));
            const length = Math.max(
              1,
              end > count ? lineLength - pad : end - start
            );
            res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
          } else if (j > i2) {
            if (end > count) {
              const length = Math.max(Math.min(end - count, lineLength), 1);
              res.push(`   |  ` + "^".repeat(length));
            }
            count += lineLength + newLineSeqLength;
          }
        }
        break;
      }
    }
    return res.join("\n");
  }
  function normalizeStyle(value) {
    if (isArray(value)) {
      const res = {};
      for (let i2 = 0; i2 < value.length; i2++) {
        const item = value[i2];
        const normalized = isString(item) ? parseStringStyle(item) : normalizeStyle(item);
        if (normalized) {
          for (const key in normalized) {
            res[key] = normalized[key];
          }
        }
      }
      return res;
    } else if (isString(value) || isObject(value)) {
      return value;
    }
  }
  function parseStringStyle(cssText) {
    const ret = {};
    cssText.replace(styleCommentRE, "").split(listDelimiterRE).forEach((item) => {
      if (item) {
        const tmp = item.split(propertyDelimiterRE);
        tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
      }
    });
    return ret;
  }
  function stringifyStyle(styles) {
    if (!styles) return "";
    if (isString(styles)) return styles;
    let ret = "";
    for (const key in styles) {
      const value = styles[key];
      if (isString(value) || typeof value === "number") {
        const normalizedKey = key.startsWith(`--`) ? key : hyphenate(key);
        ret += `${normalizedKey}:${value};`;
      }
    }
    return ret;
  }
  function normalizeClass(value) {
    let res = "";
    if (isString(value)) {
      res = value;
    } else if (isArray(value)) {
      for (let i2 = 0; i2 < value.length; i2++) {
        const normalized = normalizeClass(value[i2]);
        if (normalized) {
          res += normalized + " ";
        }
      }
    } else if (isObject(value)) {
      for (const name in value) {
        if (value[name]) {
          res += name + " ";
        }
      }
    }
    return res.trim();
  }
  function normalizeProps(props) {
    if (!props) return null;
    let { class: klass, style } = props;
    if (klass && !isString(klass)) {
      props.class = normalizeClass(klass);
    }
    if (style) {
      props.style = normalizeStyle(style);
    }
    return props;
  }
  function includeBooleanAttr(value) {
    return !!value || value === "";
  }
  function isRenderableAttrValue(value) {
    if (value == null) {
      return false;
    }
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
  }
  function getEscapedCssVarName(key, doubleEscape) {
    return key.replace(
      cssVarNameEscapeSymbolsRE,
      (s) => doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`
    );
  }
  function looseCompareArrays(a, b2) {
    if (a.length !== b2.length) return false;
    let equal = true;
    for (let i2 = 0; equal && i2 < a.length; i2++) {
      equal = looseEqual(a[i2], b2[i2]);
    }
    return equal;
  }
  function looseEqual(a, b2) {
    if (a === b2) return true;
    let aValidType = isDate(a);
    let bValidType = isDate(b2);
    if (aValidType || bValidType) {
      return aValidType && bValidType ? a.getTime() === b2.getTime() : false;
    }
    aValidType = isSymbol(a);
    bValidType = isSymbol(b2);
    if (aValidType || bValidType) {
      return a === b2;
    }
    aValidType = isArray(a);
    bValidType = isArray(b2);
    if (aValidType || bValidType) {
      return aValidType && bValidType ? looseCompareArrays(a, b2) : false;
    }
    aValidType = isObject(a);
    bValidType = isObject(b2);
    if (aValidType || bValidType) {
      if (!aValidType || !bValidType) {
        return false;
      }
      const aKeysCount = Object.keys(a).length;
      const bKeysCount = Object.keys(b2).length;
      if (aKeysCount !== bKeysCount) {
        return false;
      }
      for (const key in a) {
        const aHasKey = a.hasOwnProperty(key);
        const bHasKey = b2.hasOwnProperty(key);
        if (aHasKey && !bHasKey || !aHasKey && bHasKey || !looseEqual(a[key], b2[key])) {
          return false;
        }
      }
    }
    return String(a) === String(b2);
  }
  function looseIndexOf(arr, val) {
    return arr.findIndex((item) => looseEqual(item, val));
  }
  function normalizeCssVarValue(value) {
    if (value == null) {
      return "initial";
    }
    if (typeof value === "string") {
      return value === "" ? " " : value;
    }
    if (typeof value !== "number" || !Number.isFinite(value)) {
      if (true) {
        console.warn(
          "[Vue warn] Invalid value used for CSS binding. Expected a string or a finite number but received:",
          value
        );
      }
    }
    return String(value);
  }
  var EMPTY_OBJ, EMPTY_ARR, NOOP, NO, isOn, isModelListener, extend, remove, hasOwnProperty, hasOwn, isArray, isMap, isSet, isDate, isRegExp, isFunction, isString, isSymbol, isObject, isPromise, objectToString, toTypeString, toRawType, isPlainObject, isIntegerKey, isReservedProp, isBuiltInDirective, cacheStringFunction, camelizeRE, camelize, hyphenateRE, hyphenate, capitalize, toHandlerKey, hasChanged, invokeArrayFns, def, looseToNumber, toNumber, _globalThis, getGlobalThis, PatchFlagNames, slotFlagsText, GLOBALS_ALLOWED, isGloballyAllowed, range, listDelimiterRE, propertyDelimiterRE, styleCommentRE, HTML_TAGS, SVG_TAGS, MATH_TAGS, VOID_TAGS, isHTMLTag, isSVGTag, isMathMLTag, isVoidTag, specialBooleanAttrs, isSpecialBooleanAttr, isBooleanAttr, isKnownHtmlAttr, isKnownSvgAttr, cssVarNameEscapeSymbolsRE, isRef, toDisplayString, replacer, stringifySymbol;
  var init_shared_esm_bundler = __esm({
    "node_modules/@vue/shared/dist/shared.esm-bundler.js"() {
      /**
      * @vue/shared v3.5.41
      * (c) 2018-present Yuxi (Evan) You and Vue contributors
      * @license MIT
      **/
      EMPTY_OBJ = true ? Object.freeze({}) : {};
      EMPTY_ARR = true ? Object.freeze([]) : [];
      NOOP = () => {
      };
      NO = () => false;
      isOn = (key) => key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
      (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
      isModelListener = (key) => key.startsWith("onUpdate:");
      extend = Object.assign;
      remove = (arr, el) => {
        const i2 = arr.indexOf(el);
        if (i2 > -1) {
          arr.splice(i2, 1);
        }
      };
      hasOwnProperty = Object.prototype.hasOwnProperty;
      hasOwn = (val, key) => hasOwnProperty.call(val, key);
      isArray = Array.isArray;
      isMap = (val) => toTypeString(val) === "[object Map]";
      isSet = (val) => toTypeString(val) === "[object Set]";
      isDate = (val) => toTypeString(val) === "[object Date]";
      isRegExp = (val) => toTypeString(val) === "[object RegExp]";
      isFunction = (val) => typeof val === "function";
      isString = (val) => typeof val === "string";
      isSymbol = (val) => typeof val === "symbol";
      isObject = (val) => val !== null && typeof val === "object";
      isPromise = (val) => {
        return (isObject(val) || isFunction(val)) && isFunction(val.then) && isFunction(val.catch);
      };
      objectToString = Object.prototype.toString;
      toTypeString = (value) => objectToString.call(value);
      toRawType = (value) => {
        return toTypeString(value).slice(8, -1);
      };
      isPlainObject = (val) => toTypeString(val) === "[object Object]";
      isIntegerKey = (key) => isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
      isReservedProp = /* @__PURE__ */ makeMap(
        // the leading comma is intentional so empty string "" is also included
        ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
      );
      isBuiltInDirective = /* @__PURE__ */ makeMap(
        "bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo"
      );
      cacheStringFunction = (fn) => {
        const cache = /* @__PURE__ */ Object.create(null);
        return ((str) => {
          const hit = cache[str];
          return hit || (cache[str] = fn(str));
        });
      };
      camelizeRE = /-\w/g;
      camelize = cacheStringFunction(
        (str) => {
          return str.replace(camelizeRE, (c) => c.slice(1).toUpperCase());
        }
      );
      hyphenateRE = /\B([A-Z])/g;
      hyphenate = cacheStringFunction(
        (str) => str.replace(hyphenateRE, "-$1").toLowerCase()
      );
      capitalize = cacheStringFunction((str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
      });
      toHandlerKey = cacheStringFunction(
        (str) => {
          const s = str ? `on${capitalize(str)}` : ``;
          return s;
        }
      );
      hasChanged = (value, oldValue) => !Object.is(value, oldValue);
      invokeArrayFns = (fns, ...arg) => {
        for (let i2 = 0; i2 < fns.length; i2++) {
          fns[i2](...arg);
        }
      };
      def = (obj, key, value, writable = false) => {
        Object.defineProperty(obj, key, {
          configurable: true,
          enumerable: false,
          writable,
          value
        });
      };
      looseToNumber = (val) => {
        const n = parseFloat(val);
        return isNaN(n) ? val : n;
      };
      toNumber = (val) => {
        const n = isString(val) ? Number(val) : NaN;
        return isNaN(n) ? val : n;
      };
      getGlobalThis = () => {
        return _globalThis || (_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {});
      };
      PatchFlagNames = {
        [1]: `TEXT`,
        [2]: `CLASS`,
        [4]: `STYLE`,
        [8]: `PROPS`,
        [16]: `FULL_PROPS`,
        [32]: `NEED_HYDRATION`,
        [64]: `STABLE_FRAGMENT`,
        [128]: `KEYED_FRAGMENT`,
        [256]: `UNKEYED_FRAGMENT`,
        [512]: `NEED_PATCH`,
        [1024]: `DYNAMIC_SLOTS`,
        [2048]: `DEV_ROOT_FRAGMENT`,
        [-1]: `CACHED`,
        [-2]: `BAIL`
      };
      slotFlagsText = {
        [1]: "STABLE",
        [2]: "DYNAMIC",
        [3]: "FORWARDED"
      };
      GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
      isGloballyAllowed = /* @__PURE__ */ makeMap(GLOBALS_ALLOWED);
      range = 2;
      listDelimiterRE = /;(?![^(]*\))/g;
      propertyDelimiterRE = /:([^]+)/;
      styleCommentRE = /\/\*[^]*?\*\//g;
      HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
      SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
      MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
      VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
      isHTMLTag = /* @__PURE__ */ makeMap(HTML_TAGS);
      isSVGTag = /* @__PURE__ */ makeMap(SVG_TAGS);
      isMathMLTag = /* @__PURE__ */ makeMap(MATH_TAGS);
      isVoidTag = /* @__PURE__ */ makeMap(VOID_TAGS);
      specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
      isSpecialBooleanAttr = /* @__PURE__ */ makeMap(specialBooleanAttrs);
      isBooleanAttr = /* @__PURE__ */ makeMap(
        specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`
      );
      isKnownHtmlAttr = /* @__PURE__ */ makeMap(
        `accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`
      );
      isKnownSvgAttr = /* @__PURE__ */ makeMap(
        `xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`
      );
      cssVarNameEscapeSymbolsRE = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
      isRef = (val) => {
        return !!(val && val["__v_isRef"] === true);
      };
      toDisplayString = (val) => {
        return isString(val) ? val : val == null ? "" : isArray(val) || isObject(val) && (val.toString === objectToString || !isFunction(val.toString)) ? isRef(val) ? toDisplayString(val.value) : JSON.stringify(val, replacer, 2) : String(val);
      };
      replacer = (_key, val) => {
        if (isRef(val)) {
          return replacer(_key, val.value);
        } else if (isMap(val)) {
          return {
            [`Map(${val.size})`]: [...val.entries()].reduce(
              (entries, [key, val2], i2) => {
                entries[stringifySymbol(key, i2) + " =>"] = val2;
                return entries;
              },
              {}
            )
          };
        } else if (isSet(val)) {
          return {
            [`Set(${val.size})`]: [...val.values()].map((v) => stringifySymbol(v))
          };
        } else if (isSymbol(val)) {
          return stringifySymbol(val);
        } else if (isObject(val) && !isArray(val) && !isPlainObject(val)) {
          return String(val);
        }
        return val;
      };
      stringifySymbol = (v, i2 = "") => {
        var _a;
        return (
          // Symbol.description in es2019+ so we need to cast here to pass
          // the lib: es2016 check
          isSymbol(v) ? `Symbol(${(_a = v.description) != null ? _a : i2})` : v
        );
      };
    }
  });

  // node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
  function warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
  }
  function effectScope(detached) {
    return new EffectScope(detached);
  }
  function getCurrentScope() {
    return activeEffectScope;
  }
  function onScopeDispose(fn, failSilently = false) {
    if (activeEffectScope) {
      activeEffectScope.cleanups.push(fn);
    } else if (!failSilently) {
      warn(
        `onScopeDispose() is called when there is no active effect scope to be associated with.`
      );
    }
  }
  function batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
      sub.next = batchedComputed;
      batchedComputed = sub;
      return;
    }
    sub.next = batchedSub;
    batchedSub = sub;
  }
  function startBatch() {
    batchDepth++;
  }
  function endBatch() {
    if (--batchDepth > 0) {
      return;
    }
    if (batchedComputed) {
      let e = batchedComputed;
      batchedComputed = void 0;
      while (e) {
        const next = e.next;
        e.next = void 0;
        e.flags &= -9;
        e = next;
      }
    }
    let error;
    while (batchedSub) {
      let e = batchedSub;
      batchedSub = void 0;
      while (e) {
        const next = e.next;
        e.next = void 0;
        e.flags &= -9;
        if (e.flags & 1) {
          try {
            ;
            e.trigger();
          } catch (err) {
            if (!error) error = err;
          }
        }
        e = next;
      }
    }
    if (error) throw error;
  }
  function prepareDeps(sub) {
    for (let link = sub.deps; link; link = link.nextDep) {
      link.version = -1;
      link.prevActiveLink = link.dep.activeLink;
      link.dep.activeLink = link;
    }
  }
  function cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while (link) {
      const prev = link.prevDep;
      if (link.version === -1) {
        if (link === tail) tail = prev;
        removeSub(link);
        removeDep(link);
      } else {
        head = link;
      }
      link.dep.activeLink = link.prevActiveLink;
      link.prevActiveLink = void 0;
      link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
  }
  function isDirty(sub) {
    for (let link = sub.deps; link; link = link.nextDep) {
      if (link.dep.version !== link.version || link.dep.computed && (refreshComputed(link.dep.computed) || link.dep.version !== link.version)) {
        return true;
      }
    }
    if (sub._dirty) {
      return true;
    }
    return false;
  }
  function refreshComputed(computed3) {
    if (computed3.flags & 4 && !(computed3.flags & 16)) {
      return;
    }
    computed3.flags &= -17;
    if (computed3.globalVersion === globalVersion) {
      return;
    }
    computed3.globalVersion = globalVersion;
    if (!computed3.isSSR && computed3.flags & 128 && (!computed3.deps && !computed3._dirty || !isDirty(computed3))) {
      return;
    }
    computed3.flags |= 2;
    const dep = computed3.dep;
    const prevSub = activeSub;
    const prevShouldTrack = shouldTrack;
    activeSub = computed3;
    shouldTrack = true;
    try {
      prepareDeps(computed3);
      const value = computed3.fn(computed3._value);
      if (dep.version === 0 || hasChanged(value, computed3._value)) {
        computed3.flags |= 128;
        computed3._value = value;
        dep.version++;
      }
    } catch (err) {
      dep.version++;
      throw err;
    } finally {
      activeSub = prevSub;
      shouldTrack = prevShouldTrack;
      cleanupDeps(computed3);
      computed3.flags &= -3;
    }
  }
  function removeSub(link, soft = false) {
    const { dep, prevSub, nextSub } = link;
    if (prevSub) {
      prevSub.nextSub = nextSub;
      link.prevSub = void 0;
    }
    if (nextSub) {
      nextSub.prevSub = prevSub;
      link.nextSub = void 0;
    }
    if (dep.subsHead === link) {
      dep.subsHead = nextSub;
    }
    if (dep.subs === link) {
      dep.subs = prevSub;
      if (!prevSub && dep.computed) {
        dep.computed.flags &= -5;
        for (let l = dep.computed.deps; l; l = l.nextDep) {
          removeSub(l, true);
        }
      }
    }
    if (!soft && !--dep.sc && dep.map) {
      dep.map.delete(dep.key);
    }
  }
  function removeDep(link) {
    const { prevDep, nextDep } = link;
    if (prevDep) {
      prevDep.nextDep = nextDep;
      link.prevDep = void 0;
    }
    if (nextDep) {
      nextDep.prevDep = prevDep;
      link.nextDep = void 0;
    }
  }
  function effect(fn, options) {
    if (fn.effect instanceof ReactiveEffect) {
      fn = fn.effect.fn;
    }
    const e = new ReactiveEffect(fn);
    if (options) {
      extend(e, options);
    }
    try {
      e.run();
    } catch (err) {
      e.stop();
      throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
  }
  function stop(runner) {
    runner.effect.stop();
  }
  function pauseTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = false;
  }
  function resetTracking() {
    const last = trackStack.pop();
    shouldTrack = last === void 0 ? true : last;
  }
  function cleanupEffect(e) {
    const { cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
      const prevSub = activeSub;
      activeSub = void 0;
      try {
        cleanup();
      } finally {
        activeSub = prevSub;
      }
    }
  }
  function addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
      const computed3 = link.dep.computed;
      if (computed3 && !link.dep.subs) {
        computed3.flags |= 4 | 16;
        for (let l = computed3.deps; l; l = l.nextDep) {
          addSub(l);
        }
      }
      const currentTail = link.dep.subs;
      if (currentTail !== link) {
        link.prevSub = currentTail;
        if (currentTail) currentTail.nextSub = link;
      }
      if (link.dep.subsHead === void 0) {
        link.dep.subsHead = link;
      }
      link.dep.subs = link;
    }
  }
  function track(target, type, key) {
    if (shouldTrack && activeSub) {
      let depsMap = targetMap.get(target);
      if (!depsMap) {
        targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
      }
      let dep = depsMap.get(key);
      if (!dep) {
        depsMap.set(key, dep = new Dep());
        dep.map = depsMap;
        dep.key = key;
      }
      if (true) {
        dep.track({
          target,
          type,
          key
        });
      } else {
        dep.track();
      }
    }
  }
  function trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = targetMap.get(target);
    if (!depsMap) {
      globalVersion++;
      return;
    }
    const run = (dep) => {
      if (dep) {
        if (true) {
          dep.trigger({
            target,
            type,
            key,
            newValue,
            oldValue,
            oldTarget
          });
        } else {
          dep.trigger();
        }
      }
    };
    startBatch();
    if (type === "clear") {
      depsMap.forEach(run);
    } else {
      const targetIsArray = isArray(target);
      const isArrayIndex = targetIsArray && isIntegerKey(key);
      if (targetIsArray && key === "length") {
        const newLength = Number(newValue);
        depsMap.forEach((dep, key2) => {
          if (key2 === "length" || key2 === ARRAY_ITERATE_KEY || !isSymbol(key2) && key2 >= newLength) {
            run(dep);
          }
        });
      } else {
        if (key !== void 0 || depsMap.has(void 0)) {
          run(depsMap.get(key));
        }
        if (isArrayIndex) {
          run(depsMap.get(ARRAY_ITERATE_KEY));
        }
        switch (type) {
          case "add":
            if (!targetIsArray) {
              run(depsMap.get(ITERATE_KEY));
              if (isMap(target)) {
                run(depsMap.get(MAP_KEY_ITERATE_KEY));
              }
            } else if (isArrayIndex) {
              run(depsMap.get("length"));
            }
            break;
          case "delete":
            if (!targetIsArray) {
              run(depsMap.get(ITERATE_KEY));
              if (isMap(target)) {
                run(depsMap.get(MAP_KEY_ITERATE_KEY));
              }
            }
            break;
          case "set":
            if (isMap(target)) {
              run(depsMap.get(ITERATE_KEY));
            }
            break;
        }
      }
    }
    endBatch();
  }
  function getDepFromReactive(object, key) {
    const depMap = targetMap.get(object);
    return depMap && depMap.get(key);
  }
  function reactiveReadArray(array) {
    const raw = /* @__PURE__ */ toRaw(array);
    if (raw === array) return raw;
    track(raw, "iterate", ARRAY_ITERATE_KEY);
    return /* @__PURE__ */ isShallow(array) ? raw : raw.map(toReactive);
  }
  function shallowReadArray(arr) {
    track(arr = /* @__PURE__ */ toRaw(arr), "iterate", ARRAY_ITERATE_KEY);
    return arr;
  }
  function toWrapped(target, item) {
    if (/* @__PURE__ */ isReadonly(target)) {
      return /* @__PURE__ */ isReactive(target) ? toReadonly(toReactive(item)) : toReadonly(item);
    }
    return toReactive(item);
  }
  function iterator(self2, method, wrapValue) {
    const arr = shallowReadArray(self2);
    const iter = arr[method]();
    if (arr !== self2 && !/* @__PURE__ */ isShallow(self2)) {
      iter._next = iter.next;
      iter.next = () => {
        const result = iter._next();
        if (!result.done) {
          result.value = wrapValue(result.value);
        }
        return result;
      };
    }
    return iter;
  }
  function apply(self2, method, fn, thisArg, wrappedRetFn, args) {
    const arr = shallowReadArray(self2);
    const needsWrap = arr !== self2 && !/* @__PURE__ */ isShallow(self2);
    const methodFn = arr[method];
    if (methodFn !== arrayProto[method]) {
      const result2 = methodFn.apply(self2, args);
      return needsWrap ? toReactive(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self2) {
      if (needsWrap) {
        wrappedFn = function(item, index) {
          return fn.call(this, toWrapped(self2, item), index, self2);
        };
      } else if (fn.length > 2) {
        wrappedFn = function(item, index) {
          return fn.call(this, item, index, self2);
        };
      }
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
  }
  function reduce(self2, method, fn, args) {
    const arr = shallowReadArray(self2);
    const needsWrap = arr !== self2 && !/* @__PURE__ */ isShallow(self2);
    let wrappedFn = fn;
    let wrapInitialAccumulator = false;
    if (arr !== self2) {
      if (needsWrap) {
        wrapInitialAccumulator = args.length === 0;
        wrappedFn = function(acc, item, index) {
          if (wrapInitialAccumulator) {
            wrapInitialAccumulator = false;
            acc = toWrapped(self2, acc);
          }
          return fn.call(this, acc, toWrapped(self2, item), index, self2);
        };
      } else if (fn.length > 3) {
        wrappedFn = function(acc, item, index) {
          return fn.call(this, acc, item, index, self2);
        };
      }
    }
    const result = arr[method](wrappedFn, ...args);
    return wrapInitialAccumulator ? toWrapped(self2, result) : result;
  }
  function searchProxy(self2, method, args) {
    const arr = /* @__PURE__ */ toRaw(self2);
    track(arr, "iterate", ARRAY_ITERATE_KEY);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && /* @__PURE__ */ isProxy(args[0])) {
      args[0] = /* @__PURE__ */ toRaw(args[0]);
      return arr[method](...args);
    }
    return res;
  }
  function noTracking(self2, method, args = []) {
    pauseTracking();
    startBatch();
    const res = (/* @__PURE__ */ toRaw(self2))[method].apply(self2, args);
    endBatch();
    resetTracking();
    return res;
  }
  function hasOwnProperty2(key) {
    if (!isSymbol(key)) key = String(key);
    const obj = /* @__PURE__ */ toRaw(this);
    track(obj, "has", key);
    return obj.hasOwnProperty(key);
  }
  function createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
      const target = this["__v_raw"];
      const rawTarget = /* @__PURE__ */ toRaw(target);
      const targetIsMap = isMap(rawTarget);
      const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
      const isKeyOnly = method === "keys" && targetIsMap;
      const innerIterator = target[method](...args);
      const wrap = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
      !isReadonly2 && track(
        rawTarget,
        "iterate",
        isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY
      );
      return extend(
        // inheriting all iterator properties
        Object.create(innerIterator),
        {
          // iterator protocol
          next() {
            const { value, done } = innerIterator.next();
            return done ? { value, done } : {
              value: isPair ? [wrap(value[0]), wrap(value[1])] : wrap(value),
              done
            };
          }
        }
      );
    };
  }
  function createReadonlyMethod(type) {
    return function(...args) {
      if (true) {
        const key = args[0] ? `on key "${args[0]}" ` : ``;
        warn(
          `${capitalize(type)} operation ${key}failed: target is readonly.`,
          /* @__PURE__ */ toRaw(this)
        );
      }
      return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
  }
  function createInstrumentations(readonly2, shallow) {
    const instrumentations = {
      get(key) {
        const target = this["__v_raw"];
        const rawTarget = /* @__PURE__ */ toRaw(target);
        const rawKey = /* @__PURE__ */ toRaw(key);
        if (!readonly2) {
          if (hasChanged(key, rawKey)) {
            track(rawTarget, "get", key);
          }
          track(rawTarget, "get", rawKey);
        }
        const { has } = getProto(rawTarget);
        const wrap = shallow ? toShallow : readonly2 ? toReadonly : toReactive;
        if (has.call(rawTarget, key)) {
          return wrap(target.get(key));
        } else if (has.call(rawTarget, rawKey)) {
          return wrap(target.get(rawKey));
        } else if (target !== rawTarget) {
          target.get(key);
        }
      },
      get size() {
        const target = this["__v_raw"];
        !readonly2 && track(/* @__PURE__ */ toRaw(target), "iterate", ITERATE_KEY);
        return target.size;
      },
      has(key) {
        const target = this["__v_raw"];
        const rawTarget = /* @__PURE__ */ toRaw(target);
        const rawKey = /* @__PURE__ */ toRaw(key);
        if (!readonly2) {
          if (hasChanged(key, rawKey)) {
            track(rawTarget, "has", key);
          }
          track(rawTarget, "has", rawKey);
        }
        return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
      },
      forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = /* @__PURE__ */ toRaw(target);
        const wrap = shallow ? toShallow : readonly2 ? toReadonly : toReactive;
        !readonly2 && track(rawTarget, "iterate", ITERATE_KEY);
        return target.forEach((value, key) => {
          return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
      }
    };
    extend(
      instrumentations,
      readonly2 ? {
        add: createReadonlyMethod("add"),
        set: createReadonlyMethod("set"),
        delete: createReadonlyMethod("delete"),
        clear: createReadonlyMethod("clear")
      } : {
        add(value) {
          const target = /* @__PURE__ */ toRaw(this);
          const proto = getProto(target);
          const rawValue = /* @__PURE__ */ toRaw(value);
          const valueToAdd = !shallow && !/* @__PURE__ */ isShallow(value) && !/* @__PURE__ */ isReadonly(value) ? rawValue : value;
          const hadKey = proto.has.call(target, valueToAdd) || hasChanged(value, valueToAdd) && proto.has.call(target, value) || hasChanged(rawValue, valueToAdd) && proto.has.call(target, rawValue);
          if (!hadKey) {
            target.add(valueToAdd);
            trigger(target, "add", valueToAdd, valueToAdd);
          }
          return this;
        },
        set(key, value) {
          if (!shallow && !/* @__PURE__ */ isShallow(value) && !/* @__PURE__ */ isReadonly(value)) {
            value = /* @__PURE__ */ toRaw(value);
          }
          const target = /* @__PURE__ */ toRaw(this);
          const { has, get: get3 } = getProto(target);
          let hadKey = has.call(target, key);
          if (!hadKey) {
            key = /* @__PURE__ */ toRaw(key);
            hadKey = has.call(target, key);
          } else if (true) {
            checkIdentityKeys(target, has, key);
          }
          const oldValue = get3.call(target, key);
          target.set(key, value);
          if (!hadKey) {
            trigger(target, "add", key, value);
          } else if (hasChanged(value, oldValue)) {
            trigger(target, "set", key, value, oldValue);
          }
          return this;
        },
        delete(key) {
          const target = /* @__PURE__ */ toRaw(this);
          const { has, get: get3 } = getProto(target);
          let hadKey = has.call(target, key);
          if (!hadKey) {
            key = /* @__PURE__ */ toRaw(key);
            hadKey = has.call(target, key);
          } else if (true) {
            checkIdentityKeys(target, has, key);
          }
          const oldValue = get3 ? get3.call(target, key) : void 0;
          const result = target.delete(key);
          if (hadKey) {
            trigger(target, "delete", key, void 0, oldValue);
          }
          return result;
        },
        clear() {
          const target = /* @__PURE__ */ toRaw(this);
          const hadItems = target.size !== 0;
          const oldTarget = true ? isMap(target) ? new Map(target) : new Set(target) : void 0;
          const result = target.clear();
          if (hadItems) {
            trigger(
              target,
              "clear",
              void 0,
              void 0,
              oldTarget
            );
          }
          return result;
        }
      }
    );
    const iteratorMethods = [
      "keys",
      "values",
      "entries",
      Symbol.iterator
    ];
    iteratorMethods.forEach((method) => {
      instrumentations[method] = createIterableMethod(method, readonly2, shallow);
    });
    return instrumentations;
  }
  function createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver) => {
      if (key === "__v_isReactive") {
        return !isReadonly2;
      } else if (key === "__v_isReadonly") {
        return isReadonly2;
      } else if (key === "__v_raw") {
        return target;
      }
      return Reflect.get(
        hasOwn(instrumentations, key) && key in target ? instrumentations : target,
        key,
        receiver
      );
    };
  }
  function checkIdentityKeys(target, has, key) {
    const rawKey = /* @__PURE__ */ toRaw(key);
    if (rawKey !== key && has.call(target, rawKey)) {
      const type = toRawType(target);
      warn(
        `Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
      );
    }
  }
  function targetTypeMap(rawType) {
    switch (rawType) {
      case "Object":
      case "Array":
        return 1;
      case "Map":
      case "Set":
      case "WeakMap":
      case "WeakSet":
        return 2;
      default:
        return 0;
    }
  }
  // @__NO_SIDE_EFFECTS__
  function reactive(target) {
    if (/* @__PURE__ */ isReadonly(target)) {
      return target;
    }
    return createReactiveObject(
      target,
      false,
      mutableHandlers,
      mutableCollectionHandlers,
      reactiveMap
    );
  }
  // @__NO_SIDE_EFFECTS__
  function shallowReactive(target) {
    return createReactiveObject(
      target,
      false,
      shallowReactiveHandlers,
      shallowCollectionHandlers,
      shallowReactiveMap
    );
  }
  // @__NO_SIDE_EFFECTS__
  function readonly(target) {
    return createReactiveObject(
      target,
      true,
      readonlyHandlers,
      readonlyCollectionHandlers,
      readonlyMap
    );
  }
  // @__NO_SIDE_EFFECTS__
  function shallowReadonly(target) {
    return createReactiveObject(
      target,
      true,
      shallowReadonlyHandlers,
      shallowReadonlyCollectionHandlers,
      shallowReadonlyMap
    );
  }
  function createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!isObject(target)) {
      if (true) {
        warn(
          `value cannot be made ${isReadonly2 ? "readonly" : "reactive"}: ${String(
            target
          )}`
        );
      }
      return target;
    }
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) {
      return target;
    }
    if (target["__v_skip"] || !Object.isExtensible(target)) {
      return target;
    }
    const existingProxy = proxyMap.get(target);
    if (existingProxy) {
      return existingProxy;
    }
    const targetType = targetTypeMap(toRawType(target));
    if (targetType === 0) {
      return target;
    }
    const proxy = new Proxy(
      target,
      targetType === 2 ? collectionHandlers : baseHandlers
    );
    proxyMap.set(target, proxy);
    return proxy;
  }
  // @__NO_SIDE_EFFECTS__
  function isReactive(value) {
    if (/* @__PURE__ */ isReadonly(value)) {
      return /* @__PURE__ */ isReactive(value["__v_raw"]);
    }
    return !!(value && value["__v_isReactive"]);
  }
  // @__NO_SIDE_EFFECTS__
  function isReadonly(value) {
    return !!(value && value["__v_isReadonly"]);
  }
  // @__NO_SIDE_EFFECTS__
  function isShallow(value) {
    return !!(value && value["__v_isShallow"]);
  }
  // @__NO_SIDE_EFFECTS__
  function isProxy(value) {
    return value ? !!value["__v_raw"] : false;
  }
  // @__NO_SIDE_EFFECTS__
  function toRaw(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? /* @__PURE__ */ toRaw(raw) : observed;
  }
  function markRaw(value) {
    if (!hasOwn(value, "__v_skip") && Object.isExtensible(value)) {
      def(value, "__v_skip", true);
    }
    return value;
  }
  // @__NO_SIDE_EFFECTS__
  function isRef2(r) {
    return r ? r["__v_isRef"] === true : false;
  }
  // @__NO_SIDE_EFFECTS__
  function ref(value) {
    return createRef(value, false);
  }
  // @__NO_SIDE_EFFECTS__
  function shallowRef(value) {
    return createRef(value, true);
  }
  function createRef(rawValue, shallow) {
    if (/* @__PURE__ */ isRef2(rawValue)) {
      return rawValue;
    }
    return new RefImpl(rawValue, shallow);
  }
  function triggerRef(ref2) {
    if (ref2.dep) {
      if (true) {
        ref2.dep.trigger({
          target: ref2,
          type: "set",
          key: "value",
          newValue: ref2._value
        });
      } else {
        ref2.dep.trigger();
      }
    }
  }
  function unref(ref2) {
    return /* @__PURE__ */ isRef2(ref2) ? ref2.value : ref2;
  }
  function toValue(source) {
    return isFunction(source) ? source() : unref(source);
  }
  function proxyRefs(objectWithRefs) {
    return /* @__PURE__ */ isReactive(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, shallowUnwrapHandlers);
  }
  function customRef(factory2) {
    return new CustomRefImpl(factory2);
  }
  // @__NO_SIDE_EFFECTS__
  function toRefs(object) {
    if (!/* @__PURE__ */ isProxy(object)) {
      warn(`toRefs() expects a reactive object but received a plain one.`);
    }
    const ret = isArray(object) ? new Array(object.length) : {};
    for (const key in object) {
      ret[key] = propertyToRef(object, key);
    }
    return ret;
  }
  // @__NO_SIDE_EFFECTS__
  function toRef(source, key, defaultValue) {
    if (/* @__PURE__ */ isRef2(source)) {
      return source;
    } else if (isFunction(source)) {
      return new GetterRefImpl(source);
    } else if (isObject(source) && arguments.length > 1) {
      return propertyToRef(source, key, defaultValue);
    } else {
      return /* @__PURE__ */ ref(source);
    }
  }
  function propertyToRef(source, key, defaultValue) {
    return new ObjectRefImpl(source, key, defaultValue);
  }
  // @__NO_SIDE_EFFECTS__
  function computed(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if (isFunction(getterOrOptions)) {
      getter = getterOrOptions;
    } else {
      getter = getterOrOptions.get;
      setter = getterOrOptions.set;
    }
    const cRef = new ComputedRefImpl(getter, setter, isSSR);
    if (debugOptions && !isSSR) {
      cRef.onTrack = debugOptions.onTrack;
      cRef.onTrigger = debugOptions.onTrigger;
    }
    return cRef;
  }
  function getCurrentWatcher() {
    return activeWatcher;
  }
  function onWatcherCleanup(cleanupFn, failSilently = false, owner = activeWatcher) {
    if (owner) {
      let cleanups = cleanupMap.get(owner);
      if (!cleanups) cleanupMap.set(owner, cleanups = []);
      cleanups.push(cleanupFn);
    } else if (!failSilently) {
      warn(
        `onWatcherCleanup() was called when there was no active watcher to associate with.`
      );
    }
  }
  function watch(source, cb, options = EMPTY_OBJ) {
    const { immediate, deep, once, scheduler, augmentJob, call } = options;
    const warnInvalidSource = (s) => {
      (options.onWarn || warn)(
        `Invalid watch source: `,
        s,
        `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`
      );
    };
    const reactiveGetter = (source2) => {
      if (deep) return source2;
      if (/* @__PURE__ */ isShallow(source2) || deep === false || deep === 0)
        return traverse(source2, 1);
      return traverse(source2);
    };
    let effect2;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if (/* @__PURE__ */ isRef2(source)) {
      getter = () => source.value;
      forceTrigger = /* @__PURE__ */ isShallow(source);
    } else if (/* @__PURE__ */ isReactive(source)) {
      getter = () => reactiveGetter(source);
      forceTrigger = true;
    } else if (isArray(source)) {
      isMultiSource = true;
      forceTrigger = source.some((s) => /* @__PURE__ */ isReactive(s) || /* @__PURE__ */ isShallow(s));
      getter = () => source.map((s) => {
        if (/* @__PURE__ */ isRef2(s)) {
          return s.value;
        } else if (/* @__PURE__ */ isReactive(s)) {
          return reactiveGetter(s);
        } else if (isFunction(s)) {
          return call ? call(s, 2) : s();
        } else {
          warnInvalidSource(s);
        }
      });
    } else if (isFunction(source)) {
      if (cb) {
        getter = call ? () => call(source, 2) : source;
      } else {
        getter = () => {
          if (cleanup) {
            pauseTracking();
            try {
              cleanup();
            } finally {
              resetTracking();
            }
          }
          const currentEffect = activeWatcher;
          activeWatcher = effect2;
          try {
            return call ? call(source, 3, [boundCleanup]) : source(boundCleanup);
          } finally {
            activeWatcher = currentEffect;
          }
        };
      }
    } else {
      getter = NOOP;
      warnInvalidSource(source);
    }
    if (cb && deep) {
      const baseGetter = getter;
      const depth = deep === true ? Infinity : deep;
      getter = () => traverse(baseGetter(), depth);
    }
    const scope = getCurrentScope();
    const watchHandle = () => {
      effect2.stop();
      if (scope && scope.active) {
        remove(scope.effects, effect2);
      }
    };
    if (once && cb) {
      const _cb = cb;
      cb = (...args) => {
        const res = _cb(...args);
        watchHandle();
        return res;
      };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill(INITIAL_WATCHER_VALUE) : INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun) => {
      if (!(effect2.flags & 1) || !effect2.dirty && !immediateFirstRun) {
        return;
      }
      if (cb) {
        const newValue = effect2.run();
        if (immediateFirstRun || deep || forceTrigger || (isMultiSource ? newValue.some((v, i2) => hasChanged(v, oldValue[i2])) : hasChanged(newValue, oldValue))) {
          if (cleanup) {
            cleanup();
          }
          const currentWatcher = activeWatcher;
          activeWatcher = effect2;
          try {
            const args = [
              newValue,
              // pass undefined as the old value when it's changed for the first time
              oldValue === INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === INITIAL_WATCHER_VALUE ? [] : oldValue,
              boundCleanup
            ];
            oldValue = newValue;
            call ? call(cb, 3, args) : (
              // @ts-expect-error
              cb(...args)
            );
          } finally {
            activeWatcher = currentWatcher;
          }
        }
      } else {
        effect2.run();
      }
    };
    if (augmentJob) {
      augmentJob(job);
    }
    effect2 = new ReactiveEffect(getter);
    effect2.scheduler = scheduler ? () => scheduler(job, false) : job;
    boundCleanup = (fn) => onWatcherCleanup(fn, false, effect2);
    cleanup = effect2.onStop = () => {
      const cleanups = cleanupMap.get(effect2);
      if (cleanups) {
        if (call) {
          call(cleanups, 4);
        } else {
          for (const cleanup2 of cleanups) cleanup2();
        }
        cleanupMap.delete(effect2);
      }
    };
    if (true) {
      effect2.onTrack = options.onTrack;
      effect2.onTrigger = options.onTrigger;
    }
    if (cb) {
      if (immediate) {
        job(true);
      } else {
        oldValue = effect2.run();
      }
    } else if (scheduler) {
      scheduler(job.bind(null, true), true);
    } else {
      effect2.run();
    }
    watchHandle.pause = effect2.pause.bind(effect2);
    watchHandle.resume = effect2.resume.bind(effect2);
    watchHandle.stop = watchHandle;
    return watchHandle;
  }
  function traverse(value, depth = Infinity, seen2) {
    if (depth <= 0 || !isObject(value) || value["__v_skip"]) {
      return value;
    }
    seen2 = seen2 || /* @__PURE__ */ new Map();
    if ((seen2.get(value) || 0) >= depth) {
      return value;
    }
    seen2.set(value, depth);
    depth--;
    if (/* @__PURE__ */ isRef2(value)) {
      traverse(value.value, depth, seen2);
    } else if (isArray(value)) {
      for (let i2 = 0; i2 < value.length; i2++) {
        traverse(value[i2], depth, seen2);
      }
    } else if (isSet(value) || isMap(value)) {
      value.forEach((v) => {
        traverse(v, depth, seen2);
      });
    } else if (isPlainObject(value)) {
      for (const key in value) {
        traverse(value[key], depth, seen2);
      }
      for (const key of Object.getOwnPropertySymbols(value)) {
        if (Object.prototype.propertyIsEnumerable.call(value, key)) {
          traverse(value[key], depth, seen2);
        }
      }
    }
    return value;
  }
  var activeEffectScope, EffectScope, activeSub, pausedQueueEffects, ReactiveEffect, batchDepth, batchedSub, batchedComputed, shouldTrack, trackStack, globalVersion, Link, Dep, targetMap, ITERATE_KEY, MAP_KEY_ITERATE_KEY, ARRAY_ITERATE_KEY, arrayInstrumentations, arrayProto, isNonTrackableKeys, builtInSymbols, BaseReactiveHandler, MutableReactiveHandler, ReadonlyReactiveHandler, mutableHandlers, readonlyHandlers, shallowReactiveHandlers, shallowReadonlyHandlers, toShallow, getProto, mutableCollectionHandlers, shallowCollectionHandlers, readonlyCollectionHandlers, shallowReadonlyCollectionHandlers, reactiveMap, shallowReactiveMap, readonlyMap, shallowReadonlyMap, toReactive, toReadonly, RefImpl, shallowUnwrapHandlers, CustomRefImpl, ObjectRefImpl, GetterRefImpl, ComputedRefImpl, TrackOpTypes, TriggerOpTypes, INITIAL_WATCHER_VALUE, cleanupMap, activeWatcher;
  var init_reactivity_esm_bundler = __esm({
    "node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js"() {
      init_shared_esm_bundler();
      /**
      * @vue/reactivity v3.5.41
      * (c) 2018-present Yuxi (Evan) You and Vue contributors
      * @license MIT
      **/
      EffectScope = class {
        // TODO isolatedDeclarations "__v_skip"
        constructor(detached = false) {
          this.detached = detached;
          this._active = true;
          this._on = 0;
          this.effects = [];
          this.cleanups = [];
          this._isPaused = false;
          this._warnOnRun = true;
          this.__v_skip = true;
          if (!detached && activeEffectScope) {
            if (activeEffectScope.active) {
              this.parent = activeEffectScope;
              this.index = (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(
                this
              ) - 1;
            } else {
              this._active = false;
              this._warnOnRun = false;
            }
          }
        }
        get active() {
          return this._active;
        }
        pause() {
          if (this._active) {
            this._isPaused = true;
            let i2, l;
            if (this.scopes) {
              const scopes = this.scopes.slice();
              for (i2 = 0, l = scopes.length; i2 < l; i2++) {
                scopes[i2].pause();
              }
            }
            for (i2 = 0, l = this.effects.length; i2 < l; i2++) {
              this.effects[i2].pause();
            }
          }
        }
        /**
         * Resumes the effect scope, including all child scopes and effects.
         */
        resume() {
          if (this._active) {
            if (this._isPaused) {
              this._isPaused = false;
              let i2, l;
              if (this.scopes) {
                const scopes = this.scopes.slice();
                for (i2 = 0, l = scopes.length; i2 < l; i2++) {
                  scopes[i2].resume();
                }
              }
              const effects = this.effects.slice();
              for (i2 = 0, l = effects.length; i2 < l; i2++) {
                effects[i2].resume();
              }
            }
          }
        }
        run(fn) {
          if (this._active) {
            const currentEffectScope = activeEffectScope;
            try {
              activeEffectScope = this;
              return fn();
            } finally {
              activeEffectScope = currentEffectScope;
            }
          } else if (this._warnOnRun) {
            warn(`cannot run an inactive effect scope.`);
          }
        }
        /**
         * This should only be called on non-detached scopes
         * @internal
         */
        on() {
          if (++this._on === 1) {
            this.prevScope = activeEffectScope;
            activeEffectScope = this;
          }
        }
        /**
         * This should only be called on non-detached scopes
         * @internal
         */
        off() {
          if (this._on > 0 && --this._on === 0) {
            if (activeEffectScope === this) {
              activeEffectScope = this.prevScope;
            } else {
              let current = activeEffectScope;
              while (current) {
                if (current.prevScope === this) {
                  current.prevScope = this.prevScope;
                  break;
                }
                current = current.prevScope;
              }
            }
            this.prevScope = void 0;
          }
        }
        stop(fromParent) {
          if (this._active) {
            this._active = false;
            let i2, l;
            for (i2 = 0, l = this.effects.length; i2 < l; i2++) {
              this.effects[i2].stop();
            }
            this.effects.length = 0;
            for (i2 = 0, l = this.cleanups.length; i2 < l; i2++) {
              this.cleanups[i2]();
            }
            this.cleanups.length = 0;
            if (this.scopes) {
              const scopes = this.scopes.slice();
              for (i2 = 0, l = scopes.length; i2 < l; i2++) {
                scopes[i2].stop(true);
              }
              this.scopes.length = 0;
            }
            if (!this.detached && this.parent && !fromParent) {
              const last = this.parent.scopes.pop();
              if (last && last !== this) {
                this.parent.scopes[this.index] = last;
                last.index = this.index;
              }
            }
            this.parent = void 0;
          }
        }
      };
      pausedQueueEffects = /* @__PURE__ */ new WeakSet();
      ReactiveEffect = class {
        constructor(fn) {
          this.fn = fn;
          this.deps = void 0;
          this.depsTail = void 0;
          this.flags = 1 | 4;
          this.next = void 0;
          this.cleanup = void 0;
          this.scheduler = void 0;
          if (activeEffectScope) {
            if (activeEffectScope.active) {
              activeEffectScope.effects.push(this);
            } else {
              this.flags &= -2;
            }
          }
        }
        pause() {
          this.flags |= 64;
        }
        resume() {
          if (this.flags & 64) {
            this.flags &= -65;
            if (pausedQueueEffects.has(this)) {
              pausedQueueEffects.delete(this);
              this.trigger();
            }
          }
        }
        /**
         * @internal
         */
        notify() {
          if (this.flags & 2 && !(this.flags & 32)) {
            return;
          }
          if (!(this.flags & 8)) {
            batch(this);
          }
        }
        run() {
          if (!(this.flags & 1)) {
            return this.fn();
          }
          this.flags |= 2;
          cleanupEffect(this);
          prepareDeps(this);
          const prevEffect = activeSub;
          const prevShouldTrack = shouldTrack;
          activeSub = this;
          shouldTrack = true;
          try {
            return this.fn();
          } finally {
            if (activeSub !== this) {
              warn(
                "Active effect was not restored correctly - this is likely a Vue internal bug."
              );
            }
            cleanupDeps(this);
            activeSub = prevEffect;
            shouldTrack = prevShouldTrack;
            this.flags &= -3;
          }
        }
        stop() {
          if (this.flags & 1) {
            for (let link = this.deps; link; link = link.nextDep) {
              removeSub(link);
            }
            this.deps = this.depsTail = void 0;
            cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
          }
        }
        trigger() {
          if (this.flags & 64) {
            pausedQueueEffects.add(this);
          } else if (this.scheduler) {
            this.scheduler();
          } else {
            this.runIfDirty();
          }
        }
        /**
         * @internal
         */
        runIfDirty() {
          if (isDirty(this)) {
            this.run();
          }
        }
        get dirty() {
          return isDirty(this);
        }
      };
      batchDepth = 0;
      shouldTrack = true;
      trackStack = [];
      globalVersion = 0;
      Link = class {
        constructor(sub, dep) {
          this.sub = sub;
          this.dep = dep;
          this.version = dep.version;
          this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
        }
      };
      Dep = class {
        // TODO isolatedDeclarations "__v_skip"
        constructor(computed3) {
          this.computed = computed3;
          this.version = 0;
          this.activeLink = void 0;
          this.subs = void 0;
          this.map = void 0;
          this.key = void 0;
          this.sc = 0;
          this.__v_skip = true;
          if (true) {
            this.subsHead = void 0;
          }
        }
        track(debugInfo) {
          if (!activeSub || !shouldTrack || activeSub === this.computed) {
            return;
          }
          let link = this.activeLink;
          if (link === void 0 || link.sub !== activeSub) {
            link = this.activeLink = new Link(activeSub, this);
            if (!activeSub.deps) {
              activeSub.deps = activeSub.depsTail = link;
            } else {
              link.prevDep = activeSub.depsTail;
              activeSub.depsTail.nextDep = link;
              activeSub.depsTail = link;
            }
            addSub(link);
          } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
              const next = link.nextDep;
              next.prevDep = link.prevDep;
              if (link.prevDep) {
                link.prevDep.nextDep = next;
              }
              link.prevDep = activeSub.depsTail;
              link.nextDep = void 0;
              activeSub.depsTail.nextDep = link;
              activeSub.depsTail = link;
              if (activeSub.deps === link) {
                activeSub.deps = next;
              }
            }
          }
          if (activeSub.onTrack) {
            activeSub.onTrack(
              extend(
                {
                  effect: activeSub
                },
                debugInfo
              )
            );
          }
          return link;
        }
        trigger(debugInfo) {
          this.version++;
          globalVersion++;
          this.notify(debugInfo);
        }
        notify(debugInfo) {
          startBatch();
          try {
            if (true) {
              for (let head = this.subsHead; head; head = head.nextSub) {
                if (head.sub.onTrigger && !(head.sub.flags & 8)) {
                  head.sub.onTrigger(
                    extend(
                      {
                        effect: head.sub
                      },
                      debugInfo
                    )
                  );
                }
              }
            }
            for (let link = this.subs; link; link = link.prevSub) {
              if (link.sub.notify()) {
                ;
                link.sub.dep.notify();
              }
            }
          } finally {
            endBatch();
          }
        }
      };
      targetMap = /* @__PURE__ */ new WeakMap();
      ITERATE_KEY = /* @__PURE__ */ Symbol(
        true ? "Object iterate" : ""
      );
      MAP_KEY_ITERATE_KEY = /* @__PURE__ */ Symbol(
        true ? "Map keys iterate" : ""
      );
      ARRAY_ITERATE_KEY = /* @__PURE__ */ Symbol(
        true ? "Array iterate" : ""
      );
      arrayInstrumentations = {
        __proto__: null,
        [Symbol.iterator]() {
          return iterator(this, Symbol.iterator, (item) => toWrapped(this, item));
        },
        concat(...args) {
          return reactiveReadArray(this).concat(
            ...args.map((x) => isArray(x) ? reactiveReadArray(x) : x)
          );
        },
        entries() {
          return iterator(this, "entries", (value) => {
            value[1] = toWrapped(this, value[1]);
            return value;
          });
        },
        every(fn, thisArg) {
          return apply(this, "every", fn, thisArg, void 0, arguments);
        },
        filter(fn, thisArg) {
          return apply(
            this,
            "filter",
            fn,
            thisArg,
            (v) => v.map((item) => toWrapped(this, item)),
            arguments
          );
        },
        find(fn, thisArg) {
          return apply(
            this,
            "find",
            fn,
            thisArg,
            (item) => toWrapped(this, item),
            arguments
          );
        },
        findIndex(fn, thisArg) {
          return apply(this, "findIndex", fn, thisArg, void 0, arguments);
        },
        findLast(fn, thisArg) {
          return apply(
            this,
            "findLast",
            fn,
            thisArg,
            (item) => toWrapped(this, item),
            arguments
          );
        },
        findLastIndex(fn, thisArg) {
          return apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
        },
        // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
        forEach(fn, thisArg) {
          return apply(this, "forEach", fn, thisArg, void 0, arguments);
        },
        includes(...args) {
          return searchProxy(this, "includes", args);
        },
        indexOf(...args) {
          return searchProxy(this, "indexOf", args);
        },
        join(separator) {
          return reactiveReadArray(this).join(separator);
        },
        // keys() iterator only reads `length`, no optimization required
        lastIndexOf(...args) {
          return searchProxy(this, "lastIndexOf", args);
        },
        map(fn, thisArg) {
          return apply(this, "map", fn, thisArg, void 0, arguments);
        },
        pop() {
          return noTracking(this, "pop");
        },
        push(...args) {
          return noTracking(this, "push", args);
        },
        reduce(fn, ...args) {
          return reduce(this, "reduce", fn, args);
        },
        reduceRight(fn, ...args) {
          return reduce(this, "reduceRight", fn, args);
        },
        shift() {
          return noTracking(this, "shift");
        },
        // slice could use ARRAY_ITERATE but also seems to beg for range tracking
        some(fn, thisArg) {
          return apply(this, "some", fn, thisArg, void 0, arguments);
        },
        splice(...args) {
          return noTracking(this, "splice", args);
        },
        toReversed() {
          return reactiveReadArray(this).toReversed();
        },
        toSorted(comparer) {
          return reactiveReadArray(this).toSorted(comparer);
        },
        toSpliced(...args) {
          return reactiveReadArray(this).toSpliced(...args);
        },
        unshift(...args) {
          return noTracking(this, "unshift", args);
        },
        values() {
          return iterator(this, "values", (item) => toWrapped(this, item));
        }
      };
      arrayProto = Array.prototype;
      isNonTrackableKeys = /* @__PURE__ */ makeMap(`__proto__,__v_isRef,__isVue`);
      builtInSymbols = new Set(
        /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key) => key !== "arguments" && key !== "caller").map((key) => Symbol[key]).filter(isSymbol)
      );
      BaseReactiveHandler = class {
        constructor(_isReadonly = false, _isShallow = false) {
          this._isReadonly = _isReadonly;
          this._isShallow = _isShallow;
        }
        get(target, key, receiver) {
          if (key === "__v_skip") return target["__v_skip"];
          const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
          if (key === "__v_isReactive") {
            return !isReadonly2;
          } else if (key === "__v_isReadonly") {
            return isReadonly2;
          } else if (key === "__v_isShallow") {
            return isShallow2;
          } else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? shallowReadonlyMap : readonlyMap : isShallow2 ? shallowReactiveMap : reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) {
              return target;
            }
            return;
          }
          const targetIsArray = isArray(target);
          if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = arrayInstrumentations[key])) {
              return fn;
            }
            if (key === "hasOwnProperty") {
              return hasOwnProperty2;
            }
          }
          const res = Reflect.get(
            target,
            key,
            // if this is a proxy wrapping a ref, return methods using the raw ref
            // as receiver so that we don't have to call `toRaw` on the ref in all
            // its class methods
            /* @__PURE__ */ isRef2(target) ? target : receiver
          );
          if (isSymbol(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) {
            return res;
          }
          if (!isReadonly2) {
            track(target, "get", key);
          }
          if (isShallow2) {
            return res;
          }
          if (/* @__PURE__ */ isRef2(res)) {
            const value = targetIsArray && isIntegerKey(key) ? res : res.value;
            return isReadonly2 && isObject(value) ? /* @__PURE__ */ readonly(value) : value;
          }
          if (isObject(res)) {
            return isReadonly2 ? /* @__PURE__ */ readonly(res) : /* @__PURE__ */ reactive(res);
          }
          return res;
        }
      };
      MutableReactiveHandler = class extends BaseReactiveHandler {
        constructor(isShallow2 = false) {
          super(false, isShallow2);
        }
        set(target, key, value, receiver) {
          let oldValue = target[key];
          const isArrayWithIntegerKey = isArray(target) && isIntegerKey(key);
          if (!this._isShallow) {
            const isOldValueReadonly = /* @__PURE__ */ isReadonly(oldValue);
            if (!/* @__PURE__ */ isShallow(value) && !/* @__PURE__ */ isReadonly(value)) {
              oldValue = /* @__PURE__ */ toRaw(oldValue);
              value = /* @__PURE__ */ toRaw(value);
            }
            if (!isArrayWithIntegerKey && /* @__PURE__ */ isRef2(oldValue) && !/* @__PURE__ */ isRef2(value)) {
              if (isOldValueReadonly) {
                if (true) {
                  warn(
                    `Set operation on key "${String(key)}" failed: target is readonly.`,
                    target[key]
                  );
                }
                return true;
              } else {
                oldValue.value = value;
                return true;
              }
            }
          }
          const hadKey = isArrayWithIntegerKey ? Number(key) < target.length : hasOwn(target, key);
          const result = Reflect.set(
            target,
            key,
            value,
            /* @__PURE__ */ isRef2(target) ? target : receiver
          );
          if (target === /* @__PURE__ */ toRaw(receiver) && result) {
            if (!hadKey) {
              trigger(target, "add", key, value);
            } else if (hasChanged(value, oldValue)) {
              trigger(target, "set", key, value, oldValue);
            }
          }
          return result;
        }
        deleteProperty(target, key) {
          const hadKey = hasOwn(target, key);
          const oldValue = target[key];
          const result = Reflect.deleteProperty(target, key);
          if (result && hadKey) {
            trigger(target, "delete", key, void 0, oldValue);
          }
          return result;
        }
        has(target, key) {
          const result = Reflect.has(target, key);
          if (!isSymbol(key) || !builtInSymbols.has(key)) {
            track(target, "has", key);
          }
          return result;
        }
        ownKeys(target) {
          track(
            target,
            "iterate",
            isArray(target) ? "length" : ITERATE_KEY
          );
          return Reflect.ownKeys(target);
        }
      };
      ReadonlyReactiveHandler = class extends BaseReactiveHandler {
        constructor(isShallow2 = false) {
          super(true, isShallow2);
        }
        set(target, key) {
          if (true) {
            warn(
              `Set operation on key "${String(key)}" failed: target is readonly.`,
              target
            );
          }
          return true;
        }
        deleteProperty(target, key) {
          if (true) {
            warn(
              `Delete operation on key "${String(key)}" failed: target is readonly.`,
              target
            );
          }
          return true;
        }
      };
      mutableHandlers = /* @__PURE__ */ new MutableReactiveHandler();
      readonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler();
      shallowReactiveHandlers = /* @__PURE__ */ new MutableReactiveHandler(true);
      shallowReadonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler(true);
      toShallow = (value) => value;
      getProto = (v) => Reflect.getPrototypeOf(v);
      mutableCollectionHandlers = {
        get: /* @__PURE__ */ createInstrumentationGetter(false, false)
      };
      shallowCollectionHandlers = {
        get: /* @__PURE__ */ createInstrumentationGetter(false, true)
      };
      readonlyCollectionHandlers = {
        get: /* @__PURE__ */ createInstrumentationGetter(true, false)
      };
      shallowReadonlyCollectionHandlers = {
        get: /* @__PURE__ */ createInstrumentationGetter(true, true)
      };
      reactiveMap = /* @__PURE__ */ new WeakMap();
      shallowReactiveMap = /* @__PURE__ */ new WeakMap();
      readonlyMap = /* @__PURE__ */ new WeakMap();
      shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
      toReactive = (value) => isObject(value) ? /* @__PURE__ */ reactive(value) : value;
      toReadonly = (value) => isObject(value) ? /* @__PURE__ */ readonly(value) : value;
      RefImpl = class {
        constructor(value, isShallow2) {
          this.dep = new Dep();
          this["__v_isRef"] = true;
          this["__v_isShallow"] = false;
          this._rawValue = isShallow2 ? value : /* @__PURE__ */ toRaw(value);
          this._value = isShallow2 ? value : toReactive(value);
          this["__v_isShallow"] = isShallow2;
        }
        get value() {
          if (true) {
            this.dep.track({
              target: this,
              type: "get",
              key: "value"
            });
          } else {
            this.dep.track();
          }
          return this._value;
        }
        set value(newValue) {
          const oldValue = this._rawValue;
          const useDirectValue = this["__v_isShallow"] || /* @__PURE__ */ isShallow(newValue) || /* @__PURE__ */ isReadonly(newValue);
          newValue = useDirectValue ? newValue : /* @__PURE__ */ toRaw(newValue);
          if (hasChanged(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : toReactive(newValue);
            if (true) {
              this.dep.trigger({
                target: this,
                type: "set",
                key: "value",
                newValue,
                oldValue
              });
            } else {
              this.dep.trigger();
            }
          }
        }
      };
      shallowUnwrapHandlers = {
        get: (target, key, receiver) => key === "__v_raw" ? target : unref(Reflect.get(target, key, receiver)),
        set: (target, key, value, receiver) => {
          const oldValue = target[key];
          if (/* @__PURE__ */ isRef2(oldValue) && !/* @__PURE__ */ isRef2(value)) {
            oldValue.value = value;
            return true;
          } else {
            return Reflect.set(target, key, value, receiver);
          }
        }
      };
      CustomRefImpl = class {
        constructor(factory2) {
          this["__v_isRef"] = true;
          this._value = void 0;
          const dep = this.dep = new Dep();
          const { get: get3, set } = factory2(dep.track.bind(dep), dep.trigger.bind(dep));
          this._get = get3;
          this._set = set;
        }
        get value() {
          return this._value = this._get();
        }
        set value(newVal) {
          this._set(newVal);
        }
      };
      ObjectRefImpl = class {
        constructor(_object, key, _defaultValue) {
          this._object = _object;
          this._defaultValue = _defaultValue;
          this["__v_isRef"] = true;
          this._value = void 0;
          this._key = isSymbol(key) ? key : String(key);
          this._raw = /* @__PURE__ */ toRaw(_object);
          let shallow = true;
          let obj = _object;
          if (!isArray(_object) || isSymbol(this._key) || !isIntegerKey(this._key)) {
            do {
              shallow = !/* @__PURE__ */ isProxy(obj) || /* @__PURE__ */ isShallow(obj);
            } while (shallow && (obj = obj["__v_raw"]));
          }
          this._shallow = shallow;
        }
        get value() {
          let val = this._object[this._key];
          if (this._shallow) {
            val = unref(val);
          }
          return this._value = val === void 0 ? this._defaultValue : val;
        }
        set value(newVal) {
          if (this._shallow && /* @__PURE__ */ isRef2(this._raw[this._key])) {
            const nestedRef = this._object[this._key];
            if (/* @__PURE__ */ isRef2(nestedRef)) {
              nestedRef.value = newVal;
              return;
            }
          }
          this._object[this._key] = newVal;
        }
        get dep() {
          return getDepFromReactive(this._raw, this._key);
        }
      };
      GetterRefImpl = class {
        constructor(_getter) {
          this._getter = _getter;
          this["__v_isRef"] = true;
          this["__v_isReadonly"] = true;
          this._value = void 0;
        }
        get value() {
          return this._value = this._getter();
        }
      };
      ComputedRefImpl = class {
        constructor(fn, setter, isSSR) {
          this.fn = fn;
          this.setter = setter;
          this._value = void 0;
          this.dep = new Dep(this);
          this.__v_isRef = true;
          this.deps = void 0;
          this.depsTail = void 0;
          this.flags = 16;
          this.globalVersion = globalVersion - 1;
          this.next = void 0;
          this.effect = this;
          this["__v_isReadonly"] = !setter;
          this.isSSR = isSSR;
        }
        /**
         * @internal
         */
        notify() {
          this.flags |= 16;
          if (!(this.flags & 8) && // avoid infinite self recursion
          activeSub !== this) {
            batch(this, true);
            return true;
          } else if (true) ;
        }
        get value() {
          const link = true ? this.dep.track({
            target: this,
            type: "get",
            key: "value"
          }) : this.dep.track();
          refreshComputed(this);
          if (link) {
            link.version = this.dep.version;
          }
          return this._value;
        }
        set value(newValue) {
          if (this.setter) {
            this.setter(newValue);
          } else if (true) {
            warn("Write operation failed: computed value is readonly");
          }
        }
      };
      TrackOpTypes = {
        "GET": "get",
        "HAS": "has",
        "ITERATE": "iterate"
      };
      TriggerOpTypes = {
        "SET": "set",
        "ADD": "add",
        "DELETE": "delete",
        "CLEAR": "clear"
      };
      INITIAL_WATCHER_VALUE = {};
      cleanupMap = /* @__PURE__ */ new WeakMap();
      activeWatcher = void 0;
    }
  });

  // node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js
  function pushWarningContext(vnode) {
    stack.push(vnode);
  }
  function popWarningContext() {
    stack.pop();
  }
  function warn$1(msg, ...args) {
    if (isWarning) return;
    isWarning = true;
    pauseTracking();
    const instance = stack.length ? stack[stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = getComponentTrace();
    if (appWarnHandler) {
      callWithErrorHandling(
        appWarnHandler,
        instance,
        11,
        [
          // eslint-disable-next-line no-restricted-syntax
          msg + args.map((a) => {
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
          }).join(""),
          instance && instance.proxy,
          trace.map(
            ({ vnode }) => `at <${formatComponentName(instance, vnode.type)}>`
          ).join("\n"),
          trace
        ]
      );
    } else {
      const warnArgs = [`[Vue warn]: ${msg}`, ...args];
      if (trace.length && // avoid spamming console during tests
      true) {
        warnArgs.push(`
`, ...formatTrace(trace));
      }
      console.warn(...warnArgs);
    }
    resetTracking();
    isWarning = false;
  }
  function getComponentTrace() {
    let currentVNode = stack[stack.length - 1];
    if (!currentVNode) {
      return [];
    }
    const normalizedStack = [];
    while (currentVNode) {
      const last = normalizedStack[0];
      if (last && last.vnode === currentVNode) {
        last.recurseCount++;
      } else {
        normalizedStack.push({
          vnode: currentVNode,
          recurseCount: 0
        });
      }
      const parentInstance = currentVNode.component && currentVNode.component.parent;
      currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
  }
  function formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i2) => {
      logs.push(...i2 === 0 ? [] : [`
`], ...formatTraceEntry(entry));
    });
    return logs;
  }
  function formatTraceEntry({ vnode, recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${formatComponentName(
      vnode.component,
      vnode.type,
      isRoot
    )}`;
    const close = `>` + postfix;
    return vnode.props ? [open, ...formatProps(vnode.props), close] : [open + close];
  }
  function formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key) => {
      res.push(...formatProp(key, props[key]));
    });
    if (keys.length > 3) {
      res.push(` ...`);
    }
    return res;
  }
  function formatProp(key, value, raw) {
    if (isString(value)) {
      value = JSON.stringify(value);
      return raw ? value : [`${key}=${value}`];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) {
      return raw ? value : [`${key}=${value}`];
    } else if (isRef2(value)) {
      value = formatProp(key, toRaw(value.value), true);
      return raw ? value : [`${key}=Ref<`, value, `>`];
    } else if (isFunction(value)) {
      return [`${key}=fn${value.name ? `<${value.name}>` : ``}`];
    } else {
      value = toRaw(value);
      return raw ? value : [`${key}=`, value];
    }
  }
  function assertNumber(val, type) {
    if (false) return;
    if (val === void 0) {
      return;
    } else if (typeof val !== "number") {
      warn$1(`${type} is not a valid number - got ${JSON.stringify(val)}.`);
    } else if (isNaN(val)) {
      warn$1(`${type} is NaN - the duration expression might be incorrect.`);
    }
  }
  function callWithErrorHandling(fn, instance, type, args) {
    try {
      return args ? fn(...args) : fn();
    } catch (err) {
      handleError(err, instance, type);
    }
  }
  function callWithAsyncErrorHandling(fn, instance, type, args) {
    if (isFunction(fn)) {
      const res = callWithErrorHandling(fn, instance, type, args);
      if (res && isPromise(res)) {
        res.catch((err) => {
          handleError(err, instance, type);
        });
      }
      return res;
    }
    if (isArray(fn)) {
      const values = [];
      for (let i2 = 0; i2 < fn.length; i2++) {
        values.push(callWithAsyncErrorHandling(fn[i2], instance, type, args));
      }
      return values;
    } else if (true) {
      warn$1(
        `Invalid value type passed to callWithAsyncErrorHandling(): ${typeof fn}`
      );
    }
  }
  function handleError(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler, throwUnhandledErrorInProduction } = instance && instance.appContext.config || EMPTY_OBJ;
    if (instance) {
      let cur = instance.parent;
      const exposedInstance = instance.proxy;
      const errorInfo = true ? ErrorTypeStrings$1[type] : `https://vuejs.org/error-reference/#runtime-${type}`;
      while (cur) {
        const errorCapturedHooks = cur.ec;
        if (errorCapturedHooks) {
          for (let i2 = 0; i2 < errorCapturedHooks.length; i2++) {
            if (errorCapturedHooks[i2](err, exposedInstance, errorInfo) === false) {
              return;
            }
          }
        }
        cur = cur.parent;
      }
      if (errorHandler) {
        pauseTracking();
        callWithErrorHandling(errorHandler, null, 10, [
          err,
          exposedInstance,
          errorInfo
        ]);
        resetTracking();
        return;
      }
    }
    logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
  }
  function logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (true) {
      const info = ErrorTypeStrings$1[type];
      if (contextVNode) {
        pushWarningContext(contextVNode);
      }
      warn$1(`Unhandled error${info ? ` during execution of ${info}` : ``}`);
      if (contextVNode) {
        popWarningContext();
      }
      if (throwInDev) {
        throw err;
      } else {
        console.error(err);
      }
    } else if (throwInProd) {
      throw err;
    } else {
      console.error(err);
    }
  }
  function nextTick(fn) {
    const p2 = currentFlushPromise || resolvedPromise;
    return fn ? p2.then(this ? fn.bind(this) : fn) : p2;
  }
  function findInsertionIndex(id) {
    let start = flushIndex + 1;
    let end = queue.length;
    while (start < end) {
      const middle = start + end >>> 1;
      const middleJob = queue[middle];
      const middleJobId = getId(middleJob);
      if (middleJobId < id || middleJobId === id && middleJob.flags & 2) {
        start = middle + 1;
      } else {
        end = middle;
      }
    }
    return start;
  }
  function queueJob(job) {
    if (!(job.flags & 1)) {
      const jobId = getId(job);
      const lastJob = queue[queue.length - 1];
      if (!lastJob || // fast path when the job id is larger than the tail
      !(job.flags & 2) && jobId >= getId(lastJob)) {
        queue.push(job);
      } else {
        queue.splice(findInsertionIndex(jobId), 0, job);
      }
      job.flags |= 1;
      queueFlush();
    }
  }
  function queueFlush() {
    if (!currentFlushPromise) {
      currentFlushPromise = resolvedPromise.then(flushJobs);
    }
  }
  function queuePostFlushCb(cb) {
    if (!isArray(cb)) {
      if (activePostFlushCbs && cb.id === -1) {
        activePostFlushCbs.splice(postFlushIndex + 1, 0, cb);
      } else if (!(cb.flags & 1)) {
        pendingPostFlushCbs.push(cb);
        cb.flags |= 1;
      }
    } else {
      for (let i2 = 0; i2 < cb.length; i2++) {
        pendingPostFlushCbs.push(cb[i2]);
      }
    }
    queueFlush();
  }
  function flushPreFlushCbs(instance, seen2, i2 = flushIndex + 1) {
    if (true) {
      seen2 = seen2 || /* @__PURE__ */ new Map();
    }
    for (; i2 < queue.length; i2++) {
      const cb = queue[i2];
      if (cb && cb.flags & 2) {
        if (instance && cb.id !== instance.uid) {
          continue;
        }
        if (checkRecursiveUpdates(seen2, cb)) {
          continue;
        }
        queue.splice(i2, 1);
        i2--;
        if (cb.flags & 4) {
          cb.flags &= -2;
        }
        cb();
        if (!(cb.flags & 4)) {
          cb.flags &= -2;
        }
      }
    }
  }
  function flushPostFlushCbs(seen2) {
    if (pendingPostFlushCbs.length) {
      const deduped = [...new Set(pendingPostFlushCbs)].sort(
        (a, b2) => getId(a) - getId(b2)
      );
      pendingPostFlushCbs.length = 0;
      if (activePostFlushCbs) {
        for (let i2 = 0; i2 < deduped.length; i2++) {
          activePostFlushCbs.push(deduped[i2]);
        }
        return;
      }
      activePostFlushCbs = deduped;
      if (true) {
        seen2 = seen2 || /* @__PURE__ */ new Map();
      }
      for (postFlushIndex = 0; postFlushIndex < activePostFlushCbs.length; postFlushIndex++) {
        const cb = activePostFlushCbs[postFlushIndex];
        if (checkRecursiveUpdates(seen2, cb)) {
          continue;
        }
        if (cb.flags & 4) {
          cb.flags &= -2;
        }
        if (!(cb.flags & 8)) cb();
        cb.flags &= -2;
      }
      activePostFlushCbs = null;
      postFlushIndex = 0;
    }
  }
  function flushJobs(seen2) {
    if (true) {
      seen2 = seen2 || /* @__PURE__ */ new Map();
    }
    const check = true ? (job) => checkRecursiveUpdates(seen2, job) : NOOP;
    try {
      for (flushIndex = 0; flushIndex < queue.length; flushIndex++) {
        const job = queue[flushIndex];
        if (job && !(job.flags & 8)) {
          if (check(job)) {
            continue;
          }
          if (job.flags & 4) {
            job.flags &= ~1;
          }
          callWithErrorHandling(
            job,
            job.i,
            job.i ? 15 : 14
          );
          if (!(job.flags & 4)) {
            job.flags &= ~1;
          }
        }
      }
    } finally {
      for (; flushIndex < queue.length; flushIndex++) {
        const job = queue[flushIndex];
        if (job) {
          job.flags &= -2;
        }
      }
      flushIndex = -1;
      queue.length = 0;
      flushPostFlushCbs(seen2);
      currentFlushPromise = null;
      if (queue.length || pendingPostFlushCbs.length) {
        flushJobs(seen2);
      }
    }
  }
  function checkRecursiveUpdates(seen2, fn) {
    const count = seen2.get(fn) || 0;
    if (count > RECURSION_LIMIT) {
      const instance = fn.i;
      const componentName = instance && getComponentName(instance.type);
      handleError(
        `Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
        null,
        10
      );
      return true;
    }
    seen2.set(fn, count + 1);
    return false;
  }
  function registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = map.get(id);
    if (!record) {
      createRecord(id, instance.type);
      record = map.get(id);
    }
    record.instances.add(instance);
  }
  function unregisterHMR(instance) {
    map.get(instance.type.__hmrId).instances.delete(instance);
  }
  function createRecord(id, initialDef) {
    if (map.has(id)) {
      return false;
    }
    map.set(id, {
      initialDef: normalizeClassComponent(initialDef),
      instances: /* @__PURE__ */ new Set()
    });
    return true;
  }
  function normalizeClassComponent(component) {
    return isClassComponent(component) ? component.__vccOpts : component;
  }
  function rerender(id, newRender) {
    const record = map.get(id);
    if (!record) {
      return;
    }
    record.initialDef.render = newRender;
    [...record.instances].forEach((instance) => {
      if (newRender) {
        instance.render = newRender;
        normalizeClassComponent(instance.type).render = newRender;
      }
      instance.renderCache = [];
      isHmrUpdating = true;
      if (!(instance.job.flags & 8)) {
        instance.update();
      }
      isHmrUpdating = false;
    });
  }
  function reload(id, newComp) {
    const record = map.get(id);
    if (!record) return;
    newComp = normalizeClassComponent(newComp);
    updateComponentDef(record.initialDef, newComp);
    const instances = [...record.instances];
    for (let i2 = 0; i2 < instances.length; i2++) {
      const instance = instances[i2];
      const oldComp = normalizeClassComponent(instance.type);
      let dirtyInstances = hmrDirtyComponents.get(oldComp);
      if (!dirtyInstances) {
        if (oldComp !== record.initialDef) {
          updateComponentDef(oldComp, newComp);
        }
        hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
      }
      dirtyInstances.add(instance);
      instance.appContext.propsCache.delete(instance.type);
      instance.appContext.emitsCache.delete(instance.type);
      instance.appContext.optionsCache.delete(instance.type);
      if (instance.ceReload) {
        dirtyInstances.add(instance);
        instance.ceReload(newComp.styles);
        dirtyInstances.delete(instance);
      } else if (instance.parent) {
        queueJob(() => {
          if (!(instance.job.flags & 8)) {
            isHmrUpdating = true;
            instance.parent.update();
            isHmrUpdating = false;
            dirtyInstances.delete(instance);
          }
        });
      } else if (instance.appContext.reload) {
        instance.appContext.reload();
      } else if (typeof window !== "undefined") {
        window.location.reload();
      } else {
        console.warn(
          "[HMR] Root or manually mounted instance modified. Full reload required."
        );
      }
      if (instance.root.ce && instance !== instance.root) {
        instance.root.ce._removeChildStyle(oldComp);
      }
    }
    queuePostFlushCb(() => {
      hmrDirtyComponents.clear();
    });
  }
  function updateComponentDef(oldComp, newComp) {
    extend(oldComp, newComp);
    for (const key in oldComp) {
      if (key !== "__file" && !(key in newComp)) {
        delete oldComp[key];
      }
    }
  }
  function tryWrap(fn) {
    return (id, arg) => {
      try {
        return fn(id, arg);
      } catch (e) {
        console.error(e);
        console.warn(
          `[HMR] Something went wrong during Vue component hot-reload. Full reload required.`
        );
      }
    };
  }
  function emit$1(event, ...args) {
    if (devtools$1) {
      devtools$1.emit(event, ...args);
    } else if (!devtoolsNotInstalled) {
      buffer.push({ event, args });
    }
  }
  function setDevtoolsHook$1(hook, target) {
    var _a, _b;
    devtools$1 = hook;
    if (devtools$1) {
      devtools$1.enabled = true;
      buffer.forEach(({ event, args }) => devtools$1.emit(event, ...args));
      buffer = [];
    } else if (
      // handle late devtools injection - only do this if we are in an actual
      // browser environment to avoid the timer handle stalling test runner exit
      // (#4815)
      typeof window !== "undefined" && // some envs mock window but not fully
      window.HTMLElement && // also exclude jsdom
      // eslint-disable-next-line no-restricted-syntax
      !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))
    ) {
      const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
      replay.push((newHook) => {
        setDevtoolsHook$1(newHook, target);
      });
      setTimeout(() => {
        if (!devtools$1) {
          target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
          devtoolsNotInstalled = true;
          buffer = [];
        }
      }, 3e3);
    } else {
      devtoolsNotInstalled = true;
      buffer = [];
    }
  }
  function devtoolsInitApp(app, version2) {
    emit$1("app:init", app, version2, {
      Fragment,
      Text,
      Comment,
      Static
    });
  }
  function devtoolsUnmountApp(app) {
    emit$1("app:unmount", app);
  }
  // @__NO_SIDE_EFFECTS__
  function createDevtoolsComponentHook(hook) {
    return (component) => {
      emit$1(
        hook,
        component.appContext.app,
        component.uid,
        component.parent ? component.parent.uid : void 0,
        component
      );
    };
  }
  function createDevtoolsPerformanceHook(hook) {
    return (component, type, time) => {
      emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
  }
  function devtoolsComponentEmit(component, event, params) {
    emit$1(
      "component:emit",
      component.appContext.app,
      component,
      event,
      params
    );
  }
  function setCurrentRenderingInstance(instance) {
    const prev = currentRenderingInstance;
    currentRenderingInstance = instance;
    currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
  }
  function pushScopeId(id) {
    currentScopeId = id;
  }
  function popScopeId() {
    currentScopeId = null;
  }
  function withCtx(fn, ctx = currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) {
      return fn;
    }
    const renderFnWithContext = (...args) => {
      if (renderFnWithContext._d) {
        setBlockTracking(-1);
      }
      const prevInstance = setCurrentRenderingInstance(ctx);
      const prevStackSize = blockStack.length;
      let res;
      try {
        res = fn(...args);
      } finally {
        for (let i2 = blockStack.length; i2 > prevStackSize; i2--) closeBlock();
        setCurrentRenderingInstance(prevInstance);
        if (renderFnWithContext._d) {
          setBlockTracking(1);
        }
      }
      if (true) {
        devtoolsComponentUpdated(ctx);
      }
      return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
  }
  function validateDirectiveName(name) {
    if (isBuiltInDirective(name)) {
      warn$1("Do not use built-in directive ids as custom directive id: " + name);
    }
  }
  function withDirectives(vnode, directives) {
    if (currentRenderingInstance === null) {
      warn$1(`withDirectives can only be used inside render functions.`);
      return vnode;
    }
    const instance = getComponentPublicInstance(currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for (let i2 = 0; i2 < directives.length; i2++) {
      let [dir, value, arg, modifiers = EMPTY_OBJ] = directives[i2];
      if (dir) {
        if (isFunction(dir)) {
          dir = {
            mounted: dir,
            updated: dir
          };
        }
        if (dir.deep) {
          traverse(value);
        }
        bindings.push({
          dir,
          instance,
          value,
          oldValue: void 0,
          arg,
          modifiers
        });
      }
    }
    return vnode;
  }
  function invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for (let i2 = 0; i2 < bindings.length; i2++) {
      const binding = bindings[i2];
      if (oldBindings) {
        binding.oldValue = oldBindings[i2].value;
      }
      let hook = binding.dir[name];
      if (hook) {
        pauseTracking();
        callWithAsyncErrorHandling(hook, instance, 8, [
          vnode.el,
          binding,
          vnode,
          prevVNode
        ]);
        resetTracking();
      }
    }
  }
  function provide(key, value) {
    if (true) {
      if (!currentInstance || currentInstance.isMounted) {
        warn$1(`provide() can only be used inside setup().`);
      }
    }
    if (currentInstance) {
      let provides = currentInstance.provides;
      const parentProvides = currentInstance.parent && currentInstance.parent.provides;
      if (parentProvides === provides) {
        provides = currentInstance.provides = Object.create(parentProvides);
      }
      provides[key] = value;
    }
  }
  function inject(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = getCurrentInstance();
    if (instance || currentApp) {
      let provides = currentApp ? currentApp._context.provides : instance ? instance.parent == null || instance.ce ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
      if (provides && key in provides) {
        return provides[key];
      } else if (arguments.length > 1) {
        return treatDefaultAsFactory && isFunction(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
      } else if (true) {
        warn$1(`injection "${String(key)}" not found.`);
      }
    } else if (true) {
      warn$1(`inject() can only be used inside setup() or functional components.`);
    }
  }
  function hasInjectionContext() {
    return !!(getCurrentInstance() || currentApp);
  }
  function watchEffect(effect2, options) {
    return doWatch(effect2, null, options);
  }
  function watchPostEffect(effect2, options) {
    return doWatch(
      effect2,
      null,
      true ? extend({}, options, { flush: "post" }) : { flush: "post" }
    );
  }
  function watchSyncEffect(effect2, options) {
    return doWatch(
      effect2,
      null,
      true ? extend({}, options, { flush: "sync" }) : { flush: "sync" }
    );
  }
  function watch2(source, cb, options) {
    if (!isFunction(cb)) {
      warn$1(
        `\`watch(fn, options?)\` signature has been moved to a separate API. Use \`watchEffect(fn, options?)\` instead. \`watch\` now only supports \`watch(source, cb, options?) signature.`
      );
    }
    return doWatch(source, cb, options);
  }
  function doWatch(source, cb, options = EMPTY_OBJ) {
    const { immediate, deep, flush, once } = options;
    if (!cb) {
      if (immediate !== void 0) {
        warn$1(
          `watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.`
        );
      }
      if (deep !== void 0) {
        warn$1(
          `watch() "deep" option is only respected when using the watch(source, callback, options?) signature.`
        );
      }
      if (once !== void 0) {
        warn$1(
          `watch() "once" option is only respected when using the watch(source, callback, options?) signature.`
        );
      }
    }
    const baseWatchOptions = extend({}, options);
    if (true) baseWatchOptions.onWarn = warn$1;
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if (isInSSRComponentSetup) {
      if (flush === "sync") {
        const ctx = useSSRContext();
        ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
      } else if (!runsImmediately) {
        const watchStopHandle = () => {
        };
        watchStopHandle.stop = NOOP;
        watchStopHandle.resume = NOOP;
        watchStopHandle.pause = NOOP;
        return watchStopHandle;
      }
    }
    const instance = currentInstance;
    baseWatchOptions.call = (fn, type, args) => callWithAsyncErrorHandling(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") {
      baseWatchOptions.scheduler = (job) => {
        queuePostRenderEffect(job, instance && instance.suspense);
      };
    } else if (flush !== "sync") {
      isPre = true;
      baseWatchOptions.scheduler = (job, isFirstRun) => {
        if (isFirstRun) {
          job();
        } else {
          queueJob(job);
        }
      };
    }
    baseWatchOptions.augmentJob = (job) => {
      if (cb) {
        job.flags |= 4;
      }
      if (isPre) {
        job.flags |= 2;
        if (instance) {
          job.id = instance.uid;
          job.i = instance;
        }
      }
    };
    const watchHandle = watch(source, cb, baseWatchOptions);
    if (isInSSRComponentSetup) {
      if (ssrCleanup) {
        ssrCleanup.push(watchHandle);
      } else if (runsImmediately) {
        watchHandle();
      }
    }
    return watchHandle;
  }
  function instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = isString(source) ? source.includes(".") ? createPathGetter(publicThis, source) : () => publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if (isFunction(value)) {
      cb = value;
    } else {
      cb = value.handler;
      options = value;
    }
    const reset2 = setCurrentInstance(this);
    const res = doWatch(getter, cb.bind(publicThis), options);
    reset2();
    return res;
  }
  function createPathGetter(ctx, path) {
    const segments = path.split(".");
    return () => {
      let cur = ctx;
      for (let i2 = 0; i2 < segments.length && cur; i2++) {
        cur = cur[segments[i2]];
      }
      return cur;
    };
  }
  function moveTeleport(vnode, container, parentAnchor, { o: { insert }, m: move }, moveType = 2) {
    if (moveType === 0) {
      insert(vnode.targetAnchor, container, parentAnchor);
    }
    const { el, anchor, shapeFlag, children, props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) {
      insert(el, container, parentAnchor);
    }
    if (!pendingMounts.has(vnode) && (!isReorder || isTeleportDisabled(props))) {
      if (shapeFlag & 16) {
        for (let i2 = 0; i2 < children.length; i2++) {
          move(
            children[i2],
            container,
            parentAnchor,
            2
          );
        }
      }
    }
    if (isReorder) {
      insert(anchor, container, parentAnchor);
    }
  }
  function hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, {
    o: { nextSibling, parentNode, querySelector, insert, createText }
  }, hydrateChildren) {
    function hydrateAnchor(target2, targetNode) {
      let targetAnchor = targetNode;
      while (targetAnchor) {
        if (targetAnchor && targetAnchor.nodeType === 8) {
          if (targetAnchor.data === "teleport start anchor") {
            vnode.targetStart = targetAnchor;
          } else if (targetAnchor.data === "teleport anchor") {
            vnode.targetAnchor = targetAnchor;
            target2._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
            break;
          }
        }
        targetAnchor = nextSibling(targetAnchor);
      }
    }
    function hydrateDisabledTeleport(node2, vnode2) {
      vnode2.anchor = hydrateChildren(
        nextSibling(node2),
        vnode2,
        parentNode(node2),
        parentComponent,
        parentSuspense,
        slotScopeIds,
        optimized
      );
    }
    const target = vnode.target = resolveTarget(
      vnode.props,
      querySelector
    );
    const disabled2 = isTeleportDisabled(vnode.props);
    if (target) {
      const targetNode = target._lpa || target.firstChild;
      if (vnode.shapeFlag & 16) {
        if (disabled2) {
          hydrateDisabledTeleport(node, vnode);
          hydrateAnchor(target, targetNode);
          if (!vnode.targetAnchor) {
            prepareAnchor(
              target,
              vnode,
              createText,
              insert,
              // if target is the same as the main view, insert anchors before current node
              // to avoid hydrating mismatch
              parentNode(node) === target ? node : null
            );
          }
        } else {
          vnode.anchor = nextSibling(node);
          hydrateAnchor(target, targetNode);
          if (!vnode.targetAnchor) {
            prepareAnchor(target, vnode, createText, insert);
          }
          hydrateChildren(
            targetNode && nextSibling(targetNode),
            vnode,
            target,
            parentComponent,
            parentSuspense,
            slotScopeIds,
            optimized
          );
        }
      }
      updateCssVars(vnode, disabled2);
    } else if (disabled2) {
      if (vnode.shapeFlag & 16) {
        hydrateDisabledTeleport(node, vnode);
        vnode.targetStart = node;
        vnode.targetAnchor = nextSibling(node);
      }
    }
    return vnode.anchor && nextSibling(vnode.anchor);
  }
  function updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
      let node, anchor;
      if (isDisabled) {
        node = vnode.el;
        anchor = vnode.anchor;
      } else {
        node = vnode.targetStart;
        anchor = vnode.targetAnchor;
      }
      while (node && node !== anchor) {
        if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
        node = node.nextSibling;
      }
      ctx.ut();
    }
  }
  function prepareAnchor(target, vnode, createText, insert, anchor = null) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[TeleportEndKey] = targetAnchor;
    if (target) {
      insert(targetStart, target, anchor);
      insert(targetAnchor, target, anchor);
    }
    return targetAnchor;
  }
  function useTransitionState() {
    const state4 = {
      isMounted: false,
      isLeaving: false,
      isUnmounting: false,
      leavingVNodes: /* @__PURE__ */ new Map()
    };
    onMounted(() => {
      state4.isMounted = true;
    });
    onBeforeUnmount(() => {
      state4.isUnmounting = true;
    });
    return state4;
  }
  function findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
      let hasFound = false;
      for (const c of children) {
        if (c.type !== Comment) {
          if (hasFound) {
            warn$1(
              "<transition> can only be used on a single element or component. Use <transition-group> for lists."
            );
            break;
          }
          child = c;
          hasFound = true;
          if (false) break;
        }
      }
    }
    return child;
  }
  function getLeavingNodesForType(state4, vnode) {
    const { leavingVNodes } = state4;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
      leavingVNodesCache = /* @__PURE__ */ Object.create(null);
      leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
  }
  function resolveTransitionHooks(vnode, props, state4, instance, postClone) {
    const {
      appear,
      mode,
      persisted = false,
      onBeforeEnter,
      onEnter,
      onAfterEnter,
      onEnterCancelled,
      onBeforeLeave,
      onLeave,
      onAfterLeave,
      onLeaveCancelled,
      onBeforeAppear,
      onAppear,
      onAfterAppear,
      onAppearCancelled
    } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = getLeavingNodesForType(state4, vnode);
    const callHook3 = (hook, args) => {
      hook && callWithAsyncErrorHandling(
        hook,
        instance,
        9,
        args
      );
    };
    const callAsyncHook = (hook, args) => {
      const done = args[1];
      callHook3(hook, args);
      if (isArray(hook)) {
        if (hook.every((hook2) => hook2.length <= 1)) done();
      } else if (hook.length <= 1) {
        done();
      }
    };
    const hooks = {
      mode,
      persisted,
      beforeEnter(el) {
        let hook = onBeforeEnter;
        if (!state4.isMounted) {
          if (appear) {
            hook = onBeforeAppear || onBeforeEnter;
          } else {
            return;
          }
        }
        if (el[leaveCbKey]) {
          el[leaveCbKey](
            true
            /* cancelled */
          );
        }
        const leavingVNode = leavingVNodesCache[key];
        if (leavingVNode && isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[leaveCbKey]) {
          leavingVNode.el[leaveCbKey]();
        }
        callHook3(hook, [el]);
      },
      enter(el) {
        if (!isHmrUpdating && leavingVNodesCache[key] === vnode) return;
        let hook = onEnter;
        let afterHook = onAfterEnter;
        let cancelHook = onEnterCancelled;
        if (!state4.isMounted) {
          if (appear) {
            hook = onAppear || onEnter;
            afterHook = onAfterAppear || onAfterEnter;
            cancelHook = onAppearCancelled || onEnterCancelled;
          } else {
            return;
          }
        }
        let called = false;
        el[enterCbKey] = (cancelled) => {
          if (called) return;
          called = true;
          if (cancelled) {
            callHook3(cancelHook, [el]);
          } else {
            callHook3(afterHook, [el]);
          }
          if (hooks.delayedLeave) {
            hooks.delayedLeave();
          }
          el[enterCbKey] = void 0;
        };
        const done = el[enterCbKey].bind(null, false);
        if (hook) {
          callAsyncHook(hook, [el, done]);
        } else {
          done();
        }
      },
      leave(el, remove2) {
        const key2 = String(vnode.key);
        if (el[enterCbKey]) {
          el[enterCbKey](
            true
            /* cancelled */
          );
        }
        if (state4.isUnmounting) {
          return remove2();
        }
        callHook3(onBeforeLeave, [el]);
        let called = false;
        el[leaveCbKey] = (cancelled) => {
          if (called) return;
          called = true;
          remove2();
          if (cancelled) {
            callHook3(onLeaveCancelled, [el]);
          } else {
            callHook3(onAfterLeave, [el]);
          }
          el[leaveCbKey] = void 0;
          if (leavingVNodesCache[key2] === vnode) {
            delete leavingVNodesCache[key2];
          }
        };
        const done = el[leaveCbKey].bind(null, false);
        leavingVNodesCache[key2] = vnode;
        if (onLeave) {
          callAsyncHook(onLeave, [el, done]);
        } else {
          done();
        }
      },
      clone(vnode2) {
        const hooks2 = resolveTransitionHooks(
          vnode2,
          props,
          state4,
          instance,
          postClone
        );
        if (postClone) postClone(hooks2);
        return hooks2;
      }
    };
    return hooks;
  }
  function emptyPlaceholder(vnode) {
    if (isKeepAlive(vnode)) {
      vnode = cloneVNode(vnode);
      vnode.children = null;
      return vnode;
    }
  }
  function getInnerChild$1(vnode) {
    if (!isKeepAlive(vnode)) {
      if (isTeleport(vnode.type) && vnode.children) {
        return findNonCommentChild(vnode.children);
      }
      return vnode;
    }
    if (vnode.component) {
      return vnode.component.subTree;
    }
    const { shapeFlag, children } = vnode;
    if (children) {
      if (shapeFlag & 16) {
        return children[0];
      }
      if (shapeFlag & 32 && isFunction(children.default)) {
        return children.default();
      }
    }
  }
  function setTransitionHooks(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
      vnode.transition = hooks;
      const subTree = vnode.component.subTree;
      setTransitionHooks(
        isTeleport(subTree.type) ? getInnerChild$1(subTree) || subTree : subTree,
        hooks
      );
    } else if (vnode.shapeFlag & 128) {
      vnode.ssContent.transition = hooks.clone(vnode.ssContent);
      vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else {
      vnode.transition = hooks;
    }
  }
  function getTransitionRawChildren(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for (let i2 = 0; i2 < children.length; i2++) {
      let child = children[i2];
      const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i2);
      if (child.type === Fragment) {
        if (child.patchFlag & 128) keyedFragmentCount++;
        ret = ret.concat(
          getTransitionRawChildren(child.children, keepComment, key)
        );
      } else if (keepComment || child.type !== Comment) {
        ret.push(key != null ? cloneVNode(child, { key }) : child);
      }
    }
    if (keyedFragmentCount > 1) {
      for (let i2 = 0; i2 < ret.length; i2++) {
        ret[i2].patchFlag = -2;
      }
    }
    return ret;
  }
  // @__NO_SIDE_EFFECTS__
  function defineComponent(options, extraOptions) {
    return isFunction(options) ? (
      // #8236: extend call and options.name access are considered side-effects
      // by Rollup, so we have to wrap it in a pure-annotated IIFE.
      /* @__PURE__ */ (() => extend({ name: options.name }, extraOptions, { setup: options }))()
    ) : options;
  }
  function useId() {
    const i2 = getCurrentInstance();
    if (i2) {
      return (i2.appContext.config.idPrefix || "v") + "-" + i2.ids[0] + i2.ids[1]++;
    } else if (true) {
      warn$1(
        `useId() is called when there is no active component instance to be associated with.`
      );
    }
    return "";
  }
  function markAsyncBoundary(instance) {
    instance.ids = [instance.ids[0] + instance.ids[2]++ + "-", 0, 0];
  }
  function useTemplateRef(key) {
    const i2 = getCurrentInstance();
    const r = shallowRef(null);
    if (i2) {
      const refs = i2.refs === EMPTY_OBJ ? i2.refs = {} : i2.refs;
      if (isTemplateRefKey(refs, key)) {
        warn$1(`useTemplateRef('${key}') already exists.`);
      } else {
        Object.defineProperty(refs, key, {
          enumerable: true,
          get: () => r.value,
          set: (val) => r.value = val
        });
      }
    } else if (true) {
      warn$1(
        `useTemplateRef() is called when there is no active component instance to be associated with.`
      );
    }
    const ret = true ? readonly(r) : r;
    if (true) {
      knownTemplateRefs.add(ret);
    }
    return ret;
  }
  function isTemplateRefKey(refs, key) {
    let desc;
    return !!((desc = Object.getOwnPropertyDescriptor(refs, key)) && !desc.configurable);
  }
  function setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if (isArray(rawRef)) {
      rawRef.forEach(
        (r, i2) => setRef(
          r,
          oldRawRef && (isArray(oldRawRef) ? oldRawRef[i2] : oldRawRef),
          parentSuspense,
          vnode,
          isUnmount
        )
      );
      return;
    }
    if (isAsyncWrapper(vnode) && !isUnmount) {
      if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) {
        setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
      }
      return;
    }
    const refValue = vnode.shapeFlag & 4 ? getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref2 } = rawRef;
    if (!owner) {
      warn$1(
        `Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function.`
      );
      return;
    }
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === EMPTY_OBJ ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = toRaw(setupState);
    const canSetSetupRef = setupState === EMPTY_OBJ ? NO : (key) => {
      if (true) {
        if (hasOwn(rawSetupState, key) && !isRef2(rawSetupState[key])) {
          warn$1(
            `Template ref "${key}" used on a non-ref value. It will not work in the production build.`
          );
        }
        if (knownTemplateRefs.has(rawSetupState[key])) {
          return false;
        }
      }
      if (isTemplateRefKey(refs, key)) {
        return false;
      }
      return hasOwn(rawSetupState, key);
    };
    const canSetRef = (ref22, key) => {
      if (knownTemplateRefs.has(ref22)) {
        return false;
      }
      if (key && isTemplateRefKey(refs, key)) {
        return false;
      }
      return true;
    };
    if (oldRef != null && oldRef !== ref2) {
      invalidatePendingSetRef(oldRawRef);
      if (isString(oldRef)) {
        refs[oldRef] = null;
        if (canSetSetupRef(oldRef)) {
          setupState[oldRef] = null;
        }
      } else if (isRef2(oldRef)) {
        const oldRawRefAtom = oldRawRef;
        if (canSetRef(oldRef, oldRawRefAtom.k)) {
          oldRef.value = null;
        }
        if (oldRawRefAtom.k) refs[oldRawRefAtom.k] = null;
      }
    }
    if (isFunction(ref2)) {
      callWithErrorHandling(ref2, owner, 12, [value, refs]);
    } else {
      const _isString = isString(ref2);
      const _isRef = isRef2(ref2);
      if (_isString || _isRef) {
        const doSet = () => {
          if (rawRef.f) {
            const existing = _isString ? canSetSetupRef(ref2) ? setupState[ref2] : refs[ref2] : canSetRef(ref2) || !rawRef.k ? ref2.value : refs[rawRef.k];
            if (isUnmount) {
              isArray(existing) && remove(existing, refValue);
            } else {
              if (!isArray(existing)) {
                if (_isString) {
                  refs[ref2] = [refValue];
                  if (canSetSetupRef(ref2)) {
                    setupState[ref2] = refs[ref2];
                  }
                } else {
                  const newVal = [refValue];
                  if (canSetRef(ref2, rawRef.k)) {
                    ref2.value = newVal;
                  }
                  if (rawRef.k) refs[rawRef.k] = newVal;
                }
              } else if (!existing.includes(refValue)) {
                existing.push(refValue);
              }
            }
          } else if (_isString) {
            refs[ref2] = value;
            if (canSetSetupRef(ref2)) {
              setupState[ref2] = value;
            }
          } else if (_isRef) {
            if (canSetRef(ref2, rawRef.k)) {
              ref2.value = value;
            }
            if (rawRef.k) refs[rawRef.k] = value;
          } else if (true) {
            warn$1("Invalid template ref type:", ref2, `(${typeof ref2})`);
          }
        };
        if (value) {
          const job = () => {
            doSet();
            pendingSetRefMap.delete(rawRef);
          };
          job.id = -1;
          pendingSetRefMap.set(rawRef, job);
          queuePostRenderEffect(job, parentSuspense);
        } else {
          invalidatePendingSetRef(rawRef);
          doSet();
        }
      } else if (true) {
        warn$1("Invalid template ref type:", ref2, `(${typeof ref2})`);
      }
    }
  }
  function invalidatePendingSetRef(rawRef) {
    const pendingSetRef = pendingSetRefMap.get(rawRef);
    if (pendingSetRef) {
      pendingSetRef.flags |= 8;
      pendingSetRefMap.delete(rawRef);
    }
  }
  function createHydrationFunctions(rendererInternals) {
    const {
      mt: mountComponent,
      p: patch,
      o: {
        patchProp: patchProp2,
        createText,
        nextSibling,
        parentNode,
        remove: remove2,
        insert,
        createComment
      }
    } = rendererInternals;
    const hydrate2 = (vnode, container) => {
      if (!container.hasChildNodes()) {
        warn$1(
          `Attempting to hydrate existing markup but container is empty. Performing full mount instead.`
        );
        patch(null, vnode, container);
        flushPostFlushCbs();
        container._vnode = vnode;
        return;
      }
      hydrateNode(container.firstChild, vnode, null, null, null);
      flushPostFlushCbs();
      container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false) => {
      optimized = optimized || !!vnode.dynamicChildren;
      const isFragmentStart = isComment(node) && node.data === "[";
      const onMismatch = () => handleMismatch(
        node,
        vnode,
        parentComponent,
        parentSuspense,
        slotScopeIds,
        isFragmentStart
      );
      const { type, ref: ref2, shapeFlag, patchFlag } = vnode;
      let domType = node.nodeType;
      vnode.el = node;
      if (true) {
        def(node, "__vnode", vnode, true);
        def(node, "__vueParentComponent", parentComponent, true);
      }
      if (patchFlag === -2) {
        optimized = false;
        vnode.dynamicChildren = null;
      }
      let nextNode = null;
      switch (type) {
        case Text:
          if (domType !== 3) {
            if (vnode.children === "") {
              insert(vnode.el = createText(""), parentNode(node), node);
              nextNode = node;
            } else {
              nextNode = onMismatch();
            }
          } else {
            if (node.data !== vnode.children) {
              warn$1(
                `Hydration text mismatch in`,
                node.parentNode,
                `
  - rendered on server: ${JSON.stringify(
                  node.data
                )}
  - expected on client: ${JSON.stringify(vnode.children)}`
              );
              logMismatchError();
              node.data = vnode.children;
            }
            nextNode = nextSibling(node);
          }
          break;
        case Comment:
          if (isTemplateNode2(node)) {
            nextNode = nextSibling(node);
            replaceNode(
              vnode.el = node.content.firstChild,
              node,
              parentComponent
            );
          } else if (domType !== 8 || isFragmentStart) {
            nextNode = onMismatch();
          } else {
            nextNode = nextSibling(node);
          }
          break;
        case Static:
          if (isFragmentStart) {
            node = nextSibling(node);
            domType = node.nodeType;
          }
          if (domType === 1 || domType === 3) {
            nextNode = node;
            const needToAdoptContent = !vnode.children.length;
            for (let i2 = 0; i2 < vnode.staticCount; i2++) {
              if (needToAdoptContent)
                vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
              if (i2 === vnode.staticCount - 1) {
                vnode.anchor = nextNode;
              }
              nextNode = nextSibling(nextNode);
            }
            return isFragmentStart ? nextSibling(nextNode) : nextNode;
          } else {
            onMismatch();
          }
          break;
        case Fragment:
          if (!isFragmentStart) {
            nextNode = onMismatch();
          } else {
            nextNode = hydrateFragment(
              node,
              vnode,
              parentComponent,
              parentSuspense,
              slotScopeIds,
              optimized
            );
          }
          break;
        default:
          if (shapeFlag & 1) {
            if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode2(node)) {
              nextNode = onMismatch();
            } else {
              nextNode = hydrateElement(
                node,
                vnode,
                parentComponent,
                parentSuspense,
                slotScopeIds,
                optimized
              );
            }
          } else if (shapeFlag & 6) {
            vnode.slotScopeIds = slotScopeIds;
            const container = parentNode(node);
            if (isFragmentStart) {
              nextNode = locateClosingAnchor(node);
            } else if (isComment(node) && node.data === "teleport start") {
              nextNode = locateClosingAnchor(node, node.data, "teleport end");
            } else {
              nextNode = nextSibling(node);
            }
            mountComponent(
              vnode,
              container,
              null,
              parentComponent,
              parentSuspense,
              getContainerType(container),
              optimized
            );
            if (isAsyncWrapper(vnode) && !vnode.type.__asyncResolved) {
              let subTree;
              if (isFragmentStart) {
                subTree = createVNode(Fragment);
                subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
              } else {
                subTree = node.nodeType === 3 ? createTextVNode("") : createVNode("div");
              }
              subTree.el = node;
              vnode.component.subTree = subTree;
            }
          } else if (shapeFlag & 64) {
            if (domType !== 8) {
              nextNode = onMismatch();
            } else {
              nextNode = vnode.type.hydrate(
                node,
                vnode,
                parentComponent,
                parentSuspense,
                slotScopeIds,
                optimized,
                rendererInternals,
                hydrateChildren
              );
            }
          } else if (shapeFlag & 128) {
            nextNode = vnode.type.hydrate(
              node,
              vnode,
              parentComponent,
              parentSuspense,
              getContainerType(parentNode(node)),
              slotScopeIds,
              optimized,
              rendererInternals,
              hydrateNode
            );
          } else if (true) {
            warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
          }
      }
      if (ref2 != null) {
        setRef(ref2, null, parentSuspense, vnode);
      }
      return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized) => {
      optimized = optimized || !!vnode.dynamicChildren;
      const {
        type,
        dynamicProps,
        props,
        patchFlag,
        shapeFlag,
        dirs,
        transition
      } = vnode;
      const forcePatch = type === "input" || type === "option";
      const hasDynamicProps = !!dynamicProps;
      if (true) {
        if (dirs) {
          invokeDirectiveHook(vnode, null, parentComponent, "created");
        }
        let needCallTransitionHooks = false;
        if (isTemplateNode2(el)) {
          needCallTransitionHooks = needTransition(
            null,
            // no need check parentSuspense in hydration
            transition
          ) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
          const content = el.content.firstChild;
          if (needCallTransitionHooks) {
            const cls = content.getAttribute("class");
            if (cls) content.$cls = cls;
            transition.beforeEnter(content);
          }
          replaceNode(content, el, parentComponent);
          vnode.el = el = content;
        }
        if (shapeFlag & 16 && // skip if element has innerHTML / textContent
        !(props && (props.innerHTML || props.textContent))) {
          let next = hydrateChildren(
            el.firstChild,
            vnode,
            el,
            parentComponent,
            parentSuspense,
            slotScopeIds,
            optimized
          );
          if (next && !isMismatchAllowed(
            el,
            1
            /* CHILDREN */
          )) {
            warn$1(
              `Hydration children mismatch on`,
              el,
              `
Server rendered element contains more child nodes than client vdom.`
            );
            logMismatchError();
          }
          while (next) {
            const cur = next;
            next = next.nextSibling;
            remove2(cur);
          }
        } else if (shapeFlag & 8) {
          let clientText = vnode.children;
          if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) {
            clientText = clientText.slice(1);
          }
          const { textContent } = el;
          if (textContent !== clientText && // innerHTML normalize \r\n or \r into a single \n in the DOM
          textContent !== clientText.replace(/\r\n|\r/g, "\n")) {
            if (!isMismatchAllowed(
              el,
              0
              /* TEXT */
            )) {
              warn$1(
                `Hydration text content mismatch on`,
                el,
                `
  - rendered on server: ${textContent}
  - expected on client: ${clientText}`
              );
              logMismatchError();
            }
            el.textContent = vnode.children;
          }
        }
        if (props) {
          if (true) {
            const isCustomElement = el.tagName.includes("-");
            const namespace = el.namespaceURI.includes("svg") ? "svg" : el.namespaceURI.includes("MathML") ? "mathml" : void 0;
            for (const key in props) {
              if (// #11189 skip if this node has directives that have created hooks
              // as it could have mutated the DOM in any possible way
              !(dirs && dirs.some((d) => d.dir.created)) && propHasMismatch(el, key, props[key], vnode, parentComponent)) {
                logMismatchError();
              }
              if (forcePatch && (key.endsWith("value") || key === "indeterminate") || isOn(key) && !isReservedProp(key) || // force hydrate v-bind with .prop modifiers
              key[0] === "." || isCustomElement && !isReservedProp(key) || dynamicProps && dynamicProps.includes(key)) {
                if (isUnchangedResourceProp(el, key, props[key])) {
                  continue;
                }
                patchProp2(el, key, null, props[key], namespace, parentComponent);
              }
            }
          } else if (props.onClick) {
            patchProp2(
              el,
              "onClick",
              null,
              props.onClick,
              void 0,
              parentComponent
            );
          } else if (patchFlag & 4 && isReactive(props.style)) {
            for (const key in props.style) props.style[key];
          }
        }
        let vnodeHooks;
        if (vnodeHooks = props && props.onVnodeBeforeMount) {
          invokeVNodeHook(vnodeHooks, parentComponent, vnode);
        }
        if (dirs) {
          invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        }
        if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) {
          queueEffectWithSuspense(() => {
            vnodeHooks && invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && invokeDirectiveHook(vnode, null, parentComponent, "mounted");
          }, parentSuspense);
        }
      }
      return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized) => {
      optimized = optimized || !!parentVNode.dynamicChildren;
      const children = parentVNode.children;
      const l = children.length;
      let hasCheckedMismatch = false;
      for (let i2 = 0; i2 < l; i2++) {
        const vnode = optimized ? children[i2] : children[i2] = normalizeVNode(children[i2]);
        const isText2 = vnode.type === Text;
        if (node) {
          if (isText2 && !optimized) {
            if (i2 + 1 < l && normalizeVNode(children[i2 + 1]).type === Text) {
              insert(
                createText(
                  node.data.slice(vnode.children.length)
                ),
                container,
                nextSibling(node)
              );
              node.data = vnode.children;
            }
          }
          node = hydrateNode(
            node,
            vnode,
            parentComponent,
            parentSuspense,
            slotScopeIds,
            optimized
          );
        } else if (isText2 && !vnode.children) {
          insert(vnode.el = createText(""), container);
        } else {
          if (!hasCheckedMismatch) {
            hasCheckedMismatch = true;
            if (!isMismatchAllowed(
              container,
              1
              /* CHILDREN */
            )) {
              warn$1(
                `Hydration children mismatch on`,
                container,
                `
Server rendered element contains fewer child nodes than client vdom.`
              );
              logMismatchError();
            }
          }
          patch(
            null,
            vnode,
            container,
            null,
            parentComponent,
            parentSuspense,
            getContainerType(container),
            slotScopeIds
          );
        }
      }
      return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized) => {
      const { slotScopeIds: fragmentSlotScopeIds } = vnode;
      if (fragmentSlotScopeIds) {
        slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
      }
      const container = parentNode(node);
      const next = hydrateChildren(
        nextSibling(node),
        vnode,
        container,
        parentComponent,
        parentSuspense,
        slotScopeIds,
        optimized
      );
      if (next && isComment(next) && next.data === "]") {
        return nextSibling(vnode.anchor = next);
      } else {
        logMismatchError();
        insert(vnode.anchor = createComment(`]`), container, next);
        return next;
      }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment) => {
      if (!isNodeMismatchAllowed(node, vnode)) {
        warn$1(
          `Hydration node mismatch:
- rendered on server:`,
          node,
          node.nodeType === 3 ? `(text)` : isComment(node) && node.data === "[" ? `(start of fragment)` : ``,
          `
- expected on client:`,
          vnode.type
        );
        logMismatchError();
      }
      vnode.el = null;
      if (isFragment) {
        const end = locateClosingAnchor(node);
        while (true) {
          const next2 = nextSibling(node);
          if (next2 && next2 !== end) {
            remove2(next2);
          } else {
            break;
          }
        }
      }
      const next = nextSibling(node);
      const container = parentNode(node);
      remove2(node);
      patch(
        null,
        vnode,
        container,
        next,
        parentComponent,
        parentSuspense,
        getContainerType(container),
        slotScopeIds
      );
      if (parentComponent) {
        parentComponent.vnode.el = vnode.el;
        updateHOCHostEl(parentComponent, vnode.el);
      }
      return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]") => {
      let match = 0;
      while (node) {
        node = nextSibling(node);
        if (node && isComment(node)) {
          if (node.data === open) match++;
          if (node.data === close) {
            if (match === 0) {
              return nextSibling(node);
            } else {
              match--;
            }
          }
        }
      }
      return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent) => {
      const parentNode2 = oldNode.parentNode;
      if (parentNode2) {
        parentNode2.replaceChild(newNode, oldNode);
      }
      let parent = parentComponent;
      while (parent) {
        if (parent.vnode.el === oldNode) {
          parent.vnode.el = parent.subTree.el = newNode;
        }
        parent = parent.parent;
      }
    };
    const isTemplateNode2 = (node) => {
      return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [hydrate2, hydrateNode];
  }
  function isUnchangedResourceProp(el, key, clientValue) {
    if (!resourceProps.has(key)) {
      return false;
    }
    return el.getAttribute(key) === (clientValue == null ? null : `${clientValue}`);
  }
  function propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
      if (el.$cls) {
        actual = el.$cls;
        delete el.$cls;
      } else {
        actual = el.getAttribute("class");
      }
      expected = normalizeClass(clientValue);
      if (!isSetEqual(toClassSet(actual || ""), toClassSet(expected))) {
        mismatchType = 2;
        mismatchKey = `class`;
      }
    } else if (key === "style") {
      actual = el.getAttribute("style") || "";
      expected = isString(clientValue) ? clientValue : stringifyStyle(normalizeStyle(clientValue));
      const actualMap = toStyleMap(actual);
      const expectedMap = toStyleMap(expected);
      if (vnode.dirs) {
        for (const { dir, value } of vnode.dirs) {
          if (dir.name === "show" && !value) {
            expectedMap.set("display", "none");
          }
        }
      }
      if (instance) {
        resolveCssVars(instance, vnode, expectedMap);
      }
      if (!isMapEqual(actualMap, expectedMap)) {
        mismatchType = 3;
        mismatchKey = "style";
      }
    } else if (el instanceof SVGElement && isKnownSvgAttr(key) || el instanceof HTMLElement && (isBooleanAttr(key) || isKnownHtmlAttr(key))) {
      if (key === "hidden") {
        actual = normalizeHiddenValue(el.getAttribute(key));
        expected = normalizeHiddenValue(clientValue);
      } else if (isBooleanAttr(key)) {
        actual = el.hasAttribute(key);
        expected = includeBooleanAttr(clientValue);
      } else if (clientValue == null) {
        actual = el.hasAttribute(key);
        expected = false;
      } else {
        if (el.hasAttribute(key)) {
          actual = el.getAttribute(key);
        } else if (key === "value" && el.tagName === "TEXTAREA") {
          actual = el.value;
        } else {
          actual = false;
        }
        expected = isRenderableAttrValue(clientValue) ? String(clientValue) : false;
      }
      if (actual !== expected) {
        mismatchType = 4;
        mismatchKey = key;
      }
    }
    if (mismatchType != null && !isMismatchAllowed(el, mismatchType)) {
      const format = (v) => v === false ? `(not rendered)` : `${mismatchKey}="${v}"`;
      const preSegment = `Hydration ${MismatchTypeString[mismatchType]} mismatch on`;
      const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
      {
        warn$1(preSegment, el, postSegment);
      }
      return true;
    }
    return false;
  }
  function normalizeHiddenValue(value) {
    if (!isRenderableAttrValue(value)) {
      return false;
    }
    if (isString(value)) {
      return value.toLowerCase() === "until-found" ? "until-found" : "";
    }
    return includeBooleanAttr(value) ? "" : false;
  }
  function toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
  }
  function isSetEqual(a, b2) {
    if (a.size !== b2.size) {
      return false;
    }
    for (const s of a) {
      if (!b2.has(s)) {
        return false;
      }
    }
    return true;
  }
  function toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")) {
      let [key, value] = item.split(":");
      key = key.trim();
      value = value && value.trim();
      if (key && value) {
        styleMap.set(key, value);
      }
    }
    return styleMap;
  }
  function isMapEqual(a, b2) {
    if (a.size !== b2.size) {
      return false;
    }
    for (const [key, value] of a) {
      if (value !== b2.get(key)) {
        return false;
      }
    }
    return true;
  }
  function resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === Fragment && root.children.includes(vnode))) {
      const cssVars = instance.getCssVars();
      for (const key in cssVars) {
        const value = normalizeCssVarValue(cssVars[key]);
        expectedMap.set(`--${getEscapedCssVarName(key, false)}`, value);
      }
    }
    if (vnode === root && instance.parent) {
      resolveCssVars(instance.parent, instance.vnode, expectedMap);
    }
  }
  function isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 || allowedType === 1) {
      while (el && !el.hasAttribute(allowMismatchAttr)) {
        el = el.parentElement;
      }
    }
    return isMismatchAllowedByAttr(
      el && el.getAttribute(allowMismatchAttr),
      allowedType
    );
  }
  function isMismatchAllowedByAttr(allowedAttr, allowedType) {
    if (allowedAttr == null) {
      return false;
    } else if (allowedAttr === "") {
      return true;
    } else {
      const list = allowedAttr.split(",");
      if (allowedType === 0 && list.includes("children")) {
        return true;
      }
      return list.includes(MismatchTypeString[allowedType]);
    }
  }
  function isNodeMismatchAllowed(node, vnode) {
    return isMismatchAllowed(
      node.parentElement,
      1
      /* CHILDREN */
    ) || isMismatchAllowedByNode(node) || isMismatchAllowedByVNode(vnode);
  }
  function isMismatchAllowedByNode(node) {
    return node.nodeType === 1 && isMismatchAllowedByAttr(
      node.getAttribute(allowMismatchAttr),
      1
      /* CHILDREN */
    );
  }
  function isMismatchAllowedByVNode({ props }) {
    const allowedAttr = props && props[allowMismatchAttr];
    return typeof allowedAttr === "string" && isMismatchAllowedByAttr(
      allowedAttr,
      1
      /* CHILDREN */
    );
  }
  function elementIsVisibleInViewport(el) {
    const { top, left, bottom, right } = el.getBoundingClientRect();
    const { innerHeight, innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
  }
  function forEachElement(node, cb) {
    if (isComment(node) && node.data === "[") {
      let depth = 1;
      let next = node.nextSibling;
      while (next) {
        if (next.nodeType === 1) {
          const result = cb(next);
          if (result === false) {
            break;
          }
        } else if (isComment(next)) {
          if (next.data === "]") {
            if (--depth === 0) break;
          } else if (next.data === "[") {
            depth++;
          }
        }
        next = next.nextSibling;
      }
    } else {
      cb(node);
    }
  }
  // @__NO_SIDE_EFFECTS__
  function defineAsyncComponent(source) {
    if (isFunction(source)) {
      source = { loader: source };
    }
    const {
      loader,
      loadingComponent,
      errorComponent,
      delay = 200,
      hydrate: hydrateStrategy,
      timeout,
      // undefined = never times out
      suspensible = true,
      onError: userOnError
    } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = () => {
      retries++;
      pendingRequest = null;
      return load();
    };
    const load = () => {
      let thisRequest;
      return pendingRequest || (thisRequest = pendingRequest = loader().catch((err) => {
        err = err instanceof Error ? err : new Error(String(err));
        if (userOnError) {
          return new Promise((resolve2, reject) => {
            const userRetry = () => resolve2(retry());
            const userFail = () => reject(err);
            userOnError(err, userRetry, userFail, retries + 1);
          });
        } else {
          throw err;
        }
      }).then((comp) => {
        if (thisRequest !== pendingRequest && pendingRequest) {
          return pendingRequest;
        }
        if (!comp) {
          warn$1(
            `Async component loader resolved to undefined. If you are using retry(), make sure to return its return value.`
          );
        }
        if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) {
          comp = comp.default;
        }
        if (comp && !isObject(comp) && !isFunction(comp)) {
          throw new Error(`Invalid async component load result: ${comp}`);
        }
        resolvedComp = comp;
        return comp;
      }));
    };
    return /* @__PURE__ */ defineComponent({
      name: "AsyncComponentWrapper",
      __asyncLoader: load,
      __asyncHydrate(el, instance, hydrate2) {
        const wasConnected = el.isConnected;
        let patched = false;
        (instance.bu || (instance.bu = [])).push(() => patched = true);
        const performHydrate = () => {
          if (patched) {
            if (true) {
              warn$1(
                `Skipping lazy hydration for component '${getComponentName(resolvedComp) || resolvedComp.__file}': it was updated before lazy hydration performed.`
              );
            }
            return;
          }
          if (!el.parentNode || wasConnected && !el.isConnected) return;
          hydrate2();
        };
        const doHydrate = hydrateStrategy ? () => {
          const teardown = hydrateStrategy(
            performHydrate,
            (cb) => forEachElement(el, cb)
          );
          if (teardown) {
            (instance.bum || (instance.bum = [])).push(teardown);
          }
        } : performHydrate;
        if (resolvedComp) {
          doHydrate();
        } else {
          load().then(() => !instance.isUnmounted && doHydrate());
        }
      },
      get __asyncResolved() {
        return resolvedComp;
      },
      setup() {
        const instance = currentInstance;
        markAsyncBoundary(instance);
        if (resolvedComp) {
          return () => createInnerComp(resolvedComp, instance);
        }
        const onError = (err) => {
          pendingRequest = null;
          handleError(
            err,
            instance,
            13,
            !errorComponent
          );
        };
        if (suspensible && instance.suspense || isInSSRComponentSetup) {
          return load().then((comp) => {
            return () => createInnerComp(comp, instance);
          }).catch((err) => {
            onError(err);
            return () => errorComponent ? createVNode(errorComponent, {
              error: err
            }) : null;
          });
        }
        const loaded = ref(false);
        const error = ref();
        const delayed = ref(!!delay);
        let timeoutTimer;
        let delayTimer;
        onUnmounted(() => {
          if (timeoutTimer != null) clearTimeout(timeoutTimer);
          if (delayTimer != null) clearTimeout(delayTimer);
        });
        if (delay) {
          delayTimer = setTimeout(() => {
            if (instance.isUnmounted) return;
            delayed.value = false;
          }, delay);
        }
        if (timeout != null) {
          timeoutTimer = setTimeout(() => {
            if (instance.isUnmounted) return;
            if (!loaded.value && !error.value) {
              const err = new Error(
                `Async component timed out after ${timeout}ms.`
              );
              onError(err);
              error.value = err;
            }
          }, timeout);
        }
        load().then(() => {
          if (instance.isUnmounted) return;
          loaded.value = true;
          if (instance.parent && isKeepAlive(instance.parent.vnode)) {
            instance.parent.update();
          }
        }).catch((err) => {
          if (instance.isUnmounted) {
            pendingRequest = null;
            return;
          }
          onError(err);
          error.value = err;
        });
        return () => {
          if (loaded.value && resolvedComp) {
            return createInnerComp(resolvedComp, instance);
          } else if (error.value && errorComponent) {
            return createVNode(errorComponent, {
              error: error.value
            });
          } else if (loadingComponent && !delayed.value) {
            return createInnerComp(
              loadingComponent,
              instance
            );
          }
        };
      }
    });
  }
  function createInnerComp(comp, parent) {
    const { ref: ref2, props, children, ce: ce2 } = parent.vnode;
    const vnode = createVNode(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce2;
    delete parent.vnode.ce;
    return vnode;
  }
  function matches(pattern, name) {
    if (isArray(pattern)) {
      return pattern.some((p2) => matches(p2, name));
    } else if (isString(pattern)) {
      return pattern.split(",").includes(name);
    } else if (isRegExp(pattern)) {
      pattern.lastIndex = 0;
      return pattern.test(name);
    }
    return false;
  }
  function onActivated(hook, target) {
    registerKeepAliveHook(hook, "a", target);
  }
  function onDeactivated(hook, target) {
    registerKeepAliveHook(hook, "da", target);
  }
  function registerKeepAliveHook(hook, type, target = currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = () => {
      let current = target;
      while (current) {
        if (current.isDeactivated) {
          return;
        }
        current = current.parent;
      }
      return hook();
    });
    injectHook(type, wrappedHook, target);
    if (target) {
      let current = target.parent;
      while (current && current.parent) {
        if (isKeepAlive(current.parent.vnode)) {
          injectToKeepAliveRoot(wrappedHook, type, target, current);
        }
        current = current.parent;
      }
    }
  }
  function injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = injectHook(
      type,
      hook,
      keepAliveRoot,
      true
      /* prepend */
    );
    onUnmounted(() => {
      remove(keepAliveRoot[type], injected);
    }, target);
  }
  function resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
  }
  function getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
  }
  function injectHook(type, hook, target = currentInstance, prepend = false) {
    if (target) {
      const hooks = target[type] || (target[type] = []);
      const wrappedHook = hook.__weh || (hook.__weh = (...args) => {
        pauseTracking();
        const reset2 = setCurrentInstance(target);
        const res = callWithAsyncErrorHandling(hook, target, type, args);
        reset2();
        resetTracking();
        return res;
      });
      if (prepend) {
        hooks.unshift(wrappedHook);
      } else {
        hooks.push(wrappedHook);
      }
      return wrappedHook;
    } else if (true) {
      const apiName = toHandlerKey(ErrorTypeStrings$1[type].replace(/ hook$/, ""));
      warn$1(
        `${apiName} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`
      );
    }
  }
  function onErrorCaptured(hook, target = currentInstance) {
    injectHook("ec", hook, target);
  }
  function resolveComponent(name, maybeSelfReference) {
    return resolveAsset(COMPONENTS, name, true, maybeSelfReference) || name;
  }
  function resolveDynamicComponent(component) {
    if (isString(component)) {
      return resolveAsset(COMPONENTS, component, false) || component;
    } else {
      return component || NULL_DYNAMIC_COMPONENT;
    }
  }
  function resolveDirective(name) {
    return resolveAsset(DIRECTIVES, name);
  }
  function resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = currentRenderingInstance || currentInstance;
    if (instance) {
      const Component = instance.type;
      if (type === COMPONENTS) {
        const selfName = getComponentName(
          Component,
          false
        );
        if (selfName && (selfName === name || selfName === camelize(name) || selfName === capitalize(camelize(name)))) {
          return Component;
        }
      }
      const res = (
        // local registration
        // check instance[type] first which is resolved for options API
        resolve(instance[type] || Component[type], name) || // global registration
        resolve(instance.appContext[type], name)
      );
      if (!res && maybeSelfReference) {
        return Component;
      }
      if (warnMissing && !res) {
        const extra = type === COMPONENTS ? `
If this is a native custom element, make sure to exclude it from component resolution via compilerOptions.isCustomElement.` : ``;
        warn$1(`Failed to resolve ${type.slice(0, -1)}: ${name}${extra}`);
      }
      return res;
    } else if (true) {
      warn$1(
        `resolve${capitalize(type.slice(0, -1))} can only be used in render() or setup().`
      );
    }
  }
  function resolve(registry, name) {
    return registry && (registry[name] || registry[camelize(name)] || registry[capitalize(camelize(name))]);
  }
  function renderList(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = isArray(source);
    if (sourceIsArray || isString(source)) {
      const sourceIsReactiveArray = sourceIsArray && isReactive(source);
      let needsWrap = false;
      let isReadonlySource = false;
      if (sourceIsReactiveArray) {
        needsWrap = !isShallow(source);
        isReadonlySource = isReadonly(source);
        source = shallowReadArray(source);
      }
      ret = new Array(source.length);
      for (let i2 = 0, l = source.length; i2 < l; i2++) {
        ret[i2] = renderItem(
          needsWrap ? isReadonlySource ? toReadonly(toReactive(source[i2])) : toReactive(source[i2]) : source[i2],
          i2,
          void 0,
          cached && cached[i2]
        );
      }
    } else if (typeof source === "number") {
      if (!Number.isInteger(source) || source < 0) {
        warn$1(
          `The v-for range expects a positive integer value but got ${source}.`
        );
        ret = [];
      } else {
        ret = new Array(source);
        for (let i2 = 0; i2 < source; i2++) {
          ret[i2] = renderItem(i2 + 1, i2, void 0, cached && cached[i2]);
        }
      }
    } else if (isObject(source)) {
      if (source[Symbol.iterator]) {
        ret = Array.from(
          source,
          (item, i2) => renderItem(item, i2, void 0, cached && cached[i2])
        );
      } else {
        const keys = Object.keys(source);
        ret = new Array(keys.length);
        for (let i2 = 0, l = keys.length; i2 < l; i2++) {
          const key = keys[i2];
          ret[i2] = renderItem(source[key], key, i2, cached && cached[i2]);
        }
      }
    } else {
      ret = [];
    }
    if (cache) {
      cache[index] = ret;
    }
    return ret;
  }
  function createSlots(slots, dynamicSlots) {
    for (let i2 = 0; i2 < dynamicSlots.length; i2++) {
      const slot = dynamicSlots[i2];
      if (isArray(slot)) {
        for (let j = 0; j < slot.length; j++) {
          slots[slot[j].name] = slot[j].fn;
        }
      } else if (slot) {
        slots[slot.name] = slot.key ? (...args) => {
          const res = slot.fn(...args);
          if (res) res.key = slot.key;
          return res;
        } : slot.fn;
      }
    }
    return slots;
  }
  function renderSlot(slots, name, props, fallback, noSlotted, branchKey) {
    if (props == null) props = {};
    if (currentRenderingInstance.ce || currentRenderingInstance.parent && isAsyncWrapper(currentRenderingInstance.parent) && currentRenderingInstance.parent.ce) {
      const slotProps = branchKey != null && props.key == null ? extend({}, props, { key: branchKey }) : props;
      const hasProps = Object.keys(slotProps).length > 0;
      if (name !== "default") slotProps.name = name;
      return openBlock(), createBlock(
        Fragment,
        null,
        [createVNode("slot", slotProps, fallback && fallback())],
        hasProps ? -2 : 64
      );
    }
    let slot = slots[name];
    if (slot && slot.length > 1) {
      warn$1(
        `SSR-optimized slot function detected in a non-SSR-optimized render function. You need to mark this component with $dynamic-slots in the parent template.`
      );
      slot = () => [];
    }
    if (slot && slot._c) {
      slot._d = false;
    }
    const prevStackSize = blockStack.length;
    openBlock();
    let rendered;
    try {
      const validSlotContent = slot && ensureValidVNode(slot(props));
      const slotKey = props.key || branchKey || // slot content array of a dynamic conditional slot may have a branch
      // key attached in the `createSlots` helper, respect that
      validSlotContent && validSlotContent.key;
      rendered = createBlock(
        Fragment,
        {
          key: (slotKey && !isSymbol(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
          (!validSlotContent && fallback ? "_fb" : "")
        },
        validSlotContent || (fallback ? fallback() : []),
        validSlotContent && slots._ === 1 ? 64 : -2
      );
    } catch (err) {
      for (let i2 = blockStack.length; i2 > prevStackSize; i2--) closeBlock();
      throw err;
    } finally {
      if (slot && slot._c) {
        slot._d = true;
      }
    }
    if (!noSlotted && rendered.scopeId) {
      rendered.slotScopeIds = [rendered.scopeId + "-s"];
    }
    return rendered;
  }
  function ensureValidVNode(vnodes) {
    return vnodes.some((child) => {
      if (!isVNode(child)) return true;
      if (child.type === Comment) return false;
      if (child.type === Fragment && !ensureValidVNode(child.children))
        return false;
      return true;
    }) ? vnodes : null;
  }
  function toHandlers(obj, preserveCaseIfNecessary) {
    const ret = {};
    if (!isObject(obj)) {
      warn$1(`v-on with no argument expects an object value.`);
      return ret;
    }
    for (const key in obj) {
      ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : toHandlerKey(key)] = obj[key];
    }
    return ret;
  }
  function createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
      configurable: true,
      enumerable: false,
      get: () => instance
    });
    Object.keys(publicPropertiesMap).forEach((key) => {
      Object.defineProperty(target, key, {
        configurable: true,
        enumerable: false,
        get: () => publicPropertiesMap[key](instance),
        // intercepted by the proxy so no need for implementation,
        // but needed to prevent set errors
        set: NOOP
      });
    });
    return target;
  }
  function exposePropsOnRenderContext(instance) {
    const {
      ctx,
      propsOptions: [propsOptions]
    } = instance;
    if (propsOptions) {
      Object.keys(propsOptions).forEach((key) => {
        Object.defineProperty(ctx, key, {
          enumerable: true,
          configurable: true,
          get: () => instance.props[key],
          set: NOOP
        });
      });
    }
  }
  function exposeSetupStateOnRenderContext(instance) {
    const { ctx, setupState } = instance;
    Object.keys(toRaw(setupState)).forEach((key) => {
      if (!setupState.__isScriptSetup) {
        if (isReservedPrefix(key[0])) {
          warn$1(
            `setup() return property ${JSON.stringify(
              key
            )} should not start with "$" or "_" which are reserved prefixes for Vue internals.`
          );
          return;
        }
        Object.defineProperty(ctx, key, {
          enumerable: true,
          configurable: true,
          get: () => setupState[key],
          set: NOOP
        });
      }
    });
  }
  function defineProps() {
    if (true) {
      warnRuntimeUsage(`defineProps`);
    }
    return null;
  }
  function defineEmits() {
    if (true) {
      warnRuntimeUsage(`defineEmits`);
    }
    return null;
  }
  function defineExpose(exposed) {
    if (true) {
      warnRuntimeUsage(`defineExpose`);
    }
  }
  function defineOptions(options) {
    if (true) {
      warnRuntimeUsage(`defineOptions`);
    }
  }
  function defineSlots() {
    if (true) {
      warnRuntimeUsage(`defineSlots`);
    }
    return null;
  }
  function defineModel() {
    if (true) {
      warnRuntimeUsage("defineModel");
    }
  }
  function withDefaults(props, defaults2) {
    if (true) {
      warnRuntimeUsage(`withDefaults`);
    }
    return null;
  }
  function useSlots() {
    return getContext("useSlots").slots;
  }
  function useAttrs() {
    return getContext("useAttrs").attrs;
  }
  function getContext(calledFunctionName) {
    const i2 = getCurrentInstance();
    if (!i2) {
      warn$1(`${calledFunctionName}() called without active instance.`);
    }
    return i2.setupContext || (i2.setupContext = createSetupContext(i2));
  }
  function normalizePropsOrEmits(props) {
    return isArray(props) ? props.reduce(
      (normalized, p2) => (normalized[p2] = null, normalized),
      {}
    ) : props;
  }
  function mergeDefaults(raw, defaults2) {
    const props = normalizePropsOrEmits(raw);
    for (const key in defaults2) {
      if (key.startsWith("__skip")) continue;
      let opt = props[key];
      if (opt) {
        if (isArray(opt) || isFunction(opt)) {
          opt = props[key] = { type: opt, default: defaults2[key] };
        } else {
          opt.default = defaults2[key];
        }
      } else if (opt === null) {
        opt = props[key] = { default: defaults2[key] };
      } else if (true) {
        warn$1(`props default key "${key}" has no corresponding declaration.`);
      }
      if (opt && defaults2[`__skip_${key}`]) {
        opt.skipFactory = true;
      }
    }
    return props;
  }
  function mergeModels(a, b2) {
    if (!a || !b2) return a || b2;
    if (isArray(a) && isArray(b2)) return a.concat(b2);
    return extend({}, normalizePropsOrEmits(a), normalizePropsOrEmits(b2));
  }
  function createPropsRestProxy(props, excludedKeys) {
    const ret = {};
    for (const key in props) {
      if (!excludedKeys.includes(key)) {
        Object.defineProperty(ret, key, {
          enumerable: true,
          get: () => props[key]
        });
      }
    }
    return ret;
  }
  function withAsyncContext(getAwaitable) {
    const ctx = getCurrentInstance();
    const inSSRSetup = isInSSRComponentSetup;
    if (!ctx) {
      warn$1(
        `withAsyncContext called without active current instance. This is likely a bug.`
      );
    }
    let awaitable = getAwaitable();
    unsetCurrentInstance();
    if (inSSRSetup) {
      setInSSRSetupState(false);
    }
    const restore = () => {
      setCurrentInstance(ctx);
      if (inSSRSetup) {
        setInSSRSetupState(true);
      }
    };
    const cleanup = () => {
      if (getCurrentInstance() !== ctx) ctx.scope.off();
      unsetCurrentInstance();
      if (inSSRSetup) {
        setInSSRSetupState(false);
      }
    };
    if (isPromise(awaitable)) {
      awaitable = awaitable.catch((e) => {
        restore();
        Promise.resolve().then(() => Promise.resolve().then(cleanup));
        throw e;
      });
    }
    return [
      awaitable,
      () => {
        restore();
        Promise.resolve().then(cleanup);
      }
    ];
  }
  function createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key) => {
      if (cache[key]) {
        warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
      } else {
        cache[key] = type;
      }
    };
  }
  function applyOptions(instance) {
    const options = resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    shouldCacheAccess = false;
    if (options.beforeCreate) {
      callHook(options.beforeCreate, instance, "bc");
    }
    const {
      // state
      data: dataOptions,
      computed: computedOptions,
      methods,
      watch: watchOptions,
      provide: provideOptions,
      inject: injectOptions,
      // lifecycle
      created,
      beforeMount,
      mounted,
      beforeUpdate,
      updated,
      activated,
      deactivated,
      beforeDestroy,
      beforeUnmount,
      destroyed,
      unmounted,
      render: render67,
      renderTracked,
      renderTriggered,
      errorCaptured,
      serverPrefetch,
      // public API
      expose,
      inheritAttrs,
      // assets
      components,
      directives,
      filters
    } = options;
    const checkDuplicateProperties = true ? createDuplicateChecker() : null;
    if (true) {
      const [propsOptions] = instance.propsOptions;
      if (propsOptions) {
        for (const key in propsOptions) {
          checkDuplicateProperties("Props", key);
        }
      }
    }
    if (injectOptions) {
      resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    }
    if (methods) {
      for (const key in methods) {
        const methodHandler = methods[key];
        if (isFunction(methodHandler)) {
          if (true) {
            Object.defineProperty(ctx, key, {
              value: methodHandler.bind(publicThis),
              configurable: true,
              enumerable: true,
              writable: true
            });
          } else {
            ctx[key] = methodHandler.bind(publicThis);
          }
          if (true) {
            checkDuplicateProperties("Methods", key);
          }
        } else if (true) {
          warn$1(
            `Method "${key}" has type "${typeof methodHandler}" in the component definition. Did you reference the function correctly?`
          );
        }
      }
    }
    if (dataOptions) {
      if (!isFunction(dataOptions)) {
        warn$1(
          `The data option must be a function. Plain object usage is no longer supported.`
        );
      }
      const data = dataOptions.call(publicThis, publicThis);
      if (isPromise(data)) {
        warn$1(
          `data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>.`
        );
      }
      if (!isObject(data)) {
        warn$1(`data() should return an object.`);
      } else {
        instance.data = reactive(data);
        if (true) {
          for (const key in data) {
            checkDuplicateProperties("Data", key);
            if (!isReservedPrefix(key[0])) {
              Object.defineProperty(ctx, key, {
                configurable: true,
                enumerable: true,
                get: () => data[key],
                set: NOOP
              });
            }
          }
        }
      }
    }
    shouldCacheAccess = true;
    if (computedOptions) {
      for (const key in computedOptions) {
        const opt = computedOptions[key];
        const get3 = isFunction(opt) ? opt.bind(publicThis, publicThis) : isFunction(opt.get) ? opt.get.bind(publicThis, publicThis) : NOOP;
        if (get3 === NOOP) {
          warn$1(`Computed property "${key}" has no getter.`);
        }
        const set = !isFunction(opt) && isFunction(opt.set) ? opt.set.bind(publicThis) : true ? () => {
          warn$1(
            `Write operation failed: computed property "${key}" is readonly.`
          );
        } : NOOP;
        const c = computed2({
          get: get3,
          set
        });
        Object.defineProperty(ctx, key, {
          enumerable: true,
          configurable: true,
          get: () => c.value,
          set: (v) => c.value = v
        });
        if (true) {
          checkDuplicateProperties("Computed", key);
        }
      }
    }
    if (watchOptions) {
      for (const key in watchOptions) {
        createWatcher(watchOptions[key], ctx, publicThis, key);
      }
    }
    if (provideOptions) {
      const provides = isFunction(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
      Reflect.ownKeys(provides).forEach((key) => {
        provide(key, provides[key]);
      });
    }
    if (created) {
      callHook(created, instance, "c");
    }
    function registerLifecycleHook(register2, hook) {
      if (isArray(hook)) {
        hook.forEach((_hook) => register2(_hook.bind(publicThis)));
      } else if (hook) {
        register2(hook.bind(publicThis));
      }
    }
    registerLifecycleHook(onBeforeMount, beforeMount);
    registerLifecycleHook(onMounted, mounted);
    registerLifecycleHook(onBeforeUpdate, beforeUpdate);
    registerLifecycleHook(onUpdated, updated);
    registerLifecycleHook(onActivated, activated);
    registerLifecycleHook(onDeactivated, deactivated);
    registerLifecycleHook(onErrorCaptured, errorCaptured);
    registerLifecycleHook(onRenderTracked, renderTracked);
    registerLifecycleHook(onRenderTriggered, renderTriggered);
    registerLifecycleHook(onBeforeUnmount, beforeUnmount);
    registerLifecycleHook(onUnmounted, unmounted);
    registerLifecycleHook(onServerPrefetch, serverPrefetch);
    if (isArray(expose)) {
      if (expose.length) {
        const exposed = instance.exposed || (instance.exposed = {});
        expose.forEach((key) => {
          Object.defineProperty(exposed, key, {
            get: () => publicThis[key],
            set: (val) => publicThis[key] = val,
            enumerable: true
          });
        });
      } else if (!instance.exposed) {
        instance.exposed = {};
      }
    }
    if (render67 && instance.render === NOOP) {
      instance.render = render67;
    }
    if (inheritAttrs != null) {
      instance.inheritAttrs = inheritAttrs;
    }
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) {
      markAsyncBoundary(instance);
    }
  }
  function resolveInjections(injectOptions, ctx, checkDuplicateProperties = NOOP) {
    if (isArray(injectOptions)) {
      injectOptions = normalizeInject(injectOptions);
    }
    for (const key in injectOptions) {
      const opt = injectOptions[key];
      let injected;
      if (isObject(opt)) {
        if ("default" in opt) {
          injected = inject(
            opt.from || key,
            opt.default,
            true
          );
        } else {
          injected = inject(opt.from || key);
        }
      } else {
        injected = inject(opt);
      }
      if (isRef2(injected)) {
        Object.defineProperty(ctx, key, {
          enumerable: true,
          configurable: true,
          get: () => injected.value,
          set: (v) => injected.value = v
        });
      } else {
        ctx[key] = injected;
      }
      if (true) {
        checkDuplicateProperties("Inject", key);
      }
    }
  }
  function callHook(hook, instance, type) {
    callWithAsyncErrorHandling(
      isArray(hook) ? hook.map((h2) => h2.bind(instance.proxy)) : hook.bind(instance.proxy),
      instance,
      type
    );
  }
  function createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? createPathGetter(publicThis, key) : () => publicThis[key];
    if (isString(raw)) {
      const handler = ctx[raw];
      if (isFunction(handler)) {
        {
          watch2(getter, handler);
        }
      } else if (true) {
        warn$1(`Invalid watch handler specified by key "${raw}"`, handler);
      }
    } else if (isFunction(raw)) {
      {
        watch2(getter, raw.bind(publicThis));
      }
    } else if (isObject(raw)) {
      if (isArray(raw)) {
        raw.forEach((r) => createWatcher(r, ctx, publicThis, key));
      } else {
        const handler = isFunction(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
        if (isFunction(handler)) {
          watch2(getter, handler, raw);
        } else if (true) {
          warn$1(`Invalid watch handler specified by key "${raw.handler}"`, handler);
        }
      }
    } else if (true) {
      warn$1(`Invalid watch option: "${key}"`, raw);
    }
  }
  function resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins, extends: extendsOptions } = base;
    const {
      mixins: globalMixins,
      optionsCache: cache,
      config: { optionMergeStrategies }
    } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) {
      resolved = cached;
    } else if (!globalMixins.length && !mixins && !extendsOptions) {
      {
        resolved = base;
      }
    } else {
      resolved = {};
      if (globalMixins.length) {
        globalMixins.forEach(
          (m) => mergeOptions(resolved, m, optionMergeStrategies, true)
        );
      }
      mergeOptions(resolved, base, optionMergeStrategies);
    }
    if (isObject(base)) {
      cache.set(base, resolved);
    }
    return resolved;
  }
  function mergeOptions(to, from, strats, asMixin = false) {
    const { mixins, extends: extendsOptions } = from;
    if (extendsOptions) {
      mergeOptions(to, extendsOptions, strats, true);
    }
    if (mixins) {
      mixins.forEach(
        (m) => mergeOptions(to, m, strats, true)
      );
    }
    for (const key in from) {
      if (asMixin && key === "expose") {
        warn$1(
          `"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.`
        );
      } else {
        const strat = internalOptionMergeStrats[key] || strats && strats[key];
        to[key] = strat ? strat(to[key], from[key]) : from[key];
      }
    }
    return to;
  }
  function mergeDataFn(to, from) {
    if (!from) {
      return to;
    }
    if (!to) {
      return from;
    }
    return function mergedDataFn() {
      return extend(
        isFunction(to) ? to.call(this, this) : to,
        isFunction(from) ? from.call(this, this) : from
      );
    };
  }
  function mergeInject(to, from) {
    return mergeObjectOptions(normalizeInject(to), normalizeInject(from));
  }
  function normalizeInject(raw) {
    if (isArray(raw)) {
      const res = {};
      for (let i2 = 0; i2 < raw.length; i2++) {
        res[raw[i2]] = raw[i2];
      }
      return res;
    }
    return raw;
  }
  function mergeAsArray(to, from) {
    return to ? [...new Set([].concat(to, from))] : from;
  }
  function mergeObjectOptions(to, from) {
    return to ? extend(/* @__PURE__ */ Object.create(null), to, from) : from;
  }
  function mergeEmitsOrPropsOptions(to, from) {
    if (to) {
      if (isArray(to) && isArray(from)) {
        return [.../* @__PURE__ */ new Set([...to, ...from])];
      }
      return extend(
        /* @__PURE__ */ Object.create(null),
        normalizePropsOrEmits(to),
        normalizePropsOrEmits(from != null ? from : {})
      );
    } else {
      return from;
    }
  }
  function mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = extend(/* @__PURE__ */ Object.create(null), to);
    for (const key in from) {
      merged[key] = mergeAsArray(to[key], from[key]);
    }
    return merged;
  }
  function createAppContext() {
    return {
      app: null,
      config: {
        isNativeTag: NO,
        performance: false,
        globalProperties: {},
        optionMergeStrategies: {},
        errorHandler: void 0,
        warnHandler: void 0,
        compilerOptions: {}
      },
      mixins: [],
      components: {},
      directives: {},
      provides: /* @__PURE__ */ Object.create(null),
      optionsCache: /* @__PURE__ */ new WeakMap(),
      propsCache: /* @__PURE__ */ new WeakMap(),
      emitsCache: /* @__PURE__ */ new WeakMap()
    };
  }
  function createAppAPI(render67, hydrate2) {
    return function createApp2(rootComponent, rootProps = null) {
      if (!isFunction(rootComponent)) {
        rootComponent = extend({}, rootComponent);
      }
      if (rootProps != null && !isObject(rootProps)) {
        warn$1(`root props passed to app.mount() must be an object.`);
        rootProps = null;
      }
      const context = createAppContext();
      const installedPlugins = /* @__PURE__ */ new WeakSet();
      const pluginCleanupFns = [];
      let isMounted = false;
      const app = context.app = {
        _uid: uid$1++,
        _component: rootComponent,
        _props: rootProps,
        _container: null,
        _context: context,
        _instance: null,
        version,
        get config() {
          return context.config;
        },
        set config(v) {
          if (true) {
            warn$1(
              `app.config cannot be replaced. Modify individual options instead.`
            );
          }
        },
        use(plugin, ...options) {
          if (installedPlugins.has(plugin)) {
            warn$1(`Plugin has already been applied to target app.`);
          } else if (plugin && isFunction(plugin.install)) {
            installedPlugins.add(plugin);
            plugin.install(app, ...options);
          } else if (isFunction(plugin)) {
            installedPlugins.add(plugin);
            plugin(app, ...options);
          } else if (true) {
            warn$1(
              `A plugin must either be a function or an object with an "install" function.`
            );
          }
          return app;
        },
        mixin(mixin) {
          if (true) {
            if (!context.mixins.includes(mixin)) {
              context.mixins.push(mixin);
            } else if (true) {
              warn$1(
                "Mixin has already been applied to target app" + (mixin.name ? `: ${mixin.name}` : "")
              );
            }
          } else if (true) {
            warn$1("Mixins are only available in builds supporting Options API");
          }
          return app;
        },
        component(name, component) {
          if (true) {
            validateComponentName(name, context.config);
          }
          if (!component) {
            return context.components[name];
          }
          if (context.components[name]) {
            warn$1(`Component "${name}" has already been registered in target app.`);
          }
          context.components[name] = component;
          return app;
        },
        directive(name, directive) {
          if (true) {
            validateDirectiveName(name);
          }
          if (!directive) {
            return context.directives[name];
          }
          if (context.directives[name]) {
            warn$1(`Directive "${name}" has already been registered in target app.`);
          }
          context.directives[name] = directive;
          return app;
        },
        mount(rootContainer, isHydrate, namespace) {
          if (!isMounted) {
            if (rootContainer.__vue_app__) {
              warn$1(
                `There is already an app instance mounted on the host container.
 If you want to mount another app on the same host container, you need to unmount the previous app by calling \`app.unmount()\` first.`
              );
            }
            const vnode = app._ceVNode || createVNode(rootComponent, rootProps);
            vnode.appContext = context;
            if (namespace === true) {
              namespace = "svg";
            } else if (namespace === false) {
              namespace = void 0;
            }
            if (true) {
              context.reload = () => {
                const cloned = cloneVNode(vnode);
                cloned.el = null;
                render67(cloned, rootContainer, namespace);
              };
            }
            if (isHydrate && hydrate2) {
              hydrate2(vnode, rootContainer);
            } else {
              render67(vnode, rootContainer, namespace);
            }
            isMounted = true;
            app._container = rootContainer;
            rootContainer.__vue_app__ = app;
            if (true) {
              app._instance = vnode.component;
              devtoolsInitApp(app, version);
            }
            return getComponentPublicInstance(vnode.component);
          } else if (true) {
            warn$1(
              `App has already been mounted.
If you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. \`const createMyApp = () => createApp(App)\``
            );
          }
        },
        onUnmount(cleanupFn) {
          if (typeof cleanupFn !== "function") {
            warn$1(
              `Expected function as first argument to app.onUnmount(), but got ${typeof cleanupFn}`
            );
          }
          pluginCleanupFns.push(cleanupFn);
        },
        unmount() {
          if (isMounted) {
            callWithAsyncErrorHandling(
              pluginCleanupFns,
              app._instance,
              16
            );
            render67(null, app._container);
            if (true) {
              app._instance = null;
              devtoolsUnmountApp(app);
            }
            delete app._container.__vue_app__;
          } else if (true) {
            warn$1(`Cannot unmount an app that is not mounted.`);
          }
        },
        provide(key, value) {
          if (key in context.provides) {
            if (hasOwn(context.provides, key)) {
              warn$1(
                `App already provides property with key "${String(key)}". It will be overwritten with the new value.`
              );
            } else {
              warn$1(
                `App already provides property with key "${String(key)}" inherited from its parent element. It will be overwritten with the new value.`
              );
            }
          }
          context.provides[key] = value;
          return app;
        },
        runWithContext(fn) {
          const lastApp = currentApp;
          currentApp = app;
          try {
            return fn();
          } finally {
            currentApp = lastApp;
          }
        }
      };
      return app;
    };
  }
  function useModel(props, name, options = EMPTY_OBJ) {
    const i2 = getCurrentInstance();
    if (!i2) {
      warn$1(`useModel() called without active instance.`);
      return ref();
    }
    const camelizedName = camelize(name);
    if (!i2.propsOptions[0][camelizedName]) {
      warn$1(`useModel() called with prop "${name}" which is not declared.`);
      return ref();
    }
    const hyphenatedName = hyphenate(name);
    const modifiers = getModelModifiers(props, camelizedName);
    const res = customRef((track2, trigger2) => {
      let localValue;
      let prevSetValue = EMPTY_OBJ;
      let prevEmittedValue;
      watchSyncEffect(() => {
        const propValue = props[camelizedName];
        if (hasChanged(localValue, propValue)) {
          localValue = propValue;
          trigger2();
        }
      });
      return {
        get() {
          track2();
          return options.get ? options.get(localValue) : localValue;
        },
        set(value) {
          const emittedValue = options.set ? options.set(value) : value;
          if (!hasChanged(emittedValue, localValue) && !(prevSetValue !== EMPTY_OBJ && hasChanged(value, prevSetValue))) {
            return;
          }
          const rawProps = i2.vnode.props;
          const hasVModel = !!(rawProps && // check if parent has passed v-model
          (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps));
          if (!hasVModel) {
            localValue = value;
            trigger2();
          }
          i2.emit(`update:${name}`, emittedValue);
          if (hasChanged(value, prevSetValue) && (hasChanged(value, emittedValue) && !hasChanged(emittedValue, prevEmittedValue) || // #13524: browsers differ in when they flush microtasks between
          // event listeners. If a v-model listener emits an intermediate value
          // and a following listener restores the model to its previous prop
          // value before parent updates are flushed, the parent render can be
          // deduped as having no prop change. Force a local update so DOM state
          // such as an input's value is synchronized back to the current model.
          hasVModel && prevSetValue !== EMPTY_OBJ && !hasChanged(emittedValue, localValue))) {
            trigger2();
          }
          prevSetValue = value;
          prevEmittedValue = emittedValue;
        }
      };
    });
    res[Symbol.iterator] = () => {
      let i22 = 0;
      return {
        next() {
          if (i22 < 2) {
            return { value: i22++ ? modifiers || EMPTY_OBJ : res, done: false };
          } else {
            return { done: true };
          }
        }
      };
    };
    return res;
  }
  function emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || EMPTY_OBJ;
    if (true) {
      const {
        emitsOptions,
        propsOptions: [propsOptions]
      } = instance;
      if (emitsOptions) {
        if (!(event in emitsOptions) && true) {
          if (!propsOptions || !(toHandlerKey(camelize(event)) in propsOptions)) {
            warn$1(
              `Component emitted event "${event}" but it is neither declared in the emits option nor as an "${toHandlerKey(camelize(event))}" prop.`
            );
          }
        } else {
          const validator = emitsOptions[event];
          if (isFunction(validator)) {
            const isValid = validator(...rawArgs);
            if (!isValid) {
              warn$1(
                `Invalid event arguments: event validation failed for event "${event}".`
              );
            }
          }
        }
      }
    }
    let args = rawArgs;
    const isModelListener2 = event.startsWith("update:");
    const modifiers = isModelListener2 && getModelModifiers(props, event.slice(7));
    if (modifiers) {
      if (modifiers.trim) {
        args = rawArgs.map((a) => isString(a) ? a.trim() : a);
      }
      if (modifiers.number) {
        args = rawArgs.map(looseToNumber);
      }
    }
    if (true) {
      devtoolsComponentEmit(instance, event, args);
    }
    if (true) {
      const lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && props[toHandlerKey(lowerCaseEvent)]) {
        warn$1(
          `Event "${lowerCaseEvent}" is emitted in component ${formatComponentName(
            instance,
            instance.type
          )} but the handler is registered for "${event}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${hyphenate(
            event
          )}" instead of "${event}".`
        );
      }
    }
    let handlerName;
    let handler = props[handlerName = toHandlerKey(event)] || // also try camelCase event handler (#2249)
    props[handlerName = toHandlerKey(camelize(event))];
    if (!handler && isModelListener2) {
      handler = props[handlerName = toHandlerKey(hyphenate(event))];
    }
    if (handler) {
      callWithAsyncErrorHandling(
        handler,
        instance,
        6,
        args
      );
    }
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
      if (!instance.emitted) {
        instance.emitted = {};
      } else if (instance.emitted[handlerName]) {
        return;
      }
      instance.emitted[handlerName] = true;
      callWithAsyncErrorHandling(
        onceHandler,
        instance,
        6,
        args
      );
    }
  }
  function normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = asMixin ? mixinEmitsCache : appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) {
      return cached;
    }
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (!isFunction(comp)) {
      const extendEmits = (raw2) => {
        const normalizedFromExtend = normalizeEmitsOptions(raw2, appContext, true);
        if (normalizedFromExtend) {
          hasExtends = true;
          extend(normalized, normalizedFromExtend);
        }
      };
      if (!asMixin && appContext.mixins.length) {
        appContext.mixins.forEach(extendEmits);
      }
      if (comp.extends) {
        extendEmits(comp.extends);
      }
      if (comp.mixins) {
        comp.mixins.forEach(extendEmits);
      }
    }
    if (!raw && !hasExtends) {
      if (isObject(comp)) {
        cache.set(comp, null);
      }
      return null;
    }
    if (isArray(raw)) {
      raw.forEach((key) => normalized[key] = null);
    } else {
      extend(normalized, raw);
    }
    if (isObject(comp)) {
      cache.set(comp, normalized);
    }
    return normalized;
  }
  function isEmitListener(options, key) {
    if (!options || !isOn(key)) {
      return false;
    }
    key = key.slice(2);
    key = key === "Once" ? key : key.replace(/Once$/, "");
    return hasOwn(options, key[0].toLowerCase() + key.slice(1)) || hasOwn(options, hyphenate(key)) || hasOwn(options, key);
  }
  function markAttrsAccessed() {
    accessedAttrs = true;
  }
  function renderComponentRoot(instance) {
    const {
      type: Component,
      vnode,
      proxy,
      withProxy,
      propsOptions: [propsOptions],
      slots,
      attrs,
      emit: emit2,
      render: render67,
      renderCache,
      props,
      data,
      setupState,
      ctx,
      inheritAttrs
    } = instance;
    const prev = setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    if (true) {
      accessedAttrs = false;
    }
    try {
      if (vnode.shapeFlag & 4) {
        const proxyToUse = withProxy || proxy;
        const thisProxy = setupState.__isScriptSetup ? new Proxy(proxyToUse, {
          get(target, key, receiver) {
            warn$1(
              `Property '${String(
                key
              )}' was accessed via 'this'. Avoid using 'this' in templates.`
            );
            return Reflect.get(target, key, receiver);
          }
        }) : proxyToUse;
        result = normalizeVNode(
          render67.call(
            thisProxy,
            proxyToUse,
            renderCache,
            true ? shallowReadonly(props) : props,
            setupState,
            data,
            ctx
          )
        );
        fallthroughAttrs = attrs;
      } else {
        const render210 = Component;
        if (attrs === props) {
          markAttrsAccessed();
        }
        result = normalizeVNode(
          render210.length > 1 ? render210(
            true ? shallowReadonly(props) : props,
            true ? {
              get attrs() {
                markAttrsAccessed();
                return shallowReadonly(attrs);
              },
              slots,
              emit: emit2
            } : { attrs, slots, emit: emit2 }
          ) : render210(
            true ? shallowReadonly(props) : props,
            null
          )
        );
        fallthroughAttrs = Component.props ? attrs : getFunctionalFallthrough(attrs);
      }
    } catch (err) {
      blockStack.length = 0;
      handleError(err, instance, 1);
      result = createVNode(Comment);
    }
    let root = result;
    let setRoot = void 0;
    if (result.patchFlag > 0 && result.patchFlag & 2048) {
      [root, setRoot] = getChildRoot(result);
    }
    if (fallthroughAttrs && inheritAttrs !== false) {
      const keys = Object.keys(fallthroughAttrs);
      const { shapeFlag } = root;
      if (keys.length) {
        if (shapeFlag & (1 | 6)) {
          if (propsOptions && keys.some(isModelListener)) {
            fallthroughAttrs = filterModelListeners(
              fallthroughAttrs,
              propsOptions
            );
          }
          root = cloneVNode(root, fallthroughAttrs, false, true);
        } else if (!accessedAttrs && root.type !== Comment) {
          const allAttrs = Object.keys(attrs);
          const eventAttrs = [];
          const extraAttrs = [];
          for (let i2 = 0, l = allAttrs.length; i2 < l; i2++) {
            const key = allAttrs[i2];
            if (isOn(key)) {
              if (!isModelListener(key)) {
                eventAttrs.push(key[2].toLowerCase() + key.slice(3));
              }
            } else {
              extraAttrs.push(key);
            }
          }
          if (extraAttrs.length) {
            warn$1(
              `Extraneous non-props attributes (${extraAttrs.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text or teleport root nodes.`
            );
          }
          if (eventAttrs.length) {
            warn$1(
              `Extraneous non-emits event listeners (${eventAttrs.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`
            );
          }
        }
      }
    }
    if (vnode.dirs) {
      if (!isElementRoot(root)) {
        warn$1(
          `Runtime directive used on component with non-element root node. The directives will not function as intended.`
        );
      }
      root = cloneVNode(root, null, false, true);
      root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) {
      const child = isTeleport(root.type) ? getInnerChild$1(root) || root : root;
      if (!isElementRoot(child)) {
        warn$1(
          `Component inside <Transition> renders non-element root node that cannot be animated.`
        );
      }
      setTransitionHooks(child, vnode.transition);
    }
    if (setRoot) {
      setRoot(root);
    } else {
      result = root;
    }
    setCurrentRenderingInstance(prev);
    return result;
  }
  function filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for (let i2 = 0; i2 < children.length; i2++) {
      const child = children[i2];
      if (isVNode(child)) {
        if (child.type !== Comment || child.children === "v-if") {
          if (singleRoot) {
            return;
          } else {
            singleRoot = child;
            if (recurse && singleRoot.patchFlag > 0 && singleRoot.patchFlag & 2048) {
              return filterSingleRoot(singleRoot.children);
            }
          }
        }
      } else {
        return;
      }
    }
    return singleRoot;
  }
  function shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if ((prevChildren || nextChildren) && isHmrUpdating) {
      return true;
    }
    if (nextVNode.dirs || nextVNode.transition) {
      return true;
    }
    if (optimized && patchFlag >= 0) {
      if (patchFlag & 1024) {
        return true;
      }
      if (patchFlag & 16) {
        if (!prevProps) {
          return !!nextProps;
        }
        return hasPropsChanged(prevProps, nextProps, emits);
      } else if (patchFlag & 8) {
        const dynamicProps = nextVNode.dynamicProps;
        for (let i2 = 0; i2 < dynamicProps.length; i2++) {
          const key = dynamicProps[i2];
          if (hasPropValueChanged(nextProps, prevProps, key) && !isEmitListener(emits, key)) {
            return true;
          }
        }
      }
    } else {
      if (prevChildren || nextChildren) {
        if (!nextChildren || !nextChildren.$stable) {
          return true;
        }
      }
      if (prevProps === nextProps) {
        return false;
      }
      if (!prevProps) {
        return !!nextProps;
      }
      if (!nextProps) {
        return true;
      }
      return hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
  }
  function hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) {
      return true;
    }
    for (let i2 = 0; i2 < nextKeys.length; i2++) {
      const key = nextKeys[i2];
      if (hasPropValueChanged(nextProps, prevProps, key) && !isEmitListener(emitsOptions, key)) {
        return true;
      }
    }
    return false;
  }
  function hasPropValueChanged(nextProps, prevProps, key) {
    const nextProp = nextProps[key];
    const prevProp = prevProps[key];
    if (key === "style" && isObject(nextProp) && isObject(prevProp)) {
      return !looseEqual(nextProp, prevProp);
    }
    return nextProp !== prevProp;
  }
  function updateHOCHostEl({ vnode, parent, suspense }, el) {
    while (parent) {
      const root = parent.subTree;
      if (root.suspense && root.suspense.activeBranch === vnode) {
        root.suspense.vnode.el = root.el = el;
        vnode = root;
      }
      if (root === vnode) {
        (vnode = parent.vnode).el = el;
        parent = parent.parent;
      } else {
        break;
      }
    }
    if (suspense && suspense.activeBranch === vnode) {
      suspense.vnode.el = el;
    }
  }
  function initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    setFullProps(instance, rawProps, props, attrs);
    for (const key in instance.propsOptions[0]) {
      if (!(key in props)) {
        props[key] = void 0;
      }
    }
    if (true) {
      validateProps(rawProps || {}, props, instance);
    }
    if (isStateful) {
      instance.props = isSSR ? props : shallowReactive(props);
    } else {
      if (!instance.type.props) {
        instance.props = attrs;
      } else {
        instance.props = props;
      }
    }
    instance.attrs = attrs;
  }
  function isInHmrContext(instance) {
    while (instance) {
      if (instance.type.__hmrId) return true;
      instance = instance.parent;
    }
  }
  function updateProps(instance, rawProps, rawPrevProps, optimized) {
    const {
      props,
      attrs,
      vnode: { patchFlag }
    } = instance;
    const rawCurrentProps = toRaw(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (
      // always force full diff in dev
      // - #1942 if hmr is enabled with sfc component
      // - vite#872 non-sfc component used by sfc component
      !isInHmrContext(instance) && (optimized || patchFlag > 0) && !(patchFlag & 16)
    ) {
      if (patchFlag & 8) {
        const propsToUpdate = instance.vnode.dynamicProps;
        for (let i2 = 0; i2 < propsToUpdate.length; i2++) {
          let key = propsToUpdate[i2];
          if (isEmitListener(instance.emitsOptions, key)) {
            continue;
          }
          const value = rawProps[key];
          if (options) {
            if (hasOwn(attrs, key)) {
              if (value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
              }
            } else {
              const camelizedKey = camelize(key);
              props[camelizedKey] = resolvePropValue(
                options,
                rawCurrentProps,
                camelizedKey,
                value,
                instance,
                false
              );
            }
          } else {
            if (value !== attrs[key]) {
              attrs[key] = value;
              hasAttrsChanged = true;
            }
          }
        }
      }
    } else {
      if (setFullProps(instance, rawProps, props, attrs)) {
        hasAttrsChanged = true;
      }
      let kebabKey;
      for (const key in rawCurrentProps) {
        if (!rawProps || // for camelCase
        !hasOwn(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = hyphenate(key)) === key || !hasOwn(rawProps, kebabKey))) {
          if (options) {
            if (rawPrevProps && // for camelCase
            (rawPrevProps[key] !== void 0 || // for kebab-case
            rawPrevProps[kebabKey] !== void 0)) {
              props[key] = resolvePropValue(
                options,
                rawCurrentProps,
                key,
                void 0,
                instance,
                true
              );
            }
          } else {
            delete props[key];
          }
        }
      }
      if (attrs !== rawCurrentProps) {
        for (const key in attrs) {
          if (!rawProps || !hasOwn(rawProps, key) && true) {
            delete attrs[key];
            hasAttrsChanged = true;
          }
        }
      }
    }
    if (hasAttrsChanged) {
      trigger(instance.attrs, "set", "");
    }
    if (true) {
      validateProps(rawProps || {}, props, instance);
    }
  }
  function setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) {
      for (let key in rawProps) {
        if (isReservedProp(key)) {
          continue;
        }
        const value = rawProps[key];
        let camelKey;
        if (options && hasOwn(options, camelKey = camelize(key))) {
          if (!needCastKeys || !needCastKeys.includes(camelKey)) {
            props[camelKey] = value;
          } else {
            (rawCastValues || (rawCastValues = {}))[camelKey] = value;
          }
        } else if (!isEmitListener(instance.emitsOptions, key)) {
          if (!(key in attrs) || value !== attrs[key]) {
            attrs[key] = value;
            hasAttrsChanged = true;
          }
        }
      }
    }
    if (needCastKeys) {
      const rawCurrentProps = toRaw(props);
      const castValues = rawCastValues || EMPTY_OBJ;
      for (let i2 = 0; i2 < needCastKeys.length; i2++) {
        const key = needCastKeys[i2];
        props[key] = resolvePropValue(
          options,
          rawCurrentProps,
          key,
          castValues[key],
          instance,
          !hasOwn(castValues, key)
        );
      }
    }
    return hasAttrsChanged;
  }
  function resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
      const hasDefault = hasOwn(opt, "default");
      if (hasDefault && value === void 0) {
        const defaultValue = opt.default;
        if (opt.type !== Function && !opt.skipFactory && isFunction(defaultValue)) {
          const { propsDefaults } = instance;
          if (key in propsDefaults) {
            value = propsDefaults[key];
          } else {
            const reset2 = setCurrentInstance(instance);
            value = propsDefaults[key] = defaultValue.call(
              null,
              props
            );
            reset2();
          }
        } else {
          value = defaultValue;
        }
        if (instance.ce) {
          instance.ce._setProp(key, value);
        }
      }
      if (opt[
        0
        /* shouldCast */
      ]) {
        if (isAbsent && !hasDefault) {
          value = false;
        } else if (opt[
          1
          /* shouldCastTrue */
        ] && (value === "" || value === hyphenate(key))) {
          value = true;
        }
      }
    }
    return value;
  }
  function normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = asMixin ? mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) {
      return cached;
    }
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (!isFunction(comp)) {
      const extendProps = (raw2) => {
        hasExtends = true;
        const [props, keys] = normalizePropsOptions(raw2, appContext, true);
        extend(normalized, props);
        if (keys) needCastKeys.push(...keys);
      };
      if (!asMixin && appContext.mixins.length) {
        appContext.mixins.forEach(extendProps);
      }
      if (comp.extends) {
        extendProps(comp.extends);
      }
      if (comp.mixins) {
        comp.mixins.forEach(extendProps);
      }
    }
    if (!raw && !hasExtends) {
      if (isObject(comp)) {
        cache.set(comp, EMPTY_ARR);
      }
      return EMPTY_ARR;
    }
    if (isArray(raw)) {
      for (let i2 = 0; i2 < raw.length; i2++) {
        if (!isString(raw[i2])) {
          warn$1(`props must be strings when using array syntax.`, raw[i2]);
        }
        const normalizedKey = camelize(raw[i2]);
        if (validatePropName(normalizedKey)) {
          normalized[normalizedKey] = EMPTY_OBJ;
        }
      }
    } else if (raw) {
      if (!isObject(raw)) {
        warn$1(`invalid props options`, raw);
      }
      for (const key in raw) {
        const normalizedKey = camelize(key);
        if (validatePropName(normalizedKey)) {
          const opt = raw[key];
          const prop = normalized[normalizedKey] = isArray(opt) || isFunction(opt) ? { type: opt } : extend({}, opt);
          const propType = prop.type;
          let shouldCast = false;
          let shouldCastTrue = true;
          if (isArray(propType)) {
            for (let index = 0; index < propType.length; ++index) {
              const type = propType[index];
              const typeName = isFunction(type) && type.name;
              if (typeName === "Boolean") {
                shouldCast = true;
                break;
              } else if (typeName === "String") {
                shouldCastTrue = false;
              }
            }
          } else {
            shouldCast = isFunction(propType) && propType.name === "Boolean";
          }
          prop[
            0
            /* shouldCast */
          ] = shouldCast;
          prop[
            1
            /* shouldCastTrue */
          ] = shouldCastTrue;
          if (shouldCast || hasOwn(prop, "default")) {
            needCastKeys.push(normalizedKey);
          }
        }
      }
    }
    const res = [normalized, needCastKeys];
    if (isObject(comp)) {
      cache.set(comp, res);
    }
    return res;
  }
  function validatePropName(key) {
    if (key[0] !== "$" && !isReservedProp(key)) {
      return true;
    } else if (true) {
      warn$1(`Invalid prop name: "${key}" is a reserved property.`);
    }
    return false;
  }
  function getType(ctor) {
    if (ctor === null) {
      return "null";
    }
    if (typeof ctor === "function") {
      return ctor.name || "";
    } else if (typeof ctor === "object") {
      const name = ctor.constructor && ctor.constructor.name;
      return name || "";
    }
    return "";
  }
  function validateProps(rawProps, props, instance) {
    const resolvedValues = toRaw(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key) => camelize(key));
    for (const key in options) {
      let opt = options[key];
      if (opt == null) continue;
      validateProp(
        key,
        resolvedValues[key],
        opt,
        true ? shallowReadonly(resolvedValues) : resolvedValues,
        !camelizePropsKey.includes(key)
      );
    }
  }
  function validateProp(name, value, prop, props, isAbsent) {
    const { type, required: required2, validator, skipCheck } = prop;
    if (required2 && isAbsent) {
      warn$1('Missing required prop: "' + name + '"');
      return;
    }
    if (value == null && !required2) {
      return;
    }
    if (type != null && type !== true && !skipCheck) {
      let isValid = false;
      const types = isArray(type) ? type : [type];
      const expectedTypes = [];
      for (let i2 = 0; i2 < types.length && !isValid; i2++) {
        const { valid, expectedType } = assertType(value, types[i2]);
        expectedTypes.push(expectedType || "");
        isValid = valid;
      }
      if (!isValid) {
        warn$1(getInvalidTypeMessage(name, value, expectedTypes));
        return;
      }
    }
    if (validator && !validator(value, props)) {
      warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
    }
  }
  function assertType(value, type) {
    let valid;
    const expectedType = getType(type);
    if (expectedType === "null") {
      valid = value === null;
    } else if (isSimpleType(expectedType)) {
      const t = typeof value;
      valid = t === expectedType.toLowerCase();
      if (!valid && t === "object") {
        valid = value instanceof type;
      }
    } else if (expectedType === "Object") {
      valid = isObject(value);
    } else if (expectedType === "Array") {
      valid = isArray(value);
    } else {
      valid = value instanceof type;
    }
    return {
      valid,
      expectedType
    };
  }
  function getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) {
      return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    }
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map(capitalize).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = toRawType(value);
    const expectedValue = styleValue(value, expectedType);
    const receivedValue = styleValue(value, receivedType);
    if (expectedTypes.length === 1 && isExplicable(expectedType) && isCoercible(expectedType, receivedType)) {
      message += ` with value ${expectedValue}`;
    }
    message += `, got ${receivedType} `;
    if (isExplicable(receivedType)) {
      message += `with value ${receivedValue}.`;
    }
    return message;
  }
  function styleValue(value, type) {
    if (isSymbol(value)) {
      return value.toString();
    } else if (type === "String") {
      return `"${value}"`;
    } else if (type === "Number") {
      return `${Number(value)}`;
    } else {
      return `${value}`;
    }
  }
  function isExplicable(type) {
    const explicitTypes = ["string", "number", "boolean"];
    return explicitTypes.some((elem) => type.toLowerCase() === elem);
  }
  function isCoercible(...args) {
    return args.every((elem) => {
      const value = elem.toLowerCase();
      return value !== "boolean" && value !== "symbol";
    });
  }
  function startMeasure(instance, type) {
    if (instance.appContext.config.performance && isSupported()) {
      perf.mark(`vue-${type}-${instance.uid}`);
    }
    if (true) {
      devtoolsPerfStart(instance, type, isSupported() ? perf.now() : Date.now());
    }
  }
  function endMeasure(instance, type) {
    if (instance.appContext.config.performance && isSupported()) {
      const startTag = `vue-${type}-${instance.uid}`;
      const endTag = startTag + `:end`;
      const measureName = `<${formatComponentName(instance, instance.type)}> ${type}`;
      perf.mark(endTag);
      perf.measure(measureName, startTag, endTag);
      perf.clearMeasures(measureName);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
    }
    if (true) {
      devtoolsPerfEnd(instance, type, isSupported() ? perf.now() : Date.now());
    }
  }
  function isSupported() {
    if (supported !== void 0) {
      return supported;
    }
    if (typeof window !== "undefined" && window.performance) {
      supported = true;
      perf = window.performance;
    } else {
      supported = false;
    }
    return supported;
  }
  function initFeatureFlags() {
    const needWarn = [];
    if (false) {
      needWarn.push(`__VUE_OPTIONS_API__`);
      getGlobalThis().__VUE_OPTIONS_API__ = true;
    }
    if (false) {
      needWarn.push(`__VUE_PROD_DEVTOOLS__`);
      getGlobalThis().__VUE_PROD_DEVTOOLS__ = false;
    }
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") {
      needWarn.push(`__VUE_PROD_HYDRATION_MISMATCH_DETAILS__`);
      getGlobalThis().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
    }
    if (needWarn.length) {
      const multi = needWarn.length > 1;
      console.warn(
        `Feature flag${multi ? `s` : ``} ${needWarn.join(", ")} ${multi ? `are` : `is`} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`
      );
    }
  }
  function createRenderer(options) {
    return baseCreateRenderer(options);
  }
  function createHydrationRenderer(options) {
    return baseCreateRenderer(options, createHydrationFunctions);
  }
  function baseCreateRenderer(options, createHydrationFns) {
    {
      initFeatureFlags();
    }
    const target = getGlobalThis();
    target.__VUE__ = true;
    if (true) {
      setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    }
    const {
      insert: hostInsert,
      remove: hostRemove,
      patchProp: hostPatchProp,
      createElement: hostCreateElement,
      createText: hostCreateText,
      createComment: hostCreateComment,
      setText: hostSetText,
      setElementText: hostSetElementText,
      parentNode: hostParentNode,
      nextSibling: hostNextSibling,
      setScopeId: hostSetScopeId = NOOP,
      insertStaticContent: hostInsertStaticContent
    } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace = void 0, slotScopeIds = null, optimized = isHmrUpdating ? false : !!n2.dynamicChildren) => {
      if (n1 === n2) {
        return;
      }
      if (n1 && !isSameVNodeType(n1, n2)) {
        anchor = getNextHostNode(n1);
        unmount(n1, parentComponent, parentSuspense, true);
        n1 = null;
      }
      if (n2.patchFlag === -2) {
        optimized = false;
        n2.dynamicChildren = null;
      }
      const { type, ref: ref2, shapeFlag } = n2;
      switch (type) {
        case Text:
          processText(n1, n2, container, anchor);
          break;
        case Comment:
          processCommentNode(n1, n2, container, anchor);
          break;
        case Static:
          if (n1 == null) {
            mountStaticNode(n2, container, anchor, namespace);
          } else if (true) {
            patchStaticNode(n1, n2, container, namespace);
          }
          break;
        case Fragment:
          processFragment(
            n1,
            n2,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
          break;
        default:
          if (shapeFlag & 1) {
            processElement(
              n1,
              n2,
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized
            );
          } else if (shapeFlag & 6) {
            processComponent(
              n1,
              n2,
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized
            );
          } else if (shapeFlag & 64) {
            type.process(
              n1,
              n2,
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized,
              internals
            );
          } else if (shapeFlag & 128) {
            type.process(
              n1,
              n2,
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized,
              internals
            );
          } else if (true) {
            warn$1("Invalid VNode type:", type, `(${typeof type})`);
          }
      }
      if (ref2 != null && parentComponent) {
        setRef(ref2, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
      } else if (ref2 == null && n1 && n1.ref != null) {
        setRef(n1.ref, null, parentSuspense, n1, true);
      }
    };
    const processText = (n1, n2, container, anchor) => {
      if (n1 == null) {
        hostInsert(
          n2.el = hostCreateText(n2.children),
          container,
          anchor
        );
      } else {
        const el = n2.el = n1.el;
        if (n2.children !== n1.children) {
          hostSetText(el, n2.children);
        }
      }
    };
    const processCommentNode = (n1, n2, container, anchor) => {
      if (n1 == null) {
        hostInsert(
          n2.el = hostCreateComment(n2.children || ""),
          container,
          anchor
        );
      } else {
        n2.el = n1.el;
      }
    };
    const mountStaticNode = (n2, container, anchor, namespace) => {
      [n2.el, n2.anchor] = hostInsertStaticContent(
        n2.children,
        container,
        anchor,
        namespace,
        n2.el,
        n2.anchor
      );
    };
    const patchStaticNode = (n1, n2, container, namespace) => {
      if (n2.children !== n1.children) {
        const anchor = hostNextSibling(n1.anchor);
        removeStaticNode(n1);
        [n2.el, n2.anchor] = hostInsertStaticContent(
          n2.children,
          container,
          anchor,
          namespace
        );
      } else {
        n2.el = n1.el;
        n2.anchor = n1.anchor;
      }
    };
    const moveStaticNode = ({ el, anchor }, container, nextSibling) => {
      let next;
      while (el && el !== anchor) {
        next = hostNextSibling(el);
        hostInsert(el, container, nextSibling);
        el = next;
      }
      hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el, anchor }) => {
      let next;
      while (el && el !== anchor) {
        next = hostNextSibling(el);
        hostRemove(el);
        el = next;
      }
      hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
      if (n2.type === "svg") {
        namespace = "svg";
      } else if (n2.type === "math") {
        namespace = "mathml";
      }
      if (n1 == null) {
        mountElement(
          n2,
          container,
          anchor,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
      } else {
        const customElement = n1.el && n1.el._isVueCE ? n1.el : null;
        try {
          if (customElement) {
            customElement._beginPatch();
          }
          patchElement(
            n1,
            n2,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
        } finally {
          if (customElement) {
            customElement._endPatch();
          }
        }
      }
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
      let el;
      let vnodeHook;
      const { props, shapeFlag, transition, dirs } = vnode;
      el = vnode.el = hostCreateElement(
        vnode.type,
        namespace,
        props && props.is,
        props
      );
      if (shapeFlag & 8) {
        hostSetElementText(el, vnode.children);
      } else if (shapeFlag & 16) {
        mountChildren(
          vnode.children,
          el,
          null,
          parentComponent,
          parentSuspense,
          resolveChildrenNamespace(vnode, namespace),
          slotScopeIds,
          optimized
        );
      }
      if (dirs) {
        invokeDirectiveHook(vnode, null, parentComponent, "created");
      }
      setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
      if (props) {
        for (const key in props) {
          if (key !== "value" && !isReservedProp(key)) {
            hostPatchProp(el, key, null, props[key], namespace, parentComponent);
          }
        }
        if ("value" in props) {
          hostPatchProp(el, "value", null, props.value, namespace);
        }
        if (vnodeHook = props.onVnodeBeforeMount) {
          invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
      }
      if (true) {
        def(el, "__vnode", vnode, true);
        def(el, "__vueParentComponent", parentComponent, true);
      }
      if (dirs) {
        invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
      }
      const needCallTransitionHooks = needTransition(parentSuspense, transition);
      if (needCallTransitionHooks) {
        transition.beforeEnter(el);
      }
      hostInsert(el, container, anchor);
      if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) {
        const isHmr = isHmrUpdating;
        queuePostRenderEffect(() => {
          let prev;
          if (true) prev = setHmrUpdating(isHmr);
          try {
            vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && invokeDirectiveHook(vnode, null, parentComponent, "mounted");
          } finally {
            if (true) setHmrUpdating(prev);
          }
        }, parentSuspense);
      }
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent) => {
      if (scopeId) {
        hostSetScopeId(el, scopeId);
      }
      if (slotScopeIds) {
        for (let i2 = 0; i2 < slotScopeIds.length; i2++) {
          hostSetScopeId(el, slotScopeIds[i2]);
        }
      }
      if (parentComponent) {
        let subTree = parentComponent.subTree;
        if (subTree.patchFlag > 0 && subTree.patchFlag & 2048) {
          subTree = filterSingleRoot(subTree.children) || subTree;
        }
        if (vnode === subTree || isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
          const parentVNode = parentComponent.vnode;
          setScopeId(
            el,
            parentVNode,
            parentVNode.scopeId,
            parentVNode.slotScopeIds,
            parentComponent.parent
          );
        }
      }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0) => {
      for (let i2 = start; i2 < children.length; i2++) {
        const child = children[i2] = optimized ? cloneIfMounted(children[i2]) : normalizeVNode(children[i2]);
        patch(
          null,
          child,
          container,
          anchor,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
      }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
      const el = n2.el = n1.el;
      if (true) {
        el.__vnode = n2;
      }
      let { patchFlag, dynamicChildren, dirs } = n2;
      patchFlag |= n1.patchFlag & 16;
      const oldProps = n1.props || EMPTY_OBJ;
      const newProps = n2.props || EMPTY_OBJ;
      let vnodeHook;
      parentComponent && toggleRecurse(parentComponent, false);
      if (vnodeHook = newProps.onVnodeBeforeUpdate) {
        invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
      }
      if (dirs) {
        invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
      }
      parentComponent && toggleRecurse(parentComponent, true);
      if (
        // HMR updated, force full diff
        isHmrUpdating || // #6385 the old vnode may be a user-wrapped non-isomorphic block
        // Force full diff when block metadata is unstable.
        dynamicChildren && (!n1.dynamicChildren || n1.dynamicChildren.length !== dynamicChildren.length)
      ) {
        patchFlag = 0;
        optimized = false;
        dynamicChildren = null;
      }
      if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) {
        hostSetElementText(el, "");
      }
      if (dynamicChildren) {
        patchBlockChildren(
          n1.dynamicChildren,
          dynamicChildren,
          el,
          parentComponent,
          parentSuspense,
          resolveChildrenNamespace(n2, namespace),
          slotScopeIds
        );
        if (true) {
          traverseStaticChildren(n1, n2);
        }
      } else if (!optimized) {
        patchChildren(
          n1,
          n2,
          el,
          null,
          parentComponent,
          parentSuspense,
          resolveChildrenNamespace(n2, namespace),
          slotScopeIds,
          false
        );
      }
      if (patchFlag > 0) {
        if (patchFlag & 16) {
          patchProps(el, oldProps, newProps, parentComponent, namespace);
        } else {
          if (patchFlag & 2) {
            if (oldProps.class !== newProps.class) {
              hostPatchProp(el, "class", null, newProps.class, namespace);
            }
          }
          if (patchFlag & 4) {
            hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
          }
          if (patchFlag & 8) {
            const propsToUpdate = n2.dynamicProps;
            for (let i2 = 0; i2 < propsToUpdate.length; i2++) {
              const key = propsToUpdate[i2];
              const prev = oldProps[key];
              const next = newProps[key];
              if (next !== prev || key === "value") {
                hostPatchProp(el, key, prev, next, namespace, parentComponent);
              }
            }
          }
        }
        if (patchFlag & 1) {
          if (n1.children !== n2.children) {
            hostSetElementText(el, n2.children);
          }
        }
      } else if (!optimized && dynamicChildren == null) {
        patchProps(el, oldProps, newProps, parentComponent, namespace);
      }
      if ((vnodeHook = newProps.onVnodeUpdated) || dirs) {
        queuePostRenderEffect(() => {
          vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
          dirs && invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
      }
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds) => {
      for (let i2 = 0; i2 < newChildren.length; i2++) {
        const oldVNode = oldChildren[i2];
        const newVNode = newChildren[i2];
        const container = (
          // oldVNode may be an errored async setup() component inside Suspense
          // which will not have a mounted element
          oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
          // of the Fragment itself so it can move its children.
          (oldVNode.type === Fragment || // - In the case of different nodes, there is going to be a replacement
          // which also requires the correct parent container
          !isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
          oldVNode.shapeFlag & (6 | 64 | 128)) ? hostParentNode(oldVNode.el) : (
            // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer
          )
        );
        patch(
          oldVNode,
          newVNode,
          container,
          null,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          true
        );
      }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace) => {
      if (oldProps !== newProps) {
        if (oldProps !== EMPTY_OBJ) {
          for (const key in oldProps) {
            if (!isReservedProp(key) && !(key in newProps)) {
              hostPatchProp(
                el,
                key,
                oldProps[key],
                null,
                namespace,
                parentComponent
              );
            }
          }
        }
        for (const key in newProps) {
          if (isReservedProp(key)) continue;
          const next = newProps[key];
          const prev = oldProps[key];
          if (next !== prev && key !== "value") {
            hostPatchProp(el, key, prev, next, namespace, parentComponent);
          }
        }
        if ("value" in newProps) {
          hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
      }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
      const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
      const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
      let { patchFlag, dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
      if (
        // #5523 dev root fragment may inherit directives
        isHmrUpdating || patchFlag & 2048
      ) {
        patchFlag = 0;
        optimized = false;
        dynamicChildren = null;
      }
      if (fragmentSlotScopeIds) {
        slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
      }
      if (n1 == null) {
        hostInsert(fragmentStartAnchor, container, anchor);
        hostInsert(fragmentEndAnchor, container, anchor);
        mountChildren(
          // #10007
          // such fragment like `<></>` will be compiled into
          // a fragment which doesn't have a children.
          // In this case fallback to an empty array
          n2.children || [],
          container,
          fragmentEndAnchor,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
      } else {
        if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren && n1.dynamicChildren.length === dynamicChildren.length) {
          patchBlockChildren(
            n1.dynamicChildren,
            dynamicChildren,
            container,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds
          );
          if (true) {
            traverseStaticChildren(n1, n2);
          } else if (
            // #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree
          ) {
            traverseStaticChildren(
              n1,
              n2,
              true
              /* shallow */
            );
          }
        } else {
          patchChildren(
            n1,
            n2,
            container,
            fragmentEndAnchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
        }
      }
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
      n2.slotScopeIds = slotScopeIds;
      if (n1 == null) {
        if (n2.shapeFlag & 512) {
          parentComponent.ctx.activate(
            n2,
            container,
            anchor,
            namespace,
            optimized
          );
        } else {
          mountComponent(
            n2,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            optimized
          );
        }
      } else {
        updateComponent(n1, n2, optimized);
      }
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized) => {
      const instance = initialVNode.component = createComponentInstance(
        initialVNode,
        parentComponent,
        parentSuspense
      );
      if (instance.type.__hmrId) {
        registerHMR(instance);
      }
      if (true) {
        pushWarningContext(initialVNode);
        startMeasure(instance, `mount`);
      }
      if (isKeepAlive(initialVNode)) {
        instance.ctx.renderer = internals;
      }
      {
        if (true) {
          startMeasure(instance, `init`);
        }
        setupComponent(instance, false, optimized);
        if (true) {
          endMeasure(instance, `init`);
        }
      }
      if (isHmrUpdating) initialVNode.el = null;
      if (instance.asyncDep) {
        parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
        if (!initialVNode.el) {
          const placeholder = instance.subTree = createVNode(Comment);
          processCommentNode(null, placeholder, container, anchor);
          initialVNode.placeholder = placeholder.el;
        }
      } else {
        setupRenderEffect(
          instance,
          initialVNode,
          container,
          anchor,
          parentSuspense,
          namespace,
          optimized
        );
      }
      if (true) {
        popWarningContext();
        endMeasure(instance, `mount`);
      }
    };
    const updateComponent = (n1, n2, optimized) => {
      const instance = n2.component = n1.component;
      if (shouldUpdateComponent(n1, n2, optimized)) {
        if (instance.asyncDep && !instance.asyncResolved) {
          if (true) {
            pushWarningContext(n2);
          }
          updateComponentPreRender(instance, n2, optimized);
          if (true) {
            popWarningContext();
          }
          return;
        } else {
          instance.next = n2;
          instance.update();
        }
      } else {
        n2.el = n1.el;
        instance.vnode = n2;
      }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized) => {
      const componentUpdateFn = () => {
        if (!instance.isMounted) {
          let vnodeHook;
          const { el, props } = initialVNode;
          const { bm, m, parent, root, type } = instance;
          const isAsyncWrapperVNode = isAsyncWrapper(initialVNode);
          toggleRecurse(instance, false);
          if (bm) {
            invokeArrayFns(bm);
          }
          if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) {
            invokeVNodeHook(vnodeHook, parent, initialVNode);
          }
          toggleRecurse(instance, true);
          if (el && hydrateNode) {
            const hydrateSubTree = () => {
              if (true) {
                startMeasure(instance, `render`);
              }
              instance.subTree = renderComponentRoot(instance);
              if (true) {
                endMeasure(instance, `render`);
              }
              if (true) {
                startMeasure(instance, `hydrate`);
              }
              hydrateNode(
                el,
                instance.subTree,
                instance,
                parentSuspense,
                null
              );
              if (true) {
                endMeasure(instance, `hydrate`);
              }
            };
            if (isAsyncWrapperVNode && type.__asyncHydrate) {
              type.__asyncHydrate(
                el,
                instance,
                hydrateSubTree
              );
            } else {
              hydrateSubTree();
            }
          } else {
            if (root.ce && root.ce._hasShadowRoot()) {
              root.ce._injectChildStyle(
                type,
                instance.parent ? instance.parent.type : void 0
              );
            }
            if (true) {
              startMeasure(instance, `render`);
            }
            const subTree = instance.subTree = renderComponentRoot(instance);
            if (true) {
              endMeasure(instance, `render`);
            }
            if (true) {
              startMeasure(instance, `patch`);
            }
            patch(
              null,
              subTree,
              container,
              anchor,
              instance,
              parentSuspense,
              namespace
            );
            if (true) {
              endMeasure(instance, `patch`);
            }
            initialVNode.el = subTree.el;
          }
          if (m) {
            queuePostRenderEffect(m, parentSuspense);
          }
          if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
            const scopedInitialVNode = initialVNode;
            queuePostRenderEffect(
              () => invokeVNodeHook(vnodeHook, parent, scopedInitialVNode),
              parentSuspense
            );
          }
          if (initialVNode.shapeFlag & 256 || parent && isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) {
            instance.a && queuePostRenderEffect(instance.a, parentSuspense);
          }
          instance.isMounted = true;
          if (true) {
            devtoolsComponentAdded(instance);
          }
          initialVNode = container = anchor = null;
        } else {
          let { next, bu, u: u2, parent, vnode } = instance;
          {
            const nonHydratedAsyncRoot = locateNonHydratedAsyncRoot(instance);
            if (nonHydratedAsyncRoot) {
              if (next) {
                next.el = vnode.el;
                updateComponentPreRender(instance, next, optimized);
              }
              nonHydratedAsyncRoot.asyncDep.then(() => {
                queuePostRenderEffect(() => {
                  if (!instance.isUnmounted) update3();
                }, parentSuspense);
              });
              return;
            }
          }
          let originNext = next;
          let vnodeHook;
          if (true) {
            pushWarningContext(next || instance.vnode);
          }
          toggleRecurse(instance, false);
          if (next) {
            next.el = vnode.el;
            updateComponentPreRender(instance, next, optimized);
          } else {
            next = vnode;
          }
          if (bu) {
            invokeArrayFns(bu);
          }
          if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) {
            invokeVNodeHook(vnodeHook, parent, next, vnode);
          }
          toggleRecurse(instance, true);
          if (true) {
            startMeasure(instance, `render`);
          }
          const nextTree = renderComponentRoot(instance);
          if (true) {
            endMeasure(instance, `render`);
          }
          const prevTree = instance.subTree;
          instance.subTree = nextTree;
          if (true) {
            startMeasure(instance, `patch`);
          }
          patch(
            prevTree,
            nextTree,
            // parent may have changed if it's in a teleport
            hostParentNode(prevTree.el),
            // anchor may have changed if it's in a fragment
            getNextHostNode(prevTree),
            instance,
            parentSuspense,
            namespace
          );
          if (true) {
            endMeasure(instance, `patch`);
          }
          next.el = nextTree.el;
          if (originNext === null) {
            updateHOCHostEl(instance, nextTree.el);
          }
          if (u2) {
            queuePostRenderEffect(u2, parentSuspense);
          }
          if (vnodeHook = next.props && next.props.onVnodeUpdated) {
            queuePostRenderEffect(
              () => invokeVNodeHook(vnodeHook, parent, next, vnode),
              parentSuspense
            );
          }
          if (true) {
            devtoolsComponentUpdated(instance);
          }
          if (true) {
            popWarningContext();
          }
        }
      };
      instance.scope.on();
      const effect2 = instance.effect = new ReactiveEffect(componentUpdateFn);
      instance.scope.off();
      const update3 = instance.update = effect2.run.bind(effect2);
      const job = instance.job = effect2.runIfDirty.bind(effect2);
      job.i = instance;
      job.id = instance.uid;
      effect2.scheduler = () => queueJob(job);
      toggleRecurse(instance, true);
      if (true) {
        effect2.onTrack = instance.rtc ? (e) => invokeArrayFns(instance.rtc, e) : void 0;
        effect2.onTrigger = instance.rtg ? (e) => invokeArrayFns(instance.rtg, e) : void 0;
      }
      update3();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized) => {
      nextVNode.component = instance;
      const prevProps = instance.vnode.props;
      instance.vnode = nextVNode;
      instance.next = null;
      updateProps(instance, nextVNode.props, prevProps, optimized);
      updateSlots(instance, nextVNode.children, optimized);
      pauseTracking();
      flushPreFlushCbs(instance);
      resetTracking();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false) => {
      const c1 = n1 && n1.children;
      const prevShapeFlag = n1 ? n1.shapeFlag : 0;
      const c2 = n2.children;
      const { patchFlag, shapeFlag } = n2;
      if (patchFlag > 0) {
        if (patchFlag & 128) {
          patchKeyedChildren(
            c1,
            c2,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
          return;
        } else if (patchFlag & 256) {
          patchUnkeyedChildren(
            c1,
            c2,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
          return;
        }
      }
      if (shapeFlag & 8) {
        if (prevShapeFlag & 16) {
          unmountChildren(c1, parentComponent, parentSuspense);
        }
        if (c2 !== c1) {
          hostSetElementText(container, c2);
        }
      } else {
        if (prevShapeFlag & 16) {
          if (shapeFlag & 16) {
            patchKeyedChildren(
              c1,
              c2,
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized
            );
          } else {
            unmountChildren(c1, parentComponent, parentSuspense, true);
          }
        } else {
          if (prevShapeFlag & 8) {
            hostSetElementText(container, "");
          }
          if (shapeFlag & 16) {
            mountChildren(
              c2,
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized
            );
          }
        }
      }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
      c1 = c1 || EMPTY_ARR;
      c2 = c2 || EMPTY_ARR;
      const oldLength = c1.length;
      const newLength = c2.length;
      const commonLength = Math.min(oldLength, newLength);
      let i2;
      for (i2 = 0; i2 < commonLength; i2++) {
        const nextChild = c2[i2] = optimized ? cloneIfMounted(c2[i2]) : normalizeVNode(c2[i2]);
        patch(
          c1[i2],
          nextChild,
          container,
          null,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
      }
      if (oldLength > newLength) {
        unmountChildren(
          c1,
          parentComponent,
          parentSuspense,
          true,
          false,
          commonLength
        );
      } else {
        mountChildren(
          c2,
          container,
          anchor,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized,
          commonLength
        );
      }
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
      let i2 = 0;
      const l2 = c2.length;
      let e1 = c1.length - 1;
      let e2 = l2 - 1;
      while (i2 <= e1 && i2 <= e2) {
        const n1 = c1[i2];
        const n2 = c2[i2] = optimized ? cloneIfMounted(c2[i2]) : normalizeVNode(c2[i2]);
        if (isSameVNodeType(n1, n2)) {
          patch(
            n1,
            n2,
            container,
            null,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
        } else {
          break;
        }
        i2++;
      }
      while (i2 <= e1 && i2 <= e2) {
        const n1 = c1[e1];
        const n2 = c2[e2] = optimized ? cloneIfMounted(c2[e2]) : normalizeVNode(c2[e2]);
        if (isSameVNodeType(n1, n2)) {
          patch(
            n1,
            n2,
            container,
            null,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
        } else {
          break;
        }
        e1--;
        e2--;
      }
      if (i2 > e1) {
        if (i2 <= e2) {
          const nextPos = e2 + 1;
          const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
          while (i2 <= e2) {
            patch(
              null,
              c2[i2] = optimized ? cloneIfMounted(c2[i2]) : normalizeVNode(c2[i2]),
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized
            );
            i2++;
          }
        }
      } else if (i2 > e2) {
        while (i2 <= e1) {
          unmount(c1[i2], parentComponent, parentSuspense, true);
          i2++;
        }
      } else {
        const s1 = i2;
        const s2 = i2;
        const keyToNewIndexMap = /* @__PURE__ */ new Map();
        for (i2 = s2; i2 <= e2; i2++) {
          const nextChild = c2[i2] = optimized ? cloneIfMounted(c2[i2]) : normalizeVNode(c2[i2]);
          if (nextChild.key != null) {
            if (keyToNewIndexMap.has(nextChild.key)) {
              warn$1(
                `Duplicate keys found during update:`,
                JSON.stringify(nextChild.key),
                `Make sure keys are unique.`
              );
            }
            keyToNewIndexMap.set(nextChild.key, i2);
          }
        }
        let j;
        let patched = 0;
        const toBePatched = e2 - s2 + 1;
        let moved = false;
        let maxNewIndexSoFar = 0;
        const newIndexToOldIndexMap = new Array(toBePatched);
        for (i2 = 0; i2 < toBePatched; i2++) newIndexToOldIndexMap[i2] = 0;
        for (i2 = s1; i2 <= e1; i2++) {
          const prevChild = c1[i2];
          if (patched >= toBePatched) {
            unmount(prevChild, parentComponent, parentSuspense, true);
            continue;
          }
          let newIndex;
          if (prevChild.key != null) {
            newIndex = keyToNewIndexMap.get(prevChild.key);
          } else {
            for (j = s2; j <= e2; j++) {
              if (newIndexToOldIndexMap[j - s2] === 0 && isSameVNodeType(prevChild, c2[j])) {
                newIndex = j;
                break;
              }
            }
          }
          if (newIndex === void 0) {
            unmount(prevChild, parentComponent, parentSuspense, true);
          } else {
            newIndexToOldIndexMap[newIndex - s2] = i2 + 1;
            if (newIndex >= maxNewIndexSoFar) {
              maxNewIndexSoFar = newIndex;
            } else {
              moved = true;
            }
            patch(
              prevChild,
              c2[newIndex],
              container,
              null,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized
            );
            patched++;
          }
        }
        const increasingNewIndexSequence = moved ? getSequence(newIndexToOldIndexMap) : EMPTY_ARR;
        j = increasingNewIndexSequence.length - 1;
        for (i2 = toBePatched - 1; i2 >= 0; i2--) {
          const nextIndex = s2 + i2;
          const nextChild = c2[nextIndex];
          const anchorVNode = c2[nextIndex + 1];
          const anchor = nextIndex + 1 < l2 ? (
            // #13559, #14173 fallback to el placeholder for unresolved async component
            anchorVNode.el || resolveAsyncComponentPlaceholder(anchorVNode)
          ) : parentAnchor;
          if (newIndexToOldIndexMap[i2] === 0) {
            patch(
              null,
              nextChild,
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized
            );
          } else if (moved) {
            if (j < 0 || i2 !== increasingNewIndexSequence[j]) {
              move(nextChild, container, anchor, 2);
            } else {
              j--;
            }
          }
        }
      }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null) => {
      const { el, type, transition, children, shapeFlag } = vnode;
      if (shapeFlag & 6) {
        move(vnode.component.subTree, container, anchor, moveType);
        return;
      }
      if (shapeFlag & 128) {
        vnode.suspense.move(container, anchor, moveType);
        return;
      }
      if (shapeFlag & 64) {
        type.move(vnode, container, anchor, internals);
        return;
      }
      if (type === Fragment) {
        hostInsert(el, container, anchor);
        for (let i2 = 0; i2 < children.length; i2++) {
          move(children[i2], container, anchor, moveType);
        }
        hostInsert(vnode.anchor, container, anchor);
        return;
      }
      if (type === Static) {
        moveStaticNode(vnode, container, anchor);
        return;
      }
      const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
      if (needTransition2) {
        if (moveType === 0) {
          if (transition.persisted && !el[leaveCbKey]) {
            hostInsert(el, container, anchor);
          } else {
            transition.beforeEnter(el);
            hostInsert(el, container, anchor);
            queuePostRenderEffect(() => transition.enter(el), parentSuspense);
          }
        } else {
          const { leave, delayLeave, afterLeave } = transition;
          const remove22 = () => {
            if (vnode.ctx.isUnmounted) {
              hostRemove(el);
            } else {
              hostInsert(el, container, anchor);
            }
          };
          const performLeave = () => {
            const wasLeaving = el._isLeaving || !!el[leaveCbKey];
            if (el._isLeaving) {
              el[leaveCbKey](
                true
                /* cancelled */
              );
            }
            if (transition.persisted && !wasLeaving) {
              remove22();
            } else {
              leave(el, () => {
                remove22();
                afterLeave && afterLeave();
              });
            }
          };
          if (delayLeave) {
            delayLeave(el, remove22, performLeave);
          } else {
            performLeave();
          }
        }
      } else {
        hostInsert(el, container, anchor);
      }
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false) => {
      const {
        type,
        props,
        ref: ref2,
        children,
        dynamicChildren,
        shapeFlag,
        patchFlag,
        dirs,
        cacheIndex,
        memo
      } = vnode;
      if (patchFlag === -2) {
        optimized = false;
      }
      if (ref2 != null) {
        pauseTracking();
        setRef(ref2, null, parentSuspense, vnode, true);
        resetTracking();
      }
      if (cacheIndex != null) {
        parentComponent.renderCache[cacheIndex] = void 0;
      }
      if (shapeFlag & 256) {
        parentComponent.ctx.deactivate(vnode);
        return;
      }
      const shouldInvokeDirs = shapeFlag & 1 && dirs;
      const shouldInvokeVnodeHook = !isAsyncWrapper(vnode);
      let vnodeHook;
      if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) {
        invokeVNodeHook(vnodeHook, parentComponent, vnode);
      }
      if (shapeFlag & 6) {
        unmountComponent(vnode.component, parentSuspense, doRemove);
      } else {
        if (shapeFlag & 128) {
          vnode.suspense.unmount(parentSuspense, doRemove);
          return;
        }
        if (shouldInvokeDirs) {
          invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
        }
        if (shapeFlag & 64) {
          vnode.type.remove(
            vnode,
            parentComponent,
            parentSuspense,
            internals,
            doRemove
          );
        } else if (dynamicChildren && // #5154
        // when v-once is used inside a block, setBlockTracking(-1) marks the
        // parent block with hasOnce: true
        // so that it doesn't take the fast path during unmount - otherwise
        // components nested in v-once are never unmounted.
        !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
        (type !== Fragment || patchFlag > 0 && patchFlag & 64)) {
          unmountChildren(
            dynamicChildren,
            parentComponent,
            parentSuspense,
            false,
            true
          );
        } else if (type === Fragment && patchFlag & (128 | 256) || !optimized && shapeFlag & 16) {
          unmountChildren(children, parentComponent, parentSuspense);
        }
        if (doRemove) {
          remove2(vnode);
        }
      }
      const shouldInvalidateMemo = memo != null && cacheIndex == null;
      if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs || shouldInvalidateMemo) {
        queuePostRenderEffect(() => {
          vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
          shouldInvokeDirs && invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
          if (shouldInvalidateMemo) {
            vnode.el = null;
          }
        }, parentSuspense);
      }
    };
    const remove2 = (vnode) => {
      const { type, el, anchor, transition } = vnode;
      if (type === Fragment) {
        if (vnode.patchFlag > 0 && vnode.patchFlag & 2048 && transition && !transition.persisted) {
          vnode.children.forEach((child) => {
            if (child.type === Comment) {
              hostRemove(child.el);
            } else {
              remove2(child);
            }
          });
        } else {
          removeFragment(el, anchor);
        }
        return;
      }
      if (type === Static) {
        removeStaticNode(vnode);
        return;
      }
      const performRemove = () => {
        hostRemove(el);
        if (transition && !transition.persisted && transition.afterLeave) {
          transition.afterLeave();
        }
      };
      if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
        const { leave, delayLeave } = transition;
        const performLeave = () => leave(el, performRemove);
        if (delayLeave) {
          delayLeave(vnode.el, performRemove, performLeave);
        } else {
          performLeave();
        }
      } else {
        performRemove();
      }
    };
    const removeFragment = (cur, end) => {
      let next;
      while (cur !== end) {
        next = hostNextSibling(cur);
        hostRemove(cur);
        cur = next;
      }
      hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove) => {
      if (instance.type.__hmrId) {
        unregisterHMR(instance);
      }
      const { bum, scope, job, subTree, um, m, a } = instance;
      invalidateMount(m);
      invalidateMount(a);
      if (bum) {
        invokeArrayFns(bum);
      }
      scope.stop();
      if (job) {
        job.flags |= 8;
        unmount(subTree, instance, parentSuspense, doRemove);
      }
      if (um) {
        queuePostRenderEffect(um, parentSuspense);
      }
      queuePostRenderEffect(() => {
        instance.isUnmounted = true;
      }, parentSuspense);
      if (true) {
        devtoolsComponentRemoved(instance);
      }
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0) => {
      for (let i2 = start; i2 < children.length; i2++) {
        unmount(children[i2], parentComponent, parentSuspense, doRemove, optimized);
      }
    };
    const getNextHostNode = (vnode) => {
      if (vnode.shapeFlag & 6) {
        return getNextHostNode(vnode.component.subTree);
      }
      if (vnode.shapeFlag & 128) {
        return vnode.suspense.next();
      }
      const el = hostNextSibling(vnode.anchor || vnode.el);
      const teleportEnd = el && el[TeleportEndKey];
      return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render67 = (vnode, container, namespace) => {
      let instance;
      if (vnode == null) {
        if (container._vnode) {
          unmount(container._vnode, null, null, true);
          instance = container._vnode.component;
        }
      } else {
        patch(
          container._vnode || null,
          vnode,
          container,
          null,
          null,
          null,
          namespace
        );
      }
      container._vnode = vnode;
      if (!isFlushing) {
        isFlushing = true;
        flushPreFlushCbs(instance);
        flushPostFlushCbs();
        isFlushing = false;
      }
    };
    const internals = {
      p: patch,
      um: unmount,
      m: move,
      r: remove2,
      mt: mountComponent,
      mc: mountChildren,
      pc: patchChildren,
      pbc: patchBlockChildren,
      n: getNextHostNode,
      o: options
    };
    let hydrate2;
    let hydrateNode;
    if (createHydrationFns) {
      [hydrate2, hydrateNode] = createHydrationFns(
        internals
      );
    }
    return {
      render: render67,
      hydrate: hydrate2,
      createApp: createAppAPI(render67, hydrate2)
    };
  }
  function resolveChildrenNamespace({ type, props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
  }
  function toggleRecurse({ effect: effect2, job }, allowed) {
    if (allowed) {
      effect2.flags |= 32;
      job.flags |= 4;
    } else {
      effect2.flags &= -33;
      job.flags &= -5;
    }
  }
  function needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
  }
  function traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if (isArray(ch1) && isArray(ch2)) {
      for (let i2 = 0; i2 < ch1.length; i2++) {
        const c1 = ch1[i2];
        let c2 = ch2[i2];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
          if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
            c2 = ch2[i2] = cloneIfMounted(ch2[i2]);
            c2.el = c1.el;
          }
          if (!shallow && c2.patchFlag !== -2)
            traverseStaticChildren(c1, c2);
        }
        if (c2.type === Text) {
          if (c2.patchFlag === -1) {
            c2 = ch2[i2] = cloneIfMounted(c2);
          }
          c2.el = c1.el;
        }
        if (c2.type === Comment && !c2.el) {
          c2.el = c1.el;
        }
        if (true) {
          c2.el && (c2.el.__vnode = c2);
        }
      }
    }
  }
  function getSequence(arr) {
    const p2 = arr.slice();
    const result = [0];
    let i2, j, u2, v, c;
    const len = arr.length;
    for (i2 = 0; i2 < len; i2++) {
      const arrI = arr[i2];
      if (arrI !== 0) {
        j = result[result.length - 1];
        if (arr[j] < arrI) {
          p2[i2] = j;
          result.push(i2);
          continue;
        }
        u2 = 0;
        v = result.length - 1;
        while (u2 < v) {
          c = u2 + v >> 1;
          if (arr[result[c]] < arrI) {
            u2 = c + 1;
          } else {
            v = c;
          }
        }
        if (arrI < arr[result[u2]]) {
          if (u2 > 0) {
            p2[i2] = result[u2 - 1];
          }
          result[u2] = i2;
        }
      }
    }
    u2 = result.length;
    v = result[u2 - 1];
    while (u2-- > 0) {
      result[u2] = v;
      v = p2[v];
    }
    return result;
  }
  function locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
      if (subComponent.asyncDep && !subComponent.asyncResolved) {
        return subComponent;
      } else {
        return locateNonHydratedAsyncRoot(subComponent);
      }
    }
  }
  function invalidateMount(hooks) {
    if (hooks) {
      for (let i2 = 0; i2 < hooks.length; i2++)
        hooks[i2].flags |= 8;
    }
  }
  function resolveAsyncComponentPlaceholder(anchorVnode) {
    if (anchorVnode.placeholder) {
      return anchorVnode.placeholder;
    }
    const instance = anchorVnode.component;
    if (instance) {
      return resolveAsyncComponentPlaceholder(instance.subTree);
    }
    return null;
  }
  function triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if (isFunction(eventListener)) {
      eventListener();
    }
  }
  function mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const {
      p: patch,
      o: { createElement }
    } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = createSuspenseBoundary(
      vnode,
      parentSuspense,
      parentComponent,
      container,
      hiddenContainer,
      anchor,
      namespace,
      slotScopeIds,
      optimized,
      rendererInternals
    );
    patch(
      null,
      suspense.pendingBranch = vnode.ssContent,
      hiddenContainer,
      null,
      parentComponent,
      suspense,
      namespace,
      slotScopeIds
    );
    if (suspense.deps > 0) {
      triggerEvent(vnode, "onPending");
      triggerEvent(vnode, "onFallback");
      patch(
        null,
        vnode.ssFallback,
        container,
        anchor,
        parentComponent,
        null,
        // fallback tree will not have suspense context
        namespace,
        slotScopeIds
      );
      setActiveBranch(suspense, vnode.ssFallback);
    } else {
      suspense.resolve(false, true);
    }
  }
  function patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch, pendingBranch, isInFallback, isHydrating } = suspense;
    if (pendingBranch) {
      suspense.pendingBranch = newBranch;
      if (isSameVNodeType(pendingBranch, newBranch)) {
        patch(
          pendingBranch,
          newBranch,
          suspense.hiddenContainer,
          null,
          parentComponent,
          suspense,
          namespace,
          slotScopeIds,
          optimized
        );
        if (suspense.deps <= 0) {
          suspense.resolve();
        } else if (isInFallback) {
          if (!isHydrating) {
            patch(
              activeBranch,
              newFallback,
              container,
              anchor,
              parentComponent,
              null,
              // fallback tree will not have suspense context
              namespace,
              slotScopeIds,
              optimized
            );
            setActiveBranch(suspense, newFallback);
          }
        }
      } else {
        suspense.pendingId = suspenseId++;
        if (isHydrating) {
          suspense.isHydrating = false;
          suspense.activeBranch = pendingBranch;
        } else {
          unmount(pendingBranch, parentComponent, suspense);
        }
        suspense.deps = 0;
        suspense.effects.length = 0;
        suspense.hiddenContainer = createElement("div");
        if (isInFallback) {
          patch(
            null,
            newBranch,
            suspense.hiddenContainer,
            null,
            parentComponent,
            suspense,
            namespace,
            slotScopeIds,
            optimized
          );
          if (suspense.deps <= 0) {
            suspense.resolve();
          } else {
            patch(
              activeBranch,
              newFallback,
              container,
              anchor,
              parentComponent,
              null,
              // fallback tree will not have suspense context
              namespace,
              slotScopeIds,
              optimized
            );
            setActiveBranch(suspense, newFallback);
          }
        } else if (activeBranch && isSameVNodeType(activeBranch, newBranch)) {
          patch(
            activeBranch,
            newBranch,
            container,
            anchor,
            parentComponent,
            suspense,
            namespace,
            slotScopeIds,
            optimized
          );
          suspense.resolve(true);
        } else {
          patch(
            null,
            newBranch,
            suspense.hiddenContainer,
            null,
            parentComponent,
            suspense,
            namespace,
            slotScopeIds,
            optimized
          );
          if (suspense.deps <= 0) {
            suspense.resolve();
          }
        }
      }
    } else {
      if (activeBranch && isSameVNodeType(activeBranch, newBranch)) {
        patch(
          activeBranch,
          newBranch,
          container,
          anchor,
          parentComponent,
          suspense,
          namespace,
          slotScopeIds,
          optimized
        );
        setActiveBranch(suspense, newBranch);
      } else {
        triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) {
          suspense.pendingId = newBranch.component.suspenseId;
        } else {
          suspense.pendingId = suspenseId++;
        }
        patch(
          null,
          newBranch,
          suspense.hiddenContainer,
          null,
          parentComponent,
          suspense,
          namespace,
          slotScopeIds,
          optimized
        );
        if (suspense.deps <= 0) {
          suspense.resolve();
        } else {
          const { timeout, pendingId } = suspense;
          if (timeout > 0) {
            setTimeout(() => {
              if (suspense.pendingId === pendingId) {
                suspense.fallback(newFallback);
              }
            }, timeout);
          } else if (timeout === 0) {
            suspense.fallback(newFallback);
          }
        }
      }
    }
  }
  function createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    if (!hasWarned) {
      hasWarned = true;
      console[console.info ? "info" : "log"](
        `<Suspense> is an experimental feature and its API will likely change.`
      );
    }
    const {
      p: patch,
      m: move,
      um: unmount,
      n: next,
      o: { parentNode, remove: remove2 }
    } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = isVNodeSuspensible(vnode);
    if (isSuspensible) {
      if (parentSuspense && parentSuspense.pendingBranch) {
        parentSuspenseId = parentSuspense.pendingId;
        parentSuspense.deps++;
      }
    }
    const timeout = vnode.props ? toNumber(vnode.props.timeout) : void 0;
    if (true) {
      assertNumber(timeout, `Suspense timeout`);
    }
    const initialAnchor = anchor;
    const suspense = {
      vnode,
      parent: parentSuspense,
      parentComponent,
      namespace,
      container,
      hiddenContainer,
      deps: 0,
      pendingId: suspenseId++,
      timeout: typeof timeout === "number" ? timeout : -1,
      activeBranch: null,
      isFallbackMountPending: false,
      pendingBranch: null,
      isInFallback: !isHydrating,
      isHydrating,
      isUnmounted: false,
      effects: [],
      resolve(resume = false, sync = false) {
        if (true) {
          if (!resume && !suspense.pendingBranch) {
            throw new Error(
              `suspense.resolve() is called without a pending branch.`
            );
          }
          if (suspense.isUnmounted) {
            throw new Error(
              `suspense.resolve() is called on an already unmounted suspense boundary.`
            );
          }
        }
        const {
          vnode: vnode2,
          activeBranch,
          pendingBranch,
          pendingId,
          effects,
          parentComponent: parentComponent2,
          container: container2,
          isInFallback
        } = suspense;
        let delayEnter = false;
        if (suspense.isHydrating) {
          suspense.isHydrating = false;
        } else if (!resume) {
          delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
          let hasUpdatedAnchor = false;
          if (delayEnter) {
            activeBranch.transition.afterLeave = () => {
              if (pendingId === suspense.pendingId) {
                move(
                  pendingBranch,
                  container2,
                  anchor === initialAnchor && !hasUpdatedAnchor ? next(activeBranch) : anchor,
                  0
                );
                queuePostFlushCb(effects);
                if (isInFallback && vnode2.ssFallback) {
                  vnode2.ssFallback.el = null;
                }
              }
            };
          }
          if (activeBranch && !suspense.isFallbackMountPending) {
            if (parentNode(activeBranch.el) === container2) {
              anchor = next(activeBranch);
              hasUpdatedAnchor = true;
            }
            unmount(activeBranch, parentComponent2, suspense, true);
            if (!delayEnter && isInFallback && vnode2.ssFallback) {
              queuePostRenderEffect(() => vnode2.ssFallback.el = null, suspense);
            }
          }
          if (!delayEnter) {
            move(pendingBranch, container2, anchor, 0);
          }
        }
        suspense.isFallbackMountPending = false;
        setActiveBranch(suspense, pendingBranch);
        suspense.pendingBranch = null;
        suspense.isInFallback = false;
        let parent = suspense.parent;
        let hasUnresolvedAncestor = false;
        while (parent) {
          if (parent.pendingBranch) {
            for (let i2 = 0; i2 < effects.length; i2++) {
              parent.effects.push(effects[i2]);
            }
            hasUnresolvedAncestor = true;
            break;
          }
          parent = parent.parent;
        }
        if (!hasUnresolvedAncestor && !delayEnter) {
          queuePostFlushCb(effects);
        }
        suspense.effects = [];
        if (isSuspensible) {
          if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0 && !sync) {
              parentSuspense.resolve();
            }
          }
        }
        triggerEvent(vnode2, "onResolve");
      },
      fallback(fallbackVNode) {
        if (!suspense.pendingBranch) {
          return;
        }
        const { vnode: vnode2, activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
        triggerEvent(vnode2, "onFallback");
        const anchor2 = next(activeBranch);
        const mountFallback = () => {
          suspense.isFallbackMountPending = false;
          if (!suspense.isInFallback) {
            return;
          }
          patch(
            null,
            fallbackVNode,
            container2,
            anchor2,
            parentComponent2,
            null,
            // fallback tree will not have suspense context
            namespace2,
            slotScopeIds,
            optimized
          );
          setActiveBranch(suspense, fallbackVNode);
        };
        const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
        if (delayEnter) {
          suspense.isFallbackMountPending = true;
          activeBranch.transition.afterLeave = mountFallback;
        }
        suspense.isInFallback = true;
        unmount(
          activeBranch,
          parentComponent2,
          null,
          // no suspense so unmount hooks fire now
          true
          // shouldRemove
        );
        if (!delayEnter) {
          mountFallback();
        }
      },
      move(container2, anchor2, type) {
        suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
        suspense.container = container2;
      },
      next() {
        return suspense.activeBranch && next(suspense.activeBranch);
      },
      registerDep(instance, setupRenderEffect, optimized2) {
        const isInPendingSuspense = !!suspense.pendingBranch;
        if (isInPendingSuspense) {
          suspense.deps++;
        }
        const hydratedEl = instance.vnode.el;
        instance.asyncDep.catch((err) => {
          handleError(err, instance, 0);
        }).then((asyncSetupResult) => {
          if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) {
            return;
          }
          unsetCurrentInstance();
          instance.asyncResolved = true;
          const { vnode: vnode2 } = instance;
          if (true) {
            pushWarningContext(vnode2);
          }
          handleSetupResult(instance, asyncSetupResult, false);
          if (hydratedEl) {
            vnode2.el = hydratedEl;
          }
          const placeholder = !hydratedEl && instance.subTree.el;
          setupRenderEffect(
            instance,
            vnode2,
            // component may have been moved before resolve.
            // if this is not a hydration, instance.subTree will be the comment
            // placeholder.
            parentNode(hydratedEl || instance.subTree.el),
            // anchor will not be used if this is hydration, so only need to
            // consider the comment placeholder case.
            hydratedEl ? null : next(instance.subTree),
            suspense,
            namespace,
            optimized2
          );
          if (placeholder) {
            vnode2.placeholder = null;
            remove2(placeholder);
          }
          updateHOCHostEl(instance, vnode2.el);
          if (true) {
            popWarningContext();
          }
          if (isInPendingSuspense && --suspense.deps === 0) {
            suspense.resolve();
          }
        });
      },
      unmount(parentSuspense2, doRemove) {
        suspense.isUnmounted = true;
        if (suspense.activeBranch) {
          unmount(
            suspense.activeBranch,
            parentComponent,
            parentSuspense2,
            doRemove
          );
        }
        if (suspense.pendingBranch) {
          unmount(
            suspense.pendingBranch,
            parentComponent,
            parentSuspense2,
            doRemove
          );
        }
      }
    };
    return suspense;
  }
  function hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = createSuspenseBoundary(
      vnode,
      parentSuspense,
      parentComponent,
      node.parentNode,
      // eslint-disable-next-line no-restricted-globals
      document.createElement("div"),
      null,
      namespace,
      slotScopeIds,
      optimized,
      rendererInternals,
      true
    );
    const result = hydrateNode(
      node,
      suspense.pendingBranch = vnode.ssContent,
      parentComponent,
      suspense,
      slotScopeIds,
      optimized
    );
    if (suspense.deps === 0) {
      suspense.resolve(false, true);
    }
    return result;
  }
  function normalizeSuspenseChildren(vnode) {
    const { shapeFlag, children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = normalizeSuspenseSlot(
      isSlotChildren ? children.default : children
    );
    vnode.ssFallback = isSlotChildren ? normalizeSuspenseSlot(children.fallback) : createVNode(Comment);
  }
  function normalizeSuspenseSlot(s) {
    let block;
    if (isFunction(s)) {
      const trackBlock = isBlockTreeEnabled && s._c;
      if (trackBlock) {
        s._d = false;
        openBlock();
      }
      s = s();
      if (trackBlock) {
        s._d = true;
        block = currentBlock;
        closeBlock();
      }
    }
    if (isArray(s)) {
      const singleChild = filterSingleRoot(s);
      if (!singleChild && s.filter((child) => child !== NULL_DYNAMIC_COMPONENT).length > 0) {
        warn$1(`<Suspense> slots expect a single root node.`);
      }
      s = singleChild;
    }
    s = normalizeVNode(s);
    if (block && !s.dynamicChildren) {
      s.dynamicChildren = block.filter((c) => c !== s);
    }
    return s;
  }
  function queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
      if (isArray(fn)) {
        suspense.effects.push(...fn);
      } else {
        suspense.effects.push(fn);
      }
    } else {
      queuePostFlushCb(fn);
    }
  }
  function setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode, parentComponent } = suspense;
    let el = branch.el;
    while (!el && branch.component) {
      branch = branch.component.subTree;
      el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
      parentComponent.vnode.el = el;
      updateHOCHostEl(parentComponent, el);
    }
  }
  function isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
  }
  function openBlock(disableTracking = false) {
    blockStack.push(currentBlock = disableTracking ? null : []);
  }
  function closeBlock() {
    blockStack.pop();
    currentBlock = blockStack[blockStack.length - 1] || null;
  }
  function setBlockTracking(value, inVOnce = false) {
    isBlockTreeEnabled += value;
    if (value < 0 && currentBlock && inVOnce) {
      currentBlock.hasOnce = true;
    }
  }
  function setupBlock(vnode) {
    vnode.dynamicChildren = isBlockTreeEnabled > 0 ? currentBlock || EMPTY_ARR : null;
    closeBlock();
    if (isBlockTreeEnabled > 0 && currentBlock) {
      currentBlock.push(vnode);
    }
    return vnode;
  }
  function createElementBlock(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return setupBlock(
      createBaseVNode(
        type,
        props,
        children,
        patchFlag,
        dynamicProps,
        shapeFlag,
        true
      )
    );
  }
  function createBlock(type, props, children, patchFlag, dynamicProps) {
    return setupBlock(
      createVNode(
        type,
        props,
        children,
        patchFlag,
        dynamicProps,
        true
      )
    );
  }
  function isVNode(value) {
    return value ? value.__v_isVNode === true : false;
  }
  function isSameVNodeType(n1, n2) {
    if (n2.shapeFlag & 6 && n1.component) {
      const dirtyInstances = hmrDirtyComponents.get(n2.type);
      if (dirtyInstances && dirtyInstances.has(n1.component)) {
        n1.shapeFlag &= -257;
        n2.shapeFlag &= -513;
        return false;
      }
    }
    return n1.type === n2.type && n1.key === n2.key;
  }
  function transformVNodeArgs(transformer) {
    vnodeArgsTransformer = transformer;
  }
  function createBaseVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === Fragment ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
      __v_isVNode: true,
      __v_skip: true,
      type,
      props,
      key: props && normalizeKey(props),
      ref: props && normalizeRef(props),
      scopeId: currentScopeId,
      slotScopeIds: null,
      children,
      component: null,
      suspense: null,
      ssContent: null,
      ssFallback: null,
      dirs: null,
      transition: null,
      el: null,
      anchor: null,
      target: null,
      targetStart: null,
      targetAnchor: null,
      staticCount: 0,
      shapeFlag,
      patchFlag,
      dynamicProps,
      dynamicChildren: null,
      appContext: null,
      ctx: currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
      normalizeChildren(vnode, children);
      if (shapeFlag & 128) {
        type.normalize(vnode);
      }
    } else if (children) {
      vnode.shapeFlag |= isString(children) ? 8 : 16;
    }
    if (vnode.key !== vnode.key) {
      warn$1(`VNode created with invalid key (NaN). VNode type:`, vnode.type);
    }
    if (props && vnode.shapeFlag & 1) {
      const overwritingProp = props.innerHTML != null ? "innerHTML" : props.textContent != null ? "textContent" : null;
      if (overwritingProp && hasContentChildren(vnode.children)) {
        warn$1(
          `The \`${overwritingProp}\` prop on <${vnode.type}> will override its children. Remove either the \`${overwritingProp}\` prop or the children.`
        );
      }
    }
    if (isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) {
      currentBlock.push(vnode);
    }
    return vnode;
  }
  function hasContentChildren(children) {
    if (isString(children)) return children !== "";
    if (isArray(children)) return children.length > 0;
    return false;
  }
  function _createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === NULL_DYNAMIC_COMPONENT) {
      if (!type) {
        warn$1(`Invalid vnode type when creating vnode: ${type}.`);
      }
      type = Comment;
    }
    if (isVNode(type)) {
      const cloned = cloneVNode(
        type,
        props,
        true
        /* mergeRef: true */
      );
      if (children) {
        normalizeChildren(cloned, children);
      }
      if (isBlockTreeEnabled > 0 && !isBlockNode && currentBlock) {
        if (cloned.shapeFlag & 6) {
          currentBlock[currentBlock.indexOf(type)] = cloned;
        } else {
          currentBlock.push(cloned);
        }
      }
      cloned.patchFlag = -2;
      return cloned;
    }
    if (isClassComponent(type)) {
      type = type.__vccOpts;
    }
    if (props) {
      props = guardReactiveProps(props);
      let { class: klass, style } = props;
      if (klass && !isString(klass)) {
        props.class = normalizeClass(klass);
      }
      if (isObject(style)) {
        if (isProxy(style) && !isArray(style)) {
          style = extend({}, style);
        }
        props.style = normalizeStyle(style);
      }
    }
    const shapeFlag = isString(type) ? 1 : isSuspense(type) ? 128 : isTeleport(type) ? 64 : isObject(type) ? 4 : isFunction(type) ? 2 : 0;
    if (shapeFlag & 4 && isProxy(type)) {
      type = toRaw(type);
      warn$1(
        `Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with \`markRaw\` or using \`shallowRef\` instead of \`ref\`.`,
        `
Component that was made reactive: `,
        type
      );
    }
    return createBaseVNode(
      type,
      props,
      children,
      patchFlag,
      dynamicProps,
      shapeFlag,
      isBlockNode,
      true
    );
  }
  function guardReactiveProps(props) {
    if (!props) return null;
    return isProxy(props) || isInternalObject(props) ? extend({}, props) : props;
  }
  function cloneVNode(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props, ref: ref2, patchFlag, children, transition } = vnode;
    const mergedProps = extraProps ? mergeProps(props || {}, extraProps) : props;
    const cloned = {
      __v_isVNode: true,
      __v_skip: true,
      type: vnode.type,
      props: mergedProps,
      key: mergedProps && normalizeKey(mergedProps),
      ref: extraProps && extraProps.ref ? (
        // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref2 ? isArray(ref2) ? ref2.concat(normalizeRef(extraProps)) : [ref2, normalizeRef(extraProps)] : normalizeRef(extraProps)
      ) : ref2,
      scopeId: vnode.scopeId,
      slotScopeIds: vnode.slotScopeIds,
      children: patchFlag === -1 && isArray(children) ? children.map(deepCloneVNode) : children,
      target: vnode.target,
      targetStart: vnode.targetStart,
      targetAnchor: vnode.targetAnchor,
      staticCount: vnode.staticCount,
      shapeFlag: vnode.shapeFlag,
      // if the vnode is cloned with extra props, we can no longer assume its
      // existing patch flag to be reliable and need to add the FULL_PROPS flag.
      // note: preserve flag for fragments since they use the flag for children
      // fast paths only.
      patchFlag: extraProps && vnode.type !== Fragment ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
      dynamicProps: vnode.dynamicProps,
      dynamicChildren: vnode.dynamicChildren,
      appContext: vnode.appContext,
      dirs: vnode.dirs,
      transition,
      // These should technically only be non-null on mounted VNodes. However,
      // they *should* be copied for kept-alive vnodes. So we just always copy
      // them since them being non-null during a mount doesn't affect the logic as
      // they will simply be overwritten.
      component: vnode.component,
      suspense: vnode.suspense,
      ssContent: vnode.ssContent && cloneVNode(vnode.ssContent),
      ssFallback: vnode.ssFallback && cloneVNode(vnode.ssFallback),
      placeholder: vnode.placeholder,
      el: vnode.el,
      anchor: vnode.anchor,
      ctx: vnode.ctx,
      ce: vnode.ce
    };
    if (transition && cloneTransition) {
      setTransitionHooks(
        cloned,
        transition.clone(cloned)
      );
    }
    return cloned;
  }
  function deepCloneVNode(vnode) {
    const cloned = cloneVNode(vnode);
    if (isArray(vnode.children)) {
      cloned.children = vnode.children.map(deepCloneVNode);
    }
    return cloned;
  }
  function createTextVNode(text = " ", flag = 0) {
    return createVNode(Text, null, text, flag);
  }
  function createStaticVNode(content, numberOfNodes) {
    const vnode = createVNode(Static, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
  }
  function createCommentVNode(text = "", asBlock = false) {
    return asBlock ? (openBlock(), createBlock(Comment, null, text)) : createVNode(Comment, null, text);
  }
  function normalizeVNode(child) {
    if (child == null || typeof child === "boolean") {
      return createVNode(Comment);
    } else if (isArray(child)) {
      return createVNode(
        Fragment,
        null,
        // #3666, avoid reference pollution when reusing vnode
        child.slice()
      );
    } else if (isVNode(child)) {
      return cloneIfMounted(child);
    } else {
      return createVNode(Text, null, String(child));
    }
  }
  function cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : cloneVNode(child);
  }
  function normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag } = vnode;
    if (children == null) {
      children = null;
    } else if (isArray(children)) {
      type = 16;
    } else if (typeof children === "object") {
      if (shapeFlag & (1 | 64)) {
        const slot = children.default;
        if (slot) {
          slot._c && (slot._d = false);
          normalizeChildren(vnode, slot());
          slot._c && (slot._d = true);
        }
        return;
      } else {
        type = 32;
        const slotFlag = children._;
        if (!slotFlag && !isInternalObject(children)) {
          children._ctx = currentRenderingInstance;
        } else if (slotFlag === 3 && currentRenderingInstance) {
          if (currentRenderingInstance.slots._ === 1) {
            children._ = 1;
          } else {
            children._ = 2;
            vnode.patchFlag |= 1024;
          }
        }
      }
    } else if (isFunction(children)) {
      if (shapeFlag & (1 | 64)) {
        normalizeChildren(vnode, { default: children });
        return;
      }
      children = { default: children, _ctx: currentRenderingInstance };
      type = 32;
    } else {
      children = String(children);
      if (shapeFlag & 64) {
        type = 16;
        children = [createTextVNode(children)];
      } else {
        type = 8;
      }
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
  }
  function mergeProps(...args) {
    const ret = {};
    for (let i2 = 0; i2 < args.length; i2++) {
      const toMerge = args[i2];
      for (const key in toMerge) {
        if (key === "class") {
          if (ret.class !== toMerge.class) {
            ret.class = normalizeClass([ret.class, toMerge.class]);
          }
        } else if (key === "style") {
          ret.style = normalizeStyle([ret.style, toMerge.style]);
        } else if (isOn(key)) {
          const existing = ret[key];
          const incoming = toMerge[key];
          if (incoming && existing !== incoming && !(isArray(existing) && existing.includes(incoming))) {
            ret[key] = existing ? [].concat(existing, incoming) : incoming;
          } else if (incoming == null && existing == null && // mergeProps({ 'onUpdate:modelValue': undefined }) should not retain
          // the model listener.
          !isModelListener(key)) {
            ret[key] = incoming;
          }
        } else if (key !== "") {
          ret[key] = toMerge[key];
        }
      }
    }
    return ret;
  }
  function invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    callWithAsyncErrorHandling(hook, instance, 7, [
      vnode,
      prevVNode
    ]);
  }
  function createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || emptyAppContext;
    const instance = {
      uid: uid++,
      vnode,
      type,
      parent,
      appContext,
      root: null,
      // to be immediately set
      next: null,
      subTree: null,
      // will be set synchronously right after creation
      effect: null,
      update: null,
      // will be set synchronously right after creation
      job: null,
      scope: new EffectScope(
        true
        /* detached */
      ),
      render: null,
      proxy: null,
      exposed: null,
      exposeProxy: null,
      withProxy: null,
      provides: parent ? parent.provides : Object.create(appContext.provides),
      ids: parent ? parent.ids : ["", 0, 0],
      accessCache: null,
      renderCache: [],
      // local resolved assets
      components: null,
      directives: null,
      // resolved props and emits options
      propsOptions: normalizePropsOptions(type, appContext),
      emitsOptions: normalizeEmitsOptions(type, appContext),
      // emit
      emit: null,
      // to be set immediately
      emitted: null,
      // props default value
      propsDefaults: EMPTY_OBJ,
      // inheritAttrs
      inheritAttrs: type.inheritAttrs,
      // state
      ctx: EMPTY_OBJ,
      data: EMPTY_OBJ,
      props: EMPTY_OBJ,
      attrs: EMPTY_OBJ,
      slots: EMPTY_OBJ,
      refs: EMPTY_OBJ,
      setupState: EMPTY_OBJ,
      setupContext: null,
      // suspense related
      suspense,
      suspenseId: suspense ? suspense.pendingId : 0,
      asyncDep: null,
      asyncResolved: false,
      // lifecycle hooks
      // not using enums here because it results in computed properties
      isMounted: false,
      isUnmounted: false,
      isDeactivated: false,
      bc: null,
      c: null,
      bm: null,
      m: null,
      bu: null,
      u: null,
      um: null,
      bum: null,
      da: null,
      a: null,
      rtg: null,
      rtc: null,
      ec: null,
      sp: null
    };
    if (true) {
      instance.ctx = createDevRenderContext(instance);
    } else {
      instance.ctx = { _: instance };
    }
    instance.root = parent ? parent.root : instance;
    instance.emit = emit.bind(null, instance);
    if (vnode.ce) {
      vnode.ce(instance);
    }
    return instance;
  }
  function validateComponentName(name, { isNativeTag }) {
    if (isBuiltInTag(name) || isNativeTag(name)) {
      warn$1(
        "Do not use built-in or reserved HTML elements as component id: " + name
      );
    }
  }
  function isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
  }
  function setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && setInSSRSetupState(isSSR);
    const { props, children } = instance.vnode;
    const isStateful = isStatefulComponent(instance);
    initProps(instance, props, isStateful, isSSR);
    initSlots(instance, children, optimized || isSSR);
    const setupResult = isStateful ? setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && setInSSRSetupState(false);
    return setupResult;
  }
  function setupStatefulComponent(instance, isSSR) {
    const Component = instance.type;
    if (true) {
      if (Component.name) {
        validateComponentName(Component.name, instance.appContext.config);
      }
      if (Component.components) {
        const names2 = Object.keys(Component.components);
        for (let i2 = 0; i2 < names2.length; i2++) {
          validateComponentName(names2[i2], instance.appContext.config);
        }
      }
      if (Component.directives) {
        const names2 = Object.keys(Component.directives);
        for (let i2 = 0; i2 < names2.length; i2++) {
          validateDirectiveName(names2[i2]);
        }
      }
      if (Component.compilerOptions && isRuntimeOnly()) {
        warn$1(
          `"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.`
        );
      }
    }
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, PublicInstanceProxyHandlers);
    if (true) {
      exposePropsOnRenderContext(instance);
    }
    const { setup } = Component;
    if (setup) {
      pauseTracking();
      const setupContext = instance.setupContext = setup.length > 1 ? createSetupContext(instance) : null;
      const reset2 = setCurrentInstance(instance);
      const setupResult = callWithErrorHandling(
        setup,
        instance,
        0,
        [
          true ? shallowReadonly(instance.props) : instance.props,
          setupContext
        ]
      );
      const isAsyncSetup = isPromise(setupResult);
      resetTracking();
      reset2();
      if ((isAsyncSetup || instance.sp) && !isAsyncWrapper(instance)) {
        markAsyncBoundary(instance);
      }
      if (isAsyncSetup) {
        setupResult.then(unsetCurrentInstance, unsetCurrentInstance);
        if (isSSR) {
          return setupResult.then((resolvedResult) => {
            setInSSRSetupState(true);
            try {
              handleSetupResult(instance, resolvedResult, isSSR);
            } finally {
              setInSSRSetupState(false);
            }
          }).catch((e) => {
            handleError(e, instance, 0);
          });
        } else {
          instance.asyncDep = setupResult;
          if (!instance.suspense) {
            const name = formatComponentName(instance, Component);
            warn$1(
              `Component <${name}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`
            );
          }
        }
      } else {
        handleSetupResult(instance, setupResult, isSSR);
      }
    } else {
      finishComponentSetup(instance, isSSR);
    }
  }
  function handleSetupResult(instance, setupResult, isSSR) {
    if (isFunction(setupResult)) {
      if (instance.type.__ssrInlineRender) {
        instance.ssrRender = setupResult;
      } else {
        instance.render = setupResult;
      }
    } else if (isObject(setupResult)) {
      if (isVNode(setupResult)) {
        warn$1(
          `setup() should not return VNodes directly - return a render function instead.`
        );
      }
      if (true) {
        instance.devtoolsRawSetupState = setupResult;
      }
      instance.setupState = proxyRefs(setupResult);
      if (true) {
        exposeSetupStateOnRenderContext(instance);
      }
    } else if (setupResult !== void 0) {
      warn$1(
        `setup() should return an object. Received: ${setupResult === null ? "null" : typeof setupResult}`
      );
    }
    finishComponentSetup(instance, isSSR);
  }
  function registerRuntimeCompiler(_compile) {
    compile = _compile;
    installWithProxy = (i2) => {
      if (i2.render._rc) {
        i2.withProxy = new Proxy(i2.ctx, RuntimeCompiledPublicInstanceProxyHandlers);
      }
    };
  }
  function finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
      if (!isSSR && compile && !Component.render) {
        const template = Component.template || resolveMergedOptions(instance).template;
        if (template) {
          if (true) {
            startMeasure(instance, `compile`);
          }
          const { isCustomElement, compilerOptions } = instance.appContext.config;
          const { delimiters, compilerOptions: componentCompilerOptions } = Component;
          const finalCompilerOptions = extend(
            extend(
              {
                isCustomElement,
                delimiters
              },
              compilerOptions
            ),
            componentCompilerOptions
          );
          Component.render = compile(template, finalCompilerOptions);
          if (true) {
            endMeasure(instance, `compile`);
          }
        }
      }
      instance.render = Component.render || NOOP;
      if (installWithProxy) {
        installWithProxy(instance);
      }
    }
    if (true) {
      const reset2 = setCurrentInstance(instance);
      pauseTracking();
      try {
        applyOptions(instance);
      } finally {
        resetTracking();
        reset2();
      }
    }
    if (!Component.render && instance.render === NOOP && !isSSR) {
      if (!compile && Component.template) {
        warn$1(
          `Component provided template option but runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".`
        );
      } else {
        warn$1(`Component is missing template or render function: `, Component);
      }
    }
  }
  function getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
      get(target, key) {
        track(instance, "get", "$slots");
        return target[key];
      }
    });
  }
  function createSetupContext(instance) {
    const expose = (exposed) => {
      if (true) {
        if (instance.exposed) {
          warn$1(`expose() should be called only once per setup().`);
        }
        if (exposed != null) {
          let exposedType = typeof exposed;
          if (exposedType === "object") {
            if (isArray(exposed)) {
              exposedType = "array";
            } else if (isRef2(exposed)) {
              exposedType = "ref";
            }
          }
          if (exposedType !== "object") {
            warn$1(
              `expose() should be passed a plain object, received ${exposedType}.`
            );
          }
        }
      }
      instance.exposed = exposed || {};
    };
    if (true) {
      let attrsProxy;
      let slotsProxy;
      return Object.freeze({
        get attrs() {
          return attrsProxy || (attrsProxy = new Proxy(instance.attrs, attrsProxyHandlers));
        },
        get slots() {
          return slotsProxy || (slotsProxy = getSlotsProxy(instance));
        },
        get emit() {
          return (event, ...args) => instance.emit(event, ...args);
        },
        expose
      });
    } else {
      return {
        attrs: new Proxy(instance.attrs, attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose
      };
    }
  }
  function getComponentPublicInstance(instance) {
    if (instance.exposed) {
      return instance.exposeProxy || (instance.exposeProxy = new Proxy(proxyRefs(markRaw(instance.exposed)), {
        get(target, key) {
          if (key in target) {
            return target[key];
          } else if (key in publicPropertiesMap) {
            return publicPropertiesMap[key](instance);
          }
        },
        has(target, key) {
          return key in target || key in publicPropertiesMap;
        }
      }));
    } else {
      return instance.proxy;
    }
  }
  function getComponentName(Component, includeInferred = true) {
    return isFunction(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
  }
  function formatComponentName(instance, Component, isRoot = false) {
    let name = getComponentName(Component);
    if (!name && Component.__file) {
      const match = Component.__file.match(/([^/\\]+)\.\w+$/);
      if (match) {
        name = match[1];
      }
    }
    if (!name && instance) {
      const inferFromRegistry = (registry) => {
        for (const key in registry) {
          if (registry[key] === Component) {
            return key;
          }
        }
      };
      name = inferFromRegistry(instance.components) || instance.parent && inferFromRegistry(
        instance.parent.type.components
      ) || inferFromRegistry(instance.appContext.components);
    }
    return name ? classify(name) : isRoot ? `App` : `Anonymous`;
  }
  function isClassComponent(value) {
    return isFunction(value) && "__vccOpts" in value;
  }
  function h(type, propsOrChildren, children) {
    try {
      setBlockTracking(-1);
      const l = arguments.length;
      if (l === 2) {
        if (isObject(propsOrChildren) && !isArray(propsOrChildren)) {
          if (isVNode(propsOrChildren)) {
            return createVNode(type, null, [propsOrChildren]);
          }
          return createVNode(type, propsOrChildren);
        } else {
          return createVNode(type, null, propsOrChildren);
        }
      } else {
        if (l > 3) {
          children = Array.prototype.slice.call(arguments, 2);
        } else if (l === 3 && isVNode(children)) {
          children = [children];
        }
        return createVNode(type, propsOrChildren, children);
      }
    } finally {
      setBlockTracking(1);
    }
  }
  function initCustomFormatter() {
    if (typeof window === "undefined") {
      return;
    }
    const vueStyle = { style: "color:#3ba776" };
    const numberStyle = { style: "color:#1677ff" };
    const stringStyle = { style: "color:#f5222d" };
    const keywordStyle = { style: "color:#eb2f96" };
    const formatter = {
      __vue_custom_formatter: true,
      header(obj) {
        if (!isObject(obj)) {
          return null;
        }
        if (obj.__isVue) {
          return ["div", vueStyle, `VueInstance`];
        } else if (isRef2(obj)) {
          pauseTracking();
          const value = obj.value;
          resetTracking();
          return [
            "div",
            {},
            ["span", vueStyle, genRefFlag(obj)],
            "<",
            formatValue(value),
            `>`
          ];
        } else if (isReactive(obj)) {
          return [
            "div",
            {},
            ["span", vueStyle, isShallow(obj) ? "ShallowReactive" : "Reactive"],
            "<",
            formatValue(obj),
            `>${isReadonly(obj) ? ` (readonly)` : ``}`
          ];
        } else if (isReadonly(obj)) {
          return [
            "div",
            {},
            ["span", vueStyle, isShallow(obj) ? "ShallowReadonly" : "Readonly"],
            "<",
            formatValue(obj),
            ">"
          ];
        }
        return null;
      },
      hasBody(obj) {
        return obj && obj.__isVue;
      },
      body(obj) {
        if (obj && obj.__isVue) {
          return [
            "div",
            {},
            ...formatInstance(obj.$)
          ];
        }
      }
    };
    function formatInstance(instance) {
      const blocks = [];
      if (instance.type.props && instance.props) {
        blocks.push(createInstanceBlock("props", toRaw(instance.props)));
      }
      if (instance.setupState !== EMPTY_OBJ) {
        blocks.push(createInstanceBlock("setup", instance.setupState));
      }
      if (instance.data !== EMPTY_OBJ) {
        blocks.push(createInstanceBlock("data", toRaw(instance.data)));
      }
      const computed3 = extractKeys(instance, "computed");
      if (computed3) {
        blocks.push(createInstanceBlock("computed", computed3));
      }
      const injected = extractKeys(instance, "inject");
      if (injected) {
        blocks.push(createInstanceBlock("injected", injected));
      }
      blocks.push([
        "div",
        {},
        [
          "span",
          {
            style: keywordStyle.style + ";opacity:0.66"
          },
          "$ (internal): "
        ],
        ["object", { object: instance }]
      ]);
      return blocks;
    }
    function createInstanceBlock(type, target) {
      target = extend({}, target);
      if (!Object.keys(target).length) {
        return ["span", {}];
      }
      return [
        "div",
        { style: "line-height:1.25em;margin-bottom:0.6em" },
        [
          "div",
          {
            style: "color:#476582"
          },
          type
        ],
        [
          "div",
          {
            style: "padding-left:1.25em"
          },
          ...Object.keys(target).map((key) => {
            return [
              "div",
              {},
              ["span", keywordStyle, key + ": "],
              formatValue(target[key], false)
            ];
          })
        ]
      ];
    }
    function formatValue(v, asRaw = true) {
      if (typeof v === "number") {
        return ["span", numberStyle, v];
      } else if (typeof v === "string") {
        return ["span", stringStyle, JSON.stringify(v)];
      } else if (typeof v === "boolean") {
        return ["span", keywordStyle, v];
      } else if (isObject(v)) {
        return ["object", { object: asRaw ? toRaw(v) : v }];
      } else {
        return ["span", stringStyle, String(v)];
      }
    }
    function extractKeys(instance, type) {
      const Comp = instance.type;
      if (isFunction(Comp)) {
        return;
      }
      const extracted = {};
      for (const key in instance.ctx) {
        if (isKeyOfType(Comp, key, type)) {
          extracted[key] = instance.ctx[key];
        }
      }
      return extracted;
    }
    function isKeyOfType(Comp, key, type) {
      const opts = Comp[type];
      if (isArray(opts) && opts.includes(key) || isObject(opts) && key in opts) {
        return true;
      }
      if (Comp.extends && isKeyOfType(Comp.extends, key, type)) {
        return true;
      }
      if (Comp.mixins && Comp.mixins.some((m) => isKeyOfType(m, key, type))) {
        return true;
      }
    }
    function genRefFlag(v) {
      if (isShallow(v)) {
        return `ShallowRef`;
      }
      if (v.effect) {
        return `ComputedRef`;
      }
      return `Ref`;
    }
    if (window.devtoolsFormatters) {
      window.devtoolsFormatters.push(formatter);
    } else {
      window.devtoolsFormatters = [formatter];
    }
  }
  function withMemo(memo, render67, cache, index) {
    const cached = cache[index];
    if (cached && isMemoSame(cached, memo)) {
      return cached;
    }
    const ret = render67();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
  }
  function isMemoSame(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) {
      return false;
    }
    for (let i2 = 0; i2 < prev.length; i2++) {
      if (hasChanged(prev[i2], memo[i2])) {
        return false;
      }
    }
    if (isBlockTreeEnabled > 0 && currentBlock) {
      currentBlock.push(cached);
    }
    return true;
  }
  var stack, isWarning, ErrorCodes, ErrorTypeStrings$1, queue, flushIndex, pendingPostFlushCbs, activePostFlushCbs, postFlushIndex, resolvedPromise, currentFlushPromise, RECURSION_LIMIT, getId, isHmrUpdating, setHmrUpdating, hmrDirtyComponents, map, devtools$1, buffer, devtoolsNotInstalled, devtoolsComponentAdded, devtoolsComponentUpdated, _devtoolsComponentRemoved, devtoolsComponentRemoved, devtoolsPerfStart, devtoolsPerfEnd, currentRenderingInstance, currentScopeId, withScopeId, ssrContextKey, useSSRContext, pendingMounts, TeleportEndKey, isTeleport, isTeleportDisabled, isTeleportDeferred, isTargetSVG, isTargetMathML, resolveTarget, TeleportImpl, Teleport, leaveCbKey, enterCbKey, TransitionHookValidator, BaseTransitionPropsValidators, recursiveGetSubtree, BaseTransitionImpl, BaseTransition, knownTemplateRefs, pendingSetRefMap, hasLoggedMismatchError, logMismatchError, isSVGContainer, isMathMLContainer, getContainerType, isComment, resourceProps, allowMismatchAttr, MismatchTypeString, requestIdleCallback, cancelIdleCallback, hydrateOnIdle, hydrateOnVisible, hydrateOnMediaQuery, hydrateOnInteraction, isAsyncWrapper, isKeepAlive, KeepAliveImpl, KeepAlive, createHook, onBeforeMount, onMounted, onBeforeUpdate, onUpdated, onBeforeUnmount, onUnmounted, onServerPrefetch, onRenderTriggered, onRenderTracked, COMPONENTS, DIRECTIVES, NULL_DYNAMIC_COMPONENT, getPublicInstance, publicPropertiesMap, isReservedPrefix, hasSetupBinding, PublicInstanceProxyHandlers, RuntimeCompiledPublicInstanceProxyHandlers, warnRuntimeUsage, shouldCacheAccess, internalOptionMergeStrats, uid$1, currentApp, getModelModifiers, mixinEmitsCache, accessedAttrs, getChildRoot, getFunctionalFallthrough, filterModelListeners, isElementRoot, internalObjectProto, createInternalObject, isInternalObject, mixinPropsCache, isSimpleType, isInternalKey, normalizeSlotValue, normalizeSlot, normalizeObjectSlots, normalizeVNodeSlots, assignSlots, initSlots, updateSlots, supported, perf, queuePostRenderEffect, isSuspense, suspenseId, SuspenseImpl, Suspense, hasWarned, Fragment, Text, Comment, Static, blockStack, currentBlock, isBlockTreeEnabled, vnodeArgsTransformer, createVNodeWithArgsTransform, normalizeKey, normalizeRef, createVNode, emptyAppContext, uid, currentInstance, getCurrentInstance, internalSetCurrentInstance, setInSSRSetupState, setCurrentInstance, unsetCurrentInstance, isBuiltInTag, isInSSRComponentSetup, compile, installWithProxy, isRuntimeOnly, attrsProxyHandlers, classifyRE, classify, computed2, version, warn2, ErrorTypeStrings, devtools, setDevtoolsHook, _ssrUtils, ssrUtils, resolveFilter, compatUtils, DeprecationTypes;
  var init_runtime_core_esm_bundler = __esm({
    "node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js"() {
      init_reactivity_esm_bundler();
      init_reactivity_esm_bundler();
      init_shared_esm_bundler();
      init_shared_esm_bundler();
      /**
      * @vue/runtime-core v3.5.41
      * (c) 2018-present Yuxi (Evan) You and Vue contributors
      * @license MIT
      **/
      stack = [];
      isWarning = false;
      ErrorCodes = {
        "SETUP_FUNCTION": 0,
        "0": "SETUP_FUNCTION",
        "RENDER_FUNCTION": 1,
        "1": "RENDER_FUNCTION",
        "NATIVE_EVENT_HANDLER": 5,
        "5": "NATIVE_EVENT_HANDLER",
        "COMPONENT_EVENT_HANDLER": 6,
        "6": "COMPONENT_EVENT_HANDLER",
        "VNODE_HOOK": 7,
        "7": "VNODE_HOOK",
        "DIRECTIVE_HOOK": 8,
        "8": "DIRECTIVE_HOOK",
        "TRANSITION_HOOK": 9,
        "9": "TRANSITION_HOOK",
        "APP_ERROR_HANDLER": 10,
        "10": "APP_ERROR_HANDLER",
        "APP_WARN_HANDLER": 11,
        "11": "APP_WARN_HANDLER",
        "FUNCTION_REF": 12,
        "12": "FUNCTION_REF",
        "ASYNC_COMPONENT_LOADER": 13,
        "13": "ASYNC_COMPONENT_LOADER",
        "SCHEDULER": 14,
        "14": "SCHEDULER",
        "COMPONENT_UPDATE": 15,
        "15": "COMPONENT_UPDATE",
        "APP_UNMOUNT_CLEANUP": 16,
        "16": "APP_UNMOUNT_CLEANUP"
      };
      ErrorTypeStrings$1 = {
        ["sp"]: "serverPrefetch hook",
        ["bc"]: "beforeCreate hook",
        ["c"]: "created hook",
        ["bm"]: "beforeMount hook",
        ["m"]: "mounted hook",
        ["bu"]: "beforeUpdate hook",
        ["u"]: "updated",
        ["bum"]: "beforeUnmount hook",
        ["um"]: "unmounted hook",
        ["a"]: "activated hook",
        ["da"]: "deactivated hook",
        ["ec"]: "errorCaptured hook",
        ["rtc"]: "renderTracked hook",
        ["rtg"]: "renderTriggered hook",
        [0]: "setup function",
        [1]: "render function",
        [2]: "watcher getter",
        [3]: "watcher callback",
        [4]: "watcher cleanup function",
        [5]: "native event handler",
        [6]: "component event handler",
        [7]: "vnode hook",
        [8]: "directive hook",
        [9]: "transition hook",
        [10]: "app errorHandler",
        [11]: "app warnHandler",
        [12]: "ref function",
        [13]: "async component loader",
        [14]: "scheduler flush",
        [15]: "component update",
        [16]: "app unmount cleanup function"
      };
      queue = [];
      flushIndex = -1;
      pendingPostFlushCbs = [];
      activePostFlushCbs = null;
      postFlushIndex = 0;
      resolvedPromise = /* @__PURE__ */ Promise.resolve();
      currentFlushPromise = null;
      RECURSION_LIMIT = 100;
      getId = (job) => job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
      isHmrUpdating = false;
      setHmrUpdating = (v) => {
        try {
          return isHmrUpdating;
        } finally {
          isHmrUpdating = v;
        }
      };
      hmrDirtyComponents = /* @__PURE__ */ new Map();
      if (true) {
        getGlobalThis().__VUE_HMR_RUNTIME__ = {
          createRecord: tryWrap(createRecord),
          rerender: tryWrap(rerender),
          reload: tryWrap(reload)
        };
      }
      map = /* @__PURE__ */ new Map();
      buffer = [];
      devtoolsNotInstalled = false;
      devtoolsComponentAdded = /* @__PURE__ */ createDevtoolsComponentHook(
        "component:added"
        /* COMPONENT_ADDED */
      );
      devtoolsComponentUpdated = /* @__PURE__ */ createDevtoolsComponentHook(
        "component:updated"
        /* COMPONENT_UPDATED */
      );
      _devtoolsComponentRemoved = /* @__PURE__ */ createDevtoolsComponentHook(
        "component:removed"
        /* COMPONENT_REMOVED */
      );
      devtoolsComponentRemoved = (component) => {
        if (devtools$1 && typeof devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
        !devtools$1.cleanupBuffer(component)) {
          _devtoolsComponentRemoved(component);
        }
      };
      devtoolsPerfStart = /* @__PURE__ */ createDevtoolsPerformanceHook(
        "perf:start"
        /* PERFORMANCE_START */
      );
      devtoolsPerfEnd = /* @__PURE__ */ createDevtoolsPerformanceHook(
        "perf:end"
        /* PERFORMANCE_END */
      );
      currentRenderingInstance = null;
      currentScopeId = null;
      withScopeId = (_id) => withCtx;
      ssrContextKey = /* @__PURE__ */ Symbol.for("v-scx");
      useSSRContext = () => {
        {
          const ctx = inject(ssrContextKey);
          if (!ctx) {
            warn$1(
              `Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build.`
            );
          }
          return ctx;
        }
      };
      pendingMounts = /* @__PURE__ */ new WeakMap();
      TeleportEndKey = /* @__PURE__ */ Symbol("_vte");
      isTeleport = (type) => type.__isTeleport;
      isTeleportDisabled = (props) => props && (props.disabled || props.disabled === "");
      isTeleportDeferred = (props) => props && (props.defer || props.defer === "");
      isTargetSVG = (target) => typeof SVGElement !== "undefined" && target instanceof SVGElement;
      isTargetMathML = (target) => typeof MathMLElement === "function" && target instanceof MathMLElement;
      resolveTarget = (props, select) => {
        const targetSelector = props && props.to;
        if (isString(targetSelector)) {
          if (!select) {
            warn$1(
              `Current renderer does not support string target for Teleports. (missing querySelector renderer option)`
            );
            return null;
          } else {
            const target = select(targetSelector);
            if (!target && !isTeleportDisabled(props)) {
              warn$1(
                `Failed to locate Teleport target with selector "${targetSelector}". Note the target element must exist before the component is mounted - i.e. the target cannot be rendered by the component itself, and ideally should be outside of the entire Vue component tree.`
              );
            }
            return target;
          }
        } else {
          if (!targetSelector && !isTeleportDisabled(props)) {
            warn$1(`Invalid Teleport target: ${targetSelector}`);
          }
          return targetSelector;
        }
      };
      TeleportImpl = {
        name: "Teleport",
        __isTeleport: true,
        process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
          const {
            mc: mountChildren,
            pc: patchChildren,
            pbc: patchBlockChildren,
            o: { insert, querySelector, createText, createComment, parentNode }
          } = internals;
          const disabled2 = isTeleportDisabled(n2.props);
          let { dynamicChildren } = n2;
          if (isHmrUpdating) {
            optimized = false;
            dynamicChildren = null;
          }
          const mount = (vnode, container2, anchor2) => {
            if (vnode.shapeFlag & 16) {
              mountChildren(
                vnode.children,
                container2,
                anchor2,
                parentComponent,
                parentSuspense,
                namespace,
                slotScopeIds,
                optimized
              );
            }
          };
          const mountToTarget = (vnode = n2) => {
            const disabled22 = isTeleportDisabled(vnode.props);
            const target = vnode.target = resolveTarget(vnode.props, querySelector);
            const targetAnchor = prepareAnchor(target, vnode, createText, insert);
            if (target) {
              if (namespace !== "svg" && isTargetSVG(target)) {
                namespace = "svg";
              } else if (namespace !== "mathml" && isTargetMathML(target)) {
                namespace = "mathml";
              }
              if (parentComponent && parentComponent.isCE) {
                (parentComponent.ce._teleportTargets || (parentComponent.ce._teleportTargets = /* @__PURE__ */ new Set())).add(target);
              }
              if (!disabled22) {
                mount(vnode, target, targetAnchor);
                updateCssVars(vnode, false);
              }
            } else if (!disabled22) {
              warn$1("Invalid Teleport target on mount:", target, `(${typeof target})`);
            }
          };
          const queuePendingMount = (vnode) => {
            const mountJob = () => {
              if (pendingMounts.get(vnode) !== mountJob) return;
              pendingMounts.delete(vnode);
              if (isTeleportDisabled(vnode.props)) {
                const mountContainer = parentNode(vnode.el) || container;
                mount(vnode, mountContainer, vnode.anchor);
                updateCssVars(vnode, true);
              }
              mountToTarget(vnode);
            };
            pendingMounts.set(vnode, mountJob);
            queuePostRenderEffect(mountJob, parentSuspense);
          };
          if (n1 == null) {
            const placeholder = n2.el = true ? createComment("teleport start") : createText("");
            const mainAnchor = n2.anchor = true ? createComment("teleport end") : createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            if (isTeleportDeferred(n2.props) || parentSuspense && parentSuspense.pendingBranch) {
              queuePendingMount(n2);
              return;
            }
            if (disabled2) {
              mount(n2, container, mainAnchor);
              updateCssVars(n2, true);
            }
            mountToTarget();
          } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const pendingMount = pendingMounts.get(n1);
            if (pendingMount) {
              pendingMount.flags |= 8;
              pendingMounts.delete(n1);
              queuePendingMount(n2);
              return;
            }
            n2.targetStart = n1.targetStart;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || isTargetSVG(target)) {
              namespace = "svg";
            } else if (namespace === "mathml" || isTargetMathML(target)) {
              namespace = "mathml";
            }
            if (dynamicChildren) {
              patchBlockChildren(
                n1.dynamicChildren,
                dynamicChildren,
                currentContainer,
                parentComponent,
                parentSuspense,
                namespace,
                slotScopeIds
              );
              traverseStaticChildren(n1, n2, false);
            } else if (!optimized) {
              patchChildren(
                n1,
                n2,
                currentContainer,
                currentAnchor,
                parentComponent,
                parentSuspense,
                namespace,
                slotScopeIds,
                false
              );
            }
            if (disabled2) {
              if (!wasDisabled) {
                moveTeleport(
                  n2,
                  container,
                  mainAnchor,
                  internals,
                  1
                );
              } else {
                if (n2.props && n1.props && n2.props.to !== n1.props.to) {
                  n2.props.to = n1.props.to;
                }
              }
            } else {
              if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                const nextTarget = resolveTarget(n2.props, querySelector);
                if (nextTarget) {
                  n2.target = nextTarget;
                  moveTeleport(
                    n2,
                    nextTarget,
                    null,
                    internals,
                    0
                  );
                } else if (true) {
                  warn$1(
                    "Invalid Teleport target on update:",
                    target,
                    `(${typeof target})`
                  );
                }
              } else if (wasDisabled) {
                moveTeleport(
                  n2,
                  target,
                  targetAnchor,
                  internals,
                  1
                );
              }
            }
            updateCssVars(n2, disabled2);
          }
        },
        remove(vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
          const {
            shapeFlag,
            children,
            anchor,
            targetStart,
            targetAnchor,
            target,
            props
          } = vnode;
          const disabled2 = isTeleportDisabled(props);
          const shouldRemove = doRemove || !disabled2;
          const pendingMount = pendingMounts.get(vnode);
          if (pendingMount) {
            pendingMount.flags |= 8;
            pendingMounts.delete(vnode);
          }
          if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
          }
          doRemove && hostRemove(anchor);
          if (!pendingMount && (disabled2 || target) && shapeFlag & 16) {
            for (let i2 = 0; i2 < children.length; i2++) {
              const child = children[i2];
              unmount(
                child,
                parentComponent,
                parentSuspense,
                shouldRemove,
                !!child.dynamicChildren
              );
            }
          }
        },
        move: moveTeleport,
        hydrate: hydrateTeleport
      };
      Teleport = TeleportImpl;
      leaveCbKey = /* @__PURE__ */ Symbol("_leaveCb");
      enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
      TransitionHookValidator = [Function, Array];
      BaseTransitionPropsValidators = {
        mode: String,
        appear: Boolean,
        persisted: Boolean,
        // enter
        onBeforeEnter: TransitionHookValidator,
        onEnter: TransitionHookValidator,
        onAfterEnter: TransitionHookValidator,
        onEnterCancelled: TransitionHookValidator,
        // leave
        onBeforeLeave: TransitionHookValidator,
        onLeave: TransitionHookValidator,
        onAfterLeave: TransitionHookValidator,
        onLeaveCancelled: TransitionHookValidator,
        // appear
        onBeforeAppear: TransitionHookValidator,
        onAppear: TransitionHookValidator,
        onAfterAppear: TransitionHookValidator,
        onAppearCancelled: TransitionHookValidator
      };
      recursiveGetSubtree = (instance) => {
        const subTree = instance.subTree;
        return subTree.component ? recursiveGetSubtree(subTree.component) : subTree;
      };
      BaseTransitionImpl = {
        name: `BaseTransition`,
        props: BaseTransitionPropsValidators,
        setup(props, { slots }) {
          const instance = getCurrentInstance();
          const state4 = useTransitionState();
          return () => {
            const children = slots.default && getTransitionRawChildren(slots.default(), true);
            const child = children && children.length ? findNonCommentChild(children) : (
              // Keep explicit default-slot conditionals on the same transition path
              // as regular v-if branches, which render a comment placeholder.
              instance.subTree ? createCommentVNode() : void 0
            );
            if (!child) {
              return;
            }
            const rawProps = toRaw(props);
            const { mode } = rawProps;
            if (mode && mode !== "in-out" && mode !== "out-in" && mode !== "default") {
              warn$1(`invalid <transition> mode: ${mode}`);
            }
            if (state4.isLeaving) {
              return emptyPlaceholder(child);
            }
            const innerChild = getInnerChild$1(child);
            if (!innerChild) {
              return emptyPlaceholder(child);
            }
            let enterHooks = resolveTransitionHooks(
              innerChild,
              rawProps,
              state4,
              instance,
              // #11061, ensure enterHooks is fresh after clone
              (hooks) => enterHooks = hooks
            );
            if (innerChild.type !== Comment) {
              setTransitionHooks(innerChild, enterHooks);
            }
            let oldInnerChild = instance.subTree && getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== Comment && !isSameVNodeType(oldInnerChild, innerChild) && recursiveGetSubtree(instance).type !== Comment) {
              let leavingHooks = resolveTransitionHooks(
                oldInnerChild,
                rawProps,
                state4,
                instance
              );
              setTransitionHooks(oldInnerChild, leavingHooks);
              if (mode === "out-in" && innerChild.type !== Comment) {
                state4.isLeaving = true;
                leavingHooks.afterLeave = () => {
                  state4.isLeaving = false;
                  if (!(instance.job.flags & 8)) {
                    instance.update();
                  }
                  delete leavingHooks.afterLeave;
                  oldInnerChild = void 0;
                };
                return emptyPlaceholder(child);
              } else if (mode === "in-out" && innerChild.type !== Comment) {
                leavingHooks.delayLeave = (el, earlyRemove, delayedLeave) => {
                  const leavingVNodesCache = getLeavingNodesForType(
                    state4,
                    oldInnerChild
                  );
                  leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                  el[leaveCbKey] = () => {
                    earlyRemove();
                    el[leaveCbKey] = void 0;
                    delete enterHooks.delayedLeave;
                    oldInnerChild = void 0;
                  };
                  enterHooks.delayedLeave = () => {
                    delayedLeave();
                    delete enterHooks.delayedLeave;
                    oldInnerChild = void 0;
                  };
                };
              } else {
                oldInnerChild = void 0;
              }
            } else if (oldInnerChild) {
              oldInnerChild = void 0;
            }
            return child;
          };
        }
      };
      BaseTransition = BaseTransitionImpl;
      knownTemplateRefs = /* @__PURE__ */ new WeakSet();
      pendingSetRefMap = /* @__PURE__ */ new WeakMap();
      hasLoggedMismatchError = false;
      logMismatchError = () => {
        if (hasLoggedMismatchError) {
          return;
        }
        console.error("Hydration completed but contains mismatches.");
        hasLoggedMismatchError = true;
      };
      isSVGContainer = (container) => container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
      isMathMLContainer = (container) => container.namespaceURI.includes("MathML");
      getContainerType = (container) => {
        if (container.nodeType !== 1) return void 0;
        if (isSVGContainer(container)) return "svg";
        if (isMathMLContainer(container)) return "mathml";
        return void 0;
      };
      isComment = (node) => node.nodeType === 8;
      resourceProps = /* @__PURE__ */ new Set(["src", "srcset", "href", "poster"]);
      allowMismatchAttr = "data-allow-mismatch";
      MismatchTypeString = {
        [
          0
          /* TEXT */
        ]: "text",
        [
          1
          /* CHILDREN */
        ]: "children",
        [
          2
          /* CLASS */
        ]: "class",
        [
          3
          /* STYLE */
        ]: "style",
        [
          4
          /* ATTRIBUTE */
        ]: "attribute"
      };
      requestIdleCallback = getGlobalThis().requestIdleCallback || ((cb) => setTimeout(cb, 1));
      cancelIdleCallback = getGlobalThis().cancelIdleCallback || ((id) => clearTimeout(id));
      hydrateOnIdle = (timeout = 1e4) => (hydrate2) => {
        const id = requestIdleCallback(hydrate2, { timeout });
        return () => cancelIdleCallback(id);
      };
      hydrateOnVisible = (opts) => (hydrate2, forEach2) => {
        const ob = new IntersectionObserver((entries) => {
          for (const e of entries) {
            if (!e.isIntersecting) continue;
            ob.disconnect();
            hydrate2();
            break;
          }
        }, opts);
        forEach2((el) => {
          if (!(el instanceof Element)) return;
          if (elementIsVisibleInViewport(el)) {
            hydrate2();
            ob.disconnect();
            return false;
          }
          ob.observe(el);
        });
        return () => ob.disconnect();
      };
      hydrateOnMediaQuery = (query) => (hydrate2) => {
        if (query) {
          const mql = matchMedia(query);
          if (mql.matches) {
            hydrate2();
          } else {
            mql.addEventListener("change", hydrate2, { once: true });
            return () => mql.removeEventListener("change", hydrate2);
          }
        }
      };
      hydrateOnInteraction = (interactions = []) => (hydrate2, forEach2) => {
        if (isString(interactions)) interactions = [interactions];
        let hasHydrated = false;
        const doHydrate = (e) => {
          if (!hasHydrated) {
            hasHydrated = true;
            teardown();
            hydrate2();
            e.target.dispatchEvent(new e.constructor(e.type, e));
          }
        };
        const teardown = () => {
          forEach2((el) => {
            for (const i2 of interactions) {
              el.removeEventListener(i2, doHydrate);
            }
          });
        };
        forEach2((el) => {
          for (const i2 of interactions) {
            el.addEventListener(i2, doHydrate, { once: true });
          }
        });
        return teardown;
      };
      isAsyncWrapper = (i2) => !!i2.type.__asyncLoader;
      isKeepAlive = (vnode) => vnode.type.__isKeepAlive;
      KeepAliveImpl = {
        name: `KeepAlive`,
        // Marker for special handling inside the renderer. We are not using a ===
        // check directly on KeepAlive in the renderer, because importing it directly
        // would prevent it from being tree-shaken.
        __isKeepAlive: true,
        props: {
          include: [String, RegExp, Array],
          exclude: [String, RegExp, Array],
          max: [String, Number]
        },
        setup(props, { slots }) {
          const instance = getCurrentInstance();
          const sharedContext = instance.ctx;
          if (!sharedContext.renderer) {
            return () => {
              const children = slots.default && slots.default();
              return children && children.length === 1 ? children[0] : children;
            };
          }
          const cache = /* @__PURE__ */ new Map();
          const keys = /* @__PURE__ */ new Set();
          let current = null;
          if (true) {
            instance.__v_cache = cache;
          }
          const parentSuspense = instance.suspense;
          const {
            renderer: {
              p: patch,
              m: move,
              um: _unmount,
              o: { createElement }
            }
          } = sharedContext;
          const storageContainer = createElement("div");
          sharedContext.activate = (vnode, container, anchor, namespace, optimized) => {
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(
              instance2.vnode,
              vnode,
              container,
              anchor,
              instance2,
              parentSuspense,
              namespace,
              vnode.slotScopeIds,
              optimized
            );
            queuePostRenderEffect(() => {
              instance2.isDeactivated = false;
              if (instance2.a) {
                invokeArrayFns(instance2.a);
              }
              const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
              if (vnodeHook) {
                invokeVNodeHook(vnodeHook, instance2.parent, vnode);
              }
            }, parentSuspense);
            if (true) {
              devtoolsComponentAdded(instance2);
            }
          };
          sharedContext.deactivate = (vnode) => {
            const instance2 = vnode.component;
            invalidateMount(instance2.m);
            invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            queuePostRenderEffect(() => {
              if (instance2.da) {
                invokeArrayFns(instance2.da);
              }
              const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
              if (vnodeHook) {
                invokeVNodeHook(vnodeHook, instance2.parent, vnode);
              }
              instance2.isDeactivated = true;
            }, parentSuspense);
            if (true) {
              devtoolsComponentAdded(instance2);
            }
            if (true) {
              instance2.__keepAliveStorageContainer = storageContainer;
            }
          };
          function unmount(vnode) {
            resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
          }
          function pruneCache(filter5) {
            cache.forEach((vnode, key) => {
              const name = getComponentName(
                isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : vnode.type
              );
              if (name && !filter5(name)) {
                pruneCacheEntry(key);
              }
            });
          }
          function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !isSameVNodeType(cached, current))) {
              unmount(cached);
            } else if (current) {
              resetShapeFlag(current);
            }
            cache.delete(key);
            keys.delete(key);
          }
          watch2(
            () => [props.include, props.exclude],
            ([include, exclude]) => {
              include && pruneCache((name) => matches(include, name));
              exclude && pruneCache((name) => !matches(exclude, name));
            },
            // prune post-render after `current` has been updated
            { flush: "post", deep: true }
          );
          let pendingCacheKey = null;
          const cacheSubtree = () => {
            if (pendingCacheKey != null) {
              if (isSuspense(instance.subTree.type)) {
                queuePostRenderEffect(() => {
                  cache.set(pendingCacheKey, getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
              } else {
                cache.set(pendingCacheKey, getInnerChild(instance.subTree));
              }
            }
          };
          onMounted(cacheSubtree);
          onUpdated(cacheSubtree);
          onBeforeUnmount(() => {
            cache.forEach((cached) => {
              const { subTree, suspense } = instance;
              const vnode = getInnerChild(subTree);
              if (cached.type === vnode.type && cached.key === vnode.key) {
                resetShapeFlag(vnode);
                const da = vnode.component.da;
                da && queuePostRenderEffect(da, suspense);
                return;
              }
              unmount(cached);
            });
          });
          return () => {
            pendingCacheKey = null;
            if (!slots.default) {
              return current = null;
            }
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
              if (true) {
                warn$1(`KeepAlive should contain exactly one component child.`);
              }
              current = null;
              return children;
            } else if (!isVNode(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
              current = null;
              return rawVNode;
            }
            let vnode = getInnerChild(rawVNode);
            if (vnode.type === Comment) {
              current = null;
              return vnode;
            }
            const comp = vnode.type;
            const name = getComponentName(
              isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp
            );
            const { include, exclude, max } = props;
            if (include && (!name || !matches(include, name)) || exclude && name && matches(exclude, name)) {
              vnode.shapeFlag &= -257;
              current = vnode;
              return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
              vnode = cloneVNode(vnode);
              if (rawVNode.shapeFlag & 128) {
                rawVNode.ssContent = vnode;
              }
            }
            pendingCacheKey = key;
            if (cachedVNode) {
              vnode.el = cachedVNode.el;
              vnode.component = cachedVNode.component;
              if (vnode.transition) {
                setTransitionHooks(vnode, vnode.transition);
              }
              vnode.shapeFlag |= 512;
              keys.delete(key);
              keys.add(key);
            } else {
              keys.add(key);
              if (max && keys.size > parseInt(max, 10)) {
                pruneCacheEntry(keys.values().next().value);
              }
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return isSuspense(rawVNode.type) ? rawVNode : vnode;
          };
        }
      };
      KeepAlive = KeepAliveImpl;
      createHook = (lifecycle) => (hook, target = currentInstance) => {
        if (!isInSSRComponentSetup || lifecycle === "sp") {
          injectHook(lifecycle, (...args) => hook(...args), target);
        }
      };
      onBeforeMount = createHook("bm");
      onMounted = createHook("m");
      onBeforeUpdate = createHook(
        "bu"
      );
      onUpdated = createHook("u");
      onBeforeUnmount = createHook(
        "bum"
      );
      onUnmounted = createHook("um");
      onServerPrefetch = createHook(
        "sp"
      );
      onRenderTriggered = createHook("rtg");
      onRenderTracked = createHook("rtc");
      COMPONENTS = "components";
      DIRECTIVES = "directives";
      NULL_DYNAMIC_COMPONENT = /* @__PURE__ */ Symbol.for("v-ndc");
      getPublicInstance = (i2) => {
        if (!i2) return null;
        if (isStatefulComponent(i2)) return getComponentPublicInstance(i2);
        return getPublicInstance(i2.parent);
      };
      publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
      // due to type annotation
      /* @__PURE__ */ extend(/* @__PURE__ */ Object.create(null), {
        $: (i2) => i2,
        $el: (i2) => i2.vnode.el,
        $data: (i2) => i2.data,
        $props: (i2) => true ? shallowReadonly(i2.props) : i2.props,
        $attrs: (i2) => true ? shallowReadonly(i2.attrs) : i2.attrs,
        $slots: (i2) => true ? shallowReadonly(i2.slots) : i2.slots,
        $refs: (i2) => true ? shallowReadonly(i2.refs) : i2.refs,
        $parent: (i2) => getPublicInstance(i2.parent),
        $root: (i2) => getPublicInstance(i2.root),
        $host: (i2) => i2.ce,
        $emit: (i2) => i2.emit,
        $options: (i2) => true ? resolveMergedOptions(i2) : i2.type,
        $forceUpdate: (i2) => i2.f || (i2.f = () => {
          queueJob(i2.update);
        }),
        $nextTick: (i2) => i2.n || (i2.n = nextTick.bind(i2.proxy)),
        $watch: (i2) => true ? instanceWatch.bind(i2) : NOOP
      });
      isReservedPrefix = (key) => key === "_" || key === "$";
      hasSetupBinding = (state4, key) => state4 !== EMPTY_OBJ && !state4.__isScriptSetup && hasOwn(state4, key);
      PublicInstanceProxyHandlers = {
        get({ _: instance }, key) {
          if (key === "__v_skip") {
            return true;
          }
          const { ctx, setupState, data, props, accessCache, type, appContext } = instance;
          if (key === "__isVue") {
            return true;
          }
          if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) {
              switch (n) {
                case 1:
                  return setupState[key];
                case 2:
                  return data[key];
                case 4:
                  return ctx[key];
                case 3:
                  return props[key];
              }
            } else if (hasSetupBinding(setupState, key)) {
              accessCache[key] = 1;
              return setupState[key];
            } else if (data !== EMPTY_OBJ && hasOwn(data, key)) {
              accessCache[key] = 2;
              return data[key];
            } else if (hasOwn(props, key)) {
              accessCache[key] = 3;
              return props[key];
            } else if (ctx !== EMPTY_OBJ && hasOwn(ctx, key)) {
              accessCache[key] = 4;
              return ctx[key];
            } else if (shouldCacheAccess) {
              accessCache[key] = 0;
            }
          }
          const publicGetter = publicPropertiesMap[key];
          let cssModule, globalProperties;
          if (publicGetter) {
            if (key === "$attrs") {
              track(instance.attrs, "get", "");
              markAttrsAccessed();
            } else if (key === "$slots") {
              track(instance, "get", key);
            }
            return publicGetter(instance);
          } else if (
            // css module (injected by vue-loader)
            (cssModule = type.__cssModules) && (cssModule = cssModule[key])
          ) {
            return cssModule;
          } else if (ctx !== EMPTY_OBJ && hasOwn(ctx, key)) {
            accessCache[key] = 4;
            return ctx[key];
          } else if (
            // global properties
            globalProperties = appContext.config.globalProperties, hasOwn(globalProperties, key)
          ) {
            {
              return globalProperties[key];
            }
          } else if (currentRenderingInstance && (!isString(key) || // #1091 avoid internal isRef/isVNode checks on component instance leading
          // to infinite warning loop
          key.indexOf("__v") !== 0)) {
            if (data !== EMPTY_OBJ && isReservedPrefix(key[0]) && hasOwn(data, key)) {
              warn$1(
                `Property ${JSON.stringify(
                  key
                )} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`
              );
            } else if (instance === currentRenderingInstance) {
              warn$1(
                `Property ${JSON.stringify(key)} was accessed during render but is not defined on instance.`
              );
            }
          }
        },
        set({ _: instance }, key, value) {
          const { data, setupState, ctx } = instance;
          if (hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
          } else if (setupState.__isScriptSetup && hasOwn(setupState, key)) {
            warn$1(`Cannot mutate <script setup> binding "${key}" from Options API.`);
            return false;
          } else if (data !== EMPTY_OBJ && hasOwn(data, key)) {
            data[key] = value;
            return true;
          } else if (hasOwn(instance.props, key)) {
            warn$1(`Attempting to mutate prop "${key}". Props are readonly.`);
            return false;
          }
          if (key[0] === "$" && key.slice(1) in instance) {
            warn$1(
              `Attempting to mutate public property "${key}". Properties starting with $ are reserved and readonly.`
            );
            return false;
          } else {
            if (key in instance.appContext.config.globalProperties) {
              Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                value
              });
            } else {
              ctx[key] = value;
            }
          }
          return true;
        },
        has({
          _: { data, setupState, accessCache, ctx, appContext, props, type }
        }, key) {
          let cssModules;
          return !!(accessCache[key] || data !== EMPTY_OBJ && key[0] !== "$" && hasOwn(data, key) || hasSetupBinding(setupState, key) || hasOwn(props, key) || hasOwn(ctx, key) || hasOwn(publicPropertiesMap, key) || hasOwn(appContext.config.globalProperties, key) || (cssModules = type.__cssModules) && cssModules[key]);
        },
        defineProperty(target, key, descriptor) {
          if (descriptor.get != null) {
            target._.accessCache[key] = 0;
          } else if (hasOwn(descriptor, "value")) {
            this.set(target, key, descriptor.value, null);
          }
          return Reflect.defineProperty(target, key, descriptor);
        }
      };
      if (true) {
        PublicInstanceProxyHandlers.ownKeys = (target) => {
          warn$1(
            `Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead.`
          );
          return Reflect.ownKeys(target);
        };
      }
      RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ extend({}, PublicInstanceProxyHandlers, {
        get(target, key) {
          if (key === Symbol.unscopables) {
            return;
          }
          return PublicInstanceProxyHandlers.get(target, key, target);
        },
        has(_2, key) {
          const has = key[0] !== "_" && !isGloballyAllowed(key);
          if (!has && PublicInstanceProxyHandlers.has(_2, key)) {
            warn$1(
              `Property ${JSON.stringify(
                key
              )} should not start with _ which is a reserved prefix for Vue internals.`
            );
          }
          return has;
        }
      });
      warnRuntimeUsage = (method) => warn$1(
        `${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`
      );
      shouldCacheAccess = true;
      internalOptionMergeStrats = {
        data: mergeDataFn,
        props: mergeEmitsOrPropsOptions,
        emits: mergeEmitsOrPropsOptions,
        // objects
        methods: mergeObjectOptions,
        computed: mergeObjectOptions,
        // lifecycle
        beforeCreate: mergeAsArray,
        created: mergeAsArray,
        beforeMount: mergeAsArray,
        mounted: mergeAsArray,
        beforeUpdate: mergeAsArray,
        updated: mergeAsArray,
        beforeDestroy: mergeAsArray,
        beforeUnmount: mergeAsArray,
        destroyed: mergeAsArray,
        unmounted: mergeAsArray,
        activated: mergeAsArray,
        deactivated: mergeAsArray,
        errorCaptured: mergeAsArray,
        serverPrefetch: mergeAsArray,
        // assets
        components: mergeObjectOptions,
        directives: mergeObjectOptions,
        // watch
        watch: mergeWatchOptions,
        // provide / inject
        provide: mergeDataFn,
        inject: mergeInject
      };
      uid$1 = 0;
      currentApp = null;
      getModelModifiers = (props, modelName) => {
        return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${camelize(modelName)}Modifiers`] || props[`${hyphenate(modelName)}Modifiers`];
      };
      mixinEmitsCache = /* @__PURE__ */ new WeakMap();
      accessedAttrs = false;
      getChildRoot = (vnode) => {
        const rawChildren = vnode.children;
        const dynamicChildren = vnode.dynamicChildren;
        const childRoot = filterSingleRoot(rawChildren, false);
        if (!childRoot) {
          return [vnode, void 0];
        } else if (childRoot.patchFlag > 0 && childRoot.patchFlag & 2048) {
          return getChildRoot(childRoot);
        }
        const index = rawChildren.indexOf(childRoot);
        const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
        const setRoot = (updatedRoot) => {
          rawChildren[index] = updatedRoot;
          if (dynamicChildren) {
            if (dynamicIndex > -1) {
              dynamicChildren[dynamicIndex] = updatedRoot;
            } else if (updatedRoot.patchFlag > 0) {
              vnode.dynamicChildren = [...dynamicChildren, updatedRoot];
            }
          }
        };
        return [normalizeVNode(childRoot), setRoot];
      };
      getFunctionalFallthrough = (attrs) => {
        let res;
        for (const key in attrs) {
          if (key === "class" || key === "style" || isOn(key)) {
            (res || (res = {}))[key] = attrs[key];
          }
        }
        return res;
      };
      filterModelListeners = (attrs, props) => {
        const res = {};
        for (const key in attrs) {
          if (!isModelListener(key) || !(key.slice(9) in props)) {
            res[key] = attrs[key];
          }
        }
        return res;
      };
      isElementRoot = (vnode) => {
        return vnode.shapeFlag & (6 | 1) || vnode.type === Comment;
      };
      internalObjectProto = {};
      createInternalObject = () => Object.create(internalObjectProto);
      isInternalObject = (obj) => Object.getPrototypeOf(obj) === internalObjectProto;
      mixinPropsCache = /* @__PURE__ */ new WeakMap();
      isSimpleType = /* @__PURE__ */ makeMap(
        "String,Number,Boolean,Function,Symbol,BigInt"
      );
      isInternalKey = (key) => key === "_" || key === "_ctx" || key === "$stable";
      normalizeSlotValue = (value) => isArray(value) ? value.map(normalizeVNode) : [normalizeVNode(value)];
      normalizeSlot = (key, rawSlot, ctx) => {
        if (rawSlot._n) {
          return rawSlot;
        }
        const normalized = withCtx((...args) => {
          if (currentInstance && !(ctx === null && currentRenderingInstance) && !(ctx && ctx.root !== currentInstance.root)) {
            warn$1(
              `Slot "${key}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`
            );
          }
          return normalizeSlotValue(rawSlot(...args));
        }, ctx);
        normalized._c = false;
        return normalized;
      };
      normalizeObjectSlots = (rawSlots, slots, instance) => {
        const ctx = rawSlots._ctx;
        for (const key in rawSlots) {
          if (isInternalKey(key)) continue;
          const value = rawSlots[key];
          if (isFunction(value)) {
            slots[key] = normalizeSlot(key, value, ctx);
          } else if (value != null) {
            if (true) {
              warn$1(
                `Non-function value encountered for slot "${key}". Prefer function slots for better performance.`
              );
            }
            const normalized = normalizeSlotValue(value);
            slots[key] = () => normalized;
          }
        }
      };
      normalizeVNodeSlots = (instance, children) => {
        if (!isKeepAlive(instance.vnode) && true) {
          warn$1(
            `Non-function value encountered for default slot. Prefer function slots for better performance.`
          );
        }
        const normalized = normalizeSlotValue(children);
        instance.slots.default = () => normalized;
      };
      assignSlots = (slots, children, optimized) => {
        for (const key in children) {
          if (optimized || !isInternalKey(key)) {
            slots[key] = children[key];
          }
        }
      };
      initSlots = (instance, children, optimized) => {
        const slots = instance.slots = createInternalObject();
        if (instance.vnode.shapeFlag & 32) {
          const type = children._;
          if (type) {
            assignSlots(slots, children, optimized);
            if (optimized) {
              def(slots, "_", type, true);
            }
          } else {
            normalizeObjectSlots(children, slots);
          }
        } else if (children) {
          normalizeVNodeSlots(instance, children);
        }
      };
      updateSlots = (instance, children, optimized) => {
        const { vnode, slots } = instance;
        let needDeletionCheck = true;
        let deletionComparisonTarget = EMPTY_OBJ;
        if (vnode.shapeFlag & 32) {
          const type = children._;
          if (type) {
            if (isHmrUpdating) {
              assignSlots(slots, children, optimized);
              trigger(instance, "set", "$slots");
            } else if (optimized && type === 1) {
              needDeletionCheck = false;
            } else {
              assignSlots(slots, children, optimized);
            }
          } else {
            needDeletionCheck = !children.$stable;
            normalizeObjectSlots(children, slots);
          }
          deletionComparisonTarget = children;
        } else if (children) {
          normalizeVNodeSlots(instance, children);
          deletionComparisonTarget = { default: 1 };
        }
        if (needDeletionCheck) {
          for (const key in slots) {
            if (!isInternalKey(key) && deletionComparisonTarget[key] == null) {
              delete slots[key];
            }
          }
        }
      };
      queuePostRenderEffect = queueEffectWithSuspense;
      isSuspense = (type) => type.__isSuspense;
      suspenseId = 0;
      SuspenseImpl = {
        name: "Suspense",
        // In order to make Suspense tree-shakable, we need to avoid importing it
        // directly in the renderer. The renderer checks for the __isSuspense flag
        // on a vnode's type and calls the `process` method, passing in renderer
        // internals.
        __isSuspense: true,
        process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
          if (n1 == null) {
            mountSuspense(
              n2,
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized,
              rendererInternals
            );
          } else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
              n2.suspense = n1.suspense;
              n2.suspense.vnode = n2;
              n2.el = n1.el;
              return;
            }
            patchSuspense(
              n1,
              n2,
              container,
              anchor,
              parentComponent,
              namespace,
              slotScopeIds,
              optimized,
              rendererInternals
            );
          }
        },
        hydrate: hydrateSuspense,
        normalize: normalizeSuspenseChildren
      };
      Suspense = SuspenseImpl;
      hasWarned = false;
      Fragment = /* @__PURE__ */ Symbol.for("v-fgt");
      Text = /* @__PURE__ */ Symbol.for("v-txt");
      Comment = /* @__PURE__ */ Symbol.for("v-cmt");
      Static = /* @__PURE__ */ Symbol.for("v-stc");
      blockStack = [];
      currentBlock = null;
      isBlockTreeEnabled = 1;
      createVNodeWithArgsTransform = (...args) => {
        return _createVNode(
          ...vnodeArgsTransformer ? vnodeArgsTransformer(args, currentRenderingInstance) : args
        );
      };
      normalizeKey = ({ key }) => key != null ? key : null;
      normalizeRef = ({
        ref: ref2,
        ref_key,
        ref_for
      }) => {
        if (typeof ref2 === "number") {
          ref2 = "" + ref2;
        }
        return ref2 != null ? isString(ref2) || isRef2(ref2) || isFunction(ref2) ? { i: currentRenderingInstance, r: ref2, k: ref_key, f: !!ref_for } : ref2 : null;
      };
      createVNode = true ? createVNodeWithArgsTransform : _createVNode;
      emptyAppContext = createAppContext();
      uid = 0;
      currentInstance = null;
      getCurrentInstance = () => currentInstance || currentRenderingInstance;
      {
        const g = getGlobalThis();
        const registerGlobalSetter = (key, setter) => {
          let setters;
          if (!(setters = g[key])) setters = g[key] = [];
          setters.push(setter);
          return (v) => {
            if (setters.length > 1) setters.forEach((set) => set(v));
            else setters[0](v);
          };
        };
        internalSetCurrentInstance = registerGlobalSetter(
          `__VUE_INSTANCE_SETTERS__`,
          (v) => currentInstance = v
        );
        setInSSRSetupState = registerGlobalSetter(
          `__VUE_SSR_SETTERS__`,
          (v) => isInSSRComponentSetup = v
        );
      }
      setCurrentInstance = (instance) => {
        const prev = currentInstance;
        internalSetCurrentInstance(instance);
        instance.scope.on();
        return () => {
          instance.scope.off();
          internalSetCurrentInstance(prev);
        };
      };
      unsetCurrentInstance = () => {
        currentInstance && currentInstance.scope.off();
        internalSetCurrentInstance(null);
      };
      isBuiltInTag = /* @__PURE__ */ makeMap("slot,component");
      isInSSRComponentSetup = false;
      isRuntimeOnly = () => !compile;
      attrsProxyHandlers = true ? {
        get(target, key) {
          markAttrsAccessed();
          track(target, "get", "");
          return target[key];
        },
        set() {
          warn$1(`setupContext.attrs is readonly.`);
          return false;
        },
        deleteProperty() {
          warn$1(`setupContext.attrs is readonly.`);
          return false;
        }
      } : {
        get(target, key) {
          track(target, "get", "");
          return target[key];
        }
      };
      classifyRE = /(?:^|[-_])\w/g;
      classify = (str) => str.replace(classifyRE, (c) => c.toUpperCase()).replace(/[-_]/g, "");
      computed2 = (getterOrOptions, debugOptions) => {
        const c = computed(getterOrOptions, debugOptions, isInSSRComponentSetup);
        if (true) {
          const i2 = getCurrentInstance();
          if (i2 && i2.appContext.config.warnRecursiveComputed) {
            c._warnRecursive = true;
          }
        }
        return c;
      };
      version = "3.5.41";
      warn2 = true ? warn$1 : NOOP;
      ErrorTypeStrings = ErrorTypeStrings$1;
      devtools = true ? devtools$1 : void 0;
      setDevtoolsHook = true ? setDevtoolsHook$1 : NOOP;
      _ssrUtils = {
        createComponentInstance,
        setupComponent,
        renderComponentRoot,
        setCurrentRenderingInstance,
        isVNode,
        normalizeVNode,
        getComponentPublicInstance,
        ensureValidVNode,
        pushWarningContext,
        popWarningContext
      };
      ssrUtils = _ssrUtils;
      resolveFilter = null;
      compatUtils = null;
      DeprecationTypes = null;
    }
  });

  // node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js
  var runtime_dom_esm_bundler_exports = {};
  __export(runtime_dom_esm_bundler_exports, {
    BaseTransition: () => BaseTransition,
    BaseTransitionPropsValidators: () => BaseTransitionPropsValidators,
    Comment: () => Comment,
    DeprecationTypes: () => DeprecationTypes,
    EffectScope: () => EffectScope,
    ErrorCodes: () => ErrorCodes,
    ErrorTypeStrings: () => ErrorTypeStrings,
    Fragment: () => Fragment,
    KeepAlive: () => KeepAlive,
    ReactiveEffect: () => ReactiveEffect,
    Static: () => Static,
    Suspense: () => Suspense,
    Teleport: () => Teleport,
    Text: () => Text,
    TrackOpTypes: () => TrackOpTypes,
    Transition: () => Transition,
    TransitionGroup: () => TransitionGroup,
    TriggerOpTypes: () => TriggerOpTypes,
    VueElement: () => VueElement,
    assertNumber: () => assertNumber,
    callWithAsyncErrorHandling: () => callWithAsyncErrorHandling,
    callWithErrorHandling: () => callWithErrorHandling,
    camelize: () => camelize,
    capitalize: () => capitalize,
    cloneVNode: () => cloneVNode,
    compatUtils: () => compatUtils,
    computed: () => computed2,
    createApp: () => createApp,
    createBlock: () => createBlock,
    createCommentVNode: () => createCommentVNode,
    createElementBlock: () => createElementBlock,
    createElementVNode: () => createBaseVNode,
    createHydrationRenderer: () => createHydrationRenderer,
    createPropsRestProxy: () => createPropsRestProxy,
    createRenderer: () => createRenderer,
    createSSRApp: () => createSSRApp,
    createSlots: () => createSlots,
    createStaticVNode: () => createStaticVNode,
    createTextVNode: () => createTextVNode,
    createVNode: () => createVNode,
    customRef: () => customRef,
    defineAsyncComponent: () => defineAsyncComponent,
    defineComponent: () => defineComponent,
    defineCustomElement: () => defineCustomElement,
    defineEmits: () => defineEmits,
    defineExpose: () => defineExpose,
    defineModel: () => defineModel,
    defineOptions: () => defineOptions,
    defineProps: () => defineProps,
    defineSSRCustomElement: () => defineSSRCustomElement,
    defineSlots: () => defineSlots,
    devtools: () => devtools,
    effect: () => effect,
    effectScope: () => effectScope,
    getCurrentInstance: () => getCurrentInstance,
    getCurrentScope: () => getCurrentScope,
    getCurrentWatcher: () => getCurrentWatcher,
    getTransitionRawChildren: () => getTransitionRawChildren,
    guardReactiveProps: () => guardReactiveProps,
    h: () => h,
    handleError: () => handleError,
    hasInjectionContext: () => hasInjectionContext,
    hydrate: () => hydrate,
    hydrateOnIdle: () => hydrateOnIdle,
    hydrateOnInteraction: () => hydrateOnInteraction,
    hydrateOnMediaQuery: () => hydrateOnMediaQuery,
    hydrateOnVisible: () => hydrateOnVisible,
    initCustomFormatter: () => initCustomFormatter,
    initDirectivesForSSR: () => initDirectivesForSSR,
    inject: () => inject,
    isMemoSame: () => isMemoSame,
    isProxy: () => isProxy,
    isReactive: () => isReactive,
    isReadonly: () => isReadonly,
    isRef: () => isRef2,
    isRuntimeOnly: () => isRuntimeOnly,
    isShallow: () => isShallow,
    isVNode: () => isVNode,
    markRaw: () => markRaw,
    mergeDefaults: () => mergeDefaults,
    mergeModels: () => mergeModels,
    mergeProps: () => mergeProps,
    nextTick: () => nextTick,
    nodeOps: () => nodeOps,
    normalizeClass: () => normalizeClass,
    normalizeProps: () => normalizeProps,
    normalizeStyle: () => normalizeStyle,
    onActivated: () => onActivated,
    onBeforeMount: () => onBeforeMount,
    onBeforeUnmount: () => onBeforeUnmount,
    onBeforeUpdate: () => onBeforeUpdate,
    onDeactivated: () => onDeactivated,
    onErrorCaptured: () => onErrorCaptured,
    onMounted: () => onMounted,
    onRenderTracked: () => onRenderTracked,
    onRenderTriggered: () => onRenderTriggered,
    onScopeDispose: () => onScopeDispose,
    onServerPrefetch: () => onServerPrefetch,
    onUnmounted: () => onUnmounted,
    onUpdated: () => onUpdated,
    onWatcherCleanup: () => onWatcherCleanup,
    openBlock: () => openBlock,
    patchProp: () => patchProp,
    popScopeId: () => popScopeId,
    provide: () => provide,
    proxyRefs: () => proxyRefs,
    pushScopeId: () => pushScopeId,
    queuePostFlushCb: () => queuePostFlushCb,
    reactive: () => reactive,
    readonly: () => readonly,
    ref: () => ref,
    registerRuntimeCompiler: () => registerRuntimeCompiler,
    render: () => render,
    renderList: () => renderList,
    renderSlot: () => renderSlot,
    resolveComponent: () => resolveComponent,
    resolveDirective: () => resolveDirective,
    resolveDynamicComponent: () => resolveDynamicComponent,
    resolveFilter: () => resolveFilter,
    resolveTransitionHooks: () => resolveTransitionHooks,
    setBlockTracking: () => setBlockTracking,
    setDevtoolsHook: () => setDevtoolsHook,
    setTransitionHooks: () => setTransitionHooks,
    shallowReactive: () => shallowReactive,
    shallowReadonly: () => shallowReadonly,
    shallowRef: () => shallowRef,
    ssrContextKey: () => ssrContextKey,
    ssrUtils: () => ssrUtils,
    stop: () => stop,
    toDisplayString: () => toDisplayString,
    toHandlerKey: () => toHandlerKey,
    toHandlers: () => toHandlers,
    toRaw: () => toRaw,
    toRef: () => toRef,
    toRefs: () => toRefs,
    toValue: () => toValue,
    transformVNodeArgs: () => transformVNodeArgs,
    triggerRef: () => triggerRef,
    unref: () => unref,
    useAttrs: () => useAttrs,
    useCssModule: () => useCssModule,
    useCssVars: () => useCssVars,
    useHost: () => useHost,
    useId: () => useId,
    useModel: () => useModel,
    useSSRContext: () => useSSRContext,
    useShadowRoot: () => useShadowRoot,
    useSlots: () => useSlots,
    useTemplateRef: () => useTemplateRef,
    useTransitionState: () => useTransitionState,
    vModelCheckbox: () => vModelCheckbox,
    vModelDynamic: () => vModelDynamic,
    vModelRadio: () => vModelRadio,
    vModelSelect: () => vModelSelect,
    vModelText: () => vModelText,
    vShow: () => vShow,
    version: () => version,
    warn: () => warn2,
    watch: () => watch2,
    watchEffect: () => watchEffect,
    watchPostEffect: () => watchPostEffect,
    watchSyncEffect: () => watchSyncEffect,
    withAsyncContext: () => withAsyncContext,
    withCtx: () => withCtx,
    withDefaults: () => withDefaults,
    withDirectives: () => withDirectives,
    withKeys: () => withKeys,
    withMemo: () => withMemo,
    withModifiers: () => withModifiers,
    withScopeId: () => withScopeId
  });
  function resolveTransitionProps(rawProps) {
    const baseProps = {};
    for (const key in rawProps) {
      if (!(key in DOMTransitionPropsValidators)) {
        baseProps[key] = rawProps[key];
      }
    }
    if (rawProps.css === false) {
      return baseProps;
    }
    const {
      name = "v",
      type,
      duration,
      enterFromClass = `${name}-enter-from`,
      enterActiveClass = `${name}-enter-active`,
      enterToClass = `${name}-enter-to`,
      appearFromClass = enterFromClass,
      appearActiveClass = enterActiveClass,
      appearToClass = enterToClass,
      leaveFromClass = `${name}-leave-from`,
      leaveActiveClass = `${name}-leave-active`,
      leaveToClass = `${name}-leave-to`
    } = rawProps;
    const durations = normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const {
      onBeforeEnter,
      onEnter,
      onEnterCancelled,
      onLeave,
      onLeaveCancelled,
      onBeforeAppear = onBeforeEnter,
      onAppear = onEnter,
      onAppearCancelled = onEnterCancelled
    } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled) => {
      el._enterCancelled = isCancelled;
      removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
      removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
      done && done();
    };
    const finishLeave = (el, done) => {
      el._isLeaving = false;
      removeTransitionClass(el, leaveFromClass);
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
      done && done();
    };
    const makeEnterHook = (isAppear) => {
      return (el, done) => {
        const hook = isAppear ? onAppear : onEnter;
        const resolve2 = () => finishEnter(el, isAppear, done);
        callHook2(hook, [el, resolve2]);
        nextFrame(() => {
          removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
          addTransitionClass(el, isAppear ? appearToClass : enterToClass);
          if (!hasExplicitCallback(hook)) {
            whenTransitionEnds(el, type, enterDuration, resolve2);
          }
        });
      };
    };
    return extend(baseProps, {
      onBeforeEnter(el) {
        callHook2(onBeforeEnter, [el]);
        addTransitionClass(el, enterFromClass);
        addTransitionClass(el, enterActiveClass);
      },
      onBeforeAppear(el) {
        callHook2(onBeforeAppear, [el]);
        addTransitionClass(el, appearFromClass);
        addTransitionClass(el, appearActiveClass);
      },
      onEnter: makeEnterHook(false),
      onAppear: makeEnterHook(true),
      onLeave(el, done) {
        el._isLeaving = true;
        const resolve2 = () => finishLeave(el, done);
        addTransitionClass(el, leaveFromClass);
        if (!el._enterCancelled) {
          forceReflow(el);
          addTransitionClass(el, leaveActiveClass);
        } else {
          addTransitionClass(el, leaveActiveClass);
          forceReflow(el);
        }
        nextFrame(() => {
          if (!el._isLeaving) {
            return;
          }
          removeTransitionClass(el, leaveFromClass);
          addTransitionClass(el, leaveToClass);
          if (!hasExplicitCallback(onLeave)) {
            whenTransitionEnds(el, type, leaveDuration, resolve2);
          }
        });
        callHook2(onLeave, [el, resolve2]);
      },
      onEnterCancelled(el) {
        finishEnter(el, false, void 0, true);
        callHook2(onEnterCancelled, [el]);
      },
      onAppearCancelled(el) {
        finishEnter(el, true, void 0, true);
        callHook2(onAppearCancelled, [el]);
      },
      onLeaveCancelled(el) {
        finishLeave(el);
        callHook2(onLeaveCancelled, [el]);
      }
    });
  }
  function normalizeDuration(duration) {
    if (duration == null) {
      return null;
    } else if (isObject(duration)) {
      return [NumberOf(duration.enter), NumberOf(duration.leave)];
    } else {
      const n = NumberOf(duration);
      return [n, n];
    }
  }
  function NumberOf(val) {
    const res = toNumber(val);
    if (true) {
      assertNumber(res, "<transition> explicit duration");
    }
    return res;
  }
  function addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c) => c && el.classList.add(c));
    (el[vtcKey] || (el[vtcKey] = /* @__PURE__ */ new Set())).add(cls);
  }
  function removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c) => c && el.classList.remove(c));
    const _vtc = el[vtcKey];
    if (_vtc) {
      _vtc.delete(cls);
      if (!_vtc.size) {
        el[vtcKey] = void 0;
      }
    }
  }
  function nextFrame(cb) {
    requestAnimationFrame(() => {
      requestAnimationFrame(cb);
    });
  }
  function whenTransitionEnds(el, expectedType, explicitTimeout, resolve2) {
    const id = el._endId = ++endId;
    const resolveIfNotStale = () => {
      if (id === el._endId) {
        resolve2();
      }
    };
    if (explicitTimeout != null) {
      return setTimeout(resolveIfNotStale, explicitTimeout);
    }
    const { type, timeout, propCount } = getTransitionInfo(el, expectedType);
    if (!type) {
      return resolve2();
    }
    const endEvent = type + "end";
    let ended = 0;
    const end = () => {
      el.removeEventListener(endEvent, onEnd);
      resolveIfNotStale();
    };
    const onEnd = (e) => {
      if (e.target === el && ++ended >= propCount) {
        end();
      }
    };
    setTimeout(() => {
      if (ended < propCount) {
        end();
      }
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
  }
  function getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key) => (styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${TRANSITION}Duration`);
    const transitionTimeout = getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${ANIMATION}Duration`);
    const animationTimeout = getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === TRANSITION) {
      if (transitionTimeout > 0) {
        type = TRANSITION;
        timeout = transitionTimeout;
        propCount = transitionDurations.length;
      }
    } else if (expectedType === ANIMATION) {
      if (animationTimeout > 0) {
        type = ANIMATION;
        timeout = animationTimeout;
        propCount = animationDurations.length;
      }
    } else {
      timeout = Math.max(transitionTimeout, animationTimeout);
      type = timeout > 0 ? transitionTimeout > animationTimeout ? TRANSITION : ANIMATION : null;
      propCount = type ? type === TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === TRANSITION && /\b(?:transform|all)(?:,|$)/.test(
      getStyleProperties(`${TRANSITION}Property`).toString()
    );
    return {
      type,
      timeout,
      propCount,
      hasTransform
    };
  }
  function getTimeout(delays, durations) {
    while (delays.length < durations.length) {
      delays = delays.concat(delays);
    }
    return Math.max(...durations.map((d, i2) => toMs(d) + toMs(delays[i2])));
  }
  function toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
  }
  function forceReflow(el) {
    const targetDocument = el ? el.ownerDocument : document;
    return targetDocument.body.offsetHeight;
  }
  function patchClass(el, value, isSVG) {
    const transitionClasses = el[vtcKey];
    if (transitionClasses) {
      value = (value ? [value, ...transitionClasses] : [...transitionClasses]).join(" ");
    }
    if (value == null) {
      el.removeAttribute("class");
    } else if (isSVG) {
      el.setAttribute("class", value);
    } else {
      el.className = value;
    }
  }
  function setDisplay(el, value) {
    el.style.display = value ? el[vShowOriginalDisplay] : "none";
    el[vShowHidden] = !value;
  }
  function initVShowForSSR() {
    vShow.getSSRProps = ({ value }) => {
      if (!value) {
        return { style: { display: "none" } };
      }
    };
  }
  function useCssVars(getter) {
    const instance = getCurrentInstance();
    if (!instance) {
      warn2(`useCssVars is called without current active component instance.`);
      return;
    }
    const updateTeleports = instance.ut = (vars = getter(instance.proxy)) => {
      Array.from(
        document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)
      ).forEach((node) => setVarsOnNode(node, vars));
    };
    if (true) {
      instance.getCssVars = () => getter(instance.proxy);
    }
    const setVars = () => {
      const vars = getter(instance.proxy);
      if (instance.ce) {
        setVarsOnNode(instance.ce, vars);
      } else {
        setVarsOnVNode(instance.subTree, vars);
      }
      updateTeleports(vars);
    };
    onBeforeUpdate(() => {
      queuePostFlushCb(setVars);
    });
    onMounted(() => {
      watch2(setVars, NOOP, { flush: "post" });
      const ob = new MutationObserver(setVars);
      ob.observe(instance.subTree.el.parentNode, { childList: true });
      onUnmounted(() => ob.disconnect());
    });
  }
  function setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
      const suspense = vnode.suspense;
      vnode = suspense.activeBranch;
      if (suspense.pendingBranch && !suspense.isHydrating) {
        suspense.effects.push(() => {
          setVarsOnVNode(suspense.activeBranch, vars);
        });
      }
    }
    while (vnode.component) {
      vnode = vnode.component.subTree;
    }
    if (vnode.shapeFlag & 1 && vnode.el) {
      setVarsOnNode(vnode.el, vars);
    } else if (vnode.type === Fragment) {
      vnode.children.forEach((c) => setVarsOnVNode(c, vars));
    } else if (vnode.type === Static) {
      let { el, anchor } = vnode;
      while (el) {
        setVarsOnNode(el, vars);
        if (el === anchor) break;
        el = el.nextSibling;
      }
    }
  }
  function setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
      const style = el.style;
      let cssText = "";
      for (const key in vars) {
        const value = normalizeCssVarValue(vars[key]);
        style.setProperty(`--${key}`, value);
        cssText += `--${key}: ${value};`;
      }
      style[CSS_VAR_TEXT] = cssText;
    }
  }
  function patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = isString(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
      if (prev) {
        if (!isString(prev)) {
          for (const key in prev) {
            if (next[key] == null) {
              setStyle(style, key, "");
            }
          }
        } else {
          for (const prevStyle of prev.split(";")) {
            const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
            if (next[key] == null) {
              setStyle(style, key, "");
            }
          }
        }
      }
      for (const key in next) {
        if (key === "display") {
          hasControlledDisplay = true;
        }
        const value = next[key];
        if (value != null) {
          if (!shouldPreserveTextareaResizeStyle(
            el,
            key,
            !isString(prev) && prev ? prev[key] : void 0,
            value
          )) {
            setStyle(style, key, value);
          }
        } else {
          setStyle(style, key, "");
        }
      }
    } else {
      if (isCssString) {
        if (prev !== next) {
          const cssVarText = style[CSS_VAR_TEXT];
          if (cssVarText) {
            next += ";" + cssVarText;
          }
          style.cssText = next;
          hasControlledDisplay = displayRE.test(next);
        }
      } else if (prev) {
        el.removeAttribute("style");
      }
    }
    if (vShowOriginalDisplay in el) {
      el[vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
      if (el[vShowHidden]) {
        style.display = "none";
      }
    }
  }
  function setStyle(style, name, val) {
    if (isArray(val)) {
      val.forEach((v) => setStyle(style, name, v));
    } else {
      if (val == null) val = "";
      if (true) {
        if (semicolonRE.test(val)) {
          warn2(
            `Unexpected semicolon at the end of '${name}' style value: '${val}'`
          );
        }
      }
      if (name.startsWith("--")) {
        style.setProperty(name, val);
      } else {
        const prefixed = autoPrefix(style, name);
        if (importantRE.test(val)) {
          style.setProperty(
            hyphenate(prefixed),
            val.replace(importantRE, ""),
            "important"
          );
        } else {
          style[prefixed] = val;
        }
      }
    }
  }
  function autoPrefix(style, rawName) {
    const cached = prefixCache[rawName];
    if (cached) {
      return cached;
    }
    let name = camelize(rawName);
    if (name !== "filter" && name in style) {
      return prefixCache[rawName] = name;
    }
    name = capitalize(name);
    for (let i2 = 0; i2 < prefixes.length; i2++) {
      const prefixed = prefixes[i2] + name;
      if (prefixed in style) {
        return prefixCache[rawName] = prefixed;
      }
    }
    return rawName;
  }
  function shouldPreserveTextareaResizeStyle(el, key, prev, next) {
    return el.tagName === "TEXTAREA" && (key === "width" || key === "height") && isString(next) && prev === next;
  }
  function patchAttr(el, key, value, isSVG, instance, isBoolean2 = isSpecialBooleanAttr(key)) {
    if (isSVG && key.startsWith("xlink:")) {
      if (value == null) {
        el.removeAttributeNS(xlinkNS, key.slice(6, key.length));
      } else {
        el.setAttributeNS(xlinkNS, key, value);
      }
    } else {
      if (value == null || isBoolean2 && !includeBooleanAttr(value)) {
        el.removeAttribute(key);
      } else {
        el.setAttribute(
          key,
          isBoolean2 ? "" : isSymbol(value) ? String(value) : value
        );
      }
    }
  }
  function patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
      if (value != null) {
        el[key] = key === "innerHTML" ? unsafeToTrustedHTML(value) : value;
      }
      return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
      const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
      const newValue = value == null ? (
        // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : ""
      ) : String(value);
      if (oldValue !== newValue || !("_value" in el)) {
        el.value = newValue;
      }
      if (value == null) {
        el.removeAttribute(key);
      }
      el._value = value;
      return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
      const type = typeof el[key];
      if (type === "boolean") {
        value = includeBooleanAttr(value);
      } else if (value == null && type === "string") {
        value = "";
        needRemove = true;
      } else if (type === "number") {
        value = 0;
        needRemove = true;
      }
    }
    try {
      el[key] = value;
    } catch (e) {
      if (!needRemove) {
        warn2(
          `Failed setting prop "${key}" on <${tag.toLowerCase()}>: value ${value} is invalid.`,
          e
        );
      }
    }
    needRemove && el.removeAttribute(attrName || key);
  }
  function addEventListener2(el, event, handler, options) {
    el.addEventListener(event, handler, options);
  }
  function removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
  }
  function patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[veiKey] || (el[veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) {
      existingInvoker.value = true ? sanitizeEventValue(nextValue, rawName) : nextValue;
    } else {
      const [name, options] = parseName(rawName);
      if (nextValue) {
        const invoker = invokers[rawName] = createInvoker(
          true ? sanitizeEventValue(nextValue, rawName) : nextValue,
          instance
        );
        addEventListener2(el, name, invoker, options);
      } else if (existingInvoker) {
        removeEventListener(el, name, existingInvoker, options);
        invokers[rawName] = void 0;
      }
    }
  }
  function parseName(name) {
    let options;
    let m;
    while ((m = name.match(optionsModifierRE)) && !optionsModifierEventRE.test(name)) {
      if (!options) options = {};
      name = name.slice(0, name.length - m[1].length);
      options[m[1].toLowerCase()] = true;
    }
    const event = name[2] === ":" ? name.slice(3) : hyphenate(name.slice(2));
    return [event, options];
  }
  function createInvoker(initialValue, instance) {
    const invoker = (e) => {
      if (!e._vts) {
        e._vts = Date.now();
      } else if (e._vts <= invoker.attached) {
        return;
      }
      const value = invoker.value;
      if (isArray(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = () => {
          originalStop.call(e);
          e._stopped = true;
        };
        const handlers = value.slice();
        const args = [e];
        for (let i2 = 0; i2 < handlers.length; i2++) {
          if (e._stopped) {
            break;
          }
          const handler = handlers[i2];
          if (handler) {
            callWithAsyncErrorHandling(
              handler,
              instance,
              5,
              args
            );
          }
        }
      } else {
        callWithAsyncErrorHandling(
          value,
          instance,
          5,
          [e]
        );
      }
    };
    invoker.value = initialValue;
    invoker.attached = getNow();
    return invoker;
  }
  function sanitizeEventValue(value, propName) {
    if (isFunction(value) || isArray(value)) {
      return value;
    }
    warn2(
      `Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`
    );
    return NOOP;
  }
  function shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
      if (key === "innerHTML" || key === "textContent") {
        return true;
      }
      if (key in el && isNativeOn(key) && isFunction(value)) {
        return true;
      }
      return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate" || key === "autocorrect") {
      return false;
    }
    if (key === "sandbox" && el.tagName === "IFRAME") {
      return false;
    }
    if (key === "form") {
      return false;
    }
    if (key === "list" && el.tagName === "INPUT") {
      return false;
    }
    if (key === "type" && el.tagName === "TEXTAREA") {
      return false;
    }
    if (key === "width" || key === "height") {
      const tag = el.tagName;
      if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") {
        return false;
      }
    }
    if (isNativeOn(key) && isString(value)) {
      return false;
    }
    return key in el;
  }
  function shouldSetAsPropForVueCE(el, key) {
    const props = (
      // @ts-expect-error _def is private
      el._def.props
    );
    if (!props) {
      return false;
    }
    const camelKey = camelize(key);
    return Array.isArray(props) ? props.some((prop) => camelize(prop) === camelKey) : Object.keys(props).some((prop) => camelize(prop) === camelKey);
  }
  // @__NO_SIDE_EFFECTS__
  function defineCustomElement(options, extraOptions, _createApp) {
    let Comp = defineComponent(options, extraOptions);
    if (isPlainObject(Comp)) Comp = extend({}, Comp, extraOptions);
    class VueCustomElement extends VueElement {
      constructor(initialProps) {
        super(Comp, initialProps, _createApp);
      }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
  }
  function useHost(caller) {
    const instance = getCurrentInstance();
    const el = instance && instance.ce;
    if (el) {
      return el;
    } else if (true) {
      if (!instance) {
        warn2(
          `${caller || "useHost"} called without an active component instance.`
        );
      } else {
        warn2(
          `${caller || "useHost"} can only be used in components defined via defineCustomElement.`
        );
      }
    }
    return null;
  }
  function useShadowRoot() {
    const el = true ? useHost("useShadowRoot") : useHost();
    return el && el.shadowRoot;
  }
  function useCssModule(name = "$style") {
    {
      const instance = getCurrentInstance();
      if (!instance) {
        warn2(`useCssModule must be called inside setup()`);
        return EMPTY_OBJ;
      }
      const modules2 = instance.type.__cssModules;
      if (!modules2) {
        warn2(`Current instance does not have CSS modules injected.`);
        return EMPTY_OBJ;
      }
      const mod = modules2[name];
      if (!mod) {
        warn2(`Current instance does not have CSS module named "${name}".`);
        return EMPTY_OBJ;
      }
      return mod;
    }
  }
  function callPendingCbs(c) {
    const el = c.el;
    if (el[moveCbKey]) {
      el[moveCbKey]();
    }
    if (el[enterCbKey2]) {
      el[enterCbKey2]();
    }
  }
  function recordPosition(c) {
    newPositionMap.set(c, getPosition(c.el));
  }
  function applyTranslation(c) {
    const oldPos = positionMap.get(c);
    const newPos = newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
      const el = c.el;
      const s = el.style;
      const rect = el.getBoundingClientRect();
      let scaleX = 1;
      let scaleY = 1;
      if (el.offsetWidth) scaleX = rect.width / el.offsetWidth;
      if (el.offsetHeight) scaleY = rect.height / el.offsetHeight;
      if (!Number.isFinite(scaleX) || scaleX === 0) scaleX = 1;
      if (!Number.isFinite(scaleY) || scaleY === 0) scaleY = 1;
      if (Math.abs(scaleX - 1) < 0.01) scaleX = 1;
      if (Math.abs(scaleY - 1) < 0.01) scaleY = 1;
      s.transform = s.webkitTransform = `translate(${dx / scaleX}px,${dy / scaleY}px)`;
      s.transitionDuration = "0s";
      return c;
    }
  }
  function getPosition(el) {
    const rect = el.getBoundingClientRect();
    return {
      left: rect.left,
      top: rect.top
    };
  }
  function hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[vtcKey];
    if (_vtc) {
      _vtc.forEach((cls) => {
        cls.split(/\s+/).forEach((c) => c && clone.classList.remove(c));
      });
    }
    moveClass.split(/\s+/).forEach((c) => c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform } = getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
  }
  function onCompositionStart(e) {
    e.target.composing = true;
  }
  function onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
      target.composing = false;
      target.dispatchEvent(new Event("input"));
    }
  }
  function castValue(value, trim2, number) {
    if (trim2) value = value.trim();
    if (number) value = looseToNumber(value);
    return value;
  }
  function setChecked(el, { value, oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if (isArray(value)) {
      checked = looseIndexOf(value, vnode.props.value) > -1;
    } else if (isSet(value)) {
      checked = value.has(vnode.props.value);
    } else {
      if (value === oldValue) return;
      checked = looseEqual(value, getCheckboxValue(el, true));
    }
    if (el.checked !== checked) {
      el.checked = checked;
    }
  }
  function setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = isArray(value);
    if (isMultiple && !isArrayValue && !isSet(value)) {
      warn2(
        `<select multiple v-model> expects an Array or Set value for its binding, but got ${Object.prototype.toString.call(value).slice(8, -1)}.`
      );
      return;
    }
    for (let i2 = 0, l = el.options.length; i2 < l; i2++) {
      const option = el.options[i2];
      const optionValue = getValue(option);
      if (isMultiple) {
        if (isArrayValue) {
          const optionType = typeof optionValue;
          if (optionType === "string" || optionType === "number") {
            option.selected = value.some((v) => String(v) === String(optionValue));
          } else {
            option.selected = looseIndexOf(value, optionValue) > -1;
          }
        } else {
          option.selected = value.has(optionValue);
        }
      } else if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i2) el.selectedIndex = i2;
        return;
      }
    }
    if (!isMultiple && el.selectedIndex !== -1) {
      el.selectedIndex = -1;
    }
  }
  function getValue(el) {
    return "_value" in el ? el._value : el.value;
  }
  function getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
  }
  function resolveDynamicModel(tagName, type) {
    switch (tagName) {
      case "SELECT":
        return vModelSelect;
      case "TEXTAREA":
        return vModelText;
      default:
        switch (type) {
          case "checkbox":
            return vModelCheckbox;
          case "radio":
            return vModelRadio;
          default:
            return vModelText;
        }
    }
  }
  function callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = resolveDynamicModel(
      el.tagName,
      vnode.props && vnode.props.type
    );
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
  }
  function initVModelForSSR() {
    vModelText.getSSRProps = ({ value }) => ({ value });
    vModelRadio.getSSRProps = ({ value }, vnode) => {
      if (vnode.props && looseEqual(vnode.props.value, value)) {
        return { checked: true };
      }
    };
    vModelCheckbox.getSSRProps = ({ value }, vnode) => {
      if (isArray(value)) {
        if (vnode.props && looseIndexOf(value, vnode.props.value) > -1) {
          return { checked: true };
        }
      } else if (isSet(value)) {
        if (vnode.props && value.has(vnode.props.value)) {
          return { checked: true };
        }
      } else if (value) {
        return { checked: true };
      }
    };
    vModelDynamic.getSSRProps = (binding, vnode) => {
      if (typeof vnode.type !== "string") {
        return;
      }
      const modelToUse = resolveDynamicModel(
        // resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(),
        vnode.props && vnode.props.type
      );
      if (modelToUse.getSSRProps) {
        return modelToUse.getSSRProps(binding, vnode);
      }
    };
  }
  function ensureRenderer() {
    return renderer || (renderer = createRenderer(rendererOptions));
  }
  function ensureHydrationRenderer() {
    renderer = enabledHydration ? renderer : createHydrationRenderer(rendererOptions);
    enabledHydration = true;
    return renderer;
  }
  function resolveRootNamespace(container) {
    if (container instanceof SVGElement) {
      return "svg";
    }
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) {
      return "mathml";
    }
  }
  function injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
      value: (tag) => isHTMLTag(tag) || isSVGTag(tag) || isMathMLTag(tag),
      writable: false
    });
  }
  function injectCompilerOptionsCheck(app) {
    if (isRuntimeOnly()) {
      const isCustomElement = app.config.isCustomElement;
      Object.defineProperty(app.config, "isCustomElement", {
        get() {
          return isCustomElement;
        },
        set() {
          warn2(
            `The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`
          );
        }
      });
      const compilerOptions = app.config.compilerOptions;
      const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
      Object.defineProperty(app.config, "compilerOptions", {
        get() {
          warn2(msg);
          return compilerOptions;
        },
        set() {
          warn2(msg);
        }
      });
    }
  }
  function normalizeContainer(container) {
    if (isString(container)) {
      const res = document.querySelector(container);
      if (!res) {
        warn2(
          `Failed to mount app: mount target selector "${container}" returned null.`
        );
      }
      return res;
    }
    if (window.ShadowRoot && container instanceof window.ShadowRoot && container.mode === "closed") {
      warn2(
        `mounting on a ShadowRoot with \`{mode: "closed"}\` may lead to unpredictable bugs`
      );
    }
    return container;
  }
  var policy, tt, unsafeToTrustedHTML, svgNS, mathmlNS, doc, templateContainer, nodeOps, TRANSITION, ANIMATION, vtcKey, DOMTransitionPropsValidators, TransitionPropsValidators, decorate$1, Transition, callHook2, hasExplicitCallback, endId, vShowOriginalDisplay, vShowHidden, vShow, CSS_VAR_TEXT, displayRE, semicolonRE, importantRE, prefixes, prefixCache, xlinkNS, veiKey, optionsModifierRE, optionsModifierEventRE, cachedNow, p, getNow, isNativeOn, patchProp, REMOVAL, defineSSRCustomElement, BaseClass, VueElement, positionMap, newPositionMap, moveCbKey, enterCbKey2, decorate, TransitionGroupImpl, TransitionGroup, getModelAssigner, assignKey, initialValueKey, vModelText, vModelCheckbox, vModelRadio, vModelSelect, vModelDynamic, systemModifiers, modifierGuards, withModifiers, keyNames, withKeys, rendererOptions, renderer, enabledHydration, render, hydrate, createApp, createSSRApp, ssrDirectiveInitialized, initDirectivesForSSR;
  var init_runtime_dom_esm_bundler = __esm({
    "node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js"() {
      init_runtime_core_esm_bundler();
      init_runtime_core_esm_bundler();
      init_shared_esm_bundler();
      /**
      * @vue/runtime-dom v3.5.41
      * (c) 2018-present Yuxi (Evan) You and Vue contributors
      * @license MIT
      **/
      policy = void 0;
      tt = typeof window !== "undefined" && window.trustedTypes;
      if (tt) {
        try {
          policy = /* @__PURE__ */ tt.createPolicy("vue", {
            createHTML: (val) => val
          });
        } catch (e) {
          warn2(`Error creating trusted types policy: ${e}`);
        }
      }
      unsafeToTrustedHTML = policy ? (val) => policy.createHTML(val) : (val) => val;
      svgNS = "http://www.w3.org/2000/svg";
      mathmlNS = "http://www.w3.org/1998/Math/MathML";
      doc = typeof document !== "undefined" ? document : null;
      templateContainer = doc && /* @__PURE__ */ doc.createElement("template");
      nodeOps = {
        insert: (child, parent, anchor) => {
          parent.insertBefore(child, anchor || null);
        },
        remove: (child) => {
          const parent = child.parentNode;
          if (parent) {
            parent.removeChild(child);
          }
        },
        createElement: (tag, namespace, is, props) => {
          const el = namespace === "svg" ? doc.createElementNS(svgNS, tag) : namespace === "mathml" ? doc.createElementNS(mathmlNS, tag) : is ? doc.createElement(tag, { is }) : doc.createElement(tag);
          if (tag === "select" && props && props.multiple != null) {
            el.setAttribute("multiple", props.multiple);
          }
          return el;
        },
        createText: (text) => doc.createTextNode(text),
        createComment: (text) => doc.createComment(text),
        setText: (node, text) => {
          node.nodeValue = text;
        },
        setElementText: (el, text) => {
          el.textContent = text;
        },
        parentNode: (node) => node.parentNode,
        nextSibling: (node) => node.nextSibling,
        querySelector: (selector) => doc.querySelector(selector),
        setScopeId(el, id) {
          el.setAttribute(id, "");
        },
        // __UNSAFE__
        // Reason: innerHTML.
        // Static content here can only come from compiled templates.
        // As long as the user only uses trusted templates, this is safe.
        insertStaticContent(content, parent, anchor, namespace, start, end) {
          const before = anchor ? anchor.previousSibling : parent.lastChild;
          if (start && (start === end || start.nextSibling)) {
            while (true) {
              parent.insertBefore(start.cloneNode(true), anchor);
              if (start === end || !(start = start.nextSibling)) break;
            }
          } else {
            templateContainer.innerHTML = unsafeToTrustedHTML(
              namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content
            );
            const template = templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
              const wrapper = template.firstChild;
              while (wrapper.firstChild) {
                template.appendChild(wrapper.firstChild);
              }
              template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
          }
          return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
          ];
        }
      };
      TRANSITION = "transition";
      ANIMATION = "animation";
      vtcKey = /* @__PURE__ */ Symbol("_vtc");
      DOMTransitionPropsValidators = {
        name: String,
        type: String,
        css: {
          type: Boolean,
          default: true
        },
        duration: [String, Number, Object],
        enterFromClass: String,
        enterActiveClass: String,
        enterToClass: String,
        appearFromClass: String,
        appearActiveClass: String,
        appearToClass: String,
        leaveFromClass: String,
        leaveActiveClass: String,
        leaveToClass: String
      };
      TransitionPropsValidators = /* @__PURE__ */ extend(
        {},
        BaseTransitionPropsValidators,
        DOMTransitionPropsValidators
      );
      decorate$1 = (t) => {
        t.displayName = "Transition";
        t.props = TransitionPropsValidators;
        return t;
      };
      Transition = /* @__PURE__ */ decorate$1(
        (props, { slots }) => h(BaseTransition, resolveTransitionProps(props), slots)
      );
      callHook2 = (hook, args = []) => {
        if (isArray(hook)) {
          hook.forEach((h2) => h2(...args));
        } else if (hook) {
          hook(...args);
        }
      };
      hasExplicitCallback = (hook) => {
        return hook ? isArray(hook) ? hook.some((h2) => h2.length > 1) : hook.length > 1 : false;
      };
      endId = 0;
      vShowOriginalDisplay = /* @__PURE__ */ Symbol("_vod");
      vShowHidden = /* @__PURE__ */ Symbol("_vsh");
      vShow = {
        // used for prop mismatch check during hydration
        name: "show",
        beforeMount(el, { value }, { transition }) {
          el[vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
          if (transition && value) {
            transition.beforeEnter(el);
          } else {
            setDisplay(el, value);
          }
        },
        mounted(el, { value }, { transition }) {
          if (transition && value) {
            transition.enter(el);
          }
        },
        updated(el, { value, oldValue }, { transition }) {
          if (!value === !oldValue) return;
          if (transition) {
            if (value) {
              transition.beforeEnter(el);
              setDisplay(el, true);
              transition.enter(el);
            } else {
              transition.leave(el, () => {
                setDisplay(el, false);
              });
            }
          } else {
            setDisplay(el, value);
          }
        },
        beforeUnmount(el, { value }) {
          setDisplay(el, value);
        }
      };
      CSS_VAR_TEXT = /* @__PURE__ */ Symbol(true ? "CSS_VAR_TEXT" : "");
      displayRE = /(?:^|;)\s*display\s*:/;
      semicolonRE = /[^\\];\s*$/;
      importantRE = /\s*!important$/;
      prefixes = ["Webkit", "Moz", "ms"];
      prefixCache = {};
      xlinkNS = "http://www.w3.org/1999/xlink";
      veiKey = /* @__PURE__ */ Symbol("_vei");
      optionsModifierRE = /(Once|Passive|Capture)$/;
      optionsModifierEventRE = /^on:?(?:Once|Passive|Capture)$/;
      cachedNow = 0;
      p = /* @__PURE__ */ Promise.resolve();
      getNow = () => cachedNow || (p.then(() => cachedNow = 0), cachedNow = Date.now());
      isNativeOn = (key) => key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
      key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
      patchProp = (el, key, prevValue, nextValue, namespace, parentComponent) => {
        const isSVG = namespace === "svg";
        if (key === "class") {
          patchClass(el, nextValue, isSVG);
        } else if (key === "style") {
          patchStyle(el, prevValue, nextValue);
        } else if (isOn(key)) {
          if (!isModelListener(key)) {
            patchEvent(el, key, prevValue, nextValue, parentComponent);
          }
        } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : shouldSetAsProp(el, key, nextValue, isSVG)) {
          patchDOMProp(el, key, nextValue);
          if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) {
            patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
          }
        } else if (
          // #11081 force set props for possible async custom element
          el._isVueCE && // #12408 check if it's declared prop or it's async custom element
          (shouldSetAsPropForVueCE(el, key) || // @ts-expect-error _def is private
          el._def.__asyncLoader && (/[A-Z]/.test(key) || !isString(nextValue)))
        ) {
          patchDOMProp(el, camelize(key), nextValue, parentComponent, key);
        } else {
          if (key === "true-value") {
            el._trueValue = nextValue;
          } else if (key === "false-value") {
            el._falseValue = nextValue;
          }
          patchAttr(el, key, nextValue, isSVG);
        }
      };
      REMOVAL = {};
      defineSSRCustomElement = (/* @__NO_SIDE_EFFECTS__ */ (options, extraOptions) => {
        return /* @__PURE__ */ defineCustomElement(options, extraOptions, createSSRApp);
      });
      BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
      };
      VueElement = class _VueElement extends BaseClass {
        constructor(_def, _props = {}, _createApp = createApp) {
          super();
          this._def = _def;
          this._props = _props;
          this._createApp = _createApp;
          this._isVueCE = true;
          this._instance = null;
          this._app = null;
          this._nonce = this._def.nonce;
          this._connected = false;
          this._resolved = false;
          this._patching = false;
          this._dirty = false;
          this._numberProps = null;
          this._styleChildren = /* @__PURE__ */ new WeakSet();
          this._styleAnchors = /* @__PURE__ */ new WeakMap();
          this._ob = null;
          if (this.shadowRoot && _createApp !== createApp) {
            this._root = this.shadowRoot;
          } else {
            if (this.shadowRoot) {
              warn2(
                `Custom element has pre-rendered declarative shadow root but is not defined as hydratable. Use \`defineSSRCustomElement\`.`
              );
            }
            if (_def.shadowRoot !== false) {
              this.attachShadow(
                extend({}, _def.shadowRootOptions, {
                  mode: "open"
                })
              );
              this._root = this.shadowRoot;
            } else {
              this._root = this;
            }
          }
        }
        connectedCallback() {
          if (!this.isConnected) return;
          if (!this.shadowRoot && !this._resolved) {
            this._parseSlots();
          }
          this._connected = true;
          let parent = this;
          while (parent = parent && // #12479 should check assignedSlot first to get correct parent
          (parent.assignedSlot || parent.parentNode || parent.host)) {
            if (parent instanceof _VueElement) {
              this._parent = parent;
              break;
            }
          }
          if (!this._instance) {
            if (this._resolved) {
              this._mount(this._def);
            } else {
              if (parent && parent._pendingResolve) {
                this._pendingResolve = parent._pendingResolve.then(() => {
                  this._pendingResolve = void 0;
                  if (this.isConnected) {
                    return this._resolveDef();
                  }
                });
              } else {
                this._resolveDef();
              }
            }
          }
        }
        _setParent(parent = this._parent) {
          if (parent) {
            this._instance.parent = parent._instance;
            this._inheritParentContext(parent);
          }
        }
        _inheritParentContext(parent = this._parent) {
          if (parent && this._app) {
            Object.setPrototypeOf(
              this._app._context.provides,
              parent._instance.provides
            );
          }
        }
        disconnectedCallback() {
          this._connected = false;
          nextTick(() => {
            if (!this._connected) {
              if (this._ob) {
                this._ob.disconnect();
                this._ob = null;
              }
              this._app && this._app.unmount();
              if (this._instance) this._instance.ce = void 0;
              this._app = this._instance = null;
              if (this._teleportTargets) {
                this._teleportTargets.clear();
                this._teleportTargets = void 0;
              }
            }
          });
        }
        _processMutations(mutations4) {
          for (const m of mutations4) {
            this._setAttr(m.attributeName);
          }
        }
        /**
         * resolve inner component definition (handle possible async component)
         */
        _resolveDef() {
          if (this._pendingResolve) {
            return this._pendingResolve;
          }
          for (let i2 = 0; i2 < this.attributes.length; i2++) {
            this._setAttr(this.attributes[i2].name);
          }
          this._ob = new MutationObserver(this._processMutations.bind(this));
          this._ob.observe(this, { attributes: true });
          const resolve2 = (def2, isAsync = false) => {
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props, styles } = def2;
            let numberProps;
            if (props && !isArray(props)) {
              for (const key in props) {
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                  if (key in this._props) {
                    this._props[key] = toNumber(this._props[key]);
                  }
                  (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[camelize(key)] = true;
                }
              }
            }
            this._numberProps = numberProps;
            this._resolveProps(def2);
            if (this.shadowRoot) {
              this._applyStyles(styles);
            } else if (styles) {
              warn2(
                "Custom element style injection is not supported when using shadowRoot: false"
              );
            }
            this._mount(def2);
          };
          const asyncDef = this._def.__asyncLoader;
          if (asyncDef) {
            this._pendingResolve = asyncDef().then((def2) => {
              def2.configureApp = this._def.configureApp;
              resolve2(this._def = def2, true);
            });
            return this._pendingResolve;
          } else {
            resolve2(this._def);
          }
        }
        _mount(def2) {
          if (!def2.name) {
            def2.name = "VueElement";
          }
          this._app = this._createApp(def2);
          this._inheritParentContext();
          if (def2.configureApp) {
            def2.configureApp(this._app);
          }
          this._app._ceVNode = this._createVNode();
          this._app.mount(this._root);
          const exposed = this._instance && this._instance.exposed;
          if (!exposed) return;
          for (const key in exposed) {
            if (!hasOwn(this, key)) {
              Object.defineProperty(this, key, {
                // unwrap ref to be consistent with public instance behavior
                get: () => unref(exposed[key])
              });
            } else if (true) {
              warn2(`Exposed property "${key}" already exists on custom element.`);
            }
          }
        }
        _resolveProps(def2) {
          const { props } = def2;
          const declaredPropKeys = isArray(props) ? props : Object.keys(props || {});
          for (const key of Object.keys(this)) {
            if (key[0] !== "_" && declaredPropKeys.includes(key)) {
              this._setProp(key, this[key]);
            }
          }
          for (const key of declaredPropKeys.map(camelize)) {
            if (key in Object.getPrototypeOf(this)) {
              warn2(
                `Custom element prop "${key}" conflicts with an existing property on the element and will overwrite it.`
              );
            }
            Object.defineProperty(this, key, {
              get() {
                return this._getProp(key);
              },
              set(val) {
                this._setProp(key, val, true, !this._patching);
              }
            });
          }
        }
        _setAttr(key) {
          if (key.startsWith("data-v-")) return;
          const has = this.hasAttribute(key);
          let value = has ? this.getAttribute(key) : REMOVAL;
          const camelKey = camelize(key);
          if (has && this._numberProps && this._numberProps[camelKey]) {
            value = toNumber(value);
          }
          this._setProp(camelKey, value, false, true);
        }
        /**
         * @internal
         */
        _getProp(key) {
          return this._props[key];
        }
        /**
         * @internal
         */
        _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
          if (val !== this._props[key]) {
            this._dirty = true;
            if (val === REMOVAL) {
              delete this._props[key];
            } else {
              this._props[key] = val;
              if (key === "key" && this._app) {
                this._app._ceVNode.key = val;
              }
            }
            if (shouldUpdate && this._instance) {
              this._update();
            }
            if (shouldReflect) {
              const ob = this._ob;
              if (ob) {
                this._processMutations(ob.takeRecords());
                ob.disconnect();
              }
              if (val === true) {
                this.setAttribute(hyphenate(key), "");
              } else if (typeof val === "string" || typeof val === "number") {
                this.setAttribute(hyphenate(key), val + "");
              } else if (!val) {
                this.removeAttribute(hyphenate(key));
              }
              ob && ob.observe(this, { attributes: true });
            }
          }
        }
        _update() {
          const vnode = this._createVNode();
          if (this._app) vnode.appContext = this._app._context;
          render(vnode, this._root);
        }
        _createVNode() {
          const baseProps = {};
          if (!this.shadowRoot) {
            baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
          }
          const vnode = createVNode(this._def, extend(baseProps, this._props));
          if (!this._instance) {
            vnode.ce = (instance) => {
              this._instance = instance;
              instance.ce = this;
              instance.isCE = true;
              if (true) {
                instance.ceReload = (newStyles) => {
                  if (this._styles) {
                    this._styles.forEach((s) => this._root.removeChild(s));
                    this._styles.length = 0;
                  }
                  this._styleAnchors.delete(this._def);
                  this._applyStyles(newStyles);
                  this._instance = null;
                  this._update();
                };
              }
              const dispatch2 = (event, args) => {
                this.dispatchEvent(
                  new CustomEvent(
                    event,
                    isPlainObject(args[0]) ? extend({ detail: args }, args[0]) : { detail: args }
                  )
                );
              };
              instance.emit = (event, ...args) => {
                dispatch2(event, args);
                if (hyphenate(event) !== event) {
                  dispatch2(hyphenate(event), args);
                }
              };
              this._setParent();
            };
          }
          return vnode;
        }
        _applyStyles(styles, owner, parentComp) {
          if (!styles) return;
          if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) {
              return;
            }
            this._styleChildren.add(owner);
          }
          const nonce = this._nonce;
          const root = this.shadowRoot;
          const insertionAnchor = parentComp ? this._getStyleAnchor(parentComp) || this._getStyleAnchor(this._def) : this._getRootStyleInsertionAnchor(root);
          let last = null;
          for (let i2 = styles.length - 1; i2 >= 0; i2--) {
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i2];
            root.insertBefore(s, last || insertionAnchor);
            last = s;
            if (i2 === 0) {
              if (!parentComp) this._styleAnchors.set(this._def, s);
              if (owner) this._styleAnchors.set(owner, s);
            }
            if (true) {
              if (owner) {
                if (owner.__hmrId) {
                  if (!this._childStyles) this._childStyles = /* @__PURE__ */ new Map();
                  let entry = this._childStyles.get(owner.__hmrId);
                  if (!entry) {
                    this._childStyles.set(owner.__hmrId, entry = []);
                  }
                  entry.push(s);
                }
              } else {
                (this._styles || (this._styles = [])).push(s);
              }
            }
          }
        }
        _getStyleAnchor(comp) {
          if (!comp) {
            return null;
          }
          const anchor = this._styleAnchors.get(comp);
          if (anchor && anchor.parentNode === this.shadowRoot) {
            return anchor;
          }
          if (anchor) {
            this._styleAnchors.delete(comp);
          }
          return null;
        }
        _getRootStyleInsertionAnchor(root) {
          for (let i2 = 0; i2 < root.childNodes.length; i2++) {
            const node = root.childNodes[i2];
            if (!(node instanceof HTMLStyleElement)) {
              return node;
            }
          }
          return null;
        }
        /**
         * Only called when shadowRoot is false
         */
        _parseSlots() {
          const slots = this._slots = {};
          let n;
          while (n = this.firstChild) {
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
          }
        }
        /**
         * Only called when shadowRoot is false
         */
        _renderSlots() {
          const outlets = this._getSlots();
          const scopeId = this._instance.type.__scopeId;
          for (let i2 = 0; i2 < outlets.length; i2++) {
            const o = outlets[i2];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) {
              for (const n of content) {
                if (scopeId && n.nodeType === 1) {
                  const id = scopeId + "-s";
                  const walker = document.createTreeWalker(n, 1);
                  n.setAttribute(id, "");
                  let child;
                  while (child = walker.nextNode()) {
                    child.setAttribute(id, "");
                  }
                }
                parent.insertBefore(n, o);
              }
            } else {
              while (o.firstChild) parent.insertBefore(o.firstChild, o);
            }
            parent.removeChild(o);
          }
        }
        /**
         * @internal
         */
        _getSlots() {
          const roots = [this];
          if (this._teleportTargets) {
            roots.push(...this._teleportTargets);
          }
          const slots = /* @__PURE__ */ new Set();
          for (const root of roots) {
            const found = root.querySelectorAll("slot");
            for (let i2 = 0; i2 < found.length; i2++) {
              slots.add(found[i2]);
            }
          }
          return Array.from(slots);
        }
        /**
         * @internal
         */
        _injectChildStyle(comp, parentComp) {
          this._applyStyles(comp.styles, comp, parentComp);
        }
        /**
         * @internal
         */
        _beginPatch() {
          this._patching = true;
          this._dirty = false;
        }
        /**
         * @internal
         */
        _endPatch() {
          this._patching = false;
          if (this._dirty && this._instance) {
            this._update();
          }
        }
        /**
         * @internal
         */
        _hasShadowRoot() {
          return this._def.shadowRoot !== false;
        }
        /**
         * @internal
         */
        _removeChildStyle(comp) {
          if (true) {
            this._styleChildren.delete(comp);
            this._styleAnchors.delete(comp);
            if (this._childStyles && comp.__hmrId) {
              const oldStyles = this._childStyles.get(comp.__hmrId);
              if (oldStyles) {
                oldStyles.forEach((s) => this._root.removeChild(s));
                oldStyles.length = 0;
              }
            }
          }
        }
      };
      positionMap = /* @__PURE__ */ new WeakMap();
      newPositionMap = /* @__PURE__ */ new WeakMap();
      moveCbKey = /* @__PURE__ */ Symbol("_moveCb");
      enterCbKey2 = /* @__PURE__ */ Symbol("_enterCb");
      decorate = (t) => {
        delete t.props.mode;
        return t;
      };
      TransitionGroupImpl = /* @__PURE__ */ decorate({
        name: "TransitionGroup",
        props: /* @__PURE__ */ extend({}, TransitionPropsValidators, {
          tag: String,
          moveClass: String
        }),
        setup(props, { slots }) {
          const instance = getCurrentInstance();
          const state4 = useTransitionState();
          let prevChildren;
          let children;
          onUpdated(() => {
            if (!prevChildren.length) {
              return;
            }
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!hasCSSTransform(
              prevChildren[0].el,
              instance.vnode.el,
              moveClass
            )) {
              prevChildren = [];
              return;
            }
            prevChildren.forEach(callPendingCbs);
            prevChildren.forEach(recordPosition);
            const movedChildren = prevChildren.filter(applyTranslation);
            forceReflow(instance.vnode.el);
            movedChildren.forEach((c) => {
              const el = c.el;
              const style = el.style;
              addTransitionClass(el, moveClass);
              style.transform = style.webkitTransform = style.transitionDuration = "";
              const cb = el[moveCbKey] = (e) => {
                if (e && e.target !== el) {
                  return;
                }
                if (!e || e.propertyName.endsWith("transform")) {
                  el.removeEventListener("transitionend", cb);
                  el[moveCbKey] = null;
                  removeTransitionClass(el, moveClass);
                }
              };
              el.addEventListener("transitionend", cb);
            });
            prevChildren = [];
          });
          return () => {
            const rawProps = toRaw(props);
            const cssTransitionProps = resolveTransitionProps(rawProps);
            let tag = rawProps.tag || Fragment;
            prevChildren = [];
            if (children) {
              for (let i2 = 0; i2 < children.length; i2++) {
                const child = children[i2];
                if (child.el && child.el instanceof Element && // Hidden v-show nodes have no previous layout box to animate from.
                !child.el[vShowHidden]) {
                  prevChildren.push(child);
                  setTransitionHooks(
                    child,
                    resolveTransitionHooks(
                      child,
                      cssTransitionProps,
                      state4,
                      instance
                    )
                  );
                  positionMap.set(child, getPosition(child.el));
                }
              }
            }
            children = slots.default ? getTransitionRawChildren(slots.default()) : [];
            for (let i2 = 0; i2 < children.length; i2++) {
              const child = children[i2];
              if (child.key != null) {
                setTransitionHooks(
                  child,
                  resolveTransitionHooks(child, cssTransitionProps, state4, instance)
                );
              } else if (child.type !== Text) {
                warn2(`<TransitionGroup> children must be keyed.`);
              }
            }
            return createVNode(tag, null, children);
          };
        }
      });
      TransitionGroup = TransitionGroupImpl;
      getModelAssigner = (vnode) => {
        const fn = vnode.props["onUpdate:modelValue"] || false;
        return isArray(fn) ? (value) => invokeArrayFns(fn, value) : fn;
      };
      assignKey = /* @__PURE__ */ Symbol("_assign");
      initialValueKey = /* @__PURE__ */ Symbol("_initialValue");
      vModelText = {
        created(el, { modifiers: { lazy, trim: trim2, number } }, vnode) {
          if (el.parentNode) {
            if (el.type === "text") {
              el[initialValueKey] = el.defaultValue.replace(/[\r\n]/g, "");
            } else if (el.type === "textarea") {
              el[initialValueKey] = el.defaultValue.replace(/\r\n?/g, "\n");
            }
          }
          el[assignKey] = getModelAssigner(vnode);
          const castToNumber = number || vnode.props && vnode.props.type === "number";
          addEventListener2(el, lazy ? "change" : "input", (e) => {
            if (e.target.composing) return;
            el[assignKey](castValue(el.value, trim2, castToNumber));
          });
          if (trim2 || castToNumber) {
            addEventListener2(el, "change", () => {
              el.value = castValue(el.value, trim2, castToNumber);
            });
          }
          if (!lazy) {
            addEventListener2(el, "compositionstart", onCompositionStart);
            addEventListener2(el, "compositionend", onCompositionEnd);
            addEventListener2(el, "change", onCompositionEnd);
          }
        },
        // set value on mounted so it's after min/max for type="range"
        mounted(el, { value, modifiers: { trim: trim2, number } }) {
          const newValue = value == null ? "" : value;
          const initialValue = el[initialValueKey];
          delete el[initialValueKey];
          if (initialValue !== void 0 && (el.type === "text" || el.type === "textarea") && el.value !== initialValue) {
            el[assignKey](castValue(el.value, trim2, number));
          } else {
            el.value = newValue;
          }
        },
        beforeUpdate(el, { value, oldValue, modifiers: { lazy, trim: trim2, number } }, vnode) {
          el[assignKey] = getModelAssigner(vnode);
          if (el.composing) return;
          const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? looseToNumber(el.value) : el.value;
          const newValue = value == null ? "" : value;
          if (elValue === newValue) {
            return;
          }
          const rootNode = el.getRootNode();
          if ((rootNode instanceof Document || rootNode instanceof ShadowRoot) && rootNode.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) {
              return;
            }
            if (trim2 && el.value.trim() === newValue) {
              return;
            }
          }
          el.value = newValue;
        }
      };
      vModelCheckbox = {
        // #4096 array checkboxes need to be deep traversed
        deep: true,
        created(el, _2, vnode) {
          el[assignKey] = getModelAssigner(vnode);
          addEventListener2(el, "change", () => {
            const modelValue = el._modelValue;
            const elementValue = getValue(el);
            const checked = el.checked;
            const assign = el[assignKey];
            if (isArray(modelValue)) {
              const index = looseIndexOf(modelValue, elementValue);
              const found = index !== -1;
              if (checked && !found) {
                assign(modelValue.concat(elementValue));
              } else if (!checked && found) {
                const filtered = [...modelValue];
                filtered.splice(index, 1);
                assign(filtered);
              }
            } else if (isSet(modelValue)) {
              const cloned = new Set(modelValue);
              if (checked) {
                cloned.add(elementValue);
              } else {
                cloned.delete(elementValue);
              }
              assign(cloned);
            } else {
              assign(getCheckboxValue(el, checked));
            }
          });
        },
        // set initial checked on mount to wait for true-value/false-value
        mounted: setChecked,
        beforeUpdate(el, binding, vnode) {
          el[assignKey] = getModelAssigner(vnode);
          setChecked(el, binding, vnode);
        }
      };
      vModelRadio = {
        created(el, { value }, vnode) {
          el.checked = looseEqual(value, vnode.props.value);
          el[assignKey] = getModelAssigner(vnode);
          addEventListener2(el, "change", () => {
            el[assignKey](getValue(el));
          });
        },
        beforeUpdate(el, { value, oldValue }, vnode) {
          el[assignKey] = getModelAssigner(vnode);
          if (value !== oldValue) {
            el.checked = looseEqual(value, vnode.props.value);
          }
        }
      };
      vModelSelect = {
        // <select multiple> value need to be deep traversed
        deep: true,
        created(el, { value, modifiers: { number } }, vnode) {
          el._modelValue = value;
          addEventListener2(el, "change", () => {
            const selectedVal = Array.prototype.filter.call(el.options, (o) => o.selected).map(
              (o) => number ? looseToNumber(getValue(o)) : getValue(o)
            );
            el[assignKey](
              el.multiple ? isSet(el._modelValue) ? new Set(selectedVal) : selectedVal : selectedVal[0]
            );
            el._assigning = true;
            nextTick(() => {
              el._assigning = false;
            });
          });
          el[assignKey] = getModelAssigner(vnode);
        },
        // set value in mounted & updated because <select> relies on its children
        // <option>s.
        mounted(el, { value }) {
          setSelected(el, value);
        },
        beforeUpdate(el, { value }, vnode) {
          el._modelValue = value;
          el[assignKey] = getModelAssigner(vnode);
        },
        updated(el, { value }) {
          if (!el._assigning) {
            setSelected(el, value);
          }
        }
      };
      vModelDynamic = {
        created(el, binding, vnode) {
          callModelHook(el, binding, vnode, null, "created");
        },
        mounted(el, binding, vnode) {
          callModelHook(el, binding, vnode, null, "mounted");
        },
        beforeUpdate(el, binding, vnode, prevVNode) {
          callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
        },
        updated(el, binding, vnode, prevVNode) {
          callModelHook(el, binding, vnode, prevVNode, "updated");
        }
      };
      systemModifiers = ["ctrl", "shift", "alt", "meta"];
      modifierGuards = {
        stop: (e) => e.stopPropagation(),
        prevent: (e) => e.preventDefault(),
        self: (e) => e.target !== e.currentTarget,
        ctrl: (e) => !e.ctrlKey,
        shift: (e) => !e.shiftKey,
        alt: (e) => !e.altKey,
        meta: (e) => !e.metaKey,
        left: (e) => "button" in e && e.button !== 0,
        middle: (e) => "button" in e && e.button !== 1,
        right: (e) => "button" in e && e.button !== 2,
        exact: (e, modifiers) => systemModifiers.some((m) => e[`${m}Key`] && !modifiers.includes(m))
      };
      withModifiers = (fn, modifiers) => {
        if (!fn) return fn;
        const cache = fn._withMods || (fn._withMods = {});
        const cacheKey = modifiers.join(".");
        return cache[cacheKey] || (cache[cacheKey] = ((event, ...args) => {
          for (let i2 = 0; i2 < modifiers.length; i2++) {
            const guard = modifierGuards[modifiers[i2]];
            if (guard && guard(event, modifiers)) return;
          }
          return fn(event, ...args);
        }));
      };
      keyNames = {
        esc: "escape",
        space: " ",
        up: "arrow-up",
        left: "arrow-left",
        right: "arrow-right",
        down: "arrow-down",
        delete: "backspace"
      };
      withKeys = (fn, modifiers) => {
        const cache = fn._withKeys || (fn._withKeys = {});
        const cacheKey = modifiers.join(".");
        return cache[cacheKey] || (cache[cacheKey] = ((event) => {
          if (!("key" in event)) {
            return;
          }
          const eventKey = hyphenate(event.key);
          if (modifiers.some(
            (k) => k === eventKey || keyNames[k] === eventKey
          )) {
            return fn(event);
          }
        }));
      };
      rendererOptions = /* @__PURE__ */ extend({ patchProp }, nodeOps);
      enabledHydration = false;
      render = ((...args) => {
        ensureRenderer().render(...args);
      });
      hydrate = ((...args) => {
        ensureHydrationRenderer().hydrate(...args);
      });
      createApp = ((...args) => {
        const app = ensureRenderer().createApp(...args);
        if (true) {
          injectNativeTagCheck(app);
          injectCompilerOptionsCheck(app);
        }
        const { mount } = app;
        app.mount = (containerOrSelector) => {
          const container = normalizeContainer(containerOrSelector);
          if (!container) return;
          const component = app._component;
          if (!isFunction(component) && !component.render && !component.template) {
            component.template = container.innerHTML;
          }
          if (container.nodeType === 1) {
            container.textContent = "";
          }
          const proxy = mount(container, false, resolveRootNamespace(container));
          if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
          }
          return proxy;
        };
        return app;
      });
      createSSRApp = ((...args) => {
        const app = ensureHydrationRenderer().createApp(...args);
        if (true) {
          injectNativeTagCheck(app);
          injectCompilerOptionsCheck(app);
        }
        const { mount } = app;
        app.mount = (containerOrSelector) => {
          const container = normalizeContainer(containerOrSelector);
          if (container) {
            return mount(container, true, resolveRootNamespace(container));
          }
        };
        return app;
      });
      ssrDirectiveInitialized = false;
      initDirectivesForSSR = () => {
        if (!ssrDirectiveInitialized) {
          ssrDirectiveInitialized = true;
          initVModelForSSR();
          initVShowForSSR();
        }
      };
    }
  });

  // node_modules/@vue/compiler-core/dist/compiler-core.esm-bundler.js
  function registerRuntimeHelpers(helpers) {
    Object.getOwnPropertySymbols(helpers).forEach((s) => {
      helperNameMap[s] = helpers[s];
    });
  }
  function createRoot(children, source = "") {
    return {
      type: 0,
      source,
      children,
      helpers: /* @__PURE__ */ new Set(),
      components: [],
      directives: [],
      hoists: [],
      imports: [],
      cached: [],
      temps: 0,
      codegenNode: void 0,
      loc: locStub
    };
  }
  function createVNodeCall(context, tag, props, children, patchFlag, dynamicProps, directives, isBlock = false, disableTracking = false, isComponent2 = false, loc = locStub) {
    if (context) {
      if (isBlock) {
        context.helper(OPEN_BLOCK);
        context.helper(getVNodeBlockHelper(context.inSSR, isComponent2));
      } else {
        context.helper(getVNodeHelper(context.inSSR, isComponent2));
      }
      if (directives) {
        context.helper(WITH_DIRECTIVES);
      }
    }
    return {
      type: 13,
      tag,
      props,
      children,
      patchFlag,
      dynamicProps,
      directives,
      isBlock,
      disableTracking,
      isComponent: isComponent2,
      loc
    };
  }
  function createArrayExpression(elements, loc = locStub) {
    return {
      type: 17,
      loc,
      elements
    };
  }
  function createObjectExpression(properties, loc = locStub) {
    return {
      type: 15,
      loc,
      properties
    };
  }
  function createObjectProperty(key, value) {
    return {
      type: 16,
      loc: locStub,
      key: isString(key) ? createSimpleExpression(key, true) : key,
      value
    };
  }
  function createSimpleExpression(content, isStatic = false, loc = locStub, constType = 0) {
    return {
      type: 4,
      loc,
      content,
      isStatic,
      constType: isStatic ? 3 : constType
    };
  }
  function createCompoundExpression(children, loc = locStub) {
    return {
      type: 8,
      loc,
      children
    };
  }
  function createCallExpression(callee, args = [], loc = locStub) {
    return {
      type: 14,
      loc,
      callee,
      arguments: args
    };
  }
  function createFunctionExpression(params, returns = void 0, newline = false, isSlot = false, loc = locStub) {
    return {
      type: 18,
      params,
      returns,
      newline,
      isSlot,
      loc
    };
  }
  function createConditionalExpression(test2, consequent, alternate, newline = true) {
    return {
      type: 19,
      test: test2,
      consequent,
      alternate,
      newline,
      loc: locStub
    };
  }
  function createCacheExpression(index, value, needPauseTracking = false, inVOnce = false) {
    return {
      type: 20,
      index,
      value,
      needPauseTracking,
      inVOnce,
      needArraySpread: false,
      loc: locStub
    };
  }
  function createBlockStatement(body) {
    return {
      type: 21,
      body,
      loc: locStub
    };
  }
  function getVNodeHelper(ssr, isComponent2) {
    return ssr || isComponent2 ? CREATE_VNODE : CREATE_ELEMENT_VNODE;
  }
  function getVNodeBlockHelper(ssr, isComponent2) {
    return ssr || isComponent2 ? CREATE_BLOCK : CREATE_ELEMENT_BLOCK;
  }
  function convertToBlock(node, { helper, removeHelper, inSSR }) {
    if (!node.isBlock) {
      node.isBlock = true;
      removeHelper(getVNodeHelper(inSSR, node.isComponent));
      helper(OPEN_BLOCK);
      helper(getVNodeBlockHelper(inSSR, node.isComponent));
    }
  }
  function isTagStartChar(c) {
    return c >= 97 && c <= 122 || c >= 65 && c <= 90;
  }
  function isWhitespace(c) {
    return c === 32 || c === 10 || c === 9 || c === 12 || c === 13;
  }
  function isEndOfTagSection(c) {
    return c === 47 || c === 62 || isWhitespace(c);
  }
  function toCharCodes(str) {
    const ret = new Uint8Array(str.length);
    for (let i2 = 0; i2 < str.length; i2++) {
      ret[i2] = str.charCodeAt(i2);
    }
    return ret;
  }
  function getCompatValue(key, { compatConfig }) {
    const value = compatConfig && compatConfig[key];
    if (key === "MODE") {
      return value || 3;
    } else {
      return value;
    }
  }
  function isCompatEnabled(key, context) {
    const mode = getCompatValue("MODE", context);
    const value = getCompatValue(key, context);
    return mode === 3 ? value === true : value !== false;
  }
  function checkCompatEnabled(key, context, loc, ...args) {
    const enabled = isCompatEnabled(key, context);
    if (enabled) {
      warnDeprecation(key, context, loc, ...args);
    }
    return enabled;
  }
  function warnDeprecation(key, context, loc, ...args) {
    const val = getCompatValue(key, context);
    if (val === "suppress-warning") {
      return;
    }
    const { message, link } = deprecationData[key];
    const msg = `(deprecation ${key}) ${typeof message === "function" ? message(...args) : message}${link ? `
  Details: ${link}` : ``}`;
    const err = new SyntaxError(msg);
    err.code = key;
    if (loc) err.loc = loc;
    context.onWarn(err);
  }
  function defaultOnError(error) {
    throw error;
  }
  function defaultOnWarn(msg) {
    console.warn(`[Vue warn] ${msg.message}`);
  }
  function createCompilerError(code, loc, messages, additionalMessage) {
    const msg = true ? (messages || errorMessages)[code] + (additionalMessage || ``) : `https://vuejs.org/error-reference/#compiler-${code}`;
    const error = new SyntaxError(String(msg));
    error.code = code;
    error.loc = loc;
    return error;
  }
  function isCoreComponent(tag) {
    switch (tag) {
      case "Teleport":
      case "teleport":
        return TELEPORT;
      case "Suspense":
      case "suspense":
        return SUSPENSE;
      case "KeepAlive":
      case "keep-alive":
        return KEEP_ALIVE;
      case "BaseTransition":
      case "base-transition":
        return BASE_TRANSITION;
    }
  }
  function assert(condition, msg) {
    if (!condition) {
      throw new Error(msg || `unexpected compiler condition`);
    }
  }
  function findDir(node, name, allowEmpty = false) {
    for (let i2 = 0; i2 < node.props.length; i2++) {
      const p2 = node.props[i2];
      if (p2.type === 7 && (allowEmpty || p2.exp) && (isString(name) ? p2.name === name : name.test(p2.name))) {
        return p2;
      }
    }
  }
  function findProp(node, name, dynamicOnly = false, allowEmpty = false) {
    for (let i2 = 0; i2 < node.props.length; i2++) {
      const p2 = node.props[i2];
      if (p2.type === 6) {
        if (dynamicOnly) continue;
        if (p2.name === name && (p2.value || allowEmpty)) {
          return p2;
        }
      } else if (p2.name === "bind" && (p2.exp || allowEmpty) && isStaticArgOf(p2.arg, name)) {
        return p2;
      }
    }
  }
  function isStaticArgOf(arg, name) {
    return !!(arg && isStaticExp(arg) && arg.content === name);
  }
  function hasDynamicKeyVBind(node) {
    return node.props.some(
      (p2) => p2.type === 7 && p2.name === "bind" && (!p2.arg || // v-bind="obj"
      p2.arg.type !== 4 || // v-bind:[_ctx.foo]
      !p2.arg.isStatic)
      // v-bind:[foo]
    );
  }
  function isText$1(node) {
    return node.type === 5 || node.type === 2;
  }
  function isVPre(p2) {
    return p2.type === 7 && p2.name === "pre";
  }
  function isVSlot(p2) {
    return p2.type === 7 && p2.name === "slot";
  }
  function isTemplateNode(node) {
    return node.type === 1 && node.tagType === 3;
  }
  function isSlotOutlet(node) {
    return node.type === 1 && node.tagType === 2;
  }
  function getUnnormalizedProps(props, callPath = []) {
    if (props && !isString(props) && props.type === 14) {
      const callee = props.callee;
      if (!isString(callee) && propsHelperSet.has(callee)) {
        return getUnnormalizedProps(
          props.arguments[0],
          callPath.concat(props)
        );
      }
    }
    return [props, callPath];
  }
  function injectProp(node, prop, context) {
    if (node.type !== 13 && injectSlotKey(node, prop)) {
      return;
    }
    let propsWithInjection;
    let props = node.type === 13 ? node.props : node.arguments[2];
    let callPath = [];
    let parentCall;
    if (props && !isString(props) && props.type === 14) {
      const ret = getUnnormalizedProps(props);
      props = ret[0];
      callPath = ret[1];
      parentCall = callPath[callPath.length - 1];
    }
    if (props == null || isString(props)) {
      propsWithInjection = createObjectExpression([prop]);
    } else if (props.type === 14) {
      const first = props.arguments[0];
      if (!isString(first) && first.type === 15) {
        if (!hasProp(prop, first)) {
          first.properties.unshift(prop);
        }
      } else {
        if (props.callee === TO_HANDLERS) {
          propsWithInjection = createCallExpression(context.helper(MERGE_PROPS), [
            createObjectExpression([prop]),
            props
          ]);
        } else {
          props.arguments.unshift(createObjectExpression([prop]));
        }
      }
      !propsWithInjection && (propsWithInjection = props);
    } else if (props.type === 15) {
      if (!hasProp(prop, props)) {
        props.properties.unshift(prop);
      }
      propsWithInjection = props;
    } else {
      propsWithInjection = createCallExpression(context.helper(MERGE_PROPS), [
        createObjectExpression([prop]),
        props
      ]);
      if (parentCall && parentCall.callee === GUARD_REACTIVE_PROPS) {
        parentCall = callPath[callPath.length - 2];
      }
    }
    if (node.type === 13) {
      if (parentCall) {
        parentCall.arguments[0] = propsWithInjection;
      } else {
        node.props = propsWithInjection;
      }
    } else {
      if (parentCall) {
        parentCall.arguments[0] = propsWithInjection;
      } else {
        node.arguments[2] = propsWithInjection;
      }
    }
  }
  function injectSlotKey(node, prop) {
    var _a, _b, _c;
    if (prop.key.type !== 4 || prop.key.content !== "key") {
      return false;
    }
    const props = node.arguments[2];
    if (props && !isString(props)) {
      const [unnormalizedProps] = getUnnormalizedProps(props);
      if (unnormalizedProps && !isString(unnormalizedProps) && unnormalizedProps.type === 15 && hasProp(prop, unnormalizedProps)) {
        return true;
      }
    }
    (_a = node.arguments)[2] || (_a[2] = "{}");
    (_b = node.arguments)[3] || (_b[3] = "undefined");
    (_c = node.arguments)[4] || (_c[4] = "undefined");
    node.arguments[5] = prop.value;
    return true;
  }
  function hasProp(prop, props) {
    let result = false;
    if (prop.key.type === 4) {
      const propKeyName = prop.key.content;
      result = props.properties.some(
        (p2) => p2.key.type === 4 && p2.key.content === propKeyName
      );
    }
    return result;
  }
  function toValidAssetId(name, type) {
    return `_${type}_${name.replace(/[^\w]/g, (searchValue, replaceValue) => {
      return searchValue === "-" ? "_" : name.charCodeAt(replaceValue).toString();
    })}`;
  }
  function getMemoedVNodeCall(node) {
    if (node.type === 14 && node.callee === WITH_MEMO) {
      return node.arguments[1].returns;
    } else {
      return node;
    }
  }
  function isAllWhitespace(str) {
    for (let i2 = 0; i2 < str.length; i2++) {
      if (!isWhitespace(str.charCodeAt(i2))) {
        return false;
      }
    }
    return true;
  }
  function isWhitespaceText(node) {
    return node.type === 2 && isAllWhitespace(node.content) || node.type === 12 && isWhitespaceText(node.content);
  }
  function isCommentOrWhitespace(node) {
    return node.type === 3 || isWhitespaceText(node);
  }
  function parseForExpression(input) {
    const loc = input.loc;
    const exp = input.content;
    const inMatch = exp.match(forAliasRE);
    if (!inMatch) return;
    const [, LHS, RHS] = inMatch;
    const createAliasExpression = (content, offset, asParam = false) => {
      const start = loc.start.offset + offset;
      const end = start + content.length;
      return createExp(
        content,
        false,
        getLoc(start, end),
        0,
        asParam ? 1 : 0
        /* Normal */
      );
    };
    const result = {
      source: createAliasExpression(RHS.trim(), exp.indexOf(RHS, LHS.length)),
      value: void 0,
      key: void 0,
      index: void 0,
      finalized: false
    };
    let valueContent = LHS.trim().replace(stripParensRE, "").trim();
    const trimmedOffset = LHS.indexOf(valueContent);
    const iteratorMatch = valueContent.match(forIteratorRE);
    if (iteratorMatch) {
      valueContent = valueContent.replace(forIteratorRE, "").trim();
      const keyContent = iteratorMatch[1].trim();
      let keyOffset;
      if (keyContent) {
        keyOffset = exp.indexOf(keyContent, trimmedOffset + valueContent.length);
        result.key = createAliasExpression(keyContent, keyOffset, true);
      }
      if (iteratorMatch[2]) {
        const indexContent = iteratorMatch[2].trim();
        if (indexContent) {
          result.index = createAliasExpression(
            indexContent,
            exp.indexOf(
              indexContent,
              result.key ? keyOffset + keyContent.length : trimmedOffset + valueContent.length
            ),
            true
          );
        }
      }
    }
    if (valueContent) {
      result.value = createAliasExpression(valueContent, trimmedOffset, true);
    }
    return result;
  }
  function getSlice(start, end) {
    return currentInput.slice(start, end);
  }
  function endOpenTag(end) {
    if (tokenizer.inSFCRoot) {
      currentOpenTag.innerLoc = getLoc(end + 1, end + 1);
    }
    addNode(currentOpenTag);
    const { tag, ns } = currentOpenTag;
    if (ns === 0 && currentOptions.isPreTag(tag)) {
      inPre++;
    }
    if (currentOptions.isVoidTag(tag)) {
      onCloseTag(currentOpenTag, end);
    } else {
      stack2.unshift(currentOpenTag);
      if (ns === 1 || ns === 2) {
        tokenizer.inXML = true;
      }
    }
    currentOpenTag = null;
  }
  function onText(content, start, end) {
    {
      const tag = stack2[0] && stack2[0].tag;
      if (tag !== "script" && tag !== "style" && content.includes("&")) {
        content = currentOptions.decodeEntities(content, false);
      }
    }
    const parent = stack2[0] || currentRoot;
    const lastNode = parent.children[parent.children.length - 1];
    if (lastNode && lastNode.type === 2) {
      lastNode.content += content;
      setLocEnd(lastNode.loc, end);
    } else {
      parent.children.push({
        type: 2,
        content,
        loc: getLoc(start, end)
      });
    }
  }
  function onCloseTag(el, end, isImplied = false) {
    if (isImplied) {
      setLocEnd(el.loc, backTrack(end, 60));
    } else {
      setLocEnd(el.loc, lookAhead(end, 62) + 1);
    }
    if (tokenizer.inSFCRoot) {
      if (el.children.length) {
        el.innerLoc.end = extend({}, el.children[el.children.length - 1].loc.end);
      } else {
        el.innerLoc.end = extend({}, el.innerLoc.start);
      }
      el.innerLoc.source = getSlice(
        el.innerLoc.start.offset,
        el.innerLoc.end.offset
      );
    }
    const { tag, ns, children } = el;
    if (!inVPre) {
      if (tag === "slot") {
        el.tagType = 2;
      } else if (isFragmentTemplate(el)) {
        el.tagType = 3;
      } else if (isComponent(el)) {
        el.tagType = 1;
      }
    }
    if (!tokenizer.inRCDATA) {
      el.children = condenseWhitespace(children);
    }
    if (ns === 0 && currentOptions.isIgnoreNewlineTag(tag)) {
      const first = children[0];
      if (first && first.type === 2) {
        first.content = first.content.replace(/^\r?\n/, "");
      }
    }
    if (ns === 0 && currentOptions.isPreTag(tag)) {
      inPre--;
    }
    if (currentVPreBoundary === el) {
      inVPre = tokenizer.inVPre = false;
      currentVPreBoundary = null;
    }
    if (tokenizer.inXML && (stack2[0] ? stack2[0].ns : currentOptions.ns) === 0) {
      tokenizer.inXML = false;
    }
    {
      const props = el.props;
      if (isCompatEnabled(
        "COMPILER_V_IF_V_FOR_PRECEDENCE",
        currentOptions
      )) {
        let hasIf = false;
        let hasFor = false;
        for (let i2 = 0; i2 < props.length; i2++) {
          const p2 = props[i2];
          if (p2.type === 7) {
            if (p2.name === "if") {
              hasIf = true;
            } else if (p2.name === "for") {
              hasFor = true;
            }
          }
          if (hasIf && hasFor) {
            warnDeprecation(
              "COMPILER_V_IF_V_FOR_PRECEDENCE",
              currentOptions,
              el.loc
            );
            break;
          }
        }
      }
      if (!tokenizer.inSFCRoot && isCompatEnabled(
        "COMPILER_NATIVE_TEMPLATE",
        currentOptions
      ) && el.tag === "template" && !isFragmentTemplate(el)) {
        warnDeprecation(
          "COMPILER_NATIVE_TEMPLATE",
          currentOptions,
          el.loc
        );
        const parent = stack2[0] || currentRoot;
        const index = parent.children.indexOf(el);
        parent.children.splice(index, 1, ...el.children);
      }
      const inlineTemplateProp = props.find(
        (p2) => p2.type === 6 && p2.name === "inline-template"
      );
      if (inlineTemplateProp && checkCompatEnabled(
        "COMPILER_INLINE_TEMPLATE",
        currentOptions,
        inlineTemplateProp.loc
      ) && el.children.length) {
        inlineTemplateProp.value = {
          type: 2,
          content: getSlice(
            el.children[0].loc.start.offset,
            el.children[el.children.length - 1].loc.end.offset
          ),
          loc: inlineTemplateProp.loc
        };
      }
    }
  }
  function lookAhead(index, c) {
    let i2 = index;
    while (currentInput.charCodeAt(i2) !== c && i2 < currentInput.length - 1) i2++;
    return i2;
  }
  function backTrack(index, c) {
    let i2 = index;
    while (currentInput.charCodeAt(i2) !== c && i2 >= 0) i2--;
    return i2;
  }
  function isFragmentTemplate({ tag, props }) {
    if (tag === "template") {
      for (let i2 = 0; i2 < props.length; i2++) {
        if (props[i2].type === 7 && specialTemplateDir.has(props[i2].name)) {
          return true;
        }
      }
    }
    return false;
  }
  function isComponent({ tag, props }) {
    if (currentOptions.isCustomElement(tag)) {
      return false;
    }
    if (tag === "component" || isUpperCase(tag.charCodeAt(0)) || isCoreComponent(tag) || currentOptions.isBuiltInComponent && currentOptions.isBuiltInComponent(tag) || currentOptions.isNativeTag && !currentOptions.isNativeTag(tag)) {
      return true;
    }
    for (let i2 = 0; i2 < props.length; i2++) {
      const p2 = props[i2];
      if (p2.type === 6) {
        if (p2.name === "is" && p2.value) {
          if (p2.value.content.startsWith("vue:")) {
            return true;
          } else if (checkCompatEnabled(
            "COMPILER_IS_ON_ELEMENT",
            currentOptions,
            p2.loc
          )) {
            return true;
          }
        }
      } else if (
        // :is on plain element - only treat as component in compat mode
        p2.name === "bind" && isStaticArgOf(p2.arg, "is") && checkCompatEnabled(
          "COMPILER_IS_ON_ELEMENT",
          currentOptions,
          p2.loc
        )
      ) {
        return true;
      }
    }
    return false;
  }
  function isUpperCase(c) {
    return c > 64 && c < 91;
  }
  function condenseWhitespace(nodes) {
    const shouldCondense = currentOptions.whitespace !== "preserve";
    let removedWhitespace = false;
    for (let i2 = 0; i2 < nodes.length; i2++) {
      const node = nodes[i2];
      if (node.type === 2) {
        if (!inPre) {
          if (isAllWhitespace(node.content)) {
            const prev = nodes[i2 - 1] && nodes[i2 - 1].type;
            const next = nodes[i2 + 1] && nodes[i2 + 1].type;
            if (!prev || !next || shouldCondense && (prev === 3 && (next === 3 || next === 1) || prev === 1 && (next === 3 || next === 1 && hasNewlineChar(node.content)))) {
              removedWhitespace = true;
              nodes[i2] = null;
            } else {
              node.content = " ";
            }
          } else if (shouldCondense) {
            node.content = condense(node.content);
          }
        } else {
          node.content = node.content.replace(windowsNewlineRE, "\n");
        }
      }
    }
    return removedWhitespace ? nodes.filter(Boolean) : nodes;
  }
  function hasNewlineChar(str) {
    for (let i2 = 0; i2 < str.length; i2++) {
      const c = str.charCodeAt(i2);
      if (c === 10 || c === 13) {
        return true;
      }
    }
    return false;
  }
  function condense(str) {
    let ret = "";
    let prevCharIsWhitespace = false;
    for (let i2 = 0; i2 < str.length; i2++) {
      if (isWhitespace(str.charCodeAt(i2))) {
        if (!prevCharIsWhitespace) {
          ret += " ";
          prevCharIsWhitespace = true;
        }
      } else {
        ret += str[i2];
        prevCharIsWhitespace = false;
      }
    }
    return ret;
  }
  function addNode(node) {
    (stack2[0] || currentRoot).children.push(node);
  }
  function getLoc(start, end) {
    return {
      start: tokenizer.getPos(start),
      // @ts-expect-error allow late attachment
      end: end == null ? end : tokenizer.getPos(end),
      // @ts-expect-error allow late attachment
      source: end == null ? end : getSlice(start, end)
    };
  }
  function cloneLoc(loc) {
    return getLoc(loc.start.offset, loc.end.offset);
  }
  function setLocEnd(loc, end) {
    loc.end = tokenizer.getPos(end);
    loc.source = getSlice(loc.start.offset, end);
  }
  function dirToAttr(dir) {
    const attr = {
      type: 6,
      name: dir.rawName,
      nameLoc: getLoc(
        dir.loc.start.offset,
        dir.loc.start.offset + dir.rawName.length
      ),
      value: void 0,
      loc: dir.loc
    };
    if (dir.exp) {
      const loc = dir.exp.loc;
      if (loc.end.offset < dir.loc.end.offset) {
        loc.start.offset--;
        loc.start.column--;
        loc.end.offset++;
        loc.end.column++;
      }
      attr.value = {
        type: 2,
        content: dir.exp.content,
        loc
      };
    }
    return attr;
  }
  function createExp(content, isStatic = false, loc, constType = 0, parseMode = 0) {
    const exp = createSimpleExpression(content, isStatic, loc, constType);
    return exp;
  }
  function emitError(code, index, message) {
    currentOptions.onError(
      createCompilerError(code, getLoc(index, index), void 0, message)
    );
  }
  function reset() {
    tokenizer.reset();
    currentOpenTag = null;
    currentProp = null;
    currentAttrValue = "";
    currentAttrStartIndex = -1;
    currentAttrEndIndex = -1;
    stack2.length = 0;
  }
  function baseParse(input, options) {
    reset();
    currentInput = input;
    currentOptions = extend({}, defaultParserOptions);
    if (options) {
      let key;
      for (key in options) {
        if (options[key] != null) {
          currentOptions[key] = options[key];
        }
      }
    }
    if (true) {
      if (!currentOptions.decodeEntities) {
        throw new Error(
          `[@vue/compiler-core] decodeEntities option is required in browser builds.`
        );
      }
    }
    tokenizer.mode = currentOptions.parseMode === "html" ? 1 : currentOptions.parseMode === "sfc" ? 2 : 0;
    tokenizer.inXML = currentOptions.ns === 1 || currentOptions.ns === 2;
    const delimiters = options && options.delimiters;
    if (delimiters) {
      tokenizer.delimiterOpen = toCharCodes(delimiters[0]);
      tokenizer.delimiterClose = toCharCodes(delimiters[1]);
    }
    const root = currentRoot = createRoot([], input);
    tokenizer.parse(currentInput);
    root.loc = getLoc(0, input.length);
    root.children = condenseWhitespace(root.children);
    currentRoot = null;
    return root;
  }
  function cacheStatic(root, context) {
    walk(
      root,
      void 0,
      context,
      // Root node is unfortunately non-hoistable due to potential parent
      // fallthrough attributes.
      !!getSingleElementRoot(root)
    );
  }
  function getSingleElementRoot(root) {
    const children = root.children.filter((x) => x.type !== 3);
    return children.length === 1 && children[0].type === 1 && !isSlotOutlet(children[0]) ? children[0] : null;
  }
  function walk(node, parent, context, doNotHoistNode = false, inFor = false) {
    const { children } = node;
    const toCache = [];
    for (let i2 = 0; i2 < children.length; i2++) {
      const child = children[i2];
      if (child.type === 1 && child.tagType === 0) {
        const constantType = doNotHoistNode ? 0 : getConstantType(child, context);
        if (constantType > 0) {
          if (constantType >= 2) {
            child.codegenNode.patchFlag = -1;
            toCache.push(child);
            continue;
          }
        } else {
          const codegenNode = child.codegenNode;
          if (codegenNode.type === 13) {
            const flag = codegenNode.patchFlag;
            if ((flag === void 0 || flag === 512 || flag === 1) && getGeneratedPropsConstantType(child, context) >= 2) {
              const props = getNodeProps(child);
              if (props) {
                codegenNode.props = context.hoist(props);
              }
            }
            if (codegenNode.dynamicProps) {
              codegenNode.dynamicProps = context.hoist(codegenNode.dynamicProps);
            }
          }
        }
      } else if (child.type === 12) {
        const constantType = doNotHoistNode ? 0 : getConstantType(child, context);
        if (constantType >= 2) {
          if (child.codegenNode.type === 14 && child.codegenNode.arguments.length > 0) {
            child.codegenNode.arguments.push(
              -1 + (true ? ` /* ${PatchFlagNames[-1]} */` : ``)
            );
          }
          toCache.push(child);
          continue;
        }
      }
      if (child.type === 1) {
        const isComponent2 = child.tagType === 1;
        if (isComponent2) {
          context.scopes.vSlot++;
        }
        walk(child, node, context, false, inFor);
        if (isComponent2) {
          context.scopes.vSlot--;
        }
      } else if (child.type === 11) {
        walk(child, node, context, child.children.length === 1, true);
      } else if (child.type === 9) {
        for (let i22 = 0; i22 < child.branches.length; i22++) {
          walk(
            child.branches[i22],
            node,
            context,
            child.branches[i22].children.length === 1,
            inFor
          );
        }
      }
    }
    let cachedAsArray = false;
    if (toCache.length === children.length && node.type === 1) {
      if (node.tagType === 0 && node.codegenNode && node.codegenNode.type === 13 && isArray(node.codegenNode.children)) {
        node.codegenNode.children = getCacheExpression(
          createArrayExpression(node.codegenNode.children)
        );
        cachedAsArray = true;
      } else if (node.tagType === 1 && node.codegenNode && node.codegenNode.type === 13 && node.codegenNode.children && !isArray(node.codegenNode.children) && node.codegenNode.children.type === 15) {
        const slot = getSlotNode(node.codegenNode, "default");
        if (slot) {
          slot.returns = getCacheExpression(
            createArrayExpression(slot.returns)
          );
          cachedAsArray = true;
        }
      } else if (node.tagType === 3 && parent && parent.type === 1 && parent.tagType === 1 && parent.codegenNode && parent.codegenNode.type === 13 && parent.codegenNode.children && !isArray(parent.codegenNode.children) && parent.codegenNode.children.type === 15) {
        const slotName = findDir(node, "slot", true);
        const slot = slotName && slotName.arg && getSlotNode(parent.codegenNode, slotName.arg);
        if (slot) {
          slot.returns = getCacheExpression(
            createArrayExpression(slot.returns)
          );
          cachedAsArray = true;
        }
      }
    }
    if (!cachedAsArray) {
      for (const child of toCache) {
        child.codegenNode = context.cache(child.codegenNode);
      }
    }
    function getCacheExpression(value) {
      const exp = context.cache(value);
      exp.needArraySpread = true;
      return exp;
    }
    function getSlotNode(node2, name) {
      if (node2.children && !isArray(node2.children) && node2.children.type === 15) {
        const slot = node2.children.properties.find(
          (p2) => p2.key === name || p2.key.content === name
        );
        return slot && slot.value;
      }
    }
    if (toCache.length && context.transformHoist) {
      context.transformHoist(children, context, node);
    }
  }
  function getConstantType(node, context) {
    const { constantCache } = context;
    switch (node.type) {
      case 1:
        if (node.tagType !== 0) {
          return 0;
        }
        const cached = constantCache.get(node);
        if (cached !== void 0) {
          return cached;
        }
        const codegenNode = node.codegenNode;
        if (codegenNode.type !== 13) {
          return 0;
        }
        if (codegenNode.isBlock && node.tag !== "svg" && node.tag !== "foreignObject" && node.tag !== "math") {
          return 0;
        }
        if (codegenNode.patchFlag === void 0) {
          let returnType2 = 3;
          const generatedPropsType = getGeneratedPropsConstantType(node, context);
          if (generatedPropsType === 0) {
            constantCache.set(node, 0);
            return 0;
          }
          if (generatedPropsType < returnType2) {
            returnType2 = generatedPropsType;
          }
          for (let i2 = 0; i2 < node.children.length; i2++) {
            const childType = getConstantType(node.children[i2], context);
            if (childType === 0) {
              constantCache.set(node, 0);
              return 0;
            }
            if (childType < returnType2) {
              returnType2 = childType;
            }
          }
          if (returnType2 > 1) {
            for (let i2 = 0; i2 < node.props.length; i2++) {
              const p2 = node.props[i2];
              if (p2.type === 7 && p2.name === "bind" && p2.exp) {
                const expType = getConstantType(p2.exp, context);
                if (expType === 0) {
                  constantCache.set(node, 0);
                  return 0;
                }
                if (expType < returnType2) {
                  returnType2 = expType;
                }
              }
            }
          }
          if (codegenNode.isBlock) {
            for (let i2 = 0; i2 < node.props.length; i2++) {
              const p2 = node.props[i2];
              if (p2.type === 7) {
                constantCache.set(node, 0);
                return 0;
              }
            }
            context.removeHelper(OPEN_BLOCK);
            context.removeHelper(
              getVNodeBlockHelper(context.inSSR, codegenNode.isComponent)
            );
            codegenNode.isBlock = false;
            context.helper(getVNodeHelper(context.inSSR, codegenNode.isComponent));
          }
          constantCache.set(node, returnType2);
          return returnType2;
        } else {
          constantCache.set(node, 0);
          return 0;
        }
      case 2:
      case 3:
        return 3;
      case 9:
      case 11:
      case 10:
        return 0;
      case 5:
      case 12:
        return getConstantType(node.content, context);
      case 4:
        return node.constType;
      case 8:
        let returnType = 3;
        for (let i2 = 0; i2 < node.children.length; i2++) {
          const child = node.children[i2];
          if (isString(child) || isSymbol(child)) {
            continue;
          }
          const childType = getConstantType(child, context);
          if (childType === 0) {
            return 0;
          } else if (childType < returnType) {
            returnType = childType;
          }
        }
        return returnType;
      case 20:
        return 2;
      default:
        if (true) ;
        return 0;
    }
  }
  function getConstantTypeOfHelperCall(value, context) {
    if (value.type === 14 && !isString(value.callee) && allowHoistedHelperSet.has(value.callee)) {
      const arg = value.arguments[0];
      if (arg.type === 4) {
        return getConstantType(arg, context);
      } else if (arg.type === 14) {
        return getConstantTypeOfHelperCall(arg, context);
      }
    }
    return 0;
  }
  function getGeneratedPropsConstantType(node, context) {
    let returnType = 3;
    const props = getNodeProps(node);
    if (props && props.type === 15) {
      const { properties } = props;
      for (let i2 = 0; i2 < properties.length; i2++) {
        const { key, value } = properties[i2];
        const keyType = getConstantType(key, context);
        if (keyType === 0) {
          return keyType;
        }
        if (keyType < returnType) {
          returnType = keyType;
        }
        let valueType;
        if (value.type === 4) {
          valueType = getConstantType(value, context);
        } else if (value.type === 14) {
          valueType = getConstantTypeOfHelperCall(value, context);
        } else {
          valueType = 0;
        }
        if (valueType === 0) {
          return valueType;
        }
        if (valueType < returnType) {
          returnType = valueType;
        }
      }
    }
    return returnType;
  }
  function getNodeProps(node) {
    const codegenNode = node.codegenNode;
    if (codegenNode.type === 13) {
      return codegenNode.props;
    }
  }
  function createTransformContext(root, {
    filename = "",
    prefixIdentifiers = false,
    hoistStatic = false,
    hmr = false,
    cacheHandlers = false,
    nodeTransforms = [],
    directiveTransforms = {},
    transformHoist = null,
    isBuiltInComponent = NOOP,
    isCustomElement = NOOP,
    expressionPlugins = [],
    scopeId = null,
    slotted = true,
    ssr = false,
    inSSR = false,
    ssrCssVars = ``,
    bindingMetadata = EMPTY_OBJ,
    inline = false,
    isTS = false,
    onError = defaultOnError,
    onWarn = defaultOnWarn,
    compatConfig
  }) {
    const nameMatch = filename.replace(/\?.*$/, "").match(/([^/\\]+)\.\w+$/);
    const context = {
      // options
      filename,
      selfName: nameMatch && capitalize(camelize(nameMatch[1])),
      prefixIdentifiers,
      hoistStatic,
      hmr,
      cacheHandlers,
      nodeTransforms,
      directiveTransforms,
      transformHoist,
      isBuiltInComponent,
      isCustomElement,
      expressionPlugins,
      scopeId,
      slotted,
      ssr,
      inSSR,
      ssrCssVars,
      bindingMetadata,
      inline,
      isTS,
      onError,
      onWarn,
      compatConfig,
      // state
      root,
      helpers: /* @__PURE__ */ new Map(),
      components: /* @__PURE__ */ new Set(),
      directives: /* @__PURE__ */ new Set(),
      hoists: [],
      imports: [],
      cached: [],
      constantCache: /* @__PURE__ */ new WeakMap(),
      vForMemoKeyedNodes: /* @__PURE__ */ new WeakSet(),
      temps: 0,
      identifiers: /* @__PURE__ */ Object.create(null),
      scopes: {
        vFor: 0,
        vSlot: 0,
        vPre: 0,
        vOnce: 0
      },
      parent: null,
      grandParent: null,
      currentNode: root,
      childIndex: 0,
      inVOnce: false,
      // methods
      helper(name) {
        const count = context.helpers.get(name) || 0;
        context.helpers.set(name, count + 1);
        return name;
      },
      removeHelper(name) {
        const count = context.helpers.get(name);
        if (count) {
          const currentCount = count - 1;
          if (!currentCount) {
            context.helpers.delete(name);
          } else {
            context.helpers.set(name, currentCount);
          }
        }
      },
      helperString(name) {
        return `_${helperNameMap[context.helper(name)]}`;
      },
      replaceNode(node) {
        if (true) {
          if (!context.currentNode) {
            throw new Error(`Node being replaced is already removed.`);
          }
          if (!context.parent) {
            throw new Error(`Cannot replace root node.`);
          }
        }
        context.parent.children[context.childIndex] = context.currentNode = node;
      },
      removeNode(node) {
        if (!context.parent) {
          throw new Error(`Cannot remove root node.`);
        }
        const list = context.parent.children;
        const removalIndex = node ? list.indexOf(node) : context.currentNode ? context.childIndex : -1;
        if (removalIndex < 0) {
          throw new Error(`node being removed is not a child of current parent`);
        }
        if (!node || node === context.currentNode) {
          context.currentNode = null;
          context.onNodeRemoved();
        } else {
          if (context.childIndex > removalIndex) {
            context.childIndex--;
            context.onNodeRemoved();
          }
        }
        context.parent.children.splice(removalIndex, 1);
      },
      onNodeRemoved: NOOP,
      addIdentifiers(exp) {
      },
      removeIdentifiers(exp) {
      },
      hoist(exp) {
        if (isString(exp)) exp = createSimpleExpression(exp);
        context.hoists.push(exp);
        const identifier = createSimpleExpression(
          `_hoisted_${context.hoists.length}`,
          false,
          exp.loc,
          2
        );
        identifier.hoisted = exp;
        return identifier;
      },
      cache(exp, isVNode2 = false, inVOnce = false) {
        const cacheExp = createCacheExpression(
          context.cached.length,
          exp,
          isVNode2,
          inVOnce
        );
        context.cached.push(cacheExp);
        return cacheExp;
      }
    };
    {
      context.filters = /* @__PURE__ */ new Set();
    }
    return context;
  }
  function transform(root, options) {
    const context = createTransformContext(root, options);
    traverseNode(root, context);
    if (options.hoistStatic) {
      cacheStatic(root, context);
    }
    if (!options.ssr) {
      createRootCodegen(root, context);
    }
    root.helpers = /* @__PURE__ */ new Set([...context.helpers.keys()]);
    root.components = [...context.components];
    root.directives = [...context.directives];
    root.imports = context.imports;
    root.hoists = context.hoists;
    root.temps = context.temps;
    root.cached = context.cached;
    root.transformed = true;
    {
      root.filters = [...context.filters];
    }
  }
  function createRootCodegen(root, context) {
    const { helper } = context;
    const { children } = root;
    if (children.length === 1) {
      const singleElementRootChild = getSingleElementRoot(root);
      if (singleElementRootChild && singleElementRootChild.codegenNode) {
        const codegenNode = singleElementRootChild.codegenNode;
        if (codegenNode.type === 13) {
          convertToBlock(codegenNode, context);
        }
        root.codegenNode = codegenNode;
      } else {
        root.codegenNode = children[0];
      }
    } else if (children.length > 1) {
      let patchFlag = 64;
      if (children.filter((c) => c.type !== 3).length === 1) {
        patchFlag |= 2048;
      }
      root.codegenNode = createVNodeCall(
        context,
        helper(FRAGMENT),
        void 0,
        root.children,
        patchFlag,
        void 0,
        void 0,
        true,
        void 0,
        false
      );
    } else ;
  }
  function traverseChildren(parent, context) {
    let i2 = 0;
    const nodeRemoved = () => {
      i2--;
    };
    for (; i2 < parent.children.length; i2++) {
      const child = parent.children[i2];
      if (isString(child)) continue;
      context.grandParent = context.parent;
      context.parent = parent;
      context.childIndex = i2;
      context.onNodeRemoved = nodeRemoved;
      traverseNode(child, context);
    }
  }
  function traverseNode(node, context) {
    context.currentNode = node;
    const { nodeTransforms } = context;
    const exitFns = [];
    for (let i22 = 0; i22 < nodeTransforms.length; i22++) {
      const onExit = nodeTransforms[i22](node, context);
      if (onExit) {
        if (isArray(onExit)) {
          exitFns.push(...onExit);
        } else {
          exitFns.push(onExit);
        }
      }
      if (!context.currentNode) {
        return;
      } else {
        node = context.currentNode;
      }
    }
    switch (node.type) {
      case 3:
        if (!context.ssr) {
          context.helper(CREATE_COMMENT);
        }
        break;
      case 5:
        if (!context.ssr) {
          context.helper(TO_DISPLAY_STRING);
        }
        break;
      // for container types, further traverse downwards
      case 9:
        for (let i22 = 0; i22 < node.branches.length; i22++) {
          traverseNode(node.branches[i22], context);
        }
        break;
      case 10:
      case 11:
      case 1:
      case 0:
        traverseChildren(node, context);
        break;
    }
    context.currentNode = node;
    let i2 = exitFns.length;
    while (i2--) {
      exitFns[i2]();
    }
  }
  function createStructuralDirectiveTransform(name, fn) {
    const matches2 = isString(name) ? (n) => n === name : (n) => name.test(n);
    return (node, context) => {
      if (node.type === 1) {
        const { props } = node;
        if (node.tagType === 3 && props.some(isVSlot)) {
          return;
        }
        const exitFns = [];
        for (let i2 = 0; i2 < props.length; i2++) {
          const prop = props[i2];
          if (prop.type === 7 && matches2(prop.name)) {
            props.splice(i2, 1);
            i2--;
            const onExit = fn(node, prop, context);
            if (onExit) exitFns.push(onExit);
          }
        }
        return exitFns;
      }
    };
  }
  function createCodegenContext(ast, {
    mode = "function",
    prefixIdentifiers = mode === "module",
    sourceMap = false,
    filename = `template.vue.html`,
    scopeId = null,
    optimizeImports = false,
    runtimeGlobalName = `Vue`,
    runtimeModuleName = `vue`,
    ssrRuntimeModuleName = "vue/server-renderer",
    ssr = false,
    isTS = false,
    inSSR = false
  }) {
    const context = {
      mode,
      prefixIdentifiers,
      sourceMap,
      filename,
      scopeId,
      optimizeImports,
      runtimeGlobalName,
      runtimeModuleName,
      ssrRuntimeModuleName,
      ssr,
      isTS,
      inSSR,
      source: ast.source,
      code: ``,
      column: 1,
      line: 1,
      offset: 0,
      indentLevel: 0,
      pure: false,
      map: void 0,
      helper(key) {
        return `_${helperNameMap[key]}`;
      },
      push(code, newlineIndex = -2, node) {
        context.code += code;
      },
      indent() {
        newline(++context.indentLevel);
      },
      deindent(withoutNewLine = false) {
        if (withoutNewLine) {
          --context.indentLevel;
        } else {
          newline(--context.indentLevel);
        }
      },
      newline() {
        newline(context.indentLevel);
      }
    };
    function newline(n) {
      context.push(
        "\n" + `  `.repeat(n),
        0
        /* Start */
      );
    }
    return context;
  }
  function generate(ast, options = {}) {
    const context = createCodegenContext(ast, options);
    if (options.onContextCreated) options.onContextCreated(context);
    const {
      mode,
      push,
      prefixIdentifiers,
      indent,
      deindent,
      newline,
      scopeId,
      ssr
    } = context;
    const helpers = Array.from(ast.helpers);
    const hasHelpers = helpers.length > 0;
    const useWithBlock = !prefixIdentifiers && mode !== "module";
    const preambleContext = context;
    {
      genFunctionPreamble(ast, preambleContext);
    }
    const functionName = ssr ? `ssrRender` : `render`;
    const args = ssr ? ["_ctx", "_push", "_parent", "_attrs"] : ["_ctx", "_cache"];
    const signature = args.join(", ");
    {
      push(`function ${functionName}(${signature}) {`);
    }
    indent();
    if (useWithBlock) {
      push(`with (_ctx) {`);
      indent();
      if (hasHelpers) {
        push(
          `const { ${helpers.map(aliasHelper).join(", ")} } = _Vue
`,
          -1
          /* End */
        );
        newline();
      }
    }
    if (ast.components.length) {
      genAssets(ast.components, "component", context);
      if (ast.directives.length || ast.temps > 0) {
        newline();
      }
    }
    if (ast.directives.length) {
      genAssets(ast.directives, "directive", context);
      if (ast.temps > 0) {
        newline();
      }
    }
    if (ast.filters && ast.filters.length) {
      newline();
      genAssets(ast.filters, "filter", context);
      newline();
    }
    if (ast.temps > 0) {
      push(`let `);
      for (let i2 = 0; i2 < ast.temps; i2++) {
        push(`${i2 > 0 ? `, ` : ``}_temp${i2}`);
      }
    }
    if (ast.components.length || ast.directives.length || ast.temps) {
      push(
        `
`,
        0
        /* Start */
      );
      newline();
    }
    if (!ssr) {
      push(`return `);
    }
    if (ast.codegenNode) {
      genNode(ast.codegenNode, context);
    } else {
      push(`null`);
    }
    if (useWithBlock) {
      deindent();
      push(`}`);
    }
    deindent();
    push(`}`);
    return {
      ast,
      code: context.code,
      preamble: ``,
      map: context.map ? context.map.toJSON() : void 0
    };
  }
  function genFunctionPreamble(ast, context) {
    const {
      ssr,
      prefixIdentifiers,
      push,
      newline,
      runtimeModuleName,
      runtimeGlobalName,
      ssrRuntimeModuleName
    } = context;
    const VueBinding = runtimeGlobalName;
    const helpers = Array.from(ast.helpers);
    if (helpers.length > 0) {
      {
        push(
          `const _Vue = ${VueBinding}
`,
          -1
          /* End */
        );
        if (ast.hoists.length) {
          const staticHelpers = [
            CREATE_VNODE,
            CREATE_ELEMENT_VNODE,
            CREATE_COMMENT,
            CREATE_TEXT,
            CREATE_STATIC
          ].filter((helper) => helpers.includes(helper)).map(aliasHelper).join(", ");
          push(
            `const { ${staticHelpers} } = _Vue
`,
            -1
            /* End */
          );
        }
      }
    }
    genHoists(ast.hoists, context);
    newline();
    push(`return `);
  }
  function genAssets(assets, type, { helper, push, newline, isTS }) {
    const resolver = helper(
      type === "filter" ? RESOLVE_FILTER : type === "component" ? RESOLVE_COMPONENT : RESOLVE_DIRECTIVE
    );
    for (let i2 = 0; i2 < assets.length; i2++) {
      let id = assets[i2];
      const maybeSelfReference = id.endsWith("__self");
      if (maybeSelfReference) {
        id = id.slice(0, -6);
      }
      push(
        `const ${toValidAssetId(id, type)} = ${resolver}(${JSON.stringify(id)}${maybeSelfReference ? `, true` : ``})${isTS ? `!` : ``}`
      );
      if (i2 < assets.length - 1) {
        newline();
      }
    }
  }
  function genHoists(hoists, context) {
    if (!hoists.length) {
      return;
    }
    context.pure = true;
    const { push, newline } = context;
    newline();
    for (let i2 = 0; i2 < hoists.length; i2++) {
      const exp = hoists[i2];
      if (exp) {
        push(`const _hoisted_${i2 + 1} = `);
        genNode(exp, context);
        newline();
      }
    }
    context.pure = false;
  }
  function isText(n) {
    return isString(n) || n.type === 4 || n.type === 2 || n.type === 5 || n.type === 8;
  }
  function genNodeListAsArray(nodes, context) {
    const multilines = nodes.length > 3 || nodes.some((n) => isArray(n) || !isText(n));
    context.push(`[`);
    multilines && context.indent();
    genNodeList(nodes, context, multilines);
    multilines && context.deindent();
    context.push(`]`);
  }
  function genNodeList(nodes, context, multilines = false, comma = true) {
    const { push, newline } = context;
    for (let i2 = 0; i2 < nodes.length; i2++) {
      const node = nodes[i2];
      if (isString(node)) {
        push(
          node,
          -3
          /* Unknown */
        );
      } else if (isArray(node)) {
        genNodeListAsArray(node, context);
      } else {
        genNode(node, context);
      }
      if (i2 < nodes.length - 1) {
        if (multilines) {
          comma && push(",");
          newline();
        } else {
          comma && push(", ");
        }
      }
    }
  }
  function genNode(node, context) {
    if (isString(node)) {
      context.push(
        node,
        -3
        /* Unknown */
      );
      return;
    }
    if (isSymbol(node)) {
      context.push(context.helper(node));
      return;
    }
    switch (node.type) {
      case 1:
      case 9:
      case 11:
        assert(
          node.codegenNode != null,
          `Codegen node is missing for element/if/for node. Apply appropriate transforms first.`
        );
        genNode(node.codegenNode, context);
        break;
      case 2:
        genText(node, context);
        break;
      case 4:
        genExpression(node, context);
        break;
      case 5:
        genInterpolation(node, context);
        break;
      case 12:
        genNode(node.codegenNode, context);
        break;
      case 8:
        genCompoundExpression(node, context);
        break;
      case 3:
        genComment(node, context);
        break;
      case 13:
        genVNodeCall(node, context);
        break;
      case 14:
        genCallExpression(node, context);
        break;
      case 15:
        genObjectExpression(node, context);
        break;
      case 17:
        genArrayExpression(node, context);
        break;
      case 18:
        genFunctionExpression(node, context);
        break;
      case 19:
        genConditionalExpression(node, context);
        break;
      case 20:
        genCacheExpression(node, context);
        break;
      case 21:
        genNodeList(node.body, context, true, false);
        break;
      // SSR only types
      case 22:
        break;
      case 23:
        break;
      case 24:
        break;
      case 25:
        break;
      case 26:
        break;
      /* v8 ignore start */
      case 10:
        break;
      default:
        if (true) {
          assert(false, `unhandled codegen node type: ${node.type}`);
          const exhaustiveCheck = node;
          return exhaustiveCheck;
        }
    }
  }
  function genText(node, context) {
    context.push(JSON.stringify(node.content), -3, node);
  }
  function genExpression(node, context) {
    const { content, isStatic } = node;
    context.push(
      isStatic ? JSON.stringify(content) : content,
      -3,
      node
    );
  }
  function genInterpolation(node, context) {
    const { push, helper, pure } = context;
    if (pure) push(PURE_ANNOTATION);
    push(`${helper(TO_DISPLAY_STRING)}(`);
    genNode(node.content, context);
    push(`)`);
  }
  function genCompoundExpression(node, context) {
    for (let i2 = 0; i2 < node.children.length; i2++) {
      const child = node.children[i2];
      if (isString(child)) {
        context.push(
          child,
          -3
          /* Unknown */
        );
      } else {
        genNode(child, context);
      }
    }
  }
  function genExpressionAsPropertyKey(node, context) {
    const { push } = context;
    if (node.type === 8) {
      push(`[`);
      genCompoundExpression(node, context);
      push(`]`);
    } else if (node.isStatic) {
      const text = isSimpleIdentifier(node.content) ? node.content : JSON.stringify(node.content);
      push(text, -2, node);
    } else {
      push(`[${node.content}]`, -3, node);
    }
  }
  function genComment(node, context) {
    const { push, helper, pure } = context;
    if (pure) {
      push(PURE_ANNOTATION);
    }
    push(
      `${helper(CREATE_COMMENT)}(${JSON.stringify(node.content)})`,
      -3,
      node
    );
  }
  function genVNodeCall(node, context) {
    const { push, helper, pure } = context;
    const {
      tag,
      props,
      children,
      patchFlag,
      dynamicProps,
      directives,
      isBlock,
      disableTracking,
      isComponent: isComponent2
    } = node;
    let patchFlagString;
    if (patchFlag) {
      if (true) {
        if (patchFlag < 0) {
          patchFlagString = patchFlag + ` /* ${PatchFlagNames[patchFlag]} */`;
        } else {
          const flagNames = Object.keys(PatchFlagNames).map(Number).filter((n) => n > 0 && patchFlag & n).map((n) => PatchFlagNames[n]).join(`, `);
          patchFlagString = patchFlag + ` /* ${flagNames} */`;
        }
      } else {
        patchFlagString = String(patchFlag);
      }
    }
    if (directives) {
      push(helper(WITH_DIRECTIVES) + `(`);
    }
    if (isBlock) {
      push(`(${helper(OPEN_BLOCK)}(${disableTracking ? `true` : ``}), `);
    }
    if (pure) {
      push(PURE_ANNOTATION);
    }
    const callHelper = isBlock ? getVNodeBlockHelper(context.inSSR, isComponent2) : getVNodeHelper(context.inSSR, isComponent2);
    push(helper(callHelper) + `(`, -2, node);
    genNodeList(
      genNullableArgs([tag, props, children, patchFlagString, dynamicProps]),
      context
    );
    push(`)`);
    if (isBlock) {
      push(`)`);
    }
    if (directives) {
      push(`, `);
      genNode(directives, context);
      push(`)`);
    }
  }
  function genNullableArgs(args) {
    let i2 = args.length;
    while (i2--) {
      if (args[i2] != null) break;
    }
    return args.slice(0, i2 + 1).map((arg) => arg || `null`);
  }
  function genCallExpression(node, context) {
    const { push, helper, pure } = context;
    const callee = isString(node.callee) ? node.callee : helper(node.callee);
    if (pure) {
      push(PURE_ANNOTATION);
    }
    push(callee + `(`, -2, node);
    genNodeList(node.arguments, context);
    push(`)`);
  }
  function genObjectExpression(node, context) {
    const { push, indent, deindent, newline } = context;
    const { properties } = node;
    if (!properties.length) {
      push(`{}`, -2, node);
      return;
    }
    const multilines = properties.length > 1 || properties.some((p2) => p2.value.type !== 4);
    push(multilines ? `{` : `{ `);
    multilines && indent();
    for (let i2 = 0; i2 < properties.length; i2++) {
      const { key, value } = properties[i2];
      genExpressionAsPropertyKey(key, context);
      push(`: `);
      genNode(value, context);
      if (i2 < properties.length - 1) {
        push(`,`);
        newline();
      }
    }
    multilines && deindent();
    push(multilines ? `}` : ` }`);
  }
  function genArrayExpression(node, context) {
    genNodeListAsArray(node.elements, context);
  }
  function genFunctionExpression(node, context) {
    const { push, indent, deindent } = context;
    const { params, returns, body, newline, isSlot } = node;
    if (isSlot) {
      push(`_${helperNameMap[WITH_CTX]}(`);
    }
    push(`(`, -2, node);
    if (isArray(params)) {
      genNodeList(params, context);
    } else if (params) {
      genNode(params, context);
    }
    push(`) => `);
    if (newline || body) {
      push(`{`);
      indent();
    }
    if (returns) {
      if (newline) {
        push(`return `);
      }
      if (isArray(returns)) {
        genNodeListAsArray(returns, context);
      } else {
        genNode(returns, context);
      }
    } else if (body) {
      genNode(body, context);
    }
    if (newline || body) {
      deindent();
      push(`}`);
    }
    if (isSlot) {
      if (node.isNonScopedSlot) {
        push(`, undefined, true`);
      }
      push(`)`);
    }
  }
  function genConditionalExpression(node, context) {
    const { test: test2, consequent, alternate, newline: needNewline } = node;
    const { push, indent, deindent, newline } = context;
    if (test2.type === 4) {
      const needsParens = !isSimpleIdentifier(test2.content);
      needsParens && push(`(`);
      genExpression(test2, context);
      needsParens && push(`)`);
    } else {
      push(`(`);
      genNode(test2, context);
      push(`)`);
    }
    needNewline && indent();
    context.indentLevel++;
    needNewline || push(` `);
    push(`? `);
    genNode(consequent, context);
    context.indentLevel--;
    needNewline && newline();
    needNewline || push(` `);
    push(`: `);
    const isNested = alternate.type === 19;
    if (!isNested) {
      context.indentLevel++;
    }
    genNode(alternate, context);
    if (!isNested) {
      context.indentLevel--;
    }
    needNewline && deindent(
      true
      /* without newline */
    );
  }
  function genCacheExpression(node, context) {
    const { push, helper, indent, deindent, newline } = context;
    const { needPauseTracking, needArraySpread } = node;
    if (needArraySpread) {
      push(`[...(`);
    }
    push(`_cache[${node.index}] || (`);
    if (needPauseTracking) {
      indent();
      push(`${helper(SET_BLOCK_TRACKING)}(-1`);
      if (node.inVOnce) push(`, true`);
      push(`),`);
      newline();
      push(`(`);
    }
    push(`_cache[${node.index}] = `);
    genNode(node.value, context);
    if (needPauseTracking) {
      push(`).cacheIndex = ${node.index},`);
      newline();
      push(`${helper(SET_BLOCK_TRACKING)}(1),`);
      newline();
      push(`_cache[${node.index}]`);
      deindent();
    }
    push(`)`);
    if (needArraySpread) {
      push(`)]`);
    }
  }
  function validateBrowserExpression(node, context, asParams = false, asRawStatements = false) {
    const exp = node.content;
    if (!exp.trim()) {
      return;
    }
    try {
      new Function(
        asRawStatements ? ` ${exp} ` : `return ${asParams ? `(${exp}) => {}` : `(${exp})`}`
      );
    } catch (e) {
      let message = e.message;
      const keywordMatch = exp.replace(stripStringRE, "").match(prohibitedKeywordRE);
      if (keywordMatch) {
        message = `avoid using JavaScript keyword as property name: "${keywordMatch[0]}"`;
      }
      context.onError(
        createCompilerError(
          46,
          node.loc,
          void 0,
          message
        )
      );
    }
  }
  function processExpression(node, context, asParams = false, asRawStatements = false, localVars = Object.create(context.identifiers)) {
    {
      if (true) {
        validateBrowserExpression(node, context, asParams, asRawStatements);
      }
      return node;
    }
  }
  function processIf(node, dir, context, processCodegen) {
    if (dir.name !== "else" && (!dir.exp || !dir.exp.content.trim())) {
      const loc = dir.exp ? dir.exp.loc : node.loc;
      context.onError(
        createCompilerError(28, dir.loc)
      );
      dir.exp = createSimpleExpression(`true`, false, loc);
    }
    if (dir.exp) {
      validateBrowserExpression(dir.exp, context);
    }
    if (dir.name === "if") {
      const branch = createIfBranch(node, dir);
      const ifNode = {
        type: 9,
        loc: cloneLoc(node.loc),
        branches: [branch]
      };
      context.replaceNode(ifNode);
      if (processCodegen) {
        return processCodegen(ifNode, branch, true);
      }
    } else {
      const siblings = context.parent.children;
      const comments = [];
      let i2 = siblings.indexOf(node);
      while (i2-- >= -1) {
        const sibling = siblings[i2];
        if (sibling && isCommentOrWhitespace(sibling)) {
          context.removeNode(sibling);
          if (sibling.type === 3) {
            comments.unshift(sibling);
          }
          continue;
        }
        if (sibling && sibling.type === 9) {
          if ((dir.name === "else-if" || dir.name === "else") && sibling.branches[sibling.branches.length - 1].condition === void 0) {
            context.onError(
              createCompilerError(30, node.loc)
            );
          }
          context.removeNode();
          const branch = createIfBranch(node, dir);
          if (comments.length && // #3619 ignore comments if the v-if is direct child of <transition>
          !(context.parent && context.parent.type === 1 && (context.parent.tag === "transition" || context.parent.tag === "Transition"))) {
            branch.children = [...comments, ...branch.children];
          }
          if (true) {
            const key = branch.userKey;
            if (key) {
              sibling.branches.forEach(({ userKey }) => {
                if (isSameKey(userKey, key)) {
                  context.onError(
                    createCompilerError(
                      29,
                      branch.userKey.loc
                    )
                  );
                }
              });
            }
          }
          sibling.branches.push(branch);
          const onExit = processCodegen && processCodegen(sibling, branch, false);
          traverseNode(branch, context);
          if (onExit) onExit();
          context.currentNode = null;
        } else {
          context.onError(
            createCompilerError(30, node.loc)
          );
        }
        break;
      }
    }
  }
  function createIfBranch(node, dir) {
    const isTemplateIf = node.tagType === 3;
    return {
      type: 10,
      loc: node.loc,
      condition: dir.name === "else" ? void 0 : dir.exp,
      children: isTemplateIf && !findDir(node, "for") ? node.children : [node],
      userKey: findProp(node, `key`),
      isTemplateIf
    };
  }
  function createCodegenNodeForBranch(branch, keyIndex, context) {
    if (branch.condition) {
      return createConditionalExpression(
        branch.condition,
        createChildrenCodegenNode(branch, keyIndex, context),
        // make sure to pass in asBlock: true so that the comment node call
        // closes the current block.
        createCallExpression(context.helper(CREATE_COMMENT), [
          true ? '"v-if"' : '""',
          "true"
        ])
      );
    } else {
      return createChildrenCodegenNode(branch, keyIndex, context);
    }
  }
  function createChildrenCodegenNode(branch, keyIndex, context) {
    const { helper } = context;
    const keyProperty = createObjectProperty(
      `key`,
      createSimpleExpression(
        `${keyIndex}`,
        false,
        locStub,
        2
      )
    );
    const { children } = branch;
    const firstChild = children[0];
    const needFragmentWrapper = children.length !== 1 || firstChild.type !== 1;
    if (needFragmentWrapper) {
      if (children.length === 1 && firstChild.type === 11) {
        const vnodeCall = firstChild.codegenNode;
        injectProp(vnodeCall, keyProperty, context);
        return vnodeCall;
      } else {
        let patchFlag = 64;
        if (!branch.isTemplateIf && children.filter((c) => c.type !== 3).length === 1) {
          patchFlag |= 2048;
        }
        return createVNodeCall(
          context,
          helper(FRAGMENT),
          createObjectExpression([keyProperty]),
          children,
          patchFlag,
          void 0,
          void 0,
          true,
          false,
          false,
          branch.loc
        );
      }
    } else {
      const ret = firstChild.codegenNode;
      const vnodeCall = getMemoedVNodeCall(ret);
      if (vnodeCall.type === 13) {
        convertToBlock(vnodeCall, context);
      }
      injectProp(vnodeCall, keyProperty, context);
      return ret;
    }
  }
  function isSameKey(a, b2) {
    if (!a || a.type !== b2.type) {
      return false;
    }
    if (a.type === 6) {
      if (a.value.content !== b2.value.content) {
        return false;
      }
    } else {
      const exp = a.exp;
      const branchExp = b2.exp;
      if (exp.type !== branchExp.type) {
        return false;
      }
      if (exp.type !== 4 || exp.isStatic !== branchExp.isStatic || exp.content !== branchExp.content) {
        return false;
      }
    }
    return true;
  }
  function getParentCondition(node) {
    while (true) {
      if (node.type === 19) {
        if (node.alternate.type === 19) {
          node = node.alternate;
        } else {
          return node;
        }
      } else if (node.type === 20) {
        node = node.value;
      }
    }
  }
  function processFor(node, dir, context, processCodegen) {
    if (!dir.exp) {
      context.onError(
        createCompilerError(31, dir.loc)
      );
      return;
    }
    const parseResult = dir.forParseResult;
    if (!parseResult) {
      context.onError(
        createCompilerError(32, dir.loc)
      );
      return;
    }
    finalizeForParseResult(parseResult, context);
    const { addIdentifiers, removeIdentifiers, scopes } = context;
    const { source, value, key, index } = parseResult;
    const forNode = {
      type: 11,
      loc: dir.loc,
      source,
      valueAlias: value,
      keyAlias: key,
      objectIndexAlias: index,
      parseResult,
      children: isTemplateNode(node) ? node.children : [node]
    };
    context.replaceNode(forNode);
    scopes.vFor++;
    const onExit = processCodegen && processCodegen(forNode);
    return () => {
      scopes.vFor--;
      if (onExit) onExit();
    };
  }
  function finalizeForParseResult(result, context) {
    if (result.finalized) return;
    if (true) {
      validateBrowserExpression(result.source, context);
      if (result.key) {
        validateBrowserExpression(
          result.key,
          context,
          true
        );
      }
      if (result.index) {
        validateBrowserExpression(
          result.index,
          context,
          true
        );
      }
      if (result.value) {
        validateBrowserExpression(
          result.value,
          context,
          true
        );
      }
    }
    result.finalized = true;
  }
  function createForLoopParams({ value, key, index }, memoArgs = []) {
    return createParamsList([value, key, index, ...memoArgs]);
  }
  function createParamsList(args) {
    let i2 = args.length;
    while (i2--) {
      if (args[i2]) break;
    }
    return args.slice(0, i2 + 1).map((arg, i22) => arg || createSimpleExpression(`_`.repeat(i22 + 1), false));
  }
  function buildSlots(node, context, buildSlotFn = buildClientSlotFn) {
    context.helper(WITH_CTX);
    const { children, loc } = node;
    const slotsProperties = [];
    const dynamicSlots = [];
    let hasDynamicSlots = context.scopes.vSlot > 0 || context.scopes.vFor > 0;
    const onComponentSlot = findDir(node, "slot", true);
    if (onComponentSlot) {
      const { arg, exp } = onComponentSlot;
      if (arg && !isStaticExp(arg)) {
        hasDynamicSlots = true;
      }
      slotsProperties.push(
        createObjectProperty(
          arg || createSimpleExpression("default", true),
          buildSlotFn(exp, void 0, children, loc)
        )
      );
    }
    let hasTemplateSlots = false;
    let hasNamedDefaultSlot = false;
    const implicitDefaultChildren = [];
    const seenSlotNames = /* @__PURE__ */ new Set();
    let conditionalBranchIndex = 0;
    for (let i2 = 0; i2 < children.length; i2++) {
      const slotElement = children[i2];
      let slotDir;
      if (!isTemplateNode(slotElement) || !(slotDir = findDir(slotElement, "slot", true))) {
        if (slotElement.type !== 3) {
          implicitDefaultChildren.push(slotElement);
        }
        continue;
      }
      if (onComponentSlot) {
        context.onError(
          createCompilerError(37, slotDir.loc)
        );
        break;
      }
      hasTemplateSlots = true;
      const { children: slotChildren, loc: slotLoc } = slotElement;
      const {
        arg: slotName = createSimpleExpression(`default`, true),
        exp: slotProps,
        loc: dirLoc
      } = slotDir;
      let staticSlotName;
      if (isStaticExp(slotName)) {
        staticSlotName = slotName ? slotName.content : `default`;
      } else {
        hasDynamicSlots = true;
      }
      const vFor = findDir(slotElement, "for");
      const slotFunction = buildSlotFn(slotProps, vFor, slotChildren, slotLoc);
      let vIf;
      let vElse;
      if (vIf = findDir(slotElement, "if")) {
        hasDynamicSlots = true;
        dynamicSlots.push(
          createConditionalExpression(
            vIf.exp,
            buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++),
            defaultFallback
          )
        );
      } else if (vElse = findDir(
        slotElement,
        /^else(?:-if)?$/,
        true
        /* allowEmpty */
      )) {
        let j = i2;
        let prev;
        while (j--) {
          prev = children[j];
          if (!isCommentOrWhitespace(prev)) {
            break;
          }
        }
        if (prev && isTemplateNode(prev) && findDir(prev, /^(?:else-)?if$/)) {
          let conditional = dynamicSlots[dynamicSlots.length - 1];
          while (conditional.alternate.type === 19) {
            conditional = conditional.alternate;
          }
          conditional.alternate = vElse.exp ? createConditionalExpression(
            vElse.exp,
            buildDynamicSlot(
              slotName,
              slotFunction,
              conditionalBranchIndex++
            ),
            defaultFallback
          ) : buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++);
        } else {
          context.onError(
            createCompilerError(30, vElse.loc)
          );
        }
      } else if (vFor) {
        hasDynamicSlots = true;
        const parseResult = vFor.forParseResult;
        if (parseResult) {
          finalizeForParseResult(parseResult, context);
          dynamicSlots.push(
            createCallExpression(context.helper(RENDER_LIST), [
              parseResult.source,
              createFunctionExpression(
                createForLoopParams(parseResult),
                buildDynamicSlot(slotName, slotFunction),
                true
              )
            ])
          );
        } else {
          context.onError(
            createCompilerError(
              32,
              vFor.loc
            )
          );
        }
      } else {
        if (staticSlotName) {
          if (seenSlotNames.has(staticSlotName)) {
            context.onError(
              createCompilerError(
                38,
                dirLoc
              )
            );
            continue;
          }
          seenSlotNames.add(staticSlotName);
          if (staticSlotName === "default") {
            hasNamedDefaultSlot = true;
          }
        }
        slotsProperties.push(createObjectProperty(slotName, slotFunction));
      }
    }
    if (!onComponentSlot) {
      const buildDefaultSlotProperty = (props, children2) => {
        const fn = buildSlotFn(props, void 0, children2, loc);
        if (context.compatConfig) {
          fn.isNonScopedSlot = true;
        }
        return createObjectProperty(`default`, fn);
      };
      if (!hasTemplateSlots) {
        slotsProperties.push(buildDefaultSlotProperty(void 0, children));
      } else if (implicitDefaultChildren.length && // #3766
      // with whitespace: 'preserve', whitespaces between slots will end up in
      // implicitDefaultChildren. Ignore if all implicit children are whitespaces.
      !implicitDefaultChildren.every(isWhitespaceText)) {
        if (hasNamedDefaultSlot) {
          context.onError(
            createCompilerError(
              39,
              implicitDefaultChildren[0].loc
            )
          );
        } else {
          slotsProperties.push(
            buildDefaultSlotProperty(void 0, implicitDefaultChildren)
          );
        }
      }
    }
    const slotFlag = hasDynamicSlots ? 2 : hasForwardedSlots(node.children) ? 3 : 1;
    let slots = createObjectExpression(
      slotsProperties.concat(
        createObjectProperty(
          `_`,
          // 2 = compiled but dynamic = can skip normalization, but must run diff
          // 1 = compiled and static = can skip normalization AND diff as optimized
          createSimpleExpression(
            slotFlag + (true ? ` /* ${slotFlagsText[slotFlag]} */` : ``),
            false
          )
        )
      ),
      loc
    );
    if (dynamicSlots.length) {
      slots = createCallExpression(context.helper(CREATE_SLOTS), [
        slots,
        createArrayExpression(dynamicSlots)
      ]);
    }
    return {
      slots,
      hasDynamicSlots
    };
  }
  function buildDynamicSlot(name, fn, index) {
    const props = [
      createObjectProperty(`name`, name),
      createObjectProperty(`fn`, fn)
    ];
    if (index != null) {
      props.push(
        createObjectProperty(`key`, createSimpleExpression(String(index), true))
      );
    }
    return createObjectExpression(props);
  }
  function hasForwardedSlots(children) {
    for (let i2 = 0; i2 < children.length; i2++) {
      const child = children[i2];
      switch (child.type) {
        case 1:
          if (child.tagType === 2 || hasForwardedSlots(child.children)) {
            return true;
          }
          break;
        case 9:
          if (hasForwardedSlots(child.branches)) return true;
          break;
        case 10:
        case 11:
          if (hasForwardedSlots(child.children)) return true;
          break;
      }
    }
    return false;
  }
  function resolveComponentType(node, context, ssr = false) {
    let { tag } = node;
    const isExplicitDynamic = isComponentTag(tag);
    const isProp = findProp(
      node,
      "is",
      false,
      true
      /* allow empty */
    );
    if (isProp) {
      if (isExplicitDynamic || isCompatEnabled(
        "COMPILER_IS_ON_ELEMENT",
        context
      )) {
        let exp;
        if (isProp.type === 6) {
          exp = isProp.value && createSimpleExpression(isProp.value.content, true);
        } else {
          exp = isProp.exp;
          if (!exp) {
            exp = createSimpleExpression(`is`, false, isProp.arg.loc);
          }
        }
        if (exp) {
          return createCallExpression(context.helper(RESOLVE_DYNAMIC_COMPONENT), [
            exp
          ]);
        }
      } else if (isProp.type === 6 && isProp.value.content.startsWith("vue:")) {
        tag = isProp.value.content.slice(4);
      }
    }
    const builtIn = isCoreComponent(tag) || context.isBuiltInComponent(tag);
    if (builtIn) {
      if (!ssr) context.helper(builtIn);
      return builtIn;
    }
    context.helper(RESOLVE_COMPONENT);
    context.components.add(tag);
    return toValidAssetId(tag, `component`);
  }
  function buildProps(node, context, props = node.props, isComponent2, isDynamicComponent, ssr = false) {
    const { tag, loc: elementLoc, children } = node;
    let properties = [];
    const mergeArgs = [];
    const runtimeDirectives = [];
    const hasChildren = children.length > 0;
    let shouldUseBlock = false;
    let isBlockRequired = false;
    let patchFlag = 0;
    let hasRef = false;
    let hasClassBinding = false;
    let hasStyleBinding = false;
    let hasHydrationEventBinding = false;
    let hasDynamicKeys = false;
    let hasVnodeHook = false;
    const dynamicPropNames = [];
    const pushMergeArg = (arg) => {
      if (properties.length) {
        mergeArgs.push(
          createObjectExpression(dedupeProperties(properties), elementLoc)
        );
        properties = [];
      }
      if (arg) mergeArgs.push(arg);
    };
    const pushRefVForMarker = () => {
      if (context.scopes.vFor > 0) {
        properties.push(
          createObjectProperty(
            createSimpleExpression("ref_for", true),
            createSimpleExpression("true")
          )
        );
      }
    };
    const analyzePatchFlag = ({ key, value }) => {
      if (isStaticExp(key)) {
        const name = key.content;
        const isEventHandler = isOn(name);
        if (isEventHandler && (!isComponent2 || isDynamicComponent) && // omit the flag for click handlers because hydration gives click
        // dedicated fast path.
        name.toLowerCase() !== "onclick" && // omit v-model handlers
        name !== "onUpdate:modelValue" && // omit onVnodeXXX hooks
        !isReservedProp(name)) {
          hasHydrationEventBinding = true;
        }
        if (isEventHandler && isReservedProp(name)) {
          hasVnodeHook = true;
        }
        if (name === "ref") {
          hasRef = true;
        }
        if (isEventHandler && value.type === 14) {
          value = value.arguments[0];
        }
        if (value.type === 20 || (value.type === 4 || value.type === 8) && getConstantType(value, context) > 0) {
          return;
        }
        if (name === "class") {
          hasClassBinding = true;
        } else if (name === "style") {
          hasStyleBinding = true;
        } else if (name !== "ref" && name !== "key" && !dynamicPropNames.includes(name)) {
          dynamicPropNames.push(name);
        }
        if (isComponent2 && (name === "class" || name === "style") && !dynamicPropNames.includes(name)) {
          dynamicPropNames.push(name);
        }
      } else {
        hasDynamicKeys = true;
      }
    };
    for (let i2 = 0; i2 < props.length; i2++) {
      const prop = props[i2];
      if (prop.type === 6) {
        const { loc, name, nameLoc, value } = prop;
        let isStatic = true;
        if (name === "ref") {
          hasRef = true;
          pushRefVForMarker();
        }
        if (name === "is" && (isComponentTag(tag) || value && value.content.startsWith("vue:") || isCompatEnabled(
          "COMPILER_IS_ON_ELEMENT",
          context
        ))) {
          continue;
        }
        properties.push(
          createObjectProperty(
            createSimpleExpression(name, true, nameLoc),
            createSimpleExpression(
              value ? value.content : "",
              isStatic,
              value ? value.loc : loc
            )
          )
        );
      } else {
        const { name, arg, exp, loc, modifiers } = prop;
        const isVBind = name === "bind";
        const isVOn = name === "on";
        if (name === "slot") {
          if (!isComponent2) {
            context.onError(
              createCompilerError(40, loc)
            );
          }
          continue;
        }
        if (name === "once" || name === "memo") {
          continue;
        }
        if (name === "is" || isVBind && isStaticArgOf(arg, "is") && (isComponentTag(tag) || isCompatEnabled(
          "COMPILER_IS_ON_ELEMENT",
          context
        ))) {
          continue;
        }
        if (isVOn && ssr) {
          continue;
        }
        if (isVBind && isStaticArgOf(arg, "key")) {
          shouldUseBlock = true;
        }
        if (isVOn && hasChildren && arg && isStaticExp(arg) && camelize(arg.content) === "vue:beforeUpdate") {
          shouldUseBlock = true;
          isBlockRequired = true;
        }
        if (isVBind && isStaticArgOf(arg, "ref")) {
          pushRefVForMarker();
        }
        if (!arg && (isVBind || isVOn)) {
          hasDynamicKeys = true;
          if (exp) {
            if (isVBind) {
              {
                pushMergeArg();
                if (true) {
                  const hasOverridableKeys = mergeArgs.some((arg2) => {
                    if (arg2.type === 15) {
                      return arg2.properties.some(({ key }) => {
                        if (key.type !== 4 || !key.isStatic) {
                          return true;
                        }
                        return key.content !== "class" && key.content !== "style" && !isOn(key.content);
                      });
                    } else {
                      return true;
                    }
                  });
                  if (hasOverridableKeys) {
                    checkCompatEnabled(
                      "COMPILER_V_BIND_OBJECT_ORDER",
                      context,
                      loc
                    );
                  }
                }
                if (isCompatEnabled(
                  "COMPILER_V_BIND_OBJECT_ORDER",
                  context
                )) {
                  mergeArgs.unshift(exp);
                  continue;
                }
              }
              pushRefVForMarker();
              pushMergeArg();
              mergeArgs.push(exp);
            } else {
              pushMergeArg({
                type: 14,
                loc,
                callee: context.helper(TO_HANDLERS),
                arguments: isComponent2 ? [exp] : [exp, `true`]
              });
            }
          } else {
            context.onError(
              createCompilerError(
                isVBind ? 34 : 35,
                loc
              )
            );
          }
          continue;
        }
        if (isVBind && modifiers.some((mod) => mod.content === "prop")) {
          patchFlag |= 32;
        }
        const directiveTransform = context.directiveTransforms[name];
        if (directiveTransform) {
          const { props: props2, needRuntime } = directiveTransform(prop, node, context);
          !ssr && props2.forEach(analyzePatchFlag);
          if (isVOn && arg && !isStaticExp(arg)) {
            pushMergeArg(createObjectExpression(props2, elementLoc));
          } else {
            properties.push(...props2);
          }
          if (needRuntime) {
            runtimeDirectives.push(prop);
            if (isSymbol(needRuntime)) {
              directiveImportMap.set(prop, needRuntime);
            }
          }
        } else if (!isBuiltInDirective(name)) {
          runtimeDirectives.push(prop);
          if (hasChildren) {
            shouldUseBlock = true;
            isBlockRequired = true;
          }
        }
      }
    }
    let propsExpression = void 0;
    if (mergeArgs.length) {
      pushMergeArg();
      if (mergeArgs.length > 1) {
        propsExpression = createCallExpression(
          context.helper(MERGE_PROPS),
          mergeArgs,
          elementLoc
        );
      } else {
        propsExpression = mergeArgs[0];
      }
    } else if (properties.length) {
      propsExpression = createObjectExpression(
        dedupeProperties(properties),
        elementLoc
      );
    }
    if (hasDynamicKeys) {
      patchFlag |= 16;
    } else {
      if (hasClassBinding && !isComponent2) {
        patchFlag |= 2;
      }
      if (hasStyleBinding && !isComponent2) {
        patchFlag |= 4;
      }
      if (dynamicPropNames.length) {
        patchFlag |= 8;
      }
      if (hasHydrationEventBinding) {
        patchFlag |= 32;
      }
    }
    const needsPatch = (patchFlag === 0 || patchFlag === 32) && (hasRef || hasVnodeHook || runtimeDirectives.length > 0);
    if (!shouldUseBlock && needsPatch) {
      patchFlag |= 512;
    }
    if (!context.inSSR && propsExpression) {
      switch (propsExpression.type) {
        case 15:
          let classKeyIndex = -1;
          let styleKeyIndex = -1;
          let hasDynamicKey = false;
          for (let i2 = 0; i2 < propsExpression.properties.length; i2++) {
            const key = propsExpression.properties[i2].key;
            if (isStaticExp(key)) {
              if (key.content === "class") {
                classKeyIndex = i2;
              } else if (key.content === "style") {
                styleKeyIndex = i2;
              }
            } else if (!key.isHandlerKey) {
              hasDynamicKey = true;
            }
          }
          const classProp = propsExpression.properties[classKeyIndex];
          const styleProp = propsExpression.properties[styleKeyIndex];
          if (!hasDynamicKey) {
            if (classProp && !isStaticExp(classProp.value)) {
              classProp.value = createCallExpression(
                context.helper(NORMALIZE_CLASS),
                [classProp.value]
              );
            }
            if (styleProp && // the static style is compiled into an object,
            // so use `hasStyleBinding` to ensure that it is a dynamic style binding
            (hasStyleBinding || styleProp.value.type === 4 && styleProp.value.content.trim()[0] === `[` || // v-bind:style and style both exist,
            // v-bind:style with static literal object
            styleProp.value.type === 17)) {
              styleProp.value = createCallExpression(
                context.helper(NORMALIZE_STYLE),
                [styleProp.value]
              );
            }
          } else {
            propsExpression = createCallExpression(
              context.helper(NORMALIZE_PROPS),
              [propsExpression]
            );
          }
          break;
        case 14:
          break;
        default:
          propsExpression = createCallExpression(
            context.helper(NORMALIZE_PROPS),
            [
              createCallExpression(context.helper(GUARD_REACTIVE_PROPS), [
                propsExpression
              ])
            ]
          );
          break;
      }
    }
    return {
      props: propsExpression,
      directives: runtimeDirectives,
      patchFlag,
      dynamicPropNames,
      shouldUseBlock,
      needsPatch,
      isBlockRequired
    };
  }
  function dedupeProperties(properties) {
    const knownProps = /* @__PURE__ */ new Map();
    const deduped = [];
    for (let i2 = 0; i2 < properties.length; i2++) {
      const prop = properties[i2];
      if (prop.key.type === 8 || !prop.key.isStatic) {
        deduped.push(prop);
        continue;
      }
      const name = prop.key.content;
      const existing = knownProps.get(name);
      if (existing) {
        if (name === "style" || name === "class" || isOn(name)) {
          mergeAsArray2(existing, prop);
        }
      } else {
        knownProps.set(name, prop);
        deduped.push(prop);
      }
    }
    return deduped;
  }
  function mergeAsArray2(existing, incoming) {
    if (existing.value.type === 17) {
      existing.value.elements.push(incoming.value);
    } else {
      existing.value = createArrayExpression(
        [existing.value, incoming.value],
        existing.loc
      );
    }
  }
  function buildDirectiveArgs(dir, context) {
    const dirArgs = [];
    const runtime = directiveImportMap.get(dir);
    if (runtime) {
      dirArgs.push(context.helperString(runtime));
    } else {
      {
        context.helper(RESOLVE_DIRECTIVE);
        context.directives.add(dir.name);
        dirArgs.push(toValidAssetId(dir.name, `directive`));
      }
    }
    const { loc } = dir;
    if (dir.exp) dirArgs.push(dir.exp);
    if (dir.arg) {
      if (!dir.exp) {
        dirArgs.push(`void 0`);
      }
      dirArgs.push(dir.arg);
    }
    if (Object.keys(dir.modifiers).length) {
      if (!dir.arg) {
        if (!dir.exp) {
          dirArgs.push(`void 0`);
        }
        dirArgs.push(`void 0`);
      }
      const trueExpression = createSimpleExpression(`true`, false, loc);
      dirArgs.push(
        createObjectExpression(
          dir.modifiers.map(
            (modifier) => createObjectProperty(modifier, trueExpression)
          ),
          loc
        )
      );
    }
    return createArrayExpression(dirArgs, dir.loc);
  }
  function stringifyDynamicPropNames(props) {
    let propsNamesString = `[`;
    for (let i2 = 0, l = props.length; i2 < l; i2++) {
      propsNamesString += JSON.stringify(props[i2]);
      if (i2 < l - 1) propsNamesString += ", ";
    }
    return propsNamesString + `]`;
  }
  function isComponentTag(tag) {
    return tag === "component" || tag === "Component";
  }
  function processSlotOutlet(node, context) {
    let slotName = `"default"`;
    let slotProps = void 0;
    const nonNameProps = [];
    for (let i2 = 0; i2 < node.props.length; i2++) {
      const p2 = node.props[i2];
      if (p2.type === 6) {
        if (p2.value) {
          if (p2.name === "name") {
            slotName = JSON.stringify(p2.value.content);
          } else {
            p2.name = camelize(p2.name);
            nonNameProps.push(p2);
          }
        }
      } else {
        if (p2.name === "bind" && isStaticArgOf(p2.arg, "name")) {
          if (p2.exp) {
            slotName = p2.exp;
          } else if (p2.arg && p2.arg.type === 4) {
            const name = camelize(p2.arg.content);
            slotName = p2.exp = createSimpleExpression(name, false, p2.arg.loc);
          }
        } else {
          if (p2.name === "bind" && p2.arg && isStaticExp(p2.arg)) {
            p2.arg.content = camelize(p2.arg.content);
          }
          nonNameProps.push(p2);
        }
      }
    }
    if (nonNameProps.length > 0) {
      const { props, directives } = buildProps(
        node,
        context,
        nonNameProps,
        false,
        false
      );
      slotProps = props;
      if (directives.length) {
        context.onError(
          createCompilerError(
            36,
            directives[0].loc
          )
        );
      }
    }
    return {
      slotName,
      slotProps
    };
  }
  function createTransformProps(props = []) {
    return { props };
  }
  function rewriteFilter(node, context) {
    if (node.type === 4) {
      parseFilter(node, context);
    } else {
      for (let i2 = 0; i2 < node.children.length; i2++) {
        const child = node.children[i2];
        if (typeof child !== "object") continue;
        if (child.type === 4) {
          parseFilter(child, context);
        } else if (child.type === 8) {
          rewriteFilter(child, context);
        } else if (child.type === 5) {
          rewriteFilter(child.content, context);
        }
      }
    }
  }
  function parseFilter(node, context) {
    const exp = node.content;
    let inSingle = false;
    let inDouble = false;
    let inTemplateString = false;
    let inRegex = false;
    let curly = 0;
    let square = 0;
    let paren = 0;
    let lastFilterIndex = 0;
    let c, prev, i2, expression, filters = [];
    for (i2 = 0; i2 < exp.length; i2++) {
      prev = c;
      c = exp.charCodeAt(i2);
      if (inSingle) {
        if (c === 39 && prev !== 92) inSingle = false;
      } else if (inDouble) {
        if (c === 34 && prev !== 92) inDouble = false;
      } else if (inTemplateString) {
        if (c === 96 && prev !== 92) inTemplateString = false;
      } else if (inRegex) {
        if (c === 47 && prev !== 92) inRegex = false;
      } else if (c === 124 && // pipe
      exp.charCodeAt(i2 + 1) !== 124 && exp.charCodeAt(i2 - 1) !== 124 && !curly && !square && !paren) {
        if (expression === void 0) {
          lastFilterIndex = i2 + 1;
          expression = exp.slice(0, i2).trim();
        } else {
          pushFilter();
        }
      } else {
        switch (c) {
          case 34:
            inDouble = true;
            break;
          // "
          case 39:
            inSingle = true;
            break;
          // '
          case 96:
            inTemplateString = true;
            break;
          // `
          case 40:
            paren++;
            break;
          // (
          case 41:
            paren--;
            break;
          // )
          case 91:
            square++;
            break;
          // [
          case 93:
            square--;
            break;
          // ]
          case 123:
            curly++;
            break;
          // {
          case 125:
            curly--;
            break;
        }
        if (c === 47) {
          let j = i2 - 1;
          let p2;
          for (; j >= 0; j--) {
            p2 = exp.charAt(j);
            if (p2 !== " ") break;
          }
          if (!p2 || !validDivisionCharRE.test(p2)) {
            inRegex = true;
          }
        }
      }
    }
    if (expression === void 0) {
      expression = exp.slice(0, i2).trim();
    } else if (lastFilterIndex !== 0) {
      pushFilter();
    }
    function pushFilter() {
      filters.push(exp.slice(lastFilterIndex, i2).trim());
      lastFilterIndex = i2 + 1;
    }
    if (filters.length) {
      warnDeprecation(
        "COMPILER_FILTERS",
        context,
        node.loc
      );
      for (i2 = 0; i2 < filters.length; i2++) {
        expression = wrapFilter(expression, filters[i2], context);
      }
      node.content = expression;
      node.ast = void 0;
    }
  }
  function wrapFilter(exp, filter5, context) {
    context.helper(RESOLVE_FILTER);
    const i2 = filter5.indexOf("(");
    if (i2 < 0) {
      context.filters.add(filter5);
      return `${toValidAssetId(filter5, "filter")}(${exp})`;
    } else {
      const name = filter5.slice(0, i2);
      const args = filter5.slice(i2 + 1);
      context.filters.add(name);
      return `${toValidAssetId(name, "filter")}(${exp}${args !== ")" ? "," + args : args}`;
    }
  }
  function getBaseTransformPreset(prefixIdentifiers) {
    return [
      [
        transformVBindShorthand,
        transformOnce,
        transformIf,
        transformMemo,
        transformFor,
        ...[transformFilter],
        ...true ? [transformExpression] : [],
        transformSlotOutlet,
        transformElement,
        trackSlotScopes,
        transformText
      ],
      {
        on: transformOn,
        bind: transformBind,
        model: transformModel
      }
    ];
  }
  function baseCompile(source, options = {}) {
    const onError = options.onError || defaultOnError;
    const isModuleMode = options.mode === "module";
    {
      if (options.prefixIdentifiers === true) {
        onError(createCompilerError(48));
      } else if (isModuleMode) {
        onError(createCompilerError(49));
      }
    }
    const prefixIdentifiers = false;
    if (options.cacheHandlers) {
      onError(createCompilerError(50));
    }
    if (options.scopeId && !isModuleMode) {
      onError(createCompilerError(51));
    }
    const resolvedOptions = extend({}, options, {
      prefixIdentifiers
    });
    const ast = isString(source) ? baseParse(source, resolvedOptions) : source;
    const [nodeTransforms, directiveTransforms] = getBaseTransformPreset();
    transform(
      ast,
      extend({}, resolvedOptions, {
        nodeTransforms: [
          ...nodeTransforms,
          ...options.nodeTransforms || []
          // user transforms
        ],
        directiveTransforms: extend(
          {},
          directiveTransforms,
          options.directiveTransforms || {}
          // user transforms
        )
      })
    );
    return generate(ast, resolvedOptions);
  }
  var FRAGMENT, TELEPORT, SUSPENSE, KEEP_ALIVE, BASE_TRANSITION, OPEN_BLOCK, CREATE_BLOCK, CREATE_ELEMENT_BLOCK, CREATE_VNODE, CREATE_ELEMENT_VNODE, CREATE_COMMENT, CREATE_TEXT, CREATE_STATIC, RESOLVE_COMPONENT, RESOLVE_DYNAMIC_COMPONENT, RESOLVE_DIRECTIVE, RESOLVE_FILTER, WITH_DIRECTIVES, RENDER_LIST, RENDER_SLOT, CREATE_SLOTS, TO_DISPLAY_STRING, MERGE_PROPS, NORMALIZE_CLASS, NORMALIZE_STYLE, NORMALIZE_PROPS, GUARD_REACTIVE_PROPS, TO_HANDLERS, CAMELIZE, CAPITALIZE, TO_HANDLER_KEY, SET_BLOCK_TRACKING, PUSH_SCOPE_ID, POP_SCOPE_ID, WITH_CTX, UNREF, IS_REF, WITH_MEMO, IS_MEMO_SAME, helperNameMap, locStub, defaultDelimitersOpen, defaultDelimitersClose, Sequences, Tokenizer, deprecationData, errorMessages, isStaticExp, nonIdentifierRE, isSimpleIdentifier, validFirstIdentCharRE, validIdentCharRE, whitespaceRE, getExpSource, isMemberExpressionBrowser, isMemberExpression, fnExpRE, isFnExpressionBrowser, isFnExpression, propsHelperSet, forAliasRE, defaultParserOptions, currentOptions, currentRoot, currentInput, currentOpenTag, currentProp, currentAttrValue, currentAttrStartIndex, currentAttrEndIndex, inPre, inVPre, currentVPreBoundary, stack2, tokenizer, forIteratorRE, stripParensRE, specialTemplateDir, windowsNewlineRE, allowHoistedHelperSet, PURE_ANNOTATION, aliasHelper, prohibitedKeywordRE, stripStringRE, transformExpression, transformIf, transformFor, defaultFallback, trackSlotScopes, buildClientSlotFn, directiveImportMap, transformElement, transformSlotOutlet, transformOn, transformBind, injectPrefix, transformText, seen$1, transformOnce, transformModel, validDivisionCharRE, transformFilter, seen, transformMemo, transformVBindShorthand, noopDirectiveTransform;
  var init_compiler_core_esm_bundler = __esm({
    "node_modules/@vue/compiler-core/dist/compiler-core.esm-bundler.js"() {
      init_shared_esm_bundler();
      /**
      * @vue/compiler-core v3.5.41
      * (c) 2018-present Yuxi (Evan) You and Vue contributors
      * @license MIT
      **/
      FRAGMENT = /* @__PURE__ */ Symbol(true ? `Fragment` : ``);
      TELEPORT = /* @__PURE__ */ Symbol(true ? `Teleport` : ``);
      SUSPENSE = /* @__PURE__ */ Symbol(true ? `Suspense` : ``);
      KEEP_ALIVE = /* @__PURE__ */ Symbol(true ? `KeepAlive` : ``);
      BASE_TRANSITION = /* @__PURE__ */ Symbol(
        true ? `BaseTransition` : ``
      );
      OPEN_BLOCK = /* @__PURE__ */ Symbol(true ? `openBlock` : ``);
      CREATE_BLOCK = /* @__PURE__ */ Symbol(true ? `createBlock` : ``);
      CREATE_ELEMENT_BLOCK = /* @__PURE__ */ Symbol(
        true ? `createElementBlock` : ``
      );
      CREATE_VNODE = /* @__PURE__ */ Symbol(true ? `createVNode` : ``);
      CREATE_ELEMENT_VNODE = /* @__PURE__ */ Symbol(
        true ? `createElementVNode` : ``
      );
      CREATE_COMMENT = /* @__PURE__ */ Symbol(
        true ? `createCommentVNode` : ``
      );
      CREATE_TEXT = /* @__PURE__ */ Symbol(
        true ? `createTextVNode` : ``
      );
      CREATE_STATIC = /* @__PURE__ */ Symbol(
        true ? `createStaticVNode` : ``
      );
      RESOLVE_COMPONENT = /* @__PURE__ */ Symbol(
        true ? `resolveComponent` : ``
      );
      RESOLVE_DYNAMIC_COMPONENT = /* @__PURE__ */ Symbol(
        true ? `resolveDynamicComponent` : ``
      );
      RESOLVE_DIRECTIVE = /* @__PURE__ */ Symbol(
        true ? `resolveDirective` : ``
      );
      RESOLVE_FILTER = /* @__PURE__ */ Symbol(
        true ? `resolveFilter` : ``
      );
      WITH_DIRECTIVES = /* @__PURE__ */ Symbol(
        true ? `withDirectives` : ``
      );
      RENDER_LIST = /* @__PURE__ */ Symbol(true ? `renderList` : ``);
      RENDER_SLOT = /* @__PURE__ */ Symbol(true ? `renderSlot` : ``);
      CREATE_SLOTS = /* @__PURE__ */ Symbol(true ? `createSlots` : ``);
      TO_DISPLAY_STRING = /* @__PURE__ */ Symbol(
        true ? `toDisplayString` : ``
      );
      MERGE_PROPS = /* @__PURE__ */ Symbol(true ? `mergeProps` : ``);
      NORMALIZE_CLASS = /* @__PURE__ */ Symbol(
        true ? `normalizeClass` : ``
      );
      NORMALIZE_STYLE = /* @__PURE__ */ Symbol(
        true ? `normalizeStyle` : ``
      );
      NORMALIZE_PROPS = /* @__PURE__ */ Symbol(
        true ? `normalizeProps` : ``
      );
      GUARD_REACTIVE_PROPS = /* @__PURE__ */ Symbol(
        true ? `guardReactiveProps` : ``
      );
      TO_HANDLERS = /* @__PURE__ */ Symbol(true ? `toHandlers` : ``);
      CAMELIZE = /* @__PURE__ */ Symbol(true ? `camelize` : ``);
      CAPITALIZE = /* @__PURE__ */ Symbol(true ? `capitalize` : ``);
      TO_HANDLER_KEY = /* @__PURE__ */ Symbol(
        true ? `toHandlerKey` : ``
      );
      SET_BLOCK_TRACKING = /* @__PURE__ */ Symbol(
        true ? `setBlockTracking` : ``
      );
      PUSH_SCOPE_ID = /* @__PURE__ */ Symbol(true ? `pushScopeId` : ``);
      POP_SCOPE_ID = /* @__PURE__ */ Symbol(true ? `popScopeId` : ``);
      WITH_CTX = /* @__PURE__ */ Symbol(true ? `withCtx` : ``);
      UNREF = /* @__PURE__ */ Symbol(true ? `unref` : ``);
      IS_REF = /* @__PURE__ */ Symbol(true ? `isRef` : ``);
      WITH_MEMO = /* @__PURE__ */ Symbol(true ? `withMemo` : ``);
      IS_MEMO_SAME = /* @__PURE__ */ Symbol(true ? `isMemoSame` : ``);
      helperNameMap = {
        [FRAGMENT]: `Fragment`,
        [TELEPORT]: `Teleport`,
        [SUSPENSE]: `Suspense`,
        [KEEP_ALIVE]: `KeepAlive`,
        [BASE_TRANSITION]: `BaseTransition`,
        [OPEN_BLOCK]: `openBlock`,
        [CREATE_BLOCK]: `createBlock`,
        [CREATE_ELEMENT_BLOCK]: `createElementBlock`,
        [CREATE_VNODE]: `createVNode`,
        [CREATE_ELEMENT_VNODE]: `createElementVNode`,
        [CREATE_COMMENT]: `createCommentVNode`,
        [CREATE_TEXT]: `createTextVNode`,
        [CREATE_STATIC]: `createStaticVNode`,
        [RESOLVE_COMPONENT]: `resolveComponent`,
        [RESOLVE_DYNAMIC_COMPONENT]: `resolveDynamicComponent`,
        [RESOLVE_DIRECTIVE]: `resolveDirective`,
        [RESOLVE_FILTER]: `resolveFilter`,
        [WITH_DIRECTIVES]: `withDirectives`,
        [RENDER_LIST]: `renderList`,
        [RENDER_SLOT]: `renderSlot`,
        [CREATE_SLOTS]: `createSlots`,
        [TO_DISPLAY_STRING]: `toDisplayString`,
        [MERGE_PROPS]: `mergeProps`,
        [NORMALIZE_CLASS]: `normalizeClass`,
        [NORMALIZE_STYLE]: `normalizeStyle`,
        [NORMALIZE_PROPS]: `normalizeProps`,
        [GUARD_REACTIVE_PROPS]: `guardReactiveProps`,
        [TO_HANDLERS]: `toHandlers`,
        [CAMELIZE]: `camelize`,
        [CAPITALIZE]: `capitalize`,
        [TO_HANDLER_KEY]: `toHandlerKey`,
        [SET_BLOCK_TRACKING]: `setBlockTracking`,
        [PUSH_SCOPE_ID]: `pushScopeId`,
        [POP_SCOPE_ID]: `popScopeId`,
        [WITH_CTX]: `withCtx`,
        [UNREF]: `unref`,
        [IS_REF]: `isRef`,
        [WITH_MEMO]: `withMemo`,
        [IS_MEMO_SAME]: `isMemoSame`
      };
      locStub = {
        start: { line: 1, column: 1, offset: 0 },
        end: { line: 1, column: 1, offset: 0 },
        source: ""
      };
      defaultDelimitersOpen = new Uint8Array([123, 123]);
      defaultDelimitersClose = new Uint8Array([125, 125]);
      Sequences = {
        Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
        // CDATA[
        CdataEnd: new Uint8Array([93, 93, 62]),
        // ]]>
        CommentEnd: new Uint8Array([45, 45, 62]),
        // `-->`
        ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
        // `<\/script`
        StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
        // `</style`
        TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101]),
        // `</title`
        TextareaEnd: new Uint8Array([
          60,
          47,
          116,
          101,
          120,
          116,
          97,
          114,
          101,
          97
        ])
        // `</textarea
      };
      Tokenizer = class {
        constructor(stack3, cbs) {
          this.stack = stack3;
          this.cbs = cbs;
          this.state = 1;
          this.buffer = "";
          this.sectionStart = 0;
          this.index = 0;
          this.entityStart = 0;
          this.baseState = 1;
          this.inRCDATA = false;
          this.inXML = false;
          this.inVPre = false;
          this.newlines = [];
          this.mode = 0;
          this.delimiterOpen = defaultDelimitersOpen;
          this.delimiterClose = defaultDelimitersClose;
          this.delimiterIndex = -1;
          this.currentSequence = void 0;
          this.sequenceIndex = 0;
        }
        get inSFCRoot() {
          return this.mode === 2 && this.stack.length === 0;
        }
        reset() {
          this.state = 1;
          this.mode = 0;
          this.buffer = "";
          this.sectionStart = 0;
          this.index = 0;
          this.baseState = 1;
          this.inRCDATA = false;
          this.currentSequence = void 0;
          this.newlines.length = 0;
          this.delimiterOpen = defaultDelimitersOpen;
          this.delimiterClose = defaultDelimitersClose;
        }
        /**
         * Generate Position object with line / column information using recorded
         * newline positions. We know the index is always going to be an already
         * processed index, so all the newlines up to this index should have been
         * recorded.
         */
        getPos(index) {
          let line = 1;
          let column = index + 1;
          const length = this.newlines.length;
          let j = -1;
          if (length > 100) {
            let l = -1;
            let r = length;
            while (l + 1 < r) {
              const m = l + r >>> 1;
              this.newlines[m] < index ? l = m : r = m;
            }
            j = l;
          } else {
            for (let i2 = length - 1; i2 >= 0; i2--) {
              if (index > this.newlines[i2]) {
                j = i2;
                break;
              }
            }
          }
          if (j >= 0) {
            line = j + 2;
            column = index - this.newlines[j];
          }
          return {
            column,
            line,
            offset: index
          };
        }
        peek() {
          return this.buffer.charCodeAt(this.index + 1);
        }
        stateText(c) {
          if (c === 60) {
            if (this.index > this.sectionStart) {
              this.cbs.ontext(this.sectionStart, this.index);
            }
            this.state = 5;
            this.sectionStart = this.index;
          } else if (!this.inVPre && c === this.delimiterOpen[0]) {
            this.state = 2;
            this.delimiterIndex = 0;
            this.stateInterpolationOpen(c);
          }
        }
        stateInterpolationOpen(c) {
          if (c === this.delimiterOpen[this.delimiterIndex]) {
            if (this.delimiterIndex === this.delimiterOpen.length - 1) {
              const start = this.index + 1 - this.delimiterOpen.length;
              if (start > this.sectionStart) {
                this.cbs.ontext(this.sectionStart, start);
              }
              this.state = 3;
              this.sectionStart = start;
            } else {
              this.delimiterIndex++;
            }
          } else if (this.inRCDATA) {
            this.state = 32;
            this.stateInRCDATA(c);
          } else {
            this.state = 1;
            this.stateText(c);
          }
        }
        stateInterpolation(c) {
          if (c === this.delimiterClose[0]) {
            this.state = 4;
            this.delimiterIndex = 0;
            this.stateInterpolationClose(c);
          }
        }
        stateInterpolationClose(c) {
          if (c === this.delimiterClose[this.delimiterIndex]) {
            if (this.delimiterIndex === this.delimiterClose.length - 1) {
              this.cbs.oninterpolation(this.sectionStart, this.index + 1);
              if (this.inRCDATA) {
                this.state = 32;
              } else {
                this.state = 1;
              }
              this.sectionStart = this.index + 1;
            } else {
              this.delimiterIndex++;
            }
          } else {
            this.state = 3;
            this.stateInterpolation(c);
          }
        }
        stateSpecialStartSequence(c) {
          const isEnd = this.sequenceIndex === this.currentSequence.length;
          const isMatch = isEnd ? (
            // If we are at the end of the sequence, make sure the tag name has ended
            isEndOfTagSection(c)
          ) : (
            // Otherwise, do a case-insensitive comparison
            (c | 32) === this.currentSequence[this.sequenceIndex]
          );
          if (!isMatch) {
            this.inRCDATA = false;
          } else if (!isEnd) {
            this.sequenceIndex++;
            return;
          }
          this.sequenceIndex = 0;
          this.state = 6;
          this.stateInTagName(c);
        }
        /** Look for an end tag. For <title> and <textarea>, also decode entities. */
        stateInRCDATA(c) {
          if (this.sequenceIndex === this.currentSequence.length) {
            if (c === 62 || isWhitespace(c)) {
              const endOfText = this.index - this.currentSequence.length;
              if (this.sectionStart < endOfText) {
                const actualIndex = this.index;
                this.index = endOfText;
                this.cbs.ontext(this.sectionStart, endOfText);
                this.index = actualIndex;
              }
              this.sectionStart = endOfText + 2;
              this.stateInClosingTagName(c);
              this.inRCDATA = false;
              return;
            }
            this.sequenceIndex = 0;
          }
          if ((c | 32) === this.currentSequence[this.sequenceIndex]) {
            this.sequenceIndex += 1;
          } else if (this.sequenceIndex === 0) {
            if (this.currentSequence === Sequences.TitleEnd || this.currentSequence === Sequences.TextareaEnd && !this.inSFCRoot) {
              if (!this.inVPre && c === this.delimiterOpen[0]) {
                this.state = 2;
                this.delimiterIndex = 0;
                this.stateInterpolationOpen(c);
              }
            } else if (this.fastForwardTo(60)) {
              this.sequenceIndex = 1;
            }
          } else {
            this.sequenceIndex = Number(c === 60);
          }
        }
        stateCDATASequence(c) {
          if (c === Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === Sequences.Cdata.length) {
              this.state = 28;
              this.currentSequence = Sequences.CdataEnd;
              this.sequenceIndex = 0;
              this.sectionStart = this.index + 1;
            }
          } else {
            this.sequenceIndex = 0;
            this.state = 23;
            this.stateInDeclaration(c);
          }
        }
        /**
         * When we wait for one specific character, we can speed things up
         * by skipping through the buffer until we find it.
         *
         * @returns Whether the character was found.
         */
        fastForwardTo(c) {
          while (++this.index < this.buffer.length) {
            const cc = this.buffer.charCodeAt(this.index);
            if (cc === 10) {
              this.newlines.push(this.index);
            }
            if (cc === c) {
              return true;
            }
          }
          this.index = this.buffer.length - 1;
          return false;
        }
        /**
         * Comments and CDATA end with `-->` and `]]>`.
         *
         * Their common qualities are:
         * - Their end sequences have a distinct character they start with.
         * - That character is then repeated, so we have to check multiple repeats.
         * - All characters but the start character of the sequence can be skipped.
         */
        stateInCommentLike(c) {
          if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
              if (this.currentSequence === Sequences.CdataEnd) {
                this.cbs.oncdata(this.sectionStart, this.index - 2);
              } else {
                this.cbs.oncomment(this.sectionStart, this.index - 2);
              }
              this.sequenceIndex = 0;
              this.sectionStart = this.index + 1;
              this.state = 1;
            }
          } else if (this.sequenceIndex === 0) {
            if (this.fastForwardTo(this.currentSequence[0])) {
              this.sequenceIndex = 1;
            }
          } else if (c !== this.currentSequence[this.sequenceIndex - 1]) {
            this.sequenceIndex = 0;
          }
        }
        startSpecial(sequence, offset) {
          this.enterRCDATA(sequence, offset);
          this.state = 31;
        }
        enterRCDATA(sequence, offset) {
          this.inRCDATA = true;
          this.currentSequence = sequence;
          this.sequenceIndex = offset;
        }
        stateBeforeTagName(c) {
          if (c === 33) {
            this.state = 22;
            this.sectionStart = this.index + 1;
          } else if (c === 63) {
            this.state = 24;
            this.sectionStart = this.index + 1;
          } else if (isTagStartChar(c)) {
            this.sectionStart = this.index;
            if (this.mode === 0) {
              this.state = 6;
            } else if (this.inSFCRoot) {
              this.state = 34;
            } else if (!this.inXML) {
              if (c === 116) {
                this.state = 30;
              } else {
                this.state = c === 115 ? 29 : 6;
              }
            } else {
              this.state = 6;
            }
          } else if (c === 47) {
            this.state = 8;
          } else {
            this.state = 1;
            this.stateText(c);
          }
        }
        stateInTagName(c) {
          if (isEndOfTagSection(c)) {
            this.handleTagName(c);
          }
        }
        stateInSFCRootTagName(c) {
          if (isEndOfTagSection(c)) {
            const tag = this.buffer.slice(this.sectionStart, this.index);
            if (tag !== "template") {
              this.enterRCDATA(toCharCodes(`</` + tag), 0);
            }
            this.handleTagName(c);
          }
        }
        handleTagName(c) {
          this.cbs.onopentagname(this.sectionStart, this.index);
          this.sectionStart = -1;
          this.state = 11;
          this.stateBeforeAttrName(c);
        }
        stateBeforeClosingTagName(c) {
          if (isWhitespace(c)) ;
          else if (c === 62) {
            if (true) {
              this.cbs.onerr(14, this.index);
            }
            this.state = 1;
            this.sectionStart = this.index + 1;
          } else {
            this.state = isTagStartChar(c) ? 9 : 27;
            this.sectionStart = this.index;
          }
        }
        stateInClosingTagName(c) {
          if (c === 62 || isWhitespace(c)) {
            this.cbs.onclosetag(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = 10;
            this.stateAfterClosingTagName(c);
          }
        }
        stateAfterClosingTagName(c) {
          if (c === 62) {
            this.state = 1;
            this.sectionStart = this.index + 1;
          }
        }
        stateBeforeAttrName(c) {
          if (c === 62) {
            this.cbs.onopentagend(this.index);
            if (this.inRCDATA) {
              this.state = 32;
            } else {
              this.state = 1;
            }
            this.sectionStart = this.index + 1;
          } else if (c === 47) {
            this.state = 7;
            if (this.peek() !== 62) {
              this.cbs.onerr(22, this.index);
            }
          } else if (c === 60 && this.peek() === 47) {
            this.cbs.onopentagend(this.index);
            this.state = 5;
            this.sectionStart = this.index;
          } else if (!isWhitespace(c)) {
            if (c === 61) {
              this.cbs.onerr(
                19,
                this.index
              );
            }
            this.handleAttrStart(c);
          }
        }
        handleAttrStart(c) {
          if (c === 118 && this.peek() === 45) {
            this.state = 13;
            this.sectionStart = this.index;
          } else if (c === 46 || c === 58 || c === 64 || c === 35) {
            this.cbs.ondirname(this.index, this.index + 1);
            this.state = 14;
            this.sectionStart = this.index + 1;
          } else {
            this.state = 12;
            this.sectionStart = this.index;
          }
        }
        stateInSelfClosingTag(c) {
          if (c === 62) {
            this.cbs.onselfclosingtag(this.index);
            this.state = 1;
            this.sectionStart = this.index + 1;
            this.inRCDATA = false;
          } else if (!isWhitespace(c)) {
            this.state = 11;
            this.stateBeforeAttrName(c);
          }
        }
        stateInAttrName(c) {
          if (c === 61 || isEndOfTagSection(c)) {
            this.cbs.onattribname(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
          } else if (c === 34 || c === 39 || c === 60) {
            this.cbs.onerr(
              17,
              this.index
            );
          }
        }
        stateInDirName(c) {
          if (c === 61 || isEndOfTagSection(c)) {
            this.cbs.ondirname(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
          } else if (c === 58) {
            this.cbs.ondirname(this.sectionStart, this.index);
            this.state = 14;
            this.sectionStart = this.index + 1;
          } else if (c === 46) {
            this.cbs.ondirname(this.sectionStart, this.index);
            this.state = 16;
            this.sectionStart = this.index + 1;
          }
        }
        stateInDirArg(c) {
          if (c === 61 || isEndOfTagSection(c)) {
            this.cbs.ondirarg(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
          } else if (c === 91) {
            this.state = 15;
          } else if (c === 46) {
            this.cbs.ondirarg(this.sectionStart, this.index);
            this.state = 16;
            this.sectionStart = this.index + 1;
          }
        }
        stateInDynamicDirArg(c) {
          if (c === 93) {
            this.state = 14;
          } else if (c === 61 || isEndOfTagSection(c)) {
            this.cbs.ondirarg(this.sectionStart, this.index + 1);
            this.handleAttrNameEnd(c);
            if (true) {
              this.cbs.onerr(
                27,
                this.index
              );
            }
          }
        }
        stateInDirModifier(c) {
          if (c === 61 || isEndOfTagSection(c)) {
            this.cbs.ondirmodifier(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
          } else if (c === 46) {
            this.cbs.ondirmodifier(this.sectionStart, this.index);
            this.sectionStart = this.index + 1;
          }
        }
        handleAttrNameEnd(c) {
          this.sectionStart = this.index;
          this.state = 17;
          this.cbs.onattribnameend(this.index);
          this.stateAfterAttrName(c);
        }
        stateAfterAttrName(c) {
          if (c === 61) {
            this.state = 18;
          } else if (c === 47 || c === 62) {
            this.cbs.onattribend(0, this.sectionStart);
            this.sectionStart = -1;
            this.state = 11;
            this.stateBeforeAttrName(c);
          } else if (!isWhitespace(c)) {
            this.cbs.onattribend(0, this.sectionStart);
            this.handleAttrStart(c);
          }
        }
        stateBeforeAttrValue(c) {
          if (c === 34) {
            this.state = 19;
            this.sectionStart = this.index + 1;
          } else if (c === 39) {
            this.state = 20;
            this.sectionStart = this.index + 1;
          } else if (!isWhitespace(c)) {
            this.sectionStart = this.index;
            this.state = 21;
            this.stateInAttrValueNoQuotes(c);
          }
        }
        handleInAttrValue(c, quote) {
          if (c === quote || this.fastForwardTo(quote)) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(
              quote === 34 ? 3 : 2,
              this.index + 1
            );
            this.state = 11;
          }
        }
        stateInAttrValueDoubleQuotes(c) {
          this.handleInAttrValue(c, 34);
        }
        stateInAttrValueSingleQuotes(c) {
          this.handleInAttrValue(c, 39);
        }
        stateInAttrValueNoQuotes(c) {
          if (isWhitespace(c) || c === 62) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(1, this.index);
            this.state = 11;
            this.stateBeforeAttrName(c);
          } else if (c === 34 || c === 39 || c === 60 || c === 61 || c === 96) {
            this.cbs.onerr(
              18,
              this.index
            );
          } else ;
        }
        stateBeforeDeclaration(c) {
          if (c === 91) {
            this.state = 26;
            this.sequenceIndex = 0;
          } else {
            this.state = c === 45 ? 25 : 23;
          }
        }
        stateInDeclaration(c) {
          if (c === 62 || this.fastForwardTo(62)) {
            this.state = 1;
            this.sectionStart = this.index + 1;
          }
        }
        stateInProcessingInstruction(c) {
          if (c === 62 || this.fastForwardTo(62)) {
            this.cbs.onprocessinginstruction(this.sectionStart, this.index);
            this.state = 1;
            this.sectionStart = this.index + 1;
          }
        }
        stateBeforeComment(c) {
          if (c === 45) {
            this.state = 28;
            this.currentSequence = Sequences.CommentEnd;
            this.sequenceIndex = 2;
            this.sectionStart = this.index + 1;
          } else {
            this.state = 23;
          }
        }
        stateInSpecialComment(c) {
          if (c === 62 || this.fastForwardTo(62)) {
            this.cbs.oncomment(this.sectionStart, this.index);
            this.state = 1;
            this.sectionStart = this.index + 1;
          }
        }
        stateBeforeSpecialS(c) {
          if (c === Sequences.ScriptEnd[3]) {
            this.startSpecial(Sequences.ScriptEnd, 4);
          } else if (c === Sequences.StyleEnd[3]) {
            this.startSpecial(Sequences.StyleEnd, 4);
          } else {
            this.state = 6;
            this.stateInTagName(c);
          }
        }
        stateBeforeSpecialT(c) {
          if (c === Sequences.TitleEnd[3]) {
            this.startSpecial(Sequences.TitleEnd, 4);
          } else if (c === Sequences.TextareaEnd[3]) {
            this.startSpecial(Sequences.TextareaEnd, 4);
          } else {
            this.state = 6;
            this.stateInTagName(c);
          }
        }
        startEntity() {
        }
        stateInEntity() {
        }
        /**
         * Iterates through the buffer, calling the function corresponding to the current state.
         *
         * States that are more likely to be hit are higher up, as a performance improvement.
         */
        parse(input) {
          this.buffer = input;
          while (this.index < this.buffer.length) {
            const c = this.buffer.charCodeAt(this.index);
            if (c === 10 && this.state !== 33) {
              this.newlines.push(this.index);
            }
            switch (this.state) {
              case 1: {
                this.stateText(c);
                break;
              }
              case 2: {
                this.stateInterpolationOpen(c);
                break;
              }
              case 3: {
                this.stateInterpolation(c);
                break;
              }
              case 4: {
                this.stateInterpolationClose(c);
                break;
              }
              case 31: {
                this.stateSpecialStartSequence(c);
                break;
              }
              case 32: {
                this.stateInRCDATA(c);
                break;
              }
              case 26: {
                this.stateCDATASequence(c);
                break;
              }
              case 19: {
                this.stateInAttrValueDoubleQuotes(c);
                break;
              }
              case 12: {
                this.stateInAttrName(c);
                break;
              }
              case 13: {
                this.stateInDirName(c);
                break;
              }
              case 14: {
                this.stateInDirArg(c);
                break;
              }
              case 15: {
                this.stateInDynamicDirArg(c);
                break;
              }
              case 16: {
                this.stateInDirModifier(c);
                break;
              }
              case 28: {
                this.stateInCommentLike(c);
                break;
              }
              case 27: {
                this.stateInSpecialComment(c);
                break;
              }
              case 11: {
                this.stateBeforeAttrName(c);
                break;
              }
              case 6: {
                this.stateInTagName(c);
                break;
              }
              case 34: {
                this.stateInSFCRootTagName(c);
                break;
              }
              case 9: {
                this.stateInClosingTagName(c);
                break;
              }
              case 5: {
                this.stateBeforeTagName(c);
                break;
              }
              case 17: {
                this.stateAfterAttrName(c);
                break;
              }
              case 20: {
                this.stateInAttrValueSingleQuotes(c);
                break;
              }
              case 18: {
                this.stateBeforeAttrValue(c);
                break;
              }
              case 8: {
                this.stateBeforeClosingTagName(c);
                break;
              }
              case 10: {
                this.stateAfterClosingTagName(c);
                break;
              }
              case 29: {
                this.stateBeforeSpecialS(c);
                break;
              }
              case 30: {
                this.stateBeforeSpecialT(c);
                break;
              }
              case 21: {
                this.stateInAttrValueNoQuotes(c);
                break;
              }
              case 7: {
                this.stateInSelfClosingTag(c);
                break;
              }
              case 23: {
                this.stateInDeclaration(c);
                break;
              }
              case 22: {
                this.stateBeforeDeclaration(c);
                break;
              }
              case 25: {
                this.stateBeforeComment(c);
                break;
              }
              case 24: {
                this.stateInProcessingInstruction(c);
                break;
              }
              case 33: {
                this.stateInEntity();
                break;
              }
            }
            this.index++;
          }
          this.cleanup();
          this.finish();
        }
        /**
         * Remove data that has already been consumed from the buffer.
         */
        cleanup() {
          if (this.sectionStart !== this.index) {
            if (this.state === 1 || this.state === 32 && this.sequenceIndex === 0) {
              this.cbs.ontext(this.sectionStart, this.index);
              this.sectionStart = this.index;
            } else if (this.state === 19 || this.state === 20 || this.state === 21) {
              this.cbs.onattribdata(this.sectionStart, this.index);
              this.sectionStart = this.index;
            }
          }
        }
        finish() {
          this.handleTrailingData();
          this.cbs.onend();
        }
        /** Handle any trailing data. */
        handleTrailingData() {
          const endIndex = this.buffer.length;
          if (this.sectionStart >= endIndex) {
            return;
          }
          if (this.state === 28) {
            if (this.currentSequence === Sequences.CdataEnd) {
              this.cbs.oncdata(this.sectionStart, endIndex);
            } else {
              this.cbs.oncomment(this.sectionStart, endIndex);
            }
          } else if (this.state === 6 || this.state === 11 || this.state === 18 || this.state === 17 || this.state === 12 || this.state === 13 || this.state === 14 || this.state === 15 || this.state === 16 || this.state === 20 || this.state === 19 || this.state === 21 || this.state === 9) ;
          else {
            this.cbs.ontext(this.sectionStart, endIndex);
          }
        }
        emitCodePoint(cp, consumed) {
        }
      };
      deprecationData = {
        ["COMPILER_IS_ON_ELEMENT"]: {
          message: `Platform-native elements with "is" prop will no longer be treated as components in Vue 3 unless the "is" value is explicitly prefixed with "vue:".`,
          link: `https://v3-migration.vuejs.org/breaking-changes/custom-elements-interop.html`
        },
        ["COMPILER_V_BIND_SYNC"]: {
          message: (key) => `.sync modifier for v-bind has been removed. Use v-model with argument instead. \`v-bind:${key}.sync\` should be changed to \`v-model:${key}\`.`,
          link: `https://v3-migration.vuejs.org/breaking-changes/v-model.html`
        },
        ["COMPILER_V_BIND_OBJECT_ORDER"]: {
          message: `v-bind="obj" usage is now order sensitive and behaves like JavaScript object spread: it will now overwrite an existing non-mergeable attribute that appears before v-bind in the case of conflict. To retain 2.x behavior, move v-bind to make it the first attribute. You can also suppress this warning if the usage is intended.`,
          link: `https://v3-migration.vuejs.org/breaking-changes/v-bind.html`
        },
        ["COMPILER_V_ON_NATIVE"]: {
          message: `.native modifier for v-on has been removed as is no longer necessary.`,
          link: `https://v3-migration.vuejs.org/breaking-changes/v-on-native-modifier-removed.html`
        },
        ["COMPILER_V_IF_V_FOR_PRECEDENCE"]: {
          message: `v-if / v-for precedence when used on the same element has changed in Vue 3: v-if now takes higher precedence and will no longer have access to v-for scope variables. It is best to avoid the ambiguity with <template> tags or use a computed property that filters v-for data source.`,
          link: `https://v3-migration.vuejs.org/breaking-changes/v-if-v-for.html`
        },
        ["COMPILER_NATIVE_TEMPLATE"]: {
          message: `<template> with no special directives will render as a native template element instead of its inner content in Vue 3.`
        },
        ["COMPILER_INLINE_TEMPLATE"]: {
          message: `"inline-template" has been removed in Vue 3.`,
          link: `https://v3-migration.vuejs.org/breaking-changes/inline-template-attribute.html`
        },
        ["COMPILER_FILTERS"]: {
          message: `filters have been removed in Vue 3. The "|" symbol will be treated as native JavaScript bitwise OR operator. Use method calls or computed properties instead.`,
          link: `https://v3-migration.vuejs.org/breaking-changes/filters.html`
        }
      };
      errorMessages = {
        // parse errors
        [0]: "Illegal comment.",
        [1]: "CDATA section is allowed only in XML context.",
        [2]: "Duplicate attribute.",
        [3]: "End tag cannot have attributes.",
        [4]: "Illegal '/' in tags.",
        [5]: "Unexpected EOF in tag.",
        [6]: "Unexpected EOF in CDATA section.",
        [7]: "Unexpected EOF in comment.",
        [8]: "Unexpected EOF in script.",
        [9]: "Unexpected EOF in tag.",
        [10]: "Incorrectly closed comment.",
        [11]: "Incorrectly opened comment.",
        [12]: "Illegal tag name. Use '&lt;' to print '<'.",
        [13]: "Attribute value was expected.",
        [14]: "End tag name was expected.",
        [15]: "Whitespace was expected.",
        [16]: "Unexpected '<!--' in comment.",
        [17]: `Attribute name cannot contain U+0022 ("), U+0027 ('), and U+003C (<).`,
        [18]: "Unquoted attribute value cannot contain U+0022 (\"), U+0027 ('), U+003C (<), U+003D (=), and U+0060 (`).",
        [19]: "Attribute name cannot start with '='.",
        [21]: "'<?' is allowed only in XML context.",
        [20]: `Unexpected null character.`,
        [22]: "Illegal '/' in tags.",
        // Vue-specific parse errors
        [23]: "Invalid end tag.",
        [24]: "Element is missing end tag.",
        [25]: "Interpolation end sign was not found.",
        [27]: "End bracket for dynamic directive argument was not found. Note that dynamic directive argument cannot contain spaces.",
        [26]: "Legal directive name was expected.",
        // transform errors
        [28]: `v-if/v-else-if is missing expression.`,
        [29]: `v-if/else branches must use unique keys.`,
        [30]: `v-else/v-else-if has no adjacent v-if or v-else-if.`,
        [31]: `v-for is missing expression.`,
        [32]: `v-for has invalid expression.`,
        [33]: `<template v-for> key should be placed on the <template> tag.`,
        [34]: `v-bind is missing expression.`,
        [53]: `v-bind with same-name shorthand only allows static argument.`,
        [35]: `v-on is missing expression.`,
        [36]: `Unexpected custom directive on <slot> outlet.`,
        [37]: `Mixed v-slot usage on both the component and nested <template>. When there are multiple named slots, all slots should use <template> syntax to avoid scope ambiguity.`,
        [38]: `Duplicate slot names found. `,
        [39]: `Extraneous children found when component already has explicitly named default slot. These children will be ignored.`,
        [40]: `v-slot can only be used on components or <template> tags.`,
        [41]: `v-model is missing expression.`,
        [42]: `v-model value must be a valid JavaScript member expression.`,
        [43]: `v-model cannot be used on v-for or v-slot scope variables because they are not writable.`,
        [44]: `v-model cannot be used on a prop, because local prop bindings are not writable.
Use a v-bind binding combined with a v-on listener that emits update:x event instead.`,
        [45]: `v-model cannot be used on a const binding because it is not writable.`,
        [46]: `Error parsing JavaScript expression: `,
        [47]: `<KeepAlive> expects exactly one child component.`,
        [52]: `@vnode-* hooks in templates are no longer supported. Use the vue: prefix instead. For example, @vnode-mounted should be changed to @vue:mounted. @vnode-* hooks support has been removed in 3.4.`,
        // generic errors
        [48]: `"prefixIdentifiers" option is not supported in this build of compiler.`,
        [49]: `ES module mode is not supported in this build of compiler.`,
        [50]: `"cacheHandlers" option is only supported when the "prefixIdentifiers" option is enabled.`,
        [51]: `"scopeId" option is only supported in module mode.`,
        // just to fulfill types
        [54]: ``
      };
      isStaticExp = (p2) => p2.type === 4 && p2.isStatic;
      nonIdentifierRE = /^$|^\d|[^\$\w\xA0-\uFFFF]/;
      isSimpleIdentifier = (name) => !nonIdentifierRE.test(name);
      validFirstIdentCharRE = /[A-Za-z_$\xA0-\uFFFF]/;
      validIdentCharRE = /[\.\?\w$\xA0-\uFFFF]/;
      whitespaceRE = /\s+[.[]\s*|\s*[.[]\s+/g;
      getExpSource = (exp) => exp.type === 4 ? exp.content : exp.loc.source;
      isMemberExpressionBrowser = (exp) => {
        const path = getExpSource(exp).trim().replace(whitespaceRE, (s) => s.trim());
        let state4 = 0;
        let stateStack = [];
        let currentOpenBracketCount = 0;
        let currentOpenParensCount = 0;
        let currentStringType = null;
        for (let i2 = 0; i2 < path.length; i2++) {
          const char = path.charAt(i2);
          switch (state4) {
            case 0:
              if (char === "[") {
                stateStack.push(state4);
                state4 = 1;
                currentOpenBracketCount++;
              } else if (char === "(") {
                stateStack.push(state4);
                state4 = 2;
                currentOpenParensCount++;
              } else if (!(i2 === 0 ? validFirstIdentCharRE : validIdentCharRE).test(char)) {
                return false;
              }
              break;
            case 1:
              if (char === `'` || char === `"` || char === "`") {
                stateStack.push(state4);
                state4 = 3;
                currentStringType = char;
              } else if (char === `[`) {
                currentOpenBracketCount++;
              } else if (char === `]`) {
                if (!--currentOpenBracketCount) {
                  state4 = stateStack.pop();
                }
              }
              break;
            case 2:
              if (char === `'` || char === `"` || char === "`") {
                stateStack.push(state4);
                state4 = 3;
                currentStringType = char;
              } else if (char === `(`) {
                currentOpenParensCount++;
              } else if (char === `)`) {
                if (i2 === path.length - 1) {
                  return false;
                }
                if (!--currentOpenParensCount) {
                  state4 = stateStack.pop();
                }
              }
              break;
            case 3:
              if (char === currentStringType) {
                state4 = stateStack.pop();
                currentStringType = null;
              }
              break;
          }
        }
        return !currentOpenBracketCount && !currentOpenParensCount;
      };
      isMemberExpression = isMemberExpressionBrowser;
      fnExpRE = /^\s*(?:async\s*)?(?:\([^)]*?\)|[\w$_]+)\s*(?::[^=]+)?=>|^\s*(?:async\s+)?function(?:\s+[\w$]+)?\s*\(/;
      isFnExpressionBrowser = (exp) => fnExpRE.test(getExpSource(exp));
      isFnExpression = isFnExpressionBrowser;
      propsHelperSet = /* @__PURE__ */ new Set([NORMALIZE_PROPS, GUARD_REACTIVE_PROPS]);
      forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+(\S[\s\S]*)/;
      defaultParserOptions = {
        parseMode: "base",
        ns: 0,
        delimiters: [`{{`, `}}`],
        getNamespace: () => 0,
        isVoidTag: NO,
        isPreTag: NO,
        isIgnoreNewlineTag: NO,
        isCustomElement: NO,
        onError: defaultOnError,
        onWarn: defaultOnWarn,
        comments: true,
        prefixIdentifiers: false
      };
      currentOptions = defaultParserOptions;
      currentRoot = null;
      currentInput = "";
      currentOpenTag = null;
      currentProp = null;
      currentAttrValue = "";
      currentAttrStartIndex = -1;
      currentAttrEndIndex = -1;
      inPre = 0;
      inVPre = false;
      currentVPreBoundary = null;
      stack2 = [];
      tokenizer = new Tokenizer(stack2, {
        onerr: emitError,
        ontext(start, end) {
          onText(getSlice(start, end), start, end);
        },
        ontextentity(char, start, end) {
          onText(char, start, end);
        },
        oninterpolation(start, end) {
          if (inVPre) {
            return onText(getSlice(start, end), start, end);
          }
          let innerStart = start + tokenizer.delimiterOpen.length;
          let innerEnd = end - tokenizer.delimiterClose.length;
          while (isWhitespace(currentInput.charCodeAt(innerStart))) {
            innerStart++;
          }
          while (isWhitespace(currentInput.charCodeAt(innerEnd - 1))) {
            innerEnd--;
          }
          let exp = getSlice(innerStart, innerEnd);
          if (exp.includes("&")) {
            {
              exp = currentOptions.decodeEntities(exp, false);
            }
          }
          addNode({
            type: 5,
            content: createExp(exp, false, getLoc(innerStart, innerEnd)),
            loc: getLoc(start, end)
          });
        },
        onopentagname(start, end) {
          const name = getSlice(start, end);
          currentOpenTag = {
            type: 1,
            tag: name,
            ns: currentOptions.getNamespace(name, stack2[0], currentOptions.ns),
            tagType: 0,
            // will be refined on tag close
            props: [],
            children: [],
            loc: getLoc(start - 1, end),
            codegenNode: void 0
          };
        },
        onopentagend(end) {
          endOpenTag(end);
        },
        onclosetag(start, end) {
          const name = getSlice(start, end);
          if (!currentOptions.isVoidTag(name)) {
            let found = false;
            for (let i2 = 0; i2 < stack2.length; i2++) {
              const e = stack2[i2];
              if (e.tag.toLowerCase() === name.toLowerCase()) {
                found = true;
                if (i2 > 0) {
                  emitError(24, stack2[0].loc.start.offset);
                }
                for (let j = 0; j <= i2; j++) {
                  const el = stack2.shift();
                  onCloseTag(el, end, j < i2);
                }
                break;
              }
            }
            if (!found) {
              emitError(23, backTrack(start, 60));
            }
          }
        },
        onselfclosingtag(end) {
          const name = currentOpenTag.tag;
          currentOpenTag.isSelfClosing = true;
          endOpenTag(end);
          if (stack2[0] && stack2[0].tag === name) {
            onCloseTag(stack2.shift(), end);
          }
        },
        onattribname(start, end) {
          currentProp = {
            type: 6,
            name: getSlice(start, end),
            nameLoc: getLoc(start, end),
            value: void 0,
            loc: getLoc(start)
          };
        },
        ondirname(start, end) {
          const raw = getSlice(start, end);
          const name = raw === "." || raw === ":" ? "bind" : raw === "@" ? "on" : raw === "#" ? "slot" : raw.slice(2);
          if (!inVPre && name === "") {
            emitError(26, start);
          }
          if (inVPre || name === "") {
            currentProp = {
              type: 6,
              name: raw,
              nameLoc: getLoc(start, end),
              value: void 0,
              loc: getLoc(start)
            };
          } else {
            currentProp = {
              type: 7,
              name,
              rawName: raw,
              exp: void 0,
              arg: void 0,
              modifiers: raw === "." ? [createSimpleExpression("prop")] : [],
              loc: getLoc(start)
            };
            if (name === "pre") {
              inVPre = tokenizer.inVPre = true;
              currentVPreBoundary = currentOpenTag;
              const props = currentOpenTag.props;
              for (let i2 = 0; i2 < props.length; i2++) {
                if (props[i2].type === 7) {
                  props[i2] = dirToAttr(props[i2]);
                }
              }
            }
          }
        },
        ondirarg(start, end) {
          if (start === end) return;
          const arg = getSlice(start, end);
          if (inVPre && !isVPre(currentProp)) {
            currentProp.name += arg;
            setLocEnd(currentProp.nameLoc, end);
          } else {
            const isStatic = arg[0] !== `[`;
            currentProp.arg = createExp(
              isStatic ? arg : arg.slice(1, -1),
              isStatic,
              getLoc(start, end),
              isStatic ? 3 : 0
            );
          }
        },
        ondirmodifier(start, end) {
          const mod = getSlice(start, end);
          if (inVPre && !isVPre(currentProp)) {
            currentProp.name += "." + mod;
            setLocEnd(currentProp.nameLoc, end);
          } else if (currentProp.name === "slot") {
            const arg = currentProp.arg;
            if (arg) {
              arg.content += "." + mod;
              setLocEnd(arg.loc, end);
            }
          } else {
            const exp = createSimpleExpression(mod, true, getLoc(start, end));
            currentProp.modifiers.push(exp);
          }
        },
        onattribdata(start, end) {
          currentAttrValue += getSlice(start, end);
          if (currentAttrStartIndex < 0) currentAttrStartIndex = start;
          currentAttrEndIndex = end;
        },
        onattribentity(char, start, end) {
          currentAttrValue += char;
          if (currentAttrStartIndex < 0) currentAttrStartIndex = start;
          currentAttrEndIndex = end;
        },
        onattribnameend(end) {
          const start = currentProp.loc.start.offset;
          const name = getSlice(start, end);
          if (currentProp.type === 7) {
            currentProp.rawName = name;
          }
          if (currentOpenTag.props.some(
            (p2) => (p2.type === 7 ? p2.rawName : p2.name) === name
          )) {
            emitError(2, start);
          }
        },
        onattribend(quote, end) {
          if (currentOpenTag && currentProp) {
            setLocEnd(currentProp.loc, end);
            if (quote !== 0) {
              if (currentAttrValue.includes("&")) {
                currentAttrValue = currentOptions.decodeEntities(
                  currentAttrValue,
                  true
                );
              }
              if (currentProp.type === 6) {
                if (currentProp.name === "class") {
                  currentAttrValue = condense(currentAttrValue).trim();
                }
                if (quote === 1 && !currentAttrValue) {
                  emitError(13, end);
                }
                currentProp.value = {
                  type: 2,
                  content: currentAttrValue,
                  loc: quote === 1 ? getLoc(currentAttrStartIndex, currentAttrEndIndex) : getLoc(currentAttrStartIndex - 1, currentAttrEndIndex + 1)
                };
                if (tokenizer.inSFCRoot && currentOpenTag.tag === "template" && currentProp.name === "lang" && currentAttrValue && currentAttrValue !== "html") {
                  tokenizer.enterRCDATA(toCharCodes(`</template`), 0);
                }
              } else {
                let expParseMode = 0;
                currentProp.exp = createExp(
                  currentAttrValue,
                  false,
                  getLoc(currentAttrStartIndex, currentAttrEndIndex),
                  0,
                  expParseMode
                );
                if (currentProp.name === "for") {
                  currentProp.forParseResult = parseForExpression(currentProp.exp);
                }
                let syncIndex = -1;
                if (currentProp.name === "bind" && (syncIndex = currentProp.modifiers.findIndex(
                  (mod) => mod.content === "sync"
                )) > -1 && checkCompatEnabled(
                  "COMPILER_V_BIND_SYNC",
                  currentOptions,
                  currentProp.loc,
                  currentProp.arg.loc.source
                )) {
                  currentProp.name = "model";
                  currentProp.modifiers.splice(syncIndex, 1);
                }
              }
            }
            if (currentProp.type !== 7 || currentProp.name !== "pre") {
              currentOpenTag.props.push(currentProp);
            }
          }
          currentAttrValue = "";
          currentAttrStartIndex = currentAttrEndIndex = -1;
        },
        oncomment(start, end) {
          if (currentOptions.comments) {
            addNode({
              type: 3,
              content: getSlice(start, end),
              loc: getLoc(start - 4, end + 3)
            });
          }
        },
        onend() {
          const end = currentInput.length;
          if (tokenizer.state !== 1) {
            switch (tokenizer.state) {
              case 5:
              case 8:
                emitError(5, end);
                break;
              case 3:
              case 4:
                emitError(
                  25,
                  tokenizer.sectionStart
                );
                break;
              case 28:
                if (tokenizer.currentSequence === Sequences.CdataEnd) {
                  emitError(6, end);
                } else {
                  emitError(7, end);
                }
                break;
              case 6:
              case 7:
              case 9:
              case 11:
              case 12:
              case 13:
              case 14:
              case 15:
              case 16:
              case 17:
              case 18:
              case 19:
              // "
              case 20:
              // '
              case 21:
                emitError(9, end);
                break;
            }
          }
          for (let index = 0; index < stack2.length; index++) {
            onCloseTag(stack2[index], end - 1);
            emitError(24, stack2[index].loc.start.offset);
          }
        },
        oncdata(start, end) {
          if ((stack2[0] ? stack2[0].ns : currentOptions.ns) !== 0) {
            onText(getSlice(start, end), start, end);
          } else {
            emitError(1, start - 9);
          }
        },
        onprocessinginstruction(start) {
          if ((stack2[0] ? stack2[0].ns : currentOptions.ns) === 0) {
            emitError(
              21,
              start - 1
            );
          }
        }
      });
      forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
      stripParensRE = /^\(|\)$/g;
      specialTemplateDir = /* @__PURE__ */ new Set(["if", "else", "else-if", "for", "slot"]);
      windowsNewlineRE = /\r\n/g;
      allowHoistedHelperSet = /* @__PURE__ */ new Set([
        NORMALIZE_CLASS,
        NORMALIZE_STYLE,
        NORMALIZE_PROPS,
        GUARD_REACTIVE_PROPS
      ]);
      PURE_ANNOTATION = `/*@__PURE__*/`;
      aliasHelper = (s) => `${helperNameMap[s]}: _${helperNameMap[s]}`;
      prohibitedKeywordRE = new RegExp(
        "\\b" + "arguments,await,break,case,catch,class,const,continue,debugger,default,delete,do,else,export,extends,finally,for,function,if,import,let,new,return,super,switch,throw,try,var,void,while,with,yield".split(",").join("\\b|\\b") + "\\b"
      );
      stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
      transformExpression = (node, context) => {
        if (node.type === 5) {
          node.content = processExpression(
            node.content,
            context
          );
        } else if (node.type === 1) {
          const memo = findDir(node, "memo");
          for (let i2 = 0; i2 < node.props.length; i2++) {
            const dir = node.props[i2];
            if (dir.type === 7 && dir.name !== "for") {
              const exp = dir.exp;
              const arg = dir.arg;
              if (exp && exp.type === 4 && !(dir.name === "on" && arg) && // key has been processed in transformFor(vMemo + vFor)
              !(memo && context.vForMemoKeyedNodes.has(node) && arg && arg.type === 4 && arg.content === "key")) {
                dir.exp = processExpression(
                  exp,
                  context,
                  // slot args must be processed as function params
                  dir.name === "slot"
                );
              }
              if (arg && arg.type === 4 && !arg.isStatic) {
                dir.arg = processExpression(arg, context);
              }
            }
          }
        }
      };
      transformIf = createStructuralDirectiveTransform(
        /^(?:if|else|else-if)$/,
        (node, dir, context) => {
          return processIf(node, dir, context, (ifNode, branch, isRoot) => {
            const siblings = context.parent.children;
            let i2 = siblings.indexOf(ifNode);
            let key = 0;
            while (i2-- >= 0) {
              const sibling = siblings[i2];
              if (sibling && sibling.type === 9) {
                key += sibling.branches.length;
              }
            }
            return () => {
              if (isRoot) {
                ifNode.codegenNode = createCodegenNodeForBranch(
                  branch,
                  key,
                  context
                );
              } else {
                const parentCondition = getParentCondition(ifNode.codegenNode);
                parentCondition.alternate = createCodegenNodeForBranch(
                  branch,
                  key + ifNode.branches.length - 1,
                  context
                );
              }
            };
          });
        }
      );
      transformFor = createStructuralDirectiveTransform(
        "for",
        (node, dir, context) => {
          const { helper, removeHelper } = context;
          return processFor(node, dir, context, (forNode) => {
            const renderExp = createCallExpression(helper(RENDER_LIST), [
              forNode.source
            ]);
            const isTemplate = isTemplateNode(node);
            const memo = findDir(node, "memo");
            const keyProp = findProp(node, `key`, false, true);
            keyProp && keyProp.type === 7;
            let keyExp = keyProp && (keyProp.type === 6 ? keyProp.value ? createSimpleExpression(keyProp.value.content, true) : void 0 : keyProp.exp);
            const keyProperty = keyExp ? createObjectProperty(`key`, keyExp) : null;
            const isStableFragment = forNode.source.type === 4 && forNode.source.constType > 0;
            const fragmentFlag = isStableFragment ? 64 : keyProp ? 128 : 256;
            forNode.codegenNode = createVNodeCall(
              context,
              helper(FRAGMENT),
              void 0,
              renderExp,
              fragmentFlag,
              void 0,
              void 0,
              true,
              !isStableFragment,
              false,
              node.loc
            );
            return () => {
              var _a;
              let childBlock;
              const { children } = forNode;
              if (isTemplate) {
                node.children.some((c) => {
                  if (c.type === 1) {
                    const key = findProp(c, "key");
                    if (key) {
                      context.onError(
                        createCompilerError(
                          33,
                          key.loc
                        )
                      );
                      return true;
                    }
                  }
                });
              }
              const needFragmentWrapper = children.length !== 1 || children[0].type !== 1;
              const slotOutlet = isSlotOutlet(node) ? node : isTemplate && node.children.length === 1 && isSlotOutlet(node.children[0]) ? node.children[0] : null;
              if (slotOutlet) {
                childBlock = slotOutlet.codegenNode;
                if (isTemplate && keyProperty) {
                  injectProp(childBlock, keyProperty, context);
                }
              } else if (needFragmentWrapper) {
                childBlock = createVNodeCall(
                  context,
                  helper(FRAGMENT),
                  keyProperty ? createObjectExpression([keyProperty]) : void 0,
                  node.children,
                  64,
                  void 0,
                  void 0,
                  true,
                  void 0,
                  false
                );
              } else {
                childBlock = children[0].codegenNode;
                if (isTemplate && keyProperty) {
                  injectProp(childBlock, keyProperty, context);
                }
                const shouldUseBlock = !isStableFragment || childBlock.isBlockRequired === true;
                if (childBlock.isBlock !== shouldUseBlock) {
                  if (childBlock.isBlock) {
                    removeHelper(OPEN_BLOCK);
                    removeHelper(
                      getVNodeBlockHelper(context.inSSR, childBlock.isComponent)
                    );
                  } else {
                    removeHelper(
                      getVNodeHelper(context.inSSR, childBlock.isComponent)
                    );
                  }
                }
                childBlock.isBlock = shouldUseBlock;
                if (childBlock.isBlock) {
                  helper(OPEN_BLOCK);
                  helper(getVNodeBlockHelper(context.inSSR, childBlock.isComponent));
                } else {
                  helper(getVNodeHelper(context.inSSR, childBlock.isComponent));
                  if (childBlock.needsPatch) {
                    childBlock.patchFlag = ((_a = childBlock.patchFlag) != null ? _a : 0) | 512;
                  }
                }
              }
              if (memo) {
                const loop = createFunctionExpression(
                  createForLoopParams(forNode.parseResult, [
                    createSimpleExpression(`_cached`)
                  ])
                );
                loop.body = createBlockStatement([
                  createCompoundExpression([`const _memo = (`, memo.exp, `)`]),
                  createCompoundExpression([
                    `if (_cached && _cached.el`,
                    ...keyExp ? [` && _cached.key === `, keyExp] : [],
                    ` && ${context.helperString(
                      IS_MEMO_SAME
                    )}(_cached, _memo)) return _cached`
                  ]),
                  createCompoundExpression([`const _item = `, childBlock]),
                  createSimpleExpression(`_item.memo = _memo`),
                  createSimpleExpression(`return _item`)
                ]);
                renderExp.arguments.push(
                  loop,
                  createSimpleExpression(`_cache`),
                  createSimpleExpression(String(context.cached.length))
                );
                context.cached.push(null);
              } else {
                renderExp.arguments.push(
                  createFunctionExpression(
                    createForLoopParams(forNode.parseResult),
                    childBlock,
                    true
                  )
                );
              }
            };
          });
        }
      );
      defaultFallback = createSimpleExpression(`undefined`, false);
      trackSlotScopes = (node, context) => {
        if (node.type === 1 && (node.tagType === 1 || node.tagType === 3)) {
          const vSlot = findDir(node, "slot");
          if (vSlot) {
            vSlot.exp;
            context.scopes.vSlot++;
            return () => {
              context.scopes.vSlot--;
            };
          }
        }
      };
      buildClientSlotFn = (props, _vForExp, children, loc) => createFunctionExpression(
        props,
        children,
        false,
        true,
        children.length ? children[0].loc : loc
      );
      directiveImportMap = /* @__PURE__ */ new WeakMap();
      transformElement = (node, context) => {
        return function postTransformElement() {
          node = context.currentNode;
          if (!(node.type === 1 && (node.tagType === 0 || node.tagType === 1))) {
            return;
          }
          const { tag, props } = node;
          const isComponent2 = node.tagType === 1;
          let vnodeTag = isComponent2 ? resolveComponentType(node, context) : `"${tag}"`;
          const isDynamicComponent = isObject(vnodeTag) && vnodeTag.callee === RESOLVE_DYNAMIC_COMPONENT;
          let vnodeProps;
          let vnodeChildren;
          let patchFlag = 0;
          let vnodeDynamicProps;
          let dynamicPropNames;
          let vnodeDirectives;
          let needsPatch = false;
          let isBlockRequired = false;
          let shouldUseBlock = (
            // dynamic component may resolve to plain elements
            isDynamicComponent || vnodeTag === TELEPORT || vnodeTag === SUSPENSE || !isComponent2 && // <svg> and <foreignObject> must be forced into blocks so that block
            // updates inside get proper isSVG flag at runtime. (#639, #643)
            // This is technically web-specific, but splitting the logic out of core
            // leads to too much unnecessary complexity.
            (tag === "svg" || tag === "foreignObject" || tag === "math")
          );
          if (props.length > 0) {
            const propsBuildResult = buildProps(
              node,
              context,
              void 0,
              isComponent2,
              isDynamicComponent
            );
            vnodeProps = propsBuildResult.props;
            patchFlag = propsBuildResult.patchFlag;
            dynamicPropNames = propsBuildResult.dynamicPropNames;
            needsPatch = propsBuildResult.needsPatch;
            isBlockRequired = propsBuildResult.isBlockRequired;
            const directives = propsBuildResult.directives;
            vnodeDirectives = directives && directives.length ? createArrayExpression(
              directives.map((dir) => buildDirectiveArgs(dir, context))
            ) : void 0;
            if (propsBuildResult.shouldUseBlock) {
              shouldUseBlock = true;
            }
          }
          if (node.children.length > 0) {
            if (vnodeTag === KEEP_ALIVE) {
              shouldUseBlock = true;
              patchFlag |= 1024;
              if (node.children.length > 1) {
                context.onError(
                  createCompilerError(47, {
                    start: node.children[0].loc.start,
                    end: node.children[node.children.length - 1].loc.end,
                    source: ""
                  })
                );
              }
            }
            const shouldBuildAsSlots = isComponent2 && // Teleport is not a real component and has dedicated runtime handling
            vnodeTag !== TELEPORT && // explained above.
            vnodeTag !== KEEP_ALIVE;
            if (shouldBuildAsSlots) {
              const { slots, hasDynamicSlots } = buildSlots(node, context);
              vnodeChildren = slots;
              if (hasDynamicSlots) {
                patchFlag |= 1024;
              }
            } else if (node.children.length === 1 && vnodeTag !== TELEPORT) {
              const child = node.children[0];
              const type = child.type;
              const hasDynamicTextChild = type === 5 || type === 8;
              if (hasDynamicTextChild && getConstantType(child, context) === 0) {
                patchFlag |= 1;
              }
              if (hasDynamicTextChild || type === 2) {
                vnodeChildren = child;
              } else {
                vnodeChildren = node.children;
              }
            } else {
              vnodeChildren = node.children;
            }
          }
          if (dynamicPropNames && dynamicPropNames.length) {
            vnodeDynamicProps = stringifyDynamicPropNames(dynamicPropNames);
          }
          const vnodeCall = node.codegenNode = createVNodeCall(
            context,
            vnodeTag,
            vnodeProps,
            vnodeChildren,
            patchFlag === 0 ? void 0 : patchFlag,
            vnodeDynamicProps,
            vnodeDirectives,
            !!shouldUseBlock,
            false,
            isComponent2,
            node.loc
          );
          needsPatch = needsPatch && (patchFlag === 0 || patchFlag === 32);
          if (needsPatch) {
            vnodeCall.needsPatch = true;
          }
          if (isBlockRequired) {
            vnodeCall.isBlockRequired = true;
          }
        };
      };
      transformSlotOutlet = (node, context) => {
        if (isSlotOutlet(node)) {
          const { children, loc } = node;
          const { slotName, slotProps } = processSlotOutlet(node, context);
          const slotArgs = [
            context.prefixIdentifiers ? `_ctx.$slots` : `$slots`,
            slotName,
            "{}",
            "undefined",
            "true"
          ];
          let expectedLen = 2;
          if (slotProps) {
            slotArgs[2] = slotProps;
            expectedLen = 3;
          }
          if (children.length) {
            slotArgs[3] = createFunctionExpression([], children, false, false, loc);
            expectedLen = 4;
          }
          if (context.scopeId && !context.slotted) {
            expectedLen = 5;
          }
          slotArgs.splice(expectedLen);
          node.codegenNode = createCallExpression(
            context.helper(RENDER_SLOT),
            slotArgs,
            loc
          );
        }
      };
      transformOn = (dir, node, context, augmentor) => {
        const { loc, modifiers, arg } = dir;
        if (!dir.exp && !modifiers.length) {
          context.onError(createCompilerError(35, loc));
        }
        let eventName;
        if (arg.type === 4) {
          if (arg.isStatic) {
            let rawName = arg.content;
            if (rawName.startsWith("vnode")) {
              context.onError(createCompilerError(52, arg.loc));
            }
            if (rawName.startsWith("vue:")) {
              rawName = `vnode-${rawName.slice(4)}`;
            }
            const eventString = node.tagType !== 0 || rawName.startsWith("vnode") || !/[A-Z]/.test(rawName) ? (
              // for non-element and vnode lifecycle event listeners, auto convert
              // it to camelCase. See issue #2249
              toHandlerKey(camelize(rawName))
            ) : (
              // preserve case for plain element listeners that have uppercase
              // letters, as these may be custom elements' custom events
              `on:${rawName}`
            );
            eventName = createSimpleExpression(eventString, true, arg.loc);
          } else {
            eventName = createCompoundExpression([
              `${context.helperString(TO_HANDLER_KEY)}(`,
              arg,
              `)`
            ]);
          }
        } else {
          eventName = arg;
          eventName.children.unshift(`${context.helperString(TO_HANDLER_KEY)}(`);
          eventName.children.push(`)`);
        }
        let exp = dir.exp;
        if (exp && !exp.content.trim()) {
          exp = void 0;
        }
        let shouldCache = context.cacheHandlers && !exp && !context.inVOnce;
        if (exp) {
          const isMemberExp = isMemberExpression(exp);
          const isInlineStatement = !(isMemberExp || isFnExpression(exp));
          const hasMultipleStatements = exp.content.includes(`;`);
          if (true) {
            validateBrowserExpression(
              exp,
              context,
              false,
              hasMultipleStatements
            );
          }
          if (isInlineStatement || shouldCache && isMemberExp) {
            exp = createCompoundExpression([
              `${isInlineStatement ? `$event` : `${``}(...args)`} => ${hasMultipleStatements ? `{` : `(`}`,
              exp,
              hasMultipleStatements ? `}` : `)`
            ]);
          }
        }
        let ret = {
          props: [
            createObjectProperty(
              eventName,
              exp || createSimpleExpression(`() => {}`, false, loc)
            )
          ]
        };
        if (augmentor) {
          ret = augmentor(ret);
        }
        if (shouldCache) {
          ret.props[0].value = context.cache(ret.props[0].value);
        }
        ret.props.forEach((p2) => p2.key.isHandlerKey = true);
        return ret;
      };
      transformBind = (dir, _node, context) => {
        const { modifiers, loc } = dir;
        const arg = dir.arg;
        let { exp } = dir;
        if (exp && exp.type === 4 && !exp.content.trim()) {
          {
            exp = void 0;
          }
        }
        if (arg.type !== 4) {
          arg.children.unshift(`(`);
          arg.children.push(`) || ""`);
        } else if (!arg.isStatic) {
          arg.content = arg.content ? `${arg.content} || ""` : `""`;
        }
        if (modifiers.some((mod) => mod.content === "camel")) {
          if (arg.type === 4) {
            if (arg.isStatic) {
              arg.content = camelize(arg.content);
            } else {
              arg.content = `${context.helperString(CAMELIZE)}(${arg.content})`;
            }
          } else {
            arg.children.unshift(`${context.helperString(CAMELIZE)}(`);
            arg.children.push(`)`);
          }
        }
        if (!context.inSSR) {
          if (modifiers.some((mod) => mod.content === "prop")) {
            injectPrefix(arg, ".");
          }
          if (modifiers.some((mod) => mod.content === "attr")) {
            injectPrefix(arg, "^");
          }
        }
        return {
          props: [createObjectProperty(arg, exp)]
        };
      };
      injectPrefix = (arg, prefix2) => {
        if (arg.type === 4) {
          if (arg.isStatic) {
            arg.content = prefix2 + arg.content;
          } else {
            arg.content = `\`${prefix2}\${${arg.content}}\``;
          }
        } else {
          arg.children.unshift(`'${prefix2}' + (`);
          arg.children.push(`)`);
        }
      };
      transformText = (node, context) => {
        if (node.type === 0 || node.type === 1 || node.type === 11 || node.type === 10) {
          return () => {
            const children = node.children;
            let currentContainer = void 0;
            let hasText = false;
            for (let i2 = 0; i2 < children.length; i2++) {
              const child = children[i2];
              if (isText$1(child)) {
                hasText = true;
                for (let j = i2 + 1; j < children.length; j++) {
                  const next = children[j];
                  if (isText$1(next)) {
                    if (!currentContainer) {
                      currentContainer = children[i2] = createCompoundExpression(
                        [child],
                        child.loc
                      );
                    }
                    currentContainer.children.push(` + `, next);
                    children.splice(j, 1);
                    j--;
                  } else {
                    currentContainer = void 0;
                    break;
                  }
                }
              }
            }
            if (!hasText || // if this is a plain element with a single text child, leave it
            // as-is since the runtime has dedicated fast path for this by directly
            // setting textContent of the element.
            // for component root it's always normalized anyway.
            children.length === 1 && (node.type === 0 || node.type === 1 && node.tagType === 0 && // #3756
            // custom directives can potentially add DOM elements arbitrarily,
            // we need to avoid setting textContent of the element at runtime
            // to avoid accidentally overwriting the DOM elements added
            // by the user through custom directives.
            !node.props.find(
              (p2) => p2.type === 7 && !context.directiveTransforms[p2.name]
            ) && // in compat mode, <template> tags with no special directives
            // will be rendered as a fragment so its children must be
            // converted into vnodes.
            !(node.tag === "template"))) {
              return;
            }
            for (let i2 = 0; i2 < children.length; i2++) {
              const child = children[i2];
              if (isText$1(child) || child.type === 8) {
                const callArgs = [];
                if (child.type !== 2 || child.content !== " ") {
                  callArgs.push(child);
                }
                if (!context.ssr && getConstantType(child, context) === 0) {
                  callArgs.push(
                    1 + (true ? ` /* ${PatchFlagNames[1]} */` : ``)
                  );
                }
                children[i2] = {
                  type: 12,
                  content: child,
                  loc: child.loc,
                  codegenNode: createCallExpression(
                    context.helper(CREATE_TEXT),
                    callArgs
                  )
                };
              }
            }
          };
        }
      };
      seen$1 = /* @__PURE__ */ new WeakSet();
      transformOnce = (node, context) => {
        if (node.type === 1 && findDir(node, "once", true)) {
          if (seen$1.has(node) || context.inVOnce || context.inSSR) {
            return;
          }
          seen$1.add(node);
          context.inVOnce = true;
          context.helper(SET_BLOCK_TRACKING);
          return () => {
            context.inVOnce = false;
            const cur = context.currentNode;
            if (cur.codegenNode) {
              cur.codegenNode = context.cache(
                cur.codegenNode,
                true,
                true
              );
            }
          };
        }
      };
      transformModel = (dir, node, context) => {
        const { exp, arg } = dir;
        if (!exp) {
          context.onError(
            createCompilerError(41, dir.loc)
          );
          return createTransformProps();
        }
        const rawExp = exp.loc.source.trim();
        const expString = exp.type === 4 ? exp.content : rawExp;
        const bindingType = context.bindingMetadata[rawExp];
        if (bindingType === "props" || bindingType === "props-aliased") {
          context.onError(createCompilerError(44, exp.loc));
          return createTransformProps();
        }
        if (bindingType === "literal-const" || bindingType === "setup-const") {
          context.onError(createCompilerError(45, exp.loc));
          return createTransformProps();
        }
        if (!expString.trim() || !isMemberExpression(exp) && true) {
          context.onError(
            createCompilerError(42, exp.loc)
          );
          return createTransformProps();
        }
        const propName = arg ? arg : createSimpleExpression("modelValue", true);
        const eventName = arg ? isStaticExp(arg) ? `onUpdate:${camelize(arg.content)}` : createCompoundExpression(['"onUpdate:" + ', arg]) : `onUpdate:modelValue`;
        let assignmentExp;
        const eventArg = context.isTS ? `($event: any)` : `$event`;
        {
          assignmentExp = createCompoundExpression([
            `${eventArg} => ((`,
            exp,
            `) = $event)`
          ]);
        }
        const props = [
          // modelValue: foo
          createObjectProperty(propName, dir.exp),
          // "onUpdate:modelValue": $event => (foo = $event)
          createObjectProperty(eventName, assignmentExp)
        ];
        if (dir.modifiers.length && node.tagType === 1) {
          const modifiers = dir.modifiers.map((m) => m.content).map((m) => (isSimpleIdentifier(m) ? m : JSON.stringify(m)) + `: true`).join(`, `);
          const modifiersKey = arg ? isStaticExp(arg) ? `${arg.content}Modifiers` : createCompoundExpression([arg, ' + "Modifiers"']) : `modelModifiers`;
          props.push(
            createObjectProperty(
              modifiersKey,
              createSimpleExpression(
                `{ ${modifiers} }`,
                false,
                dir.loc,
                2
              )
            )
          );
        }
        return createTransformProps(props);
      };
      validDivisionCharRE = /[\w).+\-_$\]]/;
      transformFilter = (node, context) => {
        if (!isCompatEnabled("COMPILER_FILTERS", context)) {
          return;
        }
        if (node.type === 5) {
          rewriteFilter(node.content, context);
        } else if (node.type === 1) {
          node.props.forEach((prop) => {
            if (prop.type === 7 && prop.name !== "for" && prop.exp) {
              rewriteFilter(prop.exp, context);
            }
          });
        }
      };
      seen = /* @__PURE__ */ new WeakSet();
      transformMemo = (node, context) => {
        if (node.type === 1) {
          const dir = findDir(node, "memo");
          if (!dir || seen.has(node) || context.inSSR) {
            return;
          }
          seen.add(node);
          return () => {
            const codegenNode = node.codegenNode || context.currentNode.codegenNode;
            if (codegenNode && codegenNode.type === 13) {
              if (node.tagType !== 1) {
                convertToBlock(codegenNode, context);
              }
              node.codegenNode = createCallExpression(context.helper(WITH_MEMO), [
                dir.exp,
                createFunctionExpression(void 0, codegenNode),
                `_cache`,
                String(context.cached.length)
              ]);
              context.cached.push(null);
            }
          };
        }
      };
      transformVBindShorthand = (node, context) => {
        if (node.type === 1) {
          for (const prop of node.props) {
            if (prop.type === 7 && prop.name === "bind" && (!prop.exp || // #13930 :foo in in-DOM templates will be parsed into :foo="" by browser
            prop.exp.type === 4 && !prop.exp.content.trim()) && prop.arg) {
              const arg = prop.arg;
              if (arg.type !== 4 || !arg.isStatic) {
                context.onError(
                  createCompilerError(
                    53,
                    arg.loc
                  )
                );
                prop.exp = createSimpleExpression("", true, arg.loc);
              } else {
                const propName = camelize(arg.content);
                if (validFirstIdentCharRE.test(propName[0]) || // allow hyphen first char for https://github.com/vuejs/language-tools/pull/3424
                propName[0] === "-") {
                  prop.exp = createSimpleExpression(propName, false, arg.loc);
                }
              }
            }
          }
        }
      };
      noopDirectiveTransform = () => ({ props: [] });
    }
  });

  // node_modules/@vue/compiler-dom/dist/compiler-dom.esm-bundler.js
  function decodeHtmlBrowser(raw, asAttr = false) {
    if (!decoder) {
      decoder = document.createElement("div");
    }
    if (asAttr) {
      decoder.innerHTML = `<div foo="${raw.replace(/"/g, "&quot;")}">`;
      return decoder.children[0].getAttribute("foo");
    } else {
      decoder.innerHTML = raw;
      return decoder.textContent;
    }
  }
  function createDOMCompilerError(code, loc) {
    return createCompilerError(
      code,
      loc,
      true ? DOMErrorMessages : void 0
    );
  }
  function hasMultipleChildren(node) {
    const children = node.children = node.children.filter(
      (c) => !isCommentOrWhitespace(c)
    );
    const child = children[0];
    return children.length !== 1 || child.type === 11 || child.type === 9 && child.branches.some(hasMultipleChildren);
  }
  function isValidHTMLNesting(parent, child) {
    if (parent === "template") {
      return true;
    }
    if (parent in onlyValidChildren) {
      return onlyValidChildren[parent].has(child);
    }
    if (child in onlyValidParents) {
      return onlyValidParents[child].has(parent);
    }
    if (parent in knownInvalidChildren) {
      if (knownInvalidChildren[parent].has(child)) return false;
    }
    if (child in knownInvalidParents) {
      if (knownInvalidParents[child].has(parent)) return false;
    }
    return true;
  }
  function compile2(src, options = {}) {
    return baseCompile(
      src,
      extend({}, parserOptions, options, {
        nodeTransforms: [
          // ignore <script> and <tag>
          // this is not put inside DOMNodeTransforms because that list is used
          // by compiler-ssr to generate vnode fallback branches
          ignoreSideEffectTags,
          ...DOMNodeTransforms,
          ...options.nodeTransforms || []
        ],
        directiveTransforms: extend(
          {},
          DOMDirectiveTransforms,
          options.directiveTransforms || {}
        ),
        transformHoist: null
      })
    );
  }
  var V_MODEL_RADIO, V_MODEL_CHECKBOX, V_MODEL_TEXT, V_MODEL_SELECT, V_MODEL_DYNAMIC, V_ON_WITH_MODIFIERS, V_ON_WITH_KEYS, V_SHOW, TRANSITION2, TRANSITION_GROUP, decoder, parserOptions, transformStyle, parseInlineCSS, DOMErrorMessages, transformVHtml, transformVText, transformModel2, isEventOptionModifier, isNonKeyModifier, maybeKeyModifier, isKeyboardEvent, resolveModifiers, transformClick, transformOn2, transformShow, transformTransition, ignoreSideEffectTags, headings, emptySet, onlyValidChildren, onlyValidParents, knownInvalidChildren, knownInvalidParents, validateHtmlNesting, DOMNodeTransforms, DOMDirectiveTransforms;
  var init_compiler_dom_esm_bundler = __esm({
    "node_modules/@vue/compiler-dom/dist/compiler-dom.esm-bundler.js"() {
      init_compiler_core_esm_bundler();
      init_compiler_core_esm_bundler();
      init_shared_esm_bundler();
      /**
      * @vue/compiler-dom v3.5.41
      * (c) 2018-present Yuxi (Evan) You and Vue contributors
      * @license MIT
      **/
      V_MODEL_RADIO = /* @__PURE__ */ Symbol(true ? `vModelRadio` : ``);
      V_MODEL_CHECKBOX = /* @__PURE__ */ Symbol(
        true ? `vModelCheckbox` : ``
      );
      V_MODEL_TEXT = /* @__PURE__ */ Symbol(true ? `vModelText` : ``);
      V_MODEL_SELECT = /* @__PURE__ */ Symbol(
        true ? `vModelSelect` : ``
      );
      V_MODEL_DYNAMIC = /* @__PURE__ */ Symbol(
        true ? `vModelDynamic` : ``
      );
      V_ON_WITH_MODIFIERS = /* @__PURE__ */ Symbol(
        true ? `vOnModifiersGuard` : ``
      );
      V_ON_WITH_KEYS = /* @__PURE__ */ Symbol(
        true ? `vOnKeysGuard` : ``
      );
      V_SHOW = /* @__PURE__ */ Symbol(true ? `vShow` : ``);
      TRANSITION2 = /* @__PURE__ */ Symbol(true ? `Transition` : ``);
      TRANSITION_GROUP = /* @__PURE__ */ Symbol(
        true ? `TransitionGroup` : ``
      );
      registerRuntimeHelpers({
        [V_MODEL_RADIO]: `vModelRadio`,
        [V_MODEL_CHECKBOX]: `vModelCheckbox`,
        [V_MODEL_TEXT]: `vModelText`,
        [V_MODEL_SELECT]: `vModelSelect`,
        [V_MODEL_DYNAMIC]: `vModelDynamic`,
        [V_ON_WITH_MODIFIERS]: `withModifiers`,
        [V_ON_WITH_KEYS]: `withKeys`,
        [V_SHOW]: `vShow`,
        [TRANSITION2]: `Transition`,
        [TRANSITION_GROUP]: `TransitionGroup`
      });
      parserOptions = {
        parseMode: "html",
        isVoidTag,
        isNativeTag: (tag) => isHTMLTag(tag) || isSVGTag(tag) || isMathMLTag(tag),
        isPreTag: (tag) => tag === "pre",
        isIgnoreNewlineTag: (tag) => tag === "pre" || tag === "textarea",
        decodeEntities: decodeHtmlBrowser,
        isBuiltInComponent: (tag) => {
          if (tag === "Transition" || tag === "transition") {
            return TRANSITION2;
          } else if (tag === "TransitionGroup" || tag === "transition-group") {
            return TRANSITION_GROUP;
          }
        },
        // https://html.spec.whatwg.org/multipage/parsing.html#tree-construction-dispatcher
        getNamespace(tag, parent, rootNamespace) {
          let ns = parent ? parent.ns : rootNamespace;
          if (parent && ns === 2) {
            if (parent.tag === "annotation-xml") {
              if (tag === "svg") {
                return 1;
              }
              if (parent.props.some(
                (a) => a.type === 6 && a.name === "encoding" && a.value != null && (a.value.content === "text/html" || a.value.content === "application/xhtml+xml")
              )) {
                ns = 0;
              }
            } else if (/^m(?:[ions]|text)$/.test(parent.tag) && tag !== "mglyph" && tag !== "malignmark") {
              ns = 0;
            }
          } else if (parent && ns === 1) {
            if (parent.tag === "foreignObject" || parent.tag === "desc" || parent.tag === "title") {
              ns = 0;
            }
          }
          if (ns === 0) {
            if (tag === "svg") {
              return 1;
            }
            if (tag === "math") {
              return 2;
            }
          }
          return ns;
        }
      };
      transformStyle = (node) => {
        if (node.type === 1) {
          node.props.forEach((p2, i2) => {
            if (p2.type === 6 && p2.name === "style" && p2.value) {
              node.props[i2] = {
                type: 7,
                name: `bind`,
                arg: createSimpleExpression(`style`, true, p2.loc),
                exp: parseInlineCSS(p2.value.content, p2.loc),
                modifiers: [],
                loc: p2.loc
              };
            }
          });
        }
      };
      parseInlineCSS = (cssText, loc) => {
        const normalized = parseStringStyle(cssText);
        return createSimpleExpression(
          JSON.stringify(normalized),
          false,
          loc,
          3
        );
      };
      DOMErrorMessages = {
        [54]: `v-html is missing expression.`,
        [55]: `v-html will override element children.`,
        [56]: `v-text is missing expression.`,
        [57]: `v-text will override element children.`,
        [58]: `v-model can only be used on <input>, <textarea> and <select> elements.`,
        [59]: `v-model argument is not supported on plain elements.`,
        [60]: `v-model cannot be used on file inputs since they are read-only. Use a v-on:change listener instead.`,
        [61]: `Unnecessary value binding used alongside v-model. It will interfere with v-model's behavior.`,
        [62]: `v-show is missing expression.`,
        [63]: `<Transition> expects exactly one child element or component.`,
        [64]: `Tags with side effect (<script> and <style>) are ignored in client component templates.`
      };
      transformVHtml = (dir, node, context) => {
        const { exp, loc } = dir;
        if (!exp) {
          context.onError(
            createDOMCompilerError(54, loc)
          );
        }
        if (node.children.length) {
          context.onError(
            createDOMCompilerError(55, loc)
          );
          node.children.length = 0;
        }
        return {
          props: [
            createObjectProperty(
              createSimpleExpression(`innerHTML`, true, loc),
              exp || createSimpleExpression("", true)
            )
          ]
        };
      };
      transformVText = (dir, node, context) => {
        const { exp, loc } = dir;
        if (!exp) {
          context.onError(
            createDOMCompilerError(56, loc)
          );
        }
        if (node.children.length) {
          context.onError(
            createDOMCompilerError(57, loc)
          );
          node.children.length = 0;
        }
        return {
          props: [
            createObjectProperty(
              createSimpleExpression(`textContent`, true),
              exp ? getConstantType(exp, context) > 0 ? exp : createCallExpression(
                context.helperString(TO_DISPLAY_STRING),
                [exp],
                loc
              ) : createSimpleExpression("", true)
            )
          ]
        };
      };
      transformModel2 = (dir, node, context) => {
        const baseResult = transformModel(dir, node, context);
        if (!baseResult.props.length || node.tagType === 1) {
          return baseResult;
        }
        if (dir.arg) {
          context.onError(
            createDOMCompilerError(
              59,
              dir.arg.loc
            )
          );
        }
        function checkDuplicatedValue() {
          const value = findDir(node, "bind");
          if (value && isStaticArgOf(value.arg, "value")) {
            context.onError(
              createDOMCompilerError(
                61,
                value.loc
              )
            );
          }
        }
        const { tag } = node;
        const isCustomElement = context.isCustomElement(tag);
        if (tag === "input" || tag === "textarea" || tag === "select" || isCustomElement) {
          let directiveToUse = V_MODEL_TEXT;
          let isInvalidType = false;
          if (tag === "input" || isCustomElement) {
            const type = findProp(node, `type`);
            if (type) {
              if (type.type === 7) {
                directiveToUse = V_MODEL_DYNAMIC;
              } else if (type.value) {
                switch (type.value.content) {
                  case "radio":
                    directiveToUse = V_MODEL_RADIO;
                    break;
                  case "checkbox":
                    directiveToUse = V_MODEL_CHECKBOX;
                    break;
                  case "file":
                    isInvalidType = true;
                    context.onError(
                      createDOMCompilerError(
                        60,
                        dir.loc
                      )
                    );
                    break;
                  default:
                    checkDuplicatedValue();
                    break;
                }
              }
            } else if (hasDynamicKeyVBind(node)) {
              directiveToUse = V_MODEL_DYNAMIC;
            } else {
              checkDuplicatedValue();
            }
          } else if (tag === "select") {
            directiveToUse = V_MODEL_SELECT;
          } else {
            checkDuplicatedValue();
          }
          if (!isInvalidType) {
            baseResult.needRuntime = context.helper(directiveToUse);
          }
        } else {
          context.onError(
            createDOMCompilerError(
              58,
              dir.loc
            )
          );
        }
        baseResult.props = baseResult.props.filter(
          (p2) => !(p2.key.type === 4 && p2.key.content === "modelValue")
        );
        return baseResult;
      };
      isEventOptionModifier = /* @__PURE__ */ makeMap(`passive,once,capture`);
      isNonKeyModifier = /* @__PURE__ */ makeMap(
        // event propagation management
        `stop,prevent,self,ctrl,shift,alt,meta,exact,middle`
      );
      maybeKeyModifier = /* @__PURE__ */ makeMap("left,right");
      isKeyboardEvent = /* @__PURE__ */ makeMap(`onkeyup,onkeydown,onkeypress`);
      resolveModifiers = (key, modifiers, context, loc) => {
        const keyModifiers = [];
        const nonKeyModifiers = [];
        const eventOptionModifiers = [];
        for (let i2 = 0; i2 < modifiers.length; i2++) {
          const modifier = modifiers[i2].content;
          if (modifier === "native" && checkCompatEnabled(
            "COMPILER_V_ON_NATIVE",
            context,
            loc
          )) {
            eventOptionModifiers.push(modifier);
          } else if (isEventOptionModifier(modifier)) {
            eventOptionModifiers.push(modifier);
          } else {
            if (maybeKeyModifier(modifier)) {
              if (isStaticExp(key)) {
                if (isKeyboardEvent(key.content.toLowerCase())) {
                  keyModifiers.push(modifier);
                } else {
                  nonKeyModifiers.push(modifier);
                }
              } else {
                keyModifiers.push(modifier);
                nonKeyModifiers.push(modifier);
              }
            } else {
              if (isNonKeyModifier(modifier)) {
                nonKeyModifiers.push(modifier);
              } else {
                keyModifiers.push(modifier);
              }
            }
          }
        }
        return {
          keyModifiers,
          nonKeyModifiers,
          eventOptionModifiers
        };
      };
      transformClick = (key, event) => {
        const isStaticClick = isStaticExp(key) && key.content.toLowerCase() === "onclick";
        return isStaticClick ? createSimpleExpression(event, true) : key.type !== 4 ? createCompoundExpression([
          `(`,
          key,
          `) === "onClick" ? "${event}" : (`,
          key,
          `)`
        ]) : key;
      };
      transformOn2 = (dir, node, context) => {
        return transformOn(dir, node, context, (baseResult) => {
          const { modifiers } = dir;
          if (!modifiers.length) return baseResult;
          let { key, value: handlerExp } = baseResult.props[0];
          const { keyModifiers, nonKeyModifiers, eventOptionModifiers } = resolveModifiers(key, modifiers, context, dir.loc);
          if (nonKeyModifiers.includes("right")) {
            key = transformClick(key, `onContextmenu`);
          }
          if (nonKeyModifiers.includes("middle")) {
            key = transformClick(key, `onMouseup`);
          }
          if (nonKeyModifiers.length) {
            handlerExp = createCallExpression(context.helper(V_ON_WITH_MODIFIERS), [
              handlerExp,
              JSON.stringify(nonKeyModifiers)
            ]);
          }
          if (keyModifiers.length && // if event name is dynamic, always wrap with keys guard
          (!isStaticExp(key) || isKeyboardEvent(key.content.toLowerCase()))) {
            handlerExp = createCallExpression(context.helper(V_ON_WITH_KEYS), [
              handlerExp,
              JSON.stringify(keyModifiers)
            ]);
          }
          if (eventOptionModifiers.length) {
            const modifierPostfix = eventOptionModifiers.map(capitalize).join("");
            key = isStaticExp(key) ? createSimpleExpression(`${key.content}${modifierPostfix}`, true) : createCompoundExpression([`(`, key, `) + "${modifierPostfix}"`]);
          }
          return {
            props: [createObjectProperty(key, handlerExp)]
          };
        });
      };
      transformShow = (dir, node, context) => {
        const { exp, loc } = dir;
        if (!exp) {
          context.onError(
            createDOMCompilerError(62, loc)
          );
        }
        return {
          props: [],
          needRuntime: context.helper(V_SHOW)
        };
      };
      transformTransition = (node, context) => {
        if (node.type === 1 && node.tagType === 1) {
          const component = context.isBuiltInComponent(node.tag);
          if (component === TRANSITION2) {
            return () => {
              if (!node.children.length) {
                return;
              }
              if (hasMultipleChildren(node)) {
                context.onError(
                  createDOMCompilerError(
                    63,
                    {
                      start: node.children[0].loc.start,
                      end: node.children[node.children.length - 1].loc.end,
                      source: ""
                    }
                  )
                );
              }
              const child = node.children[0];
              if (child.type === 1) {
                for (const p2 of child.props) {
                  if (p2.type === 7 && p2.name === "show") {
                    node.props.push({
                      type: 6,
                      name: "persisted",
                      nameLoc: node.loc,
                      value: void 0,
                      loc: node.loc
                    });
                  }
                }
              }
            };
          }
        }
      };
      ignoreSideEffectTags = (node, context) => {
        if (node.type === 1 && node.tagType === 0 && (node.tag === "script" || node.tag === "style")) {
          context.onError(
            createDOMCompilerError(
              64,
              node.loc
            )
          );
          context.removeNode();
        }
      };
      headings = /* @__PURE__ */ new Set(["h1", "h2", "h3", "h4", "h5", "h6"]);
      emptySet = /* @__PURE__ */ new Set([]);
      onlyValidChildren = {
        head: /* @__PURE__ */ new Set([
          "base",
          "basefront",
          "bgsound",
          "link",
          "meta",
          "title",
          "noscript",
          "noframes",
          "style",
          "script",
          "template"
        ]),
        optgroup: /* @__PURE__ */ new Set(["option"]),
        select: /* @__PURE__ */ new Set(["optgroup", "option", "hr"]),
        // table
        table: /* @__PURE__ */ new Set(["caption", "colgroup", "tbody", "tfoot", "thead"]),
        tr: /* @__PURE__ */ new Set(["td", "th"]),
        colgroup: /* @__PURE__ */ new Set(["col"]),
        tbody: /* @__PURE__ */ new Set(["tr"]),
        thead: /* @__PURE__ */ new Set(["tr"]),
        tfoot: /* @__PURE__ */ new Set(["tr"]),
        // these elements can not have any children elements
        script: emptySet,
        iframe: emptySet,
        option: emptySet,
        textarea: emptySet,
        style: emptySet,
        title: emptySet
      };
      onlyValidParents = {
        // sections
        html: emptySet,
        body: /* @__PURE__ */ new Set(["html"]),
        head: /* @__PURE__ */ new Set(["html"]),
        // table
        td: /* @__PURE__ */ new Set(["tr"]),
        colgroup: /* @__PURE__ */ new Set(["table"]),
        caption: /* @__PURE__ */ new Set(["table"]),
        tbody: /* @__PURE__ */ new Set(["table"]),
        tfoot: /* @__PURE__ */ new Set(["table"]),
        col: /* @__PURE__ */ new Set(["colgroup"]),
        th: /* @__PURE__ */ new Set(["tr"]),
        thead: /* @__PURE__ */ new Set(["table"]),
        tr: /* @__PURE__ */ new Set(["tbody", "thead", "tfoot"]),
        // data list
        dd: /* @__PURE__ */ new Set(["dl", "div"]),
        dt: /* @__PURE__ */ new Set(["dl", "div"]),
        // other
        figcaption: /* @__PURE__ */ new Set(["figure"]),
        // li: new Set(["ul", "ol"]),
        summary: /* @__PURE__ */ new Set(["details"]),
        area: /* @__PURE__ */ new Set(["map"])
      };
      knownInvalidChildren = {
        p: /* @__PURE__ */ new Set([
          "address",
          "article",
          "aside",
          "blockquote",
          "center",
          "details",
          "dialog",
          "dir",
          "div",
          "dl",
          "fieldset",
          "figure",
          "footer",
          "form",
          "h1",
          "h2",
          "h3",
          "h4",
          "h5",
          "h6",
          "header",
          "hgroup",
          "hr",
          "li",
          "main",
          "nav",
          "menu",
          "ol",
          "p",
          "pre",
          "section",
          "table",
          "ul"
        ]),
        svg: /* @__PURE__ */ new Set([
          "b",
          "blockquote",
          "br",
          "code",
          "dd",
          "div",
          "dl",
          "dt",
          "em",
          "embed",
          "h1",
          "h2",
          "h3",
          "h4",
          "h5",
          "h6",
          "hr",
          "i",
          "img",
          "li",
          "menu",
          "meta",
          "ol",
          "p",
          "pre",
          "ruby",
          "s",
          "small",
          "span",
          "strong",
          "sub",
          "sup",
          "table",
          "u",
          "ul",
          "var"
        ])
      };
      knownInvalidParents = {
        a: /* @__PURE__ */ new Set(["a"]),
        button: /* @__PURE__ */ new Set(["button"]),
        dd: /* @__PURE__ */ new Set(["dd", "dt"]),
        dt: /* @__PURE__ */ new Set(["dd", "dt"]),
        form: /* @__PURE__ */ new Set(["form"]),
        li: /* @__PURE__ */ new Set(["li"]),
        h1: headings,
        h2: headings,
        h3: headings,
        h4: headings,
        h5: headings,
        h6: headings
      };
      validateHtmlNesting = (node, context) => {
        if (node.type === 1 && node.tagType === 0 && context.parent && context.parent.type === 1 && context.parent.tagType === 0 && !isValidHTMLNesting(context.parent.tag, node.tag)) {
          const error = new SyntaxError(
            `<${node.tag}> cannot be child of <${context.parent.tag}>, according to HTML specifications. This can cause hydration errors or potentially disrupt future functionality.`
          );
          error.loc = node.loc;
          context.onWarn(error);
        }
      };
      DOMNodeTransforms = [
        transformStyle,
        ...true ? [transformTransition, validateHtmlNesting] : []
      ];
      DOMDirectiveTransforms = {
        cloak: noopDirectiveTransform,
        html: transformVHtml,
        text: transformVText,
        model: transformModel2,
        // override compiler-core
        on: transformOn2,
        // override compiler-core
        show: transformShow
      };
    }
  });

  // node_modules/vue/dist/vue.esm-bundler.js
  var vue_esm_bundler_exports = {};
  __export(vue_esm_bundler_exports, {
    BaseTransition: () => BaseTransition,
    BaseTransitionPropsValidators: () => BaseTransitionPropsValidators,
    Comment: () => Comment,
    DeprecationTypes: () => DeprecationTypes,
    EffectScope: () => EffectScope,
    ErrorCodes: () => ErrorCodes,
    ErrorTypeStrings: () => ErrorTypeStrings,
    Fragment: () => Fragment,
    KeepAlive: () => KeepAlive,
    ReactiveEffect: () => ReactiveEffect,
    Static: () => Static,
    Suspense: () => Suspense,
    Teleport: () => Teleport,
    Text: () => Text,
    TrackOpTypes: () => TrackOpTypes,
    Transition: () => Transition,
    TransitionGroup: () => TransitionGroup,
    TriggerOpTypes: () => TriggerOpTypes,
    VueElement: () => VueElement,
    assertNumber: () => assertNumber,
    callWithAsyncErrorHandling: () => callWithAsyncErrorHandling,
    callWithErrorHandling: () => callWithErrorHandling,
    camelize: () => camelize,
    capitalize: () => capitalize,
    cloneVNode: () => cloneVNode,
    compatUtils: () => compatUtils,
    compile: () => compileToFunction,
    computed: () => computed2,
    createApp: () => createApp,
    createBlock: () => createBlock,
    createCommentVNode: () => createCommentVNode,
    createElementBlock: () => createElementBlock,
    createElementVNode: () => createBaseVNode,
    createHydrationRenderer: () => createHydrationRenderer,
    createPropsRestProxy: () => createPropsRestProxy,
    createRenderer: () => createRenderer,
    createSSRApp: () => createSSRApp,
    createSlots: () => createSlots,
    createStaticVNode: () => createStaticVNode,
    createTextVNode: () => createTextVNode,
    createVNode: () => createVNode,
    customRef: () => customRef,
    defineAsyncComponent: () => defineAsyncComponent,
    defineComponent: () => defineComponent,
    defineCustomElement: () => defineCustomElement,
    defineEmits: () => defineEmits,
    defineExpose: () => defineExpose,
    defineModel: () => defineModel,
    defineOptions: () => defineOptions,
    defineProps: () => defineProps,
    defineSSRCustomElement: () => defineSSRCustomElement,
    defineSlots: () => defineSlots,
    devtools: () => devtools,
    effect: () => effect,
    effectScope: () => effectScope,
    getCurrentInstance: () => getCurrentInstance,
    getCurrentScope: () => getCurrentScope,
    getCurrentWatcher: () => getCurrentWatcher,
    getTransitionRawChildren: () => getTransitionRawChildren,
    guardReactiveProps: () => guardReactiveProps,
    h: () => h,
    handleError: () => handleError,
    hasInjectionContext: () => hasInjectionContext,
    hydrate: () => hydrate,
    hydrateOnIdle: () => hydrateOnIdle,
    hydrateOnInteraction: () => hydrateOnInteraction,
    hydrateOnMediaQuery: () => hydrateOnMediaQuery,
    hydrateOnVisible: () => hydrateOnVisible,
    initCustomFormatter: () => initCustomFormatter,
    initDirectivesForSSR: () => initDirectivesForSSR,
    inject: () => inject,
    isMemoSame: () => isMemoSame,
    isProxy: () => isProxy,
    isReactive: () => isReactive,
    isReadonly: () => isReadonly,
    isRef: () => isRef2,
    isRuntimeOnly: () => isRuntimeOnly,
    isShallow: () => isShallow,
    isVNode: () => isVNode,
    markRaw: () => markRaw,
    mergeDefaults: () => mergeDefaults,
    mergeModels: () => mergeModels,
    mergeProps: () => mergeProps,
    nextTick: () => nextTick,
    nodeOps: () => nodeOps,
    normalizeClass: () => normalizeClass,
    normalizeProps: () => normalizeProps,
    normalizeStyle: () => normalizeStyle,
    onActivated: () => onActivated,
    onBeforeMount: () => onBeforeMount,
    onBeforeUnmount: () => onBeforeUnmount,
    onBeforeUpdate: () => onBeforeUpdate,
    onDeactivated: () => onDeactivated,
    onErrorCaptured: () => onErrorCaptured,
    onMounted: () => onMounted,
    onRenderTracked: () => onRenderTracked,
    onRenderTriggered: () => onRenderTriggered,
    onScopeDispose: () => onScopeDispose,
    onServerPrefetch: () => onServerPrefetch,
    onUnmounted: () => onUnmounted,
    onUpdated: () => onUpdated,
    onWatcherCleanup: () => onWatcherCleanup,
    openBlock: () => openBlock,
    patchProp: () => patchProp,
    popScopeId: () => popScopeId,
    provide: () => provide,
    proxyRefs: () => proxyRefs,
    pushScopeId: () => pushScopeId,
    queuePostFlushCb: () => queuePostFlushCb,
    reactive: () => reactive,
    readonly: () => readonly,
    ref: () => ref,
    registerRuntimeCompiler: () => registerRuntimeCompiler,
    render: () => render,
    renderList: () => renderList,
    renderSlot: () => renderSlot,
    resolveComponent: () => resolveComponent,
    resolveDirective: () => resolveDirective,
    resolveDynamicComponent: () => resolveDynamicComponent,
    resolveFilter: () => resolveFilter,
    resolveTransitionHooks: () => resolveTransitionHooks,
    setBlockTracking: () => setBlockTracking,
    setDevtoolsHook: () => setDevtoolsHook,
    setTransitionHooks: () => setTransitionHooks,
    shallowReactive: () => shallowReactive,
    shallowReadonly: () => shallowReadonly,
    shallowRef: () => shallowRef,
    ssrContextKey: () => ssrContextKey,
    ssrUtils: () => ssrUtils,
    stop: () => stop,
    toDisplayString: () => toDisplayString,
    toHandlerKey: () => toHandlerKey,
    toHandlers: () => toHandlers,
    toRaw: () => toRaw,
    toRef: () => toRef,
    toRefs: () => toRefs,
    toValue: () => toValue,
    transformVNodeArgs: () => transformVNodeArgs,
    triggerRef: () => triggerRef,
    unref: () => unref,
    useAttrs: () => useAttrs,
    useCssModule: () => useCssModule,
    useCssVars: () => useCssVars,
    useHost: () => useHost,
    useId: () => useId,
    useModel: () => useModel,
    useSSRContext: () => useSSRContext,
    useShadowRoot: () => useShadowRoot,
    useSlots: () => useSlots,
    useTemplateRef: () => useTemplateRef,
    useTransitionState: () => useTransitionState,
    vModelCheckbox: () => vModelCheckbox,
    vModelDynamic: () => vModelDynamic,
    vModelRadio: () => vModelRadio,
    vModelSelect: () => vModelSelect,
    vModelText: () => vModelText,
    vShow: () => vShow,
    version: () => version,
    warn: () => warn2,
    watch: () => watch2,
    watchEffect: () => watchEffect,
    watchPostEffect: () => watchPostEffect,
    watchSyncEffect: () => watchSyncEffect,
    withAsyncContext: () => withAsyncContext,
    withCtx: () => withCtx,
    withDefaults: () => withDefaults,
    withDirectives: () => withDirectives,
    withKeys: () => withKeys,
    withMemo: () => withMemo,
    withModifiers: () => withModifiers,
    withScopeId: () => withScopeId
  });
  function initDev() {
    {
      initCustomFormatter();
    }
  }
  function compileToFunction(template, options) {
    if (!isString(template)) {
      if (template.nodeType) {
        template = template.innerHTML;
      } else {
        warn2(`invalid template option: `, template);
        return NOOP;
      }
    }
    const key = genCacheKey(template, options);
    const cached = compileCache[key];
    if (cached) {
      return cached;
    }
    if (template[0] === "#") {
      const el = document.querySelector(template);
      if (!el) {
        warn2(`Template element not found or is empty: ${template}`);
      }
      template = el ? el.innerHTML : ``;
    }
    const opts = extend(
      {
        hoistStatic: true,
        onError: true ? onError : void 0,
        onWarn: true ? (e) => onError(e, true) : NOOP
      },
      options
    );
    if (!opts.isCustomElement && typeof customElements !== "undefined") {
      opts.isCustomElement = (tag) => !!customElements.get(tag);
    }
    const { code } = compile2(template, opts);
    function onError(err, asWarning = false) {
      const message = asWarning ? err.message : `Template compilation error: ${err.message}`;
      const codeFrame = err.loc && generateCodeFrame(
        template,
        err.loc.start.offset,
        err.loc.end.offset
      );
      warn2(codeFrame ? `${message}
${codeFrame}` : message);
    }
    const render67 = new Function("Vue", code)(runtime_dom_esm_bundler_exports);
    render67._rc = true;
    return compileCache[key] = render67;
  }
  var compileCache;
  var init_vue_esm_bundler = __esm({
    "node_modules/vue/dist/vue.esm-bundler.js"() {
      init_runtime_dom_esm_bundler();
      init_runtime_dom_esm_bundler();
      init_runtime_dom_esm_bundler();
      init_compiler_dom_esm_bundler();
      init_shared_esm_bundler();
      /**
      * vue v3.5.41
      * (c) 2018-present Yuxi (Evan) You and Vue contributors
      * @license MIT
      **/
      if (true) {
        initDev();
      }
      compileCache = /* @__PURE__ */ Object.create(null);
      registerRuntimeCompiler(compileToFunction);
    }
  });

  // node_modules/konva/lib/Global.js
  function detectBrowser() {
    return typeof window !== "undefined" && ({}.toString.call(window) === "[object Window]" || {}.toString.call(window) === "[object global]");
  }
  var PI_OVER_180, glob, Konva, _registerNode;
  var init_Global = __esm({
    "node_modules/konva/lib/Global.js"() {
      PI_OVER_180 = Math.PI / 180;
      glob = typeof global !== "undefined" ? global : typeof window !== "undefined" ? window : typeof WorkerGlobalScope !== "undefined" ? self : {};
      Konva = {
        _global: glob,
        version: "10.3.0",
        isBrowser: detectBrowser(),
        isUnminified: /param/.test(function(param) {
        }.toString()),
        dblClickWindow: 400,
        getAngle(angle) {
          return Konva.angleDeg ? angle * PI_OVER_180 : angle;
        },
        enableTrace: false,
        pointerEventsEnabled: true,
        autoDrawEnabled: true,
        hitOnDragEnabled: false,
        capturePointerEventsEnabled: false,
        _mouseListenClick: false,
        _touchListenClick: false,
        _pointerListenClick: false,
        _mouseInDblClickWindow: false,
        _touchInDblClickWindow: false,
        _pointerInDblClickWindow: false,
        _mouseDblClickPointerId: null,
        _touchDblClickPointerId: null,
        _pointerDblClickPointerId: null,
        _renderBackend: "web",
        legacyTextRendering: false,
        pixelRatio: typeof window !== "undefined" && window.devicePixelRatio || 1,
        dragDistance: 3,
        angleDeg: true,
        showWarnings: true,
        dragButtons: [0, 1],
        isDragging() {
          return Konva["DD"].isDragging;
        },
        isTransforming() {
          var _a, _b;
          return (_b = (_a = Konva["Transformer"]) === null || _a === void 0 ? void 0 : _a.isTransforming()) !== null && _b !== void 0 ? _b : false;
        },
        isDragReady() {
          return !!Konva["DD"].node;
        },
        releaseCanvasOnDestroy: true,
        document: glob.document,
        _injectGlobal(Konva5) {
          if (typeof glob.Konva !== "undefined") {
            console.error("Several Konva instances detected. It is not recommended to use multiple Konva instances in the same environment.");
          }
          glob.Konva = Konva5;
        }
      };
      _registerNode = (NodeClass) => {
        Konva[NodeClass.prototype.getClassName()] = NodeClass;
      };
      Konva._injectGlobal(Konva);
    }
  });

  // node_modules/konva/lib/Util.js
  var NODE_ERROR, ensureBrowser, Transform, OBJECT_ARRAY, OBJECT_NUMBER, OBJECT_STRING, OBJECT_BOOLEAN, PI_OVER_DEG180, DEG180_OVER_PI, HASH, EMPTY_STRING, ZERO, KONVA_WARNING, KONVA_ERROR, RGB_PAREN, COLORS, RGB_REGEX, animQueue, _isCanvasFarblingActive, req, Util;
  var init_Util = __esm({
    "node_modules/konva/lib/Util.js"() {
      init_Global();
      NODE_ERROR = `Konva.js unsupported environment.

Looks like you are trying to use Konva.js in Node.js environment. because "document" object is undefined.

To use Konva.js in Node.js environment, you need to use the "canvas-backend" or "skia-backend" module.

bash: npm install canvas
js: import "konva/canvas-backend";

or

bash: npm install skia-canvas
js: import "konva/skia-backend";
`;
      ensureBrowser = () => {
        if (typeof document === "undefined") {
          throw new Error(NODE_ERROR);
        }
      };
      Transform = class _Transform {
        constructor(m = [1, 0, 0, 1, 0, 0]) {
          this.dirty = false;
          this.m = m && m.slice() || [1, 0, 0, 1, 0, 0];
        }
        reset() {
          this.m[0] = 1;
          this.m[1] = 0;
          this.m[2] = 0;
          this.m[3] = 1;
          this.m[4] = 0;
          this.m[5] = 0;
        }
        copy() {
          return new _Transform(this.m);
        }
        copyInto(tr) {
          tr.m[0] = this.m[0];
          tr.m[1] = this.m[1];
          tr.m[2] = this.m[2];
          tr.m[3] = this.m[3];
          tr.m[4] = this.m[4];
          tr.m[5] = this.m[5];
        }
        point(point) {
          const m = this.m;
          return {
            x: m[0] * point.x + m[2] * point.y + m[4],
            y: m[1] * point.x + m[3] * point.y + m[5]
          };
        }
        translate(x, y2) {
          this.m[4] += this.m[0] * x + this.m[2] * y2;
          this.m[5] += this.m[1] * x + this.m[3] * y2;
          return this;
        }
        scale(sx, sy) {
          this.m[0] *= sx;
          this.m[1] *= sx;
          this.m[2] *= sy;
          this.m[3] *= sy;
          return this;
        }
        rotate(rad) {
          const c = Math.cos(rad);
          const s = Math.sin(rad);
          const m11 = this.m[0] * c + this.m[2] * s;
          const m12 = this.m[1] * c + this.m[3] * s;
          const m21 = this.m[0] * -s + this.m[2] * c;
          const m22 = this.m[1] * -s + this.m[3] * c;
          this.m[0] = m11;
          this.m[1] = m12;
          this.m[2] = m21;
          this.m[3] = m22;
          return this;
        }
        getTranslation() {
          return {
            x: this.m[4],
            y: this.m[5]
          };
        }
        skew(sx, sy) {
          const m11 = this.m[0] + this.m[2] * sy;
          const m12 = this.m[1] + this.m[3] * sy;
          const m21 = this.m[2] + this.m[0] * sx;
          const m22 = this.m[3] + this.m[1] * sx;
          this.m[0] = m11;
          this.m[1] = m12;
          this.m[2] = m21;
          this.m[3] = m22;
          return this;
        }
        multiply(matrix) {
          const m11 = this.m[0] * matrix.m[0] + this.m[2] * matrix.m[1];
          const m12 = this.m[1] * matrix.m[0] + this.m[3] * matrix.m[1];
          const m21 = this.m[0] * matrix.m[2] + this.m[2] * matrix.m[3];
          const m22 = this.m[1] * matrix.m[2] + this.m[3] * matrix.m[3];
          const dx = this.m[0] * matrix.m[4] + this.m[2] * matrix.m[5] + this.m[4];
          const dy = this.m[1] * matrix.m[4] + this.m[3] * matrix.m[5] + this.m[5];
          this.m[0] = m11;
          this.m[1] = m12;
          this.m[2] = m21;
          this.m[3] = m22;
          this.m[4] = dx;
          this.m[5] = dy;
          return this;
        }
        invert() {
          const d = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]);
          const m0 = this.m[3] * d;
          const m1 = -this.m[1] * d;
          const m2 = -this.m[2] * d;
          const m3 = this.m[0] * d;
          const m4 = d * (this.m[2] * this.m[5] - this.m[3] * this.m[4]);
          const m5 = d * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
          this.m[0] = m0;
          this.m[1] = m1;
          this.m[2] = m2;
          this.m[3] = m3;
          this.m[4] = m4;
          this.m[5] = m5;
          return this;
        }
        getMatrix() {
          return this.m;
        }
        decompose() {
          const a = this.m[0];
          const b2 = this.m[1];
          const c = this.m[2];
          const d = this.m[3];
          const e = this.m[4];
          const f = this.m[5];
          const delta = a * d - b2 * c;
          const result = {
            x: e,
            y: f,
            rotation: 0,
            scaleX: 0,
            scaleY: 0,
            skewX: 0,
            skewY: 0
          };
          if (a != 0 || b2 != 0) {
            const r = Math.sqrt(a * a + b2 * b2);
            result.rotation = b2 > 0 ? Math.acos(a / r) : -Math.acos(a / r);
            result.scaleX = r;
            result.scaleY = delta / r;
            result.skewX = (a * c + b2 * d) / delta;
            result.skewY = 0;
          } else if (c != 0 || d != 0) {
            const s = Math.sqrt(c * c + d * d);
            result.rotation = Math.PI / 2 - (d > 0 ? Math.acos(-c / s) : -Math.acos(c / s));
            result.scaleX = delta / s;
            result.scaleY = s;
            result.skewX = 0;
            result.skewY = (a * c + b2 * d) / delta;
          } else {
          }
          result.rotation = Util._getRotation(result.rotation);
          return result;
        }
      };
      OBJECT_ARRAY = "[object Array]";
      OBJECT_NUMBER = "[object Number]";
      OBJECT_STRING = "[object String]";
      OBJECT_BOOLEAN = "[object Boolean]";
      PI_OVER_DEG180 = Math.PI / 180;
      DEG180_OVER_PI = 180 / Math.PI;
      HASH = "#";
      EMPTY_STRING = "";
      ZERO = "0";
      KONVA_WARNING = "Konva warning: ";
      KONVA_ERROR = "Konva error: ";
      RGB_PAREN = "rgb(";
      COLORS = {
        aliceblue: [240, 248, 255],
        antiquewhite: [250, 235, 215],
        aqua: [0, 255, 255],
        aquamarine: [127, 255, 212],
        azure: [240, 255, 255],
        beige: [245, 245, 220],
        bisque: [255, 228, 196],
        black: [0, 0, 0],
        blanchedalmond: [255, 235, 205],
        blue: [0, 0, 255],
        blueviolet: [138, 43, 226],
        brown: [165, 42, 42],
        burlywood: [222, 184, 135],
        cadetblue: [95, 158, 160],
        chartreuse: [127, 255, 0],
        chocolate: [210, 105, 30],
        coral: [255, 127, 80],
        cornflowerblue: [100, 149, 237],
        cornsilk: [255, 248, 220],
        crimson: [220, 20, 60],
        cyan: [0, 255, 255],
        darkblue: [0, 0, 139],
        darkcyan: [0, 139, 139],
        darkgoldenrod: [184, 132, 11],
        darkgray: [169, 169, 169],
        darkgreen: [0, 100, 0],
        darkgrey: [169, 169, 169],
        darkkhaki: [189, 183, 107],
        darkmagenta: [139, 0, 139],
        darkolivegreen: [85, 107, 47],
        darkorange: [255, 140, 0],
        darkorchid: [153, 50, 204],
        darkred: [139, 0, 0],
        darksalmon: [233, 150, 122],
        darkseagreen: [143, 188, 143],
        darkslateblue: [72, 61, 139],
        darkslategray: [47, 79, 79],
        darkslategrey: [47, 79, 79],
        darkturquoise: [0, 206, 209],
        darkviolet: [148, 0, 211],
        deeppink: [255, 20, 147],
        deepskyblue: [0, 191, 255],
        dimgray: [105, 105, 105],
        dimgrey: [105, 105, 105],
        dodgerblue: [30, 144, 255],
        firebrick: [178, 34, 34],
        floralwhite: [255, 255, 240],
        forestgreen: [34, 139, 34],
        fuchsia: [255, 0, 255],
        gainsboro: [220, 220, 220],
        ghostwhite: [248, 248, 255],
        gold: [255, 215, 0],
        goldenrod: [218, 165, 32],
        gray: [128, 128, 128],
        green: [0, 128, 0],
        greenyellow: [173, 255, 47],
        grey: [128, 128, 128],
        honeydew: [240, 255, 240],
        hotpink: [255, 105, 180],
        indianred: [205, 92, 92],
        indigo: [75, 0, 130],
        ivory: [255, 255, 240],
        khaki: [240, 230, 140],
        lavender: [230, 230, 250],
        lavenderblush: [255, 240, 245],
        lawngreen: [124, 252, 0],
        lemonchiffon: [255, 250, 205],
        lightblue: [173, 216, 230],
        lightcoral: [240, 128, 128],
        lightcyan: [224, 255, 255],
        lightgoldenrodyellow: [250, 250, 210],
        lightgray: [211, 211, 211],
        lightgreen: [144, 238, 144],
        lightgrey: [211, 211, 211],
        lightpink: [255, 182, 193],
        lightsalmon: [255, 160, 122],
        lightseagreen: [32, 178, 170],
        lightskyblue: [135, 206, 250],
        lightslategray: [119, 136, 153],
        lightslategrey: [119, 136, 153],
        lightsteelblue: [176, 196, 222],
        lightyellow: [255, 255, 224],
        lime: [0, 255, 0],
        limegreen: [50, 205, 50],
        linen: [250, 240, 230],
        magenta: [255, 0, 255],
        maroon: [128, 0, 0],
        mediumaquamarine: [102, 205, 170],
        mediumblue: [0, 0, 205],
        mediumorchid: [186, 85, 211],
        mediumpurple: [147, 112, 219],
        mediumseagreen: [60, 179, 113],
        mediumslateblue: [123, 104, 238],
        mediumspringgreen: [0, 250, 154],
        mediumturquoise: [72, 209, 204],
        mediumvioletred: [199, 21, 133],
        midnightblue: [25, 25, 112],
        mintcream: [245, 255, 250],
        mistyrose: [255, 228, 225],
        moccasin: [255, 228, 181],
        navajowhite: [255, 222, 173],
        navy: [0, 0, 128],
        oldlace: [253, 245, 230],
        olive: [128, 128, 0],
        olivedrab: [107, 142, 35],
        orange: [255, 165, 0],
        orangered: [255, 69, 0],
        orchid: [218, 112, 214],
        palegoldenrod: [238, 232, 170],
        palegreen: [152, 251, 152],
        paleturquoise: [175, 238, 238],
        palevioletred: [219, 112, 147],
        papayawhip: [255, 239, 213],
        peachpuff: [255, 218, 185],
        peru: [205, 133, 63],
        pink: [255, 192, 203],
        plum: [221, 160, 203],
        powderblue: [176, 224, 230],
        purple: [128, 0, 128],
        rebeccapurple: [102, 51, 153],
        red: [255, 0, 0],
        rosybrown: [188, 143, 143],
        royalblue: [65, 105, 225],
        saddlebrown: [139, 69, 19],
        salmon: [250, 128, 114],
        sandybrown: [244, 164, 96],
        seagreen: [46, 139, 87],
        seashell: [255, 245, 238],
        sienna: [160, 82, 45],
        silver: [192, 192, 192],
        skyblue: [135, 206, 235],
        slateblue: [106, 90, 205],
        slategray: [119, 128, 144],
        slategrey: [119, 128, 144],
        snow: [255, 255, 250],
        springgreen: [0, 255, 127],
        steelblue: [70, 130, 180],
        tan: [210, 180, 140],
        teal: [0, 128, 128],
        thistle: [216, 191, 216],
        transparent: [255, 255, 255, 0],
        tomato: [255, 99, 71],
        turquoise: [64, 224, 208],
        violet: [238, 130, 238],
        wheat: [245, 222, 179],
        white: [255, 255, 255],
        whitesmoke: [245, 245, 245],
        yellow: [255, 255, 0],
        yellowgreen: [154, 205, 5]
      };
      RGB_REGEX = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/;
      animQueue = [];
      _isCanvasFarblingActive = null;
      req = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame || function(f) {
        setTimeout(f, 16);
      };
      Util = {
        _isElement(obj) {
          return !!(obj && obj.nodeType == 1);
        },
        _isFunction(obj) {
          return !!(obj && obj.constructor && obj.call && obj.apply);
        },
        _isPlainObject(obj) {
          return !!obj && obj.constructor === Object;
        },
        _isArray(obj) {
          return Object.prototype.toString.call(obj) === OBJECT_ARRAY;
        },
        _isNumber(obj) {
          return Object.prototype.toString.call(obj) === OBJECT_NUMBER && !isNaN(obj) && isFinite(obj);
        },
        _isString(obj) {
          return Object.prototype.toString.call(obj) === OBJECT_STRING;
        },
        _isBoolean(obj) {
          return Object.prototype.toString.call(obj) === OBJECT_BOOLEAN;
        },
        isObject(val) {
          return val instanceof Object;
        },
        isValidSelector(selector) {
          if (typeof selector !== "string") {
            return false;
          }
          const firstChar = selector[0];
          return firstChar === "#" || firstChar === "." || firstChar === firstChar.toUpperCase();
        },
        _sign(number) {
          if (number === 0) {
            return 1;
          }
          if (number > 0) {
            return 1;
          } else {
            return -1;
          }
        },
        requestAnimFrame(callback) {
          animQueue.push(callback);
          if (animQueue.length === 1) {
            req(function() {
              const queue2 = animQueue;
              animQueue = [];
              queue2.forEach(function(cb) {
                cb();
              });
            });
          }
        },
        createCanvasElement() {
          ensureBrowser();
          const canvas = document.createElement("canvas");
          try {
            canvas.style = canvas.style || {};
          } catch (e) {
          }
          return canvas;
        },
        createImageElement() {
          ensureBrowser();
          return document.createElement("img");
        },
        _isInDocument(el) {
          while (el = el.parentNode) {
            if (el == document) {
              return true;
            }
          }
          return false;
        },
        _urlToImage(url, callback) {
          const imageObj = Util.createImageElement();
          imageObj.onload = function() {
            callback(imageObj);
          };
          imageObj.src = url;
        },
        _rgbToHex(r, g, b2) {
          return ((1 << 24) + (r << 16) + (g << 8) + b2).toString(16).slice(1);
        },
        _hexToRgb(hex) {
          hex = hex.replace(HASH, EMPTY_STRING);
          const bigint = parseInt(hex, 16);
          return {
            r: bigint >> 16 & 255,
            g: bigint >> 8 & 255,
            b: bigint & 255
          };
        },
        getRandomColor() {
          let randColor = (Math.random() * 16777215 << 0).toString(16);
          while (randColor.length < 6) {
            randColor = ZERO + randColor;
          }
          return HASH + randColor;
        },
        isCanvasFarblingActive() {
          if (_isCanvasFarblingActive !== null) {
            return _isCanvasFarblingActive;
          }
          if (typeof document === "undefined") {
            _isCanvasFarblingActive = false;
            return false;
          }
          const c = this.createCanvasElement();
          c.width = 10;
          c.height = 10;
          const ctx = c.getContext("2d", {
            willReadFrequently: true
          });
          ctx.clearRect(0, 0, 10, 10);
          ctx.fillStyle = "#282828";
          ctx.fillRect(0, 0, 10, 10);
          const d = ctx.getImageData(0, 0, 10, 10).data;
          let isFarbling = false;
          for (let i2 = 0; i2 < 100; i2++) {
            if (d[i2 * 4] !== 40 || d[i2 * 4 + 1] !== 40 || d[i2 * 4 + 2] !== 40 || d[i2 * 4 + 3] !== 255) {
              isFarbling = true;
              break;
            }
          }
          _isCanvasFarblingActive = isFarbling;
          this.releaseCanvas(c);
          return _isCanvasFarblingActive;
        },
        getHitColor() {
          const color = this.getRandomColor();
          return this.isCanvasFarblingActive() ? this.getSnappedHexColor(color) : color;
        },
        getHitColorKey(r, g, b2) {
          if (this.isCanvasFarblingActive()) {
            r = Math.round(r / 5) * 5;
            g = Math.round(g / 5) * 5;
            b2 = Math.round(b2 / 5) * 5;
          }
          return HASH + this._rgbToHex(r, g, b2);
        },
        getSnappedHexColor(hex) {
          const rgb = this._hexToRgb(hex);
          return HASH + this._rgbToHex(Math.round(rgb.r / 5) * 5, Math.round(rgb.g / 5) * 5, Math.round(rgb.b / 5) * 5);
        },
        getRGB(color) {
          let rgb;
          if (color in COLORS) {
            rgb = COLORS[color];
            return {
              r: rgb[0],
              g: rgb[1],
              b: rgb[2]
            };
          } else if (color[0] === HASH) {
            return this._hexToRgb(color.substring(1));
          } else if (color.substr(0, 4) === RGB_PAREN) {
            rgb = RGB_REGEX.exec(color.replace(/ /g, ""));
            return {
              r: parseInt(rgb[1], 10),
              g: parseInt(rgb[2], 10),
              b: parseInt(rgb[3], 10)
            };
          } else {
            return {
              r: 0,
              g: 0,
              b: 0
            };
          }
        },
        colorToRGBA(str) {
          str = str || "black";
          return Util._namedColorToRBA(str) || Util._hex3ColorToRGBA(str) || Util._hex4ColorToRGBA(str) || Util._hex6ColorToRGBA(str) || Util._hex8ColorToRGBA(str) || Util._rgbColorToRGBA(str) || Util._rgbaColorToRGBA(str) || Util._hslColorToRGBA(str);
        },
        _namedColorToRBA(str) {
          const c = COLORS[str.toLowerCase()];
          if (!c) {
            return null;
          }
          return {
            r: c[0],
            g: c[1],
            b: c[2],
            a: 1
          };
        },
        _rgbColorToRGBA(str) {
          if (str.indexOf("rgb(") === 0) {
            str = str.match(/rgb\(([^)]+)\)/)[1];
            const parts = str.split(/ *, */).map(Number);
            return {
              r: parts[0],
              g: parts[1],
              b: parts[2],
              a: 1
            };
          }
        },
        _rgbaColorToRGBA(str) {
          if (str.indexOf("rgba(") === 0) {
            str = str.match(/rgba\(([^)]+)\)/)[1];
            const parts = str.split(/ *, */).map((n, index) => {
              if (n.slice(-1) === "%") {
                return index === 3 ? parseInt(n) / 100 : parseInt(n) / 100 * 255;
              }
              return Number(n);
            });
            return {
              r: parts[0],
              g: parts[1],
              b: parts[2],
              a: parts[3]
            };
          }
        },
        _hex8ColorToRGBA(str) {
          if (str[0] === "#" && str.length === 9) {
            return {
              r: parseInt(str.slice(1, 3), 16),
              g: parseInt(str.slice(3, 5), 16),
              b: parseInt(str.slice(5, 7), 16),
              a: parseInt(str.slice(7, 9), 16) / 255
            };
          }
        },
        _hex6ColorToRGBA(str) {
          if (str[0] === "#" && str.length === 7) {
            return {
              r: parseInt(str.slice(1, 3), 16),
              g: parseInt(str.slice(3, 5), 16),
              b: parseInt(str.slice(5, 7), 16),
              a: 1
            };
          }
        },
        _hex4ColorToRGBA(str) {
          if (str[0] === "#" && str.length === 5) {
            return {
              r: parseInt(str[1] + str[1], 16),
              g: parseInt(str[2] + str[2], 16),
              b: parseInt(str[3] + str[3], 16),
              a: parseInt(str[4] + str[4], 16) / 255
            };
          }
        },
        _hex3ColorToRGBA(str) {
          if (str[0] === "#" && str.length === 4) {
            return {
              r: parseInt(str[1] + str[1], 16),
              g: parseInt(str[2] + str[2], 16),
              b: parseInt(str[3] + str[3], 16),
              a: 1
            };
          }
        },
        _hslColorToRGBA(str) {
          if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(str)) {
            const [_2, ...hsl] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(str);
            const h2 = Number(hsl[0]) / 360;
            const s = Number(hsl[1]) / 100;
            const l = Number(hsl[2]) / 100;
            let t2;
            let t3;
            let val;
            if (s === 0) {
              val = l * 255;
              return {
                r: Math.round(val),
                g: Math.round(val),
                b: Math.round(val),
                a: 1
              };
            }
            if (l < 0.5) {
              t2 = l * (1 + s);
            } else {
              t2 = l + s - l * s;
            }
            const t1 = 2 * l - t2;
            const rgb = [0, 0, 0];
            for (let i2 = 0; i2 < 3; i2++) {
              t3 = h2 + 1 / 3 * -(i2 - 1);
              if (t3 < 0) {
                t3++;
              }
              if (t3 > 1) {
                t3--;
              }
              if (6 * t3 < 1) {
                val = t1 + (t2 - t1) * 6 * t3;
              } else if (2 * t3 < 1) {
                val = t2;
              } else if (3 * t3 < 2) {
                val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
              } else {
                val = t1;
              }
              rgb[i2] = val * 255;
            }
            return {
              r: Math.round(rgb[0]),
              g: Math.round(rgb[1]),
              b: Math.round(rgb[2]),
              a: 1
            };
          }
        },
        haveIntersection(r1, r2) {
          return !(r2.x > r1.x + r1.width || r2.x + r2.width < r1.x || r2.y > r1.y + r1.height || r2.y + r2.height < r1.y);
        },
        cloneObject(obj) {
          const retObj = {};
          for (const key in obj) {
            if (this._isPlainObject(obj[key])) {
              retObj[key] = this.cloneObject(obj[key]);
            } else if (this._isArray(obj[key])) {
              retObj[key] = this.cloneArray(obj[key]);
            } else {
              retObj[key] = obj[key];
            }
          }
          return retObj;
        },
        cloneArray(arr) {
          return arr.slice(0);
        },
        degToRad(deg) {
          return deg * PI_OVER_DEG180;
        },
        radToDeg(rad) {
          return rad * DEG180_OVER_PI;
        },
        _degToRad(deg) {
          Util.warn("Util._degToRad is removed. Please use public Util.degToRad instead.");
          return Util.degToRad(deg);
        },
        _radToDeg(rad) {
          Util.warn("Util._radToDeg is removed. Please use public Util.radToDeg instead.");
          return Util.radToDeg(rad);
        },
        _getRotation(radians) {
          return Konva.angleDeg ? Util.radToDeg(radians) : radians;
        },
        _capitalize(str) {
          return str.charAt(0).toUpperCase() + str.slice(1);
        },
        throw(str) {
          throw new Error(KONVA_ERROR + str);
        },
        error(str) {
          console.error(KONVA_ERROR + str);
        },
        warn(str) {
          if (!Konva.showWarnings) {
            return;
          }
          console.warn(KONVA_WARNING + str);
        },
        each(obj, func) {
          for (const key in obj) {
            func(key, obj[key]);
          }
        },
        _inRange(val, left, right) {
          return left <= val && val < right;
        },
        _getProjectionToSegment(x1, y1, x2, y2, x3, y3) {
          let x, y4, dist;
          const pd2 = (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
          if (pd2 == 0) {
            x = x1;
            y4 = y1;
            dist = (x3 - x2) * (x3 - x2) + (y3 - y2) * (y3 - y2);
          } else {
            const u2 = ((x3 - x1) * (x2 - x1) + (y3 - y1) * (y2 - y1)) / pd2;
            if (u2 < 0) {
              x = x1;
              y4 = y1;
              dist = (x1 - x3) * (x1 - x3) + (y1 - y3) * (y1 - y3);
            } else if (u2 > 1) {
              x = x2;
              y4 = y2;
              dist = (x2 - x3) * (x2 - x3) + (y2 - y3) * (y2 - y3);
            } else {
              x = x1 + u2 * (x2 - x1);
              y4 = y1 + u2 * (y2 - y1);
              dist = (x - x3) * (x - x3) + (y4 - y3) * (y4 - y3);
            }
          }
          return [x, y4, dist];
        },
        _getProjectionToLine(pt, line, isClosed) {
          const pc = Util.cloneObject(pt);
          let dist = Number.MAX_VALUE;
          line.forEach(function(p1, i2) {
            if (!isClosed && i2 === line.length - 1) {
              return;
            }
            const p2 = line[(i2 + 1) % line.length];
            const proj = Util._getProjectionToSegment(p1.x, p1.y, p2.x, p2.y, pt.x, pt.y);
            const px = proj[0], py = proj[1], pdist = proj[2];
            if (pdist < dist) {
              pc.x = px;
              pc.y = py;
              dist = pdist;
            }
          });
          return pc;
        },
        _prepareArrayForTween(startArray, endArray, isClosed) {
          const start = [], end = [];
          if (startArray.length > endArray.length) {
            const temp = endArray;
            endArray = startArray;
            startArray = temp;
          }
          for (let n = 0; n < startArray.length; n += 2) {
            start.push({
              x: startArray[n],
              y: startArray[n + 1]
            });
          }
          for (let n = 0; n < endArray.length; n += 2) {
            end.push({
              x: endArray[n],
              y: endArray[n + 1]
            });
          }
          const newStart = [];
          end.forEach(function(point) {
            const pr = Util._getProjectionToLine(point, start, isClosed);
            newStart.push(pr.x);
            newStart.push(pr.y);
          });
          return newStart;
        },
        _prepareToStringify(obj) {
          let desc;
          obj.visitedByCircularReferenceRemoval = true;
          for (const key in obj) {
            if (!(obj.hasOwnProperty(key) && obj[key] && typeof obj[key] == "object")) {
              continue;
            }
            desc = Object.getOwnPropertyDescriptor(obj, key);
            if (obj[key].visitedByCircularReferenceRemoval || Util._isElement(obj[key])) {
              if (desc.configurable) {
                delete obj[key];
              } else {
                return null;
              }
            } else if (Util._prepareToStringify(obj[key]) === null) {
              if (desc.configurable) {
                delete obj[key];
              } else {
                return null;
              }
            }
          }
          delete obj.visitedByCircularReferenceRemoval;
          return obj;
        },
        _assign(target, source) {
          for (const key in source) {
            target[key] = source[key];
          }
          return target;
        },
        _getFirstPointerId(evt) {
          if (!evt.touches) {
            return evt.pointerId || 999;
          } else {
            return evt.changedTouches[0].identifier;
          }
        },
        releaseCanvas(...canvases) {
          if (!Konva.releaseCanvasOnDestroy)
            return;
          canvases.forEach((c) => {
            c.width = 0;
            c.height = 0;
          });
        },
        drawRoundedRectPath(context, width, height, cornerRadius) {
          let xOrigin = width < 0 ? width : 0;
          let yOrigin = height < 0 ? height : 0;
          width = Math.abs(width);
          height = Math.abs(height);
          let topLeft = 0;
          let topRight = 0;
          let bottomLeft = 0;
          let bottomRight = 0;
          if (typeof cornerRadius === "number") {
            topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
          } else {
            topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
            topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
            bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
            bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
          }
          context.moveTo(xOrigin + topLeft, yOrigin);
          context.lineTo(xOrigin + width - topRight, yOrigin);
          context.arc(xOrigin + width - topRight, yOrigin + topRight, topRight, Math.PI * 3 / 2, 0, false);
          context.lineTo(xOrigin + width, yOrigin + height - bottomRight);
          context.arc(xOrigin + width - bottomRight, yOrigin + height - bottomRight, bottomRight, 0, Math.PI / 2, false);
          context.lineTo(xOrigin + bottomLeft, yOrigin + height);
          context.arc(xOrigin + bottomLeft, yOrigin + height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
          context.lineTo(xOrigin, yOrigin + topLeft);
          context.arc(xOrigin + topLeft, yOrigin + topLeft, topLeft, Math.PI, Math.PI * 3 / 2, false);
        },
        drawRoundedPolygonPath(context, points, sides, radius, cornerRadius) {
          radius = Math.abs(radius);
          for (let i2 = 0; i2 < sides; i2++) {
            const prev = points[(i2 - 1 + sides) % sides];
            const curr = points[i2];
            const next = points[(i2 + 1) % sides];
            const vec1 = { x: curr.x - prev.x, y: curr.y - prev.y };
            const vec2 = { x: next.x - curr.x, y: next.y - curr.y };
            const len1 = Math.hypot(vec1.x, vec1.y);
            const len2 = Math.hypot(vec2.x, vec2.y);
            let currCornerRadius;
            if (typeof cornerRadius === "number") {
              currCornerRadius = cornerRadius;
            } else {
              currCornerRadius = i2 < cornerRadius.length ? cornerRadius[i2] : 0;
            }
            const maxCornerRadius = radius * Math.cos(Math.PI / sides);
            currCornerRadius = maxCornerRadius * Math.min(1, currCornerRadius / radius * 2);
            const normalVec1 = { x: vec1.x / len1, y: vec1.y / len1 };
            const normalVec2 = { x: vec2.x / len2, y: vec2.y / len2 };
            const p1 = {
              x: curr.x - normalVec1.x * currCornerRadius,
              y: curr.y - normalVec1.y * currCornerRadius
            };
            const p2 = {
              x: curr.x + normalVec2.x * currCornerRadius,
              y: curr.y + normalVec2.y * currCornerRadius
            };
            if (i2 === 0) {
              context.moveTo(p1.x, p1.y);
            } else {
              context.lineTo(p1.x, p1.y);
            }
            context.arcTo(curr.x, curr.y, p2.x, p2.y, currCornerRadius);
          }
        }
      };
    }
  });

  // node_modules/konva/lib/Context.js
  function simplifyArray(arr) {
    const retArr = [], len = arr.length, util = Util;
    for (let n = 0; n < len; n++) {
      let val = arr[n];
      if (util._isNumber(val)) {
        val = Math.round(val * 1e3) / 1e3;
      } else if (!util._isString(val)) {
        val = val + "";
      }
      retArr.push(val);
    }
    return retArr;
  }
  function isCSSFiltersSupported() {
    if (_cssFiltersSupported !== null) {
      return _cssFiltersSupported;
    }
    try {
      const canvas = Util.createCanvasElement();
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        _cssFiltersSupported = false;
        return false;
      }
      return !!ctx && "filter" in ctx;
    } catch (e) {
      _cssFiltersSupported = false;
      return false;
    }
  }
  var COMMA, OPEN_PAREN, CLOSE_PAREN, OPEN_PAREN_BRACKET, CLOSE_BRACKET_PAREN, SEMICOLON, DOUBLE_PAREN, EQUALS, CONTEXT_METHODS, CONTEXT_PROPERTIES, traceArrMax, _cssFiltersSupported, Context, SceneContext, HitContext;
  var init_Context = __esm({
    "node_modules/konva/lib/Context.js"() {
      init_Util();
      init_Global();
      COMMA = ",";
      OPEN_PAREN = "(";
      CLOSE_PAREN = ")";
      OPEN_PAREN_BRACKET = "([";
      CLOSE_BRACKET_PAREN = "])";
      SEMICOLON = ";";
      DOUBLE_PAREN = "()";
      EQUALS = "=";
      CONTEXT_METHODS = [
        "arc",
        "arcTo",
        "beginPath",
        "bezierCurveTo",
        "clearRect",
        "clip",
        "closePath",
        "createLinearGradient",
        "createPattern",
        "createRadialGradient",
        "drawImage",
        "ellipse",
        "fill",
        "fillText",
        "getImageData",
        "createImageData",
        "lineTo",
        "moveTo",
        "putImageData",
        "quadraticCurveTo",
        "rect",
        "roundRect",
        "restore",
        "rotate",
        "save",
        "scale",
        "setLineDash",
        "setTransform",
        "stroke",
        "strokeText",
        "transform",
        "translate"
      ];
      CONTEXT_PROPERTIES = [
        "fillStyle",
        "strokeStyle",
        "shadowColor",
        "shadowBlur",
        "shadowOffsetX",
        "shadowOffsetY",
        "letterSpacing",
        "lineCap",
        "lineDashOffset",
        "lineJoin",
        "lineWidth",
        "miterLimit",
        "direction",
        "font",
        "textAlign",
        "textBaseline",
        "globalAlpha",
        "globalCompositeOperation",
        "imageSmoothingEnabled",
        "filter"
      ];
      traceArrMax = 100;
      _cssFiltersSupported = null;
      Context = class {
        constructor(canvas) {
          this.canvas = canvas;
          if (Konva.enableTrace) {
            this.traceArr = [];
            this._enableTrace();
          }
        }
        fillShape(shape) {
          if (shape.fillEnabled()) {
            this._fill(shape);
          }
        }
        _fill(shape) {
        }
        strokeShape(shape) {
          if (shape.hasStroke()) {
            this._stroke(shape);
          }
        }
        _stroke(shape) {
        }
        fillStrokeShape(shape) {
          if (shape.attrs.fillAfterStrokeEnabled) {
            this.strokeShape(shape);
            this.fillShape(shape);
          } else {
            this.fillShape(shape);
            this.strokeShape(shape);
          }
        }
        getTrace(relaxed, rounded) {
          let traceArr = this.traceArr, len = traceArr.length, str = "", n, trace, method, args;
          for (n = 0; n < len; n++) {
            trace = traceArr[n];
            method = trace.method;
            if (method) {
              args = trace.args;
              str += method;
              if (relaxed) {
                str += DOUBLE_PAREN;
              } else {
                if (Util._isArray(args[0])) {
                  str += OPEN_PAREN_BRACKET + args.join(COMMA) + CLOSE_BRACKET_PAREN;
                } else {
                  if (rounded) {
                    args = args.map((a) => typeof a === "number" ? Math.floor(a) : a);
                  }
                  str += OPEN_PAREN + args.join(COMMA) + CLOSE_PAREN;
                }
              }
            } else {
              str += trace.property;
              if (!relaxed) {
                str += EQUALS + trace.val;
              }
            }
            str += SEMICOLON;
          }
          return str;
        }
        clearTrace() {
          this.traceArr = [];
        }
        _trace(str) {
          let traceArr = this.traceArr, len;
          traceArr.push(str);
          len = traceArr.length;
          if (len >= traceArrMax) {
            traceArr.shift();
          }
        }
        reset() {
          const pixelRatio = this.getCanvas().getPixelRatio();
          this.setTransform(1 * pixelRatio, 0, 0, 1 * pixelRatio, 0, 0);
        }
        getCanvas() {
          return this.canvas;
        }
        clear(bounds) {
          const canvas = this.getCanvas();
          if (bounds) {
            this.clearRect(bounds.x || 0, bounds.y || 0, bounds.width || 0, bounds.height || 0);
          } else {
            this.clearRect(0, 0, canvas.getWidth() / canvas.pixelRatio, canvas.getHeight() / canvas.pixelRatio);
          }
        }
        _applyLineCap(shape) {
          const lineCap = shape.attrs.lineCap;
          if (lineCap) {
            this.setAttr("lineCap", lineCap);
          }
        }
        _applyOpacity(shape) {
          const absOpacity = shape.getAbsoluteOpacity();
          if (absOpacity !== 1) {
            this.setAttr("globalAlpha", absOpacity);
          }
        }
        _applyLineJoin(shape) {
          const lineJoin = shape.attrs.lineJoin;
          if (lineJoin) {
            this.setAttr("lineJoin", lineJoin);
          }
        }
        _applyMiterLimit(shape) {
          const miterLimit = shape.attrs.miterLimit;
          if (miterLimit != null) {
            this.setAttr("miterLimit", miterLimit);
          }
        }
        setAttr(attr, val) {
          this._context[attr] = val;
        }
        arc(x, y2, radius, startAngle, endAngle, counterClockwise) {
          this._context.arc(x, y2, radius, startAngle, endAngle, counterClockwise);
        }
        arcTo(x1, y1, x2, y2, radius) {
          this._context.arcTo(x1, y1, x2, y2, radius);
        }
        beginPath() {
          this._context.beginPath();
        }
        bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y2) {
          this._context.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y2);
        }
        clearRect(x, y2, width, height) {
          this._context.clearRect(x, y2, width, height);
        }
        clip(...args) {
          this._context.clip.apply(this._context, args);
        }
        closePath() {
          this._context.closePath();
        }
        createImageData(width, height) {
          const a = arguments;
          if (a.length === 2) {
            return this._context.createImageData(width, height);
          } else if (a.length === 1) {
            return this._context.createImageData(width);
          }
        }
        createLinearGradient(x0, y0, x1, y1) {
          return this._context.createLinearGradient(x0, y0, x1, y1);
        }
        createPattern(image, repetition) {
          return this._context.createPattern(image, repetition);
        }
        createRadialGradient(x0, y0, r0, x1, y1, r1) {
          return this._context.createRadialGradient(x0, y0, r0, x1, y1, r1);
        }
        drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight) {
          const a = arguments, _context = this._context;
          if (a.length === 3) {
            _context.drawImage(image, sx, sy);
          } else if (a.length === 5) {
            _context.drawImage(image, sx, sy, sWidth, sHeight);
          } else if (a.length === 9) {
            _context.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
          }
        }
        ellipse(x, y2, radiusX, radiusY, rotation, startAngle, endAngle, counterclockwise) {
          this._context.ellipse(x, y2, radiusX, radiusY, rotation, startAngle, endAngle, counterclockwise);
        }
        isPointInPath(x, y2, path, fillRule) {
          if (path) {
            return this._context.isPointInPath(path, x, y2, fillRule);
          }
          return this._context.isPointInPath(x, y2, fillRule);
        }
        fill(...args) {
          this._context.fill.apply(this._context, args);
        }
        fillRect(x, y2, width, height) {
          this._context.fillRect(x, y2, width, height);
        }
        strokeRect(x, y2, width, height) {
          this._context.strokeRect(x, y2, width, height);
        }
        fillText(text, x, y2, maxWidth) {
          if (maxWidth) {
            this._context.fillText(text, x, y2, maxWidth);
          } else {
            this._context.fillText(text, x, y2);
          }
        }
        measureText(text) {
          return this._context.measureText(text);
        }
        getImageData(sx, sy, sw, sh) {
          return this._context.getImageData(sx, sy, sw, sh);
        }
        lineTo(x, y2) {
          this._context.lineTo(x, y2);
        }
        moveTo(x, y2) {
          this._context.moveTo(x, y2);
        }
        rect(x, y2, width, height) {
          this._context.rect(x, y2, width, height);
        }
        roundRect(x, y2, width, height, radii) {
          this._context.roundRect(x, y2, width, height, radii);
        }
        putImageData(imageData, dx, dy) {
          this._context.putImageData(imageData, dx, dy);
        }
        quadraticCurveTo(cpx, cpy, x, y2) {
          this._context.quadraticCurveTo(cpx, cpy, x, y2);
        }
        restore() {
          this._context.restore();
        }
        rotate(angle) {
          this._context.rotate(angle);
        }
        save() {
          this._context.save();
        }
        scale(x, y2) {
          this._context.scale(x, y2);
        }
        setLineDash(segments) {
          if (this._context.setLineDash) {
            this._context.setLineDash(segments);
          } else if ("mozDash" in this._context) {
            this._context["mozDash"] = segments;
          } else if ("webkitLineDash" in this._context) {
            this._context["webkitLineDash"] = segments;
          }
        }
        getLineDash() {
          return this._context.getLineDash();
        }
        setTransform(a, b2, c, d, e, f) {
          this._context.setTransform(a, b2, c, d, e, f);
        }
        stroke(path2d) {
          if (path2d) {
            this._context.stroke(path2d);
          } else {
            this._context.stroke();
          }
        }
        strokeText(text, x, y2, maxWidth) {
          this._context.strokeText(text, x, y2, maxWidth);
        }
        transform(a, b2, c, d, e, f) {
          this._context.transform(a, b2, c, d, e, f);
        }
        translate(x, y2) {
          this._context.translate(x, y2);
        }
        _enableTrace() {
          let that = this, len = CONTEXT_METHODS.length, origSetter = this.setAttr, n, args;
          const func = function(methodName) {
            let origMethod = that[methodName], ret;
            that[methodName] = function() {
              args = simplifyArray(Array.prototype.slice.call(arguments, 0));
              ret = origMethod.apply(that, arguments);
              that._trace({
                method: methodName,
                args
              });
              return ret;
            };
          };
          for (n = 0; n < len; n++) {
            func(CONTEXT_METHODS[n]);
          }
          that.setAttr = function() {
            origSetter.apply(that, arguments);
            const prop = arguments[0];
            let val = arguments[1];
            if (prop === "shadowOffsetX" || prop === "shadowOffsetY" || prop === "shadowBlur") {
              val = val / this.canvas.getPixelRatio();
            }
            that._trace({
              property: prop,
              val
            });
          };
        }
        _applyGlobalCompositeOperation(node) {
          const op = node.attrs.globalCompositeOperation;
          const def2 = !op || op === "source-over";
          if (!def2) {
            this.setAttr("globalCompositeOperation", op);
          }
        }
      };
      CONTEXT_PROPERTIES.forEach(function(prop) {
        Object.defineProperty(Context.prototype, prop, {
          get() {
            return this._context[prop];
          },
          set(val) {
            this._context[prop] = val;
          }
        });
      });
      SceneContext = class extends Context {
        constructor(canvas, { willReadFrequently = false } = {}) {
          super(canvas);
          this._context = canvas._canvas.getContext("2d", {
            willReadFrequently
          });
        }
        _fillColor(shape) {
          const fill = shape.fill();
          this.setAttr("fillStyle", fill);
          shape._fillFunc(this);
        }
        _fillPattern(shape) {
          this.setAttr("fillStyle", shape._getFillPattern());
          shape._fillFunc(this);
        }
        _fillLinearGradient(shape) {
          const grd = shape._getLinearGradient();
          if (grd) {
            this.setAttr("fillStyle", grd);
            shape._fillFunc(this);
          }
        }
        _fillRadialGradient(shape) {
          const grd = shape._getRadialGradient();
          if (grd) {
            this.setAttr("fillStyle", grd);
            shape._fillFunc(this);
          }
        }
        _fill(shape) {
          const hasColor = shape.fill(), fillPriority = shape.getFillPriority();
          if (hasColor && fillPriority === "color") {
            this._fillColor(shape);
            return;
          }
          const hasPattern = shape.getFillPatternImage();
          if (hasPattern && fillPriority === "pattern") {
            this._fillPattern(shape);
            return;
          }
          const hasLinearGradient = shape.getFillLinearGradientColorStops();
          if (hasLinearGradient && fillPriority === "linear-gradient") {
            this._fillLinearGradient(shape);
            return;
          }
          const hasRadialGradient = shape.getFillRadialGradientColorStops();
          if (hasRadialGradient && fillPriority === "radial-gradient") {
            this._fillRadialGradient(shape);
            return;
          }
          if (hasColor) {
            this._fillColor(shape);
          } else if (hasPattern) {
            this._fillPattern(shape);
          } else if (hasLinearGradient) {
            this._fillLinearGradient(shape);
          } else if (hasRadialGradient) {
            this._fillRadialGradient(shape);
          }
        }
        _strokeLinearGradient(shape) {
          const start = shape.getStrokeLinearGradientStartPoint(), end = shape.getStrokeLinearGradientEndPoint(), colorStops = shape.getStrokeLinearGradientColorStops(), grd = this.createLinearGradient(start.x, start.y, end.x, end.y);
          if (colorStops) {
            for (let n = 0; n < colorStops.length; n += 2) {
              grd.addColorStop(colorStops[n], colorStops[n + 1]);
            }
            this.setAttr("strokeStyle", grd);
          }
        }
        _stroke(shape) {
          const dash = shape.dash(), strokeScaleEnabled = shape.getStrokeScaleEnabled();
          if (shape.hasStroke()) {
            if (!strokeScaleEnabled) {
              this.save();
              const pixelRatio = this.getCanvas().getPixelRatio();
              this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            if (dash && shape.dashEnabled()) {
              this.setLineDash(dash);
              this.setAttr("lineDashOffset", shape.dashOffset());
            }
            this.setAttr("lineWidth", shape.strokeWidth());
            if (!shape.getShadowForStrokeEnabled()) {
              this.setAttr("shadowColor", "rgba(0,0,0,0)");
            }
            const hasLinearGradient = shape.getStrokeLinearGradientColorStops();
            if (hasLinearGradient) {
              this._strokeLinearGradient(shape);
            } else {
              this.setAttr("strokeStyle", shape.stroke());
            }
            shape._strokeFunc(this);
            if (!strokeScaleEnabled) {
              this.restore();
            }
          }
        }
        _applyShadow(shape) {
          var _a, _b, _c;
          const color = (_a = shape.getShadowRGBA()) !== null && _a !== void 0 ? _a : "black", blur = (_b = shape.getShadowBlur()) !== null && _b !== void 0 ? _b : 5, offset = (_c = shape.getShadowOffset()) !== null && _c !== void 0 ? _c : {
            x: 0,
            y: 0
          }, scale = shape.getAbsoluteScale(), ratio = this.canvas.getPixelRatio(), scaleX = scale.x * ratio, scaleY = scale.y * ratio;
          this.setAttr("shadowColor", color);
          this.setAttr("shadowBlur", blur * Math.min(Math.abs(scaleX), Math.abs(scaleY)));
          this.setAttr("shadowOffsetX", offset.x * scaleX);
          this.setAttr("shadowOffsetY", offset.y * scaleY);
        }
      };
      HitContext = class extends Context {
        constructor(canvas) {
          super(canvas);
          this._context = canvas._canvas.getContext("2d", {
            willReadFrequently: true
          });
        }
        _fill(shape) {
          this.save();
          this.setAttr("fillStyle", shape.colorKey);
          shape._fillFuncHit(this);
          this.restore();
        }
        strokeShape(shape) {
          if (shape.hasHitStroke()) {
            this._stroke(shape);
          }
        }
        _stroke(shape) {
          if (shape.hasHitStroke()) {
            const strokeScaleEnabled = shape.getStrokeScaleEnabled();
            if (!strokeScaleEnabled) {
              this.save();
              const pixelRatio = this.getCanvas().getPixelRatio();
              this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            const hitStrokeWidth = shape.hitStrokeWidth();
            const strokeWidth = hitStrokeWidth === "auto" ? shape.strokeWidth() : hitStrokeWidth;
            this.setAttr("lineWidth", strokeWidth);
            this.setAttr("strokeStyle", shape.colorKey);
            shape._strokeFuncHit(this);
            if (!strokeScaleEnabled) {
              this.restore();
            }
          }
        }
      };
    }
  });

  // node_modules/konva/lib/Canvas.js
  function getDevicePixelRatio() {
    if (_pixelRatio) {
      return _pixelRatio;
    }
    const canvas = Util.createCanvasElement();
    const context = canvas.getContext("2d");
    _pixelRatio = (function() {
      const devicePixelRatio = Konva._global.devicePixelRatio || 1, backingStoreRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
      return devicePixelRatio / backingStoreRatio;
    })();
    Util.releaseCanvas(canvas);
    return _pixelRatio;
  }
  var _pixelRatio, Canvas, SceneCanvas, HitCanvas;
  var init_Canvas = __esm({
    "node_modules/konva/lib/Canvas.js"() {
      init_Util();
      init_Context();
      init_Global();
      Canvas = class {
        constructor(config) {
          this.pixelRatio = 1;
          this.width = 0;
          this.height = 0;
          this.isCache = false;
          const conf = config || {};
          const pixelRatio = conf.pixelRatio || Konva.pixelRatio || getDevicePixelRatio();
          this.pixelRatio = pixelRatio;
          this._canvas = Util.createCanvasElement();
          this._canvas.style.padding = "0";
          this._canvas.style.margin = "0";
          this._canvas.style.border = "0";
          this._canvas.style.background = "transparent";
          this._canvas.style.position = "absolute";
          this._canvas.style.top = "0";
          this._canvas.style.left = "0";
        }
        getContext() {
          return this.context;
        }
        getPixelRatio() {
          return this.pixelRatio;
        }
        setPixelRatio(pixelRatio) {
          const previousRatio = this.pixelRatio;
          this.pixelRatio = pixelRatio;
          this.setSize(this.getWidth() / previousRatio, this.getHeight() / previousRatio);
        }
        setWidth(width) {
          this.width = this._canvas.width = width * this.pixelRatio;
          this._canvas.style.width = width + "px";
          const pixelRatio = this.pixelRatio, _context = this.getContext()._context;
          _context.scale(pixelRatio, pixelRatio);
        }
        setHeight(height) {
          this.height = this._canvas.height = height * this.pixelRatio;
          this._canvas.style.height = height + "px";
          const pixelRatio = this.pixelRatio, _context = this.getContext()._context;
          _context.scale(pixelRatio, pixelRatio);
        }
        getWidth() {
          return this.width;
        }
        getHeight() {
          return this.height;
        }
        setSize(width, height) {
          this.setWidth(width || 0);
          this.setHeight(height || 0);
        }
        toDataURL(mimeType, quality) {
          try {
            return this._canvas.toDataURL(mimeType, quality);
          } catch (e) {
            try {
              return this._canvas.toDataURL();
            } catch (err) {
              Util.error("Unable to get data URL. " + err.message + " For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html.");
              return "";
            }
          }
        }
      };
      SceneCanvas = class extends Canvas {
        constructor(config = { width: 0, height: 0, willReadFrequently: false }) {
          super(config);
          this.context = new SceneContext(this, {
            willReadFrequently: config.willReadFrequently
          });
          this.setSize(config.width, config.height);
        }
      };
      HitCanvas = class extends Canvas {
        constructor(config = { width: 0, height: 0 }) {
          super(config);
          this.hitCanvas = true;
          this.context = new HitContext(this);
          this.setSize(config.width, config.height);
        }
      };
    }
  });

  // node_modules/konva/lib/DragAndDrop.js
  var DD;
  var init_DragAndDrop = __esm({
    "node_modules/konva/lib/DragAndDrop.js"() {
      init_Global();
      init_Util();
      DD = {
        get isDragging() {
          let flag = false;
          DD._dragElements.forEach((elem) => {
            if (elem.dragStatus === "dragging") {
              flag = true;
            }
          });
          return flag;
        },
        justDragged: false,
        get node() {
          let node;
          DD._dragElements.forEach((elem) => {
            node = elem.node;
          });
          return node;
        },
        _dragElements: /* @__PURE__ */ new Map(),
        _drag(evt) {
          const nodesToFireEvents = [];
          DD._dragElements.forEach((elem, key) => {
            const { node } = elem;
            const stage = node.getStage();
            stage.setPointersPositions(evt);
            if (elem.pointerId === void 0) {
              elem.pointerId = Util._getFirstPointerId(evt);
            }
            const pos = stage._changedPointerPositions.find((pos2) => pos2.id === elem.pointerId);
            if (!pos) {
              return;
            }
            if (elem.dragStatus !== "dragging") {
              const dragDistance = node.dragDistance();
              const distance = Math.max(Math.abs(pos.x - elem.startPointerPos.x), Math.abs(pos.y - elem.startPointerPos.y));
              if (distance < dragDistance) {
                return;
              }
              node.startDrag({ evt });
              if (!node.isDragging()) {
                return;
              }
            }
            node._setDragPosition(evt, elem);
            nodesToFireEvents.push(node);
          });
          nodesToFireEvents.forEach((node) => {
            if (!node.getStage()) {
              return;
            }
            node.fire("dragmove", {
              type: "dragmove",
              target: node,
              evt
            }, true);
          });
        },
        _endDragBefore(evt) {
          const drawNodes = [];
          DD._dragElements.forEach((elem) => {
            const { node } = elem;
            const stage = node.getStage();
            if (evt) {
              stage.setPointersPositions(evt);
            }
            const pos = stage._changedPointerPositions.find((pos2) => pos2.id === elem.pointerId);
            if (!pos) {
              return;
            }
            if (elem.dragStatus === "dragging" || elem.dragStatus === "stopped") {
              DD.justDragged = true;
              Konva._mouseListenClick = false;
              Konva._touchListenClick = false;
              Konva._pointerListenClick = false;
              elem.dragStatus = "stopped";
            }
            const drawNode = elem.node.getLayer() || elem.node instanceof Konva["Stage"] && elem.node;
            if (drawNode && drawNodes.indexOf(drawNode) === -1) {
              drawNodes.push(drawNode);
            }
          });
          drawNodes.forEach((drawNode) => {
            drawNode.draw();
          });
        },
        _endDragAfter(evt) {
          DD._dragElements.forEach((elem, key) => {
            if (elem.dragStatus === "stopped") {
              elem.node.fire("dragend", {
                type: "dragend",
                target: elem.node,
                evt
              }, true);
            }
            if (elem.dragStatus !== "dragging") {
              DD._dragElements.delete(key);
            }
          });
        }
      };
      if (Konva.isBrowser) {
        window.addEventListener("mouseup", DD._endDragBefore, true);
        window.addEventListener("touchend", DD._endDragBefore, true);
        window.addEventListener("touchcancel", DD._endDragBefore, true);
        window.addEventListener("mousemove", DD._drag);
        window.addEventListener("touchmove", DD._drag);
        window.addEventListener("mouseup", DD._endDragAfter, false);
        window.addEventListener("touchend", DD._endDragAfter, false);
        window.addEventListener("touchcancel", DD._endDragAfter, false);
      }
    }
  });

  // node_modules/konva/lib/Validators.js
  function _formatValue(val) {
    if (Util._isString(val)) {
      return '"' + val + '"';
    }
    if (Object.prototype.toString.call(val) === "[object Number]") {
      return val;
    }
    if (Util._isBoolean(val)) {
      return val;
    }
    return Object.prototype.toString.call(val);
  }
  function RGBComponent(val) {
    if (val > 255) {
      return 255;
    } else if (val < 0) {
      return 0;
    }
    return Math.round(val);
  }
  function getNumberValidator() {
    if (Konva.isUnminified) {
      return function(val, attr) {
        if (!Util._isNumber(val)) {
          Util.warn(_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number.');
        }
        return val;
      };
    }
  }
  function getNumberOrArrayOfNumbersValidator(noOfElements) {
    if (Konva.isUnminified) {
      return function(val, attr) {
        let isNumber2 = Util._isNumber(val);
        let isValidArray = Util._isArray(val) && val.length == noOfElements;
        if (!isNumber2 && !isValidArray) {
          Util.warn(_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number or Array<number>(' + noOfElements + ")");
        }
        return val;
      };
    }
  }
  function getNumberOrAutoValidator() {
    if (Konva.isUnminified) {
      return function(val, attr) {
        const isNumber2 = Util._isNumber(val);
        const isAuto = val === "auto";
        if (!(isNumber2 || isAuto)) {
          Util.warn(_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number or "auto".');
        }
        return val;
      };
    }
  }
  function getStringValidator() {
    if (Konva.isUnminified) {
      return function(val, attr) {
        if (!Util._isString(val)) {
          Util.warn(_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a string.');
        }
        return val;
      };
    }
  }
  function getStringOrGradientValidator() {
    if (Konva.isUnminified) {
      return function(val, attr) {
        const isString3 = Util._isString(val);
        const isGradient = Object.prototype.toString.call(val) === "[object CanvasGradient]" || val && val["addColorStop"];
        if (!(isString3 || isGradient)) {
          Util.warn(_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a string or a native gradient.');
        }
        return val;
      };
    }
  }
  function getNumberArrayValidator() {
    if (Konva.isUnminified) {
      return function(val, attr) {
        const TypedArray = Int8Array ? Object.getPrototypeOf(Int8Array) : null;
        if (TypedArray && val instanceof TypedArray) {
          return val;
        }
        if (!Util._isArray(val)) {
          Util.warn(_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a array of numbers.');
        } else {
          val.forEach(function(item) {
            if (!Util._isNumber(item)) {
              Util.warn('"' + attr + '" attribute has non numeric element ' + item + ". Make sure that all elements are numbers.");
            }
          });
        }
        return val;
      };
    }
  }
  function getBooleanValidator() {
    if (Konva.isUnminified) {
      return function(val, attr) {
        const isBool = val === true || val === false;
        if (!isBool) {
          Util.warn(_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a boolean.');
        }
        return val;
      };
    }
  }
  function getComponentValidator(components) {
    if (Konva.isUnminified) {
      return function(val, attr) {
        if (val === void 0 || val === null) {
          return val;
        }
        if (!Util.isObject(val)) {
          Util.warn(_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be an object with properties ' + components);
        }
        return val;
      };
    }
  }
  var init_Validators = __esm({
    "node_modules/konva/lib/Validators.js"() {
      init_Global();
      init_Util();
    }
  });

  // node_modules/konva/lib/Factory.js
  var GET, SET, Factory;
  var init_Factory = __esm({
    "node_modules/konva/lib/Factory.js"() {
      init_Util();
      init_Validators();
      GET = "get";
      SET = "set";
      Factory = {
        addGetterSetter(constructor, attr, def2, validator, after) {
          Factory.addGetter(constructor, attr, def2);
          Factory.addSetter(constructor, attr, validator, after);
          Factory.addOverloadedGetterSetter(constructor, attr);
        },
        addGetter(constructor, attr, def2) {
          const method = GET + Util._capitalize(attr);
          constructor.prototype[method] = constructor.prototype[method] || function() {
            const val = this.attrs[attr];
            return val === void 0 ? def2 : val;
          };
        },
        addSetter(constructor, attr, validator, after) {
          const method = SET + Util._capitalize(attr);
          if (!constructor.prototype[method]) {
            Factory.overWriteSetter(constructor, attr, validator, after);
          }
        },
        overWriteSetter(constructor, attr, validator, after) {
          const method = SET + Util._capitalize(attr);
          constructor.prototype[method] = function(val) {
            if (validator && val !== void 0 && val !== null) {
              val = validator.call(this, val, attr);
            }
            this._setAttr(attr, val);
            if (after) {
              after.call(this);
            }
            return this;
          };
        },
        addComponentsGetterSetter(constructor, attr, components, validator, after) {
          const len = components.length, capitalize2 = Util._capitalize, getter = GET + capitalize2(attr), setter = SET + capitalize2(attr);
          constructor.prototype[getter] = function() {
            const ret = {};
            for (let n = 0; n < len; n++) {
              const component = components[n];
              ret[component] = this.getAttr(attr + capitalize2(component));
            }
            return ret;
          };
          const basicValidator = getComponentValidator(components);
          constructor.prototype[setter] = function(val) {
            const oldVal = this.attrs[attr];
            if (validator) {
              val = validator.call(this, val, attr);
            }
            if (basicValidator) {
              basicValidator.call(this, val, attr);
            }
            for (const key in val) {
              if (!val.hasOwnProperty(key)) {
                continue;
              }
              this._setAttr(attr + capitalize2(key), val[key]);
            }
            if (!val) {
              components.forEach((component) => {
                this._setAttr(attr + capitalize2(component), void 0);
              });
            }
            this._fireChangeEvent(attr, oldVal, val);
            if (after) {
              after.call(this);
            }
            return this;
          };
          Factory.addOverloadedGetterSetter(constructor, attr);
        },
        addOverloadedGetterSetter(constructor, attr) {
          const capitalizedAttr = Util._capitalize(attr), setter = SET + capitalizedAttr, getter = GET + capitalizedAttr;
          constructor.prototype[attr] = function() {
            if (arguments.length) {
              this[setter](arguments[0]);
              return this;
            }
            return this[getter]();
          };
        },
        addDeprecatedGetterSetter(constructor, attr, def2, validator) {
          Util.error("Adding deprecated " + attr);
          const method = GET + Util._capitalize(attr);
          const message = attr + " property is deprecated and will be removed soon. Look at Konva change log for more information.";
          constructor.prototype[method] = function() {
            Util.error(message);
            const val = this.attrs[attr];
            return val === void 0 ? def2 : val;
          };
          Factory.addSetter(constructor, attr, validator, function() {
            Util.error(message);
          });
          Factory.addOverloadedGetterSetter(constructor, attr);
        },
        backCompat(constructor, methods) {
          Util.each(methods, function(oldMethodName, newMethodName) {
            const method = constructor.prototype[newMethodName];
            const oldGetter = GET + Util._capitalize(oldMethodName);
            const oldSetter = SET + Util._capitalize(oldMethodName);
            function deprecated() {
              method.apply(this, arguments);
              Util.error('"' + oldMethodName + '" method is deprecated and will be removed soon. Use ""' + newMethodName + '" instead.');
            }
            constructor.prototype[oldMethodName] = deprecated;
            constructor.prototype[oldGetter] = deprecated;
            constructor.prototype[oldSetter] = deprecated;
          });
        },
        afterSetFilter() {
          this._filterUpToDate = false;
        }
      };
    }
  });

  // node_modules/konva/lib/Node.js
  function parseCSSFilters(cssFilter) {
    const filterRegex = /(\w+)\(([^)]+)\)/g;
    let match;
    while ((match = filterRegex.exec(cssFilter)) !== null) {
      const [, filterName, filterValue] = match;
      switch (filterName) {
        case "blur": {
          const blurRadius = parseFloat(filterValue.replace("px", ""));
          return function(imageData) {
            this.blurRadius(blurRadius * 0.5);
            const KonvaFilters = Konva.Filters;
            if (KonvaFilters && KonvaFilters.Blur) {
              KonvaFilters.Blur.call(this, imageData);
            }
          };
        }
        case "brightness": {
          const brightness = filterValue.includes("%") ? parseFloat(filterValue) / 100 : parseFloat(filterValue);
          return function(imageData) {
            this.brightness(brightness);
            const KonvaFilters = Konva.Filters;
            if (KonvaFilters && KonvaFilters.Brightness) {
              KonvaFilters.Brightness.call(this, imageData);
            }
          };
        }
        case "contrast": {
          const contrast = parseFloat(filterValue);
          return function(imageData) {
            const konvaContrast = 100 * (Math.sqrt(contrast) - 1);
            this.contrast(konvaContrast);
            const KonvaFilters = Konva.Filters;
            if (KonvaFilters && KonvaFilters.Contrast) {
              KonvaFilters.Contrast.call(this, imageData);
            }
          };
        }
        case "grayscale": {
          return function(imageData) {
            const KonvaFilters = Konva.Filters;
            if (KonvaFilters && KonvaFilters.Grayscale) {
              KonvaFilters.Grayscale.call(this, imageData);
            }
          };
        }
        case "sepia": {
          return function(imageData) {
            const KonvaFilters = Konva.Filters;
            if (KonvaFilters && KonvaFilters.Sepia) {
              KonvaFilters.Sepia.call(this, imageData);
            }
          };
        }
        case "invert": {
          return function(imageData) {
            const KonvaFilters = Konva.Filters;
            if (KonvaFilters && KonvaFilters.Invert) {
              KonvaFilters.Invert.call(this, imageData);
            }
          };
        }
        default:
          Util.warn(`CSS filter "${filterName}" is not supported in fallback mode. Consider using function filters for better compatibility.`);
          break;
      }
    }
    return () => {
    };
  }
  var ABSOLUTE_OPACITY, ALL_LISTENERS, ABSOLUTE_TRANSFORM, ABSOLUTE_SCALE, CANVAS, CHANGE, CHILDREN, KONVA, LISTENING, MOUSEENTER, MOUSELEAVE, POINTERENTER, POINTERLEAVE, TOUCHENTER, TOUCHLEAVE, SET2, SHAPE, SPACE, STAGE, TRANSFORM, UPPER_STAGE, VISIBLE, TRANSFORM_CHANGE_STR, idCounter, Node, addGetterSetter;
  var init_Node = __esm({
    "node_modules/konva/lib/Node.js"() {
      init_Canvas();
      init_Context();
      init_DragAndDrop();
      init_Factory();
      init_Global();
      init_Util();
      init_Validators();
      ABSOLUTE_OPACITY = "absoluteOpacity";
      ALL_LISTENERS = "allEventListeners";
      ABSOLUTE_TRANSFORM = "absoluteTransform";
      ABSOLUTE_SCALE = "absoluteScale";
      CANVAS = "canvas";
      CHANGE = "Change";
      CHILDREN = "children";
      KONVA = "konva";
      LISTENING = "listening";
      MOUSEENTER = "mouseenter";
      MOUSELEAVE = "mouseleave";
      POINTERENTER = "pointerenter";
      POINTERLEAVE = "pointerleave";
      TOUCHENTER = "touchenter";
      TOUCHLEAVE = "touchleave";
      SET2 = "set";
      SHAPE = "Shape";
      SPACE = " ";
      STAGE = "stage";
      TRANSFORM = "transform";
      UPPER_STAGE = "Stage";
      VISIBLE = "visible";
      TRANSFORM_CHANGE_STR = [
        "xChange.konva",
        "yChange.konva",
        "scaleXChange.konva",
        "scaleYChange.konva",
        "skewXChange.konva",
        "skewYChange.konva",
        "rotationChange.konva",
        "offsetXChange.konva",
        "offsetYChange.konva",
        "transformsEnabledChange.konva"
      ].join(SPACE);
      idCounter = 1;
      Node = class _Node {
        constructor(config) {
          this._id = idCounter++;
          this.eventListeners = {};
          this.attrs = {};
          this.index = 0;
          this._allEventListeners = null;
          this.parent = null;
          this._cache = /* @__PURE__ */ new Map();
          this._attachedDepsListeners = /* @__PURE__ */ new Map();
          this._lastPos = null;
          this._batchingTransformChange = false;
          this._needClearTransformCache = false;
          this._filterUpToDate = false;
          this._isUnderCache = false;
          this._dragEventId = null;
          this._shouldFireChangeEvents = false;
          this.setAttrs(config);
          this._shouldFireChangeEvents = true;
        }
        hasChildren() {
          return false;
        }
        _clearCache(attr) {
          if ((attr === TRANSFORM || attr === ABSOLUTE_TRANSFORM) && this._cache.get(attr)) {
            this._cache.get(attr).dirty = true;
          } else if (attr) {
            this._cache.delete(attr);
          } else {
            this._cache.clear();
          }
        }
        _getCache(attr, privateGetter) {
          let cache = this._cache.get(attr);
          const isTransform = attr === TRANSFORM || attr === ABSOLUTE_TRANSFORM;
          const invalid = cache === void 0 || isTransform && cache.dirty === true;
          if (invalid) {
            cache = privateGetter.call(this);
            this._cache.set(attr, cache);
          }
          return cache;
        }
        _calculate(name, deps, getter) {
          if (!this._attachedDepsListeners.get(name)) {
            const depsString = deps.map((dep) => dep + "Change.konva").join(SPACE);
            this.on(depsString, () => {
              this._clearCache(name);
            });
            this._attachedDepsListeners.set(name, true);
          }
          return this._getCache(name, getter);
        }
        _getCanvasCache() {
          return this._cache.get(CANVAS);
        }
        _clearSelfAndDescendantCache(attr) {
          this._clearCache(attr);
          if (attr === ABSOLUTE_TRANSFORM) {
            this.fire("absoluteTransformChange");
          }
        }
        clearCache() {
          if (this._cache.has(CANVAS)) {
            const { scene, filter: filter5, hit } = this._cache.get(CANVAS);
            Util.releaseCanvas(scene._canvas, filter5._canvas, hit._canvas);
            this._cache.delete(CANVAS);
          }
          this._clearSelfAndDescendantCache();
          this._requestDraw();
          return this;
        }
        cache(config) {
          const conf = config || {};
          let rect = {};
          if (conf.x === void 0 || conf.y === void 0 || conf.width === void 0 || conf.height === void 0) {
            rect = this.getClientRect({
              skipTransform: true,
              relativeTo: this.getParent() || void 0
            });
          }
          let width = Math.ceil(conf.width || rect.width), height = Math.ceil(conf.height || rect.height), pixelRatio = conf.pixelRatio, x = conf.x === void 0 ? Math.floor(rect.x) : conf.x, y2 = conf.y === void 0 ? Math.floor(rect.y) : conf.y, offset = conf.offset || 0, drawBorder = conf.drawBorder || false, hitCanvasPixelRatio = conf.hitCanvasPixelRatio || 1;
          if (!width || !height) {
            Util.error("Can not cache the node. Width or height of the node equals 0. Caching is skipped.");
            return;
          }
          const extraPaddingX = Math.abs(Math.round(rect.x) - x) > 0.5 ? 1 : 0;
          const extraPaddingY = Math.abs(Math.round(rect.y) - y2) > 0.5 ? 1 : 0;
          width += offset * 2 + extraPaddingX;
          height += offset * 2 + extraPaddingY;
          x -= offset;
          y2 -= offset;
          const cachedSceneCanvas = new SceneCanvas({
            pixelRatio,
            width,
            height
          }), cachedFilterCanvas = new SceneCanvas({
            pixelRatio,
            width: 0,
            height: 0,
            willReadFrequently: true
          }), cachedHitCanvas = new HitCanvas({
            pixelRatio: hitCanvasPixelRatio,
            width,
            height
          }), sceneContext = cachedSceneCanvas.getContext(), hitContext = cachedHitCanvas.getContext();
          const bufferCanvas = new SceneCanvas({
            width: cachedSceneCanvas.width / cachedSceneCanvas.pixelRatio + Math.abs(x),
            height: cachedSceneCanvas.height / cachedSceneCanvas.pixelRatio + Math.abs(y2),
            pixelRatio: cachedSceneCanvas.pixelRatio
          }), bufferContext = bufferCanvas.getContext();
          cachedHitCanvas.isCache = true;
          cachedSceneCanvas.isCache = true;
          this._cache.delete(CANVAS);
          this._filterUpToDate = false;
          if (conf.imageSmoothingEnabled === false) {
            cachedSceneCanvas.getContext()._context.imageSmoothingEnabled = false;
            cachedFilterCanvas.getContext()._context.imageSmoothingEnabled = false;
          }
          sceneContext.save();
          hitContext.save();
          bufferContext.save();
          sceneContext.translate(-x, -y2);
          hitContext.translate(-x, -y2);
          bufferContext.translate(-x, -y2);
          bufferCanvas.x = x;
          bufferCanvas.y = y2;
          this._isUnderCache = true;
          this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
          this._clearSelfAndDescendantCache(ABSOLUTE_SCALE);
          this.drawScene(cachedSceneCanvas, this, bufferCanvas);
          this.drawHit(cachedHitCanvas, this);
          this._isUnderCache = false;
          sceneContext.restore();
          hitContext.restore();
          if (drawBorder) {
            sceneContext.save();
            sceneContext.beginPath();
            sceneContext.rect(0, 0, width, height);
            sceneContext.closePath();
            sceneContext.setAttr("strokeStyle", "red");
            sceneContext.setAttr("lineWidth", 5);
            sceneContext.stroke();
            sceneContext.restore();
          }
          Util.releaseCanvas(bufferCanvas._canvas);
          this._cache.set(CANVAS, {
            scene: cachedSceneCanvas,
            filter: cachedFilterCanvas,
            hit: cachedHitCanvas,
            x,
            y: y2
          });
          this._requestDraw();
          return this;
        }
        isCached() {
          return this._cache.has(CANVAS);
        }
        getClientRect(config) {
          throw new Error('abstract "getClientRect" method call');
        }
        _transformedRect(rect, top) {
          const points = [
            { x: rect.x, y: rect.y },
            { x: rect.x + rect.width, y: rect.y },
            { x: rect.x + rect.width, y: rect.y + rect.height },
            { x: rect.x, y: rect.y + rect.height }
          ];
          let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
          const trans = this.getAbsoluteTransform(top);
          points.forEach(function(point) {
            const transformed = trans.point(point);
            if (minX === void 0) {
              minX = maxX = transformed.x;
              minY = maxY = transformed.y;
            }
            minX = Math.min(minX, transformed.x);
            minY = Math.min(minY, transformed.y);
            maxX = Math.max(maxX, transformed.x);
            maxY = Math.max(maxY, transformed.y);
          });
          return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
          };
        }
        _drawCachedSceneCanvas(context) {
          context.save();
          context._applyOpacity(this);
          context._applyGlobalCompositeOperation(this);
          const canvasCache = this._getCanvasCache();
          context.translate(canvasCache.x, canvasCache.y);
          const cacheCanvas = this._getCachedSceneCanvas();
          const ratio = cacheCanvas.pixelRatio;
          context.drawImage(cacheCanvas._canvas, 0, 0, cacheCanvas.width / ratio, cacheCanvas.height / ratio);
          context.restore();
        }
        _drawCachedHitCanvas(context) {
          const canvasCache = this._getCanvasCache(), hitCanvas = canvasCache.hit;
          context.save();
          context.translate(canvasCache.x, canvasCache.y);
          context.drawImage(hitCanvas._canvas, 0, 0, hitCanvas.width / hitCanvas.pixelRatio, hitCanvas.height / hitCanvas.pixelRatio);
          context.restore();
        }
        _getCachedSceneCanvas() {
          let filters = this.filters(), cachedCanvas = this._getCanvasCache(), sceneCanvas = cachedCanvas.scene, filterCanvas = cachedCanvas.filter, filterContext = filterCanvas.getContext(), len, imageData, n, filter5;
          if (!filters || filters.length === 0) {
            return sceneCanvas;
          }
          if (this._filterUpToDate) {
            return filterCanvas;
          }
          let useNativeOnly = true;
          for (let i2 = 0; i2 < filters.length; i2++) {
            const fallbackRequired = typeof filters[i2] === "string" && !isCSSFiltersSupported();
            if (fallbackRequired) {
            }
            if (typeof filters[i2] !== "string" || !isCSSFiltersSupported()) {
              useNativeOnly = false;
              break;
            }
          }
          const ratio = sceneCanvas.pixelRatio;
          filterCanvas.setSize(sceneCanvas.width / sceneCanvas.pixelRatio, sceneCanvas.height / sceneCanvas.pixelRatio);
          if (useNativeOnly) {
            const finalFilter = filters.join(" ");
            filterContext.save();
            filterContext.setAttr("filter", finalFilter);
            filterContext.drawImage(sceneCanvas._canvas, 0, 0, sceneCanvas.getWidth() / ratio, sceneCanvas.getHeight() / ratio);
            filterContext.restore();
            this._filterUpToDate = true;
            return filterCanvas;
          }
          try {
            len = filters.length;
            filterContext.clear();
            filterContext.drawImage(sceneCanvas._canvas, 0, 0, sceneCanvas.getWidth() / ratio, sceneCanvas.getHeight() / ratio);
            imageData = filterContext.getImageData(0, 0, filterCanvas.getWidth(), filterCanvas.getHeight());
            for (n = 0; n < len; n++) {
              filter5 = filters[n];
              if (typeof filter5 === "string") {
                filter5 = parseCSSFilters(filter5);
              }
              filter5.call(this, imageData);
              filterContext.putImageData(imageData, 0, 0);
            }
          } catch (e) {
            Util.error("Unable to apply filter. " + e.message + " This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.");
          }
          this._filterUpToDate = true;
          return filterCanvas;
        }
        on(...args) {
          const evtStr = args[0];
          const selectorOrHandler = args[1];
          const handler = args[2];
          if (this._cache) {
            this._cache.delete(ALL_LISTENERS);
          }
          if (args.length === 3) {
            return this._delegate.apply(this, args);
          }
          const events = evtStr.split(SPACE);
          for (let n = 0; n < events.length; n++) {
            const event = events[n];
            const parts = event.split(".");
            const baseEvent = parts[0];
            const name = parts[1] || "";
            if (!this.eventListeners[baseEvent]) {
              this.eventListeners[baseEvent] = [];
            }
            this.eventListeners[baseEvent].push({ name, handler: selectorOrHandler });
          }
          return this;
        }
        off(evtStr, callback) {
          let events = (evtStr || "").split(SPACE), len = events.length, n, t, event, parts, baseEvent, name;
          this._cache && this._cache.delete(ALL_LISTENERS);
          if (!evtStr) {
            for (t in this.eventListeners) {
              this._off(t);
            }
          }
          for (n = 0; n < len; n++) {
            event = events[n];
            parts = event.split(".");
            baseEvent = parts[0];
            name = parts[1];
            if (baseEvent) {
              if (this.eventListeners[baseEvent]) {
                this._off(baseEvent, name, callback);
              }
            } else {
              for (t in this.eventListeners) {
                this._off(t, name, callback);
              }
            }
          }
          return this;
        }
        dispatchEvent(evt) {
          const e = {
            target: this,
            type: evt.type,
            evt
          };
          this.fire(evt.type, e);
          return this;
        }
        addEventListener(type, handler) {
          this.on(type, function(evt) {
            handler.call(this, evt.evt);
          });
          return this;
        }
        removeEventListener(type) {
          this.off(type);
          return this;
        }
        _delegate(event, selector, handler) {
          const stopNode = this;
          this.on(event, function(evt) {
            const targets = evt.target.findAncestors(selector, true, stopNode);
            for (let i2 = 0; i2 < targets.length; i2++) {
              evt = Util.cloneObject(evt);
              evt.currentTarget = targets[i2];
              handler.call(targets[i2], evt);
            }
          });
          return this;
        }
        remove() {
          if (this.isDragging()) {
            this.stopDrag();
          }
          DD._dragElements.delete(this._id);
          DD._dragElements.forEach((elem, key) => {
            if (this.isAncestorOf(elem.node)) {
              DD._dragElements.delete(key);
            }
          });
          this._remove();
          return this;
        }
        _clearCaches() {
          this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
          this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
          this._clearSelfAndDescendantCache(ABSOLUTE_SCALE);
          this._clearSelfAndDescendantCache(STAGE);
          this._clearSelfAndDescendantCache(VISIBLE);
          this._clearSelfAndDescendantCache(LISTENING);
        }
        _remove() {
          this._clearCaches();
          const parent = this.getParent();
          if (parent && parent.children) {
            parent.children.splice(this.index, 1);
            parent._setChildrenIndices();
            this.parent = null;
          }
        }
        destroy() {
          this.remove();
          this.clearCache();
          return this;
        }
        getAttr(attr) {
          const method = "get" + Util._capitalize(attr);
          if (Util._isFunction(this[method])) {
            return this[method]();
          }
          return this.attrs[attr];
        }
        getAncestors() {
          let parent = this.getParent(), ancestors = [];
          while (parent) {
            ancestors.push(parent);
            parent = parent.getParent();
          }
          return ancestors;
        }
        getAttrs() {
          return this.attrs || {};
        }
        setAttrs(config) {
          this._batchTransformChanges(() => {
            let key, method;
            if (!config) {
              return this;
            }
            for (key in config) {
              if (key === CHILDREN) {
                continue;
              }
              method = SET2 + Util._capitalize(key);
              if (Util._isFunction(this[method])) {
                this[method](config[key]);
              } else {
                this._setAttr(key, config[key]);
              }
            }
          });
          return this;
        }
        isListening() {
          return this._getCache(LISTENING, this._isListening);
        }
        _isListening(relativeTo) {
          const listening = this.listening();
          if (!listening) {
            return false;
          }
          const parent = this.getParent();
          if (parent && parent !== relativeTo && this !== relativeTo) {
            return parent._isListening(relativeTo);
          } else {
            return true;
          }
        }
        isVisible() {
          return this._getCache(VISIBLE, this._isVisible);
        }
        _isVisible(relativeTo) {
          const visible = this.visible();
          if (!visible) {
            return false;
          }
          const parent = this.getParent();
          if (parent && parent !== relativeTo && this !== relativeTo) {
            return parent._isVisible(relativeTo);
          } else {
            return true;
          }
        }
        shouldDrawHit(top, skipDragCheck = false) {
          if (top) {
            return this._isVisible(top) && this._isListening(top);
          }
          const layer = this.getLayer();
          let layerUnderDrag = false;
          DD._dragElements.forEach((elem) => {
            if (elem.dragStatus !== "dragging") {
              return;
            } else if (elem.node.nodeType === "Stage") {
              layerUnderDrag = true;
            } else if (elem.node.getLayer() === layer) {
              layerUnderDrag = true;
            }
          });
          const dragSkip = !skipDragCheck && !Konva.hitOnDragEnabled && (layerUnderDrag || Konva.isTransforming());
          return this.isListening() && this.isVisible() && !dragSkip;
        }
        show() {
          this.visible(true);
          return this;
        }
        hide() {
          this.visible(false);
          return this;
        }
        getZIndex() {
          return this.index || 0;
        }
        getAbsoluteZIndex() {
          let depth = this.getDepth(), that = this, index = 0, nodes, len, n, child;
          function addChildren(children) {
            nodes = [];
            len = children.length;
            for (n = 0; n < len; n++) {
              child = children[n];
              index++;
              if (child.nodeType !== SHAPE) {
                nodes = nodes.concat(child.getChildren().slice());
              }
              if (child._id === that._id) {
                n = len;
              }
            }
            if (nodes.length > 0 && nodes[0].getDepth() <= depth) {
              addChildren(nodes);
            }
          }
          const stage = this.getStage();
          if (that.nodeType !== UPPER_STAGE && stage) {
            addChildren(stage.getChildren());
          }
          return index;
        }
        getDepth() {
          let depth = 0, parent = this.parent;
          while (parent) {
            depth++;
            parent = parent.parent;
          }
          return depth;
        }
        _batchTransformChanges(func) {
          this._batchingTransformChange = true;
          func();
          this._batchingTransformChange = false;
          if (this._needClearTransformCache) {
            this._clearCache(TRANSFORM);
            this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
          }
          this._needClearTransformCache = false;
        }
        setPosition(pos) {
          this._batchTransformChanges(() => {
            this.x(pos.x);
            this.y(pos.y);
          });
          return this;
        }
        getPosition() {
          return {
            x: this.x(),
            y: this.y()
          };
        }
        getRelativePointerPosition() {
          const stage = this.getStage();
          if (!stage) {
            return null;
          }
          const pos = stage.getPointerPosition();
          if (!pos) {
            return null;
          }
          const transform2 = this.getAbsoluteTransform().copy();
          transform2.invert();
          return transform2.point(pos);
        }
        getAbsolutePosition(top) {
          let haveCachedParent = false;
          let parent = this.parent;
          while (parent) {
            if (parent.isCached()) {
              haveCachedParent = true;
              break;
            }
            parent = parent.parent;
          }
          if (haveCachedParent && !top) {
            top = true;
          }
          const absoluteMatrix = this.getAbsoluteTransform(top).getMatrix(), absoluteTransform = new Transform(), offset = this.offset();
          absoluteTransform.m = absoluteMatrix.slice();
          absoluteTransform.translate(offset.x, offset.y);
          return absoluteTransform.getTranslation();
        }
        setAbsolutePosition(pos) {
          const { x, y: y2, ...origTrans } = this._clearTransform();
          this.attrs.x = x;
          this.attrs.y = y2;
          this._clearCache(TRANSFORM);
          const it = this._getAbsoluteTransform().copy();
          it.invert();
          it.translate(pos.x, pos.y);
          pos = {
            x: this.attrs.x + it.getTranslation().x,
            y: this.attrs.y + it.getTranslation().y
          };
          this._setTransform(origTrans);
          this.setPosition({ x: pos.x, y: pos.y });
          this._clearCache(TRANSFORM);
          this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
          return this;
        }
        _setTransform(trans) {
          let key;
          for (key in trans) {
            this.attrs[key] = trans[key];
          }
        }
        _clearTransform() {
          const trans = {
            x: this.x(),
            y: this.y(),
            rotation: this.rotation(),
            scaleX: this.scaleX(),
            scaleY: this.scaleY(),
            offsetX: this.offsetX(),
            offsetY: this.offsetY(),
            skewX: this.skewX(),
            skewY: this.skewY()
          };
          this.attrs.x = 0;
          this.attrs.y = 0;
          this.attrs.rotation = 0;
          this.attrs.scaleX = 1;
          this.attrs.scaleY = 1;
          this.attrs.offsetX = 0;
          this.attrs.offsetY = 0;
          this.attrs.skewX = 0;
          this.attrs.skewY = 0;
          return trans;
        }
        move(change) {
          let changeX = change.x, changeY = change.y, x = this.x(), y2 = this.y();
          if (changeX !== void 0) {
            x += changeX;
          }
          if (changeY !== void 0) {
            y2 += changeY;
          }
          this.setPosition({ x, y: y2 });
          return this;
        }
        _eachAncestorReverse(func, top) {
          let family = [], parent = this.getParent(), len, n;
          if (top && top._id === this._id) {
            return;
          }
          family.unshift(this);
          while (parent && (!top || parent._id !== top._id)) {
            family.unshift(parent);
            parent = parent.parent;
          }
          len = family.length;
          for (n = 0; n < len; n++) {
            func(family[n]);
          }
        }
        rotate(theta) {
          this.rotation(this.rotation() + theta);
          return this;
        }
        moveToTop() {
          if (!this.parent) {
            Util.warn("Node has no parent. moveToTop function is ignored.");
            return false;
          }
          const index = this.index, len = this.parent.getChildren().length;
          if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.push(this);
            this.parent._setChildrenIndices();
            return true;
          }
          return false;
        }
        moveUp() {
          if (!this.parent) {
            Util.warn("Node has no parent. moveUp function is ignored.");
            return false;
          }
          const index = this.index, len = this.parent.getChildren().length;
          if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index + 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
          }
          return false;
        }
        moveDown() {
          if (!this.parent) {
            Util.warn("Node has no parent. moveDown function is ignored.");
            return false;
          }
          const index = this.index;
          if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index - 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
          }
          return false;
        }
        moveToBottom() {
          if (!this.parent) {
            Util.warn("Node has no parent. moveToBottom function is ignored.");
            return false;
          }
          const index = this.index;
          if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.unshift(this);
            this.parent._setChildrenIndices();
            return true;
          }
          return false;
        }
        setZIndex(zIndex) {
          if (!this.parent) {
            Util.warn("Node has no parent. zIndex parameter is ignored.");
            return this;
          }
          if (zIndex < 0 || zIndex >= this.parent.children.length) {
            Util.warn("Unexpected value " + zIndex + " for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to " + (this.parent.children.length - 1) + ".");
          }
          const index = this.index;
          this.parent.children.splice(index, 1);
          this.parent.children.splice(zIndex, 0, this);
          this.parent._setChildrenIndices();
          return this;
        }
        getAbsoluteOpacity() {
          return this._getCache(ABSOLUTE_OPACITY, this._getAbsoluteOpacity);
        }
        _getAbsoluteOpacity() {
          let absOpacity = this.opacity();
          const parent = this.getParent();
          if (parent && !parent._isUnderCache) {
            absOpacity *= parent.getAbsoluteOpacity();
          }
          return absOpacity;
        }
        moveTo(newContainer) {
          if (this.getParent() !== newContainer) {
            this._remove();
            newContainer.add(this);
          }
          return this;
        }
        toObject() {
          let attrs = this.getAttrs(), key, val, getter, defaultValue, nonPlainObject;
          const obj = {
            attrs: {},
            className: this.getClassName()
          };
          for (key in attrs) {
            val = attrs[key];
            nonPlainObject = Util.isObject(val) && !Util._isPlainObject(val) && !Util._isArray(val);
            if (nonPlainObject) {
              continue;
            }
            getter = typeof this[key] === "function" && this[key];
            delete attrs[key];
            defaultValue = getter ? getter.call(this) : null;
            attrs[key] = val;
            if (defaultValue !== val) {
              obj.attrs[key] = val;
            }
          }
          return Util._prepareToStringify(obj);
        }
        toJSON() {
          return JSON.stringify(this.toObject());
        }
        getParent() {
          return this.parent;
        }
        findAncestors(selector, includeSelf, stopNode) {
          const res = [];
          if (includeSelf && this._isMatch(selector)) {
            res.push(this);
          }
          let ancestor = this.parent;
          while (ancestor) {
            if (ancestor === stopNode) {
              return res;
            }
            if (ancestor._isMatch(selector)) {
              res.push(ancestor);
            }
            ancestor = ancestor.parent;
          }
          return res;
        }
        isAncestorOf(node) {
          return false;
        }
        findAncestor(selector, includeSelf, stopNode) {
          return this.findAncestors(selector, includeSelf, stopNode)[0];
        }
        _isMatch(selector) {
          if (!selector) {
            return false;
          }
          if (typeof selector === "function") {
            return selector(this);
          }
          let selectorArr = selector.replace(/ /g, "").split(","), len = selectorArr.length, n, sel;
          for (n = 0; n < len; n++) {
            sel = selectorArr[n];
            if (!Util.isValidSelector(sel)) {
              Util.warn('Selector "' + sel + '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".');
              Util.warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".');
              Util.warn("Konva is awesome, right?");
            }
            if (sel.charAt(0) === "#") {
              if (this.id() === sel.slice(1)) {
                return true;
              }
            } else if (sel.charAt(0) === ".") {
              if (this.hasName(sel.slice(1))) {
                return true;
              }
            } else if (this.className === sel || this.nodeType === sel) {
              return true;
            }
          }
          return false;
        }
        getLayer() {
          const parent = this.getParent();
          return parent ? parent.getLayer() : null;
        }
        getStage() {
          return this._getCache(STAGE, this._getStage);
        }
        _getStage() {
          const parent = this.getParent();
          if (parent) {
            return parent.getStage();
          } else {
            return null;
          }
        }
        fire(eventType, evt = {}, bubble) {
          evt.target = evt.target || this;
          if (bubble) {
            this._fireAndBubble(eventType, evt);
          } else {
            this._fire(eventType, evt);
          }
          return this;
        }
        getAbsoluteTransform(top) {
          if (top) {
            return this._getAbsoluteTransform(top);
          } else {
            return this._getCache(ABSOLUTE_TRANSFORM, this._getAbsoluteTransform);
          }
        }
        _getAbsoluteTransform(top) {
          let at;
          if (top) {
            at = new Transform();
            this._eachAncestorReverse(function(node) {
              const transformsEnabled = node.transformsEnabled();
              if (transformsEnabled === "all") {
                at.multiply(node.getTransform());
              } else if (transformsEnabled === "position") {
                at.translate(node.x() - node.offsetX(), node.y() - node.offsetY());
              }
            }, top);
            return at;
          } else {
            at = this._cache.get(ABSOLUTE_TRANSFORM) || new Transform();
            if (this.parent) {
              this.parent.getAbsoluteTransform().copyInto(at);
            } else {
              at.reset();
            }
            const transformsEnabled = this.transformsEnabled();
            if (transformsEnabled === "all") {
              at.multiply(this.getTransform());
            } else if (transformsEnabled === "position") {
              const x = this.attrs.x || 0;
              const y2 = this.attrs.y || 0;
              const offsetX = this.attrs.offsetX || 0;
              const offsetY = this.attrs.offsetY || 0;
              at.translate(x - offsetX, y2 - offsetY);
            }
            at.dirty = false;
            return at;
          }
        }
        getAbsoluteScale(top) {
          let parent = this;
          while (parent) {
            if (parent._isUnderCache) {
              top = parent;
            }
            parent = parent.getParent();
          }
          const transform2 = this.getAbsoluteTransform(top);
          const attrs = transform2.decompose();
          return {
            x: attrs.scaleX,
            y: attrs.scaleY
          };
        }
        getAbsoluteRotation() {
          return this.getAbsoluteTransform().decompose().rotation;
        }
        getTransform() {
          return this._getCache(TRANSFORM, this._getTransform);
        }
        _getTransform() {
          var _a, _b;
          const m = this._cache.get(TRANSFORM) || new Transform();
          m.reset();
          const x = this.x(), y2 = this.y(), rotation = Konva.getAngle(this.rotation()), scaleX = (_a = this.attrs.scaleX) !== null && _a !== void 0 ? _a : 1, scaleY = (_b = this.attrs.scaleY) !== null && _b !== void 0 ? _b : 1, skewX = this.attrs.skewX || 0, skewY = this.attrs.skewY || 0, offsetX = this.attrs.offsetX || 0, offsetY = this.attrs.offsetY || 0;
          if (x !== 0 || y2 !== 0) {
            m.translate(x, y2);
          }
          if (rotation !== 0) {
            m.rotate(rotation);
          }
          if (skewX !== 0 || skewY !== 0) {
            m.skew(skewX, skewY);
          }
          if (scaleX !== 1 || scaleY !== 1) {
            m.scale(scaleX, scaleY);
          }
          if (offsetX !== 0 || offsetY !== 0) {
            m.translate(-1 * offsetX, -1 * offsetY);
          }
          m.dirty = false;
          return m;
        }
        clone(obj) {
          let attrs = Util.cloneObject(this.attrs), key, allListeners, len, n, listener;
          for (key in obj) {
            attrs[key] = obj[key];
          }
          const node = new this.constructor(attrs);
          for (key in this.eventListeners) {
            allListeners = this.eventListeners[key];
            len = allListeners.length;
            for (n = 0; n < len; n++) {
              listener = allListeners[n];
              if (listener.name.indexOf(KONVA) < 0) {
                if (!node.eventListeners[key]) {
                  node.eventListeners[key] = [];
                }
                node.eventListeners[key].push(listener);
              }
            }
          }
          return node;
        }
        _toKonvaCanvas(config) {
          config = config || {};
          const box = this.getClientRect();
          const stage = this.getStage(), x = config.x !== void 0 ? config.x : Math.floor(box.x), y2 = config.y !== void 0 ? config.y : Math.floor(box.y), pixelRatio = config.pixelRatio || 1, canvas = new SceneCanvas({
            width: config.width || Math.ceil(box.width) || (stage ? stage.width() : 0),
            height: config.height || Math.ceil(box.height) || (stage ? stage.height() : 0),
            pixelRatio
          }), context = canvas.getContext();
          const bufferCanvas = new SceneCanvas({
            width: canvas.width / canvas.pixelRatio + Math.abs(x),
            height: canvas.height / canvas.pixelRatio + Math.abs(y2),
            pixelRatio: canvas.pixelRatio
          });
          if (config.imageSmoothingEnabled === false) {
            context._context.imageSmoothingEnabled = false;
          }
          context.save();
          if (x || y2) {
            context.translate(-1 * x, -1 * y2);
          }
          this.drawScene(canvas, void 0, bufferCanvas);
          context.restore();
          return canvas;
        }
        toCanvas(config) {
          return this._toKonvaCanvas(config)._canvas;
        }
        toDataURL(config) {
          config = config || {};
          const mimeType = config.mimeType || null, quality = config.quality || null;
          const url = this._toKonvaCanvas(config).toDataURL(mimeType, quality);
          if (config.callback) {
            config.callback(url);
          }
          return url;
        }
        toImage(config) {
          return new Promise((resolve2, reject) => {
            try {
              const callback = config === null || config === void 0 ? void 0 : config.callback;
              if (callback)
                delete config.callback;
              Util._urlToImage(this.toDataURL(config), function(img) {
                resolve2(img);
                callback === null || callback === void 0 ? void 0 : callback(img);
              });
            } catch (err) {
              reject(err);
            }
          });
        }
        toBlob(config) {
          return new Promise((resolve2, reject) => {
            try {
              const callback = config === null || config === void 0 ? void 0 : config.callback;
              if (callback)
                delete config.callback;
              this.toCanvas(config).toBlob((blob) => {
                resolve2(blob);
                callback === null || callback === void 0 ? void 0 : callback(blob);
              }, config === null || config === void 0 ? void 0 : config.mimeType, config === null || config === void 0 ? void 0 : config.quality);
            } catch (err) {
              reject(err);
            }
          });
        }
        setSize(size) {
          this.width(size.width);
          this.height(size.height);
          return this;
        }
        getSize() {
          return {
            width: this.width(),
            height: this.height()
          };
        }
        getClassName() {
          return this.className || this.nodeType;
        }
        getType() {
          return this.nodeType;
        }
        getDragDistance() {
          if (this.attrs.dragDistance !== void 0) {
            return this.attrs.dragDistance;
          } else if (this.parent) {
            return this.parent.getDragDistance();
          } else {
            return Konva.dragDistance;
          }
        }
        _off(type, name, callback) {
          let evtListeners = this.eventListeners[type], i2, evtName, handler;
          for (i2 = 0; i2 < evtListeners.length; i2++) {
            evtName = evtListeners[i2].name;
            handler = evtListeners[i2].handler;
            if ((evtName !== "konva" || name === "konva") && (!name || evtName === name) && (!callback || callback === handler)) {
              evtListeners.splice(i2, 1);
              if (evtListeners.length === 0) {
                delete this.eventListeners[type];
                break;
              }
              i2--;
            }
          }
        }
        _fireChangeEvent(attr, oldVal, newVal) {
          this._fire(attr + CHANGE, {
            oldVal,
            newVal
          });
        }
        addName(name) {
          if (!this.hasName(name)) {
            const oldName = this.name();
            const newName = oldName ? oldName + " " + name : name;
            this.name(newName);
          }
          return this;
        }
        hasName(name) {
          if (!name) {
            return false;
          }
          const fullName = this.name();
          if (!fullName) {
            return false;
          }
          const names2 = (fullName || "").split(/\s/g);
          return names2.indexOf(name) !== -1;
        }
        removeName(name) {
          const names2 = (this.name() || "").split(/\s/g);
          const index = names2.indexOf(name);
          if (index !== -1) {
            names2.splice(index, 1);
            this.name(names2.join(" "));
          }
          return this;
        }
        setAttr(attr, val) {
          const func = this[SET2 + Util._capitalize(attr)];
          if (Util._isFunction(func)) {
            func.call(this, val);
          } else {
            this._setAttr(attr, val);
          }
          return this;
        }
        _requestDraw() {
          if (Konva.autoDrawEnabled) {
            const drawNode = this.getLayer() || this.getStage();
            drawNode === null || drawNode === void 0 ? void 0 : drawNode.batchDraw();
          }
        }
        _setAttr(key, val) {
          const oldVal = this.attrs[key];
          if (oldVal === val && !Util.isObject(val)) {
            return;
          }
          if (val === void 0 || val === null) {
            delete this.attrs[key];
          } else {
            this.attrs[key] = val;
          }
          if (this._shouldFireChangeEvents) {
            this._fireChangeEvent(key, oldVal, val);
          }
          this._requestDraw();
        }
        _setComponentAttr(key, component, val) {
          let oldVal;
          if (val !== void 0) {
            oldVal = this.attrs[key];
            if (!oldVal) {
              this.attrs[key] = this.getAttr(key);
            }
            this.attrs[key][component] = val;
            this._fireChangeEvent(key, oldVal, val);
          }
        }
        _fireAndBubble(eventType, evt, compareShape) {
          if (evt && this.nodeType === SHAPE) {
            evt.target = this;
          }
          const nonBubbling = [
            MOUSEENTER,
            MOUSELEAVE,
            POINTERENTER,
            POINTERLEAVE,
            TOUCHENTER,
            TOUCHLEAVE
          ];
          const shouldStop = nonBubbling.indexOf(eventType) !== -1 && (compareShape && (this === compareShape || this.isAncestorOf && this.isAncestorOf(compareShape)) || this.nodeType === "Stage" && !compareShape);
          if (!shouldStop) {
            this._fire(eventType, evt);
            const stopBubble = nonBubbling.indexOf(eventType) !== -1 && compareShape && compareShape.isAncestorOf && compareShape.isAncestorOf(this) && !compareShape.isAncestorOf(this.parent);
            if ((evt && !evt.cancelBubble || !evt) && this.parent && this.parent.isListening() && !stopBubble) {
              if (compareShape && compareShape.parent) {
                this._fireAndBubble.call(this.parent, eventType, evt, compareShape);
              } else {
                this._fireAndBubble.call(this.parent, eventType, evt);
              }
            }
          }
        }
        _getProtoListeners(eventType) {
          var _a, _b;
          const { nodeType } = this;
          const allListeners = _Node.protoListenerMap.get(nodeType) || {};
          let events = allListeners === null || allListeners === void 0 ? void 0 : allListeners[eventType];
          if (events === void 0) {
            events = [];
            let obj = Object.getPrototypeOf(this);
            while (obj) {
              const hierarchyEvents = (_b = (_a = obj.eventListeners) === null || _a === void 0 ? void 0 : _a[eventType]) !== null && _b !== void 0 ? _b : [];
              events.push(...hierarchyEvents);
              obj = Object.getPrototypeOf(obj);
            }
            allListeners[eventType] = events;
            _Node.protoListenerMap.set(nodeType, allListeners);
          }
          return events;
        }
        _fire(eventType, evt) {
          evt = evt || {};
          evt.currentTarget = this;
          evt.type = eventType;
          const topListeners = this._getProtoListeners(eventType);
          if (topListeners) {
            const list = topListeners.slice();
            for (let i2 = 0; i2 < list.length; i2++) {
              list[i2].handler.call(this, evt);
            }
          }
          const selfListeners = this.eventListeners[eventType];
          if (selfListeners) {
            const list = selfListeners.slice();
            const origLen = list.length;
            for (let i2 = 0; i2 < list.length; i2++) {
              list[i2].handler.call(this, evt);
            }
            const liveListeners = this.eventListeners[eventType];
            if (liveListeners) {
              for (let i2 = origLen; i2 < liveListeners.length; i2++) {
                liveListeners[i2].handler.call(this, evt);
              }
            }
          }
        }
        draw() {
          this.drawScene();
          this.drawHit();
          return this;
        }
        _createDragElement(evt) {
          const pointerId = evt ? evt.pointerId : void 0;
          const stage = this.getStage();
          const ap = this.getAbsolutePosition();
          if (!stage) {
            return;
          }
          const pos = stage._getPointerById(pointerId) || stage._changedPointerPositions[0] || ap;
          DD._dragElements.set(this._id, {
            node: this,
            startPointerPos: pos,
            offset: {
              x: pos.x - ap.x,
              y: pos.y - ap.y
            },
            dragStatus: "ready",
            pointerId,
            startEvent: evt
          });
        }
        startDrag(evt, bubbleEvent = true) {
          if (!DD._dragElements.has(this._id)) {
            this._createDragElement(evt);
          }
          const elem = DD._dragElements.get(this._id);
          elem.dragStatus = "dragging";
          this.fire("dragstart", {
            type: "dragstart",
            target: this,
            evt: elem.startEvent && elem.startEvent.evt || evt && evt.evt
          }, bubbleEvent);
        }
        _setDragPosition(evt, elem) {
          const pos = this.getStage()._getPointerById(elem.pointerId);
          if (!pos) {
            return;
          }
          let newNodePos = {
            x: pos.x - elem.offset.x,
            y: pos.y - elem.offset.y
          };
          const dbf = this.dragBoundFunc();
          if (dbf !== void 0) {
            const bounded = dbf.call(this, newNodePos, evt);
            if (!bounded) {
              Util.warn("dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.");
            } else {
              newNodePos = bounded;
            }
          }
          if (!this._lastPos || this._lastPos.x !== newNodePos.x || this._lastPos.y !== newNodePos.y) {
            this.setAbsolutePosition(newNodePos);
            this._requestDraw();
          }
          this._lastPos = newNodePos;
        }
        stopDrag(evt) {
          const elem = DD._dragElements.get(this._id);
          if (elem) {
            elem.dragStatus = "stopped";
          }
          DD._endDragBefore(evt);
          DD._endDragAfter(evt);
        }
        setDraggable(draggable2) {
          this._setAttr("draggable", draggable2);
          this._dragChange();
        }
        isDragging() {
          const elem = DD._dragElements.get(this._id);
          return elem ? elem.dragStatus === "dragging" : false;
        }
        _listenDrag() {
          this._dragCleanup();
          this.on("mousedown.konva touchstart.konva", function(evt) {
            const shouldCheckButton = evt.evt["button"] !== void 0;
            const canDrag = !shouldCheckButton || Konva.dragButtons.indexOf(evt.evt["button"]) >= 0;
            if (!canDrag) {
              return;
            }
            if (this.isDragging()) {
              return;
            }
            let hasDraggingChild = false;
            DD._dragElements.forEach((elem) => {
              if (this.isAncestorOf(elem.node)) {
                hasDraggingChild = true;
              }
            });
            if (!hasDraggingChild) {
              this._createDragElement(evt);
            }
          });
        }
        _dragChange() {
          if (this.attrs.draggable) {
            this._listenDrag();
          } else {
            this._dragCleanup();
            const stage = this.getStage();
            if (!stage) {
              return;
            }
            const dragElement = DD._dragElements.get(this._id);
            const isDragging = dragElement && dragElement.dragStatus === "dragging";
            const isReady = dragElement && dragElement.dragStatus === "ready";
            if (isDragging) {
              this.stopDrag();
            } else if (isReady) {
              DD._dragElements.delete(this._id);
            }
          }
        }
        _dragCleanup() {
          this.off("mousedown.konva");
          this.off("touchstart.konva");
        }
        isClientRectOnScreen(margin = { x: 0, y: 0 }) {
          const stage = this.getStage();
          if (!stage) {
            return false;
          }
          const screenRect = {
            x: -margin.x,
            y: -margin.y,
            width: stage.width() + 2 * margin.x,
            height: stage.height() + 2 * margin.y
          };
          return Util.haveIntersection(screenRect, this.getClientRect());
        }
        static create(data, container) {
          if (Util._isString(data)) {
            data = JSON.parse(data);
          }
          return this._createNode(data, container);
        }
        static _createNode(obj, container) {
          let className = _Node.prototype.getClassName.call(obj), children = obj.children, no, len, n;
          if (container) {
            obj.attrs.container = container;
          }
          if (!Konva[className]) {
            Util.warn('Can not find a node with class name "' + className + '". Fallback to "Shape".');
            className = "Shape";
          }
          const Class = Konva[className];
          no = new Class(obj.attrs);
          if (children) {
            len = children.length;
            for (n = 0; n < len; n++) {
              no.add(_Node._createNode(children[n]));
            }
          }
          return no;
        }
      };
      Node.protoListenerMap = /* @__PURE__ */ new Map();
      Node.prototype.nodeType = "Node";
      Node.prototype._attrsAffectingSize = [];
      Node.prototype.eventListeners = {};
      Node.prototype.on(TRANSFORM_CHANGE_STR, function() {
        if (this._batchingTransformChange) {
          this._needClearTransformCache = true;
          return;
        }
        this._clearCache(TRANSFORM);
        this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
      });
      Node.prototype.on("visibleChange.konva", function() {
        this._clearSelfAndDescendantCache(VISIBLE);
      });
      Node.prototype.on("listeningChange.konva", function() {
        this._clearSelfAndDescendantCache(LISTENING);
      });
      Node.prototype.on("opacityChange.konva", function() {
        this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
      });
      addGetterSetter = Factory.addGetterSetter;
      addGetterSetter(Node, "zIndex");
      addGetterSetter(Node, "absolutePosition");
      addGetterSetter(Node, "position");
      addGetterSetter(Node, "x", 0, getNumberValidator());
      addGetterSetter(Node, "y", 0, getNumberValidator());
      addGetterSetter(Node, "globalCompositeOperation", "source-over", getStringValidator());
      addGetterSetter(Node, "opacity", 1, getNumberValidator());
      addGetterSetter(Node, "name", "", getStringValidator());
      addGetterSetter(Node, "id", "", getStringValidator());
      addGetterSetter(Node, "rotation", 0, getNumberValidator());
      Factory.addComponentsGetterSetter(Node, "scale", ["x", "y"]);
      addGetterSetter(Node, "scaleX", 1, getNumberValidator());
      addGetterSetter(Node, "scaleY", 1, getNumberValidator());
      Factory.addComponentsGetterSetter(Node, "skew", ["x", "y"]);
      addGetterSetter(Node, "skewX", 0, getNumberValidator());
      addGetterSetter(Node, "skewY", 0, getNumberValidator());
      Factory.addComponentsGetterSetter(Node, "offset", ["x", "y"]);
      addGetterSetter(Node, "offsetX", 0, getNumberValidator());
      addGetterSetter(Node, "offsetY", 0, getNumberValidator());
      addGetterSetter(Node, "dragDistance", void 0, getNumberValidator());
      addGetterSetter(Node, "width", 0, getNumberValidator());
      addGetterSetter(Node, "height", 0, getNumberValidator());
      addGetterSetter(Node, "listening", true, getBooleanValidator());
      addGetterSetter(Node, "preventDefault", true, getBooleanValidator());
      addGetterSetter(Node, "filters", void 0, function(val) {
        this._filterUpToDate = false;
        return val;
      });
      addGetterSetter(Node, "visible", true, getBooleanValidator());
      addGetterSetter(Node, "transformsEnabled", "all", getStringValidator());
      addGetterSetter(Node, "size");
      addGetterSetter(Node, "dragBoundFunc");
      addGetterSetter(Node, "draggable", false, getBooleanValidator());
      Factory.backCompat(Node, {
        rotateDeg: "rotate",
        setRotationDeg: "setRotation",
        getRotationDeg: "getRotation"
      });
    }
  });

  // node_modules/konva/lib/Container.js
  var Container;
  var init_Container = __esm({
    "node_modules/konva/lib/Container.js"() {
      init_Factory();
      init_Node();
      init_Validators();
      Container = class extends Node {
        constructor() {
          super(...arguments);
          this.children = [];
        }
        getChildren(filterFunc) {
          const children = this.children || [];
          if (filterFunc) {
            return children.filter(filterFunc);
          }
          return children;
        }
        hasChildren() {
          return this.getChildren().length > 0;
        }
        removeChildren() {
          this.getChildren().forEach((child) => {
            child.parent = null;
            child.index = 0;
            child.remove();
          });
          this.children = [];
          this._requestDraw();
          return this;
        }
        destroyChildren() {
          this.getChildren().forEach((child) => {
            child.parent = null;
            child.index = 0;
            child.destroy();
          });
          this.children = [];
          this._requestDraw();
          return this;
        }
        add(...children) {
          if (children.length === 0) {
            return this;
          }
          if (children.length > 1) {
            for (let i2 = 0; i2 < children.length; i2++) {
              this.add(children[i2]);
            }
            return this;
          }
          const child = children[0];
          if (child.getParent()) {
            child.moveTo(this);
            return this;
          }
          this._validateAdd(child);
          child.index = this.getChildren().length;
          child.parent = this;
          child._clearCaches();
          this.getChildren().push(child);
          this._fire("add", {
            child
          });
          this._requestDraw();
          return this;
        }
        destroy() {
          if (this.hasChildren()) {
            this.destroyChildren();
          }
          super.destroy();
          return this;
        }
        find(selector) {
          return this._generalFind(selector, false);
        }
        findOne(selector) {
          const result = this._generalFind(selector, true);
          return result.length > 0 ? result[0] : void 0;
        }
        _generalFind(selector, findOne) {
          const retArr = [];
          this._descendants((node) => {
            const valid = node._isMatch(selector);
            if (valid) {
              retArr.push(node);
            }
            if (valid && findOne) {
              return true;
            }
            return false;
          });
          return retArr;
        }
        _descendants(fn) {
          let shouldStop = false;
          const children = this.getChildren();
          for (const child of children) {
            shouldStop = fn(child);
            if (shouldStop) {
              return true;
            }
            if (!child.hasChildren()) {
              continue;
            }
            shouldStop = child._descendants(fn);
            if (shouldStop) {
              return true;
            }
          }
          return false;
        }
        toObject() {
          const obj = Node.prototype.toObject.call(this);
          obj.children = [];
          this.getChildren().forEach((child) => {
            obj.children.push(child.toObject());
          });
          return obj;
        }
        isAncestorOf(node) {
          let parent = node.getParent();
          while (parent) {
            if (parent._id === this._id) {
              return true;
            }
            parent = parent.getParent();
          }
          return false;
        }
        clone(obj) {
          const node = Node.prototype.clone.call(this, obj);
          this.getChildren().forEach(function(no) {
            node.add(no.clone());
          });
          return node;
        }
        getAllIntersections(pos) {
          const arr = [];
          this.find("Shape").forEach((shape) => {
            if (shape.isVisible() && shape.intersects(pos)) {
              arr.push(shape);
            }
          });
          return arr;
        }
        _clearSelfAndDescendantCache(attr) {
          var _a;
          super._clearSelfAndDescendantCache(attr);
          if (this.isCached()) {
            return;
          }
          (_a = this.children) === null || _a === void 0 ? void 0 : _a.forEach(function(node) {
            node._clearSelfAndDescendantCache(attr);
          });
        }
        _setChildrenIndices() {
          var _a;
          (_a = this.children) === null || _a === void 0 ? void 0 : _a.forEach(function(child, n) {
            child.index = n;
          });
          this._requestDraw();
        }
        drawScene(can, top, bufferCanvas) {
          const layer = this.getLayer(), canvas = can || layer && layer.getCanvas(), context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedSceneCanvas = cachedCanvas && cachedCanvas.scene;
          const caching = canvas && canvas.isCache;
          if (!this.isVisible() && !caching) {
            return this;
          }
          if (cachedSceneCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
          } else {
            this._drawChildren("drawScene", canvas, top, bufferCanvas);
          }
          return this;
        }
        drawHit(can, top) {
          if (!this.shouldDrawHit(top)) {
            return this;
          }
          const layer = this.getLayer(), canvas = can || layer && layer.hitCanvas, context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
          if (cachedHitCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
          } else {
            this._drawChildren("drawHit", canvas, top);
          }
          return this;
        }
        _drawChildren(drawMethod, canvas, top, bufferCanvas) {
          var _a;
          const context = canvas && canvas.getContext(), clipWidth = this.clipWidth(), clipHeight = this.clipHeight(), clipFunc = this.clipFunc(), hasClip = typeof clipWidth === "number" && typeof clipHeight === "number" || clipFunc;
          const selfCache = top === this;
          if (hasClip) {
            context.save();
            const transform2 = this.getAbsoluteTransform(top);
            let m = transform2.getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            context.beginPath();
            let clipArgs;
            if (clipFunc) {
              clipArgs = clipFunc.call(this, context, this);
            } else {
              const clipX = this.clipX();
              const clipY = this.clipY();
              context.rect(clipX || 0, clipY || 0, clipWidth, clipHeight);
            }
            context.clip.apply(context, clipArgs);
            m = transform2.copy().invert().getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
          }
          const hasComposition = !selfCache && this.globalCompositeOperation() !== "source-over" && drawMethod === "drawScene";
          if (hasComposition) {
            context.save();
            context._applyGlobalCompositeOperation(this);
          }
          (_a = this.children) === null || _a === void 0 ? void 0 : _a.forEach(function(child) {
            child[drawMethod](canvas, top, bufferCanvas);
          });
          if (hasComposition) {
            context.restore();
          }
          if (hasClip) {
            context.restore();
          }
        }
        getClientRect(config = {}) {
          var _a;
          const skipTransform = config.skipTransform;
          const relativeTo = config.relativeTo;
          let minX, minY, maxX, maxY;
          let selfRect = {
            x: Infinity,
            y: Infinity,
            width: 0,
            height: 0
          };
          const that = this;
          (_a = this.children) === null || _a === void 0 ? void 0 : _a.forEach(function(child) {
            if (!child.visible()) {
              return;
            }
            const rect = child.getClientRect({
              relativeTo: that,
              skipShadow: config.skipShadow,
              skipStroke: config.skipStroke
            });
            if (rect.width === 0 && rect.height === 0) {
              return;
            }
            if (minX === void 0) {
              minX = rect.x;
              minY = rect.y;
              maxX = rect.x + rect.width;
              maxY = rect.y + rect.height;
            } else {
              minX = Math.min(minX, rect.x);
              minY = Math.min(minY, rect.y);
              maxX = Math.max(maxX, rect.x + rect.width);
              maxY = Math.max(maxY, rect.y + rect.height);
            }
          });
          const shapes2 = this.find("Shape");
          let hasVisible = false;
          for (let i2 = 0; i2 < shapes2.length; i2++) {
            const shape = shapes2[i2];
            if (shape._isVisible(this)) {
              hasVisible = true;
              break;
            }
          }
          if (hasVisible && minX !== void 0) {
            selfRect = {
              x: minX,
              y: minY,
              width: maxX - minX,
              height: maxY - minY
            };
          } else {
            selfRect = {
              x: 0,
              y: 0,
              width: 0,
              height: 0
            };
          }
          if (!skipTransform) {
            return this._transformedRect(selfRect, relativeTo);
          }
          return selfRect;
        }
      };
      Factory.addComponentsGetterSetter(Container, "clip", [
        "x",
        "y",
        "width",
        "height"
      ]);
      Factory.addGetterSetter(Container, "clipX", void 0, getNumberValidator());
      Factory.addGetterSetter(Container, "clipY", void 0, getNumberValidator());
      Factory.addGetterSetter(Container, "clipWidth", void 0, getNumberValidator());
      Factory.addGetterSetter(Container, "clipHeight", void 0, getNumberValidator());
      Factory.addGetterSetter(Container, "clipFunc");
    }
  });

  // node_modules/konva/lib/PointerEvents.js
  function getCapturedShape(pointerId) {
    return Captures.get(pointerId);
  }
  function createEvent(evt) {
    return {
      evt,
      pointerId: evt.pointerId
    };
  }
  function hasPointerCapture(pointerId, shape) {
    return Captures.get(pointerId) === shape;
  }
  function setPointerCapture(pointerId, shape) {
    releaseCapture(pointerId);
    const stage = shape.getStage();
    if (!stage)
      return;
    Captures.set(pointerId, shape);
    if (SUPPORT_POINTER_EVENTS) {
      shape._fire("gotpointercapture", createEvent(new PointerEvent("gotpointercapture")));
    }
  }
  function releaseCapture(pointerId, target) {
    const shape = Captures.get(pointerId);
    if (!shape)
      return;
    const stage = shape.getStage();
    if (stage && stage.content) {
    }
    Captures.delete(pointerId);
    if (SUPPORT_POINTER_EVENTS) {
      shape._fire("lostpointercapture", createEvent(new PointerEvent("lostpointercapture")));
    }
  }
  var Captures, SUPPORT_POINTER_EVENTS;
  var init_PointerEvents = __esm({
    "node_modules/konva/lib/PointerEvents.js"() {
      init_Global();
      Captures = /* @__PURE__ */ new Map();
      SUPPORT_POINTER_EVENTS = Konva._global["PointerEvent"] !== void 0;
    }
  });

  // node_modules/konva/lib/Stage.js
  function checkNoClip(attrs = {}) {
    if (attrs.clipFunc || attrs.clipWidth || attrs.clipHeight) {
      Util.warn("Stage does not support clipping. Please use clip for Layers or Groups.");
    }
    return attrs;
  }
  var STAGE2, STRING, PX, MOUSEOUT, MOUSELEAVE2, MOUSEOVER, MOUSEENTER2, MOUSEMOVE, MOUSEDOWN, MOUSEUP, POINTERMOVE, POINTERDOWN, POINTERUP, POINTERCANCEL, LOSTPOINTERCAPTURE, POINTEROUT, POINTERLEAVE2, POINTEROVER, POINTERENTER2, CONTEXTMENU, TOUCHSTART, TOUCHEND, TOUCHMOVE, TOUCHCANCEL, WHEEL, MAX_LAYERS_NUMBER, EVENTS, EVENTS_MAP, getEventType, getEventsMap, NO_POINTERS_MESSAGE, stages, Stage;
  var init_Stage = __esm({
    "node_modules/konva/lib/Stage.js"() {
      init_Util();
      init_Factory();
      init_Container();
      init_Global();
      init_Canvas();
      init_DragAndDrop();
      init_Global();
      init_PointerEvents();
      STAGE2 = "Stage";
      STRING = "string";
      PX = "px";
      MOUSEOUT = "mouseout";
      MOUSELEAVE2 = "mouseleave";
      MOUSEOVER = "mouseover";
      MOUSEENTER2 = "mouseenter";
      MOUSEMOVE = "mousemove";
      MOUSEDOWN = "mousedown";
      MOUSEUP = "mouseup";
      POINTERMOVE = "pointermove";
      POINTERDOWN = "pointerdown";
      POINTERUP = "pointerup";
      POINTERCANCEL = "pointercancel";
      LOSTPOINTERCAPTURE = "lostpointercapture";
      POINTEROUT = "pointerout";
      POINTERLEAVE2 = "pointerleave";
      POINTEROVER = "pointerover";
      POINTERENTER2 = "pointerenter";
      CONTEXTMENU = "contextmenu";
      TOUCHSTART = "touchstart";
      TOUCHEND = "touchend";
      TOUCHMOVE = "touchmove";
      TOUCHCANCEL = "touchcancel";
      WHEEL = "wheel";
      MAX_LAYERS_NUMBER = 5;
      EVENTS = [
        [MOUSEENTER2, "_pointerenter"],
        [MOUSEDOWN, "_pointerdown"],
        [MOUSEMOVE, "_pointermove"],
        [MOUSEUP, "_pointerup"],
        [MOUSELEAVE2, "_pointerleave"],
        [TOUCHSTART, "_pointerdown"],
        [TOUCHMOVE, "_pointermove"],
        [TOUCHEND, "_pointerup"],
        [TOUCHCANCEL, "_pointercancel"],
        [MOUSEOVER, "_pointerover"],
        [WHEEL, "_wheel"],
        [CONTEXTMENU, "_contextmenu"],
        [POINTERDOWN, "_pointerdown"],
        [POINTERMOVE, "_pointermove"],
        [POINTERUP, "_pointerup"],
        [POINTERCANCEL, "_pointercancel"],
        [POINTERLEAVE2, "_pointerleave"],
        [LOSTPOINTERCAPTURE, "_lostpointercapture"]
      ];
      EVENTS_MAP = {
        mouse: {
          [POINTEROUT]: MOUSEOUT,
          [POINTERLEAVE2]: MOUSELEAVE2,
          [POINTEROVER]: MOUSEOVER,
          [POINTERENTER2]: MOUSEENTER2,
          [POINTERMOVE]: MOUSEMOVE,
          [POINTERDOWN]: MOUSEDOWN,
          [POINTERUP]: MOUSEUP,
          [POINTERCANCEL]: "mousecancel",
          pointerclick: "click",
          pointerdblclick: "dblclick"
        },
        touch: {
          [POINTEROUT]: "touchout",
          [POINTERLEAVE2]: "touchleave",
          [POINTEROVER]: "touchover",
          [POINTERENTER2]: "touchenter",
          [POINTERMOVE]: TOUCHMOVE,
          [POINTERDOWN]: TOUCHSTART,
          [POINTERUP]: TOUCHEND,
          [POINTERCANCEL]: TOUCHCANCEL,
          pointerclick: "tap",
          pointerdblclick: "dbltap"
        },
        pointer: {
          [POINTEROUT]: POINTEROUT,
          [POINTERLEAVE2]: POINTERLEAVE2,
          [POINTEROVER]: POINTEROVER,
          [POINTERENTER2]: POINTERENTER2,
          [POINTERMOVE]: POINTERMOVE,
          [POINTERDOWN]: POINTERDOWN,
          [POINTERUP]: POINTERUP,
          [POINTERCANCEL]: POINTERCANCEL,
          pointerclick: "pointerclick",
          pointerdblclick: "pointerdblclick"
        }
      };
      getEventType = (type) => {
        if (type.indexOf("pointer") >= 0) {
          return "pointer";
        }
        if (type.indexOf("touch") >= 0) {
          return "touch";
        }
        return "mouse";
      };
      getEventsMap = (eventType) => {
        const type = getEventType(eventType);
        if (type === "pointer") {
          return Konva.pointerEventsEnabled && EVENTS_MAP.pointer;
        }
        if (type === "touch") {
          return EVENTS_MAP.touch;
        }
        if (type === "mouse") {
          return EVENTS_MAP.mouse;
        }
      };
      NO_POINTERS_MESSAGE = `Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);`;
      stages = [];
      Stage = class extends Container {
        constructor(config) {
          super(checkNoClip(config));
          this._pointerPositions = [];
          this._changedPointerPositions = [];
          this._buildDOM();
          this._bindContentEvents();
          stages.push(this);
          this.on("widthChange.konva heightChange.konva", this._resizeDOM);
          this.on("visibleChange.konva", this._checkVisibility);
          this.on("clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva", () => {
            checkNoClip(this.attrs);
          });
          this._checkVisibility();
        }
        _validateAdd(child) {
          const isLayer = child.getType() === "Layer";
          const isFastLayer = child.getType() === "FastLayer";
          const valid = isLayer || isFastLayer;
          if (!valid) {
            Util.throw("You may only add layers to the stage.");
          }
        }
        _checkVisibility() {
          if (!this.content) {
            return;
          }
          const style = this.visible() ? "" : "none";
          this.content.style.display = style;
        }
        setContainer(container) {
          if (typeof container === STRING) {
            let id;
            if (container.charAt(0) === ".") {
              const className = container.slice(1);
              container = document.getElementsByClassName(className)[0];
            } else {
              if (container.charAt(0) !== "#") {
                id = container;
              } else {
                id = container.slice(1);
              }
              container = document.getElementById(id);
            }
            if (!container) {
              throw "Can not find container in document with id " + id;
            }
          }
          this._setAttr("container", container);
          if (this.content) {
            if (this.content.parentElement) {
              this.content.parentElement.removeChild(this.content);
            }
            container.appendChild(this.content);
          }
          return this;
        }
        shouldDrawHit() {
          return true;
        }
        clear() {
          const layers = this.children, len = layers.length;
          for (let n = 0; n < len; n++) {
            layers[n].clear();
          }
          return this;
        }
        clone(obj) {
          if (!obj) {
            obj = {};
          }
          obj.container = typeof document !== "undefined" && document.createElement("div");
          return Container.prototype.clone.call(this, obj);
        }
        destroy() {
          super.destroy();
          const content = this.content;
          if (content && Util._isInDocument(content)) {
            this.container().removeChild(content);
          }
          const index = stages.indexOf(this);
          if (index > -1) {
            stages.splice(index, 1);
          }
          Util.releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas);
          return this;
        }
        getPointerPosition() {
          const pos = this._pointerPositions[0] || this._changedPointerPositions[0];
          if (!pos) {
            Util.warn(NO_POINTERS_MESSAGE);
            return null;
          }
          return {
            x: pos.x,
            y: pos.y
          };
        }
        _getPointerById(id) {
          return this._pointerPositions.find((p2) => p2.id === id);
        }
        getPointersPositions() {
          return this._pointerPositions;
        }
        getStage() {
          return this;
        }
        getContent() {
          return this.content;
        }
        _toKonvaCanvas(config) {
          config = { ...config };
          config.x = config.x || 0;
          config.y = config.y || 0;
          config.width = config.width || this.width();
          config.height = config.height || this.height();
          const canvas = new SceneCanvas({
            width: config.width,
            height: config.height,
            pixelRatio: config.pixelRatio || 1
          });
          const _context = canvas.getContext()._context;
          const layers = this.children;
          if (config.x || config.y) {
            _context.translate(-1 * config.x, -1 * config.y);
          }
          layers.forEach(function(layer) {
            if (!layer.isVisible()) {
              return;
            }
            const layerCanvas = layer._toKonvaCanvas(config);
            _context.drawImage(layerCanvas._canvas, config.x, config.y, layerCanvas.getWidth() / layerCanvas.getPixelRatio(), layerCanvas.getHeight() / layerCanvas.getPixelRatio());
          });
          return canvas;
        }
        getIntersection(pos) {
          if (!pos) {
            return null;
          }
          const layers = this.children, len = layers.length, end = len - 1;
          for (let n = end; n >= 0; n--) {
            const shape = layers[n].getIntersection(pos);
            if (shape) {
              return shape;
            }
          }
          return null;
        }
        _resizeDOM() {
          const width = this.width();
          const height = this.height();
          if (this.content) {
            this.content.style.width = width + PX;
            this.content.style.height = height + PX;
          }
          this.bufferCanvas.setSize(width, height);
          this.bufferHitCanvas.setSize(width, height);
          this.children.forEach((layer) => {
            layer.setSize({ width, height });
            layer.draw();
          });
        }
        add(layer, ...rest) {
          if (arguments.length > 1) {
            for (let i2 = 0; i2 < arguments.length; i2++) {
              this.add(arguments[i2]);
            }
            return this;
          }
          super.add(layer);
          const length = this.children.length;
          if (length > MAX_LAYERS_NUMBER) {
            Util.warn("The stage has " + length + " layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group.");
          }
          layer.setSize({ width: this.width(), height: this.height() });
          layer.draw();
          if (Konva.isBrowser) {
            this.content.appendChild(layer.canvas._canvas);
          }
          return this;
        }
        getParent() {
          return null;
        }
        getLayer() {
          return null;
        }
        hasPointerCapture(pointerId) {
          return hasPointerCapture(pointerId, this);
        }
        setPointerCapture(pointerId) {
          setPointerCapture(pointerId, this);
        }
        releaseCapture(pointerId) {
          releaseCapture(pointerId, this);
        }
        getLayers() {
          return this.children;
        }
        _bindContentEvents() {
          if (!Konva.isBrowser) {
            return;
          }
          EVENTS.forEach(([event, methodName]) => {
            this.content.addEventListener(event, (evt) => {
              this[methodName](evt);
            }, { passive: false });
          });
        }
        _pointerenter(evt) {
          this.setPointersPositions(evt);
          const events = getEventsMap(evt.type);
          if (events) {
            this._fire(events.pointerenter, {
              evt,
              target: this,
              currentTarget: this
            });
          }
        }
        _pointerover(evt) {
          this.setPointersPositions(evt);
          const events = getEventsMap(evt.type);
          if (events) {
            this._fire(events.pointerover, {
              evt,
              target: this,
              currentTarget: this
            });
          }
        }
        _getTargetShape(evenType) {
          let shape = this[evenType + "targetShape"];
          if (shape && !shape.getStage()) {
            shape = null;
          }
          return shape;
        }
        _pointerleave(evt) {
          const events = getEventsMap(evt.type);
          const eventType = getEventType(evt.type);
          if (!events) {
            return;
          }
          this.setPointersPositions(evt);
          const targetShape = this._getTargetShape(eventType);
          const eventsEnabled = !(Konva.isDragging() || Konva.isTransforming()) || Konva.hitOnDragEnabled;
          if (targetShape && eventsEnabled) {
            targetShape._fireAndBubble(events.pointerout, { evt });
            targetShape._fireAndBubble(events.pointerleave, { evt });
            this._fire(events.pointerleave, {
              evt,
              target: this,
              currentTarget: this
            });
            this[eventType + "targetShape"] = null;
          } else if (eventsEnabled) {
            this._fire(events.pointerleave, {
              evt,
              target: this,
              currentTarget: this
            });
            this._fire(events.pointerout, {
              evt,
              target: this,
              currentTarget: this
            });
          }
          this.pointerPos = null;
          this._pointerPositions = [];
        }
        _pointerdown(evt) {
          const events = getEventsMap(evt.type);
          const eventType = getEventType(evt.type);
          if (!events) {
            return;
          }
          this.setPointersPositions(evt);
          let triggeredOnShape = false;
          this._changedPointerPositions.forEach((pos) => {
            const shape = this.getIntersection(pos);
            DD.justDragged = false;
            Konva["_" + eventType + "ListenClick"] = true;
            if (!shape || !shape.isListening()) {
              this[eventType + "ClickStartShape"] = void 0;
              return;
            }
            if (Konva.capturePointerEventsEnabled) {
              shape.setPointerCapture(pos.id);
            }
            this[eventType + "ClickStartShape"] = shape;
            shape._fireAndBubble(events.pointerdown, {
              evt,
              pointerId: pos.id
            });
            triggeredOnShape = true;
            const isTouch = evt.type.indexOf("touch") >= 0;
            if (shape.preventDefault() && evt.cancelable && isTouch) {
              evt.preventDefault();
            }
          });
          if (!triggeredOnShape) {
            this._fire(events.pointerdown, {
              evt,
              target: this,
              currentTarget: this,
              pointerId: this._pointerPositions[0].id
            });
          }
        }
        _pointermove(evt) {
          const events = getEventsMap(evt.type);
          const eventType = getEventType(evt.type);
          if (!events) {
            return;
          }
          const isTouchPointer = evt.type.indexOf("touch") >= 0 || evt.pointerType === "touch";
          if (Konva.isDragging() && DD.node.preventDefault() && evt.cancelable && isTouchPointer) {
            evt.preventDefault();
          }
          this.setPointersPositions(evt);
          const eventsEnabled = !(Konva.isDragging() || Konva.isTransforming()) || Konva.hitOnDragEnabled;
          if (!eventsEnabled) {
            return;
          }
          const processedShapesIds = {};
          let triggeredOnShape = false;
          const targetShape = this._getTargetShape(eventType);
          this._changedPointerPositions.forEach((pos) => {
            const shape = getCapturedShape(pos.id) || this.getIntersection(pos);
            const pointerId = pos.id;
            const event = { evt, pointerId };
            const differentTarget = targetShape !== shape;
            if (differentTarget && targetShape) {
              targetShape._fireAndBubble(events.pointerout, { ...event }, shape);
              targetShape._fireAndBubble(events.pointerleave, { ...event }, shape);
            }
            if (shape) {
              if (processedShapesIds[shape._id]) {
                return;
              }
              processedShapesIds[shape._id] = true;
            }
            if (shape && shape.isListening()) {
              triggeredOnShape = true;
              if (differentTarget) {
                shape._fireAndBubble(events.pointerover, { ...event }, targetShape);
                shape._fireAndBubble(events.pointerenter, { ...event }, targetShape);
                this[eventType + "targetShape"] = shape;
              }
              shape._fireAndBubble(events.pointermove, { ...event });
            } else {
              if (targetShape) {
                this._fire(events.pointerover, {
                  evt,
                  target: this,
                  currentTarget: this,
                  pointerId
                });
                this[eventType + "targetShape"] = null;
              }
            }
          });
          if (!triggeredOnShape) {
            this._fire(events.pointermove, {
              evt,
              target: this,
              currentTarget: this,
              pointerId: this._changedPointerPositions[0].id
            });
          }
        }
        _pointerup(evt) {
          const events = getEventsMap(evt.type);
          const eventType = getEventType(evt.type);
          if (!events) {
            return;
          }
          this.setPointersPositions(evt);
          const clickStartShape = this[eventType + "ClickStartShape"];
          const clickEndShape = this[eventType + "ClickEndShape"];
          const processedShapesIds = {};
          let skipPointerUpTrigger = false;
          this._changedPointerPositions.forEach((pos) => {
            const shape = getCapturedShape(pos.id) || this.getIntersection(pos);
            if (shape) {
              shape.releaseCapture(pos.id);
              if (processedShapesIds[shape._id]) {
                return;
              }
              processedShapesIds[shape._id] = true;
            }
            const pointerId = pos.id;
            const event = { evt, pointerId };
            let fireDblClick = false;
            if (Konva["_" + eventType + "InDblClickWindow"]) {
              fireDblClick = true;
              clearTimeout(this[eventType + "DblTimeout"]);
            } else if (!DD.justDragged) {
              Konva["_" + eventType + "InDblClickWindow"] = true;
              clearTimeout(this[eventType + "DblTimeout"]);
            }
            this[eventType + "DblTimeout"] = setTimeout(function() {
              Konva["_" + eventType + "InDblClickWindow"] = false;
            }, Konva.dblClickWindow);
            if (shape && shape.isListening()) {
              skipPointerUpTrigger = true;
              this[eventType + "ClickEndShape"] = shape;
              shape._fireAndBubble(events.pointerup, { ...event });
              if (Konva["_" + eventType + "ListenClick"] && clickStartShape && clickStartShape === shape) {
                shape._fireAndBubble(events.pointerclick, { ...event });
                if (fireDblClick && clickEndShape && clickEndShape === shape) {
                  shape._fireAndBubble(events.pointerdblclick, { ...event });
                }
              }
            } else {
              this[eventType + "ClickEndShape"] = null;
              if (!skipPointerUpTrigger) {
                this._fire(events.pointerup, {
                  evt,
                  target: this,
                  currentTarget: this,
                  pointerId: this._changedPointerPositions[0].id
                });
                skipPointerUpTrigger = true;
              }
              if (Konva["_" + eventType + "ListenClick"]) {
                this._fire(events.pointerclick, {
                  evt,
                  target: this,
                  currentTarget: this,
                  pointerId
                });
              }
              if (fireDblClick) {
                this._fire(events.pointerdblclick, {
                  evt,
                  target: this,
                  currentTarget: this,
                  pointerId
                });
              }
            }
          });
          if (!skipPointerUpTrigger) {
            this._fire(events.pointerup, {
              evt,
              target: this,
              currentTarget: this,
              pointerId: this._changedPointerPositions[0].id
            });
          }
          Konva["_" + eventType + "ListenClick"] = false;
          if (evt.cancelable && eventType !== "touch" && eventType !== "pointer") {
            evt.preventDefault();
          }
        }
        _contextmenu(evt) {
          this.setPointersPositions(evt);
          const shape = this.getIntersection(this.getPointerPosition());
          if (shape && shape.isListening()) {
            shape._fireAndBubble(CONTEXTMENU, { evt });
          } else {
            this._fire(CONTEXTMENU, {
              evt,
              target: this,
              currentTarget: this
            });
          }
        }
        _wheel(evt) {
          this.setPointersPositions(evt);
          const shape = this.getIntersection(this.getPointerPosition());
          if (shape && shape.isListening()) {
            shape._fireAndBubble(WHEEL, { evt });
          } else {
            this._fire(WHEEL, {
              evt,
              target: this,
              currentTarget: this
            });
          }
        }
        _pointercancel(evt) {
          this.setPointersPositions(evt);
          const shape = getCapturedShape(evt.pointerId) || this.getIntersection(this.getPointerPosition());
          if (shape) {
            shape._fireAndBubble(POINTERUP, createEvent(evt));
          }
          releaseCapture(evt.pointerId);
        }
        _lostpointercapture(evt) {
          releaseCapture(evt.pointerId);
        }
        setPointersPositions(evt) {
          const contentPosition = this._getContentPosition();
          let x = null, y2 = null;
          evt = evt ? evt : window.event;
          if (evt.touches !== void 0) {
            this._pointerPositions = [];
            this._changedPointerPositions = [];
            Array.prototype.forEach.call(evt.touches, (touch) => {
              this._pointerPositions.push({
                id: touch.identifier,
                x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
              });
            });
            Array.prototype.forEach.call(evt.changedTouches || evt.touches, (touch) => {
              this._changedPointerPositions.push({
                id: touch.identifier,
                x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
              });
            });
          } else {
            x = (evt.clientX - contentPosition.left) / contentPosition.scaleX;
            y2 = (evt.clientY - contentPosition.top) / contentPosition.scaleY;
            this.pointerPos = {
              x,
              y: y2
            };
            this._pointerPositions = [{ x, y: y2, id: Util._getFirstPointerId(evt) }];
            this._changedPointerPositions = [
              { x, y: y2, id: Util._getFirstPointerId(evt) }
            ];
          }
        }
        _setPointerPosition(evt) {
          Util.warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.');
          this.setPointersPositions(evt);
        }
        _getContentPosition() {
          if (!this.content || !this.content.getBoundingClientRect) {
            return {
              top: 0,
              left: 0,
              scaleX: 1,
              scaleY: 1
            };
          }
          const rect = this.content.getBoundingClientRect();
          return {
            top: rect.top,
            left: rect.left,
            scaleX: rect.width / this.content.clientWidth || 1,
            scaleY: rect.height / this.content.clientHeight || 1
          };
        }
        _buildDOM() {
          this.bufferCanvas = new SceneCanvas({
            width: this.width(),
            height: this.height()
          });
          this.bufferHitCanvas = new HitCanvas({
            pixelRatio: 1,
            width: this.width(),
            height: this.height()
          });
          if (!Konva.isBrowser) {
            return;
          }
          const container = this.container();
          if (!container) {
            throw "Stage has no container. A container is required.";
          }
          container.innerHTML = "";
          this.content = document.createElement("div");
          this.content.style.position = "relative";
          this.content.style.userSelect = "none";
          this.content.className = "konvajs-content";
          this.content.setAttribute("role", "presentation");
          container.appendChild(this.content);
          this._resizeDOM();
        }
        cache() {
          Util.warn("Cache function is not allowed for stage. You may use cache only for layers, groups and shapes.");
          return this;
        }
        clearCache() {
          return this;
        }
        batchDraw() {
          this.getChildren().forEach(function(layer) {
            layer.batchDraw();
          });
          return this;
        }
      };
      Stage.prototype.nodeType = STAGE2;
      _registerNode(Stage);
      Factory.addGetterSetter(Stage, "container");
      if (Konva.isBrowser) {
        document.addEventListener("visibilitychange", () => {
          stages.forEach((stage) => {
            stage.batchDraw();
          });
        });
      }
    }
  });

  // node_modules/konva/lib/Shape.js
  function getDummyContext() {
    if (dummyContext) {
      return dummyContext;
    }
    dummyContext = Util.createCanvasElement().getContext("2d");
    return dummyContext;
  }
  function _fillFunc(context) {
    const fillRule = this.attrs.fillRule;
    if (fillRule) {
      context.fill(fillRule);
    } else {
      context.fill();
    }
  }
  function _strokeFunc(context) {
    context.stroke();
  }
  function _fillFuncHit(context) {
    const fillRule = this.attrs.fillRule;
    if (fillRule) {
      context.fill(fillRule);
    } else {
      context.fill();
    }
  }
  function _strokeFuncHit(context) {
    context.stroke();
  }
  function _clearHasShadowCache() {
    this._clearCache(HAS_SHADOW);
  }
  function _clearGetShadowRGBACache() {
    this._clearCache(SHADOW_RGBA);
  }
  function _clearFillPatternCache() {
    this._clearCache(patternImage);
  }
  function _clearLinearGradientCache() {
    this._clearCache(linearGradient);
  }
  function _clearRadialGradientCache() {
    this._clearCache(radialGradient);
  }
  var HAS_SHADOW, SHADOW_RGBA, patternImage, linearGradient, radialGradient, dummyContext, shapes, Shape;
  var init_Shape = __esm({
    "node_modules/konva/lib/Shape.js"() {
      init_Global();
      init_Util();
      init_Factory();
      init_Node();
      init_Validators();
      init_Global();
      init_PointerEvents();
      HAS_SHADOW = "hasShadow";
      SHADOW_RGBA = "shadowRGBA";
      patternImage = "patternImage";
      linearGradient = "linearGradient";
      radialGradient = "radialGradient";
      shapes = {};
      Shape = class extends Node {
        constructor(config) {
          super(config);
          let key;
          let attempts = 0;
          while (true) {
            key = Util.getHitColor();
            if (key && !(key in shapes)) {
              break;
            }
            attempts++;
            if (attempts >= 1e4) {
              Util.warn("Failed to find a unique color key for a shape. Konva may work incorrectly. Most likely your browser is using canvas farbling. Consider disabling it.");
              key = Util.getRandomColor();
              break;
            }
          }
          this.colorKey = key;
          shapes[key] = this;
        }
        getContext() {
          Util.warn("shape.getContext() method is deprecated. Please do not use it.");
          return this.getLayer().getContext();
        }
        getCanvas() {
          Util.warn("shape.getCanvas() method is deprecated. Please do not use it.");
          return this.getLayer().getCanvas();
        }
        getSceneFunc() {
          return this.attrs.sceneFunc || this["_sceneFunc"];
        }
        getHitFunc() {
          return this.attrs.hitFunc || this["_hitFunc"];
        }
        hasShadow() {
          return this._getCache(HAS_SHADOW, this._hasShadow);
        }
        _hasShadow() {
          return this.shadowEnabled() && this.shadowOpacity() !== 0 && !!(this.shadowColor() || this.shadowBlur() || this.shadowOffsetX() || this.shadowOffsetY());
        }
        _getFillPattern() {
          return this._getCache(patternImage, this.__getFillPattern);
        }
        __getFillPattern() {
          if (this.fillPatternImage()) {
            const ctx = getDummyContext();
            const pattern = ctx.createPattern(this.fillPatternImage(), this.fillPatternRepeat() || "repeat");
            if (pattern && pattern.setTransform) {
              const tr = new Transform();
              tr.translate(this.fillPatternX(), this.fillPatternY());
              tr.rotate(Konva.getAngle(this.fillPatternRotation()));
              tr.scale(this.fillPatternScaleX(), this.fillPatternScaleY());
              tr.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
              const m = tr.getMatrix();
              const matrix = typeof DOMMatrix === "undefined" ? {
                a: m[0],
                b: m[1],
                c: m[2],
                d: m[3],
                e: m[4],
                f: m[5]
              } : new DOMMatrix(m);
              pattern.setTransform(matrix);
            }
            return pattern;
          }
        }
        _getLinearGradient() {
          return this._getCache(linearGradient, this.__getLinearGradient);
        }
        __getLinearGradient() {
          const colorStops = this.fillLinearGradientColorStops();
          if (colorStops) {
            const ctx = getDummyContext();
            const start = this.fillLinearGradientStartPoint();
            const end = this.fillLinearGradientEndPoint();
            const grd = ctx.createLinearGradient(start.x, start.y, end.x, end.y);
            for (let n = 0; n < colorStops.length; n += 2) {
              grd.addColorStop(colorStops[n], colorStops[n + 1]);
            }
            return grd;
          }
        }
        _getRadialGradient() {
          return this._getCache(radialGradient, this.__getRadialGradient);
        }
        __getRadialGradient() {
          const colorStops = this.fillRadialGradientColorStops();
          if (colorStops) {
            const ctx = getDummyContext();
            const start = this.fillRadialGradientStartPoint();
            const end = this.fillRadialGradientEndPoint();
            const grd = ctx.createRadialGradient(start.x, start.y, this.fillRadialGradientStartRadius(), end.x, end.y, this.fillRadialGradientEndRadius());
            for (let n = 0; n < colorStops.length; n += 2) {
              grd.addColorStop(colorStops[n], colorStops[n + 1]);
            }
            return grd;
          }
        }
        getShadowRGBA() {
          return this._getCache(SHADOW_RGBA, this._getShadowRGBA);
        }
        _getShadowRGBA() {
          if (!this.hasShadow()) {
            return;
          }
          const rgba = Util.colorToRGBA(this.shadowColor());
          if (rgba) {
            return "rgba(" + rgba.r + "," + rgba.g + "," + rgba.b + "," + rgba.a * (this.shadowOpacity() || 1) + ")";
          }
        }
        hasFill() {
          return this._calculate("hasFill", [
            "fillEnabled",
            "fill",
            "fillPatternImage",
            "fillLinearGradientColorStops",
            "fillRadialGradientColorStops"
          ], () => {
            return this.fillEnabled() && !!(this.fill() || this.fillPatternImage() || this.fillLinearGradientColorStops() || this.fillRadialGradientColorStops());
          });
        }
        hasStroke() {
          return this._calculate("hasStroke", [
            "strokeEnabled",
            "strokeWidth",
            "stroke",
            "strokeLinearGradientColorStops"
          ], () => {
            return this.strokeEnabled() && this.strokeWidth() && !!(this.stroke() || this.strokeLinearGradientColorStops());
          });
        }
        hasHitStroke() {
          const width = this.hitStrokeWidth();
          if (width === "auto") {
            return this.hasStroke();
          }
          return this.strokeEnabled() && !!width;
        }
        intersects(point) {
          const stage = this.getStage();
          if (!stage) {
            return false;
          }
          const bufferHitCanvas = stage.bufferHitCanvas;
          bufferHitCanvas.getContext().clear();
          this.drawHit(bufferHitCanvas, void 0, true);
          const p2 = bufferHitCanvas.context.getImageData(Math.round(point.x), Math.round(point.y), 1, 1).data;
          return p2[3] > 0;
        }
        destroy() {
          Node.prototype.destroy.call(this);
          delete shapes[this.colorKey];
          delete this.colorKey;
          return this;
        }
        _useBufferCanvas(forceFill) {
          var _a;
          const perfectDrawEnabled = (_a = this.attrs.perfectDrawEnabled) !== null && _a !== void 0 ? _a : true;
          if (!perfectDrawEnabled) {
            return false;
          }
          const hasFill = forceFill || this.hasFill();
          const hasStroke = this.hasStroke();
          const isTransparent = this.getAbsoluteOpacity() !== 1;
          if (hasFill && hasStroke && isTransparent) {
            return true;
          }
          const hasShadow = this.hasShadow();
          const strokeForShadow = this.shadowForStrokeEnabled();
          if (hasFill && hasStroke && hasShadow && strokeForShadow) {
            return true;
          }
          return false;
        }
        setStrokeHitEnabled(val) {
          Util.warn("strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead.");
          if (val) {
            this.hitStrokeWidth("auto");
          } else {
            this.hitStrokeWidth(0);
          }
        }
        getStrokeHitEnabled() {
          if (this.hitStrokeWidth() === 0) {
            return false;
          } else {
            return true;
          }
        }
        getSelfRect() {
          const size = this.size();
          return {
            x: this._centroid ? -size.width / 2 : 0,
            y: this._centroid ? -size.height / 2 : 0,
            width: size.width,
            height: size.height
          };
        }
        getClientRect(config = {}) {
          let hasCachedParent = false;
          let parent = this.getParent();
          while (parent) {
            if (parent.isCached()) {
              hasCachedParent = true;
              break;
            }
            parent = parent.getParent();
          }
          const skipTransform = config.skipTransform;
          const relativeTo = config.relativeTo || hasCachedParent && this.getStage() || void 0;
          const fillRect = this.getSelfRect();
          const applyStroke = !config.skipStroke && this.hasStroke();
          const strokeWidth = applyStroke && this.strokeWidth() || 0;
          const fillAndStrokeWidth = fillRect.width + strokeWidth;
          const fillAndStrokeHeight = fillRect.height + strokeWidth;
          const applyShadow = !config.skipShadow && this.hasShadow();
          const shadowOffsetX = applyShadow ? this.shadowOffsetX() : 0;
          const shadowOffsetY = applyShadow ? this.shadowOffsetY() : 0;
          const preWidth = fillAndStrokeWidth + Math.abs(shadowOffsetX);
          const preHeight = fillAndStrokeHeight + Math.abs(shadowOffsetY);
          const blurRadius = applyShadow && this.shadowBlur() || 0;
          const width = preWidth + blurRadius * 2;
          const height = preHeight + blurRadius * 2;
          const rect = {
            width,
            height,
            x: -(strokeWidth / 2 + blurRadius) + Math.min(shadowOffsetX, 0) + fillRect.x,
            y: -(strokeWidth / 2 + blurRadius) + Math.min(shadowOffsetY, 0) + fillRect.y
          };
          if (!skipTransform) {
            return this._transformedRect(rect, relativeTo);
          }
          return rect;
        }
        drawScene(can, top, bufferCanvas) {
          const layer = this.getLayer();
          const canvas = can || layer.getCanvas(), context = canvas.getContext(), cachedCanvas = this._getCanvasCache(), drawFunc = this.getSceneFunc(), hasShadow = this.hasShadow();
          let stage;
          const skipBuffer = false;
          const cachingSelf = top === this;
          if (!this.isVisible() && !cachingSelf) {
            return this;
          }
          if (cachedCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
            return this;
          }
          if (!drawFunc) {
            return this;
          }
          context.save();
          if (this._useBufferCanvas() && !skipBuffer) {
            stage = this.getStage();
            const bc = bufferCanvas || stage.bufferCanvas;
            const bufferContext = bc.getContext();
            if (bufferCanvas) {
              bufferContext.save();
              bufferContext.setTransform(1, 0, 0, 1, 0, 0);
              bufferContext.clearRect(0, 0, bc.width, bc.height);
              bufferContext.restore();
            } else {
              bufferContext.clear();
            }
            bufferContext.save();
            bufferContext._applyLineJoin(this);
            bufferContext._applyMiterLimit(this);
            const o = this.getAbsoluteTransform(top).getMatrix();
            bufferContext.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
            drawFunc.call(this, bufferContext, this);
            bufferContext.restore();
            const ratio = bc.pixelRatio;
            if (hasShadow) {
              context._applyShadow(this);
            }
            if (!cachingSelf) {
              context._applyOpacity(this);
              context._applyGlobalCompositeOperation(this);
            }
            context.drawImage(bc._canvas, bc.x || 0, bc.y || 0, bc.width / ratio, bc.height / ratio);
          } else {
            context._applyLineJoin(this);
            context._applyMiterLimit(this);
            if (!cachingSelf) {
              const o = this.getAbsoluteTransform(top).getMatrix();
              context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
              context._applyOpacity(this);
              context._applyGlobalCompositeOperation(this);
            }
            if (hasShadow) {
              context._applyShadow(this);
            }
            drawFunc.call(this, context, this);
          }
          context.restore();
          return this;
        }
        drawHit(can, top, skipDragCheck = false) {
          if (!this.shouldDrawHit(top, skipDragCheck)) {
            return this;
          }
          const layer = this.getLayer(), canvas = can || layer.hitCanvas, context = canvas && canvas.getContext(), drawFunc = this.hitFunc() || this.sceneFunc(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
          if (!this.colorKey) {
            Util.warn("Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()");
          }
          if (cachedHitCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
            return this;
          }
          if (!drawFunc) {
            return this;
          }
          context.save();
          context._applyLineJoin(this);
          context._applyMiterLimit(this);
          const selfCache = this === top;
          if (!selfCache) {
            const o = this.getAbsoluteTransform(top).getMatrix();
            context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
          }
          drawFunc.call(this, context, this);
          context.restore();
          return this;
        }
        drawHitFromCache(alphaThreshold = 0) {
          const cachedCanvas = this._getCanvasCache(), sceneCanvas = this._getCachedSceneCanvas(), hitCanvas = cachedCanvas.hit, hitContext = hitCanvas.getContext(), hitWidth = hitCanvas.getWidth(), hitHeight = hitCanvas.getHeight();
          hitContext.clear();
          hitContext.drawImage(sceneCanvas._canvas, 0, 0, hitWidth, hitHeight);
          try {
            const hitImageData = hitContext.getImageData(0, 0, hitWidth, hitHeight);
            const hitData = hitImageData.data;
            const len = hitData.length;
            const rgbColorKey = Util._hexToRgb(this.colorKey);
            for (let i2 = 0; i2 < len; i2 += 4) {
              const alpha = hitData[i2 + 3];
              if (alpha > alphaThreshold) {
                hitData[i2] = rgbColorKey.r;
                hitData[i2 + 1] = rgbColorKey.g;
                hitData[i2 + 2] = rgbColorKey.b;
                hitData[i2 + 3] = 255;
              } else {
                hitData[i2 + 3] = 0;
              }
            }
            hitContext.putImageData(hitImageData, 0, 0);
          } catch (e) {
            Util.error("Unable to draw hit graph from cached scene canvas. " + e.message);
          }
          return this;
        }
        hasPointerCapture(pointerId) {
          return hasPointerCapture(pointerId, this);
        }
        setPointerCapture(pointerId) {
          setPointerCapture(pointerId, this);
        }
        releaseCapture(pointerId) {
          releaseCapture(pointerId, this);
        }
      };
      Shape.prototype._fillFunc = _fillFunc;
      Shape.prototype._strokeFunc = _strokeFunc;
      Shape.prototype._fillFuncHit = _fillFuncHit;
      Shape.prototype._strokeFuncHit = _strokeFuncHit;
      Shape.prototype._centroid = false;
      Shape.prototype.nodeType = "Shape";
      _registerNode(Shape);
      Shape.prototype.eventListeners = {};
      Shape.prototype.on("shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", _clearHasShadowCache);
      Shape.prototype.on("shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", _clearGetShadowRGBACache);
      Shape.prototype.on("fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva", _clearFillPatternCache);
      Shape.prototype.on("fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva", _clearLinearGradientCache);
      Shape.prototype.on("fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva", _clearRadialGradientCache);
      Factory.addGetterSetter(Shape, "stroke", void 0, getStringOrGradientValidator());
      Factory.addGetterSetter(Shape, "strokeWidth", 2, getNumberValidator());
      Factory.addGetterSetter(Shape, "fillAfterStrokeEnabled", false);
      Factory.addGetterSetter(Shape, "hitStrokeWidth", "auto", getNumberOrAutoValidator());
      Factory.addGetterSetter(Shape, "strokeHitEnabled", true, getBooleanValidator());
      Factory.addGetterSetter(Shape, "perfectDrawEnabled", true, getBooleanValidator());
      Factory.addGetterSetter(Shape, "shadowForStrokeEnabled", true, getBooleanValidator());
      Factory.addGetterSetter(Shape, "lineJoin");
      Factory.addGetterSetter(Shape, "lineCap");
      Factory.addGetterSetter(Shape, "miterLimit");
      Factory.addGetterSetter(Shape, "sceneFunc");
      Factory.addGetterSetter(Shape, "hitFunc");
      Factory.addGetterSetter(Shape, "dash");
      Factory.addGetterSetter(Shape, "dashOffset", 0, getNumberValidator());
      Factory.addGetterSetter(Shape, "shadowColor", void 0, getStringValidator());
      Factory.addGetterSetter(Shape, "shadowBlur", 0, getNumberValidator());
      Factory.addGetterSetter(Shape, "shadowOpacity", 1, getNumberValidator());
      Factory.addComponentsGetterSetter(Shape, "shadowOffset", ["x", "y"]);
      Factory.addGetterSetter(Shape, "shadowOffsetX", 0, getNumberValidator());
      Factory.addGetterSetter(Shape, "shadowOffsetY", 0, getNumberValidator());
      Factory.addGetterSetter(Shape, "fillPatternImage");
      Factory.addGetterSetter(Shape, "fill", void 0, getStringOrGradientValidator());
      Factory.addGetterSetter(Shape, "fillPatternX", 0, getNumberValidator());
      Factory.addGetterSetter(Shape, "fillPatternY", 0, getNumberValidator());
      Factory.addGetterSetter(Shape, "fillLinearGradientColorStops");
      Factory.addGetterSetter(Shape, "strokeLinearGradientColorStops");
      Factory.addGetterSetter(Shape, "fillRadialGradientStartRadius", 0);
      Factory.addGetterSetter(Shape, "fillRadialGradientEndRadius", 0);
      Factory.addGetterSetter(Shape, "fillRadialGradientColorStops");
      Factory.addGetterSetter(Shape, "fillPatternRepeat", "repeat");
      Factory.addGetterSetter(Shape, "fillEnabled", true);
      Factory.addGetterSetter(Shape, "strokeEnabled", true);
      Factory.addGetterSetter(Shape, "shadowEnabled", true);
      Factory.addGetterSetter(Shape, "dashEnabled", true);
      Factory.addGetterSetter(Shape, "strokeScaleEnabled", true);
      Factory.addGetterSetter(Shape, "fillPriority", "color");
      Factory.addComponentsGetterSetter(Shape, "fillPatternOffset", ["x", "y"]);
      Factory.addGetterSetter(Shape, "fillPatternOffsetX", 0, getNumberValidator());
      Factory.addGetterSetter(Shape, "fillPatternOffsetY", 0, getNumberValidator());
      Factory.addComponentsGetterSetter(Shape, "fillPatternScale", ["x", "y"]);
      Factory.addGetterSetter(Shape, "fillPatternScaleX", 1, getNumberValidator());
      Factory.addGetterSetter(Shape, "fillPatternScaleY", 1, getNumberValidator());
      Factory.addComponentsGetterSetter(Shape, "fillLinearGradientStartPoint", [
        "x",
        "y"
      ]);
      Factory.addComponentsGetterSetter(Shape, "strokeLinearGradientStartPoint", [
        "x",
        "y"
      ]);
      Factory.addGetterSetter(Shape, "fillLinearGradientStartPointX", 0);
      Factory.addGetterSetter(Shape, "strokeLinearGradientStartPointX", 0);
      Factory.addGetterSetter(Shape, "fillLinearGradientStartPointY", 0);
      Factory.addGetterSetter(Shape, "strokeLinearGradientStartPointY", 0);
      Factory.addComponentsGetterSetter(Shape, "fillLinearGradientEndPoint", [
        "x",
        "y"
      ]);
      Factory.addComponentsGetterSetter(Shape, "strokeLinearGradientEndPoint", [
        "x",
        "y"
      ]);
      Factory.addGetterSetter(Shape, "fillLinearGradientEndPointX", 0);
      Factory.addGetterSetter(Shape, "strokeLinearGradientEndPointX", 0);
      Factory.addGetterSetter(Shape, "fillLinearGradientEndPointY", 0);
      Factory.addGetterSetter(Shape, "strokeLinearGradientEndPointY", 0);
      Factory.addComponentsGetterSetter(Shape, "fillRadialGradientStartPoint", [
        "x",
        "y"
      ]);
      Factory.addGetterSetter(Shape, "fillRadialGradientStartPointX", 0);
      Factory.addGetterSetter(Shape, "fillRadialGradientStartPointY", 0);
      Factory.addComponentsGetterSetter(Shape, "fillRadialGradientEndPoint", [
        "x",
        "y"
      ]);
      Factory.addGetterSetter(Shape, "fillRadialGradientEndPointX", 0);
      Factory.addGetterSetter(Shape, "fillRadialGradientEndPointY", 0);
      Factory.addGetterSetter(Shape, "fillPatternRotation", 0);
      Factory.addGetterSetter(Shape, "fillRule", void 0, getStringValidator());
      Factory.backCompat(Shape, {
        dashArray: "dash",
        getDashArray: "getDash",
        setDashArray: "getDash",
        drawFunc: "sceneFunc",
        getDrawFunc: "getSceneFunc",
        setDrawFunc: "setSceneFunc",
        drawHitFunc: "hitFunc",
        getDrawHitFunc: "getHitFunc",
        setDrawHitFunc: "setHitFunc"
      });
    }
  });

  // node_modules/konva/lib/Layer.js
  var BEFORE_DRAW, DRAW, INTERSECTION_OFFSETS, INTERSECTION_OFFSETS_LEN, Layer;
  var init_Layer = __esm({
    "node_modules/konva/lib/Layer.js"() {
      init_Util();
      init_Container();
      init_Node();
      init_Factory();
      init_Canvas();
      init_Validators();
      init_Shape();
      init_Global();
      BEFORE_DRAW = "beforeDraw";
      DRAW = "draw";
      INTERSECTION_OFFSETS = [
        { x: 0, y: 0 },
        { x: -1, y: -1 },
        { x: 1, y: -1 },
        { x: 1, y: 1 },
        { x: -1, y: 1 }
      ];
      INTERSECTION_OFFSETS_LEN = INTERSECTION_OFFSETS.length;
      Layer = class extends Container {
        constructor(config) {
          super(config);
          this.canvas = new SceneCanvas();
          this.hitCanvas = new HitCanvas({
            pixelRatio: 1
          });
          this._waitingForDraw = false;
          this.on("visibleChange.konva", this._checkVisibility);
          this._checkVisibility();
          this.on("imageSmoothingEnabledChange.konva", this._setSmoothEnabled);
          this._setSmoothEnabled();
        }
        createPNGStream() {
          const c = this.canvas._canvas;
          return c.createPNGStream();
        }
        getCanvas() {
          return this.canvas;
        }
        getNativeCanvasElement() {
          return this.canvas._canvas;
        }
        getHitCanvas() {
          return this.hitCanvas;
        }
        getContext() {
          return this.getCanvas().getContext();
        }
        clear(bounds) {
          this.getContext().clear(bounds);
          this.getHitCanvas().getContext().clear(bounds);
          return this;
        }
        setZIndex(index) {
          super.setZIndex(index);
          const stage = this.getStage();
          if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            if (index < stage.children.length - 1) {
              stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[index + 1].getCanvas()._canvas);
            } else {
              stage.content.appendChild(this.getNativeCanvasElement());
            }
          }
          return this;
        }
        moveToTop() {
          Node.prototype.moveToTop.call(this);
          const stage = this.getStage();
          if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            stage.content.appendChild(this.getNativeCanvasElement());
          }
          return true;
        }
        moveUp() {
          const moved = Node.prototype.moveUp.call(this);
          if (!moved) {
            return false;
          }
          const stage = this.getStage();
          if (!stage || !stage.content) {
            return false;
          }
          stage.content.removeChild(this.getNativeCanvasElement());
          if (this.index < stage.children.length - 1) {
            stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[this.index + 1].getCanvas()._canvas);
          } else {
            stage.content.appendChild(this.getNativeCanvasElement());
          }
          return true;
        }
        moveDown() {
          if (Node.prototype.moveDown.call(this)) {
            const stage = this.getStage();
            if (stage) {
              const children = stage.children;
              if (stage.content) {
                stage.content.removeChild(this.getNativeCanvasElement());
                stage.content.insertBefore(this.getNativeCanvasElement(), children[this.index + 1].getCanvas()._canvas);
              }
            }
            return true;
          }
          return false;
        }
        moveToBottom() {
          if (Node.prototype.moveToBottom.call(this)) {
            const stage = this.getStage();
            if (stage) {
              const children = stage.children;
              if (stage.content) {
                stage.content.removeChild(this.getNativeCanvasElement());
                stage.content.insertBefore(this.getNativeCanvasElement(), children[1].getCanvas()._canvas);
              }
            }
            return true;
          }
          return false;
        }
        getLayer() {
          return this;
        }
        remove() {
          const _canvas = this.getNativeCanvasElement();
          Node.prototype.remove.call(this);
          if (_canvas && _canvas.parentNode && Util._isInDocument(_canvas)) {
            _canvas.parentNode.removeChild(_canvas);
          }
          return this;
        }
        getStage() {
          return this.parent;
        }
        setSize({ width, height }) {
          this.canvas.setSize(width, height);
          this.hitCanvas.setSize(width, height);
          this._setSmoothEnabled();
          return this;
        }
        _validateAdd(child) {
          const type = child.getType();
          if (type !== "Group" && type !== "Shape") {
            Util.throw("You may only add groups and shapes to a layer.");
          }
        }
        _toKonvaCanvas(config) {
          config = { ...config };
          config.width = config.width || this.getWidth();
          config.height = config.height || this.getHeight();
          config.x = config.x !== void 0 ? config.x : this.x();
          config.y = config.y !== void 0 ? config.y : this.y();
          return Node.prototype._toKonvaCanvas.call(this, config);
        }
        _checkVisibility() {
          const visible = this.visible();
          if (visible) {
            this.canvas._canvas.style.display = "block";
          } else {
            this.canvas._canvas.style.display = "none";
          }
        }
        _setSmoothEnabled() {
          this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
        }
        getWidth() {
          if (this.parent) {
            return this.parent.width();
          }
        }
        setWidth() {
          Util.warn('Can not change width of layer. Use "stage.width(value)" function instead.');
        }
        getHeight() {
          if (this.parent) {
            return this.parent.height();
          }
        }
        setHeight() {
          Util.warn('Can not change height of layer. Use "stage.height(value)" function instead.');
        }
        batchDraw() {
          if (!this._waitingForDraw) {
            this._waitingForDraw = true;
            Util.requestAnimFrame(() => {
              this.draw();
              this._waitingForDraw = false;
            });
          }
          return this;
        }
        getIntersection(pos) {
          if (!this.isListening() || !this.isVisible()) {
            return null;
          }
          let spiralSearchDistance = 1;
          let continueSearch = false;
          while (true) {
            for (let i2 = 0; i2 < INTERSECTION_OFFSETS_LEN; i2++) {
              const intersectionOffset = INTERSECTION_OFFSETS[i2];
              const obj = this._getIntersection({
                x: pos.x + intersectionOffset.x * spiralSearchDistance,
                y: pos.y + intersectionOffset.y * spiralSearchDistance
              });
              const shape = obj.shape;
              if (shape) {
                return shape;
              }
              continueSearch = !!obj.antialiased;
              if (!obj.antialiased) {
                break;
              }
            }
            if (continueSearch) {
              spiralSearchDistance += 1;
            } else {
              return null;
            }
          }
        }
        _getIntersection(pos) {
          const ratio = this.hitCanvas.pixelRatio;
          const p2 = this.hitCanvas.context.getImageData(Math.round(pos.x * ratio), Math.round(pos.y * ratio), 1, 1).data;
          const p3 = p2[3];
          if (p3 === 255) {
            const colorKey = Util.getHitColorKey(p2[0], p2[1], p2[2]);
            const shape = shapes[colorKey];
            if (shape) {
              return {
                shape
              };
            }
            return {
              antialiased: true
            };
          } else if (p3 > 0) {
            return {
              antialiased: true
            };
          }
          return {};
        }
        drawScene(can, top, bufferCanvas) {
          const layer = this.getLayer(), canvas = can || layer && layer.getCanvas();
          this._fire(BEFORE_DRAW, {
            node: this
          });
          if (this.clearBeforeDraw()) {
            canvas.getContext().clear();
          }
          Container.prototype.drawScene.call(this, canvas, top, bufferCanvas);
          this._fire(DRAW, {
            node: this
          });
          return this;
        }
        drawHit(can, top) {
          const layer = this.getLayer(), canvas = can || layer && layer.hitCanvas;
          if (layer && layer.clearBeforeDraw()) {
            layer.getHitCanvas().getContext().clear();
          }
          Container.prototype.drawHit.call(this, canvas, top);
          return this;
        }
        enableHitGraph() {
          this.hitGraphEnabled(true);
          return this;
        }
        disableHitGraph() {
          this.hitGraphEnabled(false);
          return this;
        }
        setHitGraphEnabled(val) {
          Util.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead.");
          this.listening(val);
        }
        getHitGraphEnabled(val) {
          Util.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead.");
          return this.listening();
        }
        toggleHitCanvas() {
          if (!this.parent || !this.parent["content"]) {
            return;
          }
          const parent = this.parent;
          const added = !!this.hitCanvas._canvas.parentNode;
          if (added) {
            parent.content.removeChild(this.hitCanvas._canvas);
          } else {
            parent.content.appendChild(this.hitCanvas._canvas);
          }
        }
        destroy() {
          Util.releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas);
          return super.destroy();
        }
      };
      Layer.prototype.nodeType = "Layer";
      _registerNode(Layer);
      Factory.addGetterSetter(Layer, "imageSmoothingEnabled", true);
      Factory.addGetterSetter(Layer, "clearBeforeDraw", true);
      Factory.addGetterSetter(Layer, "hitGraphEnabled", true, getBooleanValidator());
    }
  });

  // node_modules/konva/lib/FastLayer.js
  var FastLayer;
  var init_FastLayer = __esm({
    "node_modules/konva/lib/FastLayer.js"() {
      init_Util();
      init_Layer();
      init_Global();
      FastLayer = class extends Layer {
        constructor(attrs) {
          super(attrs);
          this.listening(false);
          Util.warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
        }
      };
      FastLayer.prototype.nodeType = "FastLayer";
      _registerNode(FastLayer);
    }
  });

  // node_modules/konva/lib/Group.js
  var Group;
  var init_Group = __esm({
    "node_modules/konva/lib/Group.js"() {
      init_Util();
      init_Container();
      init_Global();
      Group = class extends Container {
        _validateAdd(child) {
          const type = child.getType();
          if (type !== "Group" && type !== "Shape") {
            Util.throw("You may only add groups and shapes to groups.");
          }
        }
      };
      Group.prototype.nodeType = "Group";
      _registerNode(Group);
    }
  });

  // node_modules/konva/lib/Animation.js
  var now, Animation;
  var init_Animation = __esm({
    "node_modules/konva/lib/Animation.js"() {
      init_Global();
      init_Util();
      now = (function() {
        if (glob.performance && glob.performance.now) {
          return function() {
            return glob.performance.now();
          };
        }
        return function() {
          return (/* @__PURE__ */ new Date()).getTime();
        };
      })();
      Animation = class _Animation {
        constructor(func, layers) {
          this.id = _Animation.animIdCounter++;
          this.frame = {
            time: 0,
            timeDiff: 0,
            lastTime: now(),
            frameRate: 0
          };
          this.func = func;
          this.setLayers(layers);
        }
        setLayers(layers) {
          let lays = [];
          if (layers) {
            lays = Array.isArray(layers) ? layers : [layers];
          }
          this.layers = lays;
          return this;
        }
        getLayers() {
          return this.layers;
        }
        addLayer(layer) {
          const layers = this.layers;
          const len = layers.length;
          for (let n = 0; n < len; n++) {
            if (layers[n]._id === layer._id) {
              return false;
            }
          }
          this.layers.push(layer);
          return true;
        }
        isRunning() {
          const a = _Animation;
          const animations = a.animations;
          const len = animations.length;
          for (let n = 0; n < len; n++) {
            if (animations[n].id === this.id) {
              return true;
            }
          }
          return false;
        }
        start() {
          this.stop();
          this.frame.timeDiff = 0;
          this.frame.lastTime = now();
          _Animation._addAnimation(this);
          return this;
        }
        stop() {
          _Animation._removeAnimation(this);
          return this;
        }
        _updateFrameObject(time) {
          this.frame.timeDiff = time - this.frame.lastTime;
          this.frame.lastTime = time;
          this.frame.time += this.frame.timeDiff;
          this.frame.frameRate = 1e3 / this.frame.timeDiff;
        }
        static _addAnimation(anim) {
          this.animations.push(anim);
          this._handleAnimation();
        }
        static _removeAnimation(anim) {
          const id = anim.id;
          const animations = this.animations;
          const len = animations.length;
          for (let n = 0; n < len; n++) {
            if (animations[n].id === id) {
              this.animations.splice(n, 1);
              break;
            }
          }
        }
        static _runFrames() {
          const layerHash = {};
          const animations = this.animations;
          for (let n = 0; n < animations.length; n++) {
            const anim = animations[n];
            const layers = anim.layers;
            const func = anim.func;
            anim._updateFrameObject(now());
            const layersLen = layers.length;
            let needRedraw;
            if (func) {
              needRedraw = func.call(anim, anim.frame) !== false;
            } else {
              needRedraw = true;
            }
            if (!needRedraw) {
              continue;
            }
            for (let i2 = 0; i2 < layersLen; i2++) {
              const layer = layers[i2];
              if (layer._id !== void 0) {
                layerHash[layer._id] = layer;
              }
            }
          }
          for (const key in layerHash) {
            if (!layerHash.hasOwnProperty(key)) {
              continue;
            }
            layerHash[key].batchDraw();
          }
        }
        static _animationLoop() {
          const Anim = _Animation;
          if (Anim.animations.length) {
            Anim._runFrames();
            Util.requestAnimFrame(Anim._animationLoop);
          } else {
            Anim.animRunning = false;
          }
        }
        static _handleAnimation() {
          if (!this.animRunning) {
            this.animRunning = true;
            Util.requestAnimFrame(this._animationLoop);
          }
        }
      };
      Animation.animations = [];
      Animation.animIdCounter = 0;
      Animation.animRunning = false;
    }
  });

  // node_modules/konva/lib/Tween.js
  var blacklist, PAUSED, PLAYING, REVERSING, colorAttrs, idCounter2, TweenEngine, Tween, Easings;
  var init_Tween = __esm({
    "node_modules/konva/lib/Tween.js"() {
      init_Util();
      init_Animation();
      init_Node();
      init_Global();
      blacklist = {
        node: 1,
        duration: 1,
        easing: 1,
        onFinish: 1,
        yoyo: 1
      };
      PAUSED = 1;
      PLAYING = 2;
      REVERSING = 3;
      colorAttrs = ["fill", "stroke", "shadowColor"];
      idCounter2 = 0;
      TweenEngine = class {
        constructor(prop, propFunc, func, begin, finish, duration, yoyo) {
          this.prop = prop;
          this.propFunc = propFunc;
          this.begin = begin;
          this._pos = begin;
          this.duration = duration;
          this._change = 0;
          this.prevPos = 0;
          this.yoyo = yoyo;
          this._time = 0;
          this._position = 0;
          this._startTime = 0;
          this._finish = 0;
          this.func = func;
          this._change = finish - this.begin;
          this.pause();
        }
        fire(str) {
          const handler = this[str];
          if (handler) {
            handler();
          }
        }
        setTime(t) {
          if (t > this.duration) {
            if (this.yoyo) {
              this._time = this.duration;
              this.reverse();
            } else {
              this.finish();
            }
          } else if (t < 0) {
            if (this.yoyo) {
              this._time = 0;
              this.play();
            } else {
              this.reset();
            }
          } else {
            this._time = t;
            this.update();
          }
        }
        getTime() {
          return this._time;
        }
        setPosition(p2) {
          this.prevPos = this._pos;
          this.propFunc(p2);
          this._pos = p2;
        }
        getPosition(t) {
          if (t === void 0) {
            t = this._time;
          }
          return this.func(t, this.begin, this._change, this.duration);
        }
        play() {
          this.state = PLAYING;
          this._startTime = this.getTimer() - this._time;
          this.onEnterFrame();
          this.fire("onPlay");
        }
        reverse() {
          this.state = REVERSING;
          this._time = this.duration - this._time;
          this._startTime = this.getTimer() - this._time;
          this.onEnterFrame();
          this.fire("onReverse");
        }
        seek(t) {
          this.pause();
          this._time = t;
          this.update();
          this.fire("onSeek");
        }
        reset() {
          this.pause();
          this._time = 0;
          this.update();
          this.fire("onReset");
        }
        finish() {
          this.pause();
          this._time = this.duration;
          this.update();
          this.fire("onFinish");
        }
        update() {
          this.setPosition(this.getPosition(this._time));
          this.fire("onUpdate");
        }
        onEnterFrame() {
          const t = this.getTimer() - this._startTime;
          if (this.state === PLAYING) {
            this.setTime(t);
          } else if (this.state === REVERSING) {
            this.setTime(this.duration - t);
          }
        }
        pause() {
          this.state = PAUSED;
          this.fire("onPause");
        }
        getTimer() {
          return (/* @__PURE__ */ new Date()).getTime();
        }
      };
      Tween = class _Tween {
        constructor(config) {
          const that = this, node = config.node, nodeId = node._id, easing = config.easing || Easings.Linear, yoyo = !!config.yoyo;
          let duration, key;
          if (typeof config.duration === "undefined") {
            duration = 0.3;
          } else if (config.duration === 0) {
            duration = 1e-3;
          } else {
            duration = config.duration;
          }
          this.node = node;
          this._id = idCounter2++;
          const layers = node.getLayer() || (node instanceof Konva["Stage"] ? node.getLayers() : null);
          if (!layers) {
            Util.error("Tween constructor have `node` that is not in a layer. Please add node into layer first.");
          }
          this.anim = new Animation(function() {
            that.tween.onEnterFrame();
          }, layers);
          this.tween = new TweenEngine(key, function(i2) {
            that._tweenFunc(i2);
          }, easing, 0, 1, duration * 1e3, yoyo);
          this._addListeners();
          if (!_Tween.attrs[nodeId]) {
            _Tween.attrs[nodeId] = {};
          }
          if (!_Tween.attrs[nodeId][this._id]) {
            _Tween.attrs[nodeId][this._id] = {};
          }
          if (!_Tween.tweens[nodeId]) {
            _Tween.tweens[nodeId] = {};
          }
          for (key in config) {
            if (blacklist[key] === void 0) {
              this._addAttr(key, config[key]);
            }
          }
          this.reset();
          this.onFinish = config.onFinish;
          this.onReset = config.onReset;
          this.onUpdate = config.onUpdate;
        }
        _addAttr(key, end) {
          const node = this.node, nodeId = node._id;
          let diff, len, trueEnd, trueStart, endRGBA;
          const tweenId = _Tween.tweens[nodeId][key];
          if (tweenId) {
            delete _Tween.attrs[nodeId][tweenId][key];
          }
          let start = node.getAttr(key);
          if (Util._isArray(end)) {
            diff = [];
            len = Math.max(end.length, start.length);
            if (key === "points" && end.length !== start.length) {
              if (end.length > start.length) {
                trueStart = start;
                start = Util._prepareArrayForTween(start, end, node.closed());
              } else {
                trueEnd = end;
                end = Util._prepareArrayForTween(end, start, node.closed());
              }
            }
            if (key.indexOf("fill") === 0) {
              for (let n = 0; n < len; n++) {
                if (n % 2 === 0) {
                  diff.push(end[n] - start[n]);
                } else {
                  const startRGBA = Util.colorToRGBA(start[n]);
                  endRGBA = Util.colorToRGBA(end[n]);
                  start[n] = startRGBA;
                  diff.push({
                    r: endRGBA.r - startRGBA.r,
                    g: endRGBA.g - startRGBA.g,
                    b: endRGBA.b - startRGBA.b,
                    a: endRGBA.a - startRGBA.a
                  });
                }
              }
            } else {
              for (let n = 0; n < len; n++) {
                diff.push(end[n] - start[n]);
              }
            }
          } else if (colorAttrs.indexOf(key) !== -1) {
            start = Util.colorToRGBA(start);
            endRGBA = Util.colorToRGBA(end);
            diff = {
              r: endRGBA.r - start.r,
              g: endRGBA.g - start.g,
              b: endRGBA.b - start.b,
              a: endRGBA.a - start.a
            };
          } else {
            diff = end - start;
          }
          _Tween.attrs[nodeId][this._id][key] = {
            start,
            diff,
            end,
            trueEnd,
            trueStart
          };
          _Tween.tweens[nodeId][key] = this._id;
        }
        _tweenFunc(i2) {
          const node = this.node, attrs = _Tween.attrs[node._id][this._id];
          let key, attr, start, diff, newVal, n, len, end;
          for (key in attrs) {
            attr = attrs[key];
            start = attr.start;
            diff = attr.diff;
            end = attr.end;
            if (Util._isArray(start)) {
              newVal = [];
              len = Math.max(start.length, end.length);
              if (key.indexOf("fill") === 0) {
                for (n = 0; n < len; n++) {
                  if (n % 2 === 0) {
                    newVal.push((start[n] || 0) + diff[n] * i2);
                  } else {
                    newVal.push("rgba(" + Math.round(start[n].r + diff[n].r * i2) + "," + Math.round(start[n].g + diff[n].g * i2) + "," + Math.round(start[n].b + diff[n].b * i2) + "," + (start[n].a + diff[n].a * i2) + ")");
                  }
                }
              } else {
                for (n = 0; n < len; n++) {
                  newVal.push((start[n] || 0) + diff[n] * i2);
                }
              }
            } else if (colorAttrs.indexOf(key) !== -1) {
              newVal = "rgba(" + Math.round(start.r + diff.r * i2) + "," + Math.round(start.g + diff.g * i2) + "," + Math.round(start.b + diff.b * i2) + "," + (start.a + diff.a * i2) + ")";
            } else {
              newVal = start + diff * i2;
            }
            node.setAttr(key, newVal);
          }
        }
        _addListeners() {
          this.tween.onPlay = () => {
            this.anim.start();
          };
          this.tween.onReverse = () => {
            this.anim.start();
          };
          this.tween.onPause = () => {
            this.anim.stop();
          };
          this.tween.onFinish = () => {
            const node = this.node;
            const attrs = _Tween.attrs[node._id][this._id];
            if (attrs.points && attrs.points.trueEnd) {
              node.setAttr("points", attrs.points.trueEnd);
            }
            if (this.onFinish) {
              this.onFinish.call(this);
            }
          };
          this.tween.onReset = () => {
            const node = this.node;
            const attrs = _Tween.attrs[node._id][this._id];
            if (attrs.points && attrs.points.trueStart) {
              node.points(attrs.points.trueStart);
            }
            if (this.onReset) {
              this.onReset();
            }
          };
          this.tween.onUpdate = () => {
            if (this.onUpdate) {
              this.onUpdate.call(this);
            }
          };
        }
        play() {
          this.tween.play();
          return this;
        }
        reverse() {
          this.tween.reverse();
          return this;
        }
        reset() {
          this.tween.reset();
          return this;
        }
        seek(t) {
          this.tween.seek(t * 1e3);
          return this;
        }
        pause() {
          this.tween.pause();
          return this;
        }
        finish() {
          this.tween.finish();
          return this;
        }
        destroy() {
          const nodeId = this.node._id, thisId = this._id, attrs = _Tween.tweens[nodeId];
          this.pause();
          if (this.anim) {
            this.anim.stop();
          }
          for (const key in attrs) {
            delete _Tween.tweens[nodeId][key];
          }
          delete _Tween.attrs[nodeId][thisId];
          if (_Tween.tweens[nodeId]) {
            if (Object.keys(_Tween.tweens[nodeId]).length === 0) {
              delete _Tween.tweens[nodeId];
            }
            if (Object.keys(_Tween.attrs[nodeId]).length === 0) {
              delete _Tween.attrs[nodeId];
            }
          }
        }
      };
      Tween.attrs = {};
      Tween.tweens = {};
      Node.prototype.to = function(params) {
        const onFinish = params.onFinish;
        params.node = this;
        params.onFinish = function() {
          this.destroy();
          if (onFinish) {
            onFinish();
          }
        };
        const tween = new Tween(params);
        tween.play();
      };
      Easings = {
        BackEaseIn(t, b2, c, d) {
          const s = 1.70158;
          return c * (t /= d) * t * ((s + 1) * t - s) + b2;
        },
        BackEaseOut(t, b2, c, d) {
          const s = 1.70158;
          return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b2;
        },
        BackEaseInOut(t, b2, c, d) {
          let s = 1.70158;
          if ((t /= d / 2) < 1) {
            return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b2;
          }
          return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b2;
        },
        ElasticEaseIn(t, b2, c, d, a, p2) {
          let s = 0;
          if (t === 0) {
            return b2;
          }
          if ((t /= d) === 1) {
            return b2 + c;
          }
          if (!p2) {
            p2 = d * 0.3;
          }
          if (!a || a < Math.abs(c)) {
            a = c;
            s = p2 / 4;
          } else {
            s = p2 / (2 * Math.PI) * Math.asin(c / a);
          }
          return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p2)) + b2;
        },
        ElasticEaseOut(t, b2, c, d, a, p2) {
          let s = 0;
          if (t === 0) {
            return b2;
          }
          if ((t /= d) === 1) {
            return b2 + c;
          }
          if (!p2) {
            p2 = d * 0.3;
          }
          if (!a || a < Math.abs(c)) {
            a = c;
            s = p2 / 4;
          } else {
            s = p2 / (2 * Math.PI) * Math.asin(c / a);
          }
          return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p2) + c + b2;
        },
        ElasticEaseInOut(t, b2, c, d, a, p2) {
          let s = 0;
          if (t === 0) {
            return b2;
          }
          if ((t /= d / 2) === 2) {
            return b2 + c;
          }
          if (!p2) {
            p2 = d * (0.3 * 1.5);
          }
          if (!a || a < Math.abs(c)) {
            a = c;
            s = p2 / 4;
          } else {
            s = p2 / (2 * Math.PI) * Math.asin(c / a);
          }
          if (t < 1) {
            return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p2)) + b2;
          }
          return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p2) * 0.5 + c + b2;
        },
        BounceEaseOut(t, b2, c, d) {
          if ((t /= d) < 1 / 2.75) {
            return c * (7.5625 * t * t) + b2;
          } else if (t < 2 / 2.75) {
            return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b2;
          } else if (t < 2.5 / 2.75) {
            return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b2;
          } else {
            return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b2;
          }
        },
        BounceEaseIn(t, b2, c, d) {
          return c - Easings.BounceEaseOut(d - t, 0, c, d) + b2;
        },
        BounceEaseInOut(t, b2, c, d) {
          if (t < d / 2) {
            return Easings.BounceEaseIn(t * 2, 0, c, d) * 0.5 + b2;
          } else {
            return Easings.BounceEaseOut(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b2;
          }
        },
        EaseIn(t, b2, c, d) {
          return c * (t /= d) * t + b2;
        },
        EaseOut(t, b2, c, d) {
          return -c * (t /= d) * (t - 2) + b2;
        },
        EaseInOut(t, b2, c, d) {
          if ((t /= d / 2) < 1) {
            return c / 2 * t * t + b2;
          }
          return -c / 2 * (--t * (t - 2) - 1) + b2;
        },
        StrongEaseIn(t, b2, c, d) {
          return c * (t /= d) * t * t * t * t + b2;
        },
        StrongEaseOut(t, b2, c, d) {
          return c * ((t = t / d - 1) * t * t * t * t + 1) + b2;
        },
        StrongEaseInOut(t, b2, c, d) {
          if ((t /= d / 2) < 1) {
            return c / 2 * t * t * t * t * t + b2;
          }
          return c / 2 * ((t -= 2) * t * t * t * t + 2) + b2;
        },
        Linear(t, b2, c, d) {
          return c * t / d + b2;
        }
      };
    }
  });

  // node_modules/konva/lib/_CoreInternals.js
  var Konva2;
  var init_CoreInternals = __esm({
    "node_modules/konva/lib/_CoreInternals.js"() {
      init_Global();
      init_Util();
      init_Node();
      init_Container();
      init_Stage();
      init_Layer();
      init_FastLayer();
      init_Group();
      init_DragAndDrop();
      init_Shape();
      init_Animation();
      init_Tween();
      init_Context();
      init_Canvas();
      Konva2 = Util._assign(Konva, {
        Util,
        Transform,
        Node,
        Container,
        Stage,
        stages,
        Layer,
        FastLayer,
        Group,
        DD,
        Shape,
        shapes,
        Animation,
        Tween,
        Easings,
        Context,
        Canvas
      });
    }
  });

  // node_modules/konva/lib/shapes/Arc.js
  var Arc;
  var init_Arc = __esm({
    "node_modules/konva/lib/shapes/Arc.js"() {
      init_Factory();
      init_Shape();
      init_Global();
      init_Validators();
      init_Global();
      Arc = class extends Shape {
        _sceneFunc(context) {
          const angle = Konva.getAngle(this.angle()), clockwise = this.clockwise();
          context.beginPath();
          context.arc(0, 0, this.outerRadius(), 0, angle, clockwise);
          context.arc(0, 0, this.innerRadius(), angle, 0, !clockwise);
          context.closePath();
          context.fillStrokeShape(this);
        }
        getWidth() {
          return this.outerRadius() * 2;
        }
        getHeight() {
          return this.outerRadius() * 2;
        }
        setWidth(width) {
          this.outerRadius(width / 2);
        }
        setHeight(height) {
          this.outerRadius(height / 2);
        }
        getSelfRect() {
          const innerRadius = this.innerRadius();
          const outerRadius = this.outerRadius();
          const clockwise = this.clockwise();
          const angle = Konva.getAngle(clockwise ? 360 - this.angle() : this.angle());
          const boundLeftRatio = Math.cos(Math.min(angle, Math.PI));
          const boundRightRatio = 1;
          const boundTopRatio = Math.sin(Math.min(Math.max(Math.PI, angle), 3 * Math.PI / 2));
          const boundBottomRatio = Math.sin(Math.min(angle, Math.PI / 2));
          const boundLeft = boundLeftRatio * (boundLeftRatio > 0 ? innerRadius : outerRadius);
          const boundRight = boundRightRatio * (boundRightRatio > 0 ? outerRadius : innerRadius);
          const boundTop = boundTopRatio * (boundTopRatio > 0 ? innerRadius : outerRadius);
          const boundBottom = boundBottomRatio * (boundBottomRatio > 0 ? outerRadius : innerRadius);
          return {
            x: boundLeft,
            y: clockwise ? -1 * boundBottom : boundTop,
            width: boundRight - boundLeft,
            height: boundBottom - boundTop
          };
        }
      };
      Arc.prototype._centroid = true;
      Arc.prototype.className = "Arc";
      Arc.prototype._attrsAffectingSize = [
        "innerRadius",
        "outerRadius",
        "angle",
        "clockwise"
      ];
      _registerNode(Arc);
      Factory.addGetterSetter(Arc, "innerRadius", 0, getNumberValidator());
      Factory.addGetterSetter(Arc, "outerRadius", 0, getNumberValidator());
      Factory.addGetterSetter(Arc, "angle", 0, getNumberValidator());
      Factory.addGetterSetter(Arc, "clockwise", false, getBooleanValidator());
    }
  });

  // node_modules/konva/lib/shapes/Line.js
  function getControlPoints(x0, y0, x1, y1, x2, y2, t) {
    const d01 = Math.sqrt(Math.pow(x1 - x0, 2) + Math.pow(y1 - y0, 2)), d12 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)), fa = t * d01 / (d01 + d12), fb = t * d12 / (d01 + d12), p1x = x1 - fa * (x2 - x0), p1y = y1 - fa * (y2 - y0), p2x = x1 + fb * (x2 - x0), p2y = y1 + fb * (y2 - y0);
    return [p1x, p1y, p2x, p2y];
  }
  function expandPoints(p2, tension) {
    const len = p2.length, allPoints = [];
    for (let n = 2; n < len - 2; n += 2) {
      const cp = getControlPoints(p2[n - 2], p2[n - 1], p2[n], p2[n + 1], p2[n + 2], p2[n + 3], tension);
      if (isNaN(cp[0])) {
        continue;
      }
      allPoints.push(cp[0]);
      allPoints.push(cp[1]);
      allPoints.push(p2[n]);
      allPoints.push(p2[n + 1]);
      allPoints.push(cp[2]);
      allPoints.push(cp[3]);
    }
    return allPoints;
  }
  function getBezierExtremaPoints(points) {
    const axisPoints = [
      [points[0], points[2], points[4], points[6]],
      [points[1], points[3], points[5], points[7]]
    ];
    const extremaTs = [];
    for (const axis of axisPoints) {
      const a = -3 * axis[0] + 9 * axis[1] - 9 * axis[2] + 3 * axis[3];
      if (a !== 0) {
        const b2 = 6 * axis[0] - 12 * axis[1] + 6 * axis[2];
        const c = -3 * axis[0] + 3 * axis[1];
        const discriminant = b2 * b2 - 4 * a * c;
        if (discriminant >= 0) {
          const d = Math.sqrt(discriminant);
          extremaTs.push((-b2 + d) / (2 * a));
          extremaTs.push((-b2 - d) / (2 * a));
        }
      }
    }
    return extremaTs.filter((t) => t > 0 && t < 1).flatMap((t) => axisPoints.map((axis) => {
      const mt = 1 - t;
      return mt * mt * mt * axis[0] + 3 * mt * mt * t * axis[1] + 3 * mt * t * t * axis[2] + t * t * t * axis[3];
    }));
  }
  var Line;
  var init_Line = __esm({
    "node_modules/konva/lib/shapes/Line.js"() {
      init_Factory();
      init_Global();
      init_Shape();
      init_Validators();
      Line = class extends Shape {
        constructor(config) {
          super(config);
          this.on("pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva", function() {
            this._clearCache("tensionPoints");
          });
        }
        _sceneFunc(context) {
          const points = this.points(), length = points.length, tension = this.tension(), closed = this.closed(), bezier = this.bezier();
          if (!length) {
            return;
          }
          let n = 0;
          context.beginPath();
          context.moveTo(points[0], points[1]);
          if (tension !== 0 && length > 4) {
            const tp = this.getTensionPoints();
            const len = tp.length;
            n = closed ? 0 : 4;
            if (!closed) {
              context.quadraticCurveTo(tp[0], tp[1], tp[2], tp[3]);
            }
            while (n < len - 2) {
              context.bezierCurveTo(tp[n++], tp[n++], tp[n++], tp[n++], tp[n++], tp[n++]);
            }
            if (!closed) {
              context.quadraticCurveTo(tp[len - 2], tp[len - 1], points[length - 2], points[length - 1]);
            }
          } else if (bezier) {
            n = 2;
            while (n < length) {
              context.bezierCurveTo(points[n++], points[n++], points[n++], points[n++], points[n++], points[n++]);
            }
          } else {
            for (n = 2; n < length; n += 2) {
              context.lineTo(points[n], points[n + 1]);
            }
          }
          if (closed) {
            context.closePath();
            context.fillStrokeShape(this);
          } else {
            context.strokeShape(this);
          }
        }
        getTensionPoints() {
          return this._getCache("tensionPoints", this._getTensionPoints);
        }
        _getTensionPoints() {
          if (this.closed()) {
            return this._getTensionPointsClosed();
          } else {
            return expandPoints(this.points(), this.tension());
          }
        }
        _getTensionPointsClosed() {
          const p2 = this.points(), len = p2.length, tension = this.tension(), firstControlPoints = getControlPoints(p2[len - 2], p2[len - 1], p2[0], p2[1], p2[2], p2[3], tension), lastControlPoints = getControlPoints(p2[len - 4], p2[len - 3], p2[len - 2], p2[len - 1], p2[0], p2[1], tension), middle = expandPoints(p2, tension), tp = [firstControlPoints[2], firstControlPoints[3]].concat(middle).concat([
            lastControlPoints[0],
            lastControlPoints[1],
            p2[len - 2],
            p2[len - 1],
            lastControlPoints[2],
            lastControlPoints[3],
            firstControlPoints[0],
            firstControlPoints[1],
            p2[0],
            p2[1]
          ]);
          return tp;
        }
        getWidth() {
          return this.getSelfRect().width;
        }
        getHeight() {
          return this.getSelfRect().height;
        }
        getSelfRect() {
          let points = this.points();
          if (points.length < 4) {
            return {
              x: points[0] || 0,
              y: points[1] || 0,
              width: 0,
              height: 0
            };
          }
          if (this.tension() !== 0) {
            points = [
              points[0],
              points[1],
              ...this._getTensionPoints(),
              points[points.length - 2],
              points[points.length - 1]
            ];
          } else if (this.bezier()) {
            points = [
              points[0],
              points[1],
              ...getBezierExtremaPoints(this.points()),
              points[points.length - 2],
              points[points.length - 1]
            ];
          } else {
            points = this.points();
          }
          let minX = points[0];
          let maxX = points[0];
          let minY = points[1];
          let maxY = points[1];
          let x, y2;
          for (let i2 = 0; i2 < points.length / 2; i2++) {
            x = points[i2 * 2];
            y2 = points[i2 * 2 + 1];
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y2);
            maxY = Math.max(maxY, y2);
          }
          return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
          };
        }
      };
      Line.prototype.className = "Line";
      Line.prototype._attrsAffectingSize = ["points", "bezier", "tension"];
      _registerNode(Line);
      Factory.addGetterSetter(Line, "closed", false);
      Factory.addGetterSetter(Line, "bezier", false);
      Factory.addGetterSetter(Line, "tension", 0, getNumberValidator());
      Factory.addGetterSetter(Line, "points", [], getNumberArrayValidator());
    }
  });

  // node_modules/konva/lib/BezierFunctions.js
  function BFunc(xs, ys, t) {
    const xbase = getDerivative(1, t, xs);
    const ybase = getDerivative(1, t, ys);
    const combined = xbase * xbase + ybase * ybase;
    return Math.sqrt(combined);
  }
  var tValues, cValues, binomialCoefficients, getCubicArcLength, getQuadraticArcLength, getDerivative, t2length;
  var init_BezierFunctions = __esm({
    "node_modules/konva/lib/BezierFunctions.js"() {
      tValues = [
        [],
        [],
        [
          -0.5773502691896257,
          0.5773502691896257
        ],
        [
          0,
          -0.7745966692414834,
          0.7745966692414834
        ],
        [
          -0.33998104358485626,
          0.33998104358485626,
          -0.8611363115940526,
          0.8611363115940526
        ],
        [
          0,
          -0.5384693101056831,
          0.5384693101056831,
          -0.906179845938664,
          0.906179845938664
        ],
        [
          0.6612093864662645,
          -0.6612093864662645,
          -0.2386191860831969,
          0.2386191860831969,
          -0.932469514203152,
          0.932469514203152
        ],
        [
          0,
          0.4058451513773972,
          -0.4058451513773972,
          -0.7415311855993945,
          0.7415311855993945,
          -0.9491079123427585,
          0.9491079123427585
        ],
        [
          -0.1834346424956498,
          0.1834346424956498,
          -0.525532409916329,
          0.525532409916329,
          -0.7966664774136267,
          0.7966664774136267,
          -0.9602898564975363,
          0.9602898564975363
        ],
        [
          0,
          -0.8360311073266358,
          0.8360311073266358,
          -0.9681602395076261,
          0.9681602395076261,
          -0.3242534234038089,
          0.3242534234038089,
          -0.6133714327005904,
          0.6133714327005904
        ],
        [
          -0.14887433898163122,
          0.14887433898163122,
          -0.4333953941292472,
          0.4333953941292472,
          -0.6794095682990244,
          0.6794095682990244,
          -0.8650633666889845,
          0.8650633666889845,
          -0.9739065285171717,
          0.9739065285171717
        ],
        [
          0,
          -0.26954315595234496,
          0.26954315595234496,
          -0.5190961292068118,
          0.5190961292068118,
          -0.7301520055740494,
          0.7301520055740494,
          -0.8870625997680953,
          0.8870625997680953,
          -0.978228658146057,
          0.978228658146057
        ],
        [
          -0.1252334085114689,
          0.1252334085114689,
          -0.3678314989981802,
          0.3678314989981802,
          -0.5873179542866175,
          0.5873179542866175,
          -0.7699026741943047,
          0.7699026741943047,
          -0.9041172563704749,
          0.9041172563704749,
          -0.9815606342467192,
          0.9815606342467192
        ],
        [
          0,
          -0.2304583159551348,
          0.2304583159551348,
          -0.44849275103644687,
          0.44849275103644687,
          -0.6423493394403402,
          0.6423493394403402,
          -0.8015780907333099,
          0.8015780907333099,
          -0.9175983992229779,
          0.9175983992229779,
          -0.9841830547185881,
          0.9841830547185881
        ],
        [
          -0.10805494870734367,
          0.10805494870734367,
          -0.31911236892788974,
          0.31911236892788974,
          -0.5152486363581541,
          0.5152486363581541,
          -0.6872929048116855,
          0.6872929048116855,
          -0.827201315069765,
          0.827201315069765,
          -0.9284348836635735,
          0.9284348836635735,
          -0.9862838086968123,
          0.9862838086968123
        ],
        [
          0,
          -0.20119409399743451,
          0.20119409399743451,
          -0.3941513470775634,
          0.3941513470775634,
          -0.5709721726085388,
          0.5709721726085388,
          -0.7244177313601701,
          0.7244177313601701,
          -0.8482065834104272,
          0.8482065834104272,
          -0.937273392400706,
          0.937273392400706,
          -0.9879925180204854,
          0.9879925180204854
        ],
        [
          -0.09501250983763744,
          0.09501250983763744,
          -0.2816035507792589,
          0.2816035507792589,
          -0.45801677765722737,
          0.45801677765722737,
          -0.6178762444026438,
          0.6178762444026438,
          -0.755404408355003,
          0.755404408355003,
          -0.8656312023878318,
          0.8656312023878318,
          -0.9445750230732326,
          0.9445750230732326,
          -0.9894009349916499,
          0.9894009349916499
        ],
        [
          0,
          -0.17848418149584785,
          0.17848418149584785,
          -0.3512317634538763,
          0.3512317634538763,
          -0.5126905370864769,
          0.5126905370864769,
          -0.6576711592166907,
          0.6576711592166907,
          -0.7815140038968014,
          0.7815140038968014,
          -0.8802391537269859,
          0.8802391537269859,
          -0.9506755217687678,
          0.9506755217687678,
          -0.9905754753144174,
          0.9905754753144174
        ],
        [
          -0.0847750130417353,
          0.0847750130417353,
          -0.2518862256915055,
          0.2518862256915055,
          -0.41175116146284263,
          0.41175116146284263,
          -0.5597708310739475,
          0.5597708310739475,
          -0.6916870430603532,
          0.6916870430603532,
          -0.8037049589725231,
          0.8037049589725231,
          -0.8926024664975557,
          0.8926024664975557,
          -0.9558239495713977,
          0.9558239495713977,
          -0.9915651684209309,
          0.9915651684209309
        ],
        [
          0,
          -0.16035864564022537,
          0.16035864564022537,
          -0.31656409996362983,
          0.31656409996362983,
          -0.46457074137596094,
          0.46457074137596094,
          -0.600545304661681,
          0.600545304661681,
          -0.7209661773352294,
          0.7209661773352294,
          -0.8227146565371428,
          0.8227146565371428,
          -0.9031559036148179,
          0.9031559036148179,
          -0.96020815213483,
          0.96020815213483,
          -0.9924068438435844,
          0.9924068438435844
        ],
        [
          -0.07652652113349734,
          0.07652652113349734,
          -0.22778585114164507,
          0.22778585114164507,
          -0.37370608871541955,
          0.37370608871541955,
          -0.5108670019508271,
          0.5108670019508271,
          -0.636053680726515,
          0.636053680726515,
          -0.7463319064601508,
          0.7463319064601508,
          -0.8391169718222188,
          0.8391169718222188,
          -0.912234428251326,
          0.912234428251326,
          -0.9639719272779138,
          0.9639719272779138,
          -0.9931285991850949,
          0.9931285991850949
        ],
        [
          0,
          -0.1455618541608951,
          0.1455618541608951,
          -0.2880213168024011,
          0.2880213168024011,
          -0.4243421202074388,
          0.4243421202074388,
          -0.5516188358872198,
          0.5516188358872198,
          -0.6671388041974123,
          0.6671388041974123,
          -0.7684399634756779,
          0.7684399634756779,
          -0.8533633645833173,
          0.8533633645833173,
          -0.9200993341504008,
          0.9200993341504008,
          -0.9672268385663063,
          0.9672268385663063,
          -0.9937521706203895,
          0.9937521706203895
        ],
        [
          -0.06973927331972223,
          0.06973927331972223,
          -0.20786042668822127,
          0.20786042668822127,
          -0.34193582089208424,
          0.34193582089208424,
          -0.469355837986757,
          0.469355837986757,
          -0.5876404035069116,
          0.5876404035069116,
          -0.6944872631866827,
          0.6944872631866827,
          -0.7878168059792081,
          0.7878168059792081,
          -0.8658125777203002,
          0.8658125777203002,
          -0.926956772187174,
          0.926956772187174,
          -0.9700604978354287,
          0.9700604978354287,
          -0.9942945854823992,
          0.9942945854823992
        ],
        [
          0,
          -0.1332568242984661,
          0.1332568242984661,
          -0.26413568097034495,
          0.26413568097034495,
          -0.3903010380302908,
          0.3903010380302908,
          -0.5095014778460075,
          0.5095014778460075,
          -0.6196098757636461,
          0.6196098757636461,
          -0.7186613631319502,
          0.7186613631319502,
          -0.8048884016188399,
          0.8048884016188399,
          -0.8767523582704416,
          0.8767523582704416,
          -0.9329710868260161,
          0.9329710868260161,
          -0.9725424712181152,
          0.9725424712181152,
          -0.9947693349975522,
          0.9947693349975522
        ],
        [
          -0.06405689286260563,
          0.06405689286260563,
          -0.1911188674736163,
          0.1911188674736163,
          -0.3150426796961634,
          0.3150426796961634,
          -0.4337935076260451,
          0.4337935076260451,
          -0.5454214713888396,
          0.5454214713888396,
          -0.6480936519369755,
          0.6480936519369755,
          -0.7401241915785544,
          0.7401241915785544,
          -0.820001985973903,
          0.820001985973903,
          -0.8864155270044011,
          0.8864155270044011,
          -0.9382745520027328,
          0.9382745520027328,
          -0.9747285559713095,
          0.9747285559713095,
          -0.9951872199970213,
          0.9951872199970213
        ]
      ];
      cValues = [
        [],
        [],
        [1, 1],
        [
          0.8888888888888888,
          0.5555555555555556,
          0.5555555555555556
        ],
        [
          0.6521451548625461,
          0.6521451548625461,
          0.34785484513745385,
          0.34785484513745385
        ],
        [
          0.5688888888888889,
          0.47862867049936647,
          0.47862867049936647,
          0.23692688505618908,
          0.23692688505618908
        ],
        [
          0.3607615730481386,
          0.3607615730481386,
          0.46791393457269104,
          0.46791393457269104,
          0.17132449237917036,
          0.17132449237917036
        ],
        [
          0.4179591836734694,
          0.3818300505051189,
          0.3818300505051189,
          0.27970539148927664,
          0.27970539148927664,
          0.1294849661688697,
          0.1294849661688697
        ],
        [
          0.362683783378362,
          0.362683783378362,
          0.31370664587788727,
          0.31370664587788727,
          0.22238103445337448,
          0.22238103445337448,
          0.10122853629037626,
          0.10122853629037626
        ],
        [
          0.3302393550012598,
          0.1806481606948574,
          0.1806481606948574,
          0.08127438836157441,
          0.08127438836157441,
          0.31234707704000286,
          0.31234707704000286,
          0.26061069640293544,
          0.26061069640293544
        ],
        [
          0.29552422471475287,
          0.29552422471475287,
          0.26926671930999635,
          0.26926671930999635,
          0.21908636251598204,
          0.21908636251598204,
          0.1494513491505806,
          0.1494513491505806,
          0.06667134430868814,
          0.06667134430868814
        ],
        [
          0.2729250867779006,
          0.26280454451024665,
          0.26280454451024665,
          0.23319376459199048,
          0.23319376459199048,
          0.18629021092773426,
          0.18629021092773426,
          0.1255803694649046,
          0.1255803694649046,
          0.05566856711617366,
          0.05566856711617366
        ],
        [
          0.24914704581340277,
          0.24914704581340277,
          0.2334925365383548,
          0.2334925365383548,
          0.20316742672306592,
          0.20316742672306592,
          0.16007832854334622,
          0.16007832854334622,
          0.10693932599531843,
          0.10693932599531843,
          0.04717533638651183,
          0.04717533638651183
        ],
        [
          0.2325515532308739,
          0.22628318026289723,
          0.22628318026289723,
          0.2078160475368885,
          0.2078160475368885,
          0.17814598076194574,
          0.17814598076194574,
          0.13887351021978725,
          0.13887351021978725,
          0.09212149983772845,
          0.09212149983772845,
          0.04048400476531588,
          0.04048400476531588
        ],
        [
          0.2152638534631578,
          0.2152638534631578,
          0.2051984637212956,
          0.2051984637212956,
          0.18553839747793782,
          0.18553839747793782,
          0.15720316715819355,
          0.15720316715819355,
          0.12151857068790319,
          0.12151857068790319,
          0.08015808715976021,
          0.08015808715976021,
          0.03511946033175186,
          0.03511946033175186
        ],
        [
          0.2025782419255613,
          0.19843148532711158,
          0.19843148532711158,
          0.1861610000155622,
          0.1861610000155622,
          0.16626920581699392,
          0.16626920581699392,
          0.13957067792615432,
          0.13957067792615432,
          0.10715922046717194,
          0.10715922046717194,
          0.07036604748810812,
          0.07036604748810812,
          0.03075324199611727,
          0.03075324199611727
        ],
        [
          0.1894506104550685,
          0.1894506104550685,
          0.18260341504492358,
          0.18260341504492358,
          0.16915651939500254,
          0.16915651939500254,
          0.14959598881657674,
          0.14959598881657674,
          0.12462897125553388,
          0.12462897125553388,
          0.09515851168249279,
          0.09515851168249279,
          0.062253523938647894,
          0.062253523938647894,
          0.027152459411754096,
          0.027152459411754096
        ],
        [
          0.17944647035620653,
          0.17656270536699264,
          0.17656270536699264,
          0.16800410215645004,
          0.16800410215645004,
          0.15404576107681028,
          0.15404576107681028,
          0.13513636846852548,
          0.13513636846852548,
          0.11188384719340397,
          0.11188384719340397,
          0.08503614831717918,
          0.08503614831717918,
          0.0554595293739872,
          0.0554595293739872,
          0.02414830286854793,
          0.02414830286854793
        ],
        [
          0.1691423829631436,
          0.1691423829631436,
          0.16427648374583273,
          0.16427648374583273,
          0.15468467512626524,
          0.15468467512626524,
          0.14064291467065065,
          0.14064291467065065,
          0.12255520671147846,
          0.12255520671147846,
          0.10094204410628717,
          0.10094204410628717,
          0.07642573025488905,
          0.07642573025488905,
          0.0497145488949698,
          0.0497145488949698,
          0.02161601352648331,
          0.02161601352648331
        ],
        [
          0.1610544498487837,
          0.15896884339395434,
          0.15896884339395434,
          0.15276604206585967,
          0.15276604206585967,
          0.1426067021736066,
          0.1426067021736066,
          0.12875396253933621,
          0.12875396253933621,
          0.11156664554733399,
          0.11156664554733399,
          0.09149002162245,
          0.09149002162245,
          0.06904454273764123,
          0.06904454273764123,
          0.0448142267656996,
          0.0448142267656996,
          0.019461788229726478,
          0.019461788229726478
        ],
        [
          0.15275338713072584,
          0.15275338713072584,
          0.14917298647260374,
          0.14917298647260374,
          0.14209610931838204,
          0.14209610931838204,
          0.13168863844917664,
          0.13168863844917664,
          0.11819453196151841,
          0.11819453196151841,
          0.10193011981724044,
          0.10193011981724044,
          0.08327674157670475,
          0.08327674157670475,
          0.06267204833410907,
          0.06267204833410907,
          0.04060142980038694,
          0.04060142980038694,
          0.017614007139152118,
          0.017614007139152118
        ],
        [
          0.14608113364969041,
          0.14452440398997005,
          0.14452440398997005,
          0.13988739479107315,
          0.13988739479107315,
          0.13226893863333747,
          0.13226893863333747,
          0.12183141605372853,
          0.12183141605372853,
          0.10879729916714838,
          0.10879729916714838,
          0.09344442345603386,
          0.09344442345603386,
          0.0761001136283793,
          0.0761001136283793,
          0.057134425426857205,
          0.057134425426857205,
          0.036953789770852494,
          0.036953789770852494,
          0.016017228257774335,
          0.016017228257774335
        ],
        [
          0.13925187285563198,
          0.13925187285563198,
          0.13654149834601517,
          0.13654149834601517,
          0.13117350478706238,
          0.13117350478706238,
          0.12325237681051242,
          0.12325237681051242,
          0.11293229608053922,
          0.11293229608053922,
          0.10041414444288096,
          0.10041414444288096,
          0.08594160621706773,
          0.08594160621706773,
          0.06979646842452049,
          0.06979646842452049,
          0.052293335152683286,
          0.052293335152683286,
          0.03377490158481415,
          0.03377490158481415,
          0.0146279952982722,
          0.0146279952982722
        ],
        [
          0.13365457218610619,
          0.1324620394046966,
          0.1324620394046966,
          0.12890572218808216,
          0.12890572218808216,
          0.12304908430672953,
          0.12304908430672953,
          0.11499664022241136,
          0.11499664022241136,
          0.10489209146454141,
          0.10489209146454141,
          0.09291576606003515,
          0.09291576606003515,
          0.07928141177671895,
          0.07928141177671895,
          0.06423242140852585,
          0.06423242140852585,
          0.04803767173108467,
          0.04803767173108467,
          0.030988005856979445,
          0.030988005856979445,
          0.013411859487141771,
          0.013411859487141771
        ],
        [
          0.12793819534675216,
          0.12793819534675216,
          0.1258374563468283,
          0.1258374563468283,
          0.12167047292780339,
          0.12167047292780339,
          0.1155056680537256,
          0.1155056680537256,
          0.10744427011596563,
          0.10744427011596563,
          0.09761865210411388,
          0.09761865210411388,
          0.08619016153195327,
          0.08619016153195327,
          0.0733464814110803,
          0.0733464814110803,
          0.05929858491543678,
          0.05929858491543678,
          0.04427743881741981,
          0.04427743881741981,
          0.028531388628933663,
          0.028531388628933663,
          0.0123412297999872,
          0.0123412297999872
        ]
      ];
      binomialCoefficients = [[1], [1, 1], [1, 2, 1], [1, 3, 3, 1]];
      getCubicArcLength = (xs, ys, t) => {
        let sum;
        let correctedT;
        const n = 20;
        const z2 = t / 2;
        sum = 0;
        for (let i2 = 0; i2 < n; i2++) {
          correctedT = z2 * tValues[n][i2] + z2;
          sum += cValues[n][i2] * BFunc(xs, ys, correctedT);
        }
        return z2 * sum;
      };
      getQuadraticArcLength = (xs, ys, t) => {
        if (t === void 0) {
          t = 1;
        }
        const ax = xs[0] - 2 * xs[1] + xs[2];
        const ay = ys[0] - 2 * ys[1] + ys[2];
        const bx = 2 * xs[1] - 2 * xs[0];
        const by = 2 * ys[1] - 2 * ys[0];
        const A = 4 * (ax * ax + ay * ay);
        const B2 = 4 * (ax * bx + ay * by);
        const C = bx * bx + by * by;
        if (A === 0) {
          return t * Math.sqrt(Math.pow(xs[2] - xs[0], 2) + Math.pow(ys[2] - ys[0], 2));
        }
        const b2 = B2 / (2 * A);
        const c = C / A;
        const u2 = t + b2;
        const k = c - b2 * b2;
        const uuk = u2 * u2 + k > 0 ? Math.sqrt(u2 * u2 + k) : 0;
        const bbk = b2 * b2 + k > 0 ? Math.sqrt(b2 * b2 + k) : 0;
        const term = b2 + Math.sqrt(b2 * b2 + k) !== 0 ? k * Math.log(Math.abs((u2 + uuk) / (b2 + bbk))) : 0;
        return Math.sqrt(A) / 2 * (u2 * uuk - b2 * bbk + term);
      };
      getDerivative = (derivative, t, vs) => {
        const n = vs.length - 1;
        let _vs;
        let value;
        if (n === 0) {
          return 0;
        }
        if (derivative === 0) {
          value = 0;
          for (let k = 0; k <= n; k++) {
            value += binomialCoefficients[n][k] * Math.pow(1 - t, n - k) * Math.pow(t, k) * vs[k];
          }
          return value;
        } else {
          _vs = new Array(n);
          for (let k = 0; k < n; k++) {
            _vs[k] = n * (vs[k + 1] - vs[k]);
          }
          return getDerivative(derivative - 1, t, _vs);
        }
      };
      t2length = (length, totalLength, func) => {
        let error = 1;
        let t = length / totalLength;
        let step = (length - func(t)) / totalLength;
        let numIterations = 0;
        while (error > 1e-3) {
          const increasedTLength = func(t + step);
          const increasedTError = Math.abs(length - increasedTLength) / totalLength;
          if (increasedTError < error) {
            error = increasedTError;
            t += step;
          } else {
            const decreasedTLength = func(t - step);
            const decreasedTError = Math.abs(length - decreasedTLength) / totalLength;
            if (decreasedTError < error) {
              error = decreasedTError;
              t -= step;
            } else {
              step /= 2;
            }
          }
          numIterations++;
          if (numIterations > 500) {
            break;
          }
        }
        return t;
      };
    }
  });

  // node_modules/konva/lib/shapes/Path.js
  var Path;
  var init_Path = __esm({
    "node_modules/konva/lib/shapes/Path.js"() {
      init_Factory();
      init_Global();
      init_Shape();
      init_BezierFunctions();
      Path = class _Path extends Shape {
        constructor(config) {
          super(config);
          this.dataArray = [];
          this.pathLength = 0;
          this._readDataAttribute();
          this.on("dataChange.konva", function() {
            this._readDataAttribute();
          });
        }
        _readDataAttribute() {
          this.dataArray = _Path.parsePathData(this.data());
          this.pathLength = _Path.getPathLength(this.dataArray);
        }
        _sceneFunc(context) {
          const ca = this.dataArray;
          context.beginPath();
          let isClosed = false;
          for (let n = 0; n < ca.length; n++) {
            const c = ca[n].command;
            const p2 = ca[n].points;
            switch (c) {
              case "L":
                context.lineTo(p2[0], p2[1]);
                break;
              case "M":
                context.moveTo(p2[0], p2[1]);
                break;
              case "C":
                context.bezierCurveTo(p2[0], p2[1], p2[2], p2[3], p2[4], p2[5]);
                break;
              case "Q":
                context.quadraticCurveTo(p2[0], p2[1], p2[2], p2[3]);
                break;
              case "A":
                const cx = p2[0], cy = p2[1], rx = p2[2], ry = p2[3], theta = p2[4], dTheta = p2[5], psi = p2[6], fs = p2[7];
                const r = rx > ry ? rx : ry;
                const scaleX = rx > ry ? 1 : rx / ry;
                const scaleY = rx > ry ? ry / rx : 1;
                context.translate(cx, cy);
                context.rotate(psi);
                context.scale(scaleX, scaleY);
                context.arc(0, 0, r, theta, theta + dTheta, 1 - fs);
                context.scale(1 / scaleX, 1 / scaleY);
                context.rotate(-psi);
                context.translate(-cx, -cy);
                break;
              case "z":
                isClosed = true;
                context.closePath();
                break;
            }
          }
          if (!isClosed && !this.hasFill()) {
            context.strokeShape(this);
          } else {
            context.fillStrokeShape(this);
          }
        }
        getSelfRect() {
          let points = [];
          this.dataArray.forEach(function(data) {
            if (data.command === "A") {
              const start = data.points[4];
              const dTheta = data.points[5];
              const end = data.points[4] + dTheta;
              let inc = Math.PI / 180;
              if (Math.abs(start - end) < inc) {
                inc = Math.abs(start - end);
              }
              if (dTheta < 0) {
                for (let t = start - inc; t > end; t -= inc) {
                  const point = _Path.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
                  points.push(point.x, point.y);
                }
              } else {
                for (let t = start + inc; t < end; t += inc) {
                  const point = _Path.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
                  points.push(point.x, point.y);
                }
              }
            } else if (data.command === "C") {
              for (let t = 0; t <= 1; t += 0.01) {
                const point = _Path.getPointOnCubicBezier(t, data.start.x, data.start.y, data.points[0], data.points[1], data.points[2], data.points[3], data.points[4], data.points[5]);
                points.push(point.x, point.y);
              }
            } else {
              points = points.concat(data.points);
            }
          });
          let minX = points[0];
          let maxX = points[0];
          let minY = points[1];
          let maxY = points[1];
          let x, y2;
          for (let i2 = 0; i2 < points.length / 2; i2++) {
            x = points[i2 * 2];
            y2 = points[i2 * 2 + 1];
            if (!isNaN(x)) {
              minX = Math.min(minX, x);
              maxX = Math.max(maxX, x);
            }
            if (!isNaN(y2)) {
              minY = Math.min(minY, y2);
              maxY = Math.max(maxY, y2);
            }
          }
          return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
          };
        }
        getLength() {
          return this.pathLength;
        }
        getPointAtLength(length) {
          return _Path.getPointAtLengthOfDataArray(length, this.dataArray);
        }
        static getLineLength(x1, y1, x2, y2) {
          return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        }
        static getPathLength(dataArray) {
          let pathLength = 0;
          for (let i2 = 0; i2 < dataArray.length; ++i2) {
            pathLength += dataArray[i2].pathLength;
          }
          return pathLength;
        }
        static getPointAtLengthOfDataArray(length, dataArray) {
          let points, i2 = 0, ii = dataArray.length;
          if (!ii) {
            return null;
          }
          while (i2 < ii && length > dataArray[i2].pathLength) {
            length -= dataArray[i2].pathLength;
            ++i2;
          }
          if (i2 === ii) {
            points = dataArray[i2 - 1].points.slice(-2);
            return {
              x: points[0],
              y: points[1]
            };
          }
          if (length < 0.01) {
            const cmd = dataArray[i2].command;
            if (cmd === "M") {
              points = dataArray[i2].points.slice(0, 2);
              return {
                x: points[0],
                y: points[1]
              };
            } else {
              return {
                x: dataArray[i2].start.x,
                y: dataArray[i2].start.y
              };
            }
          }
          const cp = dataArray[i2];
          const p2 = cp.points;
          switch (cp.command) {
            case "L":
              return _Path.getPointOnLine(length, cp.start.x, cp.start.y, p2[0], p2[1]);
            case "C":
              return _Path.getPointOnCubicBezier(t2length(length, _Path.getPathLength(dataArray), (i3) => {
                return getCubicArcLength([cp.start.x, p2[0], p2[2], p2[4]], [cp.start.y, p2[1], p2[3], p2[5]], i3);
              }), cp.start.x, cp.start.y, p2[0], p2[1], p2[2], p2[3], p2[4], p2[5]);
            case "Q":
              return _Path.getPointOnQuadraticBezier(t2length(length, _Path.getPathLength(dataArray), (i3) => {
                return getQuadraticArcLength([cp.start.x, p2[0], p2[2]], [cp.start.y, p2[1], p2[3]], i3);
              }), cp.start.x, cp.start.y, p2[0], p2[1], p2[2], p2[3]);
            case "A":
              const cx = p2[0], cy = p2[1], rx = p2[2], ry = p2[3], dTheta = p2[5], psi = p2[6];
              let theta = p2[4];
              theta += dTheta * length / cp.pathLength;
              return _Path.getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi);
          }
          return null;
        }
        static getPointOnLine(dist, P1x, P1y, P2x, P2y, fromX, fromY) {
          fromX = fromX !== null && fromX !== void 0 ? fromX : P1x;
          fromY = fromY !== null && fromY !== void 0 ? fromY : P1y;
          const len = this.getLineLength(P1x, P1y, P2x, P2y);
          if (len < 1e-10) {
            return { x: P1x, y: P1y };
          }
          if (P2x === P1x) {
            return { x: fromX, y: fromY + (P2y > P1y ? dist : -dist) };
          }
          const m = (P2y - P1y) / (P2x - P1x);
          const run = Math.sqrt(dist * dist / (1 + m * m)) * (P2x < P1x ? -1 : 1);
          const rise = m * run;
          if (Math.abs(fromY - P1y - m * (fromX - P1x)) < 1e-10) {
            return { x: fromX + run, y: fromY + rise };
          }
          const u2 = ((fromX - P1x) * (P2x - P1x) + (fromY - P1y) * (P2y - P1y)) / (len * len);
          const ix = P1x + u2 * (P2x - P1x);
          const iy = P1y + u2 * (P2y - P1y);
          const pRise = this.getLineLength(fromX, fromY, ix, iy);
          const pRun = Math.sqrt(dist * dist - pRise * pRise);
          const adjustedRun = Math.sqrt(pRun * pRun / (1 + m * m)) * (P2x < P1x ? -1 : 1);
          const adjustedRise = m * adjustedRun;
          return { x: ix + adjustedRun, y: iy + adjustedRise };
        }
        static getPointOnCubicBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y, P4x, P4y) {
          function CB1(t) {
            return t * t * t;
          }
          function CB2(t) {
            return 3 * t * t * (1 - t);
          }
          function CB3(t) {
            return 3 * t * (1 - t) * (1 - t);
          }
          function CB4(t) {
            return (1 - t) * (1 - t) * (1 - t);
          }
          const x = P4x * CB1(pct) + P3x * CB2(pct) + P2x * CB3(pct) + P1x * CB4(pct);
          const y2 = P4y * CB1(pct) + P3y * CB2(pct) + P2y * CB3(pct) + P1y * CB4(pct);
          return { x, y: y2 };
        }
        static getPointOnQuadraticBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y) {
          function QB1(t) {
            return t * t;
          }
          function QB2(t) {
            return 2 * t * (1 - t);
          }
          function QB3(t) {
            return (1 - t) * (1 - t);
          }
          const x = P3x * QB1(pct) + P2x * QB2(pct) + P1x * QB3(pct);
          const y2 = P3y * QB1(pct) + P2y * QB2(pct) + P1y * QB3(pct);
          return { x, y: y2 };
        }
        static getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi) {
          const cosPsi = Math.cos(psi), sinPsi = Math.sin(psi);
          const pt = {
            x: rx * Math.cos(theta),
            y: ry * Math.sin(theta)
          };
          return {
            x: cx + (pt.x * cosPsi - pt.y * sinPsi),
            y: cy + (pt.x * sinPsi + pt.y * cosPsi)
          };
        }
        static parsePathData(data) {
          if (!data) {
            return [];
          }
          let cs = data;
          const cc = [
            "m",
            "M",
            "l",
            "L",
            "v",
            "V",
            "h",
            "H",
            "z",
            "Z",
            "c",
            "C",
            "q",
            "Q",
            "t",
            "T",
            "s",
            "S",
            "a",
            "A"
          ];
          cs = cs.replace(new RegExp(" ", "g"), ",");
          for (let n = 0; n < cc.length; n++) {
            cs = cs.replace(new RegExp(cc[n], "g"), "|" + cc[n]);
          }
          const arr = cs.split("|");
          const ca = [];
          const coords = [];
          let cpx = 0;
          let cpy = 0;
          const re2 = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;
          let match;
          for (let n = 1; n < arr.length; n++) {
            let str = arr[n];
            let c = str.charAt(0);
            str = str.slice(1);
            coords.length = 0;
            while (match = re2.exec(str)) {
              coords.push(match[0]);
            }
            let p2 = [];
            let arcParamIndex = c === "A" || c === "a" ? 0 : -1;
            for (let j = 0, jlen = coords.length; j < jlen; j++) {
              const token = coords[j];
              if (token === "00") {
                p2.push(0, 0);
                if (arcParamIndex >= 0) {
                  arcParamIndex += 2;
                  if (arcParamIndex >= 7)
                    arcParamIndex -= 7;
                }
                continue;
              }
              if (arcParamIndex >= 0) {
                if (arcParamIndex === 3) {
                  if (/^[01]{2}\d+(?:\.\d+)?$/.test(token)) {
                    p2.push(parseInt(token[0], 10));
                    p2.push(parseInt(token[1], 10));
                    p2.push(parseFloat(token.slice(2)));
                    arcParamIndex += 3;
                    if (arcParamIndex >= 7)
                      arcParamIndex -= 7;
                    continue;
                  }
                  if (token === "11" || token === "10" || token === "01") {
                    p2.push(parseInt(token[0], 10));
                    p2.push(parseInt(token[1], 10));
                    arcParamIndex += 2;
                    if (arcParamIndex >= 7)
                      arcParamIndex -= 7;
                    continue;
                  }
                  if (token === "0" || token === "1") {
                    p2.push(parseInt(token, 10));
                    arcParamIndex += 1;
                    if (arcParamIndex >= 7)
                      arcParamIndex -= 7;
                    continue;
                  }
                } else if (arcParamIndex === 4) {
                  if (/^[01]\d+(?:\.\d+)?$/.test(token)) {
                    p2.push(parseInt(token[0], 10));
                    p2.push(parseFloat(token.slice(1)));
                    arcParamIndex += 2;
                    if (arcParamIndex >= 7)
                      arcParamIndex -= 7;
                    continue;
                  }
                  if (token === "0" || token === "1") {
                    p2.push(parseInt(token, 10));
                    arcParamIndex += 1;
                    if (arcParamIndex >= 7)
                      arcParamIndex -= 7;
                    continue;
                  }
                }
                const parsedArc = parseFloat(token);
                if (!isNaN(parsedArc)) {
                  p2.push(parsedArc);
                } else {
                  p2.push(0);
                }
                arcParamIndex += 1;
                if (arcParamIndex >= 7)
                  arcParamIndex -= 7;
              } else {
                const parsed = parseFloat(token);
                if (!isNaN(parsed)) {
                  p2.push(parsed);
                } else {
                  p2.push(0);
                }
              }
            }
            while (p2.length > 0) {
              if (isNaN(p2[0])) {
                break;
              }
              let cmd = "";
              let points = [];
              const startX = cpx, startY = cpy;
              let prevCmd, ctlPtx, ctlPty;
              let rx, ry, psi, fa, fs, x1, y1;
              switch (c) {
                case "l":
                  cpx += p2.shift();
                  cpy += p2.shift();
                  cmd = "L";
                  points.push(cpx, cpy);
                  break;
                case "L":
                  cpx = p2.shift();
                  cpy = p2.shift();
                  points.push(cpx, cpy);
                  break;
                case "m":
                  const dx = p2.shift();
                  const dy = p2.shift();
                  cpx += dx;
                  cpy += dy;
                  cmd = "M";
                  if (ca.length > 2 && ca[ca.length - 1].command === "z") {
                    for (let idx = ca.length - 2; idx >= 0; idx--) {
                      if (ca[idx].command === "M") {
                        cpx = ca[idx].points[0] + dx;
                        cpy = ca[idx].points[1] + dy;
                        break;
                      }
                    }
                  }
                  points.push(cpx, cpy);
                  c = "l";
                  break;
                case "M":
                  cpx = p2.shift();
                  cpy = p2.shift();
                  cmd = "M";
                  points.push(cpx, cpy);
                  c = "L";
                  break;
                case "h":
                  cpx += p2.shift();
                  cmd = "L";
                  points.push(cpx, cpy);
                  break;
                case "H":
                  cpx = p2.shift();
                  cmd = "L";
                  points.push(cpx, cpy);
                  break;
                case "v":
                  cpy += p2.shift();
                  cmd = "L";
                  points.push(cpx, cpy);
                  break;
                case "V":
                  cpy = p2.shift();
                  cmd = "L";
                  points.push(cpx, cpy);
                  break;
                case "C":
                  points.push(p2.shift(), p2.shift(), p2.shift(), p2.shift());
                  cpx = p2.shift();
                  cpy = p2.shift();
                  points.push(cpx, cpy);
                  break;
                case "c":
                  points.push(cpx + p2.shift(), cpy + p2.shift(), cpx + p2.shift(), cpy + p2.shift());
                  cpx += p2.shift();
                  cpy += p2.shift();
                  cmd = "C";
                  points.push(cpx, cpy);
                  break;
                case "S":
                  ctlPtx = cpx;
                  ctlPty = cpy;
                  prevCmd = ca[ca.length - 1];
                  if (prevCmd.command === "C") {
                    ctlPtx = cpx + (cpx - prevCmd.points[2]);
                    ctlPty = cpy + (cpy - prevCmd.points[3]);
                  }
                  points.push(ctlPtx, ctlPty, p2.shift(), p2.shift());
                  cpx = p2.shift();
                  cpy = p2.shift();
                  cmd = "C";
                  points.push(cpx, cpy);
                  break;
                case "s":
                  ctlPtx = cpx;
                  ctlPty = cpy;
                  prevCmd = ca[ca.length - 1];
                  if (prevCmd.command === "C") {
                    ctlPtx = cpx + (cpx - prevCmd.points[2]);
                    ctlPty = cpy + (cpy - prevCmd.points[3]);
                  }
                  points.push(ctlPtx, ctlPty, cpx + p2.shift(), cpy + p2.shift());
                  cpx += p2.shift();
                  cpy += p2.shift();
                  cmd = "C";
                  points.push(cpx, cpy);
                  break;
                case "Q":
                  points.push(p2.shift(), p2.shift());
                  cpx = p2.shift();
                  cpy = p2.shift();
                  points.push(cpx, cpy);
                  break;
                case "q":
                  points.push(cpx + p2.shift(), cpy + p2.shift());
                  cpx += p2.shift();
                  cpy += p2.shift();
                  cmd = "Q";
                  points.push(cpx, cpy);
                  break;
                case "T":
                  ctlPtx = cpx;
                  ctlPty = cpy;
                  prevCmd = ca[ca.length - 1];
                  if (prevCmd.command === "Q") {
                    ctlPtx = cpx + (cpx - prevCmd.points[0]);
                    ctlPty = cpy + (cpy - prevCmd.points[1]);
                  }
                  cpx = p2.shift();
                  cpy = p2.shift();
                  cmd = "Q";
                  points.push(ctlPtx, ctlPty, cpx, cpy);
                  break;
                case "t":
                  ctlPtx = cpx;
                  ctlPty = cpy;
                  prevCmd = ca[ca.length - 1];
                  if (prevCmd.command === "Q") {
                    ctlPtx = cpx + (cpx - prevCmd.points[0]);
                    ctlPty = cpy + (cpy - prevCmd.points[1]);
                  }
                  cpx += p2.shift();
                  cpy += p2.shift();
                  cmd = "Q";
                  points.push(ctlPtx, ctlPty, cpx, cpy);
                  break;
                case "A":
                  rx = p2.shift();
                  ry = p2.shift();
                  psi = p2.shift();
                  fa = p2.shift();
                  fs = p2.shift();
                  x1 = cpx;
                  y1 = cpy;
                  cpx = p2.shift();
                  cpy = p2.shift();
                  cmd = "A";
                  points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                  break;
                case "a":
                  rx = p2.shift();
                  ry = p2.shift();
                  psi = p2.shift();
                  fa = p2.shift();
                  fs = p2.shift();
                  x1 = cpx;
                  y1 = cpy;
                  cpx += p2.shift();
                  cpy += p2.shift();
                  cmd = "A";
                  points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                  break;
              }
              ca.push({
                command: cmd || c,
                points,
                start: {
                  x: startX,
                  y: startY
                },
                pathLength: this.calcLength(startX, startY, cmd || c, points)
              });
            }
            if (c === "z" || c === "Z") {
              ca.push({
                command: "z",
                points: [],
                start: void 0,
                pathLength: 0
              });
            }
          }
          return ca;
        }
        static calcLength(x, y2, cmd, points) {
          let len, p1, p2, t;
          const path = _Path;
          switch (cmd) {
            case "L":
              return path.getLineLength(x, y2, points[0], points[1]);
            case "C":
              return getCubicArcLength([x, points[0], points[2], points[4]], [y2, points[1], points[3], points[5]], 1);
            case "Q":
              return getQuadraticArcLength([x, points[0], points[2]], [y2, points[1], points[3]], 1);
            case "A":
              len = 0;
              const start = points[4];
              const dTheta = points[5];
              const end = points[4] + dTheta;
              let inc = Math.PI / 180;
              if (Math.abs(start - end) < inc) {
                inc = Math.abs(start - end);
              }
              p1 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], start, 0);
              if (dTheta < 0) {
                for (t = start - inc; t > end; t -= inc) {
                  p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                  len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                  p1 = p2;
                }
              } else {
                for (t = start + inc; t < end; t += inc) {
                  p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                  len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                  p1 = p2;
                }
              }
              p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], end, 0);
              len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
              return len;
          }
          return 0;
        }
        static convertEndpointToCenterParameterization(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg) {
          const psi = psiDeg * (Math.PI / 180);
          const xp = Math.cos(psi) * (x1 - x2) / 2 + Math.sin(psi) * (y1 - y2) / 2;
          const yp = -1 * Math.sin(psi) * (x1 - x2) / 2 + Math.cos(psi) * (y1 - y2) / 2;
          const lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
          if (lambda > 1) {
            rx *= Math.sqrt(lambda);
            ry *= Math.sqrt(lambda);
          }
          let f = Math.sqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp)));
          if (fa === fs) {
            f *= -1;
          }
          if (isNaN(f)) {
            f = 0;
          }
          const cxp = f * rx * yp / ry;
          const cyp = f * -ry * xp / rx;
          const cx = (x1 + x2) / 2 + Math.cos(psi) * cxp - Math.sin(psi) * cyp;
          const cy = (y1 + y2) / 2 + Math.sin(psi) * cxp + Math.cos(psi) * cyp;
          const vMag = function(v2) {
            return Math.sqrt(v2[0] * v2[0] + v2[1] * v2[1]);
          };
          const vRatio = function(u3, v2) {
            return (u3[0] * v2[0] + u3[1] * v2[1]) / (vMag(u3) * vMag(v2));
          };
          const vAngle = function(u3, v2) {
            return (u3[0] * v2[1] < u3[1] * v2[0] ? -1 : 1) * Math.acos(vRatio(u3, v2));
          };
          const theta = vAngle([1, 0], [(xp - cxp) / rx, (yp - cyp) / ry]);
          const u2 = [(xp - cxp) / rx, (yp - cyp) / ry];
          const v = [(-1 * xp - cxp) / rx, (-1 * yp - cyp) / ry];
          let dTheta = vAngle(u2, v);
          if (vRatio(u2, v) <= -1) {
            dTheta = Math.PI;
          }
          if (vRatio(u2, v) >= 1) {
            dTheta = 0;
          }
          if (fs === 0 && dTheta > 0) {
            dTheta = dTheta - 2 * Math.PI;
          }
          if (fs === 1 && dTheta < 0) {
            dTheta = dTheta + 2 * Math.PI;
          }
          return [cx, cy, rx, ry, theta, dTheta, psi, fs];
        }
      };
      Path.prototype.className = "Path";
      Path.prototype._attrsAffectingSize = ["data"];
      _registerNode(Path);
      Factory.addGetterSetter(Path, "data");
    }
  });

  // node_modules/konva/lib/shapes/Arrow.js
  var Arrow;
  var init_Arrow = __esm({
    "node_modules/konva/lib/shapes/Arrow.js"() {
      init_Factory();
      init_Line();
      init_Validators();
      init_Global();
      init_Path();
      Arrow = class extends Line {
        _sceneFunc(ctx) {
          super._sceneFunc(ctx);
          const PI2 = Math.PI * 2;
          const points = this.points();
          let tp = points;
          const fromTension = this.tension() !== 0 && points.length > 4;
          if (fromTension) {
            tp = this.getTensionPoints();
          }
          const length = this.pointerLength();
          const n = points.length;
          let dx, dy;
          if (fromTension) {
            const lp = [
              tp[tp.length - 4],
              tp[tp.length - 3],
              tp[tp.length - 2],
              tp[tp.length - 1],
              points[n - 2],
              points[n - 1]
            ];
            const lastLength = Path.calcLength(tp[tp.length - 4], tp[tp.length - 3], "C", lp);
            const previous = Path.getPointOnQuadraticBezier(Math.min(1, 1 - length / lastLength), lp[0], lp[1], lp[2], lp[3], lp[4], lp[5]);
            dx = points[n - 2] - previous.x;
            dy = points[n - 1] - previous.y;
          } else {
            dx = points[n - 2] - points[n - 4];
            dy = points[n - 1] - points[n - 3];
          }
          const radians = (Math.atan2(dy, dx) + PI2) % PI2;
          const width = this.pointerWidth();
          if (this.pointerAtEnding()) {
            ctx.save();
            ctx.beginPath();
            ctx.translate(points[n - 2], points[n - 1]);
            ctx.rotate(radians);
            ctx.moveTo(0, 0);
            ctx.lineTo(-length, width / 2);
            ctx.lineTo(-length, -width / 2);
            ctx.closePath();
            ctx.restore();
            this.__fillStroke(ctx);
          }
          if (this.pointerAtBeginning()) {
            ctx.save();
            ctx.beginPath();
            ctx.translate(points[0], points[1]);
            if (fromTension) {
              dx = (tp[0] + tp[2]) / 2 - points[0];
              dy = (tp[1] + tp[3]) / 2 - points[1];
            } else {
              dx = points[2] - points[0];
              dy = points[3] - points[1];
            }
            ctx.rotate((Math.atan2(-dy, -dx) + PI2) % PI2);
            ctx.moveTo(0, 0);
            ctx.lineTo(-length, width / 2);
            ctx.lineTo(-length, -width / 2);
            ctx.closePath();
            ctx.restore();
            this.__fillStroke(ctx);
          }
        }
        __fillStroke(ctx) {
          const isDashEnabled = this.dashEnabled();
          if (isDashEnabled) {
            this.attrs.dashEnabled = false;
            ctx.setLineDash([]);
          }
          ctx.fillStrokeShape(this);
          if (isDashEnabled) {
            this.attrs.dashEnabled = true;
          }
        }
        getSelfRect() {
          const lineRect = super.getSelfRect();
          const offset = this.pointerWidth() / 2;
          return {
            x: lineRect.x,
            y: lineRect.y - offset,
            width: lineRect.width,
            height: lineRect.height + offset * 2
          };
        }
      };
      Arrow.prototype.className = "Arrow";
      _registerNode(Arrow);
      Factory.addGetterSetter(Arrow, "pointerLength", 10, getNumberValidator());
      Factory.addGetterSetter(Arrow, "pointerWidth", 10, getNumberValidator());
      Factory.addGetterSetter(Arrow, "pointerAtBeginning", false);
      Factory.addGetterSetter(Arrow, "pointerAtEnding", true);
    }
  });

  // node_modules/konva/lib/shapes/Circle.js
  var Circle;
  var init_Circle = __esm({
    "node_modules/konva/lib/shapes/Circle.js"() {
      init_Factory();
      init_Shape();
      init_Validators();
      init_Global();
      Circle = class extends Shape {
        _sceneFunc(context) {
          context.beginPath();
          context.arc(0, 0, this.attrs.radius || 0, 0, Math.PI * 2, false);
          context.closePath();
          context.fillStrokeShape(this);
        }
        getWidth() {
          return this.radius() * 2;
        }
        getHeight() {
          return this.radius() * 2;
        }
        setWidth(width) {
          if (this.radius() !== width / 2) {
            this.radius(width / 2);
          }
        }
        setHeight(height) {
          if (this.radius() !== height / 2) {
            this.radius(height / 2);
          }
        }
      };
      Circle.prototype._centroid = true;
      Circle.prototype.className = "Circle";
      Circle.prototype._attrsAffectingSize = ["radius"];
      _registerNode(Circle);
      Factory.addGetterSetter(Circle, "radius", 0, getNumberValidator());
    }
  });

  // node_modules/konva/lib/shapes/Ellipse.js
  var Ellipse;
  var init_Ellipse = __esm({
    "node_modules/konva/lib/shapes/Ellipse.js"() {
      init_Factory();
      init_Shape();
      init_Validators();
      init_Global();
      Ellipse = class extends Shape {
        _sceneFunc(context) {
          const rx = this.radiusX(), ry = this.radiusY();
          context.beginPath();
          context.save();
          if (rx !== ry) {
            context.scale(1, ry / rx);
          }
          context.arc(0, 0, rx, 0, Math.PI * 2, false);
          context.restore();
          context.closePath();
          context.fillStrokeShape(this);
        }
        getWidth() {
          return this.radiusX() * 2;
        }
        getHeight() {
          return this.radiusY() * 2;
        }
        setWidth(width) {
          this.radiusX(width / 2);
        }
        setHeight(height) {
          this.radiusY(height / 2);
        }
      };
      Ellipse.prototype.className = "Ellipse";
      Ellipse.prototype._centroid = true;
      Ellipse.prototype._attrsAffectingSize = ["radiusX", "radiusY"];
      _registerNode(Ellipse);
      Factory.addComponentsGetterSetter(Ellipse, "radius", ["x", "y"]);
      Factory.addGetterSetter(Ellipse, "radiusX", 0, getNumberValidator());
      Factory.addGetterSetter(Ellipse, "radiusY", 0, getNumberValidator());
    }
  });

  // node_modules/konva/lib/shapes/Image.js
  var Image2;
  var init_Image = __esm({
    "node_modules/konva/lib/shapes/Image.js"() {
      init_Util();
      init_Factory();
      init_Shape();
      init_Global();
      init_Validators();
      Image2 = class _Image extends Shape {
        constructor(attrs) {
          super(attrs);
          this._loadListener = () => {
            this._requestDraw();
          };
          this.on("imageChange.konva", (props) => {
            this._removeImageLoad(props.oldVal);
            this._setImageLoad();
          });
          this._setImageLoad();
        }
        _setImageLoad() {
          const image = this.image();
          if (image && image.complete) {
            return;
          }
          if (image && image.readyState === 4) {
            return;
          }
          if (image && image["addEventListener"]) {
            image["addEventListener"]("load", this._loadListener);
          }
        }
        _removeImageLoad(image) {
          if (image && image["removeEventListener"]) {
            image["removeEventListener"]("load", this._loadListener);
          }
        }
        destroy() {
          this._removeImageLoad(this.image());
          super.destroy();
          return this;
        }
        _useBufferCanvas() {
          const hasCornerRadius = !!this.cornerRadius();
          const hasShadow = this.hasShadow();
          if (hasCornerRadius && hasShadow) {
            return true;
          }
          return super._useBufferCanvas(true);
        }
        _sceneFunc(context) {
          const width = this.getWidth();
          const height = this.getHeight();
          const cornerRadius = this.cornerRadius();
          const image = this.attrs.image;
          let params;
          if (image) {
            const cropWidth = this.attrs.cropWidth;
            const cropHeight = this.attrs.cropHeight;
            if (cropWidth && cropHeight) {
              params = [
                image,
                this.cropX(),
                this.cropY(),
                cropWidth,
                cropHeight,
                0,
                0,
                width,
                height
              ];
            } else {
              params = [image, 0, 0, width, height];
            }
          }
          if (this.hasFill() || this.hasStroke() || cornerRadius) {
            context.beginPath();
            cornerRadius ? Util.drawRoundedRectPath(context, width, height, cornerRadius) : context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
          }
          if (image) {
            if (cornerRadius) {
              context.clip();
            }
            context.drawImage.apply(context, params);
          }
        }
        _hitFunc(context) {
          const width = this.width(), height = this.height(), cornerRadius = this.cornerRadius();
          context.beginPath();
          if (!cornerRadius) {
            context.rect(0, 0, width, height);
          } else {
            Util.drawRoundedRectPath(context, width, height, cornerRadius);
          }
          context.closePath();
          context.fillStrokeShape(this);
        }
        getWidth() {
          var _a, _b, _c;
          return (_c = (_a = this.attrs.width) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.width) !== null && _c !== void 0 ? _c : 0;
        }
        getHeight() {
          var _a, _b, _c;
          return (_c = (_a = this.attrs.height) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.height) !== null && _c !== void 0 ? _c : 0;
        }
        static fromURL(url, callback, onError = null) {
          const img = Util.createImageElement();
          img.onload = function() {
            const image = new _Image({
              image: img
            });
            callback(image);
          };
          img.onerror = onError;
          img.crossOrigin = "Anonymous";
          img.src = url;
        }
      };
      Image2.prototype.className = "Image";
      Image2.prototype._attrsAffectingSize = ["image"];
      _registerNode(Image2);
      Factory.addGetterSetter(Image2, "cornerRadius", 0, getNumberOrArrayOfNumbersValidator(4));
      Factory.addGetterSetter(Image2, "image");
      Factory.addComponentsGetterSetter(Image2, "crop", ["x", "y", "width", "height"]);
      Factory.addGetterSetter(Image2, "cropX", 0, getNumberValidator());
      Factory.addGetterSetter(Image2, "cropY", 0, getNumberValidator());
      Factory.addGetterSetter(Image2, "cropWidth", 0, getNumberValidator());
      Factory.addGetterSetter(Image2, "cropHeight", 0, getNumberValidator());
    }
  });

  // node_modules/konva/lib/shapes/Label.js
  var ATTR_CHANGE_LIST, CHANGE_KONVA, NONE, UP, RIGHT, DOWN, LEFT, attrChangeListLen, Label, Tag;
  var init_Label = __esm({
    "node_modules/konva/lib/shapes/Label.js"() {
      init_Factory();
      init_Shape();
      init_Group();
      init_Validators();
      init_Global();
      ATTR_CHANGE_LIST = [
        "fontFamily",
        "fontSize",
        "fontStyle",
        "padding",
        "lineHeight",
        "text",
        "width",
        "height",
        "pointerDirection",
        "pointerWidth",
        "pointerHeight"
      ];
      CHANGE_KONVA = "Change.konva";
      NONE = "none";
      UP = "up";
      RIGHT = "right";
      DOWN = "down";
      LEFT = "left";
      attrChangeListLen = ATTR_CHANGE_LIST.length;
      Label = class extends Group {
        constructor(config) {
          super(config);
          this.on("add.konva", function(evt) {
            this._addListeners(evt.child);
            this._sync();
          });
        }
        getText() {
          return this.find("Text")[0];
        }
        getTag() {
          return this.find("Tag")[0];
        }
        _addListeners(text) {
          let that = this, n;
          const func = function() {
            that._sync();
          };
          for (n = 0; n < attrChangeListLen; n++) {
            text.on(ATTR_CHANGE_LIST[n] + CHANGE_KONVA, func);
          }
        }
        getWidth() {
          return this.getText().width();
        }
        getHeight() {
          return this.getText().height();
        }
        _sync() {
          let text = this.getText(), tag = this.getTag(), width, height, pointerDirection, pointerWidth, x, y2, pointerHeight;
          if (text && tag) {
            width = text.width();
            height = text.height();
            pointerDirection = tag.pointerDirection();
            pointerWidth = tag.pointerWidth();
            pointerHeight = tag.pointerHeight();
            x = 0;
            y2 = 0;
            switch (pointerDirection) {
              case UP:
                x = width / 2;
                y2 = -1 * pointerHeight;
                break;
              case RIGHT:
                x = width + pointerWidth;
                y2 = height / 2;
                break;
              case DOWN:
                x = width / 2;
                y2 = height + pointerHeight;
                break;
              case LEFT:
                x = -1 * pointerWidth;
                y2 = height / 2;
                break;
            }
            tag.setAttrs({
              x: -1 * x,
              y: -1 * y2,
              width,
              height
            });
            text.setAttrs({
              x: -1 * x,
              y: -1 * y2
            });
          }
        }
      };
      Label.prototype.className = "Label";
      _registerNode(Label);
      Tag = class extends Shape {
        _sceneFunc(context) {
          const width = this.width(), height = this.height(), pointerDirection = this.pointerDirection(), pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), cornerRadius = this.cornerRadius();
          let topLeft = 0;
          let topRight = 0;
          let bottomLeft = 0;
          let bottomRight = 0;
          if (typeof cornerRadius === "number") {
            topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
          } else {
            topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
            topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
            bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
            bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
          }
          context.beginPath();
          context.moveTo(topLeft, 0);
          if (pointerDirection === UP) {
            context.lineTo((width - pointerWidth) / 2, 0);
            context.lineTo(width / 2, -1 * pointerHeight);
            context.lineTo((width + pointerWidth) / 2, 0);
          }
          context.lineTo(width - topRight, 0);
          context.arc(width - topRight, topRight, topRight, Math.PI * 3 / 2, 0, false);
          if (pointerDirection === RIGHT) {
            context.lineTo(width, (height - pointerHeight) / 2);
            context.lineTo(width + pointerWidth, height / 2);
            context.lineTo(width, (height + pointerHeight) / 2);
          }
          context.lineTo(width, height - bottomRight);
          context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
          if (pointerDirection === DOWN) {
            context.lineTo((width + pointerWidth) / 2, height);
            context.lineTo(width / 2, height + pointerHeight);
            context.lineTo((width - pointerWidth) / 2, height);
          }
          context.lineTo(bottomLeft, height);
          context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
          if (pointerDirection === LEFT) {
            context.lineTo(0, (height + pointerHeight) / 2);
            context.lineTo(-1 * pointerWidth, height / 2);
            context.lineTo(0, (height - pointerHeight) / 2);
          }
          context.lineTo(0, topLeft);
          context.arc(topLeft, topLeft, topLeft, Math.PI, Math.PI * 3 / 2, false);
          context.closePath();
          context.fillStrokeShape(this);
        }
        getSelfRect() {
          let x = 0, y2 = 0, pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), direction = this.pointerDirection(), width = this.width(), height = this.height();
          if (direction === UP) {
            y2 -= pointerHeight;
            height += pointerHeight;
          } else if (direction === DOWN) {
            height += pointerHeight;
          } else if (direction === LEFT) {
            x -= pointerWidth * 1.5;
            width += pointerWidth;
          } else if (direction === RIGHT) {
            width += pointerWidth * 1.5;
          }
          return {
            x,
            y: y2,
            width,
            height
          };
        }
      };
      Tag.prototype.className = "Tag";
      _registerNode(Tag);
      Factory.addGetterSetter(Tag, "pointerDirection", NONE);
      Factory.addGetterSetter(Tag, "pointerWidth", 0, getNumberValidator());
      Factory.addGetterSetter(Tag, "pointerHeight", 0, getNumberValidator());
      Factory.addGetterSetter(Tag, "cornerRadius", 0, getNumberOrArrayOfNumbersValidator(4));
    }
  });

  // node_modules/konva/lib/shapes/Rect.js
  var Rect;
  var init_Rect = __esm({
    "node_modules/konva/lib/shapes/Rect.js"() {
      init_Factory();
      init_Shape();
      init_Global();
      init_Util();
      init_Validators();
      Rect = class extends Shape {
        _sceneFunc(context) {
          const cornerRadius = this.cornerRadius(), width = this.width(), height = this.height();
          context.beginPath();
          if (!cornerRadius) {
            context.rect(0, 0, width, height);
          } else {
            Util.drawRoundedRectPath(context, width, height, cornerRadius);
          }
          context.closePath();
          context.fillStrokeShape(this);
        }
      };
      Rect.prototype.className = "Rect";
      _registerNode(Rect);
      Factory.addGetterSetter(Rect, "cornerRadius", 0, getNumberOrArrayOfNumbersValidator(4));
    }
  });

  // node_modules/konva/lib/shapes/RegularPolygon.js
  var RegularPolygon;
  var init_RegularPolygon = __esm({
    "node_modules/konva/lib/shapes/RegularPolygon.js"() {
      init_Factory();
      init_Shape();
      init_Validators();
      init_Global();
      init_Util();
      RegularPolygon = class extends Shape {
        _sceneFunc(context) {
          const points = this._getPoints(), radius = this.radius(), sides = this.sides(), cornerRadius = this.cornerRadius();
          context.beginPath();
          if (!cornerRadius) {
            context.moveTo(points[0].x, points[0].y);
            for (let n = 1; n < points.length; n++) {
              context.lineTo(points[n].x, points[n].y);
            }
          } else {
            Util.drawRoundedPolygonPath(context, points, sides, radius, cornerRadius);
          }
          context.closePath();
          context.fillStrokeShape(this);
        }
        _getPoints() {
          const sides = this.attrs.sides;
          const radius = this.attrs.radius || 0;
          const points = [];
          for (let n = 0; n < sides; n++) {
            points.push({
              x: radius * Math.sin(n * 2 * Math.PI / sides),
              y: -1 * radius * Math.cos(n * 2 * Math.PI / sides)
            });
          }
          return points;
        }
        getSelfRect() {
          const points = this._getPoints();
          let minX = points[0].x;
          let maxX = points[0].x;
          let minY = points[0].y;
          let maxY = points[0].y;
          points.forEach((point) => {
            minX = Math.min(minX, point.x);
            maxX = Math.max(maxX, point.x);
            minY = Math.min(minY, point.y);
            maxY = Math.max(maxY, point.y);
          });
          return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
          };
        }
        getWidth() {
          return this.radius() * 2;
        }
        getHeight() {
          return this.radius() * 2;
        }
        setWidth(width) {
          this.radius(width / 2);
        }
        setHeight(height) {
          this.radius(height / 2);
        }
      };
      RegularPolygon.prototype.className = "RegularPolygon";
      RegularPolygon.prototype._centroid = true;
      RegularPolygon.prototype._attrsAffectingSize = ["radius"];
      _registerNode(RegularPolygon);
      Factory.addGetterSetter(RegularPolygon, "radius", 0, getNumberValidator());
      Factory.addGetterSetter(RegularPolygon, "sides", 0, getNumberValidator());
      Factory.addGetterSetter(RegularPolygon, "cornerRadius", 0, getNumberOrArrayOfNumbersValidator(4));
    }
  });

  // node_modules/konva/lib/shapes/Ring.js
  var PIx2, Ring;
  var init_Ring = __esm({
    "node_modules/konva/lib/shapes/Ring.js"() {
      init_Factory();
      init_Shape();
      init_Validators();
      init_Global();
      PIx2 = Math.PI * 2;
      Ring = class extends Shape {
        _sceneFunc(context) {
          context.beginPath();
          context.arc(0, 0, this.innerRadius(), 0, PIx2, false);
          context.moveTo(this.outerRadius(), 0);
          context.arc(0, 0, this.outerRadius(), PIx2, 0, true);
          context.closePath();
          context.fillStrokeShape(this);
        }
        getWidth() {
          return this.outerRadius() * 2;
        }
        getHeight() {
          return this.outerRadius() * 2;
        }
        setWidth(width) {
          this.outerRadius(width / 2);
        }
        setHeight(height) {
          this.outerRadius(height / 2);
        }
      };
      Ring.prototype.className = "Ring";
      Ring.prototype._centroid = true;
      Ring.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"];
      _registerNode(Ring);
      Factory.addGetterSetter(Ring, "innerRadius", 0, getNumberValidator());
      Factory.addGetterSetter(Ring, "outerRadius", 0, getNumberValidator());
    }
  });

  // node_modules/konva/lib/shapes/Sprite.js
  var Sprite;
  var init_Sprite = __esm({
    "node_modules/konva/lib/shapes/Sprite.js"() {
      init_Factory();
      init_Shape();
      init_Animation();
      init_Validators();
      init_Global();
      Sprite = class extends Shape {
        constructor(config) {
          super(config);
          this._updated = true;
          this.anim = new Animation(() => {
            const updated = this._updated;
            this._updated = false;
            return updated;
          });
          this.on("animationChange.konva", function() {
            this.frameIndex(0);
          });
          this.on("frameIndexChange.konva", function() {
            this._updated = true;
          });
          this.on("frameRateChange.konva", function() {
            if (!this.anim.isRunning()) {
              return;
            }
            clearInterval(this.interval);
            this._setInterval();
          });
        }
        _sceneFunc(context) {
          const anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), x = set[ix4 + 0], y2 = set[ix4 + 1], width = set[ix4 + 2], height = set[ix4 + 3], image = this.image();
          if (this.hasFill() || this.hasStroke()) {
            context.beginPath();
            context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
          }
          if (image) {
            if (offsets) {
              const offset = offsets[anim], ix2 = index * 2;
              context.drawImage(image, x, y2, width, height, offset[ix2 + 0], offset[ix2 + 1], width, height);
            } else {
              context.drawImage(image, x, y2, width, height, 0, 0, width, height);
            }
          }
        }
        _hitFunc(context) {
          const anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), width = set[ix4 + 2], height = set[ix4 + 3];
          context.beginPath();
          if (offsets) {
            const offset = offsets[anim];
            const ix2 = index * 2;
            context.rect(offset[ix2 + 0], offset[ix2 + 1], width, height);
          } else {
            context.rect(0, 0, width, height);
          }
          context.closePath();
          context.fillShape(this);
        }
        _useBufferCanvas() {
          return super._useBufferCanvas(true);
        }
        _setInterval() {
          const that = this;
          this.interval = setInterval(function() {
            that._updateIndex();
          }, 1e3 / this.frameRate());
        }
        start() {
          if (this.isRunning()) {
            return;
          }
          const layer = this.getLayer();
          this.anim.setLayers(layer);
          this._setInterval();
          this.anim.start();
        }
        stop() {
          this.anim.stop();
          clearInterval(this.interval);
        }
        isRunning() {
          return this.anim.isRunning();
        }
        _updateIndex() {
          const index = this.frameIndex(), animation = this.animation(), animations = this.animations(), anim = animations[animation], len = anim.length / 4;
          if (index < len - 1) {
            this.frameIndex(index + 1);
          } else {
            this.frameIndex(0);
          }
        }
      };
      Sprite.prototype.className = "Sprite";
      _registerNode(Sprite);
      Factory.addGetterSetter(Sprite, "animation");
      Factory.addGetterSetter(Sprite, "animations");
      Factory.addGetterSetter(Sprite, "frameOffsets");
      Factory.addGetterSetter(Sprite, "image");
      Factory.addGetterSetter(Sprite, "frameIndex", 0, getNumberValidator());
      Factory.addGetterSetter(Sprite, "frameRate", 17, getNumberValidator());
      Factory.backCompat(Sprite, {
        index: "frameIndex",
        getIndex: "getFrameIndex",
        setIndex: "setFrameIndex"
      });
    }
  });

  // node_modules/konva/lib/shapes/Star.js
  var Star;
  var init_Star = __esm({
    "node_modules/konva/lib/shapes/Star.js"() {
      init_Factory();
      init_Shape();
      init_Validators();
      init_Global();
      Star = class extends Shape {
        _sceneFunc(context) {
          const innerRadius = this.innerRadius(), outerRadius = this.outerRadius(), numPoints = this.numPoints();
          context.beginPath();
          context.moveTo(0, 0 - outerRadius);
          for (let n = 1; n < numPoints * 2; n++) {
            const radius = n % 2 === 0 ? outerRadius : innerRadius;
            const x = radius * Math.sin(n * Math.PI / numPoints);
            const y2 = -1 * radius * Math.cos(n * Math.PI / numPoints);
            context.lineTo(x, y2);
          }
          context.closePath();
          context.fillStrokeShape(this);
        }
        getWidth() {
          return this.outerRadius() * 2;
        }
        getHeight() {
          return this.outerRadius() * 2;
        }
        setWidth(width) {
          this.outerRadius(width / 2);
        }
        setHeight(height) {
          this.outerRadius(height / 2);
        }
      };
      Star.prototype.className = "Star";
      Star.prototype._centroid = true;
      Star.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"];
      _registerNode(Star);
      Factory.addGetterSetter(Star, "numPoints", 5, getNumberValidator());
      Factory.addGetterSetter(Star, "innerRadius", 0, getNumberValidator());
      Factory.addGetterSetter(Star, "outerRadius", 0, getNumberValidator());
    }
  });

  // node_modules/konva/lib/shapes/Text.js
  function stringToArray(string) {
    return [...string].reduce((acc, char, index, array) => {
      if (/\p{Emoji}/u.test(char)) {
        const nextChar = array[index + 1];
        if (nextChar && /\p{Emoji_Modifier}|\u200D/u.test(nextChar)) {
          acc.push(char + nextChar);
          array[index + 1] = "";
        } else {
          acc.push(char);
        }
      } else if (/\p{Regional_Indicator}{2}/u.test(char + (array[index + 1] || ""))) {
        acc.push(char + array[index + 1]);
      } else if (index > 0 && /\p{Mn}|\p{Me}|\p{Mc}/u.test(char)) {
        acc[acc.length - 1] += char;
      } else if (char) {
        acc.push(char);
      }
      return acc;
    }, []);
  }
  function hasShadowOpacityBug() {
    if (_shadowOpacityBuggy !== null) {
      return _shadowOpacityBuggy;
    }
    _shadowOpacityBuggy = false;
    try {
      const c = document.createElement("canvas");
      c.width = 10;
      c.height = 10;
      const ctx = c.getContext(CONTEXT_2D);
      if (ctx) {
        ctx.globalAlpha = 0;
        ctx.shadowColor = "black";
        ctx.shadowBlur = 5;
        ctx.shadowOffsetX = 5;
        ctx.shadowOffsetY = 5;
        ctx.fillStyle = "black";
        ctx.font = "10px Arial";
        ctx.fillText("X", 0, 10);
        const data = ctx.getImageData(0, 0, 10, 10).data;
        for (let i2 = 3; i2 < data.length; i2 += 4) {
          if (data[i2] > 0) {
            _shadowOpacityBuggy = true;
            break;
          }
        }
      }
    } catch (e) {
    }
    return _shadowOpacityBuggy;
  }
  function normalizeFontFamily(fontFamily) {
    return fontFamily.split(",").map((family) => {
      family = family.trim();
      const hasSpace = family.indexOf(" ") >= 0;
      const hasQuotes = family.indexOf('"') >= 0 || family.indexOf("'") >= 0;
      if (hasSpace && !hasQuotes) {
        family = `"${family}"`;
      }
      return family;
    }).join(", ");
  }
  function getDummyContext2() {
    if (dummyContext2) {
      return dummyContext2;
    }
    dummyContext2 = Util.createCanvasElement().getContext(CONTEXT_2D);
    return dummyContext2;
  }
  function _fillFunc2(context) {
    context.fillText(this._partialText, this._partialTextX, this._partialTextY);
  }
  function _strokeFunc2(context) {
    context.setAttr("miterLimit", 2);
    context.strokeText(this._partialText, this._partialTextX, this._partialTextY);
  }
  function checkDefaultFill(config) {
    config = config || {};
    if (!config.fillLinearGradientColorStops && !config.fillRadialGradientColorStops && !config.fillPatternImage) {
      config.fill = config.fill || "black";
    }
    return config;
  }
  var AUTO, CENTER, INHERIT, JUSTIFY, CHANGE_KONVA2, CONTEXT_2D, DASH, LEFT2, TEXT, TEXT_UPPER, TOP, BOTTOM, MIDDLE, NORMAL, PX_SPACE, SPACE2, RIGHT2, RTL, WORD, CHAR, NONE2, ELLIPSIS, ATTR_CHANGE_LIST2, attrChangeListLen2, _shadowOpacityBuggy, dummyContext2, Text2;
  var init_Text = __esm({
    "node_modules/konva/lib/shapes/Text.js"() {
      init_Util();
      init_Factory();
      init_Shape();
      init_Global();
      init_Validators();
      init_Global();
      AUTO = "auto";
      CENTER = "center";
      INHERIT = "inherit";
      JUSTIFY = "justify";
      CHANGE_KONVA2 = "Change.konva";
      CONTEXT_2D = "2d";
      DASH = "-";
      LEFT2 = "left";
      TEXT = "text";
      TEXT_UPPER = "Text";
      TOP = "top";
      BOTTOM = "bottom";
      MIDDLE = "middle";
      NORMAL = "normal";
      PX_SPACE = "px ";
      SPACE2 = " ";
      RIGHT2 = "right";
      RTL = "rtl";
      WORD = "word";
      CHAR = "char";
      NONE2 = "none";
      ELLIPSIS = "\u2026";
      ATTR_CHANGE_LIST2 = [
        "direction",
        "fontFamily",
        "fontSize",
        "fontStyle",
        "fontVariant",
        "padding",
        "align",
        "verticalAlign",
        "lineHeight",
        "text",
        "width",
        "height",
        "wrap",
        "ellipsis",
        "letterSpacing"
      ];
      attrChangeListLen2 = ATTR_CHANGE_LIST2.length;
      _shadowOpacityBuggy = null;
      Text2 = class extends Shape {
        constructor(config) {
          super(checkDefaultFill(config));
          this._partialTextX = 0;
          this._partialTextY = 0;
          for (let n = 0; n < attrChangeListLen2; n++) {
            this.on(ATTR_CHANGE_LIST2[n] + CHANGE_KONVA2, this._setTextData);
          }
          this._setTextData();
        }
        _sceneFunc(context) {
          var _a, _b;
          const textArr = this.textArr, textArrLen = textArr.length;
          if (!this.text()) {
            return;
          }
          let padding = this.padding(), fontSize = this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, verticalAlign = this.verticalAlign(), direction = this.direction(), alignY = 0, align = this.align(), totalWidth = this.getWidth(), letterSpacing = this.letterSpacing(), charRenderFunc = this.charRenderFunc(), fill = this.fill(), textDecoration = this.textDecoration(), underlineOffset = this.underlineOffset(), shouldUnderline = textDecoration.indexOf("underline") !== -1, shouldLineThrough = textDecoration.indexOf("line-through") !== -1, n;
          direction = direction === INHERIT ? context.direction : direction;
          let translateY = lineHeightPx / 2;
          let baseline = MIDDLE;
          if (!Konva.legacyTextRendering) {
            const metrics = this.measureSize("M");
            baseline = "alphabetic";
            const ascent = (_a = metrics.fontBoundingBoxAscent) !== null && _a !== void 0 ? _a : metrics.actualBoundingBoxAscent;
            const descent = (_b = metrics.fontBoundingBoxDescent) !== null && _b !== void 0 ? _b : metrics.actualBoundingBoxDescent;
            translateY = (ascent - descent) / 2 + lineHeightPx / 2;
          }
          if (direction === RTL) {
            context.setAttr("direction", direction);
          }
          context.setAttr("font", this._getContextFont());
          context.setAttr("textBaseline", baseline);
          context.setAttr("textAlign", LEFT2);
          if (verticalAlign === MIDDLE) {
            alignY = (this.getHeight() - textArrLen * lineHeightPx - padding * 2) / 2;
          } else if (verticalAlign === BOTTOM) {
            alignY = this.getHeight() - textArrLen * lineHeightPx - padding * 2;
          }
          context.translate(padding, alignY + padding);
          for (n = 0; n < textArrLen; n++) {
            let lineTranslateX = 0;
            let lineTranslateY = 0;
            const obj = textArr[n], text = obj.text, width = obj.width, lastLine = obj.lastInParagraph;
            context.save();
            if (align === RIGHT2) {
              lineTranslateX += totalWidth - width - padding * 2;
            } else if (align === CENTER) {
              lineTranslateX += (totalWidth - width - padding * 2) / 2;
            }
            if (shouldUnderline) {
              context.save();
              context.beginPath();
              const yOffset = underlineOffset !== null && underlineOffset !== void 0 ? underlineOffset : !Konva.legacyTextRendering ? Math.round(fontSize / 4) : Math.round(fontSize / 2);
              const x = lineTranslateX;
              const y2 = translateY + lineTranslateY + yOffset;
              context.moveTo(x, y2);
              const lineWidth = align === JUSTIFY && !lastLine ? totalWidth - padding * 2 : width;
              context.lineTo(x + Math.round(lineWidth), y2);
              context.lineWidth = fontSize / 15;
              const gradient = this._getLinearGradient();
              context.strokeStyle = gradient || fill;
              context.stroke();
              context.restore();
            }
            const lineThroughStartX = lineTranslateX;
            if (direction !== RTL && (letterSpacing !== 0 || align === JUSTIFY || charRenderFunc)) {
              const spacesNumber = text.split(" ").length - 1;
              const array = stringToArray(text);
              for (let li = 0; li < array.length; li++) {
                const letter = array[li];
                if (letter === " " && !lastLine && align === JUSTIFY) {
                  lineTranslateX += (totalWidth - padding * 2 - width) / spacesNumber;
                }
                this._partialTextX = lineTranslateX;
                this._partialTextY = translateY + lineTranslateY;
                this._partialText = letter;
                if (charRenderFunc) {
                  context.save();
                  const previousLines = textArr.slice(0, n);
                  const previousGraphemes = previousLines.reduce((acc, line) => acc + stringToArray(line.text).length, 0);
                  const charIndex = li + previousGraphemes;
                  charRenderFunc({
                    char: letter,
                    index: charIndex,
                    x: lineTranslateX,
                    y: translateY + lineTranslateY,
                    lineIndex: n,
                    column: li,
                    isLastInLine: lastLine,
                    width: this.measureSize(letter).width,
                    context
                  });
                }
                context.fillStrokeShape(this);
                if (charRenderFunc) {
                  context.restore();
                }
                lineTranslateX += this.measureSize(letter).width + letterSpacing;
              }
            } else {
              if (letterSpacing !== 0) {
                context.setAttr("letterSpacing", `${letterSpacing}px`);
              }
              this._partialTextX = lineTranslateX;
              this._partialTextY = translateY + lineTranslateY;
              this._partialText = text;
              context.fillStrokeShape(this);
            }
            if (shouldLineThrough) {
              context.save();
              context.beginPath();
              const yOffset = !Konva.legacyTextRendering ? -Math.round(fontSize / 4) : 0;
              const x = lineThroughStartX;
              context.moveTo(x, translateY + lineTranslateY + yOffset);
              const lineWidth = align === JUSTIFY && !lastLine ? totalWidth - padding * 2 : width;
              context.lineTo(x + Math.round(lineWidth), translateY + lineTranslateY + yOffset);
              context.lineWidth = fontSize / 15;
              const gradient = this._getLinearGradient();
              context.strokeStyle = gradient || fill;
              context.stroke();
              context.restore();
            }
            context.restore();
            if (textArrLen > 1) {
              translateY += lineHeightPx;
            }
          }
        }
        _hitFunc(context) {
          const width = this.getWidth(), height = this.getHeight();
          context.beginPath();
          context.rect(0, 0, width, height);
          context.closePath();
          context.fillStrokeShape(this);
        }
        setText(text) {
          const str = Util._isString(text) ? text : text === null || text === void 0 ? "" : text + "";
          this._setAttr(TEXT, str);
          return this;
        }
        getWidth() {
          const isAuto = this.attrs.width === AUTO || this.attrs.width === void 0;
          return isAuto ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
        }
        getHeight() {
          const isAuto = this.attrs.height === AUTO || this.attrs.height === void 0;
          return isAuto ? this.fontSize() * this.textArr.length * this.lineHeight() + this.padding() * 2 : this.attrs.height;
        }
        getTextWidth() {
          return this.textWidth;
        }
        getTextHeight() {
          Util.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.");
          return this.textHeight;
        }
        measureSize(text) {
          var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
          let _context = getDummyContext2(), fontSize = this.fontSize(), metrics;
          _context.save();
          _context.font = this._getContextFont();
          metrics = _context.measureText(text);
          _context.restore();
          const scaleFactor = fontSize / 100;
          return {
            actualBoundingBoxAscent: (_a = metrics.actualBoundingBoxAscent) !== null && _a !== void 0 ? _a : 71.58203125 * scaleFactor,
            actualBoundingBoxDescent: (_b = metrics.actualBoundingBoxDescent) !== null && _b !== void 0 ? _b : 0,
            actualBoundingBoxLeft: (_c = metrics.actualBoundingBoxLeft) !== null && _c !== void 0 ? _c : -7.421875 * scaleFactor,
            actualBoundingBoxRight: (_d = metrics.actualBoundingBoxRight) !== null && _d !== void 0 ? _d : 75.732421875 * scaleFactor,
            alphabeticBaseline: (_e = metrics.alphabeticBaseline) !== null && _e !== void 0 ? _e : 0,
            emHeightAscent: (_f = metrics.emHeightAscent) !== null && _f !== void 0 ? _f : 100 * scaleFactor,
            emHeightDescent: (_g = metrics.emHeightDescent) !== null && _g !== void 0 ? _g : -20 * scaleFactor,
            fontBoundingBoxAscent: (_h = metrics.fontBoundingBoxAscent) !== null && _h !== void 0 ? _h : 91 * scaleFactor,
            fontBoundingBoxDescent: (_j = metrics.fontBoundingBoxDescent) !== null && _j !== void 0 ? _j : 21 * scaleFactor,
            hangingBaseline: (_k = metrics.hangingBaseline) !== null && _k !== void 0 ? _k : 72.80000305175781 * scaleFactor,
            ideographicBaseline: (_l = metrics.ideographicBaseline) !== null && _l !== void 0 ? _l : -21 * scaleFactor,
            width: metrics.width,
            height: fontSize
          };
        }
        _getContextFont() {
          return this.fontStyle() + SPACE2 + this.fontVariant() + SPACE2 + (this.fontSize() + PX_SPACE) + normalizeFontFamily(this.fontFamily());
        }
        _addTextLine(line) {
          const align = this.align();
          if (align === JUSTIFY) {
            line = line.trim();
          }
          const width = this._getTextWidth(line);
          return this.textArr.push({
            text: line,
            width,
            lastInParagraph: false
          });
        }
        _getTextWidth(text) {
          const letterSpacing = this.letterSpacing();
          const length = text.length;
          return getDummyContext2().measureText(text).width + letterSpacing * length;
        }
        _setTextData() {
          let lines = this.text().split("\n"), fontSize = +this.fontSize(), textWidth = 0, lineHeightPx = this.lineHeight() * fontSize, width = this.attrs.width, height = this.attrs.height, fixedWidth = width !== AUTO && width !== void 0, fixedHeight = height !== AUTO && height !== void 0, padding = this.padding(), maxWidth = width - padding * 2, maxHeightPx = height - padding * 2, currentHeightPx = 0, wrap = this.wrap(), shouldWrap = wrap !== NONE2, wrapAtWord = wrap !== CHAR && shouldWrap, shouldAddEllipsis = this.ellipsis();
          this.textArr = [];
          getDummyContext2().font = this._getContextFont();
          const additionalWidth = shouldAddEllipsis ? this._getTextWidth(ELLIPSIS) : 0;
          for (let i2 = 0, max = lines.length; i2 < max; ++i2) {
            let line = lines[i2];
            let lineWidth = this._getTextWidth(line);
            if (fixedWidth && lineWidth > maxWidth) {
              while (line.length > 0) {
                let low = 0, high = stringToArray(line).length, match = "", matchWidth = 0;
                while (low < high) {
                  const mid = low + high >>> 1, lineArray = stringToArray(line), substr = lineArray.slice(0, mid + 1).join(""), substrWidth = this._getTextWidth(substr);
                  const shouldConsiderEllipsis = shouldAddEllipsis && fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx;
                  const effectiveWidth = shouldConsiderEllipsis ? substrWidth + additionalWidth : substrWidth;
                  if (effectiveWidth <= maxWidth) {
                    low = mid + 1;
                    match = substr;
                    matchWidth = substrWidth;
                  } else {
                    high = mid;
                  }
                }
                if (match) {
                  if (wrapAtWord) {
                    const lineArray2 = stringToArray(line);
                    const matchArray = stringToArray(match);
                    const nextChar = lineArray2[matchArray.length];
                    const nextIsSpaceOrDash = nextChar === SPACE2 || nextChar === DASH;
                    let wrapIndex;
                    if (nextIsSpaceOrDash && matchWidth <= maxWidth) {
                      wrapIndex = matchArray.length;
                    } else {
                      const lastSpaceIndex = matchArray.lastIndexOf(SPACE2);
                      const lastDashIndex = matchArray.lastIndexOf(DASH);
                      wrapIndex = Math.max(lastSpaceIndex, lastDashIndex) + 1;
                    }
                    if (wrapIndex > 0) {
                      low = wrapIndex;
                      match = lineArray2.slice(0, low).join("");
                      matchWidth = this._getTextWidth(match);
                    }
                  }
                  match = match.trimRight();
                  this._addTextLine(match);
                  textWidth = Math.max(textWidth, matchWidth);
                  currentHeightPx += lineHeightPx;
                  const shouldHandleEllipsis = this._shouldHandleEllipsis(currentHeightPx);
                  if (shouldHandleEllipsis) {
                    this._tryToAddEllipsisToLastLine();
                    break;
                  }
                  const lineArray = stringToArray(line);
                  line = lineArray.slice(low).join("").trimLeft();
                  if (line.length > 0) {
                    lineWidth = this._getTextWidth(line);
                    if (lineWidth <= maxWidth) {
                      this._addTextLine(line);
                      currentHeightPx += lineHeightPx;
                      textWidth = Math.max(textWidth, lineWidth);
                      break;
                    }
                  }
                } else {
                  break;
                }
              }
            } else {
              this._addTextLine(line);
              currentHeightPx += lineHeightPx;
              textWidth = Math.max(textWidth, lineWidth);
              if (this._shouldHandleEllipsis(currentHeightPx) && i2 < max - 1) {
                this._tryToAddEllipsisToLastLine();
              }
            }
            if (this.textArr[this.textArr.length - 1]) {
              this.textArr[this.textArr.length - 1].lastInParagraph = true;
            }
            if (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx) {
              break;
            }
          }
          this.textHeight = fontSize;
          this.textWidth = textWidth;
        }
        _shouldHandleEllipsis(currentHeightPx) {
          const fontSize = +this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, height = this.attrs.height, fixedHeight = height !== AUTO && height !== void 0, padding = this.padding(), maxHeightPx = height - padding * 2, wrap = this.wrap(), shouldWrap = wrap !== NONE2;
          return !shouldWrap || fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx;
        }
        _tryToAddEllipsisToLastLine() {
          const width = this.attrs.width, fixedWidth = width !== AUTO && width !== void 0, padding = this.padding(), maxWidth = width - padding * 2, shouldAddEllipsis = this.ellipsis();
          const lastLine = this.textArr[this.textArr.length - 1];
          if (!lastLine || !shouldAddEllipsis) {
            return;
          }
          if (fixedWidth) {
            const haveSpace = this._getTextWidth(lastLine.text + ELLIPSIS) < maxWidth;
            if (!haveSpace) {
              lastLine.text = lastLine.text.slice(0, lastLine.text.length - 3);
            }
          }
          this.textArr.splice(this.textArr.length - 1, 1);
          this._addTextLine(lastLine.text + ELLIPSIS);
        }
        getStrokeScaleEnabled() {
          return true;
        }
        _useBufferCanvas() {
          const hasLine = this.textDecoration().indexOf("underline") !== -1 || this.textDecoration().indexOf("line-through") !== -1;
          const hasShadow = this.hasShadow();
          if (hasLine && hasShadow) {
            return true;
          }
          if (hasShadow && this.getAbsoluteOpacity() !== 1 && hasShadowOpacityBug()) {
            return true;
          }
          return super._useBufferCanvas();
        }
      };
      Text2.prototype._fillFunc = _fillFunc2;
      Text2.prototype._strokeFunc = _strokeFunc2;
      Text2.prototype.className = TEXT_UPPER;
      Text2.prototype._attrsAffectingSize = [
        "text",
        "fontSize",
        "padding",
        "wrap",
        "lineHeight",
        "letterSpacing"
      ];
      _registerNode(Text2);
      Factory.overWriteSetter(Text2, "width", getNumberOrAutoValidator());
      Factory.overWriteSetter(Text2, "height", getNumberOrAutoValidator());
      Factory.addGetterSetter(Text2, "direction", INHERIT);
      Factory.addGetterSetter(Text2, "fontFamily", "Arial");
      Factory.addGetterSetter(Text2, "fontSize", 12, getNumberValidator());
      Factory.addGetterSetter(Text2, "fontStyle", NORMAL);
      Factory.addGetterSetter(Text2, "fontVariant", NORMAL);
      Factory.addGetterSetter(Text2, "padding", 0, getNumberValidator());
      Factory.addGetterSetter(Text2, "align", LEFT2);
      Factory.addGetterSetter(Text2, "verticalAlign", TOP);
      Factory.addGetterSetter(Text2, "lineHeight", 1, getNumberValidator());
      Factory.addGetterSetter(Text2, "wrap", WORD);
      Factory.addGetterSetter(Text2, "ellipsis", false, getBooleanValidator());
      Factory.addGetterSetter(Text2, "letterSpacing", 0, getNumberValidator());
      Factory.addGetterSetter(Text2, "text", "", getStringValidator());
      Factory.addGetterSetter(Text2, "textDecoration", "");
      Factory.addGetterSetter(Text2, "underlineOffset", void 0, getNumberValidator());
      Factory.addGetterSetter(Text2, "charRenderFunc", void 0);
    }
  });

  // node_modules/konva/lib/shapes/TextPath.js
  function _fillFunc3(context) {
    context.fillText(this.partialText, 0, 0);
  }
  function _strokeFunc3(context) {
    context.strokeText(this.partialText, 0, 0);
  }
  var EMPTY_STRING2, NORMAL2, TextPath;
  var init_TextPath = __esm({
    "node_modules/konva/lib/shapes/TextPath.js"() {
      init_Util();
      init_Factory();
      init_Shape();
      init_Path();
      init_Text();
      init_Validators();
      init_Global();
      EMPTY_STRING2 = "";
      NORMAL2 = "normal";
      TextPath = class extends Shape {
        constructor(config) {
          super(config);
          this.dummyCanvas = Util.createCanvasElement();
          this.dataArray = [];
          this._readDataAttribute();
          this.on("dataChange.konva", function() {
            this._readDataAttribute();
            this._setTextData();
          });
          this.on("textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva fontSizeChange.konva fontFamilyChange.konva directionChange.konva", this._setTextData);
          this._setTextData();
        }
        _getTextPathLength() {
          return Path.getPathLength(this.dataArray);
        }
        _getPointAtLength(length) {
          if (!this.attrs.data) {
            return null;
          }
          const totalLength = this.pathLength;
          if (length > totalLength) {
            return null;
          }
          return Path.getPointAtLengthOfDataArray(length, this.dataArray);
        }
        _readDataAttribute() {
          this.dataArray = Path.parsePathData(this.attrs.data);
          this.pathLength = this._getTextPathLength();
        }
        _sceneFunc(context) {
          context.setAttr("font", this._getContextFont());
          context.setAttr("textBaseline", this.textBaseline());
          context.setAttr("textAlign", "left");
          context.save();
          const textDecoration = this.textDecoration();
          const fill = this.fill();
          const fontSize = this.fontSize();
          const glyphInfo = this.glyphInfo;
          const hasUnderline = textDecoration.indexOf("underline") !== -1;
          const hasLineThrough = textDecoration.indexOf("line-through") !== -1;
          if (hasUnderline) {
            context.beginPath();
          }
          for (let i2 = 0; i2 < glyphInfo.length; i2++) {
            context.save();
            const p0 = glyphInfo[i2].p0;
            context.translate(p0.x, p0.y);
            context.rotate(glyphInfo[i2].rotation);
            this.partialText = glyphInfo[i2].text;
            context.fillStrokeShape(this);
            if (hasUnderline) {
              if (i2 === 0) {
                context.moveTo(0, fontSize / 2 + 1);
              }
              context.lineTo(glyphInfo[i2].width, fontSize / 2 + 1);
            }
            context.restore();
          }
          if (hasUnderline) {
            context.strokeStyle = fill;
            context.lineWidth = fontSize / 20;
            context.stroke();
          }
          if (hasLineThrough) {
            context.beginPath();
            for (let i2 = 0; i2 < glyphInfo.length; i2++) {
              context.save();
              const p0 = glyphInfo[i2].p0;
              context.translate(p0.x, p0.y);
              context.rotate(glyphInfo[i2].rotation);
              if (i2 === 0) {
                context.moveTo(0, 0);
              }
              context.lineTo(glyphInfo[i2].width, 0);
              context.restore();
            }
            context.strokeStyle = fill;
            context.lineWidth = fontSize / 20;
            context.stroke();
          }
          context.restore();
        }
        _hitFunc(context) {
          context.beginPath();
          const glyphInfo = this.glyphInfo;
          if (glyphInfo.length >= 1) {
            const p0 = glyphInfo[0].p0;
            context.moveTo(p0.x, p0.y);
          }
          for (let i2 = 0; i2 < glyphInfo.length; i2++) {
            const p1 = glyphInfo[i2].p1;
            context.lineTo(p1.x, p1.y);
          }
          context.setAttr("lineWidth", this.fontSize());
          context.setAttr("strokeStyle", this.colorKey);
          context.stroke();
        }
        getTextWidth() {
          return this.textWidth;
        }
        getTextHeight() {
          Util.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.");
          return this.textHeight;
        }
        setText(text) {
          return Text2.prototype.setText.call(this, text);
        }
        _getContextFont() {
          return Text2.prototype._getContextFont.call(this);
        }
        _getTextSize(text) {
          const dummyCanvas = this.dummyCanvas;
          const _context = dummyCanvas.getContext("2d");
          _context.save();
          _context.font = this._getContextFont();
          const metrics = _context.measureText(text);
          _context.restore();
          return {
            width: metrics.width,
            height: parseInt(`${this.fontSize()}`, 10)
          };
        }
        _setTextData() {
          const charArr = stringToArray(this.text());
          if (this.direction() === "rtl") {
            charArr.reverse();
          }
          const chars = [];
          let width = 0;
          for (let i2 = 0; i2 < charArr.length; i2++) {
            chars.push({
              char: charArr[i2],
              width: this._getTextSize(charArr[i2]).width
            });
            width += chars[i2].width;
          }
          const { width: fullTextWidth, height } = this._getTextSize(this.attrs.text);
          this.textWidth = width;
          this.textHeight = height;
          this.glyphInfo = [];
          if (!this.attrs.data) {
            return null;
          }
          const letterSpacing = this.letterSpacing();
          const align = this.align();
          const kerningFunc = this.kerningFunc();
          const kerningAdjustment = Math.max(0, width - fullTextWidth);
          const textWidth = Math.max(this.textWidth + ((this.attrs.text || "").length - 1) * letterSpacing, 0);
          let offset = 0;
          if (align === "center") {
            offset = Math.max(0, this.pathLength / 2 - textWidth / 2);
          }
          if (align === "right") {
            offset = Math.max(0, this.pathLength - textWidth);
          }
          let offsetToGlyph = offset;
          for (let i2 = 0; i2 < chars.length; i2++) {
            const charStartPoint = this._getPointAtLength(offsetToGlyph);
            if (!charStartPoint)
              return;
            const char = chars[i2].char;
            let glyphWidth = chars[i2].width + letterSpacing;
            if (char === " " && align === "justify") {
              const numberOfSpaces = this.text().split(" ").length - 1;
              glyphWidth += (this.pathLength - textWidth) / numberOfSpaces;
            }
            const charEndLength = offsetToGlyph + glyphWidth;
            const charEndPoint = this._getPointAtLength(charEndLength > this.pathLength && charEndLength - this.pathLength <= kerningAdjustment ? this.pathLength : charEndLength);
            if (!charEndPoint) {
              return;
            }
            const width2 = Path.getLineLength(charStartPoint.x, charStartPoint.y, charEndPoint.x, charEndPoint.y);
            let kern = 0;
            if (kerningFunc) {
              try {
                kern = kerningFunc(chars[i2 - 1].char, char) * this.fontSize();
              } catch (e) {
                kern = 0;
              }
            }
            charStartPoint.x += kern;
            charEndPoint.x += kern;
            this.textWidth += kern;
            const midpoint = Path.getPointOnLine(kern + width2 / 2, charStartPoint.x, charStartPoint.y, charEndPoint.x, charEndPoint.y);
            const rotation = Math.atan2(charEndPoint.y - charStartPoint.y, charEndPoint.x - charStartPoint.x);
            this.glyphInfo.push({
              transposeX: midpoint.x,
              transposeY: midpoint.y,
              text: charArr[i2],
              rotation,
              p0: charStartPoint,
              p1: charEndPoint,
              width: width2
            });
            offsetToGlyph += glyphWidth;
          }
        }
        getSelfRect() {
          if (!this.glyphInfo.length) {
            return {
              x: 0,
              y: 0,
              width: 0,
              height: 0
            };
          }
          const points = [];
          this.glyphInfo.forEach(function(info) {
            points.push(info.p0.x);
            points.push(info.p0.y);
            points.push(info.p1.x);
            points.push(info.p1.y);
          });
          let minX = points[0] || 0;
          let maxX = points[0] || 0;
          let minY = points[1] || 0;
          let maxY = points[1] || 0;
          let x, y2;
          for (let i2 = 0; i2 < points.length / 2; i2++) {
            x = points[i2 * 2];
            y2 = points[i2 * 2 + 1];
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y2);
            maxY = Math.max(maxY, y2);
          }
          const fontSize = this.fontSize();
          return {
            x: minX - fontSize / 2,
            y: minY - fontSize / 2,
            width: maxX - minX + fontSize,
            height: maxY - minY + fontSize
          };
        }
        destroy() {
          Util.releaseCanvas(this.dummyCanvas);
          return super.destroy();
        }
      };
      TextPath.prototype._fillFunc = _fillFunc3;
      TextPath.prototype._strokeFunc = _strokeFunc3;
      TextPath.prototype._fillFuncHit = _fillFunc3;
      TextPath.prototype._strokeFuncHit = _strokeFunc3;
      TextPath.prototype.className = "TextPath";
      TextPath.prototype._attrsAffectingSize = ["text", "fontSize", "data"];
      _registerNode(TextPath);
      Factory.addGetterSetter(TextPath, "data");
      Factory.addGetterSetter(TextPath, "fontFamily", "Arial");
      Factory.addGetterSetter(TextPath, "fontSize", 12, getNumberValidator());
      Factory.addGetterSetter(TextPath, "fontStyle", NORMAL2);
      Factory.addGetterSetter(TextPath, "align", "left");
      Factory.addGetterSetter(TextPath, "letterSpacing", 0, getNumberValidator());
      Factory.addGetterSetter(TextPath, "textBaseline", "middle");
      Factory.addGetterSetter(TextPath, "fontVariant", NORMAL2);
      Factory.addGetterSetter(TextPath, "text", EMPTY_STRING2);
      Factory.addGetterSetter(TextPath, "textDecoration", "");
      Factory.addGetterSetter(TextPath, "kerningFunc", void 0);
      Factory.addGetterSetter(TextPath, "direction", "inherit");
    }
  });

  // node_modules/konva/lib/shapes/Transformer.js
  function getCursor(anchorName, rad, rotateCursor) {
    if (anchorName === "rotater") {
      return rotateCursor;
    }
    rad += Util.degToRad(ANGLES[anchorName] || 0);
    const angle = (Util.radToDeg(rad) % 360 + 360) % 360;
    if (Util._inRange(angle, 315 + 22.5, 360) || Util._inRange(angle, 0, 22.5)) {
      return "ns-resize";
    } else if (Util._inRange(angle, 45 - 22.5, 45 + 22.5)) {
      return "nesw-resize";
    } else if (Util._inRange(angle, 90 - 22.5, 90 + 22.5)) {
      return "ew-resize";
    } else if (Util._inRange(angle, 135 - 22.5, 135 + 22.5)) {
      return "nwse-resize";
    } else if (Util._inRange(angle, 180 - 22.5, 180 + 22.5)) {
      return "ns-resize";
    } else if (Util._inRange(angle, 225 - 22.5, 225 + 22.5)) {
      return "nesw-resize";
    } else if (Util._inRange(angle, 270 - 22.5, 270 + 22.5)) {
      return "ew-resize";
    } else if (Util._inRange(angle, 315 - 22.5, 315 + 22.5)) {
      return "nwse-resize";
    } else {
      Util.error("Transformer has unknown angle for cursor detection: " + angle);
      return "pointer";
    }
  }
  function getCenter(shape) {
    return {
      x: shape.x + shape.width / 2 * Math.cos(shape.rotation) + shape.height / 2 * Math.sin(-shape.rotation),
      y: shape.y + shape.height / 2 * Math.cos(shape.rotation) + shape.width / 2 * Math.sin(shape.rotation)
    };
  }
  function rotateAroundPoint(shape, angleRad, point) {
    const x = point.x + (shape.x - point.x) * Math.cos(angleRad) - (shape.y - point.y) * Math.sin(angleRad);
    const y2 = point.y + (shape.x - point.x) * Math.sin(angleRad) + (shape.y - point.y) * Math.cos(angleRad);
    return {
      ...shape,
      rotation: shape.rotation + angleRad,
      x,
      y: y2
    };
  }
  function rotateAroundCenter(shape, deltaRad) {
    const center = getCenter(shape);
    return rotateAroundPoint(shape, deltaRad, center);
  }
  function getSnap(snaps, newRotationRad, tol) {
    let snapped = newRotationRad;
    for (let i2 = 0; i2 < snaps.length; i2++) {
      const angle = Konva.getAngle(snaps[i2]);
      const absDiff = Math.abs(angle - newRotationRad) % (Math.PI * 2);
      const dif = Math.min(absDiff, Math.PI * 2 - absDiff);
      if (dif < tol) {
        snapped = angle;
      }
    }
    return snapped;
  }
  function validateAnchors(val) {
    if (!(val instanceof Array)) {
      Util.warn("enabledAnchors value should be an array");
    }
    if (val instanceof Array) {
      val.forEach(function(name) {
        if (ANCHORS_NAMES.indexOf(name) === -1) {
          Util.warn("Unknown anchor name: " + name + ". Available names are: " + ANCHORS_NAMES.join(", "));
        }
      });
    }
    return val || [];
  }
  var EVENTS_NAME, ATTR_CHANGE_LIST3, NODES_RECT, TRANSFORM_CHANGE_STR2, ANGLES, TOUCH_DEVICE, ANCHORS_NAMES, MAX_SAFE_INTEGER, activeTransformersCount, Transformer;
  var init_Transformer = __esm({
    "node_modules/konva/lib/shapes/Transformer.js"() {
      init_Util();
      init_Factory();
      init_Node();
      init_Shape();
      init_Rect();
      init_Group();
      init_Global();
      init_Validators();
      init_Global();
      EVENTS_NAME = "tr-konva";
      ATTR_CHANGE_LIST3 = [
        "resizeEnabledChange",
        "rotateAnchorOffsetChange",
        "rotateAnchorAngleChange",
        "rotateEnabledChange",
        "enabledAnchorsChange",
        "anchorSizeChange",
        "borderEnabledChange",
        "borderStrokeChange",
        "borderStrokeWidthChange",
        "borderDashChange",
        "anchorStrokeChange",
        "anchorStrokeWidthChange",
        "anchorFillChange",
        "anchorCornerRadiusChange",
        "ignoreStrokeChange",
        "anchorStyleFuncChange"
      ].map((e) => e + `.${EVENTS_NAME}`).join(" ");
      NODES_RECT = "nodesRect";
      TRANSFORM_CHANGE_STR2 = [
        "widthChange",
        "heightChange",
        "scaleXChange",
        "scaleYChange",
        "skewXChange",
        "skewYChange",
        "rotationChange",
        "offsetXChange",
        "offsetYChange",
        "transformsEnabledChange",
        "strokeWidthChange",
        "draggableChange"
      ];
      ANGLES = {
        "top-left": -45,
        "top-center": 0,
        "top-right": 45,
        "middle-right": -90,
        "middle-left": 90,
        "bottom-left": -135,
        "bottom-center": 180,
        "bottom-right": 135
      };
      TOUCH_DEVICE = "ontouchstart" in Konva._global;
      ANCHORS_NAMES = [
        "top-left",
        "top-center",
        "top-right",
        "middle-right",
        "middle-left",
        "bottom-left",
        "bottom-center",
        "bottom-right"
      ];
      MAX_SAFE_INTEGER = 1e8;
      activeTransformersCount = 0;
      Transformer = class extends Group {
        constructor(config) {
          super(config);
          this._movingAnchorName = null;
          this._transforming = false;
          this._elementsCreated = false;
          this._createElements();
          this._handleMouseMove = this._handleMouseMove.bind(this);
          this._handleMouseUp = this._handleMouseUp.bind(this);
          this.update = this.update.bind(this);
          this.on(ATTR_CHANGE_LIST3, this.update);
          if (this.getNode()) {
            this.update();
          }
        }
        attachTo(node) {
          this.setNode(node);
          return this;
        }
        setNode(node) {
          Util.warn("tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead.");
          return this.setNodes([node]);
        }
        getNode() {
          return this._nodes && this._nodes[0];
        }
        _getEventNamespace() {
          return EVENTS_NAME + this._id;
        }
        setNodes(nodes = []) {
          if (this._nodes && this._nodes.length) {
            this.detach();
          }
          const filteredNodes = nodes.filter((node) => {
            if (node.isAncestorOf(this)) {
              Util.error("Konva.Transformer cannot be an a child of the node you are trying to attach");
              return false;
            }
            return true;
          });
          this._nodes = nodes = filteredNodes;
          if (nodes.length === 1 && this.useSingleNodeRotation()) {
            this.rotation(nodes[0].getAbsoluteRotation());
          } else {
            this.rotation(0);
          }
          this._nodes.forEach((node) => {
            const onChange = () => {
              if (this.nodes().length === 1 && this.useSingleNodeRotation()) {
                this.rotation(this.nodes()[0].getAbsoluteRotation());
              }
              this._resetTransformCache();
              if (!this._transforming && !this.isDragging()) {
                this.update();
              }
            };
            if (node._attrsAffectingSize.length) {
              const additionalEvents = node._attrsAffectingSize.map((prop) => prop + "Change." + this._getEventNamespace()).join(" ");
              node.on(additionalEvents, onChange);
            }
            node.on(TRANSFORM_CHANGE_STR2.map((e) => e + `.${this._getEventNamespace()}`).join(" "), onChange);
            node.on(`absoluteTransformChange.${this._getEventNamespace()}`, onChange);
            this._proxyDrag(node);
          });
          this._resetTransformCache();
          const elementsCreated = !!this.findOne(".top-left");
          if (elementsCreated) {
            this.update();
          }
          return this;
        }
        _proxyDrag(node) {
          let lastPos;
          node.on(`dragstart.${this._getEventNamespace()}`, (e) => {
            lastPos = node.getAbsolutePosition();
            if (!this.isDragging() && node !== this.findOne(".back")) {
              this.startDrag(e, false);
            }
          });
          node.on(`dragmove.${this._getEventNamespace()}`, (e) => {
            if (!lastPos) {
              return;
            }
            const abs = node.getAbsolutePosition();
            const dx = abs.x - lastPos.x;
            const dy = abs.y - lastPos.y;
            this.nodes().forEach((otherNode) => {
              if (otherNode === node) {
                return;
              }
              if (otherNode.isDragging()) {
                return;
              }
              const otherAbs = otherNode.getAbsolutePosition();
              otherNode.setAbsolutePosition({
                x: otherAbs.x + dx,
                y: otherAbs.y + dy
              });
              otherNode.startDrag(e);
            });
            lastPos = null;
          });
        }
        getNodes() {
          return this._nodes || [];
        }
        getActiveAnchor() {
          return this._movingAnchorName;
        }
        detach() {
          if (this._nodes) {
            this._nodes.forEach((node) => {
              node.off("." + this._getEventNamespace());
            });
          }
          this._nodes = [];
          this._resetTransformCache();
        }
        _resetTransformCache() {
          this._clearCache(NODES_RECT);
          this._clearCache("transform");
          this._clearSelfAndDescendantCache("absoluteTransform");
        }
        _getNodeRect() {
          return this._getCache(NODES_RECT, this.__getNodeRect);
        }
        __getNodeShape(node, rot = this.rotation(), relative) {
          const rect = node.getClientRect({
            skipTransform: true,
            skipShadow: true,
            skipStroke: this.ignoreStroke()
          });
          const absScale = node.getAbsoluteScale(relative);
          const absPos = node.getAbsolutePosition(relative);
          const dx = rect.x * absScale.x - node.offsetX() * absScale.x;
          const dy = rect.y * absScale.y - node.offsetY() * absScale.y;
          const rotation = (Konva.getAngle(node.getAbsoluteRotation()) + Math.PI * 2) % (Math.PI * 2);
          const box = {
            x: absPos.x + dx * Math.cos(rotation) + dy * Math.sin(-rotation),
            y: absPos.y + dy * Math.cos(rotation) + dx * Math.sin(rotation),
            width: rect.width * absScale.x,
            height: rect.height * absScale.y,
            rotation
          };
          return rotateAroundPoint(box, -Konva.getAngle(rot), {
            x: 0,
            y: 0
          });
        }
        __getNodeRect() {
          const node = this.getNode();
          if (!node) {
            return {
              x: -MAX_SAFE_INTEGER,
              y: -MAX_SAFE_INTEGER,
              width: 0,
              height: 0,
              rotation: 0
            };
          }
          const totalPoints = [];
          this.nodes().map((node2) => {
            const box = node2.getClientRect({
              skipTransform: true,
              skipShadow: true,
              skipStroke: this.ignoreStroke()
            });
            const points = [
              { x: box.x, y: box.y },
              { x: box.x + box.width, y: box.y },
              { x: box.x + box.width, y: box.y + box.height },
              { x: box.x, y: box.y + box.height }
            ];
            const trans = node2.getAbsoluteTransform();
            points.forEach(function(point) {
              const transformed = trans.point(point);
              totalPoints.push(transformed);
            });
          });
          const tr = new Transform();
          tr.rotate(-Konva.getAngle(this.rotation()));
          let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
          totalPoints.forEach(function(point) {
            const transformed = tr.point(point);
            if (minX === void 0) {
              minX = maxX = transformed.x;
              minY = maxY = transformed.y;
            }
            minX = Math.min(minX, transformed.x);
            minY = Math.min(minY, transformed.y);
            maxX = Math.max(maxX, transformed.x);
            maxY = Math.max(maxY, transformed.y);
          });
          tr.invert();
          const p2 = tr.point({ x: minX, y: minY });
          return {
            x: p2.x,
            y: p2.y,
            width: maxX - minX,
            height: maxY - minY,
            rotation: Konva.getAngle(this.rotation())
          };
        }
        getX() {
          return this._getNodeRect().x;
        }
        getY() {
          return this._getNodeRect().y;
        }
        getWidth() {
          return this._getNodeRect().width;
        }
        getHeight() {
          return this._getNodeRect().height;
        }
        _createElements() {
          this._createBack();
          ANCHORS_NAMES.forEach((name) => {
            this._createAnchor(name);
          });
          this._createAnchor("rotater");
          this._elementsCreated = true;
        }
        _createAnchor(name) {
          const anchor = new Rect({
            stroke: "rgb(0, 161, 255)",
            fill: "white",
            strokeWidth: 1,
            name: name + " _anchor",
            dragDistance: 0,
            draggable: true,
            hitStrokeWidth: TOUCH_DEVICE ? 10 : "auto"
          });
          const self2 = this;
          anchor.on("mousedown touchstart", function(e) {
            self2._handleMouseDown(e);
          });
          anchor.on("dragstart", (e) => {
            anchor.stopDrag();
            e.cancelBubble = true;
          });
          anchor.on("dragend", (e) => {
            e.cancelBubble = true;
          });
          anchor.on("mouseenter", () => {
            const rad = Konva.getAngle(this.rotation());
            const rotateCursor = this.rotateAnchorCursor();
            const cursor = getCursor(name, rad, rotateCursor);
            anchor.getStage().content && (anchor.getStage().content.style.cursor = cursor);
            this._cursorChange = true;
          });
          anchor.on("mouseout", () => {
            anchor.getStage().content && (anchor.getStage().content.style.cursor = "");
            this._cursorChange = false;
          });
          this.add(anchor);
        }
        _createBack() {
          const back = new Shape({
            name: "back",
            width: 0,
            height: 0,
            sceneFunc(ctx, shape) {
              const tr = shape.getParent();
              const padding = tr.padding();
              const width = shape.width();
              const height = shape.height();
              ctx.beginPath();
              ctx.rect(-padding, -padding, width + padding * 2, height + padding * 2);
              if (tr.rotateEnabled() && tr.rotateLineVisible()) {
                const rotateAnchorAngle = tr.rotateAnchorAngle();
                const rotateAnchorOffset = tr.rotateAnchorOffset();
                const rad = Util.degToRad(rotateAnchorAngle);
                const dirX = Math.sin(rad);
                const dirY = -Math.cos(rad);
                const cx = width / 2;
                const cy = height / 2;
                let t = Infinity;
                if (dirY < 0) {
                  t = Math.min(t, -cy / dirY);
                } else if (dirY > 0) {
                  t = Math.min(t, (height - cy) / dirY);
                }
                if (dirX < 0) {
                  t = Math.min(t, -cx / dirX);
                } else if (dirX > 0) {
                  t = Math.min(t, (width - cx) / dirX);
                }
                const edgeX = cx + dirX * t;
                const edgeY = cy + dirY * t;
                const sign = Util._sign(height);
                const endX = edgeX + dirX * rotateAnchorOffset * sign;
                const endY = edgeY + dirY * rotateAnchorOffset * sign;
                ctx.moveTo(edgeX, edgeY);
                ctx.lineTo(endX, endY);
              }
              ctx.fillStrokeShape(shape);
            },
            hitFunc: (ctx, shape) => {
              if (!this.shouldOverdrawWholeArea()) {
                return;
              }
              const padding = this.padding();
              ctx.beginPath();
              ctx.rect(-padding, -padding, shape.width() + padding * 2, shape.height() + padding * 2);
              ctx.fillStrokeShape(shape);
            }
          });
          this.add(back);
          this._proxyDrag(back);
          back.on("dragstart", (e) => {
            e.cancelBubble = true;
          });
          back.on("dragmove", (e) => {
            e.cancelBubble = true;
          });
          back.on("dragend", (e) => {
            e.cancelBubble = true;
          });
          this.on("dragmove", (e) => {
            this.update();
          });
        }
        _handleMouseDown(e) {
          if (this._transforming) {
            return;
          }
          this._movingAnchorName = e.target.name().split(" ")[0];
          const attrs = this._getNodeRect();
          const width = attrs.width;
          const height = attrs.height;
          const hypotenuse = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2));
          this.sin = Math.abs(height / hypotenuse);
          this.cos = Math.abs(width / hypotenuse);
          if (typeof window !== "undefined") {
            window.addEventListener("mousemove", this._handleMouseMove);
            window.addEventListener("touchmove", this._handleMouseMove);
            window.addEventListener("mouseup", this._handleMouseUp, true);
            window.addEventListener("touchend", this._handleMouseUp, true);
          }
          this._transforming = true;
          const ap = e.target.getAbsolutePosition();
          const pos = e.target.getStage().getPointerPosition();
          this._anchorDragOffset = {
            x: pos.x - ap.x,
            y: pos.y - ap.y
          };
          activeTransformersCount++;
          this._fire("transformstart", { evt: e.evt, target: this.getNode() });
          this._nodes.forEach((target) => {
            target._fire("transformstart", { evt: e.evt, target });
          });
        }
        _handleMouseMove(e) {
          let x, y2, newHypotenuse;
          const anchorNode = this.findOne("." + this._movingAnchorName);
          const stage = anchorNode.getStage();
          stage.setPointersPositions(e);
          const pp = stage.getPointerPosition();
          let newNodePos = {
            x: pp.x - this._anchorDragOffset.x,
            y: pp.y - this._anchorDragOffset.y
          };
          const oldAbs = anchorNode.getAbsolutePosition();
          if (this.anchorDragBoundFunc()) {
            newNodePos = this.anchorDragBoundFunc()(oldAbs, newNodePos, e);
          }
          anchorNode.setAbsolutePosition(newNodePos);
          const newAbs = anchorNode.getAbsolutePosition();
          if (oldAbs.x === newAbs.x && oldAbs.y === newAbs.y) {
            return;
          }
          if (this._movingAnchorName === "rotater") {
            const attrs = this._getNodeRect();
            x = anchorNode.x() - attrs.width / 2;
            y2 = -anchorNode.y() + attrs.height / 2;
            const rotateAnchorAngleRad = Konva.getAngle(this.rotateAnchorAngle());
            let delta = Math.atan2(-y2, x) + Math.PI / 2 - rotateAnchorAngleRad;
            if (attrs.height < 0) {
              delta -= Math.PI;
            }
            const oldRotation = Konva.getAngle(this.rotation());
            const newRotation = oldRotation + delta;
            const tol = Konva.getAngle(this.rotationSnapTolerance());
            const snappedRot = getSnap(this.rotationSnaps(), newRotation, tol);
            const diff = snappedRot - attrs.rotation;
            const shape = rotateAroundCenter(attrs, diff);
            this._fitNodesInto(shape, e);
            return;
          }
          const shiftBehavior = this.shiftBehavior();
          let keepProportion;
          if (shiftBehavior === "inverted") {
            keepProportion = this.keepRatio() && !e.shiftKey;
          } else if (shiftBehavior === "none") {
            keepProportion = this.keepRatio();
          } else {
            keepProportion = this.keepRatio() || e.shiftKey;
          }
          let centeredScaling = this.centeredScaling() || e.altKey;
          if (this._movingAnchorName === "top-left") {
            if (keepProportion) {
              const comparePoint = centeredScaling ? {
                x: this.width() / 2,
                y: this.height() / 2
              } : {
                x: this.findOne(".bottom-right").x(),
                y: this.findOne(".bottom-right").y()
              };
              newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) + Math.pow(comparePoint.y - anchorNode.y(), 2));
              const reverseX = this.findOne(".top-left").x() > comparePoint.x ? -1 : 1;
              const reverseY = this.findOne(".top-left").y() > comparePoint.y ? -1 : 1;
              x = newHypotenuse * this.cos * reverseX;
              y2 = newHypotenuse * this.sin * reverseY;
              this.findOne(".top-left").x(comparePoint.x - x);
              this.findOne(".top-left").y(comparePoint.y - y2);
            }
          } else if (this._movingAnchorName === "top-center") {
            this.findOne(".top-left").y(anchorNode.y());
          } else if (this._movingAnchorName === "top-right") {
            if (keepProportion) {
              const comparePoint = centeredScaling ? {
                x: this.width() / 2,
                y: this.height() / 2
              } : {
                x: this.findOne(".bottom-left").x(),
                y: this.findOne(".bottom-left").y()
              };
              newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) + Math.pow(comparePoint.y - anchorNode.y(), 2));
              const reverseX = this.findOne(".top-right").x() < comparePoint.x ? -1 : 1;
              const reverseY = this.findOne(".top-right").y() > comparePoint.y ? -1 : 1;
              x = newHypotenuse * this.cos * reverseX;
              y2 = newHypotenuse * this.sin * reverseY;
              this.findOne(".top-right").x(comparePoint.x + x);
              this.findOne(".top-right").y(comparePoint.y - y2);
            }
            var pos = anchorNode.position();
            this.findOne(".top-left").y(pos.y);
            this.findOne(".bottom-right").x(pos.x);
          } else if (this._movingAnchorName === "middle-left") {
            this.findOne(".top-left").x(anchorNode.x());
          } else if (this._movingAnchorName === "middle-right") {
            this.findOne(".bottom-right").x(anchorNode.x());
          } else if (this._movingAnchorName === "bottom-left") {
            if (keepProportion) {
              const comparePoint = centeredScaling ? {
                x: this.width() / 2,
                y: this.height() / 2
              } : {
                x: this.findOne(".top-right").x(),
                y: this.findOne(".top-right").y()
              };
              newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) + Math.pow(anchorNode.y() - comparePoint.y, 2));
              const reverseX = comparePoint.x < anchorNode.x() ? -1 : 1;
              const reverseY = anchorNode.y() < comparePoint.y ? -1 : 1;
              x = newHypotenuse * this.cos * reverseX;
              y2 = newHypotenuse * this.sin * reverseY;
              anchorNode.x(comparePoint.x - x);
              anchorNode.y(comparePoint.y + y2);
            }
            pos = anchorNode.position();
            this.findOne(".top-left").x(pos.x);
            this.findOne(".bottom-right").y(pos.y);
          } else if (this._movingAnchorName === "bottom-center") {
            this.findOne(".bottom-right").y(anchorNode.y());
          } else if (this._movingAnchorName === "bottom-right") {
            if (keepProportion) {
              const comparePoint = centeredScaling ? {
                x: this.width() / 2,
                y: this.height() / 2
              } : {
                x: this.findOne(".top-left").x(),
                y: this.findOne(".top-left").y()
              };
              newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) + Math.pow(anchorNode.y() - comparePoint.y, 2));
              const reverseX = this.findOne(".bottom-right").x() < comparePoint.x ? -1 : 1;
              const reverseY = this.findOne(".bottom-right").y() < comparePoint.y ? -1 : 1;
              x = newHypotenuse * this.cos * reverseX;
              y2 = newHypotenuse * this.sin * reverseY;
              this.findOne(".bottom-right").x(comparePoint.x + x);
              this.findOne(".bottom-right").y(comparePoint.y + y2);
            }
          } else {
            console.error(new Error("Wrong position argument of selection resizer: " + this._movingAnchorName));
          }
          centeredScaling = this.centeredScaling() || e.altKey;
          if (centeredScaling) {
            const topLeft = this.findOne(".top-left");
            const bottomRight = this.findOne(".bottom-right");
            const topOffsetX = topLeft.x();
            const topOffsetY = topLeft.y();
            const bottomOffsetX = this.getWidth() - bottomRight.x();
            const bottomOffsetY = this.getHeight() - bottomRight.y();
            bottomRight.move({
              x: -topOffsetX,
              y: -topOffsetY
            });
            topLeft.move({
              x: bottomOffsetX,
              y: bottomOffsetY
            });
          }
          const absPos = this.findOne(".top-left").getAbsolutePosition();
          x = absPos.x;
          y2 = absPos.y;
          const width = this.findOne(".bottom-right").x() - this.findOne(".top-left").x();
          const height = this.findOne(".bottom-right").y() - this.findOne(".top-left").y();
          this._fitNodesInto({
            x,
            y: y2,
            width,
            height,
            rotation: Konva.getAngle(this.rotation())
          }, e);
        }
        _handleMouseUp(e) {
          this._removeEvents(e);
        }
        getAbsoluteTransform() {
          return this.getTransform();
        }
        _removeEvents(e) {
          var _a;
          if (this._transforming) {
            this._transforming = false;
            if (typeof window !== "undefined") {
              window.removeEventListener("mousemove", this._handleMouseMove);
              window.removeEventListener("touchmove", this._handleMouseMove);
              window.removeEventListener("mouseup", this._handleMouseUp, true);
              window.removeEventListener("touchend", this._handleMouseUp, true);
            }
            const node = this.getNode();
            activeTransformersCount--;
            this._fire("transformend", { evt: e, target: node });
            (_a = this.getLayer()) === null || _a === void 0 ? void 0 : _a.batchDraw();
            if (node) {
              this._nodes.forEach((target) => {
                var _a2;
                target._fire("transformend", { evt: e, target });
                (_a2 = target.getLayer()) === null || _a2 === void 0 ? void 0 : _a2.batchDraw();
              });
            }
            this._movingAnchorName = null;
          }
        }
        _fitNodesInto(newAttrs, evt) {
          const oldAttrs = this._getNodeRect();
          const minSize = 1;
          if (Util._inRange(newAttrs.width, -this.padding() * 2 - minSize, minSize)) {
            this.update();
            return;
          }
          if (Util._inRange(newAttrs.height, -this.padding() * 2 - minSize, minSize)) {
            this.update();
            return;
          }
          const t = new Transform();
          t.rotate(Konva.getAngle(this.rotation()));
          if (this._movingAnchorName && newAttrs.width < 0 && this._movingAnchorName.indexOf("left") >= 0) {
            const offset = t.point({
              x: -this.padding() * 2,
              y: 0
            });
            newAttrs.x += offset.x;
            newAttrs.y += offset.y;
            newAttrs.width += this.padding() * 2;
            this._movingAnchorName = this._movingAnchorName.replace("left", "right");
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
          } else if (this._movingAnchorName && newAttrs.width < 0 && this._movingAnchorName.indexOf("right") >= 0) {
            const offset = t.point({
              x: this.padding() * 2,
              y: 0
            });
            this._movingAnchorName = this._movingAnchorName.replace("right", "left");
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.width += this.padding() * 2;
          }
          if (this._movingAnchorName && newAttrs.height < 0 && this._movingAnchorName.indexOf("top") >= 0) {
            const offset = t.point({
              x: 0,
              y: -this.padding() * 2
            });
            newAttrs.x += offset.x;
            newAttrs.y += offset.y;
            this._movingAnchorName = this._movingAnchorName.replace("top", "bottom");
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.height += this.padding() * 2;
          } else if (this._movingAnchorName && newAttrs.height < 0 && this._movingAnchorName.indexOf("bottom") >= 0) {
            const offset = t.point({
              x: 0,
              y: this.padding() * 2
            });
            this._movingAnchorName = this._movingAnchorName.replace("bottom", "top");
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.height += this.padding() * 2;
          }
          if (this.boundBoxFunc()) {
            const bounded = this.boundBoxFunc()(oldAttrs, newAttrs);
            if (bounded) {
              newAttrs = bounded;
            } else {
              Util.warn("boundBoxFunc returned falsy. You should return new bound rect from it!");
            }
          }
          const baseSize = 1e7;
          const oldTr = new Transform();
          oldTr.translate(oldAttrs.x, oldAttrs.y);
          oldTr.rotate(oldAttrs.rotation);
          oldTr.scale(oldAttrs.width / baseSize, oldAttrs.height / baseSize);
          const newTr = new Transform();
          const newScaleX = newAttrs.width / baseSize;
          const newScaleY = newAttrs.height / baseSize;
          if (this.flipEnabled() === false) {
            newTr.translate(newAttrs.x, newAttrs.y);
            newTr.rotate(newAttrs.rotation);
            newTr.translate(newAttrs.width < 0 ? newAttrs.width : 0, newAttrs.height < 0 ? newAttrs.height : 0);
            newTr.scale(Math.abs(newScaleX), Math.abs(newScaleY));
          } else {
            newTr.translate(newAttrs.x, newAttrs.y);
            newTr.rotate(newAttrs.rotation);
            newTr.scale(newScaleX, newScaleY);
          }
          const delta = newTr.multiply(oldTr.invert());
          this._nodes.forEach((node) => {
            var _a;
            if (!node.getStage()) {
              return;
            }
            const parentTransform = node.getParent().getAbsoluteTransform();
            const localTransform = node.getTransform().copy();
            localTransform.translate(node.offsetX(), node.offsetY());
            const newLocalTransform = new Transform();
            newLocalTransform.multiply(parentTransform.copy().invert()).multiply(delta).multiply(parentTransform).multiply(localTransform);
            const attrs = newLocalTransform.decompose();
            node.setAttrs(attrs);
            (_a = node.getLayer()) === null || _a === void 0 ? void 0 : _a.batchDraw();
          });
          this.rotation(Util._getRotation(newAttrs.rotation));
          this._nodes.forEach((node) => {
            this._fire("transform", { evt, target: node });
            node._fire("transform", { evt, target: node });
          });
          this._resetTransformCache();
          this.update();
          this.getLayer().batchDraw();
        }
        forceUpdate() {
          this._resetTransformCache();
          this.update();
        }
        _batchChangeChild(selector, attrs) {
          const anchor = this.findOne(selector);
          anchor.setAttrs(attrs);
        }
        update() {
          var _a;
          const attrs = this._getNodeRect();
          this.rotation(Util._getRotation(attrs.rotation));
          const width = attrs.width;
          const height = attrs.height;
          const enabledAnchors = this.enabledAnchors();
          const resizeEnabled = this.resizeEnabled();
          const padding = this.padding();
          const anchorSize = this.anchorSize();
          const anchors = this.find("._anchor");
          anchors.forEach((node) => {
            node.setAttrs({
              width: anchorSize,
              height: anchorSize,
              offsetX: anchorSize / 2,
              offsetY: anchorSize / 2,
              stroke: this.anchorStroke(),
              strokeWidth: this.anchorStrokeWidth(),
              fill: this.anchorFill(),
              cornerRadius: this.anchorCornerRadius()
            });
          });
          this._batchChangeChild(".top-left", {
            x: 0,
            y: 0,
            offsetX: anchorSize / 2 + padding,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf("top-left") >= 0
          });
          this._batchChangeChild(".top-center", {
            x: width / 2,
            y: 0,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf("top-center") >= 0
          });
          this._batchChangeChild(".top-right", {
            x: width,
            y: 0,
            offsetX: anchorSize / 2 - padding,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf("top-right") >= 0
          });
          this._batchChangeChild(".middle-left", {
            x: 0,
            y: height / 2,
            offsetX: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf("middle-left") >= 0
          });
          this._batchChangeChild(".middle-right", {
            x: width,
            y: height / 2,
            offsetX: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf("middle-right") >= 0
          });
          this._batchChangeChild(".bottom-left", {
            x: 0,
            y: height,
            offsetX: anchorSize / 2 + padding,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf("bottom-left") >= 0
          });
          this._batchChangeChild(".bottom-center", {
            x: width / 2,
            y: height,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf("bottom-center") >= 0
          });
          this._batchChangeChild(".bottom-right", {
            x: width,
            y: height,
            offsetX: anchorSize / 2 - padding,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf("bottom-right") >= 0
          });
          const rotateAnchorAngle = this.rotateAnchorAngle();
          const rotateAnchorOffset = this.rotateAnchorOffset();
          const rad = Util.degToRad(rotateAnchorAngle);
          const dirX = Math.sin(rad);
          const dirY = -Math.cos(rad);
          const cx = width / 2;
          const cy = height / 2;
          let t = Infinity;
          if (dirY < 0) {
            t = Math.min(t, -cy / dirY);
          } else if (dirY > 0) {
            t = Math.min(t, (height - cy) / dirY);
          }
          if (dirX < 0) {
            t = Math.min(t, -cx / dirX);
          } else if (dirX > 0) {
            t = Math.min(t, (width - cx) / dirX);
          }
          const edgeX = cx + dirX * t;
          const edgeY = cy + dirY * t;
          const sign = Util._sign(height);
          this._batchChangeChild(".rotater", {
            x: edgeX + dirX * rotateAnchorOffset * sign,
            y: edgeY + dirY * rotateAnchorOffset * sign - padding * dirY,
            visible: this.rotateEnabled()
          });
          this._batchChangeChild(".back", {
            width,
            height,
            visible: this.borderEnabled(),
            stroke: this.borderStroke(),
            strokeWidth: this.borderStrokeWidth(),
            dash: this.borderDash(),
            draggable: this.nodes().some((node) => node.draggable()),
            x: 0,
            y: 0
          });
          const styleFunc = this.anchorStyleFunc();
          if (styleFunc) {
            anchors.forEach((node) => {
              styleFunc(node);
            });
          }
          (_a = this.getLayer()) === null || _a === void 0 ? void 0 : _a.batchDraw();
        }
        isTransforming() {
          return this._transforming;
        }
        stopTransform() {
          if (this._transforming) {
            this._removeEvents();
            const anchorNode = this.findOne("." + this._movingAnchorName);
            if (anchorNode) {
              anchorNode.stopDrag();
            }
          }
        }
        destroy() {
          if (this.getStage() && this._cursorChange) {
            this.getStage().content && (this.getStage().content.style.cursor = "");
          }
          Group.prototype.destroy.call(this);
          this.detach();
          this._removeEvents();
          return this;
        }
        add(...children) {
          if (this._elementsCreated) {
            Util.error("You cannot add external nodes to the Transformer. Use tr.nodes([node]) instead.");
            return this;
          }
          return super.add(...children);
        }
        toObject() {
          return Node.prototype.toObject.call(this);
        }
        clone(obj) {
          const node = Node.prototype.clone.call(this, obj);
          return node;
        }
        getClientRect() {
          if (this.nodes().length > 0) {
            return super.getClientRect();
          } else {
            return { x: 0, y: 0, width: 0, height: 0 };
          }
        }
      };
      Transformer.isTransforming = () => {
        return activeTransformersCount > 0;
      };
      Transformer.prototype.className = "Transformer";
      _registerNode(Transformer);
      Factory.addGetterSetter(Transformer, "enabledAnchors", ANCHORS_NAMES, validateAnchors);
      Factory.addGetterSetter(Transformer, "flipEnabled", true, getBooleanValidator());
      Factory.addGetterSetter(Transformer, "resizeEnabled", true);
      Factory.addGetterSetter(Transformer, "anchorSize", 10, getNumberValidator());
      Factory.addGetterSetter(Transformer, "rotateEnabled", true);
      Factory.addGetterSetter(Transformer, "rotateLineVisible", true);
      Factory.addGetterSetter(Transformer, "rotationSnaps", []);
      Factory.addGetterSetter(Transformer, "rotateAnchorOffset", 50, getNumberValidator());
      Factory.addGetterSetter(Transformer, "rotateAnchorAngle", 0, getNumberValidator());
      Factory.addGetterSetter(Transformer, "rotateAnchorCursor", "crosshair");
      Factory.addGetterSetter(Transformer, "rotationSnapTolerance", 5, getNumberValidator());
      Factory.addGetterSetter(Transformer, "borderEnabled", true);
      Factory.addGetterSetter(Transformer, "anchorStroke", "rgb(0, 161, 255)");
      Factory.addGetterSetter(Transformer, "anchorStrokeWidth", 1, getNumberValidator());
      Factory.addGetterSetter(Transformer, "anchorFill", "white");
      Factory.addGetterSetter(Transformer, "anchorCornerRadius", 0, getNumberValidator());
      Factory.addGetterSetter(Transformer, "borderStroke", "rgb(0, 161, 255)");
      Factory.addGetterSetter(Transformer, "borderStrokeWidth", 1, getNumberValidator());
      Factory.addGetterSetter(Transformer, "borderDash");
      Factory.addGetterSetter(Transformer, "keepRatio", true);
      Factory.addGetterSetter(Transformer, "shiftBehavior", "default");
      Factory.addGetterSetter(Transformer, "centeredScaling", false);
      Factory.addGetterSetter(Transformer, "ignoreStroke", false);
      Factory.addGetterSetter(Transformer, "padding", 0, getNumberValidator());
      Factory.addGetterSetter(Transformer, "nodes");
      Factory.addGetterSetter(Transformer, "node");
      Factory.addGetterSetter(Transformer, "boundBoxFunc");
      Factory.addGetterSetter(Transformer, "anchorDragBoundFunc");
      Factory.addGetterSetter(Transformer, "anchorStyleFunc");
      Factory.addGetterSetter(Transformer, "shouldOverdrawWholeArea", false);
      Factory.addGetterSetter(Transformer, "useSingleNodeRotation", true);
      Factory.backCompat(Transformer, {
        lineEnabled: "borderEnabled",
        rotateHandlerOffset: "rotateAnchorOffset",
        enabledHandlers: "enabledAnchors"
      });
    }
  });

  // node_modules/konva/lib/shapes/Wedge.js
  var Wedge;
  var init_Wedge = __esm({
    "node_modules/konva/lib/shapes/Wedge.js"() {
      init_Factory();
      init_Shape();
      init_Global();
      init_Validators();
      init_Global();
      Wedge = class extends Shape {
        _sceneFunc(context) {
          context.beginPath();
          context.arc(0, 0, this.radius(), 0, Konva.getAngle(this.angle()), this.clockwise());
          context.lineTo(0, 0);
          context.closePath();
          context.fillStrokeShape(this);
        }
        getWidth() {
          return this.radius() * 2;
        }
        getHeight() {
          return this.radius() * 2;
        }
        setWidth(width) {
          this.radius(width / 2);
        }
        setHeight(height) {
          this.radius(height / 2);
        }
      };
      Wedge.prototype.className = "Wedge";
      Wedge.prototype._centroid = true;
      Wedge.prototype._attrsAffectingSize = ["radius"];
      _registerNode(Wedge);
      Factory.addGetterSetter(Wedge, "radius", 0, getNumberValidator());
      Factory.addGetterSetter(Wedge, "angle", 0, getNumberValidator());
      Factory.addGetterSetter(Wedge, "clockwise", false);
      Factory.backCompat(Wedge, {
        angleDeg: "angle",
        getAngleDeg: "getAngle",
        setAngleDeg: "setAngle"
      });
    }
  });

  // node_modules/konva/lib/filters/Blur.js
  function BlurStack() {
    this.r = 0;
    this.g = 0;
    this.b = 0;
    this.a = 0;
    this.next = null;
  }
  function filterGaussBlurRGBA(imageData, radius) {
    const pixels = imageData.data, width = imageData.width, height = imageData.height;
    let p2, yi, yw, r_sum, g_sum, b_sum, a_sum, r_out_sum, g_out_sum, b_out_sum, a_out_sum, r_in_sum, g_in_sum, b_in_sum, a_in_sum, pr, pg, pb, pa, rbs;
    const div = radius + radius + 1, widthMinus1 = width - 1, heightMinus1 = height - 1, radiusPlus1 = radius + 1, sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2, stackStart = new BlurStack(), mul_sum = mul_table[radius], shg_sum = shg_table[radius];
    let stackEnd = null, stack3 = stackStart, stackIn = null, stackOut = null;
    for (let i2 = 1; i2 < div; i2++) {
      stack3 = stack3.next = new BlurStack();
      if (i2 === radiusPlus1) {
        stackEnd = stack3;
      }
    }
    stack3.next = stackStart;
    yw = yi = 0;
    for (let y2 = 0; y2 < height; y2++) {
      r_in_sum = g_in_sum = b_in_sum = a_in_sum = r_sum = g_sum = b_sum = a_sum = 0;
      r_out_sum = radiusPlus1 * (pr = pixels[yi]);
      g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
      b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
      a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
      r_sum += sumFactor * pr;
      g_sum += sumFactor * pg;
      b_sum += sumFactor * pb;
      a_sum += sumFactor * pa;
      stack3 = stackStart;
      for (let i2 = 0; i2 < radiusPlus1; i2++) {
        stack3.r = pr;
        stack3.g = pg;
        stack3.b = pb;
        stack3.a = pa;
        stack3 = stack3.next;
      }
      for (let i2 = 1; i2 < radiusPlus1; i2++) {
        p2 = yi + ((widthMinus1 < i2 ? widthMinus1 : i2) << 2);
        r_sum += (stack3.r = pr = pixels[p2]) * (rbs = radiusPlus1 - i2);
        g_sum += (stack3.g = pg = pixels[p2 + 1]) * rbs;
        b_sum += (stack3.b = pb = pixels[p2 + 2]) * rbs;
        a_sum += (stack3.a = pa = pixels[p2 + 3]) * rbs;
        r_in_sum += pr;
        g_in_sum += pg;
        b_in_sum += pb;
        a_in_sum += pa;
        stack3 = stack3.next;
      }
      stackIn = stackStart;
      stackOut = stackEnd;
      for (let x = 0; x < width; x++) {
        pixels[yi + 3] = pa = a_sum * mul_sum >> shg_sum;
        if (pa !== 0) {
          pa = 255 / pa;
          pixels[yi] = (r_sum * mul_sum >> shg_sum) * pa;
          pixels[yi + 1] = (g_sum * mul_sum >> shg_sum) * pa;
          pixels[yi + 2] = (b_sum * mul_sum >> shg_sum) * pa;
        } else {
          pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
        }
        r_sum -= r_out_sum;
        g_sum -= g_out_sum;
        b_sum -= b_out_sum;
        a_sum -= a_out_sum;
        r_out_sum -= stackIn.r;
        g_out_sum -= stackIn.g;
        b_out_sum -= stackIn.b;
        a_out_sum -= stackIn.a;
        p2 = yw + ((p2 = x + radius + 1) < widthMinus1 ? p2 : widthMinus1) << 2;
        r_in_sum += stackIn.r = pixels[p2];
        g_in_sum += stackIn.g = pixels[p2 + 1];
        b_in_sum += stackIn.b = pixels[p2 + 2];
        a_in_sum += stackIn.a = pixels[p2 + 3];
        r_sum += r_in_sum;
        g_sum += g_in_sum;
        b_sum += b_in_sum;
        a_sum += a_in_sum;
        stackIn = stackIn.next;
        r_out_sum += pr = stackOut.r;
        g_out_sum += pg = stackOut.g;
        b_out_sum += pb = stackOut.b;
        a_out_sum += pa = stackOut.a;
        r_in_sum -= pr;
        g_in_sum -= pg;
        b_in_sum -= pb;
        a_in_sum -= pa;
        stackOut = stackOut.next;
        yi += 4;
      }
      yw += width;
    }
    for (let x = 0; x < width; x++) {
      g_in_sum = b_in_sum = a_in_sum = r_in_sum = g_sum = b_sum = a_sum = r_sum = 0;
      yi = x << 2;
      r_out_sum = radiusPlus1 * (pr = pixels[yi]);
      g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
      b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
      a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
      r_sum += sumFactor * pr;
      g_sum += sumFactor * pg;
      b_sum += sumFactor * pb;
      a_sum += sumFactor * pa;
      stack3 = stackStart;
      for (let i2 = 0; i2 < radiusPlus1; i2++) {
        stack3.r = pr;
        stack3.g = pg;
        stack3.b = pb;
        stack3.a = pa;
        stack3 = stack3.next;
      }
      let yp = width;
      for (let i2 = 1; i2 <= radius; i2++) {
        yi = yp + x << 2;
        r_sum += (stack3.r = pr = pixels[yi]) * (rbs = radiusPlus1 - i2);
        g_sum += (stack3.g = pg = pixels[yi + 1]) * rbs;
        b_sum += (stack3.b = pb = pixels[yi + 2]) * rbs;
        a_sum += (stack3.a = pa = pixels[yi + 3]) * rbs;
        r_in_sum += pr;
        g_in_sum += pg;
        b_in_sum += pb;
        a_in_sum += pa;
        stack3 = stack3.next;
        if (i2 < heightMinus1) {
          yp += width;
        }
      }
      yi = x;
      stackIn = stackStart;
      stackOut = stackEnd;
      for (let y2 = 0; y2 < height; y2++) {
        p2 = yi << 2;
        pixels[p2 + 3] = pa = a_sum * mul_sum >> shg_sum;
        if (pa > 0) {
          pa = 255 / pa;
          pixels[p2] = (r_sum * mul_sum >> shg_sum) * pa;
          pixels[p2 + 1] = (g_sum * mul_sum >> shg_sum) * pa;
          pixels[p2 + 2] = (b_sum * mul_sum >> shg_sum) * pa;
        } else {
          pixels[p2] = pixels[p2 + 1] = pixels[p2 + 2] = 0;
        }
        r_sum -= r_out_sum;
        g_sum -= g_out_sum;
        b_sum -= b_out_sum;
        a_sum -= a_out_sum;
        r_out_sum -= stackIn.r;
        g_out_sum -= stackIn.g;
        b_out_sum -= stackIn.b;
        a_out_sum -= stackIn.a;
        p2 = x + ((p2 = y2 + radiusPlus1) < heightMinus1 ? p2 : heightMinus1) * width << 2;
        r_sum += r_in_sum += stackIn.r = pixels[p2];
        g_sum += g_in_sum += stackIn.g = pixels[p2 + 1];
        b_sum += b_in_sum += stackIn.b = pixels[p2 + 2];
        a_sum += a_in_sum += stackIn.a = pixels[p2 + 3];
        stackIn = stackIn.next;
        r_out_sum += pr = stackOut.r;
        g_out_sum += pg = stackOut.g;
        b_out_sum += pb = stackOut.b;
        a_out_sum += pa = stackOut.a;
        r_in_sum -= pr;
        g_in_sum -= pg;
        b_in_sum -= pb;
        a_in_sum -= pa;
        stackOut = stackOut.next;
        yi += width;
      }
    }
  }
  var mul_table, shg_table, Blur;
  var init_Blur = __esm({
    "node_modules/konva/lib/filters/Blur.js"() {
      init_Factory();
      init_Node();
      init_Validators();
      mul_table = [
        512,
        512,
        456,
        512,
        328,
        456,
        335,
        512,
        405,
        328,
        271,
        456,
        388,
        335,
        292,
        512,
        454,
        405,
        364,
        328,
        298,
        271,
        496,
        456,
        420,
        388,
        360,
        335,
        312,
        292,
        273,
        512,
        482,
        454,
        428,
        405,
        383,
        364,
        345,
        328,
        312,
        298,
        284,
        271,
        259,
        496,
        475,
        456,
        437,
        420,
        404,
        388,
        374,
        360,
        347,
        335,
        323,
        312,
        302,
        292,
        282,
        273,
        265,
        512,
        497,
        482,
        468,
        454,
        441,
        428,
        417,
        405,
        394,
        383,
        373,
        364,
        354,
        345,
        337,
        328,
        320,
        312,
        305,
        298,
        291,
        284,
        278,
        271,
        265,
        259,
        507,
        496,
        485,
        475,
        465,
        456,
        446,
        437,
        428,
        420,
        412,
        404,
        396,
        388,
        381,
        374,
        367,
        360,
        354,
        347,
        341,
        335,
        329,
        323,
        318,
        312,
        307,
        302,
        297,
        292,
        287,
        282,
        278,
        273,
        269,
        265,
        261,
        512,
        505,
        497,
        489,
        482,
        475,
        468,
        461,
        454,
        447,
        441,
        435,
        428,
        422,
        417,
        411,
        405,
        399,
        394,
        389,
        383,
        378,
        373,
        368,
        364,
        359,
        354,
        350,
        345,
        341,
        337,
        332,
        328,
        324,
        320,
        316,
        312,
        309,
        305,
        301,
        298,
        294,
        291,
        287,
        284,
        281,
        278,
        274,
        271,
        268,
        265,
        262,
        259,
        257,
        507,
        501,
        496,
        491,
        485,
        480,
        475,
        470,
        465,
        460,
        456,
        451,
        446,
        442,
        437,
        433,
        428,
        424,
        420,
        416,
        412,
        408,
        404,
        400,
        396,
        392,
        388,
        385,
        381,
        377,
        374,
        370,
        367,
        363,
        360,
        357,
        354,
        350,
        347,
        344,
        341,
        338,
        335,
        332,
        329,
        326,
        323,
        320,
        318,
        315,
        312,
        310,
        307,
        304,
        302,
        299,
        297,
        294,
        292,
        289,
        287,
        285,
        282,
        280,
        278,
        275,
        273,
        271,
        269,
        267,
        265,
        263,
        261,
        259
      ];
      shg_table = [
        9,
        11,
        12,
        13,
        13,
        14,
        14,
        15,
        15,
        15,
        15,
        16,
        16,
        16,
        16,
        17,
        17,
        17,
        17,
        17,
        17,
        17,
        18,
        18,
        18,
        18,
        18,
        18,
        18,
        18,
        18,
        19,
        19,
        19,
        19,
        19,
        19,
        19,
        19,
        19,
        19,
        19,
        19,
        19,
        19,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        20,
        21,
        21,
        21,
        21,
        21,
        21,
        21,
        21,
        21,
        21,
        21,
        21,
        21,
        21,
        21,
        21,
        21,
        21,
        21,
        21,
        21,
        21,
        21,
        21,
        21,
        21,
        21,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        22,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        23,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24,
        24
      ];
      Blur = function Blur2(imageData) {
        const radius = Math.round(this.blurRadius());
        if (radius > 0) {
          filterGaussBlurRGBA(imageData, radius);
        }
      };
      Factory.addGetterSetter(Node, "blurRadius", 0, getNumberValidator(), Factory.afterSetFilter);
    }
  });

  // node_modules/konva/lib/filters/Brighten.js
  var Brighten;
  var init_Brighten = __esm({
    "node_modules/konva/lib/filters/Brighten.js"() {
      init_Factory();
      init_Node();
      init_Validators();
      Brighten = function(imageData) {
        const brightness = this.brightness() * 255, data = imageData.data, len = data.length;
        for (let i2 = 0; i2 < len; i2 += 4) {
          data[i2] += brightness;
          data[i2 + 1] += brightness;
          data[i2 + 2] += brightness;
        }
      };
      Factory.addGetterSetter(Node, "brightness", 0, getNumberValidator(), Factory.afterSetFilter);
    }
  });

  // node_modules/konva/lib/filters/Brightness.js
  var Brightness;
  var init_Brightness = __esm({
    "node_modules/konva/lib/filters/Brightness.js"() {
      Brightness = function(imageData) {
        const brightness = this.brightness(), data = imageData.data, len = data.length;
        for (let i2 = 0; i2 < len; i2 += 4) {
          data[i2] = Math.min(255, data[i2] * brightness);
          data[i2 + 1] = Math.min(255, data[i2 + 1] * brightness);
          data[i2 + 2] = Math.min(255, data[i2 + 2] * brightness);
        }
      };
    }
  });

  // node_modules/konva/lib/filters/Contrast.js
  var Contrast;
  var init_Contrast = __esm({
    "node_modules/konva/lib/filters/Contrast.js"() {
      init_Factory();
      init_Node();
      init_Validators();
      Contrast = function(imageData) {
        const adjust = Math.pow((this.contrast() + 100) / 100, 2);
        const data = imageData.data, nPixels = data.length;
        let red = 150, green = 150, blue = 150;
        for (let i2 = 0; i2 < nPixels; i2 += 4) {
          red = data[i2];
          green = data[i2 + 1];
          blue = data[i2 + 2];
          red /= 255;
          red -= 0.5;
          red *= adjust;
          red += 0.5;
          red *= 255;
          green /= 255;
          green -= 0.5;
          green *= adjust;
          green += 0.5;
          green *= 255;
          blue /= 255;
          blue -= 0.5;
          blue *= adjust;
          blue += 0.5;
          blue *= 255;
          red = red < 0 ? 0 : red > 255 ? 255 : red;
          green = green < 0 ? 0 : green > 255 ? 255 : green;
          blue = blue < 0 ? 0 : blue > 255 ? 255 : blue;
          data[i2] = red;
          data[i2 + 1] = green;
          data[i2 + 2] = blue;
        }
      };
      Factory.addGetterSetter(Node, "contrast", 0, getNumberValidator(), Factory.afterSetFilter);
    }
  });

  // node_modules/konva/lib/filters/Emboss.js
  var Emboss;
  var init_Emboss = __esm({
    "node_modules/konva/lib/filters/Emboss.js"() {
      init_Factory();
      init_Node();
      init_Validators();
      Emboss = function(imageData) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const data = imageData.data;
        const w = imageData.width;
        const h2 = imageData.height;
        const strength01 = Math.min(1, Math.max(0, (_b = (_a = this.embossStrength) === null || _a === void 0 ? void 0 : _a.call(this)) !== null && _b !== void 0 ? _b : 0.5));
        const whiteLevel01 = Math.min(1, Math.max(0, (_d = (_c = this.embossWhiteLevel) === null || _c === void 0 ? void 0 : _c.call(this)) !== null && _d !== void 0 ? _d : 0.5));
        const directionMap = {
          "top-left": 315,
          top: 270,
          "top-right": 225,
          right: 180,
          "bottom-right": 135,
          bottom: 90,
          "bottom-left": 45,
          left: 0
        };
        const directionDeg = (_g = directionMap[(_f = (_e = this.embossDirection) === null || _e === void 0 ? void 0 : _e.call(this)) !== null && _f !== void 0 ? _f : "top-left"]) !== null && _g !== void 0 ? _g : 315;
        const blend = !!((_j = (_h = this.embossBlend) === null || _h === void 0 ? void 0 : _h.call(this)) !== null && _j !== void 0 ? _j : false);
        const strength = strength01 * 10;
        const bias = whiteLevel01 * 255;
        const dirRad = directionDeg * Math.PI / 180;
        const cx = Math.cos(dirRad);
        const cy = Math.sin(dirRad);
        const SCALE = 128 / 1020 * strength;
        const src = new Uint8ClampedArray(data);
        const lum = new Float32Array(w * h2);
        for (let p2 = 0, i2 = 0; i2 < data.length; i2 += 4, p2++) {
          lum[p2] = 0.2126 * src[i2] + 0.7152 * src[i2 + 1] + 0.0722 * src[i2 + 2];
        }
        const Gx = [-1, 0, 1, -2, 0, 2, -1, 0, 1];
        const Gy = [-1, -2, -1, 0, 0, 0, 1, 2, 1];
        const OFF = [-w - 1, -w, -w + 1, -1, 0, 1, w - 1, w, w + 1];
        const clamp8 = (v) => v < 0 ? 0 : v > 255 ? 255 : v;
        for (let y2 = 1; y2 < h2 - 1; y2++) {
          for (let x = 1; x < w - 1; x++) {
            const p2 = y2 * w + x;
            let sx = 0, sy = 0;
            sx += lum[p2 + OFF[0]] * Gx[0];
            sy += lum[p2 + OFF[0]] * Gy[0];
            sx += lum[p2 + OFF[1]] * Gx[1];
            sy += lum[p2 + OFF[1]] * Gy[1];
            sx += lum[p2 + OFF[2]] * Gx[2];
            sy += lum[p2 + OFF[2]] * Gy[2];
            sx += lum[p2 + OFF[3]] * Gx[3];
            sy += lum[p2 + OFF[3]] * Gy[3];
            sx += lum[p2 + OFF[5]] * Gx[5];
            sy += lum[p2 + OFF[5]] * Gy[5];
            sx += lum[p2 + OFF[6]] * Gx[6];
            sy += lum[p2 + OFF[6]] * Gy[6];
            sx += lum[p2 + OFF[7]] * Gx[7];
            sy += lum[p2 + OFF[7]] * Gy[7];
            sx += lum[p2 + OFF[8]] * Gx[8];
            sy += lum[p2 + OFF[8]] * Gy[8];
            const r = cx * sx + cy * sy;
            const outGray = clamp8(bias + r * SCALE);
            const o = p2 * 4;
            if (blend) {
              const delta = outGray - bias;
              data[o] = clamp8(src[o] + delta);
              data[o + 1] = clamp8(src[o + 1] + delta);
              data[o + 2] = clamp8(src[o + 2] + delta);
              data[o + 3] = src[o + 3];
            } else {
              data[o] = data[o + 1] = data[o + 2] = outGray;
              data[o + 3] = src[o + 3];
            }
          }
        }
        for (let x = 0; x < w; x++) {
          let oTop = x * 4, oBot = ((h2 - 1) * w + x) * 4;
          data[oTop] = src[oTop];
          data[oTop + 1] = src[oTop + 1];
          data[oTop + 2] = src[oTop + 2];
          data[oTop + 3] = src[oTop + 3];
          data[oBot] = src[oBot];
          data[oBot + 1] = src[oBot + 1];
          data[oBot + 2] = src[oBot + 2];
          data[oBot + 3] = src[oBot + 3];
        }
        for (let y2 = 1; y2 < h2 - 1; y2++) {
          let oL = y2 * w * 4, oR = (y2 * w + (w - 1)) * 4;
          data[oL] = src[oL];
          data[oL + 1] = src[oL + 1];
          data[oL + 2] = src[oL + 2];
          data[oL + 3] = src[oL + 3];
          data[oR] = src[oR];
          data[oR + 1] = src[oR + 1];
          data[oR + 2] = src[oR + 2];
          data[oR + 3] = src[oR + 3];
        }
        return imageData;
      };
      Factory.addGetterSetter(Node, "embossStrength", 0.5, getNumberValidator(), Factory.afterSetFilter);
      Factory.addGetterSetter(Node, "embossWhiteLevel", 0.5, getNumberValidator(), Factory.afterSetFilter);
      Factory.addGetterSetter(Node, "embossDirection", "top-left", void 0, Factory.afterSetFilter);
      Factory.addGetterSetter(Node, "embossBlend", false, void 0, Factory.afterSetFilter);
    }
  });

  // node_modules/konva/lib/filters/Enhance.js
  function remap(fromValue, fromMin, fromMax, toMin, toMax) {
    const fromRange = fromMax - fromMin, toRange = toMax - toMin;
    if (fromRange === 0) {
      return toMin + toRange / 2;
    }
    if (toRange === 0) {
      return toMin;
    }
    let toValue2 = (fromValue - fromMin) / fromRange;
    toValue2 = toRange * toValue2 + toMin;
    return toValue2;
  }
  var Enhance;
  var init_Enhance = __esm({
    "node_modules/konva/lib/filters/Enhance.js"() {
      init_Factory();
      init_Node();
      init_Validators();
      Enhance = function(imageData) {
        const data = imageData.data, nSubPixels = data.length;
        let rMin = data[0], rMax = rMin, r, gMin = data[1], gMax = gMin, g, bMin = data[2], bMax = bMin, b2;
        const enhanceAmount = this.enhance();
        if (enhanceAmount === 0) {
          return;
        }
        for (let i2 = 0; i2 < nSubPixels; i2 += 4) {
          r = data[i2 + 0];
          if (r < rMin) {
            rMin = r;
          } else if (r > rMax) {
            rMax = r;
          }
          g = data[i2 + 1];
          if (g < gMin) {
            gMin = g;
          } else if (g > gMax) {
            gMax = g;
          }
          b2 = data[i2 + 2];
          if (b2 < bMin) {
            bMin = b2;
          } else if (b2 > bMax) {
            bMax = b2;
          }
        }
        if (rMax === rMin) {
          rMax = 255;
          rMin = 0;
        }
        if (gMax === gMin) {
          gMax = 255;
          gMin = 0;
        }
        if (bMax === bMin) {
          bMax = 255;
          bMin = 0;
        }
        let rGoalMax, rGoalMin, gGoalMax, gGoalMin, bGoalMax, bGoalMin;
        if (enhanceAmount > 0) {
          rGoalMax = rMax + enhanceAmount * (255 - rMax);
          rGoalMin = rMin - enhanceAmount * (rMin - 0);
          gGoalMax = gMax + enhanceAmount * (255 - gMax);
          gGoalMin = gMin - enhanceAmount * (gMin - 0);
          bGoalMax = bMax + enhanceAmount * (255 - bMax);
          bGoalMin = bMin - enhanceAmount * (bMin - 0);
        } else {
          const rMid = (rMax + rMin) * 0.5;
          rGoalMax = rMax + enhanceAmount * (rMax - rMid);
          rGoalMin = rMin + enhanceAmount * (rMin - rMid);
          const gMid = (gMax + gMin) * 0.5;
          gGoalMax = gMax + enhanceAmount * (gMax - gMid);
          gGoalMin = gMin + enhanceAmount * (gMin - gMid);
          const bMid = (bMax + bMin) * 0.5;
          bGoalMax = bMax + enhanceAmount * (bMax - bMid);
          bGoalMin = bMin + enhanceAmount * (bMin - bMid);
        }
        for (let i2 = 0; i2 < nSubPixels; i2 += 4) {
          data[i2 + 0] = remap(data[i2 + 0], rMin, rMax, rGoalMin, rGoalMax);
          data[i2 + 1] = remap(data[i2 + 1], gMin, gMax, gGoalMin, gGoalMax);
          data[i2 + 2] = remap(data[i2 + 2], bMin, bMax, bGoalMin, bGoalMax);
        }
      };
      Factory.addGetterSetter(Node, "enhance", 0, getNumberValidator(), Factory.afterSetFilter);
    }
  });

  // node_modules/konva/lib/filters/Grayscale.js
  var Grayscale;
  var init_Grayscale = __esm({
    "node_modules/konva/lib/filters/Grayscale.js"() {
      Grayscale = function(imageData) {
        const data = imageData.data, len = data.length;
        for (let i2 = 0; i2 < len; i2 += 4) {
          const brightness = 0.34 * data[i2] + 0.5 * data[i2 + 1] + 0.16 * data[i2 + 2];
          data[i2] = brightness;
          data[i2 + 1] = brightness;
          data[i2 + 2] = brightness;
        }
      };
    }
  });

  // node_modules/konva/lib/filters/HSL.js
  var HSL;
  var init_HSL = __esm({
    "node_modules/konva/lib/filters/HSL.js"() {
      init_Factory();
      init_Node();
      init_Validators();
      Factory.addGetterSetter(Node, "hue", 0, getNumberValidator(), Factory.afterSetFilter);
      Factory.addGetterSetter(Node, "saturation", 0, getNumberValidator(), Factory.afterSetFilter);
      Factory.addGetterSetter(Node, "luminance", 0, getNumberValidator(), Factory.afterSetFilter);
      HSL = function(imageData) {
        const data = imageData.data, nPixels = data.length, v = 1, s = Math.pow(2, this.saturation()), h2 = Math.abs(this.hue() + 360) % 360, l = this.luminance() * 127;
        const vsu = v * s * Math.cos(h2 * Math.PI / 180), vsw = v * s * Math.sin(h2 * Math.PI / 180);
        const rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
        const gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
        const br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
        let r, g, b2, a;
        for (let i2 = 0; i2 < nPixels; i2 += 4) {
          r = data[i2 + 0];
          g = data[i2 + 1];
          b2 = data[i2 + 2];
          a = data[i2 + 3];
          data[i2 + 0] = rr * r + rg * g + rb * b2 + l;
          data[i2 + 1] = gr * r + gg * g + gb * b2 + l;
          data[i2 + 2] = br * r + bg * g + bb * b2 + l;
          data[i2 + 3] = a;
        }
      };
    }
  });

  // node_modules/konva/lib/filters/HSV.js
  var HSV;
  var init_HSV = __esm({
    "node_modules/konva/lib/filters/HSV.js"() {
      init_Factory();
      init_Node();
      init_Validators();
      HSV = function(imageData) {
        const data = imageData.data, nPixels = data.length, v = Math.pow(2, this.value()), s = Math.pow(2, this.saturation()), h2 = Math.abs(this.hue() + 360) % 360;
        const vsu = v * s * Math.cos(h2 * Math.PI / 180), vsw = v * s * Math.sin(h2 * Math.PI / 180);
        const rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
        const gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
        const br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
        for (let i2 = 0; i2 < nPixels; i2 += 4) {
          const r = data[i2 + 0];
          const g = data[i2 + 1];
          const b2 = data[i2 + 2];
          const a = data[i2 + 3];
          data[i2 + 0] = rr * r + rg * g + rb * b2;
          data[i2 + 1] = gr * r + gg * g + gb * b2;
          data[i2 + 2] = br * r + bg * g + bb * b2;
          data[i2 + 3] = a;
        }
      };
      Factory.addGetterSetter(Node, "hue", 0, getNumberValidator(), Factory.afterSetFilter);
      Factory.addGetterSetter(Node, "saturation", 0, getNumberValidator(), Factory.afterSetFilter);
      Factory.addGetterSetter(Node, "value", 0, getNumberValidator(), Factory.afterSetFilter);
    }
  });

  // node_modules/konva/lib/filters/Invert.js
  var Invert;
  var init_Invert = __esm({
    "node_modules/konva/lib/filters/Invert.js"() {
      Invert = function(imageData) {
        const data = imageData.data, len = data.length;
        for (let i2 = 0; i2 < len; i2 += 4) {
          data[i2] = 255 - data[i2];
          data[i2 + 1] = 255 - data[i2 + 1];
          data[i2 + 2] = 255 - data[i2 + 2];
        }
      };
    }
  });

  // node_modules/konva/lib/filters/Kaleidoscope.js
  var ToPolar, FromPolar, Kaleidoscope;
  var init_Kaleidoscope = __esm({
    "node_modules/konva/lib/filters/Kaleidoscope.js"() {
      init_Factory();
      init_Node();
      init_Util();
      init_Validators();
      ToPolar = function(src, dst, opt) {
        const srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2;
        let rMax = Math.sqrt(xMid * xMid + yMid * yMid);
        let x = xSize - xMid;
        let y2 = ySize - yMid;
        const rad = Math.sqrt(x * x + y2 * y2);
        rMax = rad > rMax ? rad : rMax;
        const rSize = ySize, tSize = xSize;
        const conversion = 360 / tSize * Math.PI / 180;
        for (let theta = 0; theta < tSize; theta += 1) {
          const sin = Math.sin(theta * conversion);
          const cos = Math.cos(theta * conversion);
          for (let radius = 0; radius < rSize; radius += 1) {
            x = Math.floor(xMid + rMax * radius / rSize * cos);
            y2 = Math.floor(yMid + rMax * radius / rSize * sin);
            let i2 = (y2 * xSize + x) * 4;
            const r = srcPixels[i2 + 0];
            const g = srcPixels[i2 + 1];
            const b2 = srcPixels[i2 + 2];
            const a = srcPixels[i2 + 3];
            i2 = (theta + radius * xSize) * 4;
            dstPixels[i2 + 0] = r;
            dstPixels[i2 + 1] = g;
            dstPixels[i2 + 2] = b2;
            dstPixels[i2 + 3] = a;
          }
        }
      };
      FromPolar = function(src, dst, opt) {
        const srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2;
        let rMax = Math.sqrt(xMid * xMid + yMid * yMid);
        let x = xSize - xMid;
        let y2 = ySize - yMid;
        const rad = Math.sqrt(x * x + y2 * y2);
        rMax = rad > rMax ? rad : rMax;
        const rSize = ySize, tSize = xSize, phaseShift = opt.polarRotation || 0;
        let x1, y1;
        for (x = 0; x < xSize; x += 1) {
          for (y2 = 0; y2 < ySize; y2 += 1) {
            const dx = x - xMid;
            const dy = y2 - yMid;
            const radius = Math.sqrt(dx * dx + dy * dy) * rSize / rMax;
            let theta = (Math.atan2(dy, dx) * 180 / Math.PI + 360 + phaseShift) % 360;
            theta = theta * tSize / 360;
            x1 = Math.floor(theta);
            y1 = Math.floor(radius);
            let i2 = (y1 * xSize + x1) * 4;
            const r = srcPixels[i2 + 0];
            const g = srcPixels[i2 + 1];
            const b2 = srcPixels[i2 + 2];
            const a = srcPixels[i2 + 3];
            i2 = (y2 * xSize + x) * 4;
            dstPixels[i2 + 0] = r;
            dstPixels[i2 + 1] = g;
            dstPixels[i2 + 2] = b2;
            dstPixels[i2 + 3] = a;
          }
        }
      };
      Kaleidoscope = function(imageData) {
        const xSize = imageData.width, ySize = imageData.height;
        let x, y2, xoff, i2, r, g, b2, a, srcPos, dstPos;
        let power = Math.round(this.kaleidoscopePower());
        const angle = Math.round(this.kaleidoscopeAngle());
        const offset = Math.floor(xSize * (angle % 360) / 360);
        if (power < 1) {
          return;
        }
        const tempCanvas = Util.createCanvasElement();
        tempCanvas.width = xSize;
        tempCanvas.height = ySize;
        const scratchData = tempCanvas.getContext("2d").getImageData(0, 0, xSize, ySize);
        Util.releaseCanvas(tempCanvas);
        ToPolar(imageData, scratchData, {
          polarCenterX: xSize / 2,
          polarCenterY: ySize / 2
        });
        let minSectionSize = xSize / Math.pow(2, power);
        while (minSectionSize <= 8) {
          minSectionSize = minSectionSize * 2;
          power -= 1;
        }
        minSectionSize = Math.ceil(minSectionSize);
        let sectionSize = minSectionSize;
        let xStart = 0, xEnd = sectionSize, xDelta = 1;
        if (offset + minSectionSize > xSize) {
          xStart = sectionSize;
          xEnd = 0;
          xDelta = -1;
        }
        for (y2 = 0; y2 < ySize; y2 += 1) {
          for (x = xStart; x !== xEnd; x += xDelta) {
            xoff = Math.round(x + offset) % xSize;
            srcPos = (xSize * y2 + xoff) * 4;
            r = scratchData.data[srcPos + 0];
            g = scratchData.data[srcPos + 1];
            b2 = scratchData.data[srcPos + 2];
            a = scratchData.data[srcPos + 3];
            dstPos = (xSize * y2 + x) * 4;
            scratchData.data[dstPos + 0] = r;
            scratchData.data[dstPos + 1] = g;
            scratchData.data[dstPos + 2] = b2;
            scratchData.data[dstPos + 3] = a;
          }
        }
        for (y2 = 0; y2 < ySize; y2 += 1) {
          sectionSize = Math.floor(minSectionSize);
          for (i2 = 0; i2 < power; i2 += 1) {
            for (x = 0; x < sectionSize + 1; x += 1) {
              srcPos = (xSize * y2 + x) * 4;
              r = scratchData.data[srcPos + 0];
              g = scratchData.data[srcPos + 1];
              b2 = scratchData.data[srcPos + 2];
              a = scratchData.data[srcPos + 3];
              dstPos = (xSize * y2 + sectionSize * 2 - x - 1) * 4;
              scratchData.data[dstPos + 0] = r;
              scratchData.data[dstPos + 1] = g;
              scratchData.data[dstPos + 2] = b2;
              scratchData.data[dstPos + 3] = a;
            }
            sectionSize *= 2;
          }
        }
        FromPolar(scratchData, imageData, { polarRotation: 0 });
      };
      Factory.addGetterSetter(Node, "kaleidoscopePower", 2, getNumberValidator(), Factory.afterSetFilter);
      Factory.addGetterSetter(Node, "kaleidoscopeAngle", 0, getNumberValidator(), Factory.afterSetFilter);
    }
  });

  // node_modules/konva/lib/filters/Mask.js
  function pixelAt(idata, x, y2) {
    let idx = (y2 * idata.width + x) * 4;
    const d = [];
    d.push(idata.data[idx++], idata.data[idx++], idata.data[idx++], idata.data[idx++]);
    return d;
  }
  function rgbDistance(p1, p2) {
    return Math.sqrt(Math.pow(p1[0] - p2[0], 2) + Math.pow(p1[1] - p2[1], 2) + Math.pow(p1[2] - p2[2], 2));
  }
  function rgbMean(pTab) {
    const m = [0, 0, 0];
    for (let i2 = 0; i2 < pTab.length; i2++) {
      m[0] += pTab[i2][0];
      m[1] += pTab[i2][1];
      m[2] += pTab[i2][2];
    }
    m[0] /= pTab.length;
    m[1] /= pTab.length;
    m[2] /= pTab.length;
    return m;
  }
  function backgroundMask(idata, threshold) {
    const rgbv_no = pixelAt(idata, 0, 0);
    const rgbv_ne = pixelAt(idata, idata.width - 1, 0);
    const rgbv_so = pixelAt(idata, 0, idata.height - 1);
    const rgbv_se = pixelAt(idata, idata.width - 1, idata.height - 1);
    const thres = threshold || 10;
    if (rgbDistance(rgbv_no, rgbv_ne) < thres && rgbDistance(rgbv_ne, rgbv_se) < thres && rgbDistance(rgbv_se, rgbv_so) < thres && rgbDistance(rgbv_so, rgbv_no) < thres) {
      const mean = rgbMean([rgbv_ne, rgbv_no, rgbv_se, rgbv_so]);
      const mask = [];
      for (let i2 = 0; i2 < idata.width * idata.height; i2++) {
        const d = rgbDistance(mean, [
          idata.data[i2 * 4],
          idata.data[i2 * 4 + 1],
          idata.data[i2 * 4 + 2]
        ]);
        mask[i2] = d < thres ? 0 : 255;
      }
      return mask;
    }
  }
  function applyMask(idata, mask) {
    for (let i2 = 0; i2 < idata.width * idata.height; i2++) {
      idata.data[4 * i2 + 3] = mask[i2];
    }
  }
  function erodeMask(mask, sw, sh) {
    const weights = [1, 1, 1, 1, 0, 1, 1, 1, 1];
    const side = Math.round(Math.sqrt(weights.length));
    const halfSide = Math.floor(side / 2);
    const maskResult = [];
    for (let y2 = 0; y2 < sh; y2++) {
      for (let x = 0; x < sw; x++) {
        const so = y2 * sw + x;
        let a = 0;
        for (let cy = 0; cy < side; cy++) {
          for (let cx = 0; cx < side; cx++) {
            const scy = y2 + cy - halfSide;
            const scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
              const srcOff = scy * sw + scx;
              const wt = weights[cy * side + cx];
              a += mask[srcOff] * wt;
            }
          }
        }
        maskResult[so] = a === 255 * 8 ? 255 : 0;
      }
    }
    return maskResult;
  }
  function dilateMask(mask, sw, sh) {
    const weights = [1, 1, 1, 1, 1, 1, 1, 1, 1];
    const side = Math.round(Math.sqrt(weights.length));
    const halfSide = Math.floor(side / 2);
    const maskResult = [];
    for (let y2 = 0; y2 < sh; y2++) {
      for (let x = 0; x < sw; x++) {
        const so = y2 * sw + x;
        let a = 0;
        for (let cy = 0; cy < side; cy++) {
          for (let cx = 0; cx < side; cx++) {
            const scy = y2 + cy - halfSide;
            const scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
              const srcOff = scy * sw + scx;
              const wt = weights[cy * side + cx];
              a += mask[srcOff] * wt;
            }
          }
        }
        maskResult[so] = a >= 255 * 4 ? 255 : 0;
      }
    }
    return maskResult;
  }
  function smoothEdgeMask(mask, sw, sh) {
    const weights = [
      1 / 9,
      1 / 9,
      1 / 9,
      1 / 9,
      1 / 9,
      1 / 9,
      1 / 9,
      1 / 9,
      1 / 9
    ];
    const side = Math.round(Math.sqrt(weights.length));
    const halfSide = Math.floor(side / 2);
    const maskResult = [];
    for (let y2 = 0; y2 < sh; y2++) {
      for (let x = 0; x < sw; x++) {
        const so = y2 * sw + x;
        let a = 0;
        for (let cy = 0; cy < side; cy++) {
          for (let cx = 0; cx < side; cx++) {
            const scy = y2 + cy - halfSide;
            const scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
              const srcOff = scy * sw + scx;
              const wt = weights[cy * side + cx];
              a += mask[srcOff] * wt;
            }
          }
        }
        maskResult[so] = a;
      }
    }
    return maskResult;
  }
  var Mask;
  var init_Mask = __esm({
    "node_modules/konva/lib/filters/Mask.js"() {
      init_Factory();
      init_Node();
      init_Validators();
      Mask = function(imageData) {
        const threshold = this.threshold();
        let mask = backgroundMask(imageData, threshold);
        if (mask) {
          mask = erodeMask(mask, imageData.width, imageData.height);
          mask = dilateMask(mask, imageData.width, imageData.height);
          mask = smoothEdgeMask(mask, imageData.width, imageData.height);
          applyMask(imageData, mask);
        }
        return imageData;
      };
      Factory.addGetterSetter(Node, "threshold", 0, getNumberValidator(), Factory.afterSetFilter);
    }
  });

  // node_modules/konva/lib/filters/Noise.js
  var Noise;
  var init_Noise = __esm({
    "node_modules/konva/lib/filters/Noise.js"() {
      init_Factory();
      init_Node();
      init_Validators();
      Noise = function(imageData) {
        const amount = this.noise() * 255, data = imageData.data, nPixels = data.length, half = amount / 2;
        for (let i2 = 0; i2 < nPixels; i2 += 4) {
          data[i2 + 0] += half - 2 * half * Math.random();
          data[i2 + 1] += half - 2 * half * Math.random();
          data[i2 + 2] += half - 2 * half * Math.random();
        }
      };
      Factory.addGetterSetter(Node, "noise", 0.2, getNumberValidator(), Factory.afterSetFilter);
    }
  });

  // node_modules/konva/lib/filters/Pixelate.js
  var Pixelate;
  var init_Pixelate = __esm({
    "node_modules/konva/lib/filters/Pixelate.js"() {
      init_Factory();
      init_Util();
      init_Node();
      init_Validators();
      Pixelate = function(imageData) {
        let pixelSize = Math.ceil(this.pixelSize()), width = imageData.width, height = imageData.height, nBinsX = Math.ceil(width / pixelSize), nBinsY = Math.ceil(height / pixelSize), data = imageData.data;
        if (pixelSize <= 0) {
          Util.error("pixelSize value can not be <= 0");
          return;
        }
        for (let xBin = 0; xBin < nBinsX; xBin += 1) {
          for (let yBin = 0; yBin < nBinsY; yBin += 1) {
            let red = 0;
            let green = 0;
            let blue = 0;
            let alpha = 0;
            const xBinStart = xBin * pixelSize;
            const xBinEnd = xBinStart + pixelSize;
            const yBinStart = yBin * pixelSize;
            const yBinEnd = yBinStart + pixelSize;
            let pixelsInBin = 0;
            for (let x = xBinStart; x < xBinEnd; x += 1) {
              if (x >= width) {
                continue;
              }
              for (let y2 = yBinStart; y2 < yBinEnd; y2 += 1) {
                if (y2 >= height) {
                  continue;
                }
                const i2 = (width * y2 + x) * 4;
                red += data[i2 + 0];
                green += data[i2 + 1];
                blue += data[i2 + 2];
                alpha += data[i2 + 3];
                pixelsInBin += 1;
              }
            }
            red = red / pixelsInBin;
            green = green / pixelsInBin;
            blue = blue / pixelsInBin;
            alpha = alpha / pixelsInBin;
            for (let x = xBinStart; x < xBinEnd; x += 1) {
              if (x >= width) {
                continue;
              }
              for (let y2 = yBinStart; y2 < yBinEnd; y2 += 1) {
                if (y2 >= height) {
                  continue;
                }
                const i2 = (width * y2 + x) * 4;
                data[i2 + 0] = red;
                data[i2 + 1] = green;
                data[i2 + 2] = blue;
                data[i2 + 3] = alpha;
              }
            }
          }
        }
      };
      Factory.addGetterSetter(Node, "pixelSize", 8, getNumberValidator(), Factory.afterSetFilter);
    }
  });

  // node_modules/konva/lib/filters/Posterize.js
  var Posterize;
  var init_Posterize = __esm({
    "node_modules/konva/lib/filters/Posterize.js"() {
      init_Factory();
      init_Node();
      init_Validators();
      Posterize = function(imageData) {
        const levels = Math.round(this.levels() * 254) + 1, data = imageData.data, len = data.length, scale = 255 / levels;
        for (let i2 = 0; i2 < len; i2 += 1) {
          data[i2] = Math.floor(data[i2] / scale) * scale;
        }
      };
      Factory.addGetterSetter(Node, "levels", 0.5, getNumberValidator(), Factory.afterSetFilter);
    }
  });

  // node_modules/konva/lib/filters/RGB.js
  var RGB;
  var init_RGB = __esm({
    "node_modules/konva/lib/filters/RGB.js"() {
      init_Factory();
      init_Node();
      init_Validators();
      RGB = function(imageData) {
        const data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue();
        for (let i2 = 0; i2 < nPixels; i2 += 4) {
          const brightness = (0.34 * data[i2] + 0.5 * data[i2 + 1] + 0.16 * data[i2 + 2]) / 255;
          data[i2] = brightness * red;
          data[i2 + 1] = brightness * green;
          data[i2 + 2] = brightness * blue;
          data[i2 + 3] = data[i2 + 3];
        }
      };
      Factory.addGetterSetter(Node, "red", 0, function(val) {
        this._filterUpToDate = false;
        if (val > 255) {
          return 255;
        } else if (val < 0) {
          return 0;
        } else {
          return Math.round(val);
        }
      });
      Factory.addGetterSetter(Node, "green", 0, function(val) {
        this._filterUpToDate = false;
        if (val > 255) {
          return 255;
        } else if (val < 0) {
          return 0;
        } else {
          return Math.round(val);
        }
      });
      Factory.addGetterSetter(Node, "blue", 0, RGBComponent, Factory.afterSetFilter);
    }
  });

  // node_modules/konva/lib/filters/RGBA.js
  var RGBA;
  var init_RGBA = __esm({
    "node_modules/konva/lib/filters/RGBA.js"() {
      init_Factory();
      init_Node();
      init_Validators();
      RGBA = function(imageData) {
        const data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue(), alpha = this.alpha();
        for (let i2 = 0; i2 < nPixels; i2 += 4) {
          const ia = 1 - alpha;
          data[i2] = red * alpha + data[i2] * ia;
          data[i2 + 1] = green * alpha + data[i2 + 1] * ia;
          data[i2 + 2] = blue * alpha + data[i2 + 2] * ia;
        }
      };
      Factory.addGetterSetter(Node, "red", 0, function(val) {
        this._filterUpToDate = false;
        if (val > 255) {
          return 255;
        } else if (val < 0) {
          return 0;
        } else {
          return Math.round(val);
        }
      });
      Factory.addGetterSetter(Node, "green", 0, function(val) {
        this._filterUpToDate = false;
        if (val > 255) {
          return 255;
        } else if (val < 0) {
          return 0;
        } else {
          return Math.round(val);
        }
      });
      Factory.addGetterSetter(Node, "blue", 0, RGBComponent, Factory.afterSetFilter);
      Factory.addGetterSetter(Node, "alpha", 1, function(val) {
        this._filterUpToDate = false;
        if (val > 1) {
          return 1;
        } else if (val < 0) {
          return 0;
        } else {
          return val;
        }
      });
    }
  });

  // node_modules/konva/lib/filters/Sepia.js
  var Sepia;
  var init_Sepia = __esm({
    "node_modules/konva/lib/filters/Sepia.js"() {
      Sepia = function(imageData) {
        const data = imageData.data, nPixels = data.length;
        for (let i2 = 0; i2 < nPixels; i2 += 4) {
          const r = data[i2 + 0];
          const g = data[i2 + 1];
          const b2 = data[i2 + 2];
          data[i2 + 0] = Math.min(255, r * 0.393 + g * 0.769 + b2 * 0.189);
          data[i2 + 1] = Math.min(255, r * 0.349 + g * 0.686 + b2 * 0.168);
          data[i2 + 2] = Math.min(255, r * 0.272 + g * 0.534 + b2 * 0.131);
        }
      };
    }
  });

  // node_modules/konva/lib/filters/Solarize.js
  var Solarize;
  var init_Solarize = __esm({
    "node_modules/konva/lib/filters/Solarize.js"() {
      Solarize = function(imageData) {
        const threshold = 128;
        const d = imageData.data;
        for (let i2 = 0; i2 < d.length; i2 += 4) {
          const r = d[i2], g = d[i2 + 1], b2 = d[i2 + 2];
          const L = 0.2126 * r + 0.7152 * g + 0.0722 * b2;
          if (L >= threshold) {
            d[i2] = 255 - r;
            d[i2 + 1] = 255 - g;
            d[i2 + 2] = 255 - b2;
          }
        }
        return imageData;
      };
    }
  });

  // node_modules/konva/lib/filters/Threshold.js
  var Threshold;
  var init_Threshold = __esm({
    "node_modules/konva/lib/filters/Threshold.js"() {
      init_Factory();
      init_Node();
      init_Validators();
      Threshold = function(imageData) {
        const level = this.threshold() * 255, data = imageData.data, len = data.length;
        for (let i2 = 0; i2 < len; i2 += 1) {
          data[i2] = data[i2] < level ? 0 : 255;
        }
      };
      Factory.addGetterSetter(Node, "threshold", 0.5, getNumberValidator(), Factory.afterSetFilter);
    }
  });

  // node_modules/konva/lib/_FullInternals.js
  var Konva3;
  var init_FullInternals = __esm({
    "node_modules/konva/lib/_FullInternals.js"() {
      init_CoreInternals();
      init_Arc();
      init_Arrow();
      init_Circle();
      init_Ellipse();
      init_Image();
      init_Label();
      init_Line();
      init_Path();
      init_Rect();
      init_RegularPolygon();
      init_Ring();
      init_Sprite();
      init_Star();
      init_Text();
      init_TextPath();
      init_Transformer();
      init_Wedge();
      init_Blur();
      init_Brighten();
      init_Brightness();
      init_Contrast();
      init_Emboss();
      init_Enhance();
      init_Grayscale();
      init_HSL();
      init_HSV();
      init_Invert();
      init_Kaleidoscope();
      init_Mask();
      init_Noise();
      init_Pixelate();
      init_Posterize();
      init_RGB();
      init_RGBA();
      init_Sepia();
      init_Solarize();
      init_Threshold();
      Konva3 = Konva2.Util._assign(Konva2, {
        Arc,
        Arrow,
        Circle,
        Ellipse,
        Image: Image2,
        Label,
        Tag,
        Line,
        Path,
        Rect,
        RegularPolygon,
        Ring,
        Sprite,
        Star,
        Text: Text2,
        TextPath,
        Transformer,
        Wedge,
        Filters: {
          Blur,
          Brightness,
          Brighten,
          Contrast,
          Emboss,
          Enhance,
          Grayscale,
          HSL,
          HSV,
          Invert,
          Kaleidoscope,
          Mask,
          Noise,
          Pixelate,
          Posterize,
          RGB,
          RGBA,
          Sepia,
          Solarize,
          Threshold
        }
      });
    }
  });

  // node_modules/konva/lib/index.js
  var lib_exports = {};
  __export(lib_exports, {
    default: () => lib_default
  });
  var lib_default;
  var init_lib = __esm({
    "node_modules/konva/lib/index.js"() {
      init_FullInternals();
      lib_default = Konva3;
    }
  });

  // node_modules/@vue/devtools-api/lib/esm/env.js
  function getDevtoolsGlobalHook() {
    return getTarget().__VUE_DEVTOOLS_GLOBAL_HOOK__;
  }
  function getTarget() {
    return typeof navigator !== "undefined" && typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : {};
  }
  var isProxyAvailable;
  var init_env = __esm({
    "node_modules/@vue/devtools-api/lib/esm/env.js"() {
      isProxyAvailable = typeof Proxy === "function";
    }
  });

  // node_modules/@vue/devtools-api/lib/esm/const.js
  var HOOK_SETUP, HOOK_PLUGIN_SETTINGS_SET;
  var init_const = __esm({
    "node_modules/@vue/devtools-api/lib/esm/const.js"() {
      HOOK_SETUP = "devtools-plugin:setup";
      HOOK_PLUGIN_SETTINGS_SET = "plugin:settings:set";
    }
  });

  // node_modules/@vue/devtools-api/lib/esm/time.js
  function isPerformanceSupported() {
    var _a;
    if (supported2 !== void 0) {
      return supported2;
    }
    if (typeof window !== "undefined" && window.performance) {
      supported2 = true;
      perf2 = window.performance;
    } else if (typeof globalThis !== "undefined" && ((_a = globalThis.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
      supported2 = true;
      perf2 = globalThis.perf_hooks.performance;
    } else {
      supported2 = false;
    }
    return supported2;
  }
  function now2() {
    return isPerformanceSupported() ? perf2.now() : Date.now();
  }
  var supported2, perf2;
  var init_time = __esm({
    "node_modules/@vue/devtools-api/lib/esm/time.js"() {
    }
  });

  // node_modules/@vue/devtools-api/lib/esm/proxy.js
  var ApiProxy;
  var init_proxy = __esm({
    "node_modules/@vue/devtools-api/lib/esm/proxy.js"() {
      init_const();
      init_time();
      ApiProxy = class {
        constructor(plugin, hook) {
          this.target = null;
          this.targetQueue = [];
          this.onQueue = [];
          this.plugin = plugin;
          this.hook = hook;
          const defaultSettings = {};
          if (plugin.settings) {
            for (const id in plugin.settings) {
              const item = plugin.settings[id];
              defaultSettings[id] = item.defaultValue;
            }
          }
          const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
          let currentSettings = Object.assign({}, defaultSettings);
          try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
          } catch (e) {
          }
          this.fallbacks = {
            getSettings() {
              return currentSettings;
            },
            setSettings(value) {
              try {
                localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
              } catch (e) {
              }
              currentSettings = value;
            },
            now() {
              return now2();
            }
          };
          if (hook) {
            hook.on(HOOK_PLUGIN_SETTINGS_SET, (pluginId, value) => {
              if (pluginId === this.plugin.id) {
                this.fallbacks.setSettings(value);
              }
            });
          }
          this.proxiedOn = new Proxy({}, {
            get: (_target, prop) => {
              if (this.target) {
                return this.target.on[prop];
              } else {
                return (...args) => {
                  this.onQueue.push({
                    method: prop,
                    args
                  });
                };
              }
            }
          });
          this.proxiedTarget = new Proxy({}, {
            get: (_target, prop) => {
              if (this.target) {
                return this.target[prop];
              } else if (prop === "on") {
                return this.proxiedOn;
              } else if (Object.keys(this.fallbacks).includes(prop)) {
                return (...args) => {
                  this.targetQueue.push({
                    method: prop,
                    args,
                    resolve: () => {
                    }
                  });
                  return this.fallbacks[prop](...args);
                };
              } else {
                return (...args) => {
                  return new Promise((resolve2) => {
                    this.targetQueue.push({
                      method: prop,
                      args,
                      resolve: resolve2
                    });
                  });
                };
              }
            }
          });
        }
        async setRealTarget(target) {
          this.target = target;
          for (const item of this.onQueue) {
            this.target.on[item.method](...item.args);
          }
          for (const item of this.targetQueue) {
            item.resolve(await this.target[item.method](...item.args));
          }
        }
      };
    }
  });

  // node_modules/@vue/devtools-api/lib/esm/api/api.js
  var init_api = __esm({
    "node_modules/@vue/devtools-api/lib/esm/api/api.js"() {
    }
  });

  // node_modules/@vue/devtools-api/lib/esm/api/app.js
  var init_app = __esm({
    "node_modules/@vue/devtools-api/lib/esm/api/app.js"() {
    }
  });

  // node_modules/@vue/devtools-api/lib/esm/api/component.js
  var init_component = __esm({
    "node_modules/@vue/devtools-api/lib/esm/api/component.js"() {
    }
  });

  // node_modules/@vue/devtools-api/lib/esm/api/context.js
  var init_context = __esm({
    "node_modules/@vue/devtools-api/lib/esm/api/context.js"() {
    }
  });

  // node_modules/@vue/devtools-api/lib/esm/api/hooks.js
  var init_hooks = __esm({
    "node_modules/@vue/devtools-api/lib/esm/api/hooks.js"() {
    }
  });

  // node_modules/@vue/devtools-api/lib/esm/api/util.js
  var init_util = __esm({
    "node_modules/@vue/devtools-api/lib/esm/api/util.js"() {
    }
  });

  // node_modules/@vue/devtools-api/lib/esm/api/index.js
  var init_api2 = __esm({
    "node_modules/@vue/devtools-api/lib/esm/api/index.js"() {
      init_api();
      init_app();
      init_component();
      init_context();
      init_hooks();
      init_util();
    }
  });

  // node_modules/@vue/devtools-api/lib/esm/plugin.js
  var init_plugin = __esm({
    "node_modules/@vue/devtools-api/lib/esm/plugin.js"() {
    }
  });

  // node_modules/@vue/devtools-api/lib/esm/index.js
  function setupDevtoolsPlugin(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = getTarget();
    const hook = getDevtoolsGlobalHook();
    const enableProxy = isProxyAvailable && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) {
      hook.emit(HOOK_SETUP, pluginDescriptor, setupFn);
    } else {
      const proxy = enableProxy ? new ApiProxy(descriptor, hook) : null;
      const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
      list.push({
        pluginDescriptor: descriptor,
        setupFn,
        proxy
      });
      if (proxy) {
        setupFn(proxy.proxiedTarget);
      }
    }
  }
  var init_esm = __esm({
    "node_modules/@vue/devtools-api/lib/esm/index.js"() {
      init_env();
      init_const();
      init_proxy();
      init_api2();
      init_plugin();
      init_time();
    }
  });

  // node_modules/vuex/dist/vuex.esm-bundler.js
  function useStore(key) {
    if (key === void 0) key = null;
    return inject(key !== null ? key : storeKey);
  }
  function forEachValue(obj, fn) {
    Object.keys(obj).forEach(function(key) {
      return fn(obj[key], key);
    });
  }
  function isObject2(obj) {
    return obj !== null && typeof obj === "object";
  }
  function isPromise2(val) {
    return val && typeof val.then === "function";
  }
  function assert2(condition, msg) {
    if (!condition) {
      throw new Error("[vuex] " + msg);
    }
  }
  function partial(fn, arg) {
    return function() {
      return fn(arg);
    };
  }
  function genericSubscribe(fn, subs, options) {
    if (subs.indexOf(fn) < 0) {
      options && options.prepend ? subs.unshift(fn) : subs.push(fn);
    }
    return function() {
      var i2 = subs.indexOf(fn);
      if (i2 > -1) {
        subs.splice(i2, 1);
      }
    };
  }
  function resetStore(store2, hot) {
    store2._actions = /* @__PURE__ */ Object.create(null);
    store2._mutations = /* @__PURE__ */ Object.create(null);
    store2._wrappedGetters = /* @__PURE__ */ Object.create(null);
    store2._modulesNamespaceMap = /* @__PURE__ */ Object.create(null);
    var state4 = store2.state;
    installModule(store2, state4, [], store2._modules.root, true);
    resetStoreState(store2, state4, hot);
  }
  function resetStoreState(store2, state4, hot) {
    var oldState = store2._state;
    var oldScope = store2._scope;
    store2.getters = {};
    store2._makeLocalGettersCache = /* @__PURE__ */ Object.create(null);
    var wrappedGetters = store2._wrappedGetters;
    var computedObj = {};
    var computedCache = {};
    var scope = effectScope(true);
    scope.run(function() {
      forEachValue(wrappedGetters, function(fn, key) {
        computedObj[key] = partial(fn, store2);
        computedCache[key] = computed2(function() {
          return computedObj[key]();
        });
        Object.defineProperty(store2.getters, key, {
          get: function() {
            return computedCache[key].value;
          },
          enumerable: true
          // for local getters
        });
      });
    });
    store2._state = reactive({
      data: state4
    });
    store2._scope = scope;
    if (store2.strict) {
      enableStrictMode(store2);
    }
    if (oldState) {
      if (hot) {
        store2._withCommit(function() {
          oldState.data = null;
        });
      }
    }
    if (oldScope) {
      oldScope.stop();
    }
  }
  function installModule(store2, rootState, path, module, hot) {
    var isRoot = !path.length;
    var namespace = store2._modules.getNamespace(path);
    if (module.namespaced) {
      if (store2._modulesNamespaceMap[namespace] && true) {
        console.error("[vuex] duplicate namespace " + namespace + " for the namespaced module " + path.join("/"));
      }
      store2._modulesNamespaceMap[namespace] = module;
    }
    if (!isRoot && !hot) {
      var parentState = getNestedState(rootState, path.slice(0, -1));
      var moduleName = path[path.length - 1];
      store2._withCommit(function() {
        if (true) {
          if (moduleName in parentState) {
            console.warn(
              '[vuex] state field "' + moduleName + '" was overridden by a module with the same name at "' + path.join(".") + '"'
            );
          }
        }
        parentState[moduleName] = module.state;
      });
    }
    var local = module.context = makeLocalContext(store2, namespace, path);
    module.forEachMutation(function(mutation, key) {
      var namespacedType = namespace + key;
      registerMutation(store2, namespacedType, mutation, local);
    });
    module.forEachAction(function(action, key) {
      var type = action.root ? key : namespace + key;
      var handler = action.handler || action;
      registerAction(store2, type, handler, local);
    });
    module.forEachGetter(function(getter, key) {
      var namespacedType = namespace + key;
      registerGetter(store2, namespacedType, getter, local);
    });
    module.forEachChild(function(child, key) {
      installModule(store2, rootState, path.concat(key), child, hot);
    });
  }
  function makeLocalContext(store2, namespace, path) {
    var noNamespace = namespace === "";
    var local = {
      dispatch: noNamespace ? store2.dispatch : function(_type, _payload, _options) {
        var args = unifyObjectStyle(_type, _payload, _options);
        var payload = args.payload;
        var options = args.options;
        var type = args.type;
        if (!options || !options.root) {
          type = namespace + type;
          if (!store2._actions[type]) {
            console.error("[vuex] unknown local action type: " + args.type + ", global type: " + type);
            return;
          }
        }
        return store2.dispatch(type, payload);
      },
      commit: noNamespace ? store2.commit : function(_type, _payload, _options) {
        var args = unifyObjectStyle(_type, _payload, _options);
        var payload = args.payload;
        var options = args.options;
        var type = args.type;
        if (!options || !options.root) {
          type = namespace + type;
          if (!store2._mutations[type]) {
            console.error("[vuex] unknown local mutation type: " + args.type + ", global type: " + type);
            return;
          }
        }
        store2.commit(type, payload, options);
      }
    };
    Object.defineProperties(local, {
      getters: {
        get: noNamespace ? function() {
          return store2.getters;
        } : function() {
          return makeLocalGetters(store2, namespace);
        }
      },
      state: {
        get: function() {
          return getNestedState(store2.state, path);
        }
      }
    });
    return local;
  }
  function makeLocalGetters(store2, namespace) {
    if (!store2._makeLocalGettersCache[namespace]) {
      var gettersProxy = {};
      var splitPos = namespace.length;
      Object.keys(store2.getters).forEach(function(type) {
        if (type.slice(0, splitPos) !== namespace) {
          return;
        }
        var localType = type.slice(splitPos);
        Object.defineProperty(gettersProxy, localType, {
          get: function() {
            return store2.getters[type];
          },
          enumerable: true
        });
      });
      store2._makeLocalGettersCache[namespace] = gettersProxy;
    }
    return store2._makeLocalGettersCache[namespace];
  }
  function registerMutation(store2, type, handler, local) {
    var entry = store2._mutations[type] || (store2._mutations[type] = []);
    entry.push(function wrappedMutationHandler(payload) {
      handler.call(store2, local.state, payload);
    });
  }
  function registerAction(store2, type, handler, local) {
    var entry = store2._actions[type] || (store2._actions[type] = []);
    entry.push(function wrappedActionHandler(payload) {
      var res = handler.call(store2, {
        dispatch: local.dispatch,
        commit: local.commit,
        getters: local.getters,
        state: local.state,
        rootGetters: store2.getters,
        rootState: store2.state
      }, payload);
      if (!isPromise2(res)) {
        res = Promise.resolve(res);
      }
      if (store2._devtoolHook) {
        return res.catch(function(err) {
          store2._devtoolHook.emit("vuex:error", err);
          throw err;
        });
      } else {
        return res;
      }
    });
  }
  function registerGetter(store2, type, rawGetter, local) {
    if (store2._wrappedGetters[type]) {
      if (true) {
        console.error("[vuex] duplicate getter key: " + type);
      }
      return;
    }
    store2._wrappedGetters[type] = function wrappedGetter(store3) {
      return rawGetter(
        local.state,
        // local state
        local.getters,
        // local getters
        store3.state,
        // root state
        store3.getters
        // root getters
      );
    };
  }
  function enableStrictMode(store2) {
    watch2(function() {
      return store2._state.data;
    }, function() {
      if (true) {
        assert2(store2._committing, "do not mutate vuex store state outside mutation handlers.");
      }
    }, { deep: true, flush: "sync" });
  }
  function getNestedState(state4, path) {
    return path.reduce(function(state5, key) {
      return state5[key];
    }, state4);
  }
  function unifyObjectStyle(type, payload, options) {
    if (isObject2(type) && type.type) {
      options = payload;
      payload = type;
      type = type.type;
    }
    if (true) {
      assert2(typeof type === "string", "expects string as the type, but found " + typeof type + ".");
    }
    return { type, payload, options };
  }
  function addDevtools(app, store2) {
    setupDevtoolsPlugin(
      {
        id: "org.vuejs.vuex",
        app,
        label: "Vuex",
        homepage: "https://next.vuex.vuejs.org/",
        logo: "https://vuejs.org/images/icons/favicon-96x96.png",
        packageName: "vuex",
        componentStateTypes: [LABEL_VUEX_BINDINGS]
      },
      function(api) {
        api.addTimelineLayer({
          id: MUTATIONS_LAYER_ID,
          label: "Vuex Mutations",
          color: COLOR_LIME_500
        });
        api.addTimelineLayer({
          id: ACTIONS_LAYER_ID,
          label: "Vuex Actions",
          color: COLOR_LIME_500
        });
        api.addInspector({
          id: INSPECTOR_ID,
          label: "Vuex",
          icon: "storage",
          treeFilterPlaceholder: "Filter stores..."
        });
        api.on.getInspectorTree(function(payload) {
          if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
            if (payload.filter) {
              var nodes = [];
              flattenStoreForInspectorTree(nodes, store2._modules.root, payload.filter, "");
              payload.rootNodes = nodes;
            } else {
              payload.rootNodes = [
                formatStoreForInspectorTree(store2._modules.root, "")
              ];
            }
          }
        });
        api.on.getInspectorState(function(payload) {
          if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
            var modulePath = payload.nodeId;
            makeLocalGetters(store2, modulePath);
            payload.state = formatStoreForInspectorState(
              getStoreModule(store2._modules, modulePath),
              modulePath === "root" ? store2.getters : store2._makeLocalGettersCache,
              modulePath
            );
          }
        });
        api.on.editInspectorState(function(payload) {
          if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
            var modulePath = payload.nodeId;
            var path = payload.path;
            if (modulePath !== "root") {
              path = modulePath.split("/").filter(Boolean).concat(path);
            }
            store2._withCommit(function() {
              payload.set(store2._state.data, path, payload.state.value);
            });
          }
        });
        store2.subscribe(function(mutation, state4) {
          var data = {};
          if (mutation.payload) {
            data.payload = mutation.payload;
          }
          data.state = state4;
          api.notifyComponentUpdate();
          api.sendInspectorTree(INSPECTOR_ID);
          api.sendInspectorState(INSPECTOR_ID);
          api.addTimelineEvent({
            layerId: MUTATIONS_LAYER_ID,
            event: {
              time: Date.now(),
              title: mutation.type,
              data
            }
          });
        });
        store2.subscribeAction({
          before: function(action, state4) {
            var data = {};
            if (action.payload) {
              data.payload = action.payload;
            }
            action._id = actionId++;
            action._time = Date.now();
            data.state = state4;
            api.addTimelineEvent({
              layerId: ACTIONS_LAYER_ID,
              event: {
                time: action._time,
                title: action.type,
                groupId: action._id,
                subtitle: "start",
                data
              }
            });
          },
          after: function(action, state4) {
            var data = {};
            var duration = Date.now() - action._time;
            data.duration = {
              _custom: {
                type: "duration",
                display: duration + "ms",
                tooltip: "Action duration",
                value: duration
              }
            };
            if (action.payload) {
              data.payload = action.payload;
            }
            data.state = state4;
            api.addTimelineEvent({
              layerId: ACTIONS_LAYER_ID,
              event: {
                time: Date.now(),
                title: action.type,
                groupId: action._id,
                subtitle: "end",
                data
              }
            });
          }
        });
      }
    );
  }
  function extractNameFromPath(path) {
    return path && path !== "root" ? path.split("/").slice(-2, -1)[0] : "Root";
  }
  function formatStoreForInspectorTree(module, path) {
    return {
      id: path || "root",
      // all modules end with a `/`, we want the last segment only
      // cart/ -> cart
      // nested/cart/ -> cart
      label: extractNameFromPath(path),
      tags: module.namespaced ? [TAG_NAMESPACED] : [],
      children: Object.keys(module._children).map(
        function(moduleName) {
          return formatStoreForInspectorTree(
            module._children[moduleName],
            path + moduleName + "/"
          );
        }
      )
    };
  }
  function flattenStoreForInspectorTree(result, module, filter5, path) {
    if (path.includes(filter5)) {
      result.push({
        id: path || "root",
        label: path.endsWith("/") ? path.slice(0, path.length - 1) : path || "Root",
        tags: module.namespaced ? [TAG_NAMESPACED] : []
      });
    }
    Object.keys(module._children).forEach(function(moduleName) {
      flattenStoreForInspectorTree(result, module._children[moduleName], filter5, path + moduleName + "/");
    });
  }
  function formatStoreForInspectorState(module, getters4, path) {
    getters4 = path === "root" ? getters4 : getters4[path];
    var gettersKeys = Object.keys(getters4);
    var storeState = {
      state: Object.keys(module.state).map(function(key) {
        return {
          key,
          editable: true,
          value: module.state[key]
        };
      })
    };
    if (gettersKeys.length) {
      var tree = transformPathsToObjectTree(getters4);
      storeState.getters = Object.keys(tree).map(function(key) {
        return {
          key: key.endsWith("/") ? extractNameFromPath(key) : key,
          editable: false,
          value: canThrow(function() {
            return tree[key];
          })
        };
      });
    }
    return storeState;
  }
  function transformPathsToObjectTree(getters4) {
    var result = {};
    Object.keys(getters4).forEach(function(key) {
      var path = key.split("/");
      if (path.length > 1) {
        var target = result;
        var leafKey = path.pop();
        path.forEach(function(p2) {
          if (!target[p2]) {
            target[p2] = {
              _custom: {
                value: {},
                display: p2,
                tooltip: "Module",
                abstract: true
              }
            };
          }
          target = target[p2]._custom.value;
        });
        target[leafKey] = canThrow(function() {
          return getters4[key];
        });
      } else {
        result[key] = canThrow(function() {
          return getters4[key];
        });
      }
    });
    return result;
  }
  function getStoreModule(moduleMap, path) {
    var names2 = path.split("/").filter(function(n) {
      return n;
    });
    return names2.reduce(
      function(module, moduleName, i2) {
        var child = module[moduleName];
        if (!child) {
          throw new Error('Missing module "' + moduleName + '" for path "' + path + '".');
        }
        return i2 === names2.length - 1 ? child : child._children;
      },
      path === "root" ? moduleMap : moduleMap.root._children
    );
  }
  function canThrow(cb) {
    try {
      return cb();
    } catch (e) {
      return e;
    }
  }
  function update2(path, targetModule, newModule) {
    if (true) {
      assertRawModule(path, newModule);
    }
    targetModule.update(newModule);
    if (newModule.modules) {
      for (var key in newModule.modules) {
        if (!targetModule.getChild(key)) {
          if (true) {
            console.warn(
              "[vuex] trying to add a new module '" + key + "' on hot reloading, manual reload is needed"
            );
          }
          return;
        }
        update2(
          path.concat(key),
          targetModule.getChild(key),
          newModule.modules[key]
        );
      }
    }
  }
  function assertRawModule(path, rawModule) {
    Object.keys(assertTypes).forEach(function(key) {
      if (!rawModule[key]) {
        return;
      }
      var assertOptions2 = assertTypes[key];
      forEachValue(rawModule[key], function(value, type) {
        assert2(
          assertOptions2.assert(value),
          makeAssertionMessage(path, key, type, value, assertOptions2.expected)
        );
      });
    });
  }
  function makeAssertionMessage(path, key, type, value, expected) {
    var buf = key + " should be " + expected + ' but "' + key + "." + type + '"';
    if (path.length > 0) {
      buf += ' in module "' + path.join(".") + '"';
    }
    buf += " is " + JSON.stringify(value) + ".";
    return buf;
  }
  function createStore(options) {
    return new Store(options);
  }
  function normalizeMap(map3) {
    if (!isValidMap(map3)) {
      return [];
    }
    return Array.isArray(map3) ? map3.map(function(key) {
      return { key, val: key };
    }) : Object.keys(map3).map(function(key) {
      return { key, val: map3[key] };
    });
  }
  function isValidMap(map3) {
    return Array.isArray(map3) || isObject2(map3);
  }
  function normalizeNamespace(fn) {
    return function(namespace, map3) {
      if (typeof namespace !== "string") {
        map3 = namespace;
        namespace = "";
      } else if (namespace.charAt(namespace.length - 1) !== "/") {
        namespace += "/";
      }
      return fn(namespace, map3);
    };
  }
  function getModuleByNamespace(store2, helper, namespace) {
    var module = store2._modulesNamespaceMap[namespace];
    if (!module) {
      console.error("[vuex] module namespace not found in " + helper + "(): " + namespace);
    }
    return module;
  }
  var storeKey, LABEL_VUEX_BINDINGS, MUTATIONS_LAYER_ID, ACTIONS_LAYER_ID, INSPECTOR_ID, actionId, COLOR_LIME_500, COLOR_DARK, COLOR_WHITE, TAG_NAMESPACED, Module, prototypeAccessors$1, ModuleCollection, functionAssert, objectAssert, assertTypes, Store, prototypeAccessors, mapState, mapMutations, mapGetters, mapActions;
  var init_vuex_esm_bundler = __esm({
    "node_modules/vuex/dist/vuex.esm-bundler.js"() {
      init_vue_esm_bundler();
      init_esm();
      /*!
       * vuex v4.1.0
       * (c) 2022 Evan You
       * @license MIT
       */
      storeKey = "store";
      LABEL_VUEX_BINDINGS = "vuex bindings";
      MUTATIONS_LAYER_ID = "vuex:mutations";
      ACTIONS_LAYER_ID = "vuex:actions";
      INSPECTOR_ID = "vuex";
      actionId = 0;
      COLOR_LIME_500 = 8702998;
      COLOR_DARK = 6710886;
      COLOR_WHITE = 16777215;
      TAG_NAMESPACED = {
        label: "namespaced",
        textColor: COLOR_WHITE,
        backgroundColor: COLOR_DARK
      };
      Module = function Module2(rawModule, runtime) {
        this.runtime = runtime;
        this._children = /* @__PURE__ */ Object.create(null);
        this._rawModule = rawModule;
        var rawState = rawModule.state;
        this.state = (typeof rawState === "function" ? rawState() : rawState) || {};
      };
      prototypeAccessors$1 = { namespaced: { configurable: true } };
      prototypeAccessors$1.namespaced.get = function() {
        return !!this._rawModule.namespaced;
      };
      Module.prototype.addChild = function addChild(key, module) {
        this._children[key] = module;
      };
      Module.prototype.removeChild = function removeChild(key) {
        delete this._children[key];
      };
      Module.prototype.getChild = function getChild(key) {
        return this._children[key];
      };
      Module.prototype.hasChild = function hasChild(key) {
        return key in this._children;
      };
      Module.prototype.update = function update(rawModule) {
        this._rawModule.namespaced = rawModule.namespaced;
        if (rawModule.actions) {
          this._rawModule.actions = rawModule.actions;
        }
        if (rawModule.mutations) {
          this._rawModule.mutations = rawModule.mutations;
        }
        if (rawModule.getters) {
          this._rawModule.getters = rawModule.getters;
        }
      };
      Module.prototype.forEachChild = function forEachChild(fn) {
        forEachValue(this._children, fn);
      };
      Module.prototype.forEachGetter = function forEachGetter(fn) {
        if (this._rawModule.getters) {
          forEachValue(this._rawModule.getters, fn);
        }
      };
      Module.prototype.forEachAction = function forEachAction(fn) {
        if (this._rawModule.actions) {
          forEachValue(this._rawModule.actions, fn);
        }
      };
      Module.prototype.forEachMutation = function forEachMutation(fn) {
        if (this._rawModule.mutations) {
          forEachValue(this._rawModule.mutations, fn);
        }
      };
      Object.defineProperties(Module.prototype, prototypeAccessors$1);
      ModuleCollection = function ModuleCollection2(rawRootModule) {
        this.register([], rawRootModule, false);
      };
      ModuleCollection.prototype.get = function get(path) {
        return path.reduce(function(module, key) {
          return module.getChild(key);
        }, this.root);
      };
      ModuleCollection.prototype.getNamespace = function getNamespace(path) {
        var module = this.root;
        return path.reduce(function(namespace, key) {
          module = module.getChild(key);
          return namespace + (module.namespaced ? key + "/" : "");
        }, "");
      };
      ModuleCollection.prototype.update = function update$1(rawRootModule) {
        update2([], this.root, rawRootModule);
      };
      ModuleCollection.prototype.register = function register(path, rawModule, runtime) {
        var this$1$1 = this;
        if (runtime === void 0) runtime = true;
        if (true) {
          assertRawModule(path, rawModule);
        }
        var newModule = new Module(rawModule, runtime);
        if (path.length === 0) {
          this.root = newModule;
        } else {
          var parent = this.get(path.slice(0, -1));
          parent.addChild(path[path.length - 1], newModule);
        }
        if (rawModule.modules) {
          forEachValue(rawModule.modules, function(rawChildModule, key) {
            this$1$1.register(path.concat(key), rawChildModule, runtime);
          });
        }
      };
      ModuleCollection.prototype.unregister = function unregister(path) {
        var parent = this.get(path.slice(0, -1));
        var key = path[path.length - 1];
        var child = parent.getChild(key);
        if (!child) {
          if (true) {
            console.warn(
              "[vuex] trying to unregister module '" + key + "', which is not registered"
            );
          }
          return;
        }
        if (!child.runtime) {
          return;
        }
        parent.removeChild(key);
      };
      ModuleCollection.prototype.isRegistered = function isRegistered(path) {
        var parent = this.get(path.slice(0, -1));
        var key = path[path.length - 1];
        if (parent) {
          return parent.hasChild(key);
        }
        return false;
      };
      functionAssert = {
        assert: function(value) {
          return typeof value === "function";
        },
        expected: "function"
      };
      objectAssert = {
        assert: function(value) {
          return typeof value === "function" || typeof value === "object" && typeof value.handler === "function";
        },
        expected: 'function or object with "handler" function'
      };
      assertTypes = {
        getters: functionAssert,
        mutations: functionAssert,
        actions: objectAssert
      };
      Store = function Store2(options) {
        var this$1$1 = this;
        if (options === void 0) options = {};
        if (true) {
          assert2(typeof Promise !== "undefined", "vuex requires a Promise polyfill in this browser.");
          assert2(this instanceof Store2, "store must be called with the new operator.");
        }
        var plugins = options.plugins;
        if (plugins === void 0) plugins = [];
        var strict = options.strict;
        if (strict === void 0) strict = false;
        var devtools2 = options.devtools;
        this._committing = false;
        this._actions = /* @__PURE__ */ Object.create(null);
        this._actionSubscribers = [];
        this._mutations = /* @__PURE__ */ Object.create(null);
        this._wrappedGetters = /* @__PURE__ */ Object.create(null);
        this._modules = new ModuleCollection(options);
        this._modulesNamespaceMap = /* @__PURE__ */ Object.create(null);
        this._subscribers = [];
        this._makeLocalGettersCache = /* @__PURE__ */ Object.create(null);
        this._scope = null;
        this._devtools = devtools2;
        var store2 = this;
        var ref2 = this;
        var dispatch2 = ref2.dispatch;
        var commit2 = ref2.commit;
        this.dispatch = function boundDispatch(type, payload) {
          return dispatch2.call(store2, type, payload);
        };
        this.commit = function boundCommit(type, payload, options2) {
          return commit2.call(store2, type, payload, options2);
        };
        this.strict = strict;
        var state4 = this._modules.root.state;
        installModule(this, state4, [], this._modules.root);
        resetStoreState(this, state4);
        plugins.forEach(function(plugin) {
          return plugin(this$1$1);
        });
      };
      prototypeAccessors = { state: { configurable: true } };
      Store.prototype.install = function install(app, injectKey) {
        app.provide(injectKey || storeKey, this);
        app.config.globalProperties.$store = this;
        var useDevtools = this._devtools !== void 0 ? this._devtools : true;
        if (useDevtools) {
          addDevtools(app, this);
        }
      };
      prototypeAccessors.state.get = function() {
        return this._state.data;
      };
      prototypeAccessors.state.set = function(v) {
        if (true) {
          assert2(false, "use store.replaceState() to explicit replace store state.");
        }
      };
      Store.prototype.commit = function commit(_type, _payload, _options) {
        var this$1$1 = this;
        var ref2 = unifyObjectStyle(_type, _payload, _options);
        var type = ref2.type;
        var payload = ref2.payload;
        var options = ref2.options;
        var mutation = { type, payload };
        var entry = this._mutations[type];
        if (!entry) {
          if (true) {
            console.error("[vuex] unknown mutation type: " + type);
          }
          return;
        }
        this._withCommit(function() {
          entry.forEach(function commitIterator(handler) {
            handler(payload);
          });
        });
        this._subscribers.slice().forEach(function(sub) {
          return sub(mutation, this$1$1.state);
        });
        if (options && options.silent) {
          console.warn(
            "[vuex] mutation type: " + type + ". Silent option has been removed. Use the filter functionality in the vue-devtools"
          );
        }
      };
      Store.prototype.dispatch = function dispatch(_type, _payload) {
        var this$1$1 = this;
        var ref2 = unifyObjectStyle(_type, _payload);
        var type = ref2.type;
        var payload = ref2.payload;
        var action = { type, payload };
        var entry = this._actions[type];
        if (!entry) {
          if (true) {
            console.error("[vuex] unknown action type: " + type);
          }
          return;
        }
        try {
          this._actionSubscribers.slice().filter(function(sub) {
            return sub.before;
          }).forEach(function(sub) {
            return sub.before(action, this$1$1.state);
          });
        } catch (e) {
          if (true) {
            console.warn("[vuex] error in before action subscribers: ");
            console.error(e);
          }
        }
        var result = entry.length > 1 ? Promise.all(entry.map(function(handler) {
          return handler(payload);
        })) : entry[0](payload);
        return new Promise(function(resolve2, reject) {
          result.then(function(res) {
            try {
              this$1$1._actionSubscribers.filter(function(sub) {
                return sub.after;
              }).forEach(function(sub) {
                return sub.after(action, this$1$1.state);
              });
            } catch (e) {
              if (true) {
                console.warn("[vuex] error in after action subscribers: ");
                console.error(e);
              }
            }
            resolve2(res);
          }, function(error) {
            try {
              this$1$1._actionSubscribers.filter(function(sub) {
                return sub.error;
              }).forEach(function(sub) {
                return sub.error(action, this$1$1.state, error);
              });
            } catch (e) {
              if (true) {
                console.warn("[vuex] error in error action subscribers: ");
                console.error(e);
              }
            }
            reject(error);
          });
        });
      };
      Store.prototype.subscribe = function subscribe(fn, options) {
        return genericSubscribe(fn, this._subscribers, options);
      };
      Store.prototype.subscribeAction = function subscribeAction(fn, options) {
        var subs = typeof fn === "function" ? { before: fn } : fn;
        return genericSubscribe(subs, this._actionSubscribers, options);
      };
      Store.prototype.watch = function watch$1(getter, cb, options) {
        var this$1$1 = this;
        if (true) {
          assert2(typeof getter === "function", "store.watch only accepts a function.");
        }
        return watch2(function() {
          return getter(this$1$1.state, this$1$1.getters);
        }, cb, Object.assign({}, options));
      };
      Store.prototype.replaceState = function replaceState(state4) {
        var this$1$1 = this;
        this._withCommit(function() {
          this$1$1._state.data = state4;
        });
      };
      Store.prototype.registerModule = function registerModule(path, rawModule, options) {
        if (options === void 0) options = {};
        if (typeof path === "string") {
          path = [path];
        }
        if (true) {
          assert2(Array.isArray(path), "module path must be a string or an Array.");
          assert2(path.length > 0, "cannot register the root module by using registerModule.");
        }
        this._modules.register(path, rawModule);
        installModule(this, this.state, path, this._modules.get(path), options.preserveState);
        resetStoreState(this, this.state);
      };
      Store.prototype.unregisterModule = function unregisterModule(path) {
        var this$1$1 = this;
        if (typeof path === "string") {
          path = [path];
        }
        if (true) {
          assert2(Array.isArray(path), "module path must be a string or an Array.");
        }
        this._modules.unregister(path);
        this._withCommit(function() {
          var parentState = getNestedState(this$1$1.state, path.slice(0, -1));
          delete parentState[path[path.length - 1]];
        });
        resetStore(this);
      };
      Store.prototype.hasModule = function hasModule(path) {
        if (typeof path === "string") {
          path = [path];
        }
        if (true) {
          assert2(Array.isArray(path), "module path must be a string or an Array.");
        }
        return this._modules.isRegistered(path);
      };
      Store.prototype.hotUpdate = function hotUpdate(newOptions) {
        this._modules.update(newOptions);
        resetStore(this, true);
      };
      Store.prototype._withCommit = function _withCommit(fn) {
        var committing = this._committing;
        this._committing = true;
        fn();
        this._committing = committing;
      };
      Object.defineProperties(Store.prototype, prototypeAccessors);
      mapState = normalizeNamespace(function(namespace, states) {
        var res = {};
        if (!isValidMap(states)) {
          console.error("[vuex] mapState: mapper parameter must be either an Array or an Object");
        }
        normalizeMap(states).forEach(function(ref2) {
          var key = ref2.key;
          var val = ref2.val;
          res[key] = function mappedState() {
            var state4 = this.$store.state;
            var getters4 = this.$store.getters;
            if (namespace) {
              var module = getModuleByNamespace(this.$store, "mapState", namespace);
              if (!module) {
                return;
              }
              state4 = module.context.state;
              getters4 = module.context.getters;
            }
            return typeof val === "function" ? val.call(this, state4, getters4) : state4[val];
          };
          res[key].vuex = true;
        });
        return res;
      });
      mapMutations = normalizeNamespace(function(namespace, mutations4) {
        var res = {};
        if (!isValidMap(mutations4)) {
          console.error("[vuex] mapMutations: mapper parameter must be either an Array or an Object");
        }
        normalizeMap(mutations4).forEach(function(ref2) {
          var key = ref2.key;
          var val = ref2.val;
          res[key] = function mappedMutation() {
            var args = [], len = arguments.length;
            while (len--) args[len] = arguments[len];
            var commit2 = this.$store.commit;
            if (namespace) {
              var module = getModuleByNamespace(this.$store, "mapMutations", namespace);
              if (!module) {
                return;
              }
              commit2 = module.context.commit;
            }
            return typeof val === "function" ? val.apply(this, [commit2].concat(args)) : commit2.apply(this.$store, [val].concat(args));
          };
        });
        return res;
      });
      mapGetters = normalizeNamespace(function(namespace, getters4) {
        var res = {};
        if (!isValidMap(getters4)) {
          console.error("[vuex] mapGetters: mapper parameter must be either an Array or an Object");
        }
        normalizeMap(getters4).forEach(function(ref2) {
          var key = ref2.key;
          var val = ref2.val;
          val = namespace + val;
          res[key] = function mappedGetter() {
            if (namespace && !getModuleByNamespace(this.$store, "mapGetters", namespace)) {
              return;
            }
            if (!(val in this.$store.getters)) {
              console.error("[vuex] unknown getter: " + val);
              return;
            }
            return this.$store.getters[val];
          };
          res[key].vuex = true;
        });
        return res;
      });
      mapActions = normalizeNamespace(function(namespace, actions4) {
        var res = {};
        if (!isValidMap(actions4)) {
          console.error("[vuex] mapActions: mapper parameter must be either an Array or an Object");
        }
        normalizeMap(actions4).forEach(function(ref2) {
          var key = ref2.key;
          var val = ref2.val;
          res[key] = function mappedAction() {
            var args = [], len = arguments.length;
            while (len--) args[len] = arguments[len];
            var dispatch2 = this.$store.dispatch;
            if (namespace) {
              var module = getModuleByNamespace(this.$store, "mapActions", namespace);
              if (!module) {
                return;
              }
              dispatch2 = module.context.dispatch;
            }
            return typeof val === "function" ? val.apply(this, [dispatch2].concat(args)) : dispatch2.apply(this.$store, [val].concat(args));
          };
        });
        return res;
      });
    }
  });

  // node_modules/lodash/lodash.js
  var require_lodash = __commonJS({
    "node_modules/lodash/lodash.js"(exports, module) {
      /**
       * @license
       * Lodash <https://lodash.com/>
       * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
       * Released under MIT license <https://lodash.com/license>
       * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
       * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
       */
      (function() {
        var undefined2;
        var VERSION3 = "4.18.1";
        var LARGE_ARRAY_SIZE = 200;
        var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`", INVALID_TEMPL_IMPORTS_ERROR_TEXT = "Invalid `imports` option passed into `_.template`";
        var HASH_UNDEFINED = "__lodash_hash_undefined__";
        var MAX_MEMOIZE_SIZE = 500;
        var PLACEHOLDER = "__lodash_placeholder__";
        var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
        var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
        var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
        var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
        var HOT_COUNT = 800, HOT_SPAN = 16;
        var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
        var INFINITY = 1 / 0, MAX_SAFE_INTEGER2 = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
        var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
        var wrapFlags = [
          ["ary", WRAP_ARY_FLAG],
          ["bind", WRAP_BIND_FLAG],
          ["bindKey", WRAP_BIND_KEY_FLAG],
          ["curry", WRAP_CURRY_FLAG],
          ["curryRight", WRAP_CURRY_RIGHT_FLAG],
          ["flip", WRAP_FLIP_FLAG],
          ["partial", WRAP_PARTIAL_FLAG],
          ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
          ["rearg", WRAP_REARG_FLAG]
        ];
        var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
        var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
        var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
        var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
        var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
        var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
        var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
        var reTrimStart = /^\s+/;
        var reWhitespace = /\s/;
        var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
        var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
        var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
        var reEscapeChar = /\\(\\)?/g;
        var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
        var reFlags = /\w*$/;
        var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
        var reIsBinary = /^0b[01]+$/i;
        var reIsHostCtor = /^\[object .+?Constructor\]$/;
        var reIsOctal = /^0o[0-7]+$/i;
        var reIsUint = /^(?:0|[1-9]\d*)$/;
        var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
        var reNoMatch = /($^)/;
        var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
        var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
        var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
        var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
        var reApos = RegExp(rsApos, "g");
        var reComboMark = RegExp(rsCombo, "g");
        var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
        var reUnicodeWord = RegExp([
          rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
          rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
          rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
          rsUpper + "+" + rsOptContrUpper,
          rsOrdUpper,
          rsOrdLower,
          rsDigits,
          rsEmoji
        ].join("|"), "g");
        var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
        var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
        var contextProps = [
          "Array",
          "Buffer",
          "DataView",
          "Date",
          "Error",
          "Float32Array",
          "Float64Array",
          "Function",
          "Int8Array",
          "Int16Array",
          "Int32Array",
          "Map",
          "Math",
          "Object",
          "Promise",
          "RegExp",
          "Set",
          "String",
          "Symbol",
          "TypeError",
          "Uint8Array",
          "Uint8ClampedArray",
          "Uint16Array",
          "Uint32Array",
          "WeakMap",
          "_",
          "clearTimeout",
          "isFinite",
          "parseInt",
          "setTimeout"
        ];
        var templateCounter = -1;
        var typedArrayTags = {};
        typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
        typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
        var cloneableTags = {};
        cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
        cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
        var deburredLetters = {
          // Latin-1 Supplement block.
          "\xC0": "A",
          "\xC1": "A",
          "\xC2": "A",
          "\xC3": "A",
          "\xC4": "A",
          "\xC5": "A",
          "\xE0": "a",
          "\xE1": "a",
          "\xE2": "a",
          "\xE3": "a",
          "\xE4": "a",
          "\xE5": "a",
          "\xC7": "C",
          "\xE7": "c",
          "\xD0": "D",
          "\xF0": "d",
          "\xC8": "E",
          "\xC9": "E",
          "\xCA": "E",
          "\xCB": "E",
          "\xE8": "e",
          "\xE9": "e",
          "\xEA": "e",
          "\xEB": "e",
          "\xCC": "I",
          "\xCD": "I",
          "\xCE": "I",
          "\xCF": "I",
          "\xEC": "i",
          "\xED": "i",
          "\xEE": "i",
          "\xEF": "i",
          "\xD1": "N",
          "\xF1": "n",
          "\xD2": "O",
          "\xD3": "O",
          "\xD4": "O",
          "\xD5": "O",
          "\xD6": "O",
          "\xD8": "O",
          "\xF2": "o",
          "\xF3": "o",
          "\xF4": "o",
          "\xF5": "o",
          "\xF6": "o",
          "\xF8": "o",
          "\xD9": "U",
          "\xDA": "U",
          "\xDB": "U",
          "\xDC": "U",
          "\xF9": "u",
          "\xFA": "u",
          "\xFB": "u",
          "\xFC": "u",
          "\xDD": "Y",
          "\xFD": "y",
          "\xFF": "y",
          "\xC6": "Ae",
          "\xE6": "ae",
          "\xDE": "Th",
          "\xFE": "th",
          "\xDF": "ss",
          // Latin Extended-A block.
          "\u0100": "A",
          "\u0102": "A",
          "\u0104": "A",
          "\u0101": "a",
          "\u0103": "a",
          "\u0105": "a",
          "\u0106": "C",
          "\u0108": "C",
          "\u010A": "C",
          "\u010C": "C",
          "\u0107": "c",
          "\u0109": "c",
          "\u010B": "c",
          "\u010D": "c",
          "\u010E": "D",
          "\u0110": "D",
          "\u010F": "d",
          "\u0111": "d",
          "\u0112": "E",
          "\u0114": "E",
          "\u0116": "E",
          "\u0118": "E",
          "\u011A": "E",
          "\u0113": "e",
          "\u0115": "e",
          "\u0117": "e",
          "\u0119": "e",
          "\u011B": "e",
          "\u011C": "G",
          "\u011E": "G",
          "\u0120": "G",
          "\u0122": "G",
          "\u011D": "g",
          "\u011F": "g",
          "\u0121": "g",
          "\u0123": "g",
          "\u0124": "H",
          "\u0126": "H",
          "\u0125": "h",
          "\u0127": "h",
          "\u0128": "I",
          "\u012A": "I",
          "\u012C": "I",
          "\u012E": "I",
          "\u0130": "I",
          "\u0129": "i",
          "\u012B": "i",
          "\u012D": "i",
          "\u012F": "i",
          "\u0131": "i",
          "\u0134": "J",
          "\u0135": "j",
          "\u0136": "K",
          "\u0137": "k",
          "\u0138": "k",
          "\u0139": "L",
          "\u013B": "L",
          "\u013D": "L",
          "\u013F": "L",
          "\u0141": "L",
          "\u013A": "l",
          "\u013C": "l",
          "\u013E": "l",
          "\u0140": "l",
          "\u0142": "l",
          "\u0143": "N",
          "\u0145": "N",
          "\u0147": "N",
          "\u014A": "N",
          "\u0144": "n",
          "\u0146": "n",
          "\u0148": "n",
          "\u014B": "n",
          "\u014C": "O",
          "\u014E": "O",
          "\u0150": "O",
          "\u014D": "o",
          "\u014F": "o",
          "\u0151": "o",
          "\u0154": "R",
          "\u0156": "R",
          "\u0158": "R",
          "\u0155": "r",
          "\u0157": "r",
          "\u0159": "r",
          "\u015A": "S",
          "\u015C": "S",
          "\u015E": "S",
          "\u0160": "S",
          "\u015B": "s",
          "\u015D": "s",
          "\u015F": "s",
          "\u0161": "s",
          "\u0162": "T",
          "\u0164": "T",
          "\u0166": "T",
          "\u0163": "t",
          "\u0165": "t",
          "\u0167": "t",
          "\u0168": "U",
          "\u016A": "U",
          "\u016C": "U",
          "\u016E": "U",
          "\u0170": "U",
          "\u0172": "U",
          "\u0169": "u",
          "\u016B": "u",
          "\u016D": "u",
          "\u016F": "u",
          "\u0171": "u",
          "\u0173": "u",
          "\u0174": "W",
          "\u0175": "w",
          "\u0176": "Y",
          "\u0177": "y",
          "\u0178": "Y",
          "\u0179": "Z",
          "\u017B": "Z",
          "\u017D": "Z",
          "\u017A": "z",
          "\u017C": "z",
          "\u017E": "z",
          "\u0132": "IJ",
          "\u0133": "ij",
          "\u0152": "Oe",
          "\u0153": "oe",
          "\u0149": "'n",
          "\u017F": "s"
        };
        var htmlEscapes = {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;"
        };
        var htmlUnescapes = {
          "&amp;": "&",
          "&lt;": "<",
          "&gt;": ">",
          "&quot;": '"',
          "&#39;": "'"
        };
        var stringEscapes = {
          "\\": "\\",
          "'": "'",
          "\n": "n",
          "\r": "r",
          "\u2028": "u2028",
          "\u2029": "u2029"
        };
        var freeParseFloat = parseFloat, freeParseInt = parseInt;
        var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
        var freeSelf = typeof self == "object" && self && self.Object === Object && self;
        var root = freeGlobal || freeSelf || Function("return this")();
        var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
        var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
        var moduleExports = freeModule && freeModule.exports === freeExports;
        var freeProcess = moduleExports && freeGlobal.process;
        var nodeUtil = (function() {
          try {
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) {
              return types;
            }
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
          } catch (e) {
          }
        })();
        var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
        function apply2(func, thisArg, args) {
          switch (args.length) {
            case 0:
              return func.call(thisArg);
            case 1:
              return func.call(thisArg, args[0]);
            case 2:
              return func.call(thisArg, args[0], args[1]);
            case 3:
              return func.call(thisArg, args[0], args[1], args[2]);
          }
          return func.apply(thisArg, args);
        }
        function arrayAggregator(array, setter, iteratee, accumulator) {
          var index = -1, length = array == null ? 0 : array.length;
          while (++index < length) {
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
          }
          return accumulator;
        }
        function arrayEach(array, iteratee) {
          var index = -1, length = array == null ? 0 : array.length;
          while (++index < length) {
            if (iteratee(array[index], index, array) === false) {
              break;
            }
          }
          return array;
        }
        function arrayEachRight(array, iteratee) {
          var length = array == null ? 0 : array.length;
          while (length--) {
            if (iteratee(array[length], length, array) === false) {
              break;
            }
          }
          return array;
        }
        function arrayEvery(array, predicate) {
          var index = -1, length = array == null ? 0 : array.length;
          while (++index < length) {
            if (!predicate(array[index], index, array)) {
              return false;
            }
          }
          return true;
        }
        function arrayFilter(array, predicate) {
          var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
          while (++index < length) {
            var value = array[index];
            if (predicate(value, index, array)) {
              result[resIndex++] = value;
            }
          }
          return result;
        }
        function arrayIncludes(array, value) {
          var length = array == null ? 0 : array.length;
          return !!length && baseIndexOf(array, value, 0) > -1;
        }
        function arrayIncludesWith(array, value, comparator) {
          var index = -1, length = array == null ? 0 : array.length;
          while (++index < length) {
            if (comparator(value, array[index])) {
              return true;
            }
          }
          return false;
        }
        function arrayMap(array, iteratee) {
          var index = -1, length = array == null ? 0 : array.length, result = Array(length);
          while (++index < length) {
            result[index] = iteratee(array[index], index, array);
          }
          return result;
        }
        function arrayPush(array, values) {
          var index = -1, length = values.length, offset = array.length;
          while (++index < length) {
            array[offset + index] = values[index];
          }
          return array;
        }
        function arrayReduce(array, iteratee, accumulator, initAccum) {
          var index = -1, length = array == null ? 0 : array.length;
          if (initAccum && length) {
            accumulator = array[++index];
          }
          while (++index < length) {
            accumulator = iteratee(accumulator, array[index], index, array);
          }
          return accumulator;
        }
        function arrayReduceRight(array, iteratee, accumulator, initAccum) {
          var length = array == null ? 0 : array.length;
          if (initAccum && length) {
            accumulator = array[--length];
          }
          while (length--) {
            accumulator = iteratee(accumulator, array[length], length, array);
          }
          return accumulator;
        }
        function arraySome(array, predicate) {
          var index = -1, length = array == null ? 0 : array.length;
          while (++index < length) {
            if (predicate(array[index], index, array)) {
              return true;
            }
          }
          return false;
        }
        var asciiSize = baseProperty("length");
        function asciiToArray(string) {
          return string.split("");
        }
        function asciiWords(string) {
          return string.match(reAsciiWord) || [];
        }
        function baseFindKey(collection, predicate, eachFunc) {
          var result;
          eachFunc(collection, function(value, key, collection2) {
            if (predicate(value, key, collection2)) {
              result = key;
              return false;
            }
          });
          return result;
        }
        function baseFindIndex(array, predicate, fromIndex, fromRight) {
          var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
          while (fromRight ? index-- : ++index < length) {
            if (predicate(array[index], index, array)) {
              return index;
            }
          }
          return -1;
        }
        function baseIndexOf(array, value, fromIndex) {
          return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
        }
        function baseIndexOfWith(array, value, fromIndex, comparator) {
          var index = fromIndex - 1, length = array.length;
          while (++index < length) {
            if (comparator(array[index], value)) {
              return index;
            }
          }
          return -1;
        }
        function baseIsNaN(value) {
          return value !== value;
        }
        function baseMean(array, iteratee) {
          var length = array == null ? 0 : array.length;
          return length ? baseSum(array, iteratee) / length : NAN;
        }
        function baseProperty(key) {
          return function(object) {
            return object == null ? undefined2 : object[key];
          };
        }
        function basePropertyOf(object) {
          return function(key) {
            return object == null ? undefined2 : object[key];
          };
        }
        function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
          eachFunc(collection, function(value, index, collection2) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection2);
          });
          return accumulator;
        }
        function baseSortBy(array, comparer) {
          var length = array.length;
          array.sort(comparer);
          while (length--) {
            array[length] = array[length].value;
          }
          return array;
        }
        function baseSum(array, iteratee) {
          var result, index = -1, length = array.length;
          while (++index < length) {
            var current = iteratee(array[index]);
            if (current !== undefined2) {
              result = result === undefined2 ? current : result + current;
            }
          }
          return result;
        }
        function baseTimes(n, iteratee) {
          var index = -1, result = Array(n);
          while (++index < n) {
            result[index] = iteratee(index);
          }
          return result;
        }
        function baseToPairs(object, props) {
          return arrayMap(props, function(key) {
            return [key, object[key]];
          });
        }
        function baseTrim(string) {
          return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
        }
        function baseUnary(func) {
          return function(value) {
            return func(value);
          };
        }
        function baseValues(object, props) {
          return arrayMap(props, function(key) {
            return object[key];
          });
        }
        function cacheHas(cache, key) {
          return cache.has(key);
        }
        function charsStartIndex(strSymbols, chrSymbols) {
          var index = -1, length = strSymbols.length;
          while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
          }
          return index;
        }
        function charsEndIndex(strSymbols, chrSymbols) {
          var index = strSymbols.length;
          while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
          }
          return index;
        }
        function countHolders(array, placeholder) {
          var length = array.length, result = 0;
          while (length--) {
            if (array[length] === placeholder) {
              ++result;
            }
          }
          return result;
        }
        var deburrLetter = basePropertyOf(deburredLetters);
        var escapeHtmlChar = basePropertyOf(htmlEscapes);
        function escapeStringChar(chr) {
          return "\\" + stringEscapes[chr];
        }
        function getValue2(object, key) {
          return object == null ? undefined2 : object[key];
        }
        function hasUnicode(string) {
          return reHasUnicode.test(string);
        }
        function hasUnicodeWord(string) {
          return reHasUnicodeWord.test(string);
        }
        function iteratorToArray(iterator3) {
          var data, result = [];
          while (!(data = iterator3.next()).done) {
            result.push(data.value);
          }
          return result;
        }
        function mapToArray(map3) {
          var index = -1, result = Array(map3.size);
          map3.forEach(function(value, key) {
            result[++index] = [key, value];
          });
          return result;
        }
        function overArg(func, transform2) {
          return function(arg) {
            return func(transform2(arg));
          };
        }
        function replaceHolders(array, placeholder) {
          var index = -1, length = array.length, resIndex = 0, result = [];
          while (++index < length) {
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
              array[index] = PLACEHOLDER;
              result[resIndex++] = index;
            }
          }
          return result;
        }
        function setToArray(set) {
          var index = -1, result = Array(set.size);
          set.forEach(function(value) {
            result[++index] = value;
          });
          return result;
        }
        function setToPairs(set) {
          var index = -1, result = Array(set.size);
          set.forEach(function(value) {
            result[++index] = [value, value];
          });
          return result;
        }
        function strictIndexOf(array, value, fromIndex) {
          var index = fromIndex - 1, length = array.length;
          while (++index < length) {
            if (array[index] === value) {
              return index;
            }
          }
          return -1;
        }
        function strictLastIndexOf(array, value, fromIndex) {
          var index = fromIndex + 1;
          while (index--) {
            if (array[index] === value) {
              return index;
            }
          }
          return index;
        }
        function stringSize(string) {
          return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
        }
        function stringToArray2(string) {
          return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
        }
        function trimmedEndIndex(string) {
          var index = string.length;
          while (index-- && reWhitespace.test(string.charAt(index))) {
          }
          return index;
        }
        var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
        function unicodeSize(string) {
          var result = reUnicode.lastIndex = 0;
          while (reUnicode.test(string)) {
            ++result;
          }
          return result;
        }
        function unicodeToArray(string) {
          return string.match(reUnicode) || [];
        }
        function unicodeWords(string) {
          return string.match(reUnicodeWord) || [];
        }
        var runInContext = (function runInContext2(context) {
          context = context == null ? root : _2.defaults(root.Object(), context, _2.pick(root, contextProps));
          var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
          var arrayProto2 = Array2.prototype, funcProto = Function2.prototype, objectProto = Object2.prototype;
          var coreJsData = context["__core-js_shared__"];
          var funcToString = funcProto.toString;
          var hasOwnProperty4 = objectProto.hasOwnProperty;
          var idCounter3 = 0;
          var maskSrcKey = (function() {
            var uid3 = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid3 ? "Symbol(src)_1." + uid3 : "";
          })();
          var nativeObjectToString = objectProto.toString;
          var objectCtorString = funcToString.call(Object2);
          var oldDash = root._;
          var reIsNative = RegExp2(
            "^" + funcToString.call(hasOwnProperty4).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
          );
          var Buffer2 = moduleExports ? context.Buffer : undefined2, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : undefined2, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable2 = objectProto.propertyIsEnumerable, splice = arrayProto2.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined2, symIterator = Symbol2 ? Symbol2.iterator : undefined2, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined2;
          var defineProperty = (function() {
            try {
              var func = getNative(Object2, "defineProperty");
              func({}, "", {});
              return func;
            } catch (e) {
            }
          })();
          var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
          var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : undefined2, nativeIsFinite = context.isFinite, nativeJoin = arrayProto2.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto2.reverse;
          var DataView2 = getNative(context, "DataView"), Map2 = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set2 = getNative(context, "Set"), WeakMap2 = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
          var metaMap = WeakMap2 && new WeakMap2();
          var realNames = {};
          var dataViewCtorString = toSource(DataView2), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap2);
          var symbolProto = Symbol2 ? Symbol2.prototype : undefined2, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined2, symbolToString = symbolProto ? symbolProto.toString : undefined2;
          function lodash(value) {
            if (isObjectLike(value) && !isArray3(value) && !(value instanceof LazyWrapper)) {
              if (value instanceof LodashWrapper) {
                return value;
              }
              if (hasOwnProperty4.call(value, "__wrapped__")) {
                return wrapperClone(value);
              }
            }
            return new LodashWrapper(value);
          }
          var baseCreate = /* @__PURE__ */ (function() {
            function object() {
            }
            return function(proto) {
              if (!isObject4(proto)) {
                return {};
              }
              if (objectCreate) {
                return objectCreate(proto);
              }
              object.prototype = proto;
              var result2 = new object();
              object.prototype = undefined2;
              return result2;
            };
          })();
          function baseLodash() {
          }
          function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined2;
          }
          lodash.templateSettings = {
            /**
             * Used to detect `data` property values to be HTML-escaped.
             *
             * @memberOf _.templateSettings
             * @type {RegExp}
             */
            "escape": reEscape,
            /**
             * Used to detect code to be evaluated.
             *
             * @memberOf _.templateSettings
             * @type {RegExp}
             */
            "evaluate": reEvaluate,
            /**
             * Used to detect `data` property values to inject.
             *
             * @memberOf _.templateSettings
             * @type {RegExp}
             */
            "interpolate": reInterpolate,
            /**
             * Used to reference the data object in the template text.
             *
             * @memberOf _.templateSettings
             * @type {string}
             */
            "variable": "",
            /**
             * Used to import variables into the compiled template.
             *
             * @memberOf _.templateSettings
             * @type {Object}
             */
            "imports": {
              /**
               * A reference to the `lodash` function.
               *
               * @memberOf _.templateSettings.imports
               * @type {Function}
               */
              "_": lodash
            }
          };
          lodash.prototype = baseLodash.prototype;
          lodash.prototype.constructor = lodash;
          LodashWrapper.prototype = baseCreate(baseLodash.prototype);
          LodashWrapper.prototype.constructor = LodashWrapper;
          function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
          }
          function lazyClone() {
            var result2 = new LazyWrapper(this.__wrapped__);
            result2.__actions__ = copyArray(this.__actions__);
            result2.__dir__ = this.__dir__;
            result2.__filtered__ = this.__filtered__;
            result2.__iteratees__ = copyArray(this.__iteratees__);
            result2.__takeCount__ = this.__takeCount__;
            result2.__views__ = copyArray(this.__views__);
            return result2;
          }
          function lazyReverse() {
            if (this.__filtered__) {
              var result2 = new LazyWrapper(this);
              result2.__dir__ = -1;
              result2.__filtered__ = true;
            } else {
              result2 = this.clone();
              result2.__dir__ *= -1;
            }
            return result2;
          }
          function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray3(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) {
              return baseWrapperValue(array, this.__actions__);
            }
            var result2 = [];
            outer:
              while (length-- && resIndex < takeCount) {
                index += dir;
                var iterIndex = -1, value = array[index];
                while (++iterIndex < iterLength) {
                  var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed3 = iteratee2(value);
                  if (type == LAZY_MAP_FLAG) {
                    value = computed3;
                  } else if (!computed3) {
                    if (type == LAZY_FILTER_FLAG) {
                      continue outer;
                    } else {
                      break outer;
                    }
                  }
                }
                result2[resIndex++] = value;
              }
            return result2;
          }
          LazyWrapper.prototype = baseCreate(baseLodash.prototype);
          LazyWrapper.prototype.constructor = LazyWrapper;
          function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while (++index < length) {
              var entry = entries[index];
              this.set(entry[0], entry[1]);
            }
          }
          function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
          }
          function hashDelete(key) {
            var result2 = this.has(key) && delete this.__data__[key];
            this.size -= result2 ? 1 : 0;
            return result2;
          }
          function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
              var result2 = data[key];
              return result2 === HASH_UNDEFINED ? undefined2 : result2;
            }
            return hasOwnProperty4.call(data, key) ? data[key] : undefined2;
          }
          function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined2 : hasOwnProperty4.call(data, key);
          }
          function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined2 ? HASH_UNDEFINED : value;
            return this;
          }
          Hash.prototype.clear = hashClear;
          Hash.prototype["delete"] = hashDelete;
          Hash.prototype.get = hashGet;
          Hash.prototype.has = hashHas;
          Hash.prototype.set = hashSet;
          function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while (++index < length) {
              var entry = entries[index];
              this.set(entry[0], entry[1]);
            }
          }
          function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
          }
          function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
              return false;
            }
            var lastIndex = data.length - 1;
            if (index == lastIndex) {
              data.pop();
            } else {
              splice.call(data, index, 1);
            }
            --this.size;
            return true;
          }
          function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined2 : data[index][1];
          }
          function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
          }
          function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
              ++this.size;
              data.push([key, value]);
            } else {
              data[index][1] = value;
            }
            return this;
          }
          ListCache.prototype.clear = listCacheClear;
          ListCache.prototype["delete"] = listCacheDelete;
          ListCache.prototype.get = listCacheGet;
          ListCache.prototype.has = listCacheHas;
          ListCache.prototype.set = listCacheSet;
          function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while (++index < length) {
              var entry = entries[index];
              this.set(entry[0], entry[1]);
            }
          }
          function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
              "hash": new Hash(),
              "map": new (Map2 || ListCache)(),
              "string": new Hash()
            };
          }
          function mapCacheDelete(key) {
            var result2 = getMapData(this, key)["delete"](key);
            this.size -= result2 ? 1 : 0;
            return result2;
          }
          function mapCacheGet(key) {
            return getMapData(this, key).get(key);
          }
          function mapCacheHas(key) {
            return getMapData(this, key).has(key);
          }
          function mapCacheSet(key, value) {
            var data = getMapData(this, key), size2 = data.size;
            data.set(key, value);
            this.size += data.size == size2 ? 0 : 1;
            return this;
          }
          MapCache.prototype.clear = mapCacheClear;
          MapCache.prototype["delete"] = mapCacheDelete;
          MapCache.prototype.get = mapCacheGet;
          MapCache.prototype.has = mapCacheHas;
          MapCache.prototype.set = mapCacheSet;
          function SetCache(values2) {
            var index = -1, length = values2 == null ? 0 : values2.length;
            this.__data__ = new MapCache();
            while (++index < length) {
              this.add(values2[index]);
            }
          }
          function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
          }
          function setCacheHas(value) {
            return this.__data__.has(value);
          }
          SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
          SetCache.prototype.has = setCacheHas;
          function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
          }
          function stackClear() {
            this.__data__ = new ListCache();
            this.size = 0;
          }
          function stackDelete(key) {
            var data = this.__data__, result2 = data["delete"](key);
            this.size = data.size;
            return result2;
          }
          function stackGet(key) {
            return this.__data__.get(key);
          }
          function stackHas(key) {
            return this.__data__.has(key);
          }
          function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
              var pairs = data.__data__;
              if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
                pairs.push([key, value]);
                this.size = ++data.size;
                return this;
              }
              data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
          }
          Stack.prototype.clear = stackClear;
          Stack.prototype["delete"] = stackDelete;
          Stack.prototype.get = stackGet;
          Stack.prototype.has = stackHas;
          Stack.prototype.set = stackSet;
          function arrayLikeKeys(value, inherited) {
            var isArr = isArray3(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer2(value), isType = !isArr && !isArg && !isBuff && isTypedArray2(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value.length, String2) : [], length = result2.length;
            for (var key in value) {
              if ((inherited || hasOwnProperty4.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
              (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
              isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
              isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
              isIndex(key, length)))) {
                result2.push(key);
              }
            }
            return result2;
          }
          function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined2;
          }
          function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
          }
          function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
          }
          function assignMergeValue(object, key, value) {
            if (value !== undefined2 && !eq(object[key], value) || value === undefined2 && !(key in object)) {
              baseAssignValue(object, key, value);
            }
          }
          function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty4.call(object, key) && eq(objValue, value)) || value === undefined2 && !(key in object)) {
              baseAssignValue(object, key, value);
            }
          }
          function assocIndexOf(array, key) {
            var length = array.length;
            while (length--) {
              if (eq(array[length][0], key)) {
                return length;
              }
            }
            return -1;
          }
          function baseAggregator(collection, setter, iteratee2, accumulator) {
            baseEach(collection, function(value, key, collection2) {
              setter(accumulator, value, iteratee2(value), collection2);
            });
            return accumulator;
          }
          function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
          }
          function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
          }
          function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) {
              defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
              });
            } else {
              object[key] = value;
            }
          }
          function baseAt(object, paths) {
            var index = -1, length = paths.length, result2 = Array2(length), skip = object == null;
            while (++index < length) {
              result2[index] = skip ? undefined2 : get3(object, paths[index]);
            }
            return result2;
          }
          function baseClamp(number, lower, upper) {
            if (number === number) {
              if (upper !== undefined2) {
                number = number <= upper ? number : upper;
              }
              if (lower !== undefined2) {
                number = number >= lower ? number : lower;
              }
            }
            return number;
          }
          function baseClone(value, bitmask, customizer, key, object, stack3) {
            var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) {
              result2 = object ? customizer(value, key, object, stack3) : customizer(value);
            }
            if (result2 !== undefined2) {
              return result2;
            }
            if (!isObject4(value)) {
              return value;
            }
            var isArr = isArray3(value);
            if (isArr) {
              result2 = initCloneArray(value);
              if (!isDeep) {
                return copyArray(value, result2);
              }
            } else {
              var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
              if (isBuffer2(value)) {
                return cloneBuffer(value, isDeep);
              }
              if (tag == objectTag || tag == argsTag || isFunc && !object) {
                result2 = isFlat || isFunc ? {} : initCloneObject(value);
                if (!isDeep) {
                  return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
                }
              } else {
                if (!cloneableTags[tag]) {
                  return object ? value : {};
                }
                result2 = initCloneByTag(value, tag, isDeep);
              }
            }
            stack3 || (stack3 = new Stack());
            var stacked = stack3.get(value);
            if (stacked) {
              return stacked;
            }
            stack3.set(value, result2);
            if (isSet3(value)) {
              value.forEach(function(subValue) {
                result2.add(baseClone(subValue, bitmask, customizer, subValue, value, stack3));
              });
            } else if (isMap2(value)) {
              value.forEach(function(subValue, key2) {
                result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack3));
              });
            }
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined2 : keysFunc(value);
            arrayEach(props || value, function(subValue, key2) {
              if (props) {
                key2 = subValue;
                subValue = value[key2];
              }
              assignValue(result2, key2, baseClone(subValue, bitmask, customizer, key2, value, stack3));
            });
            return result2;
          }
          function baseConforms(source) {
            var props = keys(source);
            return function(object) {
              return baseConformsTo(object, source, props);
            };
          }
          function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) {
              return !length;
            }
            object = Object2(object);
            while (length--) {
              var key = props[length], predicate = source[key], value = object[key];
              if (value === undefined2 && !(key in object) || !predicate(value)) {
                return false;
              }
            }
            return true;
          }
          function baseDelay(func, wait, args) {
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            return setTimeout2(function() {
              func.apply(undefined2, args);
            }, wait);
          }
          function baseDifference(array, values2, iteratee2, comparator) {
            var index = -1, includes2 = arrayIncludes, isCommon = true, length = array.length, result2 = [], valuesLength = values2.length;
            if (!length) {
              return result2;
            }
            if (iteratee2) {
              values2 = arrayMap(values2, baseUnary(iteratee2));
            }
            if (comparator) {
              includes2 = arrayIncludesWith;
              isCommon = false;
            } else if (values2.length >= LARGE_ARRAY_SIZE) {
              includes2 = cacheHas;
              isCommon = false;
              values2 = new SetCache(values2);
            }
            outer:
              while (++index < length) {
                var value = array[index], computed3 = iteratee2 == null ? value : iteratee2(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed3 === computed3) {
                  var valuesIndex = valuesLength;
                  while (valuesIndex--) {
                    if (values2[valuesIndex] === computed3) {
                      continue outer;
                    }
                  }
                  result2.push(value);
                } else if (!includes2(values2, computed3, comparator)) {
                  result2.push(value);
                }
              }
            return result2;
          }
          var baseEach = createBaseEach(baseForOwn);
          var baseEachRight = createBaseEach(baseForOwnRight, true);
          function baseEvery(collection, predicate) {
            var result2 = true;
            baseEach(collection, function(value, index, collection2) {
              result2 = !!predicate(value, index, collection2);
              return result2;
            });
            return result2;
          }
          function baseExtremum(array, iteratee2, comparator) {
            var index = -1, length = array.length;
            while (++index < length) {
              var value = array[index], current = iteratee2(value);
              if (current != null && (computed3 === undefined2 ? current === current && !isSymbol2(current) : comparator(current, computed3))) {
                var computed3 = current, result2 = value;
              }
            }
            return result2;
          }
          function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) {
              start = -start > length ? 0 : length + start;
            }
            end = end === undefined2 || end > length ? length : toInteger(end);
            if (end < 0) {
              end += length;
            }
            end = start > end ? 0 : toLength(end);
            while (start < end) {
              array[start++] = value;
            }
            return array;
          }
          function baseFilter(collection, predicate) {
            var result2 = [];
            baseEach(collection, function(value, index, collection2) {
              if (predicate(value, index, collection2)) {
                result2.push(value);
              }
            });
            return result2;
          }
          function baseFlatten(array, depth, predicate, isStrict, result2) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result2 || (result2 = []);
            while (++index < length) {
              var value = array[index];
              if (depth > 0 && predicate(value)) {
                if (depth > 1) {
                  baseFlatten(value, depth - 1, predicate, isStrict, result2);
                } else {
                  arrayPush(result2, value);
                }
              } else if (!isStrict) {
                result2[result2.length] = value;
              }
            }
            return result2;
          }
          var baseFor = createBaseFor();
          var baseForRight = createBaseFor(true);
          function baseForOwn(object, iteratee2) {
            return object && baseFor(object, iteratee2, keys);
          }
          function baseForOwnRight(object, iteratee2) {
            return object && baseForRight(object, iteratee2, keys);
          }
          function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
              return isFunction5(object[key]);
            });
          }
          function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while (object != null && index < length) {
              object = object[toKey(path[index++])];
            }
            return index && index == length ? object : undefined2;
          }
          function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result2 = keysFunc(object);
            return isArray3(object) ? result2 : arrayPush(result2, symbolsFunc(object));
          }
          function baseGetTag(value) {
            if (value == null) {
              return value === undefined2 ? undefinedTag : nullTag;
            }
            return symToStringTag && symToStringTag in Object2(value) ? getRawTag(value) : objectToString2(value);
          }
          function baseGt(value, other) {
            return value > other;
          }
          function baseHas(object, key) {
            return object != null && hasOwnProperty4.call(object, key);
          }
          function baseHasIn(object, key) {
            return object != null && key in Object2(object);
          }
          function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
          }
          function baseIntersection(arrays, iteratee2, comparator) {
            var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
            while (othIndex--) {
              var array = arrays[othIndex];
              if (othIndex && iteratee2) {
                array = arrayMap(array, baseUnary(iteratee2));
              }
              maxLength = nativeMin(array.length, maxLength);
              caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined2;
            }
            array = arrays[0];
            var index = -1, seen2 = caches[0];
            outer:
              while (++index < length && result2.length < maxLength) {
                var value = array[index], computed3 = iteratee2 ? iteratee2(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen2 ? cacheHas(seen2, computed3) : includes2(result2, computed3, comparator))) {
                  othIndex = othLength;
                  while (--othIndex) {
                    var cache = caches[othIndex];
                    if (!(cache ? cacheHas(cache, computed3) : includes2(arrays[othIndex], computed3, comparator))) {
                      continue outer;
                    }
                  }
                  if (seen2) {
                    seen2.push(computed3);
                  }
                  result2.push(value);
                }
              }
            return result2;
          }
          function baseInverter(object, setter, iteratee2, accumulator) {
            baseForOwn(object, function(value, key, object2) {
              setter(accumulator, iteratee2(value), key, object2);
            });
            return accumulator;
          }
          function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined2 : apply2(func, object, args);
          }
          function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
          }
          function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
          }
          function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
          }
          function baseIsEqual(value, other, bitmask, customizer, stack3) {
            if (value === other) {
              return true;
            }
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
              return value !== value && other !== other;
            }
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack3);
          }
          function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack3) {
            var objIsArr = isArray3(object), othIsArr = isArray3(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer2(object)) {
              if (!isBuffer2(other)) {
                return false;
              }
              objIsArr = true;
              objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
              stack3 || (stack3 = new Stack());
              return objIsArr || isTypedArray2(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack3) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack3);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
              var objIsWrapped = objIsObj && hasOwnProperty4.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty4.call(other, "__wrapped__");
              if (objIsWrapped || othIsWrapped) {
                var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                stack3 || (stack3 = new Stack());
                return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack3);
              }
            }
            if (!isSameTag) {
              return false;
            }
            stack3 || (stack3 = new Stack());
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack3);
          }
          function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
          }
          function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) {
              return !length;
            }
            object = Object2(object);
            while (index--) {
              var data = matchData[index];
              if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
                return false;
              }
            }
            while (++index < length) {
              data = matchData[index];
              var key = data[0], objValue = object[key], srcValue = data[1];
              if (noCustomizer && data[2]) {
                if (objValue === undefined2 && !(key in object)) {
                  return false;
                }
              } else {
                var stack3 = new Stack();
                if (customizer) {
                  var result2 = customizer(objValue, srcValue, key, object, source, stack3);
                }
                if (!(result2 === undefined2 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack3) : result2)) {
                  return false;
                }
              }
            }
            return true;
          }
          function baseIsNative(value) {
            if (!isObject4(value) || isMasked(value)) {
              return false;
            }
            var pattern = isFunction5(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
          }
          function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
          }
          function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
          }
          function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
          }
          function baseIteratee(value) {
            if (typeof value == "function") {
              return value;
            }
            if (value == null) {
              return identity;
            }
            if (typeof value == "object") {
              return isArray3(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            }
            return property(value);
          }
          function baseKeys(object) {
            if (!isPrototype(object)) {
              return nativeKeys(object);
            }
            var result2 = [];
            for (var key in Object2(object)) {
              if (hasOwnProperty4.call(object, key) && key != "constructor") {
                result2.push(key);
              }
            }
            return result2;
          }
          function baseKeysIn(object) {
            if (!isObject4(object)) {
              return nativeKeysIn(object);
            }
            var isProto = isPrototype(object), result2 = [];
            for (var key in object) {
              if (!(key == "constructor" && (isProto || !hasOwnProperty4.call(object, key)))) {
                result2.push(key);
              }
            }
            return result2;
          }
          function baseLt(value, other) {
            return value < other;
          }
          function baseMap(collection, iteratee2) {
            var index = -1, result2 = isArrayLike(collection) ? Array2(collection.length) : [];
            baseEach(collection, function(value, key, collection2) {
              result2[++index] = iteratee2(value, key, collection2);
            });
            return result2;
          }
          function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) {
              return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            }
            return function(object) {
              return object === source || baseIsMatch(object, source, matchData);
            };
          }
          function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) {
              return matchesStrictComparable(toKey(path), srcValue);
            }
            return function(object) {
              var objValue = get3(object, path);
              return objValue === undefined2 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
          }
          function baseMerge(object, source, srcIndex, customizer, stack3) {
            if (object === source) {
              return;
            }
            baseFor(source, function(srcValue, key) {
              stack3 || (stack3 = new Stack());
              if (isObject4(srcValue)) {
                baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack3);
              } else {
                var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack3) : undefined2;
                if (newValue === undefined2) {
                  newValue = srcValue;
                }
                assignMergeValue(object, key, newValue);
              }
            }, keysIn);
          }
          function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack3) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack3.get(srcValue);
            if (stacked) {
              assignMergeValue(object, key, stacked);
              return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack3) : undefined2;
            var isCommon = newValue === undefined2;
            if (isCommon) {
              var isArr = isArray3(srcValue), isBuff = !isArr && isBuffer2(srcValue), isTyped = !isArr && !isBuff && isTypedArray2(srcValue);
              newValue = srcValue;
              if (isArr || isBuff || isTyped) {
                if (isArray3(objValue)) {
                  newValue = objValue;
                } else if (isArrayLikeObject(objValue)) {
                  newValue = copyArray(objValue);
                } else if (isBuff) {
                  isCommon = false;
                  newValue = cloneBuffer(srcValue, true);
                } else if (isTyped) {
                  isCommon = false;
                  newValue = cloneTypedArray(srcValue, true);
                } else {
                  newValue = [];
                }
              } else if (isPlainObject3(srcValue) || isArguments(srcValue)) {
                newValue = objValue;
                if (isArguments(objValue)) {
                  newValue = toPlainObject(objValue);
                } else if (!isObject4(objValue) || isFunction5(objValue)) {
                  newValue = initCloneObject(srcValue);
                }
              } else {
                isCommon = false;
              }
            }
            if (isCommon) {
              stack3.set(srcValue, newValue);
              mergeFunc(newValue, srcValue, srcIndex, customizer, stack3);
              stack3["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
          }
          function baseNth(array, n) {
            var length = array.length;
            if (!length) {
              return;
            }
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined2;
          }
          function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) {
              iteratees = arrayMap(iteratees, function(iteratee2) {
                if (isArray3(iteratee2)) {
                  return function(value) {
                    return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
                  };
                }
                return iteratee2;
              });
            } else {
              iteratees = [identity];
            }
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result2 = baseMap(collection, function(value, key, collection2) {
              var criteria = arrayMap(iteratees, function(iteratee2) {
                return iteratee2(value);
              });
              return { "criteria": criteria, "index": ++index, "value": value };
            });
            return baseSortBy(result2, function(object, other) {
              return compareMultiple(object, other, orders);
            });
          }
          function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
              return hasIn(object, path);
            });
          }
          function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result2 = {};
            while (++index < length) {
              var path = paths[index], value = baseGet(object, path);
              if (predicate(value, path)) {
                baseSet(result2, castPath(path, object), value);
              }
            }
            return result2;
          }
          function basePropertyDeep(path) {
            return function(object) {
              return baseGet(object, path);
            };
          }
          function basePullAll(array, values2, iteratee2, comparator) {
            var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values2.length, seen2 = array;
            if (array === values2) {
              values2 = copyArray(values2);
            }
            if (iteratee2) {
              seen2 = arrayMap(array, baseUnary(iteratee2));
            }
            while (++index < length) {
              var fromIndex = 0, value = values2[index], computed3 = iteratee2 ? iteratee2(value) : value;
              while ((fromIndex = indexOf2(seen2, computed3, fromIndex, comparator)) > -1) {
                if (seen2 !== array) {
                  splice.call(seen2, fromIndex, 1);
                }
                splice.call(array, fromIndex, 1);
              }
            }
            return array;
          }
          function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while (length--) {
              var index = indexes[length];
              if (length == lastIndex || index !== previous) {
                var previous = index;
                if (isIndex(index)) {
                  splice.call(array, index, 1);
                } else {
                  baseUnset(array, index);
                }
              }
            }
            return array;
          }
          function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
          }
          function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result2 = Array2(length);
            while (length--) {
              result2[fromRight ? length : ++index] = start;
              start += step;
            }
            return result2;
          }
          function baseRepeat(string, n) {
            var result2 = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER2) {
              return result2;
            }
            do {
              if (n % 2) {
                result2 += string;
              }
              n = nativeFloor(n / 2);
              if (n) {
                string += string;
              }
            } while (n);
            return result2;
          }
          function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
          }
          function baseSample(collection) {
            return arraySample(values(collection));
          }
          function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
          }
          function baseSet(object, path, value, customizer) {
            if (!isObject4(object)) {
              return object;
            }
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while (nested != null && ++index < length) {
              var key = toKey(path[index]), newValue = value;
              if (key === "__proto__" || key === "constructor" || key === "prototype") {
                return object;
              }
              if (index != lastIndex) {
                var objValue = nested[key];
                newValue = customizer ? customizer(objValue, key, nested) : undefined2;
                if (newValue === undefined2) {
                  newValue = isObject4(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
              }
              assignValue(nested, key, newValue);
              nested = nested[key];
            }
            return object;
          }
          var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
          };
          var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
              "configurable": true,
              "enumerable": false,
              "value": constant(string),
              "writable": true
            });
          };
          function baseShuffle(collection) {
            return shuffleSelf(values(collection));
          }
          function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) {
              start = -start > length ? 0 : length + start;
            }
            end = end > length ? length : end;
            if (end < 0) {
              end += length;
            }
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result2 = Array2(length);
            while (++index < length) {
              result2[index] = array[index + start];
            }
            return result2;
          }
          function baseSome(collection, predicate) {
            var result2;
            baseEach(collection, function(value, index, collection2) {
              result2 = predicate(value, index, collection2);
              return !result2;
            });
            return !!result2;
          }
          function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
              while (low < high) {
                var mid = low + high >>> 1, computed3 = array[mid];
                if (computed3 !== null && !isSymbol2(computed3) && (retHighest ? computed3 <= value : computed3 < value)) {
                  low = mid + 1;
                } else {
                  high = mid;
                }
              }
              return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
          }
          function baseSortedIndexBy(array, value, iteratee2, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) {
              return 0;
            }
            value = iteratee2(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol2(value), valIsUndefined = value === undefined2;
            while (low < high) {
              var mid = nativeFloor((low + high) / 2), computed3 = iteratee2(array[mid]), othIsDefined = computed3 !== undefined2, othIsNull = computed3 === null, othIsReflexive = computed3 === computed3, othIsSymbol = isSymbol2(computed3);
              if (valIsNaN) {
                var setLow = retHighest || othIsReflexive;
              } else if (valIsUndefined) {
                setLow = othIsReflexive && (retHighest || othIsDefined);
              } else if (valIsNull) {
                setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
              } else if (valIsSymbol) {
                setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
              } else if (othIsNull || othIsSymbol) {
                setLow = false;
              } else {
                setLow = retHighest ? computed3 <= value : computed3 < value;
              }
              if (setLow) {
                low = mid + 1;
              } else {
                high = mid;
              }
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
          }
          function baseSortedUniq(array, iteratee2) {
            var index = -1, length = array.length, resIndex = 0, result2 = [];
            while (++index < length) {
              var value = array[index], computed3 = iteratee2 ? iteratee2(value) : value;
              if (!index || !eq(computed3, seen2)) {
                var seen2 = computed3;
                result2[resIndex++] = value === 0 ? 0 : value;
              }
            }
            return result2;
          }
          function baseToNumber(value) {
            if (typeof value == "number") {
              return value;
            }
            if (isSymbol2(value)) {
              return NAN;
            }
            return +value;
          }
          function baseToString(value) {
            if (typeof value == "string") {
              return value;
            }
            if (isArray3(value)) {
              return arrayMap(value, baseToString) + "";
            }
            if (isSymbol2(value)) {
              return symbolToString ? symbolToString.call(value) : "";
            }
            var result2 = value + "";
            return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
          }
          function baseUniq(array, iteratee2, comparator) {
            var index = -1, includes2 = arrayIncludes, length = array.length, isCommon = true, result2 = [], seen2 = result2;
            if (comparator) {
              isCommon = false;
              includes2 = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
              var set2 = iteratee2 ? null : createSet(array);
              if (set2) {
                return setToArray(set2);
              }
              isCommon = false;
              includes2 = cacheHas;
              seen2 = new SetCache();
            } else {
              seen2 = iteratee2 ? [] : result2;
            }
            outer:
              while (++index < length) {
                var value = array[index], computed3 = iteratee2 ? iteratee2(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed3 === computed3) {
                  var seenIndex = seen2.length;
                  while (seenIndex--) {
                    if (seen2[seenIndex] === computed3) {
                      continue outer;
                    }
                  }
                  if (iteratee2) {
                    seen2.push(computed3);
                  }
                  result2.push(value);
                } else if (!includes2(seen2, computed3, comparator)) {
                  if (seen2 !== result2) {
                    seen2.push(computed3);
                  }
                  result2.push(value);
                }
              }
            return result2;
          }
          function baseUnset(object, path) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            if (!length) {
              return true;
            }
            while (++index < length) {
              var key = toKey(path[index]);
              if (key === "__proto__" && !hasOwnProperty4.call(object, "__proto__")) {
                return false;
              }
              if ((key === "constructor" || key === "prototype") && index < length - 1) {
                return false;
              }
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
          }
          function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
          }
          function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {
            }
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
          }
          function baseWrapperValue(value, actions4) {
            var result2 = value;
            if (result2 instanceof LazyWrapper) {
              result2 = result2.value();
            }
            return arrayReduce(actions4, function(result3, action) {
              return action.func.apply(action.thisArg, arrayPush([result3], action.args));
            }, result2);
          }
          function baseXor(arrays, iteratee2, comparator) {
            var length = arrays.length;
            if (length < 2) {
              return length ? baseUniq(arrays[0]) : [];
            }
            var index = -1, result2 = Array2(length);
            while (++index < length) {
              var array = arrays[index], othIndex = -1;
              while (++othIndex < length) {
                if (othIndex != index) {
                  result2[index] = baseDifference(result2[index] || array, arrays[othIndex], iteratee2, comparator);
                }
              }
            }
            return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
          }
          function baseZipObject(props, values2, assignFunc) {
            var index = -1, length = props.length, valsLength = values2.length, result2 = {};
            while (++index < length) {
              var value = index < valsLength ? values2[index] : undefined2;
              assignFunc(result2, props[index], value);
            }
            return result2;
          }
          function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
          }
          function castFunction(value) {
            return typeof value == "function" ? value : identity;
          }
          function castPath(value, object) {
            if (isArray3(value)) {
              return value;
            }
            return isKey(value, object) ? [value] : stringToPath(toString3(value));
          }
          var castRest = baseRest;
          function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined2 ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
          }
          var clearTimeout2 = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
          };
          function cloneBuffer(buffer2, isDeep) {
            if (isDeep) {
              return buffer2.slice();
            }
            var length = buffer2.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer2.constructor(length);
            buffer2.copy(result2);
            return result2;
          }
          function cloneArrayBuffer(arrayBuffer) {
            var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
            return result2;
          }
          function cloneDataView(dataView, isDeep) {
            var buffer2 = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer2, dataView.byteOffset, dataView.byteLength);
          }
          function cloneRegExp(regexp) {
            var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result2.lastIndex = regexp.lastIndex;
            return result2;
          }
          function cloneSymbol(symbol) {
            return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
          }
          function cloneTypedArray(typedArray, isDeep) {
            var buffer2 = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer2, typedArray.byteOffset, typedArray.length);
          }
          function compareAscending(value, other) {
            if (value !== other) {
              var valIsDefined = value !== undefined2, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol2(value);
              var othIsDefined = other !== undefined2, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol2(other);
              if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
                return 1;
              }
              if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
                return -1;
              }
            }
            return 0;
          }
          function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while (++index < length) {
              var result2 = compareAscending(objCriteria[index], othCriteria[index]);
              if (result2) {
                if (index >= ordersLength) {
                  return result2;
                }
                var order = orders[index];
                return result2 * (order == "desc" ? -1 : 1);
              }
            }
            return object.index - other.index;
          }
          function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
            while (++leftIndex < leftLength) {
              result2[leftIndex] = partials[leftIndex];
            }
            while (++argsIndex < holdersLength) {
              if (isUncurried || argsIndex < argsLength) {
                result2[holders[argsIndex]] = args[argsIndex];
              }
            }
            while (rangeLength--) {
              result2[leftIndex++] = args[argsIndex++];
            }
            return result2;
          }
          function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
            while (++argsIndex < rangeLength) {
              result2[argsIndex] = args[argsIndex];
            }
            var offset = argsIndex;
            while (++rightIndex < rightLength) {
              result2[offset + rightIndex] = partials[rightIndex];
            }
            while (++holdersIndex < holdersLength) {
              if (isUncurried || argsIndex < argsLength) {
                result2[offset + holders[holdersIndex]] = args[argsIndex++];
              }
            }
            return result2;
          }
          function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array2(length));
            while (++index < length) {
              array[index] = source[index];
            }
            return array;
          }
          function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while (++index < length) {
              var key = props[index];
              var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined2;
              if (newValue === undefined2) {
                newValue = source[key];
              }
              if (isNew) {
                baseAssignValue(object, key, newValue);
              } else {
                assignValue(object, key, newValue);
              }
            }
            return object;
          }
          function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
          }
          function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
          }
          function createAggregator(setter, initializer) {
            return function(collection, iteratee2) {
              var func = isArray3(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
              return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
            };
          }
          function createAssigner(assigner) {
            return baseRest(function(object, sources) {
              var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined2, guard = length > 2 ? sources[2] : undefined2;
              customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined2;
              if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                customizer = length < 3 ? undefined2 : customizer;
                length = 1;
              }
              object = Object2(object);
              while (++index < length) {
                var source = sources[index];
                if (source) {
                  assigner(object, source, index, customizer);
                }
              }
              return object;
            });
          }
          function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee2) {
              if (collection == null) {
                return collection;
              }
              if (!isArrayLike(collection)) {
                return eachFunc(collection, iteratee2);
              }
              var length = collection.length, index = fromRight ? length : -1, iterable = Object2(collection);
              while (fromRight ? index-- : ++index < length) {
                if (iteratee2(iterable[index], index, iterable) === false) {
                  break;
                }
              }
              return collection;
            };
          }
          function createBaseFor(fromRight) {
            return function(object, iteratee2, keysFunc) {
              var index = -1, iterable = Object2(object), props = keysFunc(object), length = props.length;
              while (length--) {
                var key = props[fromRight ? length : ++index];
                if (iteratee2(iterable[key], key, iterable) === false) {
                  break;
                }
              }
              return object;
            };
          }
          function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
              var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
              return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
          }
          function createCaseFirst(methodName) {
            return function(string) {
              string = toString3(string);
              var strSymbols = hasUnicode(string) ? stringToArray2(string) : undefined2;
              var chr = strSymbols ? strSymbols[0] : string.charAt(0);
              var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
              return chr[methodName]() + trailing;
            };
          }
          function createCompounder(callback) {
            return function(string) {
              return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
          }
          function createCtor(Ctor) {
            return function() {
              var args = arguments;
              switch (args.length) {
                case 0:
                  return new Ctor();
                case 1:
                  return new Ctor(args[0]);
                case 2:
                  return new Ctor(args[0], args[1]);
                case 3:
                  return new Ctor(args[0], args[1], args[2]);
                case 4:
                  return new Ctor(args[0], args[1], args[2], args[3]);
                case 5:
                  return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                case 6:
                  return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                case 7:
                  return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
              }
              var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
              return isObject4(result2) ? result2 : thisBinding;
            };
          }
          function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
              var length = arguments.length, args = Array2(length), index = length, placeholder = getHolder(wrapper);
              while (index--) {
                args[index] = arguments[index];
              }
              var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
              length -= holders.length;
              if (length < arity) {
                return createRecurry(
                  func,
                  bitmask,
                  createHybrid,
                  wrapper.placeholder,
                  undefined2,
                  args,
                  holders,
                  undefined2,
                  undefined2,
                  arity - length
                );
              }
              var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
              return apply2(fn, this, args);
            }
            return wrapper;
          }
          function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
              var iterable = Object2(collection);
              if (!isArrayLike(collection)) {
                var iteratee2 = getIteratee(predicate, 3);
                collection = keys(collection);
                predicate = function(key) {
                  return iteratee2(iterable[key], key, iterable);
                };
              }
              var index = findIndexFunc(collection, predicate, fromIndex);
              return index > -1 ? iterable[iteratee2 ? collection[index] : index] : undefined2;
            };
          }
          function createFlow(fromRight) {
            return flatRest(function(funcs) {
              var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
              if (fromRight) {
                funcs.reverse();
              }
              while (index--) {
                var func = funcs[index];
                if (typeof func != "function") {
                  throw new TypeError2(FUNC_ERROR_TEXT);
                }
                if (prereq && !wrapper && getFuncName(func) == "wrapper") {
                  var wrapper = new LodashWrapper([], true);
                }
              }
              index = wrapper ? index : length;
              while (++index < length) {
                func = funcs[index];
                var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined2;
                if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
                  wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                } else {
                  wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
              }
              return function() {
                var args = arguments, value = args[0];
                if (wrapper && args.length == 1 && isArray3(value)) {
                  return wrapper.plant(value).value();
                }
                var index2 = 0, result2 = length ? funcs[index2].apply(this, args) : value;
                while (++index2 < length) {
                  result2 = funcs[index2].call(this, result2);
                }
                return result2;
              };
            });
          }
          function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined2 : createCtor(func);
            function wrapper() {
              var length = arguments.length, args = Array2(length), index = length;
              while (index--) {
                args[index] = arguments[index];
              }
              if (isCurried) {
                var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
              }
              if (partials) {
                args = composeArgs(args, partials, holders, isCurried);
              }
              if (partialsRight) {
                args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
              }
              length -= holdersCount;
              if (isCurried && length < arity) {
                var newHolders = replaceHolders(args, placeholder);
                return createRecurry(
                  func,
                  bitmask,
                  createHybrid,
                  wrapper.placeholder,
                  thisArg,
                  args,
                  newHolders,
                  argPos,
                  ary2,
                  arity - length
                );
              }
              var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
              length = args.length;
              if (argPos) {
                args = reorder(args, argPos);
              } else if (isFlip && length > 1) {
                args.reverse();
              }
              if (isAry && ary2 < length) {
                args.length = ary2;
              }
              if (this && this !== root && this instanceof wrapper) {
                fn = Ctor || createCtor(fn);
              }
              return fn.apply(thisBinding, args);
            }
            return wrapper;
          }
          function createInverter(setter, toIteratee) {
            return function(object, iteratee2) {
              return baseInverter(object, setter, toIteratee(iteratee2), {});
            };
          }
          function createMathOperation(operator, defaultValue) {
            return function(value, other) {
              var result2;
              if (value === undefined2 && other === undefined2) {
                return defaultValue;
              }
              if (value !== undefined2) {
                result2 = value;
              }
              if (other !== undefined2) {
                if (result2 === undefined2) {
                  return other;
                }
                if (typeof value == "string" || typeof other == "string") {
                  value = baseToString(value);
                  other = baseToString(other);
                } else {
                  value = baseToNumber(value);
                  other = baseToNumber(other);
                }
                result2 = operator(value, other);
              }
              return result2;
            };
          }
          function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
              iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
              return baseRest(function(args) {
                var thisArg = this;
                return arrayFunc(iteratees, function(iteratee2) {
                  return apply2(iteratee2, thisArg, args);
                });
              });
            });
          }
          function createPadding(length, chars) {
            chars = chars === undefined2 ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) {
              return charsLength ? baseRepeat(chars, length) : chars;
            }
            var result2 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray2(result2), 0, length).join("") : result2.slice(0, length);
          }
          function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
              var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
              while (++leftIndex < leftLength) {
                args[leftIndex] = partials[leftIndex];
              }
              while (argsLength--) {
                args[leftIndex++] = arguments[++argsIndex];
              }
              return apply2(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
          }
          function createRange(fromRight) {
            return function(start, end, step) {
              if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
                end = step = undefined2;
              }
              start = toFinite(start);
              if (end === undefined2) {
                end = start;
                start = 0;
              } else {
                end = toFinite(end);
              }
              step = step === undefined2 ? start < end ? 1 : -1 : toFinite(step);
              return baseRange(start, end, step, fromRight);
            };
          }
          function createRelationalOperation(operator) {
            return function(value, other) {
              if (!(typeof value == "string" && typeof other == "string")) {
                value = toNumber2(value);
                other = toNumber2(other);
              }
              return operator(value, other);
            };
          }
          function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined2, newHoldersRight = isCurry ? undefined2 : holders, newPartials = isCurry ? partials : undefined2, newPartialsRight = isCurry ? undefined2 : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
              bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            }
            var newData = [
              func,
              bitmask,
              thisArg,
              newPartials,
              newHolders,
              newPartialsRight,
              newHoldersRight,
              argPos,
              ary2,
              arity
            ];
            var result2 = wrapFunc.apply(undefined2, newData);
            if (isLaziable(func)) {
              setData(result2, newData);
            }
            result2.placeholder = placeholder;
            return setWrapToString(result2, func, bitmask);
          }
          function createRound(methodName) {
            var func = Math2[methodName];
            return function(number, precision) {
              number = toNumber2(number);
              precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
              if (precision && nativeIsFinite(number)) {
                var pair = (toString3(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                pair = (toString3(value) + "e").split("e");
                return +(pair[0] + "e" + (+pair[1] - precision));
              }
              return func(number);
            };
          }
          var createSet = !(Set2 && 1 / setToArray(new Set2([, -0]))[1] == INFINITY) ? noop2 : function(values2) {
            return new Set2(values2);
          };
          function createToPairs(keysFunc) {
            return function(object) {
              var tag = getTag(object);
              if (tag == mapTag) {
                return mapToArray(object);
              }
              if (tag == setTag) {
                return setToPairs(object);
              }
              return baseToPairs(object, keysFunc(object));
            };
          }
          function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            var length = partials ? partials.length : 0;
            if (!length) {
              bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
              partials = holders = undefined2;
            }
            ary2 = ary2 === undefined2 ? ary2 : nativeMax(toInteger(ary2), 0);
            arity = arity === undefined2 ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
              var partialsRight = partials, holdersRight = holders;
              partials = holders = undefined2;
            }
            var data = isBindKey ? undefined2 : getData(func);
            var newData = [
              func,
              bitmask,
              thisArg,
              partials,
              holders,
              partialsRight,
              holdersRight,
              argPos,
              ary2,
              arity
            ];
            if (data) {
              mergeData(newData, data);
            }
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined2 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
              bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            }
            if (!bitmask || bitmask == WRAP_BIND_FLAG) {
              var result2 = createBind(func, bitmask, thisArg);
            } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
              result2 = createCurry(func, bitmask, arity);
            } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
              result2 = createPartial(func, bitmask, thisArg, partials);
            } else {
              result2 = createHybrid.apply(undefined2, newData);
            }
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result2, newData), func, bitmask);
          }
          function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined2 || eq(objValue, objectProto[key]) && !hasOwnProperty4.call(object, key)) {
              return srcValue;
            }
            return objValue;
          }
          function customDefaultsMerge(objValue, srcValue, key, object, source, stack3) {
            if (isObject4(objValue) && isObject4(srcValue)) {
              stack3.set(srcValue, objValue);
              baseMerge(objValue, srcValue, undefined2, customDefaultsMerge, stack3);
              stack3["delete"](srcValue);
            }
            return objValue;
          }
          function customOmitClone(value) {
            return isPlainObject3(value) ? undefined2 : value;
          }
          function equalArrays(array, other, bitmask, customizer, equalFunc, stack3) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
              return false;
            }
            var arrStacked = stack3.get(array);
            var othStacked = stack3.get(other);
            if (arrStacked && othStacked) {
              return arrStacked == other && othStacked == array;
            }
            var index = -1, result2 = true, seen2 = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined2;
            stack3.set(array, other);
            stack3.set(other, array);
            while (++index < arrLength) {
              var arrValue = array[index], othValue = other[index];
              if (customizer) {
                var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack3) : customizer(arrValue, othValue, index, array, other, stack3);
              }
              if (compared !== undefined2) {
                if (compared) {
                  continue;
                }
                result2 = false;
                break;
              }
              if (seen2) {
                if (!arraySome(other, function(othValue2, othIndex) {
                  if (!cacheHas(seen2, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack3))) {
                    return seen2.push(othIndex);
                  }
                })) {
                  result2 = false;
                  break;
                }
              } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack3))) {
                result2 = false;
                break;
              }
            }
            stack3["delete"](array);
            stack3["delete"](other);
            return result2;
          }
          function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack3) {
            switch (tag) {
              case dataViewTag:
                if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
                  return false;
                }
                object = object.buffer;
                other = other.buffer;
              case arrayBufferTag:
                if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
                  return false;
                }
                return true;
              case boolTag:
              case dateTag:
              case numberTag:
                return eq(+object, +other);
              case errorTag:
                return object.name == other.name && object.message == other.message;
              case regexpTag:
              case stringTag:
                return object == other + "";
              case mapTag:
                var convert = mapToArray;
              case setTag:
                var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                convert || (convert = setToArray);
                if (object.size != other.size && !isPartial) {
                  return false;
                }
                var stacked = stack3.get(object);
                if (stacked) {
                  return stacked == other;
                }
                bitmask |= COMPARE_UNORDERED_FLAG;
                stack3.set(object, other);
                var result2 = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack3);
                stack3["delete"](object);
                return result2;
              case symbolTag:
                if (symbolValueOf) {
                  return symbolValueOf.call(object) == symbolValueOf.call(other);
                }
            }
            return false;
          }
          function equalObjects(object, other, bitmask, customizer, equalFunc, stack3) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) {
              return false;
            }
            var index = objLength;
            while (index--) {
              var key = objProps[index];
              if (!(isPartial ? key in other : hasOwnProperty4.call(other, key))) {
                return false;
              }
            }
            var objStacked = stack3.get(object);
            var othStacked = stack3.get(other);
            if (objStacked && othStacked) {
              return objStacked == other && othStacked == object;
            }
            var result2 = true;
            stack3.set(object, other);
            stack3.set(other, object);
            var skipCtor = isPartial;
            while (++index < objLength) {
              key = objProps[index];
              var objValue = object[key], othValue = other[key];
              if (customizer) {
                var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack3) : customizer(objValue, othValue, key, object, other, stack3);
              }
              if (!(compared === undefined2 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack3) : compared)) {
                result2 = false;
                break;
              }
              skipCtor || (skipCtor = key == "constructor");
            }
            if (result2 && !skipCtor) {
              var objCtor = object.constructor, othCtor = other.constructor;
              if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
                result2 = false;
              }
            }
            stack3["delete"](object);
            stack3["delete"](other);
            return result2;
          }
          function flatRest(func) {
            return setToString(overRest(func, undefined2, flatten), func + "");
          }
          function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
          }
          function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
          }
          var getData = !metaMap ? noop2 : function(func) {
            return metaMap.get(func);
          };
          function getFuncName(func) {
            var result2 = func.name + "", array = realNames[result2], length = hasOwnProperty4.call(realNames, result2) ? array.length : 0;
            while (length--) {
              var data = array[length], otherFunc = data.func;
              if (otherFunc == null || otherFunc == func) {
                return data.name;
              }
            }
            return result2;
          }
          function getHolder(func) {
            var object = hasOwnProperty4.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
          }
          function getIteratee() {
            var result2 = lodash.iteratee || iteratee;
            result2 = result2 === iteratee ? baseIteratee : result2;
            return arguments.length ? result2(arguments[0], arguments[1]) : result2;
          }
          function getMapData(map4, key) {
            var data = map4.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
          }
          function getMatchData(object) {
            var result2 = keys(object), length = result2.length;
            while (length--) {
              var key = result2[length], value = object[key];
              result2[length] = [key, value, isStrictComparable(value)];
            }
            return result2;
          }
          function getNative(object, key) {
            var value = getValue2(object, key);
            return baseIsNative(value) ? value : undefined2;
          }
          function getRawTag(value) {
            var isOwn = hasOwnProperty4.call(value, symToStringTag), tag = value[symToStringTag];
            try {
              value[symToStringTag] = undefined2;
              var unmasked = true;
            } catch (e) {
            }
            var result2 = nativeObjectToString.call(value);
            if (unmasked) {
              if (isOwn) {
                value[symToStringTag] = tag;
              } else {
                delete value[symToStringTag];
              }
            }
            return result2;
          }
          var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) {
              return [];
            }
            object = Object2(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
              return propertyIsEnumerable2.call(object, symbol);
            });
          };
          var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result2 = [];
            while (object) {
              arrayPush(result2, getSymbols(object));
              object = getPrototype(object);
            }
            return result2;
          };
          var getTag = baseGetTag;
          if (DataView2 && getTag(new DataView2(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
            getTag = function(value) {
              var result2 = baseGetTag(value), Ctor = result2 == objectTag ? value.constructor : undefined2, ctorString = Ctor ? toSource(Ctor) : "";
              if (ctorString) {
                switch (ctorString) {
                  case dataViewCtorString:
                    return dataViewTag;
                  case mapCtorString:
                    return mapTag;
                  case promiseCtorString:
                    return promiseTag;
                  case setCtorString:
                    return setTag;
                  case weakMapCtorString:
                    return weakMapTag;
                }
              }
              return result2;
            };
          }
          function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while (++index < length) {
              var data = transforms[index], size2 = data.size;
              switch (data.type) {
                case "drop":
                  start += size2;
                  break;
                case "dropRight":
                  end -= size2;
                  break;
                case "take":
                  end = nativeMin(end, start + size2);
                  break;
                case "takeRight":
                  start = nativeMax(start, end - size2);
                  break;
              }
            }
            return { "start": start, "end": end };
          }
          function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
          }
          function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result2 = false;
            while (++index < length) {
              var key = toKey(path[index]);
              if (!(result2 = object != null && hasFunc(object, key))) {
                break;
              }
              object = object[key];
            }
            if (result2 || ++index != length) {
              return result2;
            }
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray3(object) || isArguments(object));
          }
          function initCloneArray(array) {
            var length = array.length, result2 = new array.constructor(length);
            if (length && typeof array[0] == "string" && hasOwnProperty4.call(array, "index")) {
              result2.index = array.index;
              result2.input = array.input;
            }
            return result2;
          }
          function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
          }
          function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch (tag) {
              case arrayBufferTag:
                return cloneArrayBuffer(object);
              case boolTag:
              case dateTag:
                return new Ctor(+object);
              case dataViewTag:
                return cloneDataView(object, isDeep);
              case float32Tag:
              case float64Tag:
              case int8Tag:
              case int16Tag:
              case int32Tag:
              case uint8Tag:
              case uint8ClampedTag:
              case uint16Tag:
              case uint32Tag:
                return cloneTypedArray(object, isDeep);
              case mapTag:
                return new Ctor();
              case numberTag:
              case stringTag:
                return new Ctor(object);
              case regexpTag:
                return cloneRegExp(object);
              case setTag:
                return new Ctor();
              case symbolTag:
                return cloneSymbol(object);
            }
          }
          function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) {
              return source;
            }
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
          }
          function isFlattenable(value) {
            return isArray3(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
          }
          function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER2 : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
          }
          function isIterateeCall(value, index, object) {
            if (!isObject4(object)) {
              return false;
            }
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) {
              return eq(object[index], value);
            }
            return false;
          }
          function isKey(value, object) {
            if (isArray3(value)) {
              return false;
            }
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol2(value)) {
              return true;
            }
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object2(object);
          }
          function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
          }
          function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
              return false;
            }
            if (func === other) {
              return true;
            }
            var data = getData(other);
            return !!data && func === data[0];
          }
          function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
          }
          var isMaskable = coreJsData ? isFunction5 : stubFalse;
          function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
          }
          function isStrictComparable(value) {
            return value === value && !isObject4(value);
          }
          function matchesStrictComparable(key, srcValue) {
            return function(object) {
              if (object == null) {
                return false;
              }
              return object[key] === srcValue && (srcValue !== undefined2 || key in Object2(object));
            };
          }
          function memoizeCapped(func) {
            var result2 = memoize(func, function(key) {
              if (cache.size === MAX_MEMOIZE_SIZE) {
                cache.clear();
              }
              return key;
            });
            var cache = result2.cache;
            return result2;
          }
          function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            if (!(isCommon || isCombo)) {
              return data;
            }
            if (srcBitmask & WRAP_BIND_FLAG) {
              data[2] = source[2];
              newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            var value = source[3];
            if (value) {
              var partials = data[3];
              data[3] = partials ? composeArgs(partials, value, source[4]) : value;
              data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            value = source[5];
            if (value) {
              partials = data[5];
              data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
              data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            value = source[7];
            if (value) {
              data[7] = value;
            }
            if (srcBitmask & WRAP_ARY_FLAG) {
              data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            }
            if (data[9] == null) {
              data[9] = source[9];
            }
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
          }
          function nativeKeysIn(object) {
            var result2 = [];
            if (object != null) {
              for (var key in Object2(object)) {
                result2.push(key);
              }
            }
            return result2;
          }
          function objectToString2(value) {
            return nativeObjectToString.call(value);
          }
          function overRest(func, start, transform3) {
            start = nativeMax(start === undefined2 ? func.length - 1 : start, 0);
            return function() {
              var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array2(length);
              while (++index < length) {
                array[index] = args[start + index];
              }
              index = -1;
              var otherArgs = Array2(start + 1);
              while (++index < start) {
                otherArgs[index] = args[index];
              }
              otherArgs[start] = transform3(array);
              return apply2(func, this, otherArgs);
            };
          }
          function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
          }
          function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while (length--) {
              var index = indexes[length];
              array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined2;
            }
            return array;
          }
          function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") {
              return;
            }
            if (key == "__proto__") {
              return;
            }
            return object[key];
          }
          var setData = shortOut(baseSetData);
          var setTimeout2 = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
          };
          var setToString = shortOut(baseSetToString);
          function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
          }
          function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
              var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
              lastCalled = stamp;
              if (remaining > 0) {
                if (++count >= HOT_COUNT) {
                  return arguments[0];
                }
              } else {
                count = 0;
              }
              return func.apply(undefined2, arguments);
            };
          }
          function shuffleSelf(array, size2) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size2 = size2 === undefined2 ? length : size2;
            while (++index < size2) {
              var rand = baseRandom(index, lastIndex), value = array[rand];
              array[rand] = array[index];
              array[index] = value;
            }
            array.length = size2;
            return array;
          }
          var stringToPath = memoizeCapped(function(string) {
            var result2 = [];
            if (string.charCodeAt(0) === 46) {
              result2.push("");
            }
            string.replace(rePropName, function(match, number, quote, subString) {
              result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result2;
          });
          function toKey(value) {
            if (typeof value == "string" || isSymbol2(value)) {
              return value;
            }
            var result2 = value + "";
            return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
          }
          function toSource(func) {
            if (func != null) {
              try {
                return funcToString.call(func);
              } catch (e) {
              }
              try {
                return func + "";
              } catch (e) {
              }
            }
            return "";
          }
          function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
              var value = "_." + pair[0];
              if (bitmask & pair[1] && !arrayIncludes(details, value)) {
                details.push(value);
              }
            });
            return details.sort();
          }
          function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) {
              return wrapper.clone();
            }
            var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result2.__actions__ = copyArray(wrapper.__actions__);
            result2.__index__ = wrapper.__index__;
            result2.__values__ = wrapper.__values__;
            return result2;
          }
          function chunk(array, size2, guard) {
            if (guard ? isIterateeCall(array, size2, guard) : size2 === undefined2) {
              size2 = 1;
            } else {
              size2 = nativeMax(toInteger(size2), 0);
            }
            var length = array == null ? 0 : array.length;
            if (!length || size2 < 1) {
              return [];
            }
            var index = 0, resIndex = 0, result2 = Array2(nativeCeil(length / size2));
            while (index < length) {
              result2[resIndex++] = baseSlice(array, index, index += size2);
            }
            return result2;
          }
          function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
            while (++index < length) {
              var value = array[index];
              if (value) {
                result2[resIndex++] = value;
              }
            }
            return result2;
          }
          function concat() {
            var length = arguments.length;
            if (!length) {
              return [];
            }
            var args = Array2(length - 1), array = arguments[0], index = length;
            while (index--) {
              args[index - 1] = arguments[index];
            }
            return arrayPush(isArray3(array) ? copyArray(array) : [array], baseFlatten(args, 1));
          }
          var difference = baseRest(function(array, values2) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
          });
          var differenceBy = baseRest(function(array, values2) {
            var iteratee2 = last(values2);
            if (isArrayLikeObject(iteratee2)) {
              iteratee2 = undefined2;
            }
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
          });
          var differenceWith = baseRest(function(array, values2) {
            var comparator = last(values2);
            if (isArrayLikeObject(comparator)) {
              comparator = undefined2;
            }
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), undefined2, comparator) : [];
          });
          function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) {
              return [];
            }
            n = guard || n === undefined2 ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
          }
          function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) {
              return [];
            }
            n = guard || n === undefined2 ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
          }
          function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
          }
          function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
          }
          function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) {
              return [];
            }
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
              start = 0;
              end = length;
            }
            return baseFill(array, value, start, end);
          }
          function findIndex2(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) {
              return -1;
            }
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) {
              index = nativeMax(length + index, 0);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index);
          }
          function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) {
              return -1;
            }
            var index = length - 1;
            if (fromIndex !== undefined2) {
              index = toInteger(fromIndex);
              index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
          }
          function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
          }
          function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
          }
          function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) {
              return [];
            }
            depth = depth === undefined2 ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
          }
          function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result2 = {};
            while (++index < length) {
              var pair = pairs[index];
              baseAssignValue(result2, pair[0], pair[1]);
            }
            return result2;
          }
          function head(array) {
            return array && array.length ? array[0] : undefined2;
          }
          function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) {
              return -1;
            }
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) {
              index = nativeMax(length + index, 0);
            }
            return baseIndexOf(array, value, index);
          }
          function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
          }
          var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
          });
          var intersectionBy = baseRest(function(arrays) {
            var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee2 === last(mapped)) {
              iteratee2 = undefined2;
            } else {
              mapped.pop();
            }
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
          });
          var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined2;
            if (comparator) {
              mapped.pop();
            }
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined2, comparator) : [];
          });
          function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
          }
          function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined2;
          }
          function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) {
              return -1;
            }
            var index = length;
            if (fromIndex !== undefined2) {
              index = toInteger(fromIndex);
              index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
          }
          function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined2;
          }
          var pull = baseRest(pullAll);
          function pullAll(array, values2) {
            return array && array.length && values2 && values2.length ? basePullAll(array, values2) : array;
          }
          function pullAllBy(array, values2, iteratee2) {
            return array && array.length && values2 && values2.length ? basePullAll(array, values2, getIteratee(iteratee2, 2)) : array;
          }
          function pullAllWith(array, values2, comparator) {
            return array && array.length && values2 && values2.length ? basePullAll(array, values2, undefined2, comparator) : array;
          }
          var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result2 = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
              return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result2;
          });
          function remove2(array, predicate) {
            var result2 = [];
            if (!(array && array.length)) {
              return result2;
            }
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while (++index < length) {
              var value = array[index];
              if (predicate(value, index, array)) {
                result2.push(value);
                indexes.push(index);
              }
            }
            basePullAt(array, indexes);
            return result2;
          }
          function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
          }
          function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) {
              return [];
            }
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
              start = 0;
              end = length;
            } else {
              start = start == null ? 0 : toInteger(start);
              end = end === undefined2 ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
          }
          function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
          }
          function sortedIndexBy(array, value, iteratee2) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2));
          }
          function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
              var index = baseSortedIndex(array, value);
              if (index < length && eq(array[index], value)) {
                return index;
              }
            }
            return -1;
          }
          function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
          }
          function sortedLastIndexBy(array, value, iteratee2) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2), true);
          }
          function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
              var index = baseSortedIndex(array, value, true) - 1;
              if (eq(array[index], value)) {
                return index;
              }
            }
            return -1;
          }
          function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
          }
          function sortedUniqBy(array, iteratee2) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
          }
          function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
          }
          function take(array, n, guard) {
            if (!(array && array.length)) {
              return [];
            }
            n = guard || n === undefined2 ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
          }
          function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) {
              return [];
            }
            n = guard || n === undefined2 ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
          }
          function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
          }
          function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
          }
          var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
          });
          var unionBy = baseRest(function(arrays) {
            var iteratee2 = last(arrays);
            if (isArrayLikeObject(iteratee2)) {
              iteratee2 = undefined2;
            }
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
          });
          var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined2;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined2, comparator);
          });
          function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
          }
          function uniqBy(array, iteratee2) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
          }
          function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined2;
            return array && array.length ? baseUniq(array, undefined2, comparator) : [];
          }
          function unzip(array) {
            if (!(array && array.length)) {
              return [];
            }
            var length = 0;
            array = arrayFilter(array, function(group) {
              if (isArrayLikeObject(group)) {
                length = nativeMax(group.length, length);
                return true;
              }
            });
            return baseTimes(length, function(index) {
              return arrayMap(array, baseProperty(index));
            });
          }
          function unzipWith(array, iteratee2) {
            if (!(array && array.length)) {
              return [];
            }
            var result2 = unzip(array);
            if (iteratee2 == null) {
              return result2;
            }
            return arrayMap(result2, function(group) {
              return apply2(iteratee2, undefined2, group);
            });
          }
          var without = baseRest(function(array, values2) {
            return isArrayLikeObject(array) ? baseDifference(array, values2) : [];
          });
          var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
          });
          var xorBy = baseRest(function(arrays) {
            var iteratee2 = last(arrays);
            if (isArrayLikeObject(iteratee2)) {
              iteratee2 = undefined2;
            }
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
          });
          var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined2;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined2, comparator);
          });
          var zip = baseRest(unzip);
          function zipObject(props, values2) {
            return baseZipObject(props || [], values2 || [], assignValue);
          }
          function zipObjectDeep(props, values2) {
            return baseZipObject(props || [], values2 || [], baseSet);
          }
          var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined2;
            iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined2;
            return unzipWith(arrays, iteratee2);
          });
          function chain3(value) {
            var result2 = lodash(value);
            result2.__chain__ = true;
            return result2;
          }
          function tap(value, interceptor) {
            interceptor(value);
            return value;
          }
          function thru(value, interceptor) {
            return interceptor(value);
          }
          var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
              return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
              return this.thru(interceptor);
            }
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
              "func": thru,
              "args": [interceptor],
              "thisArg": undefined2
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
              if (length && !array.length) {
                array.push(undefined2);
              }
              return array;
            });
          });
          function wrapperChain() {
            return chain3(this);
          }
          function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
          }
          function wrapperNext() {
            if (this.__values__ === undefined2) {
              this.__values__ = toArray2(this.value());
            }
            var done = this.__index__ >= this.__values__.length, value = done ? undefined2 : this.__values__[this.__index__++];
            return { "done": done, "value": value };
          }
          function wrapperToIterator() {
            return this;
          }
          function wrapperPlant(value) {
            var result2, parent2 = this;
            while (parent2 instanceof baseLodash) {
              var clone2 = wrapperClone(parent2);
              clone2.__index__ = 0;
              clone2.__values__ = undefined2;
              if (result2) {
                previous.__wrapped__ = clone2;
              } else {
                result2 = clone2;
              }
              var previous = clone2;
              parent2 = parent2.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result2;
          }
          function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
              var wrapped = value;
              if (this.__actions__.length) {
                wrapped = new LazyWrapper(this);
              }
              wrapped = wrapped.reverse();
              wrapped.__actions__.push({
                "func": thru,
                "args": [reverse],
                "thisArg": undefined2
              });
              return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
          }
          function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
          }
          var countBy = createAggregator(function(result2, value, key) {
            if (hasOwnProperty4.call(result2, key)) {
              ++result2[key];
            } else {
              baseAssignValue(result2, key, 1);
            }
          });
          function every(collection, predicate, guard) {
            var func = isArray3(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) {
              predicate = undefined2;
            }
            return func(collection, getIteratee(predicate, 3));
          }
          function filter5(collection, predicate) {
            var func = isArray3(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
          }
          var find8 = createFind(findIndex2);
          var findLast = createFind(findLastIndex);
          function flatMap(collection, iteratee2) {
            return baseFlatten(map3(collection, iteratee2), 1);
          }
          function flatMapDeep(collection, iteratee2) {
            return baseFlatten(map3(collection, iteratee2), INFINITY);
          }
          function flatMapDepth(collection, iteratee2, depth) {
            depth = depth === undefined2 ? 1 : toInteger(depth);
            return baseFlatten(map3(collection, iteratee2), depth);
          }
          function forEach2(collection, iteratee2) {
            var func = isArray3(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee2, 3));
          }
          function forEachRight(collection, iteratee2) {
            var func = isArray3(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee2, 3));
          }
          var groupBy = createAggregator(function(result2, value, key) {
            if (hasOwnProperty4.call(result2, key)) {
              result2[key].push(value);
            } else {
              baseAssignValue(result2, key, [value]);
            }
          });
          function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) {
              fromIndex = nativeMax(length + fromIndex, 0);
            }
            return isString3(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
          }
          var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result2 = isArrayLike(collection) ? Array2(collection.length) : [];
            baseEach(collection, function(value) {
              result2[++index] = isFunc ? apply2(path, value, args) : baseInvoke(value, path, args);
            });
            return result2;
          });
          var keyBy = createAggregator(function(result2, value, key) {
            baseAssignValue(result2, key, value);
          });
          function map3(collection, iteratee2) {
            var func = isArray3(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee2, 3));
          }
          function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) {
              return [];
            }
            if (!isArray3(iteratees)) {
              iteratees = iteratees == null ? [] : [iteratees];
            }
            orders = guard ? undefined2 : orders;
            if (!isArray3(orders)) {
              orders = orders == null ? [] : [orders];
            }
            return baseOrderBy(collection, iteratees, orders);
          }
          var partition = createAggregator(function(result2, value, key) {
            result2[key ? 0 : 1].push(value);
          }, function() {
            return [[], []];
          });
          function reduce2(collection, iteratee2, accumulator) {
            var func = isArray3(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
          }
          function reduceRight(collection, iteratee2, accumulator) {
            var func = isArray3(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
          }
          function reject(collection, predicate) {
            var func = isArray3(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
          }
          function sample(collection) {
            var func = isArray3(collection) ? arraySample : baseSample;
            return func(collection);
          }
          function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined2) {
              n = 1;
            } else {
              n = toInteger(n);
            }
            var func = isArray3(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
          }
          function shuffle3(collection) {
            var func = isArray3(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
          }
          function size(collection) {
            if (collection == null) {
              return 0;
            }
            if (isArrayLike(collection)) {
              return isString3(collection) ? stringSize(collection) : collection.length;
            }
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) {
              return collection.size;
            }
            return baseKeys(collection).length;
          }
          function some2(collection, predicate, guard) {
            var func = isArray3(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) {
              predicate = undefined2;
            }
            return func(collection, getIteratee(predicate, 3));
          }
          var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) {
              return [];
            }
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
              iteratees = [];
            } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
              iteratees = [iteratees[0]];
            }
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
          });
          var now3 = ctxNow || function() {
            return root.Date.now();
          };
          function after(n, func) {
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            n = toInteger(n);
            return function() {
              if (--n < 1) {
                return func.apply(this, arguments);
              }
            };
          }
          function ary(func, n, guard) {
            n = guard ? undefined2 : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined2, undefined2, undefined2, undefined2, n);
          }
          function before(n, func) {
            var result2;
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            n = toInteger(n);
            return function() {
              if (--n > 0) {
                result2 = func.apply(this, arguments);
              }
              if (n <= 1) {
                func = undefined2;
              }
              return result2;
            };
          }
          var bind2 = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
              var holders = replaceHolders(partials, getHolder(bind2));
              bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
          });
          var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
              var holders = replaceHolders(partials, getHolder(bindKey));
              bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
          });
          function curry(func, arity, guard) {
            arity = guard ? undefined2 : arity;
            var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
            result2.placeholder = curry.placeholder;
            return result2;
          }
          function curryRight(func, arity, guard) {
            arity = guard ? undefined2 : arity;
            var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
            result2.placeholder = curryRight.placeholder;
            return result2;
          }
          function debounce4(func, wait, options) {
            var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            wait = toNumber2(wait) || 0;
            if (isObject4(options)) {
              leading = !!options.leading;
              maxing = "maxWait" in options;
              maxWait = maxing ? nativeMax(toNumber2(options.maxWait) || 0, wait) : maxWait;
              trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
              var args = lastArgs, thisArg = lastThis;
              lastArgs = lastThis = undefined2;
              lastInvokeTime = time;
              result2 = func.apply(thisArg, args);
              return result2;
            }
            function leadingEdge(time) {
              lastInvokeTime = time;
              timerId = setTimeout2(timerExpired, wait);
              return leading ? invokeFunc(time) : result2;
            }
            function remainingWait(time) {
              var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
              return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
              var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
              return lastCallTime === undefined2 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
              var time = now3();
              if (shouldInvoke(time)) {
                return trailingEdge(time);
              }
              timerId = setTimeout2(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
              timerId = undefined2;
              if (trailing && lastArgs) {
                return invokeFunc(time);
              }
              lastArgs = lastThis = undefined2;
              return result2;
            }
            function cancel() {
              if (timerId !== undefined2) {
                clearTimeout2(timerId);
              }
              lastInvokeTime = 0;
              lastArgs = lastCallTime = lastThis = timerId = undefined2;
            }
            function flush() {
              return timerId === undefined2 ? result2 : trailingEdge(now3());
            }
            function debounced() {
              var time = now3(), isInvoking = shouldInvoke(time);
              lastArgs = arguments;
              lastThis = this;
              lastCallTime = time;
              if (isInvoking) {
                if (timerId === undefined2) {
                  return leadingEdge(lastCallTime);
                }
                if (maxing) {
                  clearTimeout2(timerId);
                  timerId = setTimeout2(timerExpired, wait);
                  return invokeFunc(lastCallTime);
                }
              }
              if (timerId === undefined2) {
                timerId = setTimeout2(timerExpired, wait);
              }
              return result2;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
          }
          var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
          });
          var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber2(wait) || 0, args);
          });
          function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
          }
          function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            var memoized = function() {
              var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
              if (cache.has(key)) {
                return cache.get(key);
              }
              var result2 = func.apply(this, args);
              memoized.cache = cache.set(key, result2) || cache;
              return result2;
            };
            memoized.cache = new (memoize.Cache || MapCache)();
            return memoized;
          }
          memoize.Cache = MapCache;
          function negate(predicate) {
            if (typeof predicate != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            return function() {
              var args = arguments;
              switch (args.length) {
                case 0:
                  return !predicate.call(this);
                case 1:
                  return !predicate.call(this, args[0]);
                case 2:
                  return !predicate.call(this, args[0], args[1]);
                case 3:
                  return !predicate.call(this, args[0], args[1], args[2]);
              }
              return !predicate.apply(this, args);
            };
          }
          function once(func) {
            return before(2, func);
          }
          var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray3(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
              var index = -1, length = nativeMin(args.length, funcsLength);
              while (++index < length) {
                args[index] = transforms[index].call(this, args[index]);
              }
              return apply2(func, this, args);
            });
          });
          var partial2 = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial2));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined2, partials, holders);
          });
          var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined2, partials, holders);
          });
          var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined2, undefined2, undefined2, indexes);
          });
          function rest(func, start) {
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            start = start === undefined2 ? start : toInteger(start);
            return baseRest(func, start);
          }
          function spread3(func, start) {
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
              var array = args[start], otherArgs = castSlice(args, 0, start);
              if (array) {
                arrayPush(otherArgs, array);
              }
              return apply2(func, this, otherArgs);
            });
          }
          function throttle2(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            if (isObject4(options)) {
              leading = "leading" in options ? !!options.leading : leading;
              trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce4(func, wait, {
              "leading": leading,
              "maxWait": wait,
              "trailing": trailing
            });
          }
          function unary(func) {
            return ary(func, 1);
          }
          function wrap(value, wrapper) {
            return partial2(castFunction(wrapper), value);
          }
          function castArray() {
            if (!arguments.length) {
              return [];
            }
            var value = arguments[0];
            return isArray3(value) ? value : [value];
          }
          function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
          }
          function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined2;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
          }
          function cloneDeep2(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
          }
          function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined2;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
          }
          function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
          }
          function eq(value, other) {
            return value === other || value !== value && other !== other;
          }
          var gt = createRelationalOperation(baseGt);
          var gte = createRelationalOperation(function(value, other) {
            return value >= other;
          });
          var isArguments = baseIsArguments(/* @__PURE__ */ (function() {
            return arguments;
          })()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty4.call(value, "callee") && !propertyIsEnumerable2.call(value, "callee");
          };
          var isArray3 = Array2.isArray;
          var isArrayBuffer2 = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
          function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction5(value);
          }
          function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
          }
          function isBoolean2(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
          }
          var isBuffer2 = nativeIsBuffer || stubFalse;
          var isDate3 = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
          function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject3(value);
          }
          function isEmpty(value) {
            if (value == null) {
              return true;
            }
            if (isArrayLike(value) && (isArray3(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer2(value) || isTypedArray2(value) || isArguments(value))) {
              return !value.length;
            }
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) {
              return !value.size;
            }
            if (isPrototype(value)) {
              return !baseKeys(value).length;
            }
            for (var key in value) {
              if (hasOwnProperty4.call(value, key)) {
                return false;
              }
            }
            return true;
          }
          function isEqual2(value, other) {
            return baseIsEqual(value, other);
          }
          function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined2;
            var result2 = customizer ? customizer(value, other) : undefined2;
            return result2 === undefined2 ? baseIsEqual(value, other, undefined2, customizer) : !!result2;
          }
          function isError(value) {
            if (!isObjectLike(value)) {
              return false;
            }
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject3(value);
          }
          function isFinite2(value) {
            return typeof value == "number" && nativeIsFinite(value);
          }
          function isFunction5(value) {
            if (!isObject4(value)) {
              return false;
            }
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
          }
          function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
          }
          function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER2;
          }
          function isObject4(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
          }
          function isObjectLike(value) {
            return value != null && typeof value == "object";
          }
          var isMap2 = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
          function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
          }
          function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined2;
            return baseIsMatch(object, source, getMatchData(source), customizer);
          }
          function isNaN2(value) {
            return isNumber2(value) && value != +value;
          }
          function isNative(value) {
            if (isMaskable(value)) {
              throw new Error2(CORE_ERROR_TEXT);
            }
            return baseIsNative(value);
          }
          function isNull(value) {
            return value === null;
          }
          function isNil(value) {
            return value == null;
          }
          function isNumber2(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
          }
          function isPlainObject3(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
              return false;
            }
            var proto = getPrototype(value);
            if (proto === null) {
              return true;
            }
            var Ctor = hasOwnProperty4.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
          }
          var isRegExp3 = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
          function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER2 && value <= MAX_SAFE_INTEGER2;
          }
          var isSet3 = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
          function isString3(value) {
            return typeof value == "string" || !isArray3(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
          }
          function isSymbol2(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
          }
          var isTypedArray2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
          function isUndefined2(value) {
            return value === undefined2;
          }
          function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
          }
          function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
          }
          var lt = createRelationalOperation(baseLt);
          var lte = createRelationalOperation(function(value, other) {
            return value <= other;
          });
          function toArray2(value) {
            if (!value) {
              return [];
            }
            if (isArrayLike(value)) {
              return isString3(value) ? stringToArray2(value) : copyArray(value);
            }
            if (symIterator && value[symIterator]) {
              return iteratorToArray(value[symIterator]());
            }
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
          }
          function toFinite(value) {
            if (!value) {
              return value === 0 ? value : 0;
            }
            value = toNumber2(value);
            if (value === INFINITY || value === -INFINITY) {
              var sign = value < 0 ? -1 : 1;
              return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
          }
          function toInteger(value) {
            var result2 = toFinite(value), remainder = result2 % 1;
            return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
          }
          function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
          }
          function toNumber2(value) {
            if (typeof value == "number") {
              return value;
            }
            if (isSymbol2(value)) {
              return NAN;
            }
            if (isObject4(value)) {
              var other = typeof value.valueOf == "function" ? value.valueOf() : value;
              value = isObject4(other) ? other + "" : other;
            }
            if (typeof value != "string") {
              return value === 0 ? value : +value;
            }
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
          }
          function toPlainObject(value) {
            return copyObject(value, keysIn(value));
          }
          function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER2, MAX_SAFE_INTEGER2) : value === 0 ? value : 0;
          }
          function toString3(value) {
            return value == null ? "" : baseToString(value);
          }
          var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
              copyObject(source, keys(source), object);
              return;
            }
            for (var key in source) {
              if (hasOwnProperty4.call(source, key)) {
                assignValue(object, key, source[key]);
              }
            }
          });
          var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
          });
          var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
          });
          var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
          });
          var at = flatRest(baseAt);
          function create2(prototype2, properties) {
            var result2 = baseCreate(prototype2);
            return properties == null ? result2 : baseAssign(result2, properties);
          }
          var defaults2 = baseRest(function(object, sources) {
            object = Object2(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined2;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              length = 1;
            }
            while (++index < length) {
              var source = sources[index];
              var props = keysIn(source);
              var propsIndex = -1;
              var propsLength = props.length;
              while (++propsIndex < propsLength) {
                var key = props[propsIndex];
                var value = object[key];
                if (value === undefined2 || eq(value, objectProto[key]) && !hasOwnProperty4.call(object, key)) {
                  object[key] = source[key];
                }
              }
            }
            return object;
          });
          var defaultsDeep = baseRest(function(args) {
            args.push(undefined2, customDefaultsMerge);
            return apply2(mergeWith, undefined2, args);
          });
          function findKey2(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
          }
          function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
          }
          function forIn(object, iteratee2) {
            return object == null ? object : baseFor(object, getIteratee(iteratee2, 3), keysIn);
          }
          function forInRight(object, iteratee2) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee2, 3), keysIn);
          }
          function forOwn(object, iteratee2) {
            return object && baseForOwn(object, getIteratee(iteratee2, 3));
          }
          function forOwnRight(object, iteratee2) {
            return object && baseForOwnRight(object, getIteratee(iteratee2, 3));
          }
          function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
          }
          function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
          }
          function get3(object, path, defaultValue) {
            var result2 = object == null ? undefined2 : baseGet(object, path);
            return result2 === undefined2 ? defaultValue : result2;
          }
          function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
          }
          function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
          }
          var invert = createInverter(function(result2, value, key) {
            if (value != null && typeof value.toString != "function") {
              value = nativeObjectToString.call(value);
            }
            result2[value] = key;
          }, constant(identity));
          var invertBy = createInverter(function(result2, value, key) {
            if (value != null && typeof value.toString != "function") {
              value = nativeObjectToString.call(value);
            }
            if (hasOwnProperty4.call(result2, value)) {
              result2[value].push(key);
            } else {
              result2[value] = [key];
            }
          }, getIteratee);
          var invoke = baseRest(baseInvoke);
          function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
          }
          function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
          }
          function mapKeys(object, iteratee2) {
            var result2 = {};
            iteratee2 = getIteratee(iteratee2, 3);
            baseForOwn(object, function(value, key, object2) {
              baseAssignValue(result2, iteratee2(value, key, object2), value);
            });
            return result2;
          }
          function mapValues(object, iteratee2) {
            var result2 = {};
            iteratee2 = getIteratee(iteratee2, 3);
            baseForOwn(object, function(value, key, object2) {
              baseAssignValue(result2, key, iteratee2(value, key, object2));
            });
            return result2;
          }
          var merge2 = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
          });
          var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
          });
          var omit = flatRest(function(object, paths) {
            var result2 = {};
            if (object == null) {
              return result2;
            }
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
              path = castPath(path, object);
              isDeep || (isDeep = path.length > 1);
              return path;
            });
            copyObject(object, getAllKeysIn(object), result2);
            if (isDeep) {
              result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            }
            var length = paths.length;
            while (length--) {
              baseUnset(result2, paths[length]);
            }
            return result2;
          });
          function omitBy(object, predicate) {
            return pickBy2(object, negate(getIteratee(predicate)));
          }
          var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
          });
          function pickBy2(object, predicate) {
            if (object == null) {
              return {};
            }
            var props = arrayMap(getAllKeysIn(object), function(prop) {
              return [prop];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
              return predicate(value, path[0]);
            });
          }
          function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            if (!length) {
              length = 1;
              object = undefined2;
            }
            while (++index < length) {
              var value = object == null ? undefined2 : object[toKey(path[index])];
              if (value === undefined2) {
                index = length;
                value = defaultValue;
              }
              object = isFunction5(value) ? value.call(object) : value;
            }
            return object;
          }
          function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
          }
          function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined2;
            return object == null ? object : baseSet(object, path, value, customizer);
          }
          var toPairs = createToPairs(keys);
          var toPairsIn = createToPairs(keysIn);
          function transform2(object, iteratee2, accumulator) {
            var isArr = isArray3(object), isArrLike = isArr || isBuffer2(object) || isTypedArray2(object);
            iteratee2 = getIteratee(iteratee2, 4);
            if (accumulator == null) {
              var Ctor = object && object.constructor;
              if (isArrLike) {
                accumulator = isArr ? new Ctor() : [];
              } else if (isObject4(object)) {
                accumulator = isFunction5(Ctor) ? baseCreate(getPrototype(object)) : {};
              } else {
                accumulator = {};
              }
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object2) {
              return iteratee2(accumulator, value, index, object2);
            });
            return accumulator;
          }
          function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
          }
          function update3(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
          }
          function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined2;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
          }
          function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
          }
          function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
          }
          function clamp2(number, lower, upper) {
            if (upper === undefined2) {
              upper = lower;
              lower = undefined2;
            }
            if (upper !== undefined2) {
              upper = toNumber2(upper);
              upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined2) {
              lower = toNumber2(lower);
              lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber2(number), lower, upper);
          }
          function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined2) {
              end = start;
              start = 0;
            } else {
              end = toFinite(end);
            }
            number = toNumber2(number);
            return baseInRange(number, start, end);
          }
          function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
              upper = floating = undefined2;
            }
            if (floating === undefined2) {
              if (typeof upper == "boolean") {
                floating = upper;
                upper = undefined2;
              } else if (typeof lower == "boolean") {
                floating = lower;
                lower = undefined2;
              }
            }
            if (lower === undefined2 && upper === undefined2) {
              lower = 0;
              upper = 1;
            } else {
              lower = toFinite(lower);
              if (upper === undefined2) {
                upper = lower;
                lower = 0;
              } else {
                upper = toFinite(upper);
              }
            }
            if (lower > upper) {
              var temp = lower;
              lower = upper;
              upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
              var rand = nativeRandom();
              return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
          }
          var camelCase = createCompounder(function(result2, word, index) {
            word = word.toLowerCase();
            return result2 + (index ? capitalize2(word) : word);
          });
          function capitalize2(string) {
            return upperFirst(toString3(string).toLowerCase());
          }
          function deburr(string) {
            string = toString3(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
          }
          function endsWith2(string, target, position) {
            string = toString3(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined2 ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
          }
          function escape(string) {
            string = toString3(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
          }
          function escapeRegExp(string) {
            string = toString3(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
          }
          var kebabCase = createCompounder(function(result2, word, index) {
            return result2 + (index ? "-" : "") + word.toLowerCase();
          });
          var lowerCase = createCompounder(function(result2, word, index) {
            return result2 + (index ? " " : "") + word.toLowerCase();
          });
          var lowerFirst = createCaseFirst("toLowerCase");
          function pad(string, length, chars) {
            string = toString3(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) {
              return string;
            }
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
          }
          function padEnd(string, length, chars) {
            string = toString3(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
          }
          function padStart(string, length, chars) {
            string = toString3(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
          }
          function parseInt2(string, radix, guard) {
            if (guard || radix == null) {
              radix = 0;
            } else if (radix) {
              radix = +radix;
            }
            return nativeParseInt(toString3(string).replace(reTrimStart, ""), radix || 0);
          }
          function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined2) {
              n = 1;
            } else {
              n = toInteger(n);
            }
            return baseRepeat(toString3(string), n);
          }
          function replace() {
            var args = arguments, string = toString3(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
          }
          var snakeCase = createCompounder(function(result2, word, index) {
            return result2 + (index ? "_" : "") + word.toLowerCase();
          });
          function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) {
              separator = limit = undefined2;
            }
            limit = limit === undefined2 ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) {
              return [];
            }
            string = toString3(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp3(separator))) {
              separator = baseToString(separator);
              if (!separator && hasUnicode(string)) {
                return castSlice(stringToArray2(string), 0, limit);
              }
            }
            return string.split(separator, limit);
          }
          var startCase = createCompounder(function(result2, word, index) {
            return result2 + (index ? " " : "") + upperFirst(word);
          });
          function startsWith(string, target, position) {
            string = toString3(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
          }
          function template(string, options, guard) {
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) {
              options = undefined2;
            }
            string = toString3(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
              if (reForbiddenIdentifierChars.test(key)) {
                throw new Error2(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
              }
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            var reDelimiters = RegExp2(
              (options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
              "g"
            );
            var sourceURL = "//# sourceURL=" + (hasOwnProperty4.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
              interpolateValue || (interpolateValue = esTemplateValue);
              source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
              if (escapeValue) {
                isEscaping = true;
                source += "' +\n__e(" + escapeValue + ") +\n'";
              }
              if (evaluateValue) {
                isEvaluating = true;
                source += "';\n" + evaluateValue + ";\n__p += '";
              }
              if (interpolateValue) {
                source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
              }
              index = offset + match.length;
              return match;
            });
            source += "';\n";
            var variable = hasOwnProperty4.call(options, "variable") && options.variable;
            if (!variable) {
              source = "with (obj) {\n" + source + "\n}\n";
            } else if (reForbiddenIdentifierChars.test(variable)) {
              throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
            }
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result2 = attempt(function() {
              return Function2(importsKeys, sourceURL + "return " + source).apply(undefined2, importsValues);
            });
            result2.source = source;
            if (isError(result2)) {
              throw result2;
            }
            return result2;
          }
          function toLower(value) {
            return toString3(value).toLowerCase();
          }
          function toUpper(value) {
            return toString3(value).toUpperCase();
          }
          function trim2(string, chars, guard) {
            string = toString3(string);
            if (string && (guard || chars === undefined2)) {
              return baseTrim(string);
            }
            if (!string || !(chars = baseToString(chars))) {
              return string;
            }
            var strSymbols = stringToArray2(string), chrSymbols = stringToArray2(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
          }
          function trimEnd(string, chars, guard) {
            string = toString3(string);
            if (string && (guard || chars === undefined2)) {
              return string.slice(0, trimmedEndIndex(string) + 1);
            }
            if (!string || !(chars = baseToString(chars))) {
              return string;
            }
            var strSymbols = stringToArray2(string), end = charsEndIndex(strSymbols, stringToArray2(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
          }
          function trimStart(string, chars, guard) {
            string = toString3(string);
            if (string && (guard || chars === undefined2)) {
              return string.replace(reTrimStart, "");
            }
            if (!string || !(chars = baseToString(chars))) {
              return string;
            }
            var strSymbols = stringToArray2(string), start = charsStartIndex(strSymbols, stringToArray2(chars));
            return castSlice(strSymbols, start).join("");
          }
          function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject4(options)) {
              var separator = "separator" in options ? options.separator : separator;
              length = "length" in options ? toInteger(options.length) : length;
              omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString3(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
              var strSymbols = stringToArray2(string);
              strLength = strSymbols.length;
            }
            if (length >= strLength) {
              return string;
            }
            var end = length - stringSize(omission);
            if (end < 1) {
              return omission;
            }
            var result2 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined2) {
              return result2 + omission;
            }
            if (strSymbols) {
              end += result2.length - end;
            }
            if (isRegExp3(separator)) {
              if (string.slice(end).search(separator)) {
                var match, substring = result2;
                if (!separator.global) {
                  separator = RegExp2(separator.source, toString3(reFlags.exec(separator)) + "g");
                }
                separator.lastIndex = 0;
                while (match = separator.exec(substring)) {
                  var newEnd = match.index;
                }
                result2 = result2.slice(0, newEnd === undefined2 ? end : newEnd);
              }
            } else if (string.indexOf(baseToString(separator), end) != end) {
              var index = result2.lastIndexOf(separator);
              if (index > -1) {
                result2 = result2.slice(0, index);
              }
            }
            return result2 + omission;
          }
          function unescape(string) {
            string = toString3(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
          }
          var upperCase = createCompounder(function(result2, word, index) {
            return result2 + (index ? " " : "") + word.toUpperCase();
          });
          var upperFirst = createCaseFirst("toUpperCase");
          function words(string, pattern, guard) {
            string = toString3(string);
            pattern = guard ? undefined2 : pattern;
            if (pattern === undefined2) {
              return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            }
            return string.match(pattern) || [];
          }
          var attempt = baseRest(function(func, args) {
            try {
              return apply2(func, undefined2, args);
            } catch (e) {
              return isError(e) ? e : new Error2(e);
            }
          });
          var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
              key = toKey(key);
              baseAssignValue(object, key, bind2(object[key], object));
            });
            return object;
          });
          function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
              if (typeof pair[1] != "function") {
                throw new TypeError2(FUNC_ERROR_TEXT);
              }
              return [toIteratee(pair[0]), pair[1]];
            });
            return baseRest(function(args) {
              var index = -1;
              while (++index < length) {
                var pair = pairs[index];
                if (apply2(pair[0], this, args)) {
                  return apply2(pair[1], this, args);
                }
              }
            });
          }
          function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
          }
          function constant(value) {
            return function() {
              return value;
            };
          }
          function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
          }
          var flow = createFlow();
          var flowRight = createFlow(true);
          function identity(value) {
            return value;
          }
          function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
          }
          function matches2(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
          }
          function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
          }
          var method = baseRest(function(path, args) {
            return function(object) {
              return baseInvoke(object, path, args);
            };
          });
          var methodOf = baseRest(function(object, args) {
            return function(path) {
              return baseInvoke(object, path, args);
            };
          });
          function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject4(source) && (methodNames.length || !props.length))) {
              options = source;
              source = object;
              object = this;
              methodNames = baseFunctions(source, keys(source));
            }
            var chain4 = !(isObject4(options) && "chain" in options) || !!options.chain, isFunc = isFunction5(object);
            arrayEach(methodNames, function(methodName) {
              var func = source[methodName];
              object[methodName] = func;
              if (isFunc) {
                object.prototype[methodName] = function() {
                  var chainAll = this.__chain__;
                  if (chain4 || chainAll) {
                    var result2 = object(this.__wrapped__), actions4 = result2.__actions__ = copyArray(this.__actions__);
                    actions4.push({ "func": func, "args": arguments, "thisArg": object });
                    result2.__chain__ = chainAll;
                    return result2;
                  }
                  return func.apply(object, arrayPush([this.value()], arguments));
                };
              }
            });
            return object;
          }
          function noConflict() {
            if (root._ === this) {
              root._ = oldDash;
            }
            return this;
          }
          function noop2() {
          }
          function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
              return baseNth(args, n);
            });
          }
          var over = createOver(arrayMap);
          var overEvery = createOver(arrayEvery);
          var overSome = createOver(arraySome);
          function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
          }
          function propertyOf(object) {
            return function(path) {
              return object == null ? undefined2 : baseGet(object, path);
            };
          }
          var range2 = createRange();
          var rangeRight = createRange(true);
          function stubArray() {
            return [];
          }
          function stubFalse() {
            return false;
          }
          function stubObject() {
            return {};
          }
          function stubString() {
            return "";
          }
          function stubTrue() {
            return true;
          }
          function times(n, iteratee2) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER2) {
              return [];
            }
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee2 = getIteratee(iteratee2);
            n -= MAX_ARRAY_LENGTH;
            var result2 = baseTimes(length, iteratee2);
            while (++index < n) {
              iteratee2(index);
            }
            return result2;
          }
          function toPath(value) {
            if (isArray3(value)) {
              return arrayMap(value, toKey);
            }
            return isSymbol2(value) ? [value] : copyArray(stringToPath(toString3(value)));
          }
          function uniqueId(prefix2) {
            var id = ++idCounter3;
            return toString3(prefix2) + id;
          }
          var add = createMathOperation(function(augend, addend) {
            return augend + addend;
          }, 0);
          var ceil = createRound("ceil");
          var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
          }, 1);
          var floor = createRound("floor");
          function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined2;
          }
          function maxBy(array, iteratee2) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined2;
          }
          function mean(array) {
            return baseMean(array, identity);
          }
          function meanBy(array, iteratee2) {
            return baseMean(array, getIteratee(iteratee2, 2));
          }
          function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined2;
          }
          function minBy(array, iteratee2) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined2;
          }
          var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
          }, 1);
          var round = createRound("round");
          var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
          }, 0);
          function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
          }
          function sumBy(array, iteratee2) {
            return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
          }
          lodash.after = after;
          lodash.ary = ary;
          lodash.assign = assign;
          lodash.assignIn = assignIn;
          lodash.assignInWith = assignInWith;
          lodash.assignWith = assignWith;
          lodash.at = at;
          lodash.before = before;
          lodash.bind = bind2;
          lodash.bindAll = bindAll;
          lodash.bindKey = bindKey;
          lodash.castArray = castArray;
          lodash.chain = chain3;
          lodash.chunk = chunk;
          lodash.compact = compact;
          lodash.concat = concat;
          lodash.cond = cond;
          lodash.conforms = conforms;
          lodash.constant = constant;
          lodash.countBy = countBy;
          lodash.create = create2;
          lodash.curry = curry;
          lodash.curryRight = curryRight;
          lodash.debounce = debounce4;
          lodash.defaults = defaults2;
          lodash.defaultsDeep = defaultsDeep;
          lodash.defer = defer;
          lodash.delay = delay;
          lodash.difference = difference;
          lodash.differenceBy = differenceBy;
          lodash.differenceWith = differenceWith;
          lodash.drop = drop;
          lodash.dropRight = dropRight;
          lodash.dropRightWhile = dropRightWhile;
          lodash.dropWhile = dropWhile;
          lodash.fill = fill;
          lodash.filter = filter5;
          lodash.flatMap = flatMap;
          lodash.flatMapDeep = flatMapDeep;
          lodash.flatMapDepth = flatMapDepth;
          lodash.flatten = flatten;
          lodash.flattenDeep = flattenDeep;
          lodash.flattenDepth = flattenDepth;
          lodash.flip = flip;
          lodash.flow = flow;
          lodash.flowRight = flowRight;
          lodash.fromPairs = fromPairs;
          lodash.functions = functions;
          lodash.functionsIn = functionsIn;
          lodash.groupBy = groupBy;
          lodash.initial = initial;
          lodash.intersection = intersection;
          lodash.intersectionBy = intersectionBy;
          lodash.intersectionWith = intersectionWith;
          lodash.invert = invert;
          lodash.invertBy = invertBy;
          lodash.invokeMap = invokeMap;
          lodash.iteratee = iteratee;
          lodash.keyBy = keyBy;
          lodash.keys = keys;
          lodash.keysIn = keysIn;
          lodash.map = map3;
          lodash.mapKeys = mapKeys;
          lodash.mapValues = mapValues;
          lodash.matches = matches2;
          lodash.matchesProperty = matchesProperty;
          lodash.memoize = memoize;
          lodash.merge = merge2;
          lodash.mergeWith = mergeWith;
          lodash.method = method;
          lodash.methodOf = methodOf;
          lodash.mixin = mixin;
          lodash.negate = negate;
          lodash.nthArg = nthArg;
          lodash.omit = omit;
          lodash.omitBy = omitBy;
          lodash.once = once;
          lodash.orderBy = orderBy;
          lodash.over = over;
          lodash.overArgs = overArgs;
          lodash.overEvery = overEvery;
          lodash.overSome = overSome;
          lodash.partial = partial2;
          lodash.partialRight = partialRight;
          lodash.partition = partition;
          lodash.pick = pick;
          lodash.pickBy = pickBy2;
          lodash.property = property;
          lodash.propertyOf = propertyOf;
          lodash.pull = pull;
          lodash.pullAll = pullAll;
          lodash.pullAllBy = pullAllBy;
          lodash.pullAllWith = pullAllWith;
          lodash.pullAt = pullAt;
          lodash.range = range2;
          lodash.rangeRight = rangeRight;
          lodash.rearg = rearg;
          lodash.reject = reject;
          lodash.remove = remove2;
          lodash.rest = rest;
          lodash.reverse = reverse;
          lodash.sampleSize = sampleSize;
          lodash.set = set;
          lodash.setWith = setWith;
          lodash.shuffle = shuffle3;
          lodash.slice = slice;
          lodash.sortBy = sortBy;
          lodash.sortedUniq = sortedUniq;
          lodash.sortedUniqBy = sortedUniqBy;
          lodash.split = split;
          lodash.spread = spread3;
          lodash.tail = tail;
          lodash.take = take;
          lodash.takeRight = takeRight;
          lodash.takeRightWhile = takeRightWhile;
          lodash.takeWhile = takeWhile;
          lodash.tap = tap;
          lodash.throttle = throttle2;
          lodash.thru = thru;
          lodash.toArray = toArray2;
          lodash.toPairs = toPairs;
          lodash.toPairsIn = toPairsIn;
          lodash.toPath = toPath;
          lodash.toPlainObject = toPlainObject;
          lodash.transform = transform2;
          lodash.unary = unary;
          lodash.union = union;
          lodash.unionBy = unionBy;
          lodash.unionWith = unionWith;
          lodash.uniq = uniq;
          lodash.uniqBy = uniqBy;
          lodash.uniqWith = uniqWith;
          lodash.unset = unset;
          lodash.unzip = unzip;
          lodash.unzipWith = unzipWith;
          lodash.update = update3;
          lodash.updateWith = updateWith;
          lodash.values = values;
          lodash.valuesIn = valuesIn;
          lodash.without = without;
          lodash.words = words;
          lodash.wrap = wrap;
          lodash.xor = xor;
          lodash.xorBy = xorBy;
          lodash.xorWith = xorWith;
          lodash.zip = zip;
          lodash.zipObject = zipObject;
          lodash.zipObjectDeep = zipObjectDeep;
          lodash.zipWith = zipWith;
          lodash.entries = toPairs;
          lodash.entriesIn = toPairsIn;
          lodash.extend = assignIn;
          lodash.extendWith = assignInWith;
          mixin(lodash, lodash);
          lodash.add = add;
          lodash.attempt = attempt;
          lodash.camelCase = camelCase;
          lodash.capitalize = capitalize2;
          lodash.ceil = ceil;
          lodash.clamp = clamp2;
          lodash.clone = clone;
          lodash.cloneDeep = cloneDeep2;
          lodash.cloneDeepWith = cloneDeepWith;
          lodash.cloneWith = cloneWith;
          lodash.conformsTo = conformsTo;
          lodash.deburr = deburr;
          lodash.defaultTo = defaultTo;
          lodash.divide = divide;
          lodash.endsWith = endsWith2;
          lodash.eq = eq;
          lodash.escape = escape;
          lodash.escapeRegExp = escapeRegExp;
          lodash.every = every;
          lodash.find = find8;
          lodash.findIndex = findIndex2;
          lodash.findKey = findKey2;
          lodash.findLast = findLast;
          lodash.findLastIndex = findLastIndex;
          lodash.findLastKey = findLastKey;
          lodash.floor = floor;
          lodash.forEach = forEach2;
          lodash.forEachRight = forEachRight;
          lodash.forIn = forIn;
          lodash.forInRight = forInRight;
          lodash.forOwn = forOwn;
          lodash.forOwnRight = forOwnRight;
          lodash.get = get3;
          lodash.gt = gt;
          lodash.gte = gte;
          lodash.has = has;
          lodash.hasIn = hasIn;
          lodash.head = head;
          lodash.identity = identity;
          lodash.includes = includes;
          lodash.indexOf = indexOf;
          lodash.inRange = inRange;
          lodash.invoke = invoke;
          lodash.isArguments = isArguments;
          lodash.isArray = isArray3;
          lodash.isArrayBuffer = isArrayBuffer2;
          lodash.isArrayLike = isArrayLike;
          lodash.isArrayLikeObject = isArrayLikeObject;
          lodash.isBoolean = isBoolean2;
          lodash.isBuffer = isBuffer2;
          lodash.isDate = isDate3;
          lodash.isElement = isElement;
          lodash.isEmpty = isEmpty;
          lodash.isEqual = isEqual2;
          lodash.isEqualWith = isEqualWith;
          lodash.isError = isError;
          lodash.isFinite = isFinite2;
          lodash.isFunction = isFunction5;
          lodash.isInteger = isInteger;
          lodash.isLength = isLength;
          lodash.isMap = isMap2;
          lodash.isMatch = isMatch;
          lodash.isMatchWith = isMatchWith;
          lodash.isNaN = isNaN2;
          lodash.isNative = isNative;
          lodash.isNil = isNil;
          lodash.isNull = isNull;
          lodash.isNumber = isNumber2;
          lodash.isObject = isObject4;
          lodash.isObjectLike = isObjectLike;
          lodash.isPlainObject = isPlainObject3;
          lodash.isRegExp = isRegExp3;
          lodash.isSafeInteger = isSafeInteger;
          lodash.isSet = isSet3;
          lodash.isString = isString3;
          lodash.isSymbol = isSymbol2;
          lodash.isTypedArray = isTypedArray2;
          lodash.isUndefined = isUndefined2;
          lodash.isWeakMap = isWeakMap;
          lodash.isWeakSet = isWeakSet;
          lodash.join = join;
          lodash.kebabCase = kebabCase;
          lodash.last = last;
          lodash.lastIndexOf = lastIndexOf;
          lodash.lowerCase = lowerCase;
          lodash.lowerFirst = lowerFirst;
          lodash.lt = lt;
          lodash.lte = lte;
          lodash.max = max;
          lodash.maxBy = maxBy;
          lodash.mean = mean;
          lodash.meanBy = meanBy;
          lodash.min = min;
          lodash.minBy = minBy;
          lodash.stubArray = stubArray;
          lodash.stubFalse = stubFalse;
          lodash.stubObject = stubObject;
          lodash.stubString = stubString;
          lodash.stubTrue = stubTrue;
          lodash.multiply = multiply;
          lodash.nth = nth;
          lodash.noConflict = noConflict;
          lodash.noop = noop2;
          lodash.now = now3;
          lodash.pad = pad;
          lodash.padEnd = padEnd;
          lodash.padStart = padStart;
          lodash.parseInt = parseInt2;
          lodash.random = random;
          lodash.reduce = reduce2;
          lodash.reduceRight = reduceRight;
          lodash.repeat = repeat;
          lodash.replace = replace;
          lodash.result = result;
          lodash.round = round;
          lodash.runInContext = runInContext2;
          lodash.sample = sample;
          lodash.size = size;
          lodash.snakeCase = snakeCase;
          lodash.some = some2;
          lodash.sortedIndex = sortedIndex;
          lodash.sortedIndexBy = sortedIndexBy;
          lodash.sortedIndexOf = sortedIndexOf;
          lodash.sortedLastIndex = sortedLastIndex;
          lodash.sortedLastIndexBy = sortedLastIndexBy;
          lodash.sortedLastIndexOf = sortedLastIndexOf;
          lodash.startCase = startCase;
          lodash.startsWith = startsWith;
          lodash.subtract = subtract;
          lodash.sum = sum;
          lodash.sumBy = sumBy;
          lodash.template = template;
          lodash.times = times;
          lodash.toFinite = toFinite;
          lodash.toInteger = toInteger;
          lodash.toLength = toLength;
          lodash.toLower = toLower;
          lodash.toNumber = toNumber2;
          lodash.toSafeInteger = toSafeInteger;
          lodash.toString = toString3;
          lodash.toUpper = toUpper;
          lodash.trim = trim2;
          lodash.trimEnd = trimEnd;
          lodash.trimStart = trimStart;
          lodash.truncate = truncate;
          lodash.unescape = unescape;
          lodash.uniqueId = uniqueId;
          lodash.upperCase = upperCase;
          lodash.upperFirst = upperFirst;
          lodash.each = forEach2;
          lodash.eachRight = forEachRight;
          lodash.first = head;
          mixin(lodash, (function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
              if (!hasOwnProperty4.call(lodash.prototype, methodName)) {
                source[methodName] = func;
              }
            });
            return source;
          })(), { "chain": false });
          lodash.VERSION = VERSION3;
          arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
            lodash[methodName].placeholder = lodash;
          });
          arrayEach(["drop", "take"], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
              n = n === undefined2 ? 1 : nativeMax(toInteger(n), 0);
              var result2 = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
              if (result2.__filtered__) {
                result2.__takeCount__ = nativeMin(n, result2.__takeCount__);
              } else {
                result2.__views__.push({
                  "size": nativeMin(n, MAX_ARRAY_LENGTH),
                  "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
                });
              }
              return result2;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
              return this.reverse()[methodName](n).reverse();
            };
          });
          arrayEach(["filter", "map", "takeWhile"], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee2) {
              var result2 = this.clone();
              result2.__iteratees__.push({
                "iteratee": getIteratee(iteratee2, 3),
                "type": type
              });
              result2.__filtered__ = result2.__filtered__ || isFilter;
              return result2;
            };
          });
          arrayEach(["head", "last"], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
              return this[takeName](1).value()[0];
            };
          });
          arrayEach(["initial", "tail"], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
              return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
          });
          LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
          };
          LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
          };
          LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
          };
          LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") {
              return new LazyWrapper(this);
            }
            return this.map(function(value) {
              return baseInvoke(value, path, args);
            });
          });
          LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
          };
          LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result2 = this;
            if (result2.__filtered__ && (start > 0 || end < 0)) {
              return new LazyWrapper(result2);
            }
            if (start < 0) {
              result2 = result2.takeRight(-start);
            } else if (start) {
              result2 = result2.drop(start);
            }
            if (end !== undefined2) {
              end = toInteger(end);
              result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
            }
            return result2;
          };
          LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
          };
          LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
          };
          baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) {
              return;
            }
            lodash.prototype[methodName] = function() {
              var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray3(value);
              var interceptor = function(value2) {
                var result3 = lodashFunc.apply(lodash, arrayPush([value2], args));
                return isTaker && chainAll ? result3[0] : result3;
              };
              if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
                isLazy = useLazy = false;
              }
              var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
              if (!retUnwrapped && useLazy) {
                value = onlyLazy ? value : new LazyWrapper(this);
                var result2 = func.apply(value, args);
                result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined2 });
                return new LodashWrapper(result2, chainAll);
              }
              if (isUnwrapped && onlyLazy) {
                return func.apply(this, args);
              }
              result2 = this.thru(interceptor);
              return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
            };
          });
          arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
            var func = arrayProto2[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
              var args = arguments;
              if (retUnwrapped && !this.__chain__) {
                var value = this.value();
                return func.apply(isArray3(value) ? value : [], args);
              }
              return this[chainName](function(value2) {
                return func.apply(isArray3(value2) ? value2 : [], args);
              });
            };
          });
          baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
              var key = lodashFunc.name + "";
              if (!hasOwnProperty4.call(realNames, key)) {
                realNames[key] = [];
              }
              realNames[key].push({ "name": methodName, "func": lodashFunc });
            }
          });
          realNames[createHybrid(undefined2, WRAP_BIND_KEY_FLAG).name] = [{
            "name": "wrapper",
            "func": undefined2
          }];
          LazyWrapper.prototype.clone = lazyClone;
          LazyWrapper.prototype.reverse = lazyReverse;
          LazyWrapper.prototype.value = lazyValue;
          lodash.prototype.at = wrapperAt;
          lodash.prototype.chain = wrapperChain;
          lodash.prototype.commit = wrapperCommit;
          lodash.prototype.next = wrapperNext;
          lodash.prototype.plant = wrapperPlant;
          lodash.prototype.reverse = wrapperReverse;
          lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
          lodash.prototype.first = lodash.prototype.head;
          if (symIterator) {
            lodash.prototype[symIterator] = wrapperToIterator;
          }
          return lodash;
        });
        var _2 = runInContext();
        if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
          root._ = _2;
          define(function() {
            return _2;
          });
        } else if (freeModule) {
          (freeModule.exports = _2)._ = _2;
          freeExports._ = _2;
        } else {
          root._ = _2;
        }
      }).call(exports);
    }
  });

  // src/vue/components/helpers/personalizeAddCart.js
  var personalizeAddCart_exports = {};
  __export(personalizeAddCart_exports, {
    additionalItems: () => additionalItems,
    calculateFee: () => calculateFee,
    formData: () => formData
  });
  var import_lodash, getFeeType, getFeePrice, calculateFee, additionalItems, formData;
  var init_personalizeAddCart = __esm({
    "src/vue/components/helpers/personalizeAddCart.js"() {
      "use strict";
      import_lodash = __toESM(require_lodash(), 1);
      getFeeType = (variant, type = "flat") => variant.find((v) => v.title.toLowerCase().includes(type));
      getFeePrice = (variant, price) => variant.filter((v) => v.price == price);
      calculateFee = ({
        steps,
        feeVariant,
        quantity,
        templateColor
      }) => {
        const addOnsFee = (0, import_lodash.find)(steps?.add_ons, ["type", "personalization"])?.fees;
        let feeVariantId = [];
        let addOns = 0;
        let per_item = false;
        if (addOnsFee?.flat) {
          const variant = getFeeType(
            getFeePrice(feeVariant, addOnsFee?.flat),
            "flat"
          );
          if (variant) {
            addOns = variant?.price ?? 0;
            feeVariantId.push(variant);
          }
        } else if (addOnsFee?.per_item) {
          per_item = getFeeType(
            getFeePrice(feeVariant, addOnsFee?.per_item),
            "per item"
          );
          if (per_item) {
            feeVariantId.push(per_item);
            addOns = per_item?.price ?? 0 * quantity;
          }
        }
        let colorFees = (0, import_lodash.find)(steps?.colors, ["hex_value", templateColor])?.fees?.per_item;
        if (colorFees) {
          const variant = getFeeType(getFeePrice(feeVariant, colorFees), "color");
          if (variant) {
            feeVariantId.push(variant);
            colorFees = variant.price ?? 0 * quantity;
          }
        }
        return {
          feeVariantId,
          addOns,
          per_item,
          colorFees
        };
      };
      additionalItems = ({
        feeVariantId,
        groupId,
        image,
        title,
        quantity
      }) => {
        let is_flat_type = null;
        let is_per_item_type = null;
        let is_color_type = null;
        let additionalVariants = [];
        if (feeVariantId.length) {
          additionalVariants = feeVariantId.map((v) => {
            if (v.title.toLocaleLowerCase().includes("flat")) {
              is_flat_type = v.price;
            }
            if (v.title.toLowerCase().includes("per item")) {
              is_per_item_type = v.price;
            }
            if (v.title.toLowerCase().includes("color")) {
              is_color_type = v.price;
            }
            return {
              id: v.id,
              quantity: v.title.toLocaleLowerCase().includes("flat") ? 1 : quantity,
              properties: {
                _quantity_update: v.title.toLocaleLowerCase().includes("flat") ? false : true,
                _image: image,
                _qty_disable: true,
                _group_id: groupId,
                _fee_type: v.title.toLocaleLowerCase().includes("flat") ? "flat" : "per_item",
                _title: `${v.title.toLocaleLowerCase().includes("flat") ? "Personalization Setup Fee for" : "Per Item Fee for"} ${title}`
              }
            };
          });
        }
        return { additionalVariants, is_flat_type, is_per_item_type, is_color_type };
      };
      formData = ({
        quantity,
        productVariant,
        feeVariantId,
        legacyId,
        hazmat,
        customizations,
        is_sale,
        addOns,
        personalizationProperties,
        activeLayout,
        scene7Id,
        font,
        colorName,
        locations,
        artwork,
        base64Image,
        url,
        instructions,
        signOff,
        items,
        lineitemsWithFontSize,
        renderTemplate,
        prices,
        price,
        dimensions
      }) => {
        const groupId = (/* @__PURE__ */ new Date()).valueOf();
        const _image = base64Image.value || url.value;
        const { additionalVariants, is_color_type, is_flat_type, is_per_item_type } = additionalItems({
          feeVariantId,
          groupId,
          image: _image,
          title: productVariant.value.title,
          quantity: quantity.value
        });
        let formData2 = {
          items: [
            {
              quantity: quantity.value,
              id: productVariant.value.id,
              properties: {
                _parent_sku: legacyId.value,
                ...feeVariantId.length && {
                  _group_id: groupId,
                  _flat_fee_amount: is_flat_type,
                  _per_item_fee_amount: (is_per_item_type ?? is_color_type) * quantity.value
                },
                ...dimensions.value.weight && {
                  _weight: dimensions.value.weight
                },
                ...dimensions.value.length && {
                  _dimensions_length: dimensions.value.length
                },
                ...dimensions.value.width && {
                  _dimensions_width: dimensions.value.width
                },
                ...dimensions.value.height && {
                  _dimensions_height: dimensions.value.height
                },
                _hazmat: hazmat.value,
                _customizations: customizations,
                ...(is_sale.value || !!addOns) > 0 && {
                  _runDiscount: true
                },
                _personalization: {
                  ...customizations,
                  ...personalizationProperties
                },
                ...activeLayout.value && {
                  layout: customizations?.layout?.display ?? activeLayout.value
                },
                ...scene7Id.value && {
                  "Title Graphic": customizations?.titleGraphic?.display
                },
                ...font.value && { Font: customizations?.font?.display },
                ...colorName.value && { Color: colorName.value?.name },
                ...locations.value && {
                  Location: customizations?.location?.display
                },
                ...artwork.value?.image_path && {
                  "Upload Logo": artwork.value?.image_url
                },
                _image,
                ...instructions.value && {
                  notes: instructions.value
                },
                ...signOff.value && { approval: signOff?.value },
                ...items.value.length && {
                  _lineitems: lineitemsWithFontSize
                },
                ...(items.value.length > 1 || renderTemplate.value) && {
                  _qty_disable: true
                },
                ...prices.value && {
                  _price: price
                }
              }
            },
            ...feeVariantId.length > 0 ? additionalVariants : []
          ]
        };
        return formData2;
      };
    }
  });

  // src/vue/components/helpers/addCart.js
  var addCart_exports = {};
  __export(addCart_exports, {
    default: () => addCart
  });
  function addCart() {
    const add = async (e) => {
      const target = e.target;
      const form = window.jQuery(target).closest("form").serializeArray();
      const quantity = (0, import_lodash2.find)(form, ["name", "quantity"])?.value || 1;
      const vid = (0, import_lodash2.find)(form, ["name", "id"])?.value;
      const _price = (0, import_lodash2.find)(form, ["name", "properties[_price]"])?.value;
      const line1 = (0, import_lodash2.find)(form, ["name", "properties[line1]"])?.value;
      const _parent_sku = (0, import_lodash2.find)(form, ["name", "properties[_parent_sku]"])?.value;
      const _hazmat = (0, import_lodash2.find)(form, ["name", "properties[_hazmat]"])?.value;
      const _weight = (0, import_lodash2.find)(form, ["name", "properties[_weight]"])?.value;
      const _length = (0, import_lodash2.find)(form, [
        "name",
        "properties[_dimensions_length]"
      ])?.value;
      const _height = (0, import_lodash2.find)(form, [
        "name",
        "properties[_dimensions_height]"
      ])?.value;
      const _width = (0, import_lodash2.find)(form, ["name", "properties[_dimensions_width]"])?.value;
      const _is_clearance = (0, import_lodash2.find)(form, [
        "name",
        "properties[_is_clearance]"
      ])?.value;
      const _fetch_personalized = (0, import_lodash2.find)(form, [
        "name",
        "properties[_fetch_personalized]"
      ])?.value;
      const title_graphics = (0, import_lodash2.find)(form, [
        "name",
        "properties[title_graphics]"
      ])?.value;
      let formData2 = {
        items: [
          {
            quantity,
            id: vid
          }
          // ...(Object.keys(additionalVariants).length > 0
          //   ? additionalVariants.additionalVariants
          //   : []),
        ]
      };
      formData2.items[0]["properties"] = {
        ..._price && {
          _price
        },
        // ...(Object.keys(additionalVariants).length && {
        //   _group_id: groupId,
        //   _flat_fee_amount: additionalVariants.is_flat_type,
        //   _per_item_fee_amount:
        //     (additionalVariants.is_per_item_type ??
        //       additionalVariants.is_color_type) * quantity.value,
        // }),
        ...line1 && {
          line1,
          _image: `https://s7d7.scene7.com/is/image/Baudville/${title_graphics}?&layer=1&$line1=${line1}`
        },
        ..._parent_sku && {
          _parent_sku
        },
        ..._hazmat && {
          _hazmat
        },
        ..._weight && {
          _weight
        },
        ..._length && {
          _dimensions_length: _length
        },
        ..._height && {
          _dimensions_height: _height
        },
        ..._width && {
          _dimensions_width: _width
        },
        ...(_is_clearance || !!_fetch_personalized) && {
          _runDiscount: true
        }
      };
      console.log(formData2);
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData2)
      }).then((response) => {
        return response.json();
      }).then(async () => {
        if (window.theme.remodal) {
          window.theme.remodal.close();
        }
        document.body.classList.add("cart-add-logo");
        setTimeout(() => {
          document.body.classList.remove("cart-add-logo");
          document.body.classList.add("body-scroll--disabled");
          document.body.classList.remove("body-scroll--disabled");
        }, 2e3);
        window.jQuery("#add-to-cart-image").show();
        window.cartTarget.dispatchEvent(
          new CustomEvent("ajaxCart", {
            detail: {
              name: "ajaxCart"
            }
          })
        );
      }).catch((error) => {
        console.error("Error:", error);
      });
    };
    return {
      add
    };
  }
  var import_lodash2;
  var init_addCart = __esm({
    "src/vue/components/helpers/addCart.js"() {
      "use strict";
      import_lodash2 = __toESM(require_lodash(), 1);
      init_personalizeAddCart();
    }
  });

  // src/vue/store/cart.js
  var cart_exports = {};
  __export(cart_exports, {
    default: () => cart_default
  });
  var state, getters, mutations, actions, cart_default;
  var init_cart = __esm({
    "src/vue/store/cart.js"() {
      "use strict";
      state = {
        cart: [],
        cartDrawer: false,
        addToCart: true,
        selectedFilter: {},
        filteredProductsLength: 0,
        filteredProducts: [],
        seletctedSort: null
      };
      getters = {
        getCart(state4) {
          return state4.cart;
        },
        getCartDrawer(state4) {
          return state4.cartDrawer;
        },
        count(state4) {
          return state4.cart.item_count;
        },
        addToCart(state4) {
          return state4.addToCart;
        },
        getSelectedFilter(state4) {
          return state4.selectedFilter;
        },
        getSelectedSort(state4) {
          return state4.seletctedSort;
        },
        getProducts(state4) {
          return state4.products;
        },
        getFilteredProducts(state4) {
          return state4.filteredProducts;
        },
        getFilteredProductsLength(state4) {
          return state4.filteredProductsLength;
        }
      };
      mutations = {
        SAVE_CART_DRAWER(state4, bool) {
          state4.cartDrawer = bool;
        },
        SAVE_CART(state4, cart) {
          state4.cart = cart;
        },
        SAVE_ADD_TO_CART(state4, bool) {
          state4.addToCart = bool;
        },
        SAVE_SELECTED_FILTER(state4, filter5) {
          state4.selectedFilter = { ...filter5 };
        },
        SAVE_SELECTED_SORT(state4, sort) {
          state4.seletctedSort = sort;
        },
        SAVE_FILTERED_PRODUCTS(state4, products) {
          state4.filteredProducts = [...products];
        },
        SAVE_FILTERED_PRODUCTS_LENGTH(state4, length) {
          state4.filteredProductsLength = length;
        }
      };
      actions = {
        saveCartDrawer({ commit: commit2 }, bool) {
          commit2("SAVE_CART_DRAWER", bool);
        },
        saveCart({ commit: commit2 }, cart) {
          commit2("SAVE_CART", cart);
        },
        saveAddToCart({ commit: commit2 }, bool) {
          commit2("SAVE_ADD_TO_CART", bool);
        },
        saveSelectedFilter({ commit: commit2 }, filter5) {
          commit2("SAVE_SELECTED_FILTER", filter5);
        },
        saveSelectedSort({ commit: commit2 }, sort) {
          commit2("SAVE_SELECTED_SORT", sort);
        },
        saveFilteredProducts({ commit: commit2 }, products) {
          commit2("SAVE_FILTERED_PRODUCTS", products);
        },
        saveFilteredProductsLength({ commit: commit2 }, length) {
          commit2("SAVE_FILTERED_PRODUCTS_LENGTH", length);
        }
      };
      cart_default = {
        state,
        getters,
        mutations,
        actions
      };
    }
  });

  // src/vue/store/mobile-menu.js
  var mobile_menu_exports = {};
  __export(mobile_menu_exports, {
    default: () => mobile_menu_default
  });
  var state2, getters2, mutations2, actions2, mobile_menu_default;
  var init_mobile_menu = __esm({
    "src/vue/store/mobile-menu.js"() {
      "use strict";
      state2 = {
        visible: false
      };
      getters2 = {};
      mutations2 = {
        TOGGLE(state4) {
          state4.visible = !state4.visible;
        },
        SHOW(state4) {
          state4.visible = true;
        },
        HIDE(state4) {
          state4.visible = false;
        }
      };
      actions2 = {
        toggle({ commit: commit2 }) {
          commit2("TOGGLE");
        },
        show({ commit: commit2 }) {
          commit2("SHOW");
        },
        hide({ commit: commit2 }) {
          commit2("HIDE");
        }
      };
      mobile_menu_default = {
        namespaced: true,
        state: state2,
        getters: getters2,
        mutations: mutations2,
        actions: actions2
      };
    }
  });

  // src/vue/store/stores.js
  var stores_exports = {};
  __export(stores_exports, {
    default: () => stores_default
  });
  var state3, getters3, mutations3, actions3, stores_default;
  var init_stores = __esm({
    "src/vue/store/stores.js"() {
      "use strict";
      state3 = {
        scene7Id: null,
        emblem: null,
        titleGraphicCategories: null,
        items: [
          {
            line1: "",
            line2: "",
            line3: "",
            line4: "",
            line5: "",
            line6: "",
            linelp: ""
          }
        ],
        activeIndex: 0,
        instructions: "",
        signOff: null,
        signOffError: false,
        artwork: {},
        artworks: [],
        layout: null,
        layouts: null,
        locations: null,
        font: "",
        fontSize: [112, 80, 80],
        fontSizeName: [
          {
            size1: {},
            size2: {},
            size3: {},
            size4: {},
            size5: {},
            size6: {}
          }
        ],
        verse: null,
        productColor: null,
        templateColor: null,
        colorName: null,
        renderTemplate: false,
        certificateTemp: false,
        canvases: [],
        selectedCanvas: -1,
        uploadTextLogo: "NOGRAPHIC",
        uploadLogo: false,
        logoText: {
          line1: "",
          line2: "",
          line3: ""
        },
        quantities: {
          s: 0,
          m: 0,
          l: 0,
          xl: 0,
          xxl: 0
        },
        quantity: 1,
        minQuantity: 1,
        multipleQuantity: 1,
        prices: false
      };
      getters3 = {
        getScene7Id(state4) {
          return state4.scene7Id;
        },
        getEmblem(state4) {
          return state4.emblem;
        },
        getTitleGraphicCategories(state4) {
          return state4.titleGraphicCategories;
        },
        getTemplateColor(state4) {
          return state4.templateColor;
        },
        getColorName(state4) {
          return state4.colorName;
        },
        getProductColor(state4) {
          return state4.productColor;
        },
        getArtwork(state4) {
          return state4.artwork;
        },
        getArtworks(state4) {
          return state4.artworks;
        },
        getFont(state4) {
          return state4.font;
        },
        getFontSize(state4) {
          return state4.fontSize;
        },
        getFontSizeName(state4) {
          return state4.fontSizeName;
        },
        getFontSizeNameById: (state4) => (id) => {
          return state4.fontSizeName[id];
        },
        getLastFontSizeName(state4) {
          if (state4.fontSizeName.length > 0) {
            return state4.fontSizeName.slice(-1).pop();
          }
        },
        getVerse(state4) {
          return state4.verse;
        },
        getActiveIndex(state4) {
          return state4.activeIndex;
        },
        getItems(state4) {
          return state4.items;
        },
        getLayout(state4) {
          return state4.layout;
        },
        getLayouts(state4) {
          return state4.layouts;
        },
        getLocations(state4) {
          return state4.locations;
        },
        getItemSize(state4) {
          return state4.items.length - 1;
        },
        getActiveItemSize(state4) {
          return Object.keys(state4.items[0]).length;
        },
        getItemById: (state4) => (id) => {
          return state4.items[id];
        },
        getLastItem(state4) {
          if (state4.items.length > 0) {
            return state4.items.slice(-1).pop();
          }
        },
        getCanvases(state4) {
          return state4.canvases;
        },
        getSelectedCanvas(state4) {
          return state4.selectedCanvas;
        },
        getCanvasById: (state4) => (id) => {
          return state4.artworks[id];
        },
        getRenderTemplate(state4) {
          return state4.renderTemplate;
        },
        getCertificateTemp(state4) {
          return state4.certificateTemp;
        },
        instructions(state4) {
          return state4.instructions;
        },
        signOff(state4) {
          return state4.signOff;
        },
        signOffError(state4) {
          return state4.signOffError;
        },
        getLogoText(state4) {
          return state4.logoText;
        },
        uploadLogo(state4) {
          return state4.uploadLogo;
        },
        uploadTextLogo(state4) {
          return state4.uploadTextLogo;
        },
        getQuantities(state4) {
          return state4.quantities;
        },
        getQuantity(state4) {
          return state4.quantity;
        },
        getMinQuantity(state4) {
          return state4.minQuantity;
        },
        getMultipleQuantity(state4) {
          return state4.multipleQuantity;
        },
        getPrices(state4) {
          return state4.prices;
        }
      };
      mutations3 = {
        SAVE_SCENE7_ID(state4, id) {
          state4.scene7Id = id;
        },
        SAVE_EMBLEM(state4, id) {
          state4.emblem = id;
        },
        SAVE_TITLE_GRAPHIC_CATEGORIES(state4, id) {
          state4.titleGraphicCategories = id;
        },
        SAVE_ARTWORK(state4, artwork) {
          state4.artwork = artwork;
        },
        SAVE_ARTWORKS(state4, artwork) {
          state4.artworks.push(artwork);
        },
        UPDATE_ARTWORKS(state4, obj) {
          state4.artworks[obj.index] = obj.obj;
        },
        SORT_ARTWORKS(state4, obj) {
          state4.artworks = obj;
        },
        DELETE_ARTWORKS(state4, index) {
          state4.artworks.splice(index, 1);
        },
        SAVE_TEMPLATE_COLOR(state4, templateColor) {
          state4.templateColor = templateColor;
        },
        SAVE_COLOR_NAME(state4, name) {
          state4.colorName = name;
        },
        SAVE_PRODUCT_COLOR(state4, productColor) {
          state4.productColor = productColor;
        },
        SAVE_RENDER_TEMPLATE(state4, template) {
          state4.renderTemplate = template;
        },
        SAVE_CERTIFICATE_TEMP(state4, template) {
          state4.certificateTemp = template;
        },
        SAVE_LAYOUT(state4, layout) {
          state4.layout = layout;
        },
        SAVE_LAYOUTS(state4, layouts) {
          state4.layouts = layouts;
        },
        SAVE_LOCATIONS(state4, locations) {
          state4.locations = locations;
        },
        SAVE_FONT(state4, font) {
          state4.font = font;
        },
        SAVE_FONT_SIZE(state4, fontSize) {
          state4.fontSize = fontSize;
        },
        SAVE_FONT_SIZE_NAME(state4, name) {
          state4.fontSizeName.push(name);
        },
        UPDATE_FONT_SIZE_NAME(state4, { item, index }) {
          state4.fontSizeName[index] = item;
        },
        DELETE_FONT_SIZE_NAME(state4, index) {
          state4.fontSizeName.splice(index, 1);
        },
        SAVE_VERSE(state4, verse) {
          state4.verse = verse;
        },
        UPDATE_ACTIVE_INDEX(state4, index) {
          state4.activeIndex = index;
        },
        SAVE_ITEMS(state4, item) {
          state4.items.push(item);
        },
        UPDATE_ITEMS(state4, { item, index }) {
          state4.items[index] = item;
        },
        DELETE_ITEMS(state4, index) {
          state4.items.splice(index, 1);
        },
        SAVE_INSTRUCTIONS(state4, text) {
          state4.instructions = text;
        },
        SAVE_SIGN_OFF(state4, text) {
          state4.signOff = text;
        },
        SAVE_SIGN_OFF_ERROR(state4, bool) {
          state4.signOffError = bool;
        },
        SAVE_CANVASES(state4, canvas) {
          state4.canvases.push(canvas);
        },
        SAVE_SELECTED_CANVAS(state4, index) {
          state4.selectedCanvas = index;
        },
        SAVE_UPLOAD_LOGO(state4, bool) {
          state4.uploadLogo = bool;
        },
        SAVE_LOGO_TEXT(state4, text) {
          state4.logoText = text;
        },
        SAVE_UPLOAD_LOGO_TEXT(state4, text) {
          state4.uploadTextLogo = text;
        },
        SAVE_QUANTITIES(state4, quantity) {
          state4.quantities = quantity;
        },
        SAVE_QUANTITY(state4, quantity) {
          state4.quantity = quantity;
        },
        SAVE_MULTIPLE_QUANTITY(state4, multipleQuantity) {
          state4.multipleQuantity = multipleQuantity;
        },
        SAVE_MIN_QUANTITY(state4, quantity) {
          state4.minQuantity = quantity;
        },
        SAVE_PRICES(state4, prices) {
          state4.prices = prices;
        }
      };
      actions3 = {
        saveScene7Id({ commit: commit2 }, id) {
          commit2("SAVE_SCENE7_ID", id);
        },
        saveEmblem({ commit: commit2 }, id) {
          commit2("SAVE_EMBLEM", id);
        },
        saveTitleGraphicCategories({ commit: commit2 }, id) {
          commit2("SAVE_TITLE_GRAPHIC_CATEGORIES", id);
        },
        saveArtwork({ commit: commit2 }, artwork) {
          commit2("SAVE_ARTWORK", artwork);
        },
        saveArtworks({ commit: commit2 }, artworks) {
          commit2("SAVE_ARTWORKS", artworks);
        },
        sortArtworks({ commit: commit2 }, obj) {
          commit2("SORT_ARTWORKS", obj);
        },
        updateArtworks({ commit: commit2 }, obj) {
          commit2("UPDATE_ARTWORKS", obj);
        },
        deleteArtworks({ commit: commit2 }, index) {
          commit2("DELETE_ARTWORKS", index);
        },
        saveTemplateColor({ commit: commit2 }, templateColor) {
          commit2("SAVE_TEMPLATE_COLOR", templateColor);
        },
        saveColorName({ commit: commit2 }, templateColor) {
          commit2("SAVE_COLOR_NAME", templateColor);
        },
        saveProductColor({ commit: commit2 }, name) {
          commit2("SAVE_PRODUCT_COLOR", name);
        },
        saveRenderTemplate({ commit: commit2 }, template) {
          commit2("SAVE_RENDER_TEMPLATE", template);
        },
        saveCertificateTemp({ commit: commit2 }, template) {
          commit2("SAVE_CERTIFICATE_TEMP", template);
        },
        saveFont({ commit: commit2 }, font) {
          commit2("SAVE_FONT", font);
        },
        saveFontSize({ commit: commit2 }, fontSize) {
          commit2("SAVE_FONT_SIZE", fontSize);
        },
        saveFontSizeName({ commit: commit2 }, name) {
          commit2("SAVE_FONT_SIZE_NAME", name);
        },
        updateFontSizeName({ commit: commit2 }, obj) {
          commit2("UPDATE_FONT_SIZE_NAME", obj);
        },
        deleteFontSizeName({ commit: commit2 }, index) {
          commit2("DELETE_FONT_SIZE_NAME", index);
        },
        saveLayout({ commit: commit2 }, layout) {
          commit2("SAVE_LAYOUT", layout);
        },
        saveLayouts({ commit: commit2 }, layouts) {
          commit2("SAVE_LAYOUTS", layouts);
        },
        saveLocations({ commit: commit2 }, locations) {
          commit2("SAVE_LOCATIONS", locations);
        },
        saveVerse({ commit: commit2 }, verse) {
          commit2("SAVE_VERSE", verse);
        },
        updateActiveIndex({ commit: commit2 }, index) {
          commit2("UPDATE_ACTIVE_INDEX", index);
        },
        saveItems({ commit: commit2 }, item) {
          commit2("SAVE_ITEMS", item);
        },
        updateItem({ commit: commit2 }, obj) {
          commit2("UPDATE_ITEMS", obj);
        },
        deleteItem({ commit: commit2 }, index) {
          commit2("DELETE_ITEMS", index);
        },
        saveInstructions({ commit: commit2 }, text) {
          commit2("SAVE_INSTRUCTIONS", text);
        },
        saveSignOff({ commit: commit2 }, text) {
          commit2("SAVE_SIGN_OFF", text);
        },
        saveSignOffEror({ commit: commit2 }, bool) {
          commit2("SAVE_SIGN_OFF_ERROR", bool);
        },
        saveCanvases({ commit: commit2 }, canvas) {
          commit2("SAVE_CANVASES", canvas);
        },
        saveSelectedCanvas({ commit: commit2 }, index) {
          commit2("SAVE_SELECTED_CANVAS", index);
        },
        saveUploadLogo({ commit: commit2 }, bool) {
          commit2("SAVE_UPLOAD_LOGO", bool);
        },
        saveLogoText({ commit: commit2 }, text) {
          commit2("SAVE_LOGO_TEXT", text);
        },
        saveUploadLogoText({ commit: commit2 }, text) {
          commit2("SAVE_UPLOAD_LOGO_TEXT", text);
        },
        saveQuantities({ commit: commit2 }, quantity) {
          commit2("SAVE_QUANTITIES", quantity);
        },
        saveQuantity({ commit: commit2 }, quantity) {
          commit2("SAVE_QUANTITY", quantity);
        },
        saveMinQuantity({ commit: commit2 }, quantity) {
          commit2("SAVE_MIN_QUANTITY", quantity);
        },
        saveMultipleQuantity({ commit: commit2 }, multipleQuantity) {
          commit2("SAVE_MULTIPLE_QUANTITY", multipleQuantity);
        },
        savePrices({ commit: commit2 }, prices) {
          commit2("SAVE_PRICES", prices);
        }
      };
      stores_default = {
        //   namespaced: true,
        state: state3,
        getters: getters3,
        mutations: mutations3,
        actions: actions3
      };
    }
  });

  // src/vue/components/helpers/canvas.js
  var canvas_exports = {};
  __export(canvas_exports, {
    default: () => canvasHelper
  });
  function canvasHelper() {
    const config = {
      scene7CanvasSize: {
        width: 2e3,
        height: 2e3
      },
      uiCanvasSize: {
        width: 530,
        height: 530
      },
      primaryImageSize: {
        width: 530,
        height: 530
      },
      scene7ToUiRatio: 2e3 / 530,
      imageDebounce: 500,
      multiViewOffset: 50,
      fullyCustomizable: {
        clipArtThumbPreset: "$bv_config_graphic_thumb_wide_2x$",
        clipArtSize: [144, 144],
        defaultFontSize: 12,
        defaultColor: "#000000"
      }
    };
    const store2 = useStore();
    const canvases = computed2(() => store2.getters.getCanvases);
    const scaleDimension = (dimension) => {
      return dimension / config.scene7ToUiRatio;
    };
    const getCanvasWidth = () => {
      return scaleDimension(canvases.value[0].width);
    };
    const getCanvasHeight = () => {
      return scaleDimension(canvases.value[0].height);
    };
    const getCanvasTop = () => {
      const centerOfScene7Template = config.scene7CanvasSize.height;
      const centerLocationOfCanvas = centerOfScene7Template / 2 + canvases.value[0].position_y;
      const topPosition = centerLocationOfCanvas - canvases.value[0].height / 2;
      return scaleDimension(topPosition);
    };
    const getCanvasLeft = () => {
      const centerOfScene7Template = config.scene7CanvasSize.width;
      const centerLocationOfCanvas = centerOfScene7Template / 2 + canvases.value[0].position_x;
      const leftPosition = centerLocationOfCanvas - canvases.value[0].width / 2;
      return scaleDimension(leftPosition) + 98;
    };
    const calculateAspectRatioFit = (srcWidth, srcHeight, maxWidth, maxHeight) => {
      const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
      return [srcWidth * ratio, srcHeight * ratio];
    };
    return {
      getCanvasTop,
      getCanvasLeft,
      getCanvasWidth,
      getCanvasHeight,
      calculateAspectRatioFit
    };
  }
  var init_canvas = __esm({
    "src/vue/components/helpers/canvas.js"() {
      "use strict";
      init_vuex_esm_bundler();
      init_vue_esm_bundler();
    }
  });

  // node_modules/axios/lib/helpers/bind.js
  function bind(fn, thisArg) {
    return function wrap() {
      return fn.apply(thisArg, arguments);
    };
  }
  var init_bind = __esm({
    "node_modules/axios/lib/helpers/bind.js"() {
      "use strict";
    }
  });

  // node_modules/axios/lib/utils.js
  function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction2(val.constructor.isBuffer) && val.constructor.isBuffer(val);
  }
  function isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
      result = ArrayBuffer.isView(val);
    } else {
      result = val && val.buffer && isArrayBuffer(val.buffer);
    }
    return result;
  }
  function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof global !== "undefined") return global;
    return {};
  }
  function forEach(obj, fn, { allOwnKeys = false } = {}) {
    if (obj === null || typeof obj === "undefined") {
      return;
    }
    let i2;
    let l;
    if (typeof obj !== "object") {
      obj = [obj];
    }
    if (isArray2(obj)) {
      for (i2 = 0, l = obj.length; i2 < l; i2++) {
        fn.call(null, obj[i2], i2, obj);
      }
    } else {
      if (isBuffer(obj)) {
        return;
      }
      const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
      const len = keys.length;
      let key;
      for (i2 = 0; i2 < len; i2++) {
        key = keys[i2];
        fn.call(null, obj[key], key, obj);
      }
    }
  }
  function findKey(obj, key) {
    if (isBuffer(obj)) {
      return null;
    }
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i2 = keys.length;
    let _key;
    while (i2-- > 0) {
      _key = keys[i2];
      if (key === _key.toLowerCase()) {
        return _key;
      }
    }
    return null;
  }
  function merge(...objs) {
    const { caseless, skipUndefined } = isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key) => {
      if (key === "__proto__" || key === "constructor" || key === "prototype") {
        return;
      }
      const targetKey = caseless && typeof key === "string" && findKey(result, key) || key;
      const existing = hasOwnProperty3(result, targetKey) ? result[targetKey] : void 0;
      if (isPlainObject2(existing) && isPlainObject2(val)) {
        result[targetKey] = merge(existing, val);
      } else if (isPlainObject2(val)) {
        result[targetKey] = merge({}, val);
      } else if (isArray2(val)) {
        result[targetKey] = val.slice();
      } else if (!skipUndefined || !isUndefined(val)) {
        result[targetKey] = val;
      }
    };
    for (let i2 = 0, l = objs.length; i2 < l; i2++) {
      const source = objs[i2];
      if (!source || isBuffer(source)) {
        continue;
      }
      forEach(source, assignValue);
      if (typeof source !== "object" || isArray2(source)) {
        continue;
      }
      const symbols = Object.getOwnPropertySymbols(source);
      for (let j = 0; j < symbols.length; j++) {
        const symbol = symbols[j];
        if (propertyIsEnumerable.call(source, symbol)) {
          assignValue(source[symbol], symbol);
        }
      }
    }
    return result;
  }
  function isSpecCompliantForm(thing) {
    return !!(thing && isFunction2(thing.append) && thing[toStringTag] === "FormData" && thing[iterator2]);
  }
  var toString, getPrototypeOf, iterator2, toStringTag, hasOwnProperty3, hasOwnInPrototypeChain, getSafeProp, kindOf, kindOfTest, typeOfTest, isArray2, isUndefined, isArrayBuffer, isString2, isFunction2, isNumber, isObject3, isBoolean, isPlainObject2, isEmptyObject, isDate2, isFile, isReactNativeBlob, isReactNative, isBlob, isFileList, isSet2, isStream, G2, FormDataCtor, isFormData, isURLSearchParams, isReadableStream, isRequest, isResponse, isHeaders, trim, _global, isContextDefined, extend2, stripBOM, inherits, toFlatObject, endsWith, toArray, isTypedArray, forEachEntry, matchAll, isHTMLForm, toCamelCase, propertyIsEnumerable, isRegExp2, reduceDescriptors, freezeMethods, toObjectSet, noop, toFiniteNumber, toJSONObject, isAsyncFn, isThenable, _setImmediate, asap, isIterable, isSafeIterable, utils_default;
  var init_utils = __esm({
    "node_modules/axios/lib/utils.js"() {
      "use strict";
      init_bind();
      ({ toString } = Object.prototype);
      ({ getPrototypeOf } = Object);
      ({ iterator: iterator2, toStringTag } = Symbol);
      hasOwnProperty3 = (({ hasOwnProperty: hasOwnProperty4 }) => (obj, prop) => hasOwnProperty4.call(obj, prop))(Object.prototype);
      hasOwnInPrototypeChain = (thing, prop) => {
        let obj = thing;
        const seen2 = [];
        while (obj != null && obj !== Object.prototype) {
          if (seen2.indexOf(obj) !== -1) {
            return false;
          }
          seen2.push(obj);
          if (hasOwnProperty3(obj, prop)) {
            return true;
          }
          obj = getPrototypeOf(obj);
        }
        return false;
      };
      getSafeProp = (obj, prop) => obj != null && hasOwnInPrototypeChain(obj, prop) ? obj[prop] : void 0;
      kindOf = /* @__PURE__ */ ((cache) => (thing) => {
        const str = toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
      })(/* @__PURE__ */ Object.create(null));
      kindOfTest = (type) => {
        type = type.toLowerCase();
        return (thing) => kindOf(thing) === type;
      };
      typeOfTest = (type) => (thing) => typeof thing === type;
      ({ isArray: isArray2 } = Array);
      isUndefined = typeOfTest("undefined");
      isArrayBuffer = kindOfTest("ArrayBuffer");
      isString2 = typeOfTest("string");
      isFunction2 = typeOfTest("function");
      isNumber = typeOfTest("number");
      isObject3 = (thing) => thing !== null && typeof thing === "object";
      isBoolean = (thing) => thing === true || thing === false;
      isPlainObject2 = (val) => {
        if (!isObject3(val)) {
          return false;
        }
        const prototype2 = getPrototypeOf(val);
        return (prototype2 === null || prototype2 === Object.prototype || getPrototypeOf(prototype2) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
        // Symbol.iterator as evidence the value is a tagged/iterable type rather
        // than a plain object, while ignoring keys injected onto Object.prototype.
        !hasOwnInPrototypeChain(val, toStringTag) && !hasOwnInPrototypeChain(val, iterator2);
      };
      isEmptyObject = (val) => {
        if (!isObject3(val) || isBuffer(val)) {
          return false;
        }
        try {
          return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
        } catch (e) {
          return false;
        }
      };
      isDate2 = kindOfTest("Date");
      isFile = kindOfTest("File");
      isReactNativeBlob = (value) => {
        return !!(value && typeof value.uri !== "undefined");
      };
      isReactNative = (formData2) => formData2 && typeof formData2.getParts !== "undefined";
      isBlob = kindOfTest("Blob");
      isFileList = kindOfTest("FileList");
      isSet2 = kindOfTest("Set");
      isStream = (val) => isObject3(val) && isFunction2(val.pipe);
      G2 = getGlobal();
      FormDataCtor = typeof G2.FormData !== "undefined" ? G2.FormData : void 0;
      isFormData = (thing) => {
        if (!thing) return false;
        if (FormDataCtor && thing instanceof FormDataCtor) return true;
        const proto = getPrototypeOf(thing);
        if (!proto || proto === Object.prototype) return false;
        if (!isFunction2(thing.append)) return false;
        const kind = kindOf(thing);
        return kind === "formdata" || // detect form-data instance
        kind === "object" && isFunction2(thing.toString) && thing.toString() === "[object FormData]";
      };
      isURLSearchParams = kindOfTest("URLSearchParams");
      [isReadableStream, isRequest, isResponse, isHeaders] = [
        "ReadableStream",
        "Request",
        "Response",
        "Headers"
      ].map(kindOfTest);
      trim = (str) => {
        return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
      };
      _global = (() => {
        if (typeof globalThis !== "undefined") return globalThis;
        return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : global;
      })();
      isContextDefined = (context) => !isUndefined(context) && context !== _global;
      extend2 = (a, b2, thisArg, { allOwnKeys } = {}) => {
        forEach(
          b2,
          (val, key) => {
            if (thisArg && isFunction2(val)) {
              Object.defineProperty(a, key, {
                // Null-proto descriptor so a polluted Object.prototype.get cannot
                // hijack defineProperty's accessor-vs-data resolution.
                __proto__: null,
                value: bind(val, thisArg),
                writable: true,
                enumerable: true,
                configurable: true
              });
            } else {
              Object.defineProperty(a, key, {
                __proto__: null,
                value: val,
                writable: true,
                enumerable: true,
                configurable: true
              });
            }
          },
          { allOwnKeys }
        );
        return a;
      };
      stripBOM = (content) => {
        if (content.charCodeAt(0) === 65279) {
          content = content.slice(1);
        }
        return content;
      };
      inherits = (constructor, superConstructor, props, descriptors) => {
        constructor.prototype = Object.create(superConstructor.prototype, descriptors);
        Object.defineProperty(constructor.prototype, "constructor", {
          __proto__: null,
          value: constructor,
          writable: true,
          enumerable: false,
          configurable: true
        });
        Object.defineProperty(constructor, "super", {
          __proto__: null,
          value: superConstructor.prototype
        });
        props && Object.assign(constructor.prototype, props);
      };
      toFlatObject = (sourceObj, destObj, filter5, propFilter) => {
        let props;
        let i2;
        let prop;
        const merged = {};
        destObj = destObj || {};
        if (sourceObj == null) return destObj;
        do {
          props = Object.getOwnPropertyNames(sourceObj);
          i2 = props.length;
          while (i2-- > 0) {
            prop = props[i2];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
              destObj[prop] = sourceObj[prop];
              merged[prop] = true;
            }
          }
          sourceObj = filter5 !== false && getPrototypeOf(sourceObj);
        } while (sourceObj && (!filter5 || filter5(sourceObj, destObj)) && sourceObj !== Object.prototype);
        return destObj;
      };
      endsWith = (str, searchString, position) => {
        str = String(str);
        if (position === void 0 || position > str.length) {
          position = str.length;
        }
        position -= searchString.length;
        const lastIndex = str.indexOf(searchString, position);
        return lastIndex !== -1 && lastIndex === position;
      };
      toArray = (thing) => {
        if (!thing) return null;
        if (isArray2(thing)) return thing;
        let i2 = thing.length;
        if (!isNumber(i2)) return null;
        const arr = new Array(i2);
        while (i2-- > 0) {
          arr[i2] = thing[i2];
        }
        return arr;
      };
      isTypedArray = /* @__PURE__ */ ((TypedArray) => {
        return (thing) => {
          return TypedArray && thing instanceof TypedArray;
        };
      })(typeof Uint8Array !== "undefined" && getPrototypeOf(Uint8Array));
      forEachEntry = (obj, fn) => {
        const generator = obj && obj[iterator2];
        const _iterator = generator.call(obj);
        let result;
        while ((result = _iterator.next()) && !result.done) {
          const pair = result.value;
          fn.call(obj, pair[0], pair[1]);
        }
      };
      matchAll = (regExp, str) => {
        let matches2;
        const arr = [];
        while ((matches2 = regExp.exec(str)) !== null) {
          arr.push(matches2);
        }
        return arr;
      };
      isHTMLForm = kindOfTest("HTMLFormElement");
      toCamelCase = (str) => {
        return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer2(m, p1, p2) {
          return p1.toUpperCase() + p2;
        });
      };
      ({ propertyIsEnumerable } = Object.prototype);
      isRegExp2 = kindOfTest("RegExp");
      reduceDescriptors = (obj, reducer) => {
        const descriptors = Object.getOwnPropertyDescriptors(obj);
        const reducedDescriptors = {};
        forEach(descriptors, (descriptor, name) => {
          let ret;
          if ((ret = reducer(descriptor, name, obj)) !== false) {
            reducedDescriptors[name] = ret || descriptor;
          }
        });
        Object.defineProperties(obj, reducedDescriptors);
      };
      freezeMethods = (obj) => {
        reduceDescriptors(obj, (descriptor, name) => {
          if (isFunction2(obj) && ["arguments", "caller", "callee"].includes(name)) {
            return false;
          }
          const value = obj[name];
          if (!isFunction2(value)) return;
          descriptor.enumerable = false;
          if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
          }
          if (!descriptor.set) {
            descriptor.set = () => {
              throw Error("Can not rewrite read-only method '" + name + "'");
            };
          }
        });
      };
      toObjectSet = (arrayOrString, delimiter) => {
        const obj = {};
        const define2 = (arr) => {
          arr.forEach((value) => {
            obj[value] = true;
          });
        };
        isArray2(arrayOrString) ? define2(arrayOrString) : define2(String(arrayOrString).split(delimiter));
        return obj;
      };
      noop = () => {
      };
      toFiniteNumber = (value, defaultValue) => {
        return value != null && Number.isFinite(value = +value) ? value : defaultValue;
      };
      toJSONObject = (obj) => {
        const visited = /* @__PURE__ */ new WeakSet();
        const visit = (source) => {
          if (isObject3(source)) {
            if (visited.has(source)) {
              return;
            }
            if (isBuffer(source)) {
              return source;
            }
            if (!("toJSON" in source)) {
              visited.add(source);
              let target;
              if (isSet2(source)) {
                target = [];
                for (const value of source) {
                  const reducedValue = visit(value);
                  !isUndefined(reducedValue) && target.push(reducedValue);
                }
              } else {
                target = isArray2(source) ? [] : {};
                forEach(source, (value, key) => {
                  const reducedValue = visit(value);
                  !isUndefined(reducedValue) && (target[key] = reducedValue);
                });
              }
              visited.delete(source);
              return target;
            }
          }
          return source;
        };
        return visit(obj);
      };
      isAsyncFn = kindOfTest("AsyncFunction");
      isThenable = (thing) => thing && (isObject3(thing) || isFunction2(thing)) && isFunction2(thing.then) && isFunction2(thing.catch);
      _setImmediate = ((setImmediateSupported, postMessageSupported) => {
        if (setImmediateSupported) {
          return setImmediate;
        }
        return postMessageSupported ? ((token, callbacks) => {
          _global.addEventListener(
            "message",
            ({ source, data }) => {
              if (source === _global && data === token) {
                callbacks.length && callbacks.shift()();
              }
            },
            false
          );
          return (cb) => {
            callbacks.push(cb);
            _global.postMessage(token, "*");
          };
        })(`axios@${Math.random()}`, []) : (cb) => setTimeout(cb);
      })(typeof setImmediate === "function", isFunction2(_global.postMessage));
      asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind(_global) : typeof process !== "undefined" && process.nextTick || _setImmediate;
      isIterable = (thing) => thing != null && isFunction2(thing[iterator2]);
      isSafeIterable = (thing) => thing != null && hasOwnInPrototypeChain(thing, iterator2) && isIterable(thing);
      utils_default = {
        isArray: isArray2,
        isArrayBuffer,
        isBuffer,
        isFormData,
        isArrayBufferView,
        isString: isString2,
        isNumber,
        isBoolean,
        isObject: isObject3,
        isPlainObject: isPlainObject2,
        isEmptyObject,
        isReadableStream,
        isRequest,
        isResponse,
        isHeaders,
        isUndefined,
        isDate: isDate2,
        isFile,
        isReactNativeBlob,
        isReactNative,
        isBlob,
        isRegExp: isRegExp2,
        isFunction: isFunction2,
        isStream,
        isURLSearchParams,
        isTypedArray,
        isFileList,
        forEach,
        merge,
        extend: extend2,
        trim,
        stripBOM,
        inherits,
        toFlatObject,
        kindOf,
        kindOfTest,
        endsWith,
        toArray,
        forEachEntry,
        matchAll,
        isHTMLForm,
        hasOwnProperty: hasOwnProperty3,
        hasOwnProp: hasOwnProperty3,
        // an alias to avoid ESLint no-prototype-builtins detection
        hasOwnInPrototypeChain,
        getSafeProp,
        reduceDescriptors,
        freezeMethods,
        toObjectSet,
        toCamelCase,
        noop,
        toFiniteNumber,
        findKey,
        global: _global,
        isContextDefined,
        isSpecCompliantForm,
        toJSONObject,
        isAsyncFn,
        isThenable,
        setImmediate: _setImmediate,
        asap,
        isIterable,
        isSafeIterable
      };
    }
  });

  // node_modules/axios/lib/helpers/parseHeaders.js
  var ignoreDuplicateOf, parseHeaders_default;
  var init_parseHeaders = __esm({
    "node_modules/axios/lib/helpers/parseHeaders.js"() {
      "use strict";
      init_utils();
      ignoreDuplicateOf = utils_default.toObjectSet([
        "age",
        "authorization",
        "content-length",
        "content-type",
        "etag",
        "expires",
        "from",
        "host",
        "if-modified-since",
        "if-unmodified-since",
        "last-modified",
        "location",
        "max-forwards",
        "proxy-authorization",
        "referer",
        "retry-after",
        "user-agent"
      ]);
      parseHeaders_default = (rawHeaders) => {
        const parsed = {};
        let key;
        let val;
        let i2;
        rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
          i2 = line.indexOf(":");
          key = line.substring(0, i2).trim().toLowerCase();
          val = line.substring(i2 + 1).trim();
          const hasKey = utils_default.hasOwnProp(parsed, key);
          if (!key || hasKey && utils_default.hasOwnProp(ignoreDuplicateOf, key)) {
            return;
          }
          if (key === "set-cookie") {
            if (hasKey) {
              parsed[key].push(val);
            } else {
              parsed[key] = [val];
            }
          } else {
            parsed[key] = hasKey ? parsed[key] + ", " + val : val;
          }
        });
        return parsed;
      };
    }
  });

  // node_modules/axios/lib/helpers/sanitizeHeaderValue.js
  function trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while (start < end) {
      const code = str.charCodeAt(start);
      if (code !== 9 && code !== 32) {
        break;
      }
      start += 1;
    }
    while (end > start) {
      const code = str.charCodeAt(end - 1);
      if (code !== 9 && code !== 32) {
        break;
      }
      end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
  }
  function sanitizeValue(value, invalidChars) {
    if (utils_default.isArray(value)) {
      return value.map((item) => sanitizeValue(item, invalidChars));
    }
    return trimSPorHTAB(String(value).replace(invalidChars, ""));
  }
  function toByteStringHeaderObject(headers) {
    const byteStringHeaders = /* @__PURE__ */ Object.create(null);
    utils_default.forEach(headers.toJSON(), (value, header) => {
      byteStringHeaders[header] = sanitizeByteStringHeaderValue(value);
    });
    return byteStringHeaders;
  }
  var INVALID_UNICODE_HEADER_VALUE_CHARS, INVALID_BYTE_STRING_HEADER_VALUE_CHARS, sanitizeHeaderValue, sanitizeByteStringHeaderValue;
  var init_sanitizeHeaderValue = __esm({
    "node_modules/axios/lib/helpers/sanitizeHeaderValue.js"() {
      "use strict";
      init_utils();
      INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g");
      INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
      sanitizeHeaderValue = (value) => sanitizeValue(value, INVALID_UNICODE_HEADER_VALUE_CHARS);
      sanitizeByteStringHeaderValue = (value) => sanitizeValue(value, INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
    }
  });

  // node_modules/axios/lib/core/AxiosHeaders.js
  function normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
  }
  function normalizeValue(value) {
    if (value === false || value == null) {
      return value;
    }
    return utils_default.isArray(value) ? value.map(normalizeValue) : sanitizeHeaderValue(String(value));
  }
  function parseTokens(str) {
    const tokens = /* @__PURE__ */ Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while (match = tokensRE.exec(str)) {
      tokens[match[1]] = match[2];
    }
    return tokens;
  }
  function trimOWS(value) {
    let start = 0;
    let end = value.length;
    while (start < end) {
      const code = value.charCodeAt(start);
      if (code !== 9 && code !== 32) {
        break;
      }
      start += 1;
    }
    while (end > start) {
      const code = value.charCodeAt(end - 1);
      if (code !== 9 && code !== 32) {
        break;
      }
      end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
  }
  function decodeQuotedString(value) {
    const last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 34 || value.charCodeAt(last) !== 34) {
      return value;
    }
    let decoded = "";
    for (let i2 = 1; i2 < last; i2++) {
      const code = value.charCodeAt(i2);
      if (code === 34) {
        return value;
      }
      if (code === 92) {
        i2 += 1;
        if (i2 >= last) {
          return value;
        }
      }
      decoded += value[i2];
    }
    return decoded;
  }
  function parseParameters(value) {
    const parameters = /* @__PURE__ */ Object.create(null);
    const str = String(value);
    let start = 0;
    let quoted = false;
    let escaped = false;
    function parseParameter(end) {
      const part = trimOWS(str.slice(start, end));
      const equals = part.indexOf("=");
      if (equals < 1) {
        return;
      }
      const name = trimOWS(part.slice(0, equals));
      if (!parameterNameRE.test(name)) {
        return;
      }
      const normalizedName = name.toLowerCase();
      if (normalizedName === "__proto__" || normalizedName === "constructor" || normalizedName === "prototype") {
        return;
      }
      const parameterValue = trimOWS(part.slice(equals + 1));
      parameters[normalizedName] = decodeQuotedString(parameterValue);
    }
    for (let i2 = 0; i2 < str.length; i2++) {
      const code = str.charCodeAt(i2);
      if (quoted) {
        if (escaped) {
          escaped = false;
        } else if (code === 92) {
          escaped = true;
        } else if (code === 34) {
          quoted = false;
        }
      } else if (code === 34) {
        quoted = true;
      } else if (code === 44 || code === 59) {
        parseParameter(i2);
        start = i2 + 1;
      }
    }
    parseParameter(str.length);
    return parameters;
  }
  function matchHeaderValue(context, value, header, filter5, isHeaderNameFilter) {
    if (utils_default.isFunction(filter5)) {
      return filter5.call(this, value, header);
    }
    if (isHeaderNameFilter) {
      value = header;
    }
    if (!utils_default.isString(value)) return;
    if (utils_default.isString(filter5)) {
      return value.indexOf(filter5) !== -1;
    }
    if (utils_default.isRegExp(filter5)) {
      return filter5.test(value);
    }
  }
  function formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
  }
  function buildAccessors(obj, header) {
    const accessorName = utils_default.toCamelCase(" " + header);
    ["get", "set", "has"].forEach((methodName) => {
      Object.defineProperty(obj, methodName + accessorName, {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: function(arg1, arg2, arg3) {
          return this[methodName].call(this, header, arg1, arg2, arg3);
        },
        configurable: true
      });
    });
  }
  var $internals, parameterNameRE, isValidHeaderName, AxiosHeaders, AxiosHeaders_default;
  var init_AxiosHeaders = __esm({
    "node_modules/axios/lib/core/AxiosHeaders.js"() {
      "use strict";
      init_utils();
      init_parseHeaders();
      init_sanitizeHeaderValue();
      $internals = /* @__PURE__ */ Symbol("internals");
      parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
      isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
      AxiosHeaders = class {
        constructor(headers) {
          headers && this.set(headers);
        }
        set(header, valueOrRewrite, rewrite) {
          const self2 = this;
          function setHeader(_value, _header, _rewrite) {
            const lHeader = normalizeHeader(_header);
            if (!lHeader) {
              return;
            }
            const key = utils_default.findKey(self2, lHeader);
            if (!key || self2[key] === void 0 || _rewrite === true || _rewrite === void 0 && self2[key] !== false) {
              self2[key || _header] = normalizeValue(_value);
            }
          }
          const setHeaders = (headers, _rewrite) => utils_default.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));
          if (utils_default.isPlainObject(header) || header instanceof this.constructor) {
            setHeaders(header, valueOrRewrite);
          } else if (utils_default.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
            setHeaders(parseHeaders_default(header), valueOrRewrite);
          } else if (utils_default.isObject(header) && utils_default.isSafeIterable(header)) {
            let obj = /* @__PURE__ */ Object.create(null), dest, key;
            for (const entry of header) {
              if (!utils_default.isArray(entry)) {
                throw new TypeError("Object iterator must return a key-value pair");
              }
              key = entry[0];
              if (utils_default.hasOwnProp(obj, key)) {
                dest = obj[key];
                obj[key] = utils_default.isArray(dest) ? [...dest, entry[1]] : [dest, entry[1]];
              } else {
                obj[key] = entry[1];
              }
            }
            setHeaders(obj, valueOrRewrite);
          } else {
            header != null && setHeader(valueOrRewrite, header, rewrite);
          }
          return this;
        }
        get(header, parser) {
          header = normalizeHeader(header);
          if (header) {
            const key = utils_default.findKey(this, header);
            if (key) {
              const value = this[key];
              if (!parser) {
                return value;
              }
              if (parser === true) {
                return parseTokens(value);
              }
              if (utils_default.isFunction(parser)) {
                return parser.call(this, value, key);
              }
              if (utils_default.isRegExp(parser)) {
                return parser.exec(value);
              }
              throw new TypeError("parser must be boolean|regexp|function");
            }
          }
        }
        has(header, matcher) {
          header = normalizeHeader(header);
          if (header) {
            const key = utils_default.findKey(this, header);
            return !!(key && this[key] !== void 0 && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
          }
          return false;
        }
        delete(header, matcher) {
          const self2 = this;
          let deleted = false;
          function deleteHeader(_header) {
            _header = normalizeHeader(_header);
            if (_header) {
              const key = utils_default.findKey(self2, _header);
              if (key && (!matcher || matchHeaderValue(self2, self2[key], key, matcher))) {
                delete self2[key];
                deleted = true;
              }
            }
          }
          if (utils_default.isArray(header)) {
            header.forEach(deleteHeader);
          } else {
            deleteHeader(header);
          }
          return deleted;
        }
        clear(matcher) {
          const keys = Object.keys(this);
          let i2 = keys.length;
          let deleted = false;
          while (i2--) {
            const key = keys[i2];
            if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
              delete this[key];
              deleted = true;
            }
          }
          return deleted;
        }
        normalize(format) {
          const self2 = this;
          const headers = {};
          utils_default.forEach(this, (value, header) => {
            const key = utils_default.findKey(headers, header);
            if (key) {
              self2[key] = normalizeValue(value);
              delete self2[header];
              return;
            }
            const normalized = format ? formatHeader(header) : String(header).trim();
            if (normalized !== header) {
              delete self2[header];
            }
            self2[normalized] = normalizeValue(value);
            headers[normalized] = true;
          });
          return this;
        }
        concat(...targets) {
          return this.constructor.concat(this, ...targets);
        }
        toJSON(asStrings) {
          const obj = /* @__PURE__ */ Object.create(null);
          utils_default.forEach(this, (value, header) => {
            value != null && value !== false && (obj[header] = asStrings && utils_default.isArray(value) ? value.join(", ") : value);
          });
          return obj;
        }
        [Symbol.iterator]() {
          return Object.entries(this.toJSON())[Symbol.iterator]();
        }
        toString() {
          return Object.entries(this.toJSON()).map(([header, value]) => header + ": " + value).join("\n");
        }
        getSetCookie() {
          const value = this.get("set-cookie");
          return utils_default.isArray(value) ? value : value == null || value === false ? [] : [value];
        }
        get [Symbol.toStringTag]() {
          return "AxiosHeaders";
        }
        static from(thing) {
          return thing instanceof this ? thing : new this(thing);
        }
        static parseParameters(value) {
          return parseParameters(value);
        }
        static concat(first, ...targets) {
          const computed3 = new this(first);
          targets.forEach((target) => computed3.set(target));
          return computed3;
        }
        static accessor(header) {
          const internals = this[$internals] = this[$internals] = {
            accessors: {}
          };
          const accessors = internals.accessors;
          const prototype2 = this.prototype;
          function defineAccessor(_header) {
            const lHeader = normalizeHeader(_header);
            if (!accessors[lHeader]) {
              buildAccessors(prototype2, _header);
              accessors[lHeader] = true;
            }
          }
          utils_default.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
          return this;
        }
      };
      AxiosHeaders.accessor([
        "Content-Type",
        "Content-Length",
        "Accept",
        "Accept-Encoding",
        "User-Agent",
        "Authorization"
      ]);
      utils_default.reduceDescriptors(AxiosHeaders.prototype, ({ value }, key) => {
        let mapped = key[0].toUpperCase() + key.slice(1);
        return {
          get: () => value,
          set(headerValue) {
            this[mapped] = headerValue;
          }
        };
      });
      utils_default.freezeMethods(AxiosHeaders);
      AxiosHeaders_default = AxiosHeaders;
    }
  });

  // node_modules/axios/lib/core/AxiosError.js
  function hasOwnOrPrototypeToJSON(source) {
    if (utils_default.hasOwnProp(source, "toJSON")) {
      return true;
    }
    let prototype2 = Object.getPrototypeOf(source);
    while (prototype2 && prototype2 !== Object.prototype) {
      if (utils_default.hasOwnProp(prototype2, "toJSON")) {
        return true;
      }
      prototype2 = Object.getPrototypeOf(prototype2);
    }
    return false;
  }
  function redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k) => String(k).toLowerCase()));
    const seen2 = [];
    const visit = (source) => {
      if (source === null || typeof source !== "object") return source;
      if (utils_default.isBuffer(source)) return source;
      if (seen2.indexOf(source) !== -1) return void 0;
      if (source instanceof AxiosHeaders_default) {
        source = source.toJSON();
      }
      seen2.push(source);
      let result;
      if (utils_default.isArray(source)) {
        result = [];
        source.forEach((v, i2) => {
          const reducedValue = visit(v);
          if (!utils_default.isUndefined(reducedValue)) {
            result[i2] = reducedValue;
          }
        });
      } else {
        if (!utils_default.isPlainObject(source) && hasOwnOrPrototypeToJSON(source)) {
          seen2.pop();
          return source;
        }
        result = /* @__PURE__ */ Object.create(null);
        for (const [key, value] of Object.entries(source)) {
          const reducedValue = lowerKeys.has(key.toLowerCase()) ? REDACTED : visit(value);
          if (!utils_default.isUndefined(reducedValue)) {
            result[key] = reducedValue;
          }
        }
      }
      seen2.pop();
      return result;
    };
    return visit(config);
  }
  function stringifySafely(value) {
    try {
      return String(value);
    } catch (err) {
      return "";
    }
  }
  function aggregateErrorMessage(error) {
    const message = error.errors.map((entry) => {
      try {
        return entry && entry.message ? stringifySafely(entry.message) : stringifySafely(entry);
      } catch (err) {
        return "";
      }
    }).filter(Boolean).join("; ");
    return message || error.name || "AggregateError";
  }
  var REDACTED, AxiosError, AxiosError_default;
  var init_AxiosError = __esm({
    "node_modules/axios/lib/core/AxiosError.js"() {
      "use strict";
      init_utils();
      init_AxiosHeaders();
      REDACTED = "[REDACTED ****]";
      AxiosError = class _AxiosError extends Error {
        static from(error, code, config, request, response, customProps) {
          let message = error.message;
          if (!message && utils_default.isArray(error.errors) && error.errors.length) {
            message = aggregateErrorMessage(error);
          }
          const axiosError = new _AxiosError(message, code || error.code, config, request, response);
          Object.defineProperty(axiosError, "cause", {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
          });
          axiosError.name = error.name;
          if (error.status != null && axiosError.status == null) {
            axiosError.status = error.status;
          }
          customProps && Object.assign(axiosError, customProps);
          return axiosError;
        }
        /**
         * Create an Error with the specified message, config, error code, request and response.
         *
         * @param {string} message The error message.
         * @param {string} [code] The error code (for example, 'ECONNABORTED').
         * @param {Object} [config] The config.
         * @param {Object} [request] The request.
         * @param {Object} [response] The response.
         *
         * @returns {Error} The created error.
         */
        constructor(message, code, config, request, response) {
          super(message);
          Object.defineProperty(this, "message", {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
          });
          this.name = "AxiosError";
          this.isAxiosError = true;
          code && (this.code = code);
          config && (this.config = config);
          request && (this.request = request);
          if (response) {
            this.response = response;
            this.status = response.status;
          }
        }
        toJSON() {
          const config = this.config;
          const redactKeys = config && utils_default.hasOwnProp(config, "redact") ? config.redact : void 0;
          const serializedConfig = utils_default.isArray(redactKeys) && redactKeys.length > 0 ? redactConfig(config, redactKeys) : utils_default.toJSONObject(config);
          return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
          };
        }
      };
      AxiosError.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
      AxiosError.ERR_BAD_OPTION = "ERR_BAD_OPTION";
      AxiosError.ECONNABORTED = "ECONNABORTED";
      AxiosError.ETIMEDOUT = "ETIMEDOUT";
      AxiosError.ECONNREFUSED = "ECONNREFUSED";
      AxiosError.ERR_NETWORK = "ERR_NETWORK";
      AxiosError.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
      AxiosError.ERR_DEPRECATED = "ERR_DEPRECATED";
      AxiosError.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
      AxiosError.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
      AxiosError.ERR_CANCELED = "ERR_CANCELED";
      AxiosError.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
      AxiosError.ERR_INVALID_URL = "ERR_INVALID_URL";
      AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
      AxiosError_default = AxiosError;
    }
  });

  // node_modules/axios/lib/helpers/null.js
  var null_default;
  var init_null = __esm({
    "node_modules/axios/lib/helpers/null.js"() {
      null_default = null;
    }
  });

  // node_modules/axios/lib/helpers/toFormData.js
  function isVisitable(thing) {
    return utils_default.isPlainObject(thing) || utils_default.isArray(thing);
  }
  function removeBrackets(key) {
    return utils_default.endsWith(key, "[]") ? key.slice(0, -2) : key;
  }
  function renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each3(token, i2) {
      token = removeBrackets(token);
      return !dots && i2 ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
  }
  function isFlatArray(arr) {
    return utils_default.isArray(arr) && !arr.some(isVisitable);
  }
  function toFormData(obj, formData2, options) {
    if (!utils_default.isObject(obj)) {
      throw new TypeError("target must be an object");
    }
    formData2 = formData2 || new (null_default || FormData)();
    options = utils_default.toFlatObject(
      options,
      {
        metaTokens: true,
        dots: false,
        indexes: false
      },
      false,
      function defined(option, source) {
        return !utils_default.isUndefined(source[option]);
      }
    );
    const metaTokens = options.metaTokens;
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const maxDepth = options.maxDepth === void 0 ? DEFAULT_FORM_DATA_MAX_DEPTH : options.maxDepth;
    const useBlob = _Blob && utils_default.isSpecCompliantForm(formData2);
    const stack3 = [];
    if (!utils_default.isFunction(visitor)) {
      throw new TypeError("visitor must be a function");
    }
    function convertValue(value) {
      if (value === null) return "";
      if (utils_default.isDate(value)) {
        return value.toISOString();
      }
      if (utils_default.isBoolean(value)) {
        return value.toString();
      }
      if (!useBlob && utils_default.isBlob(value)) {
        throw new AxiosError_default("Blob is not supported. Use a Buffer instead.");
      }
      if (utils_default.isArrayBuffer(value) || utils_default.isTypedArray(value)) {
        if (useBlob && typeof _Blob === "function") {
          return new _Blob([value]);
        }
        if (null_default && null_default.isBufferAvailable()) {
          return null_default.from(value);
        }
        throw new AxiosError_default("Blob is not supported. Use a Buffer instead.", AxiosError_default.ERR_NOT_SUPPORT);
      }
      return value;
    }
    function throwIfMaxDepthExceeded(depth) {
      if (depth > maxDepth) {
        throw new AxiosError_default(
          "Object is too deeply nested (" + depth + " levels). Max depth: " + maxDepth,
          AxiosError_default.ERR_FORM_DATA_DEPTH_EXCEEDED
        );
      }
    }
    function stringifyWithDepthLimit(value, depth) {
      if (maxDepth === Infinity) {
        return JSON.stringify(value);
      }
      const ancestors = [];
      return JSON.stringify(value, function limitDepth(_key, currentValue) {
        if (!utils_default.isObject(currentValue)) {
          return currentValue;
        }
        while (ancestors.length && ancestors[ancestors.length - 1] !== this) {
          ancestors.pop();
        }
        ancestors.push(currentValue);
        throwIfMaxDepthExceeded(depth + ancestors.length - 1);
        return currentValue;
      });
    }
    function defaultVisitor(value, key, path) {
      let arr = value;
      if (utils_default.isReactNative(formData2) && utils_default.isReactNativeBlob(value)) {
        formData2.append(renderKey(path, key, dots), convertValue(value));
        return false;
      }
      if (value && !path && typeof value === "object") {
        if (utils_default.endsWith(key, "{}")) {
          key = metaTokens ? key : key.slice(0, -2);
          value = stringifyWithDepthLimit(value, 1);
        } else if (utils_default.isArray(value) && isFlatArray(value) || (utils_default.isFileList(value) || utils_default.endsWith(key, "[]")) && (arr = utils_default.toArray(value))) {
          key = removeBrackets(key);
          arr.forEach(function each3(el, index) {
            !(utils_default.isUndefined(el) || el === null) && formData2.append(
              // eslint-disable-next-line no-nested-ternary
              indexes === true ? renderKey([key], index, dots) : indexes === null ? key : key + "[]",
              convertValue(el)
            );
          });
          return false;
        }
      }
      if (isVisitable(value)) {
        return true;
      }
      formData2.append(renderKey(path, key, dots), convertValue(value));
      return false;
    }
    const exposedHelpers = Object.assign(predicates, {
      defaultVisitor,
      convertValue,
      isVisitable
    });
    function build(value, path, depth = 0) {
      if (utils_default.isUndefined(value)) return;
      throwIfMaxDepthExceeded(depth);
      if (stack3.indexOf(value) !== -1) {
        throw new Error("Circular reference detected in " + path.join("."));
      }
      stack3.push(value);
      utils_default.forEach(value, function each3(el, key) {
        const result = !(utils_default.isUndefined(el) || el === null) && visitor.call(formData2, el, utils_default.isString(key) ? key.trim() : key, path, exposedHelpers);
        if (result === true) {
          build(el, path ? path.concat(key) : [key], depth + 1);
        }
      });
      stack3.pop();
    }
    if (!utils_default.isObject(obj)) {
      throw new TypeError("data must be an object");
    }
    build(obj);
    return formData2;
  }
  var DEFAULT_FORM_DATA_MAX_DEPTH, predicates, toFormData_default;
  var init_toFormData = __esm({
    "node_modules/axios/lib/helpers/toFormData.js"() {
      "use strict";
      init_utils();
      init_AxiosError();
      init_null();
      init_null();
      DEFAULT_FORM_DATA_MAX_DEPTH = 100;
      predicates = utils_default.toFlatObject(utils_default, {}, null, function filter(prop) {
        return /^is[A-Z]/.test(prop);
      });
      toFormData_default = toFormData;
    }
  });

  // node_modules/axios/lib/helpers/AxiosURLSearchParams.js
  function encode(str) {
    const charMap = {
      "!": "%21",
      "'": "%27",
      "(": "%28",
      ")": "%29",
      "~": "%7E",
      "%20": "+"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer2(match) {
      return charMap[match];
    });
  }
  function AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && toFormData_default(params, this, options);
  }
  var prototype, AxiosURLSearchParams_default;
  var init_AxiosURLSearchParams = __esm({
    "node_modules/axios/lib/helpers/AxiosURLSearchParams.js"() {
      "use strict";
      init_toFormData();
      prototype = AxiosURLSearchParams.prototype;
      prototype.append = function append(name, value) {
        this._pairs.push([name, value]);
      };
      prototype.toString = function toString2(encoder) {
        const _encode = encoder ? (value) => encoder.call(this, value, encode) : encode;
        return this._pairs.map(function each3(pair) {
          return _encode(pair[0]) + "=" + _encode(pair[1]);
        }, "").join("&");
      };
      AxiosURLSearchParams_default = AxiosURLSearchParams;
    }
  });

  // node_modules/axios/lib/helpers/buildURL.js
  function encode2(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
  }
  function buildURL(url, params, options) {
    if (!params) {
      return url;
    }
    url = url || "";
    const _options = utils_default.isFunction(options) ? {
      serialize: options
    } : options;
    const _encode = utils_default.getSafeProp(_options, "encode") || encode2;
    const serializeFn = utils_default.getSafeProp(_options, "serialize");
    let serializedParams;
    if (serializeFn) {
      serializedParams = serializeFn(params, _options);
    } else {
      serializedParams = utils_default.isURLSearchParams(params) ? params.toString() : new AxiosURLSearchParams_default(params, _options).toString(_encode);
    }
    if (serializedParams) {
      const hashmarkIndex = url.indexOf("#");
      if (hashmarkIndex !== -1) {
        url = url.slice(0, hashmarkIndex);
      }
      url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
  }
  var init_buildURL = __esm({
    "node_modules/axios/lib/helpers/buildURL.js"() {
      "use strict";
      init_utils();
      init_AxiosURLSearchParams();
    }
  });

  // node_modules/axios/lib/core/InterceptorManager.js
  var InterceptorManager, InterceptorManager_default;
  var init_InterceptorManager = __esm({
    "node_modules/axios/lib/core/InterceptorManager.js"() {
      "use strict";
      init_utils();
      InterceptorManager = class {
        constructor() {
          this.handlers = [];
        }
        /**
         * Add a new interceptor to the stack
         *
         * @param {Function} fulfilled The function to handle `then` for a `Promise`
         * @param {Function} rejected The function to handle `reject` for a `Promise`
         * @param {Object} options The options for the interceptor, synchronous and runWhen
         *
         * @return {Number} An ID used to remove interceptor later
         */
        use(fulfilled, rejected, options) {
          this.handlers.push({
            fulfilled,
            rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
          });
          return this.handlers.length - 1;
        }
        /**
         * Remove an interceptor from the stack
         *
         * @param {Number} id The ID that was returned by `use`
         *
         * @returns {void}
         */
        eject(id) {
          if (this.handlers[id]) {
            this.handlers[id] = null;
          }
        }
        /**
         * Clear all interceptors from the stack
         *
         * @returns {void}
         */
        clear() {
          if (this.handlers) {
            this.handlers = [];
          }
        }
        /**
         * Iterate over all the registered interceptors
         *
         * This method is particularly useful for skipping over any
         * interceptors that may have become `null` calling `eject`.
         *
         * @param {Function} fn The function to call for each interceptor
         *
         * @returns {void}
         */
        forEach(fn) {
          utils_default.forEach(this.handlers, function forEachHandler(h2) {
            if (h2 !== null) {
              fn(h2);
            }
          });
        }
      };
      InterceptorManager_default = InterceptorManager;
    }
  });

  // node_modules/axios/lib/defaults/transitional.js
  var transitional_default;
  var init_transitional = __esm({
    "node_modules/axios/lib/defaults/transitional.js"() {
      "use strict";
      transitional_default = {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false,
        legacyInterceptorReqResOrdering: true,
        advertiseZstdAcceptEncoding: false,
        validateStatusUndefinedResolves: true
      };
    }
  });

  // node_modules/axios/lib/platform/browser/classes/URLSearchParams.js
  var URLSearchParams_default;
  var init_URLSearchParams = __esm({
    "node_modules/axios/lib/platform/browser/classes/URLSearchParams.js"() {
      "use strict";
      init_AxiosURLSearchParams();
      URLSearchParams_default = typeof URLSearchParams !== "undefined" ? URLSearchParams : AxiosURLSearchParams_default;
    }
  });

  // node_modules/axios/lib/platform/browser/classes/FormData.js
  var FormData_default;
  var init_FormData = __esm({
    "node_modules/axios/lib/platform/browser/classes/FormData.js"() {
      "use strict";
      FormData_default = typeof FormData !== "undefined" ? FormData : null;
    }
  });

  // node_modules/axios/lib/platform/browser/classes/Blob.js
  var Blob_default;
  var init_Blob = __esm({
    "node_modules/axios/lib/platform/browser/classes/Blob.js"() {
      "use strict";
      Blob_default = typeof Blob !== "undefined" ? Blob : null;
    }
  });

  // node_modules/axios/lib/platform/browser/index.js
  var browser_default;
  var init_browser = __esm({
    "node_modules/axios/lib/platform/browser/index.js"() {
      init_URLSearchParams();
      init_FormData();
      init_Blob();
      browser_default = {
        isBrowser: true,
        classes: {
          URLSearchParams: URLSearchParams_default,
          FormData: FormData_default,
          Blob: Blob_default
        },
        protocols: ["http", "https", "file", "blob", "url", "data"]
      };
    }
  });

  // node_modules/axios/lib/platform/common/utils.js
  var utils_exports = {};
  __export(utils_exports, {
    hasBrowserEnv: () => hasBrowserEnv,
    hasStandardBrowserEnv: () => hasStandardBrowserEnv,
    hasStandardBrowserWebWorkerEnv: () => hasStandardBrowserWebWorkerEnv,
    navigator: () => _navigator,
    origin: () => origin
  });
  var hasBrowserEnv, _navigator, hasStandardBrowserEnv, hasStandardBrowserWebWorkerEnv, origin;
  var init_utils2 = __esm({
    "node_modules/axios/lib/platform/common/utils.js"() {
      hasBrowserEnv = typeof window !== "undefined" && typeof document !== "undefined";
      _navigator = typeof navigator === "object" && navigator || void 0;
      hasStandardBrowserEnv = hasBrowserEnv && (!_navigator || ["ReactNative", "NativeScript", "NS"].indexOf(_navigator.product) < 0);
      hasStandardBrowserWebWorkerEnv = (() => {
        return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
        self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
      })();
      origin = hasBrowserEnv && window.location.href || "http://localhost";
    }
  });

  // node_modules/axios/lib/platform/index.js
  var platform_default;
  var init_platform = __esm({
    "node_modules/axios/lib/platform/index.js"() {
      init_browser();
      init_utils2();
      platform_default = {
        ...utils_exports,
        ...browser_default
      };
    }
  });

  // node_modules/axios/lib/helpers/toURLEncodedForm.js
  function toURLEncodedForm(data, options) {
    return toFormData_default(data, new platform_default.classes.URLSearchParams(), {
      visitor: function(value, key, path, helpers) {
        if (platform_default.isNode && utils_default.isBuffer(value)) {
          this.append(key, value.toString("base64"));
          return false;
        }
        return helpers.defaultVisitor.apply(this, arguments);
      },
      ...options
    });
  }
  var init_toURLEncodedForm = __esm({
    "node_modules/axios/lib/helpers/toURLEncodedForm.js"() {
      "use strict";
      init_utils();
      init_toFormData();
      init_platform();
    }
  });

  // node_modules/axios/lib/helpers/formDataToJSON.js
  function throwIfDepthExceeded(index) {
    if (index > MAX_DEPTH) {
      throw new AxiosError_default(
        "FormData field is too deeply nested (" + index + " levels). Max depth: " + MAX_DEPTH,
        AxiosError_default.ERR_FORM_DATA_DEPTH_EXCEEDED
      );
    }
  }
  function parsePropPath(name) {
    const path = [];
    const pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    let match;
    while ((match = pattern.exec(name)) !== null) {
      throwIfDepthExceeded(path.length);
      path.push(match[0] === "[]" ? "" : match[1] || match[0]);
    }
    return path;
  }
  function arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i2;
    const len = keys.length;
    let key;
    for (i2 = 0; i2 < len; i2++) {
      key = keys[i2];
      obj[key] = arr[key];
    }
    return obj;
  }
  function formDataToJSON(formData2) {
    function buildPath(path, value, target, index) {
      throwIfDepthExceeded(index);
      let name = path[index++];
      if (name === "__proto__") return true;
      const isNumericKey = Number.isFinite(+name);
      const isLast = index >= path.length;
      name = !name && utils_default.isArray(target) ? target.length : name;
      if (isLast) {
        if (utils_default.hasOwnProp(target, name)) {
          target[name] = utils_default.isArray(target[name]) ? target[name].concat(value) : [target[name], value];
        } else {
          target[name] = value;
        }
        return !isNumericKey;
      }
      if (!utils_default.hasOwnProp(target, name) || !utils_default.isObject(target[name])) {
        target[name] = [];
      }
      const result = buildPath(path, value, target[name], index);
      if (result && utils_default.isArray(target[name])) {
        target[name] = arrayToObject(target[name]);
      }
      return !isNumericKey;
    }
    if (utils_default.isFormData(formData2) && utils_default.isFunction(formData2.entries)) {
      const obj = {};
      utils_default.forEachEntry(formData2, (name, value) => {
        buildPath(parsePropPath(name), value, obj, 0);
      });
      return obj;
    }
    return null;
  }
  var MAX_DEPTH, formDataToJSON_default;
  var init_formDataToJSON = __esm({
    "node_modules/axios/lib/helpers/formDataToJSON.js"() {
      "use strict";
      init_utils();
      init_AxiosError();
      init_toFormData();
      MAX_DEPTH = DEFAULT_FORM_DATA_MAX_DEPTH;
      formDataToJSON_default = formDataToJSON;
    }
  });

  // node_modules/axios/lib/defaults/index.js
  function stringifySafely2(rawValue, parser, encoder) {
    if (utils_default.isString(rawValue)) {
      try {
        (parser || JSON.parse)(rawValue);
        return utils_default.trim(rawValue);
      } catch (e) {
        if (e.name !== "SyntaxError") {
          throw e;
        }
      }
    }
    return (encoder || JSON.stringify)(rawValue);
  }
  var own, defaults, defaults_default;
  var init_defaults = __esm({
    "node_modules/axios/lib/defaults/index.js"() {
      "use strict";
      init_utils();
      init_AxiosError();
      init_transitional();
      init_toFormData();
      init_toURLEncodedForm();
      init_platform();
      init_formDataToJSON();
      own = (obj, key) => obj != null && utils_default.hasOwnProp(obj, key) ? obj[key] : void 0;
      defaults = {
        transitional: transitional_default,
        adapter: ["xhr", "http", "fetch"],
        transformRequest: [
          function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = utils_default.isObject(data);
            if (isObjectPayload && utils_default.isHTMLForm(data)) {
              data = new FormData(data);
            }
            const isFormData2 = utils_default.isFormData(data);
            if (isFormData2) {
              return hasJSONContentType ? JSON.stringify(formDataToJSON_default(data)) : data;
            }
            if (utils_default.isArrayBuffer(data) || utils_default.isBuffer(data) || utils_default.isStream(data) || utils_default.isFile(data) || utils_default.isBlob(data) || utils_default.isReadableStream(data)) {
              return data;
            }
            if (utils_default.isArrayBufferView(data)) {
              return data.buffer;
            }
            if (utils_default.isURLSearchParams(data)) {
              headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
              return data.toString();
            }
            let isFileList2;
            if (isObjectPayload) {
              const formSerializer = own(this, "formSerializer");
              if (contentType.indexOf("application/x-www-form-urlencoded") > -1) {
                return toURLEncodedForm(data, formSerializer).toString();
              }
              if ((isFileList2 = utils_default.isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                const env = own(this, "env");
                const _FormData = env && env.FormData;
                return toFormData_default(
                  isFileList2 ? { "files[]": data } : data,
                  _FormData && new _FormData(),
                  formSerializer
                );
              }
            }
            if (isObjectPayload || hasJSONContentType) {
              headers.setContentType("application/json", false);
              return stringifySafely2(data);
            }
            return data;
          }
        ],
        transformResponse: [
          function transformResponse(data) {
            const transitional2 = own(this, "transitional") || defaults.transitional;
            const forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
            const responseType = own(this, "responseType");
            const JSONRequested = responseType === "json";
            if (utils_default.isResponse(data) || utils_default.isReadableStream(data)) {
              return data;
            }
            if (data && utils_default.isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
              const silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
              const strictJSONParsing = !silentJSONParsing && JSONRequested;
              try {
                return JSON.parse(data, own(this, "parseReviver"));
              } catch (e) {
                if (strictJSONParsing) {
                  if (e.name === "SyntaxError") {
                    throw AxiosError_default.from(e, AxiosError_default.ERR_BAD_RESPONSE, this, null, own(this, "response"));
                  }
                  throw e;
                }
              }
            }
            return data;
          }
        ],
        /**
         * A timeout in milliseconds to abort a request. If set to 0 (default) a
         * timeout is not created.
         */
        timeout: 0,
        xsrfCookieName: "XSRF-TOKEN",
        xsrfHeaderName: "X-XSRF-TOKEN",
        maxContentLength: -1,
        maxBodyLength: -1,
        env: {
          FormData: platform_default.classes.FormData,
          Blob: platform_default.classes.Blob
        },
        validateStatus: function validateStatus(status) {
          return status >= 200 && status < 300;
        },
        headers: {
          common: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": void 0
          }
        }
      };
      utils_default.forEach(["delete", "get", "head", "post", "put", "patch", "query"], (method) => {
        defaults.headers[method] = {};
      });
      defaults_default = defaults;
    }
  });

  // node_modules/axios/lib/core/transformData.js
  function transformData(fns, response) {
    const config = this || defaults_default;
    const context = response || config;
    const headers = AxiosHeaders_default.from(context.headers);
    let data = context.data;
    utils_default.forEach(fns, function transform2(fn) {
      data = fn.call(config, data, headers.normalize(), response ? response.status : void 0);
    });
    headers.normalize();
    return data;
  }
  var init_transformData = __esm({
    "node_modules/axios/lib/core/transformData.js"() {
      "use strict";
      init_utils();
      init_defaults();
      init_AxiosHeaders();
    }
  });

  // node_modules/axios/lib/cancel/isCancel.js
  function isCancel(value) {
    return !!(value && value.__CANCEL__);
  }
  var init_isCancel = __esm({
    "node_modules/axios/lib/cancel/isCancel.js"() {
      "use strict";
    }
  });

  // node_modules/axios/lib/cancel/CanceledError.js
  var CanceledError, CanceledError_default;
  var init_CanceledError = __esm({
    "node_modules/axios/lib/cancel/CanceledError.js"() {
      "use strict";
      init_AxiosError();
      CanceledError = class extends AxiosError_default {
        /**
         * A `CanceledError` is an object that is thrown when an operation is canceled.
         *
         * @param {string=} message The message.
         * @param {Object=} config The config.
         * @param {Object=} request The request.
         *
         * @returns {CanceledError} The created error.
         */
        constructor(message, config, request) {
          super(message == null ? "canceled" : message, AxiosError_default.ERR_CANCELED, config, request);
          this.name = "CanceledError";
          this.__CANCEL__ = true;
        }
      };
      CanceledError_default = CanceledError;
    }
  });

  // node_modules/axios/lib/core/settle.js
  function settle(resolve2, reject, response) {
    const validateStatus2 = response.config.validateStatus;
    if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
      resolve2(response);
    } else {
      reject(new AxiosError_default(
        "Request failed with status code " + response.status,
        response.status >= 400 && response.status < 500 ? AxiosError_default.ERR_BAD_REQUEST : AxiosError_default.ERR_BAD_RESPONSE,
        response.config,
        response.request,
        response
      ));
    }
  }
  var init_settle = __esm({
    "node_modules/axios/lib/core/settle.js"() {
      "use strict";
      init_AxiosError();
    }
  });

  // node_modules/axios/lib/helpers/parseProtocol.js
  function parseProtocol(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || "";
  }
  var init_parseProtocol = __esm({
    "node_modules/axios/lib/helpers/parseProtocol.js"() {
      "use strict";
    }
  });

  // node_modules/axios/lib/helpers/speedometer.js
  function speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== void 0 ? min : 1e3;
    return function push(chunkLength) {
      const now3 = Date.now();
      const startedAt = timestamps[tail];
      if (!firstSampleTS) {
        firstSampleTS = now3;
      }
      bytes[head] = chunkLength;
      timestamps[head] = now3;
      let i2 = tail;
      let bytesCount = 0;
      while (i2 !== head) {
        bytesCount += bytes[i2++];
        i2 = i2 % samplesCount;
      }
      head = (head + 1) % samplesCount;
      if (head === tail) {
        tail = (tail + 1) % samplesCount;
      }
      if (now3 - firstSampleTS < min) {
        return;
      }
      const passed = startedAt && now3 - startedAt;
      return passed ? Math.round(bytesCount * 1e3 / passed) : void 0;
    };
  }
  var speedometer_default;
  var init_speedometer = __esm({
    "node_modules/axios/lib/helpers/speedometer.js"() {
      "use strict";
      speedometer_default = speedometer;
    }
  });

  // node_modules/axios/lib/helpers/throttle.js
  function throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1e3 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now3 = Date.now()) => {
      timestamp = now3;
      lastArgs = null;
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      fn(...args);
    };
    const throttled = (...args) => {
      const now3 = Date.now();
      const passed = now3 - timestamp;
      if (passed >= threshold) {
        invoke(args, now3);
      } else {
        lastArgs = args;
        if (!timer) {
          timer = setTimeout(() => {
            timer = null;
            invoke(lastArgs);
          }, threshold - passed);
        }
      }
    };
    const flush = () => lastArgs && invoke(lastArgs);
    return [throttled, flush];
  }
  var throttle_default;
  var init_throttle = __esm({
    "node_modules/axios/lib/helpers/throttle.js"() {
      throttle_default = throttle;
    }
  });

  // node_modules/axios/lib/helpers/progressEventReducer.js
  var progressEventReducer, progressEventDecorator, asyncDecorator;
  var init_progressEventReducer = __esm({
    "node_modules/axios/lib/helpers/progressEventReducer.js"() {
      init_speedometer();
      init_throttle();
      init_utils();
      progressEventReducer = (listener, isDownloadStream, freq = 3) => {
        let bytesNotified = 0;
        const _speedometer = speedometer_default(50, 250);
        return throttle_default((e) => {
          if (!e || typeof e.loaded !== "number") {
            return;
          }
          const rawLoaded = e.loaded;
          const total = e.lengthComputable ? e.total : void 0;
          const loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
          const progressBytes = Math.max(0, loaded - bytesNotified);
          const rate = _speedometer(progressBytes);
          bytesNotified = Math.max(bytesNotified, loaded);
          const data = {
            loaded,
            total,
            progress: total ? loaded / total : void 0,
            bytes: progressBytes,
            rate: rate ? rate : void 0,
            estimated: rate && total ? (total - loaded) / rate : void 0,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
          };
          listener(data);
        }, freq);
      };
      progressEventDecorator = (total, throttled) => {
        const lengthComputable = total != null;
        return [
          (loaded) => throttled[0]({
            lengthComputable,
            total,
            loaded
          }),
          throttled[1]
        ];
      };
      asyncDecorator = (fn, scheduler = utils_default.asap) => (...args) => scheduler(() => fn(...args));
    }
  });

  // node_modules/axios/lib/helpers/isURLSameOrigin.js
  var isURLSameOrigin_default;
  var init_isURLSameOrigin = __esm({
    "node_modules/axios/lib/helpers/isURLSameOrigin.js"() {
      init_platform();
      isURLSameOrigin_default = platform_default.hasStandardBrowserEnv ? /* @__PURE__ */ ((origin2, isMSIE) => (url) => {
        url = new URL(url, platform_default.origin);
        return origin2.protocol === url.protocol && origin2.host === url.host && (isMSIE || origin2.port === url.port);
      })(
        new URL(platform_default.origin),
        platform_default.navigator && /(msie|trident)/i.test(platform_default.navigator.userAgent)
      ) : () => true;
    }
  });

  // node_modules/axios/lib/helpers/cookies.js
  var cookies_default;
  var init_cookies = __esm({
    "node_modules/axios/lib/helpers/cookies.js"() {
      init_utils();
      init_platform();
      cookies_default = platform_default.hasStandardBrowserEnv ? (
        // Standard browser envs support document.cookie
        {
          write(name, value, expires, path, domain, secure, sameSite) {
            if (typeof document === "undefined") return;
            const cookie = [`${name}=${encodeURIComponent(value)}`];
            if (utils_default.isNumber(expires)) {
              cookie.push(`expires=${new Date(expires).toUTCString()}`);
            }
            if (utils_default.isString(path)) {
              cookie.push(`path=${path}`);
            }
            if (utils_default.isString(domain)) {
              cookie.push(`domain=${domain}`);
            }
            if (secure === true) {
              cookie.push("secure");
            }
            if (utils_default.isString(sameSite)) {
              cookie.push(`SameSite=${sameSite}`);
            }
            document.cookie = cookie.join("; ");
          },
          read(name) {
            if (typeof document === "undefined") return null;
            const cookies = document.cookie.split(";");
            for (let i2 = 0; i2 < cookies.length; i2++) {
              const cookie = cookies[i2].replace(/^\s+/, "");
              const eq = cookie.indexOf("=");
              if (eq !== -1 && cookie.slice(0, eq) === name) {
                try {
                  return decodeURIComponent(cookie.slice(eq + 1));
                } catch (e) {
                  return cookie.slice(eq + 1);
                }
              }
            }
            return null;
          },
          remove(name) {
            this.write(name, "", Date.now() - 864e5, "/");
          }
        }
      ) : (
        // Non-standard browser env (web workers, react-native) lack needed support.
        {
          write() {
          },
          read() {
            return null;
          },
          remove() {
          }
        }
      );
    }
  });

  // node_modules/axios/lib/helpers/isAbsoluteURL.js
  function isAbsoluteURL(url) {
    if (typeof url !== "string") {
      return false;
    }
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
  }
  var init_isAbsoluteURL = __esm({
    "node_modules/axios/lib/helpers/isAbsoluteURL.js"() {
      "use strict";
    }
  });

  // node_modules/axios/lib/helpers/combineURLs.js
  function combineURLs(baseURL, relativeURL) {
    if (!relativeURL) {
      return baseURL;
    }
    let end = baseURL.length;
    while (end > 0 && baseURL.charCodeAt(end - 1) === 47) {
      end--;
    }
    return baseURL.slice(0, end) + "/" + relativeURL.replace(/^\/+/, "");
  }
  var init_combineURLs = __esm({
    "node_modules/axios/lib/helpers/combineURLs.js"() {
      "use strict";
    }
  });

  // node_modules/axios/lib/core/buildFullPath.js
  function stripLeadingC0ControlOrSpace(url) {
    let i2 = 0;
    while (i2 < url.length && url.charCodeAt(i2) <= 32) {
      i2++;
    }
    return url.slice(i2);
  }
  function normalizeURLForProtocolCheck(url) {
    return stripLeadingC0ControlOrSpace(url).replace(httpProtocolControlCharacters, "");
  }
  function redactFragment(fragment) {
    if (!fragment) {
      return fragment;
    }
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, (match, separator, parameterName = "") => {
      return `${separator}${parameterName}${REDACTED}`;
    });
  }
  function redactSensitiveURLParts(url) {
    const redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${REDACTED}@`);
    const fragmentIndex = redactedURL.indexOf("#");
    const urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    const redactedURLWithoutFragment = urlWithoutFragment.replace(
      /([?&][^=&#]*=)[^&#]*/g,
      `$1${REDACTED}`
    );
    if (fragmentIndex === -1) {
      return redactedURLWithoutFragment;
    }
    return `${redactedURLWithoutFragment}#${redactFragment(redactedURL.slice(fragmentIndex + 1))}`;
  }
  function assertValidHttpProtocolURL(url, config) {
    if (typeof url === "string") {
      const normalizedURL = normalizeURLForProtocolCheck(url);
      if (malformedHttpProtocol.test(normalizedURL)) {
        throw new AxiosError_default(
          `Invalid URL ${JSON.stringify(redactSensitiveURLParts(normalizedURL))}: missing "//" after protocol`,
          AxiosError_default.ERR_INVALID_URL,
          config
        );
      }
    }
  }
  function buildFullPath(baseURL, requestedURL, allowAbsoluteUrls, config) {
    assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !isAbsoluteURL(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
      assertValidHttpProtocolURL(baseURL, config);
      return combineURLs(baseURL, requestedURL);
    }
    return requestedURL;
  }
  var malformedHttpProtocol, httpProtocolControlCharacters;
  var init_buildFullPath = __esm({
    "node_modules/axios/lib/core/buildFullPath.js"() {
      "use strict";
      init_AxiosError();
      init_isAbsoluteURL();
      init_combineURLs();
      malformedHttpProtocol = /^https?:(?!\/\/)/i;
      httpProtocolControlCharacters = /[\t\n\r]/g;
    }
  });

  // node_modules/axios/lib/core/mergeConfig.js
  function mergeConfig(config1, config2) {
    config1 = config1 || {};
    config2 = config2 || {};
    const config = /* @__PURE__ */ Object.create(null);
    Object.defineProperty(config, "hasOwnProperty", {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: Object.prototype.hasOwnProperty,
      enumerable: false,
      writable: true,
      configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
      if (utils_default.isPlainObject(target) && utils_default.isPlainObject(source)) {
        return utils_default.merge.call({ caseless }, target, source);
      } else if (utils_default.isPlainObject(source)) {
        return utils_default.merge({}, source);
      } else if (utils_default.isArray(source)) {
        return source.slice();
      }
      return source;
    }
    function mergeDeepProperties(a, b2, prop, caseless) {
      if (!utils_default.isUndefined(b2)) {
        return getMergedValue(a, b2, prop, caseless);
      } else if (!utils_default.isUndefined(a)) {
        return getMergedValue(void 0, a, prop, caseless);
      }
    }
    function valueFromConfig2(a, b2) {
      if (!utils_default.isUndefined(b2)) {
        return getMergedValue(void 0, b2);
      }
    }
    function defaultToConfig2(a, b2) {
      if (!utils_default.isUndefined(b2)) {
        return getMergedValue(void 0, b2);
      } else if (!utils_default.isUndefined(a)) {
        return getMergedValue(void 0, a);
      }
    }
    function getMergedTransitionalOption(prop) {
      const transitional2 = utils_default.hasOwnProp(config2, "transitional") ? config2.transitional : void 0;
      if (!utils_default.isUndefined(transitional2)) {
        if (utils_default.isPlainObject(transitional2)) {
          if (utils_default.hasOwnProp(transitional2, prop)) {
            return transitional2[prop];
          }
        } else {
          return void 0;
        }
      }
      const transitional1 = utils_default.hasOwnProp(config1, "transitional") ? config1.transitional : void 0;
      if (utils_default.isPlainObject(transitional1) && utils_default.hasOwnProp(transitional1, prop)) {
        return transitional1[prop];
      }
      return void 0;
    }
    function mergeDirectKeys(a, b2, prop) {
      if (utils_default.hasOwnProp(config2, prop)) {
        return getMergedValue(a, b2);
      } else if (utils_default.hasOwnProp(config1, prop)) {
        return getMergedValue(void 0, a);
      }
    }
    const mergeMap = {
      url: valueFromConfig2,
      method: valueFromConfig2,
      data: valueFromConfig2,
      baseURL: defaultToConfig2,
      transformRequest: defaultToConfig2,
      transformResponse: defaultToConfig2,
      paramsSerializer: defaultToConfig2,
      timeout: defaultToConfig2,
      timeoutMessage: defaultToConfig2,
      withCredentials: defaultToConfig2,
      withXSRFToken: defaultToConfig2,
      adapter: defaultToConfig2,
      responseType: defaultToConfig2,
      xsrfCookieName: defaultToConfig2,
      xsrfHeaderName: defaultToConfig2,
      onUploadProgress: defaultToConfig2,
      onDownloadProgress: defaultToConfig2,
      decompress: defaultToConfig2,
      maxContentLength: defaultToConfig2,
      maxBodyLength: defaultToConfig2,
      beforeRedirect: defaultToConfig2,
      transport: defaultToConfig2,
      httpAgent: defaultToConfig2,
      httpsAgent: defaultToConfig2,
      cancelToken: defaultToConfig2,
      socketPath: defaultToConfig2,
      allowedSocketPaths: defaultToConfig2,
      responseEncoding: defaultToConfig2,
      validateStatus: mergeDirectKeys,
      headers: (a, b2, prop) => mergeDeepProperties(headersToObject(a), headersToObject(b2), prop, true)
    };
    utils_default.forEach(ownEnumerableKeys({ ...config1, ...config2 }), function computeConfigValue(prop) {
      if (prop === "__proto__" || prop === "constructor" || prop === "prototype") return;
      const merge2 = utils_default.hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
      const a = utils_default.hasOwnProp(config1, prop) ? config1[prop] : void 0;
      const b2 = utils_default.hasOwnProp(config2, prop) ? config2[prop] : void 0;
      const configValue = merge2(a, b2, prop);
      utils_default.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop] = configValue);
    });
    if (utils_default.hasOwnProp(config2, "validateStatus") && utils_default.isUndefined(config2.validateStatus) && getMergedTransitionalOption("validateStatusUndefinedResolves") === false) {
      if (utils_default.hasOwnProp(config1, "validateStatus")) {
        config.validateStatus = getMergedValue(void 0, config1.validateStatus);
      } else {
        delete config.validateStatus;
      }
    }
    return config;
  }
  var headersToObject, ownEnumerableKeys;
  var init_mergeConfig = __esm({
    "node_modules/axios/lib/core/mergeConfig.js"() {
      "use strict";
      init_utils();
      init_AxiosHeaders();
      headersToObject = (thing) => thing instanceof AxiosHeaders_default ? { ...thing } : thing;
      ownEnumerableKeys = (thing) => {
        if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) {
          return Object.keys(thing).concat(
            Object.getOwnPropertySymbols(thing).filter(
              (symbol) => Object.getOwnPropertyDescriptor(thing, symbol).enumerable
            )
          );
        }
        return Object.keys(thing);
      };
    }
  });

  // node_modules/axios/lib/core/setFormDataHeaders.js
  function setFormDataHeaders(headers, formHeaders, policy2) {
    if (policy2 !== "content-only") {
      headers.set(formHeaders);
      return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val]) => {
      if (FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) {
        headers.set(key, val);
      }
    });
  }
  var FORM_DATA_CONTENT_HEADERS;
  var init_setFormDataHeaders = __esm({
    "node_modules/axios/lib/core/setFormDataHeaders.js"() {
      "use strict";
      FORM_DATA_CONTENT_HEADERS = ["content-type", "content-length"];
    }
  });

  // node_modules/axios/lib/helpers/resolveConfig.js
  function resolveConfig(config) {
    const newConfig = mergeConfig({}, config);
    const own2 = (key) => utils_default.hasOwnProp(newConfig, key) ? newConfig[key] : void 0;
    const data = own2("data");
    let withXSRFToken = own2("withXSRFToken");
    const xsrfHeaderName = own2("xsrfHeaderName");
    const xsrfCookieName = own2("xsrfCookieName");
    let headers = own2("headers");
    const auth = own2("auth");
    const baseURL = own2("baseURL");
    const allowAbsoluteUrls = own2("allowAbsoluteUrls");
    const url = own2("url");
    newConfig.headers = headers = AxiosHeaders_default.from(headers);
    newConfig.url = buildURL(
      buildFullPath(baseURL, url, allowAbsoluteUrls, newConfig),
      own2("params"),
      own2("paramsSerializer")
    );
    if (auth) {
      const username = utils_default.getSafeProp(auth, "username") || "";
      const password = utils_default.getSafeProp(auth, "password") || "";
      try {
        headers.set(
          "Authorization",
          "Basic " + btoa(username + ":" + (password ? encodeUTF8(password) : ""))
        );
      } catch (e) {
        throw AxiosError_default.from(e, AxiosError_default.ERR_BAD_OPTION_VALUE, config);
      }
    }
    if (utils_default.isFormData(data)) {
      if (platform_default.hasStandardBrowserEnv || platform_default.hasStandardBrowserWebWorkerEnv || utils_default.isReactNative(data)) {
        headers.setContentType(void 0);
      } else if (utils_default.isFunction(data.getHeaders)) {
        setFormDataHeaders(headers, data.getHeaders(), own2("formDataHeaderPolicy"));
      }
    }
    if (platform_default.hasStandardBrowserEnv) {
      if (utils_default.isFunction(withXSRFToken)) {
        withXSRFToken = withXSRFToken(newConfig);
      }
      const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && isURLSameOrigin_default(newConfig.url);
      if (shouldSendXSRF) {
        const xsrfValue = xsrfHeaderName && xsrfCookieName && cookies_default.read(xsrfCookieName);
        if (xsrfValue) {
          headers.set(xsrfHeaderName, xsrfValue);
        }
      }
    }
    return newConfig;
  }
  var encodeUTF8, resolveConfig_default;
  var init_resolveConfig = __esm({
    "node_modules/axios/lib/helpers/resolveConfig.js"() {
      init_platform();
      init_utils();
      init_AxiosError();
      init_isURLSameOrigin();
      init_cookies();
      init_buildFullPath();
      init_mergeConfig();
      init_AxiosHeaders();
      init_setFormDataHeaders();
      init_buildURL();
      encodeUTF8 = (str) => encodeURIComponent(str).replace(
        /%([0-9A-F]{2})/gi,
        (_2, hex) => String.fromCharCode(parseInt(hex, 16))
      );
      resolveConfig_default = resolveConfig;
    }
  });

  // node_modules/axios/lib/adapters/xhr.js
  var isXHRAdapterSupported, xhr_default;
  var init_xhr = __esm({
    "node_modules/axios/lib/adapters/xhr.js"() {
      init_utils();
      init_settle();
      init_transitional();
      init_AxiosError();
      init_CanceledError();
      init_parseProtocol();
      init_platform();
      init_AxiosHeaders();
      init_progressEventReducer();
      init_resolveConfig();
      init_sanitizeHeaderValue();
      isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
      xhr_default = isXHRAdapterSupported && function(config) {
        return new Promise(function dispatchXhrRequest(resolve2, reject) {
          const _config = resolveConfig_default(config);
          let requestData = _config.data;
          const requestHeaders = AxiosHeaders_default.from(_config.headers).normalize();
          let { responseType, onUploadProgress, onDownloadProgress } = _config;
          let onCanceled;
          let uploadThrottled, downloadThrottled;
          let flushUpload, flushDownload;
          function done() {
            flushUpload && flushUpload();
            flushDownload && flushDownload();
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
          }
          let request = new XMLHttpRequest();
          request.open(_config.method.toUpperCase(), _config.url, true);
          request.timeout = _config.timeout;
          function onloadend() {
            if (!request) {
              return;
            }
            const responseHeaders = AxiosHeaders_default.from(
              "getAllResponseHeaders" in request && request.getAllResponseHeaders()
            );
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
              data: responseData,
              status: request.status,
              statusText: request.statusText,
              headers: responseHeaders,
              config,
              request
            };
            settle(
              function _resolve(value) {
                resolve2(value);
                done();
              },
              function _reject(err) {
                reject(err);
                done();
              },
              response
            );
            request = null;
          }
          if ("onloadend" in request) {
            request.onloadend = onloadend;
          } else {
            request.onreadystatechange = function handleLoad() {
              if (!request || request.readyState !== 4) {
                return;
              }
              if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith("file:"))) {
                return;
              }
              setTimeout(onloadend);
            };
          }
          request.onabort = function handleAbort() {
            if (!request) {
              return;
            }
            reject(new AxiosError_default("Request aborted", AxiosError_default.ECONNABORTED, config, request));
            done();
            request = null;
          };
          request.onerror = function handleError2(event) {
            const msg = event && event.message ? event.message : "Network Error";
            const err = new AxiosError_default(msg, AxiosError_default.ERR_NETWORK, config, request);
            err.event = event || null;
            reject(err);
            done();
            request = null;
          };
          request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional2 = _config.transitional || transitional_default;
            if (_config.timeoutErrorMessage) {
              timeoutErrorMessage = _config.timeoutErrorMessage;
            }
            reject(
              new AxiosError_default(
                timeoutErrorMessage,
                transitional2.clarifyTimeoutError ? AxiosError_default.ETIMEDOUT : AxiosError_default.ECONNABORTED,
                config,
                request
              )
            );
            done();
            request = null;
          };
          requestData === void 0 && requestHeaders.setContentType(null);
          if ("setRequestHeader" in request) {
            utils_default.forEach(toByteStringHeaderObject(requestHeaders), function setRequestHeader(val, key) {
              request.setRequestHeader(key, val);
            });
          }
          if (!utils_default.isUndefined(_config.withCredentials)) {
            request.withCredentials = !!_config.withCredentials;
          }
          if (responseType && responseType !== "json") {
            request.responseType = _config.responseType;
          }
          if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = progressEventReducer(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
          }
          if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = progressEventReducer(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
          }
          if (_config.cancelToken || _config.signal) {
            onCanceled = (cancel) => {
              if (!request) {
                return;
              }
              reject(!cancel || cancel.type ? new CanceledError_default(null, config, request) : cancel);
              request.abort();
              done();
              request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) {
              _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
            }
          }
          const protocol = parseProtocol(_config.url);
          if (protocol && !platform_default.protocols.includes(protocol)) {
            reject(
              new AxiosError_default(
                "Unsupported protocol " + protocol + ":",
                AxiosError_default.ERR_BAD_REQUEST,
                config
              )
            );
            done();
            return;
          }
          request.send(requestData || null);
        });
      };
    }
  });

  // node_modules/axios/lib/helpers/composeSignals.js
  var composeSignals, composeSignals_default;
  var init_composeSignals = __esm({
    "node_modules/axios/lib/helpers/composeSignals.js"() {
      init_CanceledError();
      init_AxiosError();
      init_utils();
      composeSignals = (signals, timeout) => {
        signals = signals ? signals.filter(Boolean) : [];
        if (!timeout && !signals.length) {
          return;
        }
        const controller = new AbortController();
        let aborted = false;
        const onabort = function(reason) {
          if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(
              err instanceof AxiosError_default ? err : new CanceledError_default(err instanceof Error ? err.message : err)
            );
          }
        };
        let timer = timeout && setTimeout(() => {
          timer = null;
          onabort(new AxiosError_default(`timeout of ${timeout}ms exceeded`, AxiosError_default.ETIMEDOUT));
        }, timeout);
        const unsubscribe = () => {
          if (!signals) {
            return;
          }
          timer && clearTimeout(timer);
          timer = null;
          signals.forEach((signal2) => {
            signal2.unsubscribe ? signal2.unsubscribe(onabort) : signal2.removeEventListener("abort", onabort);
          });
          signals = null;
        };
        signals.forEach((signal2) => {
          if (aborted) {
            return;
          }
          if (signal2.aborted) {
            onabort.call(signal2);
            return;
          }
          signal2.addEventListener("abort", onabort, { once: true });
        });
        const { signal } = controller;
        signal.unsubscribe = () => utils_default.asap(unsubscribe);
        return signal;
      };
      composeSignals_default = composeSignals;
    }
  });

  // node_modules/axios/lib/helpers/trackStream.js
  var streamChunk, readBytes, readStream, trackStream;
  var init_trackStream = __esm({
    "node_modules/axios/lib/helpers/trackStream.js"() {
      streamChunk = function* (chunk, chunkSize) {
        let len = chunk.byteLength;
        if (!chunkSize || len < chunkSize) {
          yield chunk;
          return;
        }
        let pos = 0;
        let end;
        while (pos < len) {
          end = pos + chunkSize;
          yield chunk.slice(pos, end);
          pos = end;
        }
      };
      readBytes = async function* (iterable, chunkSize) {
        for await (const chunk of readStream(iterable)) {
          yield* streamChunk(chunk, chunkSize);
        }
      };
      readStream = async function* (stream) {
        if (stream[Symbol.asyncIterator]) {
          yield* stream;
          return;
        }
        const reader = stream.getReader();
        try {
          for (; ; ) {
            const { done, value } = await reader.read();
            if (done) {
              break;
            }
            yield value;
          }
        } finally {
          await reader.cancel();
        }
      };
      trackStream = (stream, chunkSize, onProgress, onFinish) => {
        const iterator3 = readBytes(stream, chunkSize);
        let bytes = 0;
        let done;
        let _onFinish = (e) => {
          if (!done) {
            done = true;
            onFinish && onFinish(e);
          }
        };
        return new ReadableStream(
          {
            async pull(controller) {
              try {
                const { done: done2, value } = await iterator3.next();
                if (done2) {
                  _onFinish();
                  controller.close();
                  return;
                }
                let len = value.byteLength;
                if (onProgress) {
                  let loadedBytes = bytes += len;
                  onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
              } catch (err) {
                _onFinish(err);
                throw err;
              }
            },
            cancel(reason) {
              _onFinish(reason);
              return iterator3.return();
            }
          },
          {
            highWaterMark: 2
          }
        );
      };
    }
  });

  // node_modules/axios/lib/helpers/estimateDataURLDecodedBytes.js
  function estimateDataURLDecodedBytes(url) {
    const fragmentIndex = typeof url === "string" ? url.indexOf("#") : -1;
    return estimateDataURLBytes(
      fragmentIndex === -1 ? url : url.slice(0, fragmentIndex),
      estimatePercentDecodedBase64Bytes
    );
  }
  var isHexDigit, isPercentEncodedByte, hexValue, isBase64Char, isBase64Whitespace, base64Bytes, estimateBase64BufferAllocation, estimatePercentDecodedBase64Bytes, estimateDataURLBytes;
  var init_estimateDataURLDecodedBytes = __esm({
    "node_modules/axios/lib/helpers/estimateDataURLDecodedBytes.js"() {
      isHexDigit = (charCode) => charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
      isPercentEncodedByte = (str, i2, len) => i2 + 2 < len && isHexDigit(str.charCodeAt(i2 + 1)) && isHexDigit(str.charCodeAt(i2 + 2));
      hexValue = (charCode) => charCode <= 57 ? charCode - 48 : (charCode & 223) - 55;
      isBase64Char = (charCode) => charCode >= 65 && charCode <= 90 || // A-Z
      charCode >= 97 && charCode <= 122 || // a-z
      charCode >= 48 && charCode <= 57 || // 0-9
      charCode === 43 || // +
      charCode === 47 || // /
      charCode === 45 || // - (base64url)
      charCode === 95;
      isBase64Whitespace = (charCode) => charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
      base64Bytes = (significant) => {
        const groups = Math.floor(significant / 4);
        const remainder = significant % 4;
        return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
      };
      estimateBase64BufferAllocation = (body) => {
        const len = body.length;
        let padding = 0;
        if (len > 0 && body.charCodeAt(len - 1) === 61) {
          padding++;
          if (len > 1 && body.charCodeAt(len - 2) === 61) {
            padding++;
          }
        }
        return Math.floor((len - padding) * 3 / 4);
      };
      estimatePercentDecodedBase64Bytes = (body) => {
        const len = body.length;
        let significant = 0;
        let padding = 0;
        let invalid = false;
        for (let i2 = 0; i2 < len; i2++) {
          let code = body.charCodeAt(i2);
          if (code === 37 && isPercentEncodedByte(body, i2, len)) {
            code = hexValue(body.charCodeAt(i2 + 1)) * 16 + hexValue(body.charCodeAt(i2 + 2));
            i2 += 2;
          }
          if (isBase64Whitespace(code)) {
            continue;
          }
          if (code === 61) {
            padding++;
            continue;
          }
          if (!isBase64Char(code) || padding > 0) {
            invalid = true;
            continue;
          }
          significant++;
        }
        if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) {
          return estimateBase64BufferAllocation(body);
        }
        return base64Bytes(significant);
      };
      estimateDataURLBytes = (url, estimateBase64) => {
        if (!url || typeof url !== "string") return 0;
        if (!url.startsWith("data:")) return 0;
        const comma = url.indexOf(",");
        if (comma < 0) return 0;
        const meta = url.slice(5, comma);
        const body = url.slice(comma + 1);
        const isBase64 = /;base64/i.test(meta);
        if (isBase64) {
          return estimateBase64(body);
        }
        let bytes = 0;
        for (let i2 = 0, len = body.length; i2 < len; i2++) {
          const c = body.charCodeAt(i2);
          if (c === 37 && isPercentEncodedByte(body, i2, len)) {
            bytes += 1;
            i2 += 2;
          } else if (c < 128) {
            bytes += 1;
          } else if (c < 2048) {
            bytes += 2;
          } else if (c >= 55296 && c <= 56319 && i2 + 1 < len) {
            const next = body.charCodeAt(i2 + 1);
            if (next >= 56320 && next <= 57343) {
              bytes += 4;
              i2++;
            } else {
              bytes += 3;
            }
          } else {
            bytes += 3;
          }
        }
        return bytes;
      };
    }
  });

  // node_modules/axios/lib/env/data.js
  var VERSION;
  var init_data = __esm({
    "node_modules/axios/lib/env/data.js"() {
      VERSION = "1.19.0";
    }
  });

  // node_modules/axios/lib/adapters/fetch.js
  var DEFAULT_CHUNK_SIZE, isFunction3, encodeUTF82, decodeURIComponentSafe, test, maybeWithAuthCredentials, factory, seedCache, getFetch, adapter;
  var init_fetch = __esm({
    "node_modules/axios/lib/adapters/fetch.js"() {
      init_platform();
      init_utils();
      init_AxiosError();
      init_composeSignals();
      init_trackStream();
      init_AxiosHeaders();
      init_progressEventReducer();
      init_resolveConfig();
      init_settle();
      init_estimateDataURLDecodedBytes();
      init_data();
      init_sanitizeHeaderValue();
      DEFAULT_CHUNK_SIZE = 64 * 1024;
      ({ isFunction: isFunction3 } = utils_default);
      encodeUTF82 = (str) => encodeURIComponent(str).replace(
        /%([0-9A-F]{2})/gi,
        (_2, hex) => String.fromCharCode(parseInt(hex, 16))
      );
      decodeURIComponentSafe = (value) => {
        if (!utils_default.isString(value)) {
          return value;
        }
        try {
          return decodeURIComponent(value);
        } catch (error) {
          return value;
        }
      };
      test = (fn, ...args) => {
        try {
          return !!fn(...args);
        } catch (e) {
          return false;
        }
      };
      maybeWithAuthCredentials = (url) => {
        const protocolIndex = url.indexOf("://");
        let urlToCheck = url;
        if (protocolIndex !== -1) {
          urlToCheck = urlToCheck.slice(protocolIndex + 3);
        }
        return urlToCheck.includes("@") || urlToCheck.includes(":");
      };
      factory = (env) => {
        const globalObject = utils_default.global !== void 0 && utils_default.global !== null ? utils_default.global : globalThis;
        const { ReadableStream: ReadableStream2, TextEncoder } = globalObject;
        env = utils_default.merge.call(
          {
            skipUndefined: true
          },
          {
            Request: globalObject.Request,
            Response: globalObject.Response
          },
          env
        );
        const { fetch: envFetch, Request, Response } = env;
        const isFetchSupported = envFetch ? isFunction3(envFetch) : typeof fetch === "function";
        const isRequestSupported = isFunction3(Request);
        const isResponseSupported = isFunction3(Response);
        if (!isFetchSupported) {
          return false;
        }
        const isReadableStreamSupported = isFetchSupported && isFunction3(ReadableStream2);
        const encodeText = isFetchSupported && (typeof TextEncoder === "function" ? /* @__PURE__ */ ((encoder) => (str) => encoder.encode(str))(new TextEncoder()) : async (str) => new Uint8Array(await new Request(str).arrayBuffer()));
        const supportsRequestStream = isRequestSupported && isReadableStreamSupported && test(() => {
          let duplexAccessed = false;
          const request = new Request(platform_default.origin, {
            body: new ReadableStream2(),
            method: "POST",
            get duplex() {
              duplexAccessed = true;
              return "half";
            }
          });
          const hasContentType = request.headers.has("Content-Type");
          if (request.body != null) {
            request.body.cancel();
          }
          return duplexAccessed && !hasContentType;
        });
        const supportsResponseStream = isResponseSupported && isReadableStreamSupported && test(() => utils_default.isReadableStream(new Response("").body));
        const resolvers = {
          stream: supportsResponseStream && ((res) => res.body)
        };
        isFetchSupported && (() => {
          ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((type) => {
            !resolvers[type] && (resolvers[type] = (res, config) => {
              let method = res && res[type];
              if (method) {
                return method.call(res);
              }
              throw new AxiosError_default(
                `Response type '${type}' is not supported`,
                AxiosError_default.ERR_NOT_SUPPORT,
                config
              );
            });
          });
        })();
        const getBodyLength = async (body) => {
          if (body == null) {
            return 0;
          }
          if (utils_default.isBlob(body)) {
            return body.size;
          }
          if (utils_default.isSpecCompliantForm(body)) {
            const _request = new Request(platform_default.origin, {
              method: "POST",
              body
            });
            return (await _request.arrayBuffer()).byteLength;
          }
          if (utils_default.isArrayBufferView(body) || utils_default.isArrayBuffer(body)) {
            return body.byteLength;
          }
          if (utils_default.isURLSearchParams(body)) {
            body = body + "";
          }
          if (utils_default.isString(body)) {
            return (await encodeText(body)).byteLength;
          }
        };
        const resolveBodyLength = async (headers, body) => {
          const length = utils_default.toFiniteNumber(headers.getContentLength());
          return length == null ? getBodyLength(body) : length;
        };
        return async (config) => {
          let {
            url,
            method,
            data,
            signal,
            cancelToken,
            timeout,
            onDownloadProgress,
            onUploadProgress,
            responseType,
            headers,
            withCredentials = "same-origin",
            fetchOptions,
            maxContentLength,
            maxBodyLength
          } = resolveConfig_default(config);
          const hasMaxContentLength = utils_default.isNumber(maxContentLength) && maxContentLength > -1;
          const hasMaxBodyLength = utils_default.isNumber(maxBodyLength) && maxBodyLength > -1;
          const own2 = (key) => utils_default.hasOwnProp(config, key) ? config[key] : void 0;
          let _fetch = envFetch || fetch;
          responseType = responseType ? (responseType + "").toLowerCase() : "text";
          let composedSignal = composeSignals_default(
            [signal, cancelToken && cancelToken.toAbortSignal()],
            timeout
          );
          let request = null;
          const unsubscribe = composedSignal && composedSignal.unsubscribe && (() => {
            composedSignal.unsubscribe();
          });
          let requestContentLength;
          let pendingBodyError = null;
          const maxBodyLengthError = () => new AxiosError_default(
            "Request body larger than maxBodyLength limit",
            AxiosError_default.ERR_BAD_REQUEST,
            config,
            request
          );
          try {
            let auth = void 0;
            const configAuth = own2("auth");
            if (configAuth) {
              const username = utils_default.getSafeProp(configAuth, "username") || "";
              const password = utils_default.getSafeProp(configAuth, "password") || "";
              auth = {
                username,
                password
              };
            }
            if (maybeWithAuthCredentials(url)) {
              const parsedURL = new URL(url, platform_default.origin);
              if (!auth && (parsedURL.username || parsedURL.password)) {
                const urlUsername = decodeURIComponentSafe(parsedURL.username);
                const urlPassword = decodeURIComponentSafe(parsedURL.password);
                auth = {
                  username: urlUsername,
                  password: urlPassword
                };
              }
              if (parsedURL.username || parsedURL.password) {
                parsedURL.username = "";
                parsedURL.password = "";
                url = parsedURL.href;
              }
            }
            if (auth) {
              headers.delete("authorization");
              headers.set(
                "Authorization",
                "Basic " + btoa(encodeUTF82((auth.username || "") + ":" + (auth.password || "")))
              );
            }
            if (hasMaxContentLength && typeof url === "string" && url.startsWith("data:")) {
              const estimated = estimateDataURLDecodedBytes(url);
              if (estimated > maxContentLength) {
                throw new AxiosError_default(
                  "maxContentLength size of " + maxContentLength + " exceeded",
                  AxiosError_default.ERR_BAD_RESPONSE,
                  config,
                  request
                );
              }
            }
            if (hasMaxBodyLength && method !== "get" && method !== "head") {
              const outboundLength = await getBodyLength(data);
              if (typeof outboundLength === "number" && isFinite(outboundLength)) {
                requestContentLength = outboundLength;
                if (outboundLength > maxBodyLength) {
                  throw maxBodyLengthError();
                }
              }
            }
            const mustEnforceStreamBody = hasMaxBodyLength && (utils_default.isReadableStream(data) || utils_default.isStream(data));
            const trackRequestStream = (stream, onProgress, flush) => trackStream(
              stream,
              DEFAULT_CHUNK_SIZE,
              (loadedBytes) => {
                if (hasMaxBodyLength && loadedBytes > maxBodyLength) {
                  throw pendingBodyError = maxBodyLengthError();
                }
                onProgress && onProgress(loadedBytes);
              },
              flush
            );
            if (supportsRequestStream && method !== "get" && method !== "head" && (onUploadProgress || mustEnforceStreamBody)) {
              requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
              if (requestContentLength !== 0 || mustEnforceStreamBody) {
                let _request = new Request(url, {
                  method: "POST",
                  body: data,
                  duplex: "half"
                });
                let contentTypeHeader;
                if (utils_default.isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) {
                  headers.setContentType(contentTypeHeader);
                }
                if (_request.body) {
                  const [onProgress, flush] = onUploadProgress && progressEventDecorator(
                    requestContentLength,
                    progressEventReducer(asyncDecorator(onUploadProgress))
                  ) || [];
                  data = trackRequestStream(_request.body, onProgress, flush);
                }
              }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== "get" && method !== "head") {
              data = trackRequestStream(data);
            } else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== "get" && method !== "head") {
              throw new AxiosError_default(
                "Stream request bodies are not supported by the current fetch implementation",
                AxiosError_default.ERR_NOT_SUPPORT,
                config,
                request
              );
            }
            if (!utils_default.isString(withCredentials)) {
              withCredentials = withCredentials ? "include" : "omit";
            }
            const isCredentialsSupported = isRequestSupported && "credentials" in Request.prototype;
            if (utils_default.isFormData(data)) {
              const contentType = headers.getContentType();
              if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) {
                headers.delete("content-type");
              }
            }
            headers.set("User-Agent", "axios/" + VERSION, false);
            const resolvedOptions = {
              ...fetchOptions,
              signal: composedSignal,
              method: method.toUpperCase(),
              headers: toByteStringHeaderObject(headers.normalize()),
              body: data,
              duplex: "half",
              credentials: isCredentialsSupported ? withCredentials : void 0
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = AxiosHeaders_default.from(response.headers);
            if (hasMaxContentLength) {
              const declaredLength = utils_default.toFiniteNumber(responseHeaders.getContentLength());
              if (declaredLength != null && declaredLength > maxContentLength) {
                throw new AxiosError_default(
                  "maxContentLength size of " + maxContentLength + " exceeded",
                  AxiosError_default.ERR_BAD_RESPONSE,
                  config,
                  request
                );
              }
            }
            const isStreamResponse = supportsResponseStream && (responseType === "stream" || responseType === "response");
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
              const options = {};
              ["status", "statusText", "headers"].forEach((prop) => {
                options[prop] = response[prop];
              });
              const responseContentLength = utils_default.toFiniteNumber(responseHeaders.getContentLength());
              const [onProgress, flush] = onDownloadProgress && progressEventDecorator(
                responseContentLength,
                progressEventReducer(asyncDecorator(onDownloadProgress), true)
              ) || [];
              let bytesRead = 0;
              const onChunkProgress = (loadedBytes) => {
                if (hasMaxContentLength) {
                  bytesRead = loadedBytes;
                  if (bytesRead > maxContentLength) {
                    throw new AxiosError_default(
                      "maxContentLength size of " + maxContentLength + " exceeded",
                      AxiosError_default.ERR_BAD_RESPONSE,
                      config,
                      request
                    );
                  }
                }
                onProgress && onProgress(loadedBytes);
              };
              response = new Response(
                trackStream(response.body, DEFAULT_CHUNK_SIZE, onChunkProgress, () => {
                  flush && flush();
                  unsubscribe && unsubscribe();
                }),
                options
              );
            }
            responseType = responseType || "text";
            let responseData = await resolvers[utils_default.findKey(resolvers, responseType) || "text"](
              response,
              config
            );
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
              let materializedSize;
              if (responseData != null) {
                if (typeof responseData.byteLength === "number") {
                  materializedSize = responseData.byteLength;
                } else if (typeof responseData.size === "number") {
                  materializedSize = responseData.size;
                } else if (typeof responseData === "string") {
                  materializedSize = typeof TextEncoder === "function" ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
              }
              if (typeof materializedSize === "number" && materializedSize > maxContentLength) {
                throw new AxiosError_default(
                  "maxContentLength size of " + maxContentLength + " exceeded",
                  AxiosError_default.ERR_BAD_RESPONSE,
                  config,
                  request
                );
              }
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve2, reject) => {
              settle(resolve2, reject, {
                data: responseData,
                headers: AxiosHeaders_default.from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config,
                request
              });
            });
          } catch (err) {
            unsubscribe && unsubscribe();
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof AxiosError_default) {
              const canceledError = composedSignal.reason;
              canceledError.config = config;
              request && (canceledError.request = request);
              if (err !== canceledError) {
                Object.defineProperty(canceledError, "cause", {
                  __proto__: null,
                  value: err,
                  writable: true,
                  enumerable: false,
                  configurable: true
                });
              }
              throw canceledError;
            }
            if (pendingBodyError) {
              request && !pendingBodyError.request && (pendingBodyError.request = request);
              throw pendingBodyError;
            }
            if (err instanceof AxiosError_default) {
              request && !err.request && (err.request = request);
              throw err;
            }
            if (err && err.name === "TypeError" && /Load failed|fetch/i.test(err.message)) {
              const networkError = new AxiosError_default(
                "Network Error",
                AxiosError_default.ERR_NETWORK,
                config,
                request,
                err && err.response
              );
              Object.defineProperty(networkError, "cause", {
                __proto__: null,
                value: err.cause || err,
                writable: true,
                enumerable: false,
                configurable: true
              });
              throw networkError;
            }
            throw AxiosError_default.from(err, err && err.code, config, request, err && err.response);
          }
        };
      };
      seedCache = /* @__PURE__ */ new Map();
      getFetch = (config) => {
        let env = config && config.env || {};
        const { fetch: fetch2, Request, Response } = env;
        const seeds = [Request, Response, fetch2];
        let len = seeds.length, i2 = len, seed, target, map3 = seedCache;
        while (i2--) {
          seed = seeds[i2];
          target = map3.get(seed);
          target === void 0 && map3.set(seed, target = i2 ? /* @__PURE__ */ new Map() : factory(env));
          map3 = target;
        }
        return target;
      };
      adapter = getFetch();
    }
  });

  // node_modules/axios/lib/adapters/adapters.js
  function getAdapter(adapters, config) {
    adapters = utils_default.isArray(adapters) ? adapters : [adapters];
    const { length } = adapters;
    let nameOrAdapter;
    let adapter2;
    const rejectedReasons = {};
    for (let i2 = 0; i2 < length; i2++) {
      nameOrAdapter = adapters[i2];
      let id;
      adapter2 = nameOrAdapter;
      if (!isResolvedHandle(nameOrAdapter)) {
        adapter2 = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
        if (adapter2 === void 0) {
          throw new AxiosError_default(`Unknown adapter '${id}'`);
        }
      }
      if (adapter2 && (utils_default.isFunction(adapter2) || (adapter2 = adapter2.get(config)))) {
        break;
      }
      rejectedReasons[id || "#" + i2] = adapter2;
    }
    if (!adapter2) {
      const reasons = Object.entries(rejectedReasons).map(
        ([id, state4]) => `adapter ${id} ` + (state4 === false ? "is not supported by the environment" : "is not available in the build")
      );
      let s = length ? reasons.length > 1 ? "since :\n" + reasons.map(renderReason).join("\n") : " " + renderReason(reasons[0]) : "as no adapter specified";
      throw new AxiosError_default(
        `There is no suitable adapter to dispatch the request ` + s,
        AxiosError_default.ERR_NOT_SUPPORT
      );
    }
    return adapter2;
  }
  var knownAdapters, renderReason, isResolvedHandle, adapters_default;
  var init_adapters = __esm({
    "node_modules/axios/lib/adapters/adapters.js"() {
      init_utils();
      init_null();
      init_xhr();
      init_fetch();
      init_AxiosError();
      knownAdapters = {
        http: null_default,
        xhr: xhr_default,
        fetch: {
          get: getFetch
        }
      };
      utils_default.forEach(knownAdapters, (fn, value) => {
        if (fn) {
          try {
            Object.defineProperty(fn, "name", { __proto__: null, value });
          } catch (e) {
          }
          Object.defineProperty(fn, "adapterName", { __proto__: null, value });
        }
      });
      renderReason = (reason) => `- ${reason}`;
      isResolvedHandle = (adapter2) => utils_default.isFunction(adapter2) || adapter2 === null || adapter2 === false;
      adapters_default = {
        /**
         * Resolve an adapter from a list of adapter names or functions.
         * @type {Function}
         */
        getAdapter,
        /**
         * Exposes all known adapters
         * @type {Object<string, Function|Object>}
         */
        adapters: knownAdapters
      };
    }
  });

  // node_modules/axios/lib/core/dispatchRequest.js
  function throwIfCancellationRequested(config) {
    if (config.cancelToken) {
      config.cancelToken.throwIfRequested();
    }
    if (config.signal && config.signal.aborted) {
      throw new CanceledError_default(null, config);
    }
  }
  function dispatchRequest(config) {
    throwIfCancellationRequested(config);
    config.headers = AxiosHeaders_default.from(config.headers);
    config.data = transformData.call(config, config.transformRequest);
    if (["post", "put", "patch"].indexOf(config.method) !== -1) {
      config.headers.setContentType("application/x-www-form-urlencoded", false);
    }
    const adapter2 = adapters_default.getAdapter(config.adapter || defaults_default.adapter, config);
    return adapter2(config).then(
      function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        config.response = response;
        try {
          response.data = transformData.call(config, config.transformResponse, response);
        } finally {
          delete config.response;
        }
        response.headers = AxiosHeaders_default.from(response.headers);
        return response;
      },
      function onAdapterRejection(reason) {
        if (!isCancel(reason)) {
          throwIfCancellationRequested(config);
          if (reason && reason.response) {
            config.response = reason.response;
            try {
              reason.response.data = transformData.call(
                config,
                config.transformResponse,
                reason.response
              );
            } finally {
              delete config.response;
            }
            reason.response.headers = AxiosHeaders_default.from(reason.response.headers);
          }
        }
        return Promise.reject(reason);
      }
    );
  }
  var init_dispatchRequest = __esm({
    "node_modules/axios/lib/core/dispatchRequest.js"() {
      "use strict";
      init_transformData();
      init_isCancel();
      init_defaults();
      init_CanceledError();
      init_AxiosHeaders();
      init_adapters();
    }
  });

  // node_modules/axios/lib/helpers/validator.js
  function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object" || options === null) {
      throw new AxiosError_default("options must be an object", AxiosError_default.ERR_BAD_OPTION_VALUE);
    }
    const keys = Object.keys(options);
    let i2 = keys.length;
    while (i2-- > 0) {
      const opt = keys[i2];
      const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : void 0;
      if (validator) {
        const value = options[opt];
        const result = value === void 0 || validator(value, opt, options);
        if (result !== true) {
          throw new AxiosError_default(
            "option " + opt + " must be " + result,
            AxiosError_default.ERR_BAD_OPTION_VALUE
          );
        }
        continue;
      }
      if (allowUnknown !== true) {
        throw new AxiosError_default("Unknown option " + opt, AxiosError_default.ERR_BAD_OPTION);
      }
    }
  }
  var validators, deprecatedWarnings, validator_default;
  var init_validator = __esm({
    "node_modules/axios/lib/helpers/validator.js"() {
      "use strict";
      init_data();
      init_AxiosError();
      validators = {};
      ["object", "boolean", "number", "function", "string", "symbol"].forEach((type, i2) => {
        validators[type] = function validator(thing) {
          return typeof thing === type || "a" + (i2 < 1 ? "n " : " ") + type;
        };
      });
      deprecatedWarnings = {};
      validators.transitional = function transitional(validator, version2, message) {
        function formatMessage(opt, desc) {
          return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
        }
        return (value, opt, opts) => {
          if (validator === false) {
            throw new AxiosError_default(
              formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")),
              AxiosError_default.ERR_DEPRECATED
            );
          }
          if (version2 && !deprecatedWarnings[opt]) {
            deprecatedWarnings[opt] = true;
            console.warn(
              formatMessage(
                opt,
                " has been deprecated since v" + version2 + " and will be removed in the near future"
              )
            );
          }
          return validator ? validator(value, opt, opts) : true;
        };
      };
      validators.spelling = function spelling(correctSpelling) {
        return (value, opt) => {
          console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
          return true;
        };
      };
      validator_default = {
        assertOptions,
        validators
      };
    }
  });

  // node_modules/axios/lib/core/Axios.js
  var validators2, Axios, Axios_default;
  var init_Axios = __esm({
    "node_modules/axios/lib/core/Axios.js"() {
      "use strict";
      init_utils();
      init_buildURL();
      init_InterceptorManager();
      init_dispatchRequest();
      init_mergeConfig();
      init_buildFullPath();
      init_validator();
      init_AxiosHeaders();
      init_transitional();
      validators2 = validator_default.validators;
      Axios = class {
        constructor(instanceConfig) {
          this.defaults = instanceConfig || {};
          this.interceptors = {
            request: new InterceptorManager_default(),
            response: new InterceptorManager_default()
          };
        }
        /**
         * Dispatch a request
         *
         * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
         * @param {?Object} config
         *
         * @returns {Promise} The Promise to be fulfilled
         */
        async request(configOrUrl, config) {
          try {
            return await this._request(configOrUrl, config);
          } catch (err) {
            if (err instanceof Error) {
              let dummy = {};
              Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
              const stack3 = (() => {
                if (!dummy.stack) {
                  return "";
                }
                const firstNewlineIndex = dummy.stack.indexOf("\n");
                return firstNewlineIndex === -1 ? "" : dummy.stack.slice(firstNewlineIndex + 1);
              })();
              try {
                if (!err.stack) {
                  err.stack = stack3;
                } else if (stack3) {
                  const firstNewlineIndex = stack3.indexOf("\n");
                  const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack3.indexOf("\n", firstNewlineIndex + 1);
                  const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? "" : stack3.slice(secondNewlineIndex + 1);
                  if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) {
                    err.stack += "\n" + stack3;
                  }
                }
              } catch (e) {
              }
            }
            throw err;
          }
        }
        _request(configOrUrl, config) {
          if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
          } else {
            config = configOrUrl || {};
          }
          config = mergeConfig(this.defaults, config);
          const { transitional: transitional2, paramsSerializer, headers } = config;
          if (transitional2 !== void 0) {
            validator_default.assertOptions(
              transitional2,
              {
                silentJSONParsing: validators2.transitional(validators2.boolean),
                forcedJSONParsing: validators2.transitional(validators2.boolean),
                clarifyTimeoutError: validators2.transitional(validators2.boolean),
                legacyInterceptorReqResOrdering: validators2.transitional(validators2.boolean),
                advertiseZstdAcceptEncoding: validators2.transitional(validators2.boolean),
                validateStatusUndefinedResolves: validators2.transitional(validators2.boolean)
              },
              false
            );
          }
          if (paramsSerializer != null) {
            if (utils_default.isFunction(paramsSerializer)) {
              config.paramsSerializer = {
                serialize: paramsSerializer
              };
            } else {
              validator_default.assertOptions(
                paramsSerializer,
                {
                  encode: validators2.function,
                  serialize: validators2.function
                },
                true
              );
            }
          }
          if (config.allowAbsoluteUrls !== void 0) {
          } else if (this.defaults.allowAbsoluteUrls !== void 0) {
            config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
          } else {
            config.allowAbsoluteUrls = true;
          }
          validator_default.assertOptions(
            config,
            {
              baseUrl: validators2.spelling("baseURL"),
              withXsrfToken: validators2.spelling("withXSRFToken")
            },
            true
          );
          config.method = (config.method || this.defaults.method || "get").toLowerCase();
          let contextHeaders = headers && utils_default.merge(headers.common, headers[config.method]);
          headers && utils_default.forEach(["delete", "get", "head", "post", "put", "patch", "query", "common"], (method) => {
            delete headers[method];
          });
          config.headers = AxiosHeaders_default.concat(contextHeaders, headers);
          const requestInterceptorChain = [];
          let synchronousRequestInterceptors = true;
          this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
              return;
            }
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional3 = config.transitional || transitional_default;
            const legacyInterceptorReqResOrdering = transitional3 && transitional3.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) {
              requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            } else {
              requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
            }
          });
          const responseInterceptorChain = [];
          this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
          });
          let promise;
          let i2 = 0;
          let len;
          if (!synchronousRequestInterceptors) {
            const chain3 = [dispatchRequest.bind(this), void 0];
            chain3.unshift(...requestInterceptorChain);
            chain3.push(...responseInterceptorChain);
            len = chain3.length;
            promise = Promise.resolve(config);
            while (i2 < len) {
              promise = promise.then(chain3[i2++], chain3[i2++]);
            }
            return promise;
          }
          len = requestInterceptorChain.length;
          let newConfig = config;
          while (i2 < len) {
            const onFulfilled = requestInterceptorChain[i2++];
            const onRejected = requestInterceptorChain[i2++];
            try {
              newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
            } catch (error) {
              if (!onRejected) {
                promise = Promise.reject(error);
                break;
              }
              try {
                const rejectedResult = onRejected.call(this, error);
                if (utils_default.isThenable(rejectedResult)) {
                  promise = Promise.resolve(rejectedResult).then(
                    () => dispatchRequest.call(this, newConfig)
                  );
                }
              } catch (rejectedError) {
                promise = Promise.reject(rejectedError);
              }
              break;
            }
          }
          if (!promise) {
            try {
              promise = dispatchRequest.call(this, newConfig);
            } catch (error) {
              promise = Promise.reject(error);
            }
          }
          i2 = 0;
          len = responseInterceptorChain.length;
          while (i2 < len) {
            promise = promise.then(responseInterceptorChain[i2++], responseInterceptorChain[i2++]);
          }
          return promise;
        }
        getUri(config) {
          config = mergeConfig(this.defaults, config);
          const fullPath = buildFullPath(config.baseURL, config.url, config.allowAbsoluteUrls, config);
          return buildURL(fullPath, config.params, config.paramsSerializer);
        }
      };
      utils_default.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
        Axios.prototype[method] = function(url, config) {
          return this.request(
            mergeConfig(config || {}, {
              method,
              url,
              data: config && utils_default.hasOwnProp(config, "data") ? config.data : void 0
            })
          );
        };
      });
      utils_default.forEach(["post", "put", "patch", "query"], function forEachMethodWithData(method) {
        function generateHTTPMethod(isForm) {
          return function httpMethod(url, data, config) {
            return this.request(
              mergeConfig(config || {}, {
                method,
                headers: isForm ? {
                  "Content-Type": "multipart/form-data"
                } : {},
                url,
                data
              })
            );
          };
        }
        Axios.prototype[method] = generateHTTPMethod();
        if (method !== "query") {
          Axios.prototype[method + "Form"] = generateHTTPMethod(true);
        }
      });
      Axios_default = Axios;
    }
  });

  // node_modules/axios/lib/cancel/CancelToken.js
  var CancelToken, CancelToken_default;
  var init_CancelToken = __esm({
    "node_modules/axios/lib/cancel/CancelToken.js"() {
      "use strict";
      init_CanceledError();
      CancelToken = class _CancelToken {
        constructor(executor) {
          if (typeof executor !== "function") {
            throw new TypeError("executor must be a function.");
          }
          let resolvePromise;
          this.promise = new Promise(function promiseExecutor(resolve2) {
            resolvePromise = resolve2;
          });
          const token = this;
          this.promise.then((cancel) => {
            if (!token._listeners) return;
            let i2 = token._listeners.length;
            while (i2-- > 0) {
              token._listeners[i2](cancel);
            }
            token._listeners = null;
          });
          this.promise.then = (onfulfilled) => {
            let _resolve;
            const promise = new Promise((resolve2) => {
              token.subscribe(resolve2);
              _resolve = resolve2;
            }).then(onfulfilled);
            promise.cancel = function reject() {
              token.unsubscribe(_resolve);
            };
            return promise;
          };
          executor(function cancel(message, config, request) {
            if (token.reason) {
              return;
            }
            token.reason = new CanceledError_default(message, config, request);
            resolvePromise(token.reason);
          });
        }
        /**
         * Throws a `CanceledError` if cancellation has been requested.
         */
        throwIfRequested() {
          if (this.reason) {
            throw this.reason;
          }
        }
        /**
         * Subscribe to the cancel signal
         */
        subscribe(listener) {
          if (this.reason) {
            listener(this.reason);
            return;
          }
          if (this._listeners) {
            this._listeners.push(listener);
          } else {
            this._listeners = [listener];
          }
        }
        /**
         * Unsubscribe from the cancel signal
         */
        unsubscribe(listener) {
          if (!this._listeners) {
            return;
          }
          const index = this._listeners.indexOf(listener);
          if (index !== -1) {
            this._listeners.splice(index, 1);
          }
        }
        toAbortSignal() {
          const controller = new AbortController();
          const abort = (err) => {
            controller.abort(err);
          };
          this.subscribe(abort);
          controller.signal.unsubscribe = () => this.unsubscribe(abort);
          return controller.signal;
        }
        /**
         * Returns an object that contains a new `CancelToken` and a function that, when called,
         * cancels the `CancelToken`.
         */
        static source() {
          let cancel;
          const token = new _CancelToken(function executor(c) {
            cancel = c;
          });
          return {
            token,
            cancel
          };
        }
      };
      CancelToken_default = CancelToken;
    }
  });

  // node_modules/axios/lib/helpers/spread.js
  function spread(callback) {
    return function wrap(arr) {
      return callback.apply(null, arr);
    };
  }
  var init_spread = __esm({
    "node_modules/axios/lib/helpers/spread.js"() {
      "use strict";
    }
  });

  // node_modules/axios/lib/helpers/isAxiosError.js
  function isAxiosError(payload) {
    return utils_default.isObject(payload) && payload.isAxiosError === true;
  }
  var init_isAxiosError = __esm({
    "node_modules/axios/lib/helpers/isAxiosError.js"() {
      "use strict";
      init_utils();
    }
  });

  // node_modules/axios/lib/helpers/HttpStatusCode.js
  var HttpStatusCode, HttpStatusCode_default;
  var init_HttpStatusCode = __esm({
    "node_modules/axios/lib/helpers/HttpStatusCode.js"() {
      HttpStatusCode = {
        Continue: 100,
        SwitchingProtocols: 101,
        Processing: 102,
        EarlyHints: 103,
        Ok: 200,
        Created: 201,
        Accepted: 202,
        NonAuthoritativeInformation: 203,
        NoContent: 204,
        ResetContent: 205,
        PartialContent: 206,
        MultiStatus: 207,
        AlreadyReported: 208,
        ImUsed: 226,
        MultipleChoices: 300,
        MovedPermanently: 301,
        Found: 302,
        SeeOther: 303,
        NotModified: 304,
        UseProxy: 305,
        Unused: 306,
        TemporaryRedirect: 307,
        PermanentRedirect: 308,
        BadRequest: 400,
        Unauthorized: 401,
        PaymentRequired: 402,
        Forbidden: 403,
        NotFound: 404,
        MethodNotAllowed: 405,
        NotAcceptable: 406,
        ProxyAuthenticationRequired: 407,
        RequestTimeout: 408,
        Conflict: 409,
        Gone: 410,
        LengthRequired: 411,
        PreconditionFailed: 412,
        PayloadTooLarge: 413,
        UriTooLong: 414,
        UnsupportedMediaType: 415,
        RangeNotSatisfiable: 416,
        ExpectationFailed: 417,
        ImATeapot: 418,
        MisdirectedRequest: 421,
        UnprocessableEntity: 422,
        Locked: 423,
        FailedDependency: 424,
        TooEarly: 425,
        UpgradeRequired: 426,
        PreconditionRequired: 428,
        TooManyRequests: 429,
        RequestHeaderFieldsTooLarge: 431,
        UnavailableForLegalReasons: 451,
        InternalServerError: 500,
        NotImplemented: 501,
        BadGateway: 502,
        ServiceUnavailable: 503,
        GatewayTimeout: 504,
        HttpVersionNotSupported: 505,
        VariantAlsoNegotiates: 506,
        InsufficientStorage: 507,
        LoopDetected: 508,
        NotExtended: 510,
        NetworkAuthenticationRequired: 511,
        WebServerReturnsAnUnknownError: 520,
        WebServerIsDown: 521,
        ConnectionTimedOut: 522,
        OriginIsUnreachable: 523,
        TimeoutOccurred: 524,
        SslHandshakeFailed: 525,
        InvalidSslCertificate: 526
      };
      Object.entries(HttpStatusCode).forEach(([key, value]) => {
        HttpStatusCode[value] = key;
      });
      HttpStatusCode_default = HttpStatusCode;
    }
  });

  // node_modules/axios/lib/axios.js
  function createInstance(defaultConfig) {
    const context = new Axios_default(defaultConfig);
    const instance = bind(Axios_default.prototype.request, context);
    utils_default.extend(instance, Axios_default.prototype, context, { allOwnKeys: true });
    utils_default.extend(instance, context, null, { allOwnKeys: true });
    instance.create = function create2(instanceConfig) {
      return createInstance(mergeConfig(defaultConfig, instanceConfig));
    };
    return instance;
  }
  var axios, axios_default;
  var init_axios = __esm({
    "node_modules/axios/lib/axios.js"() {
      "use strict";
      init_utils();
      init_bind();
      init_Axios();
      init_mergeConfig();
      init_defaults();
      init_formDataToJSON();
      init_CanceledError();
      init_CancelToken();
      init_isCancel();
      init_data();
      init_toFormData();
      init_AxiosError();
      init_spread();
      init_isAxiosError();
      init_AxiosHeaders();
      init_adapters();
      init_HttpStatusCode();
      axios = createInstance(defaults_default);
      axios.Axios = Axios_default;
      axios.CanceledError = CanceledError_default;
      axios.CancelToken = CancelToken_default;
      axios.isCancel = isCancel;
      axios.VERSION = VERSION;
      axios.toFormData = toFormData_default;
      axios.AxiosError = AxiosError_default;
      axios.Cancel = axios.CanceledError;
      axios.all = function all(promises) {
        return Promise.all(promises);
      };
      axios.spread = spread;
      axios.isAxiosError = isAxiosError;
      axios.mergeConfig = mergeConfig;
      axios.AxiosHeaders = AxiosHeaders_default;
      axios.formToJSON = (thing) => formDataToJSON_default(utils_default.isHTMLForm(thing) ? new FormData(thing) : thing);
      axios.getAdapter = adapters_default.getAdapter;
      axios.HttpStatusCode = HttpStatusCode_default;
      axios.default = axios;
      axios_default = axios;
    }
  });

  // node_modules/axios/index.js
  var Axios2, AxiosError2, CanceledError2, isCancel2, CancelToken2, VERSION2, all2, Cancel, isAxiosError2, spread2, toFormData2, AxiosHeaders2, HttpStatusCode2, formToJSON, getAdapter2, mergeConfig2, create;
  var init_axios2 = __esm({
    "node_modules/axios/index.js"() {
      init_axios();
      ({
        Axios: Axios2,
        AxiosError: AxiosError2,
        CanceledError: CanceledError2,
        isCancel: isCancel2,
        CancelToken: CancelToken2,
        VERSION: VERSION2,
        all: all2,
        Cancel,
        isAxiosError: isAxiosError2,
        spread: spread2,
        toFormData: toFormData2,
        AxiosHeaders: AxiosHeaders2,
        HttpStatusCode: HttpStatusCode2,
        formToJSON,
        getAdapter: getAdapter2,
        mergeConfig: mergeConfig2,
        create
      } = axios_default);
    }
  });

  // src/vue/components/helpers/cart.js
  var cart_exports2 = {};
  __export(cart_exports2, {
    default: () => cartHelpers
  });
  function cartHelpers() {
    const store2 = useStore();
    const cart = computed2(() => store2.getters.getCart);
    const getGroupId = (properties) => properties?.find(([k]) => k === "_groupId")?.[1];
    const getItemsByGroupId = (groupId) => cart.value.items.filter((item) => getGroupId(item.properties) === groupId);
    const fetchAndUpdateCart = async () => {
      try {
        const response = await axios_default("/cart?view=view-json");
        store2.dispatch("saveCart", response.data);
      } catch (error) {
        console.error(error);
        throw new Error("Failed to fetch cart data.");
      }
    };
    const price = (amount) => {
      return window.Shopify.formatMoney(amount);
    };
    const addCart2 = async (id, quantity = 1, properties = {}) => {
      await Shopify.theme.cart.addItem(id, { quantity, properties });
      await fetchAndUpdateCart();
    };
    const getImage = (src, properties) => {
      const url = ref(src);
      (0, import_lodash3.find)(properties, (key) => {
        if (key[0] === "_image" && key[1]) {
          url.value = key[1].replaceAll("&amp;", "&");
        }
      });
      return url.value || src;
    };
    const updateItem = async (quantity, key, properties = null) => {
      toggleLoader(true);
      try {
        await Shopify.theme.cart.updateItem(key, { quantity, properties });
      } catch (err) {
        console.error(err);
        location.reload();
      }
    };
    const update3 = (qty, key, qb = false, props = {}, groupId = null) => {
      toggleLoader(true);
      const quantity = ref(parseInt(qty, 10));
      let objProps = null;
      let updateGroupItems = {};
      let per_item_base_price = 0;
      if (groupId) {
        const items = getItemsByGroupId(groupId).filter(
          (item) => item.key !== key && item.quantity_update
        );
        items.forEach((item) => {
          if (item.title.startsWith("Per Item")) {
            per_item_base_price = item.price;
          }
        });
        updateGroupItems = items.reduce((acc, item) => {
          acc[item.key] = quantity.value;
          return acc;
        }, {});
      }
      if (qb || per_item_base_price) {
        objProps = {};
        const properties = props && Object.values({ ...JSON.parse(JSON.stringify(props)) });
        const price2 = ref(window.theme.quantityBreak(quantity.value, qb));
        if (properties) {
          properties.forEach((p2) => {
            if (p2[0] === "_price") {
              objProps[p2[0]] = price2.value;
            } else if (p2[0] === "_image") {
              objProps[p2[0]] = p2[1].replaceAll("&amp;", "&");
            } else if (p2[0] == "_per_item_fee_amount") {
              objProps[p2[0]] = per_item_base_price * quantity.value;
            } else {
              objProps[p2[0]] = p2[1];
            }
          });
        }
      }
      Shopify.theme.cart.updateItem(key, { quantity: quantity.value, properties: objProps }).then(() => {
        if (Object.keys(updateGroupItems).length > 0) {
          return updateItemsFromCart(updateGroupItems);
        }
      }).catch((error) => {
        console.error(error);
        location.reload();
      }).finally(() => {
        toggleLoader(true);
        fetchAndUpdateCart();
      });
    };
    const remove2 = async (key, groupId = null) => {
      if (!confirmDelete()) {
        return false;
      }
      let removeItems = {};
      toggleLoader();
      if (groupId) {
        removeItems = getItemsByGroupId(groupId).reduce((acc, item) => {
          acc[item.key] = 0;
          return acc;
        }, {});
      } else {
        removeItems[key] = 0;
      }
      try {
        await updateItemsFromCart(removeItems);
      } catch (error) {
        console.error(error);
      } finally {
        await fetchAndUpdateCart();
        if (window.location.pathname.includes("/cart") && cart.value.item_count === 0) {
          window.location.reload();
        }
        toggleLoader();
      }
    };
    return {
      fetchAndUpdateCart,
      addCart: addCart2,
      price,
      getImage,
      update: update3,
      remove: remove2
    };
  }
  var import_lodash3, disabled, toggleLoader, confirmDelete, updateItemsFromCart;
  var init_cart2 = __esm({
    "src/vue/components/helpers/cart.js"() {
      "use strict";
      import_lodash3 = __toESM(require_lodash(), 1);
      init_vue_esm_bundler();
      init_vuex_esm_bundler();
      init_axios2();
      disabled = ref(false);
      toggleLoader = (disable = false) => {
        window.jQuery("#cart-load-icon").fadeToggle();
        window.jQuery(".mini-cart--open").toggleClass("pointer-events-none");
        if (window.jQuery("#mian-cart-load-icon").length) {
          window.jQuery("#mian-cart-load-icon").fadeToggle();
        }
        if (disable) {
          window.jQuery(".custom-number-input button").toggleClass("pointer-events-none").attr("disabled", disabled.value = !disabled.value);
        }
      };
      confirmDelete = () => {
        return window.confirm("Are you sure you want to delete this?");
      };
      updateItemsFromCart = async (items) => {
        try {
          const formData2 = { updates: items };
          const response = await fetch(
            window.Shopify.routes.root + "cart/update.js",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify(formData2)
            }
          );
          await response.json();
        } catch (error) {
          console.error(error);
          throw new Error("Failed to remove items from cart.");
        }
      };
    }
  });

  // src/vue/components/helpers/properties.js
  var properties_exports = {};
  __export(properties_exports, {
    default: () => properties_default,
    getObjValue: () => getObjValue,
    lineitem: () => lineitem,
    personalizationProperty: () => personalizationProperty
  });
  function lineitem(items, font, len) {
    let outputs = [];
    const obj = (item, name, font_size) => ({
      line: item,
      sizeName: name,
      sizeValue: font_size
    });
    for (let i2 = 0; i2 < items.length; i2++) {
      let output = {};
      for (let j = 1; j <= len; j++) {
        const key = `line${j}`;
        if (items[i2][key]) {
          output[key] = obj(
            items[i2][key],
            font[i2][`size${j}`].size,
            font[i2][`size${j}`].font_size
          );
        }
      }
      outputs.push(output);
    }
    return outputs;
  }
  function properties_default(state4) {
    return {
      layout: {
        value: state4?.layout?.value ?? null,
        ...state4?.layout?.name && {
          display: state4?.layout?.name
        }
      },
      titleGraphic: {
        ...state4.titleGraphic
      },
      titleGraphicCategory: {
        value: state4.titleGraphicCategory
      },
      titleGraphicModifier: {
        value: ""
      },
      titleGraphicIsSmartSaying: {
        value: false
      },
      emblem: {
        ...state4.emblem
      },
      font: {
        value: state4?.font?.value ?? null,
        ...state4?.font?.name && {
          display: state4?.font?.name
        }
      },
      verse: {
        value: state4.verseText || ""
      },
      verseFont: {
        value: null
      },
      verseSize: {
        value: null
      },
      color: {
        value: state4?.color?.value,
        ...state4?.color?.name && {
          display: state4?.color?.name
        }
      },
      colorHexValue: {
        value: state4?.colorHexValue
      },
      productColor: {
        value: state4?.productColor?.value,
        ...state4?.productColor && {
          display: state4?.productColor?.name
        }
      },
      productColorHexValue: {
        value: state4?.productColor?.hex_value
      },
      graphicColor: {
        value: null
      },
      graphicColorHexValue: {
        value: null
      },
      primaryGraphicColor: {
        value: state4?.primaryGraphicColor?.value
      },
      primaryGraphicColorHexValue: {
        value: state4?.primaryGraphicColor?.hex_value
      },
      secondaryGraphicColor: {
        value: state4?.secondaryGraphicColor?.value || ""
      },
      secondaryGraphicColorHexValue: {
        value: state4?.secondaryGraphicColor?.hex_value || ""
      },
      textColor: {
        value: null
      },
      textColorHexValue: {
        value: null
      },
      primaryTextColor: {
        value: state4?.primaryTextColor?.value
      },
      primaryTextColorHexValue: {
        value: state4?.primaryTextColor?.hex_value
      },
      secondaryTextColor: {
        value: state4?.secondaryTextColor?.value
      },
      secondaryTextColorHexValue: {
        value: state4?.secondaryTextColor?.hex_value
      },
      logoTextColor: {
        value: state4?.logoTextColor?.value,
        ...state4?.logoTextColor && {
          display: state4?.logoTextColor?.name
        }
      },
      logoTextColorHexValue: {
        value: state4?.logoTextColor?.hex_value
      },
      logoTextLocation: {
        value: null
      },
      logoOrText: {
        value: null
      },
      location: {
        value: state4?.location?.value ?? null,
        ...state4?.location?.name && {
          display: state4?.location?.name
        }
      },
      lineFont: {
        value: null
      },
      line1: {
        value: state4.line1,
        ...state4?.line1 && {
          display: state4?.line1
        }
      },
      line1Size: {
        value: state4.line1Size
      },
      line1SizeName: {
        value: state4?.line1SizeName,
        ...state4?.line1SizeName && {
          display: state4?.line1SizeName
        }
      },
      line2: {
        value: state4.line2,
        ...state4?.line2 && {
          display: state4?.line2
        }
      },
      line2Size: {
        value: state4.line2Size
      },
      line2SizeName: {
        value: state4?.line2SizeName,
        ...state4?.line2SizeName && {
          display: state4?.line2SizeName
        }
      },
      line3: {
        value: state4.line3,
        ...state4?.line3 && {
          display: state4?.line3
        }
      },
      line3Size: {
        value: state4.line3Size
      },
      line3SizeName: {
        value: state4?.line3SizeName,
        ...state4?.line3SizeName && {
          display: state4?.line3SizeName
        }
      },
      line4: {
        value: state4.line4,
        ...state4?.line4 && {
          display: state4?.line4
        }
      },
      line4Size: {
        value: state4.line4Size
      },
      line4SizeName: {
        value: state4?.line4SizeName,
        ...state4?.line4SizeName && {
          display: state4?.line4SizeName
        }
      },
      line5: {
        value: state4.line5,
        ...state4?.line5 && {
          display: state4?.line5
        }
      },
      line5Size: {
        value: state4.line5Size
      },
      line5SizeName: {
        value: state4?.line5SizeName,
        ...state4?.line5SizeName && {
          display: state4?.line5SizeName
        }
      },
      line6: {
        value: state4.line6,
        ...state4?.line6 && {
          display: state4?.line6
        }
      },
      line6Size: {
        value: state4.line6Size
      },
      line6SizeName: {
        value: state4?.line6SizeName,
        ...state4?.line6SizeName && {
          display: state4?.line6SizeName
        }
      },
      logoLine1: {
        value: ""
      },
      logoLine2: {
        value: ""
      },
      logoLine3: {
        value: ""
      },
      envelopeFont: {
        value: null
      },
      envelopeReturnAddress: {
        value: null
      },
      envelopeUpgrade: {
        value: null
      },
      sizes: {
        value: state4?.sizes || {},
        ...state4?.sizes && {
          display: state4?.sizes
        }
      },
      orderItemId: {
        value: null
      },
      notes: {
        value: state4.notes,
        display: state4.notes
      },
      approval: {
        value: state4.approval,
        display: state4.approval
      },
      uploadLogo: {
        value: state4.uploadLogo,
        display: state4.uploadLogo
      },
      compositedImageUrl: {
        value: state4.url
      }
    };
  }
  function personalizationProperty() {
    return {
      linelp: {
        value: null
      },
      linelpSize: {
        value: null
      },
      linelpSizeName: {
        value: null
      },
      envelopeLine1: {
        value: null
      },
      envelopeLine1Size: {
        value: null
      },
      envelopeLine2: {
        value: null
      },
      envelopeLine2Size: {
        value: null
      },
      envelopeLine3: {
        value: null
      },
      envelopeLine3Size: {
        value: null
      },
      envelopeLine4: {
        value: null
      },
      envelopeLine4Size: {
        value: null
      },
      envelopeReturnAddress: {
        value: null
      },
      layers: {
        value: null
      },
      quantity: {
        value: null
      },
      basePrice: {
        value: null
      },
      noColor: {
        value: null
      }
    };
  }
  var import_lodash4, getObjValue;
  var init_properties = __esm({
    "src/vue/components/helpers/properties.js"() {
      "use strict";
      import_lodash4 = __toESM(require_lodash(), 1);
      getObjValue = (value = null, steps = [], layout = null) => {
        const matchingStep = (0, import_lodash4.find)(steps, (step) => {
          if (layout === null) {
            return (0, import_lodash4.some)(step, (propValue) => {
              return (0, import_lodash4.isEqual)(propValue, value);
            });
          } else {
            return (0, import_lodash4.some)(step.layouts, { layout, value });
          }
        });
        if (matchingStep) {
          return {
            value,
            display: matchingStep.name
          };
        } else {
          return {
            value
          };
        }
      };
    }
  });

  // src/vue/components/render/available-options.vue
  var available_options_exports = {};
  __export(available_options_exports, {
    default: () => available_options_default,
    render: () => render2
  });
  function render2(_ctx, _cache) {
    return openBlock(), createElementBlock("div", _hoisted_1, [
      _cache[0] || (_cache[0] = createBaseVNode(
        "p",
        { class: "mb-3 font-bold sentiments__heading" },
        " Available Options ",
        -1
        /* CACHED */
      )),
      createBaseVNode("div", _hoisted_2, [
        (openBlock(true), createElementBlock(
          Fragment,
          null,
          renderList(_ctx.products, (product, key) => {
            return openBlock(), createElementBlock("div", {
              key,
              class: "pr-2 sentiments__item last:pr-0"
            }, [
              product.featured_image ? (openBlock(), createElementBlock("a", {
                key: 0,
                class: "sentiments__button",
                href: product.url
              }, [
                createBaseVNode("img", {
                  alt: product.title,
                  class: "object-cover object-center w-16 h-16 sentiments__image",
                  src: product.featured_image
                }, null, 8, _hoisted_4)
              ], 8, _hoisted_3)) : createCommentVNode("v-if", true)
            ]);
          }),
          128
          /* KEYED_FRAGMENT */
        ))
      ])
    ]);
  }
  var import_lodash5, __default__, _hoisted_1, _hoisted_2, _hoisted_3, _hoisted_4, available_options_default;
  var init_available_options = __esm({
    "src/vue/components/render/available-options.vue"() {
      "use strict";
      init_vue_esm_bundler();
      import_lodash5 = __toESM(require_lodash());
      init_vue_esm_bundler();
      __default__ = {
        props: {
          id: {
            type: Number,
            required: true
          }
        },
        setup(props) {
          const { id } = toRefs(props);
          const products = ref(null);
          onMounted(() => {
            fetch(
              `${window.Shopify.routes.root}recommendations/products.json?product_id=${id.value}&limit=4&intent=related`
            ).then((response) => response.json()).then((data) => {
              products.value = (0, import_lodash5.shuffle)(data.products);
            }).catch((error) => {
              console.log(error);
            });
          });
          return {
            products
          };
        }
      };
      _hoisted_1 = { class: "mb-5 available-options" };
      _hoisted_2 = { class: "flex flex-wrap" };
      _hoisted_3 = ["href"];
      _hoisted_4 = ["alt", "src"];
      __default__.render = render2;
      available_options_default = __default__;
    }
  });

  // src/vue/components/svg/icon-remove.vue
  var icon_remove_exports = {};
  __export(icon_remove_exports, {
    default: () => icon_remove_default,
    render: () => render3
  });
  function render3(_ctx, _cache) {
    return openBlock(), createElementBlock("svg", _hoisted_12, [..._cache[0] || (_cache[0] = [
      createBaseVNode(
        "title",
        null,
        "Remove",
        -1
        /* CACHED */
      ),
      createBaseVNode(
        "path",
        { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" },
        null,
        -1
        /* CACHED */
      )
    ])]);
  }
  var __default__2, _hoisted_12, icon_remove_default;
  var init_icon_remove = __esm({
    "src/vue/components/svg/icon-remove.vue"() {
      "use strict";
      init_vue_esm_bundler();
      __default__2 = {};
      _hoisted_12 = {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#8C8C8C",
        viewBox: "0 0 24 24",
        class: "svg-icon svg-icon--small"
      };
      __default__2.render = render3;
      icon_remove_default = __default__2;
    }
  });

  // src/vue/components/render/product-qty.vue
  var product_qty_exports = {};
  __export(product_qty_exports, {
    default: () => product_qty_default,
    render: () => render4
  });
  function render4(_ctx, _cache) {
    return openBlock(), createElementBlock(
      Fragment,
      null,
      [
        createBaseVNode(
          "div",
          {
            class: normalizeClass(["h-6 lg:h-10 custom-number-input", _ctx.width])
          },
          [
            createBaseVNode(
              "div",
              {
                class: normalizeClass([
                  "quantity-main",
                  _ctx.min > _ctx.productQty || _ctx.multiple > 1 && _ctx.productQty % _ctx.multiple !== 0 ? "border-red-200" : "border-gray-50"
                ])
              },
              [
                createBaseVNode("button", {
                  type: "button",
                  class: normalizeClass(["quantity-change-btn", _ctx.disabled && "cursor-not-allowed disabled hidden"]),
                  disabled: _ctx.disabled,
                  onClick: _cache[0] || (_cache[0] = withModifiers((...args) => _ctx.decrement && _ctx.decrement(...args), ["prevent"]))
                }, [..._cache[3] || (_cache[3] = [
                  createBaseVNode(
                    "span",
                    { class: "m-auto text-sm md:text-lg lg:text-xl font-thin" },
                    "\u2212",
                    -1
                    /* CACHED */
                  )
                ])], 10, _hoisted_13),
                _ctx.disabled ? (openBlock(), createElementBlock(
                  "div",
                  {
                    key: 0,
                    class: normalizeClass(["flex items-center justify-center w-full font-semibold text-center outline-none focus:outline-none text-md hover:text-black focus:text-black md:text-basecursor-default", _ctx.disabled && "cursor-not-allowed bg-gray-300 text-gray-100"])
                  },
                  toDisplayString(_ctx.qty),
                  3
                  /* TEXT, CLASS */
                )) : withDirectives((openBlock(), createElementBlock("input", {
                  key: 1,
                  id: `quantity_${_ctx.index}`,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.productQty = $event),
                  type: "number",
                  name: "quantity",
                  min: _ctx.min,
                  class: normalizeClass(["quantity-number", _ctx.disabled && "cursor-not-allowed bg-gray-300 text-gray-100"]),
                  title: "Qty",
                  "aria-label": "Qty",
                  disabled: _ctx.disabled
                }, null, 10, _hoisted_22)), [
                  [vModelText, _ctx.productQty]
                ]),
                createBaseVNode("button", {
                  type: "button",
                  class: normalizeClass(["quantity-change-btn", _ctx.disabled && "cursor-not-allowed disabled hidden"]),
                  disabled: _ctx.disabled,
                  onClick: _cache[2] || (_cache[2] = withModifiers((...args) => _ctx.increment && _ctx.increment(...args), ["prevent"]))
                }, [..._cache[4] || (_cache[4] = [
                  createBaseVNode(
                    "span",
                    { class: "m-auto text-sm md:text-lg lg:text-xl font-thin" },
                    "+",
                    -1
                    /* CACHED */
                  )
                ])], 10, _hoisted_32)
              ],
              2
              /* CLASS */
            )
          ],
          2
          /* CLASS */
        ),
        _ctx.min > _ctx.productQty ? (openBlock(), createElementBlock("label", {
          key: 0,
          for: `quantity_${_ctx.index}`,
          class: normalizeClass(["mt-1 text-red-500", _ctx.update && "block"])
        }, "Min: " + toDisplayString(_ctx.min) + " Qty", 11, _hoisted_42)) : createCommentVNode("v-if", true),
        _ctx.multiple > 1 && _ctx.productQty % _ctx.multiple !== 0 ? (openBlock(), createElementBlock("label", {
          key: 1,
          for: `quantity_${_ctx.index}`,
          class: normalizeClass([_ctx.update && "block", "mt-1 text-red-500"])
        }, "Please enter a multiple of " + toDisplayString(_ctx.multiple) + ".", 11, _hoisted_5)) : createCommentVNode("v-if", true)
      ],
      64
      /* STABLE_FRAGMENT */
    );
  }
  var __default__3, _hoisted_13, _hoisted_22, _hoisted_32, _hoisted_42, _hoisted_5, product_qty_default;
  var init_product_qty = __esm({
    "src/vue/components/render/product-qty.vue"() {
      "use strict";
      init_vuex_esm_bundler();
      init_vue_esm_bundler();
      init_vue_esm_bundler();
      __default__3 = {
        props: {
          qty: {
            type: Number,
            required: true
          },
          group_id: {
            type: [Number, Boolean],
            default: false
          },
          min: {
            type: Number,
            default: 1
          },
          multiple: {
            type: Number,
            default: 1
          },
          data: {
            type: [Object, Boolean],
            default: false
          },
          index: {
            type: Number,
            default: 0
          },
          itemKey: {
            type: String,
            default: null
          },
          update: {
            type: Boolean,
            default: false
          },
          disabled: {
            type: Boolean,
            default: false
          },
          properties: {
            type: [Object, Boolean],
            default: false
          },
          width: {
            type: String,
            default: "custom-width"
          }
        },
        emits: ["updateQty"],
        setup(props, { emit: emit2 }) {
          const store2 = useStore();
          const { qty, multiple } = toRefs(props);
          const productQty = ref(qty.value);
          const oldQty = ref([qty.value, qty.value, 0]);
          const parentClass = () => {
            return props.disabled ? "pointer-events-none " + props.width : props.width;
          };
          const updateCartBtn = (bool = false) => {
            if (props.update) {
              store2.dispatch("saveAddToCart", bool);
            }
          };
          watch2(productQty, (q2, o) => {
            if (props.min > productQty.value) {
              oldQty.value = [
                q2,
                o,
                multiple.value - productQty.value % multiple.value
              ];
              updateCartBtn();
              return;
            }
            if (multiple.value > 1 && productQty.value % multiple.value !== 0) {
              oldQty.value = [
                q2,
                o,
                multiple.value - productQty.value % multiple.value
              ];
              updateCartBtn();
              return;
            }
            oldQty.value = [q2, o, 0];
            if (props.update) {
              updateCartBtn(true);
              const price = ref(
                window.theme.quantityBreak(productQty.value, props.data)
              );
              window.jQuery(".shopify-product-form .properties_price").val(price.value);
              window.jQuery(".mh-qty").html(productQty.value);
              window.jQuery(".mh-base-price").html(window.Shopify.formatMoney(price.value));
            } else {
              emit2(
                "updateQty",
                productQty.value,
                props.itemKey,
                props.data,
                props.properties,
                props.group_id
              );
            }
          });
          const decrement = () => {
            if (props.min >= productQty.value) {
              return;
            }
            if (oldQty.value[2] > 0 && multiple.value > 1) {
              productQty.value = oldQty.value[0] - (multiple.value - oldQty.value[2]);
              oldQty.value[2] = 0;
            } else {
              productQty.value = oldQty.value[0] - multiple.value;
            }
          };
          const increment = () => {
            if (oldQty.value[2] > 0 && multiple.value > 1) {
              productQty.value = oldQty.value[0] + oldQty.value[2];
              oldQty.value[2] = 0;
            } else {
              productQty.value = oldQty.value[0] + multiple.value;
            }
          };
          return {
            productQty,
            parentClass,
            increment,
            decrement
          };
        }
      };
      _hoisted_13 = ["disabled"];
      _hoisted_22 = ["id", "min", "disabled"];
      _hoisted_32 = ["disabled"];
      _hoisted_42 = ["for"];
      _hoisted_5 = ["for"];
      __default__3.render = render4;
      product_qty_default = __default__3;
    }
  });

  // src/vue/components/render/cart-drawer.vue
  var cart_drawer_exports = {};
  __export(cart_drawer_exports, {
    default: () => cart_drawer_default,
    render: () => render5
  });
  function render5(_ctx, _cache) {
    const _component_IconRemove = resolveComponent("IconRemove");
    const _component_ProductQty = resolveComponent("ProductQty");
    return withDirectives((openBlock(), createElementBlock(
      "div",
      _hoisted_14,
      [
        withDirectives(createBaseVNode(
          "div",
          _hoisted_23,
          [..._cache[2] || (_cache[2] = [
            createBaseVNode(
              "img",
              {
                class: "w-12",
                src: "https://cdn.shopify.com/s/files/1/0667/4766/2632/files/cws-ajax-loader.gif?v=1674112260",
                alt: ""
              },
              null,
              -1
              /* CACHED */
            )
          ])],
          512
          /* NEED_PATCH */
        ), [
          [vShow, !_ctx.loading]
        ]),
        withDirectives(createBaseVNode(
          "div",
          _hoisted_33,
          null,
          512
          /* NEED_PATCH */
        ), [
          [vShow, _ctx.loading]
        ]),
        withDirectives(createBaseVNode(
          "div",
          {
            class: "mini-cart__drawer",
            onClick: _cache[1] || (_cache[1] = withModifiers(($event) => _ctx.close(), ["self"]))
          },
          [
            createBaseVNode("div", _hoisted_43, [
              createBaseVNode("div", _hoisted_52, [
                createBaseVNode("button", {
                  class: "mini-cart__action-button",
                  "data-close-mini-cart": "",
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.close(), ["self"]))
                }, " X ")
              ]),
              createBaseVNode("div", _hoisted_6, [
                createBaseVNode("div", _hoisted_7, [
                  _cache[3] || (_cache[3] = createBaseVNode(
                    "h3",
                    { class: "cart-summary__heading-label" },
                    "My Cart",
                    -1
                    /* CACHED */
                  )),
                  createBaseVNode(
                    "div",
                    _hoisted_8,
                    toDisplayString(_ctx.cart.item_count),
                    1
                    /* TEXT */
                  )
                ]),
                _ctx.cart.item_count > 0 ? (openBlock(), createElementBlock("div", _hoisted_9, [
                  (openBlock(true), createElementBlock(
                    Fragment,
                    null,
                    renderList(_ctx.cart.items, (item, index) => {
                      return openBlock(), createElementBlock("div", {
                        "data-group_id": item.group_id,
                        key: item.key,
                        class: "cart-summary__item"
                      }, [
                        createBaseVNode("div", _hoisted_11, [
                          createBaseVNode("div", _hoisted_122, [
                            createBaseVNode("div", _hoisted_132, [
                              createBaseVNode("a", {
                                class: normalizeClass(["cart-summary__cover-link", {
                                  "pointer-events-none": !_ctx.hideCrossButton(item.title)
                                }]),
                                href: item.url
                              }, [
                                createBaseVNode("img", {
                                  alt: item.title,
                                  class: "cart-summary__cover-image",
                                  src: _ctx.getImage(item.image, item.properties)
                                }, null, 8, _hoisted_15)
                              ], 10, _hoisted_142)
                            ])
                          ]),
                          createBaseVNode("div", _hoisted_16, [
                            _ctx.hideCrossButton(item.title) ? (openBlock(), createElementBlock("div", _hoisted_17, [
                              createBaseVNode("button", {
                                name: "button",
                                type: "submit",
                                value: "remove_item",
                                class: "text-button",
                                onClick: withModifiers(($event) => _ctx.itemRemove(item.key, item.group_id, item.properties), ["prevent"])
                              }, [
                                createVNode(_component_IconRemove)
                              ], 8, _hoisted_18)
                            ])) : createCommentVNode("v-if", true),
                            createBaseVNode("div", _hoisted_19, [
                              createBaseVNode("div", _hoisted_20, [
                                createBaseVNode("a", {
                                  class: normalizeClass(["link", {
                                    "pointer-events-none": !_ctx.hideCrossButton(item.title)
                                  }]),
                                  href: item.url,
                                  innerHTML: item.title
                                }, null, 10, _hoisted_21)
                              ]),
                              item.sku ? (openBlock(), createElementBlock(
                                "div",
                                _hoisted_222,
                                " Item " + toDisplayString(item.sku),
                                1
                                /* TEXT */
                              )) : createCommentVNode("v-if", true),
                              createBaseVNode("table", _hoisted_232, [
                                createBaseVNode("tbody", null, [
                                  _ctx.showTablePrice(item.title) ? (openBlock(), createElementBlock("tr", _hoisted_24, [
                                    _cache[4] || (_cache[4] = createBaseVNode(
                                      "th",
                                      null,
                                      "Price",
                                      -1
                                      /* CACHED */
                                    )),
                                    createBaseVNode("td", _hoisted_25, [
                                      createBaseVNode("p", _hoisted_26, [
                                        createBaseVNode(
                                          "span",
                                          null,
                                          toDisplayString(_ctx.price(item.price)),
                                          1
                                          /* TEXT */
                                        )
                                      ]),
                                      createCommentVNode(' <p class="table__price">\r\n                              <span\r\n                                class="text-xs font-normal sm:font-bold sm:text-sm"\r\n                                >Customizations:\r\n                                {{ price(item.personalization) }}</span\r\n                              >\r\n                            </p> ')
                                    ])
                                  ])) : createCommentVNode("v-if", true),
                                  _ctx.showTablePrice(item.title) ? (openBlock(), createElementBlock("tr", _hoisted_27, [
                                    _cache[5] || (_cache[5] = createBaseVNode(
                                      "th",
                                      null,
                                      "Quantity",
                                      -1
                                      /* CACHED */
                                    )),
                                    createBaseVNode("td", null, [
                                      createBaseVNode("div", _hoisted_28, [
                                        createVNode(_component_ProductQty, {
                                          qty: item.quantity,
                                          min: item.min,
                                          data: item.quantity_breaks,
                                          index,
                                          "item-key": item.key,
                                          multiple: item.qty_multiple,
                                          disabled: item.qty_disable,
                                          properties: item.properties,
                                          group_id: item.group_id,
                                          width: "w-20 sm:w-32",
                                          onUpdateQty: _ctx.updateQty
                                        }, null, 8, ["qty", "min", "data", "index", "item-key", "multiple", "disabled", "properties", "group_id", "onUpdateQty"])
                                      ])
                                    ])
                                  ])) : createCommentVNode("v-if", true),
                                  createBaseVNode("tr", null, [
                                    _cache[6] || (_cache[6] = createBaseVNode(
                                      "th",
                                      null,
                                      "Total",
                                      -1
                                      /* CACHED */
                                    )),
                                    createBaseVNode(
                                      "td",
                                      _hoisted_29,
                                      toDisplayString(_ctx.price(item.line_price)),
                                      1
                                      /* TEXT */
                                    )
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ], 8, _hoisted_10);
                    }),
                    128
                    /* KEYED_FRAGMENT */
                  ))
                ])) : createCommentVNode("v-if", true),
                _ctx.cart.item_count > 0 ? (openBlock(), createElementBlock("div", _hoisted_30, [
                  _cache[7] || (_cache[7] = createBaseVNode(
                    "div",
                    { class: "cart-summary__total-content" },
                    [
                      createBaseVNode("div", { class: "text-xl cart-summary__total-label" }, "Subtotal")
                    ],
                    -1
                    /* CACHED */
                  )),
                  createBaseVNode("div", _hoisted_31, [
                    createBaseVNode(
                      "div",
                      _hoisted_322,
                      toDisplayString(_ctx.price(_ctx.cart.original_total_price)),
                      1
                      /* TEXT */
                    )
                  ])
                ])) : createCommentVNode("v-if", true),
                _ctx.cart.item_count > 0 ? (openBlock(), createElementBlock("div", _hoisted_332, [..._cache[8] || (_cache[8] = [
                  createStaticVNode('<div class="flex items-center"><div class="w-1/2 pr-4"><a class="justify-center button button--cart-summary button--full button-secondary" href="/cart">View Full Cart</a></div><div class="w-1/2 pl-4 mini-cart__checkout-button"><a class="button button--cart-summary button--full button-product !inline-flex items-center leading-none justify-center" href="/checkout">Checkout</a></div></div>', 1)
                ])])) : (openBlock(), createElementBlock("div", _hoisted_34, [..._cache[9] || (_cache[9] = [
                  createBaseVNode(
                    "div",
                    { class: "text-left cart-summary__message-empty font-base" },
                    " You were looking at some great stuff. ",
                    -1
                    /* CACHED */
                  )
                ])]))
              ])
            ])
          ],
          512
          /* NEED_PATCH */
        ), [
          [vShow, _ctx.loading]
        ])
      ],
      512
      /* NEED_PATCH */
    )), [
      [vShow, _ctx.show]
    ]);
  }
  var __default__4, _hoisted_14, _hoisted_23, _hoisted_33, _hoisted_43, _hoisted_52, _hoisted_6, _hoisted_7, _hoisted_8, _hoisted_9, _hoisted_10, _hoisted_11, _hoisted_122, _hoisted_132, _hoisted_142, _hoisted_15, _hoisted_16, _hoisted_17, _hoisted_18, _hoisted_19, _hoisted_20, _hoisted_21, _hoisted_222, _hoisted_232, _hoisted_24, _hoisted_25, _hoisted_26, _hoisted_27, _hoisted_28, _hoisted_29, _hoisted_30, _hoisted_31, _hoisted_322, _hoisted_332, _hoisted_34, cart_drawer_default;
  var init_cart_drawer = __esm({
    "src/vue/components/render/cart-drawer.vue"() {
      "use strict";
      init_axios2();
      init_vue_esm_bundler();
      init_vuex_esm_bundler();
      init_cart2();
      init_icon_remove();
      init_product_qty();
      init_vue_esm_bundler();
      __default__4 = {
        components: { IconRemove: icon_remove_default, ProductQty: product_qty_default },
        setup() {
          const store2 = useStore();
          const cart = computed2(() => store2.getters.getCart);
          const { price, remove: remove2, update: update3, getImage } = cartHelpers();
          const updateQty = (qty, key, qb, properties, group_id) => {
            update3(qty, key, qb, properties, group_id);
          };
          const loading = ref(false);
          const show = computed2(() => store2.getters.getCartDrawer);
          const close = () => {
            window.theme.cartDrawer.close();
            document.body.classList.remove("body-scroll--disabled");
            store2.dispatch("saveCartDrawer", false);
          };
          const showTablePrice = (title) => {
            const name = title?.trim();
            return !name.startsWith("Personalization Setup Fee");
          };
          const hideCrossButton = (title) => {
            const name = title?.trim();
            return !(name.startsWith("Personalization Setup Fee") || name.startsWith("Per Item Fee"));
          };
          const itemRemove = (key, groupId, properties = null) => {
            let groupIdToRemove = groupId;
            if (properties) {
              const obj = Object.fromEntries(properties);
              groupIdToRemove = obj._groupId;
            }
            remove2(key, groupIdToRemove);
          };
          watch2(show, () => {
            loading.value = show.value;
          });
          return {
            cart,
            show,
            loading,
            close,
            getImage,
            price,
            itemRemove,
            updateQty,
            showTablePrice,
            hideCrossButton
          };
        },
        mounted() {
          const store2 = useStore();
          window.cartTarget.addEventListener("ajaxCart", (e) => {
            if (e.detail.name == "ajaxCart") {
              axios_default("/cart?view=view-json").then((response) => {
                store2.dispatch("saveCart", response.data);
                if (window.location.pathname != "/cart") {
                  window.theme.cartDrawer.open();
                }
                setTimeout(() => {
                  window.jQuery("#add-to-cart-image").hide();
                  document.body.classList.remove("cart-add-logo");
                }, 2e3);
              });
            }
          });
        },
        created() {
          const store2 = useStore();
          axios_default("/cart?view=view-json").then((response) => {
            store2.dispatch("saveCart", response.data);
          });
        }
      };
      _hoisted_14 = { class: "mh-cart-drawer mh-cart-drawer--right" };
      _hoisted_23 = {
        id: "cart-load-icon",
        class: "fixed z-[1111] translate-x-1/2 translate-y-1/2 left-2/4 top-2/4"
      };
      _hoisted_33 = {
        id: "add-to-cart-image",
        class: "added-to-cart-image"
      };
      _hoisted_43 = {
        class: "mini-cart mini-cart--open",
        "data-mini-cart": ""
      };
      _hoisted_52 = { class: "mini-cart__actions" };
      _hoisted_6 = { class: "mini-cart__wrap" };
      _hoisted_7 = { class: "flex items-center cart-summary__heading" };
      _hoisted_8 = { class: "cart-summary__heading-value" };
      _hoisted_9 = {
        key: 0,
        class: "cart-summary__body"
      };
      _hoisted_10 = ["data-group_id"];
      _hoisted_11 = { class: "flex -ml-2" };
      _hoisted_122 = { class: "inline-block w-4/12 pl-2 text-base" };
      _hoisted_132 = { class: "cart-summary__cover" };
      _hoisted_142 = ["href"];
      _hoisted_15 = ["alt", "src"];
      _hoisted_16 = { class: "inline-block w-8/12 pl-2 text-base" };
      _hoisted_17 = {
        key: 0,
        class: "cart-summary__remove"
      };
      _hoisted_18 = ["onClick"];
      _hoisted_19 = { class: "cart-summary__content" };
      _hoisted_20 = { class: "cart-summary__content-name" };
      _hoisted_21 = ["href", "innerHTML"];
      _hoisted_222 = {
        key: 0,
        class: "cart-summary__content-sku"
      };
      _hoisted_232 = { class: "table table--cart-summary" };
      _hoisted_24 = { key: 0 };
      _hoisted_25 = { class: "font-mont" };
      _hoisted_26 = { class: "cart-summary__price" };
      _hoisted_27 = { key: 1 };
      _hoisted_28 = { class: "flex flex-col items-end justify-end inline-form" };
      _hoisted_29 = { class: "font-bold font-mont" };
      _hoisted_30 = {
        key: 1,
        class: "flex items-center justify-between cart-summary__total"
      };
      _hoisted_31 = { class: "cart-summary__total-content" };
      _hoisted_322 = { class: "text-xl cart-summary__total-value" };
      _hoisted_332 = {
        key: 2,
        class: "px-4 mb-6 text-center cart-summary__actions"
      };
      _hoisted_34 = {
        key: 3,
        class: "px-4 cart-summary__body"
      };
      __default__4.render = render5;
      cart_drawer_default = __default__4;
    }
  });

  // src/vue/components/render/collection-filter-heading.vue
  var collection_filter_heading_exports = {};
  __export(collection_filter_heading_exports, {
    default: () => collection_filter_heading_default,
    render: () => render6
  });
  function render6(_ctx, _cache) {
    return openBlock(), createElementBlock("div", _hoisted_110, [
      createBaseVNode(
        "span",
        null,
        toDisplayString(_ctx.name),
        1
        /* TEXT */
      ),
      _cache[0] || (_cache[0] = createStaticVNode('<span class="sidebar-filter__icon icon-plus"><svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.87283 6.69429H0V4.24286H3.87283V0H6.12717V4.24286H10V6.69429H6.12717V11H3.87283V6.69429Z" fill="black"></path></svg></span><span class="sidebar-filter__icon icon-minus"><svg width="10" height="3" viewBox="0 0 10 3" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0H10V3H0V0Z" fill="black"></path></svg></span>', 2))
    ]);
  }
  var __default__5, _hoisted_110, collection_filter_heading_default;
  var init_collection_filter_heading = __esm({
    "src/vue/components/render/collection-filter-heading.vue"() {
      "use strict";
      init_vue_esm_bundler();
      __default__5 = {
        props: {
          name: {
            type: String,
            required: true
          }
        }
      };
      _hoisted_110 = { class: "sidebar-filters__heading" };
      __default__5.render = render6;
      collection_filter_heading_default = __default__5;
    }
  });

  // src/vue/components/render/collection-filter-item.vue
  var collection_filter_item_exports = {};
  __export(collection_filter_item_exports, {
    default: () => collection_filter_item_default,
    render: () => render7
  });
  function render7(_ctx, _cache) {
    return openBlock(), createElementBlock("li", _hoisted_111, [
      createBaseVNode("label", {
        class: normalizeClass(["result-filter__link", { disabled: _ctx.value.disabled }]),
        for: `Filter-${_ctx.filter.filter_param_name}-${_ctx.key}-no-js`
      }, [
        createBaseVNode("input", {
          "data-label": _ctx.value.name,
          onChange: _cache[0] || (_cache[0] = ($event) => _ctx.handleClick(_ctx.value.param_name, _ctx.value.value)),
          class: "result-filter__checkbox",
          type: "checkbox",
          id: `Filter-${_ctx.filter.filter_param_name}-${_ctx.key}-no-js`,
          name: _ctx.value.param_name,
          value: _ctx.value.value,
          checked: _ctx.value.active,
          disabled: _ctx.value.disabled
        }, null, 40, _hoisted_35),
        createBaseVNode(
          "span",
          {
            class: normalizeClass(["result-filter__value", { "primary-color": _ctx.value.active }])
          },
          [
            createBaseVNode("span", {
              class: "inline-block",
              innerHTML: _ctx.value.name
            }, null, 8, _hoisted_44),
            createBaseVNode(
              "span",
              _hoisted_53,
              "(" + toDisplayString(_ctx.value.count) + ")",
              1
              /* TEXT */
            )
          ],
          2
          /* CLASS */
        )
      ], 10, _hoisted_210)
    ]);
  }
  var __default__6, _hoisted_111, _hoisted_210, _hoisted_35, _hoisted_44, _hoisted_53, collection_filter_item_default;
  var init_collection_filter_item = __esm({
    "src/vue/components/render/collection-filter-item.vue"() {
      "use strict";
      init_vue_esm_bundler();
      __default__6 = {
        props: {
          value: {
            type: Object,
            required: true
          }
        }
      };
      _hoisted_111 = { class: "result-filter" };
      _hoisted_210 = ["for"];
      _hoisted_35 = ["data-label", "id", "name", "value", "checked", "disabled"];
      _hoisted_44 = ["innerHTML"];
      _hoisted_53 = { class: "ml-1 result-filter__count" };
      __default__6.render = render7;
      collection_filter_item_default = __default__6;
    }
  });

  // src/vue/components/render/collection-sort.vue
  var collection_sort_exports = {};
  __export(collection_sort_exports, {
    default: () => collection_sort_default,
    render: () => render8
  });
  function render8(_ctx, _cache) {
    const _component_FilterHeading = resolveComponent("FilterHeading");
    return openBlock(), createElementBlock("div", _hoisted_112, [
      createVNode(_component_FilterHeading, { name: "Sort By" }),
      createBaseVNode("ul", _hoisted_211, [
        (openBlock(true), createElementBlock(
          Fragment,
          null,
          renderList(_ctx.options, (option, key) => {
            return openBlock(), createElementBlock("li", {
              class: "result-filter",
              key
            }, [
              createBaseVNode("label", {
                class: normalizeClass(["result-filter__link", { active: option[0] === _ctx.sorted }]),
                for: `options-${option[0]}-${key}-no-js`
              }, [
                createBaseVNode("input", {
                  "data-label": option[1],
                  onChange: ($event) => _ctx.handleSortBy($event, option),
                  class: "result-filter__checkbox",
                  type: "checkbox",
                  id: `options-${option[0]}-${key}-no-js`,
                  name: option[0],
                  value: option[0],
                  checked: option[0] === _ctx.sorted
                }, null, 40, _hoisted_45),
                createBaseVNode("span", {
                  class: normalizeClass(["result-filter__value", { "primary-color": option[0] === _ctx.sorted }]),
                  innerHTML: option[1]
                }, null, 10, _hoisted_54)
              ], 10, _hoisted_36)
            ]);
          }),
          128
          /* KEYED_FRAGMENT */
        ))
      ])
    ]);
  }
  var __default__7, _hoisted_112, _hoisted_211, _hoisted_36, _hoisted_45, _hoisted_54, collection_sort_default;
  var init_collection_sort = __esm({
    "src/vue/components/render/collection-sort.vue"() {
      "use strict";
      init_vue_esm_bundler();
      init_collection_filter_heading();
      init_vue_esm_bundler();
      __default__7 = {
        components: { FilterHeading: collection_filter_heading_default },
        emits: ["sortBy"],
        props: {
          sorted: {
            type: String,
            default: window.filtersJSON.sort_by
          }
        },
        setup(_2, { emit: emit2 }) {
          const options = ref([...window.filtersJSON.sort_options]);
          const handleSortBy = (event, option) => {
            emit2("sortBy", event);
          };
          return {
            options,
            handleSortBy
          };
        }
      };
      _hoisted_112 = {
        class: "sidebar-filters__section",
        tabindex: "1"
      };
      _hoisted_211 = { class: "sidebar-filters__group list-reset" };
      _hoisted_36 = ["for"];
      _hoisted_45 = ["data-label", "onChange", "id", "name", "value", "checked"];
      _hoisted_54 = ["innerHTML"];
      __default__7.render = render8;
      collection_sort_default = __default__7;
    }
  });

  // src/vue/components/render/collection-filter.vue
  var collection_filter_exports = {};
  __export(collection_filter_exports, {
    default: () => collection_filter_default,
    render: () => render9
  });
  function render9(_ctx, _cache) {
    const _component_FilterHeading = resolveComponent("FilterHeading");
    const _component_CollectionSort = resolveComponent("CollectionSort");
    return openBlock(), createElementBlock("div", _hoisted_113, [
      (openBlock(true), createElementBlock(
        Fragment,
        null,
        renderList(_ctx.filtersData, (filter5, index) => {
          return openBlock(), createElementBlock(
            "div",
            {
              key: index,
              class: normalizeClass(["sidebar-filters__section", { open: index == -2 }]),
              tabindex: "1"
            },
            [
              createVNode(_component_FilterHeading, {
                name: filter5.name
              }, null, 8, ["name"]),
              createBaseVNode("ul", _hoisted_212, [
                (openBlock(true), createElementBlock(
                  Fragment,
                  null,
                  renderList(filter5.values, (value, key) => {
                    return openBlock(), createElementBlock("li", {
                      class: "result-filter",
                      key
                    }, [
                      createBaseVNode("label", {
                        class: normalizeClass(["result-filter__link", { disabled: value.disabled }]),
                        for: `Filter-${filter5.filter_param_name}-${key}-no-js`
                      }, [
                        createBaseVNode("input", {
                          "data-label": value.name,
                          onChange: ($event) => _ctx.handleClick(value.param_name, value.value),
                          class: "result-filter__checkbox",
                          type: "checkbox",
                          id: `Filter-${filter5.filter_param_name}-${key}-no-js`,
                          name: value.param_name,
                          value: value.value,
                          checked: value.active,
                          disabled: value.disabled
                        }, null, 40, _hoisted_46),
                        createBaseVNode(
                          "span",
                          {
                            class: normalizeClass(["result-filter__value", { "primary-color": value.active }])
                          },
                          [
                            createBaseVNode("span", {
                              class: "inline-block",
                              innerHTML: value.name
                            }, null, 8, _hoisted_55),
                            createBaseVNode(
                              "span",
                              _hoisted_62,
                              "(" + toDisplayString(value.count) + ")",
                              1
                              /* TEXT */
                            )
                          ],
                          2
                          /* CLASS */
                        )
                      ], 10, _hoisted_37)
                    ]);
                  }),
                  128
                  /* KEYED_FRAGMENT */
                ))
              ])
            ],
            2
            /* CLASS */
          );
        }),
        128
        /* KEYED_FRAGMENT */
      )),
      createVNode(_component_CollectionSort, {
        onSortBy: _ctx.handleSortBy,
        sorted: _ctx.sorted
      }, null, 8, ["onSortBy", "sorted"])
    ]);
  }
  var __default__8, _hoisted_113, _hoisted_212, _hoisted_37, _hoisted_46, _hoisted_55, _hoisted_62, collection_filter_default;
  var init_collection_filter = __esm({
    "src/vue/components/render/collection-filter.vue"() {
      "use strict";
      init_vue_esm_bundler();
      init_collection_filter_heading();
      init_collection_sort();
      init_vue_esm_bundler();
      __default__8 = {
        components: { FilterHeading: collection_filter_heading_default, CollectionSort: collection_sort_default },
        props: {
          filters: {
            type: Object,
            required: true
          },
          sorted: {
            type: String,
            required: true
          }
        },
        emits: ["click", "sort"],
        setup(props, { emit: emit2 }) {
          const { filters } = toRefs(props);
          const filtersData = computed2(() => {
            return filters.value.filter((filter5) => filter5.name !== "Sub Category");
          });
          const handleClick = (key, value) => {
            emit2("click", key, value);
          };
          const handleSortBy = (event) => {
            console.log(event.target.value);
            emit2("sort", event);
          };
          return {
            filtersData,
            handleClick,
            handleSortBy
          };
        }
      };
      _hoisted_113 = { class: "collecction-sidebar__filter" };
      _hoisted_212 = { class: "sidebar-filters__group list-reset" };
      _hoisted_37 = ["for"];
      _hoisted_46 = ["data-label", "onChange", "id", "name", "value", "checked", "disabled"];
      _hoisted_55 = ["innerHTML"];
      _hoisted_62 = { class: "ml-1 result-filter__count" };
      __default__8.render = render9;
      collection_filter_default = __default__8;
    }
  });

  // src/vue/components/render/collection-mobile-filter.vue
  var collection_mobile_filter_exports = {};
  __export(collection_mobile_filter_exports, {
    default: () => collection_mobile_filter_default,
    render: () => render10
  });
  function render10(_ctx, _cache) {
    return openBlock(true), createElementBlock(
      Fragment,
      null,
      renderList(_ctx.filters, (filter5, index) => {
        return openBlock(), createElementBlock("details", {
          key: index,
          tabindex: "1"
        }, [
          createBaseVNode("summary", null, [
            createBaseVNode(
              "span",
              null,
              toDisplayString(filter5.name),
              1
              /* TEXT */
            ),
            _cache[0] || (_cache[0] = createBaseVNode(
              "svg",
              {
                width: "8",
                height: "4",
                viewBox: "0 0 8 4",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              },
              [
                createBaseVNode("path", {
                  d: "M4 4L0.535899 0.249999L7.4641 0.25L4 4Z",
                  fill: "black"
                })
              ],
              -1
              /* CACHED */
            ))
          ]),
          createBaseVNode("ul", _hoisted_114, [
            (openBlock(true), createElementBlock(
              Fragment,
              null,
              renderList(filter5.values, (value, key) => {
                return openBlock(), createElementBlock("li", {
                  class: "result-filter",
                  key
                }, [
                  createBaseVNode("label", {
                    class: normalizeClass(["result-filter__link", { disabled: value.disabled }]),
                    for: `Filter-${filter5.filter_param_name}-${key}-no-js`
                  }, [
                    createBaseVNode("input", {
                      "data-label": value.name,
                      onChange: ($event) => _ctx.handleClick(value.param_name, value.value),
                      class: "result-filter__checkbox",
                      type: "checkbox",
                      id: `Filter-${filter5.filter_param_name}-${key}-no-js`,
                      name: value.param_name,
                      value: value.value,
                      checked: value.active,
                      disabled: value.disabled
                    }, null, 40, _hoisted_38),
                    createBaseVNode(
                      "span",
                      {
                        class: normalizeClass(["result-filter__value", { "primary-color": value.active }])
                      },
                      [
                        createBaseVNode("span", {
                          class: "inline-block",
                          innerHTML: value.name
                        }, null, 8, _hoisted_47),
                        createBaseVNode(
                          "span",
                          _hoisted_56,
                          " (" + toDisplayString(value.count) + ") ",
                          1
                          /* TEXT */
                        )
                      ],
                      2
                      /* CLASS */
                    )
                  ], 10, _hoisted_213)
                ]);
              }),
              128
              /* KEYED_FRAGMENT */
            ))
          ])
        ]);
      }),
      128
      /* KEYED_FRAGMENT */
    );
  }
  var __default__9, _hoisted_114, _hoisted_213, _hoisted_38, _hoisted_47, _hoisted_56, collection_mobile_filter_default;
  var init_collection_mobile_filter = __esm({
    "src/vue/components/render/collection-mobile-filter.vue"() {
      "use strict";
      init_vue_esm_bundler();
      __default__9 = {
        props: {
          filters: {
            type: Object,
            required: true
          },
          sorted: {
            type: String,
            required: true
          }
        },
        emits: ["click", "sort"],
        setup(_2, { emit: emit2 }) {
          const handleClick = (key, value) => {
            emit2("click", key, value);
          };
          const handleSortBy = (event) => {
            console.log(event.target.value);
            emit2("sort", event);
          };
          return {
            handleClick,
            handleSortBy
          };
        }
      };
      _hoisted_114 = { class: "mobile-filters__group list-reset" };
      _hoisted_213 = ["for"];
      _hoisted_38 = ["data-label", "onChange", "id", "name", "value", "checked", "disabled"];
      _hoisted_47 = ["innerHTML"];
      _hoisted_56 = { class: "ml-1 result-filter__count" };
      __default__9.render = render10;
      collection_mobile_filter_default = __default__9;
    }
  });

  // src/vue/components/render/collection-selected-filter.vue
  var collection_selected_filter_exports = {};
  __export(collection_selected_filter_exports, {
    default: () => collection_selected_filter_default,
    render: () => render11
  });
  function render11(_ctx, _cache) {
    return Object.keys(_ctx.selectedFilters).length ? (openBlock(), createElementBlock("div", _hoisted_115, [
      createBaseVNode("div", _hoisted_214, [
        createBaseVNode("ul", _hoisted_39, [
          (openBlock(true), createElementBlock(
            Fragment,
            null,
            renderList(_ctx.selectedFilters, (filter5, key) => {
              return openBlock(), createElementBlock("li", { key }, [
                createBaseVNode("div", _hoisted_48, [
                  createBaseVNode("a", {
                    class: "flex items-center justify-between gap-2 px-2 py-1 text-white",
                    rel: "nofollow",
                    href: "#",
                    onClick: withModifiers(($event) => _ctx.handleRemove(filter5, key), ["prevent"]),
                    role: "button"
                  }, [
                    createBaseVNode("span", {
                      innerHTML: key.split(":")[1]
                    }, null, 8, _hoisted_63),
                    _cache[1] || (_cache[1] = createBaseVNode(
                      "svg",
                      {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 24 24",
                        class: "w-4 h-4 fill-white product-result-controls__selected-icon svg-icon svg-icon--small svg-icon--white"
                      },
                      [
                        createBaseVNode("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" })
                      ],
                      -1
                      /* CACHED */
                    ))
                  ], 8, _hoisted_57)
                ])
              ]);
            }),
            128
            /* KEYED_FRAGMENT */
          ))
        ]),
        createBaseVNode("div", _hoisted_72, [
          createBaseVNode("a", {
            class: "px-0 py-1",
            href: "#",
            onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.handleClearAll(), ["prevent"]))
          }, [..._cache[2] || (_cache[2] = [
            createBaseVNode(
              "span",
              null,
              "Clear All",
              -1
              /* CACHED */
            )
          ])])
        ])
      ])
    ])) : createCommentVNode("v-if", true);
  }
  var __default__10, _hoisted_115, _hoisted_214, _hoisted_39, _hoisted_48, _hoisted_57, _hoisted_63, _hoisted_72, collection_selected_filter_default;
  var init_collection_selected_filter = __esm({
    "src/vue/components/render/collection-selected-filter.vue"() {
      "use strict";
      init_vue_esm_bundler();
      init_vue_esm_bundler();
      __default__10 = {
        props: {
          selected: {
            type: Object,
            required: true
          }
        },
        emits: ["remove", "clear"],
        setup(props, ctx) {
          const { selected } = toRefs(props);
          const handleClearAll = () => {
            ctx.emit("clear");
          };
          const handleRemove = (key, value) => {
            ctx.emit("remove", key, value);
          };
          return {
            selectedFilters: selected,
            handleRemove,
            handleClearAll
          };
        }
      };
      _hoisted_115 = {
        key: 0,
        class: "collections-selected-filter"
      };
      _hoisted_214 = { class: "flex items-center mb-3 gap-4 text-gray-100" };
      _hoisted_39 = { class: "flex flex-wrap" };
      _hoisted_48 = { class: "inline-block mb-2 mr-2 bg-green-100 cursor-pointer whitespace-nowrap" };
      _hoisted_57 = ["onClick"];
      _hoisted_63 = ["innerHTML"];
      _hoisted_72 = {
        class: "",
        style: { "min-width": "100px" }
      };
      __default__10.render = render11;
      collection_selected_filter_default = __default__10;
    }
  });

  // src/vue/components/render/collection-sub-category.vue
  var collection_sub_category_exports = {};
  __export(collection_sub_category_exports, {
    default: () => collection_sub_category_default,
    render: () => render12
  });
  function render12(_ctx, _cache) {
    return Object.keys(_ctx.filtersData).length ? (openBlock(), createElementBlock("ul", _hoisted_116, [
      (openBlock(true), createElementBlock(
        Fragment,
        null,
        renderList(_ctx.filtersData.values, (value, key) => {
          return openBlock(), createElementBlock("li", {
            key,
            class: ""
          }, [
            createBaseVNode("label", {
              class: normalizeClass(["result-filter__link", { disabled: value.disabled, active: value.active }]),
              for: `Filter-${_ctx.filtersData.filter_param_name}-${key}-no-js`
            }, [
              createBaseVNode("input", {
                "data-label": value.name,
                onChange: ($event) => _ctx.handleClick(value.param_name, value.value),
                class: "result-filter__checkbox",
                type: "checkbox",
                id: `Filter-${_ctx.filtersData.filter_param_name}-${key}-no-js`,
                name: value.param_name,
                value: value.value,
                checked: value.active,
                disabled: value.disabled
              }, null, 40, _hoisted_310),
              createBaseVNode("span", {
                class: normalizeClass(["result-filter__value", { "active font-normal": value.active }]),
                innerHTML: value.name
              }, null, 10, _hoisted_49)
            ], 10, _hoisted_215)
          ]);
        }),
        128
        /* KEYED_FRAGMENT */
      ))
    ])) : createCommentVNode("v-if", true);
  }
  var __default__11, _hoisted_116, _hoisted_215, _hoisted_310, _hoisted_49, collection_sub_category_default;
  var init_collection_sub_category = __esm({
    "src/vue/components/render/collection-sub-category.vue"() {
      "use strict";
      init_vue_esm_bundler();
      init_vue_esm_bundler();
      __default__11 = {
        props: {
          filters: {
            type: Object,
            required: true
          }
        },
        emits: ["click"],
        setup(props, { emit: emit2 }) {
          const { filters } = toRefs(props);
          const sub_categories_filters = ref(
            window.filtersJSON.sub_categories_filters
          );
          const filtersData = computed2(() => {
            const subCategories = filters.value.find(
              (filter5) => filter5.name === "Sub Category"
            );
            if (!subCategories) {
              return {};
            }
            const filteredValues = [];
            const whatNeededToFilter = sub_categories_filters.value.split(",");
            whatNeededToFilter.forEach((item) => {
              const name = item.trim();
              const foundByName = subCategories.values.find(
                (value) => value.name === name
              );
              if (foundByName) {
                filteredValues.push(foundByName);
              }
            });
            return { ...subCategories, values: filteredValues };
          });
          const handleClick = (key, value) => {
            console.log(key, value);
            emit2("click", key, value);
          };
          return {
            filtersData,
            handleClick
          };
        }
      };
      _hoisted_116 = {
        key: 0,
        class: "bv-tab-heading"
      };
      _hoisted_215 = ["for"];
      _hoisted_310 = ["data-label", "onChange", "id", "name", "value", "checked", "disabled"];
      _hoisted_49 = ["innerHTML"];
      __default__11.render = render12;
      collection_sub_category_default = __default__11;
    }
  });

  // src/vue/components/render/hubspot-form.vue
  var hubspot_form_exports = {};
  __export(hubspot_form_exports, {
    default: () => hubspot_form_default,
    render: () => render13
  });
  function render13(_ctx, _cache) {
    return openBlock(), createElementBlock(
      "div",
      {
        class: normalizeClass(_ctx.containerClass)
      },
      [
        createBaseVNode("div", _hoisted_117, [
          createBaseVNode("div", _hoisted_216, [
            _cache[0] || (setBlockTracking(-1, true), (_cache[0] = createBaseVNode("div", { id: "hubspotForm" })).cacheIndex = 0, setBlockTracking(1), _cache[0])
          ])
        ])
      ],
      2
      /* CLASS */
    );
  }
  var __default__12, _hoisted_117, _hoisted_216, hubspot_form_default;
  var init_hubspot_form = __esm({
    "src/vue/components/render/hubspot-form.vue"() {
      "use strict";
      init_vue_esm_bundler();
      __default__12 = {
        props: {
          id: {
            type: String,
            required: true
          },
          containerClass: {
            type: String,
            default: "container"
          }
        },
        mounted() {
          const script7 = document.createElement("script");
          script7.src = "https://js.hsforms.net/forms/v2.js";
          document.body.appendChild(script7);
          script7.addEventListener("load", () => {
            if (window.hbspt) {
              window.hbspt.forms.create({
                portalId: "275687",
                formId: this.id,
                target: "#hubspotForm"
              });
            }
          });
        }
      };
      _hoisted_117 = { class: "view content-wrapper" };
      _hoisted_216 = { class: "html-content-block" };
      __default__12.render = render13;
      hubspot_form_default = __default__12;
    }
  });

  // src/vue/components/render/hubspot-news-form.vue
  var hubspot_news_form_exports = {};
  __export(hubspot_news_form_exports, {
    default: () => hubspot_news_form_default,
    render: () => render14
  });
  function render14(_ctx, _cache) {
    return openBlock(), createElementBlock("div", _hoisted_118, [
      createBaseVNode("div", _hoisted_217, [
        _cache[0] || (setBlockTracking(-1, true), (_cache[0] = createBaseVNode("div", { id: "hubspotForm2" })).cacheIndex = 0, setBlockTracking(1), _cache[0])
      ])
    ]);
  }
  var __default__13, _hoisted_118, _hoisted_217, hubspot_news_form_default;
  var init_hubspot_news_form = __esm({
    "src/vue/components/render/hubspot-news-form.vue"() {
      "use strict";
      init_vue_esm_bundler();
      __default__13 = {
        props: {
          id: {
            type: String,
            required: true
          }
        },
        mounted() {
          const script7 = document.createElement("script");
          script7.src = "https://js.hsforms.net/forms/v2.js";
          document.body.appendChild(script7);
          script7.addEventListener("load", () => {
            if (window.hbspt) {
              window.hbspt.forms.create({
                portalId: "275687",
                formId: this.id,
                target: "#hubspotForm2"
              });
            }
          });
        }
      };
      _hoisted_118 = { class: "view content-wrapper" };
      _hoisted_217 = { class: "html-content-block" };
      __default__13.render = render14;
      hubspot_news_form_default = __default__13;
    }
  });

  // node_modules/vue-demi/lib/index.mjs
  var init_lib2 = __esm({
    "node_modules/vue-demi/lib/index.mjs"() {
      init_vue_esm_bundler();
      init_vue_esm_bundler();
    }
  });

  // node_modules/@vuelidate/core/dist/index.mjs
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = null != arguments[i2] ? arguments[i2] : {};
      i2 % 2 ? ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function unwrapObj(obj) {
    let ignoreKeys = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return Object.keys(obj).reduce((o, k) => {
      if (ignoreKeys.includes(k)) return o;
      o[k] = unref(obj[k]);
      return o;
    }, {});
  }
  function isFunction4(val) {
    return typeof val === "function";
  }
  function isProxy2(value) {
    return isReactive(value) || isReadonly(value);
  }
  function get2(obj, stringPath, def2) {
    let current = obj;
    const path = stringPath.split(".");
    for (let i2 = 0; i2 < path.length; i2++) {
      if (!current[path[i2]]) return def2;
      current = current[path[i2]];
    }
    return current;
  }
  function gatherBooleanGroupProperties(group, nestedResults, property) {
    return computed2(() => {
      return group.some((path) => {
        return get2(nestedResults, path, {
          [property]: false
        })[property];
      });
    });
  }
  function gatherArrayGroupProperties(group, nestedResults, property) {
    return computed2(() => {
      return group.reduce((all3, path) => {
        const fetchedProperty = get2(nestedResults, path, {
          [property]: false
        })[property] || [];
        return all3.concat(fetchedProperty);
      }, []);
    });
  }
  function callRule(rule, value, siblingState, instance) {
    return rule.call(instance, unref(value), unref(siblingState), instance);
  }
  function normalizeValidatorResponse(result) {
    return result.$valid !== void 0 ? !result.$valid : !result;
  }
  function createAsyncResult(rule, model, $pending, $dirty, _ref, $response, instance) {
    let {
      $lazy,
      $rewardEarly
    } = _ref;
    let watchTargets = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : [];
    let siblingState = arguments.length > 8 ? arguments[8] : void 0;
    let $lastInvalidState = arguments.length > 9 ? arguments[9] : void 0;
    let $lastCommittedOn = arguments.length > 10 ? arguments[10] : void 0;
    const $invalid = ref(!!$dirty.value);
    const $pendingCounter = ref(0);
    $pending.value = false;
    const $unwatch = watch2([model, $dirty].concat(watchTargets, $lastCommittedOn), () => {
      if ($lazy && !$dirty.value || $rewardEarly && !$lastInvalidState.value && !$pending.value) {
        return;
      }
      let ruleResult;
      try {
        ruleResult = callRule(rule, model, siblingState, instance);
      } catch (err) {
        ruleResult = Promise.reject(err);
      }
      $pendingCounter.value++;
      $pending.value = !!$pendingCounter.value;
      $invalid.value = false;
      Promise.resolve(ruleResult).then((data) => {
        $pendingCounter.value--;
        $pending.value = !!$pendingCounter.value;
        $response.value = data;
        $invalid.value = normalizeValidatorResponse(data);
      }).catch((error) => {
        $pendingCounter.value--;
        $pending.value = !!$pendingCounter.value;
        $response.value = error;
        $invalid.value = true;
      });
    }, {
      immediate: true,
      deep: typeof model === "object"
    });
    return {
      $invalid,
      $unwatch
    };
  }
  function createSyncResult(rule, model, $dirty, _ref2, $response, instance, siblingState, $lastInvalidState) {
    let {
      $lazy,
      $rewardEarly
    } = _ref2;
    const $unwatch = () => ({});
    const $invalid = computed2(() => {
      if ($lazy && !$dirty.value || $rewardEarly && !$lastInvalidState.value) {
        return false;
      }
      let returnValue = true;
      try {
        const result = callRule(rule, model, siblingState, instance);
        $response.value = result;
        returnValue = normalizeValidatorResponse(result);
      } catch (err) {
        $response.value = err;
      }
      return returnValue;
    });
    return {
      $unwatch,
      $invalid
    };
  }
  function createValidatorResult(rule, model, $dirty, config, instance, validatorName, propertyKey, propertyPath, siblingState, $lastInvalidState, $lastCommittedOn) {
    const $pending = ref(false);
    const $params = rule.$params || {};
    const $response = ref(null);
    let $invalid;
    let $unwatch;
    if (rule.$async) {
      ({
        $invalid,
        $unwatch
      } = createAsyncResult(rule.$validator, model, $pending, $dirty, config, $response, instance, rule.$watchTargets, siblingState, $lastInvalidState, $lastCommittedOn));
    } else {
      ({
        $invalid,
        $unwatch
      } = createSyncResult(rule.$validator, model, $dirty, config, $response, instance, siblingState, $lastInvalidState));
    }
    const message = rule.$message;
    const $message = isFunction4(message) ? computed2(() => message(unwrapObj({
      $pending,
      $invalid,
      $params: unwrapObj($params),
      $model: model,
      $response,
      $validator: validatorName,
      $propertyPath: propertyPath,
      $property: propertyKey
    }))) : message || "";
    return {
      $message,
      $params,
      $pending,
      $invalid,
      $response,
      $unwatch
    };
  }
  function sortValidations() {
    let validationsRaw = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const validations = unref(validationsRaw);
    const validationKeys = Object.keys(validations);
    const rules = {};
    const nestedValidators = {};
    const config = {};
    let validationGroups = null;
    validationKeys.forEach((key) => {
      const v = validations[key];
      switch (true) {
        case isFunction4(v.$validator):
          rules[key] = v;
          break;
        case isFunction4(v):
          rules[key] = {
            $validator: v
          };
          break;
        case key === "$validationGroups":
          validationGroups = v;
          break;
        case key.startsWith("$"):
          config[key] = v;
          break;
        default:
          nestedValidators[key] = v;
      }
    });
    return {
      rules,
      nestedValidators,
      config,
      validationGroups
    };
  }
  function createValidationResults(rules, model, key, resultsCache, path, config, instance, externalResults, siblingState) {
    const ruleKeys = Object.keys(rules);
    const cachedResult = resultsCache.get(path, rules);
    const $dirty = ref(false);
    const $lastInvalidState = ref(false);
    const $lastCommittedOn = ref(0);
    if (cachedResult) {
      if (!cachedResult.$partial) return cachedResult;
      cachedResult.$unwatch();
      $dirty.value = cachedResult.$dirty.value;
    }
    const result = {
      $dirty,
      $path: path,
      $touch: () => {
        if (!$dirty.value) $dirty.value = true;
      },
      $reset: () => {
        if ($dirty.value) $dirty.value = false;
      },
      $commit: () => {
      }
    };
    if (!ruleKeys.length) {
      cachedResult && resultsCache.set(path, rules, result);
      return result;
    }
    ruleKeys.forEach((ruleKey) => {
      result[ruleKey] = createValidatorResult(rules[ruleKey], model, result.$dirty, config, instance, ruleKey, key, path, siblingState, $lastInvalidState, $lastCommittedOn);
    });
    result.$externalResults = computed2(() => {
      if (!externalResults.value) return [];
      return [].concat(externalResults.value).map((stringError, index) => ({
        $propertyPath: path,
        $property: key,
        $validator: "$externalResults",
        $uid: `${path}-externalResult-${index}`,
        $message: stringError,
        $params: {},
        $response: null,
        $pending: false
      }));
    });
    result.$invalid = computed2(() => {
      const r = ruleKeys.some((ruleKey) => unref(result[ruleKey].$invalid));
      $lastInvalidState.value = r;
      return !!result.$externalResults.value.length || r;
    });
    result.$pending = computed2(() => ruleKeys.some((ruleKey) => unref(result[ruleKey].$pending)));
    result.$error = computed2(() => result.$dirty.value ? result.$pending.value || result.$invalid.value : false);
    result.$silentErrors = computed2(() => ruleKeys.filter((ruleKey) => unref(result[ruleKey].$invalid)).map((ruleKey) => {
      const res = result[ruleKey];
      return reactive({
        $propertyPath: path,
        $property: key,
        $validator: ruleKey,
        $uid: `${path}-${ruleKey}`,
        $message: res.$message,
        $params: res.$params,
        $response: res.$response,
        $pending: res.$pending
      });
    }).concat(result.$externalResults.value));
    result.$errors = computed2(() => result.$dirty.value ? result.$silentErrors.value : []);
    result.$unwatch = () => ruleKeys.forEach((ruleKey) => {
      result[ruleKey].$unwatch();
    });
    result.$commit = () => {
      $lastInvalidState.value = true;
      $lastCommittedOn.value = Date.now();
    };
    resultsCache.set(path, rules, result);
    return result;
  }
  function collectNestedValidationResults(validations, nestedState, path, resultsCache, config, instance, nestedExternalResults) {
    const nestedValidationKeys = Object.keys(validations);
    if (!nestedValidationKeys.length) return {};
    return nestedValidationKeys.reduce((results, nestedKey) => {
      results[nestedKey] = setValidations({
        validations: validations[nestedKey],
        state: nestedState,
        key: nestedKey,
        parentKey: path,
        resultsCache,
        globalConfig: config,
        instance,
        externalResults: nestedExternalResults
      });
      return results;
    }, {});
  }
  function createMetaFields(results, nestedResults, childResults) {
    const allResults = computed2(() => [nestedResults, childResults].filter((res) => res).reduce((allRes, res) => {
      return allRes.concat(Object.values(unref(res)));
    }, []));
    const $dirty = computed2({
      get() {
        return results.$dirty.value || (allResults.value.length ? allResults.value.every((r) => r.$dirty) : false);
      },
      set(v) {
        results.$dirty.value = v;
      }
    });
    const $silentErrors = computed2(() => {
      const modelErrors = unref(results.$silentErrors) || [];
      const nestedErrors = allResults.value.filter((result) => (unref(result).$silentErrors || []).length).reduce((errors, result) => {
        return errors.concat(...result.$silentErrors);
      }, []);
      return modelErrors.concat(nestedErrors);
    });
    const $errors = computed2(() => {
      const modelErrors = unref(results.$errors) || [];
      const nestedErrors = allResults.value.filter((result) => (unref(result).$errors || []).length).reduce((errors, result) => {
        return errors.concat(...result.$errors);
      }, []);
      return modelErrors.concat(nestedErrors);
    });
    const $invalid = computed2(() => allResults.value.some((r) => r.$invalid) || unref(results.$invalid) || false);
    const $pending = computed2(() => allResults.value.some((r) => unref(r.$pending)) || unref(results.$pending) || false);
    const $anyDirty = computed2(() => allResults.value.some((r) => r.$dirty) || allResults.value.some((r) => r.$anyDirty) || $dirty.value);
    const $error = computed2(() => $dirty.value ? $pending.value || $invalid.value : false);
    const $touch = () => {
      results.$touch();
      allResults.value.forEach((result) => {
        result.$touch();
      });
    };
    const $commit = () => {
      results.$commit();
      allResults.value.forEach((result) => {
        result.$commit();
      });
    };
    const $reset = () => {
      results.$reset();
      allResults.value.forEach((result) => {
        result.$reset();
      });
    };
    if (allResults.value.length && allResults.value.every((nr) => nr.$dirty)) $touch();
    return {
      $dirty,
      $errors,
      $invalid,
      $anyDirty,
      $error,
      $pending,
      $touch,
      $reset,
      $silentErrors,
      $commit
    };
  }
  function setValidations(_ref) {
    let {
      validations,
      state: state4,
      key,
      parentKey,
      childResults,
      resultsCache,
      globalConfig = {},
      instance,
      externalResults
    } = _ref;
    const path = parentKey ? `${parentKey}.${key}` : key;
    const {
      rules,
      nestedValidators,
      config,
      validationGroups
    } = sortValidations(validations);
    const mergedConfig = _objectSpread2(_objectSpread2({}, globalConfig), config);
    const nestedState = key ? computed2(() => {
      const s = unref(state4);
      return s ? unref(s[key]) : void 0;
    }) : state4;
    const cachedExternalResults = _objectSpread2({}, unref(externalResults) || {});
    const nestedExternalResults = computed2(() => {
      const results2 = unref(externalResults);
      if (!key) return results2;
      return results2 ? unref(results2[key]) : void 0;
    });
    const results = createValidationResults(rules, nestedState, key, resultsCache, path, mergedConfig, instance, nestedExternalResults, state4);
    const nestedResults = collectNestedValidationResults(nestedValidators, nestedState, path, resultsCache, mergedConfig, instance, nestedExternalResults);
    const $validationGroups = {};
    if (validationGroups) {
      Object.entries(validationGroups).forEach((_ref2) => {
        let [key2, group] = _ref2;
        $validationGroups[key2] = {
          $invalid: gatherBooleanGroupProperties(group, nestedResults, "$invalid"),
          $error: gatherBooleanGroupProperties(group, nestedResults, "$error"),
          $pending: gatherBooleanGroupProperties(group, nestedResults, "$pending"),
          $errors: gatherArrayGroupProperties(group, nestedResults, "$errors"),
          $silentErrors: gatherArrayGroupProperties(group, nestedResults, "$silentErrors")
        };
      });
    }
    const {
      $dirty,
      $errors,
      $invalid,
      $anyDirty,
      $error,
      $pending,
      $touch,
      $reset,
      $silentErrors,
      $commit
    } = createMetaFields(results, nestedResults, childResults);
    const $model = key ? computed2({
      get: () => unref(nestedState),
      set: (val) => {
        $dirty.value = true;
        const s = unref(state4);
        const external = unref(externalResults);
        if (external) {
          external[key] = cachedExternalResults[key];
        }
        if (isRef2(s[key])) {
          s[key].value = val;
        } else {
          s[key] = val;
        }
      }
    }) : null;
    if (key && mergedConfig.$autoDirty) {
      watch2(nestedState, () => {
        if (!$dirty.value) $touch();
        const external = unref(externalResults);
        if (external) {
          external[key] = cachedExternalResults[key];
        }
      }, {
        flush: "sync"
      });
    }
    async function $validate() {
      $touch();
      if (mergedConfig.$rewardEarly) {
        $commit();
        await nextTick();
      }
      await nextTick();
      return new Promise((resolve2) => {
        if (!$pending.value) return resolve2(!$invalid.value);
        const unwatch = watch2($pending, () => {
          resolve2(!$invalid.value);
          unwatch();
        });
      });
    }
    function $getResultsForChild(key2) {
      return (childResults.value || {})[key2];
    }
    function $clearExternalResults() {
      if (isRef2(externalResults)) {
        externalResults.value = cachedExternalResults;
      } else {
        if (Object.keys(cachedExternalResults).length === 0) {
          Object.keys(externalResults).forEach((k) => {
            delete externalResults[k];
          });
        } else {
          Object.assign(externalResults, cachedExternalResults);
        }
      }
    }
    return reactive(_objectSpread2(_objectSpread2(_objectSpread2({}, results), {}, {
      $model,
      $dirty,
      $error,
      $errors,
      $invalid,
      $anyDirty,
      $pending,
      $touch,
      $reset,
      $path: path || ROOT_PATH,
      $silentErrors,
      $validate,
      $commit
    }, childResults && {
      $getResultsForChild,
      $clearExternalResults,
      $validationGroups
    }), nestedResults));
  }
  function nestedValidations(_ref) {
    let {
      $scope,
      instance
    } = _ref;
    const childResultsRaw = {};
    const childResultsKeys = ref([]);
    const childResults = computed2(() => childResultsKeys.value.reduce((results, key) => {
      results[key] = unref(childResultsRaw[key]);
      return results;
    }, {}));
    function injectChildResultsIntoParent(results, _ref2) {
      let {
        $registerAs: key,
        $scope: childScope,
        $stopPropagation
      } = _ref2;
      if ($stopPropagation || $scope === CollectFlag.COLLECT_NONE || childScope === CollectFlag.COLLECT_NONE || $scope !== CollectFlag.COLLECT_ALL && $scope !== childScope) return;
      childResultsRaw[key] = results;
      childResultsKeys.value.push(key);
    }
    instance.__vuelidateInjectInstances = [].concat(instance.__vuelidateInjectInstances || [], injectChildResultsIntoParent);
    function removeChildResultsFromParent(key) {
      childResultsKeys.value = childResultsKeys.value.filter((childKey) => childKey !== key);
      delete childResultsRaw[key];
    }
    instance.__vuelidateRemoveInstances = [].concat(instance.__vuelidateRemoveInstances || [], removeChildResultsFromParent);
    const sendValidationResultsToParent = inject(VuelidateInjectChildResults, []);
    provide(VuelidateInjectChildResults, instance.__vuelidateInjectInstances);
    const removeValidationResultsFromParent = inject(VuelidateRemoveChildResults, []);
    provide(VuelidateRemoveChildResults, instance.__vuelidateRemoveInstances);
    return {
      childResults,
      sendValidationResultsToParent,
      removeValidationResultsFromParent
    };
  }
  function ComputedProxyFactory(target) {
    return new Proxy(target, {
      get(target2, prop) {
        return typeof target2[prop] === "object" ? ComputedProxyFactory(target2[prop]) : computed2(() => target2[prop]);
      }
    });
  }
  function useVuelidate(validations, state4) {
    var _getCurrentInstance;
    let globalConfig = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (arguments.length === 1) {
      globalConfig = validations;
      validations = void 0;
      state4 = void 0;
    }
    let {
      $registerAs,
      $scope = CollectFlag.COLLECT_ALL,
      $stopPropagation,
      $externalResults,
      currentVueInstance
    } = globalConfig;
    const instance = currentVueInstance || ((_getCurrentInstance = getCurrentInstance()) === null || _getCurrentInstance === void 0 ? void 0 : _getCurrentInstance.proxy);
    const componentOptions = instance ? instance.$options : {};
    if (!$registerAs) {
      uid2 += 1;
      $registerAs = `_vuelidate_${uid2}`;
    }
    const validationResults = ref({});
    const resultsCache = new ResultsStorage();
    const {
      childResults,
      sendValidationResultsToParent,
      removeValidationResultsFromParent
    } = instance ? nestedValidations({
      $scope,
      instance
    }) : {
      childResults: ref({})
    };
    if (!validations && componentOptions.validations) {
      const rules = componentOptions.validations;
      state4 = ref({});
      onBeforeMount(() => {
        state4.value = instance;
        watch2(() => isFunction4(rules) ? rules.call(state4.value, new ComputedProxyFactory(state4.value)) : rules, (validations2) => {
          validationResults.value = setValidations({
            validations: validations2,
            state: state4,
            childResults,
            resultsCache,
            globalConfig,
            instance,
            externalResults: $externalResults || instance.vuelidateExternalResults
          });
        }, {
          immediate: true
        });
      });
      globalConfig = componentOptions.validationsConfig || globalConfig;
    } else {
      const validationsWatchTarget = isRef2(validations) || isProxy2(validations) ? validations : reactive(validations || {});
      watch2(validationsWatchTarget, (newValidationRules) => {
        validationResults.value = setValidations({
          validations: newValidationRules,
          state: state4,
          childResults,
          resultsCache,
          globalConfig,
          instance: instance !== null && instance !== void 0 ? instance : {},
          externalResults: $externalResults
        });
      }, {
        immediate: true
      });
    }
    if (instance) {
      sendValidationResultsToParent.forEach((f) => f(validationResults, {
        $registerAs,
        $scope,
        $stopPropagation
      }));
      onBeforeUnmount(() => removeValidationResultsFromParent.forEach((f) => f($registerAs)));
    }
    return computed2(() => {
      return _objectSpread2(_objectSpread2({}, unref(validationResults.value)), childResults.value);
    });
  }
  var ROOT_PATH, ResultsStorage, CollectFlag, VuelidateInjectChildResults, VuelidateRemoveChildResults, uid2;
  var init_dist = __esm({
    "node_modules/@vuelidate/core/dist/index.mjs"() {
      init_lib2();
      ROOT_PATH = "__root";
      ResultsStorage = class {
        constructor() {
          this.storage = /* @__PURE__ */ new Map();
        }
        set(path, rules, result) {
          this.storage.set(path, {
            rules,
            result
          });
        }
        checkRulesValidity(path, rules, storedRules) {
          const storedRulesKeys = Object.keys(storedRules);
          const newRulesKeys = Object.keys(rules);
          if (newRulesKeys.length !== storedRulesKeys.length) return false;
          const hasAllValidators = newRulesKeys.every((ruleKey) => storedRulesKeys.includes(ruleKey));
          if (!hasAllValidators) return false;
          return newRulesKeys.every((ruleKey) => {
            if (!rules[ruleKey].$params) return true;
            return Object.keys(rules[ruleKey].$params).every((paramKey) => {
              return unref(storedRules[ruleKey].$params[paramKey]) === unref(rules[ruleKey].$params[paramKey]);
            });
          });
        }
        get(path, rules) {
          const storedRuleResultPair = this.storage.get(path);
          if (!storedRuleResultPair) return void 0;
          const {
            rules: storedRules,
            result
          } = storedRuleResultPair;
          const isValidCache = this.checkRulesValidity(path, rules, storedRules);
          const $unwatch = result.$unwatch ? result.$unwatch : () => ({});
          if (!isValidCache) return {
            $dirty: result.$dirty,
            $partial: true,
            $unwatch
          };
          return result;
        }
      };
      CollectFlag = {
        COLLECT_ALL: true,
        COLLECT_NONE: false
      };
      VuelidateInjectChildResults = /* @__PURE__ */ Symbol("vuelidate#injectChildResults");
      VuelidateRemoveChildResults = /* @__PURE__ */ Symbol("vuelidate#removeChildResults");
      uid2 = 0;
    }
  });

  // node_modules/@vuelidate/validators/dist/index.mjs
  function regex() {
    for (var _len = arguments.length, expr = new Array(_len), _key = 0; _key < _len; _key++) {
      expr[_key] = arguments[_key];
    }
    return (value) => {
      value = unref(value);
      return !req2(value) || expr.every((reg) => {
        reg.lastIndex = 0;
        return reg.test(value);
      });
    };
  }
  function required$1(value) {
    if (typeof value === "string") {
      value = value.trim();
    }
    return req2(value);
  }
  var req2, alpha$1, alphaNum$1, numeric$1, emailRegex, email$1, email, required, urlRegex, url$1, integer$1, decimal$1;
  var init_dist2 = __esm({
    "node_modules/@vuelidate/validators/dist/index.mjs"() {
      init_lib2();
      req2 = (value) => {
        value = unref(value);
        if (Array.isArray(value)) return !!value.length;
        if (value === void 0 || value === null) {
          return false;
        }
        if (value === false) {
          return true;
        }
        if (value instanceof Date) {
          return !isNaN(value.getTime());
        }
        if (typeof value === "object") {
          for (let _2 in value) return true;
          return false;
        }
        return !!String(value).length;
      };
      alpha$1 = regex(/^[a-zA-Z]*$/);
      alphaNum$1 = regex(/^[a-zA-Z0-9]*$/);
      numeric$1 = regex(/^\d*(\.\d+)?$/);
      emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
      email$1 = regex(emailRegex);
      email = {
        $validator: email$1,
        $message: "Value is not a valid email address",
        $params: {
          type: "email"
        }
      };
      required = {
        $validator: required$1,
        $message: "Value is required",
        $params: {
          type: "required"
        }
      };
      urlRegex = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
      url$1 = regex(urlRegex);
      integer$1 = regex(/(^[0-9]*$)|(^-[0-9]+$)/);
      decimal$1 = regex(/^[-]?\d*(\.\d+)?$/);
    }
  });

  // vue-style:C:\fork\Baudville\src\vue\components\shared\page-input.vue
  var init_page_input = __esm({
    "vue-style:C:\\fork\\Baudville\\src\\vue\\components\\shared\\page-input.vue"() {
    }
  });

  // src/vue/components/shared/page-input.vue
  var page_input_exports = {};
  __export(page_input_exports, {
    default: () => page_input_default,
    render: () => render15
  });
  function render15(_ctx, _cache) {
    return openBlock(), createElementBlock("div", _hoisted_119, [
      createBaseVNode("label", {
        class: "block pb-2 font-bold font-sm",
        for: _ctx.name
      }, [
        createBaseVNode("span", {
          class: "property__text",
          innerHTML: _ctx.title
        }, null, 8, _hoisted_311),
        _ctx.required ? (openBlock(), createElementBlock("span", _hoisted_410, "*")) : createCommentVNode("v-if", true)
      ], 8, _hoisted_218),
      _ctx.legend ? (openBlock(), createElementBlock(
        "legend",
        _hoisted_58,
        toDisplayString(_ctx.legend),
        1
        /* TEXT */
      )) : createCommentVNode("v-if", true),
      createBaseVNode("div", _hoisted_64, [
        (openBlock(), createBlock(resolveDynamicComponent(_ctx.input), {
          id: _ctx.name,
          type: _ctx.type,
          name: _ctx.name,
          class: normalizeClass(["outline-none text-box full", _ctx.error && "!border-red-100"]),
          autocapitalize: "off",
          maxlength: "100",
          value: _ctx.modelValue,
          onInput: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("update:modelValue", $event.target.value)),
          onBlur: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("blur"))
        }, null, 40, ["id", "type", "name", "class", "value"]))
      ]),
      _ctx.error ? (openBlock(), createElementBlock("div", _hoisted_73, " Please complete this required field. ")) : createCommentVNode("v-if", true)
    ]);
  }
  var __default__14, _hoisted_119, _hoisted_218, _hoisted_311, _hoisted_410, _hoisted_58, _hoisted_64, _hoisted_73, page_input_default;
  var init_page_input2 = __esm({
    "src/vue/components/shared/page-input.vue"() {
      "use strict";
      init_vue_esm_bundler();
      init_page_input();
      __default__14 = {
        props: {
          name: {
            type: String,
            required: true
          },
          title: {
            type: String,
            required: true
          },
          type: {
            type: String,
            default: "text"
          },
          input: {
            type: String,
            default: "input"
          },
          required: {
            type: Boolean,
            default: false
          },
          modelValue: {
            type: String,
            default: ""
          },
          error: {
            type: String,
            default: null
          },
          legend: {
            type: String,
            default: null
          }
        },
        emits: ["update:modelValue", "blur"]
      };
      _hoisted_119 = { class: "mb-7" };
      _hoisted_218 = ["for"];
      _hoisted_311 = ["innerHTML"];
      _hoisted_410 = {
        key: 0,
        class: "text-red-100 hs-form-required"
      };
      _hoisted_58 = {
        key: 0,
        class: "block hs-field-desc"
      };
      _hoisted_64 = { class: "block m-0" };
      _hoisted_73 = {
        key: 1,
        class: "mt-1 font-bold text-red-200"
      };
      __default__14.render = render15;
      __default__14.__scopeId = "data-v-8a7f9fe1";
      page_input_default = __default__14;
    }
  });

  // vue-style:C:\fork\Baudville\src\vue\components\shared\page-select.vue
  var init_page_select = __esm({
    "vue-style:C:\\fork\\Baudville\\src\\vue\\components\\shared\\page-select.vue"() {
    }
  });

  // src/vue/components/shared/page-select.vue
  var page_select_exports = {};
  __export(page_select_exports, {
    default: () => page_select_default,
    render: () => render16
  });
  function render16(_ctx, _cache) {
    return openBlock(), createElementBlock("div", _hoisted_120, [
      createBaseVNode("label", {
        class: "block pb-2 font-bold font-sm",
        for: _ctx.name
      }, [
        createBaseVNode(
          "span",
          _hoisted_312,
          toDisplayString(_ctx.title),
          1
          /* TEXT */
        ),
        _ctx.required ? (openBlock(), createElementBlock("span", _hoisted_411, "*")) : createCommentVNode("v-if", true)
      ], 8, _hoisted_219),
      _ctx.legend ? (openBlock(), createElementBlock(
        "legend",
        _hoisted_59,
        toDisplayString(_ctx.legend),
        1
        /* TEXT */
      )) : createCommentVNode("v-if", true),
      createBaseVNode("div", _hoisted_65, [
        createBaseVNode("select", {
          id: _ctx.name,
          name: _ctx.name,
          class: normalizeClass(["outline-none text-box full", _ctx.error && "!border-red-100"]),
          required: "required",
          title: "Tax exemption address State",
          "aria-label": "Tax exemption address Country",
          "aria-invalid": "true",
          onInput: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("update:modelValue", $event.target.value)),
          onBlur: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("blur"))
        }, [..._cache[2] || (_cache[2] = [
          createStaticVNode('<option value="" data-v-4d4592d6> Select State </option><optgroup label="United States of America" data-v-4d4592d6><option value="AL" data-v-4d4592d6> Alabama </option><option value="AK" data-v-4d4592d6> Alaska </option><option value="AS" data-v-4d4592d6> American Samoa </option><option value="AZ" data-v-4d4592d6> Arizona </option><option value="AR" data-v-4d4592d6> Arkansas </option><option value="AA" data-v-4d4592d6> Armed Forces Americas </option><option value="AE" data-v-4d4592d6> Armed Forces Europe </option><option value="AP" data-v-4d4592d6> Armed Forces Pacific </option><option value="CA" data-v-4d4592d6> California </option><option value="CO" data-v-4d4592d6> Colorado </option><option value="CT" data-v-4d4592d6> Connecticut </option><option value="DE" data-v-4d4592d6> Delaware </option><option value="FL" data-v-4d4592d6> Florida </option><option value="GA" data-v-4d4592d6> Georgia </option><option value="GU" data-v-4d4592d6> Guam </option><option value="HI" data-v-4d4592d6> Hawaii </option><option value="ID" data-v-4d4592d6> Idaho </option><option value="IL" data-v-4d4592d6> Illinois </option><option value="IN" data-v-4d4592d6> Indiana </option><option value="IA" data-v-4d4592d6> Iowa </option><option value="KS" data-v-4d4592d6> Kansas </option><option value="KY" data-v-4d4592d6> Kentucky </option><option value="LA" data-v-4d4592d6> Louisiana </option><option value="ME" data-v-4d4592d6> Maine </option><option value="MD" data-v-4d4592d6> Maryland </option><option value="MA" data-v-4d4592d6> Massachusetts </option><option value="MI" data-v-4d4592d6> Michigan </option><option value="MN" data-v-4d4592d6> Minnesota </option><option value="MS" data-v-4d4592d6> Mississippi </option><option value="MO" data-v-4d4592d6> Missouri </option><option value="MT" data-v-4d4592d6> Montana </option><option value="NE" data-v-4d4592d6> Nebraska </option><option value="NV" data-v-4d4592d6> Nevada </option><option value="NH" data-v-4d4592d6> New Hampshire </option><option value="NJ" data-v-4d4592d6> New Jersey </option><option value="NM" data-v-4d4592d6> New Mexico </option><option value="NY" data-v-4d4592d6> New York </option><option value="NC" data-v-4d4592d6> North Carolina </option><option value="ND" data-v-4d4592d6> North Dakota </option><option value="MP" data-v-4d4592d6> Northern Mariana Islands </option><option value="OH" data-v-4d4592d6> Ohio </option><option value="OK" data-v-4d4592d6> Oklahoma </option><option value="OR" data-v-4d4592d6> Oregon </option><option value="PA" data-v-4d4592d6> Pennsylvania </option><option value="PR" data-v-4d4592d6> Puerto Rico </option><option value="RI" data-v-4d4592d6> Rhode Island </option><option value="SC" data-v-4d4592d6> South Carolina </option><option value="SD" data-v-4d4592d6> South Dakota </option><option value="TN" data-v-4d4592d6> Tennessee </option><option value="TX" data-v-4d4592d6> Texas </option><option value="UM" data-v-4d4592d6> U.S. Outlying Islands </option><option value="VI" data-v-4d4592d6> U.S. Virgin Islands </option><option value="UT" data-v-4d4592d6> Utah </option><option value="VT" data-v-4d4592d6> Vermont </option><option value="VA" data-v-4d4592d6> Virginia </option><option value="WA" data-v-4d4592d6> Washington </option><option value="DC" data-v-4d4592d6> Washington DC </option><option value="WV" data-v-4d4592d6> West Virginia </option><option value="WI" data-v-4d4592d6> Wisconsin </option><option value="WY" data-v-4d4592d6> Wyoming </option></optgroup><optgroup label="Canada" data-v-4d4592d6><option value="AB" data-v-4d4592d6> Alberta </option><option value="BC" data-v-4d4592d6> British Columbia </option><option value="MB" data-v-4d4592d6> Manitoba </option><option value="NB" data-v-4d4592d6> New Brunswick </option><option value="NL" data-v-4d4592d6> Newfoundland and Labrador </option><option value="NT" data-v-4d4592d6> Northwest Territories </option><option value="NS" data-v-4d4592d6> Nova Scotia </option><option value="NU" data-v-4d4592d6> Nunavut </option><option value="ON" data-v-4d4592d6> Ontario </option><option value="PE" data-v-4d4592d6> Prince Edward Island </option><option value="QC" data-v-4d4592d6> Quebec </option><option value="SK" data-v-4d4592d6> Saskatchewan </option><option value="YT" data-v-4d4592d6> Yukon </option></optgroup>', 3)
        ])], 42, _hoisted_74)
      ]),
      _ctx.error ? (openBlock(), createElementBlock("div", _hoisted_82, " Please complete this required field. ")) : createCommentVNode("v-if", true)
    ]);
  }
  var __default__15, _hoisted_120, _hoisted_219, _hoisted_312, _hoisted_411, _hoisted_59, _hoisted_65, _hoisted_74, _hoisted_82, page_select_default;
  var init_page_select2 = __esm({
    "src/vue/components/shared/page-select.vue"() {
      "use strict";
      init_vue_esm_bundler();
      init_page_select();
      __default__15 = {
        props: {
          name: {
            type: String,
            required: true
          },
          title: {
            type: String,
            required: true
          },
          required: {
            type: Boolean,
            default: false
          },
          modelValue: {
            type: String,
            default: ""
          },
          error: {
            type: String,
            default: null
          },
          legend: {
            type: String,
            default: null
          }
        },
        emits: ["update:modelValue", "blur"]
      };
      _hoisted_120 = { class: "mb-7" };
      _hoisted_219 = ["for"];
      _hoisted_312 = { class: "property__text" };
      _hoisted_411 = {
        key: 0,
        class: "text-red-100 hs-form-required"
      };
      _hoisted_59 = {
        key: 0,
        class: "block hs-field-desc"
      };
      _hoisted_65 = { class: "block m-0" };
      _hoisted_74 = ["id", "name"];
      _hoisted_82 = {
        key: 1,
        class: "mt-1 font-bold text-red-200"
      };
      __default__15.render = render16;
      __default__15.__scopeId = "data-v-4d4592d6";
      page_select_default = __default__15;
    }
  });

  // src/vue/components/render/page-tax.vue
  var page_tax_exports = {};
  __export(page_tax_exports, {
    default: () => page_tax_default,
    render: () => render17
  });
  function render17(_ctx, _cache) {
    const _component_PageInput = resolveComponent("PageInput");
    const _component_PageSelect = resolveComponent("PageSelect");
    return openBlock(), createElementBlock(
      Fragment,
      null,
      [
        _cache[25] || (_cache[25] = createStaticVNode('<div class="content-wrapper"><div class="content-block content-block--text"><div class="text-content-block"><h1 class="text-5xl">Sales and Use Tax Exemption Certification</h1><p class="my-6 text-base font-medium"> *We are currently having issues with our tax-exempt form at checkout. If you have tax exempt status, please contact us directly at 1-800-728-0888 to finalize your order. We apologize for the inconvenience. </p><p class="my-6 text-base font-medium"> The purchaser hereby claims exemption on the purchase of tangible personal property and selected services made under this certificate from Baudville.com. and certifies that this claim is based upon the purchaser&#39;s proposed use of the items or services, or the status of the purchaser. </p></div></div><div class="py-2 mb-6 mr-0 box"><p class="mb-4 text-base font-bold font-mont"> Section 1: Items covered by this certification </p><div class="checkout-tax-exemption__items-description"> This certificate covers ALL ITEMS purchased in conjunction with this online order. </div></div></div>', 1)),
        createBaseVNode("div", _hoisted_121, [
          createBaseVNode(
            "form",
            {
              method: "post",
              action: "https://jot.baudville.com//api/tax-exemption",
              onSubmit: _cache[19] || (_cache[19] = withModifiers((...args) => _ctx.submitForm && _ctx.submitForm(...args), ["prevent"]))
            },
            [
              createBaseVNode("div", _hoisted_220, [
                _cache[20] || (_cache[20] = createBaseVNode(
                  "p",
                  { class: "mb-4 text-base font-bold font-mont" },
                  " Section 2: Basis for Exemption Claim ",
                  -1
                  /* CACHED */
                )),
                _ctx.v$.exemption?.$errors[0]?.$message ? (openBlock(), createElementBlock("div", _hoisted_313, " Please complete this required field. ")) : createCommentVNode("v-if", true),
                createBaseVNode("div", _hoisted_412, [
                  (openBlock(true), createElementBlock(
                    Fragment,
                    null,
                    renderList(_ctx.state.exemption_claim, (claim, key) => {
                      return openBlock(), createElementBlock("div", { key }, [
                        createBaseVNode("div", _hoisted_510, [
                          withDirectives(createBaseVNode("input", {
                            id: claim.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.state.exemption = $event),
                            type: "radio",
                            name: claim.value,
                            value: claim.value,
                            class: "w-4 h-4 text-blue-600 bg-gray-100 border-gray-200 rounded-full outline-none focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
                          }, null, 8, _hoisted_66), [
                            [vModelRadio, _ctx.state.exemption]
                          ]),
                          createBaseVNode("label", {
                            for: claim.value,
                            class: "ml-2 font-noraml"
                          }, toDisplayString(claim.label), 9, _hoisted_75)
                        ]),
                        claim.value === "other" && _ctx.state.exemption === "other" ? (openBlock(), createElementBlock("div", _hoisted_83, [
                          withDirectives(createBaseVNode(
                            "textarea",
                            {
                              id: "cliam_other",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.state.exemption_other = $event),
                              name: "cliam_other",
                              class: "w-8/12 h-16 mt-4 border rounded"
                            },
                            null,
                            512
                            /* NEED_PATCH */
                          ), [
                            [vModelText, _ctx.state.exemption_other]
                          ])
                        ])) : createCommentVNode("v-if", true)
                      ]);
                    }),
                    128
                    /* KEYED_FRAGMENT */
                  ))
                ])
              ]),
              createBaseVNode("div", _hoisted_92, [
                _cache[22] || (_cache[22] = createBaseVNode(
                  "p",
                  { class: "mb-4 text-base font-bold font-mont" },
                  " Section 3: Certification ",
                  -1
                  /* CACHED */
                )),
                _cache[23] || (_cache[23] = createBaseVNode(
                  "div",
                  { class: "checkout-tax-exemption__items-description" },
                  " I declare, under penalty of perjury, that the information on this certificate is true, that I have consulted the statutes, administrative rules and other sources of law applicable to my exemption, and that I have exercised reasonable care in assuring that my claim of exemption is valid under applicable laws. In the event this claim is disallowed, I accept full responsibility for the payment of tax, penalty and any accrued interest, including, if necessary, reimbursement to the vendor for tax and accrued interest. ",
                  -1
                  /* CACHED */
                )),
                createBaseVNode("div", _hoisted_102, [
                  createBaseVNode("div", _hoisted_1110, [
                    withDirectives(createBaseVNode(
                      "input",
                      {
                        id: "default-checkbox",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.state.agree = $event),
                        type: "checkbox",
                        name: "yes_i_would_like_to_receive_updates_and_offers_from_baudville_",
                        class: "w-4 h-4 text-blue-600 bg-gray-100 border-gray-200 rounded outline-none focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600",
                        onBlur: _cache[3] || (_cache[3] = ($event) => {
                          _ctx.v$.agree.$touch();
                          _ctx.v$.agree.$validate();
                        })
                      },
                      null,
                      544
                      /* NEED_HYDRATION, NEED_PATCH */
                    ), [
                      [vModelCheckbox, _ctx.state.agree]
                    ]),
                    _cache[21] || (_cache[21] = createBaseVNode(
                      "label",
                      {
                        for: "default-checkbox",
                        class: "ml-2 font-noraml"
                      },
                      " I agree with the statement above.",
                      -1
                      /* CACHED */
                    ))
                  ]),
                  _ctx.v$.agree?.$errors[0]?.$message || !_ctx.state.agree ? (openBlock(), createElementBlock("div", _hoisted_123, " Please complete this required field. ")) : createCommentVNode("v-if", true)
                ])
              ]),
              createVNode(_component_PageInput, {
                modelValue: _ctx.state.email,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => _ctx.state.email = $event),
                name: "email",
                title: "Email",
                type: "email",
                required: true,
                error: _ctx.v$.email?.$errors[0]?.$message,
                onBlur: _cache[5] || (_cache[5] = ($event) => _ctx.v$.email.$touch())
              }, null, 8, ["modelValue", "error"]),
              createBaseVNode("div", _hoisted_133, [
                createVNode(_component_PageInput, {
                  modelValue: _ctx.state.business_name,
                  "onUpdate:modelValue": [
                    _cache[6] || (_cache[6] = ($event) => _ctx.state.business_name = $event),
                    _cache[7] || (_cache[7] = ($event) => _ctx.state.business_name = $event)
                  ],
                  name: "businessname",
                  title: "Business Name",
                  required: true,
                  error: _ctx.v$.business_name?.$errors[0]?.$message,
                  onBlur: _cache[8] || (_cache[8] = ($event) => {
                    _ctx.v$.business_name.$touch();
                    _ctx.v$.business_name.$validate();
                  })
                }, null, 8, ["modelValue", "error"]),
                createVNode(_component_PageInput, {
                  modelValue: _ctx.state.street_address,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => _ctx.state.street_address = $event),
                  name: "streetaddress",
                  title: "Street Address",
                  required: true,
                  error: _ctx.v$.street_address?.$errors[0]?.$message,
                  onBlur: _cache[10] || (_cache[10] = ($event) => _ctx.v$.street_address.$touch())
                }, null, 8, ["modelValue", "error"])
              ]),
              createBaseVNode("div", _hoisted_143, [
                createVNode(_component_PageInput, {
                  modelValue: _ctx.state.city,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => _ctx.state.city = $event),
                  name: "city",
                  title: "City",
                  required: true,
                  error: _ctx.v$.city?.$errors[0]?.$message,
                  onBlur: _cache[12] || (_cache[12] = ($event) => _ctx.v$.city.$touch())
                }, null, 8, ["modelValue", "error"]),
                createVNode(_component_PageSelect, {
                  modelValue: _ctx.state.state,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => _ctx.state.state = $event),
                  name: "state",
                  title: "State/Region",
                  required: true,
                  error: _ctx.v$.state?.$errors[0]?.$message,
                  onBlur: _cache[14] || (_cache[14] = ($event) => _ctx.v$.state.$touch())
                }, null, 8, ["modelValue", "error"])
              ]),
              createBaseVNode("div", _hoisted_152, [
                createVNode(_component_PageInput, {
                  modelValue: _ctx.state.zip_code,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => _ctx.state.zip_code = $event),
                  name: "zip_code",
                  title: "Zip Code",
                  required: true,
                  error: _ctx.v$.zip_code?.$errors[0]?.$message,
                  onBlur: _cache[16] || (_cache[16] = ($event) => _ctx.v$.zip_code.$touch())
                }, null, 8, ["modelValue", "error"]),
                createVNode(_component_PageInput, {
                  modelValue: _ctx.state.federal_tax_id,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => _ctx.state.federal_tax_id = $event),
                  name: "federal_tax_id",
                  title: "Federal Tax ID",
                  required: true,
                  error: _ctx.v$.federal_tax_id?.$errors[0]?.$message,
                  onBlur: _cache[18] || (_cache[18] = ($event) => _ctx.v$.federal_tax_id.$touch())
                }, null, 8, ["modelValue", "error"])
              ]),
              createBaseVNode("div", _hoisted_162, [
                _cache[24] || (_cache[24] = createBaseVNode(
                  "button",
                  {
                    type: "submit",
                    class: "button button--red"
                  },
                  " APPLY TAX EXEMPTION ",
                  -1
                  /* CACHED */
                )),
                _ctx.error ? (openBlock(), createElementBlock(
                  "div",
                  _hoisted_172,
                  toDisplayString(_ctx.error),
                  1
                  /* TEXT */
                )) : createCommentVNode("v-if", true)
              ])
            ],
            32
            /* NEED_HYDRATION */
          )
        ])
      ],
      64
      /* STABLE_FRAGMENT */
    );
  }
  var __default__16, _hoisted_121, _hoisted_220, _hoisted_313, _hoisted_412, _hoisted_510, _hoisted_66, _hoisted_75, _hoisted_83, _hoisted_92, _hoisted_102, _hoisted_1110, _hoisted_123, _hoisted_133, _hoisted_143, _hoisted_152, _hoisted_162, _hoisted_172, page_tax_default;
  var init_page_tax = __esm({
    "src/vue/components/render/page-tax.vue"() {
      "use strict";
      init_dist();
      init_dist2();
      init_vue_esm_bundler();
      init_page_input2();
      init_axios2();
      init_page_select2();
      init_vue_esm_bundler();
      __default__16 = {
        components: { PageInput: page_input_default, PageSelect: page_select_default },
        emits: ["blur"],
        setup() {
          const state4 = reactive({
            business_name: "",
            street_address: "",
            city: "",
            state: "",
            zip_code: "",
            federal_tax_id: "",
            email: "",
            type: "",
            agree: true,
            exemption_claim: [
              {
                value: "agricultural",
                label: "Agricultural Production"
              },
              {
                value: "nonprofit",
                label: "Church, Government Entity, Nonprofit School, or Nonprofit Hospital"
              },
              {
                value: "industrial",
                label: "Industrial Processing"
              },
              {
                value: "retail",
                label: "For Resale at Retail"
              },
              {
                value: "wholesale",
                label: "For Sale at Wholesale"
              },
              {
                value: "fiveO1c",
                label: "Nonprofit Internal Revenue Code Section 501(c)(3) or 501(c)(4) Exempt Organization"
              },
              {
                value: "qualified_data_center",
                label: "Qualified Data Center"
              },
              {
                value: "other",
                label: "Other"
              }
            ],
            exemption: "",
            exemption_other: "",
            country: "US"
          });
          const error = ref();
          const rules = computed2(() => {
            return {
              email: { required, email },
              business_name: { required },
              street_address: { required },
              city: { required },
              state: { required },
              zip_code: { required },
              federal_tax_id: { required },
              agree: { checked: true },
              exemption: { required },
              country: { required }
            };
          });
          const v$ = useVuelidate(rules, state4);
          const submitForm = async () => {
            v$.value.$touch();
            if (v$.value.$error) {
              return;
            }
            state4["type"] = state4.exemption === "other" && state4.exemption_other ? state4.exemption_other : state4.exemption;
            const candaState = [
              "AB",
              "BC",
              "MB",
              "NB",
              "NL",
              "NT",
              "NS",
              "NU",
              "ON",
              "PE",
              "QC",
              "SK",
              "YT"
            ];
            state4["country"] = candaState.includes(state4.state) ? "CA" : "US";
            const requestData = Object.entries(state4).filter(
              ([key]) => !["exemption_claim", "exemption", "exemption_other"].includes(key)
            ).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
            try {
              const res = await axios_default.post(
                "https://jot.baudville.com/api/tax-exemption",
                JSON.stringify(requestData),
                { headers: { "Content-Type": "application/json" } }
              );
              error.value = null;
              if (window.location.pathname === "/cart") {
                window.jQuery("[data-remodal-id=tax-modal]")?.remodal()?.close();
                window.jQuery("#tax-message").fadeIn().html(res?.data?.message);
                window.jQuery("#register-for-tax").fadeOut();
                history.pushState(null, null, " ");
              } else {
                window.location = "/cart";
              }
            } catch (e) {
              const { errors } = e.response.data;
              error.value = e.response.data.message;
              for (const property in errors) {
                v$.value[property].$touch();
                v$.value[property].$validate();
              }
            }
          };
          return { state: state4, v$, submitForm, error };
        }
      };
      _hoisted_121 = { class: "view content-wrapper" };
      _hoisted_220 = { class: "py-2 mb-6 mr-0 box" };
      _hoisted_313 = {
        key: 0,
        class: "p-3 my-4 font-bold text-red-200 border border-red-200"
      };
      _hoisted_412 = { class: "grid gap-8 md:grid-cols-2" };
      _hoisted_510 = { class: "flex" };
      _hoisted_66 = ["id", "name", "value"];
      _hoisted_75 = ["for"];
      _hoisted_83 = { key: 0 };
      _hoisted_92 = { class: "py-2 mb-6 mr-0 box" };
      _hoisted_102 = { class: "block w-full mt-3 mb-7" };
      _hoisted_1110 = { class: "flex items-center" };
      _hoisted_123 = {
        key: 0,
        class: "mt-1 font-bold text-red-200"
      };
      _hoisted_133 = { class: "grid gap-8 md:grid-cols-2" };
      _hoisted_143 = { class: "grid gap-8 md:grid-cols-2" };
      _hoisted_152 = { class: "grid gap-8 md:grid-cols-2" };
      _hoisted_162 = { class: "flex flex-wrap items-center" };
      _hoisted_172 = {
        key: 0,
        class: "ml-2 text-red-100 text-bold"
      };
      __default__16.render = render17;
      page_tax_default = __default__16;
    }
  });

  // src/vue/components/render/main-cart.vue
  var main_cart_exports = {};
  __export(main_cart_exports, {
    default: () => main_cart_default,
    render: () => render18
  });
  function render18(_ctx, _cache) {
    const _component_ProductQty = resolveComponent("ProductQty");
    const _component_IconRemove = resolveComponent("IconRemove");
    const _component_PageTax = resolveComponent("PageTax");
    return openBlock(), createElementBlock(
      Fragment,
      null,
      [
        createBaseVNode("div", _hoisted_124, [
          createBaseVNode("div", _hoisted_221, [
            createBaseVNode("div", _hoisted_314, [
              _cache[2] || (_cache[2] = createBaseVNode(
                "h2",
                { class: "pb-1 mr-2 border-b border-b-gray-400 bv-section-heading" },
                " My Cart ",
                -1
                /* CACHED */
              )),
              createBaseVNode(
                "div",
                _hoisted_413,
                toDisplayString(_ctx.cart.item_count),
                1
                /* TEXT */
              )
            ]),
            createBaseVNode("ul", _hoisted_511, [
              (openBlock(true), createElementBlock(
                Fragment,
                null,
                renderList(_ctx.cart.items, (item, index) => {
                  return openBlock(), createElementBlock("li", {
                    "data-group_id": item.group_id,
                    key: item.key,
                    "data-index": index,
                    class: "flex flex-wrap pb-4 border-b border-b-gray-400 relative"
                  }, [
                    createBaseVNode("div", _hoisted_76, [
                      createBaseVNode("div", _hoisted_84, [
                        createBaseVNode("p", _hoisted_93, [
                          createBaseVNode("a", {
                            class: normalizeClass(["block border border-gray-700 h-0 pb-[100%]", {
                              "pointer-events-none": !_ctx.hideCrossButton(item.title)
                            }]),
                            href: item.url
                          }, [
                            createBaseVNode("img", {
                              alt: item.title,
                              class: "block",
                              src: _ctx.getImage(item.image, item.properties)
                            }, null, 8, _hoisted_1111)
                          ], 10, _hoisted_103)
                        ]),
                        createBaseVNode("div", _hoisted_125, [
                          createBaseVNode("div", _hoisted_134, [
                            createBaseVNode("p", _hoisted_144, [
                              createBaseVNode("a", {
                                href: item.url,
                                class: normalizeClass(["text-gray-100", {
                                  "pointer-events-none": !_ctx.hideCrossButton(item.title)
                                }]),
                                innerHTML: item.title
                              }, null, 10, _hoisted_153)
                            ]),
                            item.sku ? (openBlock(), createElementBlock(
                              "p",
                              _hoisted_163,
                              "# " + toDisplayString(item.sku),
                              1
                              /* TEXT */
                            )) : createCommentVNode("v-if", true),
                            item.stock_alert ? (openBlock(), createElementBlock("p", {
                              key: 1,
                              class: "item-cart font-bold",
                              innerHTML: item.stock_alert
                            }, null, 8, _hoisted_173)) : createCommentVNode("v-if", true),
                            createBaseVNode("p", _hoisted_182, [
                              _cache[3] || (_cache[3] = createBaseVNode(
                                "span",
                                { class: "item-sub" },
                                "Price:",
                                -1
                                /* CACHED */
                              )),
                              createBaseVNode(
                                "span",
                                _hoisted_192,
                                toDisplayString(_ctx.price(item.price)),
                                1
                                /* TEXT */
                              )
                            ]),
                            createBaseVNode("p", _hoisted_202, [
                              _cache[4] || (_cache[4] = createBaseVNode(
                                "span",
                                { class: "item-sub" },
                                "Quantity:",
                                -1
                                /* CACHED */
                              )),
                              createBaseVNode("span", _hoisted_2110, [
                                createVNode(_component_ProductQty, {
                                  qty: item.quantity,
                                  min: item.min,
                                  data: item.quantity_breaks,
                                  index,
                                  "item-key": item.key,
                                  multiple: item.qty_multiple,
                                  properties: item.properties,
                                  disabled: item.qty_disable,
                                  group_id: item.group_id,
                                  onUpdateQty: _ctx.updateQty
                                }, null, 8, ["qty", "min", "data", "index", "item-key", "multiple", "properties", "disabled", "group_id", "onUpdateQty"])
                              ])
                            ]),
                            createBaseVNode("div", _hoisted_223, [
                              item.line_price > item.line_subtotal_price ? (openBlock(), createElementBlock("p", _hoisted_233, [
                                _cache[5] || (_cache[5] = createBaseVNode(
                                  "span",
                                  { class: "item-sub" },
                                  "Total",
                                  -1
                                  /* CACHED */
                                )),
                                createBaseVNode(
                                  "span",
                                  _hoisted_242,
                                  toDisplayString(_ctx.price(item.line_price)),
                                  1
                                  /* TEXT */
                                )
                              ])) : (openBlock(), createElementBlock("p", _hoisted_252, [
                                _cache[6] || (_cache[6] = createBaseVNode(
                                  "span",
                                  { class: "item-sub" },
                                  "Subtotal: ",
                                  -1
                                  /* CACHED */
                                )),
                                createBaseVNode(
                                  "span",
                                  _hoisted_262,
                                  toDisplayString(_ctx.price(item.line_subtotal_price)),
                                  1
                                  /* TEXT */
                                )
                              ]))
                            ]),
                            item.properties ? (openBlock(), createElementBlock("div", _hoisted_272, [
                              (openBlock(true), createElementBlock(
                                Fragment,
                                null,
                                renderList(item.properties, (property, key) => {
                                  return openBlock(), createElementBlock("div", { key }, [
                                    property[0] === "_lineitems" ? (openBlock(), createElementBlock("div", _hoisted_282, [
                                      (openBlock(true), createElementBlock(
                                        Fragment,
                                        null,
                                        renderList(property[1], (data, dataIndex) => {
                                          return openBlock(), createElementBlock("div", {
                                            key: dataIndex,
                                            class: "product-list__customization"
                                          }, [
                                            (openBlock(true), createElementBlock(
                                              Fragment,
                                              null,
                                              renderList(data, (line, lineNumber) => {
                                                return openBlock(), createElementBlock("p", { key: lineNumber }, [
                                                  line?.line ? (openBlock(), createElementBlock("span", _hoisted_292, [
                                                    createBaseVNode("span", _hoisted_302, [
                                                      createBaseVNode(
                                                        "span",
                                                        _hoisted_315,
                                                        toDisplayString(lineNumber) + ":",
                                                        1
                                                        /* TEXT */
                                                      ),
                                                      createBaseVNode("span", {
                                                        innerHTML: line?.line
                                                      }, null, 8, _hoisted_323)
                                                    ]),
                                                    line?.sizeName ? (openBlock(), createElementBlock("span", _hoisted_333, [
                                                      createBaseVNode(
                                                        "span",
                                                        _hoisted_342,
                                                        toDisplayString(lineNumber) + " Size Name:",
                                                        1
                                                        /* TEXT */
                                                      ),
                                                      createBaseVNode("span", {
                                                        innerHTML: line?.sizeName
                                                      }, null, 8, _hoisted_352)
                                                    ])) : createCommentVNode("v-if", true)
                                                  ])) : createCommentVNode("v-if", true)
                                                ]);
                                              }),
                                              128
                                              /* KEYED_FRAGMENT */
                                            ))
                                          ]);
                                        }),
                                        128
                                        /* KEYED_FRAGMENT */
                                      ))
                                    ])) : property[0] === "Personalization Setup Fee" ? (openBlock(), createElementBlock("div", _hoisted_362, [
                                      withDirectives(createBaseVNode(
                                        "span",
                                        _hoisted_372,
                                        [
                                          createBaseVNode(
                                            "span",
                                            _hoisted_382,
                                            toDisplayString(property[0]) + ":",
                                            1
                                            /* TEXT */
                                          ),
                                          createTextVNode(
                                            " " + toDisplayString(property[1]),
                                            1
                                            /* TEXT */
                                          )
                                        ],
                                        512
                                        /* NEED_PATCH */
                                      ), [
                                        [vShow, false]
                                      ])
                                    ])) : (openBlock(), createElementBlock("p", _hoisted_392, [
                                      !/^_/.test(property[0]) ? (openBlock(), createElementBlock("span", _hoisted_40, [
                                        createBaseVNode(
                                          "span",
                                          _hoisted_41,
                                          toDisplayString(property[0]) + ":",
                                          1
                                          /* TEXT */
                                        ),
                                        createTextVNode(
                                          " " + toDisplayString(property[1]),
                                          1
                                          /* TEXT */
                                        )
                                      ])) : createCommentVNode("v-if", true)
                                    ]))
                                  ]);
                                }),
                                128
                                /* KEYED_FRAGMENT */
                              )),
                              _ctx.showEditButton(item.properties) ? (openBlock(), createElementBlock("div", _hoisted_422, [
                                createBaseVNode("a", {
                                  href: _ctx.editUrl(item),
                                  class: "link text-blue-800 border-b border-blue-800 hover:text-blue-600 hover:to-blue-600 font-medium"
                                }, "Edit", 8, _hoisted_432)
                              ])) : createCommentVNode("v-if", true)
                            ])) : createCommentVNode("v-if", true)
                          ]),
                          item.gift_bag ? (openBlock(), createElementBlock("div", _hoisted_442, [
                            createCommentVNode(" gift icon "),
                            item.gift_bag ? (openBlock(), createElementBlock(
                              "button",
                              {
                                key: 0,
                                name: "button",
                                type: "button",
                                value: "add_gift_bag",
                                class: "ml-1 text-xs product-list__gift-bag text-button text-button--secondary xl:text-sm",
                                onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.giftCart(44438490677544), ["prevent"]))
                              },
                              toDisplayString(_ctx.gift_bag),
                              1
                              /* TEXT */
                            )) : createCommentVNode("v-if", true)
                          ])) : createCommentVNode("v-if", true)
                        ])
                      ])
                    ]),
                    _ctx.hideCrossButton(item.title) ? (openBlock(), createElementBlock("div", _hoisted_452, [
                      createBaseVNode("button", {
                        name: "button",
                        type: "submit",
                        value: "remove_item",
                        class: "text-button",
                        onClick: withModifiers(($event) => _ctx.itemRemove(item.key, item._groupId, item.properties), ["prevent"])
                      }, [
                        createVNode(_component_IconRemove)
                      ], 8, _hoisted_462)
                    ])) : createCommentVNode("v-if", true),
                    createBaseVNode("div", _hoisted_472, [
                      item.gift_card ? (openBlock(), createElementBlock("div", _hoisted_482, [
                        createBaseVNode("a", {
                          class: "text-xs xl:text-sm",
                          rel: "nofollow",
                          "data-modifier": "Add a Personalized Card ($5.00)",
                          href: "/products/personalized-card",
                          onClick: _cache[1] || (_cache[1] = withModifiers(($event) => _ctx.personalizeCard(), ["prevent"]))
                        }, " Add a Personalized Card ($5.00) ")
                      ])) : createCommentVNode("v-if", true)
                    ])
                  ], 8, _hoisted_67);
                }),
                128
                /* KEYED_FRAGMENT */
              ))
            ]),
            _cache[7] || (_cache[7] = createStaticVNode('<div class="hidden mb-10 lg:flex md:items-center md:justify-between cart__checkout-action-group"><p class="mb-4 cart__checkout-action cart__checkout-action--left md:mb-0"><a class="btn-outline uppercase font-bold tracking-normal text-lg" href="/">Continue Shopping</a></p><p class="cart__checkout-action cart__checkout-action--right"><a class="font-bold btn-red-shadow button text-lg uppercase" href="/checkout"><span class="mr-1">Proceed to</span> Checkout</a></p></div>', 1))
          ]),
          createBaseVNode("div", _hoisted_492, [
            createBaseVNode("div", _hoisted_50, [
              _cache[15] || (_cache[15] = createBaseVNode(
                "p",
                { class: "mt-6 lg:mb-6 text-center lg:text-left lg:block order-5 lg:order-none" },
                [
                  createBaseVNode("a", {
                    class: "font-bold btn-red-shadow button text-lg uppercase",
                    href: "/checkout"
                  }, [
                    createBaseVNode("span", { class: "mr-1" }, "Proceed to "),
                    createTextVNode(" Checkout")
                  ])
                ],
                -1
                /* CACHED */
              )),
              createBaseVNode("div", _hoisted_51, [
                _ctx.tax === "false" || _ctx.tax === "null" ? (openBlock(), createElementBlock("div", _hoisted_522, [..._cache[8] || (_cache[8] = [
                  createBaseVNode(
                    "label",
                    {
                      id: "register-for-tax",
                      class: "block pb-1 font-normal button-property__name",
                      for: ""
                    },
                    [
                      createBaseVNode("span", { class: "text-black" }, [
                        createBaseVNode("a", {
                          class: "text-red-400",
                          href: "/pages/tax-exemption-form"
                        }, "Tax Exempt? Apply online in minutes \u2192")
                      ])
                    ],
                    -1
                    /* CACHED */
                  ),
                  createBaseVNode(
                    "div",
                    {
                      id: "tax-message",
                      class: "hidden pt-2 pb-0 font-bold text-green-50"
                    },
                    " Registered for tax exempt. ",
                    -1
                    /* CACHED */
                  )
                ])])) : createCommentVNode("v-if", true)
              ]),
              createBaseVNode("div", _hoisted_532, [
                createBaseVNode("div", _hoisted_542, [
                  _cache[14] || (_cache[14] = createBaseVNode(
                    "h2",
                    { class: "text-xl heading--no-margin" },
                    [
                      createBaseVNode("span", { class: "order-summary-table__title text-xl tracking-wider" }, "Order Summary")
                    ],
                    -1
                    /* CACHED */
                  )),
                  createBaseVNode("div", _hoisted_552, [
                    createBaseVNode("table", _hoisted_562, [
                      createBaseVNode("tbody", null, [
                        createBaseVNode("tr", null, [
                          _cache[9] || (_cache[9] = createBaseVNode(
                            "th",
                            { class: "!font-normal" },
                            "Cart Total:",
                            -1
                            /* CACHED */
                          )),
                          createBaseVNode("td", null, [
                            createBaseVNode(
                              "strong",
                              null,
                              toDisplayString(_ctx.price(_ctx.cart.original_total_price)),
                              1
                              /* TEXT */
                            )
                          ])
                        ]),
                        _cache[11] || (_cache[11] = createBaseVNode(
                          "tr",
                          null,
                          [
                            createBaseVNode("th", { class: "!font-normal" }, "Shipping:"),
                            createBaseVNode("td", null, "TBD")
                          ],
                          -1
                          /* CACHED */
                        )),
                        _cache[12] || (_cache[12] = createBaseVNode(
                          "tr",
                          null,
                          [
                            createBaseVNode("th", { class: "!font-normal" }, "Tax:"),
                            createBaseVNode("td", null, "TBD")
                          ],
                          -1
                          /* CACHED */
                        )),
                        _cache[13] || (_cache[13] = createBaseVNode(
                          "tr",
                          { class: "hidden" },
                          [
                            createBaseVNode("td", { colspan: "2" }, [
                              createBaseVNode("div", { class: "shipping-estimation" }, [
                                createBaseVNode("h2", { class: "visually-hidden" }, "Estimate Shipping"),
                                createBaseVNode("div", { class: "flex mb-4" }, [
                                  createBaseVNode("div", { class: "w-full inline-form__cell lg:w-auto" }, [
                                    createBaseVNode("div", { class: "value" }, [
                                      createBaseVNode("input", {
                                        id: "postal_code",
                                        type: "text",
                                        name: "postal_code",
                                        class: "text-box text-box--full",
                                        required: "required",
                                        autocorrect: "off",
                                        autocomplete: "postal-code",
                                        placeholder: "Postal Code",
                                        title: "Postal Code"
                                      })
                                    ])
                                  ]),
                                  createBaseVNode("p", { class: "pl-4" }, [
                                    createBaseVNode("button", {
                                      name: "button",
                                      type: "submit",
                                      value: "estimate_shipping",
                                      class: "button button--full button-secondary !font-bold text-gray-100 text-sm h-full"
                                    }, " Estimate ")
                                  ])
                                ])
                              ])
                            ])
                          ],
                          -1
                          /* CACHED */
                        )),
                        createBaseVNode("tr", _hoisted_572, [
                          _cache[10] || (_cache[10] = createBaseVNode(
                            "th",
                            null,
                            [
                              createBaseVNode("span", { class: "text-xl tracking-wider font-medium uppercase font-mont" }, "Subtotal:")
                            ],
                            -1
                            /* CACHED */
                          )),
                          createBaseVNode(
                            "td",
                            _hoisted_582,
                            toDisplayString(_ctx.price(_ctx.cart.original_total_price)),
                            1
                            /* TEXT */
                          )
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _cache[16] || (_cache[16] = createBaseVNode(
                "div",
                { class: "flex lg:hidden justify-between gap-2 items-center -order-1" },
                [
                  createBaseVNode("a", {
                    class: "continue-shop-link",
                    href: "/"
                  }, "Continue Shopping"),
                  createBaseVNode("a", {
                    class: "proceed-to-checkout-link",
                    href: "/checkout"
                  }, [
                    createBaseVNode("span", { class: "mr-1" }, "Proceed to"),
                    createTextVNode(" Checkout")
                  ])
                ],
                -1
                /* CACHED */
              ))
            ])
          ])
        ]),
        _ctx.tax === "false" || _ctx.tax === "null" ? (openBlock(), createElementBlock("div", _hoisted_592, [
          _cache[17] || (_cache[17] = createBaseVNode(
            "button",
            {
              "data-remodal-action": "close",
              class: "right-0 !left-auto remodal-close"
            },
            [
              createBaseVNode("span", { class: "sr-only hidden" }, "Close")
            ],
            -1
            /* CACHED */
          )),
          createBaseVNode("div", _hoisted_60, [
            createVNode(_component_PageTax)
          ])
        ])) : createCommentVNode("v-if", true)
      ],
      64
      /* STABLE_FRAGMENT */
    );
  }
  var import_lodash6, __default__17, _hoisted_124, _hoisted_221, _hoisted_314, _hoisted_413, _hoisted_511, _hoisted_67, _hoisted_76, _hoisted_84, _hoisted_93, _hoisted_103, _hoisted_1111, _hoisted_125, _hoisted_134, _hoisted_144, _hoisted_153, _hoisted_163, _hoisted_173, _hoisted_182, _hoisted_192, _hoisted_202, _hoisted_2110, _hoisted_223, _hoisted_233, _hoisted_242, _hoisted_252, _hoisted_262, _hoisted_272, _hoisted_282, _hoisted_292, _hoisted_302, _hoisted_315, _hoisted_323, _hoisted_333, _hoisted_342, _hoisted_352, _hoisted_362, _hoisted_372, _hoisted_382, _hoisted_392, _hoisted_40, _hoisted_41, _hoisted_422, _hoisted_432, _hoisted_442, _hoisted_452, _hoisted_462, _hoisted_472, _hoisted_482, _hoisted_492, _hoisted_50, _hoisted_51, _hoisted_522, _hoisted_532, _hoisted_542, _hoisted_552, _hoisted_562, _hoisted_572, _hoisted_582, _hoisted_592, _hoisted_60, main_cart_default;
  var init_main_cart = __esm({
    "src/vue/components/render/main-cart.vue"() {
      "use strict";
      import_lodash6 = __toESM(require_lodash());
      init_vue_esm_bundler();
      init_vuex_esm_bundler();
      init_icon_remove();
      init_cart2();
      init_product_qty();
      init_page_tax();
      init_vue_esm_bundler();
      __default__17 = {
        components: { IconRemove: icon_remove_default, ProductQty: product_qty_default, PageTax: page_tax_default },
        props: {
          tax: { type: String, default: "true" },
          gift_bag: {
            type: String,
            default: "Add a Gift Bag ($9.99 ea)"
          }
        },
        setup() {
          const store2 = useStore();
          const cart = computed2(() => store2.getters.getCart);
          const { addCart: addCart2, price, remove: remove2, update: update3, getImage } = cartHelpers();
          const updateQty = (qty, key, qb, properties, group_id) => {
            update3(qty, key, qb, properties, group_id);
          };
          const open = () => {
            window.jQuery("[data-remodal-id=tax-modal]")?.remodal()?.open();
          };
          const gift = ref(cart.value?.attributes?.giftWrapped);
          const instruction = ref(
            cart.value?.attributes?.delivery_instructions ? true : false
          );
          const message = ref(cart.value.note);
          const delivery_instructions = ref(
            cart.value?.attributes?.delivery_instructions
          );
          const updateNote = (note) => {
            window.Shopify.theme.cart.updateNote(note).then(() => {
            });
          };
          const updateDeliveryInstruction = () => {
            window.Shopify.theme.cart.updateAttributes({
              delivery_instructions: instruction.value ? delivery_instructions.value : null
            }).then(() => {
            });
          };
          const showTablePrice = (title) => {
            const name = title?.trim();
            return !name.startsWith("Personalization Setup Fee");
          };
          const hideCrossButton = (title) => {
            const name = title?.trim();
            return !(name.startsWith("Personalization Setup Fee") || name.startsWith("Per Item Fee"));
          };
          const giftCart = (id) => {
            addCart2(id, 1, { _price: 699 });
          };
          const personalizeCard = () => {
            window.theme.quickview.open("/products/personalized-card?view=quickview");
          };
          const editUrl = (item) => {
            const parsedUrl = new URL(item.properties.find(([key]) => key === "_returnToEditorUrl")[1].replaceAll("&amp;", "&"));
            parsedUrl.searchParams.set("lineItemId", item.id);
            return parsedUrl.toString();
          };
          const showEditButton = (properties) => {
            if (!properties) return false;
            const keys = properties.flat();
            return keys.includes("_returnToEditorUrl");
          };
          const itemRemove = (key, groupId, properties = null) => {
            let groupIdToRemove = groupId;
            if (properties) {
              const obj = Object.fromEntries(properties);
              groupIdToRemove = obj._groupId;
            }
            remove2(key, groupIdToRemove);
          };
          watch2(cart, () => {
            message.value = cart.value.note;
            gift.value = cart.value.attributes?.giftWrapped;
            instruction.value = cart.value?.attributes?.delivery_instructions ? true : false;
            delivery_instructions.value = cart.value?.attributes?.delivery_instructions;
          });
          watch2(gift, () => {
            console.log(gift.value);
            window.Shopify.theme.cart.updateAttributes({ giftWrapped: gift.value }).then(() => {
            });
            if (!gift.value) {
              updateNote(null);
            }
          });
          watch2(instruction, () => {
            if (!instruction.value) {
              updateDeliveryInstruction(null);
            }
          });
          watch2(
            message,
            (0, import_lodash6.debounce)(() => {
              updateNote(message.value);
            }, 250)
          );
          watch2(
            delivery_instructions,
            (0, import_lodash6.debounce)(() => {
              updateDeliveryInstruction(delivery_instructions.value);
            }, 250)
          );
          return {
            cart,
            gift,
            instruction,
            message,
            delivery_instructions,
            open,
            showTablePrice,
            hideCrossButton,
            giftCart,
            personalizeCard,
            getImage,
            price,
            updateQty,
            itemRemove,
            editUrl,
            showEditButton
          };
        }
      };
      _hoisted_124 = {
        class: "flex flex-wrap justify-between mt-8 cart",
        "data-analytics": ""
      };
      _hoisted_221 = { class: "w-full lg:w-8/12 page-content__main page-content__main--with-aside" };
      _hoisted_314 = { class: "relative cart__heading" };
      _hoisted_413 = { class: "hidden cart__heading-value" };
      _hoisted_511 = { class: "w-full mb-4" };
      _hoisted_67 = ["data-group_id", "data-index"];
      _hoisted_76 = { class: "relative w-full py-4 lg:w-8/12" };
      _hoisted_84 = { class: "flex flex-wrap w-full" };
      _hoisted_93 = { class: "w-32 pr-4 lg:w-4/12" };
      _hoisted_103 = ["href"];
      _hoisted_1111 = ["alt", "src"];
      _hoisted_125 = { class: "flex flex-col justify-between lg:w-8/12 lg:pl-2 cart-item-details" };
      _hoisted_134 = { class: "" };
      _hoisted_144 = { class: "mb-2 text-sm font-bold sm:text-base lg:text-base" };
      _hoisted_153 = ["href", "innerHTML"];
      _hoisted_163 = {
        key: 0,
        class: "text-sm mb-2"
      };
      _hoisted_173 = ["innerHTML"];
      _hoisted_182 = { class: "item-cart" };
      _hoisted_192 = { class: "item-price" };
      _hoisted_202 = { class: "item-cart" };
      _hoisted_2110 = { class: "flex flex-col items-end justify-end table__quantity" };
      _hoisted_223 = { class: "product-list__price" };
      _hoisted_233 = {
        key: 0,
        class: "item-cart"
      };
      _hoisted_242 = { class: "item-price" };
      _hoisted_252 = {
        key: 1,
        class: "item-cart"
      };
      _hoisted_262 = { class: "item-price" };
      _hoisted_272 = {
        key: 2,
        class: "item-properties"
      };
      _hoisted_282 = { key: 0 };
      _hoisted_292 = {
        key: 0,
        class: "product-list__detail-key"
      };
      _hoisted_302 = { class: "block" };
      _hoisted_315 = { class: "pr-1 capitalize" };
      _hoisted_323 = ["innerHTML"];
      _hoisted_333 = {
        key: 0,
        class: "block"
      };
      _hoisted_342 = { class: "pr-1 capitalize" };
      _hoisted_352 = ["innerHTML"];
      _hoisted_362 = { key: 1 };
      _hoisted_372 = { class: "product-list__detail-key" };
      _hoisted_382 = { class: "capitalize" };
      _hoisted_392 = {
        key: 2,
        class: "product-list__customization"
      };
      _hoisted_40 = {
        key: 0,
        class: "product-list__detail-key"
      };
      _hoisted_41 = { class: "capitalize" };
      _hoisted_422 = { key: 0 };
      _hoisted_432 = ["href"];
      _hoisted_442 = {
        key: 0,
        class: ""
      };
      _hoisted_452 = {
        key: 0,
        class: "absolute right-2 top-3 lg:top-1 z-10 product-list__remove-action"
      };
      _hoisted_462 = ["onClick"];
      _hoisted_472 = { class: "relative flex flex-col justify-between w-full py-4 lg:pr-6 lg:w-1/3 product-list__item-cell" };
      _hoisted_482 = {
        key: 0,
        class: "quickview-button"
      };
      _hoisted_492 = { class: "w-full lg:w-4/12 page-content__aside" };
      _hoisted_50 = { class: "flex flex-col lg:pl-5 lg:ml-4 cart__order-summary" };
      _hoisted_51 = { class: "flex flex-wrap justify-center lg:justify-start items-center lg:my-4" };
      _hoisted_522 = {
        key: 0,
        class: "block w-full my-3 text-center lg:text-left"
      };
      _hoisted_532 = { class: "order-summary-content" };
      _hoisted_542 = { class: "pt-6 check-summary" };
      _hoisted_552 = { class: "mt-2 border-t border-t-gray-400 order-summary-table__table" };
      _hoisted_562 = { class: "table m-0 text-sm table--totals" };
      _hoisted_572 = { class: "table__total" };
      _hoisted_582 = { class: "text-xl tracking-wider font-bold" };
      _hoisted_592 = {
        key: 0,
        class: "remodal message-view",
        "data-remodal-id": "tax-modal",
        "data-remodal-options": "hashTracking: true, closeOnOutsideClick: true"
      };
      _hoisted_60 = {
        id: "",
        class: "text-left"
      };
      __default__17.render = render18;
      main_cart_default = __default__17;
    }
  });

  // src/vue/components/render/page-catalog.vue
  var page_catalog_exports = {};
  __export(page_catalog_exports, {
    default: () => page_catalog_default,
    render: () => render19
  });
  function render19(_ctx, _cache) {
    const _component_PageInput = resolveComponent("PageInput");
    return openBlock(), createElementBlock("div", _hoisted_126, [
      _cache[27] || (_cache[27] = createStaticVNode('<div class="content-wrapper"><div class="content-block content-block--text"><div class="text-content-block"><h3 class="text-5xl">Catalog Request Form</h3><p class="my-4 text-base font-medium"> Thank you for your interest in Baudville products. Complete this simple form and we&#39;ll get one right out to you. </p></div></div></div>', 1)),
      createBaseVNode("div", _hoisted_224, [
        createBaseVNode(
          "form",
          {
            method: "post",
            action: "https://jot.baudville.com//api/catalog_requests",
            onSubmit: _cache[24] || (_cache[24] = withModifiers((...args) => _ctx.submitForm && _ctx.submitForm(...args), ["prevent"]))
          },
          [
            createBaseVNode("div", _hoisted_316, [
              createVNode(_component_PageInput, {
                modelValue: _ctx.state.first_name,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event) => _ctx.state.first_name = $event),
                  _cache[1] || (_cache[1] = ($event) => _ctx.state.first_name = $event)
                ],
                name: "firstname",
                title: "First name",
                required: true,
                error: _ctx.v$.first_name?.$errors[0]?.$message,
                onBlur: _cache[2] || (_cache[2] = ($event) => {
                  _ctx.v$.first_name.$touch();
                  _ctx.v$.first_name.$validate();
                })
              }, null, 8, ["modelValue", "error"]),
              createVNode(_component_PageInput, {
                modelValue: _ctx.state.last_name,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.state.last_name = $event),
                name: "lastname",
                title: "Last name",
                required: true,
                error: _ctx.v$.last_name?.$errors[0]?.$message,
                onBlur: _cache[4] || (_cache[4] = ($event) => _ctx.v$.last_name.$touch())
              }, null, 8, ["modelValue", "error"])
            ]),
            createVNode(_component_PageInput, {
              modelValue: _ctx.state.job_title,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => _ctx.state.job_title = $event),
              required: true,
              name: "jobtitle",
              title: "Job title",
              error: _ctx.v$.job_title?.$errors[0]?.$message,
              onBlur: _cache[6] || (_cache[6] = ($event) => _ctx.v$.job_title.$touch())
            }, null, 8, ["modelValue", "error"]),
            createVNode(_component_PageInput, {
              modelValue: _ctx.state.company_name,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => _ctx.state.company_name = $event),
              name: "company",
              title: "Company name",
              required: true,
              error: _ctx.v$.company_name?.$errors[0]?.$message,
              onBlur: _cache[8] || (_cache[8] = ($event) => _ctx.v$.company_name.$touch())
            }, null, 8, ["modelValue", "error"]),
            createVNode(_component_PageInput, {
              modelValue: _ctx.state.street_address,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => _ctx.state.street_address = $event),
              name: "address",
              title: "Street address",
              required: true,
              error: _ctx.v$.street_address?.$errors[0]?.$message,
              onBlur: _cache[10] || (_cache[10] = ($event) => _ctx.v$.street_address.$touch())
            }, null, 8, ["modelValue", "error"]),
            createVNode(_component_PageInput, {
              modelValue: _ctx.state.street_address2,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => _ctx.state.street_address2 = $event),
              name: "address_2",
              title: "Street address 2"
            }, null, 8, ["modelValue"]),
            createBaseVNode("div", _hoisted_414, [
              createVNode(_component_PageInput, {
                modelValue: _ctx.state.city,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => _ctx.state.city = $event),
                name: "city",
                title: "City",
                required: true,
                error: _ctx.v$.city?.$errors[0]?.$message,
                onBlur: _cache[13] || (_cache[13] = ($event) => _ctx.v$.city.$touch())
              }, null, 8, ["modelValue", "error"]),
              createVNode(_component_PageInput, {
                modelValue: _ctx.state.state,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => _ctx.state.state = $event),
                name: "state",
                title: "State/Region",
                required: true,
                error: _ctx.v$.state?.$errors[0]?.$message,
                onBlur: _cache[15] || (_cache[15] = ($event) => _ctx.v$.state.$touch())
              }, null, 8, ["modelValue", "error"])
            ]),
            createBaseVNode("div", _hoisted_512, [
              createVNode(_component_PageInput, {
                modelValue: _ctx.state.postal_code,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => _ctx.state.postal_code = $event),
                name: "zip",
                title: "Postal Code",
                required: true,
                error: _ctx.v$.postal_code?.$errors[0]?.$message,
                onBlur: _cache[17] || (_cache[17] = ($event) => _ctx.v$.postal_code.$touch())
              }, null, 8, ["modelValue", "error"]),
              createVNode(_component_PageInput, {
                modelValue: _ctx.state.country,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => _ctx.state.country = $event),
                name: "country",
                title: "Country",
                required: true,
                error: _ctx.v$.country?.$errors[0]?.$message,
                onBlur: _cache[19] || (_cache[19] = ($event) => _ctx.v$.country.$touch())
              }, null, 8, ["modelValue", "error"])
            ]),
            createBaseVNode("div", _hoisted_68, [
              createVNode(_component_PageInput, {
                modelValue: _ctx.state.email,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => _ctx.state.email = $event),
                name: "email",
                title: "Email",
                type: "email"
              }, null, 8, ["modelValue"]),
              createVNode(_component_PageInput, {
                modelValue: _ctx.state.phone,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => _ctx.state.phone = $event),
                name: "phone",
                title: "Phone number"
              }, null, 8, ["modelValue"])
            ]),
            createBaseVNode("div", _hoisted_77, [
              withDirectives(createBaseVNode(
                "input",
                {
                  id: "default-checkbox",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => _ctx.state.updates = $event),
                  type: "checkbox",
                  name: "yes_i_would_like_to_receive_updates_and_offers_from_baudville_",
                  class: "w-4 h-4 text-blue-600 bg-gray-100 border-gray-200 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                },
                null,
                512
                /* NEED_PATCH */
              ), [
                [vModelCheckbox, _ctx.state.updates]
              ]),
              _cache[25] || (_cache[25] = createBaseVNode(
                "label",
                {
                  for: "default-checkbox",
                  class: "ml-2 font-bold"
                },
                "Yes, I would like to receive updates and offers from Baudville! (You may unsubscribe later if you change your mind.)",
                -1
                /* CACHED */
              ))
            ]),
            createVNode(_component_PageInput, {
              modelValue: _ctx.state.offers,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => _ctx.state.offers = $event),
              name: "yes_i_would_like_to_receive_information_and_special_offers_from_baudville_via_email_",
              title: "yes, i would like to receive information and special offers from baudville via email."
            }, null, 8, ["modelValue"]),
            _cache[26] || (_cache[26] = createBaseVNode(
              "button",
              {
                type: "submit",
                class: "button button--red"
              },
              "Submit",
              -1
              /* CACHED */
            ))
          ],
          32
          /* NEED_HYDRATION */
        )
      ])
    ]);
  }
  var __default__18, _hoisted_126, _hoisted_224, _hoisted_316, _hoisted_414, _hoisted_512, _hoisted_68, _hoisted_77, page_catalog_default;
  var init_page_catalog = __esm({
    "src/vue/components/render/page-catalog.vue"() {
      "use strict";
      init_dist();
      init_dist2();
      init_vue_esm_bundler();
      init_page_input2();
      init_axios2();
      init_vue_esm_bundler();
      __default__18 = {
        components: { PageInput: page_input_default },
        emits: ["blur"],
        setup() {
          const state4 = reactive({
            first_name: "",
            last_name: "",
            job_title: "",
            company_name: "",
            street_address: "",
            street_address2: "",
            city: "",
            state: "",
            postal_code: "",
            country: "",
            email: "",
            phone: "",
            updates: false,
            offers: ""
          });
          const rules = computed2(() => {
            return {
              first_name: { required },
              last_name: { required },
              job_title: { required },
              company_name: { required },
              street_address: { required },
              city: { required },
              state: { required },
              postal_code: { required },
              country: { required },
              email: { email },
              phone: { required }
            };
          });
          const v$ = useVuelidate(rules, state4);
          const submitForm = () => {
            v$.value.$touch();
            if (v$.value.$error) {
              console.log("error");
              return;
            }
            axios_default.post("https://jot.baudville.com//api/catalog_requests", state4).then((res) => {
              console.log(res);
              window.location = "/pages/thank-you";
            }).catch((error) => {
              console.log(error);
              if (error.response.status === 422) {
                const { errors } = error.response.data;
                for (const property in errors) {
                  v$.value[property].$touch();
                  v$.value[property].$validate();
                }
              }
            });
          };
          return { state: state4, v$, submitForm };
        }
      };
      _hoisted_126 = { class: "container" };
      _hoisted_224 = { class: "view content-wrapper" };
      _hoisted_316 = { class: "grid gap-8 md:grid-cols-2" };
      _hoisted_414 = { class: "grid gap-8 md:grid-cols-2" };
      _hoisted_512 = { class: "grid gap-8 md:grid-cols-2" };
      _hoisted_68 = { class: "grid gap-8 md:grid-cols-2" };
      _hoisted_77 = { class: "flex items-center mb-7" };
      __default__18.render = render19;
      page_catalog_default = __default__18;
    }
  });

  // src/vue/components/render/page-epraise-card.vue
  var page_epraise_card_exports = {};
  __export(page_epraise_card_exports, {
    default: () => page_epraise_card_default,
    render: () => render20
  });
  function render20(_ctx, _cache) {
    return _ctx.mainImage ? (openBlock(), createElementBlock("div", _hoisted_127, [
      createBaseVNode("div", _hoisted_225, [
        _cache[2] || (_cache[2] = createBaseVNode(
          "h1",
          { class: "py-5 text-3xl text-gray-100 uppercase md:text-5xl" },
          "Epraise",
          -1
          /* CACHED */
        )),
        _ctx.mainImage ? (openBlock(), createElementBlock("a", {
          key: 0,
          href: "/pages/epraise",
          onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.replay(), ["prevent"]))
        }, [
          createBaseVNode("img", {
            src: _ctx.mainImage,
            alt: ""
          }, null, 8, _hoisted_317)
        ])) : createCommentVNode("v-if", true)
      ]),
      createBaseVNode("div", null, [
        createBaseVNode(
          "h3",
          _hoisted_415,
          "From: " + toDisplayString(_ctx.data.sender_name),
          1
          /* TEXT */
        ),
        createBaseVNode("button", {
          type: "button",
          class: "!text-xl button button--min-width button--red font-mont uppercase",
          onClick: _cache[1] || (_cache[1] = ($event) => _ctx.replay())
        }, " Reply To Sender ")
      ])
    ])) : createCommentVNode("v-if", true);
  }
  var __default__19, _hoisted_127, _hoisted_225, _hoisted_317, _hoisted_415, page_epraise_card_default;
  var init_page_epraise_card = __esm({
    "src/vue/components/render/page-epraise-card.vue"() {
      "use strict";
      init_vue_esm_bundler();
      __default__19 = {
        emits: ["showThankyou"],
        data() {
          return {
            data: [],
            mainImage: null
          };
        },
        mounted() {
          const url = new URL(window.location.href);
          const searchParams = new URLSearchParams(url.search);
          const id = searchParams.get("id");
          if (!id) {
            this.notfound();
          }
          this.home(id);
        },
        methods: {
          notfound() {
            window.location = "/404";
          },
          home(id) {
            fetch(`https://jot.baudville.com/api/epraise/${id}`).then((response) => response.json()).then((data) => {
              this.data = data;
              this.mainImage = `https://s7d7.scene7.com/is/image/Baudville/EPRAISE_${data.card.type}_TEMP?layer=0&src=EPRAISE_${data.card.template}&layer=1&$line1=${encodeURI(
                data.personalizations?.$line1?.trim()
              )}&$red=${data.personalizations?.$red}&$green=${data.personalizations?.$green}&$blue=${data.personalizations?.$blue}&$line1fs=48&$fn=${encodeURI(
                data.personalizations?.$fn
              )}&op_sharpen=1`;
            }).catch((error) => {
              this.notfound();
              console.error(error);
            });
          },
          replay() {
            window.location = `/pages/epraise?card=${this.data.card.id}&email=${this.data.sender_email}`;
          }
        }
      };
      _hoisted_127 = {
        key: 0,
        class: "container mx-auto top-position"
      };
      _hoisted_225 = { class: "mb-5" };
      _hoisted_317 = ["src"];
      _hoisted_415 = { class: "my-5 text-3xl uppercase" };
      __default__19.render = render20;
      page_epraise_card_default = __default__19;
    }
  });

  // vue-style:C:\fork\Baudville\src\vue\components\shared\epraise-card.vue
  var init_epraise_card = __esm({
    "vue-style:C:\\fork\\Baudville\\src\\vue\\components\\shared\\epraise-card.vue"() {
    }
  });

  // src/vue/components/shared/epraise-card.vue
  var epraise_card_exports = {};
  __export(epraise_card_exports, {
    default: () => epraise_card_default,
    render: () => render21
  });
  function render21(_ctx, _cache) {
    const _component_PageInput = resolveComponent("PageInput");
    return openBlock(), createElementBlock("div", _hoisted_128, [
      createBaseVNode("div", _hoisted_226, [
        createBaseVNode("img", {
          src: _ctx.state.scene7Image,
          alt: ""
        }, null, 8, _hoisted_318)
      ]),
      createBaseVNode("div", _hoisted_416, [
        _cache[32] || (_cache[32] = createBaseVNode(
          "h2",
          { class: "mb-6 text-3xl font-bold uppercase" },
          " Personalize your ePraise card ",
          -1
          /* CACHED */
        )),
        createBaseVNode(
          "form",
          {
            action: "POST",
            onSubmit: _cache[20] || (_cache[20] = withModifiers((...args) => _ctx.submitForm && _ctx.submitForm(...args), ["prevent"]))
          },
          [
            createBaseVNode("div", _hoisted_513, [
              createBaseVNode("div", _hoisted_69, [
                _cache[22] || (_cache[22] = createBaseVNode(
                  "label",
                  {
                    class: "bv-epraise-label",
                    for: "font_color"
                  },
                  "Font Color",
                  -1
                  /* CACHED */
                )),
                withDirectives(createBaseVNode(
                  "select",
                  {
                    id: "font_color",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.state.font_color = $event),
                    class: "bv-epraise-input",
                    onChange: _cache[1] || (_cache[1] = (...args) => _ctx.regenerateScene7Image && _ctx.regenerateScene7Image(...args))
                  },
                  [..._cache[21] || (_cache[21] = [
                    createStaticVNode('<option value="#008080"> Teal </option><option value="#5FC6DD"> Baudville Blue </option><option value="#0000FF"> Blue </option><option value="#000080"> Dark Blue </option><option value="#FF00FF"> Pink </option><option value="#FF0000"> Red </option><option value="#F9555E"> Baudville Red </option><option value="#800000"> Dark Red </option><option value="#60BFAD"> Baudville Green </option><option value="#008000"> Green </option><option value="#800080"> Violet </option><option value="#EAD766"> Baudville Yellow </option><option value="#808000"> Dark Yellow </option><option value="#6C7275"> Baudville Gray </option><option value="#C0C0C0"> Light Gray </option><option value="#000000"> Black </option>', 16)
                  ])],
                  544
                  /* NEED_HYDRATION, NEED_PATCH */
                ), [
                  [vModelSelect, _ctx.state.font_color]
                ])
              ]),
              createBaseVNode("div", _hoisted_78, [
                _cache[24] || (_cache[24] = createBaseVNode(
                  "label",
                  {
                    class: "bv-epraise-label",
                    for: "font"
                  },
                  "Font",
                  -1
                  /* CACHED */
                )),
                withDirectives(createBaseVNode(
                  "select",
                  {
                    id: "font",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.state.font = $event),
                    class: "bv-epraise-input",
                    onChange: _cache[3] || (_cache[3] = (...args) => _ctx.regenerateScene7Image && _ctx.regenerateScene7Image(...args))
                  },
                  [..._cache[23] || (_cache[23] = [
                    createStaticVNode('<option value="Arial"> Arial </option><option value="AvantGarde LT Book"> Avant Garde </option><option value="Bank Gothic AS"> Bank Gothic </option><option value="Comic Sans MS"> Comic Sans </option><option value="DIN Engschrift Std"> DIN Engschrift </option><option value="FuturaTMed"> Futura </option><option value="HelveticaNeue LT 45 Light"> Helvetica </option><option value="LarissaLight"> Larissa Script </option><option value="Marking Pen"> Marking Pen </option><option value="MyriadPro-Regular"> Myriad Pro </option><option value="Neville Script"> Neville Script </option><option value="Poetica ChanceryII"> Poetica Chancery </option><option value="ParkAveD"> Park Ave </option><option value="Times New Roman"> Times New Roman </option><option value="Zemke Hand ITC"> Zemke Hand </option>', 15)
                  ])],
                  544
                  /* NEED_HYDRATION, NEED_PATCH */
                ), [
                  [vModelSelect, _ctx.state.font]
                ])
              ])
            ]),
            createBaseVNode("div", _hoisted_85, [
              createVNode(_component_PageInput, {
                modelValue: _ctx.state.message,
                "onUpdate:modelValue": [
                  _cache[4] || (_cache[4] = ($event) => _ctx.state.message = $event),
                  _cache[5] || (_cache[5] = ($event) => _ctx.state.message = $event)
                ],
                name: "message",
                input: "textarea",
                title: "Write your Personal Message",
                required: true,
                error: _ctx.v$.message?.$errors[0]?.$message,
                onInput: _ctx.regenerateScene7Image,
                onBlur: _cache[6] || (_cache[6] = ($event) => {
                  _ctx.v$.message.$touch();
                  _ctx.v$.message.$validate();
                })
              }, null, 8, ["modelValue", "error", "onInput"])
            ]),
            createBaseVNode("div", _hoisted_94, [
              createVNode(_component_PageInput, {
                modelValue: _ctx.state.recipient_email,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => _ctx.state.recipient_email = $event),
                name: "recipient_email",
                title: "Recipient Email(s)<br />(Separate multiple email addresses with a comma)",
                required: true,
                error: _ctx.v$.recipient_email?.$errors[0]?.$message,
                onBlur: _cache[8] || (_cache[8] = ($event) => _ctx.v$.recipient_email.$touch())
              }, null, 8, ["modelValue", "error"])
            ]),
            createBaseVNode("div", _hoisted_104, [
              createVNode(_component_PageInput, {
                modelValue: _ctx.state.cc_recipient_email,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => _ctx.state.cc_recipient_email = $event),
                name: "recipient_email",
                title: "Cc Recipients Email"
              }, null, 8, ["modelValue"])
            ]),
            createBaseVNode("div", _hoisted_1112, [
              createBaseVNode("div", _hoisted_129, [
                createVNode(_component_PageInput, {
                  modelValue: _ctx.state.sender_name,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => _ctx.state.sender_name = $event),
                  name: "sender_name",
                  title: "Sender Name",
                  required: true,
                  error: _ctx.v$.sender_name?.$errors[0]?.$message,
                  onBlur: _cache[11] || (_cache[11] = ($event) => _ctx.v$.sender_name.$touch())
                }, null, 8, ["modelValue", "error"])
              ]),
              createBaseVNode("div", _hoisted_135, [
                createVNode(_component_PageInput, {
                  modelValue: _ctx.state.sender_email,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => _ctx.state.sender_email = $event),
                  name: "sender_email",
                  title: "Sender Email",
                  required: true,
                  error: _ctx.v$.sender_email?.$errors[0]?.$message,
                  onBlur: _cache[13] || (_cache[13] = ($event) => _ctx.v$.sender_email.$touch())
                }, null, 8, ["modelValue", "error"])
              ])
            ]),
            createBaseVNode("div", _hoisted_145, [
              withDirectives(createBaseVNode(
                "input",
                {
                  id: "send_immediately",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => _ctx.state.send_immediately = $event),
                  type: "checkbox"
                },
                null,
                512
                /* NEED_PATCH */
              ), [
                [vModelCheckbox, _ctx.state.send_immediately]
              ]),
              _cache[25] || (_cache[25] = createBaseVNode(
                "label",
                {
                  class: "ml-2 font-bold",
                  for: "send_immediately"
                },
                "Send immediately",
                -1
                /* CACHED */
              ))
            ]),
            !_ctx.state.send_immediately ? (openBlock(), createElementBlock("div", _hoisted_154, [
              _cache[29] || (_cache[29] = createBaseVNode(
                "p",
                { class: "mb-6 font-bold" },
                " Write it now, we'll send it later! ",
                -1
                /* CACHED */
              )),
              createBaseVNode("div", _hoisted_164, [
                createBaseVNode("div", _hoisted_174, [
                  _cache[26] || (_cache[26] = createBaseVNode(
                    "label",
                    {
                      class: "bv-epraise-label",
                      for: "scheduled_send_date"
                    },
                    "Date",
                    -1
                    /* CACHED */
                  )),
                  withDirectives(createBaseVNode("input", {
                    id: "scheduled_send_date",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => _ctx.state.scheduled_send_date = $event),
                    type: "date",
                    min: _ctx.minDate,
                    class: "bv-epraise-input"
                  }, null, 8, _hoisted_183), [
                    [vModelText, _ctx.state.scheduled_send_date]
                  ])
                ]),
                createBaseVNode("div", _hoisted_193, [
                  _cache[28] || (_cache[28] = createBaseVNode(
                    "label",
                    {
                      class: "bv-epraise-label",
                      for: "scheduled_send_time"
                    },
                    "Time",
                    -1
                    /* CACHED */
                  )),
                  createBaseVNode("div", _hoisted_203, [
                    createBaseVNode("div", _hoisted_2111, [
                      withDirectives(createBaseVNode(
                        "select",
                        {
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => _ctx.state.scheduled_send_hour = $event),
                          class: "bv-epraise-input"
                        },
                        [
                          (openBlock(), createElementBlock(
                            Fragment,
                            null,
                            renderList([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], (i2) => {
                              return createBaseVNode("option", {
                                key: i2,
                                value: i2
                              }, toDisplayString(i2), 9, _hoisted_227);
                            }),
                            64
                            /* STABLE_FRAGMENT */
                          ))
                        ],
                        512
                        /* NEED_PATCH */
                      ), [
                        [vModelSelect, _ctx.state.scheduled_send_hour]
                      ])
                    ]),
                    createBaseVNode("div", _hoisted_234, [
                      withDirectives(createBaseVNode(
                        "select",
                        {
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => _ctx.state.scheduled_send_minute = $event),
                          class: "bv-epraise-input"
                        },
                        [
                          (openBlock(), createElementBlock(
                            Fragment,
                            null,
                            renderList(["00", "15", "30", "45"], (i2) => {
                              return createBaseVNode("option", {
                                key: i2,
                                value: i2
                              }, toDisplayString(i2), 9, _hoisted_243);
                            }),
                            64
                            /* STABLE_FRAGMENT */
                          ))
                        ],
                        512
                        /* NEED_PATCH */
                      ), [
                        [vModelSelect, _ctx.state.scheduled_send_minute]
                      ])
                    ]),
                    createBaseVNode("div", _hoisted_253, [
                      withDirectives(createBaseVNode(
                        "select",
                        {
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => _ctx.state.scheduled_send_type = $event),
                          class: "bv-epraise-input"
                        },
                        [..._cache[27] || (_cache[27] = [
                          createBaseVNode(
                            "option",
                            { value: "AM" },
                            " AM ",
                            -1
                            /* CACHED */
                          ),
                          createBaseVNode(
                            "option",
                            { value: "PM" },
                            " PM ",
                            -1
                            /* CACHED */
                          )
                        ])],
                        512
                        /* NEED_PATCH */
                      ), [
                        [vModelSelect, _ctx.state.scheduled_send_type]
                      ])
                    ])
                  ])
                ])
              ])
            ])) : createCommentVNode("v-if", true),
            createBaseVNode("div", _hoisted_263, [
              withDirectives(createBaseVNode(
                "input",
                {
                  id: "email_sign_up",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => _ctx.state.email_sign_up = $event),
                  type: "checkbox"
                },
                null,
                512
                /* NEED_PATCH */
              ), [
                [vModelCheckbox, _ctx.state.email_sign_up]
              ]),
              _cache[30] || (_cache[30] = createBaseVNode(
                "label",
                {
                  class: "ml-2",
                  for: "email_sign_up"
                },
                "Sign up for Baudville emails and get positive mojo delivered right to your inbox!",
                -1
                /* CACHED */
              ))
            ]),
            _cache[31] || (_cache[31] = createBaseVNode(
              "button",
              {
                class: "w-full p-3 font-bold text-white uppercase bg-red-400 rounded",
                type: "submit"
              },
              " Send ",
              -1
              /* CACHED */
            ))
          ],
          32
          /* NEED_HYDRATION */
        )
      ])
    ]);
  }
  var __default__20, _hoisted_128, _hoisted_226, _hoisted_318, _hoisted_416, _hoisted_513, _hoisted_69, _hoisted_78, _hoisted_85, _hoisted_94, _hoisted_104, _hoisted_1112, _hoisted_129, _hoisted_135, _hoisted_145, _hoisted_154, _hoisted_164, _hoisted_174, _hoisted_183, _hoisted_193, _hoisted_203, _hoisted_2111, _hoisted_227, _hoisted_234, _hoisted_243, _hoisted_253, _hoisted_263, epraise_card_default;
  var init_epraise_card2 = __esm({
    "src/vue/components/shared/epraise-card.vue"() {
      "use strict";
      init_vue_esm_bundler();
      init_dist();
      init_dist2();
      init_page_input2();
      init_axios2();
      init_vue_esm_bundler();
      init_epraise_card();
      __default__20 = {
        components: { PageInput: page_input_default },
        emits: ["blur", "showThankyou"],
        setup(_2, { emit: emit2 }) {
          const time = (/* @__PURE__ */ new Date()).toLocaleString("en-US", { hour: "numeric", hour12: true }).split(" ");
          const state4 = reactive({
            data: [],
            card_id: "",
            font_color: "#008080",
            font: "Arial",
            message: "",
            recipient_email: "",
            cc_recipient_email: "",
            sender_name: "",
            sender_email: "",
            scheduled_send_date: (/* @__PURE__ */ new Date()).toISOString().slice(0, 10),
            scheduled_send_hour: time[0] < 12 ? parseInt(time[0], 10) + 1 : parseInt(time[0], 10),
            scheduled_send_minute: "00",
            scheduled_send_type: time[1],
            email_sign_up: true,
            send_immediately: true,
            scene7Image: ""
          });
          const rules = computed2(() => {
            return {
              card_id: { required },
              message: { required },
              recipient_email: { required },
              sender_name: { required },
              sender_email: { required, email }
            };
          });
          const hexToRgb = (hex) => {
            let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16)
            } : null;
          };
          const regenerateScene7Image = () => {
            state4.scene7Image = `https://s7d7.scene7.com/is/image/Baudville/EPRAISE_${state4.data.type}_TEMP?layer=0&src=EPRAISE_${state4.data.template}&layer=1&$line1=${state4.message}&$red=${hexToRgb(state4.font_color).r}&$green=${hexToRgb(state4.font_color).g}&$blue=${hexToRgb(state4.font_color).b}&$line1fs=48&$fn=${state4.font}&op_sharpen=1`;
          };
          const fetchData = () => {
            const url = new URL(window.location.href);
            const searchParams = new URLSearchParams(url.search);
            state4.card_id = searchParams.get("card");
            fetch(`https://jot.baudville.com/api/epraise/cards/${state4.card_id}`).then((response) => response.json()).then((data) => {
              state4.data = data;
              state4.recipient_email = searchParams.get("email");
              regenerateScene7Image();
            });
          };
          const formattedTime = () => {
            const date = new Date(state4.scheduled_send_date);
            const year = date.getFullYear();
            const month = new Intl.DateTimeFormat("en-US", { month: "short" }).format(
              date
            );
            const day = date.getDate();
            const hour = state4.scheduled_send_hour;
            const minute = state4.scheduled_send_minute;
            const second = "00";
            const meridian = state4.scheduled_send_type;
            return `${day} ${month} ${year} ${hour}:${minute}:${second} ${meridian}`;
          };
          const v$ = useVuelidate(rules, state4);
          const submitForm = () => {
            v$.value.$touch();
            if (v$.value.$error) {
              console.log("error");
              return;
            }
            const color = hexToRgb(state4.font_color);
            const formData2 = {
              card_id: state4.card_id,
              sender_name: state4.sender_name,
              sender_email: state4.sender_email,
              recipient_emails: state4?.recipient_email?.replaceAll(" ", "")?.split(","),
              cc_emails: state4.cc_recipient_email ? state4?.cc_recipient_email?.replaceAll(" ", "")?.split(",") : null,
              send_at: state4.send_immediately ? null : formattedTime(),
              sign_up: state4.email_sign_up,
              personalizations: {
                $line1: state4.message,
                $red: color.r,
                $green: color.g,
                $blue: color.b,
                $fn: state4.font
              }
            };
            console.log(formData2);
            axios_default.post("https://jot.baudville.com/api/epraise", formData2).then((res) => {
              console.log(res);
              emit2("showThankyou");
            }).catch((error) => {
              console.log(error);
              if (error.response.status === 422) {
                const { errors } = error.response.data;
                for (const property in errors) {
                  v$.value[property].$touch();
                  v$.value[property].$validate();
                }
              }
            });
          };
          onMounted(() => {
            fetchData();
          });
          return {
            state: state4,
            minDate: (/* @__PURE__ */ new Date()).toISOString().split("T")[0],
            v$,
            submitForm,
            regenerateScene7Image
          };
        }
      };
      _hoisted_128 = { class: "flex flex-wrap -mx-6 card-view" };
      _hoisted_226 = { class: "w-full px-6 mb-6 md:w-1/2 md:mb-0" };
      _hoisted_318 = ["src"];
      _hoisted_416 = { class: "w-full px-6 text-gray-100 md:w-1/2" };
      _hoisted_513 = { class: "flex mb-6 -mx-4" };
      _hoisted_69 = { class: "w-full px-4 sm:w-1/2" };
      _hoisted_78 = { class: "w-full px-4 sm:w-1/2" };
      _hoisted_85 = { class: "mb-6" };
      _hoisted_94 = { class: "mb-6" };
      _hoisted_104 = { class: "mb-6" };
      _hoisted_1112 = { class: "flex mb-6 -mx-4" };
      _hoisted_129 = { class: "w-full px-4 sm:w-1/2" };
      _hoisted_135 = { class: "w-full px-4 sm:w-1/2" };
      _hoisted_145 = { class: "flex items-center mb-6" };
      _hoisted_154 = { key: 0 };
      _hoisted_164 = { class: "flex mb-6 -mx-4" };
      _hoisted_174 = { class: "w-5/12 px-4" };
      _hoisted_183 = ["min"];
      _hoisted_193 = { class: "w-7/12 px-4" };
      _hoisted_203 = { class: "flex -mx-2" };
      _hoisted_2111 = { class: "flex-1 px-2" };
      _hoisted_227 = ["value"];
      _hoisted_234 = { class: "flex-1 px-2" };
      _hoisted_243 = ["value"];
      _hoisted_253 = { class: "flex-1 px-2" };
      _hoisted_263 = { class: "mb-6" };
      __default__20.render = render21;
      epraise_card_default = __default__20;
    }
  });

  // src/vue/components/render/page-epraise.vue
  var page_epraise_exports = {};
  __export(page_epraise_exports, {
    default: () => page_epraise_default,
    render: () => render22
  });
  function render22(_ctx, _cache) {
    const _component_EpraiseCard = resolveComponent("EpraiseCard");
    return openBlock(), createElementBlock(
      Fragment,
      null,
      [
        createBaseVNode("div", _hoisted_130, [
          createBaseVNode("div", _hoisted_228, [
            createBaseVNode("a", {
              href: "/pages/epraise",
              onClick: _cache[0] || (_cache[0] = withModifiers((...args) => _ctx.home && _ctx.home(...args), ["prevent"]))
            }, [
              !_ctx.thankyou ? (openBlock(), createElementBlock("img", {
                key: 0,
                src: _ctx.mainImage,
                alt: ""
              }, null, 8, _hoisted_319)) : (openBlock(), createElementBlock("img", {
                key: 1,
                src: _ctx.thanksImage,
                alt: ""
              }, null, 8, _hoisted_417))
            ])
          ])
        ]),
        !_ctx.cardView ? (openBlock(), createElementBlock("div", _hoisted_514, [
          (openBlock(true), createElementBlock(
            Fragment,
            null,
            renderList(_ctx.data, (item, key) => {
              return openBlock(), createElementBlock("div", {
                key,
                class: "mb-6"
              }, [
                createBaseVNode("h3", _hoisted_610, [
                  createTextVNode(
                    toDisplayString(item.title) + " ",
                    1
                    /* TEXT */
                  ),
                  !_ctx.categoryView ? (openBlock(), createElementBlock("a", {
                    key: 0,
                    class: "ml-3 text-base text-red-400 normal-case",
                    href: "category/" + item.id,
                    onClick: withModifiers(($event) => _ctx.category(item.id), ["prevent"])
                  }, "See all", 8, _hoisted_79)) : createCommentVNode("v-if", true)
                ]),
                createBaseVNode("div", _hoisted_86, [
                  (openBlock(true), createElementBlock(
                    Fragment,
                    null,
                    renderList(item.cards, (card, key2) => {
                      return openBlock(), createElementBlock("div", {
                        key: key2,
                        class: "w-1/2 mb-4 text-center sm:mb-3 px:2 sm:px-4 sm:w-1/3 lg:w-1/5"
                      }, [
                        createBaseVNode("a", {
                          href: "?card=" + card.id,
                          class: "block px-2 mb-2 sm:px-10",
                          onClick: withModifiers(($event) => _ctx.generateCartView(card.id), ["prevent"])
                        }, [
                          createBaseVNode("img", {
                            class: "w-full mb-1",
                            src: `https://s7d7.scene7.com/is/image/Baudville/EPRAISE_${card.template}_THUMB`,
                            alt: ""
                          }, null, 8, _hoisted_105),
                          _cache[1] || (_cache[1] = createBaseVNode(
                            "span",
                            { class: "block p-2 text-white uppercase bg-red-400 rounded" },
                            "Send",
                            -1
                            /* CACHED */
                          ))
                        ], 8, _hoisted_95),
                        createBaseVNode(
                          "p",
                          _hoisted_1113,
                          toDisplayString(card.title),
                          1
                          /* TEXT */
                        )
                      ]);
                    }),
                    128
                    /* KEYED_FRAGMENT */
                  ))
                ])
              ]);
            }),
            128
            /* KEYED_FRAGMENT */
          ))
        ])) : createCommentVNode("v-if", true),
        _ctx.cardView ? (openBlock(), createElementBlock("div", _hoisted_1210, [
          createVNode(_component_EpraiseCard, { onShowThankyou: _ctx.showThankyou }, null, 8, ["onShowThankyou"])
        ])) : createCommentVNode("v-if", true)
      ],
      64
      /* STABLE_FRAGMENT */
    );
  }
  var __default__21, _hoisted_130, _hoisted_228, _hoisted_319, _hoisted_417, _hoisted_514, _hoisted_610, _hoisted_79, _hoisted_86, _hoisted_95, _hoisted_105, _hoisted_1113, _hoisted_1210, page_epraise_default;
  var init_page_epraise = __esm({
    "src/vue/components/render/page-epraise.vue"() {
      "use strict";
      init_epraise_card2();
      init_vue_esm_bundler();
      __default__21 = {
        components: { EpraiseCard: epraise_card_default },
        emits: ["showThankyou"],
        data() {
          return {
            data: [],
            cardView: false,
            categoryView: false,
            thankyou: false,
            mainImage: "https://cdn.shopify.com/s/files/1/0667/4766/2632/files/file_6_465ed608-f4d6-438a-aaae-623870a385ee.jpg?v=1678508354",
            thanksImage: "https://cdn.shopify.com/s/files/1/0667/4766/2632/files/file_7_09044131-ce77-4bdd-8a1c-0e6205d7cb68.jpg?v=1678533207"
          };
        },
        mounted() {
          const url = new URL(window.location.href);
          const searchParams = new URLSearchParams(url.search);
          const category = searchParams.get("category");
          const card = searchParams.get("card");
          if (category) {
            this.category(category);
          } else if (card) {
            this.cardView = true;
          } else {
            this.home();
          }
        },
        methods: {
          showThankyou() {
            this.topPosition();
            this.thankyou = true;
            this.cardView = false;
            this.categoryView = false;
            this.data = [];
          },
          topPosition() {
            window.scrollTo({
              top: document.querySelector(".top-position").offsetTop - 21
            });
          },
          home() {
            this.thankyou = false;
            fetch("https://jot.baudville.com/api/epraise/categories").then((response) => response.json()).then((data) => {
              this.cardView = false;
              this.categoryView = false;
              this.data = data;
              history.pushState(null, null, "/pages/epraise");
            }).catch((error) => {
              console.error(error);
            });
          },
          category(id) {
            fetch(`https://jot.baudville.com/api/epraise/categories/${id}`).then((response) => response.json()).then((data) => {
              this.categoryView = true;
              this.cardView = false;
              this.data = [data];
              history.pushState(null, null, "?category=" + id);
              this.topPosition();
            }).catch((error) => {
              console.error(error);
            });
          },
          generateCartView(id) {
            history.pushState(null, null, "?card=" + id);
            this.cardView = true;
            this.categoryView = false;
            this.topPosition();
          }
        }
      };
      _hoisted_130 = { class: "container mx-auto top-position" };
      _hoisted_228 = { class: "mb-12" };
      _hoisted_319 = ["src"];
      _hoisted_417 = ["src"];
      _hoisted_514 = {
        key: 0,
        class: "container mx-auto"
      };
      _hoisted_610 = { class: "mb-4 text-xl font-bold text-gray-500 uppercase" };
      _hoisted_79 = ["href", "onClick"];
      _hoisted_86 = { class: "flex flex-wrap -mx-2 sm:-mx-4" };
      _hoisted_95 = ["href", "onClick"];
      _hoisted_105 = ["src"];
      _hoisted_1113 = { class: "text-gray-500" };
      _hoisted_1210 = {
        key: 1,
        class: "container mx-auto"
      };
      __default__21.render = render22;
      page_epraise_default = __default__21;
    }
  });

  // src/vue/components/render/page-quote.vue
  var page_quote_exports = {};
  __export(page_quote_exports, {
    default: () => page_quote_default,
    render: () => render23
  });
  function render23(_ctx, _cache) {
    return openBlock(), createElementBlock("div", _hoisted_131, [..._cache[0] || (_cache[0] = [
      createStaticVNode('<div class="content-wrapper mb-8"><div class="content-block content-block--text"><div class="text-content-block"><h1 class="text-5xl mb-10">Request a Quote</h1><div class="klaviyo-form-VAcPmf"></div></div></div></div>', 1)
    ])]);
  }
  var __default__22, _hoisted_131, page_quote_default;
  var init_page_quote = __esm({
    "src/vue/components/render/page-quote.vue"() {
      "use strict";
      init_vue_esm_bundler();
      __default__22 = {};
      _hoisted_131 = { class: "container" };
      __default__22.render = render23;
      page_quote_default = __default__22;
    }
  });

  // node_modules/dom-to-image/src/dom-to-image.js
  var require_dom_to_image = __commonJS({
    "node_modules/dom-to-image/src/dom-to-image.js"(exports, module) {
      (function(global2) {
        "use strict";
        var util = newUtil();
        var inliner = newInliner();
        var fontFaces = newFontFaces();
        var images = newImages();
        var defaultOptions = {
          // Default is to fail on error, no placeholder
          imagePlaceholder: void 0,
          // Default cache bust is false, it will use the cache
          cacheBust: false
        };
        var domtoimage2 = {
          toSvg,
          toPng,
          toJpeg,
          toBlob,
          toPixelData,
          impl: {
            fontFaces,
            images,
            util,
            inliner,
            options: {}
          }
        };
        if (typeof module !== "undefined")
          module.exports = domtoimage2;
        else
          global2.domtoimage = domtoimage2;
        function toSvg(node, options) {
          options = options || {};
          copyOptions(options);
          return Promise.resolve(node).then(function(node2) {
            return cloneNode(node2, options.filter, true);
          }).then(embedFonts).then(inlineImages).then(applyOptions2).then(function(clone) {
            return makeSvgDataUri(
              clone,
              options.width || util.width(node),
              options.height || util.height(node)
            );
          });
          function applyOptions2(clone) {
            if (options.bgcolor) clone.style.backgroundColor = options.bgcolor;
            if (options.width) clone.style.width = options.width + "px";
            if (options.height) clone.style.height = options.height + "px";
            if (options.style)
              Object.keys(options.style).forEach(function(property) {
                clone.style[property] = options.style[property];
              });
            return clone;
          }
        }
        function toPixelData(node, options) {
          return draw(node, options || {}).then(function(canvas) {
            return canvas.getContext("2d").getImageData(
              0,
              0,
              util.width(node),
              util.height(node)
            ).data;
          });
        }
        function toPng(node, options) {
          return draw(node, options || {}).then(function(canvas) {
            return canvas.toDataURL();
          });
        }
        function toJpeg(node, options) {
          options = options || {};
          return draw(node, options).then(function(canvas) {
            return canvas.toDataURL("image/jpeg", options.quality || 1);
          });
        }
        function toBlob(node, options) {
          return draw(node, options || {}).then(util.canvasToBlob);
        }
        function copyOptions(options) {
          if (typeof options.imagePlaceholder === "undefined") {
            domtoimage2.impl.options.imagePlaceholder = defaultOptions.imagePlaceholder;
          } else {
            domtoimage2.impl.options.imagePlaceholder = options.imagePlaceholder;
          }
          if (typeof options.cacheBust === "undefined") {
            domtoimage2.impl.options.cacheBust = defaultOptions.cacheBust;
          } else {
            domtoimage2.impl.options.cacheBust = options.cacheBust;
          }
        }
        function draw(domNode, options) {
          return toSvg(domNode, options).then(util.makeImage).then(util.delay(100)).then(function(image) {
            var canvas = newCanvas(domNode);
            canvas.getContext("2d").drawImage(image, 0, 0);
            return canvas;
          });
          function newCanvas(domNode2) {
            var canvas = document.createElement("canvas");
            canvas.width = options.width || util.width(domNode2);
            canvas.height = options.height || util.height(domNode2);
            if (options.bgcolor) {
              var ctx = canvas.getContext("2d");
              ctx.fillStyle = options.bgcolor;
              ctx.fillRect(0, 0, canvas.width, canvas.height);
            }
            return canvas;
          }
        }
        function cloneNode(node, filter5, root) {
          if (!root && filter5 && !filter5(node)) return Promise.resolve();
          return Promise.resolve(node).then(makeNodeCopy).then(function(clone) {
            return cloneChildren(node, clone, filter5);
          }).then(function(clone) {
            return processClone(node, clone);
          });
          function makeNodeCopy(node2) {
            if (node2 instanceof HTMLCanvasElement) return util.makeImage(node2.toDataURL());
            return node2.cloneNode(false);
          }
          function cloneChildren(original, clone, filter6) {
            var children = original.childNodes;
            if (children.length === 0) return Promise.resolve(clone);
            return cloneChildrenInOrder(clone, util.asArray(children), filter6).then(function() {
              return clone;
            });
            function cloneChildrenInOrder(parent, children2, filter7) {
              var done = Promise.resolve();
              children2.forEach(function(child) {
                done = done.then(function() {
                  return cloneNode(child, filter7);
                }).then(function(childClone) {
                  if (childClone) parent.appendChild(childClone);
                });
              });
              return done;
            }
          }
          function processClone(original, clone) {
            if (!(clone instanceof Element)) return clone;
            return Promise.resolve().then(cloneStyle).then(clonePseudoElements).then(copyUserInput).then(fixSvg).then(function() {
              return clone;
            });
            function cloneStyle() {
              copyStyle(window.getComputedStyle(original), clone.style);
              function copyStyle(source, target) {
                if (source.cssText) target.cssText = source.cssText;
                else copyProperties(source, target);
                function copyProperties(source2, target2) {
                  util.asArray(source2).forEach(function(name) {
                    target2.setProperty(
                      name,
                      source2.getPropertyValue(name),
                      source2.getPropertyPriority(name)
                    );
                  });
                }
              }
            }
            function clonePseudoElements() {
              [":before", ":after"].forEach(function(element) {
                clonePseudoElement(element);
              });
              function clonePseudoElement(element) {
                var style = window.getComputedStyle(original, element);
                var content = style.getPropertyValue("content");
                if (content === "" || content === "none") return;
                var className = util.uid();
                clone.className = clone.className + " " + className;
                var styleElement = document.createElement("style");
                styleElement.appendChild(formatPseudoElementStyle(className, element, style));
                clone.appendChild(styleElement);
                function formatPseudoElementStyle(className2, element2, style2) {
                  var selector = "." + className2 + ":" + element2;
                  var cssText = style2.cssText ? formatCssText(style2) : formatCssProperties(style2);
                  return document.createTextNode(selector + "{" + cssText + "}");
                  function formatCssText(style3) {
                    var content2 = style3.getPropertyValue("content");
                    return style3.cssText + " content: " + content2 + ";";
                  }
                  function formatCssProperties(style3) {
                    return util.asArray(style3).map(formatProperty).join("; ") + ";";
                    function formatProperty(name) {
                      return name + ": " + style3.getPropertyValue(name) + (style3.getPropertyPriority(name) ? " !important" : "");
                    }
                  }
                }
              }
            }
            function copyUserInput() {
              if (original instanceof HTMLTextAreaElement) clone.innerHTML = original.value;
              if (original instanceof HTMLInputElement) clone.setAttribute("value", original.value);
            }
            function fixSvg() {
              if (!(clone instanceof SVGElement)) return;
              clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
              if (!(clone instanceof SVGRectElement)) return;
              ["width", "height"].forEach(function(attribute) {
                var value = clone.getAttribute(attribute);
                if (!value) return;
                clone.style.setProperty(attribute, value);
              });
            }
          }
        }
        function embedFonts(node) {
          return fontFaces.resolveAll().then(function(cssText) {
            var styleNode = document.createElement("style");
            node.appendChild(styleNode);
            styleNode.appendChild(document.createTextNode(cssText));
            return node;
          });
        }
        function inlineImages(node) {
          return images.inlineAll(node).then(function() {
            return node;
          });
        }
        function makeSvgDataUri(node, width, height) {
          return Promise.resolve(node).then(function(node2) {
            node2.setAttribute("xmlns", "http://www.w3.org/1999/xhtml");
            return new XMLSerializer().serializeToString(node2);
          }).then(util.escapeXhtml).then(function(xhtml) {
            return '<foreignObject x="0" y="0" width="100%" height="100%">' + xhtml + "</foreignObject>";
          }).then(function(foreignObject) {
            return '<svg xmlns="http://www.w3.org/2000/svg" width="' + width + '" height="' + height + '">' + foreignObject + "</svg>";
          }).then(function(svg) {
            return "data:image/svg+xml;charset=utf-8," + svg;
          });
        }
        function newUtil() {
          return {
            escape,
            parseExtension,
            mimeType,
            dataAsUrl,
            isDataUrl,
            canvasToBlob,
            resolveUrl,
            getAndEncode,
            uid: uid3(),
            delay,
            asArray,
            escapeXhtml,
            makeImage,
            width,
            height
          };
          function mimes() {
            var WOFF = "application/font-woff";
            var JPEG = "image/jpeg";
            return {
              "woff": WOFF,
              "woff2": WOFF,
              "ttf": "application/font-truetype",
              "eot": "application/vnd.ms-fontobject",
              "png": "image/png",
              "jpg": JPEG,
              "jpeg": JPEG,
              "gif": "image/gif",
              "tiff": "image/tiff",
              "svg": "image/svg+xml"
            };
          }
          function parseExtension(url) {
            var match = /\.([^\.\/]*?)$/g.exec(url);
            if (match) return match[1];
            else return "";
          }
          function mimeType(url) {
            var extension = parseExtension(url).toLowerCase();
            return mimes()[extension] || "";
          }
          function isDataUrl(url) {
            return url.search(/^(data:)/) !== -1;
          }
          function toBlob2(canvas) {
            return new Promise(function(resolve2) {
              var binaryString = window.atob(canvas.toDataURL().split(",")[1]);
              var length = binaryString.length;
              var binaryArray = new Uint8Array(length);
              for (var i2 = 0; i2 < length; i2++)
                binaryArray[i2] = binaryString.charCodeAt(i2);
              resolve2(new Blob([binaryArray], {
                type: "image/png"
              }));
            });
          }
          function canvasToBlob(canvas) {
            if (canvas.toBlob)
              return new Promise(function(resolve2) {
                canvas.toBlob(resolve2);
              });
            return toBlob2(canvas);
          }
          function resolveUrl(url, baseUrl) {
            var doc2 = document.implementation.createHTMLDocument();
            var base = doc2.createElement("base");
            doc2.head.appendChild(base);
            var a = doc2.createElement("a");
            doc2.body.appendChild(a);
            base.href = baseUrl;
            a.href = url;
            return a.href;
          }
          function uid3() {
            var index = 0;
            return function() {
              return "u" + fourRandomChars() + index++;
              function fourRandomChars() {
                return ("0000" + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4);
              }
            };
          }
          function makeImage(uri) {
            return new Promise(function(resolve2, reject) {
              var image = new Image();
              image.onload = function() {
                resolve2(image);
              };
              image.onerror = reject;
              image.src = uri;
            });
          }
          function getAndEncode(url) {
            var TIMEOUT = 3e4;
            if (domtoimage2.impl.options.cacheBust) {
              url += (/\?/.test(url) ? "&" : "?") + (/* @__PURE__ */ new Date()).getTime();
            }
            return new Promise(function(resolve2) {
              var request = new XMLHttpRequest();
              request.onreadystatechange = done;
              request.ontimeout = timeout;
              request.responseType = "blob";
              request.timeout = TIMEOUT;
              request.open("GET", url, true);
              request.send();
              var placeholder;
              if (domtoimage2.impl.options.imagePlaceholder) {
                var split = domtoimage2.impl.options.imagePlaceholder.split(/,/);
                if (split && split[1]) {
                  placeholder = split[1];
                }
              }
              function done() {
                if (request.readyState !== 4) return;
                if (request.status !== 200) {
                  if (placeholder) {
                    resolve2(placeholder);
                  } else {
                    fail("cannot fetch resource: " + url + ", status: " + request.status);
                  }
                  return;
                }
                var encoder = new FileReader();
                encoder.onloadend = function() {
                  var content = encoder.result.split(/,/)[1];
                  resolve2(content);
                };
                encoder.readAsDataURL(request.response);
              }
              function timeout() {
                if (placeholder) {
                  resolve2(placeholder);
                } else {
                  fail("timeout of " + TIMEOUT + "ms occured while fetching resource: " + url);
                }
              }
              function fail(message) {
                console.error(message);
                resolve2("");
              }
            });
          }
          function dataAsUrl(content, type) {
            return "data:" + type + ";base64," + content;
          }
          function escape(string) {
            return string.replace(/([.*+?^${}()|\[\]\/\\])/g, "\\$1");
          }
          function delay(ms) {
            return function(arg) {
              return new Promise(function(resolve2) {
                setTimeout(function() {
                  resolve2(arg);
                }, ms);
              });
            };
          }
          function asArray(arrayLike) {
            var array = [];
            var length = arrayLike.length;
            for (var i2 = 0; i2 < length; i2++) array.push(arrayLike[i2]);
            return array;
          }
          function escapeXhtml(string) {
            return string.replace(/#/g, "%23").replace(/\n/g, "%0A");
          }
          function width(node) {
            var leftBorder = px(node, "border-left-width");
            var rightBorder = px(node, "border-right-width");
            return node.scrollWidth + leftBorder + rightBorder;
          }
          function height(node) {
            var topBorder = px(node, "border-top-width");
            var bottomBorder = px(node, "border-bottom-width");
            return node.scrollHeight + topBorder + bottomBorder;
          }
          function px(node, styleProperty) {
            var value = window.getComputedStyle(node).getPropertyValue(styleProperty);
            return parseFloat(value.replace("px", ""));
          }
        }
        function newInliner() {
          var URL_REGEX = /url\(['"]?([^'"]+?)['"]?\)/g;
          return {
            inlineAll,
            shouldProcess,
            impl: {
              readUrls,
              inline
            }
          };
          function shouldProcess(string) {
            return string.search(URL_REGEX) !== -1;
          }
          function readUrls(string) {
            var result = [];
            var match;
            while ((match = URL_REGEX.exec(string)) !== null) {
              result.push(match[1]);
            }
            return result.filter(function(url) {
              return !util.isDataUrl(url);
            });
          }
          function inline(string, url, baseUrl, get3) {
            return Promise.resolve(url).then(function(url2) {
              return baseUrl ? util.resolveUrl(url2, baseUrl) : url2;
            }).then(get3 || util.getAndEncode).then(function(data) {
              return util.dataAsUrl(data, util.mimeType(url));
            }).then(function(dataUrl) {
              return string.replace(urlAsRegex(url), "$1" + dataUrl + "$3");
            });
            function urlAsRegex(url2) {
              return new RegExp(`(url\\(['"]?)(` + util.escape(url2) + `)(['"]?\\))`, "g");
            }
          }
          function inlineAll(string, baseUrl, get3) {
            if (nothingToInline()) return Promise.resolve(string);
            return Promise.resolve(string).then(readUrls).then(function(urls) {
              var done = Promise.resolve(string);
              urls.forEach(function(url) {
                done = done.then(function(string2) {
                  return inline(string2, url, baseUrl, get3);
                });
              });
              return done;
            });
            function nothingToInline() {
              return !shouldProcess(string);
            }
          }
        }
        function newFontFaces() {
          return {
            resolveAll,
            impl: {
              readAll
            }
          };
          function resolveAll() {
            return readAll(document).then(function(webFonts) {
              return Promise.all(
                webFonts.map(function(webFont) {
                  return webFont.resolve();
                })
              );
            }).then(function(cssStrings) {
              return cssStrings.join("\n");
            });
          }
          function readAll() {
            return Promise.resolve(util.asArray(document.styleSheets)).then(getCssRules).then(selectWebFontRules).then(function(rules) {
              return rules.map(newWebFont);
            });
            function selectWebFontRules(cssRules) {
              return cssRules.filter(function(rule) {
                return rule.type === CSSRule.FONT_FACE_RULE;
              }).filter(function(rule) {
                return inliner.shouldProcess(rule.style.getPropertyValue("src"));
              });
            }
            function getCssRules(styleSheets) {
              var cssRules = [];
              styleSheets.forEach(function(sheet) {
                try {
                  util.asArray(sheet.cssRules || []).forEach(cssRules.push.bind(cssRules));
                } catch (e) {
                  console.log("Error while reading CSS rules from " + sheet.href, e.toString());
                }
              });
              return cssRules;
            }
            function newWebFont(webFontRule) {
              return {
                resolve: function resolve2() {
                  var baseUrl = (webFontRule.parentStyleSheet || {}).href;
                  return inliner.inlineAll(webFontRule.cssText, baseUrl);
                },
                src: function() {
                  return webFontRule.style.getPropertyValue("src");
                }
              };
            }
          }
        }
        function newImages() {
          return {
            inlineAll,
            impl: {
              newImage
            }
          };
          function newImage(element) {
            return {
              inline
            };
            function inline(get3) {
              if (util.isDataUrl(element.src)) return Promise.resolve();
              return Promise.resolve(element.src).then(get3 || util.getAndEncode).then(function(data) {
                return util.dataAsUrl(data, util.mimeType(element.src));
              }).then(function(dataUrl) {
                return new Promise(function(resolve2, reject) {
                  element.onload = resolve2;
                  element.onerror = reject;
                  element.src = dataUrl;
                });
              });
            }
          }
          function inlineAll(node) {
            if (!(node instanceof Element)) return Promise.resolve(node);
            return inlineBackground(node).then(function() {
              if (node instanceof HTMLImageElement)
                return newImage(node).inline();
              else
                return Promise.all(
                  util.asArray(node.childNodes).map(function(child) {
                    return inlineAll(child);
                  })
                );
            });
            function inlineBackground(node2) {
              var background = node2.style.getPropertyValue("background");
              if (!background) return Promise.resolve(node2);
              return inliner.inlineAll(background).then(function(inlined) {
                node2.style.setProperty(
                  "background",
                  inlined,
                  node2.style.getPropertyPriority("background")
                );
              }).then(function() {
                return node2;
              });
            }
          }
        }
      })(exports);
    }
  });

  // src/vue/components/shared/step-button.vue
  var step_button_exports = {};
  __export(step_button_exports, {
    default: () => step_button_default,
    render: () => render24
  });
  function render24(_ctx, _cache) {
    return openBlock(), createElementBlock("button", {
      class: "flex items-center justify-between w-full text-xl text-white bg-teal-100 border-b-2 border-white heading-font p-7",
      onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("stepChange"))
    }, [
      createBaseVNode("span", _hoisted_136, [
        createBaseVNode(
          "span",
          _hoisted_229,
          toDisplayString(_ctx.step_number),
          1
          /* TEXT */
        ),
        createBaseVNode(
          "span",
          null,
          toDisplayString(_ctx.name),
          1
          /* TEXT */
        )
      ]),
      _cache[1] || (_cache[1] = createBaseVNode(
        "span",
        null,
        [
          createBaseVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            "stroke-width": "1.5",
            stroke: "currentColor",
            class: "w-5 h-5"
          }, [
            createBaseVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              d: "M8.25 4.5l7.5 7.5-7.5 7.5"
            })
          ])
        ],
        -1
        /* CACHED */
      ))
    ]);
  }
  var __default__23, _hoisted_136, _hoisted_229, step_button_default;
  var init_step_button = __esm({
    "src/vue/components/shared/step-button.vue"() {
      "use strict";
      init_vue_esm_bundler();
      __default__23 = {
        name: "StepButton",
        props: {
          name: {
            type: String,
            required: true
          },
          step_number: {
            type: Number,
            required: true
          }
        },
        emits: ["stepChange"],
        setup() {
        }
      };
      _hoisted_136 = { class: "flex items-center" };
      _hoisted_229 = { class: "flex items-center justify-center w-6 h-6 mr-4 text-sm font-bold text-teal-100 bg-white rounded-full" };
      __default__23.render = render24;
      step_button_default = __default__23;
    }
  });

  // src/vue/components/shared/step-header.vue
  var step_header_exports = {};
  __export(step_header_exports, {
    default: () => step_header_default,
    render: () => render25
  });
  function render25(_ctx, _cache) {
    return openBlock(), createElementBlock("button", {
      class: "relative flex justify-center w-full p-3 text-xl text-white uppercase primary-bg heading-font",
      onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("back"))
    }, [
      _cache[1] || (_cache[1] = createBaseVNode(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          fill: "none",
          viewBox: "0 0 24 24",
          "stroke-width": "1.5",
          stroke: "currentColor",
          class: "absolute w-5 h-5 left-3 top-4"
        },
        [
          createBaseVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M15.75 19.5L8.25 12l7.5-7.5"
          })
        ],
        -1
        /* CACHED */
      )),
      createTextVNode(
        " " + toDisplayString(_ctx.name),
        1
        /* TEXT */
      )
    ]);
  }
  var __default__24, step_header_default;
  var init_step_header = __esm({
    "src/vue/components/shared/step-header.vue"() {
      "use strict";
      init_vue_esm_bundler();
      __default__24 = {
        name: "StepHeader",
        props: {
          name: {
            type: String,
            required: true
          }
        },
        emits: ["back"],
        setup() {
        }
      };
      __default__24.render = render25;
      step_header_default = __default__24;
    }
  });

  // src/vue/components/shared/step-footer.vue
  var step_footer_exports = {};
  __export(step_footer_exports, {
    default: () => step_footer_default,
    render: () => render26
  });
  function render26(_ctx, _cache) {
    return openBlock(), createElementBlock("div", _hoisted_137, [
      createBaseVNode("button", {
        class: "flex items-center justify-center flex-1 p-4",
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("back"))
      }, [..._cache[3] || (_cache[3] = [
        createBaseVNode(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            "stroke-width": "1.5",
            stroke: "currentColor",
            class: "w-6 h-6"
          },
          [
            createBaseVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              d: "M15.75 19.5L8.25 12l7.5-7.5"
            })
          ],
          -1
          /* CACHED */
        )
      ])]),
      _ctx.step === _ctx.totalSteps ? (openBlock(), createElementBlock("button", {
        key: 0,
        class: "flex items-center justify-center flex-1 p-4 text-xl leading-none uppercase border-l primary-border-color font-mont",
        onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("add-cart"))
      }, " ADD TO Cart ")) : (openBlock(), createElementBlock("button", {
        key: 1,
        class: "flex items-center justify-center flex-1 p-4 border-l primary-border-color",
        onClick: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("next"))
      }, [..._cache[4] || (_cache[4] = [
        createBaseVNode(
          "svg",
          {
            title: "Accept",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 17 16",
            class: "svg-icon--small svg-icon svg-icon--secondary-color svg-icon--configurator-action"
          },
          [
            createBaseVNode("path", { d: "M14.4.1C9.6 1.4 7.3 5.4 5.8 9.7c-.7-.8-1.3-1.7-2-2.5-1.6-2-5 .1-3.4 2.2 1.5 1.9 3 3.9 4.5 5.8 1.1 1.4 3.2 1.1 3.7-.7 1-4.2 2.3-9.2 7.1-10.6 2.5-.7 1.2-4.5-1.3-3.8z" })
          ],
          -1
          /* CACHED */
        )
      ])]))
    ]);
  }
  var __default__25, _hoisted_137, step_footer_default;
  var init_step_footer = __esm({
    "src/vue/components/shared/step-footer.vue"() {
      "use strict";
      init_vue_esm_bundler();
      __default__25 = {
        name: "StepFooter",
        props: {
          step: {
            type: Number,
            required: true
          },
          totalSteps: {
            type: Number,
            required: true
          }
        },
        emits: ["back", "add-cart", "next"],
        setup() {
        }
      };
      _hoisted_137 = { class: "absolute bottom-0 left-0 z-10 flex w-full border-t primary-border-color" };
      __default__25.render = render26;
      step_footer_default = __default__25;
    }
  });

  // vue-style:C:\fork\Baudville\src\vue\components\shared\div-container.vue
  var init_div_container = __esm({
    "vue-style:C:\\fork\\Baudville\\src\\vue\\components\\shared\\div-container.vue"() {
    }
  });

  // src/vue/components/shared/div-container.vue
  var div_container_exports = {};
  __export(div_container_exports, {
    default: () => div_container_default,
    render: () => render27
  });
  function render27(_ctx, _cache) {
    return openBlock(), createElementBlock("div", _hoisted_138, [
      renderSlot(_ctx.$slots, "default")
    ]);
  }
  var __default__26, _hoisted_138, div_container_default;
  var init_div_container2 = __esm({
    "src/vue/components/shared/div-container.vue"() {
      "use strict";
      init_vue_esm_bundler();
      init_div_container();
      __default__26 = {};
      _hoisted_138 = { class: "px-4 pt-4 pb-16 overflow-y-auto bg-gray-600 configurator-step__content" };
      __default__26.render = render27;
      __default__26.__scopeId = "data-v-4702f44a";
      div_container_default = __default__26;
    }
  });

  // vue-style:C:\fork\Baudville\src\vue\components\shared\message-description.vue
  var init_message_description = __esm({
    "vue-style:C:\\fork\\Baudville\\src\\vue\\components\\shared\\message-description.vue"() {
    }
  });

  // src/vue/components/shared/message-description.vue
  var message_description_exports = {};
  __export(message_description_exports, {
    default: () => message_description_default,
    render: () => render28
  });
  function render28(_ctx, _cache) {
    return openBlock(), createElementBlock("div", _hoisted_139, [
      createBaseVNode("div", null, [
        createBaseVNode("p", null, [
          _cache[1] || (_cache[1] = createBaseVNode(
            "strong",
            null,
            "Choose from these message options",
            -1
            /* CACHED */
          )),
          createBaseVNode("a", {
            href: "#message-options-help-content",
            class: "configurator-step__description-help-button text-button",
            "data-configurator-dialog-button": "",
            onClick: _cache[0] || (_cache[0] = withModifiers((...args) => _ctx.open && _ctx.open(...args), ["prevent"]))
          }, "(?)"),
          _cache[2] || (_cache[2] = createTextVNode(
            ": ",
            -1
            /* CACHED */
          ))
        ]),
        _cache[3] || (_cache[3] = createBaseVNode(
          "p",
          null,
          [
            createBaseVNode("strong", null, "Graphic & Text:"),
            createTextVNode(" Choose a message graphic from the drop-down above and add up to 3 lines of text personalization with the graphic. ")
          ],
          -1
          /* CACHED */
        )),
        _cache[4] || (_cache[4] = createBaseVNode(
          "p",
          null,
          [
            createBaseVNode("strong", null, "Graphic Only:"),
            createTextVNode(" Choose a message graphic from the drop-down above and leave the lines blank in the next step. ")
          ],
          -1
          /* CACHED */
        )),
        _cache[5] || (_cache[5] = createBaseVNode(
          "p",
          null,
          [
            createBaseVNode("strong", null, "Text Only:"),
            createTextVNode(" Choose the ''No Graphic'' option in the drop-down above to add up to 5 lines of text personalization. ")
          ],
          -1
          /* CACHED */
        )),
        _cache[6] || (_cache[6] = createBaseVNode(
          "p",
          null,
          [
            createBaseVNode("strong", null, "Custom:"),
            createTextVNode(" To completely customize this product call us today! ")
          ],
          -1
          /* CACHED */
        ))
      ]),
      _cache[7] || (_cache[7] = createBaseVNode(
        "div",
        {
          class: "remodal message-view",
          "data-remodal-id": "modal",
          "data-remodal-options": "hashTracking: true, closeOnOutsideClick: true"
        },
        [
          createBaseVNode("button", {
            "data-remodal-action": "close",
            class: "right-0 !left-auto remodal-close"
          }),
          createBaseVNode("div", {
            id: "message-options-help-content",
            class: "view configurator-step__description-help-content"
          }, [
            createBaseVNode("p", null, [
              createBaseVNode("strong", null, "Sentiment, Story, or Graphic Choices")
            ]),
            createBaseVNode("div", null, "What is a Sentiment?"),
            createBaseVNode("p", null, " Select trophies offer a choice of sentiments, also known as a pre-written verse, that incorporate the recipients name within the verse like a plaque as well as additional personalization under the sentiment/verse. These sentiments help you incorporate the words that you would like to express for your award without you having to write it or create a custom award. "),
            createBaseVNode("div", null, "What is a Story?"),
            createBaseVNode("p", null, " Select trophies offer a choice of over 100 character stories that originate with an icon such as an animal or general graphic and are geared towards every type of recognition occasion such as teamwork, excellence, and thank you. These stories are the perfect way to express your appreciation, and also eliminate the need for a custom written award. "),
            createBaseVNode("div", null, "What is a Graphic?"),
            createBaseVNode("div", null, " Select trophies offer a choice of stock graphic options that express specific award sentiments such as Above & Beyond or Excellence. You can then add additional text personalization to the award along with the chosen graphic. ")
          ])
        ],
        -1
        /* CACHED */
      ))
    ]);
  }
  var __default__27, _hoisted_139, message_description_default;
  var init_message_description2 = __esm({
    "src/vue/components/shared/message-description.vue"() {
      "use strict";
      init_vue_esm_bundler();
      init_message_description();
      __default__27 = {
        setup() {
          const open = () => {
            window.jQuery("[data-remodal-id=modal]")?.remodal()?.open();
          };
          return {
            open
          };
        }
      };
      _hoisted_139 = { class: "configurator-step__description" };
      __default__27.render = render28;
      __default__27.__scopeId = "data-v-4c17c071";
      message_description_default = __default__27;
    }
  });

  // src/vue/components/shared/font-szie.vue
  var font_szie_exports = {};
  __export(font_szie_exports, {
    default: () => font_szie_default,
    render: () => render29
  });
  function render29(_ctx, _cache) {
    return openBlock(), createElementBlock("div", _hoisted_140, [
      (openBlock(true), createElementBlock(
        Fragment,
        null,
        renderList(_ctx.line.sizes, (size, key) => {
          return openBlock(), createElementBlock("form", {
            key,
            "data-value": size.size,
            "aria-label": `Select ${size.size} font size for Line ${key + 1}`,
            tabindex: "0",
            class: "flex h-12 bg-white border border-gray-400 first:rounded-l last:rounded-r hover:bg-gray-600"
          }, [
            createBaseVNode("input", {
              id: `line${_ctx.index}${key + 1}_${size.size}`,
              class: "absolute invisible peer",
              type: "radio",
              tabindex: "-1",
              name: "Line 1_fontSize",
              value: _ctx.getFontSizeName[`size${_ctx.index + 1}`].font_size,
              checked: _ctx.getFontSizeName[`size${_ctx.index + 1}`].size === _ctx.sizeName[key],
              onChange: ($event) => _ctx.changeFontSize(size.font_size, _ctx.index, key)
            }, null, 40, _hoisted_320),
            createBaseVNode("label", {
              for: `line${_ctx.index}${key + 1}_${size.size}`,
              class: normalizeClass(["flex items-center justify-center w-12 h-full px-1 font-bold text-center cursor-pointer text-red-50 peer-checked:bg-gray-700", size.size === "big" ? "text-xl" : "text-xs"])
            }, [..._cache[0] || (_cache[0] = [
              createBaseVNode(
                "span",
                { class: "pointer-events-none" },
                "A",
                -1
                /* CACHED */
              )
            ])], 10, _hoisted_418)
          ], 8, _hoisted_230);
        }),
        128
        /* KEYED_FRAGMENT */
      ))
    ]);
  }
  var __default__28, _hoisted_140, _hoisted_230, _hoisted_320, _hoisted_418, font_szie_default;
  var init_font_szie = __esm({
    "src/vue/components/shared/font-szie.vue"() {
      "use strict";
      init_vue_esm_bundler();
      init_vuex_esm_bundler();
      init_vue_esm_bundler();
      __default__28 = {
        props: {
          line: {
            type: Object,
            required: true
          },
          index: Number
        },
        setup(_2, { emit: emit2 }) {
          const store2 = useStore();
          const fontSize = computed2(() => store2.getters.getFontSize);
          const activeIndex = computed2(() => store2.getters.getActiveIndex);
          const getFontSizeName = computed2(
            () => store2.getters.getFontSizeNameById(activeIndex.value)
          );
          const sizeName = ["small", "big"];
          const changeFontSize = (size, index, key) => {
            const prevFontSize = [...fontSize.value];
            prevFontSize[index] = size;
            store2.dispatch("saveFontSize", prevFontSize);
            emit2("updateFontSize", { index, key });
            const items = {
              ...getFontSizeName.value,
              [`size${index + 1}`]: {
                size: sizeName[key],
                font_size: size
              }
            };
            store2.dispatch("updateFontSizeName", {
              item: items,
              index: activeIndex.value
            });
          };
          return {
            fontSize,
            getFontSizeName,
            sizeName,
            changeFontSize
          };
        }
      };
      _hoisted_140 = { class: "flex justify-end w-24 ml-2" };
      _hoisted_230 = ["data-value", "aria-label"];
      _hoisted_320 = ["id", "value", "checked", "onChange"];
      _hoisted_418 = ["for"];
      __default__28.render = render29;
      font_szie_default = __default__28;
    }
  });

  // src/vue/components/shared/step-input.vue
  var step_input_exports = {};
  __export(step_input_exports, {
    default: () => step_input_default,
    render: () => render30
  });
  function render30(_ctx, _cache) {
    const _component_FontSize = resolveComponent("FontSize");
    return openBlock(), createElementBlock(
      "div",
      {
        class: normalizeClass(["flex w-full mb-4", _ctx.type === "textarea" && "flex-col"])
      },
      [
        createBaseVNode("label", {
          for: _ctx.id,
          class: "py-2 mr-4 text-base font-bold"
        }, [
          createBaseVNode(
            "span",
            _hoisted_231,
            toDisplayString(_ctx.labelText),
            1
            /* TEXT */
          )
        ], 8, _hoisted_141),
        createBaseVNode("div", _hoisted_321, [
          (openBlock(), createBlock(resolveDynamicComponent(_ctx.type), {
            id: _ctx.id,
            value: _ctx.modelValue,
            type: "text",
            name: _ctx.id,
            maxlength: _ctx.limit,
            class: "w-full h-12 px-3 py-1 border border-gray-400 rounded",
            onKeyup: _cache[0] || (_cache[0] = ($event) => _ctx.change($event))
          }, null, 40, ["id", "value", "name", "maxlength"])),
          !isNaN(_ctx.count) ? (openBlock(), createElementBlock(
            "p",
            _hoisted_419,
            toDisplayString(_ctx.count) + " characters remaining ",
            1
            /* TEXT */
          )) : createCommentVNode("v-if", true)
        ]),
        _ctx.line.sizes?.length > 1 && _ctx.line.label !== "linelp" ? (openBlock(), createBlock(_component_FontSize, {
          key: 0,
          line: _ctx.line,
          index: _ctx.index,
          onUpdateFontSize: _ctx.updateFontSize
        }, null, 8, ["line", "index", "onUpdateFontSize"])) : createCommentVNode("v-if", true)
      ],
      2
      /* CLASS */
    );
  }
  var import_lodash7, __default__29, _hoisted_141, _hoisted_231, _hoisted_321, _hoisted_419, step_input_default;
  var init_step_input = __esm({
    "src/vue/components/shared/step-input.vue"() {
      "use strict";
      import_lodash7 = __toESM(require_lodash());
      init_vue_esm_bundler();
      init_vuex_esm_bundler();
      init_font_szie();
      init_vue_esm_bundler();
      __default__29 = {
        components: { FontSize: font_szie_default },
        props: {
          id: {
            type: String,
            required: true
          },
          labelText: {
            type: String,
            required: true
          },
          modelValue: {
            type: String,
            default: ""
          },
          line: {
            type: Object,
            required: true
          },
          index: {
            type: Number,
            required: true
          },
          type: {
            type: String,
            default: "input"
          }
        },
        emits: ["update:modelValue"],
        setup(props, { emit: emit2 }) {
          const store2 = useStore();
          const sizeIndex = ref(0);
          const limit = computed2(
            () => store2.getters.getLayout ? (0, import_lodash7.find)(props.line?.layouts, ["layout", store2.getters.getLayout])?.character_limit : props.line?.sizes && props.line?.sizes[sizeIndex.value]?.character_limit || props.line?.character_limit
          );
          const count = ref(limit.value);
          const updateInput = (text = props.modelValue) => {
            const textVal = text?.slice(0, limit.value);
            count.value = limit.value - textVal?.length;
            emit2("update:modelValue", textVal);
          };
          const change = (e) => {
            updateInput(e.target.value);
          };
          updateInput();
          const updateFontSize = (size) => sizeIndex.value = size.key;
          watch2(sizeIndex, () => {
            updateInput();
          });
          return {
            count,
            limit,
            change,
            updateFontSize
          };
        }
      };
      _hoisted_141 = ["for"];
      _hoisted_231 = { class: "property__text" };
      _hoisted_321 = { class: "flex flex-col flex-1" };
      _hoisted_419 = {
        key: 0,
        class: "mt-2 text-base"
      };
      __default__29.render = render30;
      step_input_default = __default__29;
    }
  });

  // src/vue/components/shared/personalization-option-input.vue
  var personalization_option_input_exports = {};
  __export(personalization_option_input_exports, {
    default: () => personalization_option_input_default,
    render: () => render31
  });
  function render31(_ctx, _cache) {
    const _component_StepInput = resolveComponent("StepInput");
    return openBlock(), createElementBlock(
      Fragment,
      null,
      [
        _ctx.show_add_another ? (openBlock(), createElementBlock("p", _hoisted_146, [
          createBaseVNode(
            "button",
            {
              class: "tracking-wide button button-product font-mont !text-xl",
              onClick: _cache[0] || (_cache[0] = (...args) => _ctx.add && _ctx.add(...args))
            },
            " + " + toDisplayString(_ctx.label),
            1
            /* TEXT */
          )
        ])) : createCommentVNode("v-if", true),
        createBaseVNode(
          "div",
          {
            class: normalizeClass([_ctx.items.length < 2 && "pt-4 mt-4 border-t border-teal-200", ""])
          },
          [
            (openBlock(true), createElementBlock(
              Fragment,
              null,
              renderList(_ctx.items, (item, key) => {
                return openBlock(), createElementBlock("div", { key }, [
                  key !== _ctx.index ? (openBlock(), createElementBlock("div", _hoisted_235, [
                    createBaseVNode("h3", _hoisted_324, [
                      createBaseVNode(
                        "span",
                        _hoisted_420,
                        "Item " + toDisplayString(key + 1),
                        1
                        /* TEXT */
                      ),
                      createBaseVNode("span", {
                        class: "text-base cursor-pointer",
                        onClick: ($event) => _ctx.edit(key)
                      }, "(Edit)", 8, _hoisted_515)
                    ]),
                    createBaseVNode("div", _hoisted_611, [
                      (openBlock(true), createElementBlock(
                        Fragment,
                        null,
                        renderList(Object.values(item), (value, index) => {
                          return openBlock(), createElementBlock("div", {
                            key: index,
                            class: "mb-1"
                          }, [
                            value ? (openBlock(), createElementBlock(
                              "span",
                              _hoisted_710,
                              "Line " + toDisplayString(index + 1) + ":",
                              1
                              /* TEXT */
                            )) : createCommentVNode("v-if", true),
                            value ? (openBlock(), createElementBlock(
                              "span",
                              _hoisted_87,
                              toDisplayString(value),
                              1
                              /* TEXT */
                            )) : createCommentVNode("v-if", true)
                          ]);
                        }),
                        128
                        /* KEYED_FRAGMENT */
                      ))
                    ])
                  ])) : createCommentVNode("v-if", true)
                ]);
              }),
              128
              /* KEYED_FRAGMENT */
            )),
            createBaseVNode(
              "div",
              {
                class: normalizeClass(["", _ctx.items.length > 1 && "p-4 bg-white rounded"])
              },
              [
                _ctx.items.length > 1 ? (openBlock(), createElementBlock("h3", _hoisted_96, [
                  createBaseVNode(
                    "span",
                    _hoisted_106,
                    "Item " + toDisplayString(_ctx.index + 1),
                    1
                    /* TEXT */
                  )
                ])) : createCommentVNode("v-if", true),
                (openBlock(true), createElementBlock(
                  Fragment,
                  null,
                  renderList(_ctx.filteredLines, (line, index) => {
                    return openBlock(), createBlock(_component_StepInput, {
                      id: `line${index + 1}`,
                      key: index,
                      modelValue: _ctx.item[`line${index + 1}`],
                      "onUpdate:modelValue": ($event) => _ctx.item[`line${index + 1}`] = $event,
                      index,
                      "label-text": line?.label || `Line ${index + 1}:`,
                      line,
                      type: line?.label === "Gift Message" || line?.type === "textarea" ? "textarea" : "input"
                    }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "index", "label-text", "line", "type"]);
                  }),
                  128
                  /* KEYED_FRAGMENT */
                ))
              ],
              2
              /* CLASS */
            ),
            _ctx.items.length > 1 ? (openBlock(), createElementBlock("div", _hoisted_1114, [
              createBaseVNode("button", {
                class: "bg-white button button-secondary !font-bold font-mont !border-2 border-gray-100 color-gray-100 hover:bg-gray-100",
                onClick: _cache[1] || (_cache[1] = ($event) => _ctx.remove(_ctx.index))
              }, " - Remove "),
              _cache[2] || (_cache[2] = createBaseVNode(
                "p",
                { class: "hidden" },
                "This product has a minimum quantity of 1",
                -1
                /* CACHED */
              ))
            ])) : createCommentVNode("v-if", true)
          ],
          2
          /* CLASS */
        )
      ],
      64
      /* STABLE_FRAGMENT */
    );
  }
  var __default__30, _hoisted_146, _hoisted_235, _hoisted_324, _hoisted_420, _hoisted_515, _hoisted_611, _hoisted_710, _hoisted_87, _hoisted_96, _hoisted_106, _hoisted_1114, personalization_option_input_default;
  var init_personalization_option_input = __esm({
    "src/vue/components/shared/personalization-option-input.vue"() {
      "use strict";
      init_vue_esm_bundler();
      init_step_input();
      init_vuex_esm_bundler();
      init_vue_esm_bundler();
      __default__30 = {
        components: { StepInput: step_input_default },
        props: {
          lines: {
            type: Object,
            required: true
          },
          label: {
            type: String,
            default: "add another"
          },
          show_add_another: Boolean
        },
        setup(props) {
          const store2 = useStore();
          const scene7Id = computed2(() => store2.getters.getScene7Id);
          const item = ref({});
          const items = computed2(() => store2.getters.getItems);
          const fontSizeName = computed2(() => store2.getters.getLastFontSizeName);
          const index = ref(0);
          item.value = {
            ...item.value,
            ...store2.getters.getLastItem
          };
          const update3 = () => {
            index.value = store2.getters.getItemSize;
            store2.dispatch("saveQuantity", index.value + 1);
            store2.dispatch("updateActiveIndex", index.value);
          };
          const add = () => {
            store2.dispatch("saveItems", { ...item.value });
            store2.dispatch("saveFontSizeName", { ...fontSizeName.value });
            update3();
          };
          const edit = (key) => {
            index.value = key;
            store2.dispatch("updateActiveIndex", key);
            const getItem = store2.getters.getItemById(key);
            Object.assign(item.value, getItem);
          };
          const remove2 = (key) => {
            const idx = key - 1 >= 0 ? key - 1 : 0;
            store2.dispatch("deleteItem", key);
            store2.dispatch("deleteFontSizeName", key);
            update3();
            edit(idx);
          };
          const filteredLines = computed2(() => {
            if (!("active_only_if_no_graphic" in props.lines[0])) {
              return props.lines;
            }
            return props.lines.filter((line) => {
              return scene7Id.value === "NOGRAPHIC" ? line : line.active_only_if_no_graphic === false;
            });
          });
          watch2(item.value, () => {
            store2.dispatch("updateItem", {
              item: { ...item.value },
              index: index.value
            });
          });
          return {
            filteredLines,
            item,
            items,
            add,
            edit,
            remove: remove2,
            index
          };
        }
      };
      _hoisted_146 = {
        key: 0,
        class: "flex justify-end"
      };
      _hoisted_235 = {
        key: 0,
        class: "flex items-center pt-4 mt-4 mb-4 border-t border-teal-200"
      };
      _hoisted_324 = { class: "heading heading--6 heading--center flex !text-xl font-bold leading-none flex-col !mb-0" };
      _hoisted_420 = { class: "text-gray-100" };
      _hoisted_515 = ["onClick"];
      _hoisted_611 = { class: "flex flex-col ml-4" };
      _hoisted_710 = {
        key: 0,
        class: "pr-1 font-medium font-capitalize"
      };
      _hoisted_87 = {
        key: 1,
        class: "font-medium font-capitalize"
      };
      _hoisted_96 = {
        key: 0,
        class: "heading heading--6 heading--center flex !text-xl font-bold leading-none flex-col"
      };
      _hoisted_106 = { class: "text-gray-100" };
      _hoisted_1114 = {
        key: 0,
        class: "mt-4 configurator-quantity-group__actions"
      };
      __default__30.render = render31;
      personalization_option_input_default = __default__30;
    }
  });

  // vue-style:C:\fork\Baudville\src\vue\components\shared\message-options.vue
  var init_message_options = __esm({
    "vue-style:C:\\fork\\Baudville\\src\\vue\\components\\shared\\message-options.vue"() {
    }
  });

  // src/vue/components/shared/message-options.vue
  var message_options_exports = {};
  __export(message_options_exports, {
    default: () => message_options_default,
    render: () => render32
  });
  function render32(_ctx, _cache) {
    const _component_MessageDescription = resolveComponent("MessageDescription");
    const _component_PersonalizationOptionInput = resolveComponent("PersonalizationOptionInput");
    const _component_DivContainer = resolveComponent("DivContainer");
    return openBlock(), createBlock(_component_DivContainer, null, {
      default: withCtx(() => [
        _ctx.certificateTemp ? (openBlock(), createBlock(_component_MessageDescription, { key: 0 })) : createCommentVNode("v-if", true),
        _ctx.activeLayout ? (openBlock(), createElementBlock("div", _hoisted_147, [
          _cache[2] || (_cache[2] = createBaseVNode(
            "p",
            { class: "mb-4 text-sm font-bold" },
            "Choose a Layout",
            -1
            /* CACHED */
          )),
          createBaseVNode("div", _hoisted_236, [
            (openBlock(true), createElementBlock(
              Fragment,
              null,
              renderList(_ctx.layouts, (layout) => {
                return openBlock(), createElementBlock("div", {
                  key: layout.value,
                  class: "inline-block w-32 mx-1 mb-4 thumbnail-list-item"
                }, [
                  (openBlock(), createElementBlock("input", {
                    id: "`layout_${layout.value}`",
                    key: layout.value,
                    type: "radio",
                    name: "layout",
                    class: "absolute invisible thumbnail-list-item__input",
                    value: layout.value
                  }, null, 8, _hoisted_325)),
                  createBaseVNode("label", {
                    for: "`layout_${layout.value}`",
                    tabindex: "0",
                    class: normalizeClass([
                      "block p-0 border border-gray-400 rounded cursor-pointer",
                      _ctx.activeLayout === layout.value && "pointer-events-none layout-active"
                    ]),
                    onClick: ($event) => _ctx.selectLayout(layout.value)
                  }, [
                    createBaseVNode("div", _hoisted_516, [
                      createBaseVNode("img", {
                        src: `https://s7d7.scene7.com/is/image/Baudville/${layout.value == "L" ? "Landscape" : "Portrait"}?&$bv_config_graphic_thumb_wide_2x$`
                      }, null, 8, _hoisted_612),
                      createBaseVNode(
                        "div",
                        _hoisted_711,
                        toDisplayString(layout.value == "L" ? "Landscape" : "Portrait"),
                        1
                        /* TEXT */
                      )
                    ])
                  ], 10, _hoisted_421)
                ]);
              }),
              128
              /* KEYED_FRAGMENT */
            ))
          ])
        ])) : createCommentVNode("v-if", true),
        _ctx.type === "select" ? (openBlock(), createElementBlock("div", _hoisted_88, [
          (openBlock(true), createElementBlock(
            Fragment,
            null,
            renderList(_ctx.options, (option, key) => {
              return openBlock(), createElementBlock("div", {
                key,
                class: "mb-6"
              }, [
                _ctx.showMessageDescription(_ctx.text, _ctx.options.length) ? (openBlock(), createBlock(_component_MessageDescription, { key: 0 })) : createCommentVNode("v-if", true),
                createBaseVNode("div", _hoisted_97, [
                  createBaseVNode("div", _hoisted_107, [
                    createBaseVNode("p", _hoisted_1115, [
                      createBaseVNode(
                        "label",
                        _hoisted_1211,
                        toDisplayString(option.label),
                        1
                        /* TEXT */
                      )
                    ])
                  ]),
                  createBaseVNode("div", _hoisted_1310, [
                    createBaseVNode("select", {
                      id: "option-" + option.id,
                      class: "w-full px-4 py-2 border-gray-200 focus:ring-0 focus:outline-none",
                      onChange: ($event) => _ctx.change($event, option.category)
                    }, [
                      (openBlock(true), createElementBlock(
                        Fragment,
                        null,
                        renderList(_ctx.selectOptions(option), (setting, key2) => {
                          return openBlock(), createElementBlock("option", {
                            key: key2,
                            selected: _ctx.defaultSelected(setting, option.category),
                            value: JSON.stringify(setting),
                            textContent: toDisplayString(setting.name)
                          }, null, 8, _hoisted_155);
                        }),
                        128
                        /* KEYED_FRAGMENT */
                      ))
                    ], 40, _hoisted_148)
                  ])
                ]),
                _ctx.text ? (openBlock(), createElementBlock("div", {
                  key: 1,
                  class: "mt-8 text-sm font-medium leading-6 text-center text-gray-100 whitespace-pre-wrap font-mont",
                  innerHTML: _ctx.text
                }, null, 8, _hoisted_165)) : createCommentVNode("v-if", true)
              ]);
            }),
            128
            /* KEYED_FRAGMENT */
          ))
        ])) : createCommentVNode("v-if", true),
        _ctx.type === "radio" ? (openBlock(), createElementBlock("div", _hoisted_175, [
          createBaseVNode("div", _hoisted_184, [
            (openBlock(true), createElementBlock(
              Fragment,
              null,
              renderList(_ctx.options, (option, key) => {
                return openBlock(), createElementBlock("div", {
                  key,
                  class: "mb-6"
                }, [
                  option.category !== "locations" ? (openBlock(), createElementBlock(
                    "p",
                    _hoisted_194,
                    toDisplayString(option.label),
                    1
                    /* TEXT */
                  )) : createCommentVNode("v-if", true),
                  _ctx.isSelectOrProductCategory(option.category) ? (openBlock(), createElementBlock("div", _hoisted_204, [
                    (openBlock(true), createElementBlock(
                      Fragment,
                      null,
                      renderList(_ctx.getRadioData(option.settings), (setting, key2) => {
                        return openBlock(), createElementBlock("div", {
                          key: key2,
                          class: "overflow-visible"
                        }, [
                          (setting.category ? setting.category == _ctx.radioSelect : true) ? (openBlock(), createElementBlock("div", _hoisted_2112, [
                            createBaseVNode("input", {
                              id: setting.value,
                              type: "radio",
                              name: "layout",
                              class: "absolute invisible thumbnail-list-item__input",
                              value: setting.value,
                              checked: _ctx.scene7Id === setting.value,
                              onChange: ($event) => _ctx.updateScene7Id(setting)
                            }, null, 40, _hoisted_2210),
                            createBaseVNode("label", {
                              for: setting.value,
                              tabindex: "0",
                              class: normalizeClass([
                                "block p-0 border border-gray-400 rounded cursor-pointer",
                                _ctx.scene7Id === setting.value && "pointer-events-none layout-active"
                              ])
                            }, [
                              createBaseVNode("div", _hoisted_244, [
                                createBaseVNode("img", {
                                  src: `https://s7d7.scene7.com/is/image/Baudville/${setting.thumbnail?.indexOf("?") != -1 ? setting.thumbnail + "&" : setting.thumbnail + "?"}$bv_config_graphic_thumb_wide_2x$`
                                }, null, 8, _hoisted_254),
                                createBaseVNode(
                                  "div",
                                  _hoisted_264,
                                  toDisplayString(setting.name),
                                  1
                                  /* TEXT */
                                )
                              ])
                            ], 10, _hoisted_237)
                          ])) : createCommentVNode("v-if", true)
                        ]);
                      }),
                      128
                      /* KEYED_FRAGMENT */
                    ))
                  ])) : createCommentVNode("v-if", true),
                  option.category === "select" || option.category === "product" ? (openBlock(), createElementBlock("div", _hoisted_273, [
                    withDirectives(createBaseVNode("select", {
                      id: "option-" + option.id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.radioSelect = $event),
                      class: "w-full px-4 py-2 border-gray-200 focus:ring-0 focus:outline-none"
                    }, [
                      (openBlock(true), createElementBlock(
                        Fragment,
                        null,
                        renderList(option.settings, (setting, key2) => {
                          return openBlock(), createElementBlock("option", {
                            key: key2,
                            value: setting.value,
                            textContent: toDisplayString(setting.name)
                          }, null, 8, _hoisted_293);
                        }),
                        128
                        /* KEYED_FRAGMENT */
                      ))
                    ], 8, _hoisted_283), [
                      [vModelSelect, _ctx.radioSelect]
                    ])
                  ])) : createCommentVNode("v-if", true)
                ]);
              }),
              128
              /* KEYED_FRAGMENT */
            ))
          ]),
          _ctx.renderTemplate ? (openBlock(), createElementBlock("div", _hoisted_303, [
            _cache[3] || (_cache[3] = createBaseVNode(
              "p",
              { class: "mb-3" },
              [
                createBaseVNode("label", {
                  for: "option-1",
                  class: "text-sm font-bold"
                }, "Choose Graphic Location")
              ],
              -1
              /* CACHED */
            )),
            createBaseVNode("div", _hoisted_3110, [
              createBaseVNode(
                "select",
                {
                  class: "w-full px-4 py-2 border-gray-200 focus:ring-0 focus:outline-none",
                  onChange: _cache[1] || (_cache[1] = ($event) => _ctx.saveRenderTemplate($event))
                },
                [
                  (openBlock(true), createElementBlock(
                    Fragment,
                    null,
                    renderList(_ctx.images.slice(0, 2), (image, key) => {
                      return openBlock(), createElementBlock("option", {
                        key,
                        selected: image.value === _ctx.renderTemplate,
                        value: image.value,
                        textContent: toDisplayString(image.view || image.name)
                      }, null, 8, _hoisted_326);
                    }),
                    128
                    /* KEYED_FRAGMENT */
                  ))
                ],
                32
                /* NEED_HYDRATION */
              )
            ])
          ])) : createCommentVNode("v-if", true),
          createVNode(_component_PersonalizationOptionInput, {
            label: "add another kit",
            lines: _ctx.lines || {},
            show_add_another: _ctx.renderTemplate ? false : true
          }, null, 8, ["lines", "show_add_another"])
        ])) : createCommentVNode("v-if", true)
      ]),
      _: 1
      /* STABLE */
    });
  }
  var import_lodash8, __default__31, _hoisted_147, _hoisted_236, _hoisted_325, _hoisted_421, _hoisted_516, _hoisted_612, _hoisted_711, _hoisted_88, _hoisted_97, _hoisted_107, _hoisted_1115, _hoisted_1211, _hoisted_1310, _hoisted_148, _hoisted_155, _hoisted_165, _hoisted_175, _hoisted_184, _hoisted_194, _hoisted_204, _hoisted_2112, _hoisted_2210, _hoisted_237, _hoisted_244, _hoisted_254, _hoisted_264, _hoisted_273, _hoisted_283, _hoisted_293, _hoisted_303, _hoisted_3110, _hoisted_326, message_options_default;
  var init_message_options2 = __esm({
    "src/vue/components/shared/message-options.vue"() {
      "use strict";
      import_lodash8 = __toESM(require_lodash());
      init_vue_esm_bundler();
      init_vuex_esm_bundler();
      init_div_container2();
      init_message_description2();
      init_personalization_option_input();
      init_vue_esm_bundler();
      init_message_options();
      __default__31 = defineComponent({
        components: { DivContainer: div_container_default, PersonalizationOptionInput: personalization_option_input_default, MessageDescription: message_description_default },
        props: {
          options: {
            type: Object,
            required: true
          },
          type: {
            type: String,
            default: "select"
          },
          images: Object
        },
        setup(props) {
          const store2 = useStore();
          const activeLayout = computed2({
            get() {
              return store2.getters.getLayout;
            },
            set(layout) {
              store2.dispatch("saveLayout", layout);
            }
          });
          const layouts = computed2(() => store2.getters.getLayouts);
          const renderTemplate = computed2(() => store2.getters.getRenderTemplate);
          const certificateTemp = computed2(() => store2.getters.getCertificateTemp);
          const scene7Id = ref(computed2(() => store2.getters.getScene7Id));
          const emblemId = ref(computed2(() => store2.getters.getEmblem));
          const locations = computed2({
            get() {
              return store2.getters.getLocations;
            },
            set(newValue) {
              store2.dispatch("saveLocations", newValue);
            }
          });
          const titleGraphicCategoriesId = computed2(
            () => store2.getters.getTitleGraphicCategories
          );
          const text = ref(props?.options[0]?.settings[0]?.description);
          const lines = ref(
            computed2(
              () => (0, import_lodash8.filter)(
                props?.options[titleGraphicCategoriesId.value ? 1 : 0]?.settings,
                ["value", scene7Id.value]
              )[0]?.lines
            )
          );
          const radioSelect = ref(
            (0, import_lodash8.filter)(props?.options[0]?.settings, [
              "value",
              titleGraphicCategoriesId.value
            ])[0]?.value
          );
          const change = (event, category = "sentiment") => {
            const setting = JSON.parse(event.target.value);
            if (category === "emblem") {
              store2.dispatch(
                "saveEmblem",
                setting?.value || (0, import_lodash8.filter)(setting.layouts, ["layout", activeLayout.value])[0]?.value
              );
            } else if (category === "sentiment") {
              text.value = setting.description;
              store2.dispatch(
                "saveScene7Id",
                setting?.value || (0, import_lodash8.filter)(setting.layouts, ["layout", activeLayout.value])[0]?.value
              );
            } else if (category === "product") {
              const setting2 = JSON.parse(event.target.value);
              store2.dispatch("saveTitleGraphicCategories", setting2?.value || 1);
            } else if (category === "locations") {
              locations.value = setting?.value;
            }
          };
          const updateScene7Id = (setting) => {
            store2.dispatch("saveScene7Id", setting.value);
            if (setting?.product_color?.hex_value) {
              store2.dispatch("saveProductColor", setting?.product_color?.hex_value);
            }
            if (setting?.logo_text_color) {
              store2.dispatch(
                "saveTemplateColor",
                setting?.logo_text_color?.hex_value
              );
            }
          };
          const selectLayout = (value) => {
            (0, import_lodash8.each)(props.options, (option) => {
              if (option.category == "emblem") {
                const property = (0, import_lodash8.filter)(option.settings, {
                  layouts: [{ value: emblemId.value }]
                })[0]?.layouts;
                if (property) {
                  store2.dispatch(
                    "saveEmblem",
                    (0, import_lodash8.filter)(property, ["layout", value])[0].value
                  );
                }
              }
              if (option.category == "sentiment") {
                const property = (0, import_lodash8.filter)(option.settings, {
                  layouts: [{ value: scene7Id.value }]
                })[0]?.layouts;
                if (property) {
                  store2.dispatch(
                    "saveScene7Id",
                    (0, import_lodash8.filter)(property, ["layout", value])[0].value
                  );
                }
              }
            });
            store2.dispatch("saveLayout", value);
          };
          const defaultSelected = (setting, category) => {
            if (category == "product") {
              return setting.value === titleGraphicCategoriesId.value;
            }
            if (category == "locations") {
              return setting.value === locations.value;
            }
            if (activeLayout.value) {
              if (category == "emblem") {
                return setting?.value || (0, import_lodash8.filter)(setting.layouts, ["layout", activeLayout.value])[0].value === emblemId.value;
              }
              if (category == "locations") {
                return setting;
              }
              return setting?.value || (0, import_lodash8.filter)(setting.layouts, ["layout", activeLayout.value])[0]?.value === scene7Id.value;
            } else {
              if (category == "emblem") {
                return setting.value === emblemId.value;
              }
              return setting.value === scene7Id.value;
            }
          };
          const saveRenderTemplate = (e) => store2.dispatch("saveRenderTemplate", e.target.value);
          const selectOptions = (options) => {
            if (!titleGraphicCategoriesId.value || options.category == "product")
              return options.settings;
            if (options.category == "sentiment") {
              const settings = (0, import_lodash8.filter)(options.settings, [
                "category",
                titleGraphicCategoriesId.value
              ]);
              return settings;
            }
            return options.settings;
          };
          watch2(radioSelect, () => {
            if (renderTemplate?.value) {
              store2.dispatch("saveTitleGraphicCategories", radioSelect.value);
            }
          });
          watch2(lines, () => {
            const property = {};
            (0, import_lodash8.each)(lines.value, (line, index) => {
              property[`line${index + 1}`] = line.default || "";
            });
            store2.dispatch("updateItem", {
              item: { ...property },
              index: 0
            });
          });
          const showMessageDescription = (text2, len) => {
            if ((0, import_lodash8.findIndex)(props.images, ["name", "NO_GRAPHIC_TEMPLATE"]) > -1) {
              if (!text2 && len === 1 && !certificateTemp.value) {
                return true;
              }
            }
            return false;
          };
          const isSelectOrProductCategory = (category) => {
            if (category == "select") {
              return false;
            }
            if (category == "product") {
              return false;
            }
            return true;
          };
          const getRadioData = (options) => {
            if (renderTemplate?.value) {
              return (0, import_lodash8.filter)(options, ["category", titleGraphicCategoriesId.value]);
            }
            return options;
          };
          return {
            text,
            scene7Id,
            activeLayout,
            lines,
            radioSelect,
            renderTemplate,
            certificateTemp,
            titleGraphicCategoriesId,
            layouts,
            locations,
            showMessageDescription,
            selectOptions,
            change,
            selectLayout,
            defaultSelected,
            updateScene7Id,
            saveRenderTemplate,
            isSelectOrProductCategory,
            getRadioData
          };
        }
      });
      _hoisted_147 = {
        key: 1,
        class: "mb-6"
      };
      _hoisted_236 = { class: "w-full" };
      _hoisted_325 = ["value"];
      _hoisted_421 = ["onClick"];
      _hoisted_516 = { class: "pointer-events-none" };
      _hoisted_612 = ["src"];
      _hoisted_711 = { class: "p-4 font-semibold leading-4 text-center text-white bg-gray-400" };
      _hoisted_88 = { key: 2 };
      _hoisted_97 = { class: "" };
      _hoisted_107 = { class: "" };
      _hoisted_1115 = { class: "mb-3" };
      _hoisted_1211 = {
        for: "option-1",
        class: "text-sm font-bold"
      };
      _hoisted_1310 = { class: "w-full" };
      _hoisted_148 = ["id", "onChange"];
      _hoisted_155 = ["selected", "value", "textContent"];
      _hoisted_165 = ["innerHTML"];
      _hoisted_175 = {
        key: 3,
        class: "mh-radio-select"
      };
      _hoisted_184 = { class: "flex flex-col" };
      _hoisted_194 = {
        key: 0,
        class: "mb-3 text-sm font-bold"
      };
      _hoisted_204 = {
        key: 1,
        class: "grid w-full grid-cols-3"
      };
      _hoisted_2112 = {
        key: 0,
        class: "block mx-1 mb-4 thumbnail-list-item"
      };
      _hoisted_2210 = ["id", "value", "checked", "onChange"];
      _hoisted_237 = ["for"];
      _hoisted_244 = { class: "pointer-events-none" };
      _hoisted_254 = ["src"];
      _hoisted_264 = { class: "p-1 font-semibold leading-4 text-center text-white bg-gray-400" };
      _hoisted_273 = {
        key: 2,
        class: "w-full"
      };
      _hoisted_283 = ["id"];
      _hoisted_293 = ["value", "textContent"];
      _hoisted_303 = {
        key: 0,
        class: "mb-6"
      };
      _hoisted_3110 = { class: "w-full" };
      _hoisted_326 = ["selected", "value", "textContent"];
      __default__31.render = render32;
      __default__31.__scopeId = "data-v-18beaa73";
      message_options_default = __default__31;
    }
  });

  // src/vue/components/shared/price-table.vue
  var price_table_exports = {};
  __export(price_table_exports, {
    default: () => price_table_default,
    render: () => render33
  });
  function render33(_ctx, _cache) {
    return _ctx.prices ? (openBlock(), createElementBlock("div", _hoisted_149, [
      createBaseVNode("div", _hoisted_238, [
        createBaseVNode("table", _hoisted_327, [
          createBaseVNode("tbody", null, [
            (openBlock(), createElementBlock(
              Fragment,
              null,
              renderList(2, (i2) => {
                return createBaseVNode("tr", { key: i2 }, [
                  createBaseVNode("th", null, [
                    i2 == 1 ? (openBlock(), createElementBlock("span", _hoisted_423, "Qty")) : (openBlock(), createElementBlock("span", _hoisted_517, "Each"))
                  ]),
                  (openBlock(true), createElementBlock(
                    Fragment,
                    null,
                    renderList(_ctx.prices, (qty, index) => {
                      return openBlock(), createElementBlock("td", { key: index }, [
                        i2 == 1 ? (openBlock(), createElementBlock(
                          "span",
                          _hoisted_613,
                          toDisplayString(qty.min_quantity),
                          1
                          /* TEXT */
                        )) : (openBlock(), createElementBlock(
                          "span",
                          _hoisted_712,
                          toDisplayString(_ctx.sale(qty)),
                          1
                          /* TEXT */
                        ))
                      ]);
                    }),
                    128
                    /* KEYED_FRAGMENT */
                  ))
                ]);
              }),
              64
              /* STABLE_FRAGMENT */
            ))
          ])
        ])
      ])
    ])) : createCommentVNode("v-if", true);
  }
  var __default__32, _hoisted_149, _hoisted_238, _hoisted_327, _hoisted_423, _hoisted_517, _hoisted_613, _hoisted_712, price_table_default;
  var init_price_table = __esm({
    "src/vue/components/shared/price-table.vue"() {
      "use strict";
      init_vuex_esm_bundler();
      init_vue_esm_bundler();
      init_vue_esm_bundler();
      __default__32 = {
        setup() {
          const store2 = useStore();
          const prices = computed2(() => store2.getters.getPrices);
          const price = (price2) => window.Shopify.formatMoney(price2);
          const sale = (qty) => {
            let on_sale = qty.sale;
            if (!on_sale) {
              if (qty.clearance > 0) {
                on_sale = qty.clearance;
              }
            }
            if (on_sale) {
              return price(on_sale);
            } else {
              return price(qty.regular);
            }
          };
          return {
            prices,
            price,
            sale
          };
        }
      };
      _hoisted_149 = {
        key: 0,
        class: "pt-4 configurator-pricing"
      };
      _hoisted_238 = { class: "product-details__quantity-pricing" };
      _hoisted_327 = { class: "table table--enhanced" };
      _hoisted_423 = { key: 0 };
      _hoisted_517 = { key: 1 };
      _hoisted_613 = { key: 0 };
      _hoisted_712 = { key: 1 };
      __default__32.render = render33;
      price_table_default = __default__32;
    }
  });

  // vue-style:C:\fork\Baudville\src\vue\components\shared\personalization-option.vue
  var init_personalization_option = __esm({
    "vue-style:C:\\fork\\Baudville\\src\\vue\\components\\shared\\personalization-option.vue"() {
    }
  });

  // src/vue/components/shared/personalization-option.vue
  var personalization_option_exports = {};
  __export(personalization_option_exports, {
    default: () => personalization_option_default,
    render: () => render34
  });
  function render34(_ctx, _cache) {
    const _component_PriceTable = resolveComponent("PriceTable");
    const _component_PersonalizationOptionInput = resolveComponent("PersonalizationOptionInput");
    const _component_DivContainer = resolveComponent("DivContainer");
    return openBlock(), createBlock(_component_DivContainer, null, {
      default: withCtx(() => [
        _ctx.message ? (openBlock(), createElementBlock("div", _hoisted_150, [
          createBaseVNode(
            "div",
            null,
            toDisplayString(_ctx.message),
            1
            /* TEXT */
          )
        ])) : createCommentVNode("v-if", true),
        createBaseVNode("div", _hoisted_239, [
          createBaseVNode("div", _hoisted_328, [
            createBaseVNode("div", _hoisted_424, [
              createBaseVNode("div", _hoisted_518, [
                withDirectives(createBaseVNode(
                  "input",
                  {
                    id: "personalization[no]",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.personalization = $event),
                    type: "radio",
                    name: "personalization-toggle",
                    value: false
                  },
                  null,
                  512
                  /* NEED_PATCH */
                ), [
                  [vModelRadio, _ctx.personalization]
                ])
              ]),
              _cache[6] || (_cache[6] = createBaseVNode(
                "label",
                {
                  for: "personalization[no]",
                  class: "text-sm font-bold"
                },
                [
                  createBaseVNode("span", { class: "" }, "No Personalization")
                ],
                -1
                /* CACHED */
              ))
            ]),
            createBaseVNode("div", _hoisted_614, [
              createBaseVNode("div", _hoisted_713, [
                withDirectives(createBaseVNode(
                  "input",
                  {
                    id: "personalization[yes]",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.personalization = $event),
                    type: "radio",
                    name: "personalization[yes]",
                    value: true
                  },
                  null,
                  512
                  /* NEED_PATCH */
                ), [
                  [vModelRadio, _ctx.personalization]
                ])
              ]),
              _cache[7] || (_cache[7] = createBaseVNode(
                "label",
                {
                  for: "personalization[yes]",
                  class: "text-sm font-bold"
                },
                [
                  createBaseVNode("span", { class: "" }, "Personalization - Enter text below")
                ],
                -1
                /* CACHED */
              ))
            ])
          ]),
          Object.keys(_ctx.fonts).length ? (openBlock(), createElementBlock("div", _hoisted_89, [
            createBaseVNode("div", _hoisted_98, [
              _cache[8] || (_cache[8] = createBaseVNode(
                "p",
                { class: "mb-2" },
                [
                  createBaseVNode("label", {
                    for: "choose-fonts",
                    class: "text-sm font-bold"
                  }, "Choose A Font")
                ],
                -1
                /* CACHED */
              )),
              createBaseVNode("div", _hoisted_108, [
                createBaseVNode(
                  "select",
                  {
                    id: "choose-fonts",
                    class: "w-full h-12 px-4 py-2 border-gray-200 focus:ring-0 focus:outline-none",
                    onChange: _cache[2] || (_cache[2] = ($event) => _ctx.changeFont($event))
                  },
                  [
                    (openBlock(true), createElementBlock(
                      Fragment,
                      null,
                      renderList(_ctx.fonts, (font, key) => {
                        return openBlock(), createElementBlock("option", {
                          key,
                          selected: font.default,
                          value: JSON.stringify(font),
                          textContent: toDisplayString(font.name)
                        }, null, 8, _hoisted_1116);
                      }),
                      128
                      /* KEYED_FRAGMENT */
                    ))
                  ],
                  32
                  /* NEED_HYDRATION */
                )
              ])
            ])
          ])) : createCommentVNode("v-if", true),
          _ctx.personalization ? (openBlock(), createElementBlock("div", _hoisted_1212, [
            createVNode(_component_PriceTable),
            createVNode(_component_PersonalizationOptionInput, {
              lines: _ctx.lines,
              show_add_another: _ctx.add_another
            }, null, 8, ["lines", "show_add_another"])
          ])) : createCommentVNode("v-if", true),
          Object.keys(_ctx.verses).length ? (openBlock(), createElementBlock("div", _hoisted_1311, [
            createBaseVNode("div", _hoisted_1410, [
              createBaseVNode("div", _hoisted_156, [
                createBaseVNode(
                  "select",
                  {
                    id: "choose-verses",
                    class: "w-full h-12 px-4 py-2 border-gray-200 focus:ring-0 focus:outline-none",
                    onChange: _cache[3] || (_cache[3] = ($event) => _ctx.changeVerse($event))
                  },
                  [
                    (openBlock(true), createElementBlock(
                      Fragment,
                      null,
                      renderList(_ctx.verses, (verse, key) => {
                        return openBlock(), createElementBlock("option", {
                          key,
                          selected: verse.default,
                          value: JSON.stringify(verse),
                          textContent: toDisplayString(verse.name)
                        }, null, 8, _hoisted_166);
                      }),
                      128
                      /* KEYED_FRAGMENT */
                    ))
                  ],
                  32
                  /* NEED_HYDRATION */
                ),
                _cache[9] || (_cache[9] = createBaseVNode(
                  "p",
                  { class: "my-2" },
                  [
                    createBaseVNode("label", {
                      for: "choose-verses",
                      class: "text-sm font-bold"
                    }, "Enter A Custom Verse")
                  ],
                  -1
                  /* CACHED */
                ))
              ]),
              createBaseVNode("div", _hoisted_176, [
                withDirectives(createBaseVNode(
                  "textarea",
                  {
                    id: "verse",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => _ctx.verseText = $event),
                    maxlength: "750",
                    name: "verse",
                    class: "w-full px-1 py-3 text-center border border-gray-400 rounded h-44 focus:outline-none focus:border-gray-100 focus:transition",
                    onKeyup: _cache[5] || (_cache[5] = ($event) => _ctx.updateVerse($event))
                  },
                  null,
                  544
                  /* NEED_HYDRATION, NEED_PATCH */
                ), [
                  [vModelText, _ctx.verseText]
                ]),
                _cache[10] || (_cache[10] = createBaseVNode(
                  "div",
                  { class: "value__note" },
                  " Write your custom greeting here. 750 characters max. ",
                  -1
                  /* CACHED */
                ))
              ])
            ])
          ])) : createCommentVNode("v-if", true)
        ])
      ]),
      _: 1
      /* STABLE */
    });
  }
  var import_lodash9, __default__33, _hoisted_150, _hoisted_239, _hoisted_328, _hoisted_424, _hoisted_518, _hoisted_614, _hoisted_713, _hoisted_89, _hoisted_98, _hoisted_108, _hoisted_1116, _hoisted_1212, _hoisted_1311, _hoisted_1410, _hoisted_156, _hoisted_166, _hoisted_176, personalization_option_default;
  var init_personalization_option2 = __esm({
    "src/vue/components/shared/personalization-option.vue"() {
      "use strict";
      import_lodash9 = __toESM(require_lodash());
      init_vue_esm_bundler();
      init_div_container2();
      init_price_table();
      init_vuex_esm_bundler();
      init_personalization_option_input();
      init_vue_esm_bundler();
      init_personalization_option();
      __default__33 = {
        components: {
          DivContainer: div_container_default,
          PriceTable: price_table_default,
          PersonalizationOptionInput: personalization_option_input_default
        },
        props: {
          lines: {
            type: Object,
            required: true
          },
          verses: Object,
          fonts: Object,
          price: Boolean,
          add_another: {
            type: Boolean,
            default: true
          },
          message: {
            type: String,
            default: ""
          }
        },
        setup() {
          const store2 = useStore();
          const personalization = ref(true);
          const activeLayout = computed2(() => store2.getters.getLayout);
          const verseText = computed2(() => store2.getters.getVerse);
          const item = ref({});
          const items = computed2(() => store2.getters.getItems);
          const index = ref(0);
          item.value = {
            ...item.value,
            ...store2.getters.getLastItem
          };
          const update3 = () => {
            index.value = store2.getters.getItemSize;
            store2.dispatch("updateActiveIndex", index.value);
          };
          const add = () => {
            store2.dispatch("saveItems", { ...item.value });
            update3();
          };
          const edit = (key) => {
            index.value = key;
            store2.dispatch("updateActiveIndex", key);
            const getItem = { ...store2.getters.getItemById(key) };
            item.value.line1 = getItem.line1;
            item.value.line2 = getItem.line2;
            item.value.line3 = getItem.line3;
            item.value.line4 = getItem.line4;
            item.value.line5 = getItem.line5;
            item.value.line6 = getItem.line6;
          };
          const remove2 = (key) => {
            const idx = key - 1 >= 0 ? key - 1 : 0;
            store2.dispatch("deleteItem", key);
            update3();
            edit(idx);
          };
          const changeFont = (event) => {
            const font = JSON.parse(event.target.value);
            store2.dispatch("saveFont", font.value);
          };
          const changeVerse = (event) => {
            const verse = JSON.parse(event.target.value);
            const text = (0, import_lodash9.filter)(verse?.layouts, ["layout", activeLayout.value]);
            store2.dispatch("saveVerse", text[0]?.value || verse?.value);
          };
          const updateVerse = (event) => {
            store2.dispatch("saveVerse", event.target.value.replaceAll("\\", ""));
          };
          watch2(item.value, () => {
            store2.dispatch("updateItem", {
              item: { ...item.value },
              index: index.value
            });
          });
          return {
            personalization,
            item,
            items,
            add,
            edit,
            remove: remove2,
            index,
            changeFont,
            changeVerse,
            verseText,
            updateVerse
          };
        }
      };
      _hoisted_150 = {
        key: 0,
        class: "px-0 pt-2 pb-4 mb-4 border-b border-teal-200"
      };
      _hoisted_239 = { class: "pb-4" };
      _hoisted_328 = { class: "" };
      _hoisted_424 = { class: "flex items-center mb-4" };
      _hoisted_518 = { class: "inline-flex items-center pr-1 mr-2 value value--vue" };
      _hoisted_614 = { class: "flex items-center mb-4" };
      _hoisted_713 = { class: "inline-flex items-center pr-1 mr-2 value value--vue" };
      _hoisted_89 = { key: 0 };
      _hoisted_98 = { class: "my-6" };
      _hoisted_108 = { class: "w-full" };
      _hoisted_1116 = ["selected", "value", "textContent"];
      _hoisted_1212 = {
        key: 1,
        class: ""
      };
      _hoisted_1311 = { key: 2 };
      _hoisted_1410 = { class: "mt-8" };
      _hoisted_156 = { class: "w-full" };
      _hoisted_166 = ["selected", "value", "textContent"];
      _hoisted_176 = { class: "block" };
      __default__33.render = render34;
      __default__33.__scopeId = "data-v-e11c0649";
      personalization_option_default = __default__33;
    }
  });

  // src/vue/components/shared/personalization-logo-input.vue
  var personalization_logo_input_exports = {};
  __export(personalization_logo_input_exports, {
    default: () => personalization_logo_input_default,
    render: () => render35
  });
  function render35(_ctx, _cache) {
    const _component_StepInput = resolveComponent("StepInput");
    return openBlock(), createElementBlock("div", _hoisted_151, [
      createBaseVNode("div", null, [
        (openBlock(true), createElementBlock(
          Fragment,
          null,
          renderList(_ctx.lines, (line, index) => {
            return openBlock(), createBlock(_component_StepInput, {
              id: `logoline${index + 1}`,
              key: index,
              modelValue: _ctx.logoline[`line${index + 1}`],
              "onUpdate:modelValue": ($event) => _ctx.logoline[`line${index + 1}`] = $event,
              index,
              "label-text": line?.label || `Logo Line ${index + 1}:`,
              line,
              type: line?.type === "textarea" ? "textarea" : "input"
            }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "index", "label-text", "line", "type"]);
          }),
          128
          /* KEYED_FRAGMENT */
        ))
      ])
    ]);
  }
  var __default__34, _hoisted_151, personalization_logo_input_default;
  var init_personalization_logo_input = __esm({
    "src/vue/components/shared/personalization-logo-input.vue"() {
      "use strict";
      init_vue_esm_bundler();
      init_step_input();
      init_vuex_esm_bundler();
      init_vue_esm_bundler();
      __default__34 = {
        components: { StepInput: step_input_default },
        props: {
          lines: {
            type: Object,
            required: true
          }
        },
        setup() {
          const store2 = useStore();
          const logoline = ref({});
          const items = computed2(() => store2.getters.getLogoText);
          logoline.value = {
            ...logoline.value,
            ...items.value
          };
          watch2(logoline.value, () => {
            store2.dispatch("saveLogoText", { ...logoline.value });
          });
          return {
            logoline,
            items
          };
        }
      };
      _hoisted_151 = { class: "" };
      __default__34.render = render35;
      personalization_logo_input_default = __default__34;
    }
  });

  // node_modules/dropzone-vue/dist/dropzone-vue.common.js
  var require_dropzone_vue_common = __commonJS({
    "node_modules/dropzone-vue/dist/dropzone-vue.common.js"(exports, module) {
      "use strict";
      /**
       * dropzone-vue 0.1.11
       * (c) 2021
       * @license MIT
       */
      var e = (init_vue_esm_bundler(), __toCommonJS(vue_esm_bundler_exports));
      var t = function(e2) {
        try {
          return !!e2();
        } catch (e3) {
          return true;
        }
      };
      var i2 = !t((function() {
        return 7 != Object.defineProperty({}, 1, { get: function() {
          return 7;
        } })[1];
      }));
      var n = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
      function a(e2) {
        var t2 = { exports: {} };
        return e2(t2, t2.exports), t2.exports;
      }
      var p2 = function(e2) {
        return e2 && e2.Math == Math && e2;
      };
      var r = p2("object" == typeof globalThis && globalThis) || p2("object" == typeof window && window) || p2("object" == typeof self && self) || p2("object" == typeof n && n) || /* @__PURE__ */ (function() {
        return this;
      })() || Function("return this")();
      var o = function(e2) {
        return "object" == typeof e2 ? null !== e2 : "function" == typeof e2;
      };
      var m = r.document;
      var c = o(m) && o(m.createElement);
      var l = function(e2) {
        return c ? m.createElement(e2) : {};
      };
      var s = !i2 && !t((function() {
        return 7 != Object.defineProperty(l("div"), "a", { get: function() {
          return 7;
        } }).a;
      }));
      var d = function(e2) {
        if (!o(e2)) throw TypeError(String(e2) + " is not an object");
        return e2;
      };
      var u2 = function(e2, t2) {
        if (!o(e2)) return e2;
        var i3, n2;
        if (t2 && "function" == typeof (i3 = e2.toString) && !o(n2 = i3.call(e2))) return n2;
        if ("function" == typeof (i3 = e2.valueOf) && !o(n2 = i3.call(e2))) return n2;
        if (!t2 && "function" == typeof (i3 = e2.toString) && !o(n2 = i3.call(e2))) return n2;
        throw TypeError("Can't convert object to primitive value");
      };
      var f = Object.defineProperty;
      var y2 = { f: i2 ? f : function(e2, t2, i3) {
        if (d(e2), t2 = u2(t2, true), d(i3), s) try {
          return f(e2, t2, i3);
        } catch (e3) {
        }
        if ("get" in i3 || "set" in i3) throw TypeError("Accessors not supported");
        return "value" in i3 && (e2[t2] = i3.value), e2;
      } };
      var v = y2.f;
      var x = Function.prototype;
      var _2 = x.toString;
      var h2 = /^\s*function ([^ (]*)/;
      function g(e2, t2, i3) {
        return t2 in e2 ? Object.defineProperty(e2, t2, { value: i3, enumerable: true, configurable: true, writable: true }) : e2[t2] = i3, e2;
      }
      function b2(e2, t2) {
        var i3 = Object.keys(e2);
        if (Object.getOwnPropertySymbols) {
          var n2 = Object.getOwnPropertySymbols(e2);
          t2 && (n2 = n2.filter((function(t3) {
            return Object.getOwnPropertyDescriptor(e2, t3).enumerable;
          }))), i3.push.apply(i3, n2);
        }
        return i3;
      }
      function w(e2) {
        for (var t2 = 1; t2 < arguments.length; t2++) {
          var i3 = null != arguments[t2] ? arguments[t2] : {};
          t2 % 2 ? b2(Object(i3), true).forEach((function(t3) {
            g(e2, t3, i3[t3]);
          })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e2, Object.getOwnPropertyDescriptors(i3)) : b2(Object(i3)).forEach((function(t3) {
            Object.defineProperty(e2, t3, Object.getOwnPropertyDescriptor(i3, t3));
          }));
        }
        return e2;
      }
      function k(e2, t2) {
        (null == t2 || t2 > e2.length) && (t2 = e2.length);
        for (var i3 = 0, n2 = new Array(t2); i3 < t2; i3++) n2[i3] = e2[i3];
        return n2;
      }
      function A(e2) {
        return (function(e3) {
          if (Array.isArray(e3)) return k(e3);
        })(e2) || (function(e3) {
          if ("undefined" != typeof Symbol && Symbol.iterator in Object(e3)) return Array.from(e3);
        })(e2) || (function(e3, t2) {
          if (e3) {
            if ("string" == typeof e3) return k(e3, t2);
            var i3 = Object.prototype.toString.call(e3).slice(8, -1);
            return "Object" === i3 && e3.constructor && (i3 = e3.constructor.name), "Map" === i3 || "Set" === i3 ? Array.from(e3) : "Arguments" === i3 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i3) ? k(e3, t2) : void 0;
          }
        })(e2) || (function() {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        })();
      }
      i2 && !("name" in x) && v(x, "name", { configurable: true, get: function() {
        try {
          return _2.call(this).match(h2)[1];
        } catch (e2) {
          return "";
        }
      } });
      var E = {}.propertyIsEnumerable;
      var S2 = Object.getOwnPropertyDescriptor;
      var j = { f: S2 && !E.call({ 1: 2 }, 1) ? function(e2) {
        var t2 = S2(this, e2);
        return !!t2 && t2.enumerable;
      } : E };
      var O = function(e2, t2) {
        return { enumerable: !(1 & e2), configurable: !(2 & e2), writable: !(4 & e2), value: t2 };
      };
      var T2 = {}.toString;
      var I2 = function(e2) {
        return T2.call(e2).slice(8, -1);
      };
      var R2 = "".split;
      var L = t((function() {
        return !Object("z").propertyIsEnumerable(0);
      })) ? function(e2) {
        return "String" == I2(e2) ? R2.call(e2, "") : Object(e2);
      } : Object;
      var U = function(e2) {
        if (null == e2) throw TypeError("Can't call method on " + e2);
        return e2;
      };
      var z2 = function(e2) {
        return L(U(e2));
      };
      var N = {}.hasOwnProperty;
      var F2 = function(e2, t2) {
        return N.call(e2, t2);
      };
      var P2 = Object.getOwnPropertyDescriptor;
      var C = { f: i2 ? P2 : function(e2, t2) {
        if (e2 = z2(e2), t2 = u2(t2, true), s) try {
          return P2(e2, t2);
        } catch (e3) {
        }
        if (F2(e2, t2)) return O(!j.f.call(e2, t2), e2[t2]);
      } };
      var M2 = i2 ? function(e2, t2, i3) {
        return y2.f(e2, t2, O(1, i3));
      } : function(e2, t2, i3) {
        return e2[t2] = i3, e2;
      };
      var q2 = function(e2, t2) {
        try {
          M2(r, e2, t2);
        } catch (i3) {
          r[e2] = t2;
        }
        return t2;
      };
      var D2 = r["__core-js_shared__"] || q2("__core-js_shared__", {});
      var B2 = Function.toString;
      "function" != typeof D2.inspectSource && (D2.inspectSource = function(e2) {
        return B2.call(e2);
      });
      var V;
      var G3;
      var $2;
      var W2 = D2.inspectSource;
      var Y2 = r.WeakMap;
      var H2 = "function" == typeof Y2 && /native code/.test(W2(Y2));
      var Q2 = a((function(e2) {
        (e2.exports = function(e3, t2) {
          return D2[e3] || (D2[e3] = void 0 !== t2 ? t2 : {});
        })("versions", []).push({ version: "3.9.1", mode: "global", copyright: "\xA9 2021 Denis Pushkarev (zloirock.ru)" });
      }));
      var X2 = 0;
      var K = Math.random();
      var Z2 = function(e2) {
        return "Symbol(" + String(void 0 === e2 ? "" : e2) + ")_" + (++X2 + K).toString(36);
      };
      var J2 = Q2("keys");
      var ee2 = function(e2) {
        return J2[e2] || (J2[e2] = Z2(e2));
      };
      var te2 = {};
      var ie2 = r.WeakMap;
      if (H2) {
        ne2 = D2.state || (D2.state = new ie2()), ae2 = ne2.get, pe2 = ne2.has, re2 = ne2.set;
        V = function(e2, t2) {
          return t2.facade = e2, re2.call(ne2, e2, t2), t2;
        }, G3 = function(e2) {
          return ae2.call(ne2, e2) || {};
        }, $2 = function(e2) {
          return pe2.call(ne2, e2);
        };
      } else {
        oe2 = ee2("state");
        te2[oe2] = true, V = function(e2, t2) {
          return t2.facade = e2, M2(e2, oe2, t2), t2;
        }, G3 = function(e2) {
          return F2(e2, oe2) ? e2[oe2] : {};
        }, $2 = function(e2) {
          return F2(e2, oe2);
        };
      }
      var ne2;
      var ae2;
      var pe2;
      var re2;
      var oe2;
      var me2 = { set: V, get: G3, has: $2, enforce: function(e2) {
        return $2(e2) ? G3(e2) : V(e2, {});
      }, getterFor: function(e2) {
        return function(t2) {
          var i3;
          if (!o(t2) || (i3 = G3(t2)).type !== e2) throw TypeError("Incompatible receiver, " + e2 + " required");
          return i3;
        };
      } };
      var ce2 = a((function(e2) {
        var t2 = me2.get, i3 = me2.enforce, n2 = String(String).split("String");
        (e2.exports = function(e3, t3, a2, p3) {
          var o2, m2 = !!p3 && !!p3.unsafe, c2 = !!p3 && !!p3.enumerable, l2 = !!p3 && !!p3.noTargetGet;
          "function" == typeof a2 && ("string" != typeof t3 || F2(a2, "name") || M2(a2, "name", t3), (o2 = i3(a2)).source || (o2.source = n2.join("string" == typeof t3 ? t3 : ""))), e3 !== r ? (m2 ? !l2 && e3[t3] && (c2 = true) : delete e3[t3], c2 ? e3[t3] = a2 : M2(e3, t3, a2)) : c2 ? e3[t3] = a2 : q2(t3, a2);
        })(Function.prototype, "toString", (function() {
          return "function" == typeof this && t2(this).source || W2(this);
        }));
      }));
      var le2 = r;
      var se2 = function(e2) {
        return "function" == typeof e2 ? e2 : void 0;
      };
      var de2 = function(e2, t2) {
        return arguments.length < 2 ? se2(le2[e2]) || se2(r[e2]) : le2[e2] && le2[e2][t2] || r[e2] && r[e2][t2];
      };
      var ue2 = Math.ceil;
      var fe2 = Math.floor;
      var ye2 = function(e2) {
        return isNaN(e2 = +e2) ? 0 : (e2 > 0 ? fe2 : ue2)(e2);
      };
      var ve2 = Math.min;
      var xe = function(e2) {
        return e2 > 0 ? ve2(ye2(e2), 9007199254740991) : 0;
      };
      var _e = Math.max;
      var he = Math.min;
      var ge2 = function(e2, t2) {
        var i3 = ye2(e2);
        return i3 < 0 ? _e(i3 + t2, 0) : he(i3, t2);
      };
      var be = function(e2) {
        return function(t2, i3, n2) {
          var a2, p3 = z2(t2), r2 = xe(p3.length), o2 = ge2(n2, r2);
          if (e2 && i3 != i3) {
            for (; r2 > o2; ) if ((a2 = p3[o2++]) != a2) return true;
          } else for (; r2 > o2; o2++) if ((e2 || o2 in p3) && p3[o2] === i3) return e2 || o2 || 0;
          return !e2 && -1;
        };
      };
      var we = { includes: be(true), indexOf: be(false) };
      var ke = we.indexOf;
      var Ae = function(e2, t2) {
        var i3, n2 = z2(e2), a2 = 0, p3 = [];
        for (i3 in n2) !F2(te2, i3) && F2(n2, i3) && p3.push(i3);
        for (; t2.length > a2; ) F2(n2, i3 = t2[a2++]) && (~ke(p3, i3) || p3.push(i3));
        return p3;
      };
      var Ee = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
      var Se2 = Ee.concat("length", "prototype");
      var je = { f: Object.getOwnPropertyNames || function(e2) {
        return Ae(e2, Se2);
      } };
      var Oe = { f: Object.getOwnPropertySymbols };
      var Te = de2("Reflect", "ownKeys") || function(e2) {
        var t2 = je.f(d(e2)), i3 = Oe.f;
        return i3 ? t2.concat(i3(e2)) : t2;
      };
      var Ie = function(e2, t2) {
        for (var i3 = Te(t2), n2 = y2.f, a2 = C.f, p3 = 0; p3 < i3.length; p3++) {
          var r2 = i3[p3];
          F2(e2, r2) || n2(e2, r2, a2(t2, r2));
        }
      };
      var Re = /#|\.prototype\./;
      var Le = function(e2, i3) {
        var n2 = ze[Ue(e2)];
        return n2 == Fe || n2 != Ne && ("function" == typeof i3 ? t(i3) : !!i3);
      };
      var Ue = Le.normalize = function(e2) {
        return String(e2).replace(Re, ".").toLowerCase();
      };
      var ze = Le.data = {};
      var Ne = Le.NATIVE = "N";
      var Fe = Le.POLYFILL = "P";
      var Pe = Le;
      var Ce = C.f;
      var Me = function(e2, t2) {
        var i3, n2, a2, p3, o2, m2 = e2.target, c2 = e2.global, l2 = e2.stat;
        if (i3 = c2 ? r : l2 ? r[m2] || q2(m2, {}) : (r[m2] || {}).prototype) for (n2 in t2) {
          if (p3 = t2[n2], a2 = e2.noTargetGet ? (o2 = Ce(i3, n2)) && o2.value : i3[n2], !Pe(c2 ? n2 : m2 + (l2 ? "." : "#") + n2, e2.forced) && void 0 !== a2) {
            if (typeof p3 == typeof a2) continue;
            Ie(p3, a2);
          }
          (e2.sham || a2 && a2.sham) && M2(p3, "sham", true), ce2(i3, n2, p3, e2);
        }
      };
      var qe = function() {
        var e2 = d(this), t2 = "";
        return e2.global && (t2 += "g"), e2.ignoreCase && (t2 += "i"), e2.multiline && (t2 += "m"), e2.dotAll && (t2 += "s"), e2.unicode && (t2 += "u"), e2.sticky && (t2 += "y"), t2;
      };
      function De(e2, t2) {
        return RegExp(e2, t2);
      }
      var Be;
      var Ve;
      var Ge = { UNSUPPORTED_Y: t((function() {
        var e2 = De("a", "y");
        return e2.lastIndex = 2, null != e2.exec("abcd");
      })), BROKEN_CARET: t((function() {
        var e2 = De("^r", "gy");
        return e2.lastIndex = 2, null != e2.exec("str");
      })) };
      var $e = RegExp.prototype.exec;
      var We = String.prototype.replace;
      var Ye = $e;
      var He = (Be = /a/, Ve = /b*/g, $e.call(Be, "a"), $e.call(Ve, "a"), 0 !== Be.lastIndex || 0 !== Ve.lastIndex);
      var Qe = Ge.UNSUPPORTED_Y || Ge.BROKEN_CARET;
      var Xe = void 0 !== /()??/.exec("")[1];
      (He || Xe || Qe) && (Ye = function(e2) {
        var t2, i3, n2, a2, p3 = this, r2 = Qe && p3.sticky, o2 = qe.call(p3), m2 = p3.source, c2 = 0, l2 = e2;
        return r2 && (-1 === (o2 = o2.replace("y", "")).indexOf("g") && (o2 += "g"), l2 = String(e2).slice(p3.lastIndex), p3.lastIndex > 0 && (!p3.multiline || p3.multiline && "\n" !== e2[p3.lastIndex - 1]) && (m2 = "(?: " + m2 + ")", l2 = " " + l2, c2++), i3 = new RegExp("^(?:" + m2 + ")", o2)), Xe && (i3 = new RegExp("^" + m2 + "$(?!\\s)", o2)), He && (t2 = p3.lastIndex), n2 = $e.call(r2 ? i3 : p3, l2), r2 ? n2 ? (n2.input = n2.input.slice(c2), n2[0] = n2[0].slice(c2), n2.index = p3.lastIndex, p3.lastIndex += n2[0].length) : p3.lastIndex = 0 : He && n2 && (p3.lastIndex = p3.global ? n2.index + n2[0].length : t2), Xe && n2 && n2.length > 1 && We.call(n2[0], i3, (function() {
          for (a2 = 1; a2 < arguments.length - 2; a2++) void 0 === arguments[a2] && (n2[a2] = void 0);
        })), n2;
      });
      var Ke = Ye;
      Me({ target: "RegExp", proto: true, forced: /./.exec !== Ke }, { exec: Ke });
      var Ze;
      var Je;
      var et = "process" == I2(r.process);
      var tt2 = de2("navigator", "userAgent") || "";
      var it = r.process;
      var nt = it && it.versions;
      var at = nt && nt.v8;
      at ? Je = (Ze = at.split("."))[0] + Ze[1] : tt2 && (!(Ze = tt2.match(/Edge\/(\d+)/)) || Ze[1] >= 74) && (Ze = tt2.match(/Chrome\/(\d+)/)) && (Je = Ze[1]);
      var pt = Je && +Je;
      var rt = !!Object.getOwnPropertySymbols && !t((function() {
        return !Symbol.sham && (et ? 38 === pt : pt > 37 && pt < 41);
      }));
      var ot = rt && !Symbol.sham && "symbol" == typeof Symbol.iterator;
      var mt = Q2("wks");
      var ct = r.Symbol;
      var lt = ot ? ct : ct && ct.withoutSetter || Z2;
      var st = function(e2) {
        return F2(mt, e2) && (rt || "string" == typeof mt[e2]) || (rt && F2(ct, e2) ? mt[e2] = ct[e2] : mt[e2] = lt("Symbol." + e2)), mt[e2];
      };
      var dt = st("species");
      var ut = !t((function() {
        var e2 = /./;
        return e2.exec = function() {
          var e3 = [];
          return e3.groups = { a: "7" }, e3;
        }, "7" !== "".replace(e2, "$<a>");
      }));
      var ft = "$0" === "a".replace(/./, "$0");
      var yt = st("replace");
      var vt = !!/./[yt] && "" === /./[yt]("a", "$0");
      var xt = !t((function() {
        var e2 = /(?:)/, t2 = e2.exec;
        e2.exec = function() {
          return t2.apply(this, arguments);
        };
        var i3 = "ab".split(e2);
        return 2 !== i3.length || "a" !== i3[0] || "b" !== i3[1];
      }));
      var _t = function(e2, i3, n2, a2) {
        var p3 = st(e2), r2 = !t((function() {
          var t2 = {};
          return t2[p3] = function() {
            return 7;
          }, 7 != ""[e2](t2);
        })), o2 = r2 && !t((function() {
          var t2 = false, i4 = /a/;
          return "split" === e2 && ((i4 = {}).constructor = {}, i4.constructor[dt] = function() {
            return i4;
          }, i4.flags = "", i4[p3] = /./[p3]), i4.exec = function() {
            return t2 = true, null;
          }, i4[p3](""), !t2;
        }));
        if (!r2 || !o2 || "replace" === e2 && (!ut || !ft || vt) || "split" === e2 && !xt) {
          var m2 = /./[p3], c2 = n2(p3, ""[e2], (function(e3, t2, i4, n3, a3) {
            return t2.exec === Ke ? r2 && !a3 ? { done: true, value: m2.call(t2, i4, n3) } : { done: true, value: e3.call(i4, t2, n3) } : { done: false };
          }), { REPLACE_KEEPS_$0: ft, REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: vt }), l2 = c2[0], s2 = c2[1];
          ce2(String.prototype, e2, l2), ce2(RegExp.prototype, p3, 2 == i3 ? function(e3, t2) {
            return s2.call(e3, this, t2);
          } : function(e3) {
            return s2.call(e3, this);
          });
        }
        a2 && M2(RegExp.prototype[p3], "sham", true);
      };
      var ht = function(e2) {
        return function(t2, i3) {
          var n2, a2, p3 = String(U(t2)), r2 = ye2(i3), o2 = p3.length;
          return r2 < 0 || r2 >= o2 ? e2 ? "" : void 0 : (n2 = p3.charCodeAt(r2)) < 55296 || n2 > 56319 || r2 + 1 === o2 || (a2 = p3.charCodeAt(r2 + 1)) < 56320 || a2 > 57343 ? e2 ? p3.charAt(r2) : n2 : e2 ? p3.slice(r2, r2 + 2) : a2 - 56320 + (n2 - 55296 << 10) + 65536;
        };
      };
      var gt = { codeAt: ht(false), charAt: ht(true) };
      var bt = gt.charAt;
      var wt = function(e2, t2, i3) {
        return t2 + (i3 ? bt(e2, t2).length : 1);
      };
      var kt = function(e2) {
        return Object(U(e2));
      };
      var At = Math.floor;
      var Et = "".replace;
      var St = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
      var jt = /\$([$&'`]|\d{1,2})/g;
      var Ot = function(e2, t2, i3, n2, a2, p3) {
        var r2 = i3 + e2.length, o2 = n2.length, m2 = jt;
        return void 0 !== a2 && (a2 = kt(a2), m2 = St), Et.call(p3, m2, (function(p4, m3) {
          var c2;
          switch (m3.charAt(0)) {
            case "$":
              return "$";
            case "&":
              return e2;
            case "`":
              return t2.slice(0, i3);
            case "'":
              return t2.slice(r2);
            case "<":
              c2 = a2[m3.slice(1, -1)];
              break;
            default:
              var l2 = +m3;
              if (0 === l2) return p4;
              if (l2 > o2) {
                var s2 = At(l2 / 10);
                return 0 === s2 ? p4 : s2 <= o2 ? void 0 === n2[s2 - 1] ? m3.charAt(1) : n2[s2 - 1] + m3.charAt(1) : p4;
              }
              c2 = n2[l2 - 1];
          }
          return void 0 === c2 ? "" : c2;
        }));
      };
      var Tt = function(e2, t2) {
        var i3 = e2.exec;
        if ("function" == typeof i3) {
          var n2 = i3.call(e2, t2);
          if ("object" != typeof n2) throw TypeError("RegExp exec method returned something other than an Object or null");
          return n2;
        }
        if ("RegExp" !== I2(e2)) throw TypeError("RegExp#exec called on incompatible receiver");
        return Ke.call(e2, t2);
      };
      var It = Math.max;
      var Rt = Math.min;
      _t("replace", 2, (function(e2, t2, i3, n2) {
        var a2 = n2.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE, p3 = n2.REPLACE_KEEPS_$0, r2 = a2 ? "$" : "$0";
        return [function(i4, n3) {
          var a3 = U(this), p4 = null == i4 ? void 0 : i4[e2];
          return void 0 !== p4 ? p4.call(i4, a3, n3) : t2.call(String(a3), i4, n3);
        }, function(e3, n3) {
          if (!a2 && p3 || "string" == typeof n3 && -1 === n3.indexOf(r2)) {
            var o2 = i3(t2, e3, this, n3);
            if (o2.done) return o2.value;
          }
          var m2 = d(e3), c2 = String(this), l2 = "function" == typeof n3;
          l2 || (n3 = String(n3));
          var s2 = m2.global;
          if (s2) {
            var u3 = m2.unicode;
            m2.lastIndex = 0;
          }
          for (var f2 = []; ; ) {
            var y3 = Tt(m2, c2);
            if (null === y3) break;
            if (f2.push(y3), !s2) break;
            "" === String(y3[0]) && (m2.lastIndex = wt(c2, xe(m2.lastIndex), u3));
          }
          for (var v2, x2 = "", _3 = 0, h3 = 0; h3 < f2.length; h3++) {
            y3 = f2[h3];
            for (var g2 = String(y3[0]), b3 = It(Rt(ye2(y3.index), c2.length), 0), w2 = [], k2 = 1; k2 < y3.length; k2++) w2.push(void 0 === (v2 = y3[k2]) ? v2 : String(v2));
            var A2 = y3.groups;
            if (l2) {
              var E2 = [g2].concat(w2, b3, c2);
              void 0 !== A2 && E2.push(A2);
              var S3 = String(n3.apply(void 0, E2));
            } else S3 = Ot(g2, c2, b3, w2, A2, n3);
            b3 >= _3 && (x2 += c2.slice(_3, b3) + S3, _3 = b3 + g2.length);
          }
          return x2 + c2.slice(_3);
        }];
      }));
      var Lt = {};
      Lt[st("toStringTag")] = "z";
      var Ut = "[object z]" === String(Lt);
      var zt = st("toStringTag");
      var Nt = "Arguments" == I2(/* @__PURE__ */ (function() {
        return arguments;
      })());
      var Ft = Ut ? I2 : function(e2) {
        var t2, i3, n2;
        return void 0 === e2 ? "Undefined" : null === e2 ? "Null" : "string" == typeof (i3 = (function(e3, t3) {
          try {
            return e3[t3];
          } catch (e4) {
          }
        })(t2 = Object(e2), zt)) ? i3 : Nt ? I2(t2) : "Object" == (n2 = I2(t2)) && "function" == typeof t2.callee ? "Arguments" : n2;
      };
      var Pt = Ut ? {}.toString : function() {
        return "[object " + Ft(this) + "]";
      };
      Ut || ce2(Object.prototype, "toString", Pt, { unsafe: true });
      var Ct = RegExp.prototype;
      var Mt = Ct.toString;
      var qt = t((function() {
        return "/a/b" != Mt.call({ source: "a", flags: "b" });
      }));
      var Dt = "toString" != Mt.name;
      (qt || Dt) && ce2(RegExp.prototype, "toString", (function() {
        var e2 = d(this), t2 = String(e2.source), i3 = e2.flags;
        return "/" + t2 + "/" + String(void 0 === i3 && e2 instanceof RegExp && !("flags" in Ct) ? qe.call(e2) : i3);
      }), { unsafe: true });
      var Bt = st("iterator");
      var Vt = false;
      try {
        Gt = 0, $t = { next: function() {
          return { done: !!Gt++ };
        }, return: function() {
          Vt = true;
        } };
        $t[Bt] = function() {
          return this;
        }, Array.from($t, (function() {
          throw 2;
        }));
      } catch (e2) {
      }
      var Gt;
      var $t;
      var Wt;
      var Yt = "undefined" != typeof ArrayBuffer && "undefined" != typeof DataView;
      var Ht = !t((function() {
        function e2() {
        }
        return e2.prototype.constructor = null, Object.getPrototypeOf(new e2()) !== e2.prototype;
      }));
      var Qt = ee2("IE_PROTO");
      var Xt = Object.prototype;
      var Kt = Ht ? Object.getPrototypeOf : function(e2) {
        return e2 = kt(e2), F2(e2, Qt) ? e2[Qt] : "function" == typeof e2.constructor && e2 instanceof e2.constructor ? e2.constructor.prototype : e2 instanceof Object ? Xt : null;
      };
      var Zt = Object.setPrototypeOf || ("__proto__" in {} ? (function() {
        var e2, t2 = false, i3 = {};
        try {
          (e2 = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(i3, []), t2 = i3 instanceof Array;
        } catch (e3) {
        }
        return function(i4, n2) {
          return d(i4), (function(e3) {
            if (!o(e3) && null !== e3) throw TypeError("Can't set " + String(e3) + " as a prototype");
          })(n2), t2 ? e2.call(i4, n2) : i4.__proto__ = n2, i4;
        };
      })() : void 0);
      var Jt = y2.f;
      var ei = r.Int8Array;
      var ti = ei && ei.prototype;
      var ii = r.Uint8ClampedArray;
      var ni = ii && ii.prototype;
      var ai = ei && Kt(ei);
      var pi = ti && Kt(ti);
      var ri = Object.prototype;
      var oi = ri.isPrototypeOf;
      var mi = st("toStringTag");
      var ci = Z2("TYPED_ARRAY_TAG");
      var li = Yt && !!Zt && "Opera" !== Ft(r.opera);
      var si = false;
      var di = { Int8Array: 1, Uint8Array: 1, Uint8ClampedArray: 1, Int16Array: 2, Uint16Array: 2, Int32Array: 4, Uint32Array: 4, Float32Array: 4, Float64Array: 8 };
      var ui = { BigInt64Array: 8, BigUint64Array: 8 };
      var fi = function(e2) {
        if (!o(e2)) return false;
        var t2 = Ft(e2);
        return F2(di, t2) || F2(ui, t2);
      };
      for (Wt in di) r[Wt] || (li = false);
      if ((!li || "function" != typeof ai || ai === Function.prototype) && (ai = function() {
        throw TypeError("Incorrect invocation");
      }, li)) for (Wt in di) r[Wt] && Zt(r[Wt], ai);
      if ((!li || !pi || pi === ri) && (pi = ai.prototype, li)) for (Wt in di) r[Wt] && Zt(r[Wt].prototype, pi);
      if (li && Kt(ni) !== pi && Zt(ni, pi), i2 && !F2(pi, mi)) for (Wt in si = true, Jt(pi, mi, { get: function() {
        return o(this) ? this[ci] : void 0;
      } }), di) r[Wt] && M2(r[Wt], ci, Wt);
      var yi = { NATIVE_ARRAY_BUFFER_VIEWS: li, TYPED_ARRAY_TAG: si && ci, aTypedArray: function(e2) {
        if (fi(e2)) return e2;
        throw TypeError("Target is not a typed array");
      }, aTypedArrayConstructor: function(e2) {
        if (Zt) {
          if (oi.call(ai, e2)) return e2;
        } else for (var t2 in di) if (F2(di, Wt)) {
          var i3 = r[t2];
          if (i3 && (e2 === i3 || oi.call(i3, e2))) return e2;
        }
        throw TypeError("Target is not a typed array constructor");
      }, exportTypedArrayMethod: function(e2, t2, n2) {
        if (i2) {
          if (n2) for (var a2 in di) {
            var p3 = r[a2];
            p3 && F2(p3.prototype, e2) && delete p3.prototype[e2];
          }
          pi[e2] && !n2 || ce2(pi, e2, n2 ? t2 : li && ti[e2] || t2);
        }
      }, exportTypedArrayStaticMethod: function(e2, t2, n2) {
        var a2, p3;
        if (i2) {
          if (Zt) {
            if (n2) for (a2 in di) (p3 = r[a2]) && F2(p3, e2) && delete p3[e2];
            if (ai[e2] && !n2) return;
            try {
              return ce2(ai, e2, n2 ? t2 : li && ei[e2] || t2);
            } catch (e3) {
            }
          }
          for (a2 in di) !(p3 = r[a2]) || p3[e2] && !n2 || ce2(p3, e2, t2);
        }
      }, isView: function(e2) {
        if (!o(e2)) return false;
        var t2 = Ft(e2);
        return "DataView" === t2 || F2(di, t2) || F2(ui, t2);
      }, isTypedArray: fi, TypedArray: ai, TypedArrayPrototype: pi };
      var vi = yi.NATIVE_ARRAY_BUFFER_VIEWS;
      var xi = r.ArrayBuffer;
      var _i = r.Int8Array;
      var hi = !vi || !t((function() {
        _i(1);
      })) || !t((function() {
        new _i(-1);
      })) || !(function(e2, t2) {
        if (!t2 && !Vt) return false;
        var i3 = false;
        try {
          var n2 = {};
          n2[Bt] = function() {
            return { next: function() {
              return { done: i3 = true };
            } };
          }, e2(n2);
        } catch (e3) {
        }
        return i3;
      })((function(e2) {
        new _i(), new _i(null), new _i(1.5), new _i(e2);
      }), true) || t((function() {
        return 1 !== new _i(new xi(2), 1, void 0).length;
      }));
      var gi = function(e2, t2, i3) {
        for (var n2 in t2) ce2(e2, n2, t2[n2], i3);
        return e2;
      };
      var bi = function(e2, t2, i3) {
        if (!(e2 instanceof t2)) throw TypeError("Incorrect " + (i3 ? i3 + " " : "") + "invocation");
        return e2;
      };
      var wi = function(e2) {
        if (void 0 === e2) return 0;
        var t2 = ye2(e2), i3 = xe(t2);
        if (t2 !== i3) throw RangeError("Wrong length or index");
        return i3;
      };
      var ki = Math.abs;
      var Ai = Math.pow;
      var Ei = Math.floor;
      var Si = Math.log;
      var ji = Math.LN2;
      var Oi = function(e2, t2, i3) {
        var n2, a2, p3, r2 = new Array(i3), o2 = 8 * i3 - t2 - 1, m2 = (1 << o2) - 1, c2 = m2 >> 1, l2 = 23 === t2 ? Ai(2, -24) - Ai(2, -77) : 0, s2 = e2 < 0 || 0 === e2 && 1 / e2 < 0 ? 1 : 0, d2 = 0;
        for ((e2 = ki(e2)) != e2 || e2 === 1 / 0 ? (a2 = e2 != e2 ? 1 : 0, n2 = m2) : (n2 = Ei(Si(e2) / ji), e2 * (p3 = Ai(2, -n2)) < 1 && (n2--, p3 *= 2), (e2 += n2 + c2 >= 1 ? l2 / p3 : l2 * Ai(2, 1 - c2)) * p3 >= 2 && (n2++, p3 /= 2), n2 + c2 >= m2 ? (a2 = 0, n2 = m2) : n2 + c2 >= 1 ? (a2 = (e2 * p3 - 1) * Ai(2, t2), n2 += c2) : (a2 = e2 * Ai(2, c2 - 1) * Ai(2, t2), n2 = 0)); t2 >= 8; r2[d2++] = 255 & a2, a2 /= 256, t2 -= 8) ;
        for (n2 = n2 << t2 | a2, o2 += t2; o2 > 0; r2[d2++] = 255 & n2, n2 /= 256, o2 -= 8) ;
        return r2[--d2] |= 128 * s2, r2;
      };
      var Ti = function(e2, t2) {
        var i3, n2 = e2.length, a2 = 8 * n2 - t2 - 1, p3 = (1 << a2) - 1, r2 = p3 >> 1, o2 = a2 - 7, m2 = n2 - 1, c2 = e2[m2--], l2 = 127 & c2;
        for (c2 >>= 7; o2 > 0; l2 = 256 * l2 + e2[m2], m2--, o2 -= 8) ;
        for (i3 = l2 & (1 << -o2) - 1, l2 >>= -o2, o2 += t2; o2 > 0; i3 = 256 * i3 + e2[m2], m2--, o2 -= 8) ;
        if (0 === l2) l2 = 1 - r2;
        else {
          if (l2 === p3) return i3 ? NaN : c2 ? -1 / 0 : 1 / 0;
          i3 += Ai(2, t2), l2 -= r2;
        }
        return (c2 ? -1 : 1) * i3 * Ai(2, l2 - t2);
      };
      var Ii = function(e2) {
        for (var t2 = kt(this), i3 = xe(t2.length), n2 = arguments.length, a2 = ge2(n2 > 1 ? arguments[1] : void 0, i3), p3 = n2 > 2 ? arguments[2] : void 0, r2 = void 0 === p3 ? i3 : ge2(p3, i3); r2 > a2; ) t2[a2++] = e2;
        return t2;
      };
      var Ri = y2.f;
      var Li = st("toStringTag");
      var Ui = function(e2, t2, i3) {
        e2 && !F2(e2 = i3 ? e2 : e2.prototype, Li) && Ri(e2, Li, { configurable: true, value: t2 });
      };
      var zi = je.f;
      var Ni = y2.f;
      var Fi = me2.get;
      var Pi = me2.set;
      var Ci = r.ArrayBuffer;
      var Mi = Ci;
      var qi = r.DataView;
      var Di = qi && qi.prototype;
      var Bi = Object.prototype;
      var Vi = r.RangeError;
      var Gi = Oi;
      var $i = Ti;
      var Wi = function(e2) {
        return [255 & e2];
      };
      var Yi = function(e2) {
        return [255 & e2, e2 >> 8 & 255];
      };
      var Hi = function(e2) {
        return [255 & e2, e2 >> 8 & 255, e2 >> 16 & 255, e2 >> 24 & 255];
      };
      var Qi = function(e2) {
        return e2[3] << 24 | e2[2] << 16 | e2[1] << 8 | e2[0];
      };
      var Xi = function(e2) {
        return Gi(e2, 23, 4);
      };
      var Ki = function(e2) {
        return Gi(e2, 52, 8);
      };
      var Zi = function(e2, t2) {
        Ni(e2.prototype, t2, { get: function() {
          return Fi(this)[t2];
        } });
      };
      var Ji = function(e2, t2, i3, n2) {
        var a2 = wi(i3), p3 = Fi(e2);
        if (a2 + t2 > p3.byteLength) throw Vi("Wrong index");
        var r2 = Fi(p3.buffer).bytes, o2 = a2 + p3.byteOffset, m2 = r2.slice(o2, o2 + t2);
        return n2 ? m2 : m2.reverse();
      };
      var en = function(e2, t2, i3, n2, a2, p3) {
        var r2 = wi(i3), o2 = Fi(e2);
        if (r2 + t2 > o2.byteLength) throw Vi("Wrong index");
        for (var m2 = Fi(o2.buffer).bytes, c2 = r2 + o2.byteOffset, l2 = n2(+a2), s2 = 0; s2 < t2; s2++) m2[c2 + s2] = l2[p3 ? s2 : t2 - s2 - 1];
      };
      if (Yt) {
        if (!t((function() {
          Ci(1);
        })) || !t((function() {
          new Ci(-1);
        })) || t((function() {
          return new Ci(), new Ci(1.5), new Ci(NaN), "ArrayBuffer" != Ci.name;
        }))) {
          for (nn = (Mi = function(e2) {
            return bi(this, Mi), new Ci(wi(e2));
          }).prototype = Ci.prototype, an = zi(Ci), pn = 0; an.length > pn; ) (tn = an[pn++]) in Mi || M2(Mi, tn, Ci[tn]);
          nn.constructor = Mi;
        }
        Zt && Kt(Di) !== Bi && Zt(Di, Bi);
        rn = new qi(new Mi(2)), on = Di.setInt8;
        rn.setInt8(0, 2147483648), rn.setInt8(1, 2147483649), !rn.getInt8(0) && rn.getInt8(1) || gi(Di, { setInt8: function(e2, t2) {
          on.call(this, e2, t2 << 24 >> 24);
        }, setUint8: function(e2, t2) {
          on.call(this, e2, t2 << 24 >> 24);
        } }, { unsafe: true });
      } else Mi = function(e2) {
        bi(this, Mi, "ArrayBuffer");
        var t2 = wi(e2);
        Pi(this, { bytes: Ii.call(new Array(t2), 0), byteLength: t2 }), i2 || (this.byteLength = t2);
      }, qi = function(e2, t2, n2) {
        bi(this, qi, "DataView"), bi(e2, Mi, "DataView");
        var a2 = Fi(e2).byteLength, p3 = ye2(t2);
        if (p3 < 0 || p3 > a2) throw Vi("Wrong offset");
        if (p3 + (n2 = void 0 === n2 ? a2 - p3 : xe(n2)) > a2) throw Vi("Wrong length");
        Pi(this, { buffer: e2, byteLength: n2, byteOffset: p3 }), i2 || (this.buffer = e2, this.byteLength = n2, this.byteOffset = p3);
      }, i2 && (Zi(Mi, "byteLength"), Zi(qi, "buffer"), Zi(qi, "byteLength"), Zi(qi, "byteOffset")), gi(qi.prototype, { getInt8: function(e2) {
        return Ji(this, 1, e2)[0] << 24 >> 24;
      }, getUint8: function(e2) {
        return Ji(this, 1, e2)[0];
      }, getInt16: function(e2) {
        var t2 = Ji(this, 2, e2, arguments.length > 1 ? arguments[1] : void 0);
        return (t2[1] << 8 | t2[0]) << 16 >> 16;
      }, getUint16: function(e2) {
        var t2 = Ji(this, 2, e2, arguments.length > 1 ? arguments[1] : void 0);
        return t2[1] << 8 | t2[0];
      }, getInt32: function(e2) {
        return Qi(Ji(this, 4, e2, arguments.length > 1 ? arguments[1] : void 0));
      }, getUint32: function(e2) {
        return Qi(Ji(this, 4, e2, arguments.length > 1 ? arguments[1] : void 0)) >>> 0;
      }, getFloat32: function(e2) {
        return $i(Ji(this, 4, e2, arguments.length > 1 ? arguments[1] : void 0), 23);
      }, getFloat64: function(e2) {
        return $i(Ji(this, 8, e2, arguments.length > 1 ? arguments[1] : void 0), 52);
      }, setInt8: function(e2, t2) {
        en(this, 1, e2, Wi, t2);
      }, setUint8: function(e2, t2) {
        en(this, 1, e2, Wi, t2);
      }, setInt16: function(e2, t2) {
        en(this, 2, e2, Yi, t2, arguments.length > 2 ? arguments[2] : void 0);
      }, setUint16: function(e2, t2) {
        en(this, 2, e2, Yi, t2, arguments.length > 2 ? arguments[2] : void 0);
      }, setInt32: function(e2, t2) {
        en(this, 4, e2, Hi, t2, arguments.length > 2 ? arguments[2] : void 0);
      }, setUint32: function(e2, t2) {
        en(this, 4, e2, Hi, t2, arguments.length > 2 ? arguments[2] : void 0);
      }, setFloat32: function(e2, t2) {
        en(this, 4, e2, Xi, t2, arguments.length > 2 ? arguments[2] : void 0);
      }, setFloat64: function(e2, t2) {
        en(this, 8, e2, Ki, t2, arguments.length > 2 ? arguments[2] : void 0);
      } });
      var tn;
      var nn;
      var an;
      var pn;
      var rn;
      var on;
      Ui(Mi, "ArrayBuffer"), Ui(qi, "DataView");
      var mn;
      var cn = { ArrayBuffer: Mi, DataView: qi };
      var ln = function(e2, t2) {
        var i3 = (function(e3) {
          var t3 = ye2(e3);
          if (t3 < 0) throw RangeError("The argument can't be less than 0");
          return t3;
        })(e2);
        if (i3 % t2) throw RangeError("Wrong offset");
        return i3;
      };
      var sn = Object.keys || function(e2) {
        return Ae(e2, Ee);
      };
      var dn = i2 ? Object.defineProperties : function(e2, t2) {
        d(e2);
        for (var i3, n2 = sn(t2), a2 = n2.length, p3 = 0; a2 > p3; ) y2.f(e2, i3 = n2[p3++], t2[i3]);
        return e2;
      };
      var un = de2("document", "documentElement");
      var fn = ee2("IE_PROTO");
      var yn = function() {
      };
      var vn = function(e2) {
        return "<script>" + e2 + "<\/script>";
      };
      var xn = function() {
        try {
          mn = document.domain && new ActiveXObject("htmlfile");
        } catch (e3) {
        }
        var e2, t2;
        xn = mn ? (function(e3) {
          e3.write(vn("")), e3.close();
          var t3 = e3.parentWindow.Object;
          return e3 = null, t3;
        })(mn) : ((t2 = l("iframe")).style.display = "none", un.appendChild(t2), t2.src = String("javascript:"), (e2 = t2.contentWindow.document).open(), e2.write(vn("document.F=Object")), e2.close(), e2.F);
        for (var i3 = Ee.length; i3--; ) delete xn.prototype[Ee[i3]];
        return xn();
      };
      te2[fn] = true;
      var _n = Object.create || function(e2, t2) {
        var i3;
        return null !== e2 ? (yn.prototype = d(e2), i3 = new yn(), yn.prototype = null, i3[fn] = e2) : i3 = xn(), void 0 === t2 ? i3 : dn(i3, t2);
      };
      var hn = {};
      var gn = st("iterator");
      var bn = function(e2) {
        if (null != e2) return e2[gn] || e2["@@iterator"] || hn[Ft(e2)];
      };
      var wn = st("iterator");
      var kn = Array.prototype;
      var An = function(e2) {
        return void 0 !== e2 && (hn.Array === e2 || kn[wn] === e2);
      };
      var En = function(e2) {
        if ("function" != typeof e2) throw TypeError(String(e2) + " is not a function");
        return e2;
      };
      var Sn = function(e2, t2, i3) {
        if (En(e2), void 0 === t2) return e2;
        switch (i3) {
          case 0:
            return function() {
              return e2.call(t2);
            };
          case 1:
            return function(i4) {
              return e2.call(t2, i4);
            };
          case 2:
            return function(i4, n2) {
              return e2.call(t2, i4, n2);
            };
          case 3:
            return function(i4, n2, a2) {
              return e2.call(t2, i4, n2, a2);
            };
        }
        return function() {
          return e2.apply(t2, arguments);
        };
      };
      var jn = yi.aTypedArrayConstructor;
      var On = function(e2) {
        var t2, i3, n2, a2, p3, r2, o2 = kt(e2), m2 = arguments.length, c2 = m2 > 1 ? arguments[1] : void 0, l2 = void 0 !== c2, s2 = bn(o2);
        if (null != s2 && !An(s2)) for (r2 = (p3 = s2.call(o2)).next, o2 = []; !(a2 = r2.call(p3)).done; ) o2.push(a2.value);
        for (l2 && m2 > 2 && (c2 = Sn(c2, arguments[2], 2)), i3 = xe(o2.length), n2 = new (jn(this))(i3), t2 = 0; i3 > t2; t2++) n2[t2] = l2 ? c2(o2[t2], t2) : o2[t2];
        return n2;
      };
      var Tn = Array.isArray || function(e2) {
        return "Array" == I2(e2);
      };
      var In = st("species");
      var Rn = function(e2, t2) {
        var i3;
        return Tn(e2) && ("function" != typeof (i3 = e2.constructor) || i3 !== Array && !Tn(i3.prototype) ? o(i3) && null === (i3 = i3[In]) && (i3 = void 0) : i3 = void 0), new (void 0 === i3 ? Array : i3)(0 === t2 ? 0 : t2);
      };
      var Ln = [].push;
      var Un = function(e2) {
        var t2 = 1 == e2, i3 = 2 == e2, n2 = 3 == e2, a2 = 4 == e2, p3 = 6 == e2, r2 = 7 == e2, o2 = 5 == e2 || p3;
        return function(m2, c2, l2, s2) {
          for (var d2, u3, f2 = kt(m2), y3 = L(f2), v2 = Sn(c2, l2, 3), x2 = xe(y3.length), _3 = 0, h3 = s2 || Rn, g2 = t2 ? h3(m2, x2) : i3 || r2 ? h3(m2, 0) : void 0; x2 > _3; _3++) if ((o2 || _3 in y3) && (u3 = v2(d2 = y3[_3], _3, f2), e2)) if (t2) g2[_3] = u3;
          else if (u3) switch (e2) {
            case 3:
              return true;
            case 5:
              return d2;
            case 6:
              return _3;
            case 2:
              Ln.call(g2, d2);
          }
          else switch (e2) {
            case 4:
              return false;
            case 7:
              Ln.call(g2, d2);
          }
          return p3 ? -1 : n2 || a2 ? a2 : g2;
        };
      };
      var zn = { forEach: Un(0), map: Un(1), filter: Un(2), some: Un(3), every: Un(4), find: Un(5), findIndex: Un(6), filterOut: Un(7) };
      var Nn = st("species");
      var Fn = function(e2, t2, i3) {
        var n2, a2;
        return Zt && "function" == typeof (n2 = t2.constructor) && n2 !== i3 && o(a2 = n2.prototype) && a2 !== i3.prototype && Zt(e2, a2), e2;
      };
      a((function(e2) {
        var t2 = je.f, n2 = zn.forEach, a2 = me2.get, p3 = me2.set, m2 = y2.f, c2 = C.f, l2 = Math.round, s2 = r.RangeError, d2 = cn.ArrayBuffer, f2 = cn.DataView, v2 = yi.NATIVE_ARRAY_BUFFER_VIEWS, x2 = yi.TYPED_ARRAY_TAG, _3 = yi.TypedArray, h3 = yi.TypedArrayPrototype, g2 = yi.aTypedArrayConstructor, b3 = yi.isTypedArray, w2 = "BYTES_PER_ELEMENT", k2 = "Wrong length", A2 = function(e3, t3) {
          for (var i3 = 0, n3 = t3.length, a3 = new (g2(e3))(n3); n3 > i3; ) a3[i3] = t3[i3++];
          return a3;
        }, E2 = function(e3, t3) {
          m2(e3, t3, { get: function() {
            return a2(this)[t3];
          } });
        }, S3 = function(e3) {
          var t3;
          return e3 instanceof d2 || "ArrayBuffer" == (t3 = Ft(e3)) || "SharedArrayBuffer" == t3;
        }, j2 = function(e3, t3) {
          return b3(e3) && "symbol" != typeof t3 && t3 in e3 && String(+t3) == String(t3);
        }, T3 = function(e3, t3) {
          return j2(e3, t3 = u2(t3, true)) ? O(2, e3[t3]) : c2(e3, t3);
        }, I3 = function(e3, t3, i3) {
          return !(j2(e3, t3 = u2(t3, true)) && o(i3) && F2(i3, "value")) || F2(i3, "get") || F2(i3, "set") || i3.configurable || F2(i3, "writable") && !i3.writable || F2(i3, "enumerable") && !i3.enumerable ? m2(e3, t3, i3) : (e3[t3] = i3.value, e3);
        };
        i2 ? (v2 || (C.f = T3, y2.f = I3, E2(h3, "buffer"), E2(h3, "byteOffset"), E2(h3, "byteLength"), E2(h3, "length")), Me({ target: "Object", stat: true, forced: !v2 }, { getOwnPropertyDescriptor: T3, defineProperty: I3 }), e2.exports = function(e3, c3, u3) {
          var g3 = e3.match(/\d+$/)[0] / 8, E3 = e3 + (u3 ? "Clamped" : "") + "Array", j3 = "get" + e3, O2 = "set" + e3, T4 = r[E3], I4 = T4, R3 = I4 && I4.prototype, L2 = {}, U2 = function(e4, t3) {
            m2(e4, t3, { get: function() {
              return (function(e5, t4) {
                var i3 = a2(e5);
                return i3.view[j3](t4 * g3 + i3.byteOffset, true);
              })(this, t3);
            }, set: function(e5) {
              return (function(e6, t4, i3) {
                var n3 = a2(e6);
                u3 && (i3 = (i3 = l2(i3)) < 0 ? 0 : i3 > 255 ? 255 : 255 & i3), n3.view[O2](t4 * g3 + n3.byteOffset, i3, true);
              })(this, t3, e5);
            }, enumerable: true });
          };
          v2 ? hi && (I4 = c3((function(e4, t3, i3, n3) {
            return bi(e4, I4, E3), Fn(o(t3) ? S3(t3) ? void 0 !== n3 ? new T4(t3, ln(i3, g3), n3) : void 0 !== i3 ? new T4(t3, ln(i3, g3)) : new T4(t3) : b3(t3) ? A2(I4, t3) : On.call(I4, t3) : new T4(wi(t3)), e4, I4);
          })), Zt && Zt(I4, _3), n2(t2(T4), (function(e4) {
            e4 in I4 || M2(I4, e4, T4[e4]);
          })), I4.prototype = R3) : (I4 = c3((function(e4, t3, i3, n3) {
            bi(e4, I4, E3);
            var a3, r2, m3, c4 = 0, l3 = 0;
            if (o(t3)) {
              if (!S3(t3)) return b3(t3) ? A2(I4, t3) : On.call(I4, t3);
              a3 = t3, l3 = ln(i3, g3);
              var u4 = t3.byteLength;
              if (void 0 === n3) {
                if (u4 % g3) throw s2(k2);
                if ((r2 = u4 - l3) < 0) throw s2(k2);
              } else if ((r2 = xe(n3) * g3) + l3 > u4) throw s2(k2);
              m3 = r2 / g3;
            } else m3 = wi(t3), a3 = new d2(r2 = m3 * g3);
            for (p3(e4, { buffer: a3, byteOffset: l3, byteLength: r2, length: m3, view: new f2(a3) }); c4 < m3; ) U2(e4, c4++);
          })), Zt && Zt(I4, _3), R3 = I4.prototype = _n(h3)), R3.constructor !== I4 && M2(R3, "constructor", I4), x2 && M2(R3, x2, E3), L2[E3] = I4, Me({ global: true, forced: I4 != T4, sham: !v2 }, L2), w2 in I4 || M2(I4, w2, g3), w2 in R3 || M2(R3, w2, g3), (function(e4) {
            var t3 = de2(e4), n3 = y2.f;
            i2 && t3 && !t3[Nn] && n3(t3, Nn, { configurable: true, get: function() {
              return this;
            } });
          })(E3);
        }) : e2.exports = function() {
        };
      }))("Uint8", (function(e2) {
        return function(t2, i3, n2) {
          return e2(this, t2, i3, n2);
        };
      }));
      var Pn = Math.min;
      var Cn = [].copyWithin || function(e2, t2) {
        var i3 = kt(this), n2 = xe(i3.length), a2 = ge2(e2, n2), p3 = ge2(t2, n2), r2 = arguments.length > 2 ? arguments[2] : void 0, o2 = Pn((void 0 === r2 ? n2 : ge2(r2, n2)) - p3, n2 - a2), m2 = 1;
        for (p3 < a2 && a2 < p3 + o2 && (m2 = -1, p3 += o2 - 1, a2 += o2 - 1); o2-- > 0; ) p3 in i3 ? i3[a2] = i3[p3] : delete i3[a2], a2 += m2, p3 += m2;
        return i3;
      };
      var Mn = yi.aTypedArray;
      (0, yi.exportTypedArrayMethod)("copyWithin", (function(e2, t2) {
        return Cn.call(Mn(this), e2, t2, arguments.length > 2 ? arguments[2] : void 0);
      }));
      var qn = zn.every;
      var Dn = yi.aTypedArray;
      (0, yi.exportTypedArrayMethod)("every", (function(e2) {
        return qn(Dn(this), e2, arguments.length > 1 ? arguments[1] : void 0);
      }));
      var Bn = yi.aTypedArray;
      (0, yi.exportTypedArrayMethod)("fill", (function(e2) {
        return Ii.apply(Bn(this), arguments);
      }));
      var Vn = st("species");
      var Gn = function(e2, t2) {
        var i3, n2 = d(e2).constructor;
        return void 0 === n2 || null == (i3 = d(n2)[Vn]) ? t2 : En(i3);
      };
      var $n = yi.aTypedArrayConstructor;
      var Wn = function(e2, t2) {
        for (var i3 = Gn(e2, e2.constructor), n2 = 0, a2 = t2.length, p3 = new ($n(i3))(a2); a2 > n2; ) p3[n2] = t2[n2++];
        return p3;
      };
      var Yn = zn.filter;
      var Hn = yi.aTypedArray;
      (0, yi.exportTypedArrayMethod)("filter", (function(e2) {
        var t2 = Yn(Hn(this), e2, arguments.length > 1 ? arguments[1] : void 0);
        return Wn(this, t2);
      }));
      var Qn = zn.find;
      var Xn = yi.aTypedArray;
      (0, yi.exportTypedArrayMethod)("find", (function(e2) {
        return Qn(Xn(this), e2, arguments.length > 1 ? arguments[1] : void 0);
      }));
      var Kn = zn.findIndex;
      var Zn = yi.aTypedArray;
      (0, yi.exportTypedArrayMethod)("findIndex", (function(e2) {
        return Kn(Zn(this), e2, arguments.length > 1 ? arguments[1] : void 0);
      }));
      var Jn = zn.forEach;
      var ea = yi.aTypedArray;
      (0, yi.exportTypedArrayMethod)("forEach", (function(e2) {
        Jn(ea(this), e2, arguments.length > 1 ? arguments[1] : void 0);
      }));
      var ta = we.includes;
      var ia = yi.aTypedArray;
      (0, yi.exportTypedArrayMethod)("includes", (function(e2) {
        return ta(ia(this), e2, arguments.length > 1 ? arguments[1] : void 0);
      }));
      var na = we.indexOf;
      var aa = yi.aTypedArray;
      (0, yi.exportTypedArrayMethod)("indexOf", (function(e2) {
        return na(aa(this), e2, arguments.length > 1 ? arguments[1] : void 0);
      }));
      var pa = st("unscopables");
      var ra = Array.prototype;
      null == ra[pa] && y2.f(ra, pa, { configurable: true, value: _n(null) });
      var oa;
      var ma;
      var ca;
      var la = function(e2) {
        ra[pa][e2] = true;
      };
      var sa = st("iterator");
      var da = false;
      [].keys && ("next" in (ca = [].keys()) ? (ma = Kt(Kt(ca))) !== Object.prototype && (oa = ma) : da = true), (null == oa || t((function() {
        var e2 = {};
        return oa[sa].call(e2) !== e2;
      }))) && (oa = {}), F2(oa, sa) || M2(oa, sa, (function() {
        return this;
      }));
      var ua = { IteratorPrototype: oa, BUGGY_SAFARI_ITERATORS: da };
      var fa = ua.IteratorPrototype;
      var ya = function() {
        return this;
      };
      var va = function(e2, t2, i3) {
        var n2 = t2 + " Iterator";
        return e2.prototype = _n(fa, { next: O(1, i3) }), Ui(e2, n2, false), hn[n2] = ya, e2;
      };
      var xa = ua.IteratorPrototype;
      var _a = ua.BUGGY_SAFARI_ITERATORS;
      var ha = st("iterator");
      var ga = function() {
        return this;
      };
      var ba = function(e2, t2, i3, n2, a2, p3, r2) {
        va(i3, t2, n2);
        var o2, m2, c2, l2 = function(e3) {
          if (e3 === a2 && y3) return y3;
          if (!_a && e3 in u3) return u3[e3];
          switch (e3) {
            case "keys":
            case "values":
            case "entries":
              return function() {
                return new i3(this, e3);
              };
          }
          return function() {
            return new i3(this);
          };
        }, s2 = t2 + " Iterator", d2 = false, u3 = e2.prototype, f2 = u3[ha] || u3["@@iterator"] || a2 && u3[a2], y3 = !_a && f2 || l2(a2), v2 = "Array" == t2 && u3.entries || f2;
        if (v2 && (o2 = Kt(v2.call(new e2())), xa !== Object.prototype && o2.next && (Kt(o2) !== xa && (Zt ? Zt(o2, xa) : "function" != typeof o2[ha] && M2(o2, ha, ga)), Ui(o2, s2, true))), "values" == a2 && f2 && "values" !== f2.name && (d2 = true, y3 = function() {
          return f2.call(this);
        }), u3[ha] !== y3 && M2(u3, ha, y3), hn[t2] = y3, a2) if (m2 = { values: l2("values"), keys: p3 ? y3 : l2("keys"), entries: l2("entries") }, r2) for (c2 in m2) (_a || d2 || !(c2 in u3)) && ce2(u3, c2, m2[c2]);
        else Me({ target: t2, proto: true, forced: _a || d2 }, m2);
        return m2;
      };
      var wa = me2.set;
      var ka = me2.getterFor("Array Iterator");
      var Aa = ba(Array, "Array", (function(e2, t2) {
        wa(this, { type: "Array Iterator", target: z2(e2), index: 0, kind: t2 });
      }), (function() {
        var e2 = ka(this), t2 = e2.target, i3 = e2.kind, n2 = e2.index++;
        return !t2 || n2 >= t2.length ? (e2.target = void 0, { value: void 0, done: true }) : "keys" == i3 ? { value: n2, done: false } : "values" == i3 ? { value: t2[n2], done: false } : { value: [n2, t2[n2]], done: false };
      }), "values");
      hn.Arguments = hn.Array, la("keys"), la("values"), la("entries");
      var Ea = st("iterator");
      var Sa = r.Uint8Array;
      var ja = Aa.values;
      var Oa = Aa.keys;
      var Ta = Aa.entries;
      var Ia = yi.aTypedArray;
      var Ra = yi.exportTypedArrayMethod;
      var La = Sa && Sa.prototype[Ea];
      var Ua = !!La && ("values" == La.name || null == La.name);
      var za = function() {
        return ja.call(Ia(this));
      };
      Ra("entries", (function() {
        return Ta.call(Ia(this));
      })), Ra("keys", (function() {
        return Oa.call(Ia(this));
      })), Ra("values", za, !Ua), Ra(Ea, za, !Ua);
      var Na = yi.aTypedArray;
      var Fa = [].join;
      (0, yi.exportTypedArrayMethod)("join", (function(e2) {
        return Fa.apply(Na(this), arguments);
      }));
      var Pa = function(e2, i3) {
        var n2 = [][e2];
        return !!n2 && t((function() {
          n2.call(null, i3 || function() {
            throw 1;
          }, 1);
        }));
      };
      var Ca = Math.min;
      var Ma = [].lastIndexOf;
      var qa = !!Ma && 1 / [1].lastIndexOf(1, -0) < 0;
      var Da = Pa("lastIndexOf");
      var Ba = qa || !Da ? function(e2) {
        if (qa) return Ma.apply(this, arguments) || 0;
        var t2 = z2(this), i3 = xe(t2.length), n2 = i3 - 1;
        for (arguments.length > 1 && (n2 = Ca(n2, ye2(arguments[1]))), n2 < 0 && (n2 = i3 + n2); n2 >= 0; n2--) if (n2 in t2 && t2[n2] === e2) return n2 || 0;
        return -1;
      } : Ma;
      var Va = yi.aTypedArray;
      (0, yi.exportTypedArrayMethod)("lastIndexOf", (function(e2) {
        return Ba.apply(Va(this), arguments);
      }));
      var Ga = zn.map;
      var $a = yi.aTypedArray;
      var Wa = yi.aTypedArrayConstructor;
      (0, yi.exportTypedArrayMethod)("map", (function(e2) {
        return Ga($a(this), e2, arguments.length > 1 ? arguments[1] : void 0, (function(e3, t2) {
          return new (Wa(Gn(e3, e3.constructor)))(t2);
        }));
      }));
      var Ya = function(e2) {
        return function(t2, i3, n2, a2) {
          En(i3);
          var p3 = kt(t2), r2 = L(p3), o2 = xe(p3.length), m2 = e2 ? o2 - 1 : 0, c2 = e2 ? -1 : 1;
          if (n2 < 2) for (; ; ) {
            if (m2 in r2) {
              a2 = r2[m2], m2 += c2;
              break;
            }
            if (m2 += c2, e2 ? m2 < 0 : o2 <= m2) throw TypeError("Reduce of empty array with no initial value");
          }
          for (; e2 ? m2 >= 0 : o2 > m2; m2 += c2) m2 in r2 && (a2 = i3(a2, r2[m2], m2, p3));
          return a2;
        };
      };
      var Ha = { left: Ya(false), right: Ya(true) };
      var Qa = Ha.left;
      var Xa = yi.aTypedArray;
      (0, yi.exportTypedArrayMethod)("reduce", (function(e2) {
        return Qa(Xa(this), e2, arguments.length, arguments.length > 1 ? arguments[1] : void 0);
      }));
      var Ka = Ha.right;
      var Za = yi.aTypedArray;
      (0, yi.exportTypedArrayMethod)("reduceRight", (function(e2) {
        return Ka(Za(this), e2, arguments.length, arguments.length > 1 ? arguments[1] : void 0);
      }));
      var Ja = yi.aTypedArray;
      var ep = yi.exportTypedArrayMethod;
      var tp = Math.floor;
      ep("reverse", (function() {
        for (var e2, t2 = this, i3 = Ja(t2).length, n2 = tp(i3 / 2), a2 = 0; a2 < n2; ) e2 = t2[a2], t2[a2++] = t2[--i3], t2[i3] = e2;
        return t2;
      }));
      var ip = yi.aTypedArray;
      (0, yi.exportTypedArrayMethod)("set", (function(e2) {
        ip(this);
        var t2 = ln(arguments.length > 1 ? arguments[1] : void 0, 1), i3 = this.length, n2 = kt(e2), a2 = xe(n2.length), p3 = 0;
        if (a2 + t2 > i3) throw RangeError("Wrong length");
        for (; p3 < a2; ) this[t2 + p3] = n2[p3++];
      }), t((function() {
        new Int8Array(1).set({});
      })));
      var np = yi.aTypedArray;
      var ap = yi.aTypedArrayConstructor;
      var pp = [].slice;
      (0, yi.exportTypedArrayMethod)("slice", (function(e2, t2) {
        for (var i3 = pp.call(np(this), e2, t2), n2 = Gn(this, this.constructor), a2 = 0, p3 = i3.length, r2 = new (ap(n2))(p3); p3 > a2; ) r2[a2] = i3[a2++];
        return r2;
      }), t((function() {
        new Int8Array(1).slice();
      })));
      var rp = zn.some;
      var op = yi.aTypedArray;
      (0, yi.exportTypedArrayMethod)("some", (function(e2) {
        return rp(op(this), e2, arguments.length > 1 ? arguments[1] : void 0);
      }));
      var mp = yi.aTypedArray;
      var cp = [].sort;
      (0, yi.exportTypedArrayMethod)("sort", (function(e2) {
        return cp.call(mp(this), e2);
      }));
      var lp = yi.aTypedArray;
      (0, yi.exportTypedArrayMethod)("subarray", (function(e2, t2) {
        var i3 = lp(this), n2 = i3.length, a2 = ge2(e2, n2);
        return new (Gn(i3, i3.constructor))(i3.buffer, i3.byteOffset + a2 * i3.BYTES_PER_ELEMENT, xe((void 0 === t2 ? n2 : ge2(t2, n2)) - a2));
      }));
      var sp = r.Int8Array;
      var dp = yi.aTypedArray;
      var up = yi.exportTypedArrayMethod;
      var fp = [].toLocaleString;
      var yp = [].slice;
      var vp = !!sp && t((function() {
        fp.call(new sp(1));
      }));
      up("toLocaleString", (function() {
        return fp.apply(vp ? yp.call(dp(this)) : dp(this), arguments);
      }), t((function() {
        return [1, 2].toLocaleString() != new sp([1, 2]).toLocaleString();
      })) || !t((function() {
        sp.prototype.toLocaleString.call([1, 2]);
      })));
      var xp = yi.exportTypedArrayMethod;
      var _p = r.Uint8Array;
      var hp = _p && _p.prototype || {};
      var gp = [].toString;
      var bp = [].join;
      t((function() {
        gp.call({});
      })) && (gp = function() {
        return bp.call(this);
      });
      var wp = hp.toString != gp;
      xp("toString", gp, wp);
      var kp = gt.charAt;
      var Ap = me2.set;
      var Ep = me2.getterFor("String Iterator");
      ba(String, "String", (function(e2) {
        Ap(this, { type: "String Iterator", string: String(e2), index: 0 });
      }), (function() {
        var e2, t2 = Ep(this), i3 = t2.string, n2 = t2.index;
        return n2 >= i3.length ? { value: void 0, done: true } : (e2 = kp(i3, n2), t2.index += e2.length, { value: e2, done: false });
      }));
      var Sp = st("iterator");
      var jp = !t((function() {
        var e2 = new URL("b?a=1&b=2&c=3", "http://a"), t2 = e2.searchParams, i3 = "";
        return e2.pathname = "c%20d", t2.forEach((function(e3, n2) {
          t2.delete("b"), i3 += n2 + e3;
        })), !t2.sort || "http://a/c%20d?a=1&c=3" !== e2.href || "3" !== t2.get("c") || "a=1" !== String(new URLSearchParams("?a=1")) || !t2[Sp] || "a" !== new URL("https://a@b").username || "b" !== new URLSearchParams(new URLSearchParams("a=b")).get("a") || "xn--e1aybc" !== new URL("http://\u0442\u0435\u0441\u0442").host || "#%D0%B1" !== new URL("http://a#\u0431").hash || "a1c3" !== i3 || "x" !== new URL("http://x", void 0).host;
      }));
      var Op = Object.assign;
      var Tp = Object.defineProperty;
      var Ip = !Op || t((function() {
        if (i2 && 1 !== Op({ b: 1 }, Op(Tp({}, "a", { enumerable: true, get: function() {
          Tp(this, "b", { value: 3, enumerable: false });
        } }), { b: 2 })).b) return true;
        var e2 = {}, t2 = {}, n2 = /* @__PURE__ */ Symbol(), a2 = "abcdefghijklmnopqrst";
        return e2[n2] = 7, a2.split("").forEach((function(e3) {
          t2[e3] = e3;
        })), 7 != Op({}, e2)[n2] || sn(Op({}, t2)).join("") != a2;
      })) ? function(e2, t2) {
        for (var n2 = kt(e2), a2 = arguments.length, p3 = 1, r2 = Oe.f, o2 = j.f; a2 > p3; ) for (var m2, c2 = L(arguments[p3++]), l2 = r2 ? sn(c2).concat(r2(c2)) : sn(c2), s2 = l2.length, d2 = 0; s2 > d2; ) m2 = l2[d2++], i2 && !o2.call(c2, m2) || (n2[m2] = c2[m2]);
        return n2;
      } : Op;
      var Rp = function(e2, t2, i3, n2) {
        try {
          return n2 ? t2(d(i3)[0], i3[1]) : t2(i3);
        } catch (t3) {
          throw (function(e3) {
            var t4 = e3.return;
            if (void 0 !== t4) d(t4.call(e3)).value;
          })(e2), t3;
        }
      };
      var Lp = function(e2, t2, i3) {
        var n2 = u2(t2);
        n2 in e2 ? y2.f(e2, n2, O(0, i3)) : e2[n2] = i3;
      };
      var Up = function(e2) {
        var t2, i3, n2, a2, p3, r2, o2 = kt(e2), m2 = "function" == typeof this ? this : Array, c2 = arguments.length, l2 = c2 > 1 ? arguments[1] : void 0, s2 = void 0 !== l2, d2 = bn(o2), u3 = 0;
        if (s2 && (l2 = Sn(l2, c2 > 2 ? arguments[2] : void 0, 2)), null == d2 || m2 == Array && An(d2)) for (i3 = new m2(t2 = xe(o2.length)); t2 > u3; u3++) r2 = s2 ? l2(o2[u3], u3) : o2[u3], Lp(i3, u3, r2);
        else for (p3 = (a2 = d2.call(o2)).next, i3 = new m2(); !(n2 = p3.call(a2)).done; u3++) r2 = s2 ? Rp(a2, l2, [n2.value, u3], true) : n2.value, Lp(i3, u3, r2);
        return i3.length = u3, i3;
      };
      var zp = /[^\0-\u007E]/;
      var Np = /[.\u3002\uFF0E\uFF61]/g;
      var Fp = "Overflow: input needs wider integers to process";
      var Pp = Math.floor;
      var Cp = String.fromCharCode;
      var Mp = function(e2) {
        return e2 + 22 + 75 * (e2 < 26);
      };
      var qp = function(e2, t2, i3) {
        var n2 = 0;
        for (e2 = i3 ? Pp(e2 / 700) : e2 >> 1, e2 += Pp(e2 / t2); e2 > 455; n2 += 36) e2 = Pp(e2 / 35);
        return Pp(n2 + 36 * e2 / (e2 + 38));
      };
      var Dp = function(e2) {
        var t2, i3, n2 = [], a2 = (e2 = (function(e3) {
          for (var t3 = [], i4 = 0, n3 = e3.length; i4 < n3; ) {
            var a3 = e3.charCodeAt(i4++);
            if (a3 >= 55296 && a3 <= 56319 && i4 < n3) {
              var p4 = e3.charCodeAt(i4++);
              56320 == (64512 & p4) ? t3.push(((1023 & a3) << 10) + (1023 & p4) + 65536) : (t3.push(a3), i4--);
            } else t3.push(a3);
          }
          return t3;
        })(e2)).length, p3 = 128, r2 = 0, o2 = 72;
        for (t2 = 0; t2 < e2.length; t2++) (i3 = e2[t2]) < 128 && n2.push(Cp(i3));
        var m2 = n2.length, c2 = m2;
        for (m2 && n2.push("-"); c2 < a2; ) {
          var l2 = 2147483647;
          for (t2 = 0; t2 < e2.length; t2++) (i3 = e2[t2]) >= p3 && i3 < l2 && (l2 = i3);
          var s2 = c2 + 1;
          if (l2 - p3 > Pp((2147483647 - r2) / s2)) throw RangeError(Fp);
          for (r2 += (l2 - p3) * s2, p3 = l2, t2 = 0; t2 < e2.length; t2++) {
            if ((i3 = e2[t2]) < p3 && ++r2 > 2147483647) throw RangeError(Fp);
            if (i3 == p3) {
              for (var d2 = r2, u3 = 36; ; u3 += 36) {
                var f2 = u3 <= o2 ? 1 : u3 >= o2 + 26 ? 26 : u3 - o2;
                if (d2 < f2) break;
                var y3 = d2 - f2, v2 = 36 - f2;
                n2.push(Cp(Mp(f2 + y3 % v2))), d2 = Pp(y3 / v2);
              }
              n2.push(Cp(Mp(d2))), o2 = qp(r2, s2, c2 == m2), r2 = 0, ++c2;
            }
          }
          ++r2, ++p3;
        }
        return n2.join("");
      };
      var Bp = function(e2) {
        var t2 = bn(e2);
        if ("function" != typeof t2) throw TypeError(String(e2) + " is not iterable");
        return d(t2.call(e2));
      };
      var Vp = de2("fetch");
      var Gp = de2("Headers");
      var $p = st("iterator");
      var Wp = me2.set;
      var Yp = me2.getterFor("URLSearchParams");
      var Hp = me2.getterFor("URLSearchParamsIterator");
      var Qp = /\+/g;
      var Xp = Array(4);
      var Kp = function(e2) {
        return Xp[e2 - 1] || (Xp[e2 - 1] = RegExp("((?:%[\\da-f]{2}){" + e2 + "})", "gi"));
      };
      var Zp = function(e2) {
        try {
          return decodeURIComponent(e2);
        } catch (t2) {
          return e2;
        }
      };
      var Jp = function(e2) {
        var t2 = e2.replace(Qp, " "), i3 = 4;
        try {
          return decodeURIComponent(t2);
        } catch (e3) {
          for (; i3; ) t2 = t2.replace(Kp(i3--), Zp);
          return t2;
        }
      };
      var er = /[!'()~]|%20/g;
      var tr = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+" };
      var ir = function(e2) {
        return tr[e2];
      };
      var nr = function(e2) {
        return encodeURIComponent(e2).replace(er, ir);
      };
      var ar = function(e2, t2) {
        if (t2) for (var i3, n2, a2 = t2.split("&"), p3 = 0; p3 < a2.length; ) (i3 = a2[p3++]).length && (n2 = i3.split("="), e2.push({ key: Jp(n2.shift()), value: Jp(n2.join("=")) }));
      };
      var pr = function(e2) {
        this.entries.length = 0, ar(this.entries, e2);
      };
      var rr = function(e2, t2) {
        if (e2 < t2) throw TypeError("Not enough arguments");
      };
      var or = va((function(e2, t2) {
        Wp(this, { type: "URLSearchParamsIterator", iterator: Bp(Yp(e2).entries), kind: t2 });
      }), "Iterator", (function() {
        var e2 = Hp(this), t2 = e2.kind, i3 = e2.iterator.next(), n2 = i3.value;
        return i3.done || (i3.value = "keys" === t2 ? n2.key : "values" === t2 ? n2.value : [n2.key, n2.value]), i3;
      }));
      var mr = function() {
        bi(this, mr, "URLSearchParams");
        var e2, t2, i3, n2, a2, p3, r2, m2, c2, l2 = arguments.length > 0 ? arguments[0] : void 0, s2 = this, u3 = [];
        if (Wp(s2, { type: "URLSearchParams", entries: u3, updateURL: function() {
        }, updateSearchParams: pr }), void 0 !== l2) if (o(l2)) if ("function" == typeof (e2 = bn(l2))) for (i3 = (t2 = e2.call(l2)).next; !(n2 = i3.call(t2)).done; ) {
          if ((r2 = (p3 = (a2 = Bp(d(n2.value))).next).call(a2)).done || (m2 = p3.call(a2)).done || !p3.call(a2).done) throw TypeError("Expected sequence with length 2");
          u3.push({ key: r2.value + "", value: m2.value + "" });
        }
        else for (c2 in l2) F2(l2, c2) && u3.push({ key: c2, value: l2[c2] + "" });
        else ar(u3, "string" == typeof l2 ? "?" === l2.charAt(0) ? l2.slice(1) : l2 : l2 + "");
      };
      var cr = mr.prototype;
      gi(cr, { append: function(e2, t2) {
        rr(arguments.length, 2);
        var i3 = Yp(this);
        i3.entries.push({ key: e2 + "", value: t2 + "" }), i3.updateURL();
      }, delete: function(e2) {
        rr(arguments.length, 1);
        for (var t2 = Yp(this), i3 = t2.entries, n2 = e2 + "", a2 = 0; a2 < i3.length; ) i3[a2].key === n2 ? i3.splice(a2, 1) : a2++;
        t2.updateURL();
      }, get: function(e2) {
        rr(arguments.length, 1);
        for (var t2 = Yp(this).entries, i3 = e2 + "", n2 = 0; n2 < t2.length; n2++) if (t2[n2].key === i3) return t2[n2].value;
        return null;
      }, getAll: function(e2) {
        rr(arguments.length, 1);
        for (var t2 = Yp(this).entries, i3 = e2 + "", n2 = [], a2 = 0; a2 < t2.length; a2++) t2[a2].key === i3 && n2.push(t2[a2].value);
        return n2;
      }, has: function(e2) {
        rr(arguments.length, 1);
        for (var t2 = Yp(this).entries, i3 = e2 + "", n2 = 0; n2 < t2.length; ) if (t2[n2++].key === i3) return true;
        return false;
      }, set: function(e2, t2) {
        rr(arguments.length, 1);
        for (var i3, n2 = Yp(this), a2 = n2.entries, p3 = false, r2 = e2 + "", o2 = t2 + "", m2 = 0; m2 < a2.length; m2++) (i3 = a2[m2]).key === r2 && (p3 ? a2.splice(m2--, 1) : (p3 = true, i3.value = o2));
        p3 || a2.push({ key: r2, value: o2 }), n2.updateURL();
      }, sort: function() {
        var e2, t2, i3, n2 = Yp(this), a2 = n2.entries, p3 = a2.slice();
        for (a2.length = 0, i3 = 0; i3 < p3.length; i3++) {
          for (e2 = p3[i3], t2 = 0; t2 < i3; t2++) if (a2[t2].key > e2.key) {
            a2.splice(t2, 0, e2);
            break;
          }
          t2 === i3 && a2.push(e2);
        }
        n2.updateURL();
      }, forEach: function(e2) {
        for (var t2, i3 = Yp(this).entries, n2 = Sn(e2, arguments.length > 1 ? arguments[1] : void 0, 3), a2 = 0; a2 < i3.length; ) n2((t2 = i3[a2++]).value, t2.key, this);
      }, keys: function() {
        return new or(this, "keys");
      }, values: function() {
        return new or(this, "values");
      }, entries: function() {
        return new or(this, "entries");
      } }, { enumerable: true }), ce2(cr, $p, cr.entries), ce2(cr, "toString", (function() {
        for (var e2, t2 = Yp(this).entries, i3 = [], n2 = 0; n2 < t2.length; ) e2 = t2[n2++], i3.push(nr(e2.key) + "=" + nr(e2.value));
        return i3.join("&");
      }), { enumerable: true }), Ui(mr, "URLSearchParams"), Me({ global: true, forced: !jp }, { URLSearchParams: mr }), jp || "function" != typeof Vp || "function" != typeof Gp || Me({ global: true, enumerable: true, forced: true }, { fetch: function(e2) {
        var t2, i3, n2, a2 = [e2];
        return arguments.length > 1 && (o(t2 = arguments[1]) && (i3 = t2.body, "URLSearchParams" === Ft(i3) && ((n2 = t2.headers ? new Gp(t2.headers) : new Gp()).has("content-type") || n2.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"), t2 = _n(t2, { body: O(0, String(i3)), headers: O(0, n2) }))), a2.push(t2)), Vp.apply(this, a2);
      } });
      var lr;
      var sr = { URLSearchParams: mr, getState: Yp };
      var dr = gt.codeAt;
      var ur = r.URL;
      var fr = sr.URLSearchParams;
      var yr = sr.getState;
      var vr = me2.set;
      var xr = me2.getterFor("URL");
      var _r = Math.floor;
      var hr = Math.pow;
      var gr = /[A-Za-z]/;
      var br = /[\d+-.A-Za-z]/;
      var wr = /\d/;
      var kr = /^(0x|0X)/;
      var Ar = /^[0-7]+$/;
      var Er = /^\d+$/;
      var Sr = /^[\dA-Fa-f]+$/;
      var jr = /[\u0000\t\u000A\u000D #%/:?@[\\]]/;
      var Or = /[\u0000\t\u000A\u000D #/:?@[\\]]/;
      var Tr = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g;
      var Ir = /[\t\u000A\u000D]/g;
      var Rr = function(e2, t2) {
        var i3, n2, a2;
        if ("[" == t2.charAt(0)) {
          if ("]" != t2.charAt(t2.length - 1)) return "Invalid host";
          if (!(i3 = Ur(t2.slice(1, -1)))) return "Invalid host";
          e2.host = i3;
        } else if (Dr(e2)) {
          if (t2 = (function(e3) {
            var t3, i4, n3 = [], a3 = e3.toLowerCase().replace(Np, ".").split(".");
            for (t3 = 0; t3 < a3.length; t3++) i4 = a3[t3], n3.push(zp.test(i4) ? "xn--" + Dp(i4) : i4);
            return n3.join(".");
          })(t2), jr.test(t2)) return "Invalid host";
          if (null === (i3 = Lr(t2))) return "Invalid host";
          e2.host = i3;
        } else {
          if (Or.test(t2)) return "Invalid host";
          for (i3 = "", n2 = Up(t2), a2 = 0; a2 < n2.length; a2++) i3 += Mr(n2[a2], Nr);
          e2.host = i3;
        }
      };
      var Lr = function(e2) {
        var t2, i3, n2, a2, p3, r2, o2, m2 = e2.split(".");
        if (m2.length && "" == m2[m2.length - 1] && m2.pop(), (t2 = m2.length) > 4) return e2;
        for (i3 = [], n2 = 0; n2 < t2; n2++) {
          if ("" == (a2 = m2[n2])) return e2;
          if (p3 = 10, a2.length > 1 && "0" == a2.charAt(0) && (p3 = kr.test(a2) ? 16 : 8, a2 = a2.slice(8 == p3 ? 1 : 2)), "" === a2) r2 = 0;
          else {
            if (!(10 == p3 ? Er : 8 == p3 ? Ar : Sr).test(a2)) return e2;
            r2 = parseInt(a2, p3);
          }
          i3.push(r2);
        }
        for (n2 = 0; n2 < t2; n2++) if (r2 = i3[n2], n2 == t2 - 1) {
          if (r2 >= hr(256, 5 - t2)) return null;
        } else if (r2 > 255) return null;
        for (o2 = i3.pop(), n2 = 0; n2 < i3.length; n2++) o2 += i3[n2] * hr(256, 3 - n2);
        return o2;
      };
      var Ur = function(e2) {
        var t2, i3, n2, a2, p3, r2, o2, m2 = [0, 0, 0, 0, 0, 0, 0, 0], c2 = 0, l2 = null, s2 = 0, d2 = function() {
          return e2.charAt(s2);
        };
        if (":" == d2()) {
          if (":" != e2.charAt(1)) return;
          s2 += 2, l2 = ++c2;
        }
        for (; d2(); ) {
          if (8 == c2) return;
          if (":" != d2()) {
            for (t2 = i3 = 0; i3 < 4 && Sr.test(d2()); ) t2 = 16 * t2 + parseInt(d2(), 16), s2++, i3++;
            if ("." == d2()) {
              if (0 == i3) return;
              if (s2 -= i3, c2 > 6) return;
              for (n2 = 0; d2(); ) {
                if (a2 = null, n2 > 0) {
                  if (!("." == d2() && n2 < 4)) return;
                  s2++;
                }
                if (!wr.test(d2())) return;
                for (; wr.test(d2()); ) {
                  if (p3 = parseInt(d2(), 10), null === a2) a2 = p3;
                  else {
                    if (0 == a2) return;
                    a2 = 10 * a2 + p3;
                  }
                  if (a2 > 255) return;
                  s2++;
                }
                m2[c2] = 256 * m2[c2] + a2, 2 != ++n2 && 4 != n2 || c2++;
              }
              if (4 != n2) return;
              break;
            }
            if (":" == d2()) {
              if (s2++, !d2()) return;
            } else if (d2()) return;
            m2[c2++] = t2;
          } else {
            if (null !== l2) return;
            s2++, l2 = ++c2;
          }
        }
        if (null !== l2) for (r2 = c2 - l2, c2 = 7; 0 != c2 && r2 > 0; ) o2 = m2[c2], m2[c2--] = m2[l2 + r2 - 1], m2[l2 + --r2] = o2;
        else if (8 != c2) return;
        return m2;
      };
      var zr = function(e2) {
        var t2, i3, n2, a2;
        if ("number" == typeof e2) {
          for (t2 = [], i3 = 0; i3 < 4; i3++) t2.unshift(e2 % 256), e2 = _r(e2 / 256);
          return t2.join(".");
        }
        if ("object" == typeof e2) {
          for (t2 = "", n2 = (function(e3) {
            for (var t3 = null, i4 = 1, n3 = null, a3 = 0, p3 = 0; p3 < 8; p3++) 0 !== e3[p3] ? (a3 > i4 && (t3 = n3, i4 = a3), n3 = null, a3 = 0) : (null === n3 && (n3 = p3), ++a3);
            return a3 > i4 && (t3 = n3, i4 = a3), t3;
          })(e2), i3 = 0; i3 < 8; i3++) a2 && 0 === e2[i3] || (a2 && (a2 = false), n2 === i3 ? (t2 += i3 ? ":" : "::", a2 = true) : (t2 += e2[i3].toString(16), i3 < 7 && (t2 += ":")));
          return "[" + t2 + "]";
        }
        return e2;
      };
      var Nr = {};
      var Fr = Ip({}, Nr, { " ": 1, '"': 1, "<": 1, ">": 1, "`": 1 });
      var Pr = Ip({}, Fr, { "#": 1, "?": 1, "{": 1, "}": 1 });
      var Cr = Ip({}, Pr, { "/": 1, ":": 1, ";": 1, "=": 1, "@": 1, "[": 1, "\\": 1, "]": 1, "^": 1, "|": 1 });
      var Mr = function(e2, t2) {
        var i3 = dr(e2, 0);
        return i3 > 32 && i3 < 127 && !F2(t2, e2) ? e2 : encodeURIComponent(e2);
      };
      var qr = { ftp: 21, file: null, http: 80, https: 443, ws: 80, wss: 443 };
      var Dr = function(e2) {
        return F2(qr, e2.scheme);
      };
      var Br = function(e2) {
        return "" != e2.username || "" != e2.password;
      };
      var Vr = function(e2) {
        return !e2.host || e2.cannotBeABaseURL || "file" == e2.scheme;
      };
      var Gr = function(e2, t2) {
        var i3;
        return 2 == e2.length && gr.test(e2.charAt(0)) && (":" == (i3 = e2.charAt(1)) || !t2 && "|" == i3);
      };
      var $r = function(e2) {
        var t2;
        return e2.length > 1 && Gr(e2.slice(0, 2)) && (2 == e2.length || "/" === (t2 = e2.charAt(2)) || "\\" === t2 || "?" === t2 || "#" === t2);
      };
      var Wr = function(e2) {
        var t2 = e2.path, i3 = t2.length;
        !i3 || "file" == e2.scheme && 1 == i3 && Gr(t2[0], true) || t2.pop();
      };
      var Yr = function(e2) {
        return "." === e2 || "%2e" === e2.toLowerCase();
      };
      var Hr = {};
      var Qr = {};
      var Xr = {};
      var Kr = {};
      var Zr = {};
      var Jr = {};
      var eo = {};
      var to = {};
      var io = {};
      var no = {};
      var ao = {};
      var po = {};
      var ro = {};
      var oo = {};
      var mo = {};
      var co = {};
      var lo = {};
      var so = {};
      var uo = {};
      var fo = {};
      var yo = {};
      var vo = function(e2, t2, i3, n2) {
        var a2, p3, r2, o2, m2, c2 = i3 || Hr, l2 = 0, s2 = "", d2 = false, u3 = false, f2 = false;
        for (i3 || (e2.scheme = "", e2.username = "", e2.password = "", e2.host = null, e2.port = null, e2.path = [], e2.query = null, e2.fragment = null, e2.cannotBeABaseURL = false, t2 = t2.replace(Tr, "")), t2 = t2.replace(Ir, ""), a2 = Up(t2); l2 <= a2.length; ) {
          switch (p3 = a2[l2], c2) {
            case Hr:
              if (!p3 || !gr.test(p3)) {
                if (i3) return "Invalid scheme";
                c2 = Xr;
                continue;
              }
              s2 += p3.toLowerCase(), c2 = Qr;
              break;
            case Qr:
              if (p3 && (br.test(p3) || "+" == p3 || "-" == p3 || "." == p3)) s2 += p3.toLowerCase();
              else {
                if (":" != p3) {
                  if (i3) return "Invalid scheme";
                  s2 = "", c2 = Xr, l2 = 0;
                  continue;
                }
                if (i3 && (Dr(e2) != F2(qr, s2) || "file" == s2 && (Br(e2) || null !== e2.port) || "file" == e2.scheme && !e2.host)) return;
                if (e2.scheme = s2, i3) return void (Dr(e2) && qr[e2.scheme] == e2.port && (e2.port = null));
                s2 = "", "file" == e2.scheme ? c2 = oo : Dr(e2) && n2 && n2.scheme == e2.scheme ? c2 = Kr : Dr(e2) ? c2 = to : "/" == a2[l2 + 1] ? (c2 = Zr, l2++) : (e2.cannotBeABaseURL = true, e2.path.push(""), c2 = uo);
              }
              break;
            case Xr:
              if (!n2 || n2.cannotBeABaseURL && "#" != p3) return "Invalid scheme";
              if (n2.cannotBeABaseURL && "#" == p3) {
                e2.scheme = n2.scheme, e2.path = n2.path.slice(), e2.query = n2.query, e2.fragment = "", e2.cannotBeABaseURL = true, c2 = yo;
                break;
              }
              c2 = "file" == n2.scheme ? oo : Jr;
              continue;
            case Kr:
              if ("/" != p3 || "/" != a2[l2 + 1]) {
                c2 = Jr;
                continue;
              }
              c2 = io, l2++;
              break;
            case Zr:
              if ("/" == p3) {
                c2 = no;
                break;
              }
              c2 = so;
              continue;
            case Jr:
              if (e2.scheme = n2.scheme, p3 == lr) e2.username = n2.username, e2.password = n2.password, e2.host = n2.host, e2.port = n2.port, e2.path = n2.path.slice(), e2.query = n2.query;
              else if ("/" == p3 || "\\" == p3 && Dr(e2)) c2 = eo;
              else if ("?" == p3) e2.username = n2.username, e2.password = n2.password, e2.host = n2.host, e2.port = n2.port, e2.path = n2.path.slice(), e2.query = "", c2 = fo;
              else {
                if ("#" != p3) {
                  e2.username = n2.username, e2.password = n2.password, e2.host = n2.host, e2.port = n2.port, e2.path = n2.path.slice(), e2.path.pop(), c2 = so;
                  continue;
                }
                e2.username = n2.username, e2.password = n2.password, e2.host = n2.host, e2.port = n2.port, e2.path = n2.path.slice(), e2.query = n2.query, e2.fragment = "", c2 = yo;
              }
              break;
            case eo:
              if (!Dr(e2) || "/" != p3 && "\\" != p3) {
                if ("/" != p3) {
                  e2.username = n2.username, e2.password = n2.password, e2.host = n2.host, e2.port = n2.port, c2 = so;
                  continue;
                }
                c2 = no;
              } else c2 = io;
              break;
            case to:
              if (c2 = io, "/" != p3 || "/" != s2.charAt(l2 + 1)) continue;
              l2++;
              break;
            case io:
              if ("/" != p3 && "\\" != p3) {
                c2 = no;
                continue;
              }
              break;
            case no:
              if ("@" == p3) {
                d2 && (s2 = "%40" + s2), d2 = true, r2 = Up(s2);
                for (var y3 = 0; y3 < r2.length; y3++) {
                  var v2 = r2[y3];
                  if (":" != v2 || f2) {
                    var x2 = Mr(v2, Cr);
                    f2 ? e2.password += x2 : e2.username += x2;
                  } else f2 = true;
                }
                s2 = "";
              } else if (p3 == lr || "/" == p3 || "?" == p3 || "#" == p3 || "\\" == p3 && Dr(e2)) {
                if (d2 && "" == s2) return "Invalid authority";
                l2 -= Up(s2).length + 1, s2 = "", c2 = ao;
              } else s2 += p3;
              break;
            case ao:
            case po:
              if (i3 && "file" == e2.scheme) {
                c2 = co;
                continue;
              }
              if (":" != p3 || u3) {
                if (p3 == lr || "/" == p3 || "?" == p3 || "#" == p3 || "\\" == p3 && Dr(e2)) {
                  if (Dr(e2) && "" == s2) return "Invalid host";
                  if (i3 && "" == s2 && (Br(e2) || null !== e2.port)) return;
                  if (o2 = Rr(e2, s2)) return o2;
                  if (s2 = "", c2 = lo, i3) return;
                  continue;
                }
                "[" == p3 ? u3 = true : "]" == p3 && (u3 = false), s2 += p3;
              } else {
                if ("" == s2) return "Invalid host";
                if (o2 = Rr(e2, s2)) return o2;
                if (s2 = "", c2 = ro, i3 == po) return;
              }
              break;
            case ro:
              if (!wr.test(p3)) {
                if (p3 == lr || "/" == p3 || "?" == p3 || "#" == p3 || "\\" == p3 && Dr(e2) || i3) {
                  if ("" != s2) {
                    var _3 = parseInt(s2, 10);
                    if (_3 > 65535) return "Invalid port";
                    e2.port = Dr(e2) && _3 === qr[e2.scheme] ? null : _3, s2 = "";
                  }
                  if (i3) return;
                  c2 = lo;
                  continue;
                }
                return "Invalid port";
              }
              s2 += p3;
              break;
            case oo:
              if (e2.scheme = "file", "/" == p3 || "\\" == p3) c2 = mo;
              else {
                if (!n2 || "file" != n2.scheme) {
                  c2 = so;
                  continue;
                }
                if (p3 == lr) e2.host = n2.host, e2.path = n2.path.slice(), e2.query = n2.query;
                else if ("?" == p3) e2.host = n2.host, e2.path = n2.path.slice(), e2.query = "", c2 = fo;
                else {
                  if ("#" != p3) {
                    $r(a2.slice(l2).join("")) || (e2.host = n2.host, e2.path = n2.path.slice(), Wr(e2)), c2 = so;
                    continue;
                  }
                  e2.host = n2.host, e2.path = n2.path.slice(), e2.query = n2.query, e2.fragment = "", c2 = yo;
                }
              }
              break;
            case mo:
              if ("/" == p3 || "\\" == p3) {
                c2 = co;
                break;
              }
              n2 && "file" == n2.scheme && !$r(a2.slice(l2).join("")) && (Gr(n2.path[0], true) ? e2.path.push(n2.path[0]) : e2.host = n2.host), c2 = so;
              continue;
            case co:
              if (p3 == lr || "/" == p3 || "\\" == p3 || "?" == p3 || "#" == p3) {
                if (!i3 && Gr(s2)) c2 = so;
                else if ("" == s2) {
                  if (e2.host = "", i3) return;
                  c2 = lo;
                } else {
                  if (o2 = Rr(e2, s2)) return o2;
                  if ("localhost" == e2.host && (e2.host = ""), i3) return;
                  s2 = "", c2 = lo;
                }
                continue;
              }
              s2 += p3;
              break;
            case lo:
              if (Dr(e2)) {
                if (c2 = so, "/" != p3 && "\\" != p3) continue;
              } else if (i3 || "?" != p3) if (i3 || "#" != p3) {
                if (p3 != lr && (c2 = so, "/" != p3)) continue;
              } else e2.fragment = "", c2 = yo;
              else e2.query = "", c2 = fo;
              break;
            case so:
              if (p3 == lr || "/" == p3 || "\\" == p3 && Dr(e2) || !i3 && ("?" == p3 || "#" == p3)) {
                if (".." === (m2 = (m2 = s2).toLowerCase()) || "%2e." === m2 || ".%2e" === m2 || "%2e%2e" === m2 ? (Wr(e2), "/" == p3 || "\\" == p3 && Dr(e2) || e2.path.push("")) : Yr(s2) ? "/" == p3 || "\\" == p3 && Dr(e2) || e2.path.push("") : ("file" == e2.scheme && !e2.path.length && Gr(s2) && (e2.host && (e2.host = ""), s2 = s2.charAt(0) + ":"), e2.path.push(s2)), s2 = "", "file" == e2.scheme && (p3 == lr || "?" == p3 || "#" == p3)) for (; e2.path.length > 1 && "" === e2.path[0]; ) e2.path.shift();
                "?" == p3 ? (e2.query = "", c2 = fo) : "#" == p3 && (e2.fragment = "", c2 = yo);
              } else s2 += Mr(p3, Pr);
              break;
            case uo:
              "?" == p3 ? (e2.query = "", c2 = fo) : "#" == p3 ? (e2.fragment = "", c2 = yo) : p3 != lr && (e2.path[0] += Mr(p3, Nr));
              break;
            case fo:
              i3 || "#" != p3 ? p3 != lr && ("'" == p3 && Dr(e2) ? e2.query += "%27" : e2.query += "#" == p3 ? "%23" : Mr(p3, Nr)) : (e2.fragment = "", c2 = yo);
              break;
            case yo:
              p3 != lr && (e2.fragment += Mr(p3, Fr));
          }
          l2++;
        }
      };
      var xo = function(e2) {
        var t2, n2, a2 = bi(this, xo, "URL"), p3 = arguments.length > 1 ? arguments[1] : void 0, r2 = String(e2), o2 = vr(a2, { type: "URL" });
        if (void 0 !== p3) {
          if (p3 instanceof xo) t2 = xr(p3);
          else if (n2 = vo(t2 = {}, String(p3))) throw TypeError(n2);
        }
        if (n2 = vo(o2, r2, null, t2)) throw TypeError(n2);
        var m2 = o2.searchParams = new fr(), c2 = yr(m2);
        c2.updateSearchParams(o2.query), c2.updateURL = function() {
          o2.query = String(m2) || null;
        }, i2 || (a2.href = ho.call(a2), a2.origin = go.call(a2), a2.protocol = bo.call(a2), a2.username = wo.call(a2), a2.password = ko.call(a2), a2.host = Ao.call(a2), a2.hostname = Eo.call(a2), a2.port = So.call(a2), a2.pathname = jo.call(a2), a2.search = Oo.call(a2), a2.searchParams = To.call(a2), a2.hash = Io.call(a2));
      };
      var _o = xo.prototype;
      var ho = function() {
        var e2 = xr(this), t2 = e2.scheme, i3 = e2.username, n2 = e2.password, a2 = e2.host, p3 = e2.port, r2 = e2.path, o2 = e2.query, m2 = e2.fragment, c2 = t2 + ":";
        return null !== a2 ? (c2 += "//", Br(e2) && (c2 += i3 + (n2 ? ":" + n2 : "") + "@"), c2 += zr(a2), null !== p3 && (c2 += ":" + p3)) : "file" == t2 && (c2 += "//"), c2 += e2.cannotBeABaseURL ? r2[0] : r2.length ? "/" + r2.join("/") : "", null !== o2 && (c2 += "?" + o2), null !== m2 && (c2 += "#" + m2), c2;
      };
      var go = function() {
        var e2 = xr(this), t2 = e2.scheme, i3 = e2.port;
        if ("blob" == t2) try {
          return new URL(t2.path[0]).origin;
        } catch (e3) {
          return "null";
        }
        return "file" != t2 && Dr(e2) ? t2 + "://" + zr(e2.host) + (null !== i3 ? ":" + i3 : "") : "null";
      };
      var bo = function() {
        return xr(this).scheme + ":";
      };
      var wo = function() {
        return xr(this).username;
      };
      var ko = function() {
        return xr(this).password;
      };
      var Ao = function() {
        var e2 = xr(this), t2 = e2.host, i3 = e2.port;
        return null === t2 ? "" : null === i3 ? zr(t2) : zr(t2) + ":" + i3;
      };
      var Eo = function() {
        var e2 = xr(this).host;
        return null === e2 ? "" : zr(e2);
      };
      var So = function() {
        var e2 = xr(this).port;
        return null === e2 ? "" : String(e2);
      };
      var jo = function() {
        var e2 = xr(this), t2 = e2.path;
        return e2.cannotBeABaseURL ? t2[0] : t2.length ? "/" + t2.join("/") : "";
      };
      var Oo = function() {
        var e2 = xr(this).query;
        return e2 ? "?" + e2 : "";
      };
      var To = function() {
        return xr(this).searchParams;
      };
      var Io = function() {
        var e2 = xr(this).fragment;
        return e2 ? "#" + e2 : "";
      };
      var Ro = function(e2, t2) {
        return { get: e2, set: t2, configurable: true, enumerable: true };
      };
      if (i2 && dn(_o, { href: Ro(ho, (function(e2) {
        var t2 = xr(this), i3 = String(e2), n2 = vo(t2, i3);
        if (n2) throw TypeError(n2);
        yr(t2.searchParams).updateSearchParams(t2.query);
      })), origin: Ro(go), protocol: Ro(bo, (function(e2) {
        var t2 = xr(this);
        vo(t2, String(e2) + ":", Hr);
      })), username: Ro(wo, (function(e2) {
        var t2 = xr(this), i3 = Up(String(e2));
        if (!Vr(t2)) {
          t2.username = "";
          for (var n2 = 0; n2 < i3.length; n2++) t2.username += Mr(i3[n2], Cr);
        }
      })), password: Ro(ko, (function(e2) {
        var t2 = xr(this), i3 = Up(String(e2));
        if (!Vr(t2)) {
          t2.password = "";
          for (var n2 = 0; n2 < i3.length; n2++) t2.password += Mr(i3[n2], Cr);
        }
      })), host: Ro(Ao, (function(e2) {
        var t2 = xr(this);
        t2.cannotBeABaseURL || vo(t2, String(e2), ao);
      })), hostname: Ro(Eo, (function(e2) {
        var t2 = xr(this);
        t2.cannotBeABaseURL || vo(t2, String(e2), po);
      })), port: Ro(So, (function(e2) {
        var t2 = xr(this);
        Vr(t2) || ("" == (e2 = String(e2)) ? t2.port = null : vo(t2, e2, ro));
      })), pathname: Ro(jo, (function(e2) {
        var t2 = xr(this);
        t2.cannotBeABaseURL || (t2.path = [], vo(t2, e2 + "", lo));
      })), search: Ro(Oo, (function(e2) {
        var t2 = xr(this);
        "" == (e2 = String(e2)) ? t2.query = null : ("?" == e2.charAt(0) && (e2 = e2.slice(1)), t2.query = "", vo(t2, e2, fo)), yr(t2.searchParams).updateSearchParams(t2.query);
      })), searchParams: Ro(To), hash: Ro(Io, (function(e2) {
        var t2 = xr(this);
        "" != (e2 = String(e2)) ? ("#" == e2.charAt(0) && (e2 = e2.slice(1)), t2.fragment = "", vo(t2, e2, yo)) : t2.fragment = null;
      })) }), ce2(_o, "toJSON", (function() {
        return ho.call(this);
      }), { enumerable: true }), ce2(_o, "toString", (function() {
        return ho.call(this);
      }), { enumerable: true }), ur) {
        Lo = ur.createObjectURL, Uo = ur.revokeObjectURL;
        Lo && ce2(xo, "createObjectURL", (function(e2) {
          return Lo.apply(ur, arguments);
        })), Uo && ce2(xo, "revokeObjectURL", (function(e2) {
          return Uo.apply(ur, arguments);
        }));
      }
      var Lo;
      var Uo;
      Ui(xo, "URL"), Me({ global: true, forced: !jp, sham: !i2 }, { URL: xo });
      var zo = { CSSRuleList: 0, CSSStyleDeclaration: 0, CSSValueList: 0, ClientRectList: 0, DOMRectList: 0, DOMStringList: 0, DOMTokenList: 1, DataTransferItemList: 0, FileList: 0, HTMLAllCollection: 0, HTMLCollection: 0, HTMLFormElement: 0, HTMLSelectElement: 0, MediaList: 0, MimeTypeArray: 0, NamedNodeMap: 0, NodeList: 1, PaintRequestList: 0, Plugin: 0, PluginArray: 0, SVGLengthList: 0, SVGNumberList: 0, SVGPathSegList: 0, SVGPointList: 0, SVGStringList: 0, SVGTransformList: 0, SourceBufferList: 0, StyleSheetList: 0, TextTrackCueList: 0, TextTrackList: 0, TouchList: 0 };
      var No = st("iterator");
      var Fo = st("toStringTag");
      var Po = Aa.values;
      for (Co in zo) {
        Mo = r[Co], qo = Mo && Mo.prototype;
        if (qo) {
          if (qo[No] !== Po) try {
            M2(qo, No, Po);
          } catch (e2) {
            qo[No] = Po;
          }
          if (qo[Fo] || M2(qo, Fo, Co), zo[Co]) {
            for (Do in Aa) if (qo[Do] !== Aa[Do]) try {
              M2(qo, Do, Aa[Do]);
            } catch (e2) {
              qo[Do] = Aa[Do];
            }
          }
        }
      }
      var Mo;
      var qo;
      var Do;
      var Co;
      var Bo = zn.forEach;
      var Vo = Pa("forEach") ? [].forEach : function(e2) {
        return Bo(this, e2, arguments.length > 1 ? arguments[1] : void 0);
      };
      for (Go in zo) {
        $o = r[Go], Wo = $o && $o.prototype;
        if (Wo && Wo.forEach !== Vo) try {
          M2(Wo, "forEach", Vo);
        } catch (e2) {
          Wo.forEach = Vo;
        }
      }
      var $o;
      var Wo;
      var Go;
      var Yo = j.f;
      var Ho = function(e2) {
        return function(t2) {
          for (var n2, a2 = z2(t2), p3 = sn(a2), r2 = p3.length, o2 = 0, m2 = []; r2 > o2; ) n2 = p3[o2++], i2 && !Yo.call(a2, n2) || m2.push(e2 ? [n2, a2[n2]] : a2[n2]);
          return m2;
        };
      };
      var Qo = { entries: Ho(true), values: Ho(false) }.values;
      Me({ target: "Object", stat: true }, { values: function(e2) {
        return Qo(e2);
      } });
      var Xo = st("species");
      var Ko = function(e2) {
        return pt >= 51 || !t((function() {
          var t2 = [];
          return (t2.constructor = {})[Xo] = function() {
            return { foo: 1 };
          }, 1 !== t2[e2](Boolean).foo;
        }));
      };
      var Zo = st("isConcatSpreadable");
      var Jo = pt >= 51 || !t((function() {
        var e2 = [];
        return e2[Zo] = false, e2.concat()[0] !== e2;
      }));
      var em = Ko("concat");
      var tm = function(e2) {
        if (!o(e2)) return false;
        var t2 = e2[Zo];
        return void 0 !== t2 ? !!t2 : Tn(e2);
      };
      Me({ target: "Array", proto: true, forced: !Jo || !em }, { concat: function(e2) {
        var t2, i3, n2, a2, p3, r2 = kt(this), o2 = Rn(r2, 0), m2 = 0;
        for (t2 = -1, n2 = arguments.length; t2 < n2; t2++) if (tm(p3 = -1 === t2 ? r2 : arguments[t2])) {
          if (m2 + (a2 = xe(p3.length)) > 9007199254740991) throw TypeError("Maximum allowed index exceeded");
          for (i3 = 0; i3 < a2; i3++, m2++) i3 in p3 && Lp(o2, m2, p3[i3]);
        } else {
          if (m2 >= 9007199254740991) throw TypeError("Maximum allowed index exceeded");
          Lp(o2, m2++, p3);
        }
        return o2.length = m2, o2;
      } });
      var im = function() {
        return ("10000000-1000-4000-8000" + -1e11).replace(/[018]/g, (function(e2) {
          return (e2 ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> e2 / 4).toString(16);
        }));
      };
      var nm = function(e2, t2) {
        var i3;
        if ("string" == typeof e2 ? i3 = document.querySelector(e2) : null != e2.nodeType && (i3 = e2), null == i3) throw new Error("Invalid `".concat(t2, "` option provided. Please provide a CSS selector or a plain HTML element."));
        return i3;
      };
      var am = function e2(t2) {
        var i3 = [];
        return null !== t2.nodeType && Object.values(t2.children).forEach((function(t3) {
          i3.push(t3);
          var n2 = e2(t3);
          n2.length > 0 && i3.push.apply(i3, A(n2));
        })), i3;
      };
      var pm = function(e2) {
        (function(e3) {
          if (e3.dataTransfer.types) {
            for (var t2 = 0; t2 < e3.dataTransfer.types.length; t2++) if ("Files" === e3.dataTransfer.types[t2]) return true;
          }
          return false;
        })(e2) && (e2.stopPropagation(), e2.preventDefault ? e2.preventDefault() : e2.returnValue = false);
      };
      var rm = { tb: "TB", gb: "GB", mb: "MB", kb: "KB", b: "b" };
      var om = function(e2) {
        var t2 = 0, i3 = "b";
        if (e2 > 0) {
          for (var n2 = ["tb", "gb", "mb", "kb", "b"], a2 = 0; a2 < n2.length; a2 += 1) {
            var p3 = n2[a2];
            if (e2 >= Math.pow(1024, 4 - a2) / 10) {
              t2 = e2 / Math.pow(1024, 4 - a2), i3 = p3;
              break;
            }
          }
          t2 = Math.round(10 * t2) / 10;
        }
        return "<strong>".concat(t2, "</strong> ").concat(rm[i3]);
      };
      function mm(e2) {
        var t2 = e2.itemManager, i3 = function e3(i4, n3, a2) {
          var p3 = i4.createReader(), r2 = function(e4) {
          };
          return (function i5() {
            return p3.readEntries((function(a3) {
              if (a3.length > 0) {
                for (var p4 = function(i6) {
                  var p5 = a3[i6];
                  p5.isFile ? p5.file((function(e4) {
                    e4.fullPath = "".concat(n3, "/").concat(e4.name), t2.addFile(im(), e4);
                  })) : p5.isDirectory && e3(p5, "".concat(n3, "/").concat(p5.name));
                }, r3 = 0; r3 < a3.length; r3 += 1) p4(r3);
                i5();
              }
              return null;
            }), r2);
          })();
        }, n2 = function(e3, n3) {
          e3.forEach((function(e4) {
            var a2 = null;
            null != e4.webkitGetAsEntry ? (a2 = e4.webkitGetAsEntry()).isFile && n3 ? t2.addFile(im(), e4.getAsFile()) : a2.isDirectory && i3(a2, a2.name) : null != e4.getAsFile && (null != e4.kind && "file" !== e4.kind || t2.addFile(im(), e4.getAsFile()));
          }));
        };
        return { handleDragOver: function(e3) {
          var t3;
          try {
            t3 = e3.dataTransfer.effectAllowed;
          } catch (e4) {
          }
          pm(e3), e3.dataTransfer.dropEffect = "move" === t3 || "linkMove" === t3 ? "move" : "copy";
        }, onDrop: function(e3) {
          if (pm(e3), e3.dataTransfer.items) {
            var i4 = e3.dataTransfer.items;
            i4 && i4.length && null != i4[0].webkitGetAsEntry && n2(i4, true);
          } else for (var a2 = 0; a2 < e3.dataTransfer.files.length; a2 += 1) {
            var p3 = im(), r2 = e3.dataTransfer.files[a2];
            t2.addFile(p3, r2);
          }
        } };
      }
      var cm = zn.findIndex;
      var lm = true;
      "findIndex" in [] && Array(1).findIndex((function() {
        lm = false;
      })), Me({ target: "Array", proto: true, forced: lm }, { findIndex: function(e2) {
        return cm(this, e2, arguments.length > 1 ? arguments[1] : void 0);
      } }), la("findIndex");
      var sm = [].join;
      var dm = L != Object;
      var um = Pa("join", ",");
      function fm() {
        var e2, t2 = [], i3 = function(i4) {
          return (!i4.detail || 1 === i4.detail) && (-1 !== t2.findIndex((function(e3) {
            return e3 === i4.target;
          })) && (i4.stopPropagation(), e2.click()), true);
        }, n2 = function(t3) {
          e2 && t3 ? e2.setAttribute("multiple", "multiple") : e2 && !t3 && e2.removeAttribute("multiple");
        }, a2 = function t3(i4) {
          var a3 = i4.config, p3 = i4.itemManager;
          e2 && e2.parentNode.removeChild(e2), (e2 = document.createElement("input")).setAttribute("type", "file"), (null === a3.maxFiles || a3.maxFiles > 1) && n2(true), a3.accepts.length > 0 && e2.setAttribute("accept", a3.accepts.join(",")), e2.setAttribute("tabindex", "-1"), e2.style.visibility = "hidden", e2.style.position = "absolute", e2.style.top = "0", e2.style.left = "0", e2.style.height = "0", e2.style.width = "0", nm(a3.hiddenInputContainer, "hiddenInputContainer").appendChild(e2), e2.addEventListener("change", (function() {
            e2.files.forEach((function(e3) {
              p3.addFile(im(), e3);
            })), t3({ config: a3, itemManager: p3 });
          }));
        };
        return { initHiddenFileInput: function(e3) {
          var n3 = e3.config, p3 = e3.dropzone, r2 = e3.itemManager;
          if (n3.clickable) {
            var o2, m2 = nm(".".concat(n3.dropzoneMessageClassName), n3.dropzoneMessageClassName), c2 = am(m2);
            if ((t2 = [p3.value]).push(m2), c2.length > 0) (o2 = t2).push.apply(o2, A(c2));
            a2({ config: n3, itemManager: r2 }), t2.forEach((function(e4) {
              e4.classList.add("dropzone-clickable"), e4.addEventListener("click", i3);
            }));
          }
        }, destroyHiddenFileInput: function() {
          t2.forEach((function(e3) {
            e3.removeEventListener("click", i3);
          })), e2 && (e2.parentElement.removeChild(e2), e2 = null);
        }, setMultiple: n2 };
      }
      Me({ target: "Array", proto: true, forced: dm || !um }, { join: function(e2) {
        return sm.call(z2(this), void 0 === e2 ? "," : e2);
      } });
      var ym = zn.find;
      var vm = true;
      "find" in [] && Array(1).find((function() {
        vm = false;
      })), Me({ target: "Array", proto: true, forced: vm }, { find: function(e2) {
        return ym(this, e2, arguments.length > 1 ? arguments[1] : void 0);
      } }), la("find");
      var xm = "	\n\v\f\r \xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
      var _m = "[" + xm + "]";
      var hm = RegExp("^" + _m + _m + "*");
      var gm = RegExp(_m + _m + "*$");
      var bm = function(e2) {
        return function(t2) {
          var i3 = String(U(t2));
          return 1 & e2 && (i3 = i3.replace(hm, "")), 2 & e2 && (i3 = i3.replace(gm, "")), i3;
        };
      };
      var wm = { start: bm(1), end: bm(2), trim: bm(3) };
      var km = je.f;
      var Am = C.f;
      var Em = y2.f;
      var Sm = wm.trim;
      var jm = r.Number;
      var Om = jm.prototype;
      var Tm = "Number" == I2(_n(Om));
      var Im = function(e2) {
        var t2, i3, n2, a2, p3, r2, o2, m2, c2 = u2(e2, false);
        if ("string" == typeof c2 && c2.length > 2) {
          if (43 === (t2 = (c2 = Sm(c2)).charCodeAt(0)) || 45 === t2) {
            if (88 === (i3 = c2.charCodeAt(2)) || 120 === i3) return NaN;
          } else if (48 === t2) {
            switch (c2.charCodeAt(1)) {
              case 66:
              case 98:
                n2 = 2, a2 = 49;
                break;
              case 79:
              case 111:
                n2 = 8, a2 = 55;
                break;
              default:
                return +c2;
            }
            for (r2 = (p3 = c2.slice(2)).length, o2 = 0; o2 < r2; o2++) if ((m2 = p3.charCodeAt(o2)) < 48 || m2 > a2) return NaN;
            return parseInt(p3, n2);
          }
        }
        return +c2;
      };
      if (Pe("Number", !jm(" 0o1") || !jm("0b1") || jm("+0x1"))) {
        for (Lm = function(e2) {
          var i3 = arguments.length < 1 ? 0 : e2, n2 = this;
          return n2 instanceof Lm && (Tm ? t((function() {
            Om.valueOf.call(n2);
          })) : "Number" != I2(n2)) ? Fn(new jm(Im(i3)), n2, Lm) : Im(i3);
        }, Um = i2 ? km(jm) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger,fromString,range".split(","), zm = 0; Um.length > zm; zm++) F2(jm, Rm = Um[zm]) && !F2(Lm, Rm) && Em(Lm, Rm, Am(jm, Rm));
        Lm.prototype = Om, Om.constructor = Lm, ce2(r, "Number", Lm);
      }
      var Rm;
      var Lm;
      var Um;
      var zm;
      var Nm = { url: { type: String, default: null, validator: function(e2) {
        if (null === e2) return true;
        try {
          return void 0 !== new URL(e2);
        } catch (e3) {
          return false;
        }
      } }, method: { type: String, default: "POST", validator: function(e2) {
        return "POST" === e2.toUpperCase() || "PUT" === e2.toUpperCase();
      } }, paramName: { type: String, default: "file" }, headers: { type: Object, default: null, validator: function(e2) {
        return !Object.values(e2).find((function(e3) {
          return "string" != typeof e3 && "number" != typeof e3;
        }));
      } }, xhrTimeout: { type: Number, default: 6e4, validator: function(e2) {
        return e2 >= 0;
      } }, withCredentials: { type: Boolean, default: false }, uploadOnDrop: { type: Boolean, default: true }, retryOnError: { type: Boolean, default: false }, multipleUpload: { type: Boolean, default: false }, parallelUpload: { type: Number, default: 3 }, maxFiles: { type: Number, default: null }, maxFileSize: { type: Number, default: 1e6 }, hiddenInputContainer: { default: "body" }, clickable: { type: Boolean, default: true }, acceptedFiles: { type: Array, default: null }, chunking: { type: Boolean, default: false }, numberOfChunks: { type: Number, default: 10 } };
      var Fm = zn.filter;
      var Pm = Ko("filter");
      Me({ target: "Array", proto: true, forced: !Pm }, { filter: function(e2) {
        return Fm(this, e2, arguments.length > 1 ? arguments[1] : void 0);
      } });
      var Cm = st("match");
      var Mm = function(e2) {
        var t2;
        return o(e2) && (void 0 !== (t2 = e2[Cm]) ? !!t2 : "RegExp" == I2(e2));
      };
      var qm = [].push;
      var Dm = Math.min;
      var Bm = !t((function() {
        return !RegExp(4294967295, "y");
      }));
      _t("split", 2, (function(e2, t2, i3) {
        var n2;
        return n2 = "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1).length || 2 != "ab".split(/(?:ab)*/).length || 4 != ".".split(/(.?)(.?)/).length || ".".split(/()()/).length > 1 || "".split(/.?/).length ? function(e3, i4) {
          var n3 = String(U(this)), a2 = void 0 === i4 ? 4294967295 : i4 >>> 0;
          if (0 === a2) return [];
          if (void 0 === e3) return [n3];
          if (!Mm(e3)) return t2.call(n3, e3, a2);
          for (var p3, r2, o2, m2 = [], c2 = (e3.ignoreCase ? "i" : "") + (e3.multiline ? "m" : "") + (e3.unicode ? "u" : "") + (e3.sticky ? "y" : ""), l2 = 0, s2 = new RegExp(e3.source, c2 + "g"); (p3 = Ke.call(s2, n3)) && !((r2 = s2.lastIndex) > l2 && (m2.push(n3.slice(l2, p3.index)), p3.length > 1 && p3.index < n3.length && qm.apply(m2, p3.slice(1)), o2 = p3[0].length, l2 = r2, m2.length >= a2)); ) s2.lastIndex === p3.index && s2.lastIndex++;
          return l2 === n3.length ? !o2 && s2.test("") || m2.push("") : m2.push(n3.slice(l2)), m2.length > a2 ? m2.slice(0, a2) : m2;
        } : "0".split(void 0, 0).length ? function(e3, i4) {
          return void 0 === e3 && 0 === i4 ? [] : t2.call(this, e3, i4);
        } : t2, [function(t3, i4) {
          var a2 = U(this), p3 = null == t3 ? void 0 : t3[e2];
          return void 0 !== p3 ? p3.call(t3, a2, i4) : n2.call(String(a2), t3, i4);
        }, function(e3, a2) {
          var p3 = i3(n2, e3, this, a2, n2 !== t2);
          if (p3.done) return p3.value;
          var r2 = d(e3), o2 = String(this), m2 = Gn(r2, RegExp), c2 = r2.unicode, l2 = (r2.ignoreCase ? "i" : "") + (r2.multiline ? "m" : "") + (r2.unicode ? "u" : "") + (Bm ? "y" : "g"), s2 = new m2(Bm ? r2 : "^(?:" + r2.source + ")", l2), u3 = void 0 === a2 ? 4294967295 : a2 >>> 0;
          if (0 === u3) return [];
          if (0 === o2.length) return null === Tt(s2, o2) ? [o2] : [];
          for (var f2 = 0, y3 = 0, v2 = []; y3 < o2.length; ) {
            s2.lastIndex = Bm ? y3 : 0;
            var x2, _3 = Tt(s2, Bm ? o2 : o2.slice(y3));
            if (null === _3 || (x2 = Dm(xe(s2.lastIndex + (Bm ? 0 : y3)), o2.length)) === f2) y3 = wt(o2, y3, c2);
            else {
              if (v2.push(o2.slice(f2, y3)), v2.length === u3) return v2;
              for (var h3 = 1; h3 <= _3.length - 1; h3++) if (v2.push(_3[h3]), v2.length === u3) return v2;
              y3 = f2 = x2;
            }
          }
          return v2.push(o2.slice(f2)), v2;
        }];
      }), !Bm);
      var Vm;
      var Gm = function(e2) {
        if (Mm(e2)) throw TypeError("The method doesn't accept regular expressions");
        return e2;
      };
      var $m = st("match");
      var Wm = function(e2) {
        var t2 = /./;
        try {
          "/./"[e2](t2);
        } catch (i3) {
          try {
            return t2[$m] = false, "/./"[e2](t2);
          } catch (e3) {
          }
        }
        return false;
      };
      var Ym = C.f;
      var Hm = "".startsWith;
      var Qm = Math.min;
      var Xm = Wm("startsWith");
      var Km = !(Xm || (Vm = Ym(String.prototype, "startsWith"), !Vm || Vm.writable));
      Me({ target: "String", proto: true, forced: !Km && !Xm }, { startsWith: function(e2) {
        var t2 = String(U(this));
        Gm(e2);
        var i3 = xe(Qm(arguments.length > 1 ? arguments[1] : void 0, t2.length)), n2 = String(e2);
        return Hm ? Hm.call(t2, n2, i3) : t2.slice(i3, i3 + n2.length) === n2;
      } });
      var Zm = zn.map;
      var Jm = Ko("map");
      Me({ target: "Array", proto: true, forced: !Jm }, { map: function(e2) {
        return Zm(this, e2, arguments.length > 1 ? arguments[1] : void 0);
      } });
      var ec = we.includes;
      Me({ target: "Array", proto: true }, { includes: function(e2) {
        return ec(this, e2, arguments.length > 1 ? arguments[1] : void 0);
      } }), la("includes"), Me({ target: "String", proto: true, forced: !Wm("includes") }, { includes: function(e2) {
        return !!~String(U(this)).indexOf(Gm(e2), arguments.length > 1 ? arguments[1] : void 0);
      } });
      var tc = { data: [{ mime_type: "application/activemessage" }, { mime_type: "application/andrew-inset", ext: "ez" }, { mime_type: "application/applefile" }, { mime_type: "application/applixware", ext: "aw" }, { mime_type: "application/atom+xml", ext: "atom" }, { mime_type: "application/atomcat+xml", ext: "atomcat" }, { mime_type: "application/atomicmail" }, { mime_type: "application/atomsvc+xml", ext: "atomsvc" }, { mime_type: "application/auth-policy+xml" }, { mime_type: "application/batch-smtp" }, { mime_type: "application/beep+xml" }, { mime_type: "application/cals-1840" }, { mime_type: "application/ccxml+xml", ext: "ccxml" }, { mime_type: "application/cea-2018+xml" }, { mime_type: "application/cellml+xml" }, { mime_type: "application/cnrp+xml" }, { mime_type: "application/commonground" }, { mime_type: "application/conference-info+xml" }, { mime_type: "application/cpl+xml" }, { mime_type: "application/csta+xml" }, { mime_type: "application/cstadata+xml" }, { mime_type: "application/cu-seeme", ext: "cu" }, { mime_type: "application/cybercash" }, { mime_type: "application/davmount+xml", ext: "davmount" }, { mime_type: "application/dca-rft" }, { mime_type: "application/dec-dx" }, { mime_type: "application/dialog-info+xml" }, { mime_type: "application/dicom" }, { mime_type: "application/dns" }, { mime_type: "application/dvcs" }, { mime_type: "application/ecmascript", ext: "ecma" }, { mime_type: "application/edi-consent" }, { mime_type: "application/edi-x12" }, { mime_type: "application/edifact" }, { mime_type: "application/emma+xml", ext: "emma" }, { mime_type: "application/epp+xml" }, { mime_type: "application/epub+zip", ext: "epub" }, { mime_type: "application/eshop" }, { mime_type: "application/example" }, { mime_type: "application/fastinfoset" }, { mime_type: "application/fastsoap" }, { mime_type: "application/fits" }, { mime_type: "application/font-tdpfr", ext: "pfr" }, { mime_type: "application/h224" }, { mime_type: "application/http" }, { mime_type: "application/hyperstudio", ext: "stk" }, { mime_type: "application/ibe-key-request+xml" }, { mime_type: "application/ibe-pkg-reply+xml" }, { mime_type: "application/ibe-pp-data" }, { mime_type: "application/iges" }, { mime_type: "application/im-iscomposing+xml" }, { mime_type: "application/index" }, { mime_type: "application/index.cmd" }, { mime_type: "application/index.obj" }, { mime_type: "application/index.response" }, { mime_type: "application/index.vnd" }, { mime_type: "application/iotp" }, { mime_type: "application/ipp" }, { mime_type: "application/isup" }, { mime_type: "application/java-archive", ext: "jar" }, { mime_type: "application/java-serialized-object", ext: "ser" }, { mime_type: "application/java-vm", ext: "class" }, { mime_type: "application/javascript", ext: "js" }, { mime_type: "application/json", ext: "json" }, { mime_type: "application/kpml-request+xml" }, { mime_type: "application/kpml-response+xml" }, { mime_type: "application/lost+xml", ext: "lostxml" }, { mime_type: "application/mac-binhex40", ext: "hqx" }, { mime_type: "application/mac-compactpro", ext: "cpt" }, { mime_type: "application/macwriteii" }, { mime_type: "application/marc", ext: "mrc" }, { mime_type: "application/mathematica", ext: "ma nb mb" }, { mime_type: "application/mathml+xml", ext: "mathml" }, { mime_type: "application/mbms-associated-procedure-description+xml" }, { mime_type: "application/mbms-deregister+xml" }, { mime_type: "application/mbms-envelope+xml" }, { mime_type: "application/mbms-msk+xml" }, { mime_type: "application/mbms-msk-response+xml" }, { mime_type: "application/mbms-protection-description+xml" }, { mime_type: "application/mbms-reception-report+xml" }, { mime_type: "application/mbms-register+xml" }, { mime_type: "application/mbms-register-response+xml" }, { mime_type: "application/mbms-user-service-description+xml" }, { mime_type: "application/mbox", ext: "mbox" }, { mime_type: "application/media_control+xml" }, { mime_type: "application/mediaservercontrol+xml", ext: "mscml" }, { mime_type: "application/mikey" }, { mime_type: "application/moss-keys" }, { mime_type: "application/moss-signature" }, { mime_type: "application/mosskey-data" }, { mime_type: "application/mosskey-request" }, { mime_type: "application/mp4", ext: "mp4s" }, { mime_type: "application/mpeg4-generic" }, { mime_type: "application/mpeg4-iod" }, { mime_type: "application/mpeg4-iod-xmt" }, { mime_type: "application/msword", ext: "doc dot" }, { mime_type: "application/mxf", ext: "mxf" }, { mime_type: "application/nasdata" }, { mime_type: "application/news-checkgroups" }, { mime_type: "application/news-groupinfo" }, { mime_type: "application/news-transmission" }, { mime_type: "application/nss" }, { mime_type: "application/ocsp-request" }, { mime_type: "application/ocsp-response" }, { mime_type: "application/octet-stream bin dms lha lrf lzh so iso dmg dist distz pkg bpk dump elc deploy scpt dmgpart" }, { mime_type: "application/oda", ext: "oda" }, { mime_type: "application/oebps-package+xml", ext: "opf" }, { mime_type: "application/ogg", ext: "ogx" }, { mime_type: "application/onenote", ext: "onetoc onetoc2 onetmp onepkg" }, { mime_type: "application/parityfec" }, { mime_type: "application/patch-ops-error+xml", ext: "xer" }, { mime_type: "application/pdf", ext: "pdf" }, { mime_type: "application/pgp-encrypted", ext: "pgp" }, { mime_type: "application/pgp-keys" }, { mime_type: "application/pgp-signature", ext: "asc sig" }, { mime_type: "application/pics-rules", ext: "prf" }, { mime_type: "application/pidf+xml" }, { mime_type: "application/pidf-diff+xml" }, { mime_type: "application/pkcs10", ext: "p10" }, { mime_type: "application/pkcs7-mime", ext: "p7m p7c" }, { mime_type: "application/pkcs7-signature", ext: "p7s" }, { mime_type: "application/pkix-cert", ext: "cer" }, { mime_type: "application/pkix-crl", ext: "crl" }, { mime_type: "application/pkix-pkipath", ext: "pkipath" }, { mime_type: "application/pkixcmp", ext: "pki" }, { mime_type: "application/pls+xml", ext: "pls" }, { mime_type: "application/poc-settings+xml" }, { mime_type: "application/postscript", ext: "ai eps ps" }, { mime_type: "application/prs.alvestrand.titrax-sheet" }, { mime_type: "application/prs.cww", ext: "cww" }, { mime_type: "application/prs.nprend" }, { mime_type: "application/prs.plucker" }, { mime_type: "application/qsig" }, { mime_type: "application/rdf+xml", ext: "rdf" }, { mime_type: "application/reginfo+xml", ext: "rif" }, { mime_type: "application/relax-ng-compact-syntax", ext: "rnc" }, { mime_type: "application/remote-printing" }, { mime_type: "application/resource-lists+xml", ext: "rl" }, { mime_type: "application/resource-lists-diff+xml", ext: "rld" }, { mime_type: "application/riscos" }, { mime_type: "application/rlmi+xml" }, { mime_type: "application/rls-services+xml", ext: "rs" }, { mime_type: "application/rsd+xml", ext: "rsd" }, { mime_type: "application/rss+xml", ext: "rss" }, { mime_type: "application/rtf", ext: "rtf" }, { mime_type: "application/rtx" }, { mime_type: "application/samlassertion+xml" }, { mime_type: "application/samlmetadata+xml" }, { mime_type: "application/sbml+xml", ext: "sbml" }, { mime_type: "application/scvp-cv-request", ext: "scq" }, { mime_type: "application/scvp-cv-response", ext: "scs" }, { mime_type: "application/scvp-vp-request", ext: "spq" }, { mime_type: "application/scvp-vp-response", ext: "spp" }, { mime_type: "application/sdp", ext: "sdp" }, { mime_type: "application/set-payment" }, { mime_type: "application/set-payment-initiation", ext: "setpay" }, { mime_type: "application/set-registration" }, { mime_type: "application/set-registration-initiation", ext: "setreg" }, { mime_type: "application/sgml" }, { mime_type: "application/sgml-open-catalog" }, { mime_type: "application/shf+xml", ext: "shf" }, { mime_type: "application/sieve" }, { mime_type: "application/simple-filter+xml" }, { mime_type: "application/simple-message-summary" }, { mime_type: "application/simplesymbolcontainer" }, { mime_type: "application/slate" }, { mime_type: "application/smil" }, { mime_type: "application/smil+xml", ext: "smi smil" }, { mime_type: "application/soap+fastinfoset" }, { mime_type: "application/soap+xml" }, { mime_type: "application/sparql-query", ext: "rq" }, { mime_type: "application/sparql-results+xml", ext: "srx" }, { mime_type: "application/spirits-event+xml" }, { mime_type: "application/srgs", ext: "gram" }, { mime_type: "application/srgs+xml", ext: "grxml" }, { mime_type: "application/ssml+xml", ext: "ssml" }, { mime_type: "application/timestamp-query" }, { mime_type: "application/timestamp-reply" }, { mime_type: "application/tve-trigger" }, { mime_type: "application/ulpfec" }, { mime_type: "application/vemmi" }, { mime_type: "application/vividence.scriptfile" }, { mime_type: "application/vnd.3gpp.bsf+xml" }, { mime_type: "application/vnd.3gpp.pic-bw-large", ext: "plb" }, { mime_type: "application/vnd.3gpp.pic-bw-small", ext: "psb" }, { mime_type: "application/vnd.3gpp.pic-bw-var", ext: "pvb" }, { mime_type: "application/vnd.3gpp.sms" }, { mime_type: "application/vnd.3gpp2.bcmcsinfo+xml" }, { mime_type: "application/vnd.3gpp2.sms" }, { mime_type: "application/vnd.3gpp2.tcap", ext: "tcap" }, { mime_type: "application/vnd.3m.post-it-notes", ext: "pwn" }, { mime_type: "application/vnd.accpac.simply.aso", ext: "aso" }, { mime_type: "application/vnd.accpac.simply.imp", ext: "imp" }, { mime_type: "application/vnd.acucobol", ext: "acu" }, { mime_type: "application/vnd.acucorp", ext: "atc acutc" }, { mime_type: "application/vnd.adobe.air-application-installer-package+zip", ext: "air" }, { mime_type: "application/vnd.adobe.xdp+xml", ext: "xdp" }, { mime_type: "application/vnd.adobe.xfdf", ext: "xfdf" }, { mime_type: "application/vnd.aether.imp" }, { mime_type: "application/vnd.airzip.filesecure.azf", ext: "azf" }, { mime_type: "application/vnd.airzip.filesecure.azs", ext: "azs" }, { mime_type: "application/vnd.amazon.ebook", ext: "azw" }, { mime_type: "application/vnd.americandynamics.acc", ext: "acc" }, { mime_type: "application/vnd.amiga.ami", ext: "ami" }, { mime_type: "application/vnd.android.package-archive", ext: "apk" }, { mime_type: "application/vnd.anser-web-certificate-issue-initiation", ext: "cii" }, { mime_type: "application/vnd.anser-web-funds-transfer-initiation", ext: "fti" }, { mime_type: "application/vnd.antix.game-component", ext: "atx" }, { mime_type: "application/vnd.apple.installer+xml", ext: "mpkg" }, { mime_type: "application/vnd.arastra.swi", ext: "swi" }, { mime_type: "application/vnd.audiograph", ext: "aep" }, { mime_type: "application/vnd.autopackage" }, { mime_type: "application/vnd.avistar+xml" }, { mime_type: "application/vnd.blueice.multipass", ext: "mpm" }, { mime_type: "application/vnd.bluetooth.ep.oob" }, { mime_type: "application/vnd.bmi", ext: "bmi" }, { mime_type: "application/vnd.businessobjects", ext: "rep" }, { mime_type: "application/vnd.cab-jscript" }, { mime_type: "application/vnd.canon-cpdl" }, { mime_type: "application/vnd.canon-lips" }, { mime_type: "application/vnd.cendio.thinlinc.clientconf" }, { mime_type: "application/vnd.chemdraw+xml", ext: "cdxml" }, { mime_type: "application/vnd.chipnuts.karaoke-mmd", ext: "mmd" }, { mime_type: "application/vnd.cinderella", ext: "cdy" }, { mime_type: "application/vnd.cirpack.isdn-ext" }, { mime_type: "application/vnd.claymore", ext: "cla" }, { mime_type: "application/vnd.clonk.c4group", ext: "c4g c4d c4f c4p c4u" }, { mime_type: "application/vnd.commerce-battelle" }, { mime_type: "application/vnd.commonspace", ext: "csp" }, { mime_type: "application/vnd.contact.cmsg", ext: "cdbcmsg" }, { mime_type: "application/vnd.cosmocaller", ext: "cmc" }, { mime_type: "application/vnd.crick.clicker", ext: "clkx" }, { mime_type: "application/vnd.crick.clicker.keyboard", ext: "clkk" }, { mime_type: "application/vnd.crick.clicker.palette", ext: "clkp" }, { mime_type: "application/vnd.crick.clicker.template", ext: "clkt" }, { mime_type: "application/vnd.crick.clicker.wordbank", ext: "clkw" }, { mime_type: "application/vnd.criticaltools.wbs+xml", ext: "wbs" }, { mime_type: "application/vnd.ctc-posml", ext: "pml" }, { mime_type: "application/vnd.ctct.ws+xml" }, { mime_type: "application/vnd.cups-pdf" }, { mime_type: "application/vnd.cups-postscript" }, { mime_type: "application/vnd.cups-ppd", ext: "ppd" }, { mime_type: "application/vnd.cups-raster" }, { mime_type: "application/vnd.cups-raw" }, { mime_type: "application/vnd.curl.car", ext: "car" }, { mime_type: "application/vnd.curl.pcurl", ext: "pcurl" }, { mime_type: "application/vnd.cybank" }, { mime_type: "application/vnd.data-vision.rdz", ext: "rdz" }, { mime_type: "application/vnd.denovo.fcselayout-link", ext: "fe_launch" }, { mime_type: "application/vnd.dir-bi.plate-dl-nosuffix" }, { mime_type: "application/vnd.dna", ext: "dna" }, { mime_type: "application/vnd.dolby.mlp", ext: "mlp" }, { mime_type: "application/vnd.dolby.mobile.1" }, { mime_type: "application/vnd.dolby.mobile.2" }, { mime_type: "application/vnd.dpgraph", ext: "dpg" }, { mime_type: "application/vnd.dreamfactory", ext: "dfac" }, { mime_type: "application/vnd.dvb.esgcontainer" }, { mime_type: "application/vnd.dvb.ipdcdftnotifaccess" }, { mime_type: "application/vnd.dvb.ipdcesgaccess" }, { mime_type: "application/vnd.dvb.ipdcroaming" }, { mime_type: "application/vnd.dvb.iptv.alfec-base" }, { mime_type: "application/vnd.dvb.iptv.alfec-enhancement" }, { mime_type: "application/vnd.dvb.notif-aggregate-root+xml" }, { mime_type: "application/vnd.dvb.notif-container+xml" }, { mime_type: "application/vnd.dvb.notif-generic+xml" }, { mime_type: "application/vnd.dvb.notif-ia-msglist+xml" }, { mime_type: "application/vnd.dvb.notif-ia-registration-request+xml" }, { mime_type: "application/vnd.dvb.notif-ia-registration-response+xml" }, { mime_type: "application/vnd.dvb.notif-init+xml" }, { mime_type: "application/vnd.dxr" }, { mime_type: "application/vnd.dynageo", ext: "geo" }, { mime_type: "application/vnd.ecdis-update" }, { mime_type: "application/vnd.ecowin.chart", ext: "mag" }, { mime_type: "application/vnd.ecowin.filerequest" }, { mime_type: "application/vnd.ecowin.fileupdate" }, { mime_type: "application/vnd.ecowin.series" }, { mime_type: "application/vnd.ecowin.seriesrequest" }, { mime_type: "application/vnd.ecowin.seriesupdate" }, { mime_type: "application/vnd.emclient.accessrequest+xml" }, { mime_type: "application/vnd.enliven", ext: "nml" }, { mime_type: "application/vnd.epson.esf", ext: "esf" }, { mime_type: "application/vnd.epson.msf", ext: "msf" }, { mime_type: "application/vnd.epson.quickanime", ext: "qam" }, { mime_type: "application/vnd.epson.salt", ext: "slt" }, { mime_type: "application/vnd.epson.ssf", ext: "ssf" }, { mime_type: "application/vnd.ericsson.quickcall" }, { mime_type: "application/vnd.eszigno3+xml", ext: "es3 et3" }, { mime_type: "application/vnd.etsi.aoc+xml" }, { mime_type: "application/vnd.etsi.cug+xml" }, { mime_type: "application/vnd.etsi.iptvcommand+xml" }, { mime_type: "application/vnd.etsi.iptvdiscovery+xml" }, { mime_type: "application/vnd.etsi.iptvprofile+xml" }, { mime_type: "application/vnd.etsi.iptvsad-bc+xml" }, { mime_type: "application/vnd.etsi.iptvsad-cod+xml" }, { mime_type: "application/vnd.etsi.iptvsad-npvr+xml" }, { mime_type: "application/vnd.etsi.iptvueprofile+xml" }, { mime_type: "application/vnd.etsi.mcid+xml" }, { mime_type: "application/vnd.etsi.sci+xml" }, { mime_type: "application/vnd.etsi.simservs+xml" }, { mime_type: "application/vnd.eudora.data" }, { mime_type: "application/vnd.ezpix-album", ext: "ez2" }, { mime_type: "application/vnd.ezpix-package", ext: "ez3" }, { mime_type: "application/vnd.f-secure.mobile" }, { mime_type: "application/vnd.fdf", ext: "fdf" }, { mime_type: "application/vnd.fdsn.mseed", ext: "mseed" }, { mime_type: "application/vnd.fdsn.seed", ext: "seed dataless" }, { mime_type: "application/vnd.ffsns" }, { mime_type: "application/vnd.fints" }, { mime_type: "application/vnd.flographit", ext: "gph" }, { mime_type: "application/vnd.fluxtime.clip", ext: "ftc" }, { mime_type: "application/vnd.font-fontforge-sfd" }, { mime_type: "application/vnd.framemaker", ext: "fm frame maker book" }, { mime_type: "application/vnd.frogans.fnc", ext: "fnc" }, { mime_type: "application/vnd.frogans.ltf", ext: "ltf" }, { mime_type: "application/vnd.fsc.weblaunch", ext: "fsc" }, { mime_type: "application/vnd.fujitsu.oasys", ext: "oas" }, { mime_type: "application/vnd.fujitsu.oasys2", ext: "oa2" }, { mime_type: "application/vnd.fujitsu.oasys3", ext: "oa3" }, { mime_type: "application/vnd.fujitsu.oasysgp", ext: "fg5" }, { mime_type: "application/vnd.fujitsu.oasysprs", ext: "bh2" }, { mime_type: "application/vnd.fujixerox.art-ex" }, { mime_type: "application/vnd.fujixerox.art4" }, { mime_type: "application/vnd.fujixerox.hbpl" }, { mime_type: "application/vnd.fujixerox.ddd", ext: "ddd" }, { mime_type: "application/vnd.fujixerox.docuworks", ext: "xdw" }, { mime_type: "application/vnd.fujixerox.docuworks.binder", ext: "xbd" }, { mime_type: "application/vnd.fut-misnet" }, { mime_type: "application/vnd.fuzzysheet", ext: "fzs" }, { mime_type: "application/vnd.genomatix.tuxedo", ext: "txd" }, { mime_type: "application/vnd.geogebra.file", ext: "ggb" }, { mime_type: "application/vnd.geogebra.tool", ext: "ggt" }, { mime_type: "application/vnd.geometry-explorer", ext: "gex gre" }, { mime_type: "application/vnd.gmx", ext: "gmx" }, { mime_type: "application/vnd.google-earth.kml+xml", ext: "kml" }, { mime_type: "application/vnd.google-earth.kmz", ext: "kmz" }, { mime_type: "application/vnd.grafeq", ext: "gqf gqs" }, { mime_type: "application/vnd.gridmp" }, { mime_type: "application/vnd.groove-account", ext: "gac" }, { mime_type: "application/vnd.groove-help", ext: "ghf" }, { mime_type: "application/vnd.groove-identity-message", ext: "gim" }, { mime_type: "application/vnd.groove-injector", ext: "grv" }, { mime_type: "application/vnd.groove-tool-message", ext: "gtm" }, { mime_type: "application/vnd.groove-tool-template", ext: "tpl" }, { mime_type: "application/vnd.groove-vcard", ext: "vcg" }, { mime_type: "application/vnd.handheld-entertainment+xml", ext: "zmm" }, { mime_type: "application/vnd.hbci", ext: "hbci" }, { mime_type: "application/vnd.hcl-bireports" }, { mime_type: "application/vnd.hhe.lesson-player", ext: "les" }, { mime_type: "application/vnd.hp-hpgl", ext: "hpgl" }, { mime_type: "application/vnd.hp-hpid", ext: "hpid" }, { mime_type: "application/vnd.hp-hps", ext: "hps" }, { mime_type: "application/vnd.hp-jlyt", ext: "jlt" }, { mime_type: "application/vnd.hp-pcl", ext: "pcl" }, { mime_type: "application/vnd.hp-pclxl", ext: "pclxl" }, { mime_type: "application/vnd.httphone" }, { mime_type: "application/vnd.hydrostatix.sof-data", ext: "sfd-hdstx" }, { mime_type: "application/vnd.hzn-3d-crossword", ext: "x3d" }, { mime_type: "application/vnd.ibm.afplinedata" }, { mime_type: "application/vnd.ibm.electronic-media" }, { mime_type: "application/vnd.ibm.minipay", ext: "mpy" }, { mime_type: "application/vnd.ibm.modcap", ext: "afp listafp list3820" }, { mime_type: "application/vnd.ibm.rights-management", ext: "irm" }, { mime_type: "application/vnd.ibm.secure-container", ext: "sc" }, { mime_type: "application/vnd.iccprofile", ext: "icc icm" }, { mime_type: "application/vnd.igloader", ext: "igl" }, { mime_type: "application/vnd.immervision-ivp", ext: "ivp" }, { mime_type: "application/vnd.immervision-ivu", ext: "ivu" }, { mime_type: "application/vnd.informedcontrol.rms+xml" }, { mime_type: "application/vnd.informix-visionary" }, { mime_type: "application/vnd.intercon.formnet", ext: "xpw xpx" }, { mime_type: "application/vnd.intertrust.digibox" }, { mime_type: "application/vnd.intertrust.nncp" }, { mime_type: "application/vnd.intu.qbo", ext: "qbo" }, { mime_type: "application/vnd.intu.qfx", ext: "qfx" }, { mime_type: "application/vnd.iptc.g2.conceptitem+xml" }, { mime_type: "application/vnd.iptc.g2.knowledgeitem+xml" }, { mime_type: "application/vnd.iptc.g2.newsitem+xml" }, { mime_type: "application/vnd.iptc.g2.packageitem+xml" }, { mime_type: "application/vnd.ipunplugged.rcprofile", ext: "rcprofile" }, { mime_type: "application/vnd.irepository.package+xml", ext: "irp" }, { mime_type: "application/vnd.is-xpr", ext: "xpr" }, { mime_type: "application/vnd.jam", ext: "jam" }, { mime_type: "application/vnd.japannet-directory-service" }, { mime_type: "application/vnd.japannet-jpnstore-wakeup" }, { mime_type: "application/vnd.japannet-payment-wakeup" }, { mime_type: "application/vnd.japannet-registration" }, { mime_type: "application/vnd.japannet-registration-wakeup" }, { mime_type: "application/vnd.japannet-setstore-wakeup" }, { mime_type: "application/vnd.japannet-verification" }, { mime_type: "application/vnd.japannet-verification-wakeup" }, { mime_type: "application/vnd.jcp.javame.midlet-rms", ext: "rms" }, { mime_type: "application/vnd.jisp", ext: "jisp" }, { mime_type: "application/vnd.joost.joda-archive", ext: "joda" }, { mime_type: "application/vnd.kahootz", ext: "ktz ktr" }, { mime_type: "application/vnd.kde.karbon", ext: "karbon" }, { mime_type: "application/vnd.kde.kchart", ext: "chrt" }, { mime_type: "application/vnd.kde.kformula", ext: "kfo" }, { mime_type: "application/vnd.kde.kivio", ext: "flw" }, { mime_type: "application/vnd.kde.kontour", ext: "kon" }, { mime_type: "application/vnd.kde.kpresenter", ext: "kpr kpt" }, { mime_type: "application/vnd.kde.kspread", ext: "ksp" }, { mime_type: "application/vnd.kde.kword", ext: "kwd kwt" }, { mime_type: "application/vnd.kenameaapp", ext: "htke" }, { mime_type: "application/vnd.kidspiration", ext: "kia" }, { mime_type: "application/vnd.kinar", ext: "kne knp" }, { mime_type: "application/vnd.koan", ext: "skp skd skt skm" }, { mime_type: "application/vnd.kodak-descriptor", ext: "sse" }, { mime_type: "application/vnd.liberty-request+xml" }, { mime_type: "application/vnd.llamagraphics.life-balance.desktop", ext: "lbd" }, { mime_type: "application/vnd.llamagraphics.life-balance.exchange+xml", ext: "lbe" }, { mime_type: "application/vnd.lotus-1-2-3", ext: "123" }, { mime_type: "application/vnd.lotus-approach", ext: "apr" }, { mime_type: "application/vnd.lotus-freelance", ext: "pre" }, { mime_type: "application/vnd.lotus-notes", ext: "nsf" }, { mime_type: "application/vnd.lotus-organizer", ext: "org" }, { mime_type: "application/vnd.lotus-screencam", ext: "scm" }, { mime_type: "application/vnd.lotus-wordpro", ext: "lwp" }, { mime_type: "application/vnd.macports.portpkg", ext: "portpkg" }, { mime_type: "application/vnd.marlin.drm.actiontoken+xml" }, { mime_type: "application/vnd.marlin.drm.conftoken+xml" }, { mime_type: "application/vnd.marlin.drm.license+xml" }, { mime_type: "application/vnd.marlin.drm.mdcf" }, { mime_type: "application/vnd.mcd", ext: "mcd" }, { mime_type: "application/vnd.medcalcdata", ext: "mc1" }, { mime_type: "application/vnd.mediastation.cdkey", ext: "cdkey" }, { mime_type: "application/vnd.meridian-slingshot" }, { mime_type: "application/vnd.mfer", ext: "mwf" }, { mime_type: "application/vnd.mfmp", ext: "mfm" }, { mime_type: "application/vnd.micrografx.flo", ext: "flo" }, { mime_type: "application/vnd.micrografx.igx", ext: "igx" }, { mime_type: "application/vnd.mif", ext: "mif" }, { mime_type: "application/vnd.minisoft-hp3000-save" }, { mime_type: "application/vnd.mitsubishi.misty-guard.trustweb" }, { mime_type: "application/vnd.mobius.daf", ext: "daf" }, { mime_type: "application/vnd.mobius.dis", ext: "dis" }, { mime_type: "application/vnd.mobius.mbk", ext: "mbk" }, { mime_type: "application/vnd.mobius.mqy", ext: "mqy" }, { mime_type: "application/vnd.mobius.msl", ext: "msl" }, { mime_type: "application/vnd.mobius.plc", ext: "plc" }, { mime_type: "application/vnd.mobius.txf", ext: "txf" }, { mime_type: "application/vnd.mophun.application", ext: "mpn" }, { mime_type: "application/vnd.mophun.certificate", ext: "mpc" }, { mime_type: "application/vnd.motorola.flexsuite" }, { mime_type: "application/vnd.motorola.flexsuite.adsi" }, { mime_type: "application/vnd.motorola.flexsuite.fis" }, { mime_type: "application/vnd.motorola.flexsuite.gotap" }, { mime_type: "application/vnd.motorola.flexsuite.kmr" }, { mime_type: "application/vnd.motorola.flexsuite.ttc" }, { mime_type: "application/vnd.motorola.flexsuite.wem" }, { mime_type: "application/vnd.motorola.iprm" }, { mime_type: "application/vnd.mozilla.xul+xml", ext: "xul" }, { mime_type: "application/vnd.ms-artgalry", ext: "cil" }, { mime_type: "application/vnd.ms-asf" }, { mime_type: "application/vnd.ms-cab-compressed", ext: "cab" }, { mime_type: "application/vnd.ms-excel", ext: "xls xlm xla xlc xlt xlw" }, { mime_type: "application/vnd.ms-excel.addin.macroenabled.12", ext: "xlam" }, { mime_type: "application/vnd.ms-excel.sheet.binary.macroenabled.12", ext: "xlsb" }, { mime_type: "application/vnd.ms-excel.sheet.macroenabled.12", ext: "xlsm" }, { mime_type: "application/vnd.ms-excel.template.macroenabled.12", ext: "xltm" }, { mime_type: "application/vnd.ms-fontobject", ext: "eot" }, { mime_type: "application/vnd.ms-htmlhelp", ext: "chm" }, { mime_type: "application/vnd.ms-ims", ext: "ims" }, { mime_type: "application/vnd.ms-lrm", ext: "lrm" }, { mime_type: "application/vnd.ms-pki.seccat", ext: "cat" }, { mime_type: "application/vnd.ms-pki.stl", ext: "stl" }, { mime_type: "application/vnd.ms-playready.initiator+xml" }, { mime_type: "application/vnd.ms-powerpoint", ext: "ppt pps pot" }, { mime_type: "application/vnd.ms-powerpoint.addin.macroenabled.12", ext: "ppam" }, { mime_type: "application/vnd.ms-powerpoint.presentation.macroenabled.12", ext: "pptm" }, { mime_type: "application/vnd.ms-powerpoint.slide.macroenabled.12", ext: "sldm" }, { mime_type: "application/vnd.ms-powerpoint.slideshow.macroenabled.12", ext: "ppsm" }, { mime_type: "application/vnd.ms-powerpoint.template.macroenabled.12", ext: "potm" }, { mime_type: "application/vnd.ms-project", ext: "mpp mpt" }, { mime_type: "application/vnd.ms-tnef" }, { mime_type: "application/vnd.ms-wmdrm.lic-chlg-req" }, { mime_type: "application/vnd.ms-wmdrm.lic-resp" }, { mime_type: "application/vnd.ms-wmdrm.meter-chlg-req" }, { mime_type: "application/vnd.ms-wmdrm.meter-resp" }, { mime_type: "application/vnd.ms-word.document.macroenabled.12", ext: "docm" }, { mime_type: "application/vnd.ms-word.template.macroenabled.12", ext: "dotm" }, { mime_type: "application/vnd.ms-works", ext: "wps wks wcm wdb" }, { mime_type: "application/vnd.ms-wpl", ext: "wpl" }, { mime_type: "application/vnd.ms-xpsdocument", ext: "xps" }, { mime_type: "application/vnd.mseq", ext: "mseq" }, { mime_type: "application/vnd.msign" }, { mime_type: "application/vnd.multiad.creator" }, { mime_type: "application/vnd.multiad.creator.cif" }, { mime_type: "application/vnd.music-niff" }, { mime_type: "application/vnd.musician", ext: "mus" }, { mime_type: "application/vnd.muvee.style", ext: "msty" }, { mime_type: "application/vnd.ncd.control" }, { mime_type: "application/vnd.ncd.reference" }, { mime_type: "application/vnd.nervana" }, { mime_type: "application/vnd.netfpx" }, { mime_type: "application/vnd.neurolanguage.nlu", ext: "nlu" }, { mime_type: "application/vnd.noblenet-directory", ext: "nnd" }, { mime_type: "application/vnd.noblenet-sealer", ext: "nns" }, { mime_type: "application/vnd.noblenet-web", ext: "nnw" }, { mime_type: "application/vnd.nokia.catalogs" }, { mime_type: "application/vnd.nokia.conml+wbxml" }, { mime_type: "application/vnd.nokia.conml+xml" }, { mime_type: "application/vnd.nokia.isds-radio-presets" }, { mime_type: "application/vnd.nokia.iptv.config+xml" }, { mime_type: "application/vnd.nokia.landmark+wbxml" }, { mime_type: "application/vnd.nokia.landmark+xml" }, { mime_type: "application/vnd.nokia.landmarkcollection+xml" }, { mime_type: "application/vnd.nokia.n-gage.ac+xml" }, { mime_type: "application/vnd.nokia.n-gage.data", ext: "ngdat" }, { mime_type: "application/vnd.nokia.n-gage.symbian.install", ext: "n-gage" }, { mime_type: "application/vnd.nokia.ncd" }, { mime_type: "application/vnd.nokia.pcd+wbxml" }, { mime_type: "application/vnd.nokia.pcd+xml" }, { mime_type: "application/vnd.nokia.radio-preset", ext: "rpst" }, { mime_type: "application/vnd.nokia.radio-presets", ext: "rpss" }, { mime_type: "application/vnd.novadigm.edm", ext: "edm" }, { mime_type: "application/vnd.novadigm.edx", ext: "edx" }, { mime_type: "application/vnd.novadigm.ext", ext: "ext" }, { mime_type: "application/vnd.oasis.opendocument.chart", ext: "odc" }, { mime_type: "application/vnd.oasis.opendocument.chart-template", ext: "otc" }, { mime_type: "application/vnd.oasis.opendocument.database", ext: "odb" }, { mime_type: "application/vnd.oasis.opendocument.formula", ext: "odf" }, { mime_type: "application/vnd.oasis.opendocument.formula-template", ext: "odft" }, { mime_type: "application/vnd.oasis.opendocument.graphics", ext: "odg" }, { mime_type: "application/vnd.oasis.opendocument.graphics-template", ext: "otg" }, { mime_type: "application/vnd.oasis.opendocument.image", ext: "odi" }, { mime_type: "application/vnd.oasis.opendocument.image-template", ext: "oti" }, { mime_type: "application/vnd.oasis.opendocument.presentation", ext: "odp" }, { mime_type: "application/vnd.oasis.opendocument.presentation-template otp" }, { mime_type: "application/vnd.oasis.opendocument.spreadsheet", ext: "ods" }, { mime_type: "application/vnd.oasis.opendocument.spreadsheet-template", ext: "ots" }, { mime_type: "application/vnd.oasis.opendocument.text", ext: "odt" }, { mime_type: "application/vnd.oasis.opendocument.text-master", ext: "otm" }, { mime_type: "application/vnd.oasis.opendocument.text-template", ext: "ott" }, { mime_type: "application/vnd.oasis.opendocument.text-web", ext: "oth" }, { mime_type: "application/vnd.obn" }, { mime_type: "application/vnd.olpc-sugar", ext: "xo" }, { mime_type: "application/vnd.oma-scws-config" }, { mime_type: "application/vnd.oma-scws-http-request" }, { mime_type: "application/vnd.oma-scws-http-response" }, { mime_type: "application/vnd.oma.bcast.associated-procedure-parameter+xml" }, { mime_type: "application/vnd.oma.bcast.drm-trigger+xml" }, { mime_type: "application/vnd.oma.bcast.imd+xml" }, { mime_type: "application/vnd.oma.bcast.ltkm" }, { mime_type: "application/vnd.oma.bcast.notification+xml" }, { mime_type: "application/vnd.oma.bcast.provisioningtrigger" }, { mime_type: "application/vnd.oma.bcast.sgboot" }, { mime_type: "application/vnd.oma.bcast.sgdd+xml" }, { mime_type: "application/vnd.oma.bcast.sgdu" }, { mime_type: "application/vnd.oma.bcast.simple-symbol-container" }, { mime_type: "application/vnd.oma.bcast.smartcard-trigger+xml" }, { mime_type: "application/vnd.oma.bcast.sprov+xml" }, { mime_type: "application/vnd.oma.bcast.stkm" }, { mime_type: "application/vnd.oma.dcd" }, { mime_type: "application/vnd.oma.dcdc" }, { mime_type: "application/vnd.oma.dd2+xml", ext: "dd2" }, { mime_type: "application/vnd.oma.drm.risd+xml" }, { mime_type: "application/vnd.oma.group-usage-list+xml" }, { mime_type: "application/vnd.oma.poc.detailed-progress-report+xml" }, { mime_type: "application/vnd.oma.poc.final-report+xml" }, { mime_type: "application/vnd.oma.poc.groups+xml" }, { mime_type: "application/vnd.oma.poc.invocation-descriptor+xml" }, { mime_type: "application/vnd.oma.poc.optimized-progress-report+xml" }, { mime_type: "application/vnd.oma.xcap-directory+xml" }, { mime_type: "application/vnd.omads-email+xml" }, { mime_type: "application/vnd.omads-file+xml" }, { mime_type: "application/vnd.omads-folder+xml" }, { mime_type: "application/vnd.omaloc-supl-init" }, { mime_type: "application/vnd.openofficeorg.extension", ext: "oxt" }, { mime_type: "application/vnd.openxmlformats-officedocument.presentationml.presentation", ext: "pptx" }, { mime_type: "application/vnd.openxmlformats-officedocument.presentationml.slide", ext: "sldx" }, { mime_type: "application/vnd.openxmlformats-officedocument.presentationml.slideshow", ext: "ppsx" }, { mime_type: "application/vnd.openxmlformats-officedocument.presentationml.template", ext: "potx" }, { mime_type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", ext: "xlsx" }, { mime_type: "application/vnd.openxmlformats-officedocument.spreadsheetml.template", ext: "xltx" }, { mime_type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document", ext: "docx" }, { mime_type: "application/vnd.openxmlformats-officedocument.wordprocessingml.template", ext: "dotx" }, { mime_type: "application/vnd.osa.netdeploy" }, { mime_type: "application/vnd.osgi.bundle" }, { mime_type: "application/vnd.osgi.dp", ext: "dp" }, { mime_type: "application/vnd.otps.ct-kip+xml" }, { mime_type: "application/vnd.palm", ext: "pdb pqa oprc" }, { mime_type: "application/vnd.paos.xml" }, { mime_type: "application/vnd.pg.format", ext: "str" }, { mime_type: "application/vnd.pg.osasli", ext: "ei6" }, { mime_type: "application/vnd.piaccess.application-licence" }, { mime_type: "application/vnd.picsel", ext: "efif" }, { mime_type: "application/vnd.poc.group-advertisement+xml" }, { mime_type: "application/vnd.pocketlearn", ext: "plf" }, { mime_type: "application/vnd.powerbuilder6", ext: "pbd" }, { mime_type: "application/vnd.powerbuilder6-s" }, { mime_type: "application/vnd.powerbuilder7" }, { mime_type: "application/vnd.powerbuilder7-s" }, { mime_type: "application/vnd.powerbuilder75" }, { mime_type: "application/vnd.powerbuilder75-s" }, { mime_type: "application/vnd.preminet" }, { mime_type: "application/vnd.previewsystems.box", ext: "box" }, { mime_type: "application/vnd.proteus.magazine", ext: "mgz" }, { mime_type: "application/vnd.publishare-delta-tree", ext: "qps" }, { mime_type: "application/vnd.pvi.ptid1", ext: "ptid" }, { mime_type: "application/vnd.pwg-multiplexed" }, { mime_type: "application/vnd.pwg-xhtml-print+xml" }, { mime_type: "application/vnd.qualcomm.brew-app-res" }, { mime_type: "application/vnd.quark.quarkxpress", ext: "qxd qxt qwd qwt qxl qxb" }, { mime_type: "application/vnd.rapid" }, { mime_type: "application/vnd.recordare.musicxml", ext: "mxl" }, { mime_type: "application/vnd.recordare.musicxml+xml", ext: "musicxml" }, { mime_type: "application/vnd.renlearn.rlprint" }, { mime_type: "application/vnd.rim.cod", ext: "cod" }, { mime_type: "application/vnd.rn-realmedia", ext: "rm" }, { mime_type: "application/vnd.route66.link66+xml", ext: "link66" }, { mime_type: "application/vnd.ruckus.download" }, { mime_type: "application/vnd.s3sms" }, { mime_type: "application/vnd.sbm.cid" }, { mime_type: "application/vnd.sbm.mid2" }, { mime_type: "application/vnd.scribus" }, { mime_type: "application/vnd.sealed.3df" }, { mime_type: "application/vnd.sealed.csf" }, { mime_type: "application/vnd.sealed.doc" }, { mime_type: "application/vnd.sealed.eml" }, { mime_type: "application/vnd.sealed.mht" }, { mime_type: "application/vnd.sealed.net" }, { mime_type: "application/vnd.sealed.ppt" }, { mime_type: "application/vnd.sealed.tiff" }, { mime_type: "application/vnd.sealed.xls" }, { mime_type: "application/vnd.sealedmedia.softseal.html" }, { mime_type: "application/vnd.sealedmedia.softseal.pdf" }, { mime_type: "application/vnd.seemail", ext: "see" }, { mime_type: "application/vnd.sema", ext: "sema" }, { mime_type: "application/vnd.semd", ext: "semd" }, { mime_type: "application/vnd.semf", ext: "semf" }, { mime_type: "application/vnd.shana.informed.formdata", ext: "ifm" }, { mime_type: "application/vnd.shana.informed.formtemplate", ext: "itp" }, { mime_type: "application/vnd.shana.informed.interchange", ext: "iif" }, { mime_type: "application/vnd.shana.informed.package", ext: "ipk" }, { mime_type: "application/vnd.simtech-mindmapper", ext: "twd twds" }, { mime_type: "application/vnd.smaf", ext: "mmf" }, { mime_type: "application/vnd.smart.teacher", ext: "teacher" }, { mime_type: "application/vnd.software602.filler.form+xml" }, { mime_type: "application/vnd.software602.filler.form-xml-zip" }, { mime_type: "application/vnd.solent.sdkm+xml", ext: "sdkm sdkd" }, { mime_type: "application/vnd.spotfire.dxp", ext: "dxp" }, { mime_type: "application/vnd.spotfire.sfs", ext: "sfs" }, { mime_type: "application/vnd.sss-cod" }, { mime_type: "application/vnd.sss-dtf" }, { mime_type: "application/vnd.sss-ntf" }, { mime_type: "application/vnd.stardivision.calc", ext: "sdc" }, { mime_type: "application/vnd.stardivision.draw", ext: "sda" }, { mime_type: "application/vnd.stardivision.impress", ext: "sdd" }, { mime_type: "application/vnd.stardivision.math", ext: "smf" }, { mime_type: "application/vnd.stardivision.writer", ext: "sdw" }, { mime_type: "application/vnd.stardivision.writer", ext: "vor" }, { mime_type: "application/vnd.stardivision.writer-global", ext: "sgl" }, { mime_type: "application/vnd.street-stream" }, { mime_type: "application/vnd.sun.xml.calc", ext: "sxc" }, { mime_type: "application/vnd.sun.xml.calc.template", ext: "stc" }, { mime_type: "application/vnd.sun.xml.draw", ext: "sxd" }, { mime_type: "application/vnd.sun.xml.draw.template", ext: "std" }, { mime_type: "application/vnd.sun.xml.impress", ext: "sxi" }, { mime_type: "application/vnd.sun.xml.impress.template", ext: "sti" }, { mime_type: "application/vnd.sun.xml.math", ext: "sxm" }, { mime_type: "application/vnd.sun.xml.writer", ext: "sxw" }, { mime_type: "application/vnd.sun.xml.writer.global", ext: "sxg" }, { mime_type: "application/vnd.sun.xml.writer.template", ext: "stw" }, { mime_type: "application/vnd.sun.wadl+xml" }, { mime_type: "application/vnd.sus-calendar", ext: "sus susp" }, { mime_type: "application/vnd.svd", ext: "svd" }, { mime_type: "application/vnd.swiftview-ics" }, { mime_type: "application/vnd.symbian.install", ext: "sis sisx" }, { mime_type: "application/vnd.syncml+xml", ext: "xsm" }, { mime_type: "application/vnd.syncml.dm+wbxml", ext: "bdm" }, { mime_type: "application/vnd.syncml.dm+xml", ext: "xdm" }, { mime_type: "application/vnd.syncml.dm.notification" }, { mime_type: "application/vnd.syncml.ds.notification" }, { mime_type: "application/vnd.tao.intent-module-archive", ext: "tao" }, { mime_type: "application/vnd.tmobile-livetv", ext: "tmo" }, { mime_type: "application/vnd.trid.tpt", ext: "tpt" }, { mime_type: "application/vnd.triscape.mxs", ext: "mxs" }, { mime_type: "application/vnd.trueapp", ext: "tra" }, { mime_type: "application/vnd.truedoc" }, { mime_type: "application/vnd.ufdl", ext: "ufd ufdl" }, { mime_type: "application/vnd.uiq.theme", ext: "utz" }, { mime_type: "application/vnd.umajin", ext: "umj" }, { mime_type: "application/vnd.unity", ext: "unityweb" }, { mime_type: "application/vnd.uoml+xml", ext: "uoml" }, { mime_type: "application/vnd.uplanet.alert" }, { mime_type: "application/vnd.uplanet.alert-wbxml" }, { mime_type: "application/vnd.uplanet.bearer-choice" }, { mime_type: "application/vnd.uplanet.bearer-choice-wbxml" }, { mime_type: "application/vnd.uplanet.cacheop" }, { mime_type: "application/vnd.uplanet.cacheop-wbxml" }, { mime_type: "application/vnd.uplanet.channel" }, { mime_type: "application/vnd.uplanet.channel-wbxml" }, { mime_type: "application/vnd.uplanet.list" }, { mime_type: "application/vnd.uplanet.list-wbxml" }, { mime_type: "application/vnd.uplanet.listcmd" }, { mime_type: "application/vnd.uplanet.listcmd-wbxml" }, { mime_type: "application/vnd.uplanet.signal" }, { mime_type: "application/vnd.vcx", ext: "vcx" }, { mime_type: "application/vnd.vd-study" }, { mime_type: "application/vnd.vectorworks" }, { mime_type: "application/vnd.vidsoft.vidconference" }, { mime_type: "application/vnd.visio", ext: "vsd vst vss vsw" }, { mime_type: "application/vnd.visionary", ext: "vis" }, { mime_type: "application/vnd.vividence.scriptfile" }, { mime_type: "application/vnd.vsf", ext: "vsf" }, { mime_type: "application/vnd.wap.sic" }, { mime_type: "application/vnd.wap.slc" }, { mime_type: "application/vnd.wap.wbxml", ext: "wbxml" }, { mime_type: "application/vnd.wap.wmlc", ext: "wmlc" }, { mime_type: "application/vnd.wap.wmlscriptc", ext: "wmlsc" }, { mime_type: "application/vnd.webturbo", ext: "wtb" }, { mime_type: "application/vnd.wfa.wsc" }, { mime_type: "application/vnd.wmc" }, { mime_type: "application/vnd.wmf.bootstrap" }, { mime_type: "application/vnd.wordperfect", ext: "wpd" }, { mime_type: "application/vnd.wqd", ext: "wqd" }, { mime_type: "application/vnd.wrq-hp3000-labelled" }, { mime_type: "application/vnd.wt.stf", ext: "stf" }, { mime_type: "application/vnd.wv.csp+wbxml" }, { mime_type: "application/vnd.wv.csp+xml" }, { mime_type: "application/vnd.wv.ssp+xml" }, { mime_type: "application/vnd.xara", ext: "xar" }, { mime_type: "application/vnd.xfdl", ext: "xfdl" }, { mime_type: "application/vnd.xfdl.webform" }, { mime_type: "application/vnd.xmi+xml" }, { mime_type: "application/vnd.xmpie.cpkg" }, { mime_type: "application/vnd.xmpie.dpkg" }, { mime_type: "application/vnd.xmpie.plan" }, { mime_type: "application/vnd.xmpie.ppkg" }, { mime_type: "application/vnd.xmpie.xlim" }, { mime_type: "application/vnd.yamaha.hv-dic", ext: "hvd" }, { mime_type: "application/vnd.yamaha.hv-script", ext: "hvs" }, { mime_type: "application/vnd.yamaha.hv-voice", ext: "hvp" }, { mime_type: "application/vnd.yamaha.openscoreformat", ext: "osf" }, { mime_type: "application/vnd.yamaha.openscoreformat.osfpvg+xml", ext: "osfpvg" }, { mime_type: "application/vnd.yamaha.smaf-audio", ext: "saf" }, { mime_type: "application/vnd.yamaha.smaf-phrase", ext: "spf" }, { mime_type: "application/vnd.yellowriver-custom-menu", ext: "cmp" }, { mime_type: "application/vnd.zul", ext: "zir zirz" }, { mime_type: "application/vnd.zzazz.deck+xml", ext: "zaz" }, { mime_type: "application/voicexml+xml", ext: "vxml" }, { mime_type: "application/watcherinfo+xml" }, { mime_type: "application/whoispp-query" }, { mime_type: "application/whoispp-response" }, { mime_type: "application/winhlp", ext: "hlp" }, { mime_type: "application/wita" }, { mime_type: "application/wordperfect5.1" }, { mime_type: "application/wsdl+xml", ext: "wsdl" }, { mime_type: "application/wspolicy+xml", ext: "wspolicy" }, { mime_type: "application/x-abiword", ext: "abw" }, { mime_type: "application/x-ace-compressed", ext: "ace" }, { mime_type: "application/x-authorware-bin", ext: "aab x32 u32 vox" }, { mime_type: "application/x-authorware-map", ext: "aam" }, { mime_type: "application/x-authorware-seg", ext: "aas" }, { mime_type: "application/x-bcpio", ext: "bcpio" }, { mime_type: "application/x-bittorrent", ext: "torrent" }, { mime_type: "application/x-bzip", ext: "bz" }, { mime_type: "application/x-bzip2", ext: "bz2 boz" }, { mime_type: "application/x-cdlink", ext: "vcd" }, { mime_type: "application/x-chat", ext: "chat" }, { mime_type: "application/x-chess-pgn", ext: "pgn" }, { mime_type: "application/x-compress" }, { mime_type: "application/x-cpio", ext: "cpio" }, { mime_type: "application/x-csh", ext: "csh" }, { mime_type: "application/x-debian-package", ext: "deb udeb" }, { mime_type: "application/x-director", ext: "dir dcr dxr cst cct cxt w3d fgd swa" }, { mime_type: "application/x-doom", ext: "wad" }, { mime_type: "application/x-dtbncx+xml", ext: "ncx" }, { mime_type: "application/x-dtbook+xml", ext: "dtb" }, { mime_type: "application/x-dtbresource+xml", ext: "res" }, { mime_type: "application/x-dvi", ext: "dvi" }, { mime_type: "application/x-font-bdf", ext: "bdf" }, { mime_type: "application/x-font-dos" }, { mime_type: "application/x-font-framemaker" }, { mime_type: "application/x-font-ghostscript", ext: "gsf" }, { mime_type: "application/x-font-libgrx" }, { mime_type: "application/x-font-linux-psf", ext: "psf" }, { mime_type: "application/x-font-otf", ext: "otf" }, { mime_type: "application/x-font-pcf", ext: "pcf" }, { mime_type: "application/x-font-snf", ext: "snf" }, { mime_type: "application/x-font-speedo" }, { mime_type: "application/x-font-sunos-news" }, { mime_type: "application/x-font-ttf", ext: "ttf ttc" }, { mime_type: "application/x-font-type1", ext: "pfa pfb pfm afm" }, { mime_type: "application/x-font-vfont" }, { mime_type: "application/x-futuresplash", ext: "spl" }, { mime_type: "application/x-gnumeric", ext: "gnumeric" }, { mime_type: "application/x-gtar", ext: "gtar" }, { mime_type: "application/x-gzip" }, { mime_type: "application/x-hdf", ext: "hdf" }, { mime_type: "application/x-java-jnlp-file", ext: "jnlp" }, { mime_type: "application/x-latex", ext: "latex" }, { mime_type: "application/x-mobipocket-ebook", ext: "prc mobi" }, { mime_type: "application/x-ms-application", ext: "application" }, { mime_type: "application/x-ms-wmd", ext: "wmd" }, { mime_type: "application/x-ms-wmz", ext: "wmz" }, { mime_type: "application/x-ms-xbap", ext: "xbap" }, { mime_type: "application/x-msaccess", ext: "mdb" }, { mime_type: "application/x-msbinder", ext: "obd" }, { mime_type: "application/x-mscardfile", ext: "crd" }, { mime_type: "application/x-msclip", ext: "clp" }, { mime_type: "application/x-msdownload", ext: "exe dll com bat msi" }, { mime_type: "application/x-msmediaview", ext: "mvb m13 m14" }, { mime_type: "application/x-msmetafile", ext: "wmf" }, { mime_type: "application/x-msmoney", ext: "mny" }, { mime_type: "application/x-mspublisher", ext: "pub" }, { mime_type: "application/x-msschedule", ext: "scd" }, { mime_type: "application/x-msterminal", ext: "trm" }, { mime_type: "application/x-mswrite", ext: "wri" }, { mime_type: "application/x-netcdf", ext: "nc cdf" }, { mime_type: "application/x-pkcs12", ext: "p12 pfx" }, { mime_type: "application/x-pkcs7-certificates", ext: "p7b spc" }, { mime_type: "application/x-pkcs7-certreqresp", ext: "p7r" }, { mime_type: "application/x-rar-compressed", ext: "rar" }, { mime_type: "application/x-sh", ext: "sh" }, { mime_type: "application/x-shar", ext: "shar" }, { mime_type: "application/x-shockwave-flash", ext: "swf" }, { mime_type: "application/x-silverlight-app", ext: "xap" }, { mime_type: "application/x-stuffit", ext: "sit" }, { mime_type: "application/x-stuffitx", ext: "sitx" }, { mime_type: "application/x-sv4cpio", ext: "sv4cpio" }, { mime_type: "application/x-sv4crc", ext: "sv4crc" }, { mime_type: "application/x-tar", ext: "tar" }, { mime_type: "application/x-tcl", ext: "tcl" }, { mime_type: "application/x-tex", ext: "tex" }, { mime_type: "application/x-tex-tfm", ext: "tfm" }, { mime_type: "application/x-texinfo", ext: "texinfo texi" }, { mime_type: "application/x-ustar", ext: "ustar" }, { mime_type: "application/x-wais-source", ext: "src" }, { mime_type: "application/x-x509-ca-cert", ext: "der crt" }, { mime_type: "application/x-xfig", ext: "fig" }, { mime_type: "application/x-xpinstall", ext: "xpi" }, { mime_type: "application/x400-bp" }, { mime_type: "application/xcap-att+xml" }, { mime_type: "application/xcap-caps+xml" }, { mime_type: "application/xcap-el+xml" }, { mime_type: "application/xcap-error+xml" }, { mime_type: "application/xcap-ns+xml" }, { mime_type: "application/xcon-conference-info-diff+xml" }, { mime_type: "application/xcon-conference-info+xml" }, { mime_type: "application/xenc+xml", ext: "xenc" }, { mime_type: "application/xhtml+xml", ext: "xhtml xht" }, { mime_type: "application/xhtml-voice+xml" }, { mime_type: "application/xml", ext: "xml xsl" }, { mime_type: "application/xml-dtd", ext: "dtd" }, { mime_type: "application/xml-external-parsed-entity" }, { mime_type: "application/xmpp+xml" }, { mime_type: "application/xop+xml", ext: "xop" }, { mime_type: "application/xslt+xml", ext: "xslt" }, { mime_type: "application/xspf+xml", ext: "xspf" }, { mime_type: "application/xv+xml", ext: "mxml xhvml xvml xvm" }, { mime_type: "application/zip", ext: "zip" }, { mime_type: "audio/32kadpcm" }, { mime_type: "audio/3gpp" }, { mime_type: "audio/3gpp2" }, { mime_type: "audio/ac3" }, { mime_type: "audio/adpcm", ext: "adp" }, { mime_type: "audio/amr" }, { mime_type: "audio/amr-wb" }, { mime_type: "audio/amr-wb+" }, { mime_type: "audio/asc" }, { mime_type: "audio/basic", ext: "au snd" }, { mime_type: "audio/bv16" }, { mime_type: "audio/bv32" }, { mime_type: "audio/clearmode" }, { mime_type: "audio/cn" }, { mime_type: "audio/dat12" }, { mime_type: "audio/dls" }, { mime_type: "audio/dsr-es201108" }, { mime_type: "audio/dsr-es202050" }, { mime_type: "audio/dsr-es202211" }, { mime_type: "audio/dsr-es202212" }, { mime_type: "audio/dvi4" }, { mime_type: "audio/eac3" }, { mime_type: "audio/evrc" }, { mime_type: "audio/evrc-qcp" }, { mime_type: "audio/evrc0" }, { mime_type: "audio/evrc1" }, { mime_type: "audio/evrcb" }, { mime_type: "audio/evrcb0" }, { mime_type: "audio/evrcb1" }, { mime_type: "audio/evrcwb" }, { mime_type: "audio/evrcwb0" }, { mime_type: "audio/evrcwb1" }, { mime_type: "audio/example" }, { mime_type: "audio/g719" }, { mime_type: "audio/g722" }, { mime_type: "audio/g7221" }, { mime_type: "audio/g723" }, { mime_type: "audio/g726-16" }, { mime_type: "audio/g726-24" }, { mime_type: "audio/g726-32" }, { mime_type: "audio/g726-40" }, { mime_type: "audio/g728" }, { mime_type: "audio/g729" }, { mime_type: "audio/g7291" }, { mime_type: "audio/g729d" }, { mime_type: "audio/g729e" }, { mime_type: "audio/gsm" }, { mime_type: "audio/gsm-efr" }, { mime_type: "audio/ilbc" }, { mime_type: "audio/l16" }, { mime_type: "audio/l20" }, { mime_type: "audio/l24" }, { mime_type: "audio/l8" }, { mime_type: "audio/lpc" }, { mime_type: "audio/midi", ext: "mid midi kar rmi" }, { mime_type: "audio/mobile-xmf" }, { mime_type: "audio/mp4", ext: "mp4a" }, { mime_type: "audio/mp4a-latm", ext: "m4a m4p" }, { mime_type: "audio/mpa" }, { mime_type: "audio/mpa-robust" }, { mime_type: "audio/mpeg", ext: "mpga mp2 mp2a mp3 m2a m3a" }, { mime_type: "audio/mpeg4-generic" }, { mime_type: "audio/ogg", ext: "oga ogg spx" }, { mime_type: "audio/parityfec" }, { mime_type: "audio/pcma" }, { mime_type: "audio/pcma-wb" }, { mime_type: "audio/pcmu-wb" }, { mime_type: "audio/pcmu" }, { mime_type: "audio/prs.sid" }, { mime_type: "audio/qcelp" }, { mime_type: "audio/red" }, { mime_type: "audio/rtp-enc-aescm128" }, { mime_type: "audio/rtp-midi" }, { mime_type: "audio/rtx" }, { mime_type: "audio/smv" }, { mime_type: "audio/smv0" }, { mime_type: "audio/smv-qcp" }, { mime_type: "audio/sp-midi" }, { mime_type: "audio/t140c" }, { mime_type: "audio/t38" }, { mime_type: "audio/telephone-event" }, { mime_type: "audio/tone" }, { mime_type: "audio/ulpfec" }, { mime_type: "audio/vdvi" }, { mime_type: "audio/vmr-wb" }, { mime_type: "audio/vnd.3gpp.iufp" }, { mime_type: "audio/vnd.4sb" }, { mime_type: "audio/vnd.audiokoz" }, { mime_type: "audio/vnd.celp" }, { mime_type: "audio/vnd.cisco.nse" }, { mime_type: "audio/vnd.cmles.radio-events" }, { mime_type: "audio/vnd.cns.anp1" }, { mime_type: "audio/vnd.cns.inf1" }, { mime_type: "audio/vnd.digital-winds", ext: "eol" }, { mime_type: "audio/vnd.dlna.adts" }, { mime_type: "audio/vnd.dolby.heaac.1" }, { mime_type: "audio/vnd.dolby.heaac.2" }, { mime_type: "audio/vnd.dolby.mlp" }, { mime_type: "audio/vnd.dolby.mps" }, { mime_type: "audio/vnd.dolby.pl2" }, { mime_type: "audio/vnd.dolby.pl2x" }, { mime_type: "audio/vnd.dolby.pl2z" }, { mime_type: "audio/vnd.dts", ext: "dts" }, { mime_type: "audio/vnd.dts.hd", ext: "dtshd" }, { mime_type: "audio/vnd.everad.plj" }, { mime_type: "audio/vnd.hns.audio" }, { mime_type: "audio/vnd.lucent.voice", ext: "lvp" }, { mime_type: "audio/vnd.ms-playready.media.pya", ext: "pya" }, { mime_type: "audio/vnd.nokia.mobile-xmf" }, { mime_type: "audio/vnd.nortel.vbk" }, { mime_type: "audio/vnd.nuera.ecelp4800", ext: "ecelp4800" }, { mime_type: "audio/vnd.nuera.ecelp7470", ext: "ecelp7470" }, { mime_type: "audio/vnd.nuera.ecelp9600", ext: "ecelp9600" }, { mime_type: "audio/vnd.octel.sbc" }, { mime_type: "audio/vnd.qcelp" }, { mime_type: "audio/vnd.rhetorex.32kadpcm" }, { mime_type: "audio/vnd.sealedmedia.softseal.mpeg" }, { mime_type: "audio/vnd.vmx.cvsd" }, { mime_type: "audio/vorbis" }, { mime_type: "audio/vorbis-config" }, { mime_type: "audio/x-aac", ext: "aac" }, { mime_type: "audio/x-aiff", ext: "aif aiff aifc" }, { mime_type: "audio/x-mpegurl", ext: "m3u" }, { mime_type: "audio/x-ms-wax", ext: "wax" }, { mime_type: "audio/x-ms-wma", ext: "wma" }, { mime_type: "audio/x-pn-realaudio", ext: "ram ra" }, { mime_type: "audio/x-pn-realaudio-plugin", ext: "rmp" }, { mime_type: "audio/x-wav", ext: "wav" }, { mime_type: "chemical/x-cdx", ext: "cdx" }, { mime_type: "chemical/x-cif", ext: "cif" }, { mime_type: "chemical/x-cmdf", ext: "cmdf" }, { mime_type: "chemical/x-cml", ext: "cml" }, { mime_type: "chemical/x-csml", ext: "csml" }, { mime_type: "chemical/x-pdb" }, { mime_type: "chemical/x-xyz", ext: "xyz" }, { mime_type: "image/bmp", ext: "bmp" }, { mime_type: "image/cgm", ext: "cgm" }, { mime_type: "image/example" }, { mime_type: "image/fits" }, { mime_type: "image/g3fax", ext: "g3" }, { mime_type: "image/gif", ext: "gif" }, { mime_type: "image/ief", ext: "ief" }, { mime_type: "image/jp2", ext: "jp2" }, { mime_type: "image/jpeg", ext: "jpeg jpg jpe" }, { mime_type: "image/jpm" }, { mime_type: "image/jpx" }, { mime_type: "image/naplps" }, { mime_type: "image/pict", ext: "pict pic pct" }, { mime_type: "image/png", ext: "png" }, { mime_type: "image/prs.btif", ext: "btif" }, { mime_type: "image/prs.pti" }, { mime_type: "image/svg+xml", ext: "svg svgz" }, { mime_type: "image/t38" }, { mime_type: "image/tiff", ext: "tiff tif" }, { mime_type: "image/tiff-fx" }, { mime_type: "image/vnd.adobe.photoshop", ext: "psd" }, { mime_type: "image/vnd.cns.inf2" }, { mime_type: "image/vnd.djvu", ext: "djvu djv" }, { mime_type: "image/vnd.dwg", ext: "dwg" }, { mime_type: "image/vnd.dxf", ext: "dxf" }, { mime_type: "image/vnd.fastbidsheet", ext: "fbs" }, { mime_type: "image/vnd.fpx", ext: "fpx" }, { mime_type: "image/vnd.fst", ext: "fst" }, { mime_type: "image/vnd.fujixerox.edmics-mmr", ext: "mmr" }, { mime_type: "image/vnd.fujixerox.edmics-rlc", ext: "rlc" }, { mime_type: "image/vnd.globalgraphics.pgb" }, { mime_type: "image/vnd.microsoft.icon" }, { mime_type: "image/vnd.mix" }, { mime_type: "image/vnd.ms-modi", ext: "mdi" }, { mime_type: "image/vnd.net-fpx", ext: "npx" }, { mime_type: "image/vnd.radiance" }, { mime_type: "image/vnd.sealed.png" }, { mime_type: "image/vnd.sealedmedia.softseal.gif" }, { mime_type: "image/vnd.sealedmedia.softseal.jpg" }, { mime_type: "image/vnd.svf" }, { mime_type: "image/vnd.wap.wbmp", ext: "wbmp" }, { mime_type: "image/vnd.xiff", ext: "xif" }, { mime_type: "image/x-cmu-raster", ext: "ras" }, { mime_type: "image/x-cmx", ext: "cmx" }, { mime_type: "image/x-freehand", ext: "fh fhc fh4 fh5 fh7" }, { mime_type: "image/x-icon", ext: "ico" }, { mime_type: "image/x-macpaint", ext: "pntg pnt mac" }, { mime_type: "image/x-pcx", ext: "pcx" }, { mime_type: "image/x-portable-anymap", ext: "pnm" }, { mime_type: "image/x-portable-bitmap", ext: "pbm" }, { mime_type: "image/x-portable-graymap", ext: "pgm" }, { mime_type: "image/x-portable-pixmap", ext: "ppm" }, { mime_type: "image/x-quicktime", ext: "qtif qti" }, { mime_type: "image/x-rgb", ext: "rgb" }, { mime_type: "image/x-xbitmap", ext: "xbm" }, { mime_type: "image/x-xpixmap", ext: "xpm" }, { mime_type: "image/x-xwindowdump", ext: "xwd" }, { mime_type: "message/cpim" }, { mime_type: "message/delivery-status" }, { mime_type: "message/disposition-notification" }, { mime_type: "message/example" }, { mime_type: "message/external-body" }, { mime_type: "message/global" }, { mime_type: "message/global-delivery-status" }, { mime_type: "message/global-disposition-notification" }, { mime_type: "message/global-headers" }, { mime_type: "message/http" }, { mime_type: "message/imdn+xml" }, { mime_type: "message/news" }, { mime_type: "message/partial" }, { mime_type: "message/rfc822", ext: "eml mime" }, { mime_type: "message/s-http" }, { mime_type: "message/sip" }, { mime_type: "message/sipfrag" }, { mime_type: "message/tracking-status" }, { mime_type: "message/vnd.si.simp" }, { mime_type: "model/example" }, { mime_type: "model/iges", ext: "igs iges" }, { mime_type: "model/mesh", ext: "msh mesh silo" }, { mime_type: "model/vnd.dwf", ext: "dwf" }, { mime_type: "model/vnd.flatland.3dml" }, { mime_type: "model/vnd.gdl", ext: "gdl" }, { mime_type: "model/vnd.gs-gdl" }, { mime_type: "model/vnd.gs.gdl" }, { mime_type: "model/vnd.gtw", ext: "gtw" }, { mime_type: "model/vnd.moml+xml" }, { mime_type: "model/vnd.mts", ext: "mts" }, { mime_type: "model/vnd.parasolid.transmit.binary" }, { mime_type: "model/vnd.parasolid.transmit.text" }, { mime_type: "model/vnd.vtu", ext: "vtu" }, { mime_type: "model/vrml", ext: "wrl vrml" }, { mime_type: "multipart/alternative" }, { mime_type: "multipart/appledouble" }, { mime_type: "multipart/byteranges" }, { mime_type: "multipart/digest" }, { mime_type: "multipart/encrypted" }, { mime_type: "multipart/example" }, { mime_type: "multipart/form-data" }, { mime_type: "multipart/header-set" }, { mime_type: "multipart/mixed" }, { mime_type: "multipart/parallel" }, { mime_type: "multipart/related" }, { mime_type: "multipart/report" }, { mime_type: "multipart/signed" }, { mime_type: "multipart/voice-message" }, { mime_type: "text/calendar", ext: "ics ifb" }, { mime_type: "text/css", ext: "css" }, { mime_type: "text/csv", ext: "csv" }, { mime_type: "text/directory" }, { mime_type: "text/dns" }, { mime_type: "text/ecmascript" }, { mime_type: "text/enriched" }, { mime_type: "text/example" }, { mime_type: "text/html", ext: "html htm" }, { mime_type: "text/javascript" }, { mime_type: "text/parityfec" }, { mime_type: "text/plain", ext: "txt text conf def list log in" }, { mime_type: "text/prs.fallenstein.rst" }, { mime_type: "text/prs.lines.tag", ext: "dsc" }, { mime_type: "text/red" }, { mime_type: "text/rfc822-headers" }, { mime_type: "text/richtext", ext: "rtx" }, { mime_type: "text/rtf" }, { mime_type: "text/rtp-enc-aescm128" }, { mime_type: "text/rtx" }, { mime_type: "text/sgml", ext: "sgml sgm" }, { mime_type: "text/t140" }, { mime_type: "text/tab-separated-values", ext: "tsv" }, { mime_type: "text/troff", ext: "t tr roff man me ms" }, { mime_type: "text/ulpfec" }, { mime_type: "text/uri-list", ext: "uri uris urls" }, { mime_type: "text/vnd.abc" }, { mime_type: "text/vnd.curl", ext: "curl" }, { mime_type: "text/vnd.curl.dcurl", ext: "dcurl" }, { mime_type: "text/vnd.curl.scurl", ext: "scurl" }, { mime_type: "text/vnd.curl.mcurl", ext: "mcurl" }, { mime_type: "text/vnd.dmclientscript" }, { mime_type: "text/vnd.esmertec.theme-descriptor" }, { mime_type: "text/vnd.fly", ext: "fly" }, { mime_type: "text/vnd.fmi.flexstor", ext: "flx" }, { mime_type: "text/vnd.graphviz", ext: "gv" }, { mime_type: "text/vnd.in3d.3dml", ext: "3dml" }, { mime_type: "text/vnd.in3d.spot", ext: "spot" }, { mime_type: "text/vnd.iptc.newsml" }, { mime_type: "text/vnd.iptc.nitf" }, { mime_type: "text/vnd.latex-z" }, { mime_type: "text/vnd.motorola.reflex" }, { mime_type: "text/vnd.ms-mediapackage" }, { mime_type: "text/vnd.net2phone.commcenter.command" }, { mime_type: "text/vnd.si.uricatalogue" }, { mime_type: "text/vnd.sun.j2me.app-descriptor", ext: "jad" }, { mime_type: "text/vnd.trolltech.linguist" }, { mime_type: "text/vnd.wap.si" }, { mime_type: "text/vnd.wap.sl" }, { mime_type: "text/vnd.wap.wml", ext: "wml" }, { mime_type: "text/vnd.wap.wmlscript", ext: "wmls" }, { mime_type: "text/x-asm", ext: "s asm" }, { mime_type: "text/x-c", ext: "c cc cxx cpp h hh dic" }, { mime_type: "text/x-fortran", ext: "f for f77 f90" }, { mime_type: "text/x-pascal", ext: "p pas" }, { mime_type: "text/x-java-source", ext: "java" }, { mime_type: "text/x-setext", ext: "etx" }, { mime_type: "text/x-uuencode", ext: "uu" }, { mime_type: "text/x-vcalendar", ext: "vcs" }, { mime_type: "text/x-vcard", ext: "vcf" }, { mime_type: "text/xml" }, { mime_type: "text/xml-external-parsed-entity" }, { mime_type: "video/3gpp", ext: "3gp" }, { mime_type: "video/3gpp-tt" }, { mime_type: "video/3gpp2", ext: "3g2" }, { mime_type: "video/bmpeg" }, { mime_type: "video/bt656" }, { mime_type: "video/celb" }, { mime_type: "video/dv" }, { mime_type: "video/example" }, { mime_type: "video/h261", ext: "h261" }, { mime_type: "video/h263", ext: "h263" }, { mime_type: "video/h263-1998" }, { mime_type: "video/h263-2000" }, { mime_type: "video/h264", ext: "h264" }, { mime_type: "video/jpeg", ext: "jpgv" }, { mime_type: "video/jpeg2000" }, { mime_type: "video/jpm", ext: "jpm jpgm" }, { mime_type: "video/mj2", ext: "mj2 mjp2" }, { mime_type: "video/mp1s" }, { mime_type: "video/mp2p" }, { mime_type: "video/mp2t" }, { mime_type: "video/mp4", ext: "mp4 mp4v mpg4 m4v" }, { mime_type: "video/mp4v-es" }, { mime_type: "video/mpeg", ext: "mpeg mpg mpe m1v m2v" }, { mime_type: "video/mpeg4-generic" }, { mime_type: "video/mpv" }, { mime_type: "video/nv" }, { mime_type: "video/ogg", ext: "ogv" }, { mime_type: "video/parityfec" }, { mime_type: "video/pointer" }, { mime_type: "video/quicktime", ext: "qt mov" }, { mime_type: "video/raw" }, { mime_type: "video/rtp-enc-aescm128" }, { mime_type: "video/rtx" }, { mime_type: "video/smpte292m" }, { mime_type: "video/ulpfec" }, { mime_type: "video/vc1" }, { mime_type: "video/vnd.cctv" }, { mime_type: "video/vnd.dlna.mpeg-tts" }, { mime_type: "video/vnd.fvt", ext: "fvt" }, { mime_type: "video/vnd.hns.video" }, { mime_type: "video/vnd.iptvforum.1dparityfec-1010" }, { mime_type: "video/vnd.iptvforum.1dparityfec-2005" }, { mime_type: "video/vnd.iptvforum.2dparityfec-1010" }, { mime_type: "video/vnd.iptvforum.2dparityfec-2005" }, { mime_type: "video/vnd.iptvforum.ttsavc" }, { mime_type: "video/vnd.iptvforum.ttsmpeg2" }, { mime_type: "video/vnd.motorola.video" }, { mime_type: "video/vnd.motorola.videop" }, { mime_type: "video/vnd.mpegurl", ext: "mxu m4u" }, { mime_type: "video/vnd.ms-playready.media.pyv", ext: "pyv" }, { mime_type: "video/vnd.nokia.interleaved-multimedia" }, { mime_type: "video/vnd.nokia.videovoip" }, { mime_type: "video/vnd.objectvideo" }, { mime_type: "video/vnd.sealed.mpeg1" }, { mime_type: "video/vnd.sealed.mpeg4" }, { mime_type: "video/vnd.sealed.swf" }, { mime_type: "video/vnd.sealedmedia.softseal.mov" }, { mime_type: "video/vnd.vivo", ext: "viv" }, { mime_type: "video/x-dv", ext: "dv dif" }, { mime_type: "video/x-f4v", ext: "f4v" }, { mime_type: "video/x-fli", ext: "fli" }, { mime_type: "video/x-flv", ext: "flv" }, { mime_type: "video/x-ms-asf", ext: "asf asx" }, { mime_type: "video/x-ms-wm", ext: "wm" }, { mime_type: "video/x-ms-wmv", ext: "wmv" }, { mime_type: "video/x-ms-wmx", ext: "wmx" }, { mime_type: "video/x-ms-wvx", ext: "wvx" }, { mime_type: "video/x-msvideo", ext: "avi" }, { mime_type: "video/x-sgi-movie", ext: "movie" }, { mime_type: "x-conference/x-cooltalk", ext: "ice" }] };
      var ic = Ko("splice");
      var nc = Math.max;
      var ac = Math.min;
      Me({ target: "Array", proto: true, forced: !ic }, { splice: function(e2, t2) {
        var i3, n2, a2, p3, r2, o2, m2 = kt(this), c2 = xe(m2.length), l2 = ge2(e2, c2), s2 = arguments.length;
        if (0 === s2 ? i3 = n2 = 0 : 1 === s2 ? (i3 = 0, n2 = c2 - l2) : (i3 = s2 - 2, n2 = ac(nc(ye2(t2), 0), c2 - l2)), c2 + i3 - n2 > 9007199254740991) throw TypeError("Maximum allowed length exceeded");
        for (a2 = Rn(m2, n2), p3 = 0; p3 < n2; p3++) (r2 = l2 + p3) in m2 && Lp(a2, p3, m2[r2]);
        if (a2.length = n2, i3 < n2) {
          for (p3 = l2; p3 < c2 - n2; p3++) o2 = p3 + i3, (r2 = p3 + n2) in m2 ? m2[o2] = m2[r2] : delete m2[o2];
          for (p3 = c2; p3 > c2 - n2 + i3; p3--) delete m2[p3 - 1];
        } else if (i3 > n2) for (p3 = c2 - n2; p3 > l2; p3--) o2 = p3 + i3 - 1, (r2 = p3 + n2 - 1) in m2 ? m2[o2] = m2[r2] : delete m2[o2];
        for (p3 = 0; p3 < i3; p3++) m2[p3 + l2] = arguments[p3 + 2];
        return m2.length = c2 - n2 + i3, a2;
      } });
      var pc = wm.trim;
      Me({ target: "String", proto: true, forced: (function(e2) {
        return t((function() {
          return !!xm[e2]() || "\u200B\x85\u180E" != "\u200B\x85\u180E"[e2]() || xm[e2].name !== e2;
        }));
      })("trim") }, { trim: function() {
        return pc(this);
      } });
      var rc = !t((function() {
        return Object.isExtensible(Object.preventExtensions({}));
      }));
      var oc = a((function(e2) {
        var t2 = y2.f, i3 = Z2("meta"), n2 = 0, a2 = Object.isExtensible || function() {
          return true;
        }, p3 = function(e3) {
          t2(e3, i3, { value: { objectID: "O" + ++n2, weakData: {} } });
        }, r2 = e2.exports = { REQUIRED: false, fastKey: function(e3, t3) {
          if (!o(e3)) return "symbol" == typeof e3 ? e3 : ("string" == typeof e3 ? "S" : "P") + e3;
          if (!F2(e3, i3)) {
            if (!a2(e3)) return "F";
            if (!t3) return "E";
            p3(e3);
          }
          return e3[i3].objectID;
        }, getWeakData: function(e3, t3) {
          if (!F2(e3, i3)) {
            if (!a2(e3)) return true;
            if (!t3) return false;
            p3(e3);
          }
          return e3[i3].weakData;
        }, onFreeze: function(e3) {
          return rc && r2.REQUIRED && a2(e3) && !F2(e3, i3) && p3(e3), e3;
        } };
        te2[i3] = true;
      })).onFreeze;
      var mc = Object.freeze;
      var cc = t((function() {
        mc(1);
      }));
      Me({ target: "Object", stat: true, forced: cc, sham: !rc }, { freeze: function(e2) {
        return mc && o(e2) ? mc(oc(e2)) : e2;
      } });
      var lc = Object.freeze({ ADDED: "ADDED", QUEUED: "QUEUED", UPLOADING: "UPLOADING", ERROR: "ERROR", DONE: "DONE" });
      var sc = Ko("slice");
      var dc = st("species");
      var uc = [].slice;
      var fc = Math.max;
      function yc(e2, t2, i3, n2, a2, p3, r2) {
        try {
          var o2 = e2[p3](r2), m2 = o2.value;
        } catch (e3) {
          return void i3(e3);
        }
        o2.done ? t2(m2) : Promise.resolve(m2).then(n2, a2);
      }
      Me({ target: "Array", proto: true, forced: !sc }, { slice: function(e2, t2) {
        var i3, n2, a2, p3 = z2(this), r2 = xe(p3.length), m2 = ge2(e2, r2), c2 = ge2(void 0 === t2 ? r2 : t2, r2);
        if (Tn(p3) && ("function" != typeof (i3 = p3.constructor) || i3 !== Array && !Tn(i3.prototype) ? o(i3) && null === (i3 = i3[dc]) && (i3 = void 0) : i3 = void 0, i3 === Array || void 0 === i3)) return uc.call(p3, m2, c2);
        for (n2 = new (void 0 === i3 ? Array : i3)(fc(c2 - m2, 0)), a2 = 0; m2 < c2; m2++, a2++) m2 in p3 && Lp(n2, a2, p3[m2]);
        return n2.length = a2, n2;
      } }), a((function(e2) {
        !(function(t2) {
          var i3, n2 = Object.prototype, a2 = n2.hasOwnProperty, p3 = "function" == typeof Symbol ? Symbol : {}, r2 = p3.iterator || "@@iterator", o2 = p3.asyncIterator || "@@asyncIterator", m2 = p3.toStringTag || "@@toStringTag", c2 = t2.regeneratorRuntime;
          if (c2) e2.exports = c2;
          else {
            (c2 = t2.regeneratorRuntime = e2.exports).wrap = h3;
            var l2 = "suspendedStart", s2 = "suspendedYield", d2 = "executing", u3 = "completed", f2 = {}, y3 = {};
            y3[r2] = function() {
              return this;
            };
            var v2 = Object.getPrototypeOf, x2 = v2 && v2(v2(I3([])));
            x2 && x2 !== n2 && a2.call(x2, r2) && (y3 = x2);
            var _3 = k2.prototype = b3.prototype = Object.create(y3);
            w2.prototype = _3.constructor = k2, k2.constructor = w2, k2[m2] = w2.displayName = "GeneratorFunction", c2.isGeneratorFunction = function(e3) {
              var t3 = "function" == typeof e3 && e3.constructor;
              return !!t3 && (t3 === w2 || "GeneratorFunction" === (t3.displayName || t3.name));
            }, c2.mark = function(e3) {
              return Object.setPrototypeOf ? Object.setPrototypeOf(e3, k2) : (e3.__proto__ = k2, m2 in e3 || (e3[m2] = "GeneratorFunction")), e3.prototype = Object.create(_3), e3;
            }, c2.awrap = function(e3) {
              return { __await: e3 };
            }, A2(E2.prototype), E2.prototype[o2] = function() {
              return this;
            }, c2.AsyncIterator = E2, c2.async = function(e3, t3, i4, n3) {
              var a3 = new E2(h3(e3, t3, i4, n3));
              return c2.isGeneratorFunction(t3) ? a3 : a3.next().then((function(e4) {
                return e4.done ? e4.value : a3.next();
              }));
            }, A2(_3), _3[m2] = "Generator", _3[r2] = function() {
              return this;
            }, _3.toString = function() {
              return "[object Generator]";
            }, c2.keys = function(e3) {
              var t3 = [];
              for (var i4 in e3) t3.push(i4);
              return t3.reverse(), function i5() {
                for (; t3.length; ) {
                  var n3 = t3.pop();
                  if (n3 in e3) return i5.value = n3, i5.done = false, i5;
                }
                return i5.done = true, i5;
              };
            }, c2.values = I3, T3.prototype = { constructor: T3, reset: function(e3) {
              if (this.prev = 0, this.next = 0, this.sent = this._sent = i3, this.done = false, this.delegate = null, this.method = "next", this.arg = i3, this.tryEntries.forEach(O2), !e3) for (var t3 in this) "t" === t3.charAt(0) && a2.call(this, t3) && !isNaN(+t3.slice(1)) && (this[t3] = i3);
            }, stop: function() {
              this.done = true;
              var e3 = this.tryEntries[0].completion;
              if ("throw" === e3.type) throw e3.arg;
              return this.rval;
            }, dispatchException: function(e3) {
              if (this.done) throw e3;
              var t3 = this;
              function n3(n4, a3) {
                return o3.type = "throw", o3.arg = e3, t3.next = n4, a3 && (t3.method = "next", t3.arg = i3), !!a3;
              }
              for (var p4 = this.tryEntries.length - 1; p4 >= 0; --p4) {
                var r3 = this.tryEntries[p4], o3 = r3.completion;
                if ("root" === r3.tryLoc) return n3("end");
                if (r3.tryLoc <= this.prev) {
                  var m3 = a2.call(r3, "catchLoc"), c3 = a2.call(r3, "finallyLoc");
                  if (m3 && c3) {
                    if (this.prev < r3.catchLoc) return n3(r3.catchLoc, true);
                    if (this.prev < r3.finallyLoc) return n3(r3.finallyLoc);
                  } else if (m3) {
                    if (this.prev < r3.catchLoc) return n3(r3.catchLoc, true);
                  } else {
                    if (!c3) throw new Error("try statement without catch or finally");
                    if (this.prev < r3.finallyLoc) return n3(r3.finallyLoc);
                  }
                }
              }
            }, abrupt: function(e3, t3) {
              for (var i4 = this.tryEntries.length - 1; i4 >= 0; --i4) {
                var n3 = this.tryEntries[i4];
                if (n3.tryLoc <= this.prev && a2.call(n3, "finallyLoc") && this.prev < n3.finallyLoc) {
                  var p4 = n3;
                  break;
                }
              }
              p4 && ("break" === e3 || "continue" === e3) && p4.tryLoc <= t3 && t3 <= p4.finallyLoc && (p4 = null);
              var r3 = p4 ? p4.completion : {};
              return r3.type = e3, r3.arg = t3, p4 ? (this.method = "next", this.next = p4.finallyLoc, f2) : this.complete(r3);
            }, complete: function(e3, t3) {
              if ("throw" === e3.type) throw e3.arg;
              return "break" === e3.type || "continue" === e3.type ? this.next = e3.arg : "return" === e3.type ? (this.rval = this.arg = e3.arg, this.method = "return", this.next = "end") : "normal" === e3.type && t3 && (this.next = t3), f2;
            }, finish: function(e3) {
              for (var t3 = this.tryEntries.length - 1; t3 >= 0; --t3) {
                var i4 = this.tryEntries[t3];
                if (i4.finallyLoc === e3) return this.complete(i4.completion, i4.afterLoc), O2(i4), f2;
              }
            }, catch: function(e3) {
              for (var t3 = this.tryEntries.length - 1; t3 >= 0; --t3) {
                var i4 = this.tryEntries[t3];
                if (i4.tryLoc === e3) {
                  var n3 = i4.completion;
                  if ("throw" === n3.type) {
                    var a3 = n3.arg;
                    O2(i4);
                  }
                  return a3;
                }
              }
              throw new Error("illegal catch attempt");
            }, delegateYield: function(e3, t3, n3) {
              return this.delegate = { iterator: I3(e3), resultName: t3, nextLoc: n3 }, "next" === this.method && (this.arg = i3), f2;
            } };
          }
          function h3(e3, t3, i4, n3) {
            var a3 = t3 && t3.prototype instanceof b3 ? t3 : b3, p4 = Object.create(a3.prototype), r3 = new T3(n3 || []);
            return p4._invoke = /* @__PURE__ */ (function(e4, t4, i5) {
              var n4 = l2;
              return function(a4, p5) {
                if (n4 === d2) throw new Error("Generator is already running");
                if (n4 === u3) {
                  if ("throw" === a4) throw p5;
                  return R3();
                }
                for (i5.method = a4, i5.arg = p5; ; ) {
                  var r4 = i5.delegate;
                  if (r4) {
                    var o3 = S3(r4, i5);
                    if (o3) {
                      if (o3 === f2) continue;
                      return o3;
                    }
                  }
                  if ("next" === i5.method) i5.sent = i5._sent = i5.arg;
                  else if ("throw" === i5.method) {
                    if (n4 === l2) throw n4 = u3, i5.arg;
                    i5.dispatchException(i5.arg);
                  } else "return" === i5.method && i5.abrupt("return", i5.arg);
                  n4 = d2;
                  var m3 = g2(e4, t4, i5);
                  if ("normal" === m3.type) {
                    if (n4 = i5.done ? u3 : s2, m3.arg === f2) continue;
                    return { value: m3.arg, done: i5.done };
                  }
                  "throw" === m3.type && (n4 = u3, i5.method = "throw", i5.arg = m3.arg);
                }
              };
            })(e3, i4, r3), p4;
          }
          function g2(e3, t3, i4) {
            try {
              return { type: "normal", arg: e3.call(t3, i4) };
            } catch (e4) {
              return { type: "throw", arg: e4 };
            }
          }
          function b3() {
          }
          function w2() {
          }
          function k2() {
          }
          function A2(e3) {
            ["next", "throw", "return"].forEach((function(t3) {
              e3[t3] = function(e4) {
                return this._invoke(t3, e4);
              };
            }));
          }
          function E2(e3) {
            function t3(i5, n3, p4, r3) {
              var o3 = g2(e3[i5], e3, n3);
              if ("throw" !== o3.type) {
                var m3 = o3.arg, c3 = m3.value;
                return c3 && "object" == typeof c3 && a2.call(c3, "__await") ? Promise.resolve(c3.__await).then((function(e4) {
                  t3("next", e4, p4, r3);
                }), (function(e4) {
                  t3("throw", e4, p4, r3);
                })) : Promise.resolve(c3).then((function(e4) {
                  m3.value = e4, p4(m3);
                }), r3);
              }
              r3(o3.arg);
            }
            var i4;
            this._invoke = function(e4, n3) {
              function a3() {
                return new Promise((function(i5, a4) {
                  t3(e4, n3, i5, a4);
                }));
              }
              return i4 = i4 ? i4.then(a3, a3) : a3();
            };
          }
          function S3(e3, t3) {
            var n3 = e3.iterator[t3.method];
            if (n3 === i3) {
              if (t3.delegate = null, "throw" === t3.method) {
                if (e3.iterator.return && (t3.method = "return", t3.arg = i3, S3(e3, t3), "throw" === t3.method)) return f2;
                t3.method = "throw", t3.arg = new TypeError("The iterator does not provide a 'throw' method");
              }
              return f2;
            }
            var a3 = g2(n3, e3.iterator, t3.arg);
            if ("throw" === a3.type) return t3.method = "throw", t3.arg = a3.arg, t3.delegate = null, f2;
            var p4 = a3.arg;
            return p4 ? p4.done ? (t3[e3.resultName] = p4.value, t3.next = e3.nextLoc, "return" !== t3.method && (t3.method = "next", t3.arg = i3), t3.delegate = null, f2) : p4 : (t3.method = "throw", t3.arg = new TypeError("iterator result is not an object"), t3.delegate = null, f2);
          }
          function j2(e3) {
            var t3 = { tryLoc: e3[0] };
            1 in e3 && (t3.catchLoc = e3[1]), 2 in e3 && (t3.finallyLoc = e3[2], t3.afterLoc = e3[3]), this.tryEntries.push(t3);
          }
          function O2(e3) {
            var t3 = e3.completion || {};
            t3.type = "normal", delete t3.arg, e3.completion = t3;
          }
          function T3(e3) {
            this.tryEntries = [{ tryLoc: "root" }], e3.forEach(j2, this), this.reset(true);
          }
          function I3(e3) {
            if (e3) {
              var t3 = e3[r2];
              if (t3) return t3.call(e3);
              if ("function" == typeof e3.next) return e3;
              if (!isNaN(e3.length)) {
                var n3 = -1, p4 = function t4() {
                  for (; ++n3 < e3.length; ) if (a2.call(e3, n3)) return t4.value = e3[n3], t4.done = false, t4;
                  return t4.value = i3, t4.done = true, t4;
                };
                return p4.next = p4;
              }
            }
            return { next: R3 };
          }
          function R3() {
            return { value: i3, done: true };
          }
        })(/* @__PURE__ */ (function() {
          return this;
        })() || Function("return this")());
      }));
      var vc = t((function() {
        sn(1);
      }));
      function xc(e2) {
        var t2 = e2.config, i3 = e2.items, n2 = function(e3, n3, a3) {
          var p4 = [];
          Object.values(i3.all).filter((function(t3) {
            return t3.upload && t3.upload.id === e3;
          })).forEach((function(e4) {
            e4.status = lc.ERROR, e4.upload.retryErrorCounter ? e4.upload.retryErrorCounter -= 1 : e4.upload.retryErrorCounter = t2.maxRetryError, p4.push(e4.id);
          })), a3(p4, { errorType: n3.type });
        }, a2 = function(e3, t3, i4, n3, a3, p4, o2, m2) {
          var c2 = e3 + t3 + 1, l2 = i4.file.webkitSlice ? i4.file.webkitSlice(e3, c2) : i4.file.slice(e3, c2);
          n3.onloadend = function(s2) {
            s2.target.readyState === FileReader.DONE && (i4.upload.blob = l2, i4.upload.chunkIndex = Math.floor(c2 / t3), i4.upload.nextSlice = c2, i4.upload.chunkStart = e3, i4.upload.sliceSize = t3, i4.upload.reader = n3, r2(m2, [i4], a3, p4, o2));
          }, n3.readAsDataURL(l2);
        }, p3 = function(e3, t3) {
          var n3;
          void 0 !== t3 && Object.values(i3.all).filter((function(t4) {
            return t4.upload.id === e3;
          })).forEach((function(e4) {
            e4.upload.chunking ? (e4.upload.loadedBytes += t3.loaded, e4.upload.progress = 100 * e4.upload.loadedBytes / e4.file.size) : (n3 = 100 * t3.loaded / t3.total, e4.upload.progress = n3);
          }));
        }, r2 = (function() {
          var e3, i4 = (e3 = regeneratorRuntime.mark((function e4(i5, r3, o2, m2, c2) {
            var l2, s2, d2, u3, f2, y3, v2, x2, _3, h3, g2;
            return regeneratorRuntime.wrap((function(e5) {
              for (; ; ) switch (e5.prev = e5.next) {
                case 0:
                  for ((l2 = new XMLHttpRequest()).open(t2.method, t2.url, true), l2.timeout = t2.xhrTimeout, l2.withCredentials = t2.withCredentials, l2.ontimeout = function(e6) {
                    n2(i5, e6, m2);
                  }, l2.onerror = function(e6) {
                    n2(i5, e6, m2);
                  }, s2 = { Accept: "application/json", "Cache-Control": "no-cache", "X-Requested-With": "XMLHttpRequest" }, d2 = Object.keys(s2), u3 = 0; u3 < d2.length; u3 += 1) f2 = d2[u3], l2.setRequestHeader(f2, s2[f2]);
                  if (t2.headers) for (d2 = Object.keys(t2.headers), y3 = 0; y3 < d2.length; y3 += 1) v2 = d2[y3], "string" != typeof (x2 = t2.headers[v2]) && "number" != typeof x2 || l2.setRequestHeader(v2, x2);
                  return (null != l2.upload ? l2.upload : l2).onprogress = function(e6) {
                    return p3(i5, e6);
                  }, _3 = new FormData(), e5.next = 15, c2(Object.values(r3).filter((function(e6) {
                    return e6.upload.id === i5;
                  })), l2, _3);
                case 15:
                  for (h3 = 0; h3 < r3.length; h3 += 1) (g2 = r3[h3]).upload.id === i5 && (g2.upload.chunking ? (_3.set("fileName", g2.file.name), _3.set("chunkIndex", g2.upload.chunkIndex), _3.set(t2.paramName, g2.upload.blob, g2.file.name)) : _3.append(t2.paramName, g2.file, g2.file.name), g2.status = lc.UPLOADING);
                  l2.onload = function(e6) {
                    var t3;
                    if (4 === l2.readyState) {
                      if ("arraybuffer" !== l2.responseType && "blob" !== l2.responseType && (t3 = l2.responseText, l2.getResponseHeader("content-type") && ~l2.getResponseHeader("content-type").indexOf("application/json"))) try {
                        t3 = JSON.parse(t3);
                      } catch (e7) {
                        t3 = "Invalid JSON response from server.";
                      }
                      if (l2.status >= 200 && l2.status < 300) {
                        var p4 = true;
                        Object.values(r3).filter((function(e7) {
                          return e7.upload.id === i5;
                        })).forEach((function(e7) {
                          e7.upload.chunking ? e7.upload.nextSlice < e7.file.size ? (p4 = false, a2(e7.upload.nextSlice, e7.upload.sliceSize, e7, e7.upload.reader, o2, m2, c2, e7.upload.id)) : (e7.status = lc.DONE, e7.upload.progress = 100) : e7.status = lc.DONE;
                        })), true === p4 && o2(r3);
                      } else n2(i5, e6, m2);
                    }
                  }, l2.send(_3);
                case 18:
                case "end":
                  return e5.stop();
              }
            }), e4);
          })), function() {
            var t3 = this, i5 = arguments;
            return new Promise((function(n3, a3) {
              var p4 = e3.apply(t3, i5);
              function r3(e4) {
                yc(p4, n3, a3, r3, o2, "next", e4);
              }
              function o2(e4) {
                yc(p4, n3, a3, r3, o2, "throw", e4);
              }
              r3(void 0);
            }));
          });
          return function(e4, t3, n3, a3, p4) {
            return i4.apply(this, arguments);
          };
        })();
        return { upload: function(e3, i4, n3, a3) {
          for (var p4 = im(), o2 = false, m2 = 0; m2 < e3.length; m2 += 1) {
            var c2 = e3[m2];
            (c2.status === lc.QUEUED || t2.retryOnError && c2.status === lc.ERROR && c2.upload.retryErrorCounter > 0) && (c2.upload.id = p4, o2 = true);
          }
          o2 && r2(p4, e3, i4, n3, a3);
        }, uploadWithChunking: function(e3, i4, n3, p4) {
          var r3 = im();
          e3.upload.id = r3, e3.upload.chunking = true, e3.upload.loadedBytes = 0;
          var o2 = new FileReader(), m2 = e3.file.size / t2.numberOfChunks;
          a2(0, m2, e3, o2, i4, n3, p4, r3);
        } };
      }
      Me({ target: "Object", stat: true, forced: vc }, { keys: function(e2) {
        return sn(kt(e2));
      } }), _t("match", 1, (function(e2, t2, i3) {
        return [function(t3) {
          var i4 = U(this), n2 = null == t3 ? void 0 : t3[e2];
          return void 0 !== n2 ? n2.call(t3, i4) : new RegExp(t3)[e2](String(i4));
        }, function(e3) {
          var n2 = i3(t2, e3, this);
          if (n2.done) return n2.value;
          var a2 = d(e3), p3 = String(this);
          if (!a2.global) return Tt(a2, p3);
          var r2 = a2.unicode;
          a2.lastIndex = 0;
          for (var o2, m2 = [], c2 = 0; null !== (o2 = Tt(a2, p3)); ) {
            var l2 = String(o2[0]);
            m2[c2] = l2, "" === l2 && (a2.lastIndex = wt(p3, xe(a2.lastIndex), r2)), c2++;
          }
          return 0 === c2 ? null : m2;
        }];
      }));
      var _c = [];
      var hc = false;
      function gc(e2) {
        var t2 = function() {
          hc || 0 === _c.length || (hc = true, (function(t3) {
            var i3 = new FileReader();
            i3.addEventListener("load", (function() {
              e2(t3.id, i3.result);
            }), false), i3.readAsDataURL(t3.file);
          })(_c.shift()), hc = false);
        };
        return { enqueueThumbnail: function(e3, i3) {
          (/\.(jpe?g|png|gif)$/i.test(i3.name) || i3.type.match("image.*")) && (_c.push({ id: e3, file: i3 }), setTimeout((function() {
            return t2();
          }), 0));
        } };
      }
      function bc(t2) {
        var i3 = t2.config, n2 = t2.context, a2 = e.reactive({ ids: [], all: {} }), p3 = gc((function(e2, t3) {
          a2.all[e2].thumbnail = t3;
        })).enqueueThumbnail, r2 = (function(t3) {
          var i4 = t3.config, n3 = t3.items, a3 = t3.context, p4 = function t4() {
            var p5 = xc({ config: i4, items: n3 }), r3 = p5.upload, o3 = p5.uploadWithChunking, m3 = Object.values(n3.all).filter((function(e2) {
              return e2.status === lc.UPLOADING;
            })).length;
            if (!(m3 >= i4.parallelUpload)) {
              var c2 = Object.values(n3.all).filter((function(e2) {
                return e2.status === lc.QUEUED || e2.status === lc.ERROR && i4.retryOnError && e2.upload.retryErrorCounter > 0;
              }));
              if (!(c2.length <= 0)) {
                var l2 = function(t5, i5, n4) {
                  a3.emit("sending", e.readonly(t5.map((function(e2) {
                    return e2.file;
                  }))), i5, n4);
                }, s2 = function(n4) {
                  i4.autoUpload && t4(), a3.emit("uploaded", e.readonly(n4.map((function(e2) {
                    return e2.file;
                  }))));
                }, d2 = function(e2, n4) {
                  i4.autoUpload && t4(), a3.emit("error-upload", w({ ids: A(e2) }, n4));
                }, u3 = m3;
                if (i4.chunking) o3(c2.shift(), s2, d2, l2);
                else if (i4.multipleUpload) r3(c2.slice(0, i4.parallelUpload - m3), s2, d2, l2);
                else for (; u3 <= i4.parallelUpload; ) {
                  if (c2.length <= 0) return;
                  r3([c2.shift()], s2, d2, l2), u3 += 1;
                }
              }
            }
          };
          return { enqueueFile: function(e2) {
            if (-1 === n3.ids.findIndex((function(t5) {
              return t5 === e2;
            }))) throw new Error("File with ".concat(e2, " does not exist "));
            var t4 = n3.all[e2];
            if (t4.status !== lc.ADDED || true !== t4.accepted) throw new Error("File ".concat(e2, " already in ").concat(e2.status, " state"));
            t4.status = lc.QUEUED, i4.autoUpload && setTimeout((function() {
              return p4();
            }), 0);
          }, processQueue: p4 };
        })({ config: i3, items: a2, context: n2 }), o2 = r2.enqueueFile, m2 = r2.processQueue;
        return { itemManager: { getItems: function() {
          return a2;
        }, removeFile: function(e2) {
          var t3 = a2.ids.findIndex((function(t4) {
            return t4 === e2;
          }));
          if (!(t3 < 0)) {
            a2.ids.splice(t3, 1);
            var i4 = a2.all[e2];
            delete a2.all[e2], n2.emit("removed-file", { file: i4.file, status: i4.status, id: e2 });
          }
        }, addFile: function(e2, t3) {
          i3.maxFileSize && t3.size > i3.maxFileSize ? n2.emit("error-add", { files: [t3], error: "MAX_FILE_SIZE" }) : !(function(e3) {
            if (null === i3.accepts || 0 === i3.accepts.length) return true;
            var t4 = e3.type, n3 = -1 !== i3.accepts.findIndex((function(e4) {
              return e4.trim() === t4.trim();
            }));
            if (!n3) {
              var a3 = e3.name.split(".");
              if (a3.length > 1) {
                var p4 = a3[a3.length - 1], r3 = tc.data.filter((function(e4) {
                  return e4.ext && !!e4.ext.split(/\s/).find((function(e5) {
                    return p4 === e5;
                  }));
                })).map((function(e4) {
                  return e4.mime_type;
                }));
                n3 = !!i3.accepts.find((function(e4) {
                  return r3.find((function(t5) {
                    return t5 === e4;
                  }));
                }));
              }
            }
            return n3;
          })(t3) ? n2.emit("error-add", { files: [t3], error: "INVALID_TYPE" }) : i3.maxFiles && a2.ids.length + 1 > i3.maxFiles ? n2.emit("error-add", { files: [t3], error: "MAX_FILE" }) : (a2.ids.push(e2), a2.all[e2] = { file: t3, thumbnail: null, upload: { progress: 0 }, status: lc.ADDED, accepted: true, id: e2 }, p3(e2, t3), o2(e2), n2.emit("added-file", { file: a2.all[e2].file, id: e2 }));
        }, processQueue: m2 } };
      }
      var wc = e.defineComponent({ name: "DropZone", emits: ["config-update", "added-file", "removed-file", "error-upload", "uploaded", "sending", "error-add"], props: w(w({}, Nm), {}, { dropzoneRef: { default: "dropzone" }, dropzoneClassName: { default: "dropzone__box" }, dropzoneMessageClassName: { default: "dropzone__message--style" }, dropzoneItemClassName: { default: "dropzone__item--style" }, dropzoneDetailsClassName: { default: "dropzone__details--style" } }), setup: function(t2, i3) {
        var n2 = e.ref(), a2 = e.ref(false), p3 = fm(), r2 = p3.initHiddenFileInput, o2 = p3.destroyHiddenFileInput, m2 = p3.setMultiple, c2 = (function(t3) {
          var i4 = t3.props, n3 = t3.context, a3 = t3.setMultiple, p4 = e.reactive({ paramName: i4.paramName, headers: i4.headers, xhrTimeout: i4.xhrTimeout, withCredentials: i4.withCredentials, url: i4.url ? i4.url : null !== window.URL ? window.URL : window.webkitURL, method: i4.method, maxFiles: i4.maxFiles, maxFileSize: i4.maxFileSize, autoUpload: i4.uploadOnDrop, parallelUpload: i4.parallelUpload, hiddenInputContainer: i4.hiddenInputContainer, clickable: i4.clickable, acceptedFiles: i4.acceptedFiles, retryOnError: i4.retryOnError, maxRetryError: 3, chunking: i4.chunking, numberOfChunks: i4.numberOfChunks, multipleUpload: !i4.chunking && i4.multipleUpload, dropzoneMessageClassName: i4.dropzoneMessageClassName, accepts: [] }), r3 = function() {
            var e2 = [];
            null !== i4.acceptedFiles && i4.acceptedFiles.forEach((function(t4) {
              tc.data.filter((function(e3) {
                return e3.ext && !!e3.ext.split(/\s/).find((function(e4) {
                  return t4 === e4;
                })) || e3.mime_type.startsWith(t4);
              })).forEach((function(t5) {
                e2.push(t5.mime_type), t5.ext && e2.push.apply(e2, A(t5.ext.split(/\s/).map((function(e3) {
                  return ".".concat(e3);
                }))));
              }));
            })), p4.accepts = [].concat(e2);
          }, o3 = function() {
            n3.emit("config-update", w({}, p4));
          };
          return r3(), o3(), e.watch((function() {
            return i4.paramName;
          }), (function(e2) {
            p4.paramName !== e2 && (p4.paramName = e2, o3());
          })), e.watch((function() {
            return i4.acceptedFiles;
          }), (function(e2) {
            p4.acceptedFiles.every((function(t4) {
              return e2.includes(t4);
            })) || (p4.acceptedFiles = A(e2), r3(), o3());
          })), e.watch((function() {
            return i4.headers;
          }), (function(e2) {
            p4.headers !== e2 && (p4.headers = e2, o3());
          })), e.watch((function() {
            return i4.xhrTimeout;
          }), (function(e2) {
            p4.xhrTimeout !== e2 && (p4.xhrTimeout = e2, o3());
          })), e.watch((function() {
            return i4.withCredentials;
          }), (function(e2) {
            p4.withCredentials !== e2 && (p4.withCredentials = e2, o3());
          })), e.watch((function() {
            return i4.method;
          }), (function(e2) {
            p4.method !== e2 && (p4.method = e2, o3());
          })), e.watch((function() {
            return i4.maxFiles;
          }), (function(e2) {
            p4.maxFiles !== e2 && (p4.maxFiles = e2, o3());
          })), e.watch((function() {
            return i4.maxFileSize;
          }), (function(e2) {
            p4.maxFileSize !== e2 && (p4.maxFileSize = e2, o3(), p4.maxFileSize > 1 ? a3(true) : a3(false));
          })), e.watch((function() {
            return i4.hiddenInputContainer;
          }), (function(e2) {
            p4.hiddenInputContainer !== e2 && (p4.hiddenInputContainer = e2, o3());
          })), e.watch((function() {
            return i4.clickable;
          }), (function(e2) {
            p4.hiddenInputContainer !== e2 && (p4.clickable = e2, o3());
          })), e.watch((function() {
            return i4.uploadOnDrop;
          }), (function(e2) {
            p4.uploadOnDrop !== e2 && (p4.autoUpload = e2, o3());
          })), e.watch((function() {
            return i4.parallelUpload;
          }), (function(e2) {
            p4.parallelUpload !== e2 && (p4.parallelUpload = e2, o3());
          })), e.watch((function() {
            return i4.retryOnError;
          }), (function(e2) {
            p4.retryOnError !== e2 && (p4.retryOnError = e2, o3());
          })), e.watch((function() {
            return i4.maxRetryError;
          }), (function(e2) {
            p4.maxRetryError !== e2 && (p4.maxRetryError = e2, o3());
          })), e.watch((function() {
            return i4.multipleUpload;
          }), (function(e2) {
            p4.multipleUpload !== e2 && (p4.multipleUpload = !p4.chunking && e2, o3());
          })), e.watch((function() {
            return i4.numberOfChunks;
          }), (function(e2) {
            p4.numberOfChunks !== e2 && (p4.numberOfChunks = e2, o3());
          })), e.watch((function() {
            return i4.chunking;
          }), (function(e2) {
            p4.chunking !== e2 && (p4.chunking = e2, p4.multipleUpload = !e2 && p4.multipleUpload, o3());
          })), { config: p4 };
        })({ props: t2, context: i3, setMultiple: m2 }).config, l2 = bc({ config: c2, context: i3 }).itemManager, s2 = mm({ itemManager: l2 }), d2 = s2.handleDragOver, u3 = s2.onDrop;
        return e.watch((function() {
          return l2.getItems();
        }), (function(t3) {
          0 === t3.ids.length && e.nextTick((function() {
            o2(), r2({ config: c2, dropzone: n2, itemManager: l2 });
          }));
        }), { deep: true }), e.watch((function() {
          return t2.clickable;
        }), (function(t3) {
          t3 || e.nextTick((function() {
            o2();
          }));
        }), { deep: true }), e.onMounted((function() {
          var e2;
          a2.value = ("draggable" in (e2 = document.createElement("div")) || "ondragstart" in e2 && "ondrop" in e2) && "FormData" in window && "FileReader" in window, r2({ config: c2, dropzone: n2, itemManager: l2 });
        })), e.onUnmounted((function() {
          o2();
        })), w(w({}, e.toRefs(l2.getItems())), {}, { accepts: c2.accepts, onDrop: u3, handleDragOver: d2, removeFile: l2.removeFile, filesize: om, processQueue: l2.processQueue, dropzone: n2 });
      } });
      var kc = e.createTextVNode("Drop here");
      var Ac = { class: "dropzone__item-thumbnail" };
      var Ec = { class: "dropzone__item-controls" };
      var Sc = e.createVNode("i", { class: "gg-close" }, null, -1);
      var jc = { class: "dropzone__progress" };
      var Oc = { class: "dropzone__success-mark" };
      var Tc = e.createVNode("i", { class: "gg-check-o" }, null, -1);
      var Ic = { class: "dropzone__error-mark" };
      var Rc = e.createVNode("i", { class: "gg-danger" }, null, -1);
      var Lc = { class: "dropzone__file-size" };
      var Uc = { class: "dropzone__filename" };
      wc.render = function(t2, i3, n2, a2, p3, r2) {
        return e.openBlock(), e.createBlock("form", { ref: t2.dropzoneRef, class: ["dropzone", [t2.dropzoneClassName]], onDrop: i3[1] || (i3[1] = function() {
          return t2.onDrop && t2.onDrop.apply(t2, arguments);
        }), onDragover: i3[2] || (i3[2] = function() {
          return t2.handleDragOver && t2.handleDragOver.apply(t2, arguments);
        }) }, [0 === t2.ids.length ? (e.openBlock(), e.createBlock("div", { key: 0, class: ["dropzone__message", [t2.dropzoneMessageClassName]] }, [e.renderSlot(t2.$slots, "message", {}, (function() {
          return [kc];
        }))], 2)) : e.createCommentVNode("v-if", true), (e.openBlock(true), e.createBlock(e.Fragment, null, e.renderList(t2.all, (function(i4, n3) {
          return e.openBlock(), e.createBlock("div", { class: ["dropzone__item", [{ "dropzone--has-thumbnail": !!i4.thumbnail, "dropzone--added": "ADDED" === i4.status, "dropzone--processing": "UPLOADING" === i4.status, "dropzone--success": "DONE" === i4.status, "dropzone--has-error": "ERROR" === i4.status }, t2.dropzoneItemClassName]], key: n3 }, [e.createVNode("div", Ac, [i4.thumbnail ? (e.openBlock(), e.createBlock("img", { key: 0, src: i4.thumbnail }, null, 8, ["src"])) : e.createCommentVNode("v-if", true)]), e.createVNode("div", Ec, [e.createVNode("div", { class: "dropzone__item-control", onClick: function(e2) {
            return t2.removeFile(n3);
          } }, [e.renderSlot(t2.$slots, "remove", {}, (function() {
            return [Sc];
          }))], 8, ["onClick"])]), e.createVNode("div", jc, [e.createVNode("progress", { class: "dropzone__progress-bar", max: "100", value: i4.upload.progress }, null, 8, ["value"])]), e.createVNode("div", Oc, [e.renderSlot(t2.$slots, "success", {}, (function() {
            return [Tc];
          }))]), e.createVNode("div", Ic, [e.renderSlot(t2.$slots, "error", {}, (function() {
            return [Rc];
          }))]), e.createVNode("div", { class: ["dropzone__details", [t2.dropzoneDetailsClassName]] }, [e.createVNode("div", Lc, [e.createVNode("span", { innerHTML: t2.filesize(i4.file.size) }, null, 8, ["innerHTML"])]), e.createVNode("div", Uc, [e.createVNode("span", null, e.toDisplayString(i4.file.name), 1)])], 2)], 2);
        })), 128))], 34);
      }, wc.__file = "src/DropZone.vue";
      var zc = function(e2) {
        e2.component(wc.name, wc);
      };
      "undefined" != typeof window && window.Vue && zc(window.Vue), wc.install = zc, module.exports = wc;
    }
  });

  // node_modules/dropzone-vue/dist/dropzone-vue.common.css
  var init_dropzone_vue_common = __esm({
    "node_modules/dropzone-vue/dist/dropzone-vue.common.css"() {
    }
  });

  // node_modules/@ckpack/vue-color/libs/defaultConfig.js
  var prefix;
  var init_defaultConfig = __esm({
    "node_modules/@ckpack/vue-color/libs/defaultConfig.js"() {
      prefix = "";
    }
  });

  // node_modules/@ckpack/vue-color/libs/style-inject.es-746bb8ed.js
  function styleInject(css, ref2) {
    if (ref2 === void 0) ref2 = {};
    var insertAt = ref2.insertAt;
    if (!css || typeof document === "undefined") {
      return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
      if (head.firstChild) {
        head.insertBefore(style, head.firstChild);
      } else {
        head.appendChild(style);
      }
    } else {
      head.appendChild(style);
    }
    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  }
  var init_style_inject_es_746bb8ed = __esm({
    "node_modules/@ckpack/vue-color/libs/style-inject.es-746bb8ed.js"() {
    }
  });

  // node_modules/@ckpack/vue-color/libs/utils/compoent.js
  var install2;
  var init_compoent = __esm({
    "node_modules/@ckpack/vue-color/libs/utils/compoent.js"() {
      init_defaultConfig();
      install2 = function(app, options) {
        const { componentPrefix = prefix } = options || {};
        app.component(`${componentPrefix}${this.name}`, this);
      };
    }
  });

  // node_modules/@ckpack/vue-color/libs/components/checkboard/index.js
  function renderCheckboard(c1, c2, size) {
    if (typeof document === "undefined")
      return null;
    const canvas = document.createElement("canvas");
    canvas.width = canvas.height = size * 2;
    const ctx = canvas.getContext("2d");
    if (!ctx)
      return null;
    ctx.fillStyle = c1;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = c2;
    ctx.fillRect(0, 0, size, size);
    ctx.translate(size, size);
    ctx.fillRect(0, 0, size, size);
    return canvas.toDataURL();
  }
  function getCheckboard(c1, c2, size) {
    const key = `${c1},${c2},${size}`;
    if (_checkboardCache[key])
      return _checkboardCache[key];
    const checkboard = renderCheckboard(c1, c2, size);
    _checkboardCache[key] = checkboard;
    return checkboard;
  }
  function render36(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock(
      "div",
      {
        class: "vc-checkerboard",
        style: normalizeStyle($options.bgStyle)
      },
      null,
      4
      /* STYLE */
    );
  }
  var _checkboardCache, script, css_248z;
  var init_checkboard = __esm({
    "node_modules/@ckpack/vue-color/libs/components/checkboard/index.js"() {
      init_vue_esm_bundler();
      init_style_inject_es_746bb8ed();
      init_compoent();
      _checkboardCache = {};
      script = {
        name: "Checkboard",
        props: {
          size: {
            type: [Number, String],
            default: 8
          },
          white: {
            type: String,
            default: "#fff"
          },
          grey: {
            type: String,
            default: "#e6e6e6"
          }
        },
        computed: {
          bgStyle() {
            return {
              "background-image": `url(${getCheckboard(this.white, this.grey, this.size)})`
            };
          }
        }
      };
      css_248z = ".vc-checkerboard{background-size:contain;bottom:0;left:0;position:absolute;right:0;top:0}";
      styleInject(css_248z);
      script.render = render36;
      script.__file = "src/components/checkboard/checkboard.vue";
      script.install = install2;
    }
  });

  // node_modules/@ckpack/vue-color/libs/components/alpha/index.js
  function render37(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Checkboard = resolveComponent("Checkboard");
    return openBlock(), createElementBlock("div", _hoisted_157, [
      createBaseVNode("div", _hoisted_240, [
        createVNode(_component_Checkboard)
      ]),
      createBaseVNode(
        "div",
        {
          class: "vc-alpha-gradient",
          style: normalizeStyle({ background: $options.gradientColor })
        },
        null,
        4
        /* STYLE */
      ),
      createBaseVNode(
        "div",
        {
          ref: "container",
          class: "vc-alpha-container",
          onMousedown: _cache[0] || (_cache[0] = (...args) => $options.handleMouseDown && $options.handleMouseDown(...args)),
          onTouchmove: _cache[1] || (_cache[1] = (...args) => $options.handleChange && $options.handleChange(...args)),
          onTouchstart: _cache[2] || (_cache[2] = (...args) => $options.handleChange && $options.handleChange(...args))
        },
        [
          createBaseVNode(
            "div",
            {
              class: "vc-alpha-pointer",
              style: normalizeStyle({ left: `${$options.colors.a * 100}%` })
            },
            _hoisted_425,
            4
            /* STYLE */
          )
        ],
        544
        /* HYDRATE_EVENTS, NEED_PATCH */
      )
    ]);
  }
  var script2, _hoisted_157, _hoisted_240, _hoisted_329, _hoisted_425, css_248z2;
  var init_alpha = __esm({
    "node_modules/@ckpack/vue-color/libs/components/alpha/index.js"() {
      init_checkboard();
      init_vue_esm_bundler();
      init_style_inject_es_746bb8ed();
      init_compoent();
      script2 = {
        name: "Alpha",
        components: {
          Checkboard: script
        },
        props: {
          value: Object,
          onChange: Function
        },
        computed: {
          colors() {
            return this.value;
          },
          gradientColor() {
            const { rgba } = this.colors;
            const rgbStr = [rgba.r, rgba.g, rgba.b].join(",");
            return `linear-gradient(to right, rgba(${rgbStr}, 0) 0%, rgba(${rgbStr}, 1) 100%)`;
          }
        },
        methods: {
          handleChange(e, skip) {
            !skip && e.preventDefault();
            const { container } = this.$refs;
            if (!container) {
              return;
            }
            const containerWidth = container.clientWidth;
            const xOffset = container.getBoundingClientRect().left + window.pageXOffset;
            const pageX = e.pageX || (e.touches ? e.touches[0].pageX : 0);
            const left = pageX - xOffset;
            let a;
            if (left < 0)
              a = 0;
            else if (left > containerWidth)
              a = 1;
            else
              a = Math.round(left * 100 / containerWidth) / 100;
            if (this.colors.a !== a) {
              this.$emit("change", {
                h: this.colors.hsl.h,
                s: this.colors.hsl.s,
                l: this.colors.hsl.l,
                a,
                source: "rgba"
              });
            }
          },
          handleMouseDown(e) {
            this.handleChange(e, true);
            window.addEventListener("mousemove", this.handleChange);
            window.addEventListener("mouseup", this.handleMouseUp);
          },
          handleMouseUp() {
            this.unbindEventListeners();
          },
          unbindEventListeners() {
            window.removeEventListener("mousemove", this.handleChange);
            window.removeEventListener("mouseup", this.handleMouseUp);
          }
        }
      };
      _hoisted_157 = { class: "vc-alpha" };
      _hoisted_240 = { class: "vc-alpha-checkboard-wrap" };
      _hoisted_329 = /* @__PURE__ */ createBaseVNode(
        "div",
        { class: "vc-alpha-picker" },
        null,
        -1
        /* HOISTED */
      );
      _hoisted_425 = [
        _hoisted_329
      ];
      css_248z2 = ".vc-alpha,.vc-alpha-checkboard-wrap{bottom:0;left:0;position:absolute;right:0;top:0}.vc-alpha-checkboard-wrap{overflow:hidden}.vc-alpha-gradient{bottom:0;left:0;position:absolute;right:0;top:0}.vc-alpha-container{cursor:pointer;height:100%;margin:0 3px;position:relative;z-index:2}.vc-alpha-pointer{position:absolute;z-index:2}.vc-alpha-picker{background:#fff;border-radius:1px;box-shadow:0 0 2px rgba(0,0,0,.6);cursor:pointer;height:8px;margin-top:1px;transform:translateX(-2px);width:4px}";
      styleInject(css_248z2);
      script2.render = render37;
      script2.__file = "src/components/alpha/alpha.vue";
      script2.install = install2;
    }
  });

  // node_modules/@ctrl/tinycolor/dist/module/util.js
  function bound01(n, max) {
    if (isOnePointZero(n)) {
      n = "100%";
    }
    var isPercent = isPercentage(n);
    n = max === 360 ? n : Math.min(max, Math.max(0, parseFloat(n)));
    if (isPercent) {
      n = parseInt(String(n * max), 10) / 100;
    }
    if (Math.abs(n - max) < 1e-6) {
      return 1;
    }
    if (max === 360) {
      n = (n < 0 ? n % max + max : n % max) / parseFloat(String(max));
    } else {
      n = n % max / parseFloat(String(max));
    }
    return n;
  }
  function clamp01(val) {
    return Math.min(1, Math.max(0, val));
  }
  function isOnePointZero(n) {
    return typeof n === "string" && n.indexOf(".") !== -1 && parseFloat(n) === 1;
  }
  function isPercentage(n) {
    return typeof n === "string" && n.indexOf("%") !== -1;
  }
  function boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) {
      a = 1;
    }
    return a;
  }
  function convertToPercentage(n) {
    if (n <= 1) {
      return "".concat(Number(n) * 100, "%");
    }
    return n;
  }
  function pad2(c) {
    return c.length === 1 ? "0" + c : String(c);
  }
  var init_util2 = __esm({
    "node_modules/@ctrl/tinycolor/dist/module/util.js"() {
    }
  });

  // node_modules/@ctrl/tinycolor/dist/module/conversion.js
  function rgbToRgb(r, g, b2) {
    return {
      r: bound01(r, 255) * 255,
      g: bound01(g, 255) * 255,
      b: bound01(b2, 255) * 255
    };
  }
  function rgbToHsl(r, g, b2) {
    r = bound01(r, 255);
    g = bound01(g, 255);
    b2 = bound01(b2, 255);
    var max = Math.max(r, g, b2);
    var min = Math.min(r, g, b2);
    var h2 = 0;
    var s = 0;
    var l = (max + min) / 2;
    if (max === min) {
      s = 0;
      h2 = 0;
    } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h2 = (g - b2) / d + (g < b2 ? 6 : 0);
          break;
        case g:
          h2 = (b2 - r) / d + 2;
          break;
        case b2:
          h2 = (r - g) / d + 4;
          break;
        default:
          break;
      }
      h2 /= 6;
    }
    return { h: h2, s, l };
  }
  function hue2rgb(p2, q2, t) {
    if (t < 0) {
      t += 1;
    }
    if (t > 1) {
      t -= 1;
    }
    if (t < 1 / 6) {
      return p2 + (q2 - p2) * (6 * t);
    }
    if (t < 1 / 2) {
      return q2;
    }
    if (t < 2 / 3) {
      return p2 + (q2 - p2) * (2 / 3 - t) * 6;
    }
    return p2;
  }
  function hslToRgb(h2, s, l) {
    var r;
    var g;
    var b2;
    h2 = bound01(h2, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);
    if (s === 0) {
      g = l;
      b2 = l;
      r = l;
    } else {
      var q2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p2 = 2 * l - q2;
      r = hue2rgb(p2, q2, h2 + 1 / 3);
      g = hue2rgb(p2, q2, h2);
      b2 = hue2rgb(p2, q2, h2 - 1 / 3);
    }
    return { r: r * 255, g: g * 255, b: b2 * 255 };
  }
  function rgbToHsv(r, g, b2) {
    r = bound01(r, 255);
    g = bound01(g, 255);
    b2 = bound01(b2, 255);
    var max = Math.max(r, g, b2);
    var min = Math.min(r, g, b2);
    var h2 = 0;
    var v = max;
    var d = max - min;
    var s = max === 0 ? 0 : d / max;
    if (max === min) {
      h2 = 0;
    } else {
      switch (max) {
        case r:
          h2 = (g - b2) / d + (g < b2 ? 6 : 0);
          break;
        case g:
          h2 = (b2 - r) / d + 2;
          break;
        case b2:
          h2 = (r - g) / d + 4;
          break;
        default:
          break;
      }
      h2 /= 6;
    }
    return { h: h2, s, v };
  }
  function hsvToRgb(h2, s, v) {
    h2 = bound01(h2, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);
    var i2 = Math.floor(h2);
    var f = h2 - i2;
    var p2 = v * (1 - s);
    var q2 = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    var mod = i2 % 6;
    var r = [v, q2, p2, p2, t, v][mod];
    var g = [t, v, v, q2, p2, p2][mod];
    var b2 = [p2, p2, t, v, v, q2][mod];
    return { r: r * 255, g: g * 255, b: b2 * 255 };
  }
  function rgbToHex(r, g, b2, allow3Char) {
    var hex = [
      pad2(Math.round(r).toString(16)),
      pad2(Math.round(g).toString(16)),
      pad2(Math.round(b2).toString(16))
    ];
    if (allow3Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1))) {
      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }
    return hex.join("");
  }
  function rgbaToHex(r, g, b2, a, allow4Char) {
    var hex = [
      pad2(Math.round(r).toString(16)),
      pad2(Math.round(g).toString(16)),
      pad2(Math.round(b2).toString(16)),
      pad2(convertDecimalToHex(a))
    ];
    if (allow4Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1)) && hex[3].startsWith(hex[3].charAt(1))) {
      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }
    return hex.join("");
  }
  function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
  }
  function convertHexToDecimal(h2) {
    return parseIntFromHex(h2) / 255;
  }
  function parseIntFromHex(val) {
    return parseInt(val, 16);
  }
  function numberInputToObject(color) {
    return {
      r: color >> 16,
      g: (color & 65280) >> 8,
      b: color & 255
    };
  }
  var init_conversion = __esm({
    "node_modules/@ctrl/tinycolor/dist/module/conversion.js"() {
      init_util2();
    }
  });

  // node_modules/@ctrl/tinycolor/dist/module/css-color-names.js
  var names;
  var init_css_color_names = __esm({
    "node_modules/@ctrl/tinycolor/dist/module/css-color-names.js"() {
      names = {
        aliceblue: "#f0f8ff",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        aquamarine: "#7fffd4",
        azure: "#f0ffff",
        beige: "#f5f5dc",
        bisque: "#ffe4c4",
        black: "#000000",
        blanchedalmond: "#ffebcd",
        blue: "#0000ff",
        blueviolet: "#8a2be2",
        brown: "#a52a2a",
        burlywood: "#deb887",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        cornflowerblue: "#6495ed",
        cornsilk: "#fff8dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkgrey: "#a9a9a9",
        darkkhaki: "#bdb76b",
        darkmagenta: "#8b008b",
        darkolivegreen: "#556b2f",
        darkorange: "#ff8c00",
        darkorchid: "#9932cc",
        darkred: "#8b0000",
        darksalmon: "#e9967a",
        darkseagreen: "#8fbc8f",
        darkslateblue: "#483d8b",
        darkslategray: "#2f4f4f",
        darkslategrey: "#2f4f4f",
        darkturquoise: "#00ced1",
        darkviolet: "#9400d3",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        dimgray: "#696969",
        dimgrey: "#696969",
        dodgerblue: "#1e90ff",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        forestgreen: "#228b22",
        fuchsia: "#ff00ff",
        gainsboro: "#dcdcdc",
        ghostwhite: "#f8f8ff",
        goldenrod: "#daa520",
        gold: "#ffd700",
        gray: "#808080",
        green: "#008000",
        greenyellow: "#adff2f",
        grey: "#808080",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        indianred: "#cd5c5c",
        indigo: "#4b0082",
        ivory: "#fffff0",
        khaki: "#f0e68c",
        lavenderblush: "#fff0f5",
        lavender: "#e6e6fa",
        lawngreen: "#7cfc00",
        lemonchiffon: "#fffacd",
        lightblue: "#add8e6",
        lightcoral: "#f08080",
        lightcyan: "#e0ffff",
        lightgoldenrodyellow: "#fafad2",
        lightgray: "#d3d3d3",
        lightgreen: "#90ee90",
        lightgrey: "#d3d3d3",
        lightpink: "#ffb6c1",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        lightskyblue: "#87cefa",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        lightsteelblue: "#b0c4de",
        lightyellow: "#ffffe0",
        lime: "#00ff00",
        limegreen: "#32cd32",
        linen: "#faf0e6",
        magenta: "#ff00ff",
        maroon: "#800000",
        mediumaquamarine: "#66cdaa",
        mediumblue: "#0000cd",
        mediumorchid: "#ba55d3",
        mediumpurple: "#9370db",
        mediumseagreen: "#3cb371",
        mediumslateblue: "#7b68ee",
        mediumspringgreen: "#00fa9a",
        mediumturquoise: "#48d1cc",
        mediumvioletred: "#c71585",
        midnightblue: "#191970",
        mintcream: "#f5fffa",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        navajowhite: "#ffdead",
        navy: "#000080",
        oldlace: "#fdf5e6",
        olive: "#808000",
        olivedrab: "#6b8e23",
        orange: "#ffa500",
        orangered: "#ff4500",
        orchid: "#da70d6",
        palegoldenrod: "#eee8aa",
        palegreen: "#98fb98",
        paleturquoise: "#afeeee",
        palevioletred: "#db7093",
        papayawhip: "#ffefd5",
        peachpuff: "#ffdab9",
        peru: "#cd853f",
        pink: "#ffc0cb",
        plum: "#dda0dd",
        powderblue: "#b0e0e6",
        purple: "#800080",
        rebeccapurple: "#663399",
        red: "#ff0000",
        rosybrown: "#bc8f8f",
        royalblue: "#4169e1",
        saddlebrown: "#8b4513",
        salmon: "#fa8072",
        sandybrown: "#f4a460",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        sienna: "#a0522d",
        silver: "#c0c0c0",
        skyblue: "#87ceeb",
        slateblue: "#6a5acd",
        slategray: "#708090",
        slategrey: "#708090",
        snow: "#fffafa",
        springgreen: "#00ff7f",
        steelblue: "#4682b4",
        tan: "#d2b48c",
        teal: "#008080",
        thistle: "#d8bfd8",
        tomato: "#ff6347",
        turquoise: "#40e0d0",
        violet: "#ee82ee",
        wheat: "#f5deb3",
        white: "#ffffff",
        whitesmoke: "#f5f5f5",
        yellow: "#ffff00",
        yellowgreen: "#9acd32"
      };
    }
  });

  // node_modules/@ctrl/tinycolor/dist/module/format-input.js
  function inputToRGB(color) {
    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color === "string") {
      color = stringInputToObject(color);
    }
    if (typeof color === "object") {
      if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
        rgb = rgbToRgb(color.r, color.g, color.b);
        ok = true;
        format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
        s = convertToPercentage(color.s);
        v = convertToPercentage(color.v);
        rgb = hsvToRgb(color.h, s, v);
        ok = true;
        format = "hsv";
      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
        s = convertToPercentage(color.s);
        l = convertToPercentage(color.l);
        rgb = hslToRgb(color.h, s, l);
        ok = true;
        format = "hsl";
      }
      if (Object.prototype.hasOwnProperty.call(color, "a")) {
        a = color.a;
      }
    }
    a = boundAlpha(a);
    return {
      ok,
      format: color.format || format,
      r: Math.min(255, Math.max(rgb.r, 0)),
      g: Math.min(255, Math.max(rgb.g, 0)),
      b: Math.min(255, Math.max(rgb.b, 0)),
      a
    };
  }
  function stringInputToObject(color) {
    color = color.trim().toLowerCase();
    if (color.length === 0) {
      return false;
    }
    var named = false;
    if (names[color]) {
      color = names[color];
      named = true;
    } else if (color === "transparent") {
      return { r: 0, g: 0, b: 0, a: 0, format: "name" };
    }
    var match = matchers.rgb.exec(color);
    if (match) {
      return { r: match[1], g: match[2], b: match[3] };
    }
    match = matchers.rgba.exec(color);
    if (match) {
      return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    match = matchers.hsl.exec(color);
    if (match) {
      return { h: match[1], s: match[2], l: match[3] };
    }
    match = matchers.hsla.exec(color);
    if (match) {
      return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    match = matchers.hsv.exec(color);
    if (match) {
      return { h: match[1], s: match[2], v: match[3] };
    }
    match = matchers.hsva.exec(color);
    if (match) {
      return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    match = matchers.hex8.exec(color);
    if (match) {
      return {
        r: parseIntFromHex(match[1]),
        g: parseIntFromHex(match[2]),
        b: parseIntFromHex(match[3]),
        a: convertHexToDecimal(match[4]),
        format: named ? "name" : "hex8"
      };
    }
    match = matchers.hex6.exec(color);
    if (match) {
      return {
        r: parseIntFromHex(match[1]),
        g: parseIntFromHex(match[2]),
        b: parseIntFromHex(match[3]),
        format: named ? "name" : "hex"
      };
    }
    match = matchers.hex4.exec(color);
    if (match) {
      return {
        r: parseIntFromHex(match[1] + match[1]),
        g: parseIntFromHex(match[2] + match[2]),
        b: parseIntFromHex(match[3] + match[3]),
        a: convertHexToDecimal(match[4] + match[4]),
        format: named ? "name" : "hex8"
      };
    }
    match = matchers.hex3.exec(color);
    if (match) {
      return {
        r: parseIntFromHex(match[1] + match[1]),
        g: parseIntFromHex(match[2] + match[2]),
        b: parseIntFromHex(match[3] + match[3]),
        format: named ? "name" : "hex"
      };
    }
    return false;
  }
  function isValidCSSUnit(color) {
    return Boolean(matchers.CSS_UNIT.exec(String(color)));
  }
  var CSS_INTEGER, CSS_NUMBER, CSS_UNIT, PERMISSIVE_MATCH3, PERMISSIVE_MATCH4, matchers;
  var init_format_input = __esm({
    "node_modules/@ctrl/tinycolor/dist/module/format-input.js"() {
      init_conversion();
      init_css_color_names();
      init_util2();
      CSS_INTEGER = "[-\\+]?\\d+%?";
      CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
      CSS_UNIT = "(?:".concat(CSS_NUMBER, ")|(?:").concat(CSS_INTEGER, ")");
      PERMISSIVE_MATCH3 = "[\\s|\\(]+(".concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")\\s*\\)?");
      PERMISSIVE_MATCH4 = "[\\s|\\(]+(".concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")\\s*\\)?");
      matchers = {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
      };
    }
  });

  // node_modules/@ctrl/tinycolor/dist/module/index.js
  var TinyColor;
  var init_module = __esm({
    "node_modules/@ctrl/tinycolor/dist/module/index.js"() {
      init_conversion();
      init_css_color_names();
      init_format_input();
      init_util2();
      TinyColor = /** @class */
      (function() {
        function TinyColor2(color, opts) {
          if (color === void 0) {
            color = "";
          }
          if (opts === void 0) {
            opts = {};
          }
          var _a;
          if (color instanceof TinyColor2) {
            return color;
          }
          if (typeof color === "number") {
            color = numberInputToObject(color);
          }
          this.originalInput = color;
          var rgb = inputToRGB(color);
          this.originalInput = color;
          this.r = rgb.r;
          this.g = rgb.g;
          this.b = rgb.b;
          this.a = rgb.a;
          this.roundA = Math.round(100 * this.a) / 100;
          this.format = (_a = opts.format) !== null && _a !== void 0 ? _a : rgb.format;
          this.gradientType = opts.gradientType;
          if (this.r < 1) {
            this.r = Math.round(this.r);
          }
          if (this.g < 1) {
            this.g = Math.round(this.g);
          }
          if (this.b < 1) {
            this.b = Math.round(this.b);
          }
          this.isValid = rgb.ok;
        }
        TinyColor2.prototype.isDark = function() {
          return this.getBrightness() < 128;
        };
        TinyColor2.prototype.isLight = function() {
          return !this.isDark();
        };
        TinyColor2.prototype.getBrightness = function() {
          var rgb = this.toRgb();
          return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1e3;
        };
        TinyColor2.prototype.getLuminance = function() {
          var rgb = this.toRgb();
          var R2;
          var G3;
          var B2;
          var RsRGB = rgb.r / 255;
          var GsRGB = rgb.g / 255;
          var BsRGB = rgb.b / 255;
          if (RsRGB <= 0.03928) {
            R2 = RsRGB / 12.92;
          } else {
            R2 = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
          }
          if (GsRGB <= 0.03928) {
            G3 = GsRGB / 12.92;
          } else {
            G3 = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
          }
          if (BsRGB <= 0.03928) {
            B2 = BsRGB / 12.92;
          } else {
            B2 = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
          }
          return 0.2126 * R2 + 0.7152 * G3 + 0.0722 * B2;
        };
        TinyColor2.prototype.getAlpha = function() {
          return this.a;
        };
        TinyColor2.prototype.setAlpha = function(alpha) {
          this.a = boundAlpha(alpha);
          this.roundA = Math.round(100 * this.a) / 100;
          return this;
        };
        TinyColor2.prototype.isMonochrome = function() {
          var s = this.toHsl().s;
          return s === 0;
        };
        TinyColor2.prototype.toHsv = function() {
          var hsv = rgbToHsv(this.r, this.g, this.b);
          return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this.a };
        };
        TinyColor2.prototype.toHsvString = function() {
          var hsv = rgbToHsv(this.r, this.g, this.b);
          var h2 = Math.round(hsv.h * 360);
          var s = Math.round(hsv.s * 100);
          var v = Math.round(hsv.v * 100);
          return this.a === 1 ? "hsv(".concat(h2, ", ").concat(s, "%, ").concat(v, "%)") : "hsva(".concat(h2, ", ").concat(s, "%, ").concat(v, "%, ").concat(this.roundA, ")");
        };
        TinyColor2.prototype.toHsl = function() {
          var hsl = rgbToHsl(this.r, this.g, this.b);
          return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this.a };
        };
        TinyColor2.prototype.toHslString = function() {
          var hsl = rgbToHsl(this.r, this.g, this.b);
          var h2 = Math.round(hsl.h * 360);
          var s = Math.round(hsl.s * 100);
          var l = Math.round(hsl.l * 100);
          return this.a === 1 ? "hsl(".concat(h2, ", ").concat(s, "%, ").concat(l, "%)") : "hsla(".concat(h2, ", ").concat(s, "%, ").concat(l, "%, ").concat(this.roundA, ")");
        };
        TinyColor2.prototype.toHex = function(allow3Char) {
          if (allow3Char === void 0) {
            allow3Char = false;
          }
          return rgbToHex(this.r, this.g, this.b, allow3Char);
        };
        TinyColor2.prototype.toHexString = function(allow3Char) {
          if (allow3Char === void 0) {
            allow3Char = false;
          }
          return "#" + this.toHex(allow3Char);
        };
        TinyColor2.prototype.toHex8 = function(allow4Char) {
          if (allow4Char === void 0) {
            allow4Char = false;
          }
          return rgbaToHex(this.r, this.g, this.b, this.a, allow4Char);
        };
        TinyColor2.prototype.toHex8String = function(allow4Char) {
          if (allow4Char === void 0) {
            allow4Char = false;
          }
          return "#" + this.toHex8(allow4Char);
        };
        TinyColor2.prototype.toHexShortString = function(allowShortChar) {
          if (allowShortChar === void 0) {
            allowShortChar = false;
          }
          return this.a === 1 ? this.toHexString(allowShortChar) : this.toHex8String(allowShortChar);
        };
        TinyColor2.prototype.toRgb = function() {
          return {
            r: Math.round(this.r),
            g: Math.round(this.g),
            b: Math.round(this.b),
            a: this.a
          };
        };
        TinyColor2.prototype.toRgbString = function() {
          var r = Math.round(this.r);
          var g = Math.round(this.g);
          var b2 = Math.round(this.b);
          return this.a === 1 ? "rgb(".concat(r, ", ").concat(g, ", ").concat(b2, ")") : "rgba(".concat(r, ", ").concat(g, ", ").concat(b2, ", ").concat(this.roundA, ")");
        };
        TinyColor2.prototype.toPercentageRgb = function() {
          var fmt = function(x) {
            return "".concat(Math.round(bound01(x, 255) * 100), "%");
          };
          return {
            r: fmt(this.r),
            g: fmt(this.g),
            b: fmt(this.b),
            a: this.a
          };
        };
        TinyColor2.prototype.toPercentageRgbString = function() {
          var rnd = function(x) {
            return Math.round(bound01(x, 255) * 100);
          };
          return this.a === 1 ? "rgb(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%)") : "rgba(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%, ").concat(this.roundA, ")");
        };
        TinyColor2.prototype.toName = function() {
          if (this.a === 0) {
            return "transparent";
          }
          if (this.a < 1) {
            return false;
          }
          var hex = "#" + rgbToHex(this.r, this.g, this.b, false);
          for (var _i = 0, _a = Object.entries(names); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (hex === value) {
              return key;
            }
          }
          return false;
        };
        TinyColor2.prototype.toString = function(format) {
          var formatSet = Boolean(format);
          format = format !== null && format !== void 0 ? format : this.format;
          var formattedString = false;
          var hasAlpha = this.a < 1 && this.a >= 0;
          var needsAlphaFormat = !formatSet && hasAlpha && (format.startsWith("hex") || format === "name");
          if (needsAlphaFormat) {
            if (format === "name" && this.a === 0) {
              return this.toName();
            }
            return this.toRgbString();
          }
          if (format === "rgb") {
            formattedString = this.toRgbString();
          }
          if (format === "prgb") {
            formattedString = this.toPercentageRgbString();
          }
          if (format === "hex" || format === "hex6") {
            formattedString = this.toHexString();
          }
          if (format === "hex3") {
            formattedString = this.toHexString(true);
          }
          if (format === "hex4") {
            formattedString = this.toHex8String(true);
          }
          if (format === "hex8") {
            formattedString = this.toHex8String();
          }
          if (format === "name") {
            formattedString = this.toName();
          }
          if (format === "hsl") {
            formattedString = this.toHslString();
          }
          if (format === "hsv") {
            formattedString = this.toHsvString();
          }
          return formattedString || this.toHexString();
        };
        TinyColor2.prototype.toNumber = function() {
          return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
        };
        TinyColor2.prototype.clone = function() {
          return new TinyColor2(this.toString());
        };
        TinyColor2.prototype.lighten = function(amount) {
          if (amount === void 0) {
            amount = 10;
          }
          var hsl = this.toHsl();
          hsl.l += amount / 100;
          hsl.l = clamp01(hsl.l);
          return new TinyColor2(hsl);
        };
        TinyColor2.prototype.brighten = function(amount) {
          if (amount === void 0) {
            amount = 10;
          }
          var rgb = this.toRgb();
          rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
          rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
          rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
          return new TinyColor2(rgb);
        };
        TinyColor2.prototype.darken = function(amount) {
          if (amount === void 0) {
            amount = 10;
          }
          var hsl = this.toHsl();
          hsl.l -= amount / 100;
          hsl.l = clamp01(hsl.l);
          return new TinyColor2(hsl);
        };
        TinyColor2.prototype.tint = function(amount) {
          if (amount === void 0) {
            amount = 10;
          }
          return this.mix("white", amount);
        };
        TinyColor2.prototype.shade = function(amount) {
          if (amount === void 0) {
            amount = 10;
          }
          return this.mix("black", amount);
        };
        TinyColor2.prototype.desaturate = function(amount) {
          if (amount === void 0) {
            amount = 10;
          }
          var hsl = this.toHsl();
          hsl.s -= amount / 100;
          hsl.s = clamp01(hsl.s);
          return new TinyColor2(hsl);
        };
        TinyColor2.prototype.saturate = function(amount) {
          if (amount === void 0) {
            amount = 10;
          }
          var hsl = this.toHsl();
          hsl.s += amount / 100;
          hsl.s = clamp01(hsl.s);
          return new TinyColor2(hsl);
        };
        TinyColor2.prototype.greyscale = function() {
          return this.desaturate(100);
        };
        TinyColor2.prototype.spin = function(amount) {
          var hsl = this.toHsl();
          var hue = (hsl.h + amount) % 360;
          hsl.h = hue < 0 ? 360 + hue : hue;
          return new TinyColor2(hsl);
        };
        TinyColor2.prototype.mix = function(color, amount) {
          if (amount === void 0) {
            amount = 50;
          }
          var rgb1 = this.toRgb();
          var rgb2 = new TinyColor2(color).toRgb();
          var p2 = amount / 100;
          var rgba = {
            r: (rgb2.r - rgb1.r) * p2 + rgb1.r,
            g: (rgb2.g - rgb1.g) * p2 + rgb1.g,
            b: (rgb2.b - rgb1.b) * p2 + rgb1.b,
            a: (rgb2.a - rgb1.a) * p2 + rgb1.a
          };
          return new TinyColor2(rgba);
        };
        TinyColor2.prototype.analogous = function(results, slices) {
          if (results === void 0) {
            results = 6;
          }
          if (slices === void 0) {
            slices = 30;
          }
          var hsl = this.toHsl();
          var part = 360 / slices;
          var ret = [this];
          for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results; ) {
            hsl.h = (hsl.h + part) % 360;
            ret.push(new TinyColor2(hsl));
          }
          return ret;
        };
        TinyColor2.prototype.complement = function() {
          var hsl = this.toHsl();
          hsl.h = (hsl.h + 180) % 360;
          return new TinyColor2(hsl);
        };
        TinyColor2.prototype.monochromatic = function(results) {
          if (results === void 0) {
            results = 6;
          }
          var hsv = this.toHsv();
          var h2 = hsv.h;
          var s = hsv.s;
          var v = hsv.v;
          var res = [];
          var modification = 1 / results;
          while (results--) {
            res.push(new TinyColor2({ h: h2, s, v }));
            v = (v + modification) % 1;
          }
          return res;
        };
        TinyColor2.prototype.splitcomplement = function() {
          var hsl = this.toHsl();
          var h2 = hsl.h;
          return [
            this,
            new TinyColor2({ h: (h2 + 72) % 360, s: hsl.s, l: hsl.l }),
            new TinyColor2({ h: (h2 + 216) % 360, s: hsl.s, l: hsl.l })
          ];
        };
        TinyColor2.prototype.onBackground = function(background) {
          var fg = this.toRgb();
          var bg = new TinyColor2(background).toRgb();
          var alpha = fg.a + bg.a * (1 - fg.a);
          return new TinyColor2({
            r: (fg.r * fg.a + bg.r * bg.a * (1 - fg.a)) / alpha,
            g: (fg.g * fg.a + bg.g * bg.a * (1 - fg.a)) / alpha,
            b: (fg.b * fg.a + bg.b * bg.a * (1 - fg.a)) / alpha,
            a: alpha
          });
        };
        TinyColor2.prototype.triad = function() {
          return this.polyad(3);
        };
        TinyColor2.prototype.tetrad = function() {
          return this.polyad(4);
        };
        TinyColor2.prototype.polyad = function(n) {
          var hsl = this.toHsl();
          var h2 = hsl.h;
          var result = [this];
          var increment = 360 / n;
          for (var i2 = 1; i2 < n; i2++) {
            result.push(new TinyColor2({ h: (h2 + i2 * increment) % 360, s: hsl.s, l: hsl.l }));
          }
          return result;
        };
        TinyColor2.prototype.equals = function(color) {
          return this.toRgbString() === new TinyColor2(color).toRgbString();
        };
        return TinyColor2;
      })();
    }
  });

  // node_modules/@ctrl/tinycolor/dist/module/readability.js
  var init_readability = __esm({
    "node_modules/@ctrl/tinycolor/dist/module/readability.js"() {
    }
  });

  // node_modules/@ctrl/tinycolor/dist/module/to-ms-filter.js
  var init_to_ms_filter = __esm({
    "node_modules/@ctrl/tinycolor/dist/module/to-ms-filter.js"() {
    }
  });

  // node_modules/@ctrl/tinycolor/dist/module/from-ratio.js
  var init_from_ratio = __esm({
    "node_modules/@ctrl/tinycolor/dist/module/from-ratio.js"() {
    }
  });

  // node_modules/@ctrl/tinycolor/dist/module/random.js
  var init_random = __esm({
    "node_modules/@ctrl/tinycolor/dist/module/random.js"() {
    }
  });

  // node_modules/@ctrl/tinycolor/dist/module/interfaces.js
  var init_interfaces = __esm({
    "node_modules/@ctrl/tinycolor/dist/module/interfaces.js"() {
    }
  });

  // node_modules/@ctrl/tinycolor/dist/module/public_api.js
  var init_public_api = __esm({
    "node_modules/@ctrl/tinycolor/dist/module/public_api.js"() {
      init_module();
      init_css_color_names();
      init_readability();
      init_to_ms_filter();
      init_from_ratio();
      init_format_input();
      init_random();
      init_interfaces();
      init_conversion();
    }
  });

  // node_modules/@ckpack/vue-color/libs/mixin/color.js
  function tinycolor(...args) {
    return new TinyColor(...args);
  }
  function _colorChange(data, oldHue) {
    const alpha = data && data.a;
    let color;
    if (data && data.hsl)
      color = tinycolor(data.hsl);
    else if (data && data.hex && data.hex.length > 0)
      color = tinycolor(data.hex);
    else if (data && data.hsv)
      color = tinycolor(data.hsv);
    else if (data && data.rgba)
      color = tinycolor(data.rgba);
    else if (data && data.rgb)
      color = tinycolor(data.rgb);
    else
      color = tinycolor(data);
    if (color && (color._a === void 0 || color._a === null))
      color.setAlpha(alpha || color.getAlpha());
    const hsl = color.toHsl();
    const hsv = color.toHsv();
    if (hsl.s === 0)
      hsv.h = hsl.h = data.h || data.hsl && data.hsl.h || oldHue || 0;
    if (hsv.v < 0.0164) {
      hsv.h = data.h || data.hsv && data.hsv.h || 0;
      hsv.s = data.s || data.hsv && data.hsv.s || 0;
    }
    if (hsl.l < 0.01) {
      hsl.h = data.h || data.hsl && data.hsl.h || 0;
      hsl.s = data.s || data.hsl && data.hsl.s || 0;
    }
    return {
      hsl,
      hex: color.toHexString().toUpperCase(),
      hex8: color.toHex8String().toUpperCase(),
      rgba: color.toRgb(),
      hsv,
      oldHue: data.h || oldHue || hsl.h,
      source: data.source,
      a: color.getAlpha()
    };
  }
  var colorMixin;
  var init_color = __esm({
    "node_modules/@ckpack/vue-color/libs/mixin/color.js"() {
      init_public_api();
      colorMixin = {
        model: {
          prop: "modelValue",
          event: "update:modelValue"
        },
        props: ["modelValue"],
        data() {
          return {
            val: _colorChange(this.modelValue)
          };
        },
        computed: {
          colors: {
            get() {
              return this.val;
            },
            set(newVal) {
              this.val = newVal;
              this.$emit("update:modelValue", newVal);
            }
          }
        },
        watch: {
          modelValue(newVal) {
            this.val = _colorChange(newVal);
          }
        },
        methods: {
          colorChange(data, oldHue) {
            this.oldHue = this.colors.hsl.h;
            this.colors = _colorChange(data, oldHue || this.oldHue);
          },
          isValidHex(hex) {
            return tinycolor(hex).isValid;
          },
          simpleCheckForValidColor(data) {
            const keysToCheck = ["r", "g", "b", "a", "h", "s", "l", "v"];
            let checked = 0;
            let passed = 0;
            for (let i2 = 0; i2 < keysToCheck.length; i2++) {
              const letter = keysToCheck[i2];
              if (data[letter]) {
                checked++;
                if (!isNaN(data[letter]))
                  passed++;
              }
            }
            if (checked === passed)
              return data;
          },
          paletteUpperCase(palette) {
            return palette.map((c) => c.toUpperCase());
          },
          isTransparent(color) {
            return tinycolor(color).getAlpha() === 0;
          }
        }
      };
    }
  });

  // node_modules/@ckpack/vue-color/libs/components/editable-input/index.js
  function render38(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock("div", _hoisted_158, [
      withDirectives(createBaseVNode("input", {
        ref: "input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $options.val = $event),
        "aria-labelledby": $options.labelId,
        class: "vc-input__input",
        onKeydown: _cache[1] || (_cache[1] = (...args) => $options.handleKeyDown && $options.handleKeyDown(...args)),
        onInput: _cache[2] || (_cache[2] = (...args) => $options.update && $options.update(...args))
      }, null, 40, _hoisted_241), [
        [vModelText, $options.val]
      ]),
      createBaseVNode("span", {
        id: $options.labelId,
        for: $props.label,
        class: "vc-input__label"
      }, toDisplayString($options.labelSpanText), 9, _hoisted_330),
      createBaseVNode(
        "span",
        _hoisted_426,
        toDisplayString($props.desc),
        1
        /* TEXT */
      )
    ]);
  }
  var script3, _hoisted_158, _hoisted_241, _hoisted_330, _hoisted_426, css_248z3;
  var init_editable_input = __esm({
    "node_modules/@ckpack/vue-color/libs/components/editable-input/index.js"() {
      init_vue_esm_bundler();
      init_style_inject_es_746bb8ed();
      init_compoent();
      script3 = {
        name: "EditableInput",
        props: {
          label: String,
          labelText: String,
          desc: String,
          value: [String, Number],
          max: Number,
          min: Number,
          arrowOffset: {
            type: Number,
            default: 1
          }
        },
        computed: {
          val: {
            get() {
              return this.value;
            },
            set(v) {
              if (!(this.max === void 0) && +v > this.max)
                this.$refs.input.value = this.max;
              else
                return v;
            }
          },
          labelId() {
            return `input__label__${this.label}__${Math.random().toString().slice(2, 5)}`;
          },
          labelSpanText() {
            return this.labelText || this.label;
          }
        },
        methods: {
          update(e) {
            this.handleChange(e.target.value);
          },
          handleChange(newVal) {
            const data = {};
            data[this.label] = newVal;
            if (data.hex === void 0 && data["#"] === void 0)
              this.$emit("change", data);
            else if (newVal.length > 5)
              this.$emit("change", data);
          },
          // **** unused
          // handleBlur (e) {
          //   console.log(e)
          // },
          handleKeyDown(e) {
            let { val } = this;
            const number = Number(val);
            if (number) {
              const amount = this.arrowOffset || 1;
              if (e.keyCode === 38) {
                val = number + amount;
                this.handleChange(val);
                e.preventDefault();
              }
              if (e.keyCode === 40) {
                val = number - amount;
                this.handleChange(val);
                e.preventDefault();
              }
            }
          }
          // **** unused
          // handleDrag (e) {
          //   console.log(e)
          // },
          // handleMouseDown (e) {
          //   console.log(e)
          // }
        }
      };
      _hoisted_158 = { class: "vc-editable-input" };
      _hoisted_241 = ["aria-labelledby"];
      _hoisted_330 = ["id", "for"];
      _hoisted_426 = { class: "vc-input__desc" };
      css_248z3 = ".vc-editable-input{position:relative}.vc-input__input{border:0;outline:none;padding:0}.vc-input__label{text-transform:capitalize}";
      styleInject(css_248z3);
      script3.render = render38;
      script3.__file = "src/components/editable-input/editable-input.vue";
      script3.install = install2;
    }
  });

  // node_modules/@ckpack/vue-color/libs/utils/utils.js
  function clamp(value, min, max) {
    return min < max ? value < min ? min : value > max ? max : value : value < max ? max : value > min ? min : value;
  }
  var init_utils3 = __esm({
    "node_modules/@ckpack/vue-color/libs/utils/utils.js"() {
    }
  });

  // node_modules/@ckpack/vue-color/libs/components/saturation/index.js
  function render39(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock(
      "div",
      {
        ref: "container",
        class: "vc-saturation",
        style: normalizeStyle({ background: $options.bgColor }),
        onMousedown: _cache[0] || (_cache[0] = (...args) => $options.handleMouseDown && $options.handleMouseDown(...args)),
        onTouchmove: _cache[1] || (_cache[1] = (...args) => $options.handleChange && $options.handleChange(...args)),
        onTouchstart: _cache[2] || (_cache[2] = (...args) => $options.handleChange && $options.handleChange(...args))
      },
      [
        _hoisted_159,
        _hoisted_245,
        createBaseVNode(
          "div",
          {
            class: "vc-saturation-pointer",
            style: normalizeStyle({ top: $options.pointerTop, left: $options.pointerLeft })
          },
          _hoisted_427,
          4
          /* STYLE */
        )
      ],
      36
      /* STYLE, HYDRATE_EVENTS */
    );
  }
  var script4, _hoisted_159, _hoisted_245, _hoisted_331, _hoisted_427, css_248z4;
  var init_saturation = __esm({
    "node_modules/@ckpack/vue-color/libs/components/saturation/index.js"() {
      init_utils3();
      init_vue_esm_bundler();
      init_style_inject_es_746bb8ed();
      init_compoent();
      script4 = {
        name: "Saturation",
        props: {
          value: Object
        },
        computed: {
          colors() {
            return this.value;
          },
          bgColor() {
            return `hsl(${this.colors.hsv.h}, 100%, 50%)`;
          },
          pointerTop() {
            return `${-(this.colors.hsv.v * 100) + 1 + 100}%`;
          },
          pointerLeft() {
            return `${this.colors.hsv.s * 100}%`;
          }
        },
        methods: {
          handleChange(e, skip) {
            !skip && e.preventDefault();
            const { container } = this.$refs;
            if (!container) {
              return;
            }
            const containerWidth = container.clientWidth;
            const containerHeight = container.clientHeight;
            const xOffset = container.getBoundingClientRect().left + window.pageXOffset;
            const yOffset = container.getBoundingClientRect().top + window.pageYOffset;
            const pageX = e.pageX || (e.touches ? e.touches[0].pageX : 0);
            const pageY = e.pageY || (e.touches ? e.touches[0].pageY : 0);
            const left = clamp(pageX - xOffset, 0, containerWidth);
            const top = clamp(pageY - yOffset, 0, containerHeight);
            const saturation = left / containerWidth;
            const bright = clamp(-(top / containerHeight) + 1, 0, 1);
            this.onChange({
              h: this.colors.hsv.h,
              s: saturation,
              v: bright,
              a: this.colors.hsv.a,
              source: "hsva"
            });
          },
          onChange(param) {
            this.$emit("change", param);
          },
          handleMouseDown(e) {
            window.addEventListener("mousemove", this.handleChange);
            window.addEventListener("mouseup", this.handleChange);
            window.addEventListener("mouseup", this.handleMouseUp);
          },
          handleMouseUp(e) {
            this.unbindEventListeners();
          },
          unbindEventListeners() {
            window.removeEventListener("mousemove", this.handleChange);
            window.removeEventListener("mouseup", this.handleChange);
            window.removeEventListener("mouseup", this.handleMouseUp);
          }
        }
      };
      _hoisted_159 = /* @__PURE__ */ createBaseVNode(
        "div",
        { class: "vc-saturation--white" },
        null,
        -1
        /* HOISTED */
      );
      _hoisted_245 = /* @__PURE__ */ createBaseVNode(
        "div",
        { class: "vc-saturation--black" },
        null,
        -1
        /* HOISTED */
      );
      _hoisted_331 = /* @__PURE__ */ createBaseVNode(
        "div",
        { class: "vc-saturation-circle" },
        null,
        -1
        /* HOISTED */
      );
      _hoisted_427 = [
        _hoisted_331
      ];
      css_248z4 = ".vc-saturation,.vc-saturation--black,.vc-saturation--white{bottom:0;cursor:pointer;left:0;position:absolute;right:0;top:0}.vc-saturation--white{background:linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.vc-saturation--black{background:linear-gradient(0deg,#000,transparent)}.vc-saturation-pointer{cursor:pointer;position:absolute}.vc-saturation-circle{border-radius:50%;box-shadow:0 0 0 1.5px #fff,inset 0 0 1px 1px rgba(0,0,0,.3),0 0 1px 2px rgba(0,0,0,.4);cursor:head;height:4px;transform:translate(-2px,-2px);width:4px}";
      styleInject(css_248z4);
      script4.render = render39;
      script4.__file = "src/components/saturation/saturation.vue";
      script4.install = install2;
    }
  });

  // node_modules/@ckpack/vue-color/libs/components/hue/index.js
  function render40(_ctx, _cache, $props, $setup, $data, $options) {
    return openBlock(), createElementBlock(
      "div",
      {
        class: normalizeClass(["vc-hue", [$options.directionClass]])
      },
      [
        createBaseVNode("div", {
          ref: "container",
          class: "vc-hue-container",
          role: "slider",
          "aria-valuenow": $options.colors.hsl.h,
          "aria-valuemin": "0",
          "aria-valuemax": "360",
          onMousedown: _cache[0] || (_cache[0] = (...args) => $options.handleMouseDown && $options.handleMouseDown(...args)),
          onTouchmove: _cache[1] || (_cache[1] = (...args) => $options.handleChange && $options.handleChange(...args)),
          onTouchstart: _cache[2] || (_cache[2] = (...args) => $options.handleChange && $options.handleChange(...args))
        }, [
          createBaseVNode(
            "div",
            {
              class: "vc-hue-pointer",
              style: normalizeStyle({ top: $options.pointerTop, left: $options.pointerLeft }),
              role: "presentation"
            },
            _hoisted_334,
            4
            /* STYLE */
          )
        ], 40, _hoisted_160)
      ],
      2
      /* CLASS */
    );
  }
  var script5, _hoisted_160, _hoisted_246, _hoisted_334, css_248z5;
  var init_hue = __esm({
    "node_modules/@ckpack/vue-color/libs/components/hue/index.js"() {
      init_vue_esm_bundler();
      init_style_inject_es_746bb8ed();
      init_compoent();
      script5 = {
        name: "Hue",
        props: {
          value: Object,
          direction: {
            type: String,
            // [horizontal | vertical]
            default: "horizontal"
          }
        },
        data() {
          return {
            oldHue: 0,
            pullDirection: ""
          };
        },
        computed: {
          colors() {
            return this.value;
          },
          directionClass() {
            return {
              "vc-hue--horizontal": this.direction === "horizontal",
              "vc-hue--vertical": this.direction === "vertical"
            };
          },
          pointerTop() {
            if (this.direction === "vertical") {
              if (this.colors.hsl.h === 0 && this.pullDirection === "right")
                return 0;
              return `${-(this.colors.hsl.h * 100 / 360) + 100}%`;
            }
            return 0;
          },
          pointerLeft() {
            if (this.direction === "vertical")
              return 0;
            if (this.colors.hsl.h === 0 && this.pullDirection === "right")
              return "100%";
            return `${this.colors.hsl.h * 100 / 360}%`;
          }
        },
        watch: {
          value: {
            handler(value, oldVal) {
              const { h: h2 } = value.hsl;
              if (h2 !== 0 && h2 - this.oldHue > 0)
                this.pullDirection = "right";
              if (h2 !== 0 && h2 - this.oldHue < 0)
                this.pullDirection = "left";
              this.oldHue = h2;
            },
            deep: true,
            immediate: true
          }
        },
        methods: {
          handleChange(e, skip) {
            !skip && e.preventDefault();
            const { container } = this.$refs;
            if (!container) {
              return;
            }
            const containerWidth = container.clientWidth;
            const containerHeight = container.clientHeight;
            const xOffset = container.getBoundingClientRect().left + window.pageXOffset;
            const yOffset = container.getBoundingClientRect().top + window.pageYOffset;
            const pageX = e.pageX || (e.touches ? e.touches[0].pageX : 0);
            const pageY = e.pageY || (e.touches ? e.touches[0].pageY : 0);
            const left = pageX - xOffset;
            const top = pageY - yOffset;
            let h2;
            let percent;
            if (this.direction === "vertical") {
              if (top < 0) {
                h2 = 360;
              } else if (top > containerHeight) {
                h2 = 0;
              } else {
                percent = -(top * 100 / containerHeight) + 100;
                h2 = 360 * percent / 100;
              }
              if (this.colors.hsl.h !== h2) {
                this.$emit("change", {
                  h: h2,
                  s: this.colors.hsl.s,
                  l: this.colors.hsl.l,
                  a: this.colors.hsl.a,
                  source: "hsl"
                });
              }
            } else {
              if (left < 0) {
                h2 = 0;
              } else if (left > containerWidth) {
                h2 = 360;
              } else {
                percent = left * 100 / containerWidth;
                h2 = 360 * percent / 100;
              }
              if (this.colors.hsl.h !== h2) {
                this.$emit("change", {
                  h: h2,
                  s: this.colors.hsl.s,
                  l: this.colors.hsl.l,
                  a: this.colors.hsl.a,
                  source: "hsl"
                });
              }
            }
          },
          handleMouseDown(e) {
            this.handleChange(e, true);
            window.addEventListener("mousemove", this.handleChange);
            window.addEventListener("mouseup", this.handleChange);
            window.addEventListener("mouseup", this.handleMouseUp);
          },
          handleMouseUp(e) {
            this.unbindEventListeners();
          },
          unbindEventListeners() {
            window.removeEventListener("mousemove", this.handleChange);
            window.removeEventListener("mouseup", this.handleChange);
            window.removeEventListener("mouseup", this.handleMouseUp);
          }
        }
      };
      _hoisted_160 = ["aria-valuenow"];
      _hoisted_246 = /* @__PURE__ */ createBaseVNode(
        "div",
        { class: "vc-hue-picker" },
        null,
        -1
        /* HOISTED */
      );
      _hoisted_334 = [
        _hoisted_246
      ];
      css_248z5 = ".vc-hue{border-radius:2px;bottom:0;left:0;position:absolute;right:0;top:0}.vc-hue--horizontal{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.vc-hue--vertical{background:linear-gradient(0deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.vc-hue-container{cursor:pointer;height:100%;margin:0 2px;position:relative}.vc-hue-pointer{position:absolute;z-index:2}.vc-hue-picker{background:#fff;border-radius:1px;box-shadow:0 0 2px rgba(0,0,0,.6);cursor:pointer;height:8px;margin-top:1px;transform:translateX(-2px);width:4px}";
      styleInject(css_248z5);
      script5.render = render40;
      script5.__file = "src/components/hue/hue.vue";
      script5.install = install2;
    }
  });

  // node_modules/@ckpack/vue-color/libs/components/sketch/index.js
  function render41(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Saturation = resolveComponent("Saturation");
    const _component_Hue = resolveComponent("Hue");
    const _component_Alpha = resolveComponent("Alpha");
    const _component_Checkboard = resolveComponent("Checkboard");
    const _component_EdIn = resolveComponent("EdIn");
    return openBlock(), createElementBlock(
      "div",
      {
        role: "application",
        "aria-label": "Sketch color picker",
        class: normalizeClass(["vc-sketch", [$props.disableAlpha ? "vc-sketch__disable-alpha" : ""]])
      },
      [
        createBaseVNode("div", _hoisted_161, [
          createVNode(_component_Saturation, {
            value: _ctx.colors,
            onChange: $options.childChange
          }, null, 8, ["value", "onChange"])
        ]),
        createBaseVNode("div", _hoisted_247, [
          createBaseVNode("div", _hoisted_335, [
            createBaseVNode("div", _hoisted_428, [
              createVNode(_component_Hue, {
                value: _ctx.colors,
                onChange: $options.childChange
              }, null, 8, ["value", "onChange"])
            ]),
            !$props.disableAlpha ? (openBlock(), createElementBlock("div", _hoisted_519, [
              createVNode(_component_Alpha, {
                value: _ctx.colors,
                onChange: $options.childChange
              }, null, 8, ["value", "onChange"])
            ])) : createCommentVNode("v-if", true)
          ]),
          createBaseVNode("div", _hoisted_615, [
            createBaseVNode("div", {
              "aria-label": `Current color is ${$options.activeColor}`,
              class: "vc-sketch-active-color",
              style: normalizeStyle({ background: $options.activeColor })
            }, null, 12, _hoisted_714),
            createVNode(_component_Checkboard)
          ])
        ]),
        !$props.disableFields ? (openBlock(), createElementBlock("div", _hoisted_810, [
          createCommentVNode(" rgba "),
          createBaseVNode("div", _hoisted_99, [
            createVNode(_component_EdIn, {
              label: "hex",
              value: $options.hex,
              onChange: $options.inputChange
            }, null, 8, ["value", "onChange"])
          ]),
          createBaseVNode("div", _hoisted_109, [
            createVNode(_component_EdIn, {
              label: "r",
              value: _ctx.colors.rgba.r,
              onChange: $options.inputChange
            }, null, 8, ["value", "onChange"])
          ]),
          createBaseVNode("div", _hoisted_1117, [
            createVNode(_component_EdIn, {
              label: "g",
              value: _ctx.colors.rgba.g,
              onChange: $options.inputChange
            }, null, 8, ["value", "onChange"])
          ]),
          createBaseVNode("div", _hoisted_1213, [
            createVNode(_component_EdIn, {
              label: "b",
              value: _ctx.colors.rgba.b,
              onChange: $options.inputChange
            }, null, 8, ["value", "onChange"])
          ]),
          !$props.disableAlpha ? (openBlock(), createElementBlock("div", _hoisted_1312, [
            createVNode(_component_EdIn, {
              label: "a",
              value: _ctx.colors.a,
              "arrow-offset": 0.01,
              max: 1,
              onChange: $options.inputChange
            }, null, 8, ["value", "arrow-offset", "onChange"])
          ])) : createCommentVNode("v-if", true)
        ])) : createCommentVNode("v-if", true),
        createBaseVNode("div", _hoisted_1411, [
          (openBlock(true), createElementBlock(
            Fragment,
            null,
            renderList($props.presetColors, (c) => {
              return openBlock(), createElementBlock(
                Fragment,
                null,
                [
                  !_ctx.isTransparent(c) ? (openBlock(), createElementBlock("div", {
                    key: `!${c}`,
                    class: "vc-sketch-presets-color",
                    "aria-label": `Color:${c}`,
                    style: normalizeStyle({ background: c }),
                    onClick: ($event) => $options.handlePreset(c)
                  }, null, 12, _hoisted_1510)) : (openBlock(), createElementBlock("div", {
                    key: c,
                    "aria-label": `Color:${c}`,
                    class: "vc-sketch-presets-color",
                    onClick: ($event) => $options.handlePreset(c)
                  }, [
                    createVNode(_component_Checkboard)
                  ], 8, _hoisted_167))
                ],
                64
                /* STABLE_FRAGMENT */
              );
            }),
            256
            /* UNKEYED_FRAGMENT */
          ))
        ])
      ],
      2
      /* CLASS */
    );
  }
  var presetColors, script6, _hoisted_161, _hoisted_247, _hoisted_335, _hoisted_428, _hoisted_519, _hoisted_615, _hoisted_714, _hoisted_810, _hoisted_99, _hoisted_109, _hoisted_1117, _hoisted_1213, _hoisted_1312, _hoisted_1411, _hoisted_1510, _hoisted_167, css_248z6;
  var init_sketch = __esm({
    "node_modules/@ckpack/vue-color/libs/components/sketch/index.js"() {
      init_color();
      init_editable_input();
      init_saturation();
      init_hue();
      init_alpha();
      init_checkboard();
      init_vue_esm_bundler();
      init_style_inject_es_746bb8ed();
      init_compoent();
      presetColors = [
        "#D0021B",
        "#F5A623",
        "#F8E71C",
        "#8B572A",
        "#7ED321",
        "#417505",
        "#BD10E0",
        "#9013FE",
        "#4A90E2",
        "#50E3C2",
        "#B8E986",
        "#000000",
        "#4A4A4A",
        "#9B9B9B",
        "#FFFFFF",
        "rgba(0,0,0,0)"
      ];
      script6 = {
        name: "Sketch",
        components: {
          Saturation: script4,
          Hue: script5,
          Alpha: script2,
          EdIn: script3,
          Checkboard: script
        },
        mixins: [colorMixin],
        props: {
          presetColors: {
            type: Array,
            default() {
              return presetColors;
            }
          },
          disableAlpha: {
            type: Boolean,
            default: false
          },
          disableFields: {
            type: Boolean,
            default: false
          }
        },
        computed: {
          hex() {
            let hex;
            if (this.colors.a < 1)
              hex = this.colors.hex8;
            else
              hex = this.colors.hex;
            return hex.replace("#", "");
          },
          activeColor() {
            const { rgba } = this.colors;
            return `rgba(${[rgba.r, rgba.g, rgba.b, rgba.a].join(",")})`;
          }
        },
        methods: {
          handlePreset(c) {
            this.colorChange(c);
          },
          childChange(data) {
            this.colorChange(data);
          },
          inputChange(data) {
            if (!data)
              return;
            if (data.hex) {
              this.isValidHex(data.hex) && this.colorChange({
                hex: data.hex,
                source: "hex"
              });
            } else if (data.r || data.g || data.b || data.a) {
              this.colorChange({
                r: data.r || this.colors.rgba.r,
                g: data.g || this.colors.rgba.g,
                b: data.b || this.colors.rgba.b,
                a: data.a || this.colors.rgba.a,
                source: "rgba"
              });
            }
          }
        }
      };
      _hoisted_161 = { class: "vc-sketch-saturation-wrap" };
      _hoisted_247 = { class: "vc-sketch-controls" };
      _hoisted_335 = { class: "vc-sketch-sliders" };
      _hoisted_428 = { class: "vc-sketch-hue-wrap" };
      _hoisted_519 = {
        key: 0,
        class: "vc-sketch-alpha-wrap"
      };
      _hoisted_615 = { class: "vc-sketch-color-wrap" };
      _hoisted_714 = ["aria-label"];
      _hoisted_810 = {
        key: 0,
        class: "vc-sketch-field"
      };
      _hoisted_99 = { class: "vc-sketch-field--double" };
      _hoisted_109 = { class: "vc-sketch-field--single" };
      _hoisted_1117 = { class: "vc-sketch-field--single" };
      _hoisted_1213 = { class: "vc-sketch-field--single" };
      _hoisted_1312 = {
        key: 0,
        class: "vc-sketch-field--single"
      };
      _hoisted_1411 = {
        class: "vc-sketch-presets",
        role: "group",
        "aria-label": "A color preset, pick one to set as current color"
      };
      _hoisted_1510 = ["aria-label", "onClick"];
      _hoisted_167 = ["aria-label", "onClick"];
      css_248z6 = ".vc-sketch{background:#fff;border-radius:4px;box-shadow:0 0 0 1px rgba(0,0,0,.15),0 8px 16px rgba(0,0,0,.15);box-sizing:initial;padding:10px 10px 0;position:relative;width:200px}.vc-sketch-saturation-wrap{overflow:hidden;padding-bottom:75%;position:relative;width:100%}.vc-sketch-controls{display:flex}.vc-sketch-sliders{flex:1;padding:4px 0}.vc-sketch-sliders .vc-alpha-gradient,.vc-sketch-sliders .vc-hue{border-radius:2px}.vc-sketch-alpha-wrap,.vc-sketch-hue-wrap{height:10px;position:relative}.vc-sketch-alpha-wrap{margin-top:4px;overflow:hidden}.vc-sketch-color-wrap{border-radius:3px;height:24px;margin-left:4px;margin-top:4px;position:relative;width:24px}.vc-sketch-active-color{border-radius:2px;bottom:0;box-shadow:inset 0 0 0 1px rgba(0,0,0,.15),inset 0 0 4px rgba(0,0,0,.25);left:0;position:absolute;right:0;top:0;z-index:2}.vc-sketch-color-wrap .vc-checkerboard{background-size:auto}.vc-sketch-field{display:flex;padding-top:4px}.vc-sketch-field .vc-input__input{border:none;box-shadow:inset 0 0 0 1px #ccc;font-size:10px;padding:4px 0 3px 10%;width:90%}.vc-sketch-field .vc-input__label{color:#222;display:block;font-size:11px;padding-bottom:4px;padding-top:3px;text-align:center;text-transform:capitalize}.vc-sketch-field--single{flex:1;padding-left:6px}.vc-sketch-field--double{flex:2}.vc-sketch-presets{border-top:1px solid #eee;margin-left:-10px;margin-right:-10px;padding-left:10px;padding-top:10px}.vc-sketch-presets-color{cursor:pointer;display:inline-block;height:16px;margin:0 10px 10px 0;overflow:hidden;position:relative;vertical-align:top;width:16px}.vc-sketch-presets-color,.vc-sketch-presets-color .vc-checkerboard{border-radius:3px;box-shadow:inset 0 0 0 1px rgba(0,0,0,.15)}.vc-sketch__disable-alpha .vc-sketch-color-wrap{height:10px}";
      styleInject(css_248z6);
      script6.render = render41;
      script6.__file = "src/components/sketch/sketch.vue";
      script6.install = install2;
    }
  });

  // node_modules/material-colors/dist/colors.es2015.js
  var init_colors_es2015 = __esm({
    "node_modules/material-colors/dist/colors.es2015.js"() {
    }
  });

  // node_modules/@ckpack/vue-color/libs/index.js
  var init_libs = __esm({
    "node_modules/@ckpack/vue-color/libs/index.js"() {
      init_sketch();
      init_vue_esm_bundler();
      init_colors_es2015();
    }
  });

  // vue-style:C:\fork\Baudville\src\vue\components\shared\canvas-text.vue
  var init_canvas_text = __esm({
    "vue-style:C:\\fork\\Baudville\\src\\vue\\components\\shared\\canvas-text.vue"() {
    }
  });

  // src/vue/components/shared/canvas-text.vue
  var canvas_text_exports = {};
  __export(canvas_text_exports, {
    default: () => canvas_text_default,
    render: () => render42
  });
  function render42(_ctx, _cache) {
    const _component_Sketch = resolveComponent("Sketch");
    return openBlock(), createElementBlock(
      Fragment,
      null,
      [
        createBaseVNode("div", null, [
          _cache[15] || (_cache[15] = createBaseVNode(
            "p",
            { class: "mb-4" },
            ' Enter your text and its specifications (i.e. color and alignment) below. Then scroll down to click the "save" button. Your text should appear on the product preview. Click on your text to resize or move. ',
            -1
            /* CACHED */
          )),
          createBaseVNode("div", _hoisted_168, [
            _cache[8] || (_cache[8] = createBaseVNode(
              "label",
              {
                for: "custom-text",
                class: "block pb-3 font-bold"
              },
              [
                createBaseVNode("span", { class: "property__text" }, "Enter Text")
              ],
              -1
              /* CACHED */
            )),
            createBaseVNode("div", _hoisted_248, [
              withDirectives(createBaseVNode(
                "textarea",
                {
                  id: "custom-text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.text = $event),
                  name: "custom_text",
                  class: "text-box text-box--multi-line text-box--full !h-36 !w-full"
                },
                null,
                512
                /* NEED_PATCH */
              ), [
                [vModelText, _ctx.text]
              ])
            ])
          ]),
          createBaseVNode("div", _hoisted_336, [
            createBaseVNode("div", _hoisted_429, [
              _cache[12] || (_cache[12] = createBaseVNode(
                "label",
                { class: "block pb-3 font-bold" },
                [
                  createBaseVNode("span", { class: "property__text" }, "Enter Text Alignment")
                ],
                -1
                /* CACHED */
              )),
              createBaseVNode("div", _hoisted_520, [
                createBaseVNode("button", {
                  disabled: _ctx.align == "left",
                  class: "configurator-custom-text__alignment-button button button--secondary",
                  onClick: _cache[1] || (_cache[1] = ($event) => _ctx.align = "left")
                }, [..._cache[9] || (_cache[9] = [
                  createBaseVNode(
                    "svg",
                    {
                      title: "Align Left",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 66.373 66.373",
                      class: "svg-icon svg-icon--font-color"
                    },
                    [
                      createBaseVNode("path", { d: "M0 2.569h66.373v6H0zM0 16.377h50.457v6H0zM0 30.186h66.373v6H0zM0 43.995h50.457v6H0zM0 57.803h66.373v6H0z" })
                    ],
                    -1
                    /* CACHED */
                  )
                ])], 8, _hoisted_616),
                createBaseVNode("button", {
                  disabled: _ctx.align == "center",
                  class: "configurator-custom-text__alignment-button button button--secondary",
                  onClick: _cache[2] || (_cache[2] = ($event) => _ctx.align = "center")
                }, [..._cache[10] || (_cache[10] = [
                  createBaseVNode(
                    "svg",
                    {
                      title: "Align Center",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 66.373 66.373",
                      class: "svg-icon svg-icon--font-color"
                    },
                    [
                      createBaseVNode("path", { d: "M0 2.569h66.373v6H0zM7.959 16.502h50.456v6H7.959zM0 30.186h66.373v6H0zM7.959 44.12h50.456v6H7.959zM0 57.803h66.373v6H0z" })
                    ],
                    -1
                    /* CACHED */
                  )
                ])], 8, _hoisted_715),
                createBaseVNode("button", {
                  disabled: _ctx.align == "right",
                  class: "configurator-custom-text__alignment-button button button--secondary",
                  onClick: _cache[3] || (_cache[3] = ($event) => _ctx.align = "right")
                }, [..._cache[11] || (_cache[11] = [
                  createBaseVNode(
                    "svg",
                    {
                      title: "Align Right",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 66.373 66.373",
                      class: "svg-icon svg-icon--font-color"
                    },
                    [
                      createBaseVNode("path", { d: "M0 2.569h66.373v6H0zM15.917 16.377h50.456v6H15.917zM0 30.186h66.373v6H0zM15.917 43.995h50.456v6H15.917zM0 57.804h66.373v6H0z" })
                    ],
                    -1
                    /* CACHED */
                  )
                ])], 8, _hoisted_811)
              ])
            ])
          ]),
          createBaseVNode("div", _hoisted_910, [
            _cache[14] || (_cache[14] = createBaseVNode(
              "label",
              {
                for: "font",
                class: "block pb-3 font-bold property__name"
              },
              [
                createBaseVNode("span", { class: "property__text" }, "Select Font")
              ],
              -1
              /* CACHED */
            )),
            createBaseVNode("div", _hoisted_1010, [
              createBaseVNode("div", _hoisted_1118, [
                withDirectives(createBaseVNode(
                  "select",
                  {
                    id: "font",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => _ctx.font = $event),
                    name: "font"
                  },
                  [..._cache[13] || (_cache[13] = [
                    createStaticVNode('<option value="Minion Pro" data-v-f2d7f811> Minion Pro </option><option value="Times New Roman" data-v-f2d7f811> Times New Roman </option><option value="DIN Alternate Bold" data-v-f2d7f811> DINMittelschriftStd-OTF </option><option value="Helvetica Neue" data-v-f2d7f811> Helvetica Neue LT Com 77 Bold Condensed-TTF </option><option value="Dancing Script OT" data-v-f2d7f811> DancingScriptOT-OTF </option><option value="Playlist" data-v-f2d7f811> Playlist-Script-OTF </option><option value="Machiarge" data-v-f2d7f811> Machiarge-OTF </option><option value="Chewie" data-v-f2d7f811> Chewy-TTF </option><option value="DK Lemon Yellow Sun" data-v-f2d7f811> DKLemonYellowSun-OTF </option><option value="Hawaiian Pizza" data-v-f2d7f811> Hawaiian Pizza Regular-OTF </option><option value="Sweet Lollipop" data-v-f2d7f811> Sweet Lollipop-TTF </option>', 11)
                  ])],
                  512
                  /* NEED_PATCH */
                ), [
                  [vModelSelect, _ctx.font]
                ])
              ])
            ])
          ]),
          _cache[16] || (_cache[16] = createBaseVNode(
            "label",
            {
              for: "custom-text-color",
              class: "block pb-3 font-bold"
            },
            [
              createBaseVNode("span", { class: "property__text" }, "Text Color")
            ],
            -1
            /* CACHED */
          ))
        ]),
        createVNode(_component_Sketch, {
          modelValue: _ctx.color,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => _ctx.color = $event)
        }, null, 8, ["modelValue"]),
        createBaseVNode("div", _hoisted_1214, [
          createBaseVNode("button", {
            class: "mr-1 text-button",
            onClick: _cache[6] || (_cache[6] = (...args) => _ctx.cancel && _ctx.cancel(...args))
          }, " Cancel "),
          _cache[17] || (_cache[17] = createBaseVNode(
            "span",
            null,
            "\xA0",
            -1
            /* CACHED */
          )),
          createBaseVNode("button", {
            class: "button button-save",
            onClick: _cache[7] || (_cache[7] = (...args) => _ctx.add && _ctx.add(...args))
          }, " Save ")
        ])
      ],
      64
      /* STABLE_FRAGMENT */
    );
  }
  var Konva4, Text3, __default__35, _hoisted_168, _hoisted_248, _hoisted_336, _hoisted_429, _hoisted_520, _hoisted_616, _hoisted_715, _hoisted_811, _hoisted_910, _hoisted_1010, _hoisted_1118, _hoisted_1214, canvas_text_default;
  var init_canvas_text2 = __esm({
    "src/vue/components/shared/canvas-text.vue"() {
      "use strict";
      init_canvas();
      init_libs();
      init_vuex_esm_bundler();
      init_vue_esm_bundler();
      init_vue_esm_bundler();
      init_canvas_text();
      Konva4 = (init_lib(), __toCommonJS(lib_exports));
      Text3 = Konva4.default.Text;
      __default__35 = {
        components: {
          Sketch: script6
        },
        props: {
          artwork: {
            type: Object,
            default: () => {
              return {
                text: "",
                font: "Minion Pro",
                color: null,
                align: "center"
              };
            }
          }
        },
        emits: ["cancel", "saveText"],
        setup(props, { emit: emit2 }) {
          const store2 = useStore();
          const { getCanvasWidth, getCanvasHeight } = canvasHelper();
          const id = computed2(() => store2.getters.getSelectedCanvas);
          const templateColor = computed2(() => store2.getters.getTemplateColor);
          const text = ref(props.artwork.text);
          const color = ref({});
          if (!props.artwork.color) {
            color.value["hex"] = "#" + templateColor.value;
          }
          const align = ref(props.artwork.align);
          const font = ref(props.artwork.font);
          const cancel = () => {
            emit2("cancel");
          };
          const add = () => {
            let fontSize = 14;
            let textWidth = 0;
            var newText = new Text3({
              text: text.value,
              fontSize
              // start with a small font size
            });
            textWidth = newText.getTextWidth();
            while (textWidth > getCanvasWidth()) {
              fontSize -= 1;
              newText = new Text3({
                text,
                fontSize
              });
              textWidth = newText.getTextWidth();
            }
            const x = (getCanvasWidth() - textWidth) / 2;
            const y2 = (getCanvasHeight() - fontSize) / 2;
            if (!props.artwork.text) {
              store2.dispatch("saveArtworks", {
                type: "text",
                name: Math.random().toString(36).slice(2, 16),
                text: text.value,
                fontSize: 14,
                fontFamily: font.value,
                fill: color.value?.hex,
                x,
                y: y2,
                padding: 0,
                draggable: true,
                isSelected: false,
                align: align.value,
                verticalAlign: "middle"
              });
            } else {
              store2.dispatch("updateArtworks", {
                obj: {
                  text: text.value,
                  fontFamily: font.value,
                  fill: color.value?.hex,
                  x,
                  y: y2,
                  draggable: true,
                  isSelected: false,
                  align: align.value,
                  verticalAlign: "middle"
                },
                index: id.value
              });
            }
            emit2("cancel");
          };
          return {
            color,
            add,
            cancel,
            font,
            text,
            align
          };
        }
      };
      _hoisted_168 = { class: "mb-4 property" };
      _hoisted_248 = { class: "value" };
      _hoisted_336 = { class: "mb-4 configurator-custom-text__alignment" };
      _hoisted_429 = { class: "property" };
      _hoisted_520 = { class: "value" };
      _hoisted_616 = ["disabled"];
      _hoisted_715 = ["disabled"];
      _hoisted_811 = ["disabled"];
      _hoisted_910 = { class: "mb-4 property" };
      _hoisted_1010 = { class: "value" };
      _hoisted_1118 = { class: "select select--full" };
      _hoisted_1214 = { class: "my-4" };
      __default__35.render = render42;
      __default__35.__scopeId = "data-v-f2d7f811";
      canvas_text_default = __default__35;
    }
  });

  // vue-style:C:\fork\Baudville\src\vue\components\shared\selected-artwork.vue
  var init_selected_artwork = __esm({
    "vue-style:C:\\fork\\Baudville\\src\\vue\\components\\shared\\selected-artwork.vue"() {
    }
  });

  // src/vue/components/shared/selected-artwork.vue
  var selected_artwork_exports = {};
  __export(selected_artwork_exports, {
    default: () => selected_artwork_default,
    render: () => render43
  });
  function render43(_ctx, _cache) {
    const _component_CanvasText = resolveComponent("CanvasText");
    return openBlock(), createElementBlock("div", _hoisted_169, [
      createBaseVNode("div", _hoisted_249, [
        _ctx.canvas.type == "image" ? (openBlock(), createElementBlock("div", _hoisted_337, [
          createBaseVNode("div", _hoisted_430, [
            _cache[9] || (_cache[9] = createBaseVNode(
              "div",
              { class: "configurator-customizations__instructions heading heading--5" },
              " Uploaded logo will apply to all personalized kits. For no box logo, please click the green check below. ",
              -1
              /* CACHED */
            )),
            createBaseVNode("div", _hoisted_521, [
              createBaseVNode("div", _hoisted_617, [
                createBaseVNode(
                  "span",
                  _hoisted_716,
                  toDisplayString(_ctx.name(_ctx.canvas.image_path)),
                  1
                  /* TEXT */
                ),
                createBaseVNode("button", {
                  title: "Rotate 90 degrees clockwise",
                  class: "configurator-custom-graphic__control",
                  onClick: _cache[0] || (_cache[0] = ($event) => _ctx.rotate("clockwise"))
                }, [..._cache[6] || (_cache[6] = [
                  createBaseVNode(
                    "svg",
                    {
                      title: "Rotate 90 degrees clockwise",
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "481.95",
                      height: "481.95",
                      viewBox: "0 0 481.95 481.95",
                      class: "svg-icon svg-icon--font-color"
                    },
                    [
                      createBaseVNode("path", { d: "M331.5 114.75L216.75 0v79.05C117.3 91.8 38.25 175.95 38.25 280.5s79.05 188.7 178.5 201.45v-51C145.35 418.2 89.25 357 89.25 280.5s56.1-137.7 127.5-150.45v99.45L331.5 114.75zM443.7 255c-5.101-35.7-17.851-68.85-40.8-99.45l-35.7 35.7c12.75 20.4 22.95 40.8 25.5 63.75h51zM267.75 430.95v51c35.7-5.101 68.85-17.851 99.45-40.8l-35.7-35.7c-20.4 12.75-40.8 22.95-63.75 25.5zm99.45-61.2l35.7 35.7c22.949-30.601 38.25-63.75 40.8-99.45h-51c-2.55 22.95-12.75 43.35-25.5 63.75z" })
                    ],
                    -1
                    /* CACHED */
                  )
                ])]),
                createBaseVNode("button", {
                  title: "Rotate 90 degrees counter clockwise",
                  class: "configurator-custom-graphic__control",
                  onClick: _cache[1] || (_cache[1] = ($event) => _ctx.rotate("counter-clockwise"))
                }, [..._cache[7] || (_cache[7] = [
                  createBaseVNode(
                    "svg",
                    {
                      title: "Rotate 90 degrees counter clockwise",
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "481.95",
                      height: "481.95",
                      viewBox: "0 0 481.95 481.95",
                      class: "svg-icon svg-icon--font-color"
                    },
                    [
                      createBaseVNode("path", { d: "M114.75 191.25l-35.7-35.7C56.1 186.15 40.8 219.3 38.25 255h51c2.55-22.95 12.75-43.35 25.5-63.75zM89.25 306h-51c5.1 35.7 17.85 68.85 40.8 99.45l35.7-35.7C102 349.35 91.8 328.95 89.25 306zm25.5 135.15c30.6 22.949 63.75 35.699 99.45 40.8v-51c-22.95-2.55-43.35-12.75-63.75-25.5l-35.7 35.7zM265.2 79.05V0L150.45 114.75 265.2 229.5v-99.45C336.6 142.8 392.7 204 392.7 280.5s-56.1 137.7-127.5 150.45v51c99.45-12.75 178.5-99.45 178.5-201.45S364.65 91.8 265.2 79.05z" })
                    ],
                    -1
                    /* CACHED */
                  )
                ])])
              ]),
              createBaseVNode("button", {
                class: "text-button",
                onClick: _cache[2] || (_cache[2] = (...args) => _ctx.cancel && _ctx.cancel(...args))
              }, " Cancel "),
              _cache[8] || (_cache[8] = createBaseVNode(
                "span",
                null,
                "\xA0",
                -1
                /* CACHED */
              )),
              createBaseVNode("button", {
                class: "button",
                onClick: _cache[3] || (_cache[3] = (...args) => _ctx.save && _ctx.save(...args))
              }, " Done ")
            ]),
            createBaseVNode("p", {
              class: "configurator-customizations__remove-layer",
              onClick: _cache[4] || (_cache[4] = (...args) => _ctx.remove && _ctx.remove(...args))
            }, " Remove Layer ")
          ])
        ])) : createCommentVNode("v-if", true),
        _ctx.canvas.type == "text" ? (openBlock(), createElementBlock("div", _hoisted_812, [
          createVNode(_component_CanvasText, {
            artwork: _ctx.canvas,
            onCancel: _ctx.cancel,
            onSaveText: _ctx.saveText
          }, null, 8, ["artwork", "onCancel", "onSaveText"]),
          createBaseVNode("p", {
            class: "configurator-customizations__remove-layer",
            onClick: _cache[5] || (_cache[5] = (...args) => _ctx.remove && _ctx.remove(...args))
          }, " Remove Layer ")
        ])) : createCommentVNode("v-if", true)
      ])
    ]);
  }
  var __default__36, _hoisted_169, _hoisted_249, _hoisted_337, _hoisted_430, _hoisted_521, _hoisted_617, _hoisted_716, _hoisted_812, selected_artwork_default;
  var init_selected_artwork2 = __esm({
    "src/vue/components/shared/selected-artwork.vue"() {
      "use strict";
      init_vuex_esm_bundler();
      init_vue_esm_bundler();
      init_canvas_text2();
      init_vue_esm_bundler();
      init_selected_artwork();
      __default__36 = {
        components: { CanvasText: canvas_text_default },
        setup() {
          const store2 = useStore();
          const id = computed2(() => store2.getters.getSelectedCanvas);
          const image = ref(null);
          const canvas = computed2(() => store2.getters.getCanvasById(id.value));
          const cancel = () => {
            if (image.value) {
              store2.dispatch("updateArtworks", {
                obj: image.value,
                index: id.value
              });
            }
            store2.dispatch("saveSelectedCanvas", -1);
          };
          const save = () => {
            store2.dispatch("saveSelectedCanvas", -1);
          };
          const saveText = () => {
            store2.dispatch("saveSelectedCanvas", -1);
          };
          const name = (path) => {
            return path?.substring(14)?.split(".")[0];
          };
          const rotate = (direction = "clockwise") => {
            const img = { ...canvas.value };
            if (direction === "clockwise") {
              img.rotation += 90;
            } else {
              img.rotation -= 90;
            }
            img.offsetX = img.width / 2;
            img.offsetY = img.height / 2;
            img.x = img.width / 2;
            img.y = img.height / 2;
            store2.dispatch("updateArtworks", {
              obj: img,
              index: id.value
            });
          };
          const remove2 = () => {
            if (confirm("Are You Sure?")) {
              store2.dispatch("deleteArtworks", canvas.value.index);
              store2.dispatch("saveSelectedCanvas", -1);
            }
          };
          watch2(canvas, (n, o) => {
            if (!image.value) {
              image.value = { ...o };
            }
          });
          return {
            image,
            canvas,
            cancel,
            save,
            saveText,
            name,
            remove: remove2,
            rotate
          };
        }
      };
      _hoisted_169 = { class: "configurator-step__content" };
      _hoisted_249 = { class: "configurator-personalizations" };
      _hoisted_337 = {
        key: 0,
        index: "0"
      };
      _hoisted_430 = { class: "configurator-customizations hidden--for-small-only" };
      _hoisted_521 = { class: "configurator-custom-graphic configurator-custom-graphic--edit" };
      _hoisted_617 = { class: "configurator-custom-graphic__controls" };
      _hoisted_716 = { class: "block mb-2 configurator-custom-graphic__name" };
      _hoisted_812 = {
        key: 1,
        index: "0"
      };
      __default__36.render = render43;
      __default__36.__scopeId = "data-v-2f98869b";
      selected_artwork_default = __default__36;
    }
  });

  // node_modules/sortablejs/Sortable.min.js
  var require_Sortable_min = __commonJS({
    "node_modules/sortablejs/Sortable.min.js"(exports, module) {
      /*! Sortable 1.14.0 - MIT | git://github.com/SortableJS/Sortable.git */
      !(function(t, e) {
        "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = t || self).Sortable = e();
      })(exports, function() {
        "use strict";
        function e(e2, t2) {
          var n2, o2 = Object.keys(e2);
          return Object.getOwnPropertySymbols && (n2 = Object.getOwnPropertySymbols(e2), t2 && (n2 = n2.filter(function(t3) {
            return Object.getOwnPropertyDescriptor(e2, t3).enumerable;
          })), o2.push.apply(o2, n2)), o2;
        }
        function A(o2) {
          for (var t2 = 1; t2 < arguments.length; t2++) {
            var i3 = null != arguments[t2] ? arguments[t2] : {};
            t2 % 2 ? e(Object(i3), true).forEach(function(t3) {
              var e2, n2;
              e2 = o2, t3 = i3[n2 = t3], n2 in e2 ? Object.defineProperty(e2, n2, { value: t3, enumerable: true, configurable: true, writable: true }) : e2[n2] = t3;
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o2, Object.getOwnPropertyDescriptors(i3)) : e(Object(i3)).forEach(function(t3) {
              Object.defineProperty(o2, t3, Object.getOwnPropertyDescriptor(i3, t3));
            });
          }
          return o2;
        }
        function o(t2) {
          return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t3) {
            return typeof t3;
          } : function(t3) {
            return t3 && "function" == typeof Symbol && t3.constructor === Symbol && t3 !== Symbol.prototype ? "symbol" : typeof t3;
          })(t2);
        }
        function a() {
          return (a = Object.assign || function(t2) {
            for (var e2 = 1; e2 < arguments.length; e2++) {
              var n2, o2 = arguments[e2];
              for (n2 in o2) Object.prototype.hasOwnProperty.call(o2, n2) && (t2[n2] = o2[n2]);
            }
            return t2;
          }).apply(this, arguments);
        }
        function i2(t2, e2) {
          if (null == t2) return {};
          var n2, o2 = (function(t3, e3) {
            if (null == t3) return {};
            for (var n3, o3 = {}, i4 = Object.keys(t3), r3 = 0; r3 < i4.length; r3++) n3 = i4[r3], 0 <= e3.indexOf(n3) || (o3[n3] = t3[n3]);
            return o3;
          })(t2, e2);
          if (Object.getOwnPropertySymbols) for (var i3 = Object.getOwnPropertySymbols(t2), r2 = 0; r2 < i3.length; r2++) n2 = i3[r2], 0 <= e2.indexOf(n2) || Object.prototype.propertyIsEnumerable.call(t2, n2) && (o2[n2] = t2[n2]);
          return o2;
        }
        function r(t2) {
          return (function(t3) {
            if (Array.isArray(t3)) return l(t3);
          })(t2) || (function(t3) {
            if ("undefined" != typeof Symbol && null != t3[Symbol.iterator] || null != t3["@@iterator"]) return Array.from(t3);
          })(t2) || (function(t3, e2) {
            if (t3) {
              if ("string" == typeof t3) return l(t3, e2);
              var n2 = Object.prototype.toString.call(t3).slice(8, -1);
              return "Map" === (n2 = "Object" === n2 && t3.constructor ? t3.constructor.name : n2) || "Set" === n2 ? Array.from(t3) : "Arguments" === n2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2) ? l(t3, e2) : void 0;
            }
          })(t2) || (function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          })();
        }
        function l(t2, e2) {
          (null == e2 || e2 > t2.length) && (e2 = t2.length);
          for (var n2 = 0, o2 = new Array(e2); n2 < e2; n2++) o2[n2] = t2[n2];
          return o2;
        }
        function t(t2) {
          if ("undefined" != typeof window && window.navigator) return !!navigator.userAgent.match(t2);
        }
        var y2 = t(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), w = t(/Edge/i), s = t(/firefox/i), u2 = t(/safari/i) && !t(/chrome/i) && !t(/android/i), n = t(/iP(ad|od|hone)/i), c = t(/chrome/i) && t(/android/i), d = { capture: false, passive: false };
        function h2(t2, e2, n2) {
          t2.addEventListener(e2, n2, !y2 && d);
        }
        function f(t2, e2, n2) {
          t2.removeEventListener(e2, n2, !y2 && d);
        }
        function p2(t2, e2) {
          if (e2 && (">" === e2[0] && (e2 = e2.substring(1)), t2)) try {
            if (t2.matches) return t2.matches(e2);
            if (t2.msMatchesSelector) return t2.msMatchesSelector(e2);
            if (t2.webkitMatchesSelector) return t2.webkitMatchesSelector(e2);
          } catch (t3) {
            return;
          }
        }
        function N(t2, e2, n2, o2) {
          if (t2) {
            n2 = n2 || document;
            do {
              if (null != e2 && (">" !== e2[0] || t2.parentNode === n2) && p2(t2, e2) || o2 && t2 === n2) return t2;
            } while (t2 !== n2 && (t2 = (i3 = t2).host && i3 !== document && i3.host.nodeType ? i3.host : i3.parentNode));
          }
          var i3;
          return null;
        }
        var g, m = /\s+/g;
        function I2(t2, e2, n2) {
          var o2;
          t2 && e2 && (t2.classList ? t2.classList[n2 ? "add" : "remove"](e2) : (o2 = (" " + t2.className + " ").replace(m, " ").replace(" " + e2 + " ", " "), t2.className = (o2 + (n2 ? " " + e2 : "")).replace(m, " ")));
        }
        function P2(t2, e2, n2) {
          var o2 = t2 && t2.style;
          if (o2) {
            if (void 0 === n2) return document.defaultView && document.defaultView.getComputedStyle ? n2 = document.defaultView.getComputedStyle(t2, "") : t2.currentStyle && (n2 = t2.currentStyle), void 0 === e2 ? n2 : n2[e2];
            o2[e2 = !(e2 in o2 || -1 !== e2.indexOf("webkit")) ? "-webkit-" + e2 : e2] = n2 + ("string" == typeof n2 ? "" : "px");
          }
        }
        function v(t2, e2) {
          var n2 = "";
          if ("string" == typeof t2) n2 = t2;
          else do {
            var o2 = P2(t2, "transform");
          } while (o2 && "none" !== o2 && (n2 = o2 + " " + n2), !e2 && (t2 = t2.parentNode));
          var i3 = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
          return i3 && new i3(n2);
        }
        function b2(t2, e2, n2) {
          if (t2) {
            var o2 = t2.getElementsByTagName(e2), i3 = 0, r2 = o2.length;
            if (n2) for (; i3 < r2; i3++) n2(o2[i3], i3);
            return o2;
          }
          return [];
        }
        function O() {
          var t2 = document.scrollingElement;
          return t2 || document.documentElement;
        }
        function k(t2, e2, n2, o2, i3) {
          if (t2.getBoundingClientRect || t2 === window) {
            var r2, a2, l2, s2, c2, u3, d2 = t2 !== window && t2.parentNode && t2 !== O() ? (a2 = (r2 = t2.getBoundingClientRect()).top, l2 = r2.left, s2 = r2.bottom, c2 = r2.right, u3 = r2.height, r2.width) : (l2 = a2 = 0, s2 = window.innerHeight, c2 = window.innerWidth, u3 = window.innerHeight, window.innerWidth);
            if ((e2 || n2) && t2 !== window && (i3 = i3 || t2.parentNode, !y2)) do {
              if (i3 && i3.getBoundingClientRect && ("none" !== P2(i3, "transform") || n2 && "static" !== P2(i3, "position"))) {
                var h3 = i3.getBoundingClientRect();
                a2 -= h3.top + parseInt(P2(i3, "border-top-width")), l2 -= h3.left + parseInt(P2(i3, "border-left-width")), s2 = a2 + r2.height, c2 = l2 + r2.width;
                break;
              }
            } while (i3 = i3.parentNode);
            return o2 && t2 !== window && (o2 = (e2 = v(i3 || t2)) && e2.a, t2 = e2 && e2.d, e2 && (s2 = (a2 /= t2) + (u3 /= t2), c2 = (l2 /= o2) + (d2 /= o2))), { top: a2, left: l2, bottom: s2, right: c2, width: d2, height: u3 };
          }
        }
        function R2(t2, e2, n2) {
          for (var o2 = M2(t2, true), i3 = k(t2)[e2]; o2; ) {
            var r2 = k(o2)[n2];
            if (!("top" === n2 || "left" === n2 ? r2 <= i3 : i3 <= r2)) return o2;
            if (o2 === O()) break;
            o2 = M2(o2, false);
          }
          return false;
        }
        function X2(t2, e2, n2, o2) {
          for (var i3 = 0, r2 = 0, a2 = t2.children; r2 < a2.length; ) {
            if ("none" !== a2[r2].style.display && a2[r2] !== Bt.ghost && (o2 || a2[r2] !== Bt.dragged) && N(a2[r2], n2.draggable, t2, false)) {
              if (i3 === e2) return a2[r2];
              i3++;
            }
            r2++;
          }
          return null;
        }
        function Y2(t2, e2) {
          for (var n2 = t2.lastElementChild; n2 && (n2 === Bt.ghost || "none" === P2(n2, "display") || e2 && !p2(n2, e2)); ) n2 = n2.previousElementSibling;
          return n2 || null;
        }
        function B2(t2, e2) {
          var n2 = 0;
          if (!t2 || !t2.parentNode) return -1;
          for (; t2 = t2.previousElementSibling; ) "TEMPLATE" === t2.nodeName.toUpperCase() || t2 === Bt.clone || e2 && !p2(t2, e2) || n2++;
          return n2;
        }
        function E(t2) {
          var e2 = 0, n2 = 0, o2 = O();
          if (t2) do {
            var i3 = v(t2), r2 = i3.a, i3 = i3.d;
          } while (e2 += t2.scrollLeft * r2, n2 += t2.scrollTop * i3, t2 !== o2 && (t2 = t2.parentNode));
          return [e2, n2];
        }
        function M2(t2, e2) {
          if (!t2 || !t2.getBoundingClientRect) return O();
          var n2 = t2, o2 = false;
          do {
            if (n2.clientWidth < n2.scrollWidth || n2.clientHeight < n2.scrollHeight) {
              var i3 = P2(n2);
              if (n2.clientWidth < n2.scrollWidth && ("auto" == i3.overflowX || "scroll" == i3.overflowX) || n2.clientHeight < n2.scrollHeight && ("auto" == i3.overflowY || "scroll" == i3.overflowY)) {
                if (!n2.getBoundingClientRect || n2 === document.body) return O();
                if (o2 || e2) return n2;
                o2 = true;
              }
            }
          } while (n2 = n2.parentNode);
          return O();
        }
        function D2(t2, e2) {
          return Math.round(t2.top) === Math.round(e2.top) && Math.round(t2.left) === Math.round(e2.left) && Math.round(t2.height) === Math.round(e2.height) && Math.round(t2.width) === Math.round(e2.width);
        }
        function S2(e2, n2) {
          return function() {
            var t2;
            g || (1 === (t2 = arguments).length ? e2.call(this, t2[0]) : e2.apply(this, t2), g = setTimeout(function() {
              g = void 0;
            }, n2));
          };
        }
        function F2(t2, e2, n2) {
          t2.scrollLeft += e2, t2.scrollTop += n2;
        }
        function _2(t2) {
          var e2 = window.Polymer, n2 = window.jQuery || window.Zepto;
          return e2 && e2.dom ? e2.dom(t2).cloneNode(true) : n2 ? n2(t2).clone(true)[0] : t2.cloneNode(true);
        }
        function C(t2, e2) {
          P2(t2, "position", "absolute"), P2(t2, "top", e2.top), P2(t2, "left", e2.left), P2(t2, "width", e2.width), P2(t2, "height", e2.height);
        }
        function T2(t2) {
          P2(t2, "position", ""), P2(t2, "top", ""), P2(t2, "left", ""), P2(t2, "width", ""), P2(t2, "height", "");
        }
        var j = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
        function x() {
          var e2, o2 = [];
          return { captureAnimationState: function() {
            o2 = [], this.options.animation && [].slice.call(this.el.children).forEach(function(t2) {
              var e3, n2;
              "none" !== P2(t2, "display") && t2 !== Bt.ghost && (o2.push({ target: t2, rect: k(t2) }), e3 = A({}, o2[o2.length - 1].rect), !t2.thisAnimationDuration || (n2 = v(t2, true)) && (e3.top -= n2.f, e3.left -= n2.e), t2.fromRect = e3);
            });
          }, addAnimationState: function(t2) {
            o2.push(t2);
          }, removeAnimationState: function(t2) {
            o2.splice((function(t3, e3) {
              for (var n2 in t3) if (t3.hasOwnProperty(n2)) {
                for (var o3 in e3) if (e3.hasOwnProperty(o3) && e3[o3] === t3[n2][o3]) return Number(n2);
              }
              return -1;
            })(o2, { target: t2 }), 1);
          }, animateAll: function(t2) {
            var c2 = this;
            if (!this.options.animation) return clearTimeout(e2), void ("function" == typeof t2 && t2());
            var u3 = false, d2 = 0;
            o2.forEach(function(t3) {
              var e3 = 0, n2 = t3.target, o3 = n2.fromRect, i3 = k(n2), r2 = n2.prevFromRect, a2 = n2.prevToRect, l2 = t3.rect, s2 = v(n2, true);
              s2 && (i3.top -= s2.f, i3.left -= s2.e), n2.toRect = i3, n2.thisAnimationDuration && D2(r2, i3) && !D2(o3, i3) && (l2.top - i3.top) / (l2.left - i3.left) == (o3.top - i3.top) / (o3.left - i3.left) && (t3 = l2, s2 = r2, r2 = a2, a2 = c2.options, e3 = Math.sqrt(Math.pow(s2.top - t3.top, 2) + Math.pow(s2.left - t3.left, 2)) / Math.sqrt(Math.pow(s2.top - r2.top, 2) + Math.pow(s2.left - r2.left, 2)) * a2.animation), D2(i3, o3) || (n2.prevFromRect = o3, n2.prevToRect = i3, e3 = e3 || c2.options.animation, c2.animate(n2, l2, i3, e3)), e3 && (u3 = true, d2 = Math.max(d2, e3), clearTimeout(n2.animationResetTimer), n2.animationResetTimer = setTimeout(function() {
                n2.animationTime = 0, n2.prevFromRect = null, n2.fromRect = null, n2.prevToRect = null, n2.thisAnimationDuration = null;
              }, e3), n2.thisAnimationDuration = e3);
            }), clearTimeout(e2), u3 ? e2 = setTimeout(function() {
              "function" == typeof t2 && t2();
            }, d2) : "function" == typeof t2 && t2(), o2 = [];
          }, animate: function(t2, e3, n2, o3) {
            var i3, r2;
            o3 && (P2(t2, "transition", ""), P2(t2, "transform", ""), i3 = (r2 = v(this.el)) && r2.a, r2 = r2 && r2.d, i3 = (e3.left - n2.left) / (i3 || 1), r2 = (e3.top - n2.top) / (r2 || 1), t2.animatingX = !!i3, t2.animatingY = !!r2, P2(t2, "transform", "translate3d(" + i3 + "px," + r2 + "px,0)"), this.forRepaintDummy = t2.offsetWidth, P2(t2, "transition", "transform " + o3 + "ms" + (this.options.easing ? " " + this.options.easing : "")), P2(t2, "transform", "translate3d(0,0,0)"), "number" == typeof t2.animated && clearTimeout(t2.animated), t2.animated = setTimeout(function() {
              P2(t2, "transition", ""), P2(t2, "transform", ""), t2.animated = false, t2.animatingX = false, t2.animatingY = false;
            }, o3));
          } };
        }
        var H2 = [], L = { initializeByDefault: true }, K = { mount: function(e2) {
          for (var t2 in L) !L.hasOwnProperty(t2) || t2 in e2 || (e2[t2] = L[t2]);
          H2.forEach(function(t3) {
            if (t3.pluginName === e2.pluginName) throw "Sortable: Cannot mount plugin ".concat(e2.pluginName, " more than once");
          }), H2.push(e2);
        }, pluginEvent: function(e2, n2, o2) {
          var t2 = this;
          this.eventCanceled = false, o2.cancel = function() {
            t2.eventCanceled = true;
          };
          var i3 = e2 + "Global";
          H2.forEach(function(t3) {
            n2[t3.pluginName] && (n2[t3.pluginName][i3] && n2[t3.pluginName][i3](A({ sortable: n2 }, o2)), n2.options[t3.pluginName] && n2[t3.pluginName][e2] && n2[t3.pluginName][e2](A({ sortable: n2 }, o2)));
          });
        }, initializePlugins: function(n2, o2, i3, t2) {
          for (var e2 in H2.forEach(function(t3) {
            var e3 = t3.pluginName;
            (n2.options[e3] || t3.initializeByDefault) && ((t3 = new t3(n2, o2, n2.options)).sortable = n2, t3.options = n2.options, n2[e3] = t3, a(i3, t3.defaults));
          }), n2.options) {
            var r2;
            n2.options.hasOwnProperty(e2) && (void 0 !== (r2 = this.modifyOption(n2, e2, n2.options[e2])) && (n2.options[e2] = r2));
          }
        }, getEventProperties: function(e2, n2) {
          var o2 = {};
          return H2.forEach(function(t2) {
            "function" == typeof t2.eventProperties && a(o2, t2.eventProperties.call(n2[t2.pluginName], e2));
          }), o2;
        }, modifyOption: function(e2, n2, o2) {
          var i3;
          return H2.forEach(function(t2) {
            e2[t2.pluginName] && t2.optionListeners && "function" == typeof t2.optionListeners[n2] && (i3 = t2.optionListeners[n2].call(e2[t2.pluginName], o2));
          }), i3;
        } };
        function W2(t2) {
          var e2 = t2.sortable, n2 = t2.rootEl, o2 = t2.name, i3 = t2.targetEl, r2 = t2.cloneEl, a2 = t2.toEl, l2 = t2.fromEl, s2 = t2.oldIndex, c2 = t2.newIndex, u3 = t2.oldDraggableIndex, d2 = t2.newDraggableIndex, h3 = t2.originalEvent, f2 = t2.putSortable, p3 = t2.extraEventProperties;
          if (e2 = e2 || n2 && n2[j]) {
            var g2, m2 = e2.options, t2 = "on" + o2.charAt(0).toUpperCase() + o2.substr(1);
            !window.CustomEvent || y2 || w ? (g2 = document.createEvent("Event")).initEvent(o2, true, true) : g2 = new CustomEvent(o2, { bubbles: true, cancelable: true }), g2.to = a2 || n2, g2.from = l2 || n2, g2.item = i3 || n2, g2.clone = r2, g2.oldIndex = s2, g2.newIndex = c2, g2.oldDraggableIndex = u3, g2.newDraggableIndex = d2, g2.originalEvent = h3, g2.pullMode = f2 ? f2.lastPutMode : void 0;
            var v2, b3 = A(A({}, p3), K.getEventProperties(o2, e2));
            for (v2 in b3) g2[v2] = b3[v2];
            n2 && n2.dispatchEvent(g2), m2[t2] && m2[t2].call(e2, g2);
          }
        }
        function z2(t2, e2) {
          var n2 = (o2 = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {}).evt, o2 = i2(o2, G3);
          K.pluginEvent.bind(Bt)(t2, e2, A({ dragEl: q2, parentEl: V, ghostEl: Z2, rootEl: $2, nextEl: Q2, lastDownEl: J2, cloneEl: tt2, cloneHidden: et, dragStarted: pt, putSortable: lt, activeSortable: Bt.active, originalEvent: n2, oldIndex: nt, oldDraggableIndex: it, newIndex: ot, newDraggableIndex: rt, hideGhostForTarget: kt, unhideGhostForTarget: Rt, cloneNowHidden: function() {
            et = true;
          }, cloneNowShown: function() {
            et = false;
          }, dispatchSortableEvent: function(t3) {
            U({ sortable: e2, name: t3, originalEvent: n2 });
          } }, o2));
        }
        var G3 = ["evt"];
        function U(t2) {
          W2(A({ putSortable: lt, cloneEl: tt2, targetEl: q2, rootEl: $2, oldIndex: nt, oldDraggableIndex: it, newIndex: ot, newDraggableIndex: rt }, t2));
        }
        var q2, V, Z2, $2, Q2, J2, tt2, et, nt, ot, it, rt, at, lt, st, ct, ut, dt, ht, ft, pt, gt, mt, vt, bt, yt = false, wt = false, Et = [], Dt = false, St = false, _t = [], Ct = false, Tt = [], xt = "undefined" != typeof document, Ot = n, Mt = w || y2 ? "cssFloat" : "float", At = xt && !c && !n && "draggable" in document.createElement("div"), Nt = (function() {
          if (xt) {
            if (y2) return false;
            var t2 = document.createElement("x");
            return t2.style.cssText = "pointer-events:auto", "auto" === t2.style.pointerEvents;
          }
        })(), It = function(t2, e2) {
          var n2 = P2(t2), o2 = parseInt(n2.width) - parseInt(n2.paddingLeft) - parseInt(n2.paddingRight) - parseInt(n2.borderLeftWidth) - parseInt(n2.borderRightWidth), i3 = X2(t2, 0, e2), r2 = X2(t2, 1, e2), a2 = i3 && P2(i3), l2 = r2 && P2(r2), s2 = a2 && parseInt(a2.marginLeft) + parseInt(a2.marginRight) + k(i3).width, t2 = l2 && parseInt(l2.marginLeft) + parseInt(l2.marginRight) + k(r2).width;
          if ("flex" === n2.display) return "column" === n2.flexDirection || "column-reverse" === n2.flexDirection ? "vertical" : "horizontal";
          if ("grid" === n2.display) return n2.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
          if (i3 && a2.float && "none" !== a2.float) {
            e2 = "left" === a2.float ? "left" : "right";
            return !r2 || "both" !== l2.clear && l2.clear !== e2 ? "horizontal" : "vertical";
          }
          return i3 && ("block" === a2.display || "flex" === a2.display || "table" === a2.display || "grid" === a2.display || o2 <= s2 && "none" === n2[Mt] || r2 && "none" === n2[Mt] && o2 < s2 + t2) ? "vertical" : "horizontal";
        }, Pt = function(t2) {
          function l2(r2, a2) {
            return function(t3, e3, n3, o2) {
              var i3 = t3.options.group.name && e3.options.group.name && t3.options.group.name === e3.options.group.name;
              if (null == r2 && (a2 || i3)) return true;
              if (null == r2 || false === r2) return false;
              if (a2 && "clone" === r2) return r2;
              if ("function" == typeof r2) return l2(r2(t3, e3, n3, o2), a2)(t3, e3, n3, o2);
              e3 = (a2 ? t3 : e3).options.group.name;
              return true === r2 || "string" == typeof r2 && r2 === e3 || r2.join && -1 < r2.indexOf(e3);
            };
          }
          var e2 = {}, n2 = t2.group;
          n2 && "object" == o(n2) || (n2 = { name: n2 }), e2.name = n2.name, e2.checkPull = l2(n2.pull, true), e2.checkPut = l2(n2.put), e2.revertClone = n2.revertClone, t2.group = e2;
        }, kt = function() {
          !Nt && Z2 && P2(Z2, "display", "none");
        }, Rt = function() {
          !Nt && Z2 && P2(Z2, "display", "");
        };
        xt && document.addEventListener("click", function(t2) {
          if (wt) return t2.preventDefault(), t2.stopPropagation && t2.stopPropagation(), t2.stopImmediatePropagation && t2.stopImmediatePropagation(), wt = false;
        }, true);
        function Xt(t2) {
          if (q2) {
            t2 = t2.touches ? t2.touches[0] : t2;
            var e2 = (i3 = t2.clientX, r2 = t2.clientY, Et.some(function(t3) {
              var e3 = t3[j].options.emptyInsertThreshold;
              if (e3 && !Y2(t3)) {
                var n3 = k(t3), o3 = i3 >= n3.left - e3 && i3 <= n3.right + e3, e3 = r2 >= n3.top - e3 && r2 <= n3.bottom + e3;
                return o3 && e3 ? a2 = t3 : void 0;
              }
            }), a2);
            if (e2) {
              var n2, o2 = {};
              for (n2 in t2) t2.hasOwnProperty(n2) && (o2[n2] = t2[n2]);
              o2.target = o2.rootEl = e2, o2.preventDefault = void 0, o2.stopPropagation = void 0, e2[j]._onDragOver(o2);
            }
          }
          var i3, r2, a2;
        }
        function Yt(t2) {
          q2 && q2.parentNode[j]._isOutsideThisEl(t2.target);
        }
        function Bt(t2, e2) {
          if (!t2 || !t2.nodeType || 1 !== t2.nodeType) throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(t2));
          this.el = t2, this.options = e2 = a({}, e2), t2[j] = this;
          var n2, o2, i3 = { group: null, sort: true, disabled: false, store: null, handle: null, draggable: /^[uo]l$/i.test(t2.nodeName) ? ">li" : ">*", swapThreshold: 1, invertSwap: false, invertedSwapThreshold: null, removeCloneOnHide: true, direction: function() {
            return It(t2, this.options);
          }, ghostClass: "sortable-ghost", chosenClass: "sortable-chosen", dragClass: "sortable-drag", ignore: "a, img", filter: null, preventOnFilter: true, animation: 0, easing: null, setData: function(t3, e3) {
            t3.setData("Text", e3.textContent);
          }, dropBubble: false, dragoverBubble: false, dataIdAttr: "data-id", delay: 0, delayOnTouchOnly: false, touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1, forceFallback: false, fallbackClass: "sortable-fallback", fallbackOnBody: false, fallbackTolerance: 0, fallbackOffset: { x: 0, y: 0 }, supportPointer: false !== Bt.supportPointer && "PointerEvent" in window && !u2, emptyInsertThreshold: 5 };
          for (n2 in K.initializePlugins(this, t2, i3), i3) n2 in e2 || (e2[n2] = i3[n2]);
          for (o2 in Pt(e2), this) "_" === o2.charAt(0) && "function" == typeof this[o2] && (this[o2] = this[o2].bind(this));
          this.nativeDraggable = !e2.forceFallback && At, this.nativeDraggable && (this.options.touchStartThreshold = 1), e2.supportPointer ? h2(t2, "pointerdown", this._onTapStart) : (h2(t2, "mousedown", this._onTapStart), h2(t2, "touchstart", this._onTapStart)), this.nativeDraggable && (h2(t2, "dragover", this), h2(t2, "dragenter", this)), Et.push(this.el), e2.store && e2.store.get && this.sort(e2.store.get(this) || []), a(this, x());
        }
        function Ft(t2, e2, n2, o2, i3, r2, a2, l2) {
          var s2, c2, u3 = t2[j], d2 = u3.options.onMove;
          return !window.CustomEvent || y2 || w ? (s2 = document.createEvent("Event")).initEvent("move", true, true) : s2 = new CustomEvent("move", { bubbles: true, cancelable: true }), s2.to = e2, s2.from = t2, s2.dragged = n2, s2.draggedRect = o2, s2.related = i3 || e2, s2.relatedRect = r2 || k(e2), s2.willInsertAfter = l2, s2.originalEvent = a2, t2.dispatchEvent(s2), c2 = d2 ? d2.call(u3, s2, a2) : c2;
        }
        function jt(t2) {
          t2.draggable = false;
        }
        function Ht() {
          Ct = false;
        }
        function Lt(t2) {
          return setTimeout(t2, 0);
        }
        function Kt(t2) {
          return clearTimeout(t2);
        }
        Bt.prototype = { constructor: Bt, _isOutsideThisEl: function(t2) {
          this.el.contains(t2) || t2 === this.el || (gt = null);
        }, _getDirection: function(t2, e2) {
          return "function" == typeof this.options.direction ? this.options.direction.call(this, t2, e2, q2) : this.options.direction;
        }, _onTapStart: function(e2) {
          if (e2.cancelable) {
            var n2 = this, o2 = this.el, t2 = this.options, i3 = t2.preventOnFilter, r2 = e2.type, a2 = e2.touches && e2.touches[0] || e2.pointerType && "touch" === e2.pointerType && e2, l2 = (a2 || e2).target, s2 = e2.target.shadowRoot && (e2.path && e2.path[0] || e2.composedPath && e2.composedPath()[0]) || l2, c2 = t2.filter;
            if (!(function(t3) {
              Tt.length = 0;
              var e3 = t3.getElementsByTagName("input"), n3 = e3.length;
              for (; n3--; ) {
                var o3 = e3[n3];
                o3.checked && Tt.push(o3);
              }
            })(o2), !q2 && !(/mousedown|pointerdown/.test(r2) && 0 !== e2.button || t2.disabled) && !s2.isContentEditable && (this.nativeDraggable || !u2 || !l2 || "SELECT" !== l2.tagName.toUpperCase()) && !((l2 = N(l2, t2.draggable, o2, false)) && l2.animated || J2 === l2)) {
              if (nt = B2(l2), it = B2(l2, t2.draggable), "function" == typeof c2) {
                if (c2.call(this, e2, l2, this)) return U({ sortable: n2, rootEl: s2, name: "filter", targetEl: l2, toEl: o2, fromEl: o2 }), z2("filter", n2, { evt: e2 }), void (i3 && e2.cancelable && e2.preventDefault());
              } else if (c2 = c2 && c2.split(",").some(function(t3) {
                if (t3 = N(s2, t3.trim(), o2, false)) return U({ sortable: n2, rootEl: t3, name: "filter", targetEl: l2, fromEl: o2, toEl: o2 }), z2("filter", n2, { evt: e2 }), true;
              })) return void (i3 && e2.cancelable && e2.preventDefault());
              t2.handle && !N(s2, t2.handle, o2, false) || this._prepareDragStart(e2, a2, l2);
            }
          }
        }, _prepareDragStart: function(t2, e2, n2) {
          var o2, i3 = this, r2 = i3.el, a2 = i3.options, l2 = r2.ownerDocument;
          n2 && !q2 && n2.parentNode === r2 && (o2 = k(n2), $2 = r2, V = (q2 = n2).parentNode, Q2 = q2.nextSibling, J2 = n2, at = a2.group, st = { target: Bt.dragged = q2, clientX: (e2 || t2).clientX, clientY: (e2 || t2).clientY }, ht = st.clientX - o2.left, ft = st.clientY - o2.top, this._lastX = (e2 || t2).clientX, this._lastY = (e2 || t2).clientY, q2.style["will-change"] = "all", o2 = function() {
            z2("delayEnded", i3, { evt: t2 }), Bt.eventCanceled ? i3._onDrop() : (i3._disableDelayedDragEvents(), !s && i3.nativeDraggable && (q2.draggable = true), i3._triggerDragStart(t2, e2), U({ sortable: i3, name: "choose", originalEvent: t2 }), I2(q2, a2.chosenClass, true));
          }, a2.ignore.split(",").forEach(function(t3) {
            b2(q2, t3.trim(), jt);
          }), h2(l2, "dragover", Xt), h2(l2, "mousemove", Xt), h2(l2, "touchmove", Xt), h2(l2, "mouseup", i3._onDrop), h2(l2, "touchend", i3._onDrop), h2(l2, "touchcancel", i3._onDrop), s && this.nativeDraggable && (this.options.touchStartThreshold = 4, q2.draggable = true), z2("delayStart", this, { evt: t2 }), !a2.delay || a2.delayOnTouchOnly && !e2 || this.nativeDraggable && (w || y2) ? o2() : Bt.eventCanceled ? this._onDrop() : (h2(l2, "mouseup", i3._disableDelayedDrag), h2(l2, "touchend", i3._disableDelayedDrag), h2(l2, "touchcancel", i3._disableDelayedDrag), h2(l2, "mousemove", i3._delayedDragTouchMoveHandler), h2(l2, "touchmove", i3._delayedDragTouchMoveHandler), a2.supportPointer && h2(l2, "pointermove", i3._delayedDragTouchMoveHandler), i3._dragStartTimer = setTimeout(o2, a2.delay)));
        }, _delayedDragTouchMoveHandler: function(t2) {
          t2 = t2.touches ? t2.touches[0] : t2;
          Math.max(Math.abs(t2.clientX - this._lastX), Math.abs(t2.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
        }, _disableDelayedDrag: function() {
          q2 && jt(q2), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
        }, _disableDelayedDragEvents: function() {
          var t2 = this.el.ownerDocument;
          f(t2, "mouseup", this._disableDelayedDrag), f(t2, "touchend", this._disableDelayedDrag), f(t2, "touchcancel", this._disableDelayedDrag), f(t2, "mousemove", this._delayedDragTouchMoveHandler), f(t2, "touchmove", this._delayedDragTouchMoveHandler), f(t2, "pointermove", this._delayedDragTouchMoveHandler);
        }, _triggerDragStart: function(t2, e2) {
          e2 = e2 || "touch" == t2.pointerType && t2, !this.nativeDraggable || e2 ? this.options.supportPointer ? h2(document, "pointermove", this._onTouchMove) : h2(document, e2 ? "touchmove" : "mousemove", this._onTouchMove) : (h2(q2, "dragend", this), h2($2, "dragstart", this._onDragStart));
          try {
            document.selection ? Lt(function() {
              document.selection.empty();
            }) : window.getSelection().removeAllRanges();
          } catch (t3) {
          }
        }, _dragStarted: function(t2, e2) {
          var n2;
          yt = false, $2 && q2 ? (z2("dragStarted", this, { evt: e2 }), this.nativeDraggable && h2(document, "dragover", Yt), n2 = this.options, t2 || I2(q2, n2.dragClass, false), I2(q2, n2.ghostClass, true), Bt.active = this, t2 && this._appendGhost(), U({ sortable: this, name: "start", originalEvent: e2 })) : this._nulling();
        }, _emulateDragOver: function() {
          if (ct) {
            this._lastX = ct.clientX, this._lastY = ct.clientY, kt();
            for (var t2 = document.elementFromPoint(ct.clientX, ct.clientY), e2 = t2; t2 && t2.shadowRoot && (t2 = t2.shadowRoot.elementFromPoint(ct.clientX, ct.clientY)) !== e2; ) e2 = t2;
            if (q2.parentNode[j]._isOutsideThisEl(t2), e2) do {
              if (e2[j]) {
                if (e2[j]._onDragOver({ clientX: ct.clientX, clientY: ct.clientY, target: t2, rootEl: e2 }) && !this.options.dragoverBubble) break;
              }
            } while (e2 = (t2 = e2).parentNode);
            Rt();
          }
        }, _onTouchMove: function(t2) {
          if (st) {
            var e2 = this.options, n2 = e2.fallbackTolerance, o2 = e2.fallbackOffset, i3 = t2.touches ? t2.touches[0] : t2, r2 = Z2 && v(Z2, true), a2 = Z2 && r2 && r2.a, l2 = Z2 && r2 && r2.d, e2 = Ot && bt && E(bt), a2 = (i3.clientX - st.clientX + o2.x) / (a2 || 1) + (e2 ? e2[0] - _t[0] : 0) / (a2 || 1), l2 = (i3.clientY - st.clientY + o2.y) / (l2 || 1) + (e2 ? e2[1] - _t[1] : 0) / (l2 || 1);
            if (!Bt.active && !yt) {
              if (n2 && Math.max(Math.abs(i3.clientX - this._lastX), Math.abs(i3.clientY - this._lastY)) < n2) return;
              this._onDragStart(t2, true);
            }
            Z2 && (r2 ? (r2.e += a2 - (ut || 0), r2.f += l2 - (dt || 0)) : r2 = { a: 1, b: 0, c: 0, d: 1, e: a2, f: l2 }, r2 = "matrix(".concat(r2.a, ",").concat(r2.b, ",").concat(r2.c, ",").concat(r2.d, ",").concat(r2.e, ",").concat(r2.f, ")"), P2(Z2, "webkitTransform", r2), P2(Z2, "mozTransform", r2), P2(Z2, "msTransform", r2), P2(Z2, "transform", r2), ut = a2, dt = l2, ct = i3), t2.cancelable && t2.preventDefault();
          }
        }, _appendGhost: function() {
          if (!Z2) {
            var t2 = this.options.fallbackOnBody ? document.body : $2, e2 = k(q2, true, Ot, true, t2), n2 = this.options;
            if (Ot) {
              for (bt = t2; "static" === P2(bt, "position") && "none" === P2(bt, "transform") && bt !== document; ) bt = bt.parentNode;
              bt !== document.body && bt !== document.documentElement ? (bt === document && (bt = O()), e2.top += bt.scrollTop, e2.left += bt.scrollLeft) : bt = O(), _t = E(bt);
            }
            I2(Z2 = q2.cloneNode(true), n2.ghostClass, false), I2(Z2, n2.fallbackClass, true), I2(Z2, n2.dragClass, true), P2(Z2, "transition", ""), P2(Z2, "transform", ""), P2(Z2, "box-sizing", "border-box"), P2(Z2, "margin", 0), P2(Z2, "top", e2.top), P2(Z2, "left", e2.left), P2(Z2, "width", e2.width), P2(Z2, "height", e2.height), P2(Z2, "opacity", "0.8"), P2(Z2, "position", Ot ? "absolute" : "fixed"), P2(Z2, "zIndex", "100000"), P2(Z2, "pointerEvents", "none"), Bt.ghost = Z2, t2.appendChild(Z2), P2(Z2, "transform-origin", ht / parseInt(Z2.style.width) * 100 + "% " + ft / parseInt(Z2.style.height) * 100 + "%");
          }
        }, _onDragStart: function(t2, e2) {
          var n2 = this, o2 = t2.dataTransfer, i3 = n2.options;
          z2("dragStart", this, { evt: t2 }), Bt.eventCanceled ? this._onDrop() : (z2("setupClone", this), Bt.eventCanceled || ((tt2 = _2(q2)).draggable = false, tt2.style["will-change"] = "", this._hideClone(), I2(tt2, this.options.chosenClass, false), Bt.clone = tt2), n2.cloneId = Lt(function() {
            z2("clone", n2), Bt.eventCanceled || (n2.options.removeCloneOnHide || $2.insertBefore(tt2, q2), n2._hideClone(), U({ sortable: n2, name: "clone" }));
          }), e2 || I2(q2, i3.dragClass, true), e2 ? (wt = true, n2._loopId = setInterval(n2._emulateDragOver, 50)) : (f(document, "mouseup", n2._onDrop), f(document, "touchend", n2._onDrop), f(document, "touchcancel", n2._onDrop), o2 && (o2.effectAllowed = "move", i3.setData && i3.setData.call(n2, o2, q2)), h2(document, "drop", n2), P2(q2, "transform", "translateZ(0)")), yt = true, n2._dragStartId = Lt(n2._dragStarted.bind(n2, e2, t2)), h2(document, "selectstart", n2), pt = true, u2 && P2(document.body, "user-select", "none"));
        }, _onDragOver: function(n2) {
          var o2, i3, r2, t2, a2 = this.el, l2 = n2.target, e2 = this.options, s2 = e2.group, c2 = Bt.active, u3 = at === s2, d2 = e2.sort, h3 = lt || c2, f2 = this, p3 = false;
          if (!Ct) {
            if (void 0 !== n2.preventDefault && n2.cancelable && n2.preventDefault(), l2 = N(l2, e2.draggable, a2, true), T3("dragOver"), Bt.eventCanceled) return p3;
            if (q2.contains(n2.target) || l2.animated && l2.animatingX && l2.animatingY || f2._ignoreWhileAnimating === l2) return O2(false);
            if (wt = false, c2 && !e2.disabled && (u3 ? d2 || (i3 = V !== $2) : lt === this || (this.lastPutMode = at.checkPull(this, c2, q2, n2)) && s2.checkPut(this, c2, q2, n2))) {
              if (r2 = "vertical" === this._getDirection(n2, l2), o2 = k(q2), T3("dragOverValid"), Bt.eventCanceled) return p3;
              if (i3) return V = $2, x2(), this._hideClone(), T3("revert"), Bt.eventCanceled || (Q2 ? $2.insertBefore(q2, Q2) : $2.appendChild(q2)), O2(true);
              var g2 = Y2(a2, e2.draggable);
              if (!g2 || (function(t3, e3, n3) {
                n3 = k(Y2(n3.el, n3.options.draggable));
                return e3 ? t3.clientX > n3.right + 10 || t3.clientX <= n3.right && t3.clientY > n3.bottom && t3.clientX >= n3.left : t3.clientX > n3.right && t3.clientY > n3.top || t3.clientX <= n3.right && t3.clientY > n3.bottom + 10;
              })(n2, r2, this) && !g2.animated) {
                if (g2 === q2) return O2(false);
                if ((l2 = g2 && a2 === n2.target ? g2 : l2) && (w2 = k(l2)), false !== Ft($2, a2, q2, o2, l2, w2, n2, !!l2)) return x2(), a2.appendChild(q2), V = a2, M3(), O2(true);
              } else if (g2 && (function(t3, e3, n3) {
                n3 = k(X2(n3.el, 0, n3.options, true));
                return e3 ? t3.clientX < n3.left - 10 || t3.clientY < n3.top && t3.clientX < n3.right : t3.clientY < n3.top - 10 || t3.clientY < n3.bottom && t3.clientX < n3.left;
              })(n2, r2, this)) {
                var m2 = X2(a2, 0, e2, true);
                if (m2 === q2) return O2(false);
                if (w2 = k(l2 = m2), false !== Ft($2, a2, q2, o2, l2, w2, n2, false)) return x2(), a2.insertBefore(q2, m2), V = a2, M3(), O2(true);
              } else if (l2.parentNode === a2) {
                var v2, b3, y3, w2 = k(l2), E2 = q2.parentNode !== a2, D3 = (D3 = q2.animated && q2.toRect || o2, C2 = l2.animated && l2.toRect || w2, S3 = (t2 = r2) ? D3.left : D3.top, s2 = t2 ? D3.right : D3.bottom, g2 = t2 ? D3.width : D3.height, m2 = t2 ? C2.left : C2.top, D3 = t2 ? C2.right : C2.bottom, C2 = t2 ? C2.width : C2.height, !(S3 === m2 || s2 === D3 || S3 + g2 / 2 === m2 + C2 / 2)), S3 = r2 ? "top" : "left", g2 = R2(l2, "top", "top") || R2(q2, "top", "top"), m2 = g2 ? g2.scrollTop : void 0;
                if (gt !== l2 && (b3 = w2[S3], Dt = false, St = !D3 && e2.invertSwap || E2), 0 !== (v2 = (function(t3, e3, n3, o3, i4, r3, a3, l3) {
                  var s3 = o3 ? t3.clientY : t3.clientX, c3 = o3 ? n3.height : n3.width, t3 = o3 ? n3.top : n3.left, o3 = o3 ? n3.bottom : n3.right, n3 = false;
                  if (!a3) {
                    if (l3 && vt < c3 * i4) {
                      if (Dt = !Dt && (1 === mt ? t3 + c3 * r3 / 2 < s3 : s3 < o3 - c3 * r3 / 2) ? true : Dt) n3 = true;
                      else if (1 === mt ? s3 < t3 + vt : o3 - vt < s3) return -mt;
                    } else if (t3 + c3 * (1 - i4) / 2 < s3 && s3 < o3 - c3 * (1 - i4) / 2) return (function(t4) {
                      return B2(q2) < B2(t4) ? 1 : -1;
                    })(e3);
                  }
                  if ((n3 = n3 || a3) && (s3 < t3 + c3 * r3 / 2 || o3 - c3 * r3 / 2 < s3)) return t3 + c3 / 2 < s3 ? 1 : -1;
                  return 0;
                })(n2, l2, w2, r2, D3 ? 1 : e2.swapThreshold, null == e2.invertedSwapThreshold ? e2.swapThreshold : e2.invertedSwapThreshold, St, gt === l2))) for (var _3 = B2(q2); (y3 = V.children[_3 -= v2]) && ("none" === P2(y3, "display") || y3 === Z2); ) ;
                if (0 === v2 || y3 === l2) return O2(false);
                mt = v2;
                var C2 = (gt = l2).nextElementSibling, E2 = false, D3 = Ft($2, a2, q2, o2, l2, w2, n2, E2 = 1 === v2);
                if (false !== D3) return 1 !== D3 && -1 !== D3 || (E2 = 1 === D3), Ct = true, setTimeout(Ht, 30), x2(), E2 && !C2 ? a2.appendChild(q2) : l2.parentNode.insertBefore(q2, E2 ? C2 : l2), g2 && F2(g2, 0, m2 - g2.scrollTop), V = q2.parentNode, void 0 === b3 || St || (vt = Math.abs(b3 - k(l2)[S3])), M3(), O2(true);
              }
              if (a2.contains(q2)) return O2(false);
            }
            return false;
          }
          function T3(t3, e3) {
            z2(t3, f2, A({ evt: n2, isOwner: u3, axis: r2 ? "vertical" : "horizontal", revert: i3, dragRect: o2, targetRect: w2, canSort: d2, fromSortable: h3, target: l2, completed: O2, onMove: function(t4, e4) {
              return Ft($2, a2, q2, o2, t4, k(t4), n2, e4);
            }, changed: M3 }, e3));
          }
          function x2() {
            T3("dragOverAnimationCapture"), f2.captureAnimationState(), f2 !== h3 && h3.captureAnimationState();
          }
          function O2(t3) {
            return T3("dragOverCompleted", { insertion: t3 }), t3 && (u3 ? c2._hideClone() : c2._showClone(f2), f2 !== h3 && (I2(q2, (lt || c2).options.ghostClass, false), I2(q2, e2.ghostClass, true)), lt !== f2 && f2 !== Bt.active ? lt = f2 : f2 === Bt.active && lt && (lt = null), h3 === f2 && (f2._ignoreWhileAnimating = l2), f2.animateAll(function() {
              T3("dragOverAnimationComplete"), f2._ignoreWhileAnimating = null;
            }), f2 !== h3 && (h3.animateAll(), h3._ignoreWhileAnimating = null)), (l2 === q2 && !q2.animated || l2 === a2 && !l2.animated) && (gt = null), e2.dragoverBubble || n2.rootEl || l2 === document || (q2.parentNode[j]._isOutsideThisEl(n2.target), t3 || Xt(n2)), !e2.dragoverBubble && n2.stopPropagation && n2.stopPropagation(), p3 = true;
          }
          function M3() {
            ot = B2(q2), rt = B2(q2, e2.draggable), U({ sortable: f2, name: "change", toEl: a2, newIndex: ot, newDraggableIndex: rt, originalEvent: n2 });
          }
        }, _ignoreWhileAnimating: null, _offMoveEvents: function() {
          f(document, "mousemove", this._onTouchMove), f(document, "touchmove", this._onTouchMove), f(document, "pointermove", this._onTouchMove), f(document, "dragover", Xt), f(document, "mousemove", Xt), f(document, "touchmove", Xt);
        }, _offUpEvents: function() {
          var t2 = this.el.ownerDocument;
          f(t2, "mouseup", this._onDrop), f(t2, "touchend", this._onDrop), f(t2, "pointerup", this._onDrop), f(t2, "touchcancel", this._onDrop), f(document, "selectstart", this);
        }, _onDrop: function(t2) {
          var e2 = this.el, n2 = this.options;
          ot = B2(q2), rt = B2(q2, n2.draggable), z2("drop", this, { evt: t2 }), V = q2 && q2.parentNode, ot = B2(q2), rt = B2(q2, n2.draggable), Bt.eventCanceled || (Dt = St = yt = false, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), Kt(this.cloneId), Kt(this._dragStartId), this.nativeDraggable && (f(document, "drop", this), f(e2, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), u2 && P2(document.body, "user-select", ""), P2(q2, "transform", ""), t2 && (pt && (t2.cancelable && t2.preventDefault(), n2.dropBubble || t2.stopPropagation()), Z2 && Z2.parentNode && Z2.parentNode.removeChild(Z2), ($2 === V || lt && "clone" !== lt.lastPutMode) && tt2 && tt2.parentNode && tt2.parentNode.removeChild(tt2), q2 && (this.nativeDraggable && f(q2, "dragend", this), jt(q2), q2.style["will-change"] = "", pt && !yt && I2(q2, (lt || this).options.ghostClass, false), I2(q2, this.options.chosenClass, false), U({ sortable: this, name: "unchoose", toEl: V, newIndex: null, newDraggableIndex: null, originalEvent: t2 }), $2 !== V ? (0 <= ot && (U({ rootEl: V, name: "add", toEl: V, fromEl: $2, originalEvent: t2 }), U({ sortable: this, name: "remove", toEl: V, originalEvent: t2 }), U({ rootEl: V, name: "sort", toEl: V, fromEl: $2, originalEvent: t2 }), U({ sortable: this, name: "sort", toEl: V, originalEvent: t2 })), lt && lt.save()) : ot !== nt && 0 <= ot && (U({ sortable: this, name: "update", toEl: V, originalEvent: t2 }), U({ sortable: this, name: "sort", toEl: V, originalEvent: t2 })), Bt.active && (null != ot && -1 !== ot || (ot = nt, rt = it), U({ sortable: this, name: "end", toEl: V, originalEvent: t2 }), this.save())))), this._nulling();
        }, _nulling: function() {
          z2("nulling", this), $2 = q2 = V = Z2 = Q2 = tt2 = J2 = et = st = ct = pt = ot = rt = nt = it = gt = mt = lt = at = Bt.dragged = Bt.ghost = Bt.clone = Bt.active = null, Tt.forEach(function(t2) {
            t2.checked = true;
          }), Tt.length = ut = dt = 0;
        }, handleEvent: function(t2) {
          switch (t2.type) {
            case "drop":
            case "dragend":
              this._onDrop(t2);
              break;
            case "dragenter":
            case "dragover":
              q2 && (this._onDragOver(t2), (function(t3) {
                t3.dataTransfer && (t3.dataTransfer.dropEffect = "move");
                t3.cancelable && t3.preventDefault();
              })(t2));
              break;
            case "selectstart":
              t2.preventDefault();
          }
        }, toArray: function() {
          for (var t2, e2 = [], n2 = this.el.children, o2 = 0, i3 = n2.length, r2 = this.options; o2 < i3; o2++) N(t2 = n2[o2], r2.draggable, this.el, false) && e2.push(t2.getAttribute(r2.dataIdAttr) || (function(t3) {
            var e3 = t3.tagName + t3.className + t3.src + t3.href + t3.textContent, n3 = e3.length, o3 = 0;
            for (; n3--; ) o3 += e3.charCodeAt(n3);
            return o3.toString(36);
          })(t2));
          return e2;
        }, sort: function(t2, e2) {
          var n2 = {}, o2 = this.el;
          this.toArray().forEach(function(t3, e3) {
            e3 = o2.children[e3];
            N(e3, this.options.draggable, o2, false) && (n2[t3] = e3);
          }, this), e2 && this.captureAnimationState(), t2.forEach(function(t3) {
            n2[t3] && (o2.removeChild(n2[t3]), o2.appendChild(n2[t3]));
          }), e2 && this.animateAll();
        }, save: function() {
          var t2 = this.options.store;
          t2 && t2.set && t2.set(this);
        }, closest: function(t2, e2) {
          return N(t2, e2 || this.options.draggable, this.el, false);
        }, option: function(t2, e2) {
          var n2 = this.options;
          if (void 0 === e2) return n2[t2];
          var o2 = K.modifyOption(this, t2, e2);
          n2[t2] = void 0 !== o2 ? o2 : e2, "group" === t2 && Pt(n2);
        }, destroy: function() {
          z2("destroy", this);
          var t2 = this.el;
          t2[j] = null, f(t2, "mousedown", this._onTapStart), f(t2, "touchstart", this._onTapStart), f(t2, "pointerdown", this._onTapStart), this.nativeDraggable && (f(t2, "dragover", this), f(t2, "dragenter", this)), Array.prototype.forEach.call(t2.querySelectorAll("[draggable]"), function(t3) {
            t3.removeAttribute("draggable");
          }), this._onDrop(), this._disableDelayedDragEvents(), Et.splice(Et.indexOf(this.el), 1), this.el = t2 = null;
        }, _hideClone: function() {
          et || (z2("hideClone", this), Bt.eventCanceled || (P2(tt2, "display", "none"), this.options.removeCloneOnHide && tt2.parentNode && tt2.parentNode.removeChild(tt2), et = true));
        }, _showClone: function(t2) {
          "clone" === t2.lastPutMode ? et && (z2("showClone", this), Bt.eventCanceled || (q2.parentNode != $2 || this.options.group.revertClone ? Q2 ? $2.insertBefore(tt2, Q2) : $2.appendChild(tt2) : $2.insertBefore(tt2, q2), this.options.group.revertClone && this.animate(q2, tt2), P2(tt2, "display", ""), et = false)) : this._hideClone();
        } }, xt && h2(document, "touchmove", function(t2) {
          (Bt.active || yt) && t2.cancelable && t2.preventDefault();
        }), Bt.utils = { on: h2, off: f, css: P2, find: b2, is: function(t2, e2) {
          return !!N(t2, e2, t2, false);
        }, extend: function(t2, e2) {
          if (t2 && e2) for (var n2 in e2) e2.hasOwnProperty(n2) && (t2[n2] = e2[n2]);
          return t2;
        }, throttle: S2, closest: N, toggleClass: I2, clone: _2, index: B2, nextTick: Lt, cancelNextTick: Kt, detectDirection: It, getChild: X2 }, Bt.get = function(t2) {
          return t2[j];
        }, Bt.mount = function() {
          for (var t2 = arguments.length, e2 = new Array(t2), n2 = 0; n2 < t2; n2++) e2[n2] = arguments[n2];
          (e2 = e2[0].constructor === Array ? e2[0] : e2).forEach(function(t3) {
            if (!t3.prototype || !t3.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(t3));
            t3.utils && (Bt.utils = A(A({}, Bt.utils), t3.utils)), K.mount(t3);
          });
        }, Bt.create = function(t2, e2) {
          return new Bt(t2, e2);
        };
        var Wt, zt, Gt, Ut, qt, Vt, Zt = [], $t = !(Bt.version = "1.14.0");
        function Qt() {
          Zt.forEach(function(t2) {
            clearInterval(t2.pid);
          }), Zt = [];
        }
        function Jt() {
          clearInterval(Vt);
        }
        var te2, ee2 = S2(function(n2, t2, e2, o2) {
          if (t2.scroll) {
            var i3, r2 = (n2.touches ? n2.touches[0] : n2).clientX, a2 = (n2.touches ? n2.touches[0] : n2).clientY, l2 = t2.scrollSensitivity, s2 = t2.scrollSpeed, c2 = O(), u3 = false;
            zt !== e2 && (zt = e2, Qt(), Wt = t2.scroll, i3 = t2.scrollFn, true === Wt && (Wt = M2(e2, true)));
            var d2 = 0, h3 = Wt;
            do {
              var f2 = h3, p3 = k(f2), g2 = p3.top, m2 = p3.bottom, v2 = p3.left, b3 = p3.right, y3 = p3.width, w2 = p3.height, E2 = void 0, D3 = void 0, S3 = f2.scrollWidth, _3 = f2.scrollHeight, C2 = P2(f2), T3 = f2.scrollLeft, p3 = f2.scrollTop, D3 = f2 === c2 ? (E2 = y3 < S3 && ("auto" === C2.overflowX || "scroll" === C2.overflowX || "visible" === C2.overflowX), w2 < _3 && ("auto" === C2.overflowY || "scroll" === C2.overflowY || "visible" === C2.overflowY)) : (E2 = y3 < S3 && ("auto" === C2.overflowX || "scroll" === C2.overflowX), w2 < _3 && ("auto" === C2.overflowY || "scroll" === C2.overflowY)), T3 = E2 && (Math.abs(b3 - r2) <= l2 && T3 + y3 < S3) - (Math.abs(v2 - r2) <= l2 && !!T3), p3 = D3 && (Math.abs(m2 - a2) <= l2 && p3 + w2 < _3) - (Math.abs(g2 - a2) <= l2 && !!p3);
              if (!Zt[d2]) for (var x2 = 0; x2 <= d2; x2++) Zt[x2] || (Zt[x2] = {});
              Zt[d2].vx == T3 && Zt[d2].vy == p3 && Zt[d2].el === f2 || (Zt[d2].el = f2, Zt[d2].vx = T3, Zt[d2].vy = p3, clearInterval(Zt[d2].pid), 0 == T3 && 0 == p3 || (u3 = true, Zt[d2].pid = setInterval(function() {
                o2 && 0 === this.layer && Bt.active._onTouchMove(qt);
                var t3 = Zt[this.layer].vy ? Zt[this.layer].vy * s2 : 0, e3 = Zt[this.layer].vx ? Zt[this.layer].vx * s2 : 0;
                "function" == typeof i3 && "continue" !== i3.call(Bt.dragged.parentNode[j], e3, t3, n2, qt, Zt[this.layer].el) || F2(Zt[this.layer].el, e3, t3);
              }.bind({ layer: d2 }), 24))), d2++;
            } while (t2.bubbleScroll && h3 !== c2 && (h3 = M2(h3, false)));
            $t = u3;
          }
        }, 30), n = function(t2) {
          var e2 = t2.originalEvent, n2 = t2.putSortable, o2 = t2.dragEl, i3 = t2.activeSortable, r2 = t2.dispatchSortableEvent, a2 = t2.hideGhostForTarget, t2 = t2.unhideGhostForTarget;
          e2 && (i3 = n2 || i3, a2(), e2 = e2.changedTouches && e2.changedTouches.length ? e2.changedTouches[0] : e2, e2 = document.elementFromPoint(e2.clientX, e2.clientY), t2(), i3 && !i3.el.contains(e2) && (r2("spill"), this.onSpill({ dragEl: o2, putSortable: n2 })));
        };
        function ne2() {
        }
        function oe2() {
        }
        ne2.prototype = { startIndex: null, dragStart: function(t2) {
          t2 = t2.oldDraggableIndex;
          this.startIndex = t2;
        }, onSpill: function(t2) {
          var e2 = t2.dragEl, n2 = t2.putSortable;
          this.sortable.captureAnimationState(), n2 && n2.captureAnimationState();
          t2 = X2(this.sortable.el, this.startIndex, this.options);
          t2 ? this.sortable.el.insertBefore(e2, t2) : this.sortable.el.appendChild(e2), this.sortable.animateAll(), n2 && n2.animateAll();
        }, drop: n }, a(ne2, { pluginName: "revertOnSpill" }), oe2.prototype = { onSpill: function(t2) {
          var e2 = t2.dragEl, t2 = t2.putSortable || this.sortable;
          t2.captureAnimationState(), e2.parentNode && e2.parentNode.removeChild(e2), t2.animateAll();
        }, drop: n }, a(oe2, { pluginName: "removeOnSpill" });
        var ie2, re2, ae2, le2, se2, ce2 = [], ue2 = [], de2 = false, he = false, fe2 = false;
        function pe2(n2, o2) {
          ue2.forEach(function(t2, e2) {
            e2 = o2.children[t2.sortableIndex + (n2 ? Number(e2) : 0)];
            e2 ? o2.insertBefore(t2, e2) : o2.appendChild(t2);
          });
        }
        function ge2() {
          ce2.forEach(function(t2) {
            t2 !== ae2 && t2.parentNode && t2.parentNode.removeChild(t2);
          });
        }
        return Bt.mount(new function() {
          function t2() {
            for (var t3 in this.defaults = { scroll: true, forceAutoScrollFallback: false, scrollSensitivity: 30, scrollSpeed: 10, bubbleScroll: true }, this) "_" === t3.charAt(0) && "function" == typeof this[t3] && (this[t3] = this[t3].bind(this));
          }
          return t2.prototype = { dragStarted: function(t3) {
            t3 = t3.originalEvent;
            this.sortable.nativeDraggable ? h2(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? h2(document, "pointermove", this._handleFallbackAutoScroll) : t3.touches ? h2(document, "touchmove", this._handleFallbackAutoScroll) : h2(document, "mousemove", this._handleFallbackAutoScroll);
          }, dragOverCompleted: function(t3) {
            t3 = t3.originalEvent;
            this.options.dragOverBubble || t3.rootEl || this._handleAutoScroll(t3);
          }, drop: function() {
            this.sortable.nativeDraggable ? f(document, "dragover", this._handleAutoScroll) : (f(document, "pointermove", this._handleFallbackAutoScroll), f(document, "touchmove", this._handleFallbackAutoScroll), f(document, "mousemove", this._handleFallbackAutoScroll)), Jt(), Qt(), clearTimeout(g), g = void 0;
          }, nulling: function() {
            qt = zt = Wt = $t = Vt = Gt = Ut = null, Zt.length = 0;
          }, _handleFallbackAutoScroll: function(t3) {
            this._handleAutoScroll(t3, true);
          }, _handleAutoScroll: function(e2, n2) {
            var o2, i3 = this, r2 = (e2.touches ? e2.touches[0] : e2).clientX, a2 = (e2.touches ? e2.touches[0] : e2).clientY, t3 = document.elementFromPoint(r2, a2);
            qt = e2, n2 || this.options.forceAutoScrollFallback || w || y2 || u2 ? (ee2(e2, this.options, t3, n2), o2 = M2(t3, true), !$t || Vt && r2 === Gt && a2 === Ut || (Vt && Jt(), Vt = setInterval(function() {
              var t4 = M2(document.elementFromPoint(r2, a2), true);
              t4 !== o2 && (o2 = t4, Qt()), ee2(e2, i3.options, t4, n2);
            }, 10), Gt = r2, Ut = a2)) : this.options.bubbleScroll && M2(t3, true) !== O() ? ee2(e2, this.options, M2(t3, false), false) : Qt();
          } }, a(t2, { pluginName: "scroll", initializeByDefault: true });
        }()), Bt.mount(oe2, ne2), Bt.mount(new function() {
          function t2() {
            this.defaults = { swapClass: "sortable-swap-highlight" };
          }
          return t2.prototype = { dragStart: function(t3) {
            t3 = t3.dragEl;
            te2 = t3;
          }, dragOverValid: function(t3) {
            var e2 = t3.completed, n2 = t3.target, o2 = t3.onMove, i3 = t3.activeSortable, r2 = t3.changed, a2 = t3.cancel;
            i3.options.swap && (t3 = this.sortable.el, i3 = this.options, n2 && n2 !== t3 && (t3 = te2, te2 = false !== o2(n2) ? (I2(n2, i3.swapClass, true), n2) : null, t3 && t3 !== te2 && I2(t3, i3.swapClass, false)), r2(), e2(true), a2());
          }, drop: function(t3) {
            var e2, n2, o2 = t3.activeSortable, i3 = t3.putSortable, r2 = t3.dragEl, a2 = i3 || this.sortable, l2 = this.options;
            te2 && I2(te2, l2.swapClass, false), te2 && (l2.swap || i3 && i3.options.swap) && r2 !== te2 && (a2.captureAnimationState(), a2 !== o2 && o2.captureAnimationState(), n2 = te2, t3 = (e2 = r2).parentNode, l2 = n2.parentNode, t3 && l2 && !t3.isEqualNode(n2) && !l2.isEqualNode(e2) && (i3 = B2(e2), r2 = B2(n2), t3.isEqualNode(l2) && i3 < r2 && r2++, t3.insertBefore(n2, t3.children[i3]), l2.insertBefore(e2, l2.children[r2])), a2.animateAll(), a2 !== o2 && o2.animateAll());
          }, nulling: function() {
            te2 = null;
          } }, a(t2, { pluginName: "swap", eventProperties: function() {
            return { swapItem: te2 };
          } });
        }()), Bt.mount(new function() {
          function t2(o2) {
            for (var t3 in this) "_" === t3.charAt(0) && "function" == typeof this[t3] && (this[t3] = this[t3].bind(this));
            o2.options.supportPointer ? h2(document, "pointerup", this._deselectMultiDrag) : (h2(document, "mouseup", this._deselectMultiDrag), h2(document, "touchend", this._deselectMultiDrag)), h2(document, "keydown", this._checkKeyDown), h2(document, "keyup", this._checkKeyUp), this.defaults = { selectedClass: "sortable-selected", multiDragKey: null, setData: function(t4, e2) {
              var n2 = "";
              ce2.length && re2 === o2 ? ce2.forEach(function(t5, e3) {
                n2 += (e3 ? ", " : "") + t5.textContent;
              }) : n2 = e2.textContent, t4.setData("Text", n2);
            } };
          }
          return t2.prototype = { multiDragKeyDown: false, isMultiDrag: false, delayStartGlobal: function(t3) {
            t3 = t3.dragEl;
            ae2 = t3;
          }, delayEnded: function() {
            this.isMultiDrag = ~ce2.indexOf(ae2);
          }, setupClone: function(t3) {
            var e2 = t3.sortable, t3 = t3.cancel;
            if (this.isMultiDrag) {
              for (var n2 = 0; n2 < ce2.length; n2++) ue2.push(_2(ce2[n2])), ue2[n2].sortableIndex = ce2[n2].sortableIndex, ue2[n2].draggable = false, ue2[n2].style["will-change"] = "", I2(ue2[n2], this.options.selectedClass, false), ce2[n2] === ae2 && I2(ue2[n2], this.options.chosenClass, false);
              e2._hideClone(), t3();
            }
          }, clone: function(t3) {
            var e2 = t3.sortable, n2 = t3.rootEl, o2 = t3.dispatchSortableEvent, t3 = t3.cancel;
            this.isMultiDrag && (this.options.removeCloneOnHide || ce2.length && re2 === e2 && (pe2(true, n2), o2("clone"), t3()));
          }, showClone: function(t3) {
            var e2 = t3.cloneNowShown, n2 = t3.rootEl, t3 = t3.cancel;
            this.isMultiDrag && (pe2(false, n2), ue2.forEach(function(t4) {
              P2(t4, "display", "");
            }), e2(), se2 = false, t3());
          }, hideClone: function(t3) {
            var e2 = this, n2 = (t3.sortable, t3.cloneNowHidden), t3 = t3.cancel;
            this.isMultiDrag && (ue2.forEach(function(t4) {
              P2(t4, "display", "none"), e2.options.removeCloneOnHide && t4.parentNode && t4.parentNode.removeChild(t4);
            }), n2(), se2 = true, t3());
          }, dragStartGlobal: function(t3) {
            t3.sortable;
            !this.isMultiDrag && re2 && re2.multiDrag._deselectMultiDrag(), ce2.forEach(function(t4) {
              t4.sortableIndex = B2(t4);
            }), ce2 = ce2.sort(function(t4, e2) {
              return t4.sortableIndex - e2.sortableIndex;
            }), fe2 = true;
          }, dragStarted: function(t3) {
            var e2, n2 = this, t3 = t3.sortable;
            this.isMultiDrag && (this.options.sort && (t3.captureAnimationState(), this.options.animation && (ce2.forEach(function(t4) {
              t4 !== ae2 && P2(t4, "position", "absolute");
            }), e2 = k(ae2, false, true, true), ce2.forEach(function(t4) {
              t4 !== ae2 && C(t4, e2);
            }), de2 = he = true)), t3.animateAll(function() {
              de2 = he = false, n2.options.animation && ce2.forEach(function(t4) {
                T2(t4);
              }), n2.options.sort && ge2();
            }));
          }, dragOver: function(t3) {
            var e2 = t3.target, n2 = t3.completed, t3 = t3.cancel;
            he && ~ce2.indexOf(e2) && (n2(false), t3());
          }, revert: function(t3) {
            var n2, o2, e2 = t3.fromSortable, i3 = t3.rootEl, r2 = t3.sortable, a2 = t3.dragRect;
            1 < ce2.length && (ce2.forEach(function(t4) {
              r2.addAnimationState({ target: t4, rect: he ? k(t4) : a2 }), T2(t4), t4.fromRect = a2, e2.removeAnimationState(t4);
            }), he = false, n2 = !this.options.removeCloneOnHide, o2 = i3, ce2.forEach(function(t4, e3) {
              e3 = o2.children[t4.sortableIndex + (n2 ? Number(e3) : 0)];
              e3 ? o2.insertBefore(t4, e3) : o2.appendChild(t4);
            }));
          }, dragOverCompleted: function(t3) {
            var e2, n2 = t3.sortable, o2 = t3.isOwner, i3 = t3.insertion, r2 = t3.activeSortable, a2 = t3.parentEl, l2 = t3.putSortable, t3 = this.options;
            i3 && (o2 && r2._hideClone(), de2 = false, t3.animation && 1 < ce2.length && (he || !o2 && !r2.options.sort && !l2) && (e2 = k(ae2, false, true, true), ce2.forEach(function(t4) {
              t4 !== ae2 && (C(t4, e2), a2.appendChild(t4));
            }), he = true), o2 || (he || ge2(), 1 < ce2.length ? (o2 = se2, r2._showClone(n2), r2.options.animation && !se2 && o2 && ue2.forEach(function(t4) {
              r2.addAnimationState({ target: t4, rect: le2 }), t4.fromRect = le2, t4.thisAnimationDuration = null;
            })) : r2._showClone(n2)));
          }, dragOverAnimationCapture: function(t3) {
            var e2 = t3.dragRect, n2 = t3.isOwner, t3 = t3.activeSortable;
            ce2.forEach(function(t4) {
              t4.thisAnimationDuration = null;
            }), t3.options.animation && !n2 && t3.multiDrag.isMultiDrag && (le2 = a({}, e2), e2 = v(ae2, true), le2.top -= e2.f, le2.left -= e2.e);
          }, dragOverAnimationComplete: function() {
            he && (he = false, ge2());
          }, drop: function(t3) {
            var e2 = t3.originalEvent, n2 = t3.rootEl, o2 = t3.parentEl, i3 = t3.sortable, r2 = t3.dispatchSortableEvent, a2 = t3.oldIndex, l2 = t3.putSortable, s2 = l2 || this.sortable;
            if (e2) {
              var c2, u3, d2, h3 = this.options, f2 = o2.children;
              if (!fe2) if (h3.multiDragKey && !this.multiDragKeyDown && this._deselectMultiDrag(), I2(ae2, h3.selectedClass, !~ce2.indexOf(ae2)), ~ce2.indexOf(ae2)) ce2.splice(ce2.indexOf(ae2), 1), ie2 = null, W2({ sortable: i3, rootEl: n2, name: "deselect", targetEl: ae2, originalEvt: e2 });
              else {
                if (ce2.push(ae2), W2({ sortable: i3, rootEl: n2, name: "select", targetEl: ae2, originalEvt: e2 }), e2.shiftKey && ie2 && i3.el.contains(ie2)) {
                  var p3 = B2(ie2), t3 = B2(ae2);
                  if (~p3 && ~t3 && p3 !== t3) for (var g2, m2 = p3 < t3 ? (g2 = p3, t3) : (g2 = t3, p3 + 1); g2 < m2; g2++) ~ce2.indexOf(f2[g2]) || (I2(f2[g2], h3.selectedClass, true), ce2.push(f2[g2]), W2({ sortable: i3, rootEl: n2, name: "select", targetEl: f2[g2], originalEvt: e2 }));
                } else ie2 = ae2;
                re2 = s2;
              }
              fe2 && this.isMultiDrag && (he = false, (o2[j].options.sort || o2 !== n2) && 1 < ce2.length && (c2 = k(ae2), u3 = B2(ae2, ":not(." + this.options.selectedClass + ")"), !de2 && h3.animation && (ae2.thisAnimationDuration = null), s2.captureAnimationState(), de2 || (h3.animation && (ae2.fromRect = c2, ce2.forEach(function(t4) {
                var e3;
                t4.thisAnimationDuration = null, t4 !== ae2 && (e3 = he ? k(t4) : c2, t4.fromRect = e3, s2.addAnimationState({ target: t4, rect: e3 }));
              })), ge2(), ce2.forEach(function(t4) {
                f2[u3] ? o2.insertBefore(t4, f2[u3]) : o2.appendChild(t4), u3++;
              }), a2 === B2(ae2) && (d2 = false, ce2.forEach(function(t4) {
                t4.sortableIndex !== B2(t4) && (d2 = true);
              }), d2 && r2("update"))), ce2.forEach(function(t4) {
                T2(t4);
              }), s2.animateAll()), re2 = s2), (n2 === o2 || l2 && "clone" !== l2.lastPutMode) && ue2.forEach(function(t4) {
                t4.parentNode && t4.parentNode.removeChild(t4);
              });
            }
          }, nullingGlobal: function() {
            this.isMultiDrag = fe2 = false, ue2.length = 0;
          }, destroyGlobal: function() {
            this._deselectMultiDrag(), f(document, "pointerup", this._deselectMultiDrag), f(document, "mouseup", this._deselectMultiDrag), f(document, "touchend", this._deselectMultiDrag), f(document, "keydown", this._checkKeyDown), f(document, "keyup", this._checkKeyUp);
          }, _deselectMultiDrag: function(t3) {
            if (!(void 0 !== fe2 && fe2 || re2 !== this.sortable || t3 && N(t3.target, this.options.draggable, this.sortable.el, false) || t3 && 0 !== t3.button)) for (; ce2.length; ) {
              var e2 = ce2[0];
              I2(e2, this.options.selectedClass, false), ce2.shift(), W2({ sortable: this.sortable, rootEl: this.sortable.el, name: "deselect", targetEl: e2, originalEvt: t3 });
            }
          }, _checkKeyDown: function(t3) {
            t3.key === this.options.multiDragKey && (this.multiDragKeyDown = true);
          }, _checkKeyUp: function(t3) {
            t3.key === this.options.multiDragKey && (this.multiDragKeyDown = false);
          } }, a(t2, { pluginName: "multiDrag", utils: { select: function(t3) {
            var e2 = t3.parentNode[j];
            e2 && e2.options.multiDrag && !~ce2.indexOf(t3) && (re2 && re2 !== e2 && (re2.multiDrag._deselectMultiDrag(), re2 = e2), I2(t3, e2.options.selectedClass, true), ce2.push(t3));
          }, deselect: function(t3) {
            var e2 = t3.parentNode[j], n2 = ce2.indexOf(t3);
            e2 && e2.options.multiDrag && ~n2 && (I2(t3, e2.options.selectedClass, false), ce2.splice(n2, 1));
          } }, eventProperties: function() {
            var n2 = this, o2 = [], i3 = [];
            return ce2.forEach(function(t3) {
              var e2;
              o2.push({ multiDragElement: t3, index: t3.sortableIndex }), e2 = he && t3 !== ae2 ? -1 : he ? B2(t3, ":not(." + n2.options.selectedClass + ")") : B2(t3), i3.push({ multiDragElement: t3, index: e2 });
            }), { items: r(ce2), clones: [].concat(ue2), oldIndicies: o2, newIndicies: i3 };
          }, optionListeners: { multiDragKey: function(t3) {
            return "ctrl" === (t3 = t3.toLowerCase()) ? t3 = "Control" : 1 < t3.length && (t3 = t3.charAt(0).toUpperCase() + t3.substr(1)), t3;
          } } });
        }()), Bt;
      });
    }
  });

  // node_modules/vuedraggable/dist/vuedraggable.umd.js
  var require_vuedraggable_umd = __commonJS({
    "node_modules/vuedraggable/dist/vuedraggable.umd.js"(exports, module) {
      (function webpackUniversalModuleDefinition(root, factory2) {
        if (typeof exports === "object" && typeof module === "object")
          module.exports = factory2((init_vue_esm_bundler(), __toCommonJS(vue_esm_bundler_exports)), require_Sortable_min());
        else if (typeof define === "function" && define.amd)
          define([, "sortablejs"], factory2);
        else if (typeof exports === "object")
          exports["vuedraggable"] = factory2((init_vue_esm_bundler(), __toCommonJS(vue_esm_bundler_exports)), require_Sortable_min());
        else
          root["vuedraggable"] = factory2(root["Vue"], root["Sortable"]);
      })(typeof self !== "undefined" ? self : exports, function(__WEBPACK_EXTERNAL_MODULE__8bbf__, __WEBPACK_EXTERNAL_MODULE_a352__) {
        return (
          /******/
          (function(modules2) {
            var installedModules = {};
            function __webpack_require__(moduleId) {
              if (installedModules[moduleId]) {
                return installedModules[moduleId].exports;
              }
              var module2 = installedModules[moduleId] = {
                /******/
                i: moduleId,
                /******/
                l: false,
                /******/
                exports: {}
                /******/
              };
              modules2[moduleId].call(module2.exports, module2, module2.exports, __webpack_require__);
              module2.l = true;
              return module2.exports;
            }
            __webpack_require__.m = modules2;
            __webpack_require__.c = installedModules;
            __webpack_require__.d = function(exports2, name, getter) {
              if (!__webpack_require__.o(exports2, name)) {
                Object.defineProperty(exports2, name, { enumerable: true, get: getter });
              }
            };
            __webpack_require__.r = function(exports2) {
              if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                Object.defineProperty(exports2, Symbol.toStringTag, { value: "Module" });
              }
              Object.defineProperty(exports2, "__esModule", { value: true });
            };
            __webpack_require__.t = function(value, mode) {
              if (mode & 1) value = __webpack_require__(value);
              if (mode & 8) return value;
              if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
              var ns = /* @__PURE__ */ Object.create(null);
              __webpack_require__.r(ns);
              Object.defineProperty(ns, "default", { enumerable: true, value });
              if (mode & 2 && typeof value != "string") for (var key in value) __webpack_require__.d(ns, key, function(key2) {
                return value[key2];
              }.bind(null, key));
              return ns;
            };
            __webpack_require__.n = function(module2) {
              var getter = module2 && module2.__esModule ? (
                /******/
                function getDefault() {
                  return module2["default"];
                }
              ) : (
                /******/
                function getModuleExports() {
                  return module2;
                }
              );
              __webpack_require__.d(getter, "a", getter);
              return getter;
            };
            __webpack_require__.o = function(object, property) {
              return Object.prototype.hasOwnProperty.call(object, property);
            };
            __webpack_require__.p = "";
            return __webpack_require__(__webpack_require__.s = "fb15");
          })({
            /***/
            "00ee": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var wellKnownSymbol = __webpack_require__("b622");
                var TO_STRING_TAG = wellKnownSymbol("toStringTag");
                var test2 = {};
                test2[TO_STRING_TAG] = "z";
                module2.exports = String(test2) === "[object z]";
              })
            ),
            /***/
            "0366": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var aFunction = __webpack_require__("1c0b");
                module2.exports = function(fn, that, length) {
                  aFunction(fn);
                  if (that === void 0) return fn;
                  switch (length) {
                    case 0:
                      return function() {
                        return fn.call(that);
                      };
                    case 1:
                      return function(a) {
                        return fn.call(that, a);
                      };
                    case 2:
                      return function(a, b2) {
                        return fn.call(that, a, b2);
                      };
                    case 3:
                      return function(a, b2, c) {
                        return fn.call(that, a, b2, c);
                      };
                  }
                  return function() {
                    return fn.apply(that, arguments);
                  };
                };
              })
            ),
            /***/
            "057f": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var toIndexedObject = __webpack_require__("fc6a");
                var nativeGetOwnPropertyNames = __webpack_require__("241c").f;
                var toString3 = {}.toString;
                var windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
                var getWindowNames = function(it) {
                  try {
                    return nativeGetOwnPropertyNames(it);
                  } catch (error) {
                    return windowNames.slice();
                  }
                };
                module2.exports.f = function getOwnPropertyNames(it) {
                  return windowNames && toString3.call(it) == "[object Window]" ? getWindowNames(it) : nativeGetOwnPropertyNames(toIndexedObject(it));
                };
              })
            ),
            /***/
            "06cf": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var DESCRIPTORS = __webpack_require__("83ab");
                var propertyIsEnumerableModule = __webpack_require__("d1e7");
                var createPropertyDescriptor = __webpack_require__("5c6c");
                var toIndexedObject = __webpack_require__("fc6a");
                var toPrimitive = __webpack_require__("c04e");
                var has = __webpack_require__("5135");
                var IE8_DOM_DEFINE = __webpack_require__("0cfb");
                var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
                exports2.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P2) {
                  O = toIndexedObject(O);
                  P2 = toPrimitive(P2, true);
                  if (IE8_DOM_DEFINE) try {
                    return nativeGetOwnPropertyDescriptor(O, P2);
                  } catch (error) {
                  }
                  if (has(O, P2)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P2), O[P2]);
                };
              })
            ),
            /***/
            "0cfb": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var DESCRIPTORS = __webpack_require__("83ab");
                var fails = __webpack_require__("d039");
                var createElement = __webpack_require__("cc12");
                module2.exports = !DESCRIPTORS && !fails(function() {
                  return Object.defineProperty(createElement("div"), "a", {
                    get: function() {
                      return 7;
                    }
                  }).a != 7;
                });
              })
            ),
            /***/
            "13d5": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var $2 = __webpack_require__("23e7");
                var $reduce = __webpack_require__("d58f").left;
                var arrayMethodIsStrict = __webpack_require__("a640");
                var arrayMethodUsesToLength = __webpack_require__("ae40");
                var STRICT_METHOD = arrayMethodIsStrict("reduce");
                var USES_TO_LENGTH = arrayMethodUsesToLength("reduce", { 1: 0 });
                $2({ target: "Array", proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
                  reduce: function reduce2(callbackfn) {
                    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : void 0);
                  }
                });
              })
            ),
            /***/
            "14c3": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var classof = __webpack_require__("c6b6");
                var regexpExec = __webpack_require__("9263");
                module2.exports = function(R2, S2) {
                  var exec = R2.exec;
                  if (typeof exec === "function") {
                    var result = exec.call(R2, S2);
                    if (typeof result !== "object") {
                      throw TypeError("RegExp exec method returned something other than an Object or null");
                    }
                    return result;
                  }
                  if (classof(R2) !== "RegExp") {
                    throw TypeError("RegExp#exec called on incompatible receiver");
                  }
                  return regexpExec.call(R2, S2);
                };
              })
            ),
            /***/
            "159b": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var global2 = __webpack_require__("da84");
                var DOMIterables = __webpack_require__("fdbc");
                var forEach2 = __webpack_require__("17c2");
                var createNonEnumerableProperty = __webpack_require__("9112");
                for (var COLLECTION_NAME in DOMIterables) {
                  var Collection = global2[COLLECTION_NAME];
                  var CollectionPrototype = Collection && Collection.prototype;
                  if (CollectionPrototype && CollectionPrototype.forEach !== forEach2) try {
                    createNonEnumerableProperty(CollectionPrototype, "forEach", forEach2);
                  } catch (error) {
                    CollectionPrototype.forEach = forEach2;
                  }
                }
              })
            ),
            /***/
            "17c2": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var $forEach = __webpack_require__("b727").forEach;
                var arrayMethodIsStrict = __webpack_require__("a640");
                var arrayMethodUsesToLength = __webpack_require__("ae40");
                var STRICT_METHOD = arrayMethodIsStrict("forEach");
                var USES_TO_LENGTH = arrayMethodUsesToLength("forEach");
                module2.exports = !STRICT_METHOD || !USES_TO_LENGTH ? function forEach2(callbackfn) {
                  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
                } : [].forEach;
              })
            ),
            /***/
            "1be4": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var getBuiltIn = __webpack_require__("d066");
                module2.exports = getBuiltIn("document", "documentElement");
              })
            ),
            /***/
            "1c0b": (
              /***/
              (function(module2, exports2) {
                module2.exports = function(it) {
                  if (typeof it != "function") {
                    throw TypeError(String(it) + " is not a function");
                  }
                  return it;
                };
              })
            ),
            /***/
            "1c7e": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var wellKnownSymbol = __webpack_require__("b622");
                var ITERATOR = wellKnownSymbol("iterator");
                var SAFE_CLOSING = false;
                try {
                  var called = 0;
                  var iteratorWithReturn = {
                    next: function() {
                      return { done: !!called++ };
                    },
                    "return": function() {
                      SAFE_CLOSING = true;
                    }
                  };
                  iteratorWithReturn[ITERATOR] = function() {
                    return this;
                  };
                  Array.from(iteratorWithReturn, function() {
                    throw 2;
                  });
                } catch (error) {
                }
                module2.exports = function(exec, SKIP_CLOSING) {
                  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
                  var ITERATION_SUPPORT = false;
                  try {
                    var object = {};
                    object[ITERATOR] = function() {
                      return {
                        next: function() {
                          return { done: ITERATION_SUPPORT = true };
                        }
                      };
                    };
                    exec(object);
                  } catch (error) {
                  }
                  return ITERATION_SUPPORT;
                };
              })
            ),
            /***/
            "1d80": (
              /***/
              (function(module2, exports2) {
                module2.exports = function(it) {
                  if (it == void 0) throw TypeError("Can't call method on " + it);
                  return it;
                };
              })
            ),
            /***/
            "1dde": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var fails = __webpack_require__("d039");
                var wellKnownSymbol = __webpack_require__("b622");
                var V8_VERSION = __webpack_require__("2d00");
                var SPECIES = wellKnownSymbol("species");
                module2.exports = function(METHOD_NAME) {
                  return V8_VERSION >= 51 || !fails(function() {
                    var array = [];
                    var constructor = array.constructor = {};
                    constructor[SPECIES] = function() {
                      return { foo: 1 };
                    };
                    return array[METHOD_NAME](Boolean).foo !== 1;
                  });
                };
              })
            ),
            /***/
            "23cb": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var toInteger = __webpack_require__("a691");
                var max = Math.max;
                var min = Math.min;
                module2.exports = function(index, length) {
                  var integer = toInteger(index);
                  return integer < 0 ? max(integer + length, 0) : min(integer, length);
                };
              })
            ),
            /***/
            "23e7": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var global2 = __webpack_require__("da84");
                var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
                var createNonEnumerableProperty = __webpack_require__("9112");
                var redefine = __webpack_require__("6eeb");
                var setGlobal = __webpack_require__("ce4e");
                var copyConstructorProperties = __webpack_require__("e893");
                var isForced = __webpack_require__("94ca");
                module2.exports = function(options, source) {
                  var TARGET = options.target;
                  var GLOBAL = options.global;
                  var STATIC = options.stat;
                  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
                  if (GLOBAL) {
                    target = global2;
                  } else if (STATIC) {
                    target = global2[TARGET] || setGlobal(TARGET, {});
                  } else {
                    target = (global2[TARGET] || {}).prototype;
                  }
                  if (target) for (key in source) {
                    sourceProperty = source[key];
                    if (options.noTargetGet) {
                      descriptor = getOwnPropertyDescriptor(target, key);
                      targetProperty = descriptor && descriptor.value;
                    } else targetProperty = target[key];
                    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
                    if (!FORCED && targetProperty !== void 0) {
                      if (typeof sourceProperty === typeof targetProperty) continue;
                      copyConstructorProperties(sourceProperty, targetProperty);
                    }
                    if (options.sham || targetProperty && targetProperty.sham) {
                      createNonEnumerableProperty(sourceProperty, "sham", true);
                    }
                    redefine(target, key, sourceProperty, options);
                  }
                };
              })
            ),
            /***/
            "241c": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var internalObjectKeys = __webpack_require__("ca84");
                var enumBugKeys = __webpack_require__("7839");
                var hiddenKeys = enumBugKeys.concat("length", "prototype");
                exports2.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
                  return internalObjectKeys(O, hiddenKeys);
                };
              })
            ),
            /***/
            "25f0": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var redefine = __webpack_require__("6eeb");
                var anObject = __webpack_require__("825a");
                var fails = __webpack_require__("d039");
                var flags = __webpack_require__("ad6d");
                var TO_STRING = "toString";
                var RegExpPrototype = RegExp.prototype;
                var nativeToString = RegExpPrototype[TO_STRING];
                var NOT_GENERIC = fails(function() {
                  return nativeToString.call({ source: "a", flags: "b" }) != "/a/b";
                });
                var INCORRECT_NAME = nativeToString.name != TO_STRING;
                if (NOT_GENERIC || INCORRECT_NAME) {
                  redefine(RegExp.prototype, TO_STRING, function toString3() {
                    var R2 = anObject(this);
                    var p2 = String(R2.source);
                    var rf = R2.flags;
                    var f = String(rf === void 0 && R2 instanceof RegExp && !("flags" in RegExpPrototype) ? flags.call(R2) : rf);
                    return "/" + p2 + "/" + f;
                  }, { unsafe: true });
                }
              })
            ),
            /***/
            "2ca0": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var $2 = __webpack_require__("23e7");
                var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
                var toLength = __webpack_require__("50c4");
                var notARegExp = __webpack_require__("5a34");
                var requireObjectCoercible = __webpack_require__("1d80");
                var correctIsRegExpLogic = __webpack_require__("ab13");
                var IS_PURE = __webpack_require__("c430");
                var nativeStartsWith = "".startsWith;
                var min = Math.min;
                var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic("startsWith");
                var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!(function() {
                  var descriptor = getOwnPropertyDescriptor(String.prototype, "startsWith");
                  return descriptor && !descriptor.writable;
                })();
                $2({ target: "String", proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
                  startsWith: function startsWith(searchString) {
                    var that = String(requireObjectCoercible(this));
                    notARegExp(searchString);
                    var index = toLength(min(arguments.length > 1 ? arguments[1] : void 0, that.length));
                    var search = String(searchString);
                    return nativeStartsWith ? nativeStartsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
                  }
                });
              })
            ),
            /***/
            "2d00": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var global2 = __webpack_require__("da84");
                var userAgent = __webpack_require__("342f");
                var process2 = global2.process;
                var versions = process2 && process2.versions;
                var v8 = versions && versions.v8;
                var match, version2;
                if (v8) {
                  match = v8.split(".");
                  version2 = match[0] + match[1];
                } else if (userAgent) {
                  match = userAgent.match(/Edge\/(\d+)/);
                  if (!match || match[1] >= 74) {
                    match = userAgent.match(/Chrome\/(\d+)/);
                    if (match) version2 = match[1];
                  }
                }
                module2.exports = version2 && +version2;
              })
            ),
            /***/
            "342f": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var getBuiltIn = __webpack_require__("d066");
                module2.exports = getBuiltIn("navigator", "userAgent") || "";
              })
            ),
            /***/
            "35a1": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var classof = __webpack_require__("f5df");
                var Iterators = __webpack_require__("3f8c");
                var wellKnownSymbol = __webpack_require__("b622");
                var ITERATOR = wellKnownSymbol("iterator");
                module2.exports = function(it) {
                  if (it != void 0) return it[ITERATOR] || it["@@iterator"] || Iterators[classof(it)];
                };
              })
            ),
            /***/
            "37e8": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var DESCRIPTORS = __webpack_require__("83ab");
                var definePropertyModule = __webpack_require__("9bf2");
                var anObject = __webpack_require__("825a");
                var objectKeys = __webpack_require__("df75");
                module2.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
                  anObject(O);
                  var keys = objectKeys(Properties);
                  var length = keys.length;
                  var index = 0;
                  var key;
                  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
                  return O;
                };
              })
            ),
            /***/
            "3bbe": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var isObject4 = __webpack_require__("861d");
                module2.exports = function(it) {
                  if (!isObject4(it) && it !== null) {
                    throw TypeError("Can't set " + String(it) + " as a prototype");
                  }
                  return it;
                };
              })
            ),
            /***/
            "3ca3": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var charAt = __webpack_require__("6547").charAt;
                var InternalStateModule = __webpack_require__("69f3");
                var defineIterator = __webpack_require__("7dd0");
                var STRING_ITERATOR = "String Iterator";
                var setInternalState = InternalStateModule.set;
                var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);
                defineIterator(String, "String", function(iterated) {
                  setInternalState(this, {
                    type: STRING_ITERATOR,
                    string: String(iterated),
                    index: 0
                  });
                }, function next() {
                  var state4 = getInternalState(this);
                  var string = state4.string;
                  var index = state4.index;
                  var point;
                  if (index >= string.length) return { value: void 0, done: true };
                  point = charAt(string, index);
                  state4.index += point.length;
                  return { value: point, done: false };
                });
              })
            ),
            /***/
            "3f8c": (
              /***/
              (function(module2, exports2) {
                module2.exports = {};
              })
            ),
            /***/
            "4160": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var $2 = __webpack_require__("23e7");
                var forEach2 = __webpack_require__("17c2");
                $2({ target: "Array", proto: true, forced: [].forEach != forEach2 }, {
                  forEach: forEach2
                });
              })
            ),
            /***/
            "428f": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var global2 = __webpack_require__("da84");
                module2.exports = global2;
              })
            ),
            /***/
            "44ad": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var fails = __webpack_require__("d039");
                var classof = __webpack_require__("c6b6");
                var split = "".split;
                module2.exports = fails(function() {
                  return !Object("z").propertyIsEnumerable(0);
                }) ? function(it) {
                  return classof(it) == "String" ? split.call(it, "") : Object(it);
                } : Object;
              })
            ),
            /***/
            "44d2": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var wellKnownSymbol = __webpack_require__("b622");
                var create2 = __webpack_require__("7c73");
                var definePropertyModule = __webpack_require__("9bf2");
                var UNSCOPABLES = wellKnownSymbol("unscopables");
                var ArrayPrototype = Array.prototype;
                if (ArrayPrototype[UNSCOPABLES] == void 0) {
                  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
                    configurable: true,
                    value: create2(null)
                  });
                }
                module2.exports = function(key) {
                  ArrayPrototype[UNSCOPABLES][key] = true;
                };
              })
            ),
            /***/
            "44e7": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var isObject4 = __webpack_require__("861d");
                var classof = __webpack_require__("c6b6");
                var wellKnownSymbol = __webpack_require__("b622");
                var MATCH = wellKnownSymbol("match");
                module2.exports = function(it) {
                  var isRegExp3;
                  return isObject4(it) && ((isRegExp3 = it[MATCH]) !== void 0 ? !!isRegExp3 : classof(it) == "RegExp");
                };
              })
            ),
            /***/
            "4930": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var fails = __webpack_require__("d039");
                module2.exports = !!Object.getOwnPropertySymbols && !fails(function() {
                  return !String(/* @__PURE__ */ Symbol());
                });
              })
            ),
            /***/
            "4d64": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var toIndexedObject = __webpack_require__("fc6a");
                var toLength = __webpack_require__("50c4");
                var toAbsoluteIndex = __webpack_require__("23cb");
                var createMethod = function(IS_INCLUDES) {
                  return function($this, el, fromIndex) {
                    var O = toIndexedObject($this);
                    var length = toLength(O.length);
                    var index = toAbsoluteIndex(fromIndex, length);
                    var value;
                    if (IS_INCLUDES && el != el) while (length > index) {
                      value = O[index++];
                      if (value != value) return true;
                    }
                    else for (; length > index; index++) {
                      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
                    }
                    return !IS_INCLUDES && -1;
                  };
                };
                module2.exports = {
                  // `Array.prototype.includes` method
                  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
                  includes: createMethod(true),
                  // `Array.prototype.indexOf` method
                  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
                  indexOf: createMethod(false)
                };
              })
            ),
            /***/
            "4de4": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var $2 = __webpack_require__("23e7");
                var $filter = __webpack_require__("b727").filter;
                var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
                var arrayMethodUsesToLength = __webpack_require__("ae40");
                var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("filter");
                var USES_TO_LENGTH = arrayMethodUsesToLength("filter");
                $2({ target: "Array", proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
                  filter: function filter5(callbackfn) {
                    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
                  }
                });
              })
            ),
            /***/
            "4df4": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var bind2 = __webpack_require__("0366");
                var toObject = __webpack_require__("7b0b");
                var callWithSafeIterationClosing = __webpack_require__("9bdd");
                var isArrayIteratorMethod = __webpack_require__("e95a");
                var toLength = __webpack_require__("50c4");
                var createProperty = __webpack_require__("8418");
                var getIteratorMethod = __webpack_require__("35a1");
                module2.exports = function from(arrayLike) {
                  var O = toObject(arrayLike);
                  var C = typeof this == "function" ? this : Array;
                  var argumentsLength = arguments.length;
                  var mapfn = argumentsLength > 1 ? arguments[1] : void 0;
                  var mapping = mapfn !== void 0;
                  var iteratorMethod = getIteratorMethod(O);
                  var index = 0;
                  var length, result, step, iterator3, next, value;
                  if (mapping) mapfn = bind2(mapfn, argumentsLength > 2 ? arguments[2] : void 0, 2);
                  if (iteratorMethod != void 0 && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
                    iterator3 = iteratorMethod.call(O);
                    next = iterator3.next;
                    result = new C();
                    for (; !(step = next.call(iterator3)).done; index++) {
                      value = mapping ? callWithSafeIterationClosing(iterator3, mapfn, [step.value, index], true) : step.value;
                      createProperty(result, index, value);
                    }
                  } else {
                    length = toLength(O.length);
                    result = new C(length);
                    for (; length > index; index++) {
                      value = mapping ? mapfn(O[index], index) : O[index];
                      createProperty(result, index, value);
                    }
                  }
                  result.length = index;
                  return result;
                };
              })
            ),
            /***/
            "4fad": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var $2 = __webpack_require__("23e7");
                var $entries = __webpack_require__("6f53").entries;
                $2({ target: "Object", stat: true }, {
                  entries: function entries(O) {
                    return $entries(O);
                  }
                });
              })
            ),
            /***/
            "50c4": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var toInteger = __webpack_require__("a691");
                var min = Math.min;
                module2.exports = function(argument) {
                  return argument > 0 ? min(toInteger(argument), 9007199254740991) : 0;
                };
              })
            ),
            /***/
            "5135": (
              /***/
              (function(module2, exports2) {
                var hasOwnProperty4 = {}.hasOwnProperty;
                module2.exports = function(it, key) {
                  return hasOwnProperty4.call(it, key);
                };
              })
            ),
            /***/
            "5319": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
                var anObject = __webpack_require__("825a");
                var toObject = __webpack_require__("7b0b");
                var toLength = __webpack_require__("50c4");
                var toInteger = __webpack_require__("a691");
                var requireObjectCoercible = __webpack_require__("1d80");
                var advanceStringIndex = __webpack_require__("8aa5");
                var regExpExec = __webpack_require__("14c3");
                var max = Math.max;
                var min = Math.min;
                var floor = Math.floor;
                var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
                var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g;
                var maybeToString = function(it) {
                  return it === void 0 ? it : String(it);
                };
                fixRegExpWellKnownSymbolLogic("replace", 2, function(REPLACE, nativeReplace, maybeCallNative, reason) {
                  var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = reason.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE;
                  var REPLACE_KEEPS_$0 = reason.REPLACE_KEEPS_$0;
                  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? "$" : "$0";
                  return [
                    // `String.prototype.replace` method
                    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
                    function replace(searchValue, replaceValue) {
                      var O = requireObjectCoercible(this);
                      var replacer2 = searchValue == void 0 ? void 0 : searchValue[REPLACE];
                      return replacer2 !== void 0 ? replacer2.call(searchValue, O, replaceValue) : nativeReplace.call(String(O), searchValue, replaceValue);
                    },
                    // `RegExp.prototype[@@replace]` method
                    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
                    function(regexp, replaceValue) {
                      if (!REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE && REPLACE_KEEPS_$0 || typeof replaceValue === "string" && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1) {
                        var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
                        if (res.done) return res.value;
                      }
                      var rx = anObject(regexp);
                      var S2 = String(this);
                      var functionalReplace = typeof replaceValue === "function";
                      if (!functionalReplace) replaceValue = String(replaceValue);
                      var global2 = rx.global;
                      if (global2) {
                        var fullUnicode = rx.unicode;
                        rx.lastIndex = 0;
                      }
                      var results = [];
                      while (true) {
                        var result = regExpExec(rx, S2);
                        if (result === null) break;
                        results.push(result);
                        if (!global2) break;
                        var matchStr = String(result[0]);
                        if (matchStr === "") rx.lastIndex = advanceStringIndex(S2, toLength(rx.lastIndex), fullUnicode);
                      }
                      var accumulatedResult = "";
                      var nextSourcePosition = 0;
                      for (var i2 = 0; i2 < results.length; i2++) {
                        result = results[i2];
                        var matched = String(result[0]);
                        var position = max(min(toInteger(result.index), S2.length), 0);
                        var captures = [];
                        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
                        var namedCaptures = result.groups;
                        if (functionalReplace) {
                          var replacerArgs = [matched].concat(captures, position, S2);
                          if (namedCaptures !== void 0) replacerArgs.push(namedCaptures);
                          var replacement = String(replaceValue.apply(void 0, replacerArgs));
                        } else {
                          replacement = getSubstitution(matched, S2, position, captures, namedCaptures, replaceValue);
                        }
                        if (position >= nextSourcePosition) {
                          accumulatedResult += S2.slice(nextSourcePosition, position) + replacement;
                          nextSourcePosition = position + matched.length;
                        }
                      }
                      return accumulatedResult + S2.slice(nextSourcePosition);
                    }
                  ];
                  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
                    var tailPos = position + matched.length;
                    var m = captures.length;
                    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
                    if (namedCaptures !== void 0) {
                      namedCaptures = toObject(namedCaptures);
                      symbols = SUBSTITUTION_SYMBOLS;
                    }
                    return nativeReplace.call(replacement, symbols, function(match, ch) {
                      var capture;
                      switch (ch.charAt(0)) {
                        case "$":
                          return "$";
                        case "&":
                          return matched;
                        case "`":
                          return str.slice(0, position);
                        case "'":
                          return str.slice(tailPos);
                        case "<":
                          capture = namedCaptures[ch.slice(1, -1)];
                          break;
                        default:
                          var n = +ch;
                          if (n === 0) return match;
                          if (n > m) {
                            var f = floor(n / 10);
                            if (f === 0) return match;
                            if (f <= m) return captures[f - 1] === void 0 ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
                            return match;
                          }
                          capture = captures[n - 1];
                      }
                      return capture === void 0 ? "" : capture;
                    });
                  }
                });
              })
            ),
            /***/
            "5692": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var IS_PURE = __webpack_require__("c430");
                var store2 = __webpack_require__("c6cd");
                (module2.exports = function(key, value) {
                  return store2[key] || (store2[key] = value !== void 0 ? value : {});
                })("versions", []).push({
                  version: "3.6.5",
                  mode: IS_PURE ? "pure" : "global",
                  copyright: "\xA9 2020 Denis Pushkarev (zloirock.ru)"
                });
              })
            ),
            /***/
            "56ef": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var getBuiltIn = __webpack_require__("d066");
                var getOwnPropertyNamesModule = __webpack_require__("241c");
                var getOwnPropertySymbolsModule = __webpack_require__("7418");
                var anObject = __webpack_require__("825a");
                module2.exports = getBuiltIn("Reflect", "ownKeys") || function ownKeys2(it) {
                  var keys = getOwnPropertyNamesModule.f(anObject(it));
                  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
                  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
                };
              })
            ),
            /***/
            "5a34": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var isRegExp3 = __webpack_require__("44e7");
                module2.exports = function(it) {
                  if (isRegExp3(it)) {
                    throw TypeError("The method doesn't accept regular expressions");
                  }
                  return it;
                };
              })
            ),
            /***/
            "5c6c": (
              /***/
              (function(module2, exports2) {
                module2.exports = function(bitmap, value) {
                  return {
                    enumerable: !(bitmap & 1),
                    configurable: !(bitmap & 2),
                    writable: !(bitmap & 4),
                    value
                  };
                };
              })
            ),
            /***/
            "5db7": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var $2 = __webpack_require__("23e7");
                var flattenIntoArray = __webpack_require__("a2bf");
                var toObject = __webpack_require__("7b0b");
                var toLength = __webpack_require__("50c4");
                var aFunction = __webpack_require__("1c0b");
                var arraySpeciesCreate = __webpack_require__("65f0");
                $2({ target: "Array", proto: true }, {
                  flatMap: function flatMap(callbackfn) {
                    var O = toObject(this);
                    var sourceLen = toLength(O.length);
                    var A;
                    aFunction(callbackfn);
                    A = arraySpeciesCreate(O, 0);
                    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
                    return A;
                  }
                });
              })
            ),
            /***/
            "6547": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var toInteger = __webpack_require__("a691");
                var requireObjectCoercible = __webpack_require__("1d80");
                var createMethod = function(CONVERT_TO_STRING) {
                  return function($this, pos) {
                    var S2 = String(requireObjectCoercible($this));
                    var position = toInteger(pos);
                    var size = S2.length;
                    var first, second;
                    if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : void 0;
                    first = S2.charCodeAt(position);
                    return first < 55296 || first > 56319 || position + 1 === size || (second = S2.charCodeAt(position + 1)) < 56320 || second > 57343 ? CONVERT_TO_STRING ? S2.charAt(position) : first : CONVERT_TO_STRING ? S2.slice(position, position + 2) : (first - 55296 << 10) + (second - 56320) + 65536;
                  };
                };
                module2.exports = {
                  // `String.prototype.codePointAt` method
                  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
                  codeAt: createMethod(false),
                  // `String.prototype.at` method
                  // https://github.com/mathiasbynens/String.prototype.at
                  charAt: createMethod(true)
                };
              })
            ),
            /***/
            "65f0": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var isObject4 = __webpack_require__("861d");
                var isArray3 = __webpack_require__("e8b5");
                var wellKnownSymbol = __webpack_require__("b622");
                var SPECIES = wellKnownSymbol("species");
                module2.exports = function(originalArray, length) {
                  var C;
                  if (isArray3(originalArray)) {
                    C = originalArray.constructor;
                    if (typeof C == "function" && (C === Array || isArray3(C.prototype))) C = void 0;
                    else if (isObject4(C)) {
                      C = C[SPECIES];
                      if (C === null) C = void 0;
                    }
                  }
                  return new (C === void 0 ? Array : C)(length === 0 ? 0 : length);
                };
              })
            ),
            /***/
            "69f3": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
                var global2 = __webpack_require__("da84");
                var isObject4 = __webpack_require__("861d");
                var createNonEnumerableProperty = __webpack_require__("9112");
                var objectHas = __webpack_require__("5135");
                var sharedKey = __webpack_require__("f772");
                var hiddenKeys = __webpack_require__("d012");
                var WeakMap2 = global2.WeakMap;
                var set, get3, has;
                var enforce = function(it) {
                  return has(it) ? get3(it) : set(it, {});
                };
                var getterFor = function(TYPE) {
                  return function(it) {
                    var state4;
                    if (!isObject4(it) || (state4 = get3(it)).type !== TYPE) {
                      throw TypeError("Incompatible receiver, " + TYPE + " required");
                    }
                    return state4;
                  };
                };
                if (NATIVE_WEAK_MAP) {
                  var store2 = new WeakMap2();
                  var wmget = store2.get;
                  var wmhas = store2.has;
                  var wmset = store2.set;
                  set = function(it, metadata) {
                    wmset.call(store2, it, metadata);
                    return metadata;
                  };
                  get3 = function(it) {
                    return wmget.call(store2, it) || {};
                  };
                  has = function(it) {
                    return wmhas.call(store2, it);
                  };
                } else {
                  var STATE = sharedKey("state");
                  hiddenKeys[STATE] = true;
                  set = function(it, metadata) {
                    createNonEnumerableProperty(it, STATE, metadata);
                    return metadata;
                  };
                  get3 = function(it) {
                    return objectHas(it, STATE) ? it[STATE] : {};
                  };
                  has = function(it) {
                    return objectHas(it, STATE);
                  };
                }
                module2.exports = {
                  set,
                  get: get3,
                  has,
                  enforce,
                  getterFor
                };
              })
            ),
            /***/
            "6eeb": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var global2 = __webpack_require__("da84");
                var createNonEnumerableProperty = __webpack_require__("9112");
                var has = __webpack_require__("5135");
                var setGlobal = __webpack_require__("ce4e");
                var inspectSource = __webpack_require__("8925");
                var InternalStateModule = __webpack_require__("69f3");
                var getInternalState = InternalStateModule.get;
                var enforceInternalState = InternalStateModule.enforce;
                var TEMPLATE = String(String).split("String");
                (module2.exports = function(O, key, value, options) {
                  var unsafe = options ? !!options.unsafe : false;
                  var simple = options ? !!options.enumerable : false;
                  var noTargetGet = options ? !!options.noTargetGet : false;
                  if (typeof value == "function") {
                    if (typeof key == "string" && !has(value, "name")) createNonEnumerableProperty(value, "name", key);
                    enforceInternalState(value).source = TEMPLATE.join(typeof key == "string" ? key : "");
                  }
                  if (O === global2) {
                    if (simple) O[key] = value;
                    else setGlobal(key, value);
                    return;
                  } else if (!unsafe) {
                    delete O[key];
                  } else if (!noTargetGet && O[key]) {
                    simple = true;
                  }
                  if (simple) O[key] = value;
                  else createNonEnumerableProperty(O, key, value);
                })(Function.prototype, "toString", function toString3() {
                  return typeof this == "function" && getInternalState(this).source || inspectSource(this);
                });
              })
            ),
            /***/
            "6f53": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var DESCRIPTORS = __webpack_require__("83ab");
                var objectKeys = __webpack_require__("df75");
                var toIndexedObject = __webpack_require__("fc6a");
                var propertyIsEnumerable2 = __webpack_require__("d1e7").f;
                var createMethod = function(TO_ENTRIES) {
                  return function(it) {
                    var O = toIndexedObject(it);
                    var keys = objectKeys(O);
                    var length = keys.length;
                    var i2 = 0;
                    var result = [];
                    var key;
                    while (length > i2) {
                      key = keys[i2++];
                      if (!DESCRIPTORS || propertyIsEnumerable2.call(O, key)) {
                        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
                      }
                    }
                    return result;
                  };
                };
                module2.exports = {
                  // `Object.entries` method
                  // https://tc39.github.io/ecma262/#sec-object.entries
                  entries: createMethod(true),
                  // `Object.values` method
                  // https://tc39.github.io/ecma262/#sec-object.values
                  values: createMethod(false)
                };
              })
            ),
            /***/
            "73d9": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var addToUnscopables = __webpack_require__("44d2");
                addToUnscopables("flatMap");
              })
            ),
            /***/
            "7418": (
              /***/
              (function(module2, exports2) {
                exports2.f = Object.getOwnPropertySymbols;
              })
            ),
            /***/
            "746f": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var path = __webpack_require__("428f");
                var has = __webpack_require__("5135");
                var wrappedWellKnownSymbolModule = __webpack_require__("e538");
                var defineProperty = __webpack_require__("9bf2").f;
                module2.exports = function(NAME) {
                  var Symbol2 = path.Symbol || (path.Symbol = {});
                  if (!has(Symbol2, NAME)) defineProperty(Symbol2, NAME, {
                    value: wrappedWellKnownSymbolModule.f(NAME)
                  });
                };
              })
            ),
            /***/
            "7839": (
              /***/
              (function(module2, exports2) {
                module2.exports = [
                  "constructor",
                  "hasOwnProperty",
                  "isPrototypeOf",
                  "propertyIsEnumerable",
                  "toLocaleString",
                  "toString",
                  "valueOf"
                ];
              })
            ),
            /***/
            "7b0b": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var requireObjectCoercible = __webpack_require__("1d80");
                module2.exports = function(argument) {
                  return Object(requireObjectCoercible(argument));
                };
              })
            ),
            /***/
            "7c73": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var anObject = __webpack_require__("825a");
                var defineProperties = __webpack_require__("37e8");
                var enumBugKeys = __webpack_require__("7839");
                var hiddenKeys = __webpack_require__("d012");
                var html = __webpack_require__("1be4");
                var documentCreateElement = __webpack_require__("cc12");
                var sharedKey = __webpack_require__("f772");
                var GT = ">";
                var LT = "<";
                var PROTOTYPE = "prototype";
                var SCRIPT = "script";
                var IE_PROTO = sharedKey("IE_PROTO");
                var EmptyConstructor = function() {
                };
                var scriptTag = function(content) {
                  return LT + SCRIPT + GT + content + LT + "/" + SCRIPT + GT;
                };
                var NullProtoObjectViaActiveX = function(activeXDocument2) {
                  activeXDocument2.write(scriptTag(""));
                  activeXDocument2.close();
                  var temp = activeXDocument2.parentWindow.Object;
                  activeXDocument2 = null;
                  return temp;
                };
                var NullProtoObjectViaIFrame = function() {
                  var iframe = documentCreateElement("iframe");
                  var JS = "java" + SCRIPT + ":";
                  var iframeDocument;
                  iframe.style.display = "none";
                  html.appendChild(iframe);
                  iframe.src = String(JS);
                  iframeDocument = iframe.contentWindow.document;
                  iframeDocument.open();
                  iframeDocument.write(scriptTag("document.F=Object"));
                  iframeDocument.close();
                  return iframeDocument.F;
                };
                var activeXDocument;
                var NullProtoObject = function() {
                  try {
                    activeXDocument = document.domain && new ActiveXObject("htmlfile");
                  } catch (error) {
                  }
                  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
                  var length = enumBugKeys.length;
                  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
                  return NullProtoObject();
                };
                hiddenKeys[IE_PROTO] = true;
                module2.exports = Object.create || function create2(O, Properties) {
                  var result;
                  if (O !== null) {
                    EmptyConstructor[PROTOTYPE] = anObject(O);
                    result = new EmptyConstructor();
                    EmptyConstructor[PROTOTYPE] = null;
                    result[IE_PROTO] = O;
                  } else result = NullProtoObject();
                  return Properties === void 0 ? result : defineProperties(result, Properties);
                };
              })
            ),
            /***/
            "7dd0": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var $2 = __webpack_require__("23e7");
                var createIteratorConstructor = __webpack_require__("9ed3");
                var getPrototypeOf2 = __webpack_require__("e163");
                var setPrototypeOf = __webpack_require__("d2bb");
                var setToStringTag = __webpack_require__("d44e");
                var createNonEnumerableProperty = __webpack_require__("9112");
                var redefine = __webpack_require__("6eeb");
                var wellKnownSymbol = __webpack_require__("b622");
                var IS_PURE = __webpack_require__("c430");
                var Iterators = __webpack_require__("3f8c");
                var IteratorsCore = __webpack_require__("ae93");
                var IteratorPrototype = IteratorsCore.IteratorPrototype;
                var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
                var ITERATOR = wellKnownSymbol("iterator");
                var KEYS = "keys";
                var VALUES = "values";
                var ENTRIES = "entries";
                var returnThis = function() {
                  return this;
                };
                module2.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
                  createIteratorConstructor(IteratorConstructor, NAME, next);
                  var getIterationMethod = function(KIND) {
                    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
                    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
                    switch (KIND) {
                      case KEYS:
                        return function keys() {
                          return new IteratorConstructor(this, KIND);
                        };
                      case VALUES:
                        return function values() {
                          return new IteratorConstructor(this, KIND);
                        };
                      case ENTRIES:
                        return function entries() {
                          return new IteratorConstructor(this, KIND);
                        };
                    }
                    return function() {
                      return new IteratorConstructor(this);
                    };
                  };
                  var TO_STRING_TAG = NAME + " Iterator";
                  var INCORRECT_VALUES_NAME = false;
                  var IterablePrototype = Iterable.prototype;
                  var nativeIterator = IterablePrototype[ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
                  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
                  var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
                  var CurrentIteratorPrototype, methods, KEY;
                  if (anyNativeIterator) {
                    CurrentIteratorPrototype = getPrototypeOf2(anyNativeIterator.call(new Iterable()));
                    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
                      if (!IS_PURE && getPrototypeOf2(CurrentIteratorPrototype) !== IteratorPrototype) {
                        if (setPrototypeOf) {
                          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
                        } else if (typeof CurrentIteratorPrototype[ITERATOR] != "function") {
                          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
                        }
                      }
                      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
                      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
                    }
                  }
                  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
                    INCORRECT_VALUES_NAME = true;
                    defaultIterator = function values() {
                      return nativeIterator.call(this);
                    };
                  }
                  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
                    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
                  }
                  Iterators[NAME] = defaultIterator;
                  if (DEFAULT) {
                    methods = {
                      values: getIterationMethod(VALUES),
                      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
                      entries: getIterationMethod(ENTRIES)
                    };
                    if (FORCED) for (KEY in methods) {
                      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
                        redefine(IterablePrototype, KEY, methods[KEY]);
                      }
                    }
                    else $2({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
                  }
                  return methods;
                };
              })
            ),
            /***/
            "7f9a": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var global2 = __webpack_require__("da84");
                var inspectSource = __webpack_require__("8925");
                var WeakMap2 = global2.WeakMap;
                module2.exports = typeof WeakMap2 === "function" && /native code/.test(inspectSource(WeakMap2));
              })
            ),
            /***/
            "825a": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var isObject4 = __webpack_require__("861d");
                module2.exports = function(it) {
                  if (!isObject4(it)) {
                    throw TypeError(String(it) + " is not an object");
                  }
                  return it;
                };
              })
            ),
            /***/
            "83ab": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var fails = __webpack_require__("d039");
                module2.exports = !fails(function() {
                  return Object.defineProperty({}, 1, { get: function() {
                    return 7;
                  } })[1] != 7;
                });
              })
            ),
            /***/
            "8418": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var toPrimitive = __webpack_require__("c04e");
                var definePropertyModule = __webpack_require__("9bf2");
                var createPropertyDescriptor = __webpack_require__("5c6c");
                module2.exports = function(object, key, value) {
                  var propertyKey = toPrimitive(key);
                  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
                  else object[propertyKey] = value;
                };
              })
            ),
            /***/
            "861d": (
              /***/
              (function(module2, exports2) {
                module2.exports = function(it) {
                  return typeof it === "object" ? it !== null : typeof it === "function";
                };
              })
            ),
            /***/
            "8875": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
                (function(root, factory2) {
                  if (true) {
                    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = factory2, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === "function" ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports2, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== void 0 && (module2.exports = __WEBPACK_AMD_DEFINE_RESULT__));
                  } else {
                  }
                })(typeof self !== "undefined" ? self : this, function() {
                  function getCurrentScript() {
                    var descriptor = Object.getOwnPropertyDescriptor(document, "currentScript");
                    if (!descriptor && "currentScript" in document && document.currentScript) {
                      return document.currentScript;
                    }
                    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
                      return document.currentScript;
                    }
                    try {
                      throw new Error();
                    } catch (err) {
                      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig, ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig, stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack), scriptLocation = stackDetails && stackDetails[1] || false, line = stackDetails && stackDetails[2] || false, currentLocation = document.location.href.replace(document.location.hash, ""), pageSource, inlineScriptSourceRegExp, inlineScriptSource, scripts = document.getElementsByTagName("script");
                      if (scriptLocation === currentLocation) {
                        pageSource = document.documentElement.outerHTML;
                        inlineScriptSourceRegExp = new RegExp("(?:[^\\n]+?\\n){0," + (line - 2) + "}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*", "i");
                        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, "$1").trim();
                      }
                      for (var i2 = 0; i2 < scripts.length; i2++) {
                        if (scripts[i2].readyState === "interactive") {
                          return scripts[i2];
                        }
                        if (scripts[i2].src === scriptLocation) {
                          return scripts[i2];
                        }
                        if (scriptLocation === currentLocation && scripts[i2].innerHTML && scripts[i2].innerHTML.trim() === inlineScriptSource) {
                          return scripts[i2];
                        }
                      }
                      return null;
                    }
                  }
                  ;
                  return getCurrentScript;
                });
              })
            ),
            /***/
            "8925": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var store2 = __webpack_require__("c6cd");
                var functionToString = Function.toString;
                if (typeof store2.inspectSource != "function") {
                  store2.inspectSource = function(it) {
                    return functionToString.call(it);
                  };
                }
                module2.exports = store2.inspectSource;
              })
            ),
            /***/
            "8aa5": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var charAt = __webpack_require__("6547").charAt;
                module2.exports = function(S2, index, unicode) {
                  return index + (unicode ? charAt(S2, index).length : 1);
                };
              })
            ),
            /***/
            "8bbf": (
              /***/
              (function(module2, exports2) {
                module2.exports = __WEBPACK_EXTERNAL_MODULE__8bbf__;
              })
            ),
            /***/
            "90e3": (
              /***/
              (function(module2, exports2) {
                var id = 0;
                var postfix = Math.random();
                module2.exports = function(key) {
                  return "Symbol(" + String(key === void 0 ? "" : key) + ")_" + (++id + postfix).toString(36);
                };
              })
            ),
            /***/
            "9112": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var DESCRIPTORS = __webpack_require__("83ab");
                var definePropertyModule = __webpack_require__("9bf2");
                var createPropertyDescriptor = __webpack_require__("5c6c");
                module2.exports = DESCRIPTORS ? function(object, key, value) {
                  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
                } : function(object, key, value) {
                  object[key] = value;
                  return object;
                };
              })
            ),
            /***/
            "9263": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var regexpFlags = __webpack_require__("ad6d");
                var stickyHelpers = __webpack_require__("9f7f");
                var nativeExec = RegExp.prototype.exec;
                var nativeReplace = String.prototype.replace;
                var patchedExec = nativeExec;
                var UPDATES_LAST_INDEX_WRONG = (function() {
                  var re1 = /a/;
                  var re2 = /b*/g;
                  nativeExec.call(re1, "a");
                  nativeExec.call(re2, "a");
                  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
                })();
                var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;
                var NPCG_INCLUDED = /()??/.exec("")[1] !== void 0;
                var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;
                if (PATCH) {
                  patchedExec = function exec(str) {
                    var re2 = this;
                    var lastIndex, reCopy, match, i2;
                    var sticky = UNSUPPORTED_Y && re2.sticky;
                    var flags = regexpFlags.call(re2);
                    var source = re2.source;
                    var charsAdded = 0;
                    var strCopy = str;
                    if (sticky) {
                      flags = flags.replace("y", "");
                      if (flags.indexOf("g") === -1) {
                        flags += "g";
                      }
                      strCopy = String(str).slice(re2.lastIndex);
                      if (re2.lastIndex > 0 && (!re2.multiline || re2.multiline && str[re2.lastIndex - 1] !== "\n")) {
                        source = "(?: " + source + ")";
                        strCopy = " " + strCopy;
                        charsAdded++;
                      }
                      reCopy = new RegExp("^(?:" + source + ")", flags);
                    }
                    if (NPCG_INCLUDED) {
                      reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
                    }
                    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re2.lastIndex;
                    match = nativeExec.call(sticky ? reCopy : re2, strCopy);
                    if (sticky) {
                      if (match) {
                        match.input = match.input.slice(charsAdded);
                        match[0] = match[0].slice(charsAdded);
                        match.index = re2.lastIndex;
                        re2.lastIndex += match[0].length;
                      } else re2.lastIndex = 0;
                    } else if (UPDATES_LAST_INDEX_WRONG && match) {
                      re2.lastIndex = re2.global ? match.index + match[0].length : lastIndex;
                    }
                    if (NPCG_INCLUDED && match && match.length > 1) {
                      nativeReplace.call(match[0], reCopy, function() {
                        for (i2 = 1; i2 < arguments.length - 2; i2++) {
                          if (arguments[i2] === void 0) match[i2] = void 0;
                        }
                      });
                    }
                    return match;
                  };
                }
                module2.exports = patchedExec;
              })
            ),
            /***/
            "94ca": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var fails = __webpack_require__("d039");
                var replacement = /#|\.prototype\./;
                var isForced = function(feature, detection) {
                  var value = data[normalize(feature)];
                  return value == POLYFILL ? true : value == NATIVE ? false : typeof detection == "function" ? fails(detection) : !!detection;
                };
                var normalize = isForced.normalize = function(string) {
                  return String(string).replace(replacement, ".").toLowerCase();
                };
                var data = isForced.data = {};
                var NATIVE = isForced.NATIVE = "N";
                var POLYFILL = isForced.POLYFILL = "P";
                module2.exports = isForced;
              })
            ),
            /***/
            "99af": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var $2 = __webpack_require__("23e7");
                var fails = __webpack_require__("d039");
                var isArray3 = __webpack_require__("e8b5");
                var isObject4 = __webpack_require__("861d");
                var toObject = __webpack_require__("7b0b");
                var toLength = __webpack_require__("50c4");
                var createProperty = __webpack_require__("8418");
                var arraySpeciesCreate = __webpack_require__("65f0");
                var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
                var wellKnownSymbol = __webpack_require__("b622");
                var V8_VERSION = __webpack_require__("2d00");
                var IS_CONCAT_SPREADABLE = wellKnownSymbol("isConcatSpreadable");
                var MAX_SAFE_INTEGER2 = 9007199254740991;
                var MAXIMUM_ALLOWED_INDEX_EXCEEDED = "Maximum allowed index exceeded";
                var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function() {
                  var array = [];
                  array[IS_CONCAT_SPREADABLE] = false;
                  return array.concat()[0] !== array;
                });
                var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("concat");
                var isConcatSpreadable = function(O) {
                  if (!isObject4(O)) return false;
                  var spreadable = O[IS_CONCAT_SPREADABLE];
                  return spreadable !== void 0 ? !!spreadable : isArray3(O);
                };
                var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;
                $2({ target: "Array", proto: true, forced: FORCED }, {
                  concat: function concat(arg) {
                    var O = toObject(this);
                    var A = arraySpeciesCreate(O, 0);
                    var n = 0;
                    var i2, k, length, len, E;
                    for (i2 = -1, length = arguments.length; i2 < length; i2++) {
                      E = i2 === -1 ? O : arguments[i2];
                      if (isConcatSpreadable(E)) {
                        len = toLength(E.length);
                        if (n + len > MAX_SAFE_INTEGER2) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
                        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
                      } else {
                        if (n >= MAX_SAFE_INTEGER2) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
                        createProperty(A, n++, E);
                      }
                    }
                    A.length = n;
                    return A;
                  }
                });
              })
            ),
            /***/
            "9bdd": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var anObject = __webpack_require__("825a");
                module2.exports = function(iterator3, fn, value, ENTRIES) {
                  try {
                    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
                  } catch (error) {
                    var returnMethod = iterator3["return"];
                    if (returnMethod !== void 0) anObject(returnMethod.call(iterator3));
                    throw error;
                  }
                };
              })
            ),
            /***/
            "9bf2": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var DESCRIPTORS = __webpack_require__("83ab");
                var IE8_DOM_DEFINE = __webpack_require__("0cfb");
                var anObject = __webpack_require__("825a");
                var toPrimitive = __webpack_require__("c04e");
                var nativeDefineProperty = Object.defineProperty;
                exports2.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P2, Attributes) {
                  anObject(O);
                  P2 = toPrimitive(P2, true);
                  anObject(Attributes);
                  if (IE8_DOM_DEFINE) try {
                    return nativeDefineProperty(O, P2, Attributes);
                  } catch (error) {
                  }
                  if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported");
                  if ("value" in Attributes) O[P2] = Attributes.value;
                  return O;
                };
              })
            ),
            /***/
            "9ed3": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;
                var create2 = __webpack_require__("7c73");
                var createPropertyDescriptor = __webpack_require__("5c6c");
                var setToStringTag = __webpack_require__("d44e");
                var Iterators = __webpack_require__("3f8c");
                var returnThis = function() {
                  return this;
                };
                module2.exports = function(IteratorConstructor, NAME, next) {
                  var TO_STRING_TAG = NAME + " Iterator";
                  IteratorConstructor.prototype = create2(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
                  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
                  Iterators[TO_STRING_TAG] = returnThis;
                  return IteratorConstructor;
                };
              })
            ),
            /***/
            "9f7f": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var fails = __webpack_require__("d039");
                function RE(s, f) {
                  return RegExp(s, f);
                }
                exports2.UNSUPPORTED_Y = fails(function() {
                  var re2 = RE("a", "y");
                  re2.lastIndex = 2;
                  return re2.exec("abcd") != null;
                });
                exports2.BROKEN_CARET = fails(function() {
                  var re2 = RE("^r", "gy");
                  re2.lastIndex = 2;
                  return re2.exec("str") != null;
                });
              })
            ),
            /***/
            "a2bf": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var isArray3 = __webpack_require__("e8b5");
                var toLength = __webpack_require__("50c4");
                var bind2 = __webpack_require__("0366");
                var flattenIntoArray = function(target, original, source, sourceLen, start, depth, mapper, thisArg) {
                  var targetIndex = start;
                  var sourceIndex = 0;
                  var mapFn = mapper ? bind2(mapper, thisArg, 3) : false;
                  var element;
                  while (sourceIndex < sourceLen) {
                    if (sourceIndex in source) {
                      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
                      if (depth > 0 && isArray3(element)) {
                        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
                      } else {
                        if (targetIndex >= 9007199254740991) throw TypeError("Exceed the acceptable array length");
                        target[targetIndex] = element;
                      }
                      targetIndex++;
                    }
                    sourceIndex++;
                  }
                  return targetIndex;
                };
                module2.exports = flattenIntoArray;
              })
            ),
            /***/
            "a352": (
              /***/
              (function(module2, exports2) {
                module2.exports = __WEBPACK_EXTERNAL_MODULE_a352__;
              })
            ),
            /***/
            "a434": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var $2 = __webpack_require__("23e7");
                var toAbsoluteIndex = __webpack_require__("23cb");
                var toInteger = __webpack_require__("a691");
                var toLength = __webpack_require__("50c4");
                var toObject = __webpack_require__("7b0b");
                var arraySpeciesCreate = __webpack_require__("65f0");
                var createProperty = __webpack_require__("8418");
                var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
                var arrayMethodUsesToLength = __webpack_require__("ae40");
                var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("splice");
                var USES_TO_LENGTH = arrayMethodUsesToLength("splice", { ACCESSORS: true, 0: 0, 1: 2 });
                var max = Math.max;
                var min = Math.min;
                var MAX_SAFE_INTEGER2 = 9007199254740991;
                var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = "Maximum allowed length exceeded";
                $2({ target: "Array", proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
                  splice: function splice(start, deleteCount) {
                    var O = toObject(this);
                    var len = toLength(O.length);
                    var actualStart = toAbsoluteIndex(start, len);
                    var argumentsLength = arguments.length;
                    var insertCount, actualDeleteCount, A, k, from, to;
                    if (argumentsLength === 0) {
                      insertCount = actualDeleteCount = 0;
                    } else if (argumentsLength === 1) {
                      insertCount = 0;
                      actualDeleteCount = len - actualStart;
                    } else {
                      insertCount = argumentsLength - 2;
                      actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
                    }
                    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER2) {
                      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
                    }
                    A = arraySpeciesCreate(O, actualDeleteCount);
                    for (k = 0; k < actualDeleteCount; k++) {
                      from = actualStart + k;
                      if (from in O) createProperty(A, k, O[from]);
                    }
                    A.length = actualDeleteCount;
                    if (insertCount < actualDeleteCount) {
                      for (k = actualStart; k < len - actualDeleteCount; k++) {
                        from = k + actualDeleteCount;
                        to = k + insertCount;
                        if (from in O) O[to] = O[from];
                        else delete O[to];
                      }
                      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
                    } else if (insertCount > actualDeleteCount) {
                      for (k = len - actualDeleteCount; k > actualStart; k--) {
                        from = k + actualDeleteCount - 1;
                        to = k + insertCount - 1;
                        if (from in O) O[to] = O[from];
                        else delete O[to];
                      }
                    }
                    for (k = 0; k < insertCount; k++) {
                      O[k + actualStart] = arguments[k + 2];
                    }
                    O.length = len - actualDeleteCount + insertCount;
                    return A;
                  }
                });
              })
            ),
            /***/
            "a4d3": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var $2 = __webpack_require__("23e7");
                var global2 = __webpack_require__("da84");
                var getBuiltIn = __webpack_require__("d066");
                var IS_PURE = __webpack_require__("c430");
                var DESCRIPTORS = __webpack_require__("83ab");
                var NATIVE_SYMBOL = __webpack_require__("4930");
                var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");
                var fails = __webpack_require__("d039");
                var has = __webpack_require__("5135");
                var isArray3 = __webpack_require__("e8b5");
                var isObject4 = __webpack_require__("861d");
                var anObject = __webpack_require__("825a");
                var toObject = __webpack_require__("7b0b");
                var toIndexedObject = __webpack_require__("fc6a");
                var toPrimitive = __webpack_require__("c04e");
                var createPropertyDescriptor = __webpack_require__("5c6c");
                var nativeObjectCreate = __webpack_require__("7c73");
                var objectKeys = __webpack_require__("df75");
                var getOwnPropertyNamesModule = __webpack_require__("241c");
                var getOwnPropertyNamesExternal = __webpack_require__("057f");
                var getOwnPropertySymbolsModule = __webpack_require__("7418");
                var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
                var definePropertyModule = __webpack_require__("9bf2");
                var propertyIsEnumerableModule = __webpack_require__("d1e7");
                var createNonEnumerableProperty = __webpack_require__("9112");
                var redefine = __webpack_require__("6eeb");
                var shared = __webpack_require__("5692");
                var sharedKey = __webpack_require__("f772");
                var hiddenKeys = __webpack_require__("d012");
                var uid3 = __webpack_require__("90e3");
                var wellKnownSymbol = __webpack_require__("b622");
                var wrappedWellKnownSymbolModule = __webpack_require__("e538");
                var defineWellKnownSymbol = __webpack_require__("746f");
                var setToStringTag = __webpack_require__("d44e");
                var InternalStateModule = __webpack_require__("69f3");
                var $forEach = __webpack_require__("b727").forEach;
                var HIDDEN = sharedKey("hidden");
                var SYMBOL = "Symbol";
                var PROTOTYPE = "prototype";
                var TO_PRIMITIVE = wellKnownSymbol("toPrimitive");
                var setInternalState = InternalStateModule.set;
                var getInternalState = InternalStateModule.getterFor(SYMBOL);
                var ObjectPrototype = Object[PROTOTYPE];
                var $Symbol = global2.Symbol;
                var $stringify = getBuiltIn("JSON", "stringify");
                var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
                var nativeDefineProperty = definePropertyModule.f;
                var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
                var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
                var AllSymbols = shared("symbols");
                var ObjectPrototypeSymbols = shared("op-symbols");
                var StringToSymbolRegistry = shared("string-to-symbol-registry");
                var SymbolToStringRegistry = shared("symbol-to-string-registry");
                var WellKnownSymbolsStore = shared("wks");
                var QObject = global2.QObject;
                var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
                var setSymbolDescriptor = DESCRIPTORS && fails(function() {
                  return nativeObjectCreate(nativeDefineProperty({}, "a", {
                    get: function() {
                      return nativeDefineProperty(this, "a", { value: 7 }).a;
                    }
                  })).a != 7;
                }) ? function(O, P2, Attributes) {
                  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P2);
                  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P2];
                  nativeDefineProperty(O, P2, Attributes);
                  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
                    nativeDefineProperty(ObjectPrototype, P2, ObjectPrototypeDescriptor);
                  }
                } : nativeDefineProperty;
                var wrap = function(tag, description) {
                  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
                  setInternalState(symbol, {
                    type: SYMBOL,
                    tag,
                    description
                  });
                  if (!DESCRIPTORS) symbol.description = description;
                  return symbol;
                };
                var isSymbol2 = USE_SYMBOL_AS_UID ? function(it) {
                  return typeof it == "symbol";
                } : function(it) {
                  return Object(it) instanceof $Symbol;
                };
                var $defineProperty = function defineProperty(O, P2, Attributes) {
                  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P2, Attributes);
                  anObject(O);
                  var key = toPrimitive(P2, true);
                  anObject(Attributes);
                  if (has(AllSymbols, key)) {
                    if (!Attributes.enumerable) {
                      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
                      O[HIDDEN][key] = true;
                    } else {
                      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
                      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
                    }
                    return setSymbolDescriptor(O, key, Attributes);
                  }
                  return nativeDefineProperty(O, key, Attributes);
                };
                var $defineProperties = function defineProperties(O, Properties) {
                  anObject(O);
                  var properties = toIndexedObject(Properties);
                  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
                  $forEach(keys, function(key) {
                    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
                  });
                  return O;
                };
                var $create = function create2(O, Properties) {
                  return Properties === void 0 ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
                };
                var $propertyIsEnumerable = function propertyIsEnumerable2(V) {
                  var P2 = toPrimitive(V, true);
                  var enumerable = nativePropertyIsEnumerable.call(this, P2);
                  if (this === ObjectPrototype && has(AllSymbols, P2) && !has(ObjectPrototypeSymbols, P2)) return false;
                  return enumerable || !has(this, P2) || !has(AllSymbols, P2) || has(this, HIDDEN) && this[HIDDEN][P2] ? enumerable : true;
                };
                var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P2) {
                  var it = toIndexedObject(O);
                  var key = toPrimitive(P2, true);
                  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
                  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
                  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
                    descriptor.enumerable = true;
                  }
                  return descriptor;
                };
                var $getOwnPropertyNames = function getOwnPropertyNames(O) {
                  var names2 = nativeGetOwnPropertyNames(toIndexedObject(O));
                  var result = [];
                  $forEach(names2, function(key) {
                    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
                  });
                  return result;
                };
                var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
                  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
                  var names2 = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
                  var result = [];
                  $forEach(names2, function(key) {
                    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
                      result.push(AllSymbols[key]);
                    }
                  });
                  return result;
                };
                if (!NATIVE_SYMBOL) {
                  $Symbol = function Symbol2() {
                    if (this instanceof $Symbol) throw TypeError("Symbol is not a constructor");
                    var description = !arguments.length || arguments[0] === void 0 ? void 0 : String(arguments[0]);
                    var tag = uid3(description);
                    var setter = function(value) {
                      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
                      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
                      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
                    };
                    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
                    return wrap(tag, description);
                  };
                  redefine($Symbol[PROTOTYPE], "toString", function toString3() {
                    return getInternalState(this).tag;
                  });
                  redefine($Symbol, "withoutSetter", function(description) {
                    return wrap(uid3(description), description);
                  });
                  propertyIsEnumerableModule.f = $propertyIsEnumerable;
                  definePropertyModule.f = $defineProperty;
                  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
                  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
                  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;
                  wrappedWellKnownSymbolModule.f = function(name) {
                    return wrap(wellKnownSymbol(name), name);
                  };
                  if (DESCRIPTORS) {
                    nativeDefineProperty($Symbol[PROTOTYPE], "description", {
                      configurable: true,
                      get: function description() {
                        return getInternalState(this).description;
                      }
                    });
                    if (!IS_PURE) {
                      redefine(ObjectPrototype, "propertyIsEnumerable", $propertyIsEnumerable, { unsafe: true });
                    }
                  }
                }
                $2({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
                  Symbol: $Symbol
                });
                $forEach(objectKeys(WellKnownSymbolsStore), function(name) {
                  defineWellKnownSymbol(name);
                });
                $2({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
                  // `Symbol.for` method
                  // https://tc39.github.io/ecma262/#sec-symbol.for
                  "for": function(key) {
                    var string = String(key);
                    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
                    var symbol = $Symbol(string);
                    StringToSymbolRegistry[string] = symbol;
                    SymbolToStringRegistry[symbol] = string;
                    return symbol;
                  },
                  // `Symbol.keyFor` method
                  // https://tc39.github.io/ecma262/#sec-symbol.keyfor
                  keyFor: function keyFor(sym) {
                    if (!isSymbol2(sym)) throw TypeError(sym + " is not a symbol");
                    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
                  },
                  useSetter: function() {
                    USE_SETTER = true;
                  },
                  useSimple: function() {
                    USE_SETTER = false;
                  }
                });
                $2({ target: "Object", stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
                  // `Object.create` method
                  // https://tc39.github.io/ecma262/#sec-object.create
                  create: $create,
                  // `Object.defineProperty` method
                  // https://tc39.github.io/ecma262/#sec-object.defineproperty
                  defineProperty: $defineProperty,
                  // `Object.defineProperties` method
                  // https://tc39.github.io/ecma262/#sec-object.defineproperties
                  defineProperties: $defineProperties,
                  // `Object.getOwnPropertyDescriptor` method
                  // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
                  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
                });
                $2({ target: "Object", stat: true, forced: !NATIVE_SYMBOL }, {
                  // `Object.getOwnPropertyNames` method
                  // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
                  getOwnPropertyNames: $getOwnPropertyNames,
                  // `Object.getOwnPropertySymbols` method
                  // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
                  getOwnPropertySymbols: $getOwnPropertySymbols
                });
                $2({ target: "Object", stat: true, forced: fails(function() {
                  getOwnPropertySymbolsModule.f(1);
                }) }, {
                  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
                    return getOwnPropertySymbolsModule.f(toObject(it));
                  }
                });
                if ($stringify) {
                  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function() {
                    var symbol = $Symbol();
                    return $stringify([symbol]) != "[null]" || $stringify({ a: symbol }) != "{}" || $stringify(Object(symbol)) != "{}";
                  });
                  $2({ target: "JSON", stat: true, forced: FORCED_JSON_STRINGIFY }, {
                    // eslint-disable-next-line no-unused-vars
                    stringify: function stringify(it, replacer2, space) {
                      var args = [it];
                      var index = 1;
                      var $replacer;
                      while (arguments.length > index) args.push(arguments[index++]);
                      $replacer = replacer2;
                      if (!isObject4(replacer2) && it === void 0 || isSymbol2(it)) return;
                      if (!isArray3(replacer2)) replacer2 = function(key, value) {
                        if (typeof $replacer == "function") value = $replacer.call(this, key, value);
                        if (!isSymbol2(value)) return value;
                      };
                      args[1] = replacer2;
                      return $stringify.apply(null, args);
                    }
                  });
                }
                if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
                  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
                }
                setToStringTag($Symbol, SYMBOL);
                hiddenKeys[HIDDEN] = true;
              })
            ),
            /***/
            "a630": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var $2 = __webpack_require__("23e7");
                var from = __webpack_require__("4df4");
                var checkCorrectnessOfIteration = __webpack_require__("1c7e");
                var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function(iterable) {
                  Array.from(iterable);
                });
                $2({ target: "Array", stat: true, forced: INCORRECT_ITERATION }, {
                  from
                });
              })
            ),
            /***/
            "a640": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var fails = __webpack_require__("d039");
                module2.exports = function(METHOD_NAME, argument) {
                  var method = [][METHOD_NAME];
                  return !!method && fails(function() {
                    method.call(null, argument || function() {
                      throw 1;
                    }, 1);
                  });
                };
              })
            ),
            /***/
            "a691": (
              /***/
              (function(module2, exports2) {
                var ceil = Math.ceil;
                var floor = Math.floor;
                module2.exports = function(argument) {
                  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
                };
              })
            ),
            /***/
            "ab13": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var wellKnownSymbol = __webpack_require__("b622");
                var MATCH = wellKnownSymbol("match");
                module2.exports = function(METHOD_NAME) {
                  var regexp = /./;
                  try {
                    "/./"[METHOD_NAME](regexp);
                  } catch (e) {
                    try {
                      regexp[MATCH] = false;
                      return "/./"[METHOD_NAME](regexp);
                    } catch (f) {
                    }
                  }
                  return false;
                };
              })
            ),
            /***/
            "ac1f": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var $2 = __webpack_require__("23e7");
                var exec = __webpack_require__("9263");
                $2({ target: "RegExp", proto: true, forced: /./.exec !== exec }, {
                  exec
                });
              })
            ),
            /***/
            "ad6d": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var anObject = __webpack_require__("825a");
                module2.exports = function() {
                  var that = anObject(this);
                  var result = "";
                  if (that.global) result += "g";
                  if (that.ignoreCase) result += "i";
                  if (that.multiline) result += "m";
                  if (that.dotAll) result += "s";
                  if (that.unicode) result += "u";
                  if (that.sticky) result += "y";
                  return result;
                };
              })
            ),
            /***/
            "ae40": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var DESCRIPTORS = __webpack_require__("83ab");
                var fails = __webpack_require__("d039");
                var has = __webpack_require__("5135");
                var defineProperty = Object.defineProperty;
                var cache = {};
                var thrower = function(it) {
                  throw it;
                };
                module2.exports = function(METHOD_NAME, options) {
                  if (has(cache, METHOD_NAME)) return cache[METHOD_NAME];
                  if (!options) options = {};
                  var method = [][METHOD_NAME];
                  var ACCESSORS = has(options, "ACCESSORS") ? options.ACCESSORS : false;
                  var argument0 = has(options, 0) ? options[0] : thrower;
                  var argument1 = has(options, 1) ? options[1] : void 0;
                  return cache[METHOD_NAME] = !!method && !fails(function() {
                    if (ACCESSORS && !DESCRIPTORS) return true;
                    var O = { length: -1 };
                    if (ACCESSORS) defineProperty(O, 1, { enumerable: true, get: thrower });
                    else O[1] = 1;
                    method.call(O, argument0, argument1);
                  });
                };
              })
            ),
            /***/
            "ae93": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var getPrototypeOf2 = __webpack_require__("e163");
                var createNonEnumerableProperty = __webpack_require__("9112");
                var has = __webpack_require__("5135");
                var wellKnownSymbol = __webpack_require__("b622");
                var IS_PURE = __webpack_require__("c430");
                var ITERATOR = wellKnownSymbol("iterator");
                var BUGGY_SAFARI_ITERATORS = false;
                var returnThis = function() {
                  return this;
                };
                var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
                if ([].keys) {
                  arrayIterator = [].keys();
                  if (!("next" in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
                  else {
                    PrototypeOfArrayIteratorPrototype = getPrototypeOf2(getPrototypeOf2(arrayIterator));
                    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
                  }
                }
                if (IteratorPrototype == void 0) IteratorPrototype = {};
                if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
                  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
                }
                module2.exports = {
                  IteratorPrototype,
                  BUGGY_SAFARI_ITERATORS
                };
              })
            ),
            /***/
            "b041": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
                var classof = __webpack_require__("f5df");
                module2.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString3() {
                  return "[object " + classof(this) + "]";
                };
              })
            ),
            /***/
            "b0c0": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var DESCRIPTORS = __webpack_require__("83ab");
                var defineProperty = __webpack_require__("9bf2").f;
                var FunctionPrototype = Function.prototype;
                var FunctionPrototypeToString = FunctionPrototype.toString;
                var nameRE = /^\s*function ([^ (]*)/;
                var NAME = "name";
                if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
                  defineProperty(FunctionPrototype, NAME, {
                    configurable: true,
                    get: function() {
                      try {
                        return FunctionPrototypeToString.call(this).match(nameRE)[1];
                      } catch (error) {
                        return "";
                      }
                    }
                  });
                }
              })
            ),
            /***/
            "b622": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var global2 = __webpack_require__("da84");
                var shared = __webpack_require__("5692");
                var has = __webpack_require__("5135");
                var uid3 = __webpack_require__("90e3");
                var NATIVE_SYMBOL = __webpack_require__("4930");
                var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");
                var WellKnownSymbolsStore = shared("wks");
                var Symbol2 = global2.Symbol;
                var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol2 : Symbol2 && Symbol2.withoutSetter || uid3;
                module2.exports = function(name) {
                  if (!has(WellKnownSymbolsStore, name)) {
                    if (NATIVE_SYMBOL && has(Symbol2, name)) WellKnownSymbolsStore[name] = Symbol2[name];
                    else WellKnownSymbolsStore[name] = createWellKnownSymbol("Symbol." + name);
                  }
                  return WellKnownSymbolsStore[name];
                };
              })
            ),
            /***/
            "b64b": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var $2 = __webpack_require__("23e7");
                var toObject = __webpack_require__("7b0b");
                var nativeKeys = __webpack_require__("df75");
                var fails = __webpack_require__("d039");
                var FAILS_ON_PRIMITIVES = fails(function() {
                  nativeKeys(1);
                });
                $2({ target: "Object", stat: true, forced: FAILS_ON_PRIMITIVES }, {
                  keys: function keys(it) {
                    return nativeKeys(toObject(it));
                  }
                });
              })
            ),
            /***/
            "b727": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var bind2 = __webpack_require__("0366");
                var IndexedObject = __webpack_require__("44ad");
                var toObject = __webpack_require__("7b0b");
                var toLength = __webpack_require__("50c4");
                var arraySpeciesCreate = __webpack_require__("65f0");
                var push = [].push;
                var createMethod = function(TYPE) {
                  var IS_MAP = TYPE == 1;
                  var IS_FILTER = TYPE == 2;
                  var IS_SOME = TYPE == 3;
                  var IS_EVERY = TYPE == 4;
                  var IS_FIND_INDEX = TYPE == 6;
                  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
                  return function($this, callbackfn, that, specificCreate) {
                    var O = toObject($this);
                    var self2 = IndexedObject(O);
                    var boundFunction = bind2(callbackfn, that, 3);
                    var length = toLength(self2.length);
                    var index = 0;
                    var create2 = specificCreate || arraySpeciesCreate;
                    var target = IS_MAP ? create2($this, length) : IS_FILTER ? create2($this, 0) : void 0;
                    var value, result;
                    for (; length > index; index++) if (NO_HOLES || index in self2) {
                      value = self2[index];
                      result = boundFunction(value, index, O);
                      if (TYPE) {
                        if (IS_MAP) target[index] = result;
                        else if (result) switch (TYPE) {
                          case 3:
                            return true;
                          // some
                          case 5:
                            return value;
                          // find
                          case 6:
                            return index;
                          // findIndex
                          case 2:
                            push.call(target, value);
                        }
                        else if (IS_EVERY) return false;
                      }
                    }
                    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
                  };
                };
                module2.exports = {
                  // `Array.prototype.forEach` method
                  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
                  forEach: createMethod(0),
                  // `Array.prototype.map` method
                  // https://tc39.github.io/ecma262/#sec-array.prototype.map
                  map: createMethod(1),
                  // `Array.prototype.filter` method
                  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
                  filter: createMethod(2),
                  // `Array.prototype.some` method
                  // https://tc39.github.io/ecma262/#sec-array.prototype.some
                  some: createMethod(3),
                  // `Array.prototype.every` method
                  // https://tc39.github.io/ecma262/#sec-array.prototype.every
                  every: createMethod(4),
                  // `Array.prototype.find` method
                  // https://tc39.github.io/ecma262/#sec-array.prototype.find
                  find: createMethod(5),
                  // `Array.prototype.findIndex` method
                  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
                  findIndex: createMethod(6)
                };
              })
            ),
            /***/
            "c04e": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var isObject4 = __webpack_require__("861d");
                module2.exports = function(input, PREFERRED_STRING) {
                  if (!isObject4(input)) return input;
                  var fn, val;
                  if (PREFERRED_STRING && typeof (fn = input.toString) == "function" && !isObject4(val = fn.call(input))) return val;
                  if (typeof (fn = input.valueOf) == "function" && !isObject4(val = fn.call(input))) return val;
                  if (!PREFERRED_STRING && typeof (fn = input.toString) == "function" && !isObject4(val = fn.call(input))) return val;
                  throw TypeError("Can't convert object to primitive value");
                };
              })
            ),
            /***/
            "c430": (
              /***/
              (function(module2, exports2) {
                module2.exports = false;
              })
            ),
            /***/
            "c6b6": (
              /***/
              (function(module2, exports2) {
                var toString3 = {}.toString;
                module2.exports = function(it) {
                  return toString3.call(it).slice(8, -1);
                };
              })
            ),
            /***/
            "c6cd": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var global2 = __webpack_require__("da84");
                var setGlobal = __webpack_require__("ce4e");
                var SHARED = "__core-js_shared__";
                var store2 = global2[SHARED] || setGlobal(SHARED, {});
                module2.exports = store2;
              })
            ),
            /***/
            "c740": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var $2 = __webpack_require__("23e7");
                var $findIndex = __webpack_require__("b727").findIndex;
                var addToUnscopables = __webpack_require__("44d2");
                var arrayMethodUsesToLength = __webpack_require__("ae40");
                var FIND_INDEX = "findIndex";
                var SKIPS_HOLES = true;
                var USES_TO_LENGTH = arrayMethodUsesToLength(FIND_INDEX);
                if (FIND_INDEX in []) Array(1)[FIND_INDEX](function() {
                  SKIPS_HOLES = false;
                });
                $2({ target: "Array", proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH }, {
                  findIndex: function findIndex2(callbackfn) {
                    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
                  }
                });
                addToUnscopables(FIND_INDEX);
              })
            ),
            /***/
            "c8ba": (
              /***/
              (function(module2, exports2) {
                var g;
                g = /* @__PURE__ */ (function() {
                  return this;
                })();
                try {
                  g = g || new Function("return this")();
                } catch (e) {
                  if (typeof window === "object") g = window;
                }
                module2.exports = g;
              })
            ),
            /***/
            "c975": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var $2 = __webpack_require__("23e7");
                var $indexOf = __webpack_require__("4d64").indexOf;
                var arrayMethodIsStrict = __webpack_require__("a640");
                var arrayMethodUsesToLength = __webpack_require__("ae40");
                var nativeIndexOf = [].indexOf;
                var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
                var STRICT_METHOD = arrayMethodIsStrict("indexOf");
                var USES_TO_LENGTH = arrayMethodUsesToLength("indexOf", { ACCESSORS: true, 1: 0 });
                $2({ target: "Array", proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD || !USES_TO_LENGTH }, {
                  indexOf: function indexOf(searchElement) {
                    return NEGATIVE_ZERO ? nativeIndexOf.apply(this, arguments) || 0 : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : void 0);
                  }
                });
              })
            ),
            /***/
            "ca84": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var has = __webpack_require__("5135");
                var toIndexedObject = __webpack_require__("fc6a");
                var indexOf = __webpack_require__("4d64").indexOf;
                var hiddenKeys = __webpack_require__("d012");
                module2.exports = function(object, names2) {
                  var O = toIndexedObject(object);
                  var i2 = 0;
                  var result = [];
                  var key;
                  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
                  while (names2.length > i2) if (has(O, key = names2[i2++])) {
                    ~indexOf(result, key) || result.push(key);
                  }
                  return result;
                };
              })
            ),
            /***/
            "caad": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var $2 = __webpack_require__("23e7");
                var $includes = __webpack_require__("4d64").includes;
                var addToUnscopables = __webpack_require__("44d2");
                var arrayMethodUsesToLength = __webpack_require__("ae40");
                var USES_TO_LENGTH = arrayMethodUsesToLength("indexOf", { ACCESSORS: true, 1: 0 });
                $2({ target: "Array", proto: true, forced: !USES_TO_LENGTH }, {
                  includes: function includes(el) {
                    return $includes(this, el, arguments.length > 1 ? arguments[1] : void 0);
                  }
                });
                addToUnscopables("includes");
              })
            ),
            /***/
            "cc12": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var global2 = __webpack_require__("da84");
                var isObject4 = __webpack_require__("861d");
                var document2 = global2.document;
                var EXISTS = isObject4(document2) && isObject4(document2.createElement);
                module2.exports = function(it) {
                  return EXISTS ? document2.createElement(it) : {};
                };
              })
            ),
            /***/
            "ce4e": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var global2 = __webpack_require__("da84");
                var createNonEnumerableProperty = __webpack_require__("9112");
                module2.exports = function(key, value) {
                  try {
                    createNonEnumerableProperty(global2, key, value);
                  } catch (error) {
                    global2[key] = value;
                  }
                  return value;
                };
              })
            ),
            /***/
            "d012": (
              /***/
              (function(module2, exports2) {
                module2.exports = {};
              })
            ),
            /***/
            "d039": (
              /***/
              (function(module2, exports2) {
                module2.exports = function(exec) {
                  try {
                    return !!exec();
                  } catch (error) {
                    return true;
                  }
                };
              })
            ),
            /***/
            "d066": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var path = __webpack_require__("428f");
                var global2 = __webpack_require__("da84");
                var aFunction = function(variable) {
                  return typeof variable == "function" ? variable : void 0;
                };
                module2.exports = function(namespace, method) {
                  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global2[namespace]) : path[namespace] && path[namespace][method] || global2[namespace] && global2[namespace][method];
                };
              })
            ),
            /***/
            "d1e7": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
                var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
                var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);
                exports2.f = NASHORN_BUG ? function propertyIsEnumerable2(V) {
                  var descriptor = getOwnPropertyDescriptor(this, V);
                  return !!descriptor && descriptor.enumerable;
                } : nativePropertyIsEnumerable;
              })
            ),
            /***/
            "d28b": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var defineWellKnownSymbol = __webpack_require__("746f");
                defineWellKnownSymbol("iterator");
              })
            ),
            /***/
            "d2bb": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var anObject = __webpack_require__("825a");
                var aPossiblePrototype = __webpack_require__("3bbe");
                module2.exports = Object.setPrototypeOf || ("__proto__" in {} ? (function() {
                  var CORRECT_SETTER = false;
                  var test2 = {};
                  var setter;
                  try {
                    setter = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set;
                    setter.call(test2, []);
                    CORRECT_SETTER = test2 instanceof Array;
                  } catch (error) {
                  }
                  return function setPrototypeOf(O, proto) {
                    anObject(O);
                    aPossiblePrototype(proto);
                    if (CORRECT_SETTER) setter.call(O, proto);
                    else O.__proto__ = proto;
                    return O;
                  };
                })() : void 0);
              })
            ),
            /***/
            "d3b7": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
                var redefine = __webpack_require__("6eeb");
                var toString3 = __webpack_require__("b041");
                if (!TO_STRING_TAG_SUPPORT) {
                  redefine(Object.prototype, "toString", toString3, { unsafe: true });
                }
              })
            ),
            /***/
            "d44e": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var defineProperty = __webpack_require__("9bf2").f;
                var has = __webpack_require__("5135");
                var wellKnownSymbol = __webpack_require__("b622");
                var TO_STRING_TAG = wellKnownSymbol("toStringTag");
                module2.exports = function(it, TAG, STATIC) {
                  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
                    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
                  }
                };
              })
            ),
            /***/
            "d58f": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var aFunction = __webpack_require__("1c0b");
                var toObject = __webpack_require__("7b0b");
                var IndexedObject = __webpack_require__("44ad");
                var toLength = __webpack_require__("50c4");
                var createMethod = function(IS_RIGHT) {
                  return function(that, callbackfn, argumentsLength, memo) {
                    aFunction(callbackfn);
                    var O = toObject(that);
                    var self2 = IndexedObject(O);
                    var length = toLength(O.length);
                    var index = IS_RIGHT ? length - 1 : 0;
                    var i2 = IS_RIGHT ? -1 : 1;
                    if (argumentsLength < 2) while (true) {
                      if (index in self2) {
                        memo = self2[index];
                        index += i2;
                        break;
                      }
                      index += i2;
                      if (IS_RIGHT ? index < 0 : length <= index) {
                        throw TypeError("Reduce of empty array with no initial value");
                      }
                    }
                    for (; IS_RIGHT ? index >= 0 : length > index; index += i2) if (index in self2) {
                      memo = callbackfn(memo, self2[index], index, O);
                    }
                    return memo;
                  };
                };
                module2.exports = {
                  // `Array.prototype.reduce` method
                  // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
                  left: createMethod(false),
                  // `Array.prototype.reduceRight` method
                  // https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
                  right: createMethod(true)
                };
              })
            ),
            /***/
            "d784": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                __webpack_require__("ac1f");
                var redefine = __webpack_require__("6eeb");
                var fails = __webpack_require__("d039");
                var wellKnownSymbol = __webpack_require__("b622");
                var regexpExec = __webpack_require__("9263");
                var createNonEnumerableProperty = __webpack_require__("9112");
                var SPECIES = wellKnownSymbol("species");
                var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function() {
                  var re2 = /./;
                  re2.exec = function() {
                    var result = [];
                    result.groups = { a: "7" };
                    return result;
                  };
                  return "".replace(re2, "$<a>") !== "7";
                });
                var REPLACE_KEEPS_$0 = (function() {
                  return "a".replace(/./, "$0") === "$0";
                })();
                var REPLACE = wellKnownSymbol("replace");
                var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function() {
                  if (/./[REPLACE]) {
                    return /./[REPLACE]("a", "$0") === "";
                  }
                  return false;
                })();
                var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function() {
                  var re2 = /(?:)/;
                  var originalExec = re2.exec;
                  re2.exec = function() {
                    return originalExec.apply(this, arguments);
                  };
                  var result = "ab".split(re2);
                  return result.length !== 2 || result[0] !== "a" || result[1] !== "b";
                });
                module2.exports = function(KEY, length, exec, sham) {
                  var SYMBOL = wellKnownSymbol(KEY);
                  var DELEGATES_TO_SYMBOL = !fails(function() {
                    var O = {};
                    O[SYMBOL] = function() {
                      return 7;
                    };
                    return ""[KEY](O) != 7;
                  });
                  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function() {
                    var execCalled = false;
                    var re2 = /a/;
                    if (KEY === "split") {
                      re2 = {};
                      re2.constructor = {};
                      re2.constructor[SPECIES] = function() {
                        return re2;
                      };
                      re2.flags = "";
                      re2[SYMBOL] = /./[SYMBOL];
                    }
                    re2.exec = function() {
                      execCalled = true;
                      return null;
                    };
                    re2[SYMBOL]("");
                    return !execCalled;
                  });
                  if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === "replace" && !(REPLACE_SUPPORTS_NAMED_GROUPS && REPLACE_KEEPS_$0 && !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE) || KEY === "split" && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
                    var nativeRegExpMethod = /./[SYMBOL];
                    var methods = exec(SYMBOL, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
                      if (regexp.exec === regexpExec) {
                        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
                          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
                        }
                        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
                      }
                      return { done: false };
                    }, {
                      REPLACE_KEEPS_$0,
                      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
                    });
                    var stringMethod = methods[0];
                    var regexMethod = methods[1];
                    redefine(String.prototype, KEY, stringMethod);
                    redefine(
                      RegExp.prototype,
                      SYMBOL,
                      length == 2 ? function(string, arg) {
                        return regexMethod.call(string, this, arg);
                      } : function(string) {
                        return regexMethod.call(string, this);
                      }
                    );
                  }
                  if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], "sham", true);
                };
              })
            ),
            /***/
            "d81d": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var $2 = __webpack_require__("23e7");
                var $map = __webpack_require__("b727").map;
                var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
                var arrayMethodUsesToLength = __webpack_require__("ae40");
                var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("map");
                var USES_TO_LENGTH = arrayMethodUsesToLength("map");
                $2({ target: "Array", proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
                  map: function map3(callbackfn) {
                    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
                  }
                });
              })
            ),
            /***/
            "da84": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                (function(global2) {
                  var check = function(it) {
                    return it && it.Math == Math && it;
                  };
                  module2.exports = // eslint-disable-next-line no-undef
                  check(typeof globalThis == "object" && globalThis) || check(typeof window == "object" && window) || check(typeof self == "object" && self) || check(typeof global2 == "object" && global2) || // eslint-disable-next-line no-new-func
                  Function("return this")();
                }).call(this, __webpack_require__("c8ba"));
              })
            ),
            /***/
            "dbb4": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var $2 = __webpack_require__("23e7");
                var DESCRIPTORS = __webpack_require__("83ab");
                var ownKeys2 = __webpack_require__("56ef");
                var toIndexedObject = __webpack_require__("fc6a");
                var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
                var createProperty = __webpack_require__("8418");
                $2({ target: "Object", stat: true, sham: !DESCRIPTORS }, {
                  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
                    var O = toIndexedObject(object);
                    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
                    var keys = ownKeys2(O);
                    var result = {};
                    var index = 0;
                    var key, descriptor;
                    while (keys.length > index) {
                      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
                      if (descriptor !== void 0) createProperty(result, key, descriptor);
                    }
                    return result;
                  }
                });
              })
            ),
            /***/
            "dbf1": (
              /***/
              (function(module2, __webpack_exports__, __webpack_require__) {
                "use strict";
                (function(global2) {
                  __webpack_require__.d(__webpack_exports__, "a", function() {
                    return console2;
                  });
                  function getConsole() {
                    if (typeof window !== "undefined") {
                      return window.console;
                    }
                    return global2.console;
                  }
                  var console2 = getConsole();
                }).call(this, __webpack_require__("c8ba"));
              })
            ),
            /***/
            "ddb0": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var global2 = __webpack_require__("da84");
                var DOMIterables = __webpack_require__("fdbc");
                var ArrayIteratorMethods = __webpack_require__("e260");
                var createNonEnumerableProperty = __webpack_require__("9112");
                var wellKnownSymbol = __webpack_require__("b622");
                var ITERATOR = wellKnownSymbol("iterator");
                var TO_STRING_TAG = wellKnownSymbol("toStringTag");
                var ArrayValues = ArrayIteratorMethods.values;
                for (var COLLECTION_NAME in DOMIterables) {
                  var Collection = global2[COLLECTION_NAME];
                  var CollectionPrototype = Collection && Collection.prototype;
                  if (CollectionPrototype) {
                    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
                      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
                    } catch (error) {
                      CollectionPrototype[ITERATOR] = ArrayValues;
                    }
                    if (!CollectionPrototype[TO_STRING_TAG]) {
                      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
                    }
                    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
                      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
                        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
                      } catch (error) {
                        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
                      }
                    }
                  }
                }
              })
            ),
            /***/
            "df75": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var internalObjectKeys = __webpack_require__("ca84");
                var enumBugKeys = __webpack_require__("7839");
                module2.exports = Object.keys || function keys(O) {
                  return internalObjectKeys(O, enumBugKeys);
                };
              })
            ),
            /***/
            "e01a": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var $2 = __webpack_require__("23e7");
                var DESCRIPTORS = __webpack_require__("83ab");
                var global2 = __webpack_require__("da84");
                var has = __webpack_require__("5135");
                var isObject4 = __webpack_require__("861d");
                var defineProperty = __webpack_require__("9bf2").f;
                var copyConstructorProperties = __webpack_require__("e893");
                var NativeSymbol = global2.Symbol;
                if (DESCRIPTORS && typeof NativeSymbol == "function" && (!("description" in NativeSymbol.prototype) || // Safari 12 bug
                NativeSymbol().description !== void 0)) {
                  var EmptyStringDescriptionStore = {};
                  var SymbolWrapper = function Symbol2() {
                    var description = arguments.length < 1 || arguments[0] === void 0 ? void 0 : String(arguments[0]);
                    var result = this instanceof SymbolWrapper ? new NativeSymbol(description) : description === void 0 ? NativeSymbol() : NativeSymbol(description);
                    if (description === "") EmptyStringDescriptionStore[result] = true;
                    return result;
                  };
                  copyConstructorProperties(SymbolWrapper, NativeSymbol);
                  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
                  symbolPrototype.constructor = SymbolWrapper;
                  var symbolToString = symbolPrototype.toString;
                  var native = String(NativeSymbol("test")) == "Symbol(test)";
                  var regexp = /^Symbol\((.*)\)[^)]+$/;
                  defineProperty(symbolPrototype, "description", {
                    configurable: true,
                    get: function description() {
                      var symbol = isObject4(this) ? this.valueOf() : this;
                      var string = symbolToString.call(symbol);
                      if (has(EmptyStringDescriptionStore, symbol)) return "";
                      var desc = native ? string.slice(7, -1) : string.replace(regexp, "$1");
                      return desc === "" ? void 0 : desc;
                    }
                  });
                  $2({ global: true, forced: true }, {
                    Symbol: SymbolWrapper
                  });
                }
              })
            ),
            /***/
            "e163": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var has = __webpack_require__("5135");
                var toObject = __webpack_require__("7b0b");
                var sharedKey = __webpack_require__("f772");
                var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");
                var IE_PROTO = sharedKey("IE_PROTO");
                var ObjectPrototype = Object.prototype;
                module2.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function(O) {
                  O = toObject(O);
                  if (has(O, IE_PROTO)) return O[IE_PROTO];
                  if (typeof O.constructor == "function" && O instanceof O.constructor) {
                    return O.constructor.prototype;
                  }
                  return O instanceof Object ? ObjectPrototype : null;
                };
              })
            ),
            /***/
            "e177": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var fails = __webpack_require__("d039");
                module2.exports = !fails(function() {
                  function F2() {
                  }
                  F2.prototype.constructor = null;
                  return Object.getPrototypeOf(new F2()) !== F2.prototype;
                });
              })
            ),
            /***/
            "e260": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var toIndexedObject = __webpack_require__("fc6a");
                var addToUnscopables = __webpack_require__("44d2");
                var Iterators = __webpack_require__("3f8c");
                var InternalStateModule = __webpack_require__("69f3");
                var defineIterator = __webpack_require__("7dd0");
                var ARRAY_ITERATOR = "Array Iterator";
                var setInternalState = InternalStateModule.set;
                var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);
                module2.exports = defineIterator(Array, "Array", function(iterated, kind) {
                  setInternalState(this, {
                    type: ARRAY_ITERATOR,
                    target: toIndexedObject(iterated),
                    // target
                    index: 0,
                    // next index
                    kind
                    // kind
                  });
                }, function() {
                  var state4 = getInternalState(this);
                  var target = state4.target;
                  var kind = state4.kind;
                  var index = state4.index++;
                  if (!target || index >= target.length) {
                    state4.target = void 0;
                    return { value: void 0, done: true };
                  }
                  if (kind == "keys") return { value: index, done: false };
                  if (kind == "values") return { value: target[index], done: false };
                  return { value: [index, target[index]], done: false };
                }, "values");
                Iterators.Arguments = Iterators.Array;
                addToUnscopables("keys");
                addToUnscopables("values");
                addToUnscopables("entries");
              })
            ),
            /***/
            "e439": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var $2 = __webpack_require__("23e7");
                var fails = __webpack_require__("d039");
                var toIndexedObject = __webpack_require__("fc6a");
                var nativeGetOwnPropertyDescriptor = __webpack_require__("06cf").f;
                var DESCRIPTORS = __webpack_require__("83ab");
                var FAILS_ON_PRIMITIVES = fails(function() {
                  nativeGetOwnPropertyDescriptor(1);
                });
                var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;
                $2({ target: "Object", stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
                  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
                    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
                  }
                });
              })
            ),
            /***/
            "e538": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var wellKnownSymbol = __webpack_require__("b622");
                exports2.f = wellKnownSymbol;
              })
            ),
            /***/
            "e893": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var has = __webpack_require__("5135");
                var ownKeys2 = __webpack_require__("56ef");
                var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
                var definePropertyModule = __webpack_require__("9bf2");
                module2.exports = function(target, source) {
                  var keys = ownKeys2(source);
                  var defineProperty = definePropertyModule.f;
                  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
                  for (var i2 = 0; i2 < keys.length; i2++) {
                    var key = keys[i2];
                    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
                  }
                };
              })
            ),
            /***/
            "e8b5": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var classof = __webpack_require__("c6b6");
                module2.exports = Array.isArray || function isArray3(arg) {
                  return classof(arg) == "Array";
                };
              })
            ),
            /***/
            "e95a": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var wellKnownSymbol = __webpack_require__("b622");
                var Iterators = __webpack_require__("3f8c");
                var ITERATOR = wellKnownSymbol("iterator");
                var ArrayPrototype = Array.prototype;
                module2.exports = function(it) {
                  return it !== void 0 && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
                };
              })
            ),
            /***/
            "f5df": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
                var classofRaw = __webpack_require__("c6b6");
                var wellKnownSymbol = __webpack_require__("b622");
                var TO_STRING_TAG = wellKnownSymbol("toStringTag");
                var CORRECT_ARGUMENTS = classofRaw(/* @__PURE__ */ (function() {
                  return arguments;
                })()) == "Arguments";
                var tryGet = function(it, key) {
                  try {
                    return it[key];
                  } catch (error) {
                  }
                };
                module2.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function(it) {
                  var O, tag, result;
                  return it === void 0 ? "Undefined" : it === null ? "Null" : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == "string" ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) == "Object" && typeof O.callee == "function" ? "Arguments" : result;
                };
              })
            ),
            /***/
            "f772": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var shared = __webpack_require__("5692");
                var uid3 = __webpack_require__("90e3");
                var keys = shared("keys");
                module2.exports = function(key) {
                  return keys[key] || (keys[key] = uid3(key));
                };
              })
            ),
            /***/
            "fb15": (
              /***/
              (function(module2, __webpack_exports__, __webpack_require__) {
                "use strict";
                __webpack_require__.r(__webpack_exports__);
                if (typeof window !== "undefined") {
                  var currentScript = window.document.currentScript;
                  if (true) {
                    var getCurrentScript = __webpack_require__("8875");
                    currentScript = getCurrentScript();
                    if (!("currentScript" in document)) {
                      Object.defineProperty(document, "currentScript", { get: getCurrentScript });
                    }
                  }
                  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/);
                  if (src) {
                    __webpack_require__.p = src[1];
                  }
                }
                var setPublicPath = null;
                var es_array_concat = __webpack_require__("99af");
                var es_array_filter = __webpack_require__("4de4");
                var es_array_for_each = __webpack_require__("4160");
                var es_array_index_of = __webpack_require__("c975");
                var es_array_map = __webpack_require__("d81d");
                var es_array_splice = __webpack_require__("a434");
                var web_dom_collections_for_each = __webpack_require__("159b");
                var es_symbol = __webpack_require__("a4d3");
                var es_object_get_own_property_descriptor = __webpack_require__("e439");
                var es_object_get_own_property_descriptors = __webpack_require__("dbb4");
                var es_object_keys = __webpack_require__("b64b");
                function _defineProperty2(obj, key, value) {
                  if (key in obj) {
                    Object.defineProperty(obj, key, {
                      value,
                      enumerable: true,
                      configurable: true,
                      writable: true
                    });
                  } else {
                    obj[key] = value;
                  }
                  return obj;
                }
                function ownKeys2(object, enumerableOnly) {
                  var keys = Object.keys(object);
                  if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    if (enumerableOnly) symbols = symbols.filter(function(sym) {
                      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    });
                    keys.push.apply(keys, symbols);
                  }
                  return keys;
                }
                function _objectSpread22(target) {
                  for (var i2 = 1; i2 < arguments.length; i2++) {
                    var source = arguments[i2] != null ? arguments[i2] : {};
                    if (i2 % 2) {
                      ownKeys2(Object(source), true).forEach(function(key) {
                        _defineProperty2(target, key, source[key]);
                      });
                    } else if (Object.getOwnPropertyDescriptors) {
                      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
                    } else {
                      ownKeys2(Object(source)).forEach(function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                      });
                    }
                  }
                  return target;
                }
                function _arrayWithHoles(arr) {
                  if (Array.isArray(arr)) return arr;
                }
                var es_symbol_description = __webpack_require__("e01a");
                var es_symbol_iterator = __webpack_require__("d28b");
                var es_array_iterator = __webpack_require__("e260");
                var es_object_to_string = __webpack_require__("d3b7");
                var es_string_iterator = __webpack_require__("3ca3");
                var web_dom_collections_iterator = __webpack_require__("ddb0");
                function _iterableToArrayLimit(arr, i2) {
                  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
                  var _arr = [];
                  var _n = true;
                  var _d = false;
                  var _e = void 0;
                  try {
                    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                      _arr.push(_s.value);
                      if (i2 && _arr.length === i2) break;
                    }
                  } catch (err) {
                    _d = true;
                    _e = err;
                  } finally {
                    try {
                      if (!_n && _i["return"] != null) _i["return"]();
                    } finally {
                      if (_d) throw _e;
                    }
                  }
                  return _arr;
                }
                var es_array_from = __webpack_require__("a630");
                var es_array_slice = __webpack_require__("fb6a");
                var es_function_name = __webpack_require__("b0c0");
                var es_regexp_to_string = __webpack_require__("25f0");
                function _arrayLikeToArray(arr, len) {
                  if (len == null || len > arr.length) len = arr.length;
                  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
                    arr2[i2] = arr[i2];
                  }
                  return arr2;
                }
                function _unsupportedIterableToArray(o, minLen) {
                  if (!o) return;
                  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                  var n = Object.prototype.toString.call(o).slice(8, -1);
                  if (n === "Object" && o.constructor) n = o.constructor.name;
                  if (n === "Map" || n === "Set") return Array.from(o);
                  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
                }
                function _nonIterableRest() {
                  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _slicedToArray(arr, i2) {
                  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i2) || _unsupportedIterableToArray(arr, i2) || _nonIterableRest();
                }
                function _arrayWithoutHoles(arr) {
                  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
                }
                function _iterableToArray(iter) {
                  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
                }
                function _nonIterableSpread() {
                  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _toConsumableArray(arr) {
                  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
                }
                var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_ = __webpack_require__("a352");
                var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default = /* @__PURE__ */ __webpack_require__.n(external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_);
                function removeNode(node) {
                  if (node.parentElement !== null) {
                    node.parentElement.removeChild(node);
                  }
                }
                function insertNodeAt(fatherNode, node, position) {
                  var refNode = position === 0 ? fatherNode.children[0] : fatherNode.children[position - 1].nextSibling;
                  fatherNode.insertBefore(node, refNode);
                }
                var console2 = __webpack_require__("dbf1");
                var es_array_reduce = __webpack_require__("13d5");
                var es_object_entries = __webpack_require__("4fad");
                var es_regexp_exec = __webpack_require__("ac1f");
                var es_string_replace = __webpack_require__("5319");
                function cached(fn) {
                  var cache = /* @__PURE__ */ Object.create(null);
                  return function cachedFn(str) {
                    var hit = cache[str];
                    return hit || (cache[str] = fn(str));
                  };
                }
                var regex2 = /-(\w)/g;
                var camelize2 = cached(function(str) {
                  return str.replace(regex2, function(_2, c) {
                    return c.toUpperCase();
                  });
                });
                var es_array_flat_map = __webpack_require__("5db7");
                var es_array_unscopables_flat_map = __webpack_require__("73d9");
                var manageAndEmit = ["Start", "Add", "Remove", "Update", "End"];
                var emit2 = ["Choose", "Unchoose", "Sort", "Filter", "Clone"];
                var manage = ["Move"];
                var eventHandlerNames = [manage, manageAndEmit, emit2].flatMap(function(events2) {
                  return events2;
                }).map(function(evt) {
                  return "on".concat(evt);
                });
                var events = {
                  manage,
                  manageAndEmit,
                  emit: emit2
                };
                function isReadOnly(eventName) {
                  return eventHandlerNames.indexOf(eventName) !== -1;
                }
                var es_array_includes = __webpack_require__("caad");
                var es_string_starts_with = __webpack_require__("2ca0");
                var tags = ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "label", "legend", "li", "link", "main", "map", "mark", "math", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rb", "rp", "rt", "rtc", "ruby", "s", "samp", "script", "section", "select", "slot", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "svg", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr"];
                function isHtmlTag(name) {
                  return tags.includes(name);
                }
                function isTransition(name) {
                  return ["transition-group", "TransitionGroup"].includes(name);
                }
                function isHtmlAttribute(value) {
                  return ["id", "class", "role", "style"].includes(value) || value.startsWith("data-") || value.startsWith("aria-") || value.startsWith("on");
                }
                function project(entries) {
                  return entries.reduce(function(res, _ref) {
                    var _ref2 = _slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                    res[key] = value;
                    return res;
                  }, {});
                }
                function getComponentAttributes(_ref3) {
                  var $attrs = _ref3.$attrs, _ref3$componentData = _ref3.componentData, componentData = _ref3$componentData === void 0 ? {} : _ref3$componentData;
                  var attributes = project(Object.entries($attrs).filter(function(_ref4) {
                    var _ref5 = _slicedToArray(_ref4, 2), key = _ref5[0], _2 = _ref5[1];
                    return isHtmlAttribute(key);
                  }));
                  return _objectSpread22(_objectSpread22({}, attributes), componentData);
                }
                function createSortableOption(_ref6) {
                  var $attrs = _ref6.$attrs, callBackBuilder = _ref6.callBackBuilder;
                  var options = project(getValidSortableEntries($attrs));
                  Object.entries(callBackBuilder).forEach(function(_ref7) {
                    var _ref8 = _slicedToArray(_ref7, 2), eventType = _ref8[0], eventBuilder = _ref8[1];
                    events[eventType].forEach(function(event) {
                      options["on".concat(event)] = eventBuilder(event);
                    });
                  });
                  var draggable2 = "[data-draggable]".concat(options.draggable || "");
                  return _objectSpread22(_objectSpread22({}, options), {}, {
                    draggable: draggable2
                  });
                }
                function getValidSortableEntries(value) {
                  return Object.entries(value).filter(function(_ref9) {
                    var _ref10 = _slicedToArray(_ref9, 2), key = _ref10[0], _2 = _ref10[1];
                    return !isHtmlAttribute(key);
                  }).map(function(_ref11) {
                    var _ref12 = _slicedToArray(_ref11, 2), key = _ref12[0], value2 = _ref12[1];
                    return [camelize2(key), value2];
                  }).filter(function(_ref13) {
                    var _ref14 = _slicedToArray(_ref13, 2), key = _ref14[0], _2 = _ref14[1];
                    return !isReadOnly(key);
                  });
                }
                var es_array_find_index = __webpack_require__("c740");
                function _classCallCheck(instance, Constructor) {
                  if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                  }
                }
                function _defineProperties(target, props2) {
                  for (var i2 = 0; i2 < props2.length; i2++) {
                    var descriptor = props2[i2];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                  }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                  if (staticProps) _defineProperties(Constructor, staticProps);
                  return Constructor;
                }
                var getHtmlElementFromNode = function getHtmlElementFromNode2(_ref) {
                  var el = _ref.el;
                  return el;
                };
                var addContext = function addContext2(domElement, context) {
                  return domElement.__draggable_context = context;
                };
                var getContext2 = function getContext3(domElement) {
                  return domElement.__draggable_context;
                };
                var componentStructure_ComponentStructure = /* @__PURE__ */ (function() {
                  function ComponentStructure(_ref2) {
                    var _ref2$nodes = _ref2.nodes, header = _ref2$nodes.header, defaultNodes = _ref2$nodes.default, footer2 = _ref2$nodes.footer, root = _ref2.root, realList = _ref2.realList;
                    _classCallCheck(this, ComponentStructure);
                    this.defaultNodes = defaultNodes;
                    this.children = [].concat(_toConsumableArray(header), _toConsumableArray(defaultNodes), _toConsumableArray(footer2));
                    this.externalComponent = root.externalComponent;
                    this.rootTransition = root.transition;
                    this.tag = root.tag;
                    this.realList = realList;
                  }
                  _createClass(ComponentStructure, [{
                    key: "render",
                    value: function render67(h2, attributes) {
                      var tag = this.tag, children = this.children, _isRootComponent = this._isRootComponent;
                      var option = !_isRootComponent ? children : {
                        default: function _default() {
                          return children;
                        }
                      };
                      return h2(tag, attributes, option);
                    }
                  }, {
                    key: "updated",
                    value: function updated() {
                      var defaultNodes = this.defaultNodes, realList = this.realList;
                      defaultNodes.forEach(function(node, index) {
                        addContext(getHtmlElementFromNode(node), {
                          element: realList[index],
                          index
                        });
                      });
                    }
                  }, {
                    key: "getUnderlyingVm",
                    value: function getUnderlyingVm(domElement) {
                      return getContext2(domElement);
                    }
                  }, {
                    key: "getVmIndexFromDomIndex",
                    value: function getVmIndexFromDomIndex(domIndex, element) {
                      var defaultNodes = this.defaultNodes;
                      var length = defaultNodes.length;
                      var domChildren = element.children;
                      var domElement = domChildren.item(domIndex);
                      if (domElement === null) {
                        return length;
                      }
                      var context = getContext2(domElement);
                      if (context) {
                        return context.index;
                      }
                      if (length === 0) {
                        return 0;
                      }
                      var firstDomListElement = getHtmlElementFromNode(defaultNodes[0]);
                      var indexFirstDomListElement = _toConsumableArray(domChildren).findIndex(function(element2) {
                        return element2 === firstDomListElement;
                      });
                      return domIndex < indexFirstDomListElement ? 0 : length;
                    }
                  }, {
                    key: "_isRootComponent",
                    get: function get3() {
                      return this.externalComponent || this.rootTransition;
                    }
                  }]);
                  return ComponentStructure;
                })();
                var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
                function getSlot(slots, key) {
                  var slotValue = slots[key];
                  return slotValue ? slotValue() : [];
                }
                function computeNodes(_ref) {
                  var $slots = _ref.$slots, realList = _ref.realList, getKey = _ref.getKey;
                  var normalizedList = realList || [];
                  var _map = ["header", "footer"].map(function(name) {
                    return getSlot($slots, name);
                  }), _map2 = _slicedToArray(_map, 2), header = _map2[0], footer2 = _map2[1];
                  var item = $slots.item;
                  if (!item) {
                    throw new Error("draggable element must have an item slot");
                  }
                  var defaultNodes = normalizedList.flatMap(function(element, index) {
                    return item({
                      element,
                      index
                    }).map(function(node) {
                      node.key = getKey(element);
                      node.props = _objectSpread22(_objectSpread22({}, node.props || {}), {}, {
                        "data-draggable": true
                      });
                      return node;
                    });
                  });
                  if (defaultNodes.length !== normalizedList.length) {
                    throw new Error("Item slot must have only one child");
                  }
                  return {
                    header,
                    footer: footer2,
                    default: defaultNodes
                  };
                }
                function getRootInformation(tag) {
                  var transition = isTransition(tag);
                  var externalComponent = !isHtmlTag(tag) && !transition;
                  return {
                    transition,
                    externalComponent,
                    tag: externalComponent ? Object(external_commonjs_vue_commonjs2_vue_root_Vue_["resolveComponent"])(tag) : transition ? external_commonjs_vue_commonjs2_vue_root_Vue_["TransitionGroup"] : tag
                  };
                }
                function computeComponentStructure(_ref2) {
                  var $slots = _ref2.$slots, tag = _ref2.tag, realList = _ref2.realList, getKey = _ref2.getKey;
                  var nodes = computeNodes({
                    $slots,
                    realList,
                    getKey
                  });
                  var root = getRootInformation(tag);
                  return new componentStructure_ComponentStructure({
                    nodes,
                    root,
                    realList
                  });
                }
                function _emit(evtName, evtData) {
                  var _this = this;
                  Object(external_commonjs_vue_commonjs2_vue_root_Vue_["nextTick"])(function() {
                    return _this.$emit(evtName.toLowerCase(), evtData);
                  });
                }
                function _manage(evtName) {
                  var _this2 = this;
                  return function(evtData, originalElement) {
                    if (_this2.realList !== null) {
                      return _this2["onDrag".concat(evtName)](evtData, originalElement);
                    }
                  };
                }
                function _manageAndEmit(evtName) {
                  var _this3 = this;
                  var delegateCallBack = _manage.call(this, evtName);
                  return function(evtData, originalElement) {
                    delegateCallBack.call(_this3, evtData, originalElement);
                    _emit.call(_this3, evtName, evtData);
                  };
                }
                var draggingElement = null;
                var props = {
                  list: {
                    type: Array,
                    required: false,
                    default: null
                  },
                  modelValue: {
                    type: Array,
                    required: false,
                    default: null
                  },
                  itemKey: {
                    type: [String, Function],
                    required: true
                  },
                  clone: {
                    type: Function,
                    default: function _default(original) {
                      return original;
                    }
                  },
                  tag: {
                    type: String,
                    default: "div"
                  },
                  move: {
                    type: Function,
                    default: null
                  },
                  componentData: {
                    type: Object,
                    required: false,
                    default: null
                  }
                };
                var emits = ["update:modelValue", "change"].concat(_toConsumableArray([].concat(_toConsumableArray(events.manageAndEmit), _toConsumableArray(events.emit)).map(function(evt) {
                  return evt.toLowerCase();
                })));
                var draggableComponent = Object(external_commonjs_vue_commonjs2_vue_root_Vue_["defineComponent"])({
                  name: "draggable",
                  inheritAttrs: false,
                  props,
                  emits,
                  data: function data() {
                    return {
                      error: false
                    };
                  },
                  render: function render67() {
                    try {
                      this.error = false;
                      var $slots = this.$slots, $attrs = this.$attrs, tag = this.tag, componentData = this.componentData, realList = this.realList, getKey = this.getKey;
                      var componentStructure = computeComponentStructure({
                        $slots,
                        tag,
                        realList,
                        getKey
                      });
                      this.componentStructure = componentStructure;
                      var attributes = getComponentAttributes({
                        $attrs,
                        componentData
                      });
                      return componentStructure.render(external_commonjs_vue_commonjs2_vue_root_Vue_["h"], attributes);
                    } catch (err) {
                      this.error = true;
                      return Object(external_commonjs_vue_commonjs2_vue_root_Vue_["h"])("pre", {
                        style: {
                          color: "red"
                        }
                      }, err.stack);
                    }
                  },
                  created: function created() {
                    if (this.list !== null && this.modelValue !== null) {
                      console2[
                        "a"
                        /* console */
                      ].error("modelValue and list props are mutually exclusive! Please set one or another.");
                    }
                  },
                  mounted: function mounted() {
                    var _this4 = this;
                    if (this.error) {
                      return;
                    }
                    var $attrs = this.$attrs, $el = this.$el, componentStructure = this.componentStructure;
                    componentStructure.updated();
                    var sortableOptions = createSortableOption({
                      $attrs,
                      callBackBuilder: {
                        manageAndEmit: function manageAndEmit2(event) {
                          return _manageAndEmit.call(_this4, event);
                        },
                        emit: function emit3(event) {
                          return _emit.bind(_this4, event);
                        },
                        manage: function manage2(event) {
                          return _manage.call(_this4, event);
                        }
                      }
                    });
                    var targetDomElement = $el.nodeType === 1 ? $el : $el.parentElement;
                    this._sortable = new external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default.a(targetDomElement, sortableOptions);
                    this.targetDomElement = targetDomElement;
                    targetDomElement.__draggable_component__ = this;
                  },
                  updated: function updated() {
                    this.componentStructure.updated();
                  },
                  beforeUnmount: function beforeUnmount() {
                    if (this._sortable !== void 0) this._sortable.destroy();
                  },
                  computed: {
                    realList: function realList() {
                      var list = this.list;
                      return list ? list : this.modelValue;
                    },
                    getKey: function getKey() {
                      var itemKey = this.itemKey;
                      if (typeof itemKey === "function") {
                        return itemKey;
                      }
                      return function(element) {
                        return element[itemKey];
                      };
                    }
                  },
                  watch: {
                    $attrs: {
                      handler: function handler(newOptionValue) {
                        var _sortable = this._sortable;
                        if (!_sortable) return;
                        getValidSortableEntries(newOptionValue).forEach(function(_ref) {
                          var _ref2 = _slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                          _sortable.option(key, value);
                        });
                      },
                      deep: true
                    }
                  },
                  methods: {
                    getUnderlyingVm: function getUnderlyingVm(domElement) {
                      return this.componentStructure.getUnderlyingVm(domElement) || null;
                    },
                    getUnderlyingPotencialDraggableComponent: function getUnderlyingPotencialDraggableComponent(htmElement) {
                      return htmElement.__draggable_component__;
                    },
                    emitChanges: function emitChanges(evt) {
                      var _this5 = this;
                      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["nextTick"])(function() {
                        return _this5.$emit("change", evt);
                      });
                    },
                    alterList: function alterList(onList) {
                      if (this.list) {
                        onList(this.list);
                        return;
                      }
                      var newList = _toConsumableArray(this.modelValue);
                      onList(newList);
                      this.$emit("update:modelValue", newList);
                    },
                    spliceList: function spliceList() {
                      var _arguments = arguments;
                      var spliceList2 = function spliceList3(list) {
                        return list.splice.apply(list, _toConsumableArray(_arguments));
                      };
                      this.alterList(spliceList2);
                    },
                    updatePosition: function updatePosition(oldIndex, newIndex) {
                      var updatePosition2 = function updatePosition3(list) {
                        return list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
                      };
                      this.alterList(updatePosition2);
                    },
                    getRelatedContextFromMoveEvent: function getRelatedContextFromMoveEvent(_ref3) {
                      var to = _ref3.to, related = _ref3.related;
                      var component = this.getUnderlyingPotencialDraggableComponent(to);
                      if (!component) {
                        return {
                          component
                        };
                      }
                      var list = component.realList;
                      var context = {
                        list,
                        component
                      };
                      if (to !== related && list) {
                        var destination = component.getUnderlyingVm(related) || {};
                        return _objectSpread22(_objectSpread22({}, destination), context);
                      }
                      return context;
                    },
                    getVmIndexFromDomIndex: function getVmIndexFromDomIndex(domIndex) {
                      return this.componentStructure.getVmIndexFromDomIndex(domIndex, this.targetDomElement);
                    },
                    onDragStart: function onDragStart(evt) {
                      this.context = this.getUnderlyingVm(evt.item);
                      evt.item._underlying_vm_ = this.clone(this.context.element);
                      draggingElement = evt.item;
                    },
                    onDragAdd: function onDragAdd(evt) {
                      var element = evt.item._underlying_vm_;
                      if (element === void 0) {
                        return;
                      }
                      removeNode(evt.item);
                      var newIndex = this.getVmIndexFromDomIndex(evt.newIndex);
                      this.spliceList(newIndex, 0, element);
                      var added = {
                        element,
                        newIndex
                      };
                      this.emitChanges({
                        added
                      });
                    },
                    onDragRemove: function onDragRemove(evt) {
                      insertNodeAt(this.$el, evt.item, evt.oldIndex);
                      if (evt.pullMode === "clone") {
                        removeNode(evt.clone);
                        return;
                      }
                      var _this$context = this.context, oldIndex = _this$context.index, element = _this$context.element;
                      this.spliceList(oldIndex, 1);
                      var removed = {
                        element,
                        oldIndex
                      };
                      this.emitChanges({
                        removed
                      });
                    },
                    onDragUpdate: function onDragUpdate(evt) {
                      removeNode(evt.item);
                      insertNodeAt(evt.from, evt.item, evt.oldIndex);
                      var oldIndex = this.context.index;
                      var newIndex = this.getVmIndexFromDomIndex(evt.newIndex);
                      this.updatePosition(oldIndex, newIndex);
                      var moved = {
                        element: this.context.element,
                        oldIndex,
                        newIndex
                      };
                      this.emitChanges({
                        moved
                      });
                    },
                    computeFutureIndex: function computeFutureIndex(relatedContext, evt) {
                      if (!relatedContext.element) {
                        return 0;
                      }
                      var domChildren = _toConsumableArray(evt.to.children).filter(function(el) {
                        return el.style["display"] !== "none";
                      });
                      var currentDomIndex = domChildren.indexOf(evt.related);
                      var currentIndex = relatedContext.component.getVmIndexFromDomIndex(currentDomIndex);
                      var draggedInList = domChildren.indexOf(draggingElement) !== -1;
                      return draggedInList || !evt.willInsertAfter ? currentIndex : currentIndex + 1;
                    },
                    onDragMove: function onDragMove(evt, originalEvent) {
                      var move = this.move, realList = this.realList;
                      if (!move || !realList) {
                        return true;
                      }
                      var relatedContext = this.getRelatedContextFromMoveEvent(evt);
                      var futureIndex = this.computeFutureIndex(relatedContext, evt);
                      var draggedContext = _objectSpread22(_objectSpread22({}, this.context), {}, {
                        futureIndex
                      });
                      var sendEvent = _objectSpread22(_objectSpread22({}, evt), {}, {
                        relatedContext,
                        draggedContext
                      });
                      return move(sendEvent, originalEvent);
                    },
                    onDragEnd: function onDragEnd() {
                      draggingElement = null;
                    }
                  }
                });
                var vuedraggable = draggableComponent;
                var entry_lib = __webpack_exports__["default"] = vuedraggable;
              })
            ),
            /***/
            "fb6a": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                "use strict";
                var $2 = __webpack_require__("23e7");
                var isObject4 = __webpack_require__("861d");
                var isArray3 = __webpack_require__("e8b5");
                var toAbsoluteIndex = __webpack_require__("23cb");
                var toLength = __webpack_require__("50c4");
                var toIndexedObject = __webpack_require__("fc6a");
                var createProperty = __webpack_require__("8418");
                var wellKnownSymbol = __webpack_require__("b622");
                var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
                var arrayMethodUsesToLength = __webpack_require__("ae40");
                var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("slice");
                var USES_TO_LENGTH = arrayMethodUsesToLength("slice", { ACCESSORS: true, 0: 0, 1: 2 });
                var SPECIES = wellKnownSymbol("species");
                var nativeSlice = [].slice;
                var max = Math.max;
                $2({ target: "Array", proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
                  slice: function slice(start, end) {
                    var O = toIndexedObject(this);
                    var length = toLength(O.length);
                    var k = toAbsoluteIndex(start, length);
                    var fin = toAbsoluteIndex(end === void 0 ? length : end, length);
                    var Constructor, result, n;
                    if (isArray3(O)) {
                      Constructor = O.constructor;
                      if (typeof Constructor == "function" && (Constructor === Array || isArray3(Constructor.prototype))) {
                        Constructor = void 0;
                      } else if (isObject4(Constructor)) {
                        Constructor = Constructor[SPECIES];
                        if (Constructor === null) Constructor = void 0;
                      }
                      if (Constructor === Array || Constructor === void 0) {
                        return nativeSlice.call(O, k, fin);
                      }
                    }
                    result = new (Constructor === void 0 ? Array : Constructor)(max(fin - k, 0));
                    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
                    result.length = n;
                    return result;
                  }
                });
              })
            ),
            /***/
            "fc6a": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var IndexedObject = __webpack_require__("44ad");
                var requireObjectCoercible = __webpack_require__("1d80");
                module2.exports = function(it) {
                  return IndexedObject(requireObjectCoercible(it));
                };
              })
            ),
            /***/
            "fdbc": (
              /***/
              (function(module2, exports2) {
                module2.exports = {
                  CSSRuleList: 0,
                  CSSStyleDeclaration: 0,
                  CSSValueList: 0,
                  ClientRectList: 0,
                  DOMRectList: 0,
                  DOMStringList: 0,
                  DOMTokenList: 1,
                  DataTransferItemList: 0,
                  FileList: 0,
                  HTMLAllCollection: 0,
                  HTMLCollection: 0,
                  HTMLFormElement: 0,
                  HTMLSelectElement: 0,
                  MediaList: 0,
                  MimeTypeArray: 0,
                  NamedNodeMap: 0,
                  NodeList: 1,
                  PaintRequestList: 0,
                  Plugin: 0,
                  PluginArray: 0,
                  SVGLengthList: 0,
                  SVGNumberList: 0,
                  SVGPathSegList: 0,
                  SVGPointList: 0,
                  SVGStringList: 0,
                  SVGTransformList: 0,
                  SourceBufferList: 0,
                  StyleSheetList: 0,
                  TextTrackCueList: 0,
                  TextTrackList: 0,
                  TouchList: 0
                };
              })
            ),
            /***/
            "fdbf": (
              /***/
              (function(module2, exports2, __webpack_require__) {
                var NATIVE_SYMBOL = __webpack_require__("4930");
                module2.exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == "symbol";
              })
            )
            /******/
          })["default"]
        );
      });
    }
  });

  // vue-style:C:\fork\Baudville\src\vue\components\shared\art-works.vue
  var init_art_works = __esm({
    "vue-style:C:\\fork\\Baudville\\src\\vue\\components\\shared\\art-works.vue"() {
    }
  });

  // src/vue/components/shared/art-works.vue
  var art_works_exports = {};
  __export(art_works_exports, {
    default: () => art_works_default,
    render: () => render44
  });
  function render44(_ctx, _cache) {
    const _component_draggable = resolveComponent("draggable");
    return _ctx.artWorks.length ? (openBlock(), createElementBlock("div", _hoisted_170, [
      createVNode(_component_draggable, {
        modelValue: _ctx.artWorks,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.artWorks = $event),
        "item-key": (item) => item.name,
        onEnd: _cache[1] || (_cache[1] = ($event) => _ctx.draggedIndex = null)
      }, {
        item: withCtx(({ element, index }) => [
          createBaseVNode("div", _hoisted_250, [
            _cache[4] || (_cache[4] = createBaseVNode(
              "span",
              {
                title: "Drag To Rearrange",
                class: "configurator-customizations__layer-drag"
              },
              [
                createBaseVNode("svg", {
                  title: "Drag To Rearrange",
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 32 32",
                  class: "svg-icon svg-icon--font-color"
                }, [
                  createBaseVNode("path", { d: "m1.97 1h5.22v5.22h-5.22z" }),
                  createBaseVNode("path", { d: "m1.97 9.26h5.22v5.22h-5.22z" }),
                  createBaseVNode("path", { d: "m1.97 17.52h5.22v5.22h-5.22z" }),
                  createBaseVNode("path", { d: "m1.97 25.78h5.22v5.22h-5.22z" }),
                  createBaseVNode("path", { d: "m9.32 1h5.22v5.22h-5.22z" }),
                  createBaseVNode("path", { d: "m9.32 9.26h5.22v5.22h-5.22z" }),
                  createBaseVNode("path", { d: "m9.32 17.52h5.22v5.22h-5.22z" }),
                  createBaseVNode("path", { d: "m9.32 25.78h5.22v5.22h-5.22z" })
                ])
              ],
              -1
              /* CACHED */
            )),
            createBaseVNode(
              "span",
              _hoisted_338,
              toDisplayString(element?.image_path ? _ctx.name(element.image_path) : element.text),
              1
              /* TEXT */
            ),
            createBaseVNode("span", {
              title: "Edit Layer",
              class: "configurator-customizations__layer-edit",
              onClick: ($event) => _ctx.edit(index)
            }, [..._cache[2] || (_cache[2] = [
              createBaseVNode(
                "svg",
                {
                  title: "Edit Layer",
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 24 24",
                  class: "svg-icon svg-icon--font-color"
                },
                [
                  createBaseVNode("path", { d: "M7.8,21L20,8.8A3.44,3.44,0,0,0,20,4a3.49,3.49,0,0,0-2.4-1h0a3.69,3.69,0,0,0-2.4,1L3,16.2V21H7.8Z" })
                ],
                -1
                /* CACHED */
              )
            ])], 8, _hoisted_431),
            createBaseVNode("span", {
              title: "Remove Layer",
              class: "configurator-customizations__layer-edit",
              onClick: ($event) => _ctx.remove(index)
            }, [..._cache[3] || (_cache[3] = [
              createBaseVNode(
                "svg",
                {
                  title: "Remove Layer",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "svg-icon svg-icon--font-color"
                },
                [
                  createBaseVNode("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" })
                ],
                -1
                /* CACHED */
              )
            ])], 8, _hoisted_523)
          ])
        ]),
        _: 1
        /* STABLE */
      }, 8, ["modelValue", "item-key"])
    ])) : createCommentVNode("v-if", true);
  }
  var import_vuedraggable, __default__37, _hoisted_170, _hoisted_250, _hoisted_338, _hoisted_431, _hoisted_523, art_works_default;
  var init_art_works2 = __esm({
    "src/vue/components/shared/art-works.vue"() {
      "use strict";
      init_vue_esm_bundler();
      init_vuex_esm_bundler();
      import_vuedraggable = __toESM(require_vuedraggable_umd());
      init_vue_esm_bundler();
      init_art_works();
      __default__37 = {
        // mounted() {
        //   const store = useStore();
        //   const { getCanvasWidth, getCanvasHeight } = canvasHelper();
        //   const images = [
        //     {
        //       image_path:
        //         "Baudville/ugc/1676121077_mQnuNoESKJq8q7E4Uin8BGGIleKjDzlQLtxcw13m.tif",
        //       image_url:
        //         "http://s7w2p1.scene7.com/is/image/Baudville/ugc/1676121077_mQnuNoESKJq8q7E4Uin8BGGIleKjDzlQLtxcw13m.tif",
        //     },
        //     // {
        //     //   image_path:
        //     //     "Baudville/ugc/1676121077_UT91LUR6SfQva6r8dqbD1tQ9uQBtkcW66G3Jy83w.tif",
        //     //   image_url:
        //     //     "http://s7w2p1.scene7.com/is/image/Baudville/ugc/1676121077_UT91LUR6SfQva6r8dqbD1tQ9uQBtkcW66G3Jy83w.tif",
        //     // },
        //     // {
        //     //   image_path:
        //     //     "Baudville/ugc/1676121078_Qf1uvooMqBosWz0u906X9AfiMKBqCkTxsfCNkirP.tif",
        //     //   image_url:
        //     //     "http://s7w2p1.scene7.com/is/image/Baudville/ugc/1676121078_Qf1uvooMqBosWz0u906X9AfiMKBqCkTxsfCNkirP.tif",
        //     // },
        //   ];
        //   images.forEach((img, index) => {
        //     const image = new window.Image();
        //     image.src = img.image_url;
        //     image.crossOrigin = "anonymous";
        //     image.onload = () => {
        //       const aspectRatio = image.height / image.width;
        //       let maxHeight = getCanvasWidth() * aspectRatio;
        //       let maxWidth = getCanvasWidth();
        //       if (maxHeight > getCanvasHeight()) {
        //         maxHeight = getCanvasHeight();
        //         maxWidth = maxHeight / aspectRatio;
        //       }
        //       console.log(
        //         image.width,
        //         image.height,
        //         aspectRatio,
        //         maxWidth,
        //         maxHeight
        //       );
        //       store.dispatch("saveArtworks", {
        //         name: `rect${index}`,
        //         type: "image",
        //         image_path: img.image_path,
        //         image_url: img.image_url,
        //         x: getCanvasWidth() / 2 - maxWidth / 2,
        //         y: getCanvasHeight() / 2 - maxHeight / 2,
        //         width: maxWidth,
        //         height: maxHeight,
        //         draggable: true,
        //         image: image,
        //         offsetX: 0,
        //         offsetY: 0,
        //         scaleX: 1,
        //         scaleY: 1,
        //         isSelected: false,
        //         rotation: 0,
        //         rotationSnaps: [],
        //       });
        //     };
        //   });
        //   // images.map((i) => store.dispatch("saveArtworks", i));
        //   store.dispatch("saveArtworks", {
        //     type: "text",
        //     name: "text1",
        //     text: "Hello world",
        //     // image_path:
        //     //   "Baudville/ugc/1676121077_mQnuNoESKJq8q7E4Uin8BGGIleKjDzlQLtxcw13m.tif",
        //     fontSize: 14,
        //     fontFamily: "Arial",
        //     fill: "#8B572A",
        //     x: 0,
        //     y: 0,
        //     draggable: true,
        //     isSelected: false,
        //     align: "center",
        //     verticalAlign: "middle",
        //   });
        //   store.dispatch("saveArtworks", {
        //     type: "text",
        //     name: "text3",
        //     text: "Hello Raihan",
        //     fontSize: 14,
        //     fontFamily: "Arial",
        //     fill: "#8B572A",
        //     x: 0,
        //     y: 0,
        //     draggable: true,
        //     isSelected: false,
        //     align: "center",
        //     verticalAlign: "middle",
        //   });
        // },
        components: { draggable: import_vuedraggable.default },
        setup() {
          const store2 = useStore();
          const artWorks = computed2({
            get() {
              return store2.getters.getArtworks;
            },
            set(newValue) {
              store2.dispatch("sortArtworks", newValue);
            }
          });
          const name = (path) => {
            return path?.substring(14)?.split(".")[0];
          };
          const remove2 = (key) => {
            if (confirm("Are You Sure?")) {
              store2.dispatch("deleteArtworks", key);
            }
          };
          const edit = (key) => {
            console.log(key);
            store2.dispatch("saveSelectedCanvas", key);
          };
          return {
            artWorks,
            name,
            remove: remove2,
            edit
          };
        }
      };
      _hoisted_170 = {
        key: 0,
        class: "configurator-customizations__layers"
      };
      _hoisted_250 = {
        class: "configurator-customizations__layer sortable-chosen",
        draggable: "true"
      };
      _hoisted_338 = {
        title: "Drag To Rearrange",
        class: "configurator-customizations__layer-name"
      };
      _hoisted_431 = ["onClick"];
      _hoisted_523 = ["onClick"];
      __default__37.render = render44;
      __default__37.__scopeId = "data-v-c564314e";
      art_works_default = __default__37;
    }
  });

  // vue-style:C:\fork\Baudville\src\vue\components\shared\step-canvas.vue
  var init_step_canvas = __esm({
    "vue-style:C:\\fork\\Baudville\\src\\vue\\components\\shared\\step-canvas.vue"() {
    }
  });

  // src/vue/components/shared/step-canvas.vue
  var step_canvas_exports = {};
  __export(step_canvas_exports, {
    default: () => step_canvas_default,
    render: () => render45
  });
  function render45(_ctx, _cache) {
    const _component_ArtWroks = resolveComponent("ArtWroks");
    const _component_CanvasText = resolveComponent("CanvasText");
    const _component_DropZone = resolveComponent("DropZone");
    const _component_SelectedArtwork = resolveComponent("SelectedArtwork");
    return openBlock(), createElementBlock(
      Fragment,
      null,
      [
        _cache[6] || (_cache[6] = createBaseVNode(
          "div",
          { class: "lg:hidden" },
          [
            createBaseVNode("p", { class: "font-bold leading-4 font-lg" }, " Unfortunately, this feature is not supported on your mobile device. Please visit our desktop site to customize this product. ")
          ],
          -1
          /* CACHED */
        )),
        createBaseVNode("div", _hoisted_171, [
          _ctx.selectedCanvas < 0 ? (openBlock(), createElementBlock("div", _hoisted_251, [
            !_ctx.show ? (openBlock(), createBlock(_component_ArtWroks, { key: 0 })) : createCommentVNode("v-if", true),
            createBaseVNode("div", null, [
              createBaseVNode("div", _hoisted_339, [
                !_ctx.show && !_ctx.showText ? (openBlock(), createElementBlock("p", _hoisted_433, [
                  createBaseVNode(
                    "button",
                    {
                      class: "button button-product !rounded uppercase font-bold font-mont text-xl",
                      onClick: _cache[0] || (_cache[0] = ($event) => _ctx.show = true)
                    },
                    toDisplayString(_ctx.full_customization?.label),
                    1
                    /* TEXT */
                  )
                ])) : createCommentVNode("v-if", true),
                !_ctx.showText && !_ctx.show && _ctx.full_customization?.label == "Add Logo" ? (openBlock(), createElementBlock("div", _hoisted_524, [
                  createBaseVNode("button", {
                    class: "ml-4 button button-product !rounded uppercase font-bold font-mont text-xl",
                    onClick: _cache[1] || (_cache[1] = ($event) => _ctx.showText = true)
                  }, " Add Text ")
                ])) : createCommentVNode("v-if", true)
              ]),
              createBaseVNode(
                "h2",
                _hoisted_618,
                toDisplayString(_ctx.full_customization?.instructions),
                1
                /* TEXT */
              )
            ]),
            _ctx.showText ? (openBlock(), createElementBlock("div", _hoisted_717, [
              createVNode(_component_CanvasText, { onCancel: _ctx.cancel }, null, 8, ["onCancel"])
            ])) : createCommentVNode("v-if", true),
            _ctx.show ? (openBlock(), createElementBlock("div", _hoisted_813, [
              _cache[5] || (_cache[5] = createBaseVNode(
                "p",
                { class: "mb-4" },
                [
                  createTextVNode(" Upload your custom graphic or logo below. Please make sure it follows the required "),
                  createBaseVNode("a", {
                    href: "https://cdn.shopify.com/s/files/1/0667/4766/2632/files/configurator_art_specs-25711b5d2e444ae66971a046ff2dbe9ec0f49a29beb75f6cbecb9d0ae2e95e33.pdf?v=1677646756",
                    target: "_blank"
                  }, " art specifications"),
                  createTextVNode(`. Once uploaded, click the "add" button. Your custom graphic or logo should appear on the product preview. Click on it to resize or move. Don't forget to click the "done" button when you are finished. `)
                ],
                -1
                /* CACHED */
              )),
              createBaseVNode("div", _hoisted_911, [
                createBaseVNode("div", _hoisted_1011, [
                  createVNode(_component_DropZone, {
                    url: "https://jot.baudville.com/api/upload-logo",
                    onSending: _ctx.sending
                  }, null, 8, ["onSending"])
                ])
              ]),
              createBaseVNode("div", null, [
                createBaseVNode("button", {
                  class: "mr-1 text-button",
                  onClick: _cache[2] || (_cache[2] = (...args) => _ctx.cancel && _ctx.cancel(...args))
                }, "Cancel"),
                _cache[4] || (_cache[4] = createBaseVNode(
                  "span",
                  null,
                  "\xA0",
                  -1
                  /* CACHED */
                )),
                createBaseVNode("button", {
                  disabled: !Object.keys(_ctx.image)?.length,
                  class: "button",
                  onClick: _cache[3] || (_cache[3] = (...args) => _ctx.add && _ctx.add(...args))
                }, " Add ", 8, _hoisted_1119)
              ])
            ])) : createCommentVNode("v-if", true)
          ])) : createCommentVNode("v-if", true),
          _ctx.selectedCanvas > -1 ? (openBlock(), createBlock(_component_SelectedArtwork, { key: 1 })) : createCommentVNode("v-if", true)
        ])
      ],
      64
      /* STABLE_FRAGMENT */
    );
  }
  var import_dropzone_vue, __default__38, _hoisted_171, _hoisted_251, _hoisted_339, _hoisted_433, _hoisted_524, _hoisted_618, _hoisted_717, _hoisted_813, _hoisted_911, _hoisted_1011, _hoisted_1119, step_canvas_default;
  var init_step_canvas2 = __esm({
    "src/vue/components/shared/step-canvas.vue"() {
      "use strict";
      init_selected_artwork2();
      import_dropzone_vue = __toESM(require_dropzone_vue_common());
      init_dropzone_vue_common();
      init_vue_esm_bundler();
      init_vuex_esm_bundler();
      init_art_works2();
      init_canvas_text2();
      init_canvas();
      init_vue_esm_bundler();
      init_step_canvas();
      __default__38 = {
        components: {
          DropZone: import_dropzone_vue.default,
          ArtWroks: art_works_default,
          SelectedArtwork: selected_artwork_default,
          CanvasText: canvas_text_default
        },
        props: {
          full_customization: {
            type: [Object, String, Boolean],
            default: null
          },
          name: {
            type: String,
            default: ""
          }
        },
        emits: ["cancel"],
        setup() {
          const store2 = useStore();
          const show = ref(false);
          const showText = ref(false);
          const selectedCanvas = computed2(() => store2.getters.getSelectedCanvas);
          const uploadLogo = computed2({
            get() {
              return store2.getters.uploadLogo;
            },
            set(newValue) {
              store2.dispatch("saveUploadLogo", newValue);
            }
          });
          const image = ref({});
          const sending = (__, xhr) => {
            function callback(e) {
              image.value = JSON.parse(e);
            }
            xhr.onreadystatechange = () => {
              if (xhr.readyState === 4) {
                callback(xhr.response);
              }
            };
          };
          const { getCanvasWidth, getCanvasHeight } = canvasHelper();
          const add = () => {
            if (image.value?.image_url) {
              const img = new window.Image();
              img.src = image.value.image_url;
              img.crossOrigin = "anonymous";
              img.onload = () => {
                const aspectRatio = img.height / img.width;
                let maxHeight = getCanvasWidth() * aspectRatio;
                let maxWidth = getCanvasWidth();
                if (maxHeight > getCanvasHeight()) {
                  maxHeight = getCanvasHeight();
                  maxWidth = maxHeight / aspectRatio;
                }
                store2.dispatch("saveArtworks", {
                  name: Math.random().toString(36).slice(2, 16),
                  type: "image",
                  image_path: image.value.image_path,
                  image_url: image.value.image_url,
                  x: getCanvasWidth() / 2 - maxWidth / 2,
                  y: getCanvasHeight() / 2 - maxHeight / 2,
                  width: maxWidth,
                  height: maxHeight,
                  draggable: true,
                  isSelected: false,
                  image: img,
                  rotation: 0,
                  offsetX: 0,
                  offsetY: 0,
                  scaleX: 1,
                  scaleY: 1
                });
              };
            }
            show.value = false;
          };
          const cancel = () => {
            image.value = {};
            show.value = false;
            showText.value = false;
          };
          return {
            show,
            showText,
            uploadLogo,
            image,
            selectedCanvas,
            cancel,
            add,
            sending
          };
        }
      };
      _hoisted_171 = { class: "hidden lg:block" };
      _hoisted_251 = { key: 0 };
      _hoisted_339 = { class: "flex flex-wrap" };
      _hoisted_433 = {
        key: 0,
        class: "mb-4"
      };
      _hoisted_524 = { key: 1 };
      _hoisted_618 = { class: "text-xl" };
      _hoisted_717 = {
        key: 1,
        class: "mb-4 property"
      };
      _hoisted_813 = { key: 2 };
      _hoisted_911 = { class: "mb-4" };
      _hoisted_1011 = { class: "bg-white drop-area" };
      _hoisted_1119 = ["disabled"];
      __default__38.render = render45;
      __default__38.__scopeId = "data-v-4dfa518f";
      step_canvas_default = __default__38;
    }
  });

  // vue-style:C:\fork\Baudville\src\vue\components\shared\logo-artwork.vue
  var init_logo_artwork = __esm({
    "vue-style:C:\\fork\\Baudville\\src\\vue\\components\\shared\\logo-artwork.vue"() {
    }
  });

  // src/vue/components/shared/logo-artwork.vue
  var logo_artwork_exports = {};
  __export(logo_artwork_exports, {
    default: () => logo_artwork_default,
    render: () => render46
  });
  function render46(_ctx, _cache) {
    const _component_StepCanvas = resolveComponent("StepCanvas");
    const _component_DropZone = resolveComponent("DropZone");
    const _component_PersonalizationLogoInput = resolveComponent("PersonalizationLogoInput");
    const _component_DivContainer = resolveComponent("DivContainer");
    return openBlock(), createBlock(_component_DivContainer, null, {
      default: withCtx(() => [
        _ctx.canvases.length ? (openBlock(), createBlock(_component_StepCanvas, {
          key: 0,
          full_customization: _ctx.full_customization,
          name: _ctx.name
        }, null, 8, ["full_customization", "name"])) : _ctx.renderTemplate ? (openBlock(), createElementBlock("div", _hoisted_177, [
          _cache[10] || (_cache[10] = createBaseVNode(
            "h3",
            { class: "flex items-end mb-0 text-xl uppercase" },
            [
              createTextVNode(" Add your logo or artwork "),
              createBaseVNode("span", { class: "mb-1 ml-2 text-sm normal-case primary-color" }, "(Optional)")
            ],
            -1
            /* CACHED */
          )),
          _cache[11] || (_cache[11] = createBaseVNode(
            "p",
            { class: "mb-3 text-sm" },
            [
              createBaseVNode("a", {
                target: "_blank",
                href: "https://www.baudville.com/products/configurator/%7Bspecs_path%7D"
              }, "Read Artwork Specifications")
            ],
            -1
            /* CACHED */
          )),
          createBaseVNode("div", _hoisted_255, [
            _cache[9] || (_cache[9] = createBaseVNode(
              "h2",
              { class: "mb-4 text-xl text-center uppercase text-green-50" },
              " Logo Or Text Location ",
              -1
              /* CACHED */
            )),
            createBaseVNode("div", _hoisted_340, [
              createBaseVNode("div", _hoisted_434, [
                (openBlock(true), createElementBlock(
                  Fragment,
                  null,
                  renderList(_ctx.logoText, (logo, index) => {
                    return openBlock(), createElementBlock("div", {
                      key: index,
                      class: "flex items-center mb-4 button-property"
                    }, [
                      createBaseVNode("div", _hoisted_525, [
                        withDirectives(createBaseVNode("input", {
                          id: `logoTextLocation_${index}`,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.uploadTextLogo = $event),
                          type: "radio",
                          name: "logoTextLocation",
                          value: logo.value
                        }, null, 8, _hoisted_619), [
                          [vModelRadio, _ctx.uploadTextLogo]
                        ])
                      ]),
                      createBaseVNode("label", {
                        for: `logoTextLocation_${index}`,
                        class: "text-base font-bold button-property__name"
                      }, [
                        createBaseVNode(
                          "span",
                          _hoisted_814,
                          toDisplayString(logo.name),
                          1
                          /* TEXT */
                        )
                      ], 8, _hoisted_718)
                    ]);
                  }),
                  128
                  /* KEYED_FRAGMENT */
                ))
              ])
            ]),
            _ctx.uploadTextLogo !== "NOGRAPHIC" ? (openBlock(), createElementBlock("div", _hoisted_912, [
              _cache[8] || (_cache[8] = createBaseVNode(
                "h2",
                { class: "mb-4 text-xl text-center uppercase text-green-50" },
                " Upload Logo Or Text ",
                -1
                /* CACHED */
              )),
              createBaseVNode("form", null, [
                createBaseVNode("div", _hoisted_1012, [
                  createBaseVNode("div", _hoisted_1120, [
                    withDirectives(createBaseVNode(
                      "input",
                      {
                        id: "upload-logo[yes]",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.uploadLogo = $event),
                        type: "radio",
                        value: "logo"
                      },
                      null,
                      512
                      /* NEED_PATCH */
                    ), [
                      [vModelRadio, _ctx.uploadLogo]
                    ])
                  ]),
                  _cache[6] || (_cache[6] = createBaseVNode(
                    "label",
                    {
                      for: "upload-logo[yes]",
                      class: "text-base font-bold button-property__name"
                    },
                    [
                      createBaseVNode("span", { class: "button-property__text" }, "Upload Logo")
                    ],
                    -1
                    /* CACHED */
                  ))
                ]),
                _ctx.uploadTextLogo === "FRONT" ? (openBlock(), createElementBlock("div", _hoisted_1215, [
                  createBaseVNode("div", _hoisted_1313, [
                    withDirectives(createBaseVNode(
                      "input",
                      {
                        id: "logo-text",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.uploadLogo = $event),
                        type: "radio",
                        value: "text"
                      },
                      null,
                      512
                      /* NEED_PATCH */
                    ), [
                      [vModelRadio, _ctx.uploadLogo]
                    ])
                  ]),
                  _cache[7] || (_cache[7] = createBaseVNode(
                    "label",
                    {
                      for: "logo-text",
                      class: "text-base font-bold button-property__name"
                    },
                    [
                      createBaseVNode("span", { class: "button-property__text" }, "Text")
                    ],
                    -1
                    /* CACHED */
                  ))
                ])) : createCommentVNode("v-if", true)
              ])
            ])) : createCommentVNode("v-if", true),
            _ctx.uploadTextLogo !== "NOGRAPHIC" ? (openBlock(), createElementBlock("div", _hoisted_1412, [
              _ctx.uploadLogo === "logo" ? (openBlock(), createElementBlock("div", _hoisted_1511, [
                createBaseVNode("div", _hoisted_1610, [
                  createVNode(_component_DropZone, {
                    url: "https://jot.baudville.com/api/upload-logo",
                    onSending: _ctx.sending
                  }, null, 8, ["onSending"])
                ])
              ])) : createCommentVNode("v-if", true),
              _ctx.uploadLogo === "text" && _ctx.uploadTextLogo === "FRONT" ? (openBlock(), createElementBlock("div", _hoisted_178, [
                createVNode(_component_PersonalizationLogoInput, {
                  lines: _ctx.lines || {}
                }, null, 8, ["lines"])
              ])) : createCommentVNode("v-if", true)
            ])) : createCommentVNode("v-if", true)
          ])
        ])) : (openBlock(), createElementBlock("div", _hoisted_185, [
          createBaseVNode("div", {
            class: "pt-2 pb-4 mb-6 text-base border-b border-teal-200 content configurator-step__description",
            innerHTML: _ctx.message
          }, null, 8, _hoisted_195),
          createBaseVNode("div", _hoisted_205, [
            createBaseVNode("div", _hoisted_2113, [
              createBaseVNode("div", _hoisted_2211, [
                createBaseVNode("div", _hoisted_2310, [
                  withDirectives(createBaseVNode(
                    "input",
                    {
                      id: "upload-logo[no]",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.uploadLogo = $event),
                      type: "radio",
                      value: false
                    },
                    null,
                    512
                    /* NEED_PATCH */
                  ), [
                    [vModelRadio, _ctx.uploadLogo]
                  ])
                ]),
                _cache[12] || (_cache[12] = createBaseVNode(
                  "label",
                  {
                    for: "upload-logo[no]",
                    class: "text-sm font-bold button-property__name"
                  },
                  [
                    createBaseVNode("span", { class: "button-property__text" }, "No Thanks")
                  ],
                  -1
                  /* CACHED */
                ))
              ]),
              createBaseVNode("div", _hoisted_2410, [
                createBaseVNode("div", _hoisted_256, [
                  withDirectives(createBaseVNode(
                    "input",
                    {
                      id: "upload-logo[yes]",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => _ctx.uploadLogo = $event),
                      type: "radio",
                      value: "logo"
                    },
                    null,
                    512
                    /* NEED_PATCH */
                  ), [
                    [vModelRadio, _ctx.uploadLogo]
                  ])
                ]),
                _cache[13] || (_cache[13] = createBaseVNode(
                  "label",
                  {
                    for: "upload-logo[yes]",
                    class: "text-sm font-bold button-property__name"
                  },
                  [
                    createBaseVNode("span", { class: "button-property__text" }, "Yes, I would like to upload a logo")
                  ],
                  -1
                  /* CACHED */
                ))
              ])
            ])
          ]),
          _ctx.uploadLogo === "logo" && !_ctx.artWork?.image_url ? (openBlock(), createElementBlock("div", _hoisted_265, [
            createBaseVNode("div", _hoisted_274, [
              createVNode(_component_DropZone, {
                url: "https://jot.baudville.com/api/upload-logo",
                onSending: _ctx.sending
              }, null, 8, ["onSending"])
            ])
          ])) : createCommentVNode("v-if", true),
          withDirectives(createBaseVNode(
            "div",
            _hoisted_284,
            [
              _cache[14] || (_cache[14] = createBaseVNode(
                "div",
                { class: "dz-default dz-message" },
                [
                  createBaseVNode("span", null, "Drag & Drop Logo Here")
                ],
                -1
                /* CACHED */
              )),
              createBaseVNode("div", _hoisted_294, [
                createBaseVNode("div", _hoisted_304, [
                  createBaseVNode("img", {
                    src: _ctx.base64?.src || _ctx.artWork?.image_url,
                    alt: _ctx.base64?.name,
                    srcset: ""
                  }, null, 8, _hoisted_3111)
                ]),
                createBaseVNode("div", _hoisted_3210, [
                  createBaseVNode("div", _hoisted_3310, [
                    createBaseVNode(
                      "span",
                      _hoisted_343,
                      toDisplayString(_ctx.base64?.size?.toFixed(2)) + " MB",
                      1
                      /* TEXT */
                    )
                  ]),
                  createBaseVNode("div", _hoisted_353, [
                    createBaseVNode(
                      "span",
                      _hoisted_363,
                      toDisplayString(_ctx.base64?.name),
                      1
                      /* TEXT */
                    )
                  ])
                ]),
                createBaseVNode("a", {
                  class: "dz-remove",
                  href: "javascript:undefined;",
                  onClick: _cache[5] || (_cache[5] = withModifiers((...args) => _ctx.remove && _ctx.remove(...args), ["prevent"]))
                }, "Remove file")
              ])
            ],
            512
            /* NEED_PATCH */
          ), [
            [vShow, _ctx.uploadLogo === "logo" && _ctx.artWork?.image_url]
          ])
        ]))
      ]),
      _: 1
      /* STABLE */
    });
  }
  var import_lodash10, import_dropzone_vue2, __default__39, _hoisted_177, _hoisted_255, _hoisted_340, _hoisted_434, _hoisted_525, _hoisted_619, _hoisted_718, _hoisted_814, _hoisted_912, _hoisted_1012, _hoisted_1120, _hoisted_1215, _hoisted_1313, _hoisted_1412, _hoisted_1511, _hoisted_1610, _hoisted_178, _hoisted_185, _hoisted_195, _hoisted_205, _hoisted_2113, _hoisted_2211, _hoisted_2310, _hoisted_2410, _hoisted_256, _hoisted_265, _hoisted_274, _hoisted_284, _hoisted_294, _hoisted_304, _hoisted_3111, _hoisted_3210, _hoisted_3310, _hoisted_343, _hoisted_353, _hoisted_363, logo_artwork_default;
  var init_logo_artwork2 = __esm({
    "src/vue/components/shared/logo-artwork.vue"() {
      "use strict";
      init_personalization_logo_input();
      init_div_container2();
      init_vue_esm_bundler();
      init_vuex_esm_bundler();
      import_lodash10 = __toESM(require_lodash());
      import_dropzone_vue2 = __toESM(require_dropzone_vue_common());
      init_dropzone_vue_common();
      init_step_canvas2();
      init_vue_esm_bundler();
      init_logo_artwork();
      __default__39 = {
        components: {
          DivContainer: div_container_default,
          DropZone: import_dropzone_vue2.default,
          StepCanvas: step_canvas_default,
          PersonalizationLogoInput: personalization_logo_input_default
        },
        props: {
          images: Object,
          name: {
            type: String,
            default: "Add your logo or artwork"
          },
          message: {
            type: String,
            default: null
          },
          full_customization: {
            type: [Object, Boolean, String],
            default: null
          }
        },
        setup(props) {
          const store2 = useStore();
          const artWork = computed2(() => store2.getters.getArtwork);
          const base64 = ref(JSON.parse(sessionStorage.getItem("base64")));
          const uploadLogo = computed2({
            get() {
              return store2.getters.uploadLogo;
            },
            set(newValue) {
              store2.dispatch("saveUploadLogo", newValue);
            }
          });
          const lines = [
            {
              character_limit: 100,
              type: "textarea",
              font_size: 96
            },
            {
              character_limit: 100,
              type: "textarea",
              font_size: 96
            },
            {
              character_limit: 100,
              type: "textarea",
              font_size: 96
            }
          ];
          const uploadTextLogo = computed2({
            get() {
              return store2.getters.uploadTextLogo;
            },
            set(newValue) {
              store2.dispatch("saveUploadLogoText", newValue);
            }
          });
          const canvases = computed2(() => store2.getters.getCanvases);
          const renderTemplate = computed2(() => store2.getters.getRenderTemplate);
          const logoText = ref([
            {
              name: "Front Left",
              value: "FRONT"
            },
            {
              name: "Back W/ Design",
              value: "BACK"
            },
            {
              name: "No Text Or Logo",
              value: "NOGRAPHIC"
            }
          ]);
          const bytesToMegaBytes = (bytes) => bytes / (1024 * 1024);
          const sending = (files, xhr) => {
            if (files.length > 0) {
              const [imageFile] = files;
              const fileReader = new FileReader();
              fileReader.onload = () => {
                const srcData = fileReader.result;
                base64.value = {
                  src: srcData,
                  name: imageFile.name,
                  size: bytesToMegaBytes(imageFile.size)
                };
                sessionStorage.setItem("base64", JSON.stringify(base64.value));
              };
              fileReader.readAsDataURL(imageFile);
            }
            function callback(e) {
              const uploadData = JSON.parse(e);
              try {
                store2.dispatch("saveArtwork", uploadData);
              } catch (error) {
                console.error("artwork cannot saved");
              }
            }
            xhr.onreadystatechange = () => {
              if (xhr.readyState === 4) {
                callback(xhr.response);
              }
            };
          };
          const remove2 = () => {
            store2.dispatch("saveArtwork", {});
            sessionStorage.removeItem("base64");
          };
          watch2(uploadLogo, () => {
            store2.dispatch(
              "saveArtwork",
              uploadLogo.value === "logo" && renderTemplate.value ? { image_path: "Baudville/APPAREL_BLANK_LOGO" } : {}
            );
          });
          watch2(uploadTextLogo, () => {
            store2.dispatch(
              "saveUploadLogo",
              uploadLogo.value === "text" ? "text" : "logo"
            );
            if (uploadTextLogo.value !== "NOGRAPHIC") {
              store2.dispatch(
                "saveRenderTemplate",
                (0, import_lodash10.find)(props.images, ["view", uploadTextLogo.value]).value
              );
            }
          });
          return {
            uploadTextLogo,
            uploadLogo,
            canvases,
            renderTemplate,
            logoText,
            lines,
            artWork,
            base64,
            sending,
            remove: remove2
          };
        }
      };
      _hoisted_177 = { key: 1 };
      _hoisted_255 = { class: "py-6 mt-4 text-base border-t border-t-teal-200 content configurator-step__description" };
      _hoisted_340 = { class: "mb-6 font-bold" };
      _hoisted_434 = { class: "configurator-personalizations__toggle" };
      _hoisted_525 = { class: "inline-flex items-center pr-1 mr-2 value value--vue" };
      _hoisted_619 = ["id", "value"];
      _hoisted_718 = ["for"];
      _hoisted_814 = { class: "button-property__text" };
      _hoisted_912 = {
        key: 0,
        class: "w-full py-6 mt-4 border-t border-t-teal-200"
      };
      _hoisted_1012 = { class: "flex items-center mb-4 button-property" };
      _hoisted_1120 = { class: "inline-flex items-center pr-1 mr-2 value value--vue" };
      _hoisted_1215 = {
        key: 0,
        class: "flex items-center mb-4 button-property"
      };
      _hoisted_1313 = { class: "inline-flex items-center pr-1 mr-2 value value--vue" };
      _hoisted_1412 = { key: 1 };
      _hoisted_1511 = {
        key: 0,
        class: "p-2 mb-10 border-2 border-gray-200"
      };
      _hoisted_1610 = { class: "bg-white" };
      _hoisted_178 = {
        key: 1,
        class: ""
      };
      _hoisted_185 = { key: 2 };
      _hoisted_195 = ["innerHTML"];
      _hoisted_205 = { class: "mb-6 font-bold" };
      _hoisted_2113 = { class: "configurator-personalizations__toggle" };
      _hoisted_2211 = { class: "flex items-center mb-4 button-property" };
      _hoisted_2310 = { class: "inline-flex items-center pr-1 mr-2 value value--vue" };
      _hoisted_2410 = { class: "flex items-center mb-4 button-property" };
      _hoisted_256 = { class: "inline-flex items-center pr-1 mr-2 value value--vue" };
      _hoisted_265 = {
        key: 0,
        class: ""
      };
      _hoisted_274 = { class: "bg-white drop-area" };
      _hoisted_284 = { class: "vue-dropzone dropzone dz-clickable dz-started dz-max-files-reached" };
      _hoisted_294 = { class: "dz-preview dz-processing dz-image-preview dz-success dz-complete" };
      _hoisted_304 = { class: "dz-image" };
      _hoisted_3111 = ["src", "alt"];
      _hoisted_3210 = { class: "dz-details" };
      _hoisted_3310 = { class: "dz-size" };
      _hoisted_343 = { class: "font-bold" };
      _hoisted_353 = { class: "dz-filename" };
      _hoisted_363 = { "data-dz-name": "" };
      __default__39.render = render46;
      logo_artwork_default = __default__39;
    }
  });

  // src/vue/components/shared/step-approval.vue
  var step_approval_exports = {};
  __export(step_approval_exports, {
    default: () => step_approval_default,
    render: () => render47
  });
  function render47(_ctx, _cache) {
    const _component_PriceTable = resolveComponent("PriceTable");
    const _component_ProductQty = resolveComponent("ProductQty");
    const _component_DivContainer = resolveComponent("DivContainer");
    return openBlock(), createBlock(_component_DivContainer, null, {
      default: withCtx(() => [
        createBaseVNode("div", null, [
          createBaseVNode("div", _hoisted_179, [
            _cache[2] || (_cache[2] = createBaseVNode(
              "p",
              { class: "mb-2 font-bold" },
              " Enter any special instructions you have for your item(s) in the box below. If you have a due date for your order, please enter it here. Please note: as it is our busy season, we cannot guarantee due dates, but we will always try our best! ",
              -1
              /* CACHED */
            )),
            _cache[3] || (_cache[3] = createBaseVNode(
              "label",
              {
                class: "block w-full my-2 text-sm font-bold",
                for: "instructions"
              },
              "Special Instructions",
              -1
              /* CACHED */
            )),
            withDirectives(createBaseVNode(
              "textarea",
              {
                id: "instructions",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.instructions = $event),
                name: "instructions",
                data: "instructions",
                class: "w-full h-12 px-3 py-1 border border-gray-400 rounded"
              },
              null,
              512
              /* NEED_PATCH */
            ), [
              [vModelText, _ctx.instructions]
            ])
          ]),
          !_ctx.hidePriceTable ? (openBlock(), createBlock(_component_PriceTable, { key: 0 })) : createCommentVNode("v-if", true),
          !_ctx.hidePriceTable ? (openBlock(), createElementBlock("div", _hoisted_257, [
            !_ctx.getRenderTemplate ? (openBlock(), createElementBlock("div", _hoisted_341, [
              _cache[4] || (_cache[4] = createBaseVNode(
                "label",
                {
                  for: "quantity",
                  class: "block mb-2 text-sm font-bold"
                },
                [
                  createBaseVNode("span", { class: "property__text" }, "Quantity:")
                ],
                -1
                /* CACHED */
              )),
              createBaseVNode("div", _hoisted_435, [
                createVNode(_component_ProductQty, {
                  qty: _ctx.qty,
                  min: _ctx.minQty,
                  data: false,
                  disabled: _ctx.disabled(),
                  multiple: _ctx.multipleQuantity,
                  onUpdateQty: _ctx.updateProductQty
                }, null, 8, ["qty", "min", "disabled", "multiple", "onUpdateQty"])
              ])
            ])) : createCommentVNode("v-if", true)
          ])) : createCommentVNode("v-if", true),
          createBaseVNode("div", _hoisted_526, [
            _cache[6] || (_cache[6] = createBaseVNode(
              "div",
              { class: "pb-2 text-sm font-bold normal-case" },
              [
                createBaseVNode("span", { class: "property__text" }, "If you added a logo or custom graphic, you will be sent a proof to your inbox with instructions on approval there. If you did not add a logo or custom graphic this is your FINAL proof. Please initial to approve your order online.")
              ],
              -1
              /* CACHED */
            )),
            createBaseVNode("div", _hoisted_620, [
              _cache[5] || (_cache[5] = createBaseVNode(
                "label",
                {
                  for: "signOff",
                  class: "w-24 py-2 text-sm font-bold"
                },
                [
                  createBaseVNode("span", { class: "property__text" }, "Sign-Off")
                ],
                -1
                /* CACHED */
              )),
              createBaseVNode("div", _hoisted_719, [
                withDirectives(createBaseVNode(
                  "input",
                  {
                    id: "signOff",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.signOff = $event),
                    type: "text",
                    name: "signOff",
                    maxlength: "26",
                    class: "w-full h-12 px-3 py-1 border border-gray-400 rounded"
                  },
                  null,
                  512
                  /* NEED_PATCH */
                ), [
                  [vModelText, _ctx.signOff]
                ]),
                _ctx.error ? (openBlock(), createElementBlock("div", _hoisted_815, " Please complete Sign-off ")) : createCommentVNode("v-if", true)
              ])
            ])
          ])
        ])
      ]),
      _: 1
      /* STABLE */
    });
  }
  var __default__40, _hoisted_179, _hoisted_257, _hoisted_341, _hoisted_435, _hoisted_526, _hoisted_620, _hoisted_719, _hoisted_815, step_approval_default;
  var init_step_approval = __esm({
    "src/vue/components/shared/step-approval.vue"() {
      "use strict";
      init_vuex_esm_bundler();
      init_div_container2();
      init_vue_esm_bundler();
      init_price_table();
      init_product_qty();
      init_vue_esm_bundler();
      __default__40 = {
        components: { DivContainer: div_container_default, PriceTable: price_table_default, ProductQty: product_qty_default },
        props: {
          price: Boolean,
          hidePriceTable: {
            type: Boolean,
            default: false
          }
        },
        setup() {
          const store2 = useStore();
          const getRenderTemplate = computed2(() => store2.getters.getRenderTemplate);
          const getItemSize = computed2(() => store2.getters.getItemSize);
          const instructions = ref(store2.getters.instructions);
          const signOff = ref(store2.getters.signOff);
          const error = computed2(() => store2.getters.signOffError);
          const qty = computed2(() => store2.getters.getQuantity);
          const minQty = computed2(() => store2.getters.getMinQuantity);
          const multipleQuantity = computed2(() => store2.getters.getMultipleQuantity);
          const updateProductQty = (q2) => {
            store2.dispatch("saveQuantity", q2);
          };
          watch2([instructions, signOff], () => {
            store2.dispatch("saveInstructions", instructions.value);
            store2.dispatch("saveSignOff", signOff.value);
          });
          const disabled2 = () => {
            return getItemSize.value > 0 || getRenderTemplate.value;
          };
          return {
            instructions,
            qty,
            signOff,
            error,
            minQty,
            multipleQuantity,
            getRenderTemplate,
            updateProductQty,
            disabled: disabled2
          };
        }
      };
      _hoisted_179 = { class: "instruction-area" };
      _hoisted_257 = { key: 1 };
      _hoisted_341 = {
        key: 0,
        class: "my-4 configurator-text-input",
        index: "2"
      };
      _hoisted_435 = { class: "value" };
      _hoisted_526 = {
        class: "my-4 capitalize",
        index: "3"
      };
      _hoisted_620 = { class: "flex w-full pb-4 mb-4" };
      _hoisted_719 = { class: "flex flex-col w-full px-2" };
      _hoisted_815 = {
        key: 0,
        class: "mt-1 text-sm text-red-300 capitalize"
      };
      __default__40.render = render47;
      step_approval_default = __default__40;
    }
  });

  // vue-style:C:\fork\Baudville\src\vue\components\shared\colors-options.vue
  var init_colors_options = __esm({
    "vue-style:C:\\fork\\Baudville\\src\\vue\\components\\shared\\colors-options.vue"() {
    }
  });

  // src/vue/components/shared/colors-options.vue
  var colors_options_exports = {};
  __export(colors_options_exports, {
    default: () => colors_options_default,
    render: () => render48
  });
  function render48(_ctx, _cache) {
    const _component_DivContainer = resolveComponent("DivContainer");
    return openBlock(), createBlock(_component_DivContainer, null, {
      default: withCtx(() => [
        createBaseVNode("div", _hoisted_180, [
          createBaseVNode(
            "p",
            _hoisted_258,
            toDisplayString(_ctx.option.name),
            1
            /* TEXT */
          )
        ]),
        createBaseVNode("div", _hoisted_344, [
          (openBlock(true), createElementBlock(
            Fragment,
            null,
            renderList(_ctx.option.colors, (color, key) => {
              return openBlock(), createElementBlock("div", {
                key,
                class: "block w-1/2 mb-4 text-center md:w-1/3 lg:w-1/4 xl:w-1/6"
              }, [
                createBaseVNode("label", {
                  for: "color_" + key,
                  class: "block px-1 pt-0 pb-2 text-xs font-bold"
                }, [
                  createBaseVNode("input", {
                    id: "color_" + key,
                    checked: _ctx.option.category === "ProductColor" ? color.hex_value === _ctx.productColor : color.hex_value === _ctx.templateColor,
                    type: "radio",
                    name: "color",
                    class: "absolute invisible configurator-color-list__input",
                    value: color.hex_value,
                    onChange: ($event) => _ctx.change(color, _ctx.option.category)
                  }, null, 40, _hoisted_527),
                  createBaseVNode("i", {
                    tabindex: "0",
                    "aria-label": "color:" + color.name,
                    class: "configurator-color-list__swatch block relative w-full h-0 pb-[100%]",
                    style: normalizeStyle(`background-color:#${color.hex_value}`)
                  }, null, 12, _hoisted_621),
                  createBaseVNode(
                    "div",
                    _hoisted_720,
                    toDisplayString(color.name),
                    1
                    /* TEXT */
                  )
                ], 8, _hoisted_436)
              ]);
            }),
            128
            /* KEYED_FRAGMENT */
          ))
        ])
      ]),
      _: 1
      /* STABLE */
    });
  }
  var __default__41, _hoisted_180, _hoisted_258, _hoisted_344, _hoisted_436, _hoisted_527, _hoisted_621, _hoisted_720, colors_options_default;
  var init_colors_options2 = __esm({
    "src/vue/components/shared/colors-options.vue"() {
      "use strict";
      init_reactivity_esm_bundler();
      init_vuex_esm_bundler();
      init_div_container2();
      init_vue_esm_bundler();
      init_colors_options();
      __default__41 = {
        components: { DivContainer: div_container_default },
        props: {
          option: {
            type: Object,
            required: true
          }
        },
        setup() {
          const store2 = useStore();
          const templateColor = computed(() => store2.getters.getTemplateColor);
          const productColor = computed(() => store2.getters.getProductColor);
          const change = (color, category = "Color") => {
            console.log(color);
            if (category === "Color") {
              store2.dispatch("saveTemplateColor", color.hex_value);
            }
            if (category === "ProductColor") {
              store2.dispatch("saveProductColor", color.hex_value);
            }
            store2.dispatch("saveColorName", color);
          };
          return {
            change,
            templateColor,
            productColor
          };
        }
      };
      _hoisted_180 = { class: "mb-2" };
      _hoisted_258 = { class: "mb-4 text-sm font-bold" };
      _hoisted_344 = { class: "flex flex-wrap w-full" };
      _hoisted_436 = ["for"];
      _hoisted_527 = ["id", "checked", "value", "onChange"];
      _hoisted_621 = ["aria-label"];
      _hoisted_720 = { class: "mt-2" };
      __default__41.render = render48;
      __default__41.__scopeId = "data-v-fae57075";
      colors_options_default = __default__41;
    }
  });

  // src/vue/components/shared/step-quantities.vue
  var step_quantities_exports = {};
  __export(step_quantities_exports, {
    default: () => step_quantities_default,
    render: () => render49
  });
  function render49(_ctx, _cache) {
    const _component_PriceTable = resolveComponent("PriceTable");
    const _component_StepApproval = resolveComponent("StepApproval");
    const _component_DivContainer = resolveComponent("DivContainer");
    return openBlock(), createBlock(_component_DivContainer, null, {
      default: withCtx(() => [
        createBaseVNode("div", null, [
          _cache[0] || (_cache[0] = createBaseVNode(
            "div",
            { class: "pt-2" },
            " Enter the quantities of each product needed in the boxes below ",
            -1
            /* CACHED */
          )),
          createVNode(_component_PriceTable),
          createBaseVNode("div", _hoisted_181, [
            createBaseVNode("div", _hoisted_259, [
              (openBlock(true), createElementBlock(
                Fragment,
                null,
                renderList(_ctx.quantities, (quantity, key) => {
                  return openBlock(), createElementBlock("div", {
                    key,
                    class: "inline-block mx-2 mb-4"
                  }, [
                    createBaseVNode("div", _hoisted_345, [
                      createBaseVNode("input", {
                        id: `sizes[${key}]`,
                        type: "number",
                        value: quantity,
                        name: `sizes[${key}]`,
                        class: "h-8 px-1 text-sm font-bold text-center bg-white border border-gray-400 rounded w-11 font-mont",
                        onInput: ($event) => _ctx.updateQty($event, key)
                      }, null, 40, _hoisted_437)
                    ]),
                    createBaseVNode("label", {
                      for: `sizes[${key}]`,
                      class: "block mt-1 mb-2 text-sm font-bold text-center"
                    }, [
                      createBaseVNode(
                        "span",
                        _hoisted_622,
                        toDisplayString(key),
                        1
                        /* TEXT */
                      )
                    ], 8, _hoisted_528)
                  ]);
                }),
                128
                /* KEYED_FRAGMENT */
              ))
            ])
          ])
        ]),
        _cache[1] || (_cache[1] = createBaseVNode(
          "hr",
          { class: "pt-6 border-t border-t-teal-200" },
          null,
          -1
          /* CACHED */
        )),
        createVNode(_component_StepApproval, {
          class: "in-step-3",
          price: _ctx.price || false,
          "hide-price-table": true
        }, null, 8, ["price"])
      ]),
      _: 1
      /* STABLE */
    });
  }
  var __default__42, _hoisted_181, _hoisted_259, _hoisted_345, _hoisted_437, _hoisted_528, _hoisted_622, step_quantities_default;
  var init_step_quantities = __esm({
    "src/vue/components/shared/step-quantities.vue"() {
      "use strict";
      init_vuex_esm_bundler();
      init_div_container2();
      init_vue_esm_bundler();
      init_price_table();
      init_step_approval();
      init_vue_esm_bundler();
      __default__42 = {
        components: { DivContainer: div_container_default, PriceTable: price_table_default, StepApproval: step_approval_default },
        props: {
          price: Boolean
        },
        setup() {
          const store2 = useStore();
          const quantities = computed2(() => store2.getters.getQuantities);
          const qty = computed2(() => store2.getters.getQuantity);
          const item = ref({ ...quantities.value });
          const minQty = computed2(() => store2.getters.getMinQuantity);
          const multipleQuantity = computed2(() => store2.getters.getMultipleQuantity);
          const updateQty = (e, key) => {
            item.value = { ...quantities.value };
            item.value[key] = parseInt(e.target.value, 10);
            store2.dispatch("saveQuantities", { ...item.value });
            store2.dispatch(
              "saveQuantity",
              Object.values(item.value).reduce((a, b2) => a + b2, 0)
            );
          };
          return {
            qty,
            quantities,
            minQty,
            multipleQuantity,
            updateQty
          };
        }
      };
      _hoisted_181 = { class: "pt-6 mt-8 border-t border-t-teal-200" };
      _hoisted_259 = { class: "w-full" };
      _hoisted_345 = { class: "block m-0" };
      _hoisted_437 = ["id", "value", "name", "onInput"];
      _hoisted_528 = ["for"];
      _hoisted_622 = { class: "uppercase" };
      __default__42.render = render49;
      step_quantities_default = __default__42;
    }
  });

  // vue-style:C:\fork\Baudville\src\vue\components\shared\step-options.vue
  var init_step_options = __esm({
    "vue-style:C:\\fork\\Baudville\\src\\vue\\components\\shared\\step-options.vue"() {
    }
  });

  // src/vue/components/shared/step-options.vue
  var step_options_exports = {};
  __export(step_options_exports, {
    default: () => step_options_default,
    render: () => render50
  });
  function render50(_ctx, _cache) {
    const _component_StepHeader = resolveComponent("StepHeader");
    const _component_StepFooter = resolveComponent("StepFooter");
    const _component_MessageOptions = resolveComponent("MessageOptions");
    const _component_PersonalizationOption = resolveComponent("PersonalizationOption");
    const _component_StepQuantities = resolveComponent("StepQuantities");
    const _component_ColorsOptions = resolveComponent("ColorsOptions");
    const _component_LogoArtwork = resolveComponent("LogoArtwork");
    const _component_StepApproval = resolveComponent("StepApproval");
    return openBlock(), createBlock(Transition, null, {
      default: withCtx(() => [
        _ctx.step === _ctx.index ? (openBlock(), createElementBlock(
          "div",
          {
            key: 0,
            class: normalizeClass(["relative h-full bg-gray-600 configurator-options__steps", _ctx.step === 1 ? "configurator-options__steps--active" : ""])
          },
          [
            createVNode(_component_StepHeader, {
              name: _ctx.option.name,
              onBack: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("back"))
            }, null, 8, ["name"]),
            createVNode(_component_StepFooter, {
              class: "bg-white",
              step: _ctx.step,
              "total-steps": _ctx.totalSteps,
              onNext: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("next")),
              onBack: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("back")),
              onAddCart: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("add-cart"))
            }, null, 8, ["step", "total-steps"]),
            _ctx.option.category === "Message Options" ? (openBlock(), createBlock(_component_MessageOptions, {
              key: 0,
              options: _ctx.option.options,
              type: _ctx.option.type,
              images: _ctx.images
            }, null, 8, ["options", "type", "images"])) : createCommentVNode("v-if", true),
            _ctx.option.category === "Personalization" ? (openBlock(), createBlock(_component_PersonalizationOption, {
              key: 1,
              lines: _ctx.option.lines,
              fonts: _ctx.option?.fonts || {},
              price: _ctx.price || false,
              verses: _ctx.option?.verses || {},
              message: _ctx.option.message,
              add_another: _ctx.option.add_another
            }, null, 8, ["lines", "fonts", "price", "verses", "message", "add_another"])) : createCommentVNode("v-if", true),
            _ctx.option.category === "quantities" ? (openBlock(), createBlock(_component_StepQuantities, {
              key: 2,
              price: _ctx.price || false
            }, null, 8, ["price"])) : createCommentVNode("v-if", true),
            _ctx.option.category === "Color" || _ctx.option.category === "ProductColor" ? (openBlock(), createBlock(_component_ColorsOptions, {
              key: 3,
              option: _ctx.option
            }, null, 8, ["option"])) : createCommentVNode("v-if", true),
            _ctx.option.category === "logo" ? (openBlock(), createBlock(_component_LogoArtwork, {
              key: 4,
              images: _ctx.images,
              message: _ctx.option.logo.message,
              name: _ctx.option.logo.name,
              full_customization: _ctx.option.full_customization
            }, null, 8, ["images", "message", "name", "full_customization"])) : createCommentVNode("v-if", true),
            _ctx.option.category === "approval" ? (openBlock(), createBlock(_component_StepApproval, {
              key: 5,
              price: _ctx.price || false
            }, null, 8, ["price"])) : createCommentVNode("v-if", true)
          ],
          2
          /* CLASS */
        )) : createCommentVNode("v-if", true)
      ]),
      _: 1
      /* STABLE */
    });
  }
  var __default__43, step_options_default;
  var init_step_options2 = __esm({
    "src/vue/components/shared/step-options.vue"() {
      "use strict";
      init_step_header();
      init_step_footer();
      init_message_options2();
      init_personalization_option2();
      init_logo_artwork2();
      init_step_approval();
      init_colors_options2();
      init_step_quantities();
      init_vue_esm_bundler();
      init_step_options();
      __default__43 = {
        components: {
          StepHeader: step_header_default,
          StepFooter: step_footer_default,
          MessageOptions: message_options_default,
          PersonalizationOption: personalization_option_default,
          LogoArtwork: logo_artwork_default,
          StepApproval: step_approval_default,
          ColorsOptions: colors_options_default,
          StepQuantities: step_quantities_default
        },
        props: {
          step: {
            type: Number,
            required: true
          },
          images: {
            type: Object,
            required: true
          },
          totalSteps: {
            type: Number,
            required: true
          },
          index: {
            type: Number,
            required: true
          },
          option: {
            type: Object,
            required: true
          },
          price: {
            type: Boolean,
            default: false
          }
        },
        emits: ["back", "next", "add-cart"]
      };
      __default__43.render = render50;
      __default__43.__scopeId = "data-v-ca3cdde3";
      step_options_default = __default__43;
    }
  });

  // src/vue/components/shared/canvas-image.vue
  var canvas_image_exports = {};
  __export(canvas_image_exports, {
    default: () => canvas_image_default,
    render: () => render51
  });
  function render51(_ctx, _cache) {
    const _component_v_transformer = resolveComponent("v-transformer");
    const _component_v_layer = resolveComponent("v-layer");
    const _component_v_stage = resolveComponent("v-stage");
    return openBlock(), createElementBlock("div", null, [
      createVNode(_component_v_stage, {
        ref: "stage",
        config: _ctx.stageSize,
        onClick: _ctx.deselectNodes,
        onMousedown: _ctx.handleStageMouseDown,
        onTouchstart: _ctx.handleStageMouseDown
      }, {
        default: withCtx(() => [
          createVNode(
            _component_v_layer,
            { ref: "layer" },
            {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(
                  Fragment,
                  null,
                  renderList(_ctx.getArtworks, (image, key) => {
                    return openBlock(), createBlock(resolveDynamicComponent(image.type == "image" ? "v-image" : "v-text"), {
                      key,
                      config: {
                        ...image
                      },
                      onTransformend: _ctx.handleTransformEnd,
                      onClick: ($event) => _ctx.getIndex(key)
                    }, null, 40, ["config", "onTransformend", "onClick"]);
                  }),
                  128
                  /* KEYED_FRAGMENT */
                )),
                createVNode(
                  _component_v_transformer,
                  { ref: "transformer" },
                  null,
                  512
                  /* NEED_PATCH */
                )
              ]),
              _: 1
              /* STABLE */
            },
            512
            /* NEED_PATCH */
          )
        ]),
        _: 1
        /* STABLE */
      }, 8, ["config", "onClick", "onMousedown", "onTouchstart"])
    ]);
  }
  var __default__44, canvas_image_default;
  var init_canvas_image = __esm({
    "src/vue/components/shared/canvas-image.vue"() {
      "use strict";
      init_vuex_esm_bundler();
      init_vue_esm_bundler();
      __default__44 = {
        props: ["width", "height"],
        data() {
          return {
            stageSize: {
              width: this.width,
              height: this.height
            },
            selectedShapeName: ""
          };
        },
        computed: {
          ...mapGetters([
            "getArtworks",
            "getSelectedCanvas"
            // the name of the getter
          ])
        },
        watch: {
          getSelectedCanvas(n) {
            if (n == -1) {
              const stage = this.$refs.stage.getStage();
              stage.fire("click");
            }
          },
          getArtworks(n) {
            console.log(n);
          }
        },
        methods: {
          ...mapActions(["updateArtworks", "saveSelectedCanvas"]),
          getIndex(index) {
            console.log(index);
            this.saveSelectedCanvas(index);
          },
          deselectNodes() {
            const artworks = this.getArtworks;
            artworks.forEach((artwork) => {
              console.log(artwork.isSelected);
              if (artwork.isSelected) {
                artwork.isSelected = false;
              }
            });
            const stage = this.$refs.stage.getStage();
            stage.fire("deselectNodes");
          },
          handleTransformEnd(e) {
            const index = this.getArtworks.findIndex(
              (r) => r.name === this.selectedShapeName
            );
            const t = { ...this.getArtworks[index] };
            t.x = e.target.x();
            t.y = e.target.y();
            t.rotation = e.target.rotation();
            t.scaleX = e.target.scaleX();
            t.scaleY = e.target.scaleY();
            this.updateArtworks({
              obj: t,
              index
            });
          },
          handleStageMouseDown(e) {
            if (e.target === e.target.getStage()) {
              this.selectedShapeName = "";
              this.updateTransformer();
              return;
            }
            const clickedOnTransformer = e.target.getParent().className === "Transformer";
            if (clickedOnTransformer) {
              return;
            }
            const name = e.target.name();
            const rect = this.getArtworks.find((r) => r.name === name);
            if (rect) {
              this.selectedShapeName = name;
            } else {
              this.selectedShapeName = "";
            }
            this.updateTransformer();
          },
          updateTransformer() {
            const transformerNode = this.$refs.transformer.getNode();
            const stage = transformerNode.getStage();
            const { selectedShapeName } = this;
            const selectedNode = stage.findOne("." + selectedShapeName);
            if (selectedNode === transformerNode.node()) {
              return;
            }
            if (selectedNode) {
              transformerNode.nodes([selectedNode]);
            } else {
              transformerNode.nodes([]);
            }
          }
        }
      };
      __default__44.render = render51;
      canvas_image_default = __default__44;
    }
  });

  // src/vue/components/render/personalize-it.vue
  var personalize_it_exports = {};
  __export(personalize_it_exports, {
    default: () => personalize_it_default,
    render: () => render52
  });
  function render52(_ctx, _cache) {
    const _component_canvasImage = resolveComponent("canvasImage");
    const _component_StepButton = resolveComponent("StepButton");
    const _component_StepOptions = resolveComponent("StepOptions");
    return openBlock(), createElementBlock("div", _hoisted_186, [
      createBaseVNode("div", _hoisted_260, [
        createBaseVNode(
          "div",
          {
            ref: "divRef",
            class: normalizeClass(["relative w-full px-12 lg:w-7/12", _ctx.loading && "opacity-50"])
          },
          [
            _ctx.renderTemplate ? (openBlock(), createElementBlock("div", _hoisted_346, [
              createBaseVNode("div", _hoisted_438, [
                (openBlock(true), createElementBlock(
                  Fragment,
                  null,
                  renderList(_ctx.personalization.images.slice(0, 2), (image, key) => {
                    return openBlock(), createElementBlock("button", {
                      key,
                      type: "button",
                      class: normalizeClass(["button h-12 bg-gray-600 border-b border-b-teal-200 !w-1/2", _ctx.renderTemplate === image.value && "bg-red-50 text-white"]),
                      onClick: withModifiers(($event) => _ctx.saveRenderTemplate(image.value), ["prevent"])
                    }, toDisplayString(image.view || image.name), 11, _hoisted_529);
                  }),
                  128
                  /* KEYED_FRAGMENT */
                ))
              ])
            ])) : createCommentVNode("v-if", true),
            createBaseVNode("div", _hoisted_623, [
              createBaseVNode("img", {
                class: normalizeClass(["configurator-preview__image", _ctx.loading && "opacity-50"]),
                src: _ctx.url,
                alt: "",
                crossorigin: "anonymous"
              }, null, 10, _hoisted_721),
              _ctx.canvases.length ? (openBlock(), createElementBlock(
                "div",
                {
                  key: 0,
                  class: normalizeClass([
                    "configurator-preview__full-customization",
                    _ctx.canvasSelector && "configurator-preview__full-customization--is-active"
                  ]),
                  style: normalizeStyle(`position: absolute; top: ${_ctx.canvasPosition?.top}px; left: ${_ctx.canvasPosition?.left}px`)
                },
                [
                  createBaseVNode("div", null, [
                    createBaseVNode(
                      "div",
                      {
                        class: "konvajs-content",
                        role: "presentation",
                        style: normalizeStyle(` 
               position: relative;
                user-select: none;
                width:  ${_ctx.canvasPosition?.width}px;
                height:  ${_ctx.canvasPosition?.height}px;
                `)
                      },
                      [
                        createVNode(_component_canvasImage, {
                          width: _ctx.canvasPosition?.width,
                          height: _ctx.canvasPosition?.height
                        }, null, 8, ["width", "height"])
                      ],
                      4
                      /* STYLE */
                    )
                  ])
                ],
                6
                /* CLASS, STYLE */
              )) : createCommentVNode("v-if", true)
            ])
          ],
          2
          /* CLASS */
        ),
        createBaseVNode("div", _hoisted_816, [
          _ctx.step === 0 ? (openBlock(), createElementBlock("div", _hoisted_913, [
            createBaseVNode("div", _hoisted_1013, [
              createBaseVNode(
                "h3",
                _hoisted_1121,
                toDisplayString(_ctx.steps?.language?.en?.personalization?.customization_options),
                1
                /* TEXT */
              ),
              createBaseVNode(
                "p",
                _hoisted_1216,
                toDisplayString(_ctx.steps?.language?.en?.personalization?.customization_message),
                1
                /* TEXT */
              ),
              createBaseVNode(
                "h3",
                _hoisted_1314,
                toDisplayString(_ctx.steps?.language?.en?.personalization?.lets_get_started || "Let's Get Started!"),
                1
                /* TEXT */
              )
            ]),
            (openBlock(true), createElementBlock(
              Fragment,
              null,
              renderList(_ctx.personalization.steps, (info, index) => {
                return openBlock(), createBlock(_component_StepButton, {
                  key: index,
                  step_number: index + 1,
                  name: info.name,
                  onStepChange: ($event) => _ctx.step = _ctx.step + index + 1
                }, null, 8, ["step_number", "name", "onStepChange"]);
              }),
              128
              /* KEYED_FRAGMENT */
            ))
          ])) : createCommentVNode("v-if", true),
          (openBlock(true), createElementBlock(
            Fragment,
            null,
            renderList(_ctx.personalization.steps, (option, index) => {
              return openBlock(), createBlock(_component_StepOptions, {
                key: index,
                index: index + 1,
                step: _ctx.step,
                "total-steps": _ctx.personalization.steps.length,
                price: _ctx.personalization?.show_price || false,
                option,
                url: _ctx.url,
                images: _ctx.personalization.images,
                onAddCart: _ctx.addCart,
                onBack: _cache[0] || (_cache[0] = ($event) => _ctx.step = 0),
                onNext: _cache[1] || (_cache[1] = ($event) => _ctx.step = _ctx.step + 1)
              }, null, 8, ["index", "step", "total-steps", "price", "option", "url", "images", "onAddCart"]);
            }),
            128
            /* KEYED_FRAGMENT */
          ))
        ])
      ])
    ]);
  }
  var import_lodash11, import_dom_to_image, __default__45, _hoisted_186, _hoisted_260, _hoisted_346, _hoisted_438, _hoisted_529, _hoisted_623, _hoisted_721, _hoisted_816, _hoisted_913, _hoisted_1013, _hoisted_1121, _hoisted_1216, _hoisted_1314, personalize_it_default;
  var init_personalize_it = __esm({
    "src/vue/components/render/personalize-it.vue"() {
      "use strict";
      import_lodash11 = __toESM(require_lodash());
      init_vuex_esm_bundler();
      init_vue_esm_bundler();
      import_dom_to_image = __toESM(require_dom_to_image());
      init_step_button();
      init_step_options2();
      init_axios2();
      init_canvas();
      init_properties();
      init_canvas_image();
      init_personalizeAddCart();
      init_vue_esm_bundler();
      __default__45 = {
        components: {
          StepButton: step_button_default,
          StepOptions: step_options_default,
          canvasImage: canvas_image_default
        },
        props: {
          handle: {
            type: String,
            required: true
          },
          is_sale: {
            type: Boolean,
            default: false
          },
          is_custom_art: {
            type: Boolean,
            default: false
          }
        },
        setup(props) {
          const store2 = useStore();
          const { handle, is_sale, is_custom_art } = toRefs(props);
          const legacyId = ref();
          const productVariant = ref({});
          const feeVariant = ref({});
          const loading = ref(false);
          const uploadLogo = computed2(() => store2.getters.uploadLogo);
          const canvases = computed2(() => store2.getters.getCanvases);
          const { getCanvasTop, getCanvasLeft, getCanvasWidth, getCanvasHeight } = canvasHelper();
          const canvasPosition = ref({});
          const canvasSelector = ref(false);
          const scene7Id = computed2(() => store2.getters.getScene7Id);
          const scene7IdName = ref("");
          const noColor = ref(false);
          const emblem = computed2(() => store2.getters.getEmblem);
          const titleGraphicCategoriesId = computed2(
            () => store2.getters.getTitleGraphicCategories
          );
          const artwork = computed2(() => store2.getters.getArtwork);
          const artworks = computed2(() => store2.getters.getArtworks);
          const renderTemplate = computed2(() => store2.getters.getRenderTemplate);
          const templateColor = computed2(() => store2.getters.getTemplateColor);
          const colorName = computed2(() => store2.getters.getColorName);
          const productColor = computed2(() => store2.getters.getProductColor);
          const font = computed2(() => store2.getters.getFont);
          const fontSize = computed2(() => store2.getters.getFontSize);
          const items = computed2(() => store2.getters.getItems);
          const fontSizeName = computed2(() => store2.getters.getFontSizeName);
          const activeItem = computed2(
            () => store2.getters.getItemById(store2.getters.getActiveIndex)
          );
          const activeFontSizeName = computed2(
            () => store2.getters.getFontSizeNameById(store2.getters.getActiveIndex)
          );
          const activeLayout = computed2(() => store2.getters.getLayout);
          const verseText = computed2(() => store2.getters.getVerse);
          const instructions = computed2(() => store2.getters.instructions);
          const signOff = computed2(() => store2.getters.signOff);
          const quantity = computed2(() => store2.getters.getQuantity);
          const minQuantity = computed2(() => store2.getters.getMinQuantity);
          const prices = computed2(() => store2.getters.getPrices);
          const locations = computed2(() => store2.getters.getLocations);
          const productQuantities = computed2(() => store2.getters.getQuantities);
          const steps = ref([]);
          const step = ref(0);
          const hazmat = ref(false);
          const dimensions = ref({
            weight: 0,
            length: 0,
            width: 0,
            height: 0
          });
          const certificateTemp = ref(handle.value.includes("certificate"));
          if (certificateTemp.value) {
            store2.dispatch("saveCertificateTemp", certificateTemp.value);
          }
          const personalization = ref({ steps: [] });
          const base64Image = ref();
          const url = ref();
          const saveRenderTemplate = (val) => store2.dispatch("saveRenderTemplate", val);
          const divRef = ref(null);
          const linelpData = ref({
            available: false,
            index: -1,
            value: void 0
          });
          const getFontSize = (i2 = 1) => {
            return activeFontSizeName.value?.[`size${i2}`]?.font_size ?? fontSize.value[i2 - 1] ?? 80;
          };
          const dynamicImage = (line) => {
            const baseUrl = "https://s7d7.scene7.com/is/image/Baudville/";
            const imageTemplate = {
              FRONT: activeLayout.value ? (0, import_lodash11.chain)(personalization.value.images).find({ default: true }).get("layouts").find({ layout: activeLayout.value }).get("value").value() : (0, import_lodash11.filter)(personalization.value.images, ["default", true])[0]?.value || personalization.value.images[0]?.value,
              TEMPLATE: activeLayout.value ? (0, import_lodash11.chain)(personalization.value.images).find({ template: true }).get("layouts").find({ layout: activeLayout.value }).get("value").value() : (0, import_lodash11.filter)(personalization.value.images, ["template", true])[0]?.value || personalization.value.images[1]?.value
            };
            if (artwork.value?.image_path && activeLayout.value !== "P") {
              if (steps.value.logo_template_exists && !(is_custom_art.value && scene7IdName.value === "Custom Art")) {
                imageTemplate.TEMPLATE += "L";
              }
            }
            if (personalization.value.RENDER_TEMP) {
              loading.value = false;
              const src2 = `${baseUrl}RENDER_TEMP?layer=0&src=ir{BaudvilleRender/${renderTemplate.value}?obj=image/fabric&color=${productColor.value}&obj=image/flowline&color=${productColor.value}&show=&decal=&res=150&wid=2000&hei=2000&src=is{Baudville/`;
              if (renderTemplate.value === personalization.value.images[0].value) {
                return `${src2}${artwork.value?.image_path ? `${artwork.value?.image_path.replace(
                  "Baudville/",
                  ""
                )}?op_colorize=${templateColor.value}` : ""}}&anchor=0,0}`;
              }
              return `${src2}${scene7Id.value}?$line1=${line.line1}&$line2=${line.line2}&$line3=${line.line3}&layer=1&hide=1&layer=2&hide=0&op_colorize=${templateColor.value}&layer=3&op_colorize=${templateColor.value}${artwork.value?.image_path ? `&src=is{${artwork.value?.image_path}}` : uploadLogo.value === "text" ? "" : "&hide=1"}&layer=4&op_colorize=${templateColor.value}&layer=5&op_colorize=${templateColor.value}&layer=6&op_colorize=${templateColor.value}&layer=7&hide=1}&anchor=0,0}`;
            }
            let src = `${baseUrl}${imageTemplate.TEMPLATE}?`;
            if (is_custom_art.value && scene7IdName.value === "Custom Art") {
              src = `${baseUrl}${imageTemplate.TEMPLATE}CA?`;
              if (artwork.value?.image_path) {
                src = `${baseUrl}${imageTemplate.TEMPLATE}CAL?`;
              }
            }
            console.log({ scene7IdName: scene7IdName.value, src });
            if (certificateTemp.value) {
              loading.value = false;
              let layer1 = 4;
              let layer4 = 1;
              let layer3 = 3;
              const targetHandle = [
                "laurel-certificate-folder",
                "certificate-folders",
                "flag-foil-certificate-folder"
              ];
              if (targetHandle.includes(handle?.value)) {
                layer1 = 1;
                layer4 = 4;
                if (activeLayout?.value === "P") {
                  layer1 = 4;
                  layer4 = 1;
                }
              }
              if (locations.value === "CENTER") {
                return `${src}layer=0&src=is{Baudville/${imageTemplate.FRONT}}&layer=${layer4}&op_colorize=${templateColor.value}&src=is{Baudville/${scene7Id.value}}&layer=${layer1}&src=is{Baudville/NOGRAPHIC}&op_colorize=${templateColor.value}&layer=${layer3}&op_colorize=${templateColor.value}&layer=6&op_colorize=${templateColor.value}&$ctrline1=&$btrline1=&$ctrline2=&$btrline2=&$line3=&$line4=${encodeURI(
                  line.line1?.trim()
                )}&$fn=${encodeURI(font.value)}`;
              }
              return `${src}layer=0&src=is{Baudville/${imageTemplate.FRONT}}&layer=${layer1}&op_colorize=${templateColor.value}&src=is{Baudville/${scene7Id.value}}&layer=${layer4}&src=is{Baudville/NOGRAPHIC}&op_colorize=${templateColor.value}&layer=${layer3}&op_colorize=${templateColor.value}&layer=6&op_colorize=${templateColor.value}&$ctrline1=&$btrline1=&$ctrline2=&$btrline2=&$line3=&$line4=${encodeURI(
                line.line1?.trim()
              )}&$fn=${encodeURI(font.value)}`;
            }
            if (font.value) {
              src += `$fn=${encodeURI(font.value)}&$fn=${encodeURI(font.value)}`;
            }
            if (linelpData.value.available) {
              linelpData.value.value = line[`line${linelpData.value.index}`];
              console.log(linelpData);
            }
            src += `&$line1=${encodeURI(line.line1?.trim())}&$line1fs=${getFontSize(
              1
            )}&$line2=${encodeURI(line.line2?.trim())}&$line2fs=${getFontSize(
              2
            )}&$line3=${encodeURI(line.line3?.trim())}&$line3fs=${getFontSize(
              3
            )}&$line4=${encodeURI(line.line4?.trim())}&$line4fs=${getFontSize(
              4
            )}&$line5=${encodeURI(line.line5?.trim())}&$line5fs=${getFontSize(
              5
            )}&$line6=${encodeURI(line.line6?.trim())}&$line6fs=${getFontSize(
              6
            )}&$linelp=`;
            if (linelpData.value.available && linelpData.value.value) {
              src += linelpData.value.value;
            }
            if (verseText.value) {
              src += `&$verse_fs=72&$verse_text=${encodeURI(
                verseText.value?.trim()
              ).replaceAll("%0A", "\\par%0A")}`;
            }
            src += `&layer=0&src=is{Baudville/${imageTemplate.FRONT}}&layer=1&hide=0`;
            if (!canvases.value.length) {
              src += `&op_colorize=${templateColor.value}`;
            } else {
              src += `&op_colorize=${templateColor.value}`;
            }
            if (scene7Id.value) {
              src += `&src=is{Baudville/${scene7Id.value}}`;
            }
            src += `&layer=2&op_colorize=${templateColor.value}`;
            if (artwork.value?.image_path) {
              src += `&layer=3&src=is{${artwork.value?.image_path}}`;
            } else {
              src += `&layer=3`;
            }
            src += `&op_colorize=${templateColor.value}&layer=4&op_colorize=${templateColor.value}`;
            if (emblem.value) {
              src += `&layer=5&src=is{Baudville/${emblem.value}}&op_colorize=${templateColor.value}`;
            }
            loading.value = false;
            if (noColor.value) {
              src = src.replaceAll(`&op_colorize=${templateColor.value}`, "");
            }
            return src.replaceAll("undefined", "");
          };
          const addCart2 = async () => {
            if (!steps.value.quantities) {
              if (!personalization.value.RENDER_TEMP) {
                if (!signOff.value?.length && !renderTemplate.value) {
                  store2.dispatch("saveSignOffEror", true);
                  let objDiv = document.querySelector(".configurator-step__content");
                  objDiv.scrollTop = objDiv.scrollHeight;
                  return false;
                }
              }
            }
            if (personalization.value?.quantities && personalization.value.RENDER_TEMP) {
              if (!signOff.value?.length && renderTemplate.value) {
                store2.dispatch("saveSignOffEror", true);
                step.value = 3;
                setTimeout(() => {
                  let objDiv = document.querySelector(".configurator-step__content");
                  objDiv.scrollTop = objDiv.scrollHeight;
                }, 300);
                return false;
              }
            }
            if (quantity.value < minQuantity.value) {
              return false;
            }
            if (productVariant.value.available) {
              store2.dispatch("saveSignOffEror", false);
              let productColor2 = null;
              if (personalization.value.RENDER_TEMP) {
                productColor2 = (0, import_lodash11.find)(steps.value.title_graphics, [
                  "value",
                  scene7Id.value
                ]);
              }
              const lineitemsWithFontSize = lineitem(
                items.value,
                fontSizeName.value,
                store2.getters.getActiveItemSize
              );
              const customizations = properties_default({
                layout: steps.value?.layouts?.find((f) => f.value === activeLayout.value) ?? null,
                titleGraphic: getObjValue(
                  scene7Id.value,
                  steps.value?.title_graphics,
                  activeLayout?.value
                ),
                titleGraphicCategory: titleGraphicCategoriesId.value,
                emblem: getObjValue(
                  emblem.value,
                  steps.value?.emblems,
                  activeLayout?.value
                ),
                font: steps.value?.fonts?.find((f) => f.value === font.value) ?? null,
                verseText: verseText.value,
                notes: instructions.value,
                approval: signOff.value,
                url: url.value,
                uploadLogo: artwork.value?.image_path ? artwork.value?.image_url : null,
                line1: activeItem.value?.line1 || null,
                line1Size: getFontSize(1),
                line1SizeName: activeFontSizeName.value?.size1?.size || null,
                line2: activeItem.value?.line2 || null,
                line2Size: getFontSize(2),
                line2SizeName: activeFontSizeName.value?.size2?.size || null,
                line3: activeItem.value?.line3 || null,
                line3Size: getFontSize(3),
                line3SizeName: activeFontSizeName.value?.size3?.size || null,
                line4: activeItem.value?.line4 || null,
                line4Size: getFontSize(4),
                line4SizeName: activeFontSizeName.value?.size4?.size || null,
                line5: activeItem.value?.line5 || null,
                line5Size: getFontSize(5),
                line5SizeName: activeFontSizeName.value?.size5?.size || null,
                line6: activeItem.value?.line6 || null,
                line6Size: getFontSize(6),
                line6SizeName: activeFontSizeName.value?.size6?.size || null,
                color: personalization.value.RENDER_TEMP ? null : colorName.value,
                colorHexValue: templateColor.value,
                productColor: personalization.value.RENDER_TEMP ? productColor2?.product_color : null,
                primaryGraphicColor: (0, import_lodash11.find)(productColor2?.graphic_colors, ["type", "primary"]) || null,
                secondaryGraphicColor: (0, import_lodash11.find)(productColor2?.graphic_colors, ["type", "secondary"]) || null,
                primaryTextColor: (0, import_lodash11.find)(productColor2?.text_colors, ["type", "primary"]) || null,
                secondaryTextColor: (0, import_lodash11.find)(productColor2?.text_colors, ["type", "secondary"]) || null,
                logoTextColor: productColor2?.logo_text_color || null,
                location: steps.value?.locations?.find((f) => f.value === locations.value) ?? null,
                ...personalization.value.quantities && {
                  sizes: productQuantities.value
                }
              });
              const personalizationProperties = personalizationProperty({});
              if (artworks.value.length) {
                const divElement = divRef.value;
                base64Image.value = await import_dom_to_image.default.toPng(divElement);
              }
              let { addOns, feeVariantId } = calculateFee({
                steps: steps.value,
                feeVariant: feeVariant.value,
                quantity: quantity.value,
                templateColor: templateColor.value
              });
              let price = 0;
              if (prices.value) {
                price = window.theme.quantityBreak(quantity.value, prices.value);
              }
              let formDataProperty = formData({
                quantity,
                productVariant,
                feeVariantId,
                legacyId,
                hazmat,
                customizations,
                is_sale,
                addOns,
                personalizationProperties,
                activeLayout,
                scene7Id,
                font,
                colorName,
                locations,
                artwork,
                base64Image,
                url,
                instructions,
                signOff,
                items,
                lineitemsWithFontSize,
                renderTemplate,
                prices,
                price,
                dimensions
              });
              console.log(dimensions.value);
              fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify(formDataProperty)
              }).then((response) => {
                return response.json();
              }).then(async () => {
                document.body.classList.add("body-scroll--disabled");
                document.body.classList.add("cart-add-logo");
                store2.dispatch("saveCartDrawer", true);
                setTimeout(() => {
                  document.body.classList.remove("cart-add-logo");
                }, 2e3);
              }).then(() => {
                axios_default("/cart?view=view-json").then((response) => {
                  store2.dispatch("saveCart", response.data);
                });
              }).catch((e) => console.error(e));
            } else {
            }
          };
          watch2(titleGraphicCategoriesId, (id) => {
            const result = (0, import_lodash11.find)(
              steps.value.title_graphics,
              (t) => t.category == id && t.default
            );
            if (result?.value) {
              store2.dispatch("saveScene7Id", result?.value);
            }
          });
          watch2(scene7Id, (id) => {
            const result = steps.value.title_graphics.find(
              (title) => title.value === id
            );
            if (result?.value) {
              scene7IdName.value = result.name;
            }
            console.log(result);
          });
          watch2(canvases.value, () => {
            if (canvases.value.length) {
              canvasPosition.value = {
                top: getCanvasTop(),
                left: getCanvasLeft(),
                width: getCanvasWidth(),
                height: getCanvasHeight()
              };
            }
          });
          const watcher = [
            scene7Id,
            scene7IdName,
            emblem,
            renderTemplate,
            templateColor,
            productColor,
            items.value,
            artwork,
            activeLayout,
            font,
            verseText,
            fontSize,
            locations
          ];
          watch2(watcher, () => {
            loading.value = true;
            const key = store2.getters.getActiveIndex;
            url.value = dynamicImage(store2.getters.getItemById(key));
          });
          watch2(step, () => {
            if (canvases.value) {
              if (personalization.value.steps[step.value - 1]?.category == "logo") {
                canvasSelector.value = true;
              } else {
                store2.dispatch("saveSelectedCanvas", -1);
                canvasSelector.value = false;
              }
            }
          });
          return {
            divRef,
            linelpData,
            steps,
            step,
            personalization,
            loading,
            url,
            canvases,
            canvasSelector,
            canvasPosition,
            renderTemplate,
            productHandle: handle,
            productVariant,
            feeVariant,
            hazmat,
            dimensions,
            certificateTemp,
            legacyId,
            noColor,
            addCart: addCart2,
            saveRenderTemplate
          };
        },
        created() {
        },
        async mounted() {
          const store2 = useStore();
          const variant = new URL(location.href).searchParams.get("variant");
          let url = `/products/${this.productHandle}?view=personalization`;
          if (variant) {
            url = url + `&variant=${variant}`;
          }
          axios_default(url).then((response) => {
            document.title = response.data?.title + " - Baudville";
            this.legacyId = response.data._id;
            this.steps = response.data.personalization.personalization_options;
            store2.dispatch("saveQuantity", response.data.qty);
            store2.dispatch("saveMinQuantity", response.data.qty);
            store2.dispatch("savePrices", response.data.prices);
            store2.dispatch("saveMultipleQuantity", response.data.qty_multiple);
            this.productVariant = response.data.variant;
            this.feeVariant = response.data.fee;
            this.hazmat = response.data.hazmat;
            this.dimensions = {
              weight: response.data.weight ?? 0,
              length: response.data.dimensions_length ?? 0,
              width: response.data.dimensions_width ?? 0,
              height: response.data.dimensions_height ?? 0
            };
            let quantities = {
              s: response.data?.qty ?? 1,
              m: 0,
              l: 0,
              xl: 0,
              xxl: 0
            };
            if (response.data?.quantities) {
              console.log(response.data?.quantities);
              const sizes = {};
              const sizesArr = response.data?.quantities.split(",").map((size) => size.trim());
              sizesArr.forEach((size) => {
                sizes[size] = 0;
              });
              sizes[sizesArr[0]] = response.data?.qty ?? 1;
              quantities = { ...sizes };
            }
            if (this.steps.flowline_type && this.steps.flowline_type == "image/flowline") {
              this.personalization.RENDER_TEMP = true;
              this.personalization.quantities = {
                ...quantities
              };
            }
            if (this.steps.quantities || response.data?.quantities) {
              this.personalization.quantities = {
                ...quantities
              };
            }
            const optionType = () => {
              if (this.steps.canvases || this.personalization.RENDER_TEMP) {
                return "radio";
              }
              if (this.steps.title_graphics && Object.hasOwn(this.steps.title_graphics[0], "thumbnail")) {
                return "radio";
              }
              return "select";
            };
            if (this.steps.title_graphics || this.steps.emblems || this.steps.title_graphic_categories || this.steps.locations) {
              const step1 = {
                name: this.steps?.language?.en?.personalization?.steps?.message_options?.label || "Message Options",
                type: optionType(),
                category: "Message Options",
                options: []
              };
              if (this.steps.title_graphic_categories) {
                step1.options.push({
                  id: 0,
                  label: "Choose A Product",
                  category: "product",
                  settings: [...this.steps.title_graphic_categories]
                });
                const id = (0, import_lodash11.find)(this.steps.title_graphic_categories, ["default", true])?.value || "1";
                store2.dispatch("saveTitleGraphicCategories", id);
                if (this.personalization.RENDER_TEMP) {
                  const obj = (0, import_lodash11.find)(this.steps.title_graphics, ["category", id]);
                  store2.dispatch("saveProductColor", obj?.product_color?.hex_value);
                }
              }
              if (this.steps.title_graphics) {
                step1.options.push({
                  id: 1,
                  label: this.steps?.language?.en?.personalization?.steps?.title_graphics?.label || "Choose Your Sentiment",
                  category: optionType() === "radio" ? "card" : "sentiment",
                  settings: [...this.steps.title_graphics]
                });
              }
              if (this.steps.emblems) {
                step1.options.push({
                  id: 2,
                  label: "Choose An Emblem",
                  category: "emblem",
                  settings: [...this.steps.emblems]
                });
              }
              if (this.steps.locations) {
                step1.options.push({
                  id: 3,
                  label: "Choose Graphic Location",
                  category: "locations",
                  settings: [...this.steps.locations]
                });
                store2.dispatch(
                  "saveLocations",
                  (0, import_lodash11.find)(this.steps.locations, ["default", true])?.value ?? this.steps.locations[0]?.value
                );
              }
              this.personalization.steps.push(step1);
            }
            if (this.steps.lines || this.steps.verses || this.steps.fonts) {
              const step2 = {
                name: "Personalization",
                category: "Personalization",
                add_another: this.certificateTemp ? false : true,
                message: this.steps?.language?.en?.personalization?.steps?.text?.message ?? "Personalization is free for this item"
              };
              if (this.steps.lines) {
                if (Object.hasOwn(this.steps.lines[0], "active_only_if_no_graphic")) {
                  const filteredObjects = (0, import_lodash11.filter)(this.steps.lines, [
                    "active_only_if_no_graphic",
                    false
                  ]);
                  const filteredObjects2 = (0, import_lodash11.filter)(this.steps.lines, [
                    "active_only_if_no_graphic",
                    true
                  ]);
                  const plainObjects = (0, import_lodash11.map)(
                    filteredObjects,
                    (obj) => (0, import_lodash11.cloneDeep)(obj)
                  );
                  const plainObjects2 = (0, import_lodash11.map)(
                    filteredObjects2,
                    (obj) => (0, import_lodash11.cloneDeep)(obj)
                  );
                  step2["lines"] = [...plainObjects, ...plainObjects2];
                } else {
                  step2["lines"] = [...this.steps.lines];
                }
                const linelp = this.steps.lines.find(
                  (line) => line.name === "linelp"
                );
                if (linelp) {
                  const linelpProp = { ...step2["lines"][0] };
                  linelpProp.label = linelp.name;
                  linelpProp.sizes.map((size) => {
                    size.character_limit = linelp.character_limit;
                    size.font_size = linelp.font_size;
                    return size;
                  });
                  step2["lines"].push(linelpProp);
                  this.linelpData = {
                    available: true,
                    index: step2["lines"].length
                  };
                }
              }
              if (this.steps.verses) {
                step2["verses"] = [...this.steps.verses];
                store2.dispatch(
                  "saveVerse",
                  response.data.personalization_template.verse.replaceAll("\\", "")
                );
              }
              if (this.steps.fonts) {
                step2["fonts"] = [...this.steps.fonts];
              }
              this.personalization.steps.push(step2);
            }
            if (this.steps.colors) {
              if (this.personalization.RENDER_TEMP) {
                const step = {
                  name: "Choose Product Color",
                  category: "ProductColor",
                  colors: [...this.steps.colors]
                };
                this.personalization.steps.push(step);
                this.personalization.steps.push({
                  name: "Enter Product Quantities",
                  category: "quantities",
                  notes: {
                    message: "Enter the quantities of each product needed in the boxes below"
                  }
                });
                this.personalization.steps.push({
                  name: this.steps?.language?.en?.personalization?.steps?.logo?.step_label || this.steps?.language?.en?.personalization?.add_graphic || "Logo or Text",
                  category: "logo",
                  logo: {
                    message: this.steps?.language?.en?.personalization?.steps?.logo?.message
                  },
                  full_customization: this.steps?.language?.en?.personalization?.steps?.full_customization
                });
                const step2 = {
                  name: "Choose Graphic & Text Colors",
                  category: "Color",
                  labels: ["Choose Text Color", "Choose Logo Or Text Color"],
                  colors: [...this.steps.colors]
                };
                this.personalization.steps.push(step2);
              } else {
                const step = {
                  name: this.steps?.language?.en?.personalization?.steps?.colors?.label || "Choose Logo Imprint Color",
                  category: "Color",
                  colors: [...this.steps.colors]
                };
                this.personalization.steps.push(step);
                const defaultSelected = (0, import_lodash11.find)(this.steps.colors, [
                  "hex_value",
                  this.steps.template_color
                ]) ?? this.steps.colors[0];
                store2.dispatch("saveColorName", defaultSelected);
              }
            }
            if (!this.personalization.RENDER_TEMP) {
              if (this.steps.canvases || this.steps.can_upload_logo) {
                this.personalization.steps.push({
                  name: this.steps?.language?.en?.personalization?.steps?.logo?.step_label || this.steps?.language?.en?.personalization?.steps?.full_customization?.label || this.steps?.language?.en?.personalization?.add_graphic || "Add Logo or Artwork",
                  category: "logo",
                  logo: {
                    message: this.steps?.language?.en?.personalization?.steps?.logo?.message
                  },
                  full_customization: {
                    label: this.steps?.language?.en?.personalization?.add_graphic ?? this.steps?.language?.en?.personalization?.steps?.full_customization?.label ?? "Add Logo"
                  }
                });
              }
            }
            if (!this.personalization.RENDER_TEMP) {
              if (this.steps.quantities || response.data?.quantities) {
                this.personalization.steps.push({
                  name: "Enter Product Quantities",
                  category: "quantities",
                  notes: {
                    message: "Enter the quantities of each product needed in the boxes below"
                  }
                });
              } else {
                this.personalization.steps.push({
                  name: this.steps?.language?.en?.personalization?.steps?.approval?.label || "Approval",
                  category: "approval",
                  notes: {
                    message: this.steps?.language?.en?.personalization?.steps?.notes?.message
                  }
                });
              }
            }
            this.personalization["images"] = [...this.steps.images];
            if (this.steps.canvases && this.steps.canvases.length) {
              this.personalization["canvases"] = [...this.steps.canvases];
            }
            return response.data;
          }).then(() => {
            const options = (0, import_lodash11.pickBy)(this.personalization.steps, {
              category: "Message Options"
            });
            const personalization = (0, import_lodash11.filter)(this.personalization.steps, [
              "category",
              "Personalization"
            ])[0];
            const colors = (0, import_lodash11.filter)(this.personalization.steps, [
              "category",
              "Color"
            ])[0];
            const productColor = (0, import_lodash11.filter)(this.personalization.steps, [
              "category",
              "ProductColor"
            ])[0];
            const fonts = personalization?.fonts;
            if (fonts?.length) {
              store2.dispatch(
                "saveFont",
                (0, import_lodash11.filter)(fonts, ["default", true])[0]?.value
              );
            }
            const lines = personalization?.lines;
            if (lines?.length) {
              const items = {};
              const font_size = [];
              const fontSizeName = {};
              (0, import_lodash11.each)(lines, (line, index) => {
                items[`line${index + 1}`] = line?.default || "";
                font_size.push(
                  line?.font_size ?? Object.values(line?.layouts || {})[0]?.font_size ?? line?.sizes?.[0]?.font_size ?? 96
                );
                if (line?.sizes?.[0]?.size) {
                  fontSizeName[`size${index + 1}`] = {
                    font_size: line?.sizes?.[0]?.font_size,
                    size: line?.sizes?.[0]?.size
                  };
                }
              });
              if (Object.keys(fontSizeName).length) {
                store2.dispatch("updateFontSizeName", {
                  item: fontSizeName,
                  index: 0
                });
              }
              store2.dispatch("saveFontSize", font_size);
              store2.dispatch("updateItem", {
                item: items,
                index: 0
              });
            }
            if (this.personalization?.RENDER_TEMP) {
              store2.dispatch(
                "saveRenderTemplate",
                this.personalization.images[1].value
              );
            }
            if (this.steps?.template_color) {
              store2.dispatch("saveTemplateColor", this.steps.template_color);
            }
            if (productColor?.colors?.length && !this.steps.title_graphic_categories) {
              store2.dispatch("saveProductColor", productColor.colors[0].hex_value);
            }
            if (colors?.colors?.length) {
              store2.dispatch("saveTemplateColor", colors.colors[0].hex_value);
            }
            if (this.personalization?.quantities && Object.keys(this.personalization?.quantities).length) {
              store2.dispatch("saveQuantities", this.personalization.quantities);
              store2.dispatch(
                "saveQuantity",
                Object.values(this.personalization?.quantities).reduce(
                  (a, b2) => a + b2,
                  0
                )
              );
            }
            if (this.personalization.canvases && this.personalization.canvases.length > 0) {
              store2.dispatch("saveCanvases", this.personalization.canvases[0]);
            }
            if (this.steps.title_graphics) {
              if (this.steps.layouts) {
                const layout = (0, import_lodash11.find)(this.steps.layouts, {
                  default: true
                });
                store2.dispatch(
                  "saveLayout",
                  layout?.value || this.steps.layouts[0]?.value
                );
                store2.dispatch("saveLayouts", this.steps.layouts);
                if (this.steps.emblems) {
                  const settings2 = options?.[0]?.options?.[1]?.settings?.find((s) => s.default) ?? options?.[0]?.options?.[1]?.settings?.[0];
                  store2.dispatch(
                    "saveEmblem",
                    settings2?.layouts?.find((s) => s.layout === layout.value)?.value ?? settings2?.value
                  );
                }
                const settings = options?.[0]?.options?.[0]?.settings?.find((s) => s.default) ?? options?.[0]?.options?.[0]?.settings?.[0];
                store2.dispatch(
                  "saveScene7Id",
                  settings?.layouts?.find((s) => s.layout === layout.value)?.value ?? settings?.value
                );
              } else {
                let idx = 0;
                if (this.steps.title_graphic_categories) {
                  idx = 1;
                }
                let setting = (0, import_lodash11.filter)(options[0]?.options[idx]?.settings, [
                  "default",
                  true
                ])[0];
                if (this.steps.title_graphic_categories && !setting?.value) {
                  setting = options[0]?.options[idx]?.settings[0];
                }
                store2.dispatch(
                  "saveScene7Id",
                  setting?.value || options[0]?.options[0]?.settings[0].value
                );
                if (setting) {
                  this.noColor = setting?.no_color;
                } else {
                  this.noColor = options[0]?.options[0]?.settings[0]?.no_color;
                }
              }
            }
          }).catch((error) => {
            console.error("Error:", error);
          });
        }
      };
      _hoisted_186 = { class: "container relative mx-auto my-6" };
      _hoisted_260 = { class: "flex flex-wrap border border-teal-100" };
      _hoisted_346 = {
        key: 0,
        class: "clearfix configurator-image-toggle"
      };
      _hoisted_438 = { class: "-mx-12" };
      _hoisted_529 = ["onClick"];
      _hoisted_623 = { class: "configurator-preview__image" };
      _hoisted_721 = ["src"];
      _hoisted_816 = { class: "w-full border-l border-teal-100 lg:w-5/12" };
      _hoisted_913 = { key: 0 };
      _hoisted_1013 = { class: "p-4 text-center" };
      _hoisted_1121 = { class: "mb-2 text-3xl font-mont" };
      _hoisted_1216 = { class: "mb-3 text-sm font-semibold" };
      _hoisted_1314 = { class: "text-3xl font-mont" };
      __default__45.render = render52;
      personalize_it_default = __default__45;
    }
  });

  // src/vue/components/render/product-view.vue
  var product_view_exports = {};
  __export(product_view_exports, {
    default: () => product_view_default,
    render: () => render53
  });
  function render53(_ctx, _cache) {
    return openBlock(), createElementBlock("div", _hoisted_187, [
      createBaseVNode("div", _hoisted_261, [
        _ctx.product.coming_soon ? (openBlock(), createElementBlock("div", _hoisted_347, [..._cache[4] || (_cache[4] = [
          createBaseVNode(
            "svg",
            {
              width: "60",
              height: "80",
              viewBox: "0 0 120 140",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            },
            [
              createCommentVNode(" Badge Shape "),
              createBaseVNode("path", {
                d: "M20 0H100V100L60 80L20 100V0Z",
                fill: "#E07A6A"
              }),
              createCommentVNode(" Text "),
              createBaseVNode("text", {
                x: "60",
                y: "42",
                "text-anchor": "middle",
                "font-family": "AlternateGotNo3D, sans-serif",
                "font-size": "18",
                "font-weight": "700",
                fill: "white"
              }, " Coming "),
              createBaseVNode("text", {
                x: "60",
                y: "68",
                "text-anchor": "middle",
                "font-family": "AlternateGotNo3D, sans-serif",
                "font-size": "18",
                "font-weight": "700",
                fill: "white"
              }, " Soon! ")
            ],
            -1
            /* CACHED */
          )
        ])])) : createCommentVNode("v-if", true),
        createBaseVNode(
          "div",
          {
            class: normalizeClass(["product-summary__media-link-wrapper relative", {
              "mh-arrows-wrapper": _ctx.product && _ctx.product.images && _ctx.product.images.length > 1
            }])
          },
          [
            createBaseVNode("span", {
              class: "mh-arrows_arrow mh-arrows_arrow-left",
              onClick: _cache[0] || (_cache[0] = ($event) => _ctx.left())
            }, [..._cache[5] || (_cache[5] = [
              createBaseVNode(
                "svg",
                {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 512 512"
                },
                [
                  createBaseVNode("path", {
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "48",
                    d: "M328 112L184 256l144 144"
                  })
                ],
                -1
                /* CACHED */
              )
            ])]),
            createBaseVNode("span", {
              class: "mh-arrows_arrow mh-arrows_arrow-right",
              onClick: _cache[1] || (_cache[1] = ($event) => _ctx.right())
            }, [..._cache[6] || (_cache[6] = [
              createBaseVNode(
                "svg",
                {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 512 512"
                },
                [
                  createBaseVNode("path", {
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "48",
                    d: "M184 112l144 144-144 144"
                  })
                ],
                -1
                /* CACHED */
              )
            ])]),
            createBaseVNode("a", {
              class: "product-summary__media-link",
              href: _ctx.product.url || _ctx.product.href
            }, [
              _ctx.product && _ctx.product.images && _ctx.product.images.length ? (openBlock(), createElementBlock("div", _hoisted_530, [
                (openBlock(true), createElementBlock(
                  Fragment,
                  null,
                  renderList(_ctx.product.images, (image, index) => {
                    return openBlock(), createElementBlock(
                      "div",
                      {
                        key: index,
                        class: normalizeClass(["collection-product-image", index == _ctx.activeIndex ? "active" : "hidden"])
                      },
                      [
                        createBaseVNode("img", {
                          itemprop: "image",
                          src: _ctx.preloadedImageUrls[index],
                          class: "product-summary__media-image",
                          loading: "lazy",
                          width: "350",
                          height: "350",
                          alt: _ctx.product.title
                        }, null, 8, _hoisted_624),
                        createBaseVNode("link", {
                          rel: "preload",
                          href: _ctx.preloadedImageUrls[index],
                          as: "image"
                        }, null, 8, _hoisted_722)
                      ],
                      2
                      /* CLASS */
                    );
                  }),
                  128
                  /* KEYED_FRAGMENT */
                ))
              ])) : (openBlock(), createElementBlock("div", _hoisted_817, [
                _ctx.product.featured_image || _ctx.product.image ? (openBlock(), createElementBlock("img", {
                  key: 0,
                  itemprop: "image",
                  class: "product-summary__media-image",
                  src: _ctx.preloadedImageUrls,
                  alt: _ctx.product.title,
                  width: "350",
                  height: "350",
                  loading: "lazy"
                }, null, 8, _hoisted_914)) : createCommentVNode("v-if", true),
                createBaseVNode("link", {
                  rel: "preload",
                  href: _ctx.preloadedImageUrls,
                  as: "image"
                }, null, 8, _hoisted_1014)
              ]))
            ], 8, _hoisted_439)
          ],
          2
          /* CLASS */
        ),
        createBaseVNode("div", _hoisted_1122, [
          createBaseVNode("button", {
            class: "button button--full button--quickview",
            rel: "nofollow",
            "data-modifier": "false",
            "data-url": _ctx.product.url || _ctx.product.href,
            onClick: _cache[2] || (_cache[2] = (...args) => _ctx.quickview && _ctx.quickview(...args))
          }, " Quick View ", 8, _hoisted_1217)
        ])
      ]),
      createBaseVNode("div", _hoisted_1315, [
        _ctx.product.badge ? (openBlock(), createElementBlock("span", _hoisted_1413, "New")) : createCommentVNode("v-if", true),
        createBaseVNode("p", _hoisted_1512, [
          createBaseVNode("a", {
            class: "text-base font-semibold tracking-wider text-gray-100 hover:text-green-100",
            itemprop: "url",
            href: _ctx.product.href || _ctx.product.href,
            innerHTML: _ctx.product.title
          }, null, 8, _hoisted_1611)
        ]),
        createCommentVNode(" <p>Date: {{ new Date(Number(product.date)).toDateString() }}</p> "),
        createBaseVNode("div", _hoisted_1710, [
          createBaseVNode("div", _hoisted_188, [
            _ctx.product.compare_at_price !== "0" && _ctx.product.compare_at_price > _ctx.product.price ? (openBlock(), createElementBlock("p", _hoisted_196, [
              createBaseVNode(
                "s",
                null,
                toDisplayString(_ctx.money(_ctx.product.compare_at_price)),
                1
                /* TEXT */
              )
            ])) : createCommentVNode("v-if", true),
            createBaseVNode(
              "p",
              {
                class: normalizeClass([
                  "font-normal product-prices__price product-prices__price--discounted",
                  _ctx.product.compare_at_price !== "0" && _ctx.product.compare_at_price > _ctx.product.price && "text-red-500"
                ])
              },
              [
                createBaseVNode("span", null, [
                  _cache[7] || (_cache[7] = createBaseVNode(
                    "meta",
                    {
                      content: "USD",
                      itemprop: "priceCurrency"
                    },
                    null,
                    -1
                    /* CACHED */
                  )),
                  _cache[8] || (_cache[8] = createBaseVNode(
                    "meta",
                    {
                      content: "1.5",
                      itemprop: "price"
                    },
                    null,
                    -1
                    /* CACHED */
                  )),
                  createTextVNode(
                    " " + toDisplayString(_ctx.money(_ctx.product.price)) + " ",
                    1
                    /* TEXT */
                  ),
                  _cache[9] || (_cache[9] = createBaseVNode(
                    "link",
                    {
                      href: "https://schema.org/InStock",
                      itemprop: "availability"
                    },
                    null,
                    -1
                    /* CACHED */
                  ))
                ])
              ],
              2
              /* CLASS */
            )
          ])
        ]),
        createBaseVNode("p", _hoisted_206, [
          createBaseVNode("button", {
            class: "flex items-center text-green-100 border-none button hover:text-black",
            onClick: _cache[3] || (_cache[3] = (...args) => _ctx.video && _ctx.video(...args))
          }, [..._cache[10] || (_cache[10] = [
            createBaseVNode(
              "span",
              { class: "product-summary__video-link-icon" },
              [
                createBaseVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 32 32",
                  class: "mr-1 fill-green-100 svg-icon svg-icon--small svg-icon--link-color"
                }, [
                  createBaseVNode("title", null, "Play Video"),
                  createBaseVNode("path", { d: "M12.21,9.21a1.63,1.63,0,0,0-1.57,1.63V21.15A1.61,1.61,0,0,0,13,22.57L22,17.41a1.62,1.62,0,0,0,0-2.82L13,9.43A1.72,1.72,0,0,0,12.21,9.21ZM16,2.43A13.57,13.57,0,1,1,2.43,16,13.56,13.56,0,0,1,16,2.43ZM16,1A15,15,0,1,0,31,16,15,15,0,0,0,16,1Z" })
                ])
              ],
              -1
              /* CACHED */
            ),
            createBaseVNode(
              "span",
              {
                class: "text-xs product-summary__video-link-text js-video-button",
                "data-video-id": "731044217",
                "data-channel": "vimeo"
              },
              "Watch this video",
              -1
              /* CACHED */
            )
          ])])
        ])
      ])
    ]);
  }
  var __default__46, _hoisted_187, _hoisted_261, _hoisted_347, _hoisted_439, _hoisted_530, _hoisted_624, _hoisted_722, _hoisted_817, _hoisted_914, _hoisted_1014, _hoisted_1122, _hoisted_1217, _hoisted_1315, _hoisted_1413, _hoisted_1512, _hoisted_1611, _hoisted_1710, _hoisted_188, _hoisted_196, _hoisted_206, product_view_default;
  var init_product_view = __esm({
    "src/vue/components/render/product-view.vue"() {
      "use strict";
      init_vue_esm_bundler();
      init_vue_esm_bundler();
      __default__46 = {
        props: {
          product: {
            type: Object,
            required: true
          }
        },
        setup(props) {
          const imageLength = ref(props.product?.images?.length || 0);
          const activeIndex = ref(0);
          const left = () => {
            activeIndex.value = (activeIndex.value + imageLength.value - 1) % imageLength.value;
          };
          const right = () => {
            activeIndex.value = (activeIndex.value + 1) % imageLength.value;
          };
          const video = () => {
          };
          const quickview = () => {
          };
          const imageSrc = (url) => {
            if (!url.startsWith("http")) {
              url = `https://${url}`;
            }
            const urlObject = new URL(url);
            const existingWidthParam = urlObject.searchParams.get("width");
            const existingHeightParam = urlObject.searchParams.get("height");
            if (existingWidthParam) {
              urlObject.searchParams.delete("width");
            }
            if (existingHeightParam) {
              urlObject.searchParams.delete("height");
            }
            urlObject.searchParams.append("width", 350);
            urlObject.searchParams.append("height", 350);
            return urlObject.toString();
          };
          const preloadedImageUrls = computed2(() => {
            return imageLength.value ? props.product?.images.map((image) => imageSrc(image)) : imageSrc(props.product?.featured_image || props.product?.image);
          });
          const money = (money2) => {
            if (/^\$/.test(money2)) {
              return money2;
            }
            if (/\./.test(money2)) {
              return "$" + money2.toFixed(2);
            }
            return "$" + money2.toFixed(2);
          };
          return {
            activeIndex,
            video,
            quickview,
            left,
            right,
            money,
            preloadedImageUrls
          };
        }
      };
      _hoisted_187 = {
        class: "w-full product-summary group",
        itemscope: "",
        itemtype: "http://schema.org/Product"
      };
      _hoisted_261 = { class: "relative flex items-center border border-gray-800 rounded-sm product-summary__media broder-gray-300" };
      _hoisted_347 = {
        key: 0,
        class: "absolute top-0 left-0 z-10 empty:hidden"
      };
      _hoisted_439 = ["href"];
      _hoisted_530 = { key: 0 };
      _hoisted_624 = ["src", "alt"];
      _hoisted_722 = ["href"];
      _hoisted_817 = { key: 1 };
      _hoisted_914 = ["src", "alt"];
      _hoisted_1014 = ["href"];
      _hoisted_1122 = { class: "absolute bottom-0 left-0 w-full transition-opacity opacity-0 quickview-button group-hover:opacity-100" };
      _hoisted_1217 = ["data-url"];
      _hoisted_1315 = { class: "my-3 text-center product-summary__info" };
      _hoisted_1413 = {
        key: 0,
        class: "text-xl font-bold tracking-wide text-green-100 uppercase font-mont"
      };
      _hoisted_1512 = {
        class: "mb-2 product-summary__name",
        itemprop: "name"
      };
      _hoisted_1611 = ["href", "innerHTML"];
      _hoisted_1710 = { class: "flex items-center justify-center" };
      _hoisted_188 = {
        class: "flex text-xl font-normal product-prices font-mont product-prices--summary",
        itemprop: "offers",
        itemscope: "",
        itemtype: "http://schema.org/Offer"
      };
      _hoisted_196 = {
        key: 0,
        class: "mr-2 text-gray-400 product-prices__price product-prices__price--original"
      };
      _hoisted_206 = { class: "product-summary__video-link" };
      __default__46.render = render53;
      product_view_default = __default__46;
    }
  });

  // src/vue/components/render/recent-product.vue
  var recent_product_exports = {};
  __export(recent_product_exports, {
    default: () => recent_product_default,
    render: () => render54
  });
  function render54(_ctx, _cache) {
    const _component_product_view = resolveComponent("product-view");
    return _ctx.products?.length ? (openBlock(), createElementBlock("div", _hoisted_189, [
      createBaseVNode("div", _hoisted_266, [
        createBaseVNode(
          "h2",
          _hoisted_348,
          toDisplayString(_ctx.title),
          1
          /* TEXT */
        ),
        createBaseVNode("div", _hoisted_440, [
          (openBlock(true), createElementBlock(
            Fragment,
            null,
            renderList(_ctx.products, (product) => {
              return openBlock(), createElementBlock("div", {
                class: "w-1/2 lg:w-1/4 px-2 text-center mb-10 collection-product",
                key: product.id
              }, [
                createVNode(_component_product_view, { product }, null, 8, ["product"])
              ]);
            }),
            128
            /* KEYED_FRAGMENT */
          ))
        ])
      ])
    ])) : createCommentVNode("v-if", true);
  }
  var __default__47, _hoisted_189, _hoisted_266, _hoisted_348, _hoisted_440, recent_product_default;
  var init_recent_product = __esm({
    "src/vue/components/render/recent-product.vue"() {
      "use strict";
      init_product_view();
      init_vue_esm_bundler();
      __default__47 = {
        components: {
          productView: product_view_default
        },
        props: {
          products: {
            type: Object,
            default: JSON.parse(localStorage.getItem("recent-view-products")) || []
          },
          title: {
            type: String,
            default: "Recently Viewed Items"
          }
        }
      };
      _hoisted_189 = {
        key: 0,
        class: "py-12"
      };
      _hoisted_266 = { class: "container max-w-screen-xl" };
      _hoisted_348 = { class: "uppercase mb-4 tracking-wider bv-section-heading" };
      _hoisted_440 = { class: "flex flex-wrap -mx-2 render-products related-products" };
      __default__47.render = render54;
      recent_product_default = __default__47;
    }
  });

  // node_modules/dayjs/dayjs.min.js
  var require_dayjs_min = __commonJS({
    "node_modules/dayjs/dayjs.min.js"(exports, module) {
      !(function(t, e) {
        "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs = e();
      })(exports, (function() {
        "use strict";
        var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i2 = "second", s = "minute", u2 = "hour", a = "day", o = "week", c = "month", f = "quarter", h2 = "year", d = "date", l = "Invalid Date", $2 = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y2 = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M2 = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(t2) {
          var e2 = ["th", "st", "nd", "rd"], n2 = t2 % 100;
          return "[" + t2 + (e2[(n2 - 20) % 10] || e2[n2] || e2[0]) + "]";
        } }, m = function(t2, e2, n2) {
          var r2 = String(t2);
          return !r2 || r2.length >= e2 ? t2 : "" + Array(e2 + 1 - r2.length).join(n2) + t2;
        }, v = { s: m, z: function(t2) {
          var e2 = -t2.utcOffset(), n2 = Math.abs(e2), r2 = Math.floor(n2 / 60), i3 = n2 % 60;
          return (e2 <= 0 ? "+" : "-") + m(r2, 2, "0") + ":" + m(i3, 2, "0");
        }, m: function t2(e2, n2) {
          if (e2.date() < n2.date()) return -t2(n2, e2);
          var r2 = 12 * (n2.year() - e2.year()) + (n2.month() - e2.month()), i3 = e2.clone().add(r2, c), s2 = n2 - i3 < 0, u3 = e2.clone().add(r2 + (s2 ? -1 : 1), c);
          return +(-(r2 + (n2 - i3) / (s2 ? i3 - u3 : u3 - i3)) || 0);
        }, a: function(t2) {
          return t2 < 0 ? Math.ceil(t2) || 0 : Math.floor(t2);
        }, p: function(t2) {
          return { M: c, y: h2, w: o, d: a, D: d, h: u2, m: s, s: i2, ms: r, Q: f }[t2] || String(t2 || "").toLowerCase().replace(/s$/, "");
        }, u: function(t2) {
          return void 0 === t2;
        } }, g = "en", D2 = {};
        D2[g] = M2;
        var p2 = "$isDayjsObject", S2 = function(t2) {
          return t2 instanceof _2 || !(!t2 || !t2[p2]);
        }, w = function t2(e2, n2, r2) {
          var i3;
          if (!e2) return g;
          if ("string" == typeof e2) {
            var s2 = e2.toLowerCase();
            D2[s2] && (i3 = s2), n2 && (D2[s2] = n2, i3 = s2);
            var u3 = e2.split("-");
            if (!i3 && u3.length > 1) return t2(u3[0]);
          } else {
            var a2 = e2.name;
            D2[a2] = e2, i3 = a2;
          }
          return !r2 && i3 && (g = i3), i3 || !r2 && g;
        }, O = function(t2, e2) {
          if (S2(t2)) return t2.clone();
          var n2 = "object" == typeof e2 ? e2 : {};
          return n2.date = t2, n2.args = arguments, new _2(n2);
        }, b2 = v;
        b2.l = w, b2.i = S2, b2.w = function(t2, e2) {
          return O(t2, { locale: e2.$L, utc: e2.$u, x: e2.$x, $offset: e2.$offset });
        };
        var _2 = (function() {
          function M3(t2) {
            this.$L = w(t2.locale, null, true), this.parse(t2), this.$x = this.$x || t2.x || {}, this[p2] = true;
          }
          var m2 = M3.prototype;
          return m2.parse = function(t2) {
            this.$d = (function(t3) {
              var e2 = t3.date, n2 = t3.utc;
              if (null === e2) return /* @__PURE__ */ new Date(NaN);
              if (b2.u(e2)) return /* @__PURE__ */ new Date();
              if (e2 instanceof Date) return new Date(e2);
              if ("string" == typeof e2 && !/Z$/i.test(e2)) {
                var r2 = e2.match($2);
                if (r2) {
                  var i3 = r2[2] - 1 || 0, s2 = (r2[7] || "0").substring(0, 3);
                  return n2 ? new Date(Date.UTC(r2[1], i3, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2)) : new Date(r2[1], i3, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2);
                }
              }
              return new Date(e2);
            })(t2), this.init();
          }, m2.init = function() {
            var t2 = this.$d;
            this.$y = t2.getFullYear(), this.$M = t2.getMonth(), this.$D = t2.getDate(), this.$W = t2.getDay(), this.$H = t2.getHours(), this.$m = t2.getMinutes(), this.$s = t2.getSeconds(), this.$ms = t2.getMilliseconds();
          }, m2.$utils = function() {
            return b2;
          }, m2.isValid = function() {
            return !(this.$d.toString() === l);
          }, m2.isSame = function(t2, e2) {
            var n2 = O(t2);
            return this.startOf(e2) <= n2 && n2 <= this.endOf(e2);
          }, m2.isAfter = function(t2, e2) {
            return O(t2) < this.startOf(e2);
          }, m2.isBefore = function(t2, e2) {
            return this.endOf(e2) < O(t2);
          }, m2.$g = function(t2, e2, n2) {
            return b2.u(t2) ? this[e2] : this.set(n2, t2);
          }, m2.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
          }, m2.valueOf = function() {
            return this.$d.getTime();
          }, m2.startOf = function(t2, e2) {
            var n2 = this, r2 = !!b2.u(e2) || e2, f2 = b2.p(t2), l2 = function(t3, e3) {
              var i3 = b2.w(n2.$u ? Date.UTC(n2.$y, e3, t3) : new Date(n2.$y, e3, t3), n2);
              return r2 ? i3 : i3.endOf(a);
            }, $3 = function(t3, e3) {
              return b2.w(n2.toDate()[t3].apply(n2.toDate("s"), (r2 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e3)), n2);
            }, y3 = this.$W, M4 = this.$M, m3 = this.$D, v2 = "set" + (this.$u ? "UTC" : "");
            switch (f2) {
              case h2:
                return r2 ? l2(1, 0) : l2(31, 11);
              case c:
                return r2 ? l2(1, M4) : l2(0, M4 + 1);
              case o:
                var g2 = this.$locale().weekStart || 0, D3 = (y3 < g2 ? y3 + 7 : y3) - g2;
                return l2(r2 ? m3 - D3 : m3 + (6 - D3), M4);
              case a:
              case d:
                return $3(v2 + "Hours", 0);
              case u2:
                return $3(v2 + "Minutes", 1);
              case s:
                return $3(v2 + "Seconds", 2);
              case i2:
                return $3(v2 + "Milliseconds", 3);
              default:
                return this.clone();
            }
          }, m2.endOf = function(t2) {
            return this.startOf(t2, false);
          }, m2.$set = function(t2, e2) {
            var n2, o2 = b2.p(t2), f2 = "set" + (this.$u ? "UTC" : ""), l2 = (n2 = {}, n2[a] = f2 + "Date", n2[d] = f2 + "Date", n2[c] = f2 + "Month", n2[h2] = f2 + "FullYear", n2[u2] = f2 + "Hours", n2[s] = f2 + "Minutes", n2[i2] = f2 + "Seconds", n2[r] = f2 + "Milliseconds", n2)[o2], $3 = o2 === a ? this.$D + (e2 - this.$W) : e2;
            if (o2 === c || o2 === h2) {
              var y3 = this.clone().set(d, 1);
              y3.$d[l2]($3), y3.init(), this.$d = y3.set(d, Math.min(this.$D, y3.daysInMonth())).$d;
            } else l2 && this.$d[l2]($3);
            return this.init(), this;
          }, m2.set = function(t2, e2) {
            return this.clone().$set(t2, e2);
          }, m2.get = function(t2) {
            return this[b2.p(t2)]();
          }, m2.add = function(r2, f2) {
            var d2, l2 = this;
            r2 = Number(r2);
            var $3 = b2.p(f2), y3 = function(t2) {
              var e2 = O(l2);
              return b2.w(e2.date(e2.date() + Math.round(t2 * r2)), l2);
            };
            if ($3 === c) return this.set(c, this.$M + r2);
            if ($3 === h2) return this.set(h2, this.$y + r2);
            if ($3 === a) return y3(1);
            if ($3 === o) return y3(7);
            var M4 = (d2 = {}, d2[s] = e, d2[u2] = n, d2[i2] = t, d2)[$3] || 1, m3 = this.$d.getTime() + r2 * M4;
            return b2.w(m3, this);
          }, m2.subtract = function(t2, e2) {
            return this.add(-1 * t2, e2);
          }, m2.format = function(t2) {
            var e2 = this, n2 = this.$locale();
            if (!this.isValid()) return n2.invalidDate || l;
            var r2 = t2 || "YYYY-MM-DDTHH:mm:ssZ", i3 = b2.z(this), s2 = this.$H, u3 = this.$m, a2 = this.$M, o2 = n2.weekdays, c2 = n2.months, f2 = n2.meridiem, h3 = function(t3, n3, i4, s3) {
              return t3 && (t3[n3] || t3(e2, r2)) || i4[n3].slice(0, s3);
            }, d2 = function(t3) {
              return b2.s(s2 % 12 || 12, t3, "0");
            }, $3 = f2 || function(t3, e3, n3) {
              var r3 = t3 < 12 ? "AM" : "PM";
              return n3 ? r3.toLowerCase() : r3;
            };
            return r2.replace(y2, (function(t3, r3) {
              return r3 || (function(t4) {
                switch (t4) {
                  case "YY":
                    return String(e2.$y).slice(-2);
                  case "YYYY":
                    return b2.s(e2.$y, 4, "0");
                  case "M":
                    return a2 + 1;
                  case "MM":
                    return b2.s(a2 + 1, 2, "0");
                  case "MMM":
                    return h3(n2.monthsShort, a2, c2, 3);
                  case "MMMM":
                    return h3(c2, a2);
                  case "D":
                    return e2.$D;
                  case "DD":
                    return b2.s(e2.$D, 2, "0");
                  case "d":
                    return String(e2.$W);
                  case "dd":
                    return h3(n2.weekdaysMin, e2.$W, o2, 2);
                  case "ddd":
                    return h3(n2.weekdaysShort, e2.$W, o2, 3);
                  case "dddd":
                    return o2[e2.$W];
                  case "H":
                    return String(s2);
                  case "HH":
                    return b2.s(s2, 2, "0");
                  case "h":
                    return d2(1);
                  case "hh":
                    return d2(2);
                  case "a":
                    return $3(s2, u3, true);
                  case "A":
                    return $3(s2, u3, false);
                  case "m":
                    return String(u3);
                  case "mm":
                    return b2.s(u3, 2, "0");
                  case "s":
                    return String(e2.$s);
                  case "ss":
                    return b2.s(e2.$s, 2, "0");
                  case "SSS":
                    return b2.s(e2.$ms, 3, "0");
                  case "Z":
                    return i3;
                }
                return null;
              })(t3) || i3.replace(":", "");
            }));
          }, m2.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
          }, m2.diff = function(r2, d2, l2) {
            var $3, y3 = this, M4 = b2.p(d2), m3 = O(r2), v2 = (m3.utcOffset() - this.utcOffset()) * e, g2 = this - m3, D3 = function() {
              return b2.m(y3, m3);
            };
            switch (M4) {
              case h2:
                $3 = D3() / 12;
                break;
              case c:
                $3 = D3();
                break;
              case f:
                $3 = D3() / 3;
                break;
              case o:
                $3 = (g2 - v2) / 6048e5;
                break;
              case a:
                $3 = (g2 - v2) / 864e5;
                break;
              case u2:
                $3 = g2 / n;
                break;
              case s:
                $3 = g2 / e;
                break;
              case i2:
                $3 = g2 / t;
                break;
              default:
                $3 = g2;
            }
            return l2 ? $3 : b2.a($3);
          }, m2.daysInMonth = function() {
            return this.endOf(c).$D;
          }, m2.$locale = function() {
            return D2[this.$L];
          }, m2.locale = function(t2, e2) {
            if (!t2) return this.$L;
            var n2 = this.clone(), r2 = w(t2, e2, true);
            return r2 && (n2.$L = r2), n2;
          }, m2.clone = function() {
            return b2.w(this.$d, this);
          }, m2.toDate = function() {
            return new Date(this.valueOf());
          }, m2.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
          }, m2.toISOString = function() {
            return this.$d.toISOString();
          }, m2.toString = function() {
            return this.$d.toUTCString();
          }, M3;
        })(), Y2 = _2.prototype;
        return O.prototype = Y2, [["$ms", r], ["$s", i2], ["$m", s], ["$H", u2], ["$W", a], ["$M", c], ["$y", h2], ["$D", d]].forEach((function(t2) {
          Y2[t2[1]] = function(e2) {
            return this.$g(e2, t2[0], t2[1]);
          };
        })), O.extend = function(t2, e2) {
          return t2.$i || (t2(e2, _2, O), t2.$i = true), O;
        }, O.locale = w, O.isDayjs = S2, O.unix = function(t2) {
          return O(1e3 * t2);
        }, O.en = D2[g], O.Ls = D2, O.p = {}, O;
      }));
    }
  });

  // node_modules/dayjs/plugin/isBetween.js
  var require_isBetween = __commonJS({
    "node_modules/dayjs/plugin/isBetween.js"(exports, module) {
      !(function(e, i2) {
        "object" == typeof exports && "undefined" != typeof module ? module.exports = i2() : "function" == typeof define && define.amd ? define(i2) : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_isBetween = i2();
      })(exports, (function() {
        "use strict";
        return function(e, i2, t) {
          i2.prototype.isBetween = function(e2, i3, s, f) {
            var n = t(e2), o = t(i3), r = "(" === (f = f || "()")[0], u2 = ")" === f[1];
            return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u2 ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u2 ? this.isAfter(o, s) : !this.isBefore(o, s));
          };
        };
      }));
    }
  });

  // src/vue/components/render/recent-view-product.vue
  var recent_view_product_exports = {};
  __export(recent_view_product_exports, {
    default: () => recent_view_product_default,
    render: () => render55
  });
  function render55(_ctx, _cache) {
    const _component_RecentProduct = resolveComponent("RecentProduct");
    return openBlock(), createBlock(_component_RecentProduct, { products: _ctx.products }, null, 8, ["products"]);
  }
  var import_dayjs, import_isBetween, __default__48, recent_view_product_default;
  var init_recent_view_product = __esm({
    "src/vue/components/render/recent-view-product.vue"() {
      "use strict";
      import_dayjs = __toESM(require_dayjs_min());
      import_isBetween = __toESM(require_isBetween());
      init_vue_esm_bundler();
      init_recent_product();
      init_vue_esm_bundler();
      import_dayjs.default.extend(import_isBetween.default);
      __default__48 = {
        components: {
          RecentProduct: recent_product_default
        },
        props: {
          startdate: {
            type: String,
            default: null
          },
          enddate: {
            type: String,
            default: null
          },
          compare: {
            type: String,
            default: null
          },
          sku: {
            type: String,
            default: null
          },
          price: {
            type: String,
            required: true
          },
          href: {
            type: String,
            required: true
          },
          image: {
            type: String,
            required: true
          },
          images: {
            type: [Object, Boolean],
            default: false
          }
        },
        setup(props) {
          const { compare, sku, href, price, image, images, startdate, enddate } = toRefs(props);
          const products = ref([]);
          const today = (0, import_dayjs.default)();
          const product = {
            id: window.productJSON.id,
            title: window.productJSON.title,
            image: image.value,
            images: images.value,
            href: href.value,
            sku: sku.value,
            price: price.value,
            compare_at_price: compare.value,
            startdate: startdate.value,
            enddate: enddate.value,
            badge: today.isBetween(startdate.value, enddate.value)
          };
          products.value = JSON.parse(localStorage.getItem("recent-view-products")) || [];
          const data = [...products.value];
          const setProducts = async () => {
            data.unshift(product);
            const recentView = [
              ...new Map(data.map((item) => [item["id"], item])).values()
            ].slice(0, 4);
            localStorage.setItem("recent-view-products", JSON.stringify(recentView));
          };
          setProducts();
          return {
            products
          };
        }
      };
      __default__48.render = render55;
      recent_view_product_default = __default__48;
    }
  });

  // src/vue/components/render/related-product.vue
  var related_product_exports = {};
  __export(related_product_exports, {
    default: () => related_product_default,
    render: () => render56
  });
  function render56(_ctx, _cache) {
    const _component_RecentProduct = resolveComponent("RecentProduct");
    return openBlock(), createElementBlock("div", _hoisted_190, [
      createCommentVNode(" eslint-disable vue/no-v-html "),
      createVNode(_component_RecentProduct, {
        products: _ctx.products,
        title: "Similar Items"
      }, null, 8, ["products"])
    ]);
  }
  var import_lodash12, __default__49, _hoisted_190, related_product_default;
  var init_related_product = __esm({
    "src/vue/components/render/related-product.vue"() {
      "use strict";
      init_recent_product();
      import_lodash12 = __toESM(require_lodash());
      init_vue_esm_bundler();
      init_vue_esm_bundler();
      __default__49 = {
        components: {
          RecentProduct: recent_product_default
        },
        props: {
          id: {
            type: Number,
            required: true
          },
          handle: {
            type: String,
            required: true
          }
        },
        setup(props) {
          const { id, handle } = toRefs(props);
          const products = ref(null);
          return {
            pid: id.value,
            products,
            productHandle: handle.value
          };
        },
        async created() {
          const recommendationUrls = [
            `${window.Shopify.routes.root}recommendations/products.json?product_id=${this.pid}&limit=4&intent=complementary`,
            `${window.Shopify.routes.root}recommendations/products.json?product_id=${this.pid}&limit=4&intent=related`,
            `${window.Shopify.routes.root}collections/${this.productHandle}/?view=related-product`
          ];
          const fetchRecommendations = async (url) => {
            try {
              const response = await fetch(url);
              if (!response.ok) {
                throw new Error("Network response was not ok");
              }
              return response.json();
            } catch (error) {
              console.error("Error fetching recommendations:", error);
              throw error;
            }
          };
          const init = () => {
            window.jQuery(`.product-recommendations .js-video-button`).modalVideo();
            window.theme.quickview.reinit();
          };
          const refetch = async (data2) => {
            const fetchPromises = data2.products.map(async (product) => {
              const id = product?.id;
              const url = product?.url?.split("?")[0];
              const response = await fetch(`${url}?view=related`);
              const productData = await response.json();
              const updatedProduct = {
                ...data2.products.find((product2) => product2.id === id),
                ...productData
              };
              return updatedProduct;
            });
            const updatedProducts = await Promise.all(fetchPromises);
            this.products = (0, import_lodash12.shuffle)(updatedProducts);
            init();
          };
          const data = await fetchRecommendations(recommendationUrls[0]);
          if (data.products.length) {
            refetch(data);
          } else {
            const data2 = await fetchRecommendations(recommendationUrls[1]);
            if (data2.products.length) {
              refetch(data2);
            } else {
              const products = await fetchRecommendations(recommendationUrls[2]);
              const filterProduct = products.filter((p2) => p2.id != this.pid).filter((p2) => p2.title != "configurator");
              const shuffledData = (0, import_lodash12.chain)(filterProduct).shuffle().slice(0, 4).value();
              this.products = shuffledData;
              init();
            }
          }
        }
      };
      _hoisted_190 = { class: "mb-0 related-products" };
      __default__49.render = render56;
      related_product_default = __default__49;
    }
  });

  // vue-style:C:\fork\Baudville\src\vue\components\render\search-modal.vue
  var init_search_modal = __esm({
    "vue-style:C:\\fork\\Baudville\\src\\vue\\components\\render\\search-modal.vue"() {
    }
  });

  // src/vue/components/render/search-modal.vue
  var search_modal_exports = {};
  __export(search_modal_exports, {
    default: () => search_modal_default,
    render: () => render57
  });
  function render57(_ctx, _cache) {
    return _ctx.performSearch ? (openBlock(), createElementBlock("ul", _hoisted_191, [
      _cache[3] || (_cache[3] = createBaseVNode(
        "li",
        { class: "ui-menu-heading" },
        "Search Terms",
        -1
        /* CACHED */
      )),
      (openBlock(true), createElementBlock(
        Fragment,
        null,
        renderList(_ctx.search, (product) => {
          return openBlock(), createElementBlock("li", {
            key: product.id,
            class: "ui-menu-item"
          }, [
            createBaseVNode("div", _hoisted_267, [
              createBaseVNode("a", {
                class: "flex items-center text-gray-100 ui-menu-item-label hover:text-green-50 hover:font-medium",
                href: product.url
              }, [
                product.featured_image ? (openBlock(), createElementBlock("img", {
                  key: 0,
                  width: "64",
                  height: "64",
                  loading: "lazy",
                  src: _ctx.getMediumImg(product.featured_image.url),
                  alt: "",
                  class: "mr-2 ui-menu-item-image"
                }, null, 8, _hoisted_441)) : createCommentVNode("v-if", true),
                createBaseVNode(
                  "span",
                  null,
                  toDisplayString(product.title),
                  1
                  /* TEXT */
                )
              ], 8, _hoisted_349)
            ])
          ]);
        }),
        128
        /* KEYED_FRAGMENT */
      )),
      !_ctx.search.length && _ctx.performSearch ? (openBlock(), createElementBlock("li", _hoisted_531, [..._cache[2] || (_cache[2] = [
        createBaseVNode(
          "div",
          { class: "mb-3 ui-menu-item-wrapper" },
          [
            createBaseVNode("span", { class: "p-2 font-bold ui-menu-item-label" }, "Sorry, No results found.")
          ],
          -1
          /* CACHED */
        )
      ])])) : _ctx.search.length === 1 && _ctx.performSearch ? (openBlock(), createElementBlock("li", _hoisted_625, [
        createBaseVNode("button", {
          role: "button",
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.redirectToProduct(_ctx.search[0].url)),
          class: "ui-menu-button"
        }, " View Product ")
      ])) : (openBlock(), createElementBlock("li", _hoisted_723, [
        createBaseVNode("button", {
          type: "button",
          class: "ui-menu-button",
          onClick: _cache[1] || (_cache[1] = (...args) => _ctx.redirect && _ctx.redirect(...args))
        }, " See all Search Results ")
      ]))
    ])) : createCommentVNode("v-if", true);
  }
  var __default__50, _hoisted_191, _hoisted_267, _hoisted_349, _hoisted_441, _hoisted_531, _hoisted_625, _hoisted_723, search_modal_default;
  var init_search_modal2 = __esm({
    "src/vue/components/render/search-modal.vue"() {
      "use strict";
      init_vue_esm_bundler();
      init_vue_esm_bundler();
      init_search_modal();
      __default__50 = {
        props: {
          result: {
            type: String,
            default: null
          }
        },
        emits: ["getresult"],
        setup(props, { emit: emit2 }) {
          const { result } = toRefs(props);
          const search = ref([]);
          const performSearch = ref(false);
          const doSearch = (q2) => {
            if (q2.length <= 1) {
              search.value = [];
              return null;
            }
            fetch(
              window.Shopify.routes.root + `search/suggest.json?q=${q2}&resources[type]=product,collection&resources[options][unavailable_products]=hide&resources[options][fields]=title,body,vendor,tag,product_type,variants.title,variants.sku`
            ).then((response) => response.json()).then((suggestions) => {
              if (suggestions?.resources?.results?.collections?.length) {
                search.value = suggestions?.resources?.results?.collections;
              }
              if (suggestions?.resources?.results?.products?.length) {
                const products = suggestions?.resources?.results?.products;
                if (products.length) {
                  search.value = products.filter(
                    (product) => product.handle !== "personalization-setup-fee"
                  );
                }
                console.log(search.value);
              }
              if (!suggestions?.resources?.results?.collections?.length && !suggestions?.resources?.results?.products?.length) {
                search.value = [];
              }
              emit2("getresult", search.value);
              performSearch.value = true;
            });
          };
          const redirect = () => {
            window.location = `/search?type=product&q=${result.value}`;
          };
          const redirectToProduct = (url) => {
            if (!url) {
              return null;
            }
            window.location = url;
          };
          const getMediumImg = (img) => {
            return img ?? "http://cdn.shopify.com/s/files/1/0667/4766/2632/files/logo-ce7578bd0a91a33bf70b135020287010d2b54f10bd0dc294837f8cbc5146c0aa.png?v=1675421833";
          };
          watch2(result, () => {
            doSearch(result.value);
          });
          doSearch(result.value);
          return {
            search,
            performSearch,
            getMediumImg,
            redirect,
            redirectToProduct
          };
        }
      };
      _hoisted_191 = {
        key: 0,
        id: "ui-search-modal",
        tabindex: "0",
        class: "!z-50 ui-autocomplete ui-front ui-menu ui-widget ui-widget-content",
        style: { "width": "100%", "top": "40px", "left": "50%", "transform": "translateX(-50%)" }
      };
      _hoisted_267 = { class: "ui-menu-item-wrapper" };
      _hoisted_349 = ["href"];
      _hoisted_441 = ["src"];
      _hoisted_531 = { key: 0 };
      _hoisted_625 = { key: 1 };
      _hoisted_723 = { key: 2 };
      __default__50.render = render57;
      __default__50.__scopeId = "data-v-75a20857";
      search_modal_default = __default__50;
    }
  });

  // src/vue/components/render/upcoming-events.vue
  var upcoming_events_exports = {};
  __export(upcoming_events_exports, {
    default: () => upcoming_events_default,
    render: () => render58
  });
  function render58(_ctx, _cache) {
    return openBlock(), createElementBlock("div", _hoisted_197, [
      createBaseVNode("div", _hoisted_268, [
        createBaseVNode("div", _hoisted_350, [
          renderSlot(_ctx.$slots, "default"),
          _ctx.search ? (openBlock(), createElementBlock("div", _hoisted_443, [
            createBaseVNode(
              "form",
              {
                onSubmit: _cache[2] || (_cache[2] = withModifiers((...args) => _ctx.handleSubmit && _ctx.handleSubmit(...args), ["prevent"])),
                class: "border rounded flex px-2 py-[0.35rem] border-gray-500",
                "data-hs-cf-bound": "true"
              },
              [
                withDirectives(createBaseVNode(
                  "input",
                  {
                    onInput: _cache[0] || (_cache[0] = (...args) => _ctx.handleSearch && _ctx.handleSearch(...args)),
                    autocomplete: "off",
                    type: "text",
                    class: "w-full h-8 px-3 rounded focus:outline-none",
                    placeholder: "Search Events...",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.searchQuery = $event)
                  },
                  null,
                  544
                  /* NEED_HYDRATION, NEED_PATCH */
                ), [
                  [vModelText, _ctx.searchQuery]
                ]),
                createBaseVNode("button", {
                  type: "submit",
                  disabled: _ctx.searchQuery < 2
                }, null, 8, _hoisted_533)
              ],
              32
              /* NEED_HYDRATION */
            )
          ])) : createCommentVNode("v-if", true)
        ]),
        createBaseVNode("div", _hoisted_626, [
          (openBlock(true), createElementBlock(
            Fragment,
            null,
            renderList(_ctx.eventsData, (event) => {
              return openBlock(), createElementBlock("div", {
                key: event.id,
                class: "border-b border-b-gray-250 events flex justify-start pb-10 mb-10 w-full"
              }, [
                createBaseVNode("div", _hoisted_724, [
                  createBaseVNode("div", _hoisted_818, [
                    createBaseVNode(
                      "div",
                      _hoisted_915,
                      toDisplayString(event.date.day_name),
                      1
                      /* TEXT */
                    ),
                    createBaseVNode(
                      "div",
                      _hoisted_1015,
                      toDisplayString(event.date.day),
                      1
                      /* TEXT */
                    )
                  ]),
                  createBaseVNode("div", _hoisted_1123, [
                    createBaseVNode(
                      "div",
                      _hoisted_1218,
                      toDisplayString(event.date.range),
                      1
                      /* TEXT */
                    ),
                    createBaseVNode(
                      "h2",
                      _hoisted_1316,
                      toDisplayString(event.name),
                      1
                      /* TEXT */
                    ),
                    event.description ? (openBlock(), createElementBlock(
                      "div",
                      _hoisted_1414,
                      toDisplayString(event.description),
                      1
                      /* TEXT */
                    )) : createCommentVNode("v-if", true),
                    event.link ? (openBlock(), createElementBlock("a", {
                      key: 1,
                      href: event.link,
                      class: "event-btn font-mont text-base text-red-400 underline"
                    }, "Learn More", 8, _hoisted_1513)) : createCommentVNode("v-if", true)
                  ])
                ])
              ]);
            }),
            128
            /* KEYED_FRAGMENT */
          )),
          _ctx.eventsData.length === 0 ? (openBlock(), createElementBlock("div", _hoisted_1612, [..._cache[4] || (_cache[4] = [
            createBaseVNode(
              "h2",
              { class: "event-title font-mont font-normal text-base lg:text-lg tracking-widest" },
              " Sorry, no event found. ",
              -1
              /* CACHED */
            )
          ])])) : createCommentVNode("v-if", true)
        ]),
        _ctx.events.next_page_url ? (openBlock(), createElementBlock("div", _hoisted_1711, [
          createBaseVNode("button", {
            class: "font-mont font-base underline text-red-400",
            onClick: _cache[3] || (_cache[3] = ($event) => _ctx.nextEvent())
          }, " View More Events ")
        ])) : createCommentVNode("v-if", true)
      ])
    ]);
  }
  var import_lodash13, __default__51, _hoisted_197, _hoisted_268, _hoisted_350, _hoisted_443, _hoisted_533, _hoisted_626, _hoisted_724, _hoisted_818, _hoisted_915, _hoisted_1015, _hoisted_1123, _hoisted_1218, _hoisted_1316, _hoisted_1414, _hoisted_1513, _hoisted_1612, _hoisted_1711, upcoming_events_default;
  var init_upcoming_events = __esm({
    "src/vue/components/render/upcoming-events.vue"() {
      "use strict";
      import_lodash13 = __toESM(require_lodash());
      init_vue_esm_bundler();
      init_vue_esm_bundler();
      __default__51 = {
        props: {
          search: {
            type: Boolean,
            default: true
          }
        },
        setup() {
          const url = "https://jot.baudville.com/api/events";
          const events = ref([]);
          const eventsData = ref([]);
          const searchQuery = ref("");
          const getEvents = (url2, search = false) => {
            fetch(url2).then((res) => res.json()).then((data) => {
              console.log(data.events);
              events.value = data.events;
              if (data.events.data.length) {
                if (search) {
                  eventsData.value = [];
                }
                eventsData.value = [...eventsData.value, ...data.events.data];
              }
            }).catch((err) => console.error(err));
          };
          const nextEvent = () => {
            getEvents(events.value.next_page_url);
          };
          const debounceHandleSearch = (0, import_lodash13.debounce)(() => {
            const query = new URLSearchParams();
            query.append("search", searchQuery.value);
            const searchURL = `${url}?${query.toString()}`;
            console.log(searchQuery.value);
            getEvents(searchURL, true);
          }, 150);
          const handleSearch = () => {
            if (searchQuery.value.length > 1) {
              debounceHandleSearch();
            }
          };
          const handleSubmit = () => {
            console.log("submit");
            if (searchQuery.value.length > 1) {
              debounceHandleSearch();
            }
          };
          onMounted(() => {
            getEvents(url);
          });
          return {
            events,
            eventsData,
            searchQuery,
            nextEvent,
            handleSearch,
            handleSubmit
          };
        }
      };
      _hoisted_197 = { class: "bg-bv-light-gray py-16" };
      _hoisted_268 = { class: "container" };
      _hoisted_350 = { class: "flex flex-col items-center justify-center mb-12 text-center" };
      _hoisted_443 = {
        key: 0,
        class: "bg-white mt-6 sm:w-[483px] w-full"
      };
      _hoisted_533 = ["disabled"];
      _hoisted_626 = { class: "flex flex-col justify-center mt-10 w-full lg:mx-auto lg:max-w-screen-lg" };
      _hoisted_724 = { class: "flex gap-4 md:gap-10 single-event w-full" };
      _hoisted_818 = { class: "bg-red-1000 event-date flex flex-col font-mont items-center justify-evenly px-3 py-2 text-xl text-white tracking-wider uppercase w-48 h-48" };
      _hoisted_915 = { class: "day-name min-w-[160px] lg:min-w-fit font-bold capitalize tracking-wider text-2xl text-center" };
      _hoisted_1015 = { class: "day-date font-bold text-6xl tracking-widest" };
      _hoisted_1123 = { class: "event-details" };
      _hoisted_1218 = { class: "event-full-date font-mont font-bold primary-color text-xs lg:text-base tracking-widest" };
      _hoisted_1316 = { class: "event-title font-mont font-bold text-base lg:text-2xl tracking-widest" };
      _hoisted_1414 = {
        key: 0,
        class: "event-description font-mont text-sm lg:text-base"
      };
      _hoisted_1513 = ["href"];
      _hoisted_1612 = {
        key: 0,
        class: "border-b border-b-gray-250 events flex justify-center pb-10 mb-10 w-full"
      };
      _hoisted_1711 = {
        key: 0,
        class: "view-more-event text-center"
      };
      __default__51.render = render58;
      upcoming_events_default = __default__51;
    }
  });

  // src/vue/components/renderless/add-cart.vue
  var add_cart_exports = {};
  __export(add_cart_exports, {
    default: () => add_cart_default
  });
  function render59() {
  }
  var __default__52, add_cart_default;
  var init_add_cart = __esm({
    "src/vue/components/renderless/add-cart.vue"() {
      "use strict";
      init_vue_esm_bundler();
      init_addCart();
      init_vuex_esm_bundler();
      __default__52 = {
        setup(_2, { slots }) {
          const store2 = useStore();
          const addToCart = computed2(() => store2.getters.addToCart);
          const addCartBtn = (e) => {
            const { add } = addCart();
            add(e);
          };
          return () => slots.default({
            addCartBtn,
            addToCart: addToCart.value
          });
        }
      };
      __default__52.render = render59;
      add_cart_default = __default__52;
    }
  });

  // src/vue/components/renderless/addresses-switch.vue
  var addresses_switch_exports = {};
  __export(addresses_switch_exports, {
    default: () => addresses_switch_default
  });
  function render60() {
  }
  var __default__53, addresses_switch_default;
  var init_addresses_switch = __esm({
    "src/vue/components/renderless/addresses-switch.vue"() {
      "use strict";
      init_vue_esm_bundler();
      __default__53 = {
        props: {
          addresses: {
            type: Array,
            default: null
          }
        },
        setup(props, { slots }) {
          const addresses = toRef(props, "addresses");
          const visibleForm = ref(false);
          const currentlyEditedAddress = ref(null);
          const showForm = () => visibleForm.value = true;
          const editAddress = (id) => {
            visibleForm.value = true;
            currentlyEditedAddress.value = addresses.value.find((el) => el.id === id);
            scrollFormIntoView();
          };
          const cancelEdit = () => {
            visibleForm.value = false;
            currentlyEditedAddress.value = null;
            scrollFormIntoView();
          };
          const scrollFormIntoView = () => {
            if (window.matchMedia("(max-width: 1023px)").matches) {
              document.querySelector(".address-form").scrollIntoView({ behavior: "smooth" });
            }
          };
          return () => slots.default({
            visibleForm: visibleForm.value,
            currentlyEditedAddress: currentlyEditedAddress.value,
            showForm,
            editAddress,
            cancelEdit
          });
        }
      };
      __default__53.render = render60;
      addresses_switch_default = __default__53;
    }
  });

  // src/vue/components/renderless/facets-filter.vue
  var facets_filter_exports = {};
  __export(facets_filter_exports, {
    default: () => facets_filter_default
  });
  function render61() {
  }
  var __default__54, facets_filter_default;
  var init_facets_filter = __esm({
    "src/vue/components/renderless/facets-filter.vue"() {
      "use strict";
      init_vue_esm_bundler();
      __default__54 = {
        props: {
          section: {
            type: String,
            required: true
          }
        },
        setup(props, { slots }) {
          const { section } = toRefs(props);
          const filters = ref([...window.filtersJSON.filters]);
          const enableFilters = ref(window.filtersJSON.enabled_filters);
          const totalProduct = ref(window.filtersJSON.products);
          const activeFilters = reactive({});
          const openDrawer = ref(false);
          const selectedFilters = ref({});
          const handleSortBy = ref("manual");
          const filtersData = computed2(() => {
            const allFiltersData = [...filters.value];
            const filtersJSON = [];
            const defaultFilterIndex = allFiltersData.findIndex(
              (filter5) => filter5.name == "Category"
            );
            if (defaultFilterIndex !== -1) {
              filtersJSON.push(allFiltersData[defaultFilterIndex]);
              allFiltersData.splice(defaultFilterIndex, 1);
            }
            if (enableFilters.value.length) {
              enableFilters.value.split(",").map((name) => name.trim()).forEach((name) => {
                const data = allFiltersData.find((filter5) => filter5.name == name);
                if (data && data.values.length) {
                  filtersJSON.push(data);
                }
              });
            } else {
              filtersJSON.push(...allFiltersData);
            }
            return filtersJSON.filter((item) => {
              if (item.name == "Price Range") {
                item.values = item.values.filter((value) => value.count !== "0");
                return item;
              }
              if (item.values.length > 1) {
                const values = item.values.filter((value) => value.count !== "0");
                item.values = values.sort((a, b2) => b2.count - a.count);
              }
              return item;
            }).filter((filter5) => filter5.values.length);
          });
          const searchParams = computed2(
            () => window.Collections.toQueryString(activeFilters, handleSortBy.value)
          );
          const url = computed2(
            () => `${window.location.pathname}?section_id=${section.value}&${searchParams.value}&sort_by=${handleSortBy.value}`
          );
          const refreshFilterData = (url2) => {
            fetch(url2).then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }
              return response.json();
            }).then((response) => {
              window.filtersJSON = response;
              filters.value = [...window.filtersJSON.filters];
              totalProduct.value = window.filtersJSON.products;
            }).finally(() => {
              window.scrollTo({
                top: window.jQuery("#collection-products-container").position().top - window.jQuery("#shopify-section-header").outerHeight(true) - (window.scrollY == 0 ? 136.5 : 0),
                behavior: "smooth"
              });
              window.CollectionSidebar.init();
            });
          };
          const handleClick = async (key, value) => {
            if (key in activeFilters) {
              const index = activeFilters[key].indexOf(value);
              if (index !== -1) {
                activeFilters[key].splice(index, 1);
                if (!activeFilters[key].length) {
                  delete activeFilters[key];
                }
              } else {
                activeFilters[key].push(value);
              }
            } else {
              activeFilters[key] = [value];
            }
            await window.Collections.fetchData(url.value, searchParams.value);
            refreshFilterData(
              `${window.location.pathname}?${searchParams.value}&view=filter`
            );
            if (openDrawer.value) {
              openDrawer.value = false;
            }
            window.jQuery(".mobile-category-filter details[open]").removeAttr("open");
          };
          const handleRemove = (filter5, key) => {
            const newKey = "filter.p.m.bv_filter." + key.split(":")[0];
            handleClick(newKey, filter5);
          };
          const handleClearAll = async () => {
            console.log("remove all");
            for (const key in activeFilters) {
              delete activeFilters[key];
            }
            handleSortBy.value = "manual";
            await window.Collections.fetchData(url.value, searchParams.value);
            refreshFilterData(`${window.location.pathname}?view=filter`);
          };
          const sortBy = ($event) => {
            console.log("sortby");
            console.log($event.target.value);
            handleSortBy.value = $event.target.value;
            window.Collections.fetchData(url.value, searchParams.value);
          };
          const handleDrawer = (val) => {
            openDrawer.value = val;
          };
          watch2(activeFilters, (values) => {
            selectedFilters.value = {};
            for (const key in values) {
              values[key].forEach((value) => {
                const label = document.querySelector(`[value="${value}"]`)?.dataset.label;
                const newKey = key.split(".").pop() + ": " + label;
                selectedFilters.value[newKey] = value;
              });
            }
          });
          watch2(openDrawer, (val) => {
            if (val) {
              document.body.classList.add("body-scroll--disabled");
            } else {
              document.body.classList.remove("body-scroll--disabled");
            }
          });
          onMounted(() => {
            const name = ["sort_by"];
            filtersData.value.forEach((filter5) => {
              name.push(filter5.filter_param_name);
            });
            const url2 = new URL(window.location.href);
            const searchParams2 = url2.searchParams;
            if (searchParams2.size) {
              searchParams2.forEach((value, key) => {
                if (!name.includes(key)) {
                  return;
                }
                if (key === "sort_by") {
                  handleSortBy.value = value;
                } else {
                  if (key in activeFilters) {
                    activeFilters[key].push(value);
                  } else {
                    activeFilters[key] = [value];
                  }
                }
              });
            }
          });
          return () => slots.default({
            filters: filtersData.value,
            selected: selectedFilters.value,
            count: totalProduct.value,
            sorted: handleSortBy.value,
            handleClick,
            handleRemove,
            handleClearAll,
            sortBy
          });
        }
      };
      __default__54.render = render61;
      facets_filter_default = __default__54;
    }
  });

  // src/vue/components/renderless/featured-blog.vue
  var featured_blog_exports = {};
  __export(featured_blog_exports, {
    default: () => featured_blog_default
  });
  function render62() {
  }
  var __default__55, featured_blog_default;
  var init_featured_blog = __esm({
    "src/vue/components/renderless/featured-blog.vue"() {
      "use strict";
      init_vue_esm_bundler();
      __default__55 = {
        setup(_2, { slots }) {
          const posts = ref(null);
          const slider = () => {
            setTimeout(() => {
              const imageSlider = new window.Swiper(".blog-swiper", {
                loop: true,
                autoHeight: true,
                spaceBetween: 0,
                slidesPerView: 1,
                navigation: {
                  nextEl: ".blog-swiper-container .swiper-button-next",
                  prevEl: ".blog-swiper-container .swiper-button-prev"
                },
                breakpoints: {
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 24
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 24
                  }
                }
              });
            }, 500);
          };
          onMounted(() => {
            if (window.Cookies.get("featured-blog")) {
              posts.value = JSON.parse(window.Cookies.get("featured-blog"));
              slider();
            } else {
              fetch("https://ideas.baudville.com/wp-json/gff/v1/last-3-posts").then((response) => response.json()).then((json) => {
                posts.value = json;
                const in30Minutes = 1 / 48;
                window.Cookies.set("featured-blog", JSON.stringify(json), {
                  expires: in30Minutes
                });
                slider();
              });
            }
          });
          return () => slots.default({
            posts: posts.value
          });
        }
      };
      __default__55.render = render62;
      featured_blog_default = __default__55;
    }
  });

  // src/vue/components/renderless/header-cart.vue
  var header_cart_exports = {};
  __export(header_cart_exports, {
    default: () => header_cart_default
  });
  function render63() {
  }
  var __default__56, header_cart_default;
  var init_header_cart = __esm({
    "src/vue/components/renderless/header-cart.vue"() {
      "use strict";
      init_vuex_esm_bundler();
      init_vue_esm_bundler();
      __default__56 = {
        setup(props, { slots }) {
          const store2 = useStore();
          const count = computed2(() => store2.getters.count);
          const open = () => {
            if (window.location.pathname === "/cart") {
              window.location.reload();
            } else {
              document.body.classList.add("body-scroll--disabled");
              store2.dispatch("saveCartDrawer", true);
            }
          };
          return () => slots.default({
            count: count.value,
            open
          });
        }
      };
      __default__56.render = render63;
      header_cart_default = __default__56;
    }
  });

  // src/vue/components/renderless/header-search.vue
  var header_search_exports = {};
  __export(header_search_exports, {
    default: () => header_search_default
  });
  function render64() {
  }
  var import_lodash14, __default__57, header_search_default;
  var init_header_search = __esm({
    "src/vue/components/renderless/header-search.vue"() {
      "use strict";
      import_lodash14 = __toESM(require_lodash());
      init_vue_esm_bundler();
      __default__57 = {
        setup(_2, { slots }) {
          const result = ref("");
          const resultFound = ref([]);
          const focused = ref(false);
          const onFocus = (e) => {
            focused.value = true;
            result.value = e.target.value;
          };
          const onBlur = () => {
            focused.value = false;
          };
          const query = (0, import_lodash14.debounce)((e) => {
            result.value = e.target.value;
          }, 250);
          const getresult = (e) => {
            resultFound.value = e;
          };
          const searchForm = (e) => {
            if (resultFound.value.length === 1) {
              window.location = resultFound.value[0].url;
            }
            if (resultFound.value.length > 1) {
              window.jQuery(e.target).submit();
            }
          };
          const close = () => {
            window.jQuery(".mh-header-block").show();
            window.jQuery(".mh-search-block").hide();
            focused.value = false;
            result.value = "";
          };
          document.addEventListener("search:focus", () => {
            focused.value = true;
          });
          return () => slots.default({
            query,
            focused: focused.value,
            onFocus,
            onBlur,
            result: result.value,
            getresult,
            searchForm,
            close
          });
        }
      };
      __default__57.render = render64;
      header_search_default = __default__57;
    }
  });

  // src/vue/components/renderless/product-variant-selector.vue
  var product_variant_selector_exports = {};
  __export(product_variant_selector_exports, {
    default: () => product_variant_selector_default
  });
  function render65() {
  }
  var __default__58, product_variant_selector_default;
  var init_product_variant_selector = __esm({
    "src/vue/components/renderless/product-variant-selector.vue"() {
      "use strict";
      init_vue_esm_bundler();
      __default__58 = {
        setup(_2, { slots }) {
          const currentVariant = ref(window.currentVariantJSON);
          const productOptions = ref(window.productOptionsJSON);
          const productVariants = ref(window.productVariantsJSON);
          const selectedVariant = ref(null);
          const selectOption = ({ name }, $event) => {
            const selectedValue = $event.target.value;
            const selectedOption = productOptions.value.find(
              (option) => option.name === name
            );
            const currentOptions2 = selectedVariant.value.options;
            const targetOptions = currentOptions2.map(
              (opt) => selectedOption.values.includes(opt) ? selectedValue : opt
            );
            const matchedVariant = productVariants.value.find(
              (variant) => variant.options.every((option) => targetOptions.includes(option))
            );
            if (matchedVariant && matchedVariant.id) {
              selectedVariant.value = matchedVariant;
              goToVariant(matchedVariant.id);
            } else {
              console.log("No matching variant found");
            }
          };
          const goToVariant = function(value) {
            const url = new URL(window.location);
            url.searchParams.set("variant", value);
            if (document.body.classList.contains("personalized-card")) {
              localStorage.setItem(
                "personalized-message",
                document.querySelector("#mainpersonalMessage").value
              );
            }
            window.location = url;
          };
          onMounted(() => {
            document.addEventListener("DOMContentLoaded", () => {
              setTimeout(() => {
                currentVariant.value = window.currentVariantJSON;
                productOptions.value = window.productOptionsJSON;
                productVariants.value = window.productVariantsJSON;
                selectedVariant.value = currentVariant.value;
              }, 300);
            });
          });
          return () => slots.default({
            selectedVariant: selectedVariant.value,
            selectOption
          });
        }
      };
      __default__58.render = render65;
      product_variant_selector_default = __default__58;
    }
  });

  // src/vue/components/renderless/template-switch.vue
  var template_switch_exports = {};
  __export(template_switch_exports, {
    default: () => template_switch_default
  });
  function render66() {
  }
  var __default__59, template_switch_default;
  var init_template_switch = __esm({
    "src/vue/components/renderless/template-switch.vue"() {
      "use strict";
      init_vue_esm_bundler();
      __default__59 = {
        props: {
          initial: {
            type: String,
            required: true,
            default: "login"
          }
        },
        setup(props, { slots }) {
          const initial = toRef(props, "initial");
          const active = ref(initial.value);
          const show = (payload) => active.value = payload;
          const passwordVisible = ref(false);
          const showPassword = () => {
            passwordVisible.value = true;
            document.querySelector("#password").type = "text";
          };
          const hidePassword = () => {
            passwordVisible.value = false;
            document.querySelector("#password").type = "password";
          };
          onMounted(() => {
            console.log(active.value);
            console.log(window.location.hash);
            if (window.location.hash) {
              active.value = "forgot-password";
            }
          });
          return () => slots.default({
            active: active.value,
            passwordVisible,
            showPassword,
            hidePassword,
            show
          });
        }
      };
      __default__59.render = render66;
      template_switch_default = __default__59;
    }
  });

  // src/vue/mixins/global.append-parameter.js
  var global_append_parameter_exports = {};
  __export(global_append_parameter_exports, {
    default: () => global_append_parameter_default
  });
  var global_append_parameter_default;
  var init_global_append_parameter = __esm({
    "src/vue/mixins/global.append-parameter.js"() {
      "use strict";
      global_append_parameter_default = {
        methods: {
          appendParameter({ parameter }, $event) {
            const url = new URL(window.location);
            url.searchParams.set(parameter, $event.target.value);
            window.location = url;
          }
        }
      };
    }
  });

  // src/vue/mixins/global.submit.js
  var global_submit_exports = {};
  __export(global_submit_exports, {
    default: () => global_submit_default
  });
  var global_submit_default;
  var init_global_submit = __esm({
    "src/vue/mixins/global.submit.js"() {
      "use strict";
      global_submit_default = {
        methods: {
          submit(event) {
            event.target.form.submit();
          }
        }
      };
    }
  });

  // src/vue/directives/global.select-option.js
  var global_select_option_exports = {};
  __export(global_select_option_exports, {
    default: () => global_select_option_default
  });
  var global_select_option_default;
  var init_global_select_option = __esm({
    "src/vue/directives/global.select-option.js"() {
      "use strict";
      global_select_option_default = {
        name: "selectOption",
        directive: {
          beforeMount($el, binding) {
            const result = Array.from($el).find((el) => el.text === binding.value);
            if (result) result.selected = true;
          }
        }
      };
    }
  });

  // node_modules/vue-konva/dist/vue-konva.mjs
  init_vue_esm_bundler();
  init_lib();
  function y(o) {
    if (!lib_default.autoDrawEnabled) {
      const n = o.getLayer() || o.getStage();
      n && n.batchDraw();
    }
  }
  var T = { key: true, style: true, elm: true, isRootInsert: true };
  var S = ".vue-konva-event";
  function M(o, n, c, a) {
    const e = o.__konvaNode, l = {};
    let r = false;
    for (let t in c) {
      if (T.hasOwnProperty(t))
        continue;
      const s = t.slice(0, 2) === "on", f = c[t] !== n[t];
      if (s && f) {
        let g = t.slice(2).toLowerCase();
        g.slice(0, 7) === "content" && (g = "content" + g.slice(7, 1).toUpperCase() + g.slice(8)), e?.off(g + S, c[t]);
      }
      !n.hasOwnProperty(t) && e?.setAttr(t, void 0);
    }
    for (let t in n) {
      if (T.hasOwnProperty(t))
        continue;
      let s = t.slice(0, 2) === "on";
      const f = c[t] !== n[t];
      if (s && f) {
        let d = t.slice(2).toLowerCase();
        d.slice(0, 7) === "content" && (d = "content" + d.slice(7, 1).toUpperCase() + d.slice(8)), n[t] && (e?.off(d + S), e?.on(d + S, n[t]));
      }
      !s && (n[t] !== c[t] || a && n[t] !== e?.getAttr(t)) && (r = true, l[t] = n[t]);
    }
    r && e && (e.setAttrs(l), y(e));
  }
  var P = ".vue-konva-vmodel";
  var b = "onUpdate:";
  function _(o, n) {
    o.off(P);
    const c = n.vnode.props || {};
    for (const a in c)
      if (a.startsWith(b)) {
        const e = a.slice(b.length), l = c[a];
        o.on(`${e}Change${P}`, () => {
          l(o.getAttr(e));
        });
      }
  }
  var F = "V";
  function G(o) {
    function n(c) {
      return c?.__konvaNode ? c : c?.parent ? n(c.parent) : (console.error("vue-konva error: Can not find parent node"), null);
    }
    return n(o.parent);
  }
  function R(o) {
    return o.component ? o.component.__konvaNode || R(o.component.subTree) : null;
  }
  function W(o) {
    const { el: n, component: c } = o, a = R(o);
    if (n?.tagName && c && !a) {
      const e = n.tagName.toLowerCase();
      return console.error(
        `vue-konva error: You are trying to render "${e}" inside your component tree. Looks like it is not a Konva node. You can render only Konva components inside the Stage.`
      ), null;
    }
    return a;
  }
  function B(o) {
    const n = (e) => !!e && typeof e == "object" && "component" in e, c = (e) => Array.isArray(e), a = (e) => n(e) ? [e, ...a(e.children)] : c(e) ? e.flatMap(a) : [];
    return a(o.children);
  }
  function I(o, n) {
    const c = B(o), a = [];
    c.forEach((l) => {
      const r = W(l);
      r && a.push(r);
    });
    let e = false;
    a.forEach((l, r) => {
      l.getZIndex() !== r && (l.setZIndex(r), e = true);
    }), e && y(n);
  }
  var D = lib_default.default?.Stage || lib_default.Stage;
  var Y = defineComponent({
    name: "Stage",
    props: {
      config: {
        type: Object,
        default: function() {
          return {};
        }
      },
      __useStrictMode: {
        type: Boolean
      }
    },
    inheritAttrs: false,
    setup(o, { attrs: n, slots: c, expose: a }) {
      const e = getCurrentInstance();
      if (!e) return;
      const l = reactive({}), r = ref(null), t = new D({
        width: o.config.width,
        height: o.config.height,
        container: document.createElement("div")
        // Fake container. Will be replaced
      });
      e.__konvaNode = t, d();
      function s() {
        return e?.__konvaNode;
      }
      function f() {
        return e?.__konvaNode;
      }
      function d() {
        if (!e) return;
        const g = l || {}, m = {
          ...n,
          ...o.config
        };
        M(e, m, g, o.__useStrictMode), Object.assign(l, m);
      }
      return onMounted(() => {
        r.value && t.container(r.value), d(), _(t, e);
      }), onUpdated(() => {
        d(), I(e.subTree, t), _(t, e);
      }), onBeforeUnmount(() => {
        t.destroy();
      }), watch2(() => o.config, d, { deep: true }), a({
        getStage: f,
        getNode: s
      }), () => h(
        "div",
        {
          ref: r,
          id: n?.id,
          accesskey: n?.accesskey,
          class: n?.class,
          role: n?.role,
          style: n?.style,
          tabindex: n?.tabindex,
          title: n?.title
        },
        c.default?.()
      );
    }
  });
  var Z = ".vue-konva-event";
  var z = {
    Group: true,
    Layer: true,
    FastLayer: true,
    Label: true
  };
  function i(o, n) {
    return defineComponent({
      name: o,
      props: {
        config: {
          type: Object,
          default: function() {
            return {};
          }
        },
        __useStrictMode: {
          type: Boolean
        }
      },
      setup(c, { attrs: a, slots: e, expose: l }) {
        const r = getCurrentInstance();
        if (!r) return;
        const t = reactive({}), s = new n();
        r.__konvaNode = s, r.vnode.__konvaNode = s, g();
        function f() {
          return r?.__konvaNode;
        }
        function d() {
          return r?.__konvaNode;
        }
        function g() {
          if (!r) return;
          const v = {};
          for (const h2 in r?.vnode.props)
            h2.slice(0, 2) === "on" && (v[h2] = r.vnode.props[h2]);
          const K = t || {}, E = {
            ...a,
            ...c.config,
            ...v
          };
          M(r, E, K, c.__useStrictMode), Object.assign(t, E);
        }
        onMounted(() => {
          const v = G(r)?.__konvaNode;
          v && "add" in v && v.add(s), y(s), _(s, r);
        }), onUnmounted(() => {
          y(s), s.destroy(), s.off(Z), s.off(P);
        }), onUpdated(() => {
          g(), I(r.subTree, s), _(s, r);
        }), watch2(() => c.config, g, { deep: true }), l({
          getStage: d,
          getNode: f
        });
        const m = z.hasOwnProperty(o);
        return () => m ? e.default?.() : null;
      }
    });
  }
  var u = lib_default.default || lib_default;
  var X = i("Arc", u.Arc);
  var q = i("Arrow", u.Arrow);
  var H = i("Circle", u.Circle);
  var J = i("Ellipse", u.Ellipse);
  var Q = i("FastLayer", u.FastLayer);
  var ee = i("Group", u.Group);
  var ne = i("Image", u.Image);
  var te = i("Label", u.Label);
  var oe = i("Layer", u.Layer);
  var re = i("Line", u.Line);
  var ce = i("Path", u.Path);
  var ae = i("Rect", u.Rect);
  var se = i("RegularPolygon", u.RegularPolygon);
  var ie = i("Ring", u.Ring);
  var ue = i("Shape", u.Shape);
  var le = i("Sprite", u.Sprite);
  var de = i("Star", u.Star);
  var fe = i("Tag", u.Tag);
  var ge = i("Text", u.Text);
  var ve = i("TextPath", u.TextPath);
  var pe = i("Transformer", u.Transformer);
  var me = i("Wedge", u.Wedge);
  var ye = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    Arc: X,
    Arrow: q,
    Circle: H,
    Ellipse: J,
    FastLayer: Q,
    Group: ee,
    Image: ne,
    Label: te,
    Layer: oe,
    Line: re,
    Path: ce,
    Rect: ae,
    RegularPolygon: se,
    Ring: ie,
    Shape: ue,
    Sprite: le,
    Star: de,
    Tag: fe,
    Text: ge,
    TextPath: ve,
    Transformer: pe,
    Wedge: me
  }, Symbol.toStringTag, { value: "Module" }));
  var Se = {
    install: (o, n) => {
      const c = n?.prefix || F, a = n?.customNodes ? Object.entries(n.customNodes).map(
        ([l, r]) => i(l, r)
      ) : [];
      [
        Y,
        ...Object.values(ye),
        ...a
      ].forEach((l) => {
        o.component(`${c}${l.name}`, l);
      });
    }
  };

  // src/main.js
  init_vue_esm_bundler();
  init_vuex_esm_bundler();

  // src/custom.js
  init_addCart();
  var $ = window.jQuery;
  var Swiper = window.Swiper;
  var footer = {
    init: () => {
      $(".footer-menu-title").on("click", (e) => {
        const target = e.currentTarget;
        $(target).toggleClass("open");
        $(target).siblings("ul").slideToggle();
      });
    },
    unload: () => {
      $(".footer-menu-title").off("click");
    },
    reinit() {
      this.unload();
      this.init();
    }
  };
  var getCustomerId = function() {
    try {
      let curr = window.ShopifyAnalytics.meta.page.customerId;
      if (curr !== void 0 && curr !== null && curr !== "") {
        return curr;
      }
    } catch (e) {
      console.log(e);
    }
    try {
      let curr = window.meta.page.customerId;
      if (curr !== void 0 && curr !== null && curr !== "") {
        return curr;
      }
    } catch (e) {
      console.error(e);
    }
    return null;
  };
  window.theme = window.theme || {};
  window.theme = {
    cartTarget: document.querySelector(".mh-cart-drawer"),
    filterDrawer: document.querySelector(".mh-collection-fillter"),
    infiniteScroll: document.querySelector("#mh-collection"),
    quantityBreak(qty = 1, qb) {
      let found = qb[qb.length - 1];
      let index = 0;
      while (index < qb.length - 1 && !(qty < qb[index + 1]?.min_quantity)) {
        index++;
      }
      if (index < qb.length - 1) {
        found = qb[index];
      }
      let sale = found?.sale;
      if (!sale && found?.clearance > 0) {
        sale = found?.clearance;
      }
      return sale ? qty * sale : qty * found?.regular;
    },
    slider: {
      swiperInstance: null,
      init(loop = true) {
        this.swiperInstance = new Swiper(".product-images-swiper", {
          loop,
          autoHeight: true,
          // autoplay: {
          //   delay: 5000,
          // },
          navigation: {
            nextEl: ".product-images-swiper .swiper-button-next",
            prevEl: ".product-images-swiper .swiper-button-prev"
          }
        });
      },
      destroy() {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      },
      reinit(loop = true) {
        this.destroy();
        this.init(loop);
      },
      slideTo(index) {
        if (this.swiperInstance) {
          this.swiperInstance.slideTo(index);
        }
      }
    },
    modalVideo: {
      init(n) {
        $(
          `.product-summary:nth-child(n + ${n + 1}) .js-video-button`
        ).modalVideo();
      }
    },
    cartDrawer: {
      init() {
        const self2 = this;
        $("#toggleCartDrawer").on("click", function(e) {
          e.preventDefault();
          self2.open();
        });
      },
      open() {
        $(".mh-cart-drawer--right").fadeIn();
        $(".mini-cart__drawer").fadeIn();
        $("#cart-load-icon").fadeOut();
      },
      close() {
        $(".mh-cart-drawer").fadeOut();
        $(".mini-cart__drawer").fadeOut();
        $("#cart-load-icon").fadeIn();
      }
    },
    quickview: {
      init() {
        $(".button--quickview").on("click", function(event) {
          event.preventDefault();
          const vid = $(this).data("data-variant-id");
          const url = $(this).data("url")?.split("?")[0] + "?view=quickview&variant=" + vid;
          window.theme.quickview.open(url);
        });
      },
      open(url) {
        var self2 = this;
        $(".icon-loader").fadeIn();
        window.theme.remodal.open();
        $.ajax({
          url,
          type: "GET",
          dataType: "html",
          beforeSend: function() {
            $(".show-loader .quickview-product").html(null);
          },
          success: function(data) {
            window.jQuery(".show-loader .quickview-product").html($(data));
          },
          error: function(e) {
            console.log(e);
          },
          complete: function() {
            $(".show-loader").toggleClass("opening opened");
            $(".icon-loader").fadeOut();
            self2.thumb();
            self2.add();
            self2.image();
            self2.select();
            window.theme.productGallery.init(
              ".quickview-product .product-gallery"
            );
            window.theme.zoomImage.init($(".show-loader .zoom"));
            history.pushState(null, null, " ");
            window.theme.wishlist.reinit();
          }
        });
      },
      thumb() {
        $(".show-loader .thumb-image").off("click");
        $(".show-loader .thumb-image").on("click", function() {
          const el = $(".show-loader .main-product-image");
          $(this).addClass("pointer-events-none").siblings(".thumb-image").removeClass("pointer-events-none");
          $(el).attr("src", $(this).data("url")).attr("alt", $(this).data("alt")).closest(".zoom").css("background-image", "url(" + $(this).data("zoom") + ")");
        });
      },
      image() {
        var limit = 300;
        var left = 300;
        var title_graphics = $("#ajax-add-cart_title_graphics").val();
        $("#personalMessage").on("keyup", function(e) {
          var val = $(this).val();
          left = limit - val.length;
          $(".text-count").text(left);
          $(".quickview-product .main-product-image").attr(
            "src",
            `https://s7d7.scene7.com/is/image/Baudville/${title_graphics}?&layer=1&$line1=${val}`
          );
        });
        if (localStorage.getItem("personalMessage")) {
          $("#personalMessage").val(localStorage.getItem("personalMessage")).trigger("keyup");
          localStorage.removeItem("personalMessage");
        }
      },
      unload() {
        $(".button--quickview").off("click");
      },
      select() {
        $(".quickview-product #product-select-1").on("change", function() {
          const url = $(this).data("url")?.split("?")[0] + `?view=quickview&variant=${$(this).val()}`;
          $(".show-loader").toggleClass("opening opened");
          if (document.querySelector("#personalMessage")) {
            localStorage.setItem(
              "personalMessage",
              document.querySelector("#personalMessage").value
            );
          }
          window.theme.quickview.open(url);
        });
      },
      add() {
        $("#ajax-add-cart").on("click", function(e) {
          e.preventDefault();
          $(".icon-loader").fadeIn();
          const { add } = addCart();
          add(e);
        });
      },
      reinit() {
        setTimeout(() => {
          this.unload();
          this.init();
        }, 550);
      }
    },
    zoomImage: {
      init($el) {
        $($el).off("mousemove");
        $($el).on("mousemove", function(e) {
          const zoomer = e.currentTarget;
          const offsetX = e.offsetX;
          const offsetY = e.offsetY;
          const x = offsetX / zoomer.offsetWidth * 100;
          const y2 = offsetY / zoomer.offsetHeight * 100;
          zoomer.style.backgroundPosition = x + "% " + y2 + "%";
        });
      }
    },
    wishlist: {
      init() {
        $(".wish-list-form__action").on("click", function(e) {
          e.preventDefault();
          const id = $(this).data("id");
          const customer = getCustomerId();
          if (!customer) {
            alert("Please login first");
            return;
          }
          if ($(this).hasClass("active")) {
            $.ajax({
              method: "POST",
              url: `https://jot.baudville.com/api/wishlist/${customer}/products/${id}/remove`
            }).done(() => {
              $(this).removeClass("active");
            });
            return;
          }
          $.ajax({
            method: "POST",
            url: `https://jot.baudville.com/api/wishlist/${customer}/products/${id}`
          }).done(() => {
            $(this).addClass("active");
          });
        });
        $(".wishlist-remove").on("click", function(e) {
          e.preventDefault();
          if (!confirm("Are you sure?")) {
            return;
          }
          const id = $(this).data("id");
          const customer = getCustomerId();
          if (!customer) {
            alert("Please login first");
            return;
          }
          $.ajax({
            method: "POST",
            url: `https://jot.baudville.com/api/wishlist/${customer}/products/${id}/remove`
          }).done(() => {
            $(this).closest(".product-summary").remove();
            if ($(".product-summary").length === 0) {
              location.reload();
            }
          });
        });
      },
      reinit() {
        $(".wish-list-form__action").off("click");
        $(".wishlist-remove").off("click");
        this.init();
      }
    },
    collectionGallery: {
      init() {
        this.gallery();
      },
      gallery() {
        $(document).on("click", ".mh-arrows_arrow-left", this.left);
        $(document).on("click", ".mh-arrows_arrow-right", this.right);
      },
      left() {
        const target = $(this).data("target");
        const total = parseInt($(target).data("total"), 10);
        const active = parseInt($(target).attr("data-active"), 10);
        const nextActive = (active + total - 1) % total;
        const activeElement = $(target).find(`[data-index='${active}']`);
        const nextActiveElement = $(target).find(`[data-index='${nextActive}']`);
        activeElement.removeClass("active").addClass("hidden");
        nextActiveElement.addClass("active").removeClass("hidden");
        $(target).attr("data-active", nextActive);
      },
      right() {
        const target = $(this).data("target");
        const total = parseInt($(target).data("total"), 10);
        const active = parseInt($(target).attr("data-active"), 10);
        const nextActive = (active + 1) % total;
        const activeElement = $(target).find(`[data-index='${active}']`);
        const nextActiveElement = $(target).find(`[data-index='${nextActive}']`);
        activeElement.removeClass("active").addClass("hidden");
        nextActiveElement.addClass("active").removeClass("hidden");
        $(target).attr("data-active", nextActive);
      },
      unload() {
        $(document).off("click", ".mh-arrows_arrow-left", this.left);
        $(document).off("click", ".mh-arrows_arrow-right", this.right);
      },
      reinit() {
        this.unload();
        setTimeout(() => this.init(), 100);
      }
    },
    productGallery: {
      init(target = ".product-main-template .product-gallery") {
        this.gallery(target);
      },
      gallery(target) {
        const gallery = new window.Swiper(target, {
          loop: false,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          }
        });
        window.theme.zoomImage.init($(".product-gallery-top .zoom"));
        gallery.on("slideChangeTransitionStart", function() {
          $(`.product-thumbs-swiper .thumb-img`).removeClass("thumb-img-active");
          $(`.product-thumbs-swiper .thumb-img-${gallery.activeIndex}`).addClass(
            "thumb-img-active"
          );
        });
        $(`.product-thumbs-swiper .thumb-img`).on("click", function(e) {
          e.preventDefault();
          const index = $(this).data("index");
          gallery.slideTo(index);
        });
      },
      unload(target) {
        if (document.querySelector(target)) {
          const gallery = document.querySelector(target).swiper;
          const thumbs = $(target).closest(".flex").find(".product-thumbs-slider");
          if (gallery) {
            gallery.destroy();
            if (thumbs) {
              $(thumbs).find(`.product-thumbs-swiper .thumb-img`).off("click");
            }
          }
        }
      }
    }
  };
  window.theme.remodal = $("[data-remodal-id=modal]").remodal();
  $(function() {
    footer.init();
    window.theme.slider.init();
    const brandSlider = document.querySelector(".shopify-brand-slider");
    if (brandSlider) {
      new Swiper(".brand-images-swiper", {
        // autoHeight: true,
        speed: 1e3,
        autoplay: {
          delay: 1500,
          disableOnInteraction: false,
          pauseOnMouseEnter: false
        },
        loop: true,
        loopPreventsSliding: false,
        spaceBetween: 30,
        slidesPerView: 2,
        navigation: {
          nextEl: ".brand-slider-container .swiper-button-next",
          prevEl: ".brand-slider-container .swiper-button-prev"
        },
        breakpoints: {
          2e3: {
            slidesPerView: 8,
            spaceBetween: 70
          },
          1500: {
            slidesPerView: 7,
            spaceBetween: 70
          },
          1280: {
            slidesPerView: 6,
            spaceBetween: 70
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 70
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 70,
            speed: 1e3,
            autoplay: {
              delay: 1500,
              disableOnInteraction: false,
              pauseOnMouseEnter: false
            },
            loop: true,
            loopPreventsSliding: false
          }
        }
      });
    }
    const storySlider = document.querySelector(".mh-story-slider");
    if (storySlider) {
      new Swiper(".mh-story-slider", {
        loop: true,
        slidesPerView: 1,
        navigation: {
          nextEl: ".story-slider .swiper-button-next",
          prevEl: ".story-slider .swiper-button-prev"
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            loop: false,
            spaceBetween: 75,
            navigation: false
          },
          1500: {
            slidesPerView: 3,
            loop: false,
            spaceBetween: 150,
            navigation: false
          }
        }
      });
    }
    const productSwiper = new window.Swiper(".featured-product-swiper", {
      loop: true,
      autoHeight: true,
      spaceBetween: 0,
      slidesPerView: 1,
      navigation: {
        nextEl: ".featured-product-container .swiper-button-next",
        prevEl: ".featured-product-container .swiper-button-prev"
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 16
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 16
        }
      }
    });
    const relatedProductSwiper = new window.Swiper(".related-product-swiper", {
      loop: true,
      autoHeight: false,
      spaceBetween: 0,
      slidesPerView: 1,
      navigation: {
        nextEl: ".featured-product-container .swiper-button-next",
        prevEl: ".featured-product-container .swiper-button-prev"
      },
      breakpoints: {
        375: {
          slidesPerView: 2,
          spaceBetween: 10
        },
        600: {
          slidesPerView: 2,
          spaceBetween: 24
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 24
        }
      }
    });
    function scrollTop() {
      const scrollableElement = window.document.scrollingElement || document.documentElement || document.body;
      if ("scrollBehavior" in document.documentElement.style) {
        scrollableElement.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        });
      } else {
        scrollableElement.scrollTop = 0;
      }
    }
    if ($("#back-to-top-button")) {
      $("#back-to-top-button").on("click", function(e) {
        e.preventDefault();
        scrollTop();
      });
    }
    window.theme.collectionGallery.reinit();
    window.theme.productGallery.init();
    if (typeof Fancybox !== "undefined") {
      Fancybox.bind("[data-fancybox]", {
        // Your custom options
      });
    }
    window.theme.quickview.init();
    window.theme.wishlist.init();
    if ($("body").hasClass("personalized-card")) {
      var limit = 300;
      var left = 300;
      var title_graphics = $("#_title_graphics").val();
      $(".product-main-template #mainpersonalMessage").on("keyup", function(e) {
        var val = $(this).val();
        left = limit - val.length;
        $(".text-count").text(left);
        $(".product-main-template .main-product-image").attr(
          "src",
          `https://s7d7.scene7.com/is/image/Baudville/${title_graphics}?&layer=1&$line1=${val}`
        );
      });
      if (localStorage.getItem("personalized-message")) {
        $(".product-main-template #mainpersonalMessage").val(localStorage.getItem("personalized-message")).trigger("keyup");
        localStorage.removeItem("personalized-message");
      }
    }
    $(`.js-video-button`).modalVideo();
    $(document).on("closed", ".remodal", function() {
      $("#ajax-add-cart").off("click");
      $(".icon-loader").fadeOut();
      history.pushState(null, null, " ");
      window.theme.productGallery.unload(".quickview-product .product-gallery");
      window.jQuery(".show-loader").removeClass("opened").addClass("opening").find(".quickview-product").html(null);
    });
    $(".accordion-content-block").on("click", function() {
      $(this).find(".accordion-content-block__content").toggleClass("accordion-content-block__content--active");
    });
    $(".footer-menu h3:not(.dropdown-none)").on("click", function() {
      $(this).toggleClass("active").siblings("ul").slideToggle();
    });
    $(".mobile-nav__children-link").on("click", function(e) {
      e.preventDefault();
      var target = $(this).data("mobile-nav-button");
      $(target).removeClass("hidden");
      $(".mobile-nav").addClass("hidden");
    });
    $(".mobile-nav__back-button").on("click", function(e) {
      e.preventDefault();
      var target = $(this).data("mobile-nav-button");
      $(target).addClass("hidden");
      $(".mobile-nav").removeClass("hidden");
    });
    $("#mobile-menu-icon").on("click", function(e) {
      e.preventDefault();
      $(".mh-header-menu").fadeIn();
      $(".mh-header-menu .mini-cart__drawer").fadeIn();
    });
    $(".mh-header-menu .mini-cart__action-button").on("click", function(e) {
      e.preventDefault();
      $(".mh-header-menu").fadeOut();
      $(".mh-header-menu .mini-cart__drawer").fadeOut();
    });
    $(".mh-icon-search").on("click", function(e) {
      e.preventDefault();
      $(".mh-header-block").hide();
      $(".mh-search-block").show();
    });
    $(".moreless-button").click(function() {
      $("#main_description").toggleClass("description-line-clamp");
      $(".moretext").slideToggle();
      if ($(".moreless-button").text() == "Read more >") {
        $(this).text("Read less");
      } else {
        $(this).text("Read more >");
      }
    });
    $(".inner-scroll").on("click", function(e) {
      e.preventDefault();
      const targetId = $(this).attr("href");
      const targetElement = $(targetId);
      if (targetElement.length) {
        const headerHeight = $("#shopify-section-header").outerHeight();
        const targetOffset = targetElement.offset().top - headerHeight;
        $("html, body").animate(
          {
            scrollTop: targetOffset
          },
          250
        );
      }
    });
  });
  if (window.Shopify.designMode) {
    const reinit = () => {
      window.theme.remodal.close();
      window.theme.quickview.reinit();
      window.theme.wishlist.reinit();
      window.theme.collectionGallery.reinit();
    };
    addEventListener("main-slider", (e) => {
      if (e.detail.name == "main-slider") {
        window.theme.slider.reinit(false);
      }
      if (e.detail.name == "slide-to") {
        window.theme.slider.slideTo(parseInt(e.detail.index));
      }
    });
    addEventListener("tabs-event", (e) => {
      if (e.detail.name == "featured-collections-tab") {
        reinit();
        window.theme.Tabs.reinit();
      }
      if (e.detail.name == "featured-product") {
        reinit();
      }
    });
  }

  // src/main.js
  var __requireContext_0 = (() => {
    const map3 = {
      "./cart.js": () => (init_cart(), __toCommonJS(cart_exports)),
      "./mobile-menu.js": () => (init_mobile_menu(), __toCommonJS(mobile_menu_exports)),
      "./stores.js": () => (init_stores(), __toCommonJS(stores_exports))
    };
    const context = (key) => map3[key]();
    context.keys = () => Object.keys(map3);
    return context;
  })();
  var __requireContext_1 = (() => {
    const map3 = {
      "./helpers/addCart.js": () => (init_addCart(), __toCommonJS(addCart_exports)),
      "./helpers/canvas.js": () => (init_canvas(), __toCommonJS(canvas_exports)),
      "./helpers/cart.js": () => (init_cart2(), __toCommonJS(cart_exports2)),
      "./helpers/personalizeAddCart.js": () => (init_personalizeAddCart(), __toCommonJS(personalizeAddCart_exports)),
      "./helpers/properties.js": () => (init_properties(), __toCommonJS(properties_exports)),
      "./render/available-options.vue": () => (init_available_options(), __toCommonJS(available_options_exports)),
      "./render/cart-drawer.vue": () => (init_cart_drawer(), __toCommonJS(cart_drawer_exports)),
      "./render/collection-filter-heading.vue": () => (init_collection_filter_heading(), __toCommonJS(collection_filter_heading_exports)),
      "./render/collection-filter-item.vue": () => (init_collection_filter_item(), __toCommonJS(collection_filter_item_exports)),
      "./render/collection-filter.vue": () => (init_collection_filter(), __toCommonJS(collection_filter_exports)),
      "./render/collection-mobile-filter.vue": () => (init_collection_mobile_filter(), __toCommonJS(collection_mobile_filter_exports)),
      "./render/collection-selected-filter.vue": () => (init_collection_selected_filter(), __toCommonJS(collection_selected_filter_exports)),
      "./render/collection-sort.vue": () => (init_collection_sort(), __toCommonJS(collection_sort_exports)),
      "./render/collection-sub-category.vue": () => (init_collection_sub_category(), __toCommonJS(collection_sub_category_exports)),
      "./render/hubspot-form.vue": () => (init_hubspot_form(), __toCommonJS(hubspot_form_exports)),
      "./render/hubspot-news-form.vue": () => (init_hubspot_news_form(), __toCommonJS(hubspot_news_form_exports)),
      "./render/main-cart.vue": () => (init_main_cart(), __toCommonJS(main_cart_exports)),
      "./render/page-catalog.vue": () => (init_page_catalog(), __toCommonJS(page_catalog_exports)),
      "./render/page-epraise-card.vue": () => (init_page_epraise_card(), __toCommonJS(page_epraise_card_exports)),
      "./render/page-epraise.vue": () => (init_page_epraise(), __toCommonJS(page_epraise_exports)),
      "./render/page-quote.vue": () => (init_page_quote(), __toCommonJS(page_quote_exports)),
      "./render/page-tax.vue": () => (init_page_tax(), __toCommonJS(page_tax_exports)),
      "./render/personalize-it.vue": () => (init_personalize_it(), __toCommonJS(personalize_it_exports)),
      "./render/product-qty.vue": () => (init_product_qty(), __toCommonJS(product_qty_exports)),
      "./render/product-view.vue": () => (init_product_view(), __toCommonJS(product_view_exports)),
      "./render/recent-product.vue": () => (init_recent_product(), __toCommonJS(recent_product_exports)),
      "./render/recent-view-product.vue": () => (init_recent_view_product(), __toCommonJS(recent_view_product_exports)),
      "./render/related-product.vue": () => (init_related_product(), __toCommonJS(related_product_exports)),
      "./render/search-modal.vue": () => (init_search_modal2(), __toCommonJS(search_modal_exports)),
      "./render/upcoming-events.vue": () => (init_upcoming_events(), __toCommonJS(upcoming_events_exports)),
      "./renderless/add-cart.vue": () => (init_add_cart(), __toCommonJS(add_cart_exports)),
      "./renderless/addresses-switch.vue": () => (init_addresses_switch(), __toCommonJS(addresses_switch_exports)),
      "./renderless/facets-filter.vue": () => (init_facets_filter(), __toCommonJS(facets_filter_exports)),
      "./renderless/featured-blog.vue": () => (init_featured_blog(), __toCommonJS(featured_blog_exports)),
      "./renderless/header-cart.vue": () => (init_header_cart(), __toCommonJS(header_cart_exports)),
      "./renderless/header-search.vue": () => (init_header_search(), __toCommonJS(header_search_exports)),
      "./renderless/product-variant-selector.vue": () => (init_product_variant_selector(), __toCommonJS(product_variant_selector_exports)),
      "./renderless/template-switch.vue": () => (init_template_switch(), __toCommonJS(template_switch_exports)),
      "./shared/art-works.vue": () => (init_art_works2(), __toCommonJS(art_works_exports)),
      "./shared/canvas-image.vue": () => (init_canvas_image(), __toCommonJS(canvas_image_exports)),
      "./shared/canvas-text.vue": () => (init_canvas_text2(), __toCommonJS(canvas_text_exports)),
      "./shared/colors-options.vue": () => (init_colors_options2(), __toCommonJS(colors_options_exports)),
      "./shared/div-container.vue": () => (init_div_container2(), __toCommonJS(div_container_exports)),
      "./shared/epraise-card.vue": () => (init_epraise_card2(), __toCommonJS(epraise_card_exports)),
      "./shared/font-szie.vue": () => (init_font_szie(), __toCommonJS(font_szie_exports)),
      "./shared/logo-artwork.vue": () => (init_logo_artwork2(), __toCommonJS(logo_artwork_exports)),
      "./shared/message-description.vue": () => (init_message_description2(), __toCommonJS(message_description_exports)),
      "./shared/message-options.vue": () => (init_message_options2(), __toCommonJS(message_options_exports)),
      "./shared/page-input.vue": () => (init_page_input2(), __toCommonJS(page_input_exports)),
      "./shared/page-select.vue": () => (init_page_select2(), __toCommonJS(page_select_exports)),
      "./shared/personalization-logo-input.vue": () => (init_personalization_logo_input(), __toCommonJS(personalization_logo_input_exports)),
      "./shared/personalization-option-input.vue": () => (init_personalization_option_input(), __toCommonJS(personalization_option_input_exports)),
      "./shared/personalization-option.vue": () => (init_personalization_option2(), __toCommonJS(personalization_option_exports)),
      "./shared/price-table.vue": () => (init_price_table(), __toCommonJS(price_table_exports)),
      "./shared/selected-artwork.vue": () => (init_selected_artwork2(), __toCommonJS(selected_artwork_exports)),
      "./shared/step-approval.vue": () => (init_step_approval(), __toCommonJS(step_approval_exports)),
      "./shared/step-button.vue": () => (init_step_button(), __toCommonJS(step_button_exports)),
      "./shared/step-canvas.vue": () => (init_step_canvas2(), __toCommonJS(step_canvas_exports)),
      "./shared/step-footer.vue": () => (init_step_footer(), __toCommonJS(step_footer_exports)),
      "./shared/step-header.vue": () => (init_step_header(), __toCommonJS(step_header_exports)),
      "./shared/step-input.vue": () => (init_step_input(), __toCommonJS(step_input_exports)),
      "./shared/step-options.vue": () => (init_step_options2(), __toCommonJS(step_options_exports)),
      "./shared/step-quantities.vue": () => (init_step_quantities(), __toCommonJS(step_quantities_exports)),
      "./svg/icon-remove.vue": () => (init_icon_remove(), __toCommonJS(icon_remove_exports))
    };
    const context = (key) => map3[key]();
    context.keys = () => Object.keys(map3);
    return context;
  })();
  var __requireContext_2 = (() => {
    const map3 = {
      "./global.append-parameter.js": () => (init_global_append_parameter(), __toCommonJS(global_append_parameter_exports)),
      "./global.submit.js": () => (init_global_submit(), __toCommonJS(global_submit_exports))
    };
    const context = (key) => map3[key]();
    context.keys = () => Object.keys(map3);
    return context;
  })();
  var __requireContext_3 = (() => {
    const map3 = {
      "./global.select-option.js": () => (init_global_select_option(), __toCommonJS(global_select_option_exports))
    };
    const context = (key) => map3[key]();
    context.keys = () => Object.keys(map3);
    return context;
  })();
  var vuexModules = __requireContext_0;
  var modules = {};
  vuexModules.keys().forEach((key) => {
    const name = key.replace(/\.(\/|js)/g, "").replace(/\s/g, "-");
    modules[name] = vuexModules(key).default;
  });
  var store = createStore({
    strict: true,
    modules
  });
  var createVueApp = () => {
    const app = createApp({});
    const vueComponents = __requireContext_1;
    vueComponents.keys().forEach((key) => {
      const component = vueComponents(key).default;
      const name = component?.name ? component?.name : key.replace(/\.(\/|vue|js)/g, "").replace(/(\/|-|_|\s)\w/g, (match) => match.slice(1).toUpperCase());
      app.component(name, component);
    });
    const mixins = __requireContext_2;
    mixins.keys().forEach((key) => {
      app.mixin(mixins(key).default);
    });
    const directives = __requireContext_3;
    directives.keys().forEach((key) => {
      const directive = directives(key).default;
      app.directive(directive.name, directive.directive);
    });
    app.use(store);
    app.use(Se);
    return app;
  };
  var appElement = document.querySelector("#app");
  if (appElement) {
    createVueApp().mount(appElement);
  } else {
    const vueElements = document.querySelectorAll("[vue]");
    if (vueElements) vueElements.forEach((el) => createVueApp().mount(el));
  }
  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", (event) => {
      if (event.target.classList.value.includes("vue")) {
        createVueApp().mount(event.target);
      }
    });
  } else if (!Shopify.designMode && true) {
    new MutationObserver((mutationsList) => {
      mutationsList.forEach((record) => {
        const vue = Array.from(record.addedNodes).find(
          (node) => node.classList && node.classList.value.includes("vue")
        );
        if (vue) window.location.reload();
      });
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
//# sourceMappingURL=bundle.js.map
